webpackJsonp([26],{

/***/ "+9L4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/api/index.js
var src_api = __webpack_require__("gyMJ");

// EXTERNAL MODULE: ./src/api/config.js
var api_config = __webpack_require__("T452");

// EXTERNAL MODULE: ./src/components/tool/customForm.vue + 2 modules
var customForm = __webpack_require__("uuH9");

// EXTERNAL MODULE: ./src/components/tool/inputTag.vue + 2 modules
var inputTag = __webpack_require__("6EFu");

// EXTERNAL MODULE: ./src/components/tool/dataTag.vue + 2 modules
var dataTag = __webpack_require__("Mq4e");

// EXTERNAL MODULE: ./src/components/tool/switchButton.vue + 2 modules
var switchButton = __webpack_require__("BdG8");

// EXTERNAL MODULE: ./src/components/tool/pageButtons.vue + 2 modules
var pageButtons = __webpack_require__("+kXL");

// EXTERNAL MODULE: ./src/components/tool/scrollBottom.vue + 2 modules
var scrollBottom = __webpack_require__("/2uW");

// EXTERNAL MODULE: ./src/components/tool/newBorCor.vue + 2 modules
var newBorCor = __webpack_require__("jHy4");

// EXTERNAL MODULE: ./src/mixins/routeLoading.vue + 1 modules
var routeLoading = __webpack_require__("zVZS");

// EXTERNAL MODULE: ./src/mixins/responsitive.vue + 1 modules
var responsitive = __webpack_require__("E4co");

// EXTERNAL MODULE: ./src/mixins/customTimeout.vue + 1 modules
var customTimeout = __webpack_require__("WBdv");

// EXTERNAL MODULE: ./src/constants/global/data.js
var global_data = __webpack_require__("x2hU");

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dataset/base.vue












//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ var base = ({
  components: {
    customForm: customForm["a" /* default */],
    inputTag: inputTag["a" /* default */],
    dataTag: dataTag["a" /* default */],
    switchButton: switchButton["a" /* default */],
    pageButtons: pageButtons["a" /* default */],
    scrollBottom: scrollBottom["a" /* default */],
    borCor: newBorCor["a" /* default */]
  },
  mixins: [routeLoading["a" /* default */], responsitive["a" /* default */], customTimeout["a" /* default */]],
  props: {
    scope: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    defaultData: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      allCases: [],
      displayIDs: {
        case: [],
        dataset: []
      },
      dataset: {
        pipeline: 'WES'
      },
      alerts: {},
      result: {},
      validate: {},
      error: {},
      users: [],
      tags: {
        tag: []
      },
      onSubmit: false,
      // search tag
      map: {
        tag: {}
      },
      query: {
        tag: ''
      },
      tag: {
        tag: {}
      },
      curTag: {
        tag: null
      },
      loading: {
        tag: false,
        tagAdd: false
      },
      searchTimer: {
        tag: []
      },
      // sample
      sample: {
        query: '',
        viewType: 'detail',
        listType: 'case',
        datas: {
          case: null,
          dataset: null
        },
        results: {
          case: [],
          dataset: []
        },
        tableOverflow: {
          case: false,
          dataset: false
        },
        // page
        pageData: {
          selectedPage: {
            case: 1,
            dataset: 1
          },
          display: {
            case: 20,
            dataset: 20
          },
          total: {
            case: null,
            dataset: null
          },
          buttonRange: {
            case: 7,
            dataset: 7
          },
          pageJumpTo: {
            case: '',
            dataset: ''
          }
        },
        // sort
        sort: {
          case: {
            value: ['updated_at'],
            order: ['-desc']
          },
          dataset: {
            value: ['updated_at'],
            order: ['-desc']
          }
        }
      },
      // picture
      selectedPictureID: null,
      pictures: [],
      customPicture: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user', 'modal']), {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },
    userOptions: function userOptions() {
      return this.users.map(function (user) {
        return { title: [user.first_name, user.last_name].filter(function (x) {
            return x;
          }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) {
            return x;
          }).join(' ') + ')' : ''), value: user.id };
      });
    },
    pipelineOptions: function pipelineOptions() {
      var _this2 = this;

      return entries_default()(global_data["j" /* datasetPipelineMap */]).map(function (_ref3) {
        var _ref4 = slicedToArray_default()(_ref3, 2),
            value = _ref4[0],
            data = _ref4[1];

        return extends_default()({}, data, { title: _this2.$t(data.title), value: value });
      });
    },
    totalPage: function totalPage() {
      var _this3 = this;

      this.sample.pageData.selectedPage = {
        case: 1,
        dataset: 1
      };
      return entries_default()(this.sample.pageData.total).reduce(function (s, _ref5) {
        var _ref6 = slicedToArray_default()(_ref5, 2),
            type = _ref6[0],
            total = _ref6[1];

        var display = _this3.sample.pageData.display[type];
        return extends_default()({}, s, defineProperty_default()({}, type, Math.ceil(Math.min(total, display * 5000) / display)));
      }, {});
    },

    // sample
    sampleEmptyText: function sampleEmptyText() {
      return {
        case: this.$t('COMPONENT.dataset.base.sample.emptyText.___case'),
        dataset: ''
      };
    },
    selectedSampleSize: function selectedSampleSize() {
      return this.sample.results['case'].length + this.sample.results['dataset'].reduce(function (s, dataset) {
        return s + (dataset.sample_size || 0);
      }, 0);
    },
    sampleFiltedDatas: function sampleFiltedDatas() {
      var _this4 = this;

      var filter = function filter(type) {
        var filtedData = _this4.sample.datas[type] || [];
        filtedData = filtedData.filter(function (data) {
          return !_this4.sampleSelectedDataMap[type][data.id] && _this4.displayIDs[type].includes(data.id);
        });
        return filtedData;
      };
      var filtedData = {
        case: filter('case'),
        dataset: filter('dataset')
      };
      return filtedData;
    },
    sampleTableDatas: function sampleTableDatas() {
      var _this5 = this;

      var generator = function generator(type) {
        var tableDatas = [].concat(toConsumableArray_default()(Object(util["m" /* sortData */])(values_default()(_this5.sampleSelectedDataMap[type]), _this5.sample.sort[type].value.map(function (x) {
          return _this5.sampleSortMap[type][x] || x;
        }), _this5.sample.sort[type].order.map(function (x) {
          return x.replace('-', '');
        }))), toConsumableArray_default()(_this5.sampleFiltedDatas[type]));
        return Object(util["i" /* groupBy */])(tableDatas, function () {
          return 'default';
        }).map(function (datas) {
          return { title: datas[0].group, isGroup: true, datas: datas };
        });
      };
      var tableDatas = {
        case: generator('case'),
        dataset: generator('dataset')
      };
      return tableDatas;
    },
    sampleSelectedDataMap: function sampleSelectedDataMap() {
      var _this6 = this;

      var generator = function generator(type) {
        return _this6.sample.results[type].reduce(function (map, data) {
          return extends_default()({}, map, defineProperty_default()({}, data.id, extends_default()({}, data, { selected: true })));
        }, {});
      };
      return {
        case: generator('case'),
        dataset: generator('dataset')
      };
    },
    sampleTableOptions: function sampleTableOptions() {
      return {
        case: [{
          value: '_SELECT',
          width: 50,
          class: function _class() {
            return ['center'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.dataset.base.sampleTable.case.___case_id'),
          value: 'case_id',
          sortMap: { detail: undefined, list: null }[this.sample.viewType]
        }, {
          title: this.$t('COMPONENT.dataset.base.sampleTable.case.___sex'),
          value: 'sex',
          width: 66,
          class: function _class() {
            return ['center'];
          },
          display: function display(value) {
            return { Male: 'M', Female: 'F', Unknown: 'U' }[value];
          },
          style: function style(value) {
            return { Male: { color: '#003679' }, Female: { color: '#BE0F0F' }, Unknown: { color: '#333333' } }[value];
          },
          show: { detail: true, list: false }[this.sample.viewType]
        }, {
          title: this.$t('COMPONENT.dataset.base.sampleTable.case.___birth_year'),
          value: 'birth_year',
          width: 67,
          class: function _class() {
            return ['center'];
          },
          display: function display(value) {
            return value ? new Date().getFullYear() - value + '' : null;
          },
          show: { detail: true, list: false }[this.sample.viewType]
        }, {
          title: this.$t('COMPONENT.dataset.base.sampleTable.case.___created_at'),
          value: 'created_at',
          width: 167,
          display: function display(value) {
            return value ? Object(util["d" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : value;
          },
          show: { detail: true, list: false }[this.sample.viewType]
        }, {
          title: this.$t('COMPONENT.dataset.base.sampleTable.case.___updated_at'),
          value: 'updated_at',
          width: 167,
          display: function display(value) {
            return value ? Object(util["d" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : value;
          },
          show: { detail: true, list: false }[this.sample.viewType]
        }],
        dataset: [{
          value: '_SELECT',
          width: 50,
          class: function _class() {
            return ['center'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.dataset.base.sampleTable.dataset.___name'),
          value: 'name',
          sortMap: { detail: undefined, list: null }[this.sample.viewType]
        }, {
          title: this.$t('COMPONENT.dataset.base.sampleTable.dataset.___sample_size'),
          value: 'sample_size',
          width: 127,
          display: function display(value) {
            return value ? Object(util["r" /* toPriceString */])(value) : value;
          },
          show: { detail: true, list: false }[this.sample.viewType]
        }, {
          title: this.$t('COMPONENT.dataset.base.sampleTable.dataset.___user'),
          value: 'user',
          width: 352,
          display: function display(value) {
            return value ? [value.first_name, value.last_name].filter(function (x) {
              return x;
            }).join(' ') + (value.email ? ' (' + [value.email].filter(function (x) {
              return x;
            }).join(' ') + ')' : '') : value;
          },
          sortValue: 'users.first_name',
          sortMap: function sortMap(dataset) {
            return dataset.user.first_name;
          },
          show: { detail: true, list: false }[this.sample.viewType]
        }, {
          title: this.$t('COMPONENT.dataset.base.sampleTable.dataset.___detail'),
          value: '_DETAIL',
          width: 78,
          class: function _class() {
            return ['center'];
          },
          sortMap: null,
          show: { detail: true, list: false }[this.sample.viewType]
        }]
      };
    },
    sampleSortMap: function sampleSortMap() {
      var _this7 = this;

      return keys_default()(this.sampleTableOptions).reduce(function (result, key) {
        return extends_default()({}, result, defineProperty_default()({}, key, _this7.sampleTableOptions[key].reduce(function (s, c) {
          return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortMap || c.value));
        }, {})));
      }, {});
    },
    sampleSortValue: function sampleSortValue() {
      var _this8 = this;

      return keys_default()(this.sampleTableOptions).reduce(function (result, key) {
        return extends_default()({}, result, defineProperty_default()({}, key, _this8.sampleTableOptions[key].reduce(function (s, c) {
          return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortValue || c.value));
        }, {})));
      }, {});
    },

    // static
    sampleListOptions: function sampleListOptions() {
      return [{
        title: this.$t('COMPONENT.dataset.base.sampleList.title.___case') + ' (' + this.sample.results['case'].length + ')',
        value: 'case'
      }, {
        title: this.$t('COMPONENT.dataset.base.sampleList.title.___dataset'),
        value: 'dataset'
      }];
    },
    formOptions: function formOptions() {
      var _this9 = this;

      return {
        field0: [{
          title: this.$t('COMPONENT.dataset.base.form.title.___owner'),
          value: 'user_id',
          type: 'custom',
          grid: 3,
          options: this.userOptions,
          validate: 'required'
        }, {
          title: '　',
          value: '',
          grid: 3
        }],
        field1: [
        // 1
        {
          title: this.$t('COMPONENT.dataset.base.form.title.___name'),
          value: 'name',
          type: 'input',
          grid: 2,
          onChange: function onChange(value) {
            _this9.nameConfirm(value);
          },
          placeholder: function placeholder() {
            return _this9.$t('COMPONENT.dataset.base.form.placeholder.___name');
          },
          validate: 'required'
        }, {
          title: this.$t('COMPONENT.dataset.base.form.title.___tag'),
          value: '_TAG',
          type: 'custom',
          grid: 1,
          placeholder: function placeholder() {
            return _this9.$t('COMPONENT.dataset.base.form.placeholder.___tag');
          }
        }, {
          title: '',
          value: '_TAGS',
          type: 'custom',
          grid: 3
        },
        // 2
        {
          title: this.$t('COMPONENT.dataset.base.form.title.___pipeline'),
          value: 'pipeline',
          type: this.dataset.id ? 'text' : 'select',
          grid: 2,
          options: this.pipelineOptions,
          placeholder: function placeholder() {
            return _this9.$t('COMPONENT.dataset.base.form.placeholder.___pipeline');
          },
          validate: this.dataset.id ? '' : 'required',
          inputFormat: function inputFormat(value) {
            return _this9.dataset.id ? (_this9.pipelineOptions.find(function (option) {
              return option.value === value;
            }) || {}).title : value;
          }
        }, {
          title: this.$t('COMPONENT.dataset.base.form.title.___description'),
          value: 'description',
          type: 'textarea',
          row: 4,
          grid: 4,
          placeholder: function placeholder() {
            return _this9.$t('COMPONENT.dataset.base.form.placeholder.___description');
          }
        }]
      };
    },

    // unload alert
    sendData: function sendData() {
      var sendData = {};
      sendData = extends_default()({}, sendData, entries_default()(this.result).reduce(function (s, _ref7) {
        var _ref8 = slicedToArray_default()(_ref7, 2),
            k = _ref8[0],
            v = _ref8[1];

        return extends_default()({}, s, k.startsWith('_') ? {} : defineProperty_default()({}, k, v));
      }, {}), {
        tags: this.tags['tag'],
        dataset_picture_file_id: this.selectedPictureID === 'custom' ? this.customPicture.id : this.selectedPictureID
      });
      if ((this.form || {}).sampleSelect) {
        sendData = extends_default()({}, sendData, {
          case_ids: this.sample.results['case'].map(function (result) {
            return result.id;
          }),
          community_dataset_ids: this.sample.results['dataset'].map(function (result) {
            return result.id;
          })
        });
      }
      return sendData;
    },

    // global
    pageDisplay: function pageDisplay() {
      return global_data["F" /* pageDisplay */];
    },
    fileTypeCheck: function fileTypeCheck() {
      return util["f" /* fileTypeCheck */];
    }
  }),
  watch: {
    'defaultData': function defaultData() {
      this.init(this.defaultData);
    },
    'sample.listType': function sampleListType() {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this10.sample.datas[_this10.sample.listType]) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return _this10.sampleSearchDatas();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this10);
      }))();
    },
    'result.name': function resultName() {
      this.customValidate([], ['name']);
    },

    // search tag
    'query.tag': function queryTag(nv) {
      this.getTag(nv, 'tag');
    },

    // sample
    'result.user_id': function resultUser_id(nv, ov) {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, option;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(nv && ov)) {
                  _context2.next = 33;
                  break;
                }

                _this11.setLoadingAction(true);
                _context2.next = 4;
                return _this11.fetchDatasetCases();

              case 4:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 7;
                _iterator = get_iterator_default()(_this11.sampleListOptions);

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 18;
                  break;
                }

                option = _step.value;

                _this11.sample.results[option.value] = [];
                _this11.displayIDs = {
                  case: [],
                  dataset: []
                };
                _context2.next = 15;
                return _this11.sampleSearchDatas(true, option.value);

              case 15:
                _iteratorNormalCompletion = true;
                _context2.next = 9;
                break;

              case 18:
                _context2.next = 24;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 24:
                _context2.prev = 24;
                _context2.prev = 25;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 27:
                _context2.prev = 27;

                if (!_didIteratorError) {
                  _context2.next = 30;
                  break;
                }

                throw _iteratorError;

              case 30:
                return _context2.finish(27);

              case 31:
                return _context2.finish(24);

              case 32:
                _this11.setLoadingAction(false);

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this11, [[7, 20, 24, 32], [25,, 27, 31]]);
      }))();
    },
    'result.pipeline': function resultPipeline(nv, ov) {
      var _this12 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, option;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!ov) {
                  _context3.next = 33;
                  break;
                }

                _this12.setLoadingAction(true);
                _context3.next = 4;
                return _this12.fetchDatasetCases();

              case 4:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 7;
                _iterator2 = get_iterator_default()(_this12.sampleListOptions);

              case 9:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context3.next = 18;
                  break;
                }

                option = _step2.value;

                _this12.sample.results[option.value] = [];
                _this12.displayIDs = {
                  case: [],
                  dataset: []
                };
                _context3.next = 15;
                return _this12.sampleSearchDatas(true, option.value);

              case 15:
                _iteratorNormalCompletion2 = true;
                _context3.next = 9;
                break;

              case 18:
                _context3.next = 24;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3['catch'](7);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t0;

              case 24:
                _context3.prev = 24;
                _context3.prev = 25;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 27:
                _context3.prev = 27;

                if (!_didIteratorError2) {
                  _context3.next = 30;
                  break;
                }

                throw _iteratorError2;

              case 30:
                return _context3.finish(27);

              case 31:
                return _context3.finish(24);

              case 32:
                _this12.setLoadingAction(false);

              case 33:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this12, [[7, 20, 24, 32], [25,, 27, 31]]);
      }))();
    },
    'sample.query': function sampleQuery() {
      var _this13 = this;

      this.customDelay(function () {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = get_iterator_default()(_this13.sampleListOptions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var option = _step3.value;

            _this13.sampleSearchDatas(true, option.value);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }, 300, 'queryChange');
    },
    'sampleTableDatas.case': function sampleTableDatasCase() {
      this.getSampleTableOverflow('case');
    },
    'sampleTableDatas.dataset': function sampleTableDatasDataset() {
      this.getSampleTableOverflow('dataset');
    },

    // validate
    'selectedSampleSize': function selectedSampleSize() {
      this.customValidate([], ['sample']);
    },

    // unload alert
    'sendData': function sendData(nv, ov) {
      if (stringify_default()(nv) !== stringify_default()(ov)) {
        this.$emit('unloadAlert', true);
      }
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction', 'setModalAction', 'setModal2Action']), {
    init: function init(data) {
      var _this14 = this;

      this.dataset = extends_default()({}, this.dataset, data, {
        dataset_picture_file_id: (data.dataset_picture_file || {}).id
      });
      this.selectedPictureID = this.dataset.dataset_picture_file_id || this.selectedPictureID;
      this.tags['tag'] = [].concat(toConsumableArray_default()(this.dataset.tags || []));
      setTimeout(function () {
        return _this14.$emit('unloadAlert', false);
      });
    },
    fetchData: function fetchData() {
      var _this15 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this15.init(_this15.defaultData);

                if (!(_this15.form || {}).roleSelect) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 4;
                return _this15.fetchManagedUsers();

              case 4:
                if (!_this15.dataset.id) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 7;
                return _this15.fetchCustomPicture();

              case 7:
                _context4.next = 9;
                return _this15.fetchDatasetPictureFiles();

              case 9:
                if (!(_this15.form || {}).sampleSelect) {
                  _context4.next = 16;
                  break;
                }

                _context4.next = 12;
                return _this15.fetchDatasetCases();

              case 12:
                _context4.next = 14;
                return _this15.fetchSampleDatas(true, 'case');

              case 14:
                _context4.next = 16;
                return _this15.fetchSampleDatas(true, 'dataset');

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this15);
      }))();
    },
    fetchManagedUsers: function fetchManagedUsers() {
      var _this16 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var config, response, users;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                config = _this16.$ls.get('userInfo');
                _context5.next = 4;
                return Object(src_api["_47" /* getManagedUsers */])(config);

              case 4:
                response = _context5.sent;
                users = response.data.data;

                _this16.users = users;
                _this16.result = extends_default()({}, _this16.result, {
                  user_id: _this16.user.id || users[0].id
                });
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](0);
                throw _context5.t0;

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this16, [[0, 10]]);
      }))();
    },
    fetchCustomPicture: function fetchCustomPicture() {
      var _this17 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var config, id, response, customPicture;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                config = _this17.$ls.get('userInfo');
                id = _this17.dataset.id;
                _context6.next = 5;
                return Object(src_api["_20" /* getDatasetPictureFile */])(id, config);

              case 5:
                response = _context6.sent;
                customPicture = response.data.data;

                _this17.customPicture = customPicture ? extends_default()({}, customPicture, {
                  url: api_config["a" /* API_ROOT */] + 'global/files/download?file_id=' + customPicture.id + '&class_name=' + customPicture.class_name + '&access_token=' + config['access_token']
                }) : _this17.customPicture;
                _context6.next = 13;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6['catch'](0);
                throw _context6.t0;

              case 13:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this17, [[0, 10]]);
      }))();
    },
    fetchDatasetPictureFiles: function fetchDatasetPictureFiles() {
      var _this18 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var config, response, pictures;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                config = _this18.$ls.get('userInfo');
                _context7.next = 4;
                return Object(src_api["_21" /* getDatasetPictureFiles */])(config);

              case 4:
                response = _context7.sent;
                pictures = response.data.data;

                pictures = pictures.filter(function (picture) {
                  return picture.size && picture.id !== (_this18.customPicture || {}).id;
                }).map(function (picture) {
                  return extends_default()({}, picture, {
                    url: api_config["a" /* API_ROOT */] + 'global/files/download?file_id=' + picture.id + '&class_name=' + picture.class_name + '&access_token=' + config['access_token']
                  });
                });
                _this18.pictures = pictures;
                _context7.next = 13;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7['catch'](0);
                throw _context7.t0;

              case 13:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this18, [[0, 10]]);
      }))();
    },
    fetchDatasetCases: function fetchDatasetCases() {
      var _this19 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var config, params, response, cases;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                config = _this19.$ls.get('userInfo');
                params = {
                  q: _this19.sample.query || null,
                  pipeline: _this19.dataset.id ? _this19.dataset.pipeline : _this19.result.pipeline,
                  state: 'completed'
                };

                if ((_this19.form || {}).roleSelect) {
                  params.user_id = _this19.result.user_id;
                }
                _context8.next = 6;
                return Object(src_api["_12" /* getCreateDatasetCases */])(params, config);

              case 6:
                response = _context8.sent;
                cases = response.data.data;

                cases = cases.map(function (caseData) {
                  var phenotypeDatas = [].concat(toConsumableArray_default()(caseData.phenotypes.hpo.map(function (phenotype) {
                    return {
                      id: phenotype.hpo_id,
                      name: phenotype.hpo_name,
                      query: phenotype.hpo_id + ' ' + phenotype.hpo_name,
                      type: 'hpo'
                    };
                  })), toConsumableArray_default()(caseData.phenotypes.disease_term.map(function (phenotype) {
                    return {
                      id: phenotype.disease_id,
                      name: phenotype.disease_name,
                      query: phenotype.disease_id + ' ' + phenotype.disease_name,
                      type: 'disease_term'
                    };
                  })));
                  return extends_default()({}, caseData, {
                    phenotypeDatas: phenotypeDatas
                  });
                });
                _this19.allCases = cases;
                _context8.next = 14;
                break;

              case 12:
                _context8.prev = 12;
                _context8.t0 = _context8['catch'](0);

              case 14:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this19, [[0, 12]]);
      }))();
    },
    fetchSampleDatas: function fetchSampleDatas() {
      var _this20 = this;

      var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var type = arguments[1];
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var config, api, params, response, sampleDatas, total;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                config = _this20.$ls.get('userInfo');
                api = {
                  case: _this20.getCreateDatasetCases,
                  dataset: src_api["_31" /* getFullAccessDatasets */]
                }[type];
                params = {
                  q: _this20.sample.query || null,
                  type: type,
                  pipeline: _this20.dataset.id ? _this20.dataset.pipeline : _this20.result.pipeline,
                  state: 'completed'
                };

                if ((_this20.form || {}).roleSelect) {
                  params.user_id = _this20.result.user_id;
                }
                _this20.sample.pageData.selectedPage[type] && (params.page = _this20.sample.pageData.selectedPage[type]);
                _this20.sample.pageData.display[type] && (params.items = _this20.sample.pageData.display[type]);
                _this20.sample.sort[type].value[0] && (params.order_by = (_this20.sampleSortValue[type][_this20.sample.sort[type].value[0]] || _this20.sample.sort[type].value[0]) + ':' + _this20.sample.sort[type].order[0].replace(/^-/, ''));
                _context9.next = 10;
                return api(params, config);

              case 10:
                response = _context9.sent;
                sampleDatas = response.data.data || [];
                total = response.data.count || 0;

                _this20.sample.datas[type] = [].concat(toConsumableArray_default()(_this20.sample.datas[type] || []), toConsumableArray_default()(sampleDatas));
                _this20.sample.pageData.total[type] = {
                  'case': _this20.sample.pageData.total[type],
                  'dataset': sampleDatas.length
                }[type];
                _this20.displayIDs[type] = {
                  'case': [],
                  'dataset': sampleDatas.map(function (data) {
                    return data.id;
                  })
                }[type];
                // this.sample.pageData.selectedPage[type] += (sampleDatas.length ? 1 : 0)
                return _context9.abrupt('return', !!(sampleDatas.length && total > _this20.sample.datas[type].length));

              case 19:
                _context9.prev = 19;
                _context9.t0 = _context9['catch'](0);

                if (!init) {
                  _context9.next = 25;
                  break;
                }

                throw _context9.t0;

              case 25:
                return _context9.abrupt('return', false);

              case 26:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this20, [[0, 19]]);
      }))();
    },
    afterSetData: function afterSetData() {
      var _this21 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        var id;
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                id = _this21.dataset.dataset_picture_file_id || _this21.pictures[0].id;

                _this21.selectedPictureID = (_this21.pictures.find(function (picture) {
                  return picture.id === id;
                }) || {}).id || 'custom';
                setTimeout(function () {
                  return _this21.$emit('unloadAlert', false);
                });

              case 3:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this21);
      }))();
    },
    getCreateDatasetCases: function getCreateDatasetCases(params, config) {
      var _this22 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
        var response, results, order, pageData;
        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                response = { data: {} };
                results = _this22.allCases;
                order = params.order_by ? params.order_by.split(':') : null;
                pageData = {
                  selectedPage: _this22.sample.pageData.selectedPage[params.type],
                  display: _this22.sample.pageData.display[params.type]
                };

                params.q && (results = results.filter(function (result) {
                  return result.case_id.includes(params.q);
                }));
                order && (results = Object(util["m" /* sortData */])(results, order[0], order[1]));
                results = results.filter(function (_, index) {
                  return index >= (pageData.selectedPage - 1) * pageData.display && index < (pageData.selectedPage - 0) * pageData.display;
                });
                response.data = {
                  data: results,
                  count: _this22.allCases.length
                };
                return _context11.abrupt('return', response);

              case 9:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this22);
      }))();
    },
    sampleSearchDatas: function sampleSearchDatas() {
      var _this23 = this;

      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var type = arguments[1];
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
        var result;
        return regenerator_default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                reset && _this23.setLoadingAction(true);
                type = type || _this23.sample.listType;

                if (!reset) {
                  _context13.next = 12;
                  break;
                }

                _this23.sample.datas[type] = [];
                _this23.sample.pageData.selectedPage[type] = 1;
                _context13.next = 7;
                return new promise_default.a(function (resolve) {
                  setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
                    var result;
                    return regenerator_default.a.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            _context12.next = 2;
                            return _this23.fetchSampleDatas(false, type);

                          case 2:
                            result = _context12.sent;

                            resolve(result);

                          case 4:
                          case 'end':
                            return _context12.stop();
                        }
                      }
                    }, _callee12, _this23);
                  })), 300);
                });

              case 7:
                result = _context13.sent;

                reset && _this23.setLoadingAction(false);
                return _context13.abrupt('return', result);

              case 12:
                return _context13.abrupt('return', false);

              case 13:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this23);
      }))();
    },
    getSampleTableOverflow: function getSampleTableOverflow(type) {
      var _this24 = this;

      setTimeout(function () {
        try {
          var scrollContainer = _this24.$refs['custom-table-scroll-' + type][0].$el;
          if (scrollContainer) {
            _this24.sample.tableOverflow[type] = scrollContainer.scrollHeight > scrollContainer.offsetHeight;
          }
        } catch (error) {}
      });
    },
    sampleTableOnSelect: function sampleTableOnSelect(type, datas, value) {
      var _this25 = this;

      if (value === 'all') {
        if (!this.sampleFiltedDatas[type].some(function (data) {
          return !_this25.sampleSelectedDataMap[type][data.id];
        })) {
          datas = this.sample.results[type];
          value = false;
        } else {
          datas = this.sampleFiltedDatas[type];
          value = true;
        }
      }
      var dataMap = datas.reduce(function (map, data) {
        return extends_default()({}, map, defineProperty_default()({}, data.id, data));
      }, {});
      this.sample.results[type] = value ? [].concat(toConsumableArray_default()(datas.filter(function (data) {
        return !_this25.sampleSelectedDataMap[type][data.id];
      })), toConsumableArray_default()(this.sample.results[type])) : this.sample.results[type].filter(function (result) {
        return !dataMap[result.id];
      });
      this.displayIDs[type] = {
        case: this.sample.results[type].map(function (result) {
          return result.id;
        }),
        dataset: this.sample.datas[type].map(function (result) {
          return result.id;
        })
      }[type];
    },
    sampleTableSortBy: function sampleTableSortBy(value, type) {
      var position = this.sample.sort[type].value.indexOf(value);
      if (position === 0) {
        var order = this.sample.sort[type].order[position] === '-asc' ? '-desc' : '-asc';
        this.sample.sort[type].order.splice(position, 1);
        this.sample.sort[type].order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sample.sort[type].order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sample.sort[type].value.splice(position, 1);
        this.sample.sort[type].order.splice(position, 1);
        this.sample.sort[type].value.unshift(value);
        this.sample.sort[type].order.unshift(_order || '-asc');
      }
      this.sampleSearchDatas(true, type);
    },
    sampleOpenDatasetDetail: function sampleOpenDatasetDetail(dataset) {
      var _this26 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14() {
        var action, config, id, response, cases;
        return regenerator_default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                action = _this26.modal.action ? _this26.setModal2Action : _this26.setModalAction;
                _context14.prev = 1;
                config = _this26.$ls.get('userInfo');
                id = dataset.id;
                _context14.next = 6;
                return Object(src_api["_16" /* getDatasetCases */])(id, config);

              case 6:
                response = _context14.sent;
                cases = response.data.data;

                cases = cases.map(function (caseData) {
                  return extends_default()({}, caseData.case);
                });
                action({
                  action: 'datasetDetail',
                  width: '912px',
                  height: _this26.windowHeight - 160 + 'px',
                  customStyles: {
                    'max-width': 'calc(100% - 40px)'
                  },
                  param: {
                    dataset: dataset,
                    cases: cases
                  }
                });
                _context14.next = 15;
                break;

              case 12:
                _context14.prev = 12;
                _context14.t0 = _context14['catch'](1);

                _this26.addToast('error', !_context14.t0.response ? _context14.t0.message : _context14.t0.response.data.result.message);

              case 15:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this26, [[1, 12]]);
      }))();
    },
    sampleOpenDatasetSelectCase: function sampleOpenDatasetSelectCase() {
      var _this27 = this;

      var action = this.modal.action ? this.setModal2Action : this.setModalAction;
      var cases = this.allCases.filter(function (caseData) {
        return !_this27.displayIDs['case'].includes(caseData.id);
      }) || [];
      action({
        action: 'datasetSelectCase',
        width: '1208px',
        height: cases.length ? this.windowHeight - 160 + 'px' : 'auto',
        customStyles: {
          'max-width': 'calc(100% - 40px)'
        },
        param: {
          cases: cases
        },
        callback: function () {
          var _ref11 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15(result) {
            var displayIDs;
            return regenerator_default.a.wrap(function _callee15$(_context15) {
              while (1) {
                switch (_context15.prev = _context15.next) {
                  case 0:
                    if (result) {
                      displayIDs = [].concat(toConsumableArray_default()(_this27.displayIDs['case']), toConsumableArray_default()(result));

                      _this27.sample.pageData.total['case'] = displayIDs.length;
                      _this27.sampleTableOnSelect('case', _this27.allCases.filter(function (caseData) {
                        return displayIDs.includes(caseData.id);
                      }), true);
                    }

                  case 1:
                  case 'end':
                    return _context15.stop();
                }
              }
            }, _callee15, _this27);
          }));

          return function callback(_x3) {
            return _ref11.apply(this, arguments);
          };
        }()
      });
    },
    getTag: function getTag(query, target) {
      var _this28 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee17() {
        var queryMap;
        return regenerator_default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                queryMap = {};

                query = (queryMap[target] || function (x) {
                  return x;
                })(query);
                if (_this28.curTag[target] !== query) {
                  _this28.tag[target] = {};
                  if (_this28.searchTimer[target]) {
                    clearTimeout(_this28.searchTimer[target]);
                  }
                  _this28.searchTimer[target] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee16() {
                    var datas;
                    return regenerator_default.a.wrap(function _callee16$(_context16) {
                      while (1) {
                        switch (_context16.prev = _context16.next) {
                          case 0:
                            if (!(!_this28.map[target][query] && query)) {
                              _context16.next = 15;
                              break;
                            }

                            _this28.loading[target] = true;
                            _this28.setLoadingAction(true);
                            _context16.prev = 3;
                            _context16.next = 6;
                            return _this28.getDataApi(query, target);

                          case 6:
                            datas = _context16.sent;

                            _this28.map[target] = extends_default()({}, _this28.map[target], defineProperty_default()({}, query, {
                              items: datas || []
                            }));
                            _context16.next = 13;
                            break;

                          case 10:
                            _context16.prev = 10;
                            _context16.t0 = _context16['catch'](3);

                            _this28.addToast('error', !_context16.t0.response ? _context16.t0.message : _context16.t0.response.data.result.message);

                          case 13:
                            _this28.loading[target] = false;
                            _this28.setLoadingAction(false);

                          case 15:
                            _this28.tag[target] = _this28.map[target][query] || {};

                          case 16:
                          case 'end':
                            return _context16.stop();
                        }
                      }
                    }, _callee16, _this28, [[3, 10]]);
                  })), 500);
                }

              case 3:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this28);
      }))();
    },
    getDataApi: function getDataApi(query, target) {
      var _this29 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee18() {
        var seed, getRandomDatas, getData, result;
        return regenerator_default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                seed = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'm', 'n', 'p', 'Q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '2', '3', '4', '5', '6', '7', '8', '9'];

                getRandomDatas = function getRandomDatas() {
                  return query.length <= 5 ? new Array(10).fill('').map(function () {
                    var prefix = new Array(Math.floor(Math.random() * 5)).fill('').map(function () {
                      return seed[Math.floor(Math.random() * seed.length)];
                    }).join('');
                    var suffix = new Array(Math.floor(Math.random() * 5)).fill('').map(function () {
                      return seed[Math.floor(Math.random() * seed.length)];
                    }).join('');
                    return prefix + query + suffix;
                  }) : [];
                };

                getData = new promise_default.a(function (resolve) {
                  setTimeout(function () {
                    var datas = getRandomDatas();
                    resolve(datas);
                  }, 300);
                });
                _context18.next = 5;
                return getData;

              case 5:
                result = _context18.sent;
                return _context18.abrupt('return', result);

              case 7:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this29);
      }))();
    },
    addTag: function addTag(target, type) {
      var data = this.query[target];
      if (data && !this.loading[target + 'Add']) {
        this.loading[target + 'Add'] = true;
        switch (target) {
          case 'tag':
            {
              if (data) {
                this.tags[target].push(data);
                this.query[target] = '';
              } else if (!this.onError && !this.onSubmit && !data && type !== 'button') {}
              break;
            }
          default:
            {}
        }
        this.query[target] = '';
        this.loading[target + 'Add'] = false;
      }
    },
    selectCustomPicture: function selectCustomPicture(e) {
      var _this30 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee20() {
        var action, file, url;
        return regenerator_default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                action = _this30.modal.action ? _this30.setModal2Action : _this30.setModalAction;
                file = e.target.files[0];
                _context20.next = 4;
                return Object(util["k" /* imageReader */])([file]);

              case 4:
                url = _context20.sent[0];

                action({
                  action: 'imageCropper',
                  width: '616px',
                  param: {
                    url: url
                  },
                  callback: function () {
                    var _ref13 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee19(result) {
                      return regenerator_default.a.wrap(function _callee19$(_context19) {
                        while (1) {
                          switch (_context19.prev = _context19.next) {
                            case 0:
                              if (result) {
                                _this30.customPicture = {
                                  id: 'custom',
                                  name: file.name,
                                  url: result.url,
                                  file: result.file,
                                  class_name: 'DatasetPictureFile'
                                };
                              }

                            case 1:
                            case 'end':
                              return _context19.stop();
                          }
                        }
                      }, _callee19, _this30);
                    }));

                    return function callback(_x4) {
                      return _ref13.apply(this, arguments);
                    };
                  }()
                });
                e.target.value = '';

              case 7:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, _this30);
      }))();
    },
    onEvent: function onEvent(e, c) {
      if (['input', 'tag', 'send'].includes(e)) {
        if (c) {
          var id = c.id || (this.users.find(function (user) {
            return c === [user.first_name, user.last_name].filter(function (x) {
              return x;
            }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) {
              return x;
            }).join(' ') + ')' : '');
          }) || {}).id;
          this.result.user_id = id || this.result.user_id;
        } else {
          this.result.user_id = -1;
        }
      }
    },
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(cols || keys_default()(this.dataset)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var col = _step4.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    nameConfirm: function nameConfirm(name) {
      var _this31 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee21() {
        var config, params, response, result;
        return regenerator_default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                config = _this31.$ls.get('userInfo');
                params = {
                  name: name
                };

                if ((_this31.form || {}).roleSelect) {
                  params.user_id = _this31.result.user_id;
                }
                _context21.next = 6;
                return Object(src_api["_18" /* getDatasetExistingState */])(params, config);

              case 6:
                response = _context21.sent;
                result = response.data.data;

                if (result) {
                  _context21.next = 12;
                  break;
                }

                _this31.alerts = extends_default()({}, _this31.alerts, {
                  name: null
                });
                _context21.next = 13;
                break;

              case 12:
                throw new Error();

              case 13:
                _context21.next = 18;
                break;

              case 15:
                _context21.prev = 15;
                _context21.t0 = _context21['catch'](0);

                _this31.alerts = extends_default()({}, _this31.alerts, {
                  name: {
                    type: 'error',
                    msg: _this31.$t('COMPONENT.dataset.base.form.customValidate.___user_id')
                  }
                });

              case 18:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, _this31, [[0, 15]]);
      }))();
    },
    sampleValidate: function sampleValidate() {
      if (this.selectedSampleSize > 0) {
        return true;
      } else {
        this.alerts = extends_default()({}, this.alerts, {
          sample: {
            type: 'error',
            msg: this.$t('COMPONENT.dataset.base.form.customValidate.___sample_size')
          }
        });
        return false;
      }
    },
    validateSubmit: function validateSubmit() {
      var _this32 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee22() {
        var result, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, kv;

        return regenerator_default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                result = {};

                _this32.onSubmit = true;
                _iteratorNormalCompletion5 = true;
                _didIteratorError5 = false;
                _iteratorError5 = undefined;
                _context22.prev = 5;
                _iterator5 = get_iterator_default()(entries_default()(_this32.validate));

              case 7:
                if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                  _context22.next = 15;
                  break;
                }

                kv = _step5.value;
                _context22.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context22.sent;

              case 12:
                _iteratorNormalCompletion5 = true;
                _context22.next = 7;
                break;

              case 15:
                _context22.next = 21;
                break;

              case 17:
                _context22.prev = 17;
                _context22.t0 = _context22['catch'](5);
                _didIteratorError5 = true;
                _iteratorError5 = _context22.t0;

              case 21:
                _context22.prev = 21;
                _context22.prev = 22;

                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }

              case 24:
                _context22.prev = 24;

                if (!_didIteratorError5) {
                  _context22.next = 27;
                  break;
                }

                throw _iteratorError5;

              case 27:
                return _context22.finish(24);

              case 28:
                return _context22.finish(21);

              case 29:
                result['custom'] = _this32.customValidate();
                if ((_this32.form || {}).sampleSelect) {
                  result['sample'] = _this32.sampleValidate();
                }

                if (values_default()(result).includes(false)) {
                  _context22.next = 33;
                  break;
                }

                return _context22.abrupt('return', true);

              case 33:
                _this32.onSubmit = false;

              case 34:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, _this32, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    submit: function submit() {
      var _this33 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee23() {
        var data, customPicture;
        return regenerator_default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                data = _this33.sendData;
                customPicture = _this33.customPicture;
                return _context23.abrupt('return', { data: data, customPicture: customPicture });

              case 3:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, _this33);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-072f707c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dataset/base.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataset-base-page col-block width-full"},[_c('div',{staticClass:"dataset-form-container col-block width-full"},[((_vm.form || {}).roleSelect)?[_c('customForm',{attrs:{"layoutType":'grid',"groupCount":6,"init":_vm.dataset,"alerts":_vm.alerts,"scope":_vm.scope,"forms":_vm.formOptions['field0']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field0', result, validate, errors); }},scopedSlots:_vm._u([{key:"user_id",fn:function(props){return [_c('div',{staticClass:"input-group",style:({ width: '100%', padding: 0 }),attrs:{"name":props}},[_c('inputTag',{style:({ width: '100%' }),attrs:{"inputStyle":{ 'padding-right': '40px' },"init":(_vm.userOptions.find(function (option) { return option.value === _vm.result.user_id; }) || {}).title,"emptyDisplay":true,"disabled":false,"placeholder":'',"tags":_vm.users,"prefix":'(?:^)',"target":'^(.*?)$',"replace":function (user) { return [user.first_name, user.last_name].filter(function (x) { return x; }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) { return x; }).join(' ') + ')' : ''); },"filter":function (content) { return function (user) { return content && ([user.first_name, user.last_name].filter(function (x) { return x; }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) { return x; }).join(' ') + ')' : '')).match(new RegExp(content.replace(/(\(|\)|\[|\]|\{|\}|\\)/g, '\\$1'), 'i')); }; },"tagDisplay":function (user) { return [user.first_name, user.last_name].filter(function (x) { return x; }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) { return x; }).join(' ') + ')' : ''); }},on:{"input":function (content) { return _vm.onEvent('input', content); },"send":function (content) { return _vm.onEvent('send', content); },"tag":function (content) { return _vm.onEvent('tag', content); }}})],1)]}}])})]:_vm._e(),_vm._v(" "),_c('customForm',{attrs:{"layoutType":'grid',"groupCount":6,"init":_vm.dataset,"alerts":_vm.alerts,"scope":_vm.scope,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }},scopedSlots:_vm._u([{key:"_TAG",fn:function(props){return [_c('div',{staticClass:"_TAG input-group",attrs:{"name":props}},[_c('dataTag',{style:({ width: '100%' }),attrs:{"disabled":false,"placeholder":_vm.$t('COMPONENT.dataset.base.customForm.tag.___dataTagPlaceholder'),"needInfo":false,"init":_vm.query['tag'],"data":_vm.tag['tag'],"tagDisplay":function (tag) { return tag; },"emptyMsg":'',"replace":function (tag, content) { return tag; }},on:{"input":function (content) { _vm.query['tag'] = content },"tag":function (tag) { _vm.query['tag'] = tag; _vm.curTag['tag'] = tag },"send":function (content) { return _vm.addTag('tag'); }}})],1)]}},{key:"_TAGS",fn:function(props){return [_c('div',{staticClass:"_TAGS row-block stretch",attrs:{"name":props}},[_c('button',{staticClass:"white-gray-button circle-button",attrs:{"type":"button","disabled":!_vm.query['tag']},on:{"click":function (e) { return _vm.addTag('tag', 'button'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___add')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"tag-list-container row-block flex-start flex-wrap shrink"},_vm._l((_vm.tags['tag']),function(tag,index){return _c('div',{key:index,staticClass:"tag-block row-block"},[_c('div',{staticClass:"tag-title"},[_vm._v(_vm._s(tag))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('img',{staticClass:"tag-remove-icon",attrs:{"src":__webpack_require__("Fg3B"),"alt":""},on:{"click":function (e) { return _vm.tags['tag'].splice(index, 1); }}})])}),0),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]}}])})],2),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"dataset-picture-field col-block flex-start"},[_c('div',{staticClass:"dataset-picture-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.dataset.base.picture.___title')))]),_vm._v(" "),_c('div',{style:({ height: '7px' })}),_vm._v(" "),_c('div',{staticClass:"dataset-picture-container row-block flex-start flex-wrap"},[_c('div',{staticClass:"dataset-picture-list-container row-block flex-start flex-wrap"},_vm._l((_vm.pictures),function(picture,index){return _c('div',{key:index,staticClass:"dataset-picture-block",on:{"click":function (e) { return _vm.selectedPictureID = picture.id; }}},[_c('div',{staticClass:"dataset-picture",style:({ 'background-image': 'url(' + picture.url + ')' })}),_vm._v(" "),_c('div',{staticClass:"dataset-picture-radio-icon icon-block",style:({ '--size': '20px' })},[_c('img',{attrs:{"src":_vm.selectedPictureID === picture.id ? __webpack_require__("xccc") : __webpack_require__("z0Pm"),"alt":""}})])])}),0),_vm._v(" "),_c('div',{staticClass:"custom-picture-container col-block flex-start"},[_c('div',{staticClass:"custom-picture-title-container row-block",class:{ disabled: !_vm.customPicture },on:{"click":function (e) { return _vm.customPicture && (_vm.selectedPictureID = 'custom'); }}},[_c('div',{staticClass:"custom-picture-radio-icon icon-block",style:({ '--size': '20px' })},[_c('img',{attrs:{"src":_vm.selectedPictureID === 'custom' ? __webpack_require__("xccc") : __webpack_require__("z0Pm"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"custom-picture-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.dataset.base.picture.___customTitle')))])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"custom-picture-main-container col-block"},[(_vm.customPicture)?_c('div',{staticClass:"custom-picture-image-block"},[_c('div',{staticClass:"custom-picture-image mask",style:({ 'background-image': 'url(' + _vm.customPicture.url + ')' })}),_vm._v(" "),_c('div',{staticClass:"custom-picture-image",style:({ 'background-image': 'url(' + _vm.customPicture.url + ')' })})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mask"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":"custom-picture","accept":"image/*"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.selectCustomPicture(e); }, function () { return _vm.addToast('error', _vm.$t('COMMON.toast.___fileTypeAlert', { types: 'image' })); }); }}}),_vm._v(" "),_c('label',{attrs:{"for":"custom-picture"}}),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button"},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])])])])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),((_vm.form || {}).sampleSelect)?[_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '15px' })}),_vm._v(" "),_c('div',{staticClass:"dataset-sample-container col-block width-full"},[_c('div',{staticClass:"dataset-sample-title-container row-block"},[_c('borCor',{attrs:{"display":!!(_vm.alerts['sample'] && _vm.alerts['sample'].type === 'error'),"background":'white',"border":'#FA3D3D',"radius":'3px',"translate":'-120px 0px',"blockStyle":{ padding: '5px 20px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"dataset-sample-title-block row-block",class:{ alert: _vm.alerts['sample'] && _vm.alerts['sample'].type === 'error' }},[_c('div',{staticClass:"dataset-sample-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.dataset.base.sample.___title'))),_c('span',{staticClass:"alert"},[_vm._v(" *")])]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"dataset-sample-information"},[_vm._v(_vm._s(_vm.$tc('COMPONENT.dataset.base.sample.___info', _vm.selectedSampleSize, { count: _vm.selectedSampleSize })))]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"dataset-sample-option-container row-block"},[_c('button',{staticClass:"white-gray-button circle-button",attrs:{"disabled":_vm.sample.listType !== 'case'},on:{"click":function (e) { return _vm.sampleOpenDatasetSelectCase(); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"dataset-sample-alert"},[_vm._v(_vm._s((_vm.alerts['sample'] || {}).msg))])])]),_vm._v(" "),_c('div',{staticClass:"dataset-sample-view-type-container row-block"},[_c('div',{staticClass:"dataset-sample-view-type-title",class:{ active: _vm.sample.viewType === 'detail' }},[_vm._v(_vm._s(_vm.$t('COMPONENT.dataset.base.sample.viewTitle.___detail')))]),_vm._v(" "),_c('switchButton',{attrs:{"disabled":false,"active":true,"checked":_vm.sample.viewType === 'list'},on:{"input":function (c) { return _vm.sample.viewType = c ? 'list' : 'detail'; }}}),_vm._v(" "),_c('div',{staticClass:"dataset-sample-view-type-title",class:{ active: _vm.sample.viewType === 'list' }},[_vm._v(_vm._s(_vm.$t('COMPONENT.dataset.base.sample.viewTitle.___list')))])],1)],1),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '0' })}),_vm._v(" "),_c('div',{staticClass:"dataset-sample-list-container col-block width-full"},[_c('div',{staticClass:"dataset-sample-list-option-container row-block"},[_c('div',{staticClass:"dataset-sample-list-tab-list-container row-block"},_vm._l((_vm.sampleListOptions),function(option,tindex){return _c('div',{key:tindex,staticClass:"tab-field row-block height-full",class:{ active: option.value === _vm.sample.listType },on:{"click":function (e) { return _vm.sample.listType = option.value; }}},[_c('div',{staticClass:"tab-container col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"tab-block row-block"},[_c('div',{staticClass:"tab-title"},[_vm._v(_vm._s(option.title))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}),0),_vm._v(" "),_c('div',{staticClass:"dataset-sample-list-search-container input-group",style:({ width: '280px' })},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sample.query),expression:"sample.query"}],style:({ 'padding-right': '40px' }),attrs:{"type":"text","placeholder":{ case: _vm.$t('COMPONENT.dataset.base.sample.searchPlaceholder.___case'), dataset: _vm.$t('COMPONENT.dataset.base.sample.searchPlaceholder.___dataset') }[_vm.sample.listType]},domProps:{"value":(_vm.sample.query)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sample, "query", $event.target.value)}}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zSkq"),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"dataset-sample-table-field col-block width-full"},[_vm._l((_vm.sampleListOptions),function(sampleOption){return [_c('div',{key:sampleOption.value,staticClass:"dataset-sample-table-container custom-table",class:{ 'auto-height': false, active: _vm.sample.listType === sampleOption.value }},[_c('div',{staticClass:"table-field col-block",style:({ width: '100%' })},[_c('div',{staticClass:"table-container col-block"},[_c('div',{staticClass:"thead"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.sampleTableOptions[sampleOption.value].filter(function (option) { return option.show !== false; })),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:(option.width ? { width: option.width + 'px' } : { flex: 1 }),on:{"click":function (e) { return !_vm.sample.sort[sampleOption.value].disabled && option.sortMap !== null && _vm.sampleTableSortBy(option.sortValue || option.value, sampleOption.value); }}},[(option.value === '_SELECT')?[_c('div',{staticClass:"_SELECT center-block"},[_c('img',{attrs:{"src":_vm.sample.results[sampleOption.value].length ? !_vm.sampleFiltedDatas[sampleOption.value].some(function (data) { return !_vm.sampleSelectedDataMap[sampleOption.value][data.id]; }) ? __webpack_require__("7kqe") : __webpack_require__("Z77G") : __webpack_require__("5Ivo"),"alt":""},on:{"click":function (e) { return _vm.sampleTableOnSelect(sampleOption.value, null, 'all'); }}})])]:[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sample.sort[sampleOption.value].order[_vm.sample.sort[sampleOption.value].value.indexOf(option.sortValue || option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e()]],2)}),0)])]),_vm._v(" "),_c('scrollBottom',{ref:'custom-table-scroll-' + sampleOption.value,refInFor:true,staticClass:"table-group-container col-block width-full",attrs:{"containerKey":sampleOption.value,"deviation":800,"onScrollBottom":function () { return _vm.sampleSearchDatas(false, sampleOption.value); }}},[(_vm.sample.pageData.total[sampleOption.value] || Object.keys(_vm.sampleSelectedDataMap[sampleOption.value]).length)?_c('div',{staticClass:"col-block"},_vm._l((_vm.sampleTableDatas[sampleOption.value]),function(group,gindex){return _c('div',{key:gindex,staticClass:"table-container col-block"},[_c('div',{staticClass:"tbody",class:{ 'list-view': ['list'].includes(_vm.sample.viewType) }},[_c('div',{staticClass:"tr group row-block",class:{ selected: false },style:(group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' })},[_c('a',{staticClass:"container-block row-block"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.sampleTableOptions[sampleOption.value].filter(function (option) { return option.show !== false; })),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(group[option.gValue], gindex, group),style:(option.width ? { width: option.width - (!_vm.sampleTableOptions[sampleOption.value][index + 1] && _vm.sample.tableOverflow[sampleOption.value] ? _vm.scrollbarSize : 0) + 'px' } : { flex: 1 })},[[_c('span',{style:((option.gstyle || (function () { return ({}); }))(group[option.gValue], gindex, group)),attrs:{"title":((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || option.gempty || '')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('center') && !(option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sample.sort[sampleOption.value].order[_vm.sample.sort[sampleOption.value].value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)]),_vm._v(" "),_vm._l((group.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"tr col-block",class:{ selectable: false, selected: false }},[(['detail'].includes(_vm.sample.viewType))?_c('a',{staticClass:"container-block row-block",style:({ flex: 1 })},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.sampleTableOptions[sampleOption.value].filter(function (option) { return option.show !== false; })),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(data[option.value], dindex, data),style:(option.width ? { width: option.width - (!_vm.sampleTableOptions[sampleOption.value][index + 1] && _vm.sample.tableOverflow[sampleOption.value] ? _vm.scrollbarSize : 0) + 'px' } : { flex: 1 })},[(option.value === '_SELECT')?[_c('div',{staticClass:"_SELECT center-block"},[_c('img',{attrs:{"src":data.selected ? __webpack_require__("7kqe") : __webpack_require__("5Ivo"),"alt":""},on:{"click":function (e) { return _vm.sampleTableOnSelect(sampleOption.value, [data], !data.selected); }}})])]:(option.value === '_DETAIL')?[_c('div',{staticClass:"_DETAIL center-block"},[_c('img',{attrs:{"src":__webpack_require__("OlcD"),"alt":""},on:{"click":function (e) { return _vm.sampleOpenDatasetDetail(data); }}})])]:[_c('span',{style:((option.style || (function () { return ({}); }))(data[option.value], dindex, data)),attrs:{"title":((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || option.empty || '- -')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(data[option.value], dindex, data).includes('center') && !(option.class || (function () { return []; }))(data[option.value], dindex, data).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sample.sort[sampleOption.value].order[_vm.sample.sort[sampleOption.value].value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2):_c('div',{staticClass:"list-block row-block"},[_c('img',{attrs:{"src":data.selected ? __webpack_require__("7kqe") : __webpack_require__("5Ivo"),"alt":""},on:{"click":function (e) { return _vm.sampleTableOnSelect(sampleOption.value, [data], !data.selected); }}}),_vm._v(" "),_c('span',{staticClass:"ellipsis",style:({ flex: 1 }),attrs:{"title":((_vm.sampleTableOptions[sampleOption.value][1].display || (function (x) { return x; }))(data[_vm.sampleTableOptions[sampleOption.value][1].value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((_vm.sampleTableOptions[sampleOption.value][1].display || (function (x) { return x; }))(data[_vm.sampleTableOptions[sampleOption.value][1].value], dindex, data) || _vm.sampleTableOptions[sampleOption.value][1].empty || '- -')}})])])})],2)])}),0):_c('div',{staticClass:"table-empty-container col-block"},[_c('div',{style:({ flex:1 })}),_vm._v(" "),_c('div',{staticClass:"table-empty-content",class:[sampleOption.value]},[_vm._v(_vm._s(_vm.sampleEmptyText[sampleOption.value] || ''))]),_vm._v(" "),_c('div',{style:({ flex:1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-page-container row-block sub-shadow",style:({ height: '50px' })},[_c('div',{staticClass:"options-container input-group row-block",style:({ flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"display-container row-block"},[_c('div',{staticClass:"display-title"},[_vm._v(_vm._s(_vm.$t(_vm.pageDisplay.display)))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sample.pageData.display[_vm.sample.listType]),expression:"sample.pageData.display[sample.listType]"}],staticClass:"display",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.sample.pageData.display, _vm.sample.listType, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"200"}},[_vm._v("200")])])])])]),_vm._v(" "),_c('div',{staticClass:"options-container input-group row-block"},[_c('pageButtons',{style:({ flex: 1 }),attrs:{"default":_vm.sample.pageData.selectedPage[_vm.sample.listType],"display":_vm.sample.pageData.display[_vm.sample.listType] - 0,"total":_vm.totalPage * _vm.sample.pageData.display[_vm.sample.listType],"buttonRange":_vm.sample.pageData.buttonRange[_vm.sample.listType]},on:{"selectPage":function (page) { _vm.sample.pageData.selectedPage[_vm.sample.listType] = page }}})],1),_vm._v(" "),_c('div',{staticClass:"options-container input-group row-block",style:({ flex: 1 })},[_c('div',{staticClass:"jump-container row-block"},[_c('div',{staticClass:"jump-title"},[_vm._v(_vm._s(_vm.$t(_vm.pageDisplay.jump)))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sample.pageData.pageJumpTo[_vm.sample.listType]),expression:"sample.pageData.pageJumpTo[sample.listType]"}],staticClass:"jump",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.sample.pageData.pageJumpTo, _vm.sample.listType, $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function (e) { return _vm.sample.pageData.selectedPage[_vm.sample.listType] = _vm.sample.pageData.pageJumpTo[_vm.sample.listType] - 0; }]}},_vm._l(((new Array(_vm.totalPage[_vm.sample.listType])).fill('').map(function (_, i) { return i + 1; })),function(value,index){return _c('option',{key:index,domProps:{"value":value}},[_vm._v(_vm._s(value))])}),0)]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])],1)])]})],2)])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dataset_base = (esExports);
// CONCATENATED MODULE: ./src/components/dataset/base.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  base,
  dataset_base,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_dataset_base = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+kXL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/from.js
var from = __webpack_require__("c/Tr");
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/pageButtons.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pageButtons = ({
  props: {
    default: {
      type: Number,
      default: 1
    },
    display: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    buttonRange: {
      type: Number,
      default: 5
    },
    showFirst: {
      type: Boolean,
      default: true
    },
    showLast: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      page: this.default
    };
  },

  watch: {
    'page': function page(val) {
      this.fixRange();
    },
    'total': function total(val) {
      this.fixRange(true);
    },
    'display': function display(val) {
      this.fixRange();
    },
    'default': function _default(val) {
      if (val) {
        this.page = val;
      }
    }
  },
  computed: {
    first: function first() {
      return 1;
    },
    last: function last() {
      return this.total > 0 && this.display > 0 ? Math.ceil(this.total / this.display) : 1;
    },
    nowList: function nowList() {
      var _this = this;

      return from_default()(new Array(this.buttonRange), function (v, i) {
        return i + _this.page - Math.floor(_this.buttonRange / 2);
      }).filter(function (n) {
        return n >= _this.first && n <= _this.last;
      });
    }
  },
  methods: {
    selectPage: function selectPage(page) {
      this.page = page !== 'pre' ? page !== 'next' ? page : Math.min(this.page + 1, this.last) : Math.max(this.page - 1, this.first);
    },
    fixRange: function fixRange() {
      var isTotal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var fixPage = this.page >= this.first ? this.page <= this.last ? this.page : this.last : this.first;
      if (fixPage !== this.page) {
        this.selectPage(fixPage);
      } else if (!isTotal) {
        this.$emit('selectPage', this.page);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4f29cf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/pageButtons.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-group"},[_c('div',{staticClass:"pre"},[_c('a',{on:{"click":function($event){_vm.selectPage('pre')}}},[_c('img',{style:({ transform: 'rotate(270deg)' }),attrs:{"src":__webpack_require__("n3Bz"),"alt":""}})])]),_vm._v(" "),(_vm.nowList[0] !== _vm.first)?_c('div',{staticClass:"first"},[(_vm.showFirst)?_c('a',{on:{"click":function($event){_vm.selectPage(_vm.first)}}},[_vm._v(_vm._s(_vm.first))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"ellipsis"},[_vm._v("...")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"now"},_vm._l((_vm.nowList),function(n,i){return _c('a',{key:i,class:{ 'active': _vm.page === n, 'first': n === _vm.first, 'last': n === _vm.last },on:{"click":function($event){_vm.selectPage(n)}}},[_vm._v(_vm._s(n))])}),0),_vm._v(" "),(_vm.nowList[_vm.nowList.length - 1] !== _vm.last)?_c('div',{staticClass:"last"},[_c('a',{staticClass:"ellipsis"},[_vm._v("...")]),_vm._v(" "),(_vm.showLast)?_c('a',{on:{"click":function($event){_vm.selectPage(_vm.last)}}},[_vm._v(_vm._s(_vm.last))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"next"},[_c('a',{on:{"click":function($event){_vm.selectPage('next')}}},[_c('img',{style:({ transform: 'rotate(90deg)' }),attrs:{"src":__webpack_require__("n3Bz"),"alt":""}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_pageButtons = (esExports);
// CONCATENATED MODULE: ./src/components/tool/pageButtons.vue
function injectStyle (ssrContext) {
  __webpack_require__("0yFZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  pageButtons,
  tool_pageButtons,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_pageButtons = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+lE8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/from.js
var from = __webpack_require__("c/Tr");
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/api/index.js
var src_api = __webpack_require__("gyMJ");

// EXTERNAL MODULE: ./src/components/tool/switchButton.vue + 2 modules
var switchButton = __webpack_require__("BdG8");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/case/intractableDisease.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var intractableDisease = ({
  components: {
    switchButton: switchButton["a" /* default */]
  },
  props: {
    defaultDatas: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      datas: null,
      analysisSwitch: true,
      selecteds: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['modal']), {
    sendData: function sendData() {
      return {
        datas: this.selecteds,
        analysisSwitch: this.analysisSwitch
      };
    }
  }),
  watch: {
    'defaultDatas': function defaultDatas(nv, ov) {
      if (nv !== ov) {
        this.init(nv);
      }
    },
    'sendData': function sendData(nv) {
      this.$emit('change', nv);
    }
  },
  created: function created() {
    this.init(this.defaultDatas);
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction', 'setModal2Action']), {
    init: function init(defaultData) {
      var datas = defaultData.datas || [];
      this.datas = datas;
      this.selecteds = datas;
      this.analysisSwitch = ![null, undefined].includes(defaultData.analysisSwitch) ? defaultData.analysisSwitch : this.analysisSwitch;
    },
    dataOnSelect: function dataOnSelect(data) {
      if (this.selecteds.some(function (selected) {
        return selected.value === data.value;
      })) {
        this.selecteds.splice(this.selecteds.indexOf(data), 1);
      } else {
        this.selecteds.push(data);
      }
    },
    openIntractableDiseaseSelect: function openIntractableDiseaseSelect() {
      var _this = this;

      var action = this.modal.action ? this.setModal2Action : this.setModalAction;
      action({
        action: 'intractableDiseaseSelect',
        width: '1208px',
        height: 'calc(100% - 160px)',
        param: {
          selectedDatas: this.selecteds
        },
        callback: function () {
          var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(result) {
            var selectedDatas;
            return regenerator_default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (result) {
                      selectedDatas = result;

                      selectedDatas.forEach(function (selectedData) {
                        if (!_this.datas.some(function (data) {
                          return data.value === selectedData.value;
                        })) {
                          _this.datas.push(selectedData);
                        }
                        if (!_this.selecteds.some(function (selected) {
                          return selected.value === selectedData.value;
                        })) {
                          _this.selecteds.push(selectedData);
                        }
                      });
                    }

                  case 1:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function callback(_x) {
            return _ref.apply(this, arguments);
          };
        }()
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90093798","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/intractableDisease.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.datas)?_c('div',{staticClass:"intractable-disease-page col-block width-full"},[_c('div',{staticClass:"intractable-disease-main-container col-block width-full"},[_c('div',{staticClass:"intractable-disease-main-block"},[_c('div',{staticClass:"intractable-disease-select-container col-block width-full"},[_c('div',{staticClass:"intractable-disease-select-title-container row-block"},[_c('div',{staticClass:"intractable-disease-select-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.intractableDisease.select.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"intractable-disease-select-option-container row-block"},[_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.openIntractableDiseaseSelect(); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___add')))])])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"intractable-disease-switch-container col-block width-full"},[_c('div',{staticClass:"intractable-disease-switch-title-container row-block"},[_c('div',{staticClass:"intractable-disease-switch-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.intractableDisease.switch.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"intractable-disease-switch-option-container row-block"},[_c('div',{staticClass:"intractable-disease-switch-option-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.customForm.reportPhenovardb.___off')))]),_vm._v(" "),_c('switchButton',{attrs:{"disabled":false,"checked":_vm.analysisSwitch},on:{"input":function (c) { _vm.analysisSwitch = c }}}),_vm._v(" "),_c('div',{staticClass:"intractable-disease-switch-option-title active"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.customForm.reportPhenovardb.___on')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),(_vm.datas.length)?_c('div',{staticClass:"intractable-disease-select-result-container col-block width-full"},[_c('div',{staticClass:"intractable-disease-select-result-title-container row-block"},[_c('div',{staticClass:"intractable-disease-select-result-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.intractableDisease.selectResult.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"intractable-disease-select-result-item-container col-block width-full"},[_c('div',{staticClass:"intractable-disease-select-result-item-list-container row-block flex-start flex-wrap"},_vm._l((_vm.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"intractable-disease-select-result-item-block row-block",on:{"click":function (e) { return _vm.dataOnSelect(data); }}},[_c('img',{staticClass:"intractable-disease-select-result-item-icon",attrs:{"src":_vm.selecteds.some(function (selected) { return selected.value === data.value; }) ? __webpack_require__("7kqe") : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"intractable-disease-select-result-item-title"},[_vm._v(_vm._s(_vm.$t(data.title)))])])}),0)])]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var case_intractableDisease = (esExports);
// CONCATENATED MODULE: ./src/components/case/intractableDisease.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  intractableDisease,
  case_intractableDisease,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_case_intractableDisease = (Component.exports);

// EXTERNAL MODULE: ./src/components/tool/dataTag.vue + 2 modules
var dataTag = __webpack_require__("Mq4e");

// EXTERNAL MODULE: ./src/mixins/responsitive.vue + 1 modules
var responsitive = __webpack_require__("E4co");

// EXTERNAL MODULE: ./src/mixins/toastMethods.vue + 1 modules
var toastMethods = __webpack_require__("2PDt");

// EXTERNAL MODULE: ./src/mixins/customGrab.vue + 1 modules
var customGrab = __webpack_require__("TqmH");

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// EXTERNAL MODULE: ./src/constants/global/data.js
var global_data = __webpack_require__("x2hU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/case/baseFamilyCase.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var baseFamilyCase = ({
  components: {
    dataTag: dataTag["a" /* default */]
  },
  mixins: [responsitive["a" /* default */], toastMethods["a" /* default */], customGrab["a" /* default */]],
  props: {
    mode: {
      type: String,
      required: true
    },
    defaultData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      caseData: {},
      tags: {
        case: []
      },
      selectedCaseIDs: [],
      errorCases: [],
      familyMemberLimit: 9,
      // search
      map: {
        case: {}
      },
      query: {
        case: ''
      },
      tag: {
        case: {}
      },
      curTag: {
        case: null
      },
      loading: {
        case: false,
        caseAdd: false
      },
      searchTimer: {
        case: []
      },
      // table
      search: '',
      selectedTableData: null,
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [[50], [240, 300]],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    };
  },

  computed: {
    tableDatas: function tableDatas() {
      var _this = this;

      var tableDatas = [];
      tableDatas = [].concat(toConsumableArray_default()(this.tags['case']));
      tableDatas = Object(util["m" /* sortData */])(tableDatas, this.sort.value.map(function (x) {
        return _this.sortMap[x];
      }), this.sort.order.map(function (x) {
        return x.replace('-', '');
      }));
      tableDatas = Object(util["i" /* groupBy */])(tableDatas, function () {
        return 'default';
      }).map(function (datas) {
        return { title: datas[0].group, isGroup: true, datas: datas };
      });
      return tableDatas;
    },
    sortMap: function sortMap() {
      return this.tableOptions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortMap || c.value));
      }, {});
    },
    addedCaseIDs: function addedCaseIDs() {
      return this.tags['case'].map(function (tag) {
        return tag.case_id;
      });
    },
    tagGroupData: function tagGroupData() {
      return Object(util["i" /* groupBy */])(this.tags['case'], function (tag) {
        return tag.relation;
      }, true);
    },
    addedRelations: function addedRelations() {
      var _this2 = this;

      return this.familyRelationOptions.filter(function (option) {
        return option.limit !== null && _this2.tagGroupData[option.value] && _this2.tagGroupData[option.value].length >= option.limit;
      }).map(function (option) {
        return option.value;
      });
    },
    sendData: function sendData() {
      var _this3 = this;

      return this.tags['case'].filter(function (data) {
        return _this3.selectedCaseIDs.includes(data.id);
      }).map(function (data) {
        return {
          id: data.id,
          case_id: data.case_id,
          phenotype: {
            'Affected': 2,
            'Unaffected': 1
          }[data.sample_type],
          relation: data.relation
        };
      });
    },

    // static
    tableOptions: function tableOptions() {
      return [{
        value: '_SELECT',
        class: function _class() {
          return ['center'];
        },
        sortMap: null
      }, {
        title: this.$t('COMPONENT.case.baseFamilyCase.table.title.___case_id'),
        value: 'case_id',
        class: function _class() {
          return [];
        }
      }, {
        title: this.$t('COMPONENT.case.baseFamilyCase.table.title.___type'),
        value: '_TYPE',
        class: function _class() {
          return ['auto-width'];
        },
        alert: true,
        sortMap: null
      }, {
        title: this.$t('COMPONENT.case.baseFamilyCase.table.title.___relation'),
        value: '_RELATION',
        class: function _class() {
          return ['auto-width', 'no-padding'];
        },
        alert: true,
        sortMap: null
      }];
    },
    typeOptions: function typeOptions() {
      return [{
        title: this.$t('COMPONENT.case.baseFamilyCase.table.option.type.title.___Affected'),
        value: 'Affected'
      }, {
        title: this.$t('COMPONENT.case.baseFamilyCase.table.option.type.title.___Unaffected'),
        value: 'Unaffected'
      }];
    },

    // global
    familyRelationOptions: function familyRelationOptions() {
      return global_data["n" /* familyRelationOptions */];
    }
  },
  watch: {
    'defaultData': function defaultData() {
      this.init();
    },

    'sendData': {
      handler: function handler(nv) {
        this.$emit('change', nv);
      },
      deep: true
    },
    // search
    'query.case': function queryCase(nv) {
      this.getCase(nv, 'case');
    },

    // table
    'selectedTableData': function selectedTableData(nv, ov) {
      if (nv !== ov && stringify_default()(nv) !== stringify_default()(ov)) {
        this.selectedTableData = nv ? JSON.parse(stringify_default()(nv)) : null;
      }
    },
    'selectedCaseIDs': function selectedCaseIDs(nv, ov) {
      if (nv.length < ov.length) {
        this.tags['case'] = this.tags['case'].filter(function (data) {
          return nv.includes(data.id);
        });
      }
    },
    'tableDatas': function tableDatas() {
      this.getTableOverflow();
    },
    'windowWidth': function windowWidth(nv) {
      this.getTableWidths(nv);
      this.getTableOverflow();
    }
  },
  created: function created() {
    this.getCase('', 'case');
    this.init();
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction']), {
    init: function init() {
      this.caseData = this.defaultData['case'] || {};
      if ((this.defaultData['analysis'] || {}).fam_analyze) {
        this.tags['case'] = this.defaultData['analysis'].members.map(function (member) {
          return {
            id: member.id,
            case_id: member.case_id,
            sample_type: { 2: 'Affected', 1: 'Unaffected' }[member.phenotype],
            relation: member.relation
          };
        });
        this.selectedCaseIDs = this.tags['case'].map(function (data) {
          return data.id;
        });
      } else {
        this.tags['case'] = [];
        this.selectedCaseIDs = [];
      }
    },

    // search
    getCase: function getCase(query, target) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var queryMap;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                queryMap = {};

                query = (queryMap[target] || function (x) {
                  return x;
                })(query);
                if ((_this4.curTag[target] || {}).case_id !== query) {
                  _this4.tag[target] = {};
                  if (_this4.searchTimer[target]) {
                    clearTimeout(_this4.searchTimer[target]);
                  }
                  _this4.searchTimer[target] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                    var config, caseID, response, datas;
                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (_this4.map[target][query]) {
                              _context.next = 16;
                              break;
                            }

                            _this4.loading[target] = true;
                            // this.setLoadingAction(true)
                            _context.prev = 2;
                            config = _this4.$ls.get('userInfo');
                            caseID = _this4.caseData.id;
                            _context.next = 7;
                            return Object(src_api["_28" /* getFamilyCases */])(caseID, query, config);

                          case 7:
                            response = _context.sent;
                            datas = response.data.data;

                            _this4.map[target] = extends_default()({}, _this4.map[target], defineProperty_default()({}, query, {
                              items: datas || []
                            }));
                            _context.next = 15;
                            break;

                          case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](2);

                            _this4.addToast('error', !_context.t0.response ? _context.t0.message : _context.t0.response.data.result.message);

                          case 15:
                            _this4.loading[target] = false;
                            // this.setLoadingAction(false)

                          case 16:
                            _this4.tag[target] = _this4.map[target][query] || {};

                          case 17:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this4, [[2, 12]]);
                  })), 0);
                }

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    addTag: function addTag(target, type) {
      var data = this.curTag[target];
      if (data && !this.loading[target + 'Add']) {
        this.loading[target + 'Add'] = true;
        switch (target) {
          case 'case':
            {
              if (!this.tags[target].some(function (tag) {
                return tag.case_id === data.case_id;
              })) {
                if (this.tags[target].length < this.familyMemberLimit) {
                  this.tags[target].push({
                    id: data.id,
                    case_id: data.case_id,
                    sample_type: data.affected ? 'Affected' : 'Unaffected',
                    relation: ''
                    // relation: this.familyRelationOptions.find(option => !this.addedRelations.includes(option.value)).value/
                  });
                  this.selectedCaseIDs.push(data.id);
                  this.curTag[target] = null;
                  this.query[target] = '';
                } else {
                  this.addToast('error', this.$t('COMMON.toast.___familyMemberLimit', { limit: this.familyMemberLimit }));
                }
              }
              break;
            }
          default:
            {}
        }
        this.query[target] = '';
        this.loading[target + 'Add'] = false;
      }
    },
    validateSubmit: function validateSubmit() {
      var emptyRelationDatas = this.tagGroupData[''] || [];
      this.errorCases = emptyRelationDatas;
      return emptyRelationDatas.length === 0;
    },

    // table
    getTableOverflow: function getTableOverflow() {
      var _this5 = this;

      setTimeout(function () {
        var scrollContainer = _this5.$refs['custom-table-scroll'];
        if (scrollContainer) {
          _this5.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight;
        }
      });
    },
    getTableWidths: function getTableWidths(windowWidth) {
      var tableWidth = ['analysis'].includes(this.mode) ? Math.min((windowWidth - this.scrollbarSize) * 0.95, 912) - 20 * 2 - 10 * 2 : 850;
      tableWidth = tableWidth - this.staticTableWidths[0].reduce(function (s, c) {
        return s + c;
      }, 0) - this.staticTableWidths[1].reduce(function (s, c) {
        return s + c;
      }, 0);
      var tableWidths = this.tableWidths || [].concat(toConsumableArray_default()(this.staticTableWidths[0]), [1], toConsumableArray_default()(this.staticTableWidths[1])).map(function (width) {
        return {
          value: width
        };
      });
      var tableMinWidths = this.tableMinWidths || 0.1;
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length);
      var ratio = tableWidth / tableWidths.reduce(function (s, c) {
        return s + c.value;
      }, 0);
      tableWidths = Array.prototype.concat.apply([], [this.staticTableWidths[0].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      }), tableWidths.map(function (width) {
        return {
          value: width.value * ratio,
          grab: 0
        };
      }), this.staticTableWidths[1].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      })]);
      this.tableMinWidths = tableMinWidths * ratio;
      this.tableWidths = tableWidths;
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
    },

    // grab
    boardResponse: function boardResponse(id, type) {
      return {
        'board1': {
          'start': function start(boardData) {},
          'move': function move(boardData) {},
          'end': function end(boardData) {}
        }
      }[id][type];
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e754dfb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/baseFamilyCase.vue
var baseFamilyCase_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-base-family-case-page col-block flex-start"},[_c('div',{staticClass:"case-base-family-case-search-container row-block"},[_c('div',{staticClass:"case-base-family-case-search-block input-group",style:({ width: '280px' })},[_c('dataTag',{style:({ width: '100%' }),attrs:{"disabled":false,"placeholder":_vm.$t('COMPONENT.case.baseFamilyCase.___searchPlaceholder'),"needInfo":false,"allowEmpty":true,"tagHeight":'200px',"init":_vm.query['case'],"data":_vm.tag['case'],"filter":function (data) { return !_vm.addedCaseIDs.includes(data.case_id) && (data.id !== _vm.$route.params.id); },"tagDisplay":function (tag) { return tag.case_id; },"emptyMsg":'',"replace":function (tag, content) { return tag.case_id; }},on:{"input":function (content) { _vm.query['case'] = content },"tag":function (tag) { _vm.query['case'] = tag.case_id; _vm.curTag['case'] = tag },"send":function (content) { return _vm.addTag('case'); }}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zSkq"),"alt":""}})],1),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",attrs:{"type":"button","disabled":!_vm.query['case'] || !(_vm.tag['case'].items || []).length || !_vm.curTag['case']},on:{"click":function (e) { return _vm.addTag('case', 'button'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___add')))])])]),_vm._v(" "),(_vm.tags['case'].length)?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"case-base-family-case-result-container col-block width-full"},[_c('div',{staticClass:"custom-table",class:{ 'auto-height': true }},[(_vm.tableWidths)?_c('div',{staticClass:"table-field col-block grab-container",style:({ width: _vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) + 'px' }),on:{"mousedown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardStart]); })($event)},"mousemove":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseout":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardEnd]); })($event)}}},[_c('div',{staticClass:"grab-line x min",style:(_vm.lineData.x.min && _vm.lineData.x.min.display ? { left: _vm.lineData.x.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x max",style:(_vm.lineData.x.max && _vm.lineData.x.max.display ? { left: _vm.lineData.x.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x main",style:(_vm.lineData.x.main && _vm.lineData.x.main.display ? { left: (_vm.lineData.x.main.base + _vm.lineData.x.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x custom",style:(_vm.lineData.x.custom && _vm.lineData.x.custom.display ? { left: _vm.lineData.x.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y min",style:(_vm.lineData.y.min && _vm.lineData.y.min.display ? { top: _vm.lineData.y.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y max",style:(_vm.lineData.y.max && _vm.lineData.y.max.display ? { top: _vm.lineData.y.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y main",style:(_vm.lineData.y.main && _vm.lineData.y.main.display ? { top: (_vm.lineData.y.main.base + _vm.lineData.y.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y custom",style:(_vm.lineData.y.custom && _vm.lineData.y.custom.display ? { top: _vm.lineData.y.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"table-container col-block"},[_c('div',{staticClass:"thead"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab + 'px' }),on:{"click":function (e) { return !_vm.sort.disabled && option.sortMap !== null && _vm.tableSortBy(option.sortValue || option.value); }}},[(option.value === '_SELECT')?[_c('img',{staticClass:"select-icon",attrs:{"src":_vm.selectedCaseIDs.length ? _vm.selectedCaseIDs.length === _vm.tags['case'].length ? __webpack_require__("7kqe") : __webpack_require__("Z77G") : __webpack_require__("5Ivo"),"alt":""},on:{"click":function (e) { return (_vm.selectedCaseIDs = _vm.selectedCaseIDs.length === _vm.tags['case'].length ? [] : _vm.tags['case'].map(function (data) { return data.id; })); }}})]:[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.alert)?_c('span',{style:({ color: '#FA3D3D' })},[_vm._v("*")]):_vm._e()],_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e()],2)}),0)])]),_vm._v(" "),_c('div',{ref:"custom-table-scroll",staticClass:"table-group-container col-block width-full"},[_c('div',{staticClass:"col-block"},_vm._l((_vm.tableDatas),function(group,gindex){return _c('div',{key:gindex,staticClass:"table-container col-block"},[_c('div',{staticClass:"tbody"},[_c('div',{staticClass:"tr group row-block",class:{ selected: false },style:(group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' })},[_c('a',{staticClass:"container-block row-block"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(group[option.gValue], gindex, group),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.gstyle || (function () { return ({}); }))(group[option.gValue], gindex, group)),attrs:{"title":((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || option.gempty || '')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('center') && !(option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)]),_vm._v(" "),_vm._l((group.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"tr col-block",class:{ selectable: false, selected: false, error: _vm.errorCases.find(function (caseData) { return caseData.id === data.id; }) }},[_c('a',{staticClass:"container-block row-block",style:({ flex: 1 }),on:{"click":function (e) { return false && (_vm.selectedTableData = data); }}},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(data[option.value], dindex, data),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[(option.value === '_SELECT')?[_c('img',{staticClass:"select-icon",attrs:{"src":_vm.selectedCaseIDs.includes(data.id) ? __webpack_require__("7kqe") : __webpack_require__("5Ivo"),"alt":""},on:{"click":function (e) { return (_vm.selectedCaseIDs = _vm.selectedCaseIDs.includes(data.id) ? _vm.selectedCaseIDs.filter(function (id) { return id !== data.id; }) : _vm.selectedCaseIDs.concat([data.id])); }}})]:(option.value === '_TYPE')?[_c('div',{staticClass:"case-base-family-case-type-list-container row-block"},[_c('div',{staticClass:"case-base-family-case-type-list-block row-block"},_vm._l((_vm.typeOptions),function(option,toindex){return _c('div',{key:toindex,staticClass:"case-base-family-case-type-container row-block",on:{"click":function (e) { return data.sample_type = option.value; }}},[_c('img',{staticClass:"select-icon",attrs:{"src":data.sample_type === option.value ? __webpack_require__("xccc") : __webpack_require__("z0Pm"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"case-base-family-case-type-title",domProps:{"innerHTML":_vm._s(option.title)}})])}),0),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]:(option.value === '_RELATION')?[_c('div',{staticClass:"case-base-family-case-relation-container input-group col-block width-full"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(data.relation),expression:"data.relation"}],style:(data.relation ? {} : { color: '#A9A9A9' }),on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(data, "relation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function (e) { return _vm.errorCases = _vm.errorCases.filter(function (caseData) { return caseData.id !== data.id; }); }]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.baseFamilyCase.table.option.relation.___placeholder')))]),_vm._v(" "),_vm._l((_vm.familyRelationOptions),function(option,froindex){return _c('option',{key:froindex,attrs:{"hidden":_vm.addedRelations.includes(option.value) && (data.relation !== option.value)},domProps:{"value":option.value}},[_vm._v(_vm._s(_vm.$t(option.title)))])})],2)])]:[_c('span',{style:((option.style || (function () { return ({}); }))(data[option.value], dindex, data)),attrs:{"title":((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || option.empty || '- -')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(data[option.value], dindex, data).includes('center') && !(option.class || (function () { return []; }))(data[option.value], dindex, data).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)])})],2)])}),0)])]):_vm._e()])])]:_vm._e()],2)}
var baseFamilyCase_staticRenderFns = []
var baseFamilyCase_esExports = { render: baseFamilyCase_render, staticRenderFns: baseFamilyCase_staticRenderFns }
/* harmony default export */ var case_baseFamilyCase = (baseFamilyCase_esExports);
// CONCATENATED MODULE: ./src/components/case/baseFamilyCase.vue
var baseFamilyCase_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var baseFamilyCase___vue_template_functional__ = false
/* styles */
var baseFamilyCase___vue_styles__ = null
/* scopeId */
var baseFamilyCase___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var baseFamilyCase___vue_module_identifier__ = null
var baseFamilyCase_Component = baseFamilyCase_normalizeComponent(
  baseFamilyCase,
  case_baseFamilyCase,
  baseFamilyCase___vue_template_functional__,
  baseFamilyCase___vue_styles__,
  baseFamilyCase___vue_scopeId__,
  baseFamilyCase___vue_module_identifier__
)

/* harmony default export */ var components_case_baseFamilyCase = (baseFamilyCase_Component.exports);

// EXTERNAL MODULE: ./src/components/tool/customForm.vue + 2 modules
var customForm = __webpack_require__("uuH9");

// EXTERNAL MODULE: ./src/components/tool/newBorCor.vue + 2 modules
var newBorCor = __webpack_require__("jHy4");

// EXTERNAL MODULE: ./src/components/tool/inputTag.vue + 2 modules
var inputTag = __webpack_require__("6EFu");

// EXTERNAL MODULE: ./src/components/tool/phenotypeTag.vue + 2 modules
var phenotypeTag = __webpack_require__("sdWU");

// EXTERNAL MODULE: ./src/components/tool/geneTag.vue + 2 modules
var geneTag = __webpack_require__("H3ds");

// EXTERNAL MODULE: ./src/mixins/routeLoading.vue + 1 modules
var routeLoading = __webpack_require__("zVZS");

// EXTERNAL MODULE: ./src/constants/global/config.js
var global_config = __webpack_require__("j9i1");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/case/base.vue












//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ var base = ({
  components: {
    intractableDisease: components_case_intractableDisease,
    baseFamilyCase: components_case_baseFamilyCase,
    customForm: customForm["a" /* default */],
    switchButton: switchButton["a" /* default */],
    borCor: newBorCor["a" /* default */],
    inputTag: inputTag["a" /* default */],
    phenotypeTag: phenotypeTag["a" /* default */],
    geneTag: geneTag["a" /* default */]
  },
  mixins: [routeLoading["a" /* default */]],
  props: {
    mode: {
      type: String,
      required: true
    },
    isUpdate: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    layoutBlocks: {
      type: Array,
      default: function _default() {
        return ['form', 'analysis', 'file'];
      }
    },
    dataset: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    scope: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    defaultData: {
      type: Object,
      required: true
    },
    projects: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      // form
      caseData: {},
      familyDatas: [],
      intractableDiseaseResult: {
        datas: [],
        analysisSwitch: true
      },
      analysisData: {
        report_phenovardb: true,
        family_analysis: false,
        family_exclude: true
      },
      alerts: {},
      result: {
        'case': {},
        'analysis': {},
        'view': {}
      },
      validate: {},
      error: {},
      onSubmit: false,
      // options
      users: [],
      genePanels: [],
      userGenePanel: null,
      divisions: [],
      omicss: {},
      // tag
      tagData: {
        map: {
          phenotype: {},
          gene: {}
        },
        query: {
          phenotype: '',
          gene: ''
        },
        tag: {
          phenotypes: {},
          genes: {}
        },
        curTag: {
          gene: null
        },
        searchTimer: {
          phenotype: [],
          gene: []
        }
      },
      // phenotype
      phenotypePanels: [],
      searchedPhenotypes: {
        phenotypes: [],
        genes: []
      },
      selectedPhenotypes: {
        panelPhenotypes: [],
        panelGenes: [],
        phenotypes: [],
        genes: []
      },
      // file
      fromCloud: false,
      cloudFilePaths: [],
      cloudFileCurrentPath: null,
      pipelineType: {
        'fastq': 'paired',
        'ubam': 'single'
      }[this.dataset] || 'paired',
      vcfSets: [{
        snv: null,
        sv: null,
        str: null
      }],
      fastqSets: [{
        r1: null,
        r2: null
      }],
      ubamSets: [{
        bam: null
      }],
      fileLimit: {
        sv: 3
      },
      // display
      display: {
        phenotypePanel: false,
        genePanel: false,
        alleleFrequencyThreshold: false,
        scoreThreshold: false,
        familyAnalysis: true
      },
      // loading
      loading: {
        addToSearch: false
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user', 'modal', 'userSetting']), {
    onError: function onError() {
      var _this = this;

      var result = values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
      this.$emit('onError', result);
      return result;
    },
    fileSets: function fileSets() {
      var key = {
        'vcf': 'vcfSets',
        'gvcf': 'vcfSets',
        'fastq': 'fastqSets',
        'ubam': 'ubamSets'
      }[this.dataset];
      return this[key];
    },
    formGroupCount: function formGroupCount() {
      return { 'create': 6, 'edit': 4, 'analysis': 6 }[this.mode];
    },
    selectedLimit: function selectedLimit() {
      return {
        phenotypes: values_default()(this.sendData.project.phenotypes || {}).filter(function (x) {
          return x;
        }).reduce(function (s, c) {
          return s + c.length;
        }, 0) >= 30,
        genes: (this.sendData.project.gene_panels || []).length >= 10
      };
    },
    reportDatabaseable: function reportDatabaseable() {
      var _this2 = this;

      return !['analysis'].includes(this.mode) || !this.result['analysis'].report_phenovardb || this.projects.filter(function (project) {
        return _this2.analysisData.id === project.id ? _this2.result['analysis'].report_phenovardb : project.report_phenovardb;
      }).length > 1;
    },
    familyAnalysisAlert: function familyAnalysisAlert() {
      var _this3 = this;

      if (['vcf'].includes(this.dataset)) {
        // return this.$t('COMPONENT.case.base.analysis.familyAnalysis.alert.___vcf')
      } else if (!this.projects.find(function (project) {
        return _this3.analysisData.id !== project.id && !project.fam_analyze;
      })) {
        return '';
      }
    },
    intractableDiseaseValueMap: function intractableDiseaseValueMap() {
      return global_data["A" /* intractableDiseaseOptions */].reduce(function (map, option) {
        return extends_default()({}, map, defineProperty_default()({}, option.value, option));
      }, {});
    },
    userGenePanelDatas: function userGenePanelDatas() {
      return this.userGenePanel ? Array.prototype.concat.apply([], entries_default()(this.userGenePanel.data || {}).map(function (kv) {
        var type = kv[0];
        var datas = kv[1];
        return ['free_typing'].includes(type) ? datas.map(function (data) {
          return { category: 'gene', name: data.symbol, data: [data] };
        }) : datas.map(function (data) {
          return extends_default()({}, data, { category: type });
        });
      })) : null;
    },

    // options
    userOptions: function userOptions() {
      return this.users.map(function (user) {
        return { title: [user.first_name, user.last_name].filter(function (x) {
            return x;
          }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) {
            return x;
          }).join(' ') + ')' : ''), value: user.id };
      });
    },
    sexOptions: function sexOptions() {
      return [{ title: this.$t('COMPONENT.case.base.option.sex.title.___male'), value: 'Male' }, { title: this.$t('COMPONENT.case.base.option.sex.title.___female'), value: 'Female' }, { title: this.$t('COMPONENT.case.base.option.sex.title.___unknown'), value: 'Unknown' }];
    },
    populationOptions: function populationOptions() {
      return [{ title: this.$t('COMPONENT.case.base.option.popuplation.title.___AfricanAfricanAmerican'), value: 'African/African-American' }, { title: this.$t('COMPONENT.case.base.option.popuplation.title.___LatinoAdmixedAmerican'), value: 'Latino/Admixed American' }, { title: this.$t('COMPONENT.case.base.option.popuplation.title.___AshkenaziJewish'), value: 'Ashkenazi Jewish' }, { title: this.$t('COMPONENT.case.base.option.popuplation.title.___EastAsian'), value: 'East Asian' }, { title: this.$t('COMPONENT.case.base.option.popuplation.title.___Koreans'), value: 'Koreans' }, { title: this.$t('COMPONENT.case.base.option.popuplation.title.___Japanese'), value: 'Japanese' }, { title: this.$t('COMPONENT.case.base.option.popuplation.title.___OtherEastAsian'), value: 'Other East Asian' }, { title: this.$t('COMPONENT.case.base.option.popuplation.title.___Finnish'), value: 'Finnish' }, { title: this.$t('COMPONENT.case.base.option.popuplation.title.___NonFinnishEuropean'), value: 'Non-Finnish European' }, { title: this.$t('COMPONENT.case.base.option.popuplation.title.___Bulgarian'), value: 'Bulgarian' }, { title: this.$t('COMPONENT.case.base.option.popuplation.title.___Estonian'), value: 'Estonian' }, { title: this.$t('COMPONENT.case.base.option.popuplation.title.___NorthWesternEuropean'), value: 'North-Western European' }, { title: this.$t('COMPONENT.case.base.option.popuplation.title.___SouthernEuropean'), value: 'Southern European' }, { title: this.$t('COMPONENT.case.base.option.popuplation.title.___Swedish'), value: 'Swedish' }, { title: this.$t('COMPONENT.case.base.option.popuplation.title.___OthernonFinnishEuropean'), value: 'Other non-Finnish European' }, { title: this.$t('COMPONENT.case.base.option.popuplation.title.___SouthAsian'), value: 'South Asian' }, { title: this.$t('COMPONENT.case.base.option.popuplation.title.___Other'), value: 'Other' }];
    },
    omicsOptions: function omicsOptions() {
      return keys_default()(this.omicss.omics || {}).map(function (key) {
        return { title: key, value: key };
      });
    },
    pipelineOptions: function pipelineOptions() {
      var curOmics = (this.omicss.omics || {})[this.result['case'].omics_name] || {};
      return keys_default()(curOmics.pipeline || {}).map(function (key) {
        return { title: key, value: key };
      });
    },
    libraryTypeOptions: function libraryTypeOptions() {
      var curOmics = (this.omicss.omics || {})[this.result['case'].omics_name] || {};
      var curPipeline = (curOmics.pipeline || {})[this.result['case'].pipeline_name] || {};
      return (curPipeline.library_type || []).map(function (key) {
        return { title: key, value: key };
      });
    },

    // static
    formOptions: function formOptions() {
      var _this4 = this;

      return {
        'field0': [{
          title: this.$t('COMPONENT.case.base.form.case.title.___owner'),
          value: 'USER_ID',
          type: 'custom',
          grid: {
            'create': 3,
            'edit': 4
          }[this.mode],
          disabled: function disabled() {
            return false;
          },
          validate: 'required'
        }],
        'field1': [{
          title: this.$t('COMPONENT.case.base.form.case.title.___caseID'),
          value: 'case_id',
          type: {
            'create': 'input',
            'edit': 'input',
            'analysis': 'text'
          }[this.mode],
          grid: 2,
          wrap: true,
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.case.placeholder.___caseID');
          },
          validate: {
            'create': 'required',
            'edit': 'required',
            'analysis': ''
          }[this.mode]
        }, {
          title: this.$t('COMPONENT.case.base.form.case.title.___affected'),
          value: 'AFFECTED',
          type: {
            'create': 'custom',
            'edit': 'custom',
            'analysis': 'text'
          }[this.mode],
          grid: 1,
          wrap: true,
          style: {
            'true': { color: '#83C91E' },
            'false': { color: '#999999' }
          }[this.caseData.affected + ''],
          disabled: function disabled() {
            return false;
          },
          inputFormat: function inputFormat() {
            return {
              'true': _this4.$t('COMPONENT.case.base.form.case.format.affected.___true'),
              'false': _this4.$t('COMPONENT.case.base.form.case.format.affected.___false')
            }[_this4.caseData.affected + ''];
          }
        }, {
          title: this.$t('COMPONENT.case.base.form.case.title.___subjectName'),
          value: 'subject_name',
          type: {
            'create': 'input',
            'edit': 'input',
            'analysis': 'text'
          }[this.mode],
          grid: 1,
          wrap: true,
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.case.placeholder.___subjectName');
          }
        }, {
          title: this.$t('COMPONENT.case.base.form.case.title.___sex'),
          value: 'sex',
          type: {
            'create': 'select',
            'edit': 'select',
            'analysis': 'text'
          }[this.mode],
          grid: 1,
          wrap: true,
          options: this.sexOptions,
          style: {
            Male: { color: '#003679' },
            Female: { color: '#FA3D3D' },
            Unknown: { color: '#333333' }
          }[this.result['case'].sex],
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.case.placeholder.___sex');
          },
          validate: {
            'create': 'required',
            'edit': 'required',
            'analysis': ''
          }[this.mode]
        }, {
          title: this.$t('COMPONENT.case.base.form.case.title.___birthYear'),
          value: 'birth_year',
          type: {
            'create': 'select',
            'edit': 'select',
            'analysis': 'text'
          }[this.mode],
          grid: 1,
          wrap: true,
          options: [{ title: this.$t('COMPONENT.case.base.form.case.option.birthYear.___unknown'), value: 'Unknown' }].concat(toConsumableArray_default()(new Array(new Date().getYear() + 1).fill('').map(function (_, i) {
            return { title: i + 1900, value: i + 1900 };
          }).reverse())),
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.case.placeholder.___birthYear');
          },
          validate: {
            'create': 'required',
            'edit': 'required',
            'analysis': ''
          }[this.mode],
          inputFormat: function inputFormat(value) {
            return value || 'Unknown';
          },
          outputFormat: function outputFormat(value) {
            return value && value !== 'Unknown' ? value : undefined;
          }
        }, {
          title: this.$t('COMPONENT.case.base.form.case.title.___population'),
          value: 'population',
          type: {
            'create': 'select',
            'edit': 'select',
            'analysis': 'text'
          }[this.mode],
          grid: 2,
          wrap: true,
          options: this.populationOptions,
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.case.placeholder.___population');
          }
        }, {
          title: this.$t('COMPONENT.case.base.form.case.title.___note'),
          value: 'note',
          type: {
            'create': 'textarea',
            'edit': 'textarea',
            'analysis': 'text'
          }[this.mode],
          grid: 4,
          row: 4,
          wrap: true,
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.case.placeholder.___note');
          },
          validate: 'max:900'
        }],
        'field2': global_config["a" /* _LOCAL_BUILD */] ? [{
          title: this.$t('COMPONENT.case.base.form.analysis.title.___name'),
          value: 'name',
          type: 'input',
          grid: 2,
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.analysis.placeholder.___name');
          },
          validate: 'required'
        }, {
          title: this.$t('COMPONENT.case.base.form.analysis.title.___note'),
          value: 'note',
          type: 'textarea',
          grid: 4,
          row: 4,
          wrap: true,
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.analysis.placeholder.___note');
          },
          validate: 'max:300'
        }] : [{
          title: this.$t('COMPONENT.case.base.form.analysis.title.___name'),
          value: 'name',
          type: 'input',
          grid: 2,
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.analysis.placeholder.___name');
          },
          validate: 'required'
        }, {
          title: this.$t('COMPONENT.case.base.form.analysis.title.___note'),
          value: 'note',
          type: 'textarea',
          grid: 3,
          row: 4,
          wrap: true,
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.analysis.placeholder.___note');
          },
          validate: 'max:300'
        }, {
          title: this.$t('COMPONENT.case.base.form.analysis.title.___report'),
          value: 'REPORT_PHENOVARDB',
          type: 'custom',
          grid: 1,
          disabled: function disabled() {
            return false;
          }
        }],
        'field3_1': [{
          title: this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.title.___ad_cutoff'),
          value: 'ad_cutoff',
          type: 'number',
          errorTitle: this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.errorTitle.___ad_cutoff'),
          grid: 2,
          inputWidth: '126px',
          step: 0.01,
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.placeholder.___ad_cutoff');
          },
          outputFormat: function outputFormat(value) {
            return (value || 0.001) - 0;
          },
          validate: 'min_value:0|max_value:1'
        }, {
          title: this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.title.___ar_cutoff'),
          value: 'ar_cutoff',
          type: 'number',
          errorTitle: this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.errorTitle.___ar_cutoff'),
          grid: 2,
          inputWidth: '126px',
          step: 0.01,
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.placeholder.___ar_cutoff');
          },
          outputFormat: function outputFormat(value) {
            return (value || 0.05) - 0;
          },
          validate: 'min_value:0|max_value:1'
        }, {
          title: this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.title.___comp_het_cutoff'),
          value: 'comp_het_cutoff',
          type: 'number',
          grid: 2,
          inputWidth: '126px',
          step: 0.01,
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.placeholder.___comp_het_cutoff');
          },
          outputFormat: function outputFormat(value) {
            return (value || 0.05) - 0;
          },
          validate: 'min_value:0|max_value:1'
        }, {
          title: this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.title.___exclude_low_quality_variants'),
          value: 'exclude_low_quality_variants',
          type: 'boolean',
          grid: 2,
          inputFormat: function inputFormat(value) {
            return ![undefined, null].includes(value) ? value : false;
          }
        }, {
          title: this.$t('COMPONENT.case.base.form.alleleFrequencyThreshold.title.___enable_clinvar_benign_filter'),
          value: 'enable_clinvar_benign_filter',
          type: 'boolean',
          grid: 2,
          inputFormat: function inputFormat(value) {
            return ![undefined, null].includes(value) ? value : true;
          }
        }, {}],
        'field3_2': [{
          title: this.$t('COMPONENT.case.base.form.scoreThreshold.title.___phenotype_score_cutoff'),
          value: 'phenotype_score_cutoff',
          type: 'number',
          grid: 2,
          inputWidth: '126px',
          step: 0.01,
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.scoreThreshold.placeholder.___phenotype_score_cutoff');
          },
          outputFormat: function outputFormat(value) {
            return (value || 0.3) - 0;
          },
          validate: 'min_value:0|max_value:1'
        }, {
          title: this.$t('COMPONENT.case.base.form.scoreThreshold.title.___variant_score_cutoff'),
          value: 'variant_score_cutoff',
          type: 'number',
          grid: 2,
          inputWidth: '126px',
          step: 0.01,
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.scoreThreshold.placeholder.___variant_score_cutoff');
          },
          outputFormat: function outputFormat(value) {
            return (value || 0.7) - 0;
          },
          validate: 'min_value:0.6|max_value:1'
        }, {}],
        'field4': [{
          title: this.$t('COMPONENT.case.base.form.pipeline.title.___omics_name'),
          errorTitle: this.$t('COMPONENT.case.base.form.pipeline.errorTitle.___omics_name'),
          value: 'omics_name',
          type: 'select',
          grid: 1,
          options: this.omicsOptions,
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.pipeline.placeholder.___omics_name');
          },
          validate: values_default()(this.fileSets[0]).some(function (file) {
            return file;
          }) ? 'required' : ''
        }, {
          title: '　',
          errorTitle: this.$t('COMPONENT.case.base.form.pipeline.errorTitle.___pipeline_name'),
          value: 'pipeline_name',
          type: 'select',
          grid: 2,
          options: this.pipelineOptions,
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.pipeline.placeholder.___pipeline_name');
          },
          display: function display(result) {
            return result.omics_name;
          },
          validate: values_default()(this.fileSets[0]).some(function (file) {
            return file;
          }) ? 'required' : ''
        }, {
          title: '　',
          errorTitle: this.$t('COMPONENT.case.base.form.pipeline.errorTitle.___library_type_name'),
          value: 'library_type_name',
          type: 'select',
          grid: 3,
          options: this.libraryTypeOptions,
          placeholder: function placeholder() {
            return _this4.$t('COMPONENT.case.base.form.pipeline.placeholder.___library_type_name');
          },
          display: function display(result) {
            return result.pipeline_name;
          }
        }]
      };
    },
    pipelineMetadataMap: function pipelineMetadataMap() {
      return {
        'Roche SBX-D Whole Genome Sequencing': {
          type: 'single'
        },
        'PacBio Whole Genome Sequencing HiFi': {
          type: 'single'
        },
        'ONT Whole Genome Sequencing': {
          type: 'single'
        }
      };
    },

    // global
    priceMap: function priceMap() {
      return global_data["J" /* priceMap */];
    },
    fileTypeCheck: function fileTypeCheck() {
      return util["f" /* fileTypeCheck */];
    },
    locale: function locale() {
      return this.$i18n.locale;
    },
    _LOCAL_BUILD: function _LOCAL_BUILD() {
      return global_config["a" /* _LOCAL_BUILD */];
    },

    // unload alert
    sendData: function sendData() {
      var caseData = {
        dataset: {
          'gvcf': 'vcf'
        }[this.dataset] || this.dataset
      };
      var projectData = {};
      if (this.layoutBlocks.includes('form')) {
        caseData = extends_default()({}, caseData, this.result['case'], {
          affected: this.result['case'].affected || false,
          pipelineType: this.pipelineType
        });
        delete caseData.AFFECTED;
        delete caseData.USER_ID;
      }
      if (this.layoutBlocks.includes('analysis')) {
        // analysis
        projectData = extends_default()({}, projectData, this.result['analysis'], {
          report_phenovardb: this.result['analysis'].report_phenovardb || false,
          fam_analyze: this.analysisData.family_analysis
        });
        delete projectData.REPORT_PHENOVARDB;
        // intractable disease
        if (!global_config["a" /* _LOCAL_BUILD */] && this.locale === 'ja') {
          var selectedIntractableDiseases = this.intractableDiseaseResult.datas;
          if (selectedIntractableDiseases.length) {
            var intractableDiseaseGroup = Object(util["i" /* groupBy */])(selectedIntractableDiseases, function (intractableDisease) {
              return intractableDisease.type;
            }, true);
            intractableDiseaseGroup['D006-4'] && (projectData.intractable_disease_panels = intractableDiseaseGroup['D006-4'].map(function (intractableDisease) {
              return intractableDisease.value;
            }));
            // intractableDiseaseGroup['default'] && (projectData.designated_intractable_disease_panels = intractableDiseaseGroup['default'].map(intractableDisease => intractableDisease.value))
          }
          projectData.designated_intractable_disease_panels = [].concat(toConsumableArray_default()(projectData.intractable_disease_panels || []), toConsumableArray_default()(global_data["A" /* intractableDiseaseOptions */].filter(function (option) {
            return option.type === 'default';
          }).map(function (option) {
            return option.value;
          })));
          projectData.intractable_disease_tag = this.intractableDiseaseResult.analysisSwitch;
        }
        // phenotype
        var selectedPhenotypes = [].concat(toConsumableArray_default()(this.selectedPhenotypes['panelPhenotypes']), toConsumableArray_default()(this.selectedPhenotypes['phenotypes']));
        if (selectedPhenotypes.length) {
          var phenotypes = Object(util["i" /* groupBy */])(Object(util["i" /* groupBy */])(selectedPhenotypes, function (phenotype) {
            return phenotype.id;
          }).map(function (group) {
            return group[0];
          }), function (phenotype) {
            return phenotype.type;
          }, true);
          phenotypes.hpo = phenotypes.hpo ? phenotypes.hpo.map(function (hpo) {
            return {
              hpo_id: hpo.id,
              hpo_name: hpo.name,
              query: hpo.query
            };
          }) : phenotypes.hpo;
          phenotypes.disease_term = phenotypes.disease_term ? phenotypes.disease_term.map(function (disease) {
            return {
              disease_id: disease.id,
              disease_name: disease.name,
              query: disease.query
            };
          }) : phenotypes.disease_term;
          projectData.phenotypes = phenotypes;
        }
        // gene panel
        var selectedGenes = [].concat(toConsumableArray_default()(this.selectedPhenotypes['panelGenes']), toConsumableArray_default()(this.selectedPhenotypes['genes']));
        if (selectedGenes.length) {
          var genePanels = [];
          selectedGenes = Object(util["i" /* groupBy */])(selectedGenes, function (gene) {
            return gene.name;
          }).map(function (group) {
            return group[0];
          });
          genePanels = selectedGenes.map(function (gene) {
            return {
              name: gene.name,
              data: gene.data,
              category: gene.category
            };
          });
          projectData.gene_panels = genePanels;
        }
        // family
        if (projectData.fam_analyze) {
          projectData.family_segregation_algorithm = this.analysisData.family_exclude;
          projectData.members = this.familyDatas;
        }
      }
      caseData = extends_default()({}, caseData, {
        project: projectData
      });
      return caseData;
    },
    sendFileSets: function sendFileSets() {
      var _this5 = this;

      var fileSets = {
        vcf: this.vcfSets.filter(function (set) {
          return set.snv;
        }).map(function (set) {
          return Object(util["a" /* cleanObject */])(set, true);
        }),
        fastq: this.fastqSets.filter(function (set) {
          return _this5.pipelineType === 'single' || set.r1 && set.r2;
        }),
        ubam: this.ubamSets.filter(function (set) {
          return set.bam;
        })
      }[this.dataset];
      return fileSets;
    }
  }),
  watch: {
    'defaultData': function defaultData() {
      var _this6 = this;

      this.init();
      setTimeout(function () {
        return _this6.$emit('unloadAlert', false);
      });
    },
    'result.case.user_id': function resultCaseUser_id(nv, ov) {
      if (ov && (nv || -1) > 0 && ov !== nv) {
        this.tagData.map['gene'] = {};
        this.tagData.map['phenotype'] = {};
        this.tagData.query['gene'] = '';
        this.tagData.query['phenotype'] = '';
        this.selectedPhenotypes['genes'] = [];
        this.selectedPhenotypes['phenotypes'] = [];
        this.fetchOmicss();
        this.fetchPhenotypePanels();
        this.fetchUserGenePanels();
      }
    },
    'result.case.pipeline_name': function resultCasePipeline_name(nv) {
      this.caseData = extends_default()({}, this.caseData, this.result['case'], {
        library_type_name: ''
      });
    },
    'result.case.library_type_name': function resultCaseLibrary_type_name(nv) {
      if (this.pipelineMetadataMap[nv] && this.pipelineMetadataMap[nv].type) {
        this.pipelineType = this.pipelineMetadataMap[nv].type;
      }
    },

    // unload alert
    'sendData': function sendData(nv, ov) {
      if (stringify_default()(nv) !== stringify_default()(ov)) {
        this.$emit('unloadAlert', true);
      }
    },
    'sendFileSets': function sendFileSets(nv, ov) {
      if (stringify_default()(nv) !== stringify_default()(ov)) {
        this.$emit('unloadAlert', true);
      }
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction', 'setModal2Action', 'setLoadingAction', 'setUserSettingAction']), {
    preSetData: function preSetData() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this7.init();

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this7);
      }))();
    },
    fetchData: function fetchData() {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(['supervisor', 'manager'].includes(_this8.user.role) && ['create', 'edit'].includes(_this8.mode))) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return _this8.fetchManagedUsers();

              case 3:
                if (!_this8.layoutBlocks.includes('analysis')) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 6;
                return _this8.fetchPhenotypePanels();

              case 6:
                _context2.next = 8;
                return _this8.fetchUserGenePanels();

              case 8:
                if (!_this8.layoutBlocks.includes('file')) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 11;
                return _this8.fetchOmicss();

              case 11:
                if (!(['supervisor'].includes(_this8.user.role) && !global_config["a" /* _LOCAL_BUILD */])) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 14;
                return _this8.fetchCloudFilePaths();

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8);
      }))();
    },
    fetchCloudFilePaths: function fetchCloudFilePaths() {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, params, response, cloudFilePaths;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this9.$ls.get('userInfo');
                params = {
                  dataset: _this9.dataset
                };
                _context3.next = 5;
                return Object(src_api["_8" /* getCloudFilePaths */])(params, config);

              case 5:
                response = _context3.sent;
                cloudFilePaths = response.data.data;

                _this9.cloudFilePaths = cloudFilePaths;
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0;

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this9, [[0, 10]]);
      }))();
    },
    fetchManagedUsers: function fetchManagedUsers() {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var config, response, users;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                config = _this10.$ls.get('userInfo');
                _context4.next = 4;
                return Object(src_api["_47" /* getManagedUsers */])(config);

              case 4:
                response = _context4.sent;
                users = response.data.data;

                _this10.users = users;
                _this10.caseData = extends_default()({}, _this10.caseData, {
                  user_id: _this10.caseData.user ? _this10.caseData.user.id : _this10.user.id || users[0].id
                });
                _this10.result['case'].user_id = _this10.caseData.user_id;
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0;

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this10, [[0, 11]]);
      }))();
    },
    fetchOmicss: function fetchOmicss() {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var config, params, response, omicss;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                config = _this11.$ls.get('userInfo');
                params = {
                  dataset: _this11.dataset,
                  owner_id: _this11.result['case'].user_id > 0 ? _this11.result['case'].user_id : _this11.user.id
                };
                _context5.next = 5;
                return Object(src_api["_52" /* getOmicss */])(params, config);

              case 5:
                response = _context5.sent;
                omicss = response.data.data;

                _this11.omicss = omicss;
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](0);
                throw _context5.t0;

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this11, [[0, 10]]);
      }))();
    },
    fetchPhenotypePanels: function fetchPhenotypePanels() {
      var _this12 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var config, params, response, phenotypePanels;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                config = _this12.$ls.get('userInfo');
                params = {};

                if (['manager', 'supervisor'].includes(_this12.user.role) && _this12.result['case'].user_id) {
                  params.user_id = _this12.result['case'].user_id;
                }
                _context6.next = 6;
                return Object(src_api["_53" /* getPhenotypePanels */])(params, config);

              case 6:
                response = _context6.sent;
                phenotypePanels = response.data.data;

                _this12.phenotypePanels = phenotypePanels.map(function (panel) {
                  return extends_default()({}, panel, {
                    phenotypes: [].concat(toConsumableArray_default()(panel.hpo.map(function (phenotype) {
                      return {
                        id: phenotype.hpo_id,
                        name: phenotype.hpo_name,
                        query: phenotype.hpo_id + ' ' + phenotype.hpo_name,
                        panel: panel,
                        type: 'hpo'
                      };
                    })), toConsumableArray_default()(panel.disease_term.map(function (phenotype) {
                      return {
                        id: phenotype.disease_id,
                        name: phenotype.disease_name,
                        query: phenotype.disease_id + ' ' + phenotype.disease_name,
                        panel: panel,
                        type: 'disease_term'
                      };
                    })))
                  });
                }).filter(function (panel) {
                  return panel.phenotypes.length;
                });
                _this12.selectedPhenotypes['panelPhenotypes'] = [];
                _context6.next = 15;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6['catch'](0);
                throw _context6.t0;

              case 15:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this12, [[0, 12]]);
      }))();
    },
    fetchUserGenePanels: function fetchUserGenePanels() {
      var _this13 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var config, params, response, userGenePanel;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                config = _this13.$ls.get('userInfo');
                params = {};

                if (['manager', 'supervisor'].includes(_this13.user.role) && _this13.result['case'].user_id) {
                  params.user_id = _this13.result['case'].user_id;
                }
                _context7.next = 6;
                return Object(src_api["_79" /* getUserGenePanel */])(params, config);

              case 6:
                response = _context7.sent;
                userGenePanel = response.data.data;

                _this13.userGenePanel = userGenePanel;
                _this13.selectedPhenotypes['panelGenes'] = [];
                _context7.next = 15;
                break;

              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7['catch'](0);
                throw _context7.t0;

              case 15:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this13, [[0, 12]]);
      }))();
    },
    fetchSubData: function fetchSubData(funcs) {
      var _this14 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref3, _ref4, index, func;

        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                funcs = funcs || ['fetchGenePanelDivisions', 'fetchGenePanels'];
                _this14.setLoadingAction(true);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context8.prev = 5;
                _iterator = get_iterator_default()(entries_default()(funcs));

              case 7:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context8.next = 23;
                  break;
                }

                _ref3 = _step.value;
                _ref4 = slicedToArray_default()(_ref3, 2);
                index = _ref4[0];
                func = _ref4[1];
                _context8.prev = 12;
                _context8.next = 15;
                return _this14[func](params[index] || params[0]);

              case 15:
                _context8.next = 20;
                break;

              case 17:
                _context8.prev = 17;
                _context8.t0 = _context8['catch'](12);

                _this14.addToast('error', !_context8.t0.response ? _context8.t0.message : _context8.t0.response.data.result.message);

              case 20:
                _iteratorNormalCompletion = true;
                _context8.next = 7;
                break;

              case 23:
                _context8.next = 29;
                break;

              case 25:
                _context8.prev = 25;
                _context8.t1 = _context8['catch'](5);
                _didIteratorError = true;
                _iteratorError = _context8.t1;

              case 29:
                _context8.prev = 29;
                _context8.prev = 30;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 32:
                _context8.prev = 32;

                if (!_didIteratorError) {
                  _context8.next = 35;
                  break;
                }

                throw _iteratorError;

              case 35:
                return _context8.finish(32);

              case 36:
                return _context8.finish(29);

              case 37:
                _this14.setLoadingAction(false);

              case 38:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this14, [[5, 25, 29, 37], [12, 17], [30,, 32, 36]]);
      }))();
    },
    fetchGenePanelDivisions: function fetchGenePanelDivisions() {
      var _this15 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var config, response, divisions;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                config = _this15.$ls.get('userInfo');
                _context9.next = 4;
                return Object(src_api["_39" /* getGenePanelDivisions */])(config);

              case 4:
                response = _context9.sent;
                divisions = response.data.data;

                _this15.divisions = divisions;
                _context9.next = 12;
                break;

              case 9:
                _context9.prev = 9;
                _context9.t0 = _context9['catch'](0);
                throw _context9.t0;

              case 12:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this15, [[0, 9]]);
      }))();
    },
    fetchGenePanels: function fetchGenePanels() {
      var _this16 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        var config, params, response, genePanels;
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                config = _this16.$ls.get('userInfo');
                params = {};
                _context10.next = 5;
                return Object(src_api["_42" /* getGenePanels */])(params, config);

              case 5:
                response = _context10.sent;
                genePanels = response.data.data;

                genePanels = genePanels.map(function (panel) {
                  return extends_default()({}, panel, {
                    count: [(panel.data['free_typing'] || []).filter(function (data) {
                      return data.checked !== false;
                    }).length, (panel.data['user_defined'] || []).filter(function (data) {
                      return data.checked !== false;
                    }).length, (panel.data['panel'] || []).reduce(function (s, panelData) {
                      return s + panelData.data.filter(function (data) {
                        return data.checked !== false;
                      }).length;
                    }, 0), (panel.data['hpo'] || []).reduce(function (s, panelData) {
                      return s + panelData.data.filter(function (data) {
                        return data.checked !== false;
                      }).length;
                    }, 0), (panel.data['condition'] || []).reduce(function (s, panelData) {
                      return s + panelData.filter(function (data) {
                        return data.checked !== false;
                      }).data.length;
                    }, 0)].reduce(function (s, c) {
                      return s + c;
                    }, 0)
                  });
                });
                _this16.genePanels = genePanels;
                _context10.next = 14;
                break;

              case 11:
                _context10.prev = 11;
                _context10.t0 = _context10['catch'](0);
                throw _context10.t0;

              case 14:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this16, [[0, 11]]);
      }))();
    },
    afterSetData: function afterSetData() {
      var _this17 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                setTimeout(function () {
                  return _this17.$emit('unloadAlert', false);
                });

              case 1:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this17);
      }))();
    },
    init: function init() {
      var _this18 = this;

      this.caseData = extends_default()({}, this.caseData, this.defaultData['case'] || {}, {
        affected: ![null, undefined].includes(this.defaultData['case'].affected) ? this.defaultData['case'].affected : true
      });
      this.result['case'] = extends_default()({}, this.result['case'], {
        affected: this.caseData.affected
      });
      this.analysisData = extends_default()({}, this.analysisData, this.defaultData['analysis'] || {});
      if (this.defaultData['analysis']) {
        this.analysisData = extends_default()({}, this.analysisData, {
          family_analysis: this.defaultData['analysis'].fam_analyze === undefined ? this.analysisData.family_analysis : this.defaultData['analysis'].fam_analyze,
          family_exclude: this.defaultData['analysis'].family_segregation_algorithm === undefined ? this.analysisData.family_exclude : this.defaultData['analysis'].family_segregation_algorithm
        });
        this.intractableDiseaseResult = {
          // datas: [...(this.defaultData['analysis'].intractable_disease_panels || []), ...(this.defaultData['analysis'].designated_intractable_disease_panels || [])].filter(panel => this.intractableDiseaseValueMap[panel.name]).map(panel => this.intractableDiseaseValueMap[panel.name]),
          datas: [].concat(toConsumableArray_default()(this.defaultData['analysis'].intractable_disease_panels || [])).filter(function (panel) {
            return _this18.intractableDiseaseValueMap[panel.name];
          }).map(function (panel) {
            return _this18.intractableDiseaseValueMap[panel.name];
          }),
          analysisSwitch: !!this.defaultData['analysis'].intractable_disease_tag
        };
      }
      this.result['analysis'] = extends_default()({}, this.result['analysis'], {
        report_phenovardb: this.analysisData.report_phenovardb
      });
      this.analysisData.name = this.analysisData.name || 'Analysis-' + Object(util["d" /* dateFormat */])(new Date(), 'yyyyMMdd');
      this.initPhenotype();
    },
    initPhenotype: function initPhenotype(analysisData) {
      analysisData = analysisData || this.analysisData;
      var phenotypes = this.analysisData.phenotypes ? [].concat(toConsumableArray_default()((this.analysisData.phenotypes.hpo || []).map(function (hpo) {
        return {
          id: hpo.hpo_id,
          name: hpo.hpo_name,
          query: hpo.query,
          type: 'hpo'
        };
      })), toConsumableArray_default()((this.analysisData.phenotypes.disease_term || []).map(function (disease) {
        return {
          id: disease.disease_id,
          name: disease.disease_name,
          query: disease.query,
          type: 'disease_term'
        };
      }))) : [];
      !this.searchedPhenotypes['phenotypes'].length && (this.searchedPhenotypes['phenotypes'] = [].concat(toConsumableArray_default()(phenotypes || [])));
      !this.selectedPhenotypes['phenotypes'].length && (this.selectedPhenotypes['phenotypes'] = [].concat(toConsumableArray_default()(phenotypes || [])));
      var genes = analysisData.gene_panels || [];
      !this.searchedPhenotypes['genes'].length && (this.searchedPhenotypes['genes'] = [].concat(toConsumableArray_default()(genes || [])));
      !this.selectedPhenotypes['genes'].length && (this.selectedPhenotypes['genes'] = [].concat(toConsumableArray_default()(genes || [])));
    },
    getPhenotypes: function getPhenotypes(query) {
      var _this19 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
        return regenerator_default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!((_this19.tagData.tag['phenotypes'] || { datas: [] }).datas || []).includes(query)) {
                  if (_this19.tagData.searchTimer['phenotype']) {
                    clearTimeout(_this19.tagData.searchTimer['phenotype']);
                  }
                  _this19.tagData.searchTimer['phenotype'] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
                    var config, params, response, phenotypes;
                    return regenerator_default.a.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            if (!(!_this19.tagData.map['phenotype'][query] && query)) {
                              _context12.next = 15;
                              break;
                            }

                            _context12.prev = 1;
                            config = _this19.$ls.get('userInfo');
                            params = {
                              q: query
                            };

                            if (['manager', 'supervisor'].includes(_this19.user.role) && _this19.result['case'].user_id) {
                              params.user_id = _this19.result['case'].user_id;
                            }
                            _context12.next = 7;
                            return Object(src_api["_68" /* getSearchPhenotype */])(params, config);

                          case 7:
                            response = _context12.sent;
                            phenotypes = response.data.data;

                            _this19.tagData.map['phenotype'] = extends_default()({}, _this19.tagData.map['phenotype'], defineProperty_default()({}, query, {
                              info: phenotypes,
                              datas: [].concat(toConsumableArray_default()((phenotypes.hpo || { data: [] }).data.map(function (data) {
                                return extends_default()({}, data, { type: 'hpo' });
                              })), toConsumableArray_default()((phenotypes.disease_term || { data: [] }).data.map(function (data) {
                                return extends_default()({}, data, { type: 'disease_term' });
                              })))
                            }));
                            _context12.next = 15;
                            break;

                          case 12:
                            _context12.prev = 12;
                            _context12.t0 = _context12['catch'](1);

                            _this19.addToast('error', !_context12.t0.response ? _context12.t0.message : _context12.t0.response.data.result.message);

                          case 15:
                            _this19.tagData.tag['phenotypes'] = _this19.tagData.map['phenotype'][query] || {};

                          case 16:
                          case 'end':
                            return _context12.stop();
                        }
                      }
                    }, _callee12, _this19, [[1, 12]]);
                  })), 200);
                }

              case 1:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this19);
      }))();
    },
    getGenes: function getGenes(query) {
      var _this20 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15() {
        return regenerator_default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if ((_this20.tagData.curTag['gene'] || {}).name !== query) {
                  _this20.tagData.tag['genes'] = {};
                  if (_this20.tagData.searchTimer['gene']) {
                    clearTimeout(_this20.tagData.searchTimer['gene']);
                  }
                  _this20.tagData.searchTimer['gene'] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14() {
                    var config, params, response, genes;
                    return regenerator_default.a.wrap(function _callee14$(_context14) {
                      while (1) {
                        switch (_context14.prev = _context14.next) {
                          case 0:
                            if (!(!_this20.tagData.map['gene'][query] && query)) {
                              _context14.next = 17;
                              break;
                            }

                            _this20.setLoadingAction(true);
                            _context14.prev = 2;
                            config = _this20.$ls.get('userInfo');
                            params = {
                              q: query
                            };

                            if (['manager', 'supervisor'].includes(_this20.user.role) && _this20.result['case'].user_id) {
                              params.user_id = _this20.result['case'].user_id;
                            }
                            _context14.next = 8;
                            return Object(src_api["_67" /* getSearchGeneEntry */])(params, config);

                          case 8:
                            response = _context14.sent;
                            genes = response.data.data;

                            _this20.tagData.map['gene'] = extends_default()({}, _this20.tagData.map['gene'], defineProperty_default()({}, query, {
                              info: genes,
                              datas: [].concat(toConsumableArray_default()((genes.gene || { data: [] }).data.map(function (data) {
                                return extends_default()({}, data, { type: 'gene' });
                              })), toConsumableArray_default()((genes.panel || { data: [] }).data.map(function (data) {
                                return extends_default()({}, data, { type: 'panel' });
                              })), toConsumableArray_default()((genes.hpo || { data: [] }).data.map(function (data) {
                                return extends_default()({}, data, { type: 'hpo' });
                              })), toConsumableArray_default()(Object(global_data["r" /* getGeneEntriesConditionData */])(genes.condition).data.map(function (data) {
                                return extends_default()({}, data, { type: 'condition' });
                              })), toConsumableArray_default()((genes.pathway || { data: [] }).data.map(function (data) {
                                return extends_default()({}, data, { type: 'pathway' });
                              })))
                            }));
                            _context14.next = 16;
                            break;

                          case 13:
                            _context14.prev = 13;
                            _context14.t0 = _context14['catch'](2);

                            _this20.addToast('error', !_context14.t0.response ? _context14.t0.message : _context14.t0.response.data.result.message);

                          case 16:
                            _this20.setLoadingAction(false);

                          case 17:
                            _this20.tagData.tag['genes'] = _this20.tagData.map['gene'][query] || {};

                          case 18:
                          case 'end':
                            return _context14.stop();
                        }
                      }
                    }, _callee14, _this20, [[2, 13]]);
                  })), 500);
                }

              case 1:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this20);
      }))();
    },
    addToSearch: function addToSearch(type, data) {
      var _this21 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee16() {
        var ary, phenotypeID, phenotypeName, phenotypeType, phenotype, symbols, gene, oldData, panel, symbolTransform, _symbols, _gene, _oldData, _symbols2, _gene2, _oldData2, _symbols3, _gene3, _oldData3, _symbols4, _gene4, _oldData4;

        return regenerator_default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.t0 = type;
                _context16.next = _context16.t0 === 'phenotype' ? 3 : _context16.t0 === 'gene' ? 12 : 58;
                break;

              case 3:
                if (!(_this21.tagData.tag['phenotypes'].datas || []).some(function (tag) {
                  return tag.query === _this21.tagData.query['phenotype'];
                })) {
                  data = _this21.tagData.tag['phenotypes'].datas[0].query;
                }
                ary = data.split(' ');
                phenotypeID = ary.splice(0, 1)[0];
                phenotypeName = ary.join(' ');
                phenotypeType = phenotypeID.startsWith('HP:') ? 'hpo' : 'disease_term';
                phenotype = {
                  id: phenotypeID,
                  name: phenotypeName,
                  type: phenotypeType,
                  query: phenotypeID + ' ' + phenotypeName
                };

                if (!_this21.searchedPhenotypes['phenotypes'].some(function (p) {
                  return p.id === phenotype.id;
                })) {
                  _this21.searchedPhenotypes['phenotypes'].push(phenotype);
                  if (!_this21.selectedLimit['phenotypes']) {
                    _this21.selectedPhenotypes['phenotypes'].push(phenotype);
                  }
                } else {
                  _this21.addToast('error', _this21.$t('COMMON.toast.___addSameHPOTerm'));
                }
                _this21.tagData.query['phenotype'] = '';
                return _context16.abrupt('break', 58);

              case 12:
                data = data.type ? data : (_this21.tagData.map['gene'][_this21.tagData.query['gene']] || { datas: [] }).datas[0];

                if (!(data && !_this21.loading['addToSearch'])) {
                  _context16.next = 57;
                  break;
                }

                _this21.loading['addToSearch'] = true;
                _context16.t1 = data.type;
                _context16.next = _context16.t1 === 'gene' ? 18 : _context16.t1 === 'panel' ? 25 : _context16.t1 === 'hpo' ? 34 : _context16.t1 === 'condition' ? 41 : _context16.t1 === 'pathway' ? 48 : 55;
                break;

              case 18:
                _context16.next = 20;
                return _this21.getGeneSymbols(data.type, data.gene_id);

              case 20:
                symbols = _context16.sent;
                gene = {
                  name: data.symbol,
                  category: data.type,
                  data: symbols
                };
                oldData = _this21.searchedPhenotypes['genes'].find(function (g) {
                  return g.name === gene.name;
                });

                if (!oldData) {
                  _this21.searchedPhenotypes['genes'].push(gene);
                  if (!_this21.selectedLimit['genes']) {
                    _this21.selectedPhenotypes['genes'].push(gene);
                  }
                } else if (oldData.checked === false) {
                  if (!_this21.selectedLimit['genes']) {
                    if (!_this21.selectedPhenotypes['genes'].some(function (g) {
                      return g.name === gene.name;
                    })) {
                      _this21.selectedPhenotypes['genes'].push(oldData);
                    }
                  }
                }
                return _context16.abrupt('break', 55);

              case 25:
                _context16.next = 27;
                return _this21.getGenePanel(data.id);

              case 27:
                panel = _context16.sent;

                symbolTransform = function symbolTransform(symbols) {
                  return symbols.reduce(function (s, c) {
                    return extends_default()({}, s, defineProperty_default()({}, c.gene_id, c));
                  }, {});
                };

                _symbols = values_default()(extends_default()({}, symbolTransform(panel.data['free_typing'] || []), symbolTransform(panel.data['user_defined'] || []), symbolTransform(Array.prototype.concat.apply([], (panel.data['panel'] || []).map(function (panel) {
                  return panel.data;
                }))), symbolTransform(Array.prototype.concat.apply([], (panel.data['hpo'] || []).map(function (panel) {
                  return panel.data;
                }))), symbolTransform(Array.prototype.concat.apply([], (panel.data['condition'] || []).map(function (panel) {
                  return panel.data;
                }))))).filter(function (data) {
                  return data.checked;
                });
                _gene = {
                  name: panel.name,
                  category: data.type,
                  data: _symbols
                };
                _oldData = _this21.searchedPhenotypes['genes'].find(function (g) {
                  return g.name === _gene.name;
                });

                if (!_oldData) {
                  _this21.searchedPhenotypes['genes'].push(_gene);
                  if (!_this21.selectedLimit['genes']) {
                    _this21.selectedPhenotypes['genes'].push(_gene);
                  }
                } else {
                  if (!_this21.selectedLimit['genes']) {
                    if (!_this21.selectedPhenotypes['genes'].some(function (g) {
                      return g.name === _gene.name;
                    })) {
                      _this21.selectedPhenotypes['genes'].push(_oldData);
                    }
                  }
                }
                return _context16.abrupt('break', 55);

              case 34:
                _context16.next = 36;
                return _this21.getGeneSymbols(data.type, data.name);

              case 36:
                _symbols2 = _context16.sent;
                _gene2 = {
                  name: data.name,
                  category: data.type,
                  data: _symbols2
                };
                _oldData2 = _this21.searchedPhenotypes['genes'].find(function (g) {
                  return g.name === _gene2.name;
                });

                if (!_oldData2) {
                  _this21.searchedPhenotypes['genes'].push(_gene2);
                  if (!_this21.selectedLimit['genes']) {
                    _this21.selectedPhenotypes['genes'].push(_gene2);
                  }
                } else if (_oldData2.checked === false) {
                  if (!_this21.selectedLimit['genes']) {
                    if (!_this21.selectedPhenotypes['genes'].some(function (g) {
                      return g.name === _gene2.name;
                    })) {
                      _this21.selectedPhenotypes['genes'].push(_oldData2);
                    }
                  }
                }
                return _context16.abrupt('break', 55);

              case 41:
                _context16.next = 43;
                return _this21.getGeneSymbols(data.type, data.name);

              case 43:
                _symbols3 = _context16.sent;
                _gene3 = {
                  name: data.name,
                  category: data.type,
                  condition_type: data.condition_type,
                  data: _symbols3
                };
                _oldData3 = _this21.searchedPhenotypes['genes'].find(function (g) {
                  return g.name === _gene3.name;
                });

                if (!_oldData3) {
                  _this21.searchedPhenotypes['genes'].push(_gene3);
                  if (!_this21.selectedLimit['genes']) {
                    _this21.selectedPhenotypes['genes'].push(_gene3);
                  }
                } else if (_oldData3.checked === false) {
                  if (!_this21.selectedLimit['genes']) {
                    if (!_this21.selectedPhenotypes['genes'].some(function (g) {
                      return g.name === _gene3.name;
                    })) {
                      _this21.selectedPhenotypes['genes'].push(_oldData3);
                    }
                  }
                }
                return _context16.abrupt('break', 55);

              case 48:
                _context16.next = 50;
                return _this21.getPathwaySymbols(data.id);

              case 50:
                _symbols4 = _context16.sent;
                _gene4 = {
                  name: data.name,
                  category: data.type,
                  data: _symbols4
                };
                _oldData4 = _this21.searchedPhenotypes['genes'].find(function (g) {
                  return g.name === _gene4.name;
                });

                if (!_oldData4) {
                  _this21.searchedPhenotypes['genes'].push(_gene4);
                  if (!_this21.selectedLimit['genes']) {
                    _this21.selectedPhenotypes['genes'].push(_gene4);
                  }
                } else if (_oldData4.checked === false) {
                  if (!_this21.selectedLimit['genes']) {
                    if (!_this21.selectedPhenotypes['genes'].some(function (g) {
                      return g.name === _gene4.name;
                    })) {
                      _this21.selectedPhenotypes['genes'].push(_oldData4);
                    }
                  }
                }
                return _context16.abrupt('break', 55);

              case 55:
                _this21.tagData.query['gene'] = '';
                _this21.loading['addToSearch'] = false;

              case 57:
                return _context16.abrupt('break', 58);

              case 58:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this21);
      }))();
    },
    getGeneSymbols: function getGeneSymbols(type, query) {
      var _this22 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee17() {
        var config, api, response, symbols;
        return regenerator_default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                config = _this22.$ls.get('userInfo');
                api = {
                  gene: src_api["_41" /* getGenePanelSymbol */],
                  hpo: src_api["_40" /* getGenePanelHpo */],
                  condition: src_api["_37" /* getGenePanelCondition */]
                }[type];
                _context17.next = 5;
                return api(query, config);

              case 5:
                response = _context17.sent;
                symbols = response.data.data;

                symbols = symbols.map(function (symbol) {
                  return extends_default()({}, symbol, {
                    checked: true,
                    date: new Date()
                  });
                });
                return _context17.abrupt('return', symbols);

              case 11:
                _context17.prev = 11;
                _context17.t0 = _context17['catch'](0);

                _this22.addToast('error', !_context17.t0.response ? _context17.t0.message : _context17.t0.response.data.result.message);
                return _context17.abrupt('return', null);

              case 15:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this22, [[0, 11]]);
      }))();
    },
    getPathwaySymbols: function getPathwaySymbols(id) {
      var _this23 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee18() {
        var config, response, pathwayData, symbols;
        return regenerator_default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                config = _this23.$ls.get('userInfo');
                _context18.next = 4;
                return Object(src_api["_38" /* getGenePanelConditionPathway */])(id, config);

              case 4:
                response = _context18.sent;
                pathwayData = response.data.data;
                symbols = (pathwayData.data || []).map(function (symbol) {
                  return extends_default()({}, symbol, {
                    checked: true,
                    date: new Date()
                  });
                });
                return _context18.abrupt('return', symbols);

              case 10:
                _context18.prev = 10;
                _context18.t0 = _context18['catch'](0);

                _this23.addToast('error', !_context18.t0.response ? _context18.t0.message : _context18.t0.response.data.result.message);
                return _context18.abrupt('return', null);

              case 14:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this23, [[0, 10]]);
      }))();
    },
    getGenePanel: function getGenePanel(id) {
      var _this24 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee19() {
        var config, params, response, panel;
        return regenerator_default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                config = _this24.$ls.get('userInfo');
                params = {};

                if (['manager', 'supervisor'].includes(_this24.user.role) && _this24.result['case'].user_id) {
                  params.user_id = _this24.result['case'].user_id;
                }
                _context19.next = 6;
                return Object(src_api["_36" /* getGenePanel */])(id, params, config);

              case 6:
                response = _context19.sent;
                panel = response.data.data;
                return _context19.abrupt('return', panel);

              case 11:
                _context19.prev = 11;
                _context19.t0 = _context19['catch'](0);

                _this24.addToast('error', !_context19.t0.response ? _context19.t0.message : _context19.t0.response.data.result.message);
                return _context19.abrupt('return', null);

              case 15:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, _this24, [[0, 11]]);
      }))();
    },
    addToPanel: function addToPanel(phenotype) {
      var _this25 = this;

      var action = this.modal.action ? this.setModal2Action : this.setModalAction;
      action({
        action: 'addToPanel',
        width: '468px',
        param: {
          phenotype: phenotype,
          panels: this.phenotypePanels
        },
        callback: function () {
          var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee20(result) {
            return regenerator_default.a.wrap(function _callee20$(_context20) {
              while (1) {
                switch (_context20.prev = _context20.next) {
                  case 0:
                    if (!result) {
                      _context20.next = 3;
                      break;
                    }

                    _context20.next = 3;
                    return _this25.fetchPhenotypePanels();

                  case 3:
                  case 'end':
                    return _context20.stop();
                }
              }
            }, _callee20, _this25);
          }));

          return function callback(_x2) {
            return _ref7.apply(this, arguments);
          };
        }()
      });
    },
    openGenePanelDataSelect: function openGenePanelDataSelect(data) {
      var action = this.modal.action ? this.setModal2Action : this.setModalAction;
      action({
        action: 'genePanelDataSelect',
        width: '1208px',
        param: {
          data: data
        }
      });
    },
    openGenePanelSearch: function openGenePanelSearch() {
      var _this26 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee22() {
        var action;
        return regenerator_default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                if (_this26.genePanels.length && _this26.divisions.length) {
                  _context22.next = 3;
                  break;
                }

                _context22.next = 3;
                return _this26.fetchSubData();

              case 3:
                action = _this26.modal.action ? _this26.setModal2Action : _this26.setModalAction;

                action({
                  action: 'genePanelQuickSelection',
                  width: '1208px',
                  customStyles: {
                    'max-height': 'calc(100% - 160px)'
                  },
                  param: {
                    datas: _this26.genePanels,
                    divisions: _this26.divisions
                  },
                  callback: function () {
                    var _ref8 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee21(result) {
                      return regenerator_default.a.wrap(function _callee21$(_context21) {
                        while (1) {
                          switch (_context21.prev = _context21.next) {
                            case 0:
                              if (!result) {
                                _context21.next = 3;
                                break;
                              }

                              _context21.next = 3;
                              return _this26.addToSearch('gene', {
                                type: 'panel',
                                id: result - 0
                              });

                            case 3:
                            case 'end':
                              return _context21.stop();
                          }
                        }
                      }, _callee21, _this26);
                    }));

                    return function callback(_x3) {
                      return _ref8.apply(this, arguments);
                    };
                  }()
                });

              case 5:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, _this26);
      }))();
    },
    onEvent: function onEvent(e, c) {
      if (['input', 'tag', 'send'].includes(e)) {
        if (c) {
          var id = c.id || (this.users.find(function (user) {
            return c === [user.first_name, user.last_name].filter(function (x) {
              return x;
            }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) {
              return x;
            }).join(' ') + ')' : '');
          }) || {}).id;
          this.result['case'].user_id = id || this.result['case'].user_id;
          this.caseData = extends_default()({}, this.caseData, this.result['case'], {
            user_id: this.result['case'].user_id
          });
        } else {
          this.result['case'].user_id = -1;
        }
      }
    },
    initFile: function initFile() {
      this.vcfSets = [{
        snv: null,
        sv: null,
        str: null
      }];
      this.fastqSets = [{
        r1: null,
        r2: null
      }];
      this.ubamSets = [{
        bam: null
      }];
    },
    selectFile: function selectFile(e, set, target) {
      if (target === 'sv') {
        var setFiles = set[target] || [];
        var setFilesNames = setFiles.map(function (file) {
          return file.name;
        });
        var files = from_default()(e.target.files).filter(function (file) {
          return !setFilesNames.includes(file.name);
        });
        if (files.length + setFiles.length <= this.fileLimit['sv']) {
          set[target] = [].concat(toConsumableArray_default()(setFiles), toConsumableArray_default()(files));
        } else {
          this.addToast('error', this.$t('COMMON.toast.___fileUploadLimit', { count: this.fileLimit['sv'] }));
        }
      } else {
        set[target] = e.target.files[0];
      }
    },
    openFileCloud: function openFileCloud(set, target) {
      var _this27 = this;

      var action = this.modal.action ? this.setModal2Action : this.setModalAction;
      var selectedPaths = Array.prototype.concat.apply([], this.fileSets.map(function (set) {
        return values_default()(set).map(function (file) {
          return (file || {}).path;
        }).filter(function (x) {
          return x;
        });
      }));
      selectedPaths = selectedPaths.filter(function (path) {
        return path !== (set[target] || {}).path;
      });
      action({
        action: 'fileCloud',
        width: '616px',
        param: {
          type: 'single',
          options: {
            checkbox: false
          },
          fileTypes: {
            'vcf': [],
            'fastq': ['fastq', 'fq', 'fastq.gz', 'fq.gz'],
            'ubam': ['bam', 'ubam']
          }[this.dataset],
          paths: this.cloudFilePaths,
          currentPath: set[target] ? set[target].path : this.cloudFileCurrentPath || this.userSetting.cloudspace_browse_path || '',
          disabledPaths: selectedPaths,
          defaultSelectedPaths: set[target] ? [set[target].path] : [],
          functions: {
            saveCurrentPath: function saveCurrentPath(path) {
              return _this27.saveCurrentPath(path);
            }
          }
        },
        callback: function () {
          var _ref9 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee23(result) {
            var path, contentTypeMap;
            return regenerator_default.a.wrap(function _callee23$(_context23) {
              while (1) {
                switch (_context23.prev = _context23.next) {
                  case 0:
                    if (result) {
                      path = result[0];
                      contentTypeMap = {
                        gz: 'application/x-gzip',
                        vcf: 'text/directory'
                      };

                      set[target] = {
                        name: path.split('/').reverse()[0],
                        type: contentTypeMap[path.split('.').reverse(0)[0]] || 'text/plain',
                        path: path
                      };
                    }

                  case 1:
                  case 'end':
                    return _context23.stop();
                }
              }
            }, _callee23, _this27);
          }));

          return function callback(_x4) {
            return _ref9.apply(this, arguments);
          };
        }()
      });
    },
    saveCurrentPath: function saveCurrentPath(path) {
      var _this28 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee24() {
        var config, folderPath, data, response, userSettings;
        return regenerator_default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.prev = 0;
                config = _this28.$ls.get('userInfo');
                folderPath = path.replace(/\/(?!.*\/).*$/, '');
                data = {
                  cloudspace_browse_path: folderPath
                };
                _context24.next = 6;
                return Object(src_api["_154" /* putUserSettings */])(data, config);

              case 6:
                response = _context24.sent;
                userSettings = response.data.data;

                _this28.cloudFileCurrentPath = response.data.data.cloudspace_browse_path;
                _this28.setUserSettingAction(userSettings);
                _context24.next = 15;
                break;

              case 12:
                _context24.prev = 12;
                _context24.t0 = _context24['catch'](0);

                _this28.addToast('error', !_context24.t0.response ? _context24.t0.message : _context24.t0.response.data.result.message);

              case 15:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, _this28, [[0, 12]]);
      }))();
    },
    formOnChange: function formOnChange(key, field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result[key] = extends_default()({}, this.result[key], result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(cols || keys_default()(this.caseData)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var col = _step2.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    fileValidate: function fileValidate() {
      if (this.pipelineType === 'paired' && values_default()(this.fastqSets[this.fastqSets.length - 1]).filter(function (file) {
        return file;
      }).length === 1) {
        this.addToast('error', this.$t('COMMON.toast.___dataShouldBePaired'));
        return false;
      } else if ((this.vcfSets[0].sv || this.vcfSets[0].str) && !this.vcfSets[0].snv) {
        this.addToast('error', this.$t('COMMON.toast.___snvFileRequired'));
        return false;
      } else {
        return true;
      }
    },
    familyValidate: function familyValidate() {
      return this.$refs['family-base'].validateSubmit();
    },
    validateSubmit: function validateSubmit() {
      var _this29 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee25() {
        var result, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, kv;

        return regenerator_default.a.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                result = {};

                _this29.onSubmit = true;
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context25.prev = 5;
                _iterator3 = get_iterator_default()(entries_default()(_this29.validate));

              case 7:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context25.next = 15;
                  break;
                }

                kv = _step3.value;
                _context25.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context25.sent;

              case 12:
                _iteratorNormalCompletion3 = true;
                _context25.next = 7;
                break;

              case 15:
                _context25.next = 21;
                break;

              case 17:
                _context25.prev = 17;
                _context25.t0 = _context25['catch'](5);
                _didIteratorError3 = true;
                _iteratorError3 = _context25.t0;

              case 21:
                _context25.prev = 21;
                _context25.prev = 22;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 24:
                _context25.prev = 24;

                if (!_didIteratorError3) {
                  _context25.next = 27;
                  break;
                }

                throw _iteratorError3;

              case 27:
                return _context25.finish(24);

              case 28:
                return _context25.finish(21);

              case 29:
                result['file'] = !_this29.layoutBlocks.includes('file') || _this29.fileValidate();
                result['family'] = !_this29.sendData.project.fam_analyze || _this29.familyValidate();

                if (values_default()(result).includes(false)) {
                  _context25.next = 33;
                  break;
                }

                return _context25.abrupt('return', true);

              case 33:
                _this29.onSubmit = false;

              case 34:
              case 'end':
                return _context25.stop();
            }
          }
        }, _callee25, _this29, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    submit: function submit() {
      var _this30 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee26() {
        var data, fileSets;
        return regenerator_default.a.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                data = _this30.sendData;
                fileSets = _this30.sendFileSets;
                return _context26.abrupt('return', { data: data, fileSets: fileSets, users: _this30.users });

              case 3:
              case 'end':
                return _context26.stop();
            }
          }
        }, _callee26, _this30);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a364d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/base.vue
var base_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-base-page col-block width-full"},[(_vm.layoutBlocks.includes('form'))?[_c('div',{staticClass:"form-container col-block width-full"},[((['create'].includes(_vm.mode) && ['supervisor', 'manager'].includes(_vm.user.role)) || (['edit'].includes(_vm.mode) && ['supervisor'].includes(_vm.user.role)))?_c('div',{staticClass:"form-block col-block width-full"},[_c('customForm',{attrs:{"init":_vm.caseData,"layoutType":'grid',"groupCount":_vm.formGroupCount,"alerts":_vm.alerts,"forms":_vm.formOptions['field0'],"scope":_vm.scope,"reading":false},on:{"change":function (result, validate, errors) { return _vm.formOnChange('case', 'field0', result, validate, errors); }},scopedSlots:_vm._u([{key:"USER_ID",fn:function(props){return [_c('div',{staticClass:"input-group",style:({ width: '100%', padding: 0 }),attrs:{"name":props}},[_c('inputTag',{style:({ width: '100%' }),attrs:{"inputStyle":{ 'padding-right': '40px' },"init":(_vm.userOptions.find(function (option) { return option.value === _vm.result['case'].user_id; }) || {}).title,"emptyDisplay":true,"disabled":false,"placeholder":'',"tags":_vm.users,"prefix":'(?:^)',"target":'^(.*?)$',"replace":function (user) { return [user.first_name, user.last_name].filter(function (x) { return x; }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) { return x; }).join(' ') + ')' : ''); },"filter":function (content) { return function (user) { return content && ([user.first_name, user.last_name].filter(function (x) { return x; }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) { return x; }).join(' ') + ')' : '')).match(new RegExp(content.replace(/(\(|\)|\[|\]|\{|\}|\\)/g, '\\$1'), 'i')); }; },"tagDisplay":function (user) { return [user.first_name, user.last_name].filter(function (x) { return x; }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) { return x; }).join(' ') + ')' : ''); }},on:{"input":function (content) { return _vm.onEvent('input', content); },"send":function (content) { return _vm.onEvent('send', content); },"tag":function (content) { return _vm.onEvent('tag', content); }}})],1)]}}])})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-block col-block width-full"},[_c('customForm',{attrs:{"init":_vm.caseData,"layoutType":'grid',"groupCount":_vm.formGroupCount,"alerts":_vm.alerts,"forms":_vm.formOptions['field1'],"scope":_vm.scope,"reading":false},on:{"change":function (result, validate, errors) { return _vm.formOnChange('case', 'field1', result, validate, errors); }},scopedSlots:_vm._u([{key:"AFFECTED",fn:function(props){return [(props.form.type === 'custom')?_c('div',{staticClass:"AFFECTED-block row-block",attrs:{"name":props}},[_c('div',{staticClass:"AFFECTED-title",domProps:{"innerHTML":_vm._s(_vm.$t('COMPONENT.case.base.customForm.affected.___title'))}}),_vm._v(" "),_c('switchButton',{attrs:{"disabled":false,"checked":_vm.caseData.affected},on:{"input":function (c) { _vm.result['case'].affected = c }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1):_vm._e()]}}])})],1)])]:_vm._e(),_vm._v(" "),(_vm.layoutBlocks.includes('analysis'))?[_c('hr',{staticClass:"custom full",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('div',{staticClass:"analysis-container col-block width-full"},[_c('div',{staticClass:"analysis-block col-block width-full"},[_c('customForm',{attrs:{"init":_vm.analysisData,"layoutType":'grid',"groupCount":6,"alerts":_vm.alerts,"forms":_vm.formOptions['field2'],"scope":'test',"reading":false},on:{"change":function (result, validate, errors) { return _vm.formOnChange('analysis', 'field2', result, validate, errors); }},scopedSlots:_vm._u([{key:"REPORT_PHENOVARDB",fn:function(props){return [_c('div',{staticClass:"REPORT_PHENOVARDB-block row-block flex-start",attrs:{"name":props}},[_c('div',{staticClass:"REPORT_PHENOVARDB-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.customForm.reportPhenovardb.___off')))]),_vm._v(" "),_c('switchButton',{attrs:{"disabled":!_vm.reportDatabaseable,"checked":_vm.analysisData.report_phenovardb,"customStyle":{ cursor: 'pointer' }},on:{"click":function (e) { return !_vm.reportDatabaseable && _vm.addToast('error', _vm.$t('COMMON.toast.___atLeastOneCardOpen')); },"input":function (c) { _vm.result['analysis'].report_phenovardb = c }}}),_vm._v(" "),_c('div',{staticClass:"REPORT_PHENOVARDB-title active"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.customForm.reportPhenovardb.___on')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]}}])}),_vm._v(" "),(_vm.isUpdate)?_vm._t('analysis-update',null,{data:_vm.sendData}):_vm._e()],2),_vm._v(" "),_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('div',{staticClass:"analysis-block col-block width-full"},[_vm._t('analysis-import',null,{data:_vm.sendData}),_vm._v(" "),(!_vm._LOCAL_BUILD && (_vm.locale === 'ja'))?_c('div',{staticClass:"intractable-disease-container col-block width-full"},[_c('intractableDisease',{attrs:{"defaultDatas":_vm.intractableDiseaseResult},on:{"change":function (result) { return _vm.intractableDiseaseResult = result; }}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"analysis-title-container row-block"},[_c('div',{staticClass:"analysis-title main"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.analysis.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"phenotype-panel-container block col-block"},[_c('div',{staticClass:"block-content"},[_c('div',{staticClass:"display-icon center-block",class:{ active: _vm.display.phenotypePanel },on:{"click":function (e) { return _vm.display.phenotypePanel = !_vm.display.phenotypePanel; }}},[_c('img',{attrs:{"src":__webpack_require__("0Pmj"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"block-title-container row-block"},[_c('div',{staticClass:"block-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.analysis.panel.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display.phenotypePanel),expression:"display.phenotypePanel"}],staticClass:"phenotype-panel-block block-content col-block width-full"},[(_vm.phenotypePanels.length)?_vm._l((_vm.phenotypePanels),function(panel,pindex){return _c('div',{key:pindex,staticClass:"panel-group col-block flex-start"},[_c('div',{staticClass:"item-container row-block",on:{"click":function (e) {
                      _vm.selectedPhenotypes['panelPhenotypes'] =
                        _vm.selectedPhenotypes['panelPhenotypes'].some(function (phenotype) { return phenotype.panel.id === panel.id; }) ? _vm.selectedPhenotypes['panelPhenotypes'].filter(function (p) { return p.panel.id !== panel.id; })
                        : _vm.selectedPhenotypes['panelPhenotypes'].filter(function (p) { return p.panel.id !== panel.id; }).concat(panel.phenotypes)
                    }}},[_c('img',{staticClass:"checkbox",attrs:{"src":_vm.selectedPhenotypes['panelPhenotypes'].filter(function (phenotype) { return phenotype.panel.id === panel.id; }).length === panel.phenotypes.length ? __webpack_require__("7kqe")
                        : _vm.selectedPhenotypes['panelPhenotypes'].some(function (phenotype) { return phenotype.panel.id === panel.id; }) ? __webpack_require__("Z77G")
                        : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"item-title main"},[_vm._v(_vm._s(panel.panel))])]),_vm._v(" "),_c('div',{staticClass:"panel-item-container row-block flex-wrap"},_vm._l((panel.phenotypes),function(phenotype,phindex){return _c('div',{key:phindex,staticClass:"item-container row-block",on:{"click":function (e) {
                        _vm.selectedPhenotypes['panelPhenotypes'] =
                          _vm.selectedPhenotypes['panelPhenotypes'].includes(phenotype) ? _vm.selectedPhenotypes['panelPhenotypes'].filter(function (p) { return (p.panel.id + '_' + p.id) !== (phenotype.panel.id + '_' + phenotype.id); })
                          : _vm.selectedPhenotypes['panelPhenotypes'].concat([phenotype])
                      }}},[_c('img',{staticClass:"checkbox",attrs:{"src":_vm.selectedPhenotypes['panelPhenotypes'].includes(phenotype) ? __webpack_require__("7kqe")
                          : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(phenotype.query))])])}),0)])}):[_c('div',{staticClass:"row-block",style:({ width: '100%' })},[_c('router-link',{staticClass:"link dark",attrs:{"to":{ name: 'panel' }}},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.analysis.panel.___empty')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]],2)])]),_vm._v(" "),_c('div',{staticClass:"search-container row-block"},[_c('div',{staticClass:"search-block col-block",style:({ flex: 1 })},[_c('div',{staticClass:"row-block",style:({ width: '100%' })},[_c('div',{staticClass:"search-input input-group",style:({ flex: 1 })},[_c('phenotypeTag',{style:({ width: '100%' }),attrs:{"placeholder":_vm.$t('COMPONENT.case.base.analysis.phenotype.phenotypeTag.___placeholder'),"init":_vm.tagData.query['phenotype'],"dataInfo":_vm.tagData.tag['phenotypes'].info,"phenotypes":_vm.tagData.tag['phenotypes'].datas},on:{"input":function (content) { _vm.tagData.query['phenotype'] = content; _vm.getPhenotypes(content); _vm.customValidate([], ['selected', 'genePanel']) },"tag":function (content) { _vm.tagData.query['phenotype'] = content; _vm.customValidate([], ['selected', 'genePanel']) },"send":function (content) { return (_vm.tagData.tag['phenotypes'].datas || []).length && _vm.tagData.query['phenotype'] ? _vm.addToSearch('phenotype', _vm.tagData.query['phenotype']) : ''; }}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zSkq"),"alt":""}})],1),_vm._v(" "),_c('div',{style:({ width: '22px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",attrs:{"disabled":!((_vm.tagData.tag['phenotypes'].datas || []).length && _vm.tagData.query['phenotype'])},on:{"click":function (e) { return (_vm.tagData.tag['phenotypes'].datas || []).length && _vm.tagData.query['phenotype'] ? _vm.addToSearch('phenotype', _vm.tagData.query['phenotype']) : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___add')))])])]),_vm._v(" "),(_vm.searchedPhenotypes['phenotypes'].length)?_c('div',{staticClass:"selected-container col-block flex-start"},[_c('div',{staticClass:"selected-title-container row-block"},[_c('div',{staticClass:"selected-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.analysis.phenotype.___selectedTitle')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"selected-item-container row-block flex-wrap"},_vm._l((_vm.searchedPhenotypes['phenotypes']),function(phenotype,phindex){return _c('div',{key:phindex,staticClass:"item-container row-block",class:{
                    disabled: _vm.selectedLimit['phenotypes'] && !_vm.selectedPhenotypes['phenotypes'].includes(phenotype)
                  },on:{"click":function (e) {
                    _vm.selectedPhenotypes['phenotypes'] =
                      e.currentTarget.className.split(' ').includes('disabled') ? _vm.selectedPhenotypes['phenotypes']
                      : _vm.selectedPhenotypes['phenotypes'].includes(phenotype) ? _vm.selectedPhenotypes['phenotypes'].filter(function (p) { return p.id !== phenotype.id; })
                      : _vm.selectedPhenotypes['phenotypes'].concat([phenotype])
                  }}},[_c('div',{staticClass:"item-block row-block shrink"},[_c('img',{staticClass:"checkbox",attrs:{"src":_vm.selectedPhenotypes['phenotypes'].includes(phenotype) ? __webpack_require__("7kqe")
                        : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"item-title shrink break-line"},[_vm._v(_vm._s(phenotype.query))])]),_vm._v(" "),_c('img',{staticClass:"option",attrs:{"src":__webpack_require__("Xb65"),"alt":""},on:{"click":function (e) { return _vm.addToPanel(phenotype); }}})])}),0)]):_vm._e()])]),_vm._v(" "),_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '0px' })}),_vm._v(" "),_c('div',{staticClass:"analysis-title-container row-block"},[_c('div',{staticClass:"analysis-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.analysis.gene.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"gene-panel-container block col-block"},[_c('div',{staticClass:"block-content"},[_c('div',{staticClass:"display-icon center-block",class:{ active: _vm.display.genePanel },on:{"click":function (e) { return _vm.display.genePanel = !_vm.display.genePanel; }}},[_c('img',{attrs:{"src":__webpack_require__("0Pmj"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"block-title-container row-block"},[_c('div',{staticClass:"block-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.analysis.genePanel.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),((_vm.userGenePanelDatas || []).length)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display.genePanel),expression:"display.genePanel"}],staticClass:"gene-panel-block block-content col-block width-full"},[_c('div',{staticClass:"selected-item-container row-block flex-wrap"},_vm._l((_vm.userGenePanelDatas),function(gene,gindex){return _c('div',{key:gindex,staticClass:"item-container row-block",class:{
                    disabled: _vm.selectedLimit['genes'] && !_vm.selectedPhenotypes['panelGenes'].includes(gene)
                  },on:{"click":function (e) {
                    _vm.selectedPhenotypes['panelGenes'] =
                      e.currentTarget.className.split(' ').includes('disabled') ? _vm.selectedPhenotypes['panelGenes']
                      : _vm.selectedPhenotypes['panelGenes'].includes(gene) ? _vm.selectedPhenotypes['panelGenes'].filter(function (g) { return g.name + '_' + g.id !== gene.name + '_' + gene.id; })
                      : _vm.selectedPhenotypes['panelGenes'].concat([gene])
                  }}},[_c('div',{staticClass:"item-block row-block shrink"},[_c('img',{staticClass:"checkbox",attrs:{"src":_vm.selectedPhenotypes['panelGenes'].includes(gene) ? __webpack_require__("7kqe")
                        : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"item-title shrink break-line"},[_vm._v(_vm._s(((gene.category[0].toUpperCase() + gene.category.slice(1)) + ': ').replace('Gene: ', '') + gene.name))])]),_vm._v(" "),_c('img',{staticClass:"option",attrs:{"src":__webpack_require__("NMi8"),"alt":""},on:{"click":function($event){$event.stopPropagation();return (function (e) { return _vm.openGenePanelDataSelect(gene); })($event)}}})])}),0)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"search-container row-block"},[_c('div',{staticClass:"search-block col-block",style:({ flex: 1 })},[_c('div',{staticClass:"row-block flex-start",style:({ width: '100%' })},[_c('div',{staticClass:"search-input input-group",style:({ flex: 1 })},[_c('geneTag',{style:({ width: '100%' }),attrs:{"tagHeight":'300px',"placeholder":_vm.$t('COMPONENT.case.base.analysis.gene.geneTag.___placeholder'),"init":_vm.tagData.query['gene'],"dataInfo":_vm.tagData.tag['genes'].info,"genes":_vm.tagData.tag['genes'].datas},on:{"input":function (content) { _vm.tagData.query['gene'] = content; _vm.getGenes(content); _vm.customValidate([], ['selected', 'genePanel']) },"tag":function (content) { _vm.tagData.query['gene'] = content.name; _vm.tagData.curTag['gene'] = content; _vm.customValidate([], ['selected', 'genePanel']) },"send":function (content) { return (_vm.tagData.tag['genes'].datas || []).length && _vm.tagData.query['gene'] ? _vm.addToSearch('gene', _vm.tagData.curTag['gene'] || _vm.tagData.query['gene']) : ''; }}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zSkq"),"alt":""}})],1),_vm._v(" "),_c('div',{style:({ width: '22px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.loading['addToSearch'] },attrs:{"disabled":!((_vm.tagData.tag['genes'].datas || []).length && _vm.tagData.query['gene'])},on:{"click":function (e) { return (_vm.tagData.tag['genes'].datas || []).length && _vm.tagData.query['gene'] ? _vm.addToSearch('gene', _vm.tagData.curTag['gene'] || _vm.tagData.query['gene']) : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___add')))])]),_vm._v(" "),_c('div',{style:({ width: '6px' })}),_vm._v(" "),_c('div',{staticClass:"icon-block",style:({ '--size': '40px' }),on:{"click":function($event){$event.stopPropagation();return (function (e) { return _vm.openGenePanelSearch(); })($event)}}},[_c('img',{attrs:{"src":__webpack_require__("Qd2E"),"alt":""}})])]),_vm._v(" "),(_vm.searchedPhenotypes['genes'].length)?_c('div',{staticClass:"selected-container col-block flex-start"},[_c('div',{staticClass:"selected-title-container row-block"},[_c('div',{staticClass:"selected-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.analysis.gene.___selectedTitle')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"selected-item-container row-block flex-wrap"},_vm._l((_vm.searchedPhenotypes['genes']),function(gene,gindex){return _c('div',{key:gindex,staticClass:"item-container row-block",class:{
                    disabled: _vm.selectedLimit['genes'] && !_vm.selectedPhenotypes['genes'].includes(gene)
                  },on:{"click":function (e) {
                    _vm.selectedPhenotypes['genes'] =
                      e.currentTarget.className.split(' ').includes('disabled') ? _vm.selectedPhenotypes['genes']
                      : _vm.selectedPhenotypes['genes'].includes(gene) ? _vm.selectedPhenotypes['genes'].filter(function (g) { return g.name + '_' + g.id !== gene.name + '_' + gene.id; })
                      : _vm.selectedPhenotypes['genes'].concat([gene])
                  }}},[_c('div',{staticClass:"item-block row-block shrink"},[_c('img',{staticClass:"checkbox",attrs:{"src":_vm.selectedPhenotypes['genes'].includes(gene) ? __webpack_require__("7kqe")
                        : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"item-title shrink break-line"},[_vm._v(_vm._s(gene.name))])]),_vm._v(" "),_c('img',{staticClass:"option",attrs:{"src":__webpack_require__("NMi8"),"alt":""},on:{"click":function($event){$event.stopPropagation();return (function (e) { return _vm.openGenePanelDataSelect(gene); })($event)}}})])}),0)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"allele-frequency-threshold-container block col-block"},[_c('div',{staticClass:"block-content"},[_c('div',{staticClass:"display-icon center-block",class:{ active: _vm.display.alleleFrequencyThreshold },on:{"click":function (e) { return _vm.display.alleleFrequencyThreshold = !_vm.display.alleleFrequencyThreshold; }}},[_c('img',{attrs:{"src":__webpack_require__("0Pmj"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"block-title-container row-block"},[_c('div',{staticClass:"block-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.analysis.alleleFrequencyThreshold.___title')))]),_vm._v(" "),_c('borCor',{attrs:{"width":'300px',"background":'white',"border":'#CCCCCC',"radius":'0px',"blockStyle":{ padding: '10px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{style:({ width: '16px' }),attrs:{"src":__webpack_require__("Rp0L"),"alt":""}})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.analysis.alleleFrequencyThreshold.___info')))])])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display.alleleFrequencyThreshold),expression:"display.alleleFrequencyThreshold"}],staticClass:"allele-frequency-threshold-block block-content col-block"},[_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.analysisData,"layoutType":'grid',"groupCount":6,"alerts":_vm.alerts,"forms":_vm.formOptions['field3_1'],"scope":_vm.scope,"reading":false},on:{"change":function (result, validate, errors) { return _vm.formOnChange('analysis', 'field3_1', result, validate, errors); }}})],1)])]),_vm._v(" "),_c('div',{staticClass:"score-threshold-container block col-block"},[_c('div',{staticClass:"block-content"},[_c('div',{staticClass:"display-icon center-block",class:{ active: _vm.display.scoreThreshold },on:{"click":function (e) { return _vm.display.scoreThreshold = !_vm.display.scoreThreshold; }}},[_c('img',{attrs:{"src":__webpack_require__("0Pmj"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"block-title-container row-block"},[_c('div',{staticClass:"block-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.analysis.scoreThreshold.___title')))]),_vm._v(" "),_c('borCor',{attrs:{"width":'300px',"background":'white',"border":'#CCCCCC',"radius":'0px',"blockStyle":{ padding: '10px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{style:({ width: '16px' }),attrs:{"src":__webpack_require__("Rp0L"),"alt":""}})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.analysis.scoreThreshold.___info')))])])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display.scoreThreshold),expression:"display.scoreThreshold"}],staticClass:"score-threshold-block block-content col-block"},[_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.analysisData,"layoutType":'grid',"groupCount":6,"alerts":_vm.alerts,"forms":_vm.formOptions['field3_2'],"scope":_vm.scope,"reading":false},on:{"change":function (result, validate, errors) { return _vm.formOnChange('analysis', 'field3_2', result, validate, errors); }}})],1)])])],2),_vm._v(" "),(['analysis'].includes(_vm.mode))?[_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('div',{staticClass:"analysis-block col-block width-full"},[_c('div',{staticClass:"analysis-title-container row-block"},[_c('div',{staticClass:"analysis-title-block row-block",class:{ disabled: _vm.familyAnalysisAlert !== undefined }},[(_vm.familyAnalysisAlert !== undefined)?_c('div',{staticClass:"analysis-disabled-mask container-block"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"analysis-title main"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.analysis.___familyTitle')))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('switchButton',{attrs:{"checked":_vm.analysisData.family_analysis},on:{"input":function (c) { _vm.analysisData.family_analysis = c }}})],1),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),(_vm.familyAnalysisAlert)?_c('div',{staticClass:"analysis-alert"},[_vm._v(_vm._s(_vm.familyAnalysisAlert))]):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.analysisData.family_analysis),expression:"analysisData.family_analysis"}],staticClass:"family-analysis-container block col-block"},[_c('div',{staticClass:"block-content"},[_c('div',{staticClass:"display-icon center-block",class:{ active: _vm.display.familyAnalysis },on:{"click":function (e) { return _vm.display.familyAnalysis = !_vm.display.familyAnalysis; }}},[_c('img',{attrs:{"src":__webpack_require__("0Pmj"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"block-title-container row-block"},[_c('div',{staticClass:"block-title",style:({ 'font-weight': '500' })},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.analysis.familyAnalysis.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display.familyAnalysis),expression:"display.familyAnalysis"}],staticClass:"family-analysis-block block-content col-block width-full"},[_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"family-analysis-option-container col-block flex-start"},[_c('div',{staticClass:"family-analysis-option-block row-block"},[_c('div',{staticClass:"family-analysis-option-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.analysis.familyAnalysis.option.title.___excludeVariant')))]),_vm._v(" "),_c('switchButton',{attrs:{"checked":_vm.analysisData.family_exclude},on:{"input":function (c) { _vm.analysisData.family_exclude = c }}})],1)]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"family-analysis-case-container col-block width-full"},[_c('baseFamilyCase',{ref:'family-base',attrs:{"mode":_vm.mode,"defaultData":_vm.defaultData},on:{"change":function (data) { return _vm.familyDatas = data; }}})],1)])])])])]:_vm._e()],2)]:_vm._e(),_vm._v(" "),(_vm.layoutBlocks.includes('file'))?[_c('hr',{staticClass:"custom full",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('div',{staticClass:"file-container col-block width-full"},[_c('div',{staticClass:"file-title row-block"},[_c('div',{staticClass:"title row-block"},[_c('b',[_vm._v(_vm._s({ 'vcf': _vm.$t('COMPONENT.case.base.file.vcf.___title'), 'fastq': _vm.$t('COMPONENT.case.base.file.fastq.___title'), 'ubam': _vm.$t('COMPONENT.case.base.file.ubam.___title') }[_vm.dataset]))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',[_vm._v(_vm._s('(' + _vm.$t('COMPONENT.case.base.file.___afterAlert') + ')'))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),(['supervisor'].includes(_vm.user.role) && ['fastq', 'ubam'].includes(_vm.dataset) && !_vm._LOCAL_BUILD)?[_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('div',{staticClass:"file-cloud-container row-block"},[_c('div',{staticClass:"file-cloud-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.file.___cloudTitle')))]),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('switchButton',{attrs:{"disabled":false,"checked":_vm.fromCloud},on:{"input":function (c) { _vm.fromCloud = c; _vm.initFile(); }}})],1)]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"other row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),(_vm.dataset === 'fastq')?_c('button',{staticClass:"white-gray-button circle-button center-block",attrs:{"disabled":Object.values(_vm.fastqSets[_vm.fastqSets.length - 1]).some(function (file) { return !file; })},on:{"click":function (e) { return _vm.fastqSets.push({ r1: null, r2: null }); }}},[_c('img',{attrs:{"src":__webpack_require__("Hct3"),"alt":""}})]):(_vm.dataset === 'ubam')?_c('button',{staticClass:"white-gray-button circle-button center-block",attrs:{"disabled":Object.values(_vm.ubamSets[_vm.ubamSets.length - 1]).some(function (file) { return !file; })},on:{"click":function (e) { return _vm.ubamSets.push({ bam: null }); }}},[_c('img',{attrs:{"src":__webpack_require__("Hct3"),"alt":""}})]):_c('div')])],2),_vm._v(" "),(_vm.dataset === 'vcf')?[_c('div',{staticClass:"alert-container col-block width-full"},[_c('div',{staticClass:"alert",domProps:{"innerHTML":_vm._s(_vm.$t('COMPONENT.case.base.file.alert.___content'))}})])]:_vm._e(),_vm._v(" "),(_vm.dataset === 'fastq')?[_c('div',{style:({ height: '4px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.caseData,"layoutType":'grid',"groupCount":6,"alerts":_vm.alerts,"forms":_vm.formOptions['field4'],"scope":_vm.scope,"reading":false},on:{"change":function (result, validate, errors) { return _vm.formOnChange('case', 'field4', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"pipeline-type-container col-block width-full"},[_c('div',{staticClass:"pipeline-type-block row-block"},[_c('div',{staticClass:"pipeline-type-form-container row-block",class:{ disabled: (_vm.pipelineMetadataMap[_vm.result['case'].library_type_name] || {}).type }},[_c('div',{staticClass:"pipeline-type-form-mask"}),_vm._v(" "),_c('div',{staticClass:"pipeline-type-form-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.file.pipeline.title.___single')))]),_vm._v(" "),_c('switchButton',{attrs:{"disabled":false,"active":true,"checked":_vm.pipelineType === 'paired'},on:{"input":function (c) { return _vm.pipelineType = c ? 'paired' : 'single'; }}}),_vm._v(" "),_c('div',{staticClass:"pipeline-type-form-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.file.pipeline.title.___paired')))])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])]:_vm._e(),_vm._v(" "),(_vm.dataset === 'ubam')?[_c('div',{style:({ height: '4px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.caseData,"layoutType":'grid',"groupCount":6,"alerts":_vm.alerts,"forms":_vm.formOptions['field4'],"scope":_vm.scope,"reading":false},on:{"change":function (result, validate, errors) { return _vm.formOnChange('case', 'field4', result, validate, errors); }}})]:_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataset === 'vcf'),expression:"dataset === 'vcf'"}],staticClass:"file-content"},[_c('div',{style:({ height: '15px' })}),_vm._v(" "),_vm._l((_vm.vcfSets),function(set,index){return _c('div',{key:index,staticClass:"file-set-group row-block stretch"},[_c('div',{staticClass:"file-block col-block",style:({ flex: 2, width: 0 })},[_c('div',{staticClass:"title-block row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.file.vcf.file.___snvTitle'))),_c('span',{staticClass:"required"},[_vm._v("*")])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(set.snv)?[_c('div',{staticClass:"source-container col-block flex-start width-full"},[_c('div',{staticClass:"source-block row-block"},[_c('div',{staticClass:"source shrink ellipsis",attrs:{"title":set.snv.name}},[_vm._v(_vm._s(set.snv.name))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ height: '10px' })})]:_vm._e(),_vm._v(" "),(['manager', 'supervisor'].includes(_vm.user.role) || _vm.userSetting.allow_upload_vcf || _vm._LOCAL_BUILD)?[(!_vm.fromCloud)?_c('div',{staticClass:"mask"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":'set' + (index + 1) + '_snv',"extension":"vcf,vcf.gz"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.selectFile(e, set, 'snv'); }, function () { return _vm.addToast('error', _vm.$t('COMMON.toast.___fileTypeAlert', { types: 'VCF' })); }); }}}),_vm._v(" "),_c('label',{attrs:{"for":'set' + (index + 1) + '_snv'}}),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button"},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])])]):_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.openFileCloud(set, 'snv'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])])]:_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.addToast('error', _vm.$t('COMMON.toast.___noPermissionToUploadFile')); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),_c('div',{staticClass:"file-block col-block",style:({ flex: 2, width: 0 })},[_c('div',{staticClass:"title-block row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.file.vcf.file.___svTitle')))]),_vm._v(" "),_c('borCor',{attrs:{"background":'white',"border":'#CCCCCC',"radius":'0px',"blockStyle":{ padding: '10px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{style:({ width: '16px' }),attrs:{"src":__webpack_require__("Rp0L"),"alt":""}})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.file.vcf.file.___svInfo', { count: _vm.fileLimit['sv'] })))])])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(set.sv)?[_c('div',{staticClass:"source-container col-block flex-start width-full"},_vm._l((set.sv),function(file,findex){return _c('div',{key:findex,staticClass:"source-block row-block"},[_c('div',{staticClass:"source shrink ellipsis",attrs:{"title":file.name}},[_vm._v(_vm._s(file.name))]),_vm._v(" "),_c('img',{staticClass:"source-remove-icon",attrs:{"src":__webpack_require__("GFlx"),"alt":""},on:{"click":function (e) { return set.sv.splice(set.sv.indexOf(file), 1); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0),_vm._v(" "),_c('div',{style:({ height: '10px' })})]:_vm._e(),_vm._v(" "),(['manager', 'supervisor'].includes(_vm.user.role) || _vm.userSetting.allow_upload_vcf || _vm._LOCAL_BUILD)?[(!_vm.fromCloud)?_c('div',{staticClass:"mask"},[(set.snv)?[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","multiple":"","id":'set' + (index + 1) + '_sv',"extension":"vcf,vcf.gz"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.selectFile(e, set, 'sv'); }, function () { return _vm.addToast('error', _vm.$t('COMMON.toast.___fileTypeAlert', { types: 'VCF' })); }); }}}),_vm._v(" "),_c('label',{attrs:{"for":'set' + (index + 1) + '_sv'}})]:_vm._e(),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button",attrs:{"disabled":!set.snv}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])])],2):_c('button',{staticClass:"white-gray-button circle-button",attrs:{"disabled":!set.snv},on:{"click":function (e) { return e.currentTarget.className.split(' ').includes('disabled') && _vm.openFileCloud(set, 'sv'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])])]:_c('button',{staticClass:"white-gray-button circle-button",attrs:{"disabled":!set.snv},on:{"click":function (e) { return e.currentTarget.className.split(' ').includes('disabled') && _vm.addToast('error', _vm.$t('COMMON.toast.___noPermissionToUploadFile')); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),_c('div',{staticClass:"file-block col-block",style:({ flex: 3, width: 0 })},[_c('div',{staticClass:"title-block row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.file.vcf.file.___strTitle')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(set.str)?[_c('div',{staticClass:"source-container col-block flex-start width-full"},[_c('div',{staticClass:"source-block row-block"},[_c('div',{staticClass:"source shrink ellipsis",attrs:{"title":set.str.name}},[_vm._v(_vm._s(set.str.name))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ height: '10px' })})]:_vm._e(),_vm._v(" "),(['manager', 'supervisor'].includes(_vm.user.role) || _vm.userSetting.allow_upload_vcf || _vm._LOCAL_BUILD)?[(!_vm.fromCloud)?_c('div',{staticClass:"mask"},[(set.snv)?[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":'set' + (index + 1) + '_str',"extension":"vcf,vcf.gz"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.selectFile(e, set, 'str'); }, function () { return _vm.addToast('error', _vm.$t('COMMON.toast.___fileTypeAlert', { types: 'VCF' })); }); }}}),_vm._v(" "),_c('label',{attrs:{"for":'set' + (index + 1) + '_str'}})]:_vm._e(),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button",attrs:{"disabled":!set.snv}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])])],2):_c('button',{staticClass:"white-gray-button circle-button",attrs:{"disabled":!set.str},on:{"click":function (e) { return e.currentTarget.className.split(' ').includes('disabled') && _vm.openFileCloud(set, 'str'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])])]:_c('button',{staticClass:"white-gray-button circle-button",attrs:{"disabled":!set.str},on:{"click":function (e) { return e.currentTarget.className.split(' ').includes('disabled') && _vm.addToast('error', _vm.$t('COMMON.toast.___noPermissionToUploadFile')); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataset === 'fastq'),expression:"dataset === 'fastq'"}],staticClass:"file-content"},[_c('div',{style:({ height: '15px' })}),_vm._v(" "),_vm._l((_vm.fastqSets),function(set,index){return _c('div',{key:index,staticClass:"file-set-group row-block stretch"},[_c('div',{staticClass:"file-block col-block",style:({ flex: 1, width: 0 })},[_c('div',{staticClass:"title-block row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.file.fastq.file.___title', { set: index + 1, read: 'R1' })))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(set.r1)?[_c('div',{staticClass:"source-container col-block flex-start width-full"},[_c('div',{staticClass:"source-block row-block"},[_c('div',{staticClass:"source shrink ellipsis",attrs:{"title":set.r1.name}},[_vm._v(_vm._s(set.r1.name))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ height: '10px' })})]:_vm._e(),_vm._v(" "),(['manager', 'supervisor'].includes(_vm.user.role) || _vm._LOCAL_BUILD)?[(!_vm.fromCloud)?_c('div',{staticClass:"mask"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":'set' + (index + 1) + '_r1',"extension":"fq,fq.gz,fastq,fastq.gz"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.selectFile(e, set, 'r1'); }, function () { return _vm.addToast('error', _vm.$t('COMMON.toast.___fileTypeAlert', { types: 'FASTQ' })); }); }}}),_vm._v(" "),_c('label',{attrs:{"for":'set' + (index + 1) + '_r1'}}),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button"},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])])]):_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.openFileCloud(set, 'r1'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])])]:_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.addToast('error', _vm.$t('COMMON.toast.___noPermissionToUploadFile')); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),_c('div',{staticClass:"file-block col-block",class:{ disabled: _vm.pipelineType === 'single' },style:({ flex: 1, width: 0 })},[_c('div',{staticClass:"disabled-mask"}),_vm._v(" "),_c('div',{staticClass:"title-block row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.file.fastq.file.___title', { set: index + 1, read: 'R2' })))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(set.r2 && _vm.pipelineType !== 'single')?[_c('div',{staticClass:"source-container col-block flex-start width-full"},[_c('div',{staticClass:"source-block row-block"},[_c('div',{staticClass:"source shrink ellipsis",attrs:{"title":set.r2.name}},[_vm._v(_vm._s(set.r2.name))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ height: '10px' })})]:_vm._e(),_vm._v(" "),(['manager', 'supervisor'].includes(_vm.user.role) || _vm._LOCAL_BUILD)?[(!_vm.fromCloud)?_c('div',{staticClass:"mask"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":'set' + (index + 1) + '_r2',"extension":"fq,fq.gz,fastq,fastq.gz"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.selectFile(e, set, 'r2'); }, function () { return _vm.addToast('error', _vm.$t('COMMON.toast.___fileTypeAlert', { types: 'FASTQ' })); }); }}}),_vm._v(" "),_c('label',{attrs:{"for":'set' + (index + 1) + '_r2'}}),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button"},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])])]):_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.openFileCloud(set, 'r2'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])])]:_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.addToast('error', _vm.$t('COMMON.toast.___noPermissionToUploadFile')); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataset === 'ubam'),expression:"dataset === 'ubam'"}],staticClass:"file-content"},[_c('div',{style:({ height: '15px' })}),_vm._v(" "),_vm._l((_vm.ubamSets),function(set,index){return _c('div',{key:index,staticClass:"file-set-group row-block stretch"},[_c('div',{staticClass:"file-block col-block",style:({ flex: 1, width: 0 })},[_c('div',{staticClass:"title-block row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.base.file.ubam.file.___title', { set: index + 1 })))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(set.bam)?[_c('div',{staticClass:"source-container col-block flex-start width-full"},[_c('div',{staticClass:"source-block row-block"},[_c('div',{staticClass:"source shrink ellipsis",attrs:{"title":set.bam.name}},[_vm._v(_vm._s(set.bam.name))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ height: '10px' })})]:_vm._e(),_vm._v(" "),(['manager', 'supervisor'].includes(_vm.user.role) || _vm._LOCAL_BUILD)?[(!_vm.fromCloud)?_c('div',{staticClass:"mask"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":'set' + (index + 1) + '_bam',"extension":"bam,ubam"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.selectFile(e, set, 'bam'); }, function () { return _vm.addToast('error', _vm.$t('COMMON.toast.___fileTypeAlert', { types: 'BAM' })); }); }}}),_vm._v(" "),_c('label',{attrs:{"for":'set' + (index + 1) + '_bam'}}),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button"},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])])]):_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.openFileCloud(set, 'bam'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])])]:_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.addToast('error', _vm.$t('COMMON.toast.___noPermissionToUploadFile')); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)])})],2)],2)]:_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.onError))])],2)}
var base_staticRenderFns = []
var base_esExports = { render: base_render, staticRenderFns: base_staticRenderFns }
/* harmony default export */ var case_base = (base_esExports);
// CONCATENATED MODULE: ./src/components/case/base.vue
var base_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var base___vue_template_functional__ = false
/* styles */
var base___vue_styles__ = null
/* scopeId */
var base___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var base___vue_module_identifier__ = null
var base_Component = base_normalizeComponent(
  base,
  case_base,
  base___vue_template_functional__,
  base___vue_styles__,
  base___vue_scopeId__,
  base___vue_module_identifier__
)

/* harmony default export */ var components_case_base = __webpack_exports__["a"] = (base_Component.exports);


/***/ }),

/***/ "/2uW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/scrollBottom.vue


//
//
//
//
//
//

/* harmony default export */ var scrollBottom = ({
  props: {
    containerKey: {
      type: String,
      default: function _default() {
        return 'default';
      }
    },
    onScrollBottom: {
      type: Function,
      required: true
    },
    deviation: {
      type: Number,
      default: function _default() {
        return 0;
      }
    }
  },
  data: function data() {
    return {
      currentScroll: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.onScroll(_this.$refs['scroll-container-' + _this.containerKey], true);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    onScroll: function onScroll(element) {
      var _this2 = this;

      var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var result;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(element.scrollTop >= element.scrollHeight - element.offsetHeight - (init ? 0 : _this2.deviation) && (element.scrollTop > _this2.currentScroll || _this2.currentScroll === 0))) {
                  _context2.next = 6;
                  break;
                }

                _this2.currentScroll = element.scrollHeight - element.offsetHeight;
                _context2.next = 4;
                return _this2.onScrollBottom();

              case 4:
                result = _context2.sent;

                if (result !== false && element.scrollHeight === element.offsetHeight) {
                  _this2.onScroll(element);
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e669a22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/scrollBottom.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:'scroll-container-' + _vm.containerKey,attrs:{"id":"scroll-bottom"},on:{"scroll":function (e) { return _vm.onScroll(e.target); }}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_scrollBottom = (esExports);
// CONCATENATED MODULE: ./src/components/tool/scrollBottom.vue
function injectStyle (ssrContext) {
  __webpack_require__("bxm6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  scrollBottom,
  tool_scrollBottom,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_scrollBottom = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/xXD":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3NiIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDc2IDI0Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzIwMTgiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDIwMTgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xODQ2MSAtNjI1NykiPgogICAgPGxpbmUgaWQ9Iue3ml8xOTUiIGRhdGEtbmFtZT0i57eaIDE5NSIgeDI9IjEyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODQ3Ni41IDYyNjkuNSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZhM2QzZCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8bGluZSBpZD0i57eaXzE5NiIgZGF0YS1uYW1lPSLnt5ogMTk2IiB4Mj0iMTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NTEwLjUgNjI2OS41KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjYWFhIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgIDxnIGlkPSLmpZXlhoblvaJfMTA3IiBkYXRhLW5hbWU9IualleWGhuW9oiAxMDciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NTIxIDYyNjEpIiBmaWxsPSIjZmZmIiBzdHJva2U9IiNhYWEiIHN0cm9rZS13aWR0aD0iMSI+CiAgICAgIDxjaXJjbGUgY3g9IjgiIGN5PSI4IiByPSI4IiBzdHJva2U9Im5vbmUiLz4KICAgICAgPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjcuNSIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogICAgPGcgaWQ9IualleWGhuW9ol8xMDgiIGRhdGEtbmFtZT0i5qWV5YaG5b2iIDEwOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTg0ODcgNjI1NykiIGZpbGw9IiNmZmYiIHN0cm9rZT0iI2FhYSIgc3Ryb2tlLXdpZHRoPSIxIj4KICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMS41IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgICA8Y2lyY2xlIGlkPSLmpZXlhoblvaJfMTA5IiBkYXRhLW5hbWU9IualleWGhuW9oiAxMDkiIGN4PSI4IiBjeT0iOCIgcj0iOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTg0NjEgNjI2MSkiIGZpbGw9IiNmYTNkM2QiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "02u3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "09wH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzc4OTEiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDc4OTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNDUzMSAzMDM4KSI+CiAgICA8cmVjdCBpZD0i6ZW35pa55b2iXzEyNDAiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDEyNDAiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQ1MzEgLTMwMzgpIiBmaWxsPSIjZmZmIi8+CiAgICA8cGF0aCBpZD0iZm9sZGVyLW9wZW4tbGlnaHQiIGQ9Ik0xNi41LDY5SDE1VjY3LjVBMS41LDEuNSwwLDAsMCwxMy41LDY2aC01bC0yLTJoLTVBMS41LDEuNSwwLDAsMCwwLDY1LjV2OUExLjUsMS41LDAsMCwwLDEuNSw3NkgxMy41MzNhMi41LDIuNSwwLDAsMCwyLjE0NC0xLjIxNGwyLjEwOC0zLjUxNUExLjUsMS41LDAsMCwwLDE2LjUsNjlabS0xNS00SDYuMDg2bDIsMkgxMy41YS41LjUsMCwwLDEsLjUuNVY2OUg1LjM0OWEyLjUsMi41LDAsMCwwLTIuMTQ0LDEuMjE0TDEsNzMuODlWNjUuNUEuNS41LDAsMCwxLDEuNSw2NVptMTUuNDI4LDUuNzU3LTIuMTA5LDMuNTE1QTEuNSwxLjUsMCwwLDEsMTMuNTMzLDc1SDEuNGwyLjU2My00LjI3MkExLjUsMS41LDAsMCwxLDUuMjUsNzBIMTYuNWEuNS41LDAsMCwxLC40MjkuNzU3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQ1MzIgLTMwOTgpIiBmaWxsPSIjMDAzNjc5IiBzdHJva2U9IiMwMDM2NzkiIHN0cm9rZS13aWR0aD0iMC4yNSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "0Pmj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi41IiBoZWlnaHQ9IjguNTY2IiB2aWV3Qm94PSIwIDAgMTYuNSA4LjU2NiI+CiAgPHBhdGggaWQ9ImNoZXZyb24tZG93bi1yZWd1bGFyIiBkPSJNMTUuODczLjczNywxNS4xNTcuMTExYS40NzkuNDc5LDAsMCwwLS42MTQsMEw4LDUuODIsMS40NTcuMTExYS40NzkuNDc5LDAsMCwwLS42MTQsMEwuMTI3LjczN2EuMzQ3LjM0NywwLDAsMCwwLC41MzdMNy42OTMsNy44ODlhLjQ3OS40NzksMCwwLDAsLjYxNCwwbDcuNTY2LTYuNjE1QS4zNDcuMzQ3LDAsMCwwLDE1Ljg3My43MzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNi4yNSA4LjI4Mykgcm90YXRlKDE4MCkiIGZpbGw9IiMwMDM2NzkiIHN0cm9rZT0iIzA1MzY3OSIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "0VYF":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDE4IDI0Ij4KICA8cGF0aCBpZD0iZmlsZS1pbnZvaWNlLWxpZ2h0IiBkPSJNMTUsMjIuNUgzQTEuNSwxLjUsMCwwLDEsMS41LDIxVjNBMS41LDEuNSwwLDAsMSwzLDEuNUg5VjYuNzVBMi4yNTEsMi4yNTEsMCwwLDAsMTEuMjUsOUgxNi41VjIxQTEuNSwxLjUsMCwwLDEsMTUsMjIuNVptLTMuNzUtMTVhLjc1Mi43NTIsMCwwLDEtLjc1LS43NVYxLjUyM2EuNzE2LjcxNiwwLDAsMSwuMzQ3LjJMMTYuMjgsNy4xNTNhLjczNy43MzcsMCwwLDEsLjIuMzQ3Wk0zLDBBMywzLDAsMCwwLDAsM1YyMWEzLDMsMCwwLDAsMywzSDE1YTMsMywwLDAsMCwzLTNWNy42ODNhMi4yNSwyLjI1LDAsMCwwLS42NjEtMS41ODlMMTEuOTExLjY2MUEyLjI1LDIuMjUsMCwwLDAsMTAuMzIyLDBaTTMsMy43NWEuNzUyLjc1MiwwLDAsMCwuNzUuNzVoM2EuNzUuNzUsMCwwLDAsMC0xLjVoLTNBLjc1Mi43NTIsMCwwLDAsMywzLjc1Wm0wLDNhLjc1Mi43NTIsMCwwLDAsLjc1Ljc1aDNhLjc1Ljc1LDAsMCwwLDAtMS41aC0zQS43NTIuNzUyLDAsMCwwLDMsNi43NVptNy41LDEzLjVhLjc1Mi43NTIsMCwwLDAsLjc1Ljc1aDNhLjc1Ljc1LDAsMCwwLDAtMS41aC0zQS43NTIuNzUyLDAsMCwwLDEwLjUsMjAuMjVabTMtNC41aC05di0zaDlabS05LTQuNUExLjUsMS41LDAsMCwwLDMsMTIuNzV2M2ExLjUsMS41LDAsMCwwLDEuNSwxLjVoOWExLjUsMS41LDAsMCwwLDEuNS0xLjV2LTNhMS41LDEuNSwwLDAsMC0xLjUtMS41WiIgZmlsbD0iIzk5OSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "0yFZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1F0f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./src/components/tool/borCor.vue + 2 modules
var borCor = __webpack_require__("HALv");

// EXTERNAL MODULE: ./src/constants/global/data.js
var data = __webpack_require__("x2hU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/case/acmgItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var acmgItem = ({
  components: {
    borCor: borCor["a" /* default */]
  },
  props: {
    acmgData: {
      type: Object,
      required: true
    },
    acmgKey: {
      type: String,
      required: true
    },
    acmgType: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    borCorReverse: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      acmgTag: null
    };
  },

  computed: {
    acmgStyles: function acmgStyles() {
      return {
        'benign-strong': {
          '--bg-color': 'rgba(113, 72, 148, 0.1)',
          '--color': '#714894'
        },
        'benign-supporting': {
          '--bg-color': 'rgba(52, 156, 207, 0.1)',
          '--color': '#349CCF'
        },
        'pathogenic-supporting': {
          '--bg-color': 'rgba(131, 201, 30, 0.1)',
          '--color': '#83C91E'
        },
        'pathogenic-moderate': {
          '--bg-color': 'rgba(255, 158, 3, 0.1)',
          '--color': '#FF9E03'
        },
        'pathogenic-strong': {
          '--bg-color': 'rgba(250, 61, 61, 0.1)',
          '--color': '#FA3D3D'
        },
        'pathogenic-very-strong': {
          '--bg-color': 'rgba(190, 15, 15, 0.1)',
          '--color': '#BE0F0F'
        }
      }[this.acmgType];
    },
    acmgTagOptions: function acmgTagOptions() {
      var _this = this;

      var acmgNumber = (this.acmgKey.match(/^[^\d]*(\d+)/) || [])[1];
      var acmgKey = (this.acmgKey.match(/^([^\d]*)\d+/) || [])[1];
      if (acmgNumber) {
        var exceptionOptions = {
          'BA1': []
        };
        var acmgType = this.acmgKey.match(/^./);
        var acmgTagOptions = exceptionOptions[this.acmgKey] || {
          'P': ['PP', 'PM', 'PS', 'PVS'],
          'B': ['BS', 'BP']
        }[acmgType].filter(function (key) {
          return key !== acmgKey;
        }).map(function (key) {
          return { title: _this.acmgKey + '(' + key + ')' + (key + acmgNumber === _this.acmgTag ? ' ✓' : ''), value: key + acmgNumber };
        });
        return acmgTagOptions.length ? [{ title: this.acmgKey + (this.acmgKey === this.acmgTag ? ' ✓' : ''), value: this.acmgKey }].concat(toConsumableArray_default()(acmgTagOptions)) : acmgTagOptions;
      }
    },

    // global
    acmgMap: function acmgMap() {
      return data["a" /* acmgMap */];
    }
  },
  watch: {
    'acmgData': {
      handler: function handler() {
        this.setACMGTag();
      },
      deep: true
    }
  },
  created: function created() {
    this.setACMGTag();
  },

  methods: {
    setACMGTag: function setACMGTag() {
      var acmgTag = this.acmgData[this.acmgKey + '_tag'];
      this.acmgTag = this.acmgTagOptions.map(function (option) {
        return option.value;
      }).includes(acmgTag) ? acmgTag : this.acmgKey;
    },
    getACMGTag: function getACMGTag() {
      return this.acmgKey + (this.acmgKey !== this.acmgTag ? '(' + this.acmgTag.match(/^([^\d]*)\d+/)[1] + ')' : '');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bb38514","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/acmgItem.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.acmgMap[_vm.acmgKey] && _vm.acmgTag)?_c('div',{staticClass:"case-acmg-item-page",class:{ active: _vm.acmgData[_vm.acmgKey], disabled: _vm.disabled },style:(_vm.acmgStyles)},[_c('div',{staticClass:"case-acmg-item-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"case-acmg-item-content row-block shrink"},[_c('img',{staticClass:"case-acmg-item-icon",attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmgData[_vm.acmgKey] ? _vm.acmgType : _vm.acmgData[_vm.acmgKey] !== 0 ? 'empty' : 'disabled') + '.svg')},on:{"click":function (e) { return _vm.$emit('setValue', _vm.acmgKey); }}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"case-acmg-item-title-container row-block shrink input-group",attrs:{"title":_vm.getACMGTag()}},[_c('div',{staticClass:"case-acmg-item-title-block row-block shrink"},[_c('div',{staticClass:"case-acmg-item-title shrink ellipsis"},[_vm._v(_vm._s(_vm.getACMGTag()))]),_vm._v(" "),((_vm.acmgTagOptions || []).length)?_c('img',{staticClass:"case-acmg-item-title-icon",attrs:{"src":__webpack_require__("mf7a")}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"case-acmg-item-tag-option"},[((_vm.acmgTagOptions || []).length)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.acmgTag),expression:"acmgTag"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.acmgTag=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function (e) { return _vm.$emit('setValue', _vm.acmgKey, _vm.acmgTag); }]}},_vm._l((_vm.acmgTagOptions),function(option,oindex){return _c('option',{key:oindex,domProps:{"value":option.value}},[_vm._v(_vm._s(option.title))])}),0):_vm._e()])])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"case-acmg-item-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"reverse":_vm.borCorReverse,"blockStyle":{ padding: '6px 8px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap[_vm.acmgKey].informations.map(function (info) { return _vm.$t(info); }).join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var case_acmgItem = (esExports);
// CONCATENATED MODULE: ./src/components/case/acmgItem.vue
function injectStyle (ssrContext) {
  __webpack_require__("8RLt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  acmgItem,
  case_acmgItem,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_case_acmgItem = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1OSr":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTYgOCI+CiAgPHBhdGggaWQ9ImNoZXZyb24tZG93bi1yZWd1bGFyIiBkPSJNMTUuODczLjczNywxNS4xNTcuMTExYS40NzkuNDc5LDAsMCwwLS42MTQsMEw4LDUuODIsMS40NTcuMTExYS40NzkuNDc5LDAsMCwwLS42MTQsMEwuMTI3LjczN2EuMzQ3LjM0NywwLDAsMCwwLC41MzdMNy42OTMsNy44ODlhLjQ3OS40NzksMCwwLDAsLjYxNCwwbDcuNTY2LTYuNjE1QS4zNDcuMzQ3LDAsMCwwLDE1Ljg3My43MzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNiA4KSByb3RhdGUoMTgwKSIgZmlsbD0iIzAwMzY3OSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "2PDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/toastMethods.vue




/* harmony default export */ var toastMethods = ({
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addToastAction']), {
    addToast: function addToast(type, content) {
      var data = {
        type: type,
        content: content
      };
      this.addToastAction(data);
    }
  })
});
// CONCATENATED MODULE: ./src/mixins/toastMethods.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  toastMethods,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_toastMethods = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4fCP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/svg/dataset-annotation-solid.vue
//
//
//
//
//
//

/* harmony default export */ var dataset_annotation_solid = ({
  props: {
    color: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84fc817c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/dataset-annotation-solid.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"24","viewBox":"0 0 21 24"}},[_c('path',{attrs:{"id":"database-solid","d":"M21,3.429V5.571C21,7.46,16.3,9,10.5,9S0,7.46,0,5.571V3.429C0,1.54,4.7,0,10.5,0S21,1.54,21,3.429ZM21,8.25v4.821C21,14.96,16.3,16.5,10.5,16.5S0,14.96,0,13.071V8.25C2.256,9.8,6.385,10.527,10.5,10.527S18.744,9.8,21,8.25Zm0,7.5v4.821C21,22.46,16.3,24,10.5,24S0,22.46,0,20.571V15.75c2.256,1.554,6.385,2.277,10.5,2.277S18.744,17.3,21,15.75Z","fill":_vm.color}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var svg_dataset_annotation_solid = (esExports);
// CONCATENATED MODULE: ./src/components/svg/dataset-annotation-solid.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  dataset_annotation_solid,
  svg_dataset_annotation_solid,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_svg_dataset_annotation_solid = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4r+p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/tool/borCor.vue + 2 modules
var borCor = __webpack_require__("HALv");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/case/diseaseIcon.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var diseaseIcon = ({
  components: {
    borCor: borCor["a" /* default */]
  },
  props: {
    disabled: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    paths: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    borCorType: {
      type: String,
      default: function _default() {
        return 'bottom';
      }
    }
  },
  computed: {
    iconSrc: function iconSrc() {
      if (this.paths.length === 0) {
        return __webpack_require__("qElK");
      } else if (this.paths.length === 1) {
        return __webpack_require__("9yb4");
      } else {
        return __webpack_require__("/xXD");
      }
    },
    text: function text() {
      if (this.paths.length === 0) {
        return this.$t('COMPONENT.case.diseaseIcon.___text01');
      } else if (this.paths.length === 1) {
        return this.$t('COMPONENT.case.diseaseIcon.___text02');
      } else {
        return this.$t('COMPONENT.case.diseaseIcon.___text03', { length: this.paths.length - 1 });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66b8a29c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/diseaseIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-disease-icon-page"},[_c('div',{staticClass:"icon-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),(_vm.paths)?_c('div',{staticClass:"img-container center-block"},[_c('img',{attrs:{"src":_vm.iconSrc,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"count-container"},[(!_vm.disabled)?_c('borCor',{attrs:{"type":_vm.borCorType,"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
            padding: '6px 8px'
          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"count center-block"},[_vm._v(_vm._s(_vm.paths.length - 1 > 0 ? _vm.paths.length - 1 : ''))])]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",class:{ nodes: _vm.paths.length },domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),(_vm.paths.length)?[_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"node-container col-block"},[_c('div',{staticClass:"dash-line"}),_vm._v(" "),_vm._l((_vm.paths),function(path,index){return _c('div',{key:index,staticClass:"node-block row-block stretch"},[_c('div',{staticClass:"point-container"},[_c('div',{staticClass:"point"})]),_vm._v(" "),_c('div',[_c('div',{style:({ width: '5px' })})]),_vm._v(" "),_c('div',{staticClass:"node-title"},[_vm._v(_vm._s(path.name))]),_vm._v(" "),_c('div',[_c('div',{style:({ width: '5px' })})]),_vm._v(" "),_c('div',{staticClass:"link-container"},[_c('a',{staticClass:"link",attrs:{"href":'https://hpo.jax.org/app/browse/term/' + path.id,"target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("wtkH"),"alt":""}})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])})],2)]:_vm._e()],2)]):_vm._e()],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var case_diseaseIcon = (esExports);
// CONCATENATED MODULE: ./src/components/case/diseaseIcon.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  diseaseIcon,
  case_diseaseIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_case_diseaseIcon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "598Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ls__ = __webpack_require__("yXtV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_ls__);



var options = {
  namespace: 'inheriNext_'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_ls___default.a, options);

/***/ }),

/***/ "5Ggm":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTcuODU3LDUySDIuMTQzQTIuMTQzLDIuMTQzLDAsMCwxLDAsNDkuODU3VjM0LjE0M0EyLjE0MywyLjE0MywwLDAsMSwyLjE0MywzMkgxNy44NTdBMi4xNDMsMi4xNDMsMCwwLDEsMjAsMzQuMTQzVjQ5Ljg1N0EyLjE0MywyLjE0MywwLDAsMSwxNy44NTcsNTJaTTguNzE5LDQ3LjYyMmw4LjIxNC04LjIxNGEuNzE0LjcxNCwwLDAsMCwwLTEuMDFsLTEuMDEtMS4wMWEuNzE0LjcxNCwwLDAsMC0xLjAxLDBsLTYuNyw2LjdMNS4wODcsNDAuOTU5YS43MTQuNzE0LDAsMCwwLTEuMDEsMGwtMS4wMSwxLjAxYS43MTQuNzE0LDAsMCwwLDAsMS4wMWw0LjY0Myw0LjY0M0EuNzE0LjcxNCwwLDAsMCw4LjcxOSw0Ny42MjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMikiIGZpbGw9IiNiZTBmMGYiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "5Ivo":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzY5NzUiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDY5NzUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTcyIC0xNTMzKSI+CiAgICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTYuMDcxLDUwSDEuOTI5QTEuOTI5LDEuOTI5LDAsMCwxLDAsNDguMDcxVjMzLjkyOUExLjkyOSwxLjkyOSwwLDAsMSwxLjkyOSwzMkgxNi4wNzFBMS45MjksMS45MjksMCwwLDEsMTgsMzMuOTI5VjQ4LjA3MUExLjkyOSwxLjkyOSwwLDAsMSwxNi4wNzEsNTBaTTcuODQ3LDQ2LjA2bDcuMzkzLTcuMzkzYS42NDMuNjQzLDAsMCwwLDAtLjkwOWwtLjkwOS0uOTA5YS42NDMuNjQzLDAsMCwwLS45MDksMEw3LjM5Myw0Mi44NzgsNC41NzgsNDAuMDYzYS42NDMuNjQzLDAsMCwwLS45MDksMGwtLjkwOS45MDlhLjY0My42NDMsMCwwLDAsMCwuOTA5TDYuOTM4LDQ2LjA2QS42NDMuNjQzLDAsMCwwLDcuODQ3LDQ2LjA2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3MiAxNTAxKSIgZmlsbD0iI2ZmZiIvPgogICAgPGcgaWQ9IumVt+aWueW9ol8yODY4IiBkYXRhLW5hbWU9IumVt+aWueW9oiAyODY4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOTcyIDE1MzMpIiBmaWxsPSJub25lIiBzdHJva2U9IiMzMzMiIHN0cm9rZS13aWR0aD0iMSI+CiAgICAgIDxyZWN0IHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgcng9IjIiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjE3IiBoZWlnaHQ9IjE3IiByeD0iMS41IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "5xS/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "6EFu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/inputTag.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var inputTag = ({
  props: {
    init: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    tags: {
      type: Array,
      required: true
    },
    tagWidth: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    tagHeight: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    emptyDisplay: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    prefix: {
      type: String,
      default: function _default() {
        return '(?: |^)';
      }
    },
    target: {
      type: String,
      default: function _default() {
        return '@(?!.* )(.*?)$';
      }
    },
    replace: {
      type: Function,
      default: function _default(x) {
        return '@' + x + ' ';
      }
    },
    filter: {
      type: Function,
      default: function _default() {
        return null;
      }
    },
    tagDisplay: {
      type: Function,
      default: function _default(x) {
        return x;
      }
    },
    placeholder: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    // style
    inputStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      content: '',
      keyword: null,
      tagIndex: 0,
      onCompelete: false,
      focus: false,
      mouse: false,
      display: false
    };
  },

  computed: {
    filtedTags: function filtedTags() {
      var _this = this;

      if (this.keyword || !this.emptyDisplay) {
        var filter = this.filter(this.keyword) || function (x) {
          return x.includes(_this.keyword);
        };
        return this.tags.filter(function (x) {
          return filter(x);
        });
      } else {
        return this.tags;
      }
    }
  },
  watch: {
    'init': function init() {
      if (this.content !== this.init) {
        this.content = this.init;
      }
    },
    'focus': function focus() {
      this.display = this.focus || this.mouse;
    }
  },
  created: function created() {
    if (this.content !== this.init) {
      this.content = this.init;
    }
  },

  methods: {
    commentOnInput: function commentOnInput(compelete) {
      compelete && (this.onCompelete = false);
      this.tagIndex = 0;
      var match = this.content.match(new RegExp(this.prefix + this.target));
      this.keyword = match ? match[1] : null;
      this.$emit('input', this.content);
    },
    moveTagIndex: function moveTagIndex(type) {
      switch (type) {
        case 'up':
          {
            this.tagIndex = (this.tagIndex - -this.filtedTags.length - 1) % this.filtedTags.length;
            break;
          }
        case 'down':
          {
            this.tagIndex = (this.tagIndex - -1) % this.filtedTags.length;
            break;
          }
      }
      this.$refs['tag-block'].scrollTop = 29.2 * this.tagIndex;
    },
    commentTag: function commentTag() {
      var curTag = this.filtedTags[this.tagIndex];
      this.onCompelete = true;
      this.content = this.content.replace(new RegExp(this.target), this.replace(curTag));
      this.$emit('tag', curTag);
      this.commentOnInput(this.content);
      this.$refs['comment-input'].focus();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-408b9c10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/inputTag.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"input-tag-container"},on:{"mouseenter":function (e) { return _vm.mouse = true; },"mouseleave":function (e) { return _vm.mouse = false; }}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],ref:"comment-input",style:(_vm.inputStyle),attrs:{"type":"text","disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":(_vm.content)},on:{"focus":function (e) { return _vm.focus = true; },"blur":function (e) { return _vm.focus = false; },"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.moveTagIndex('up'); })($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.moveTagIndex('down'); })($event)}],"keypress":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return (_vm.filtedTags || []).length === 0 ? _vm.$emit('send', _vm.content) : _vm.commentTag(); })($event)},"input":[function($event){if($event.target.composing){ return; }_vm.content=$event.target.value},function (e) { return _vm.commentOnInput(true); }],"change":function (e) { return _vm.$emit('change', _vm.content); }}}),_vm._v(" "),((_vm.filtedTags.length > 1 || (_vm.filtedTags.length && ![_vm.content].includes(_vm.replace(_vm.filtedTags[0])))) && !_vm.onCompelete && _vm.display && (_vm.content || _vm.emptyDisplay))?_c('div',{staticClass:"input-tag",style:(_vm.tagWidth ? { 'min-width': _vm.tagWidth } : {})},[_c('div',{ref:"tag-block",staticClass:"tag-block",style:(_vm.tagHeight ? { 'max-height': _vm.tagHeight } : {})},_vm._l((_vm.filtedTags),function(tag,index){return _c('div',{key:index,staticClass:"tag",class:{ selected: _vm.tagIndex === index },on:{"mousemove":function (e) { return _vm.tagIndex = index; },"click":function($event){_vm.commentTag()}}},[_vm._v(_vm._s(_vm.tagDisplay(tag)))])}),0)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_inputTag = (esExports);
// CONCATENATED MODULE: ./src/components/tool/inputTag.vue
function injectStyle (ssrContext) {
  __webpack_require__("tIXw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  inputTag,
  tool_inputTag,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_inputTag = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Qul":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzcwNzkiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDcwNzkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDU2IDI2MikiPgogICAgPGcgaWQ9IumVt+aWueW9ol8yOTI1IiBkYXRhLW5hbWU9IumVt+aWueW9oiAyOTI1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDU2IC0yNjIpIiBmaWxsPSIjZmZmIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS13aWR0aD0iMSIgb3BhY2l0eT0iMCI+CiAgICAgIDxyZWN0IHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgc3Ryb2tlPSJub25lIi8+CiAgICAgIDxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIGZpbGw9Im5vbmUiLz4KICAgIDwvZz4KICAgIDxwYXRoIGlkPSLjg5HjgrlfNSIgZGF0YS1uYW1lPSLjg5HjgrkgNSIgZD0iTTk4MC45NzIsMTIxLjMyYTUuODc1LDUuODc1LDAsMCwxLC42MjMsMi40OTJjLS4wNTcuNDA4LS40NzQuNTgyLS40NzQsMS4yMjQsMCwxLjEzMywyLjcxOCwzLjY4MSwyLjYzNiw0LjQ4NS0uMDU2LjU1NS0xLjQzMy45MDUtMS44MTcsMS42MjZhMS42NTgsMS42NTgsMCwwLDAsLjU0NywxLjczNS43MjcuNzI3LDAsMCwxLS42NDIuNzU3LjcuNywwLDAsMSwuNDQ5LjgzYy0uOTY1LjI4Ny0uNDQzLjkwOS0uMjQ1LDEuNTdhMS44NTIsMS44NTIsMCwwLDEtLjEzOSwxLjM2NmMtLjIwNi40MTctLjc5NC40NjgtMS41NjguNTEyYTUuNjkzLDUuNjkzLDAsMCwwLTMuODE0LDEuMjMzLDcuMzgyLDcuMzgyLDAsMCwwLTIuMSwzLjUyMWwtMTIuNjMzLS4wNDFjMS40NDEtMy40MjksMi40LTcuNjg1LDEuMDUtOC44NTItNC45NDEtNC4yODMtNi45MjMtMTYuMjE1LDIuOTE4LTE5LjQxN0M5NzIuODUzLDExMi4wNTUsOTc5LjA1OCwxMTUuODIxLDk4MC45NzIsMTIxLjMyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTkuMjQxIC0zNzUuMTcpIiBmaWxsPSIjZmZmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KICAgIDxwYXRoIGlkPSLjg5HjgrlfNiIgZGF0YS1uYW1lPSLjg5HjgrkgNiIgZD0iTTk5OS41NzksMTc4LjcxNGE4Ljc2Nyw4Ljc2NywwLDAsMSwuMzA1LTIuNjZsLjA5My0uNDQ0YTI4Ljk1NSwyOC45NTUsMCwwLDEsLjkzMy0zLjI5MXEuMDkyLS4yODEuMTg2LS41NzFhNy41NDksNy41NDksMCwwLDAtLjQ4OS0xLjkzLDYuNDMsNi40MywwLDAsMC0uNzM4LTEuNTEyLDEuMTkyLDEuMTkyLDAsMCwxLS4xNTcuMDExLDIuMDQzLDIuMDQzLDAsMCwxLTEuNC0uNiwzLjc2NiwzLjc2NiwwLDAsMS0uNzQzLTEuMTlsLS4wMTMtLjAyN2MtLjAzOS0uMDg1LS4wODItLjE3Ni0uMTI5LS4yNzVhMi44MjgsMi44MjgsMCwwLDAtMS4xLTEuMzM2LDEuNjgsMS42OCwwLDAsMS0uODM0LTEuMzgxYzAtLjA0Ni0uMDA4LS4wNzUtLjAxMS0uMWEzLjgsMy44LDAsMCwxLC44MjEtMi41NzEsMi42LDIuNiwwLDAsMSwyLjAyNi0uODQ1aC4wMzNhMi40NTgsMi40NTgsMCwwLDEsMS44ODguNzU5LDMuMjEsMy4yMSwwLDAsMSwuNjY4LDIuMjkuNDQuNDQsMCwwLDEtLjQ0My4zODlsLS4wNDIsMGEuNDM5LjQzOSwwLDAsMS0uMzk0LS40NzksMi4zODksMi4zODksMCwwLDAtLjQ1MS0xLjYyLDEuNjEyLDEuNjEyLDAsMCwwLTEuMjM0LS40NjZoMGExLjc2OCwxLjc2OCwwLDAsMC0xLjM4OS41NTEsMi45NDksMi45NDksMCwwLDAtLjYwNywxLjg3N2MuMDA2LjA0My4wMTEuMDg3LjAxNS4xMzRhLjgzNi44MzYsMCwwLDAsLjQ1NS43NDcsMy42NTcsMy42NTcsMCwwLDEsMS40LDEuNjg0Yy4wNTQuMTEzLjEuMjE1LjE0NS4zMWEyLjk3OSwyLjk3OSwwLDAsMCwuNTgxLjk1MywxLjE3OSwxLjE3OSwwLDAsMCwuNzcyLjMyNi4yODYuMjg2LDAsMCwwLC4xMDgtLjAxNS45NDcuOTQ3LDAsMCwwLC4zOTUtMS4wMTEsMy42NDcsMy42NDcsMCwwLDAtLjE1LS41MzMsMS4wODIsMS4wODIsMCwwLDEtLjQyNi4wODgsMS4wODksMS4wODksMCwxLDEsMS4xLTEuMDg4LDEsMSwwLDAsMS0uMDM1LjI1Niw0LjU2MSw0LjU2MSwwLDAsMSwuMzc0LDEuMTA4LDEuODYyLDEuODYyLDAsMCwxLS40NDQsMS42MzMsNy42MDksNy42MDksMCwwLDEsLjgsMS42NDljLjA3LjIuMTM1LjM5Mi4xOTMuNThhNy42ODIsNy42ODIsMCwwLDEsMy4yMTktMy44NjMsMTAuNDQ5LDEwLjQ0OSwwLDAsMSwzLjIzNi0xLjE1NiwxLjIyLDEuMjIsMCwwLDEsMS4xNjYtLjg2NiwxLjIsMS4yLDAsMSwxLTEuMDg1LDEuNzM1QTkuNTI2LDkuNTI2LDAsMCwwLDEwMDUuMywxNjdhNi43NDQsNi43NDQsMCwwLDAtMi43MDcsMy4xMiw4LjkxLDguOTEsMCwwLDEsMS44OTMtLjg4Miw5LjM4Nyw5LjM4NywwLDAsMSwyLjk1OC0uNDA5bC4yMjQsMGExLjIyMiwxLjIyMiwwLDAsMSwxLjEtLjcsMS4yLDEuMiwwLDEsMS0xLjE0OSwxLjU3NWgtLjE3OWE4LjUzMyw4LjUzMywwLDAsMC0yLjY1Ni4zNTUsNi4wNjIsNi4wNjIsMCwwLDAtMi43NTYsMS42OHMtLjIwOS42NDYtLjI3NS44NDZhMjguMjYxLDI4LjI2MSwwLDAsMC0uOTA4LDMuMmwtLjExMS41MzFhNy43MTMsNy43MTMsMCwwLDAtLjI2OSwyLjM4OHYuMTFsLS44ODQuMDFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3MC42NDIgLTQxMS4zMjYpIiBmaWxsPSIjMDAzNjc5IiBzdHJva2U9IiMwMDM2NzkiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIwLjIiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "6v0c":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./quality-nopass-info-icon.svg": "RCqP",
	"./quality-pass-info-icon.svg": "i1qd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6v0c";

/***/ }),

/***/ "7kqe":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzY4ODMiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDY4ODMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTcyIC0xNTMzKSI+CiAgICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTYuMDcxLDUwSDEuOTI5QTEuOTI5LDEuOTI5LDAsMCwxLDAsNDguMDcxVjMzLjkyOUExLjkyOSwxLjkyOSwwLDAsMSwxLjkyOSwzMkgxNi4wNzFBMS45MjksMS45MjksMCwwLDEsMTgsMzMuOTI5VjQ4LjA3MUExLjkyOSwxLjkyOSwwLDAsMSwxNi4wNzEsNTBaTTcuODQ3LDQ2LjA2bDcuMzkzLTcuMzkzYS42NDMuNjQzLDAsMCwwLDAtLjkwOWwtLjkwOS0uOTA5YS42NDMuNjQzLDAsMCwwLS45MDksMEw3LjM5Myw0Mi44NzgsNC41NzgsNDAuMDYzYS42NDMuNjQzLDAsMCwwLS45MDksMGwtLjkwOS45MDlhLjY0My42NDMsMCwwLDAsMCwuOTA5TDYuOTM4LDQ2LjA2QS42NDMuNjQzLDAsMCwwLDcuODQ3LDQ2LjA2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3MiAxNTAxKSIgZmlsbD0iIzgzYzkxZSIvPgogICAgPGcgaWQ9IuODkeOCuV81MTUiIGRhdGEtbmFtZT0i44OR44K5IDUxNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3MiAxNTMzKSIgZmlsbD0ibm9uZSI+CiAgICAgIDxwYXRoIGQ9Ik0yLDBIMTZhMiwyLDAsMCwxLDIsMlYxNmEyLDIsMCwwLDEtMiwySDJhMiwyLDAsMCwxLTItMlYyQTIsMiwwLDAsMSwyLDBaIiBzdHJva2U9Im5vbmUiLz4KICAgICAgPHBhdGggZD0iTSAyIDEgQyAxLjQ0ODYwMDc2OTA0Mjk2OSAxIDEgMS40NDg2MDA3NjkwNDI5NjkgMSAyIEwgMSAxNiBDIDEgMTYuNTUxMzk5MjMwOTU3MDMgMS40NDg2MDA3NjkwNDI5NjkgMTcgMiAxNyBMIDE2IDE3IEMgMTYuNTUxMzk5MjMwOTU3MDMgMTcgMTcgMTYuNTUxMzk5MjMwOTU3MDMgMTcgMTYgTCAxNyAyIEMgMTcgMS40NDg2MDA3NjkwNDI5NjkgMTYuNTUxMzk5MjMwOTU3MDMgMSAxNiAxIEwgMiAxIE0gMiAwIEwgMTYgMCBDIDE3LjEwNDU3MDM4ODc5Mzk1IDAgMTggMC44OTU0Mjk2MTEyMDYwNTQ3IDE4IDIgTCAxOCAxNiBDIDE4IDE3LjEwNDU3MDM4ODc5Mzk1IDE3LjEwNDU3MDM4ODc5Mzk1IDE4IDE2IDE4IEwgMiAxOCBDIDAuODk1NDI5NjExMjA2MDU0NyAxOCAwIDE3LjEwNDU3MDM4ODc5Mzk1IDAgMTYgTCAwIDIgQyAwIDAuODk1NDI5NjExMjA2MDU0NyAwLjg5NTQyOTYxMTIwNjA1NDcgMCAyIDAgWiIgc3Ryb2tlPSJub25lIiBmaWxsPSIjMzMzIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "8RLt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8XLC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9odj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2hldnJvbi1jaXJjbGUtZG93bi1saWdodCIgZD0iTTE4LDhBMTAsMTAsMCwxLDAsMjgsMTgsMTAsMTAsMCwwLDAsMTgsOFptOC43MSwxMEE4LjcxLDguNzEsMCwxLDEsMTgsOS4yOSw4LjcwOSw4LjcwOSwwLDAsMSwyNi43MSwxOFptLTguMzY3LDMuNDkyLDQuNjM3LTQuNjQxYS40ODQuNDg0LDAsMCwwLDAtLjY4NWwtLjI4Ni0uMjg2YS40ODQuNDg0LDAsMCwwLS42ODUsMEwxOCwxOS45bC00LjAxMi00LjAxMmEuNDg0LjQ4NCwwLDAsMC0uNjg1LDBsLS4yODYuMjg2YS40ODQuNDg0LDAsMCwwLDAsLjY4NUwxNy42NTMsMjEuNUEuNDkzLjQ5MywwLDAsMCwxOC4zNDMsMjEuNDkyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjggMjgpIHJvdGF0ZSgxODApIiBmaWxsPSIjMDAzNjc5Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "9yb4":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDQyIDE2Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzIwMzMiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDIwMzMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xODQ2MSAtNjI2MSkiPgogICAgPGcgaWQ9IuOCsOODq+ODvOODl18yMDE4IiBkYXRhLW5hbWU9IuOCsOODq+ODvOODlyAyMDE4Ij4KICAgICAgPGxpbmUgaWQ9Iue3ml8xOTUiIGRhdGEtbmFtZT0i57eaIDE5NSIgeDI9IjEyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxODQ3Ni41IDYyNjkuNSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZhM2QzZCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICAgIDxnIGlkPSLmpZXlhoblvaJfMTA3IiBkYXRhLW5hbWU9IualleWGhuW9oiAxMDciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NDg3IDYyNjEpIiBmaWxsPSIjZmZmIiBzdHJva2U9IiNhYWEiIHN0cm9rZS13aWR0aD0iMSI+CiAgICAgICAgPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIHN0cm9rZT0ibm9uZSIvPgogICAgICAgIDxjaXJjbGUgY3g9IjgiIGN5PSI4IiByPSI3LjUiIGZpbGw9Im5vbmUiLz4KICAgICAgPC9nPgogICAgICA8Y2lyY2xlIGlkPSLmpZXlhoblvaJfMTA5IiBkYXRhLW5hbWU9IualleWGhuW9oiAxMDkiIGN4PSI4IiBjeT0iOCIgcj0iOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTg0NjEgNjI2MSkiIGZpbGw9IiNmYTNkM2QiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "AJyC":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./checkbox-false.svg": "5Ivo",
	"./radio-false.svg": "z0Pm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AJyC";

/***/ }),

/***/ "BdG8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/switchButton.vue


//
//
//
//
//
//

/* harmony default export */ var switchButton = ({
  props: {
    disabled: Boolean,
    type: String,
    size: String,
    checked: Boolean,
    active: Boolean,
    customStyle: Object
  },
  data: function data() {
    return {
      value: false
    };
  },

  computed: {
    classObject: function classObject() {
      var _ref;

      var type = this.type,
          size = this.size,
          value = this.value,
          active = this.active,
          disabled = this.disabled;

      return _ref = {}, defineProperty_default()(_ref, 'is-' + type, type), defineProperty_default()(_ref, 'is-' + size, size), defineProperty_default()(_ref, 'disabled', disabled), defineProperty_default()(_ref, 'checked', value), defineProperty_default()(_ref, 'active', active), _ref;
    },
    styleObject: function styleObject() {
      var defaultStyle = { cursor: this.disabled ? 'not-allowed' : 'pointer' };
      return extends_default()({}, defaultStyle, this.customStyle || {});
    }
  },
  mounted: function mounted() {
    this.value = this.checked;
  },

  watch: {
    checked: function checked() {
      this.value = this.checked;
    },
    value: function value(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf22a65c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/switchButton.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classObject,style:(_vm.styleObject),attrs:{"id":"switch-button"},on:{"click":function (e) { return _vm.$emit('click', e); }}},[(!_vm.disabled)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],style:(_vm.styleObject),attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.value)?_vm._i(_vm.value,null)>-1:(_vm.value)},on:{"change":function($event){var $$a=_vm.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.value=$$a.concat([$$v]))}else{$$i>-1&&(_vm.value=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.value=$$c}}}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_switchButton = (esExports);
// CONCATENATED MODULE: ./src/components/tool/switchButton.vue
function injectStyle (ssrContext) {
  __webpack_require__("hWQF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  switchButton,
  tool_switchButton,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_switchButton = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C9pW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2lyY2xlLXF1YXJ0ZXJzLXNvbGlkIiBkPSJNMTAsMEExMCwxMCwwLDEsMCwyMCwxMCwxMCwxMCwwLDAsMCwxMCwwWm01LjMsMTUuM0wxMCwxMCw0LjcsMTUuM0E3LjUwNSw3LjUwNSwwLDAsMSw0LjcsNC43TDEwLDEwbDUuMy01LjNhNy41MDcsNy41MDcsMCwwLDEsMCwxMC42MDlaIiBmaWxsPSIjODNjOTFlIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "Cduz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return sortData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dateFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return groupBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return splitBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fileTypeCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return toPriceString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return toDivideNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fixNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return xlsxToJson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return jsonToXlsx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return imageReader; });
/* unused harmony export imageUrlReader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCharLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return subCharString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return copyToClipboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convertNumberCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return htmlencode; });
/* unused harmony export htmldecode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return downloadFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return toFormdata; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_math_log10__ = __webpack_require__("j9JH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray__);













var _this = this;

var sortData = function sortData(arr, keys, orders) {
  if (!arr || !(arr instanceof Array)) {
    return arr;
  }
  if (keys instanceof Object && !(keys instanceof Array) && !(keys instanceof Function)) {
    return arr;
  }
  keys = keys instanceof Array ? keys : [keys];
  orders = orders instanceof Array ? orders : [orders];
  if (keys.length <= 0) {
    return arr;
  }
  var sortBy = function sortBy(keys, orders) {
    return function (o1, o2) {
      var key = keys[0];
      var order = orders[0] !== 'desc' ? 1 : -1;
      var co1 = key instanceof Function ? key(o1, order) : o1[key];
      var co2 = key instanceof Function ? key(o2, order) : o2[key];
      co1 = co1 instanceof Array ? co1.length : co1;
      co2 = co2 instanceof Array ? co2.length : co2;
      if (co1 === null || co1 === undefined || co1 < co2) {
        return -1 * order;
      } else if (co2 === null || co2 === undefined || co1 > co2) {
        return 1 * order;
      } else {
        return keys.length <= 1 ? 0 : sortBy(keys.slice(1), orders.length > 0 ? orders.slice(1) : orders)(o1, o2);
      }
    };
  };
  return [].concat(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray___default()(arr)).sort(sortBy(keys, orders));
};

var dateFormat = function dateFormat(date, fmt) {
  date.setHours(date.getHours() - (date.getTimezoneOffset() - new Date().getTimezoneOffset()) / 60);
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

var groupBy = function groupBy(ary, f) {
  var needKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var groups = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default()(ary), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      var key = needKey ? f(item) : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(f(item));
      groups[key] = groups[key] || [];
      groups[key].push(item);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return needKey ? groups : __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_values___default()(groups);
};

var splitBy = function splitBy(ary, size, key, empty) {
  var result = {};
  for (var i = 0; i < ary.length; i += size) {
    var chunk = ary.slice(i, i + size);
    result[(key || 'TEMP') + (Math.floor(i / size) + 1)] = [].concat(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray___default()(chunk), __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray___default()(empty ? Array(size - chunk.length).fill(empty) : []));
  }
  return key ? result : __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_values___default()(result);
};

var fileTypeCheck = function fileTypeCheck(e, operation, onError) {
  var acceptTypes = e.target.getAttribute('accept');
  acceptTypes = acceptTypes ? acceptTypes.split(',') : null;
  var extension = e.target.getAttribute('extension');
  extension = extension ? extension.split(',') : null;
  var match = function match(arys, s) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default()(arys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var ary = _step2.value;

        var rgx = new RegExp(ary);
        if (rgx.test(s)) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return false;
  };
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default()(e.target.files), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var file = _step3.value;

      var fileType = file.type;
      var fileExtension = file.name.split(/^[^.]*\./)[1];
      if (extension && !match(extension, fileExtension)) {
        e.target.value = '';
        if (onError) {
          onError(e, extension);
        }
        return;
      }
      if (acceptTypes && !match(acceptTypes, fileType)) {
        e.target.value = '';
        if (onError) {
          onError(e, acceptTypes);
        }
        return;
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  operation(e);
};

var toPriceString = function toPriceString(price) {
  return (price + '').split('.').map(function (s) {
    return s.replace(/(?!^)(?=(\d{3})+($|\.))/g, ',');
  }).join('.');
};

var cleanObject = function cleanObject(input) {
  var strictMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var obj = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, input);
  for (var key in obj) {
    if (obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
    if (obj[key] && strictMode) {
      if (obj[key] === '' || obj[key] instanceof Array && !obj[key].length || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(obj[key]) === 'object' && !__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(obj[key]).length && !obj[key].lastModified) {
        delete obj[key];
      }
    }
  }
  return obj;
};

var toDivideNumber = function toDivideNumber(number, base) {
  return number + (base - Math.abs(number) % base) * (number >= 0 ? 1 : -1);
};

var fixNumber = function fixNumber(value, step) {
  var fix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (step && (value || value === 0)) {
    var match = (step + '').match(/\.(.*?)$/);
    var len = match ? match[1].length : (step + '').match(/1e-(\d+)$/)[1];
    len = (len || 0) - -__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_math_log10___default()(fix);
    value = Math.round(value * Math.pow(10, len)) / Math.pow(10, len);
  }
  return value;
};

/* eslint-disable */
var _XLSX = XLSX;
/* eslint-enable */

var xlsxToJson = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(files) {
    var getContent, jsons, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, file;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (files) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return');

          case 2:
            getContent = function getContent(file) {
              return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                var reader = new FileReader();
                reader.onload = function (e) {
                  var data = e.target.result;
                  var wb = _XLSX.read(data, {
                    type: 'binary'
                  });
                  resolve(_XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]));
                };
                reader.readAsBinaryString(file);
              });
            };

            jsons = [];
            _iteratorNormalCompletion4 = true;
            _didIteratorError4 = false;
            _iteratorError4 = undefined;
            _context.prev = 7;
            _iterator4 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default()(files);

          case 9:
            if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
              _context.next = 19;
              break;
            }

            file = _step4.value;
            _context.t0 = jsons;
            _context.next = 14;
            return getContent(file);

          case 14:
            _context.t1 = _context.sent;

            _context.t0.push.call(_context.t0, _context.t1);

          case 16:
            _iteratorNormalCompletion4 = true;
            _context.next = 9;
            break;

          case 19:
            _context.next = 25;
            break;

          case 21:
            _context.prev = 21;
            _context.t2 = _context['catch'](7);
            _didIteratorError4 = true;
            _iteratorError4 = _context.t2;

          case 25:
            _context.prev = 25;
            _context.prev = 26;

            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }

          case 28:
            _context.prev = 28;

            if (!_didIteratorError4) {
              _context.next = 31;
              break;
            }

            throw _iteratorError4;

          case 31:
            return _context.finish(28);

          case 32:
            return _context.finish(25);

          case 33:
            return _context.abrupt('return', jsons);

          case 34:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[7, 21, 25, 33], [26,, 28, 32]]);
  }));

  return function xlsxToJson(_x4) {
    return _ref.apply(this, arguments);
  };
}();

var jsonToXlsx = function jsonToXlsx(datas) {
  var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'excel';
  var sheetname = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'sheet';

  var ws = _XLSX.utils.json_to_sheet(datas);
  var wb = _XLSX.utils.book_new();
  _XLSX.utils.book_append_sheet(wb, ws, sheetname);
  _XLSX.writeFile(wb, filename + '.xlsx');
};

var imageReader = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(files) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dataUrl';
    var maxWidth = arguments[2];
    var maxHeight = arguments[3];

    var getContent, content, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, file;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (files) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt('return');

          case 2:
            getContent = function getContent(file) {
              return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                var reader = new FileReader();
                reader.onload = function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(e) {
                    var dataUrl;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            dataUrl = e.target.result.startsWith('data:image/') ? e.target.result : '';

                            if (!(maxWidth || maxHeight || type === 'blob' || type === 'blobUrl')) {
                              _context2.next = 9;
                              break;
                            }

                            _context2.t0 = resolve;
                            _context2.next = 5;
                            return _this.imageUrlReader([dataUrl], type === 'dataUrl' ? 'blobUrl' : type, maxWidth, maxHeight);

                          case 5:
                            _context2.t1 = _context2.sent;
                            (0, _context2.t0)(_context2.t1);
                            _context2.next = 10;
                            break;

                          case 9:
                            if (type === 'dataUrl') {
                              resolve(dataUrl);
                            } else {
                              resolve('');
                            }

                          case 10:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this);
                  }));

                  return function (_x9) {
                    return _ref3.apply(this, arguments);
                  };
                }();
                reader.readAsDataURL(file);
              });
            };

            content = [];
            _iteratorNormalCompletion5 = true;
            _didIteratorError5 = false;
            _iteratorError5 = undefined;
            _context3.prev = 7;
            _iterator5 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default()(files);

          case 9:
            if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
              _context3.next = 19;
              break;
            }

            file = _step5.value;
            _context3.t0 = content;
            _context3.next = 14;
            return getContent(file);

          case 14:
            _context3.t1 = _context3.sent;

            _context3.t0.push.call(_context3.t0, _context3.t1);

          case 16:
            _iteratorNormalCompletion5 = true;
            _context3.next = 9;
            break;

          case 19:
            _context3.next = 25;
            break;

          case 21:
            _context3.prev = 21;
            _context3.t2 = _context3['catch'](7);
            _didIteratorError5 = true;
            _iteratorError5 = _context3.t2;

          case 25:
            _context3.prev = 25;
            _context3.prev = 26;

            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }

          case 28:
            _context3.prev = 28;

            if (!_didIteratorError5) {
              _context3.next = 31;
              break;
            }

            throw _iteratorError5;

          case 31:
            return _context3.finish(28);

          case 32:
            return _context3.finish(25);

          case 33:
            return _context3.abrupt('return', content);

          case 34:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[7, 21, 25, 33], [26,, 28, 32]]);
  }));

  return function imageReader(_x7) {
    return _ref2.apply(this, arguments);
  };
}();

var imageUrlReader = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(urls) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blobUrl';
    var maxWidth = arguments[2];
    var maxHeight = arguments[3];

    var getContent, content, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, url;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (urls) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt('return');

          case 2:
            getContent = function getContent(url) {
              return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                var img = new Image();
                img.onload = function (e) {
                  var canvas = document.createElement('canvas');
                  var targetWidth = img.width;
                  var targetHeight = img.height;
                  maxWidth = maxWidth || img.width;
                  maxHeight = maxHeight || img.height;
                  if (targetWidth > maxWidth || targetHeight > maxHeight) {
                    if (targetWidth / targetHeight > maxWidth / maxHeight) {
                      targetHeight = Math.round(maxWidth * (targetHeight / targetWidth));
                      targetWidth = maxWidth;
                    } else {
                      targetHeight = maxHeight;
                      targetWidth = Math.round(maxHeight * (targetWidth / targetHeight));
                    }
                  }
                  canvas.width = targetWidth;
                  canvas.height = targetHeight;
                  canvas.getContext('2d').drawImage(img, 0, 0, targetWidth, targetHeight);
                  canvas.toBlob(function (blob) {
                    if (type === 'blobUrl') {
                      resolve(URL.createObjectURL(blob));
                    } else if (type === 'blob') {
                      resolve(blob);
                    }
                  });
                };
                img.setAttribute('crossOrigin', 'Anonymous');
                img.src = url;
              });
            };

            content = [];
            _iteratorNormalCompletion6 = true;
            _didIteratorError6 = false;
            _iteratorError6 = undefined;
            _context4.prev = 7;
            _iterator6 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default()(urls);

          case 9:
            if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
              _context4.next = 19;
              break;
            }

            url = _step6.value;
            _context4.t0 = content;
            _context4.next = 14;
            return getContent(url);

          case 14:
            _context4.t1 = _context4.sent;

            _context4.t0.push.call(_context4.t0, _context4.t1);

          case 16:
            _iteratorNormalCompletion6 = true;
            _context4.next = 9;
            break;

          case 19:
            _context4.next = 25;
            break;

          case 21:
            _context4.prev = 21;
            _context4.t2 = _context4['catch'](7);
            _didIteratorError6 = true;
            _iteratorError6 = _context4.t2;

          case 25:
            _context4.prev = 25;
            _context4.prev = 26;

            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }

          case 28:
            _context4.prev = 28;

            if (!_didIteratorError6) {
              _context4.next = 31;
              break;
            }

            throw _iteratorError6;

          case 31:
            return _context4.finish(28);

          case 32:
            return _context4.finish(25);

          case 33:
            return _context4.abrupt('return', content);

          case 34:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this, [[7, 21, 25, 33], [26,, 28, 32]]);
  }));

  return function imageUrlReader(_x10) {
    return _ref4.apply(this, arguments);
  };
}();

var getCharLength = function getCharLength(str) {
  /* eslint-disable-next-line no-control-regex */
  var arr = str.match(/[^\x00-\xff]/ig);
  return arr == null ? str.length : str.length + arr.length;
  /* eslint-disable-next-line no-control-regex */
};

var subCharString = function subCharString(str, length) {
  /* eslint-disable-next-line no-control-regex */
  return str.replace(/([^\x00-\xff])/ig, '$1ゐ').substring(0, length).replace(/([^\x00-\xff])$/, '').replace(/([^\x00-\xff])ゐ/ig, '$1');
  /* eslint-disable-next-line no-control-regex */
};

var copyToClipboard = function copyToClipboard(value) {
  navigator.clipboard.writeText(value);
};

var convertNumberCount = function convertNumberCount(_count) {
  var split = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var step = arguments[2];
  var lower = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var limit = arguments[4];

  var sizeType = lower ? ['', 'k', 'm', 'b', 't', 'q'] : ['', 'K', 'M', 'B', 'T', 'Q'];
  limit = limit || sizeType.length;
  var type = 0;
  for (; _count > 1000 && type < limit; _count /= 1000, type++) {}
  return fixNumber(_count, step) + split + sizeType[type];
};

var htmlencode = function htmlencode(s) {
  var div = document.createElement('div');
  div.appendChild(document.createTextNode(s));
  return div.innerHTML;
};

var htmldecode = function htmldecode(s) {
  var div = document.createElement('div');
  div.innerHTML = s;
  return div.innerText || div.textContent;
};

var downloadFile = function downloadFile(fileName, urlData, target) {
  var aLink = document.createElement('a');
  if (fileName) {
    aLink.download = fileName;
  }
  if (target) {
    aLink.target = target;
  }
  aLink.href = urlData;
  aLink.click();
};

var toFormdata = function toFormdata(object) {
  var needEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var arrayFix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '[]';

  var formData = new FormData();
  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(object)), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var kv = _step7.value;

      if (needEmpty || kv[1] !== null && kv[1] !== undefined) {
        if (kv[1] instanceof Array) {
          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default()(kv[1]), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var data = _step8.value;

              formData.append(kv[0] + arrayFix, data);
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }
        } else {
          formData.append(kv[0], kv[1]);
        }
      }
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  return formData;
};

/***/ }),

/***/ "D1u2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDI0IDE4Ij4KICA8cGF0aCBpZD0ic2lnbi1vdXQtbGlnaHQiIGQ9Ik0yLjI0OSw2NEg4LjQzNUEuNTY0LjU2NCwwLDAsMSw5LDY0LjU2M3YuMzc1YS41NjQuNTY0LDAsMCwxLS41NjIuNTYzSDIuMjQ5YS43NTIuNzUyLDAsMCwwLS43NS43NXYxMy41YS43NTIuNzUyLDAsMCwwLC43NS43NUg4LjQzNUEuNTY0LjU2NCwwLDAsMSw5LDgxLjA2M3YuMzc1QS41NjQuNTY0LDAsMCwxLDguNDM1LDgySDIuMjQ5QTIuMjUsMi4yNSwwLDAsMSwwLDc5Ljc1VjY2LjI1QTIuMjUsMi4yNSwwLDAsMSwyLjI0OSw2NFptMTMuMDc1LjkxNC0uMzMzLjMzM2EuNTYzLjU2MywwLDAsMCwwLC44TDIxLjE3OCw3Mi4ySDguMDYxYS41NjQuNTY0LDAsMCwwLS41NjIuNTYzdi40NjlhLjU2NC41NjQsMCwwLDAsLjU2Mi41NjNIMjEuMTc4TDE1LDc5Ljk1NmEuNTYzLjU2MywwLDAsMCwwLC44bC4zMzMuMzMzYS41NjMuNTYzLDAsMCwwLC44LDBMMjMuODM1LDczLjRhLjU2My41NjMsMCwwLDAsMC0uOGwtNy43MTQtNy42ODdBLjU2My41NjMsMCwwLDAsMTUuMzI0LDY0LjkxNFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTY0KSIgZmlsbD0iIzAwMzY3OSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "DBs5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");



var config = {
  locale: 'en',
  events: 'input',
  dictionary: {
    en: {
      messages: {
        required: function required(field) {
          return field + ' should not be empty.';
        },
        min: function min(field, args) {
          return field + ' should be at least ' + args + ' alphanumeric characters.';
        },
        max: function max(field, args) {
          return field + ' should be less than ' + args + ' alphanumeric characters.';
        },
        digits: function digits(field, args) {
          return field + ' should be ' + args + ' digit';
        },
        min_value: function min_value(field, args) {
          return field + ' should be at least ' + args;
        },
        max_value: function max_value(field, args) {
          return field + ' should be less than ' + args;
        },
        integer: function integer(field) {
          return field + ' should be integer';
        },
        mimes: function mimes(field, args) {
          return field + ' should be mime ' + args;
        },
        ext: function ext(field, args) {
          return field + ' should be extension ' + args;
        },
        dimensions: function dimensions(field, args) {
          return field + ' should be ' + args;
        },
        regex: function regex(field) {
          return 'The ' + field + ' is incorrect.';
        },
        email: function email() {
          return 'Please enter right email format.';
        },
        confirmed: function confirmed() {
          return 'Password confirmation is incorrect.';
        }
      },
      attributes: {}
    },
    ja: {
      messages: {
        required: function required(field) {
          return field + ' は必須です。';
        },
        min: function min(field, args) {
          return field + ' は ' + args + ' 文字以上の英数字で入力してください。';
        },
        max: function max(field, args) {
          return field + ' は ' + args + ' 文字以下の英数字で入力してください。';
        },
        digits: function digits(field, args) {
          return field + ' は ' + args + ' 桁の数字で入力してください。';
        },
        min_value: function min_value(field, args) {
          return field + ' は ' + args + ' 以上の値を入力してください。';
        },
        max_value: function max_value(field, args) {
          return field + ' は ' + args + ' 以下の値を入力してください。';
        },
        integer: function integer(field) {
          return field + ' は整数で入力してください。';
        },
        mimes: function mimes(field, args) {
          return field + ' は ' + args + ' 形式のファイルを選択してください。';
        },
        ext: function ext(field, args) {
          return field + ' は ' + args + ' 形式のファイルを選択してください。';
        },
        dimensions: function dimensions(field, args) {
          return field + ' は ' + args + ' である必要があります。';
        },
        regex: function regex(field) {
          return field + ' の形式が正しくありません。';
        },
        email: function email() {
          return 'メールアドレスを正しく入力してください。';
        },
        confirmed: function confirmed() {
          return 'パスワードが一致しません。';
        }
      },
      attributes: {}
    }
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* default */], config);

/***/ }),

/***/ "DGt+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/api/config.js
var api_config = __webpack_require__("T452");

// EXTERNAL MODULE: ./src/components/tool/newBorCor.vue + 2 modules
var newBorCor = __webpack_require__("jHy4");

// EXTERNAL MODULE: ./src/components/svg/dataset-annotation-solid.vue + 2 modules
var dataset_annotation_solid = __webpack_require__("4fCP");

// EXTERNAL MODULE: ./src/components/svg/dataset-annotation-admin-solid.vue + 2 modules
var dataset_annotation_admin_solid = __webpack_require__("py3r");

// EXTERNAL MODULE: ./src/mixins/toastMethods.vue + 1 modules
var toastMethods = __webpack_require__("2PDt");

// EXTERNAL MODULE: ./src/constants/global/data.js
var data = __webpack_require__("x2hU");

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dataset/card.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var card = ({
  components: {
    borCor: newBorCor["a" /* default */],
    // svg
    datasetAnnotationSolid: dataset_annotation_solid["a" /* default */],
    datasetAnnotationAdminSolid: dataset_annotation_admin_solid["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    type: {
      type: String,
      default: function _default() {
        return 'default';
      }
    },
    dataset: {
      type: Object,
      required: true
    },
    layoutType: {
      type: String,
      default: function _default() {
        return 'default';
      }
    }
  },
  data: function data() {
    return {
      collapse: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user']), {
    // static
    informationOptions: function informationOptions() {
      var _this = this;

      return ['community', 'share'].includes(this.type) ? [{
        title: this.$t('COMPONENT.dataset.card.information.title.___Create'),
        value: function value(dataset) {
          return Object(util["d" /* dateFormat */])(new Date(dataset.created_at), 'yyyy/MM/dd hh:mm');
        }
      }, {
        title: this.$t('COMPONENT.dataset.card.information.title.___Permission'),
        value: function value(dataset) {
          var permission = data["h" /* datasetPermissionMap */][dataset.dataset_share.permission || dataset.community_permission] || {};
          return '<span style=color:' + permission.color + '>' + _this.$t(permission.title) + '</span>';
        }
      }, {
        title: this.$t('COMPONENT.dataset.card.information.title.___Pipeline'),
        value: function value(dataset) {
          return _this.$t((data["j" /* datasetPipelineMap */][dataset.pipeline] || {}).title);
        }
      }] : [{
        title: this.$t('COMPONENT.dataset.card.information.title.___Create'),
        value: function value(dataset) {
          return Object(util["d" /* dateFormat */])(new Date(dataset.created_at), 'yyyy/MM/dd hh:mm');
        }
      }, {
        title: this.$t('COMPONENT.dataset.card.information.title.___Modified'),
        value: function value(dataset) {
          return Object(util["d" /* dateFormat */])(new Date(dataset.updated_at), 'yyyy/MM/dd hh:mm');
        }
      }, {
        title: this.$t('COMPONENT.dataset.card.information.title.___Samplesize'),
        value: function value(dataset) {
          return Object(util["r" /* toPriceString */])(dataset.sample_size);
        }
      }, {
        title: this.$t('COMPONENT.dataset.card.information.title.___Pipeline'),
        value: function value(dataset) {
          return _this.$t((data["j" /* datasetPipelineMap */][dataset.pipeline] || {}).title);
        }
      }, {
        title: this.$t('COMPONENT.dataset.card.information.title.___Externaldata'),
        value: function value(dataset) {
          return dataset.external_data_included ? _this.$t('COMPONENT.dataset.card.information.value.external_data_included.___Yes') : _this.$t('COMPONENT.dataset.card.information.value.external_data_included.___No');
        }
      }, {
        title: this.$t('COMPONENT.dataset.card.information.title.___Status'),
        value: function value(dataset) {
          var status = data["l" /* datasetStatusMap */][dataset.disabled ? 'disabled' : dataset.state] || {};
          return '<span style=color:' + status.color + '>' + _this.$t(status.title) + '</span>';
        }
      }];
    },

    // global
    getCharLength: function getCharLength() {
      return util["h" /* getCharLength */];
    },
    subCharString: function subCharString() {
      return util["o" /* subCharString */];
    }
  }),
  watch: {
    'dataset.tags.length': function datasetTagsLength() {
      if ((this.$refs['tag-list'] || {}).clientHeight > 24) {
        this.collapse = true;
      }
    }
  },
  mounted: function mounted() {
    if ((this.$refs['tag-list'] || {}).clientHeight > 24) {
      this.collapse = true;
    }
  },

  methods: {
    getPictureUrl: function getPictureUrl(file) {
      var config = this.$ls.get('userInfo');
      return file ? file.url || api_config["a" /* API_ROOT */] + 'global/files/download?file_id=' + file.id + '&class_name=' + file.class_name + '&access_token=' + config['access_token'] : '';
    },
    cardOnClick: function cardOnClick() {
      if (!['default'].includes(this.layoutType)) {
        return;
      }
      if (!['default'].includes(this.type) && ['private', 'basic'].includes(this.dataset.dataset_share.permission || this.dataset.community_permission) && !['supervisor'].includes(this.user.role)) {
        this.addToast('error', this.$t('COMMON.toast.___noPermissionToOpenDataset'));
        return;
      }
      this.$router.push({ name: 'datasetDetail', params: { type: this.type, id: this.dataset.id } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e2129b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dataset/card.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"dataset-card-page col-block width-full",class:[_vm.layoutType, { disabled: ['created', 'failed'].includes(_vm.dataset.state) || _vm.dataset.disabled, archived: _vm.dataset.dataset_config.archived }],on:{"click":function($event){$event.stopPropagation();return (function (e) { return _vm.cardOnClick(); })($event)}}},[_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"card-title-container row-block flex-start"},[_c('div',{staticClass:"card-title-block row-block flex-start",style:({ flex: 1 })},[_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"card-title",style:({ flex: 1 })},[_vm._v(_vm._s(_vm.subCharString(_vm.dataset.name, (['community', 'share'].includes(_vm.type) ? 60 : 75)) + (_vm.getCharLength(_vm.dataset.name) > (['community', 'share'].includes(_vm.type) ? 60 : 75) ? '...' : '')))])]),_vm._v(" "),(['community', 'share'].includes(_vm.type))?_c('div',{staticClass:"card-picture-field row-block flex-start"},[_c('div',{staticClass:"card-picture-container col-block flex-end",style:({ width: '116px' })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"card-picture-block col-block width-full"},[_c('div',{staticClass:"card-picture",style:({ 'background-image': 'url(' + (_vm.getPictureUrl(_vm.dataset.dataset_picture_file) || __webpack_require__("GW3Y")) + ')' })})])]),_vm._v(" "),_c('div',{style:({ width: '20px' })})]):_c('div',{staticClass:"card-option-container col-block",style:({ width: '40px' })},[_c('div',{staticClass:"icon-list col-block"},[(['supervisor'].includes(_vm.user.role) && _vm.dataset.as_admin_annotation)?_c('div',{staticClass:"annotation-icon admin icon-block",style:({ '--size': '40px' }),attrs:{"title":''}},[_c('datasetAnnotationAdminSolid',{attrs:{"color":'#F8C600'}})],1):_vm._e(),_vm._v(" "),((_vm.dataset.as_private_annotation || _vm.dataset.as_external_annotation) && (_vm.dataset.user || {}).email === _vm.user.email)?_c('div',{staticClass:"annotation-icon icon-block",style:({ '--size': '40px' })},[_c('borCor',{attrs:{"reverse":true,"background":'white',"border":'#CCCCCC',"radius":'0px',"blockStyle":{
              padding: '10px'
            }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('datasetAnnotationSolid',{attrs:{"color":_vm.dataset.as_private_annotation ? '#003679' : _vm.dataset.as_external_annotation ? '#349CCF' : 'transparent'}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{domProps:{"innerHTML":_vm._s((_vm.dataset.as_private_annotation ? [
                  _vm.$t('COMPONENT.dataset.card.annotation.default.___info01'),
                  _vm.$t('COMPONENT.dataset.card.annotation.default.___info02')
                ]
                : _vm.dataset.as_external_annotation ? [
                  _vm.$t('COMPONENT.dataset.card.annotation.community.___info01'),
                  _vm.$t('COMPONENT.dataset.card.annotation.community.___info02')
                ]
                : []).join('<br>'))}})])])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"status-icon icon-block",style:({ '--size': '40px', cursor: 'default' })},[_c('img',{attrs:{"src":(['created', 'failed'].includes(_vm.dataset.state) || _vm.dataset.disabled) ? __webpack_require__("z3W2") : __webpack_require__("KWcF"),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"card-main-container col-block width-full"},[_c('div',{staticClass:"card-information-list-container row-block flex-start flex-wrap"},_vm._l((_vm.informationOptions),function(option,index){return _c('div',{key:index,staticClass:"card-information-container col-block width-full",style:({ width: '33.33%' })},[_c('div',{staticClass:"card-information-block col-block flex-start"},[_c('div',{staticClass:"card-information-title"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),_c('div',{staticClass:"card-information-content",domProps:{"innerHTML":_vm._s(option.value(_vm.dataset))}})])])}),0),_vm._v(" "),_c('div',{staticClass:"card-description-container"},[_c('div',{staticClass:"card-description-block col-block flex-start"},[_c('div',{staticClass:"card-description-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.dataset.card.information.title.___Description')))]),_vm._v(" "),_c('div',{staticClass:"card-description-content"},[_vm._v(_vm._s(_vm.dataset.description ? _vm.subCharString(_vm.dataset.description, 240) + (_vm.getCharLength(_vm.dataset.description) > 240 ? '...' : '') : '- -'))])])]),_vm._v(" "),(['community'].includes(_vm.type))?_c('div',{staticClass:"card-owner-main-container row-block flex-start"},[_c('div',{staticClass:"card-owner-container",style:({ flex: 1 })},[_c('div',{staticClass:"card-owner-block col-block flex-start"},[_c('div',{staticClass:"card-owner-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.dataset.card.information.title.___Owner')))]),_vm._v(" "),_c('div',{staticClass:"card-owner-content",domProps:{"innerHTML":_vm._s([
              [_vm.dataset.user.first_name, _vm.dataset.user.last_name].filter(function (x) { return x; }).join(' ') + (_vm.dataset.user.organization || _vm.dataset.user.division ? ' (' + [_vm.dataset.user.organization, _vm.dataset.user.division].filter(function (x) { return x; }).join(' ') + ')' : ''),
              _vm.dataset.user.email
            ].join('\n'))}})])]),_vm._v(" "),_c('div',{staticClass:"card-owner-avatar",style:({ 'background-image': 'url(' + (_vm.getPictureUrl(_vm.dataset.user.avatar) || __webpack_require__("GW3Y")) + ')' })})]):_vm._e(),_vm._v(" "),(_vm.dataset.tags.length)?_c('div',{staticClass:"card-tag-container",class:{ collapsable: ['default'].includes(_vm.layoutType) && ![null, undefined].includes(_vm.collapse), collapse: ['default'].includes(_vm.layoutType) && _vm.collapse }},[_c('div',{staticClass:"card-tag-block col-block flex-start"},[_c('div',{staticClass:"card-tag-title-container row-block"},[_c('a',{staticClass:"card-tag-title-block row-block",on:{"click":function($event){$event.stopPropagation();return (function (e) { return ['default'].includes(_vm.layoutType) && (_vm.collapse = { true: false, false: true }[_vm.collapse + '']); })($event)}}},[_c('div',{staticClass:"card-tag-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.dataset.card.information.title.___Tags')))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"card-tag-collapse-icon icon-block",style:({ '--size': '20px' })},[_c('img',{attrs:{"src":__webpack_require__("bCWW"),"alt":""}})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"card-tag-list-container width-full"},[_c('div',{ref:"tag-list",staticClass:"card-tag-list-block row-block flex-start flex-wrap"},_vm._l((_vm.dataset.tags),function(tag,index){return _c('div',{key:index,staticClass:"card-tag-block row-block",attrs:{"title":tag}},[_c('div',{staticClass:"card-tag-title"},[_vm._v(_vm._s(tag))])])}),0)])])]):_vm._e()]),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{style:({ height: '20px' })})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dataset_card = (esExports);
// CONCATENATED MODULE: ./src/components/dataset/card.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  card,
  dataset_card,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_dataset_card = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E4co":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/responsitive.vue

/* harmony default export */ var responsitive = ({
  data: function data() {
    return {
      windowWidth: 0,
      windowHeight: 0,
      scrollbarSize: 0
    };
  },

  computed: {
    isMobile: function isMobile() {
      return this.windowWidth <= 699.9;
    }
  },
  created: function created() {
    var _this = this;

    var handler = function handler() {
      _this.windowWidth = window.innerWidth;
      _this.windowHeight = window.innerHeight;
    };
    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
    window.dispatchEvent(new Event('resize'));
  },
  mounted: function mounted() {
    var scrollBox = document.getElementById('scroll-box');
    this.scrollbarSize = scrollBox.offsetWidth - scrollBox.clientWidth;
  }
});
// CONCATENATED MODULE: ./src/mixins/responsitive.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  responsitive,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_responsitive = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ew9o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F9Jn":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "FUqK":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Fg3B":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICA8cGF0aCBpZD0idGltZXMtY2lyY2xlLXNvbGlkIiBkPSJNMTUsOGE3LDcsMCwxLDAsNyw3QTcsNywwLDAsMCwxNSw4Wm0zLjQzMiw4LjgzN2EuMzM5LjMzOSwwLDAsMSwwLC40OGwtMS4xMTgsMS4xMTVhLjMzOS4zMzksMCwwLDEtLjQ4LDBMMTUsMTYuNTgxbC0xLjgzNywxLjg1MmEuMzM5LjMzOSwwLDAsMS0uNDgsMGwtMS4xMTUtMS4xMThhLjMzOS4zMzksMCwwLDEsMC0uNDhMMTMuNDE5LDE1bC0xLjg1Mi0xLjgzN2EuMzM5LjMzOSwwLDAsMSwwLS40OGwxLjExOC0xLjExOGEuMzM5LjMzOSwwLDAsMSwuNDgsMEwxNSwxMy40MTlsMS44MzctMS44NTJhLjMzOS4zMzksMCwwLDEsLjQ4LDBsMS4xMTgsMS4xMThhLjMzOS4zMzksMCwwLDEsMCwuNDhMMTYuNTgxLDE1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTggLTgpIiBmaWxsPSIjZmEzZDNkIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "Fqd/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),

/***/ "GFlx":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICA8cGF0aCBpZD0ibWludXMtY2lyY2xlLXNvbGlkIiBkPSJNMTUsOGE3LDcsMCwxLDAsNyw3QTcsNywwLDAsMCwxNSw4Wm0tMy43MjYsOC4xMjlhLjM0LjM0LDAsMCwxLS4zMzktLjMzOVYxNC4yMWEuMzQuMzQsMCwwLDEsLjMzOS0uMzM5aDcuNDUyYS4zNC4zNCwwLDAsMSwuMzM5LjMzOVYxNS43OWEuMzQuMzQsMCwwLDEtLjMzOS4zMzlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOCAtOCkiIGZpbGw9IiNmYTNkM2QiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "GW3Y":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzEzMTAiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDEzMTAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzU4IDEzMykiPgogICAgPHJlY3QgaWQ9IumVt+aWueW9ol8xMjU2IiBkYXRhLW5hbWU9IumVt+aWueW9oiAxMjU2IiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHJ4PSIyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM1OCAtMTMzKSIgZmlsbD0iI2NmZWNmZiIgb3BhY2l0eT0iMC45OTkiLz4KICAgIDxwYXRoIGlkPSJ1c2VyLWxpZ2h0IiBkPSJNMTIuNiwxMS4yNWMtMS4xNTMsMC0xLjcwOC42MjUtMy42LjYyNXMtMi40NDMtLjYyNS0zLjYtLjYyNUE1LjMyOCw1LjMyOCwwLDAsMCwwLDE2LjV2MS42MjVBMS45LDEuOSwwLDAsMCwxLjkyOSwyMEgxNi4wNzFBMS45LDEuOSwwLDAsMCwxOCwxOC4xMjVWMTYuNUE1LjMyOCw1LjMyOCwwLDAsMCwxMi42LDExLjI1Wm00LjExNCw2Ljg3NWEuNjM2LjYzNiwwLDAsMS0uNjQzLjYyNUgxLjkyOWEuNjM2LjYzNiwwLDAsMS0uNjQzLS42MjVWMTYuNWE0LjA2MSw0LjA2MSwwLDAsMSw0LjExNC00Yy43ODgsMCwxLjU3MS42MjUsMy42LjYyNXMyLjgxMy0uNjI1LDMuNi0uNjI1YTQuMDYxLDQuMDYxLDAsMCwxLDQuMTE0LDRaTTksMTBhNS4wNzMsNS4wNzMsMCwwLDAsNS4xNDMtNUE1LjA3Myw1LjA3MywwLDAsMCw5LDAsNS4wNzMsNS4wNzMsMCwwLDAsMy44NTcsNSw1LjA3Myw1LjA3MywwLDAsMCw5LDEwWk05LDEuMjVBMy44MTEsMy44MTEsMCwwLDEsMTIuODU3LDUsMy44MTEsMy44MTEsMCwwLDEsOSw4Ljc1LDMuODExLDMuODExLDAsMCwxLDUuMTQzLDUsMy44MTEsMy44MTEsMCwwLDEsOSwxLjI1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM2OSAtMTIzKSIgZmlsbD0iIzAwMzY3OSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "GljU":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzEyMTUiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDEyMTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNTQ2NyAzMjcwKSI+CiAgICA8cmVjdCBpZD0i6ZW35pa55b2iXzEyMzgiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDEyMzgiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTU0NjcgLTMyNzApIiBmaWxsPSIjZmZmIi8+CiAgICA8cGF0aCBpZD0iZmlsZS1hbHQtbGlnaHQiIGQ9Ik0xMS41NTcsMi45NjIsOC45MzYuMzQxQTEuNSwxLjUsMCwwLDAsNy44NzctLjFIMS41QTEuNSwxLjUsMCwwLDAsMCwxLjR2MTNhMS41LDEuNSwwLDAsMCwxLjUsMS41aDlBMS41LDEuNSwwLDAsMCwxMiwxNC40VjQuMDI0YTEuNTA3LDEuNTA3LDAsMCwwLS40NDEtMS4wNjJabS0uNzA2LjcwOWEuNDkyLjQ5MiwwLDAsMSwuMTMxLjIzMUg4Vi45MTlhLjQ5Mi40OTIsMCwwLDEsLjIzMS4xMzFaTTEwLjUsMTQuOWgtOWEuNS41LDAsMCwxLS41LS41VjEuNEEuNS41LDAsMCwxLDEuNS45SDdWNC4xNTJhLjc0OC43NDgsMCwwLDAsLjc1Ljc1SDExdjkuNUEuNS41LDAsMCwxLDEwLjUsMTQuOVpNOSw3LjI3N3YuMjVhLjM3Ni4zNzYsMCwwLDEtLjM3NS4zNzVIMy4zNzRBLjM3Ni4zNzYsMCwwLDEsMyw3LjUyN3YtLjI1QS4zNzYuMzc2LDAsMCwxLDMuMzc0LDYuOUg4LjYyM0EuMzc2LjM3NiwwLDAsMSw5LDcuMjc3Wm0wLDJ2LjI1YS4zNzYuMzc2LDAsMCwxLS4zNzUuMzc1SDMuMzc0QS4zNzYuMzc2LDAsMCwxLDMsOS41MjZ2LS4yNUEuMzc2LjM3NiwwLDAsMSwzLjM3NCw4LjlIOC42MjNBLjM3Ni4zNzYsMCwwLDEsOSw5LjI3NlptMCwydi4yNWEuMzc2LjM3NiwwLDAsMS0uMzc1LjM3NUgzLjM3NEEuMzc2LjM3NiwwLDAsMSwzLDExLjUyNnYtLjI1YS4zNzYuMzc2LDAsMCwxLC4zNzUtLjM3NUg4LjYyM0EuMzc2LjM3NiwwLDAsMSw5LDExLjI3NloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1NDcxIC0zMjY3LjkpIiBmaWxsPSIjMDAzNjc5Ii8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "H3ds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/geneTag.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var geneTag = ({
  props: {
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    init: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    tagWidth: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    tagHeight: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    title: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    dataInfo: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    genes: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    placeholder: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    noFocus: {
      type: Boolean,
      default: false
    },
    needFilter: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      content: '',
      tagIndex: 0,
      filter: 'all',
      onCompelete: false,
      focus: false,
      mouse: false,
      display: false,
      displayTagFilter: false
    };
  },

  computed: {
    filtedGenes: function filtedGenes() {
      return Object(util["i" /* groupBy */])(this.genes, function (gene) {
        return gene.type;
      }, true);
    },
    currentGenes: function currentGenes() {
      var _this = this;

      return this.typeList.reduce(function (result, type) {
        return [].concat(toConsumableArray_default()(result), toConsumableArray_default()(_this.filtedGenes[type] || []));
      }, []);
    },
    currentFilter: function currentFilter() {
      var _this2 = this;

      return this.filterOptions.find(function (option) {
        return option.value === _this2.filter;
      });
    },

    // static
    typeList: function typeList() {
      return this.filter === 'all' ? ['gene', 'panel', 'hpo', 'condition', 'pathway'] : [this.filter];
    },
    filterOptions: function filterOptions() {
      return [{
        title: this.$t('COMPONENT.tool.geneTag.title.___all'),
        value: 'all'
      }, {
        title: this.$t('COMPONENT.tool.geneTag.title.___gene'),
        value: 'gene'
      }, {
        title: this.$t('COMPONENT.tool.geneTag.title.___panel'),
        value: 'panel'
      }, {
        title: this.$t('COMPONENT.tool.geneTag.title.___condition'),
        value: 'condition'
      }, {
        title: this.$t('COMPONENT.tool.geneTag.title.___pathway'),
        value: 'pathway'
      }];
    }
  },
  watch: {
    'init': function init() {
      if (this.content !== this.init) {
        this.content = this.init;
      }
    },
    'focus': function focus() {
      this.display = this.focus || this.mouse;
    }
  },
  created: function created() {
    if (this.content !== this.init) {
      this.content = this.init;
    }
  },

  methods: {
    commentOnInput: function commentOnInput(compelete) {
      compelete && (this.onCompelete = false);
      this.tagIndex = 0;
      this.$emit('input', this.content);
    },
    moveTagIndex: function moveTagIndex(type) {
      switch (type) {
        case 'up':
          {
            this.tagIndex = (this.tagIndex - -this.currentGenes.length - 1) % this.currentGenes.length;
            break;
          }
        case 'down':
          {
            this.tagIndex = (this.tagIndex - -1) % this.currentGenes.length;
            break;
          }
      }
      this.$refs['tag-block'].scrollTop = 28 * this.tagIndex;
    },
    commentTag: function commentTag() {
      var curTag = this.currentGenes[this.tagIndex];
      this.onCompelete = true;
      this.content = curTag.name;
      this.$emit('tag', curTag);
      this.commentOnInput();
      !this.noFocus && this.$refs['comment-input'].focus();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e212f0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/geneTag.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-block",attrs:{"id":"gene-tag-container"},on:{"mouseenter":function (e) { return _vm.mouse = true; },"mouseleave":function (e) { return _vm.mouse = false; }}},[_c('div',{staticClass:"gene-tag-block col-block width-full"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],ref:"comment-input",attrs:{"type":"text","disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":(_vm.content)},on:{"focus":function (e) { return _vm.focus = true; },"blur":function (e) { return _vm.focus = false; },"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.moveTagIndex('up'); })($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.moveTagIndex('down'); })($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.genes.length <= 1 ? _vm.$emit('send', _vm.content) : _vm.commentTag(); })($event)}],"input":[function($event){if($event.target.composing){ return; }_vm.content=$event.target.value},function (e) { return _vm.commentOnInput(true); }],"change":function (e) { return _vm.$emit('change', _vm.content); }}}),_vm._v(" "),(_vm.needFilter)?_c('div',{staticClass:"gene-tag-filter-field block col-block"},[_c('div',{staticClass:"gene-tag-filter-container block col-block"},[_c('div',{staticClass:"block-content"},[_c('div',{staticClass:"display-icon center-block",class:{ active: _vm.displayTagFilter },on:{"click":function (e) { return _vm.displayTagFilter = !_vm.displayTagFilter; }}},[_c('img',{attrs:{"src":__webpack_require__("0Pmj"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"block-title-container row-block"},[_c('div',{staticClass:"block-title",style:(!_vm.displayTagFilter ? { color: '#777777' } : {})},[_vm._v(_vm._s(_vm.$t('COMPONENT.tool.geneTag.___filterTitle') + (!_vm.displayTagFilter ? (': ' + _vm.currentFilter.title.toLowerCase()) : '')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.displayTagFilter),expression:"displayTagFilter"}],staticClass:"gene-tag-filter-block block-content col-block width-full"},[_c('div',{staticClass:"gene-tag-filter-content-list-container row-block flex-wrap"},[_vm._l((_vm.filterOptions),function(option,oindex){return _c('div',{key:oindex,staticClass:"gene-tag-filter-content-container row-block",on:{"click":function (e) { return (_vm.filter = option.value); }}},[_c('img',{attrs:{"src":_vm.filter === option.value ? __webpack_require__("xccc") : __webpack_require__("z0Pm"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"gene-tag-filter-content-title"},[_vm._v(_vm._s(option.title))])])}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)])])])]):_vm._e()]),_vm._v(" "),(_vm.genes && !_vm.onCompelete && _vm.display && _vm.content)?_c('div',{staticClass:"input-tag",style:(_vm.tagWidth ? { 'min-width': _vm.tagWidth } : {})},[_c('div',{staticClass:"tag-block"},[(_vm.typeList.reduce(function (count, type) { return count + (_vm.filtedGenes[type] || []).length; }, 0) > 0)?[(_vm.dataInfo && (_vm.typeList.some(function (type) { return _vm.dataInfo[type]; })))?_c('div',{staticClass:"tag-info-container"},[_c('div',{staticClass:"tag-info-block"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.typeList.map(function (type) { return ((_vm.dataInfo[type] || {}).displayed ? (_vm.dataInfo[type].displayed + '/' + _vm.dataInfo[type].total + ' ' + _vm.$t('COMPONENT.tool.geneTag.info.___' + type)) : ''); }).filter(function (x) { return x; }).join(', ').replace(/,(?!.*,)/, ', ' + _vm.$t('COMPONENT.tool.geneTag.info.___and')) + '.')}})])]):_vm._e(),_vm._v(" "),_c('div',{ref:"tag-block",staticClass:"tag-group-container",style:(_vm.tagHeight ? { 'max-height': _vm.tagHeight } : {})},_vm._l((_vm.typeList.filter(function (type) { return (_vm.filtedGenes[type] || []).length; })),function(type,tindex){return _c('div',{key:tindex,staticClass:"tag-group-block"},[(_vm.title)?_c('div',{staticClass:"tag-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.tool.geneTag.title.___' + type)))]):_vm._e(),_vm._v(" "),_vm._l((_vm.filtedGenes[type]),function(tag,index){return _c('div',{key:index,staticClass:"tag",class:{ selected: _vm.tagIndex === (index + _vm.typeList.slice(0, _vm.typeList.indexOf(type)).reduce(function (value, type) { return value + (_vm.filtedGenes[type] || []).length; }, 0)) },on:{"mousemove":function (e) { return _vm.tagIndex = (index + _vm.typeList.slice(0, _vm.typeList.indexOf(type)).reduce(function (value, type) { return value + (_vm.filtedGenes[type] || []).length; }, 0)); },"click":function($event){_vm.commentTag()}}},[_c('span',{domProps:{"innerHTML":_vm._s(tag.name.replace(new RegExp(_vm.content, 'ig'), function (m) { return '<span class=\'key\'>' + m + '</span>'; }))}}),_vm._v(" "),(tag.gene_count)?_c('span',{domProps:{"innerHTML":_vm._s('<span style=color:#FA3D3D> (' + tag.gene_count + ' gene' + (tag.gene_count > 1 ? 's' : '') + ')</span>')}}):_vm._e()])})],2)}),0)]:[_c('div',{staticClass:"tab-empty"},[_vm._v(_vm._s(_vm.$t('COMPONENT.tool.geneTag.___empty')))])]],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_geneTag = (esExports);
// CONCATENATED MODULE: ./src/components/tool/geneTag.vue
function injectStyle (ssrContext) {
  __webpack_require__("o5Lq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  geneTag,
  tool_geneTag,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_geneTag = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HALv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/borCor.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var borCor = ({
  props: {
    type: {
      type: String,
      default: function _default() {
        return 'bottom';
      }
    },
    reverse: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    arrow: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    alwaysDisplay: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // style
    width: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    background: {
      type: String,
      default: function _default() {
        return '#f3f3f3';
      }
    },
    border: {
      type: String,
      default: function _default() {
        return '#aaaaaa';
      }
    },
    radius: {
      type: String,
      default: function _default() {
        return '3px';
      }
    },
    shadow: {
      type: String,
      default: function _default() {
        return '0px 0px 0px transparent';
      }
    },
    blockStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    menuBlockStyle: function menuBlockStyle() {
      var style = {
        width: this.width || 'auto',
        'white-space': this.width ? 'pre-line' : 'nowrap',
        '--bg-color': this.background,
        '--bd-color': this.border,
        '--br-value': this.radius
      };
      return extends_default()({}, style, this.blockStyle);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6404d823","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/borCor.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bor-cor",class:{ 'no-arrow': !_vm.arrow }},[_c('div',{staticClass:"trigger",class:{ 'always-display': _vm.alwaysDisplay }},[_vm._t("trigger")],2),_vm._v(" "),(!_vm.disabled)?_c('div',{staticClass:"menu-container",class:[_vm.type, { reverse: _vm.reverse }],style:({ '--sd-style': _vm.shadow })},[_c('div',{staticClass:"menu-block default-shadow",style:(_vm.menuBlockStyle)},[_vm._t("content")],2),_vm._v(" "),_c('span',{staticClass:"cursor-bor-cor"}),_vm._v(" "),(_vm.arrow)?[_c('span',{staticClass:"menu-bor-cor shadow-top",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-left",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-right",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor",style:({ '--bg-color': _vm.background })})]:_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_borCor = (esExports);
// CONCATENATED MODULE: ./src/components/tool/borCor.vue
function injectStyle (ssrContext) {
  __webpack_require__("Ew9o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  borCor,
  tool_borCor,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_borCor = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HCbd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/case/errorMessage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var errorMessage = ({
  props: {
    caseState: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    project: {
      type: Object,
      default: function _default() {}
    },
    minHeight: {
      type: String,
      required: true
    },
    customContent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f914a6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/errorMessage.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-error-message-page col-block",style:({ 'min-height': '200px' })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"message-title",class:[_vm.project.state.replace('created', '') || _vm.caseState, { error: _vm.project.error }],style:(_vm.customContent.style || {}),domProps:{"innerHTML":_vm._s(_vm.customContent.text || ({
      uploading: [
        _vm.$t('COMPONENT.case.errorMessage.___uploading')
      ],
      analyzing: [
        _vm.$t('COMPONENT.case.errorMessage.___analyzing')
      ],
      started: [
        _vm.$t('COMPONENT.case.errorMessage.___analyzing')
      ],
      failed: !_vm.project.error ? [
        _vm.$t('COMPONENT.case.errorMessage.___failed01'),
        _vm.$t('COMPONENT.case.errorMessage.___failed02')
      ] : [
        '<span>' + _vm.$t('COMPONENT.case.errorMessage.___failed03') + '<span>',
        _vm.project.error
      ]
    }[_vm.project.state.replace('created', '') || _vm.caseState] || []).join('<br>'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var case_errorMessage = (esExports);
// CONCATENATED MODULE: ./src/components/case/errorMessage.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  errorMessage,
  case_errorMessage,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_case_errorMessage = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HCoM":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICA8ZyBpZD0iSGVyZWRpdGFyeV9DYW5jZXIiIGRhdGEtbmFtZT0iSGVyZWRpdGFyeSBDYW5jZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMTMgLTI4NykiPgogICAgPGcgaWQ9IumVt+aWueW9ol8yOTI2IiBkYXRhLW5hbWU9IumVt+aWueW9oiAyOTI2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTMgMjg3KSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjNzA3MDcwIiBzdHJva2Utd2lkdGg9IjEiIG9wYWNpdHk9IjAiPgogICAgICA8cmVjdCB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjI5IiBoZWlnaHQ9IjI5IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgICA8ZyBpZD0iZG5hLXN2Z3JlcG8tY29tIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTQuNjQ0IDI4Ny4wMDEpIj4KICAgICAgPHBhdGggaWQ9IuODkeOCuV8xMiIgZGF0YS1uYW1lPSLjg5HjgrkgMTIiIGQ9Ik0xMjIuMzU2LDMuODM2VjEuMDk1YTEuMTE5LDEuMTE5LDAsMCwwLTIuMjM4LDBWMi43MzFIMTA2LjU5NFYxLjA5NWExLjExOSwxLjExOSwwLDAsMC0yLjIzOCwwVjMuODM2YzAsNC4yODEsMS43MDksOC45NjksNS4yMzMsMTEuMTY0LTMuNTA2LDIuMTg0LTUuMjMzLDYuODQtNS4yMzMsMTEuMTY0VjI4LjlhMS4xMTksMS4xMTksMCwwLDAsMi4yMzgsMFYyNy4yNjdoMTMuNTI0VjI4LjlhMS4xMTksMS4xMTksMCwwLDAsMi4yMzgsMFYyNi4xNjNjMC00LjI4MS0xLjcwOS04Ljk2OS01LjIzMy0xMS4xNjRDMTIwLjYyOSwxMi44MTUsMTIyLjM1Niw4LjE1OSwxMjIuMzU2LDMuODM2Wm0tMi4yNzgsMS4xYTEzLjY0NywxMy42NDcsMCwwLDEtLjY3MiwzLjM3MmgtMTIuMWExMy42NDgsMTMuNjQ4LDAsMCwxLS42NzItMy4zNzJaTTEwNi42MzQsMjUuMDU4YTEzLjY0OCwxMy42NDgsMCwwLDEsLjY3Mi0zLjM3MmgxMi4xYTEzLjY0OCwxMy42NDgsMCwwLDEsLjY3MiwzLjM3MlptMTEuNzUxLTUuNTgyaC0xMC4wNmMxLjEyMi0xLjg1MiwyLjg2NC0zLjM3Miw1LjAzLTMuMzcyUzExNy4yNjUsMTcuNjI1LDExOC4zODYsMTkuNDc2Wm0tNS4wMy01LjU4MmMtMi4xNjcsMC0zLjkwOS0xLjUyMS01LjAzLTMuMzcyaDEwLjA2QzExNy4yNjQsMTIuMzc0LDExNS41MjIsMTMuODk0LDExMy4zNTYsMTMuODk0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSIgZmlsbD0iI2ZmZiIvPgogICAgICA8cGF0aCBpZD0i44OR44K5XzEzIiBkYXRhLW5hbWU9IuODkeOCuSAxMyIgZD0iTTI2NSwzLjgzNlYxLjA5NWExLjExOSwxLjExOSwwLDAsMC0yLjIzOCwwVjIuNzMxSDI1NlY0Ljk0aDYuNzIyYTEzLjY0NywxMy42NDcsMCwwLDEtLjY3MiwzLjM3MkgyNTZ2Mi4yMDloNS4wM2MtMS4xMjIsMS44NTItMi44NjQsMy4zNzItNS4wMywzLjM3MmgwVjE2LjFoMGMyLjE2NywwLDMuOTA5LDEuNTIxLDUuMDMsMy4zNzJIMjU2djIuMjA5aDYuMDVhMTMuNjQ4LDEzLjY0OCwwLDAsMSwuNjcyLDMuMzcySDI1NnYyLjIwOWg2Ljc2MlYyOC45YTEuMTE5LDEuMTE5LDAsMCwwLDIuMjM4LDBWMjYuMTYzYzAtNC4yODEtMS43MDktOC45NjktNS4yMzMtMTEuMTY0QzI2My4yNjksMTIuODE1LDI2NSw4LjE1OSwyNjUsMy44MzZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTQyLjY0IDApIiBmaWxsPSIjZmZmIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "HSv/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBpZD0iZ2xvYmUtbGlnaHQiIGQ9Ik04LDE1Yy41MjIsMCwxLjI2My0uNDUsMS45MzQtMS43OTFBOS41Miw5LjUyLDAsMCwwLDEwLjY4OCwxMUg1LjMxM2E5LjUyLDkuNTIsMCwwLDAsLjc1MywyLjIwOUM2LjczOCwxNC41NSw3LjQ3OCwxNSw4LDE1Wk01LjEzNCwxMGg1LjczMUExNC42MTUsMTQuNjE1LDAsMCwwLDExLDhhMTQuNjE1LDE0LjYxNSwwLDAsMC0uMTM0LTJINS4xMzRhMTQuOTUxLDE0Ljk1MSwwLDAsMCwwLDRabS4xNzgtNWg1LjM3NWE5LjUyLDkuNTIsMCwwLDAtLjc1My0yLjIwOUM5LjI2MywxLjQ1LDguNTIyLDEsOCwxcy0xLjI2Mi40NS0xLjkzNCwxLjc5MUE5LjUyLDkuNTIsMCwwLDAsNS4zMTMsNVptNi41NjMsMUExNS45MDYsMTUuOTA2LDAsMCwxLDEyLDhhMTUuOTA2LDE1LjkwNiwwLDAsMS0uMTI1LDJoMi44MzhBNy4wNSw3LjA1LDAsMCwwLDE1LDhhNi45NDEsNi45NDEsMCwwLDAtLjI5MS0yWm0yLjQ1My0xYTcuMDEyLDcuMDEyLDAsMCwwLTQuMDkxLTMuNjM0QTkuMjczLDkuMjczLDAsMCwxLDExLjcxMyw1aDIuNjE2Wk00LjI5NCw1QTkuMjUzLDkuMjUzLDAsMCwxLDUuNzY5LDEuMzY2LDcsNywwLDAsMCwxLjY3NSw1SDQuMjk0Wm0tMywxQTcuMDUsNy4wNSwwLDAsMCwxLDhhNi45NDEsNi45NDEsMCwwLDAsLjI5MSwySDQuMTI1YTE2LjA2MywxNi4wNjMsMCwwLDEsMC00SDEuMjkxWm04Ljk0MSw4LjYzNEE3LjAyMiw3LjAyMiwwLDAsMCwxNC4zMjUsMTFIMTEuNzA5QTkuMjUzLDkuMjUzLDAsMCwxLDEwLjIzNCwxNC42MzRabS00LjQ2OSwwQTkuMzIsOS4zMiwwLDAsMSw0LjI5MSwxMUgxLjY3NUE3LjAxMiw3LjAxMiwwLDAsMCw1Ljc2NiwxNC42MzRaTTgsMTZhOCw4LDAsMSwxLDgtOCw4LDgsMCwwLDEtOCw4WiIgZmlsbD0iIzAwMzY3OSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "HZ4l":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Hct3":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNC41IiBoZWlnaHQ9IjE0LjUiIHZpZXdCb3g9IjAgMCAxNC41IDE0LjUiPgogIDxwYXRoIGlkPSJwbHVzLWxpZ2h0IiBkPSJNMTMuNzA4LDcwLjEyNUg3Ljg3NVY2NC4yOTJBLjI5Mi4yOTIsMCwwLDAsNy41ODMsNjRINi40MTdhLjI5Mi4yOTIsMCwwLDAtLjI5Mi4yOTJ2NS44MzNILjI5MkEuMjkyLjI5MiwwLDAsMCwwLDcwLjQxN3YxLjE2N2EuMjkyLjI5MiwwLDAsMCwuMjkyLjI5Mkg2LjEyNXY1LjgzM0EuMjkyLjI5MiwwLDAsMCw2LjQxNyw3OEg3LjU4M2EuMjkyLjI5MiwwLDAsMCwuMjkyLS4yOTJWNzEuODc1aDUuODMzQS4yOTIuMjkyLDAsMCwwLDE0LDcxLjU4M1Y3MC40MTdBLjI5Mi4yOTIsMCwwLDAsMTMuNzA4LDcwLjEyNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMjUgLTYzLjc1KSIgZmlsbD0iIzAwMzY3OSIgc3Ryb2tlPSIjMDAzNjc5IiBzdHJva2Utd2lkdGg9IjAuNSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "IMLV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),

/***/ "Id76":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./checkbox-true.svg": "7kqe",
	"./radio-true.svg": "xccc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Id76";

/***/ }),

/***/ "JYtJ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi41IiBoZWlnaHQ9IjE2LjUiIHZpZXdCb3g9IjAgMCAxNi41IDE2LjUiPgogIDxwYXRoIGlkPSJpbmZvLWNpcmNsZS1saWdodCIgZD0iTTE2LDkuMDMyQTYuOTY4LDYuOTY4LDAsMSwxLDkuMDMyLDE2LDYuOTY5LDYuOTY5LDAsMCwxLDE2LDkuMDMyTTE2LDhhOCw4LDAsMSwwLDgsOEE4LDgsMCwwLDAsMTYsOFpNMTQuODM5LDE5LjFoLjM4N1YxNS4yMjZoLS4zODdhLjM4Ny4zODcsMCwwLDEtLjM4Ny0uMzg3di0uMjU4YS4zODcuMzg3LDAsMCwxLC4zODctLjM4N2gxLjU0OGEuMzg3LjM4NywwLDAsMSwuMzg3LjM4N1YxOS4xaC4zODdhLjM4Ny4zODcsMCwwLDEsLjM4Ny4zODd2LjI1OGEuMzg3LjM4NywwLDAsMS0uMzg3LjM4N0gxNC44MzlhLjM4Ny4zODcsMCwwLDEtLjM4Ny0uMzg3di0uMjU4QS4zODcuMzg3LDAsMCwxLDE0LjgzOSwxOS4xWk0xNiwxMS4zNTVhMS4wMzIsMS4wMzIsMCwxLDAsMS4wMzIsMS4wMzJBMS4wMzIsMS4wMzIsMCwwLDAsMTYsMTEuMzU1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcuNzUgLTcuNzUpIiBmaWxsPSIjZjhjNjAwIiBzdHJva2U9IiNmOGM2MDAiIHN0cm9rZS13aWR0aD0iMC41Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "K1x3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var object_keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(object_keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/api/index.js
var src_api = __webpack_require__("gyMJ");

// EXTERNAL MODULE: ./src/constants/global/config.js
var global_config = __webpack_require__("j9i1");

// EXTERNAL MODULE: ./src/constants/global/data.js
var data = __webpack_require__("x2hU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/licenseManager.vue












/* harmony default export */ var licenseManager = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['userLicense']), {
    // static
    licenseTypeMap: function licenseTypeMap() {
      return {
        'vcf': 'vcf_analysis',
        'fastq': 'fastq_analysis',
        'report': 'report_module'
      };
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUserLicenseAction']), {
    setLicenseStatus: function setLicenseStatus() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var getInfoStatus, getLicenseStatus, status;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getInfoStatus = function getInfoStatus(info) {
                  // if ((info.max_uses >= 0) && (info.usage_count >= info.max_uses)) {
                  //   return 'exceeded'
                  // }
                  // if (!/^1\d{4}-/.test(info.new_expiry_date) && (new Date(info.imported_at) > new Date(info.new_expiry_date))) {
                  //   return 'expired'
                  // }
                  var status = info.status.toLowerCase();
                  return ['exceeded', 'expired'].includes(status) ? status : null;
                };

                getLicenseStatus = function () {
                  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                    var config, response, licenseInformations;
                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!global_config["a" /* _LOCAL_BUILD */]) {
                              _context.next = 15;
                              break;
                            }

                            _context.prev = 1;
                            config = _this.$ls.get('userInfo');
                            _context.next = 5;
                            return Object(src_api["_44" /* getLicenseInformations */])(config);

                          case 5:
                            response = _context.sent;
                            licenseInformations = response.data.data;
                            return _context.abrupt('return', extends_default()({}, licenseInformations.license_api_usage.reduce(function (result, info) {
                              return extends_default()({}, result, defineProperty_default()({}, info.api_name, getInfoStatus(info)));
                            }, {}), {
                              last_verified_today_utc: licenseInformations.last_verified_today_utc || false
                            }));

                          case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](1);
                            return _context.abrupt('return', extends_default()({}, keys_default()(data["C" /* licenseApiMap */]).reduce(function (result, api) {
                              return extends_default()({}, result, defineProperty_default()({}, api, 'invalid'));
                            }, {}), {
                              last_verified_today_utc: false
                            }));

                          case 13:
                            _context.next = 16;
                            break;

                          case 15:
                            return _context.abrupt('return', extends_default()({}, keys_default()(data["C" /* licenseApiMap */]).reduce(function (result, api) {
                              return extends_default()({}, result, defineProperty_default()({}, api, false));
                            }, {}), {
                              last_verified_today_utc: true
                            }));

                          case 16:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this, [[1, 10]]);
                  }));

                  return function getLicenseStatus() {
                    return _ref.apply(this, arguments);
                  };
                }();

                _context2.next = 4;
                return getLicenseStatus();

              case 4:
                status = _context2.sent;

                _this.setUserLicenseAction(status);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    checkLicenseStatus: function checkLicenseStatus(keys) {
      var _this2 = this;

      var getTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return null;
      };
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var failedType, executeMap, types, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, type;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.setLicenseStatus();

              case 2:
                keys = keys instanceof Array ? keys : [keys];
                failedType = keys.find(function (key) {
                  return _this2.userLicense[key];
                });

                if (!failedType) {
                  _context3.next = 32;
                  break;
                }

                executeMap = {
                  'alert': function alert() {
                    var msg = {
                      'exceeded': _this2.$t('COMMON.toast.___licenseExceeded'),
                      'expired': _this2.$t('COMMON.toast.___licenseExpired')
                    }[_this2.userLicense[failedType]] || _this2.$t('COMMON.toast.___licenseInvalid');
                    _this2.addToast('error', msg);
                  },
                  'redirect': function redirect() {
                    _this2.$router.push({ name: 'user', params: { tab: 'license' } });
                  }
                };
                types = getTypes(_this2.userLicense['last_verified_today_utc']) || keys_default()(executeMap);

                if (!types.length) {
                  _context3.next = 29;
                  break;
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 11;

                for (_iterator = get_iterator_default()(types); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  type = _step.value;

                  executeMap[type]();
                }
                _context3.next = 19;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3['catch'](11);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 19:
                _context3.prev = 19;
                _context3.prev = 20;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 22:
                _context3.prev = 22;

                if (!_didIteratorError) {
                  _context3.next = 25;
                  break;
                }

                throw _iteratorError;

              case 25:
                return _context3.finish(22);

              case 26:
                return _context3.finish(19);

              case 27:
                _context3.next = 30;
                break;

              case 29:
                return _context3.abrupt('return', true);

              case 30:
                _context3.next = 33;
                break;

              case 32:
                return _context3.abrupt('return', true);

              case 33:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[11, 15, 19, 27], [20,, 22, 26]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./src/mixins/licenseManager.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  licenseManager,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_licenseManager = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K4Tr":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICA8ZyBpZD0iT3BodGhhbG1vbG9neSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTg1NCAtNzcxKSI+CiAgICA8ZyBpZD0i6ZW35pa55b2iXzI5MjgiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDI5MjgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg1NCA3NzEpIiBmaWxsPSIjZmZmIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS13aWR0aD0iMSIgb3BhY2l0eT0iMCI+CiAgICAgIDxyZWN0IHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgc3Ryb2tlPSJub25lIi8+CiAgICAgIDxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIGZpbGw9Im5vbmUiLz4KICAgIDwvZz4KICAgIDxnIGlkPSJleWUtc3ZncmVwby1jb20iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg1NCA2NjAuODI2KSI+CiAgICAgIDxnIGlkPSLjgrDjg6vjg7zjg5dfNzA4MCIgZGF0YS1uYW1lPSLjgrDjg6vjg7zjg5cgNzA4MCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxMTUuODUzKSI+CiAgICAgICAgPHBhdGggaWQ9IuODkeOCuV8yNyIgZGF0YS1uYW1lPSLjg5HjgrkgMjciIGQ9Ik0yOS44ODMsMTI1LjYzNmEuOTY5Ljk2OSwwLDAsMCwwLS45MjRjLTIuODY2LTUuMjc3LTguNDU2LTkuNTM4LTE0Ljg4My05LjUzOFMyLjk4NCwxMTkuNDM1LjExOCwxMjQuNzEyYS45NjkuOTY5LDAsMCwwLDAsLjkyNGMyLjg2Niw1LjI3Nyw4LjQ1Niw5LjUzOCwxNC44ODMsOS41MzhTMjcuMDE3LDEzMC45MTMsMjkuODgzLDEyNS42MzZaTTE1LDEzMi4zMjRhNy4xNSw3LjE1LDAsMSwxLDcuMTUtNy4xNUE3LjE1LDcuMTUsMCwwLDEsMTUsMTMyLjMyNFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTExNS44NTMpIiBmaWxsPSIjZmZmIi8+CiAgICAgICAgPHBhdGggaWQ9IuODkeOCuV8yOCIgZGF0YS1uYW1lPSLjg5HjgrkgMjgiIGQ9Ik0yMzUuMzEzLDIzMS42N2EzLjY1MiwzLjY1MiwwLDAsMC0uODcyLjEwNSwxLjg5LDEuODksMCwwLDEtMi42NjYsMi42NjYsMy42NDQsMy42NDQsMCwxLDAsMy41MzgtMi43NzFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIwLjMxMyAtMjI1Ljk5MykiIGZpbGw9IiNmZmYiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "K4ph":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzQzNzkiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDQzNzkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yOTIyIC0xOTg2KSI+CiAgICA8cmVjdCBpZD0i6ZW35pa55b2iXzE0OTMiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDE0OTMiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjkyMiAxOTg2KSIgZmlsbD0iI2ZmZiIgb3BhY2l0eT0iMCIvPgogICAgPHBhdGggaWQ9ImNoZXZyb24tZG93bi1yZWd1bGFyIiBkPSJNMTEuMTExLjU4OWwtLjUtLjVhLjMuMywwLDAsMC0uNDMsMEw1LjYsNC42NTYsMS4wMi4wODlhLjMuMywwLDAsMC0uNDMsMGwtLjUuNWEuMy4zLDAsMCwwLDAsLjQzbDUuMyw1LjI5MmEuMy4zLDAsMCwwLC40MywwbDUuMy01LjI5MkEuMy4zLDAsMCwwLDExLjExMS41ODlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOTM1LjMzMyAxOTk3LjIpIHJvdGF0ZSgxODApIiBmaWxsPSIjMDAzNjc5Ii8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "KWcF":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2hlY2stY2lyY2xlLXNvbGlkIiBkPSJNMjgsMThBMTAsMTAsMCwxLDEsMTgsOCwxMCwxMCwwLDAsMSwyOCwxOFpNMTYuODQzLDIzLjI5NWw3LjQxOS03LjQxOWEuNjQ1LjY0NSwwLDAsMCwwLS45MTJsLS45MTItLjkxMmEuNjQ1LjY0NSwwLDAsMC0uOTEyLDBMMTYuMzg3LDIwLjFsLTIuODI1LTIuODI1YS42NDUuNjQ1LDAsMCwwLS45MTIsMGwtLjkxMi45MTJhLjY0NS42NDUsMCwwLDAsMCwuOTEybDQuMTk0LDQuMTk0YS42NDUuNjQ1LDAsMCwwLC45MTIsMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04IC04KSIgZmlsbD0iIzgzYzkxZSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "L+Gk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LNx3":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2lyY2xlLWNoZWNrLXNvbGlkIiBkPSJNMCwxMEExMCwxMCwwLDEsMSwxMCwyMCwxMCwxMCwwLDAsMSwwLDEwWk0xNC41MjMsOC4yNzNhMS4wOTQsMS4wOTQsMCwwLDAtMS41NDctMS41NDdMOC43NSwxMC45NTMsNy4wMjMsOS4yMjdhMS4wOTQsMS4wOTQsMCwwLDAtMS41NDcsMS41NDdsMi41LDIuNWExLjEsMS4xLDAsMCwwLDEuNTQ3LDBaIiBmaWxsPSIjMDA2ZWQ2Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "LRBV":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBpZD0iaW5mby1jaXJjbGUtbGlnaHQiIGQ9Ik0xNiw5LjAzMkE2Ljk2OCw2Ljk2OCwwLDEsMSw5LjAzMiwxNiw2Ljk2OSw2Ljk2OSwwLDAsMSwxNiw5LjAzMk0xNiw4YTgsOCwwLDEsMCw4LDhBOCw4LDAsMCwwLDE2LDhaTTE0LjgzOSwxOS4xaC4zODdWMTUuMjI2aC0uMzg3YS4zODcuMzg3LDAsMCwxLS4zODctLjM4N3YtLjI1OGEuMzg3LjM4NywwLDAsMSwuMzg3LS4zODdoMS41NDhhLjM4Ny4zODcsMCwwLDEsLjM4Ny4zODdWMTkuMWguMzg3YS4zODcuMzg3LDAsMCwxLC4zODcuMzg3di4yNThhLjM4Ny4zODcsMCwwLDEtLjM4Ny4zODdIMTQuODM5YS4zODcuMzg3LDAsMCwxLS4zODctLjM4N3YtLjI1OEEuMzg3LjM4NywwLDAsMSwxNC44MzksMTkuMVpNMTYsMTEuMzU1YTEuMDMyLDEuMDMyLDAsMSwwLDEuMDMyLDEuMDMyQTEuMDMyLDEuMDMyLDAsMCwwLDE2LDExLjM1NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04IC04KSIgZmlsbD0iIzk5OSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "Lem6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0i44Kw44Or44O844OXXzY3ODQiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDY3ODQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIiB2aWV3Qm94PSIwIDAgMzAgMzAiPgogIDxyZWN0IGlkPSLplbfmlrnlvaJfMjc0MSIgZGF0YS1uYW1lPSLplbfmlrnlvaIgMjc0MSIgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIiBmaWxsPSIjZmZmIiBvcGFjaXR5PSIwIi8+CiAgPHBhdGggaWQ9ImNoZXZyb24tZG93bi1yZWd1bGFyIiBkPSJNMTUuODczLjczNywxNS4xNTcuMTExYS40NzkuNDc5LDAsMCwwLS42MTQsMEw4LDUuODIsMS40NTcuMTExYS40NzkuNDc5LDAsMCwwLS42MTQsMEwuMTI3LjczN2EuMzQ3LjM0NywwLDAsMCwwLC41MzdMNy42OTMsNy44ODlhLjQ3OS40NzksMCwwLDAsLjYxNCwwbDcuNTY2LTYuNjE1QS4zNDcuMzQ3LDAsMCwwLDE1Ljg3My43MzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMyAxOSkgcm90YXRlKDE4MCkiIGZpbGw9IiMwMDM2NzkiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "Lkm/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNC45MTQiIHZpZXdCb3g9IjAgMCAyMCAxNC45MTQiPgogIDxwYXRoIGlkPSJjaGVjay1zb2xpZCIgZD0iTTYuNzkzLDc5LjcybC02LjUtNi41YTEsMSwwLDAsMSwwLTEuNDE0bDEuNDE0LTEuNDE0YTEsMSwwLDAsMSwxLjQxNCwwTDcuNSw3NC43N2w5LjM3OS05LjM3OWExLDEsMCwwLDEsMS40MTQsMGwxLjQxNCwxLjQxNGExLDEsMCwwLDEsMCwxLjQxNGwtMTEuNSwxMS41YTEsMSwwLDAsMS0xLjQxNCwwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtNjUuMDk4KSIgZmlsbD0iIzgzYzkxZSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "M0RH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "MVOO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./project-alert-icon.svg": "f65q",
	"./project-analyzing-icon.svg": "C9pW",
	"./project-completed-icon.svg": "LNx3",
	"./project-failed-icon.svg": "Vse0",
	"./project-list-icon.svg": "V8N6",
	"./project-started-icon.svg": "kz4M"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MVOO";

/***/ }),

/***/ "Mq4e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/dataTag.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var dataTag = ({
  props: {
    init: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tagWidth: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    tagHeight: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    needInfo: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    allowEmpty: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    filter: {
      type: Function,
      default: function _default() {
        return null;
      }
    },
    tagDisplay: {
      type: Function,
      default: function _default() {
        return null;
      }
    },
    replace: {
      type: Function,
      default: function _default(x) {
        return x.name;
      }
    },
    placeholder: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    emptyMsg: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      content: '',
      tagIndex: 0,
      onCompelete: false,
      focus: false,
      mouse: false,
      display: false
    };
  },

  computed: {
    filtedDatas: function filtedDatas() {
      return (this.data.items || []).filter(this.filter || function () {
        return true;
      });
    },
    groupedDatas: function groupedDatas() {
      return Object(util["i" /* groupBy */])(this.filtedDatas, function (item) {
        return item.type || 'default';
      }, true);
    },
    types: function types() {
      return keys_default()(this.groupedDatas);
    }
  },
  watch: {
    'init': function init() {
      if (this.content !== this.init) {
        this.content = this.init;
        this.display = false;
        this.commentOnInput(true);
      }
    },
    'focus': function focus() {
      this.display = this.focus || this.mouse;
    }
  },
  created: function created() {
    if (this.content !== this.init) {
      this.content = this.init;
    }
  },

  methods: {
    commentOnInput: function commentOnInput(compelete) {
      compelete && (this.onCompelete = false);
      this.tagIndex = 0;
      this.$emit('input', this.content);
    },
    moveTagIndex: function moveTagIndex(type) {
      switch (type) {
        case 'up':
          {
            this.tagIndex = (this.tagIndex - -this.filtedDatas.length - 1) % this.filtedDatas.length;
            break;
          }
        case 'down':
          {
            this.tagIndex = (this.tagIndex - -1) % this.filtedDatas.length;
            break;
          }
        default:
          {}
      }
      this.$refs['tag-block'].scrollTop = 25.5 * this.tagIndex;
    },
    commentTag: function commentTag() {
      var curTag = this.filtedDatas[this.tagIndex];
      this.onCompelete = true;
      this.content = this.replace(curTag, this.content);
      this.$emit('tag', curTag);
      this.commentOnInput();
      this.$refs['comment-input'].focus();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53a92f49","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/dataTag.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"data-tag-container"},on:{"mouseenter":function (e) { return _vm.mouse = true; },"mouseleave":function (e) { return _vm.mouse = false; }}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],ref:"comment-input",attrs:{"type":"text","disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":(_vm.content)},on:{"focus":function (e) { return _vm.focus = true; },"blur":function (e) { return _vm.focus = false; },"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.moveTagIndex('up'); })($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.moveTagIndex('down'); })($event)}],"keypress":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return (_vm.filtedDatas || []).length < 1 || _vm.onCompelete ? _vm.$emit('send', _vm.content) : _vm.commentTag(); })($event)},"input":[function($event){if($event.target.composing){ return; }_vm.content=$event.target.value},function (e) { return _vm.commentOnInput(true); }],"change":function (e) { return _vm.$emit('change', _vm.content); }}}),_vm._v(" "),(_vm.data.items && !_vm.onCompelete && _vm.display && (_vm.content || _vm.allowEmpty) && (_vm.filtedDatas.length > 0 || _vm.emptyMsg))?_c('div',{staticClass:"data-tag",style:(_vm.tagWidth ? { 'min-width': _vm.tagWidth } : {})},[_c('div',{staticClass:"tag-block"},[(_vm.filtedDatas.length > 0)?[(_vm.needInfo && _vm.data.info && Object.values(_vm.data.info).filter(function (x) { return x; }).length)?_c('div',{staticClass:"tag-info-container"},[_c('div',{staticClass:"tag-info-block"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.types.map(function (type) { return (_vm.data.info[type].displayed ? _vm.data.info[type].displayed + '/' + _vm.data.info[type].total + ' ' + _vm.data.info[type].subTitle + 's' : ''); }).filter(function (x) { return x; }).join(', ').replace(/,(?!.*,)/, ', and') + '.')}})])]):_vm._e(),_vm._v(" "),_c('div',{ref:"tag-block",staticClass:"tag-group-container",style:(_vm.tagHeight ? { 'max-height': _vm.tagHeight } : {})},_vm._l((_vm.types),function(key,index){return _c('div',{key:index,staticClass:"tag-group-block"},[(Object.keys(_vm.groupedDatas).length > 1)?_c('div',{staticClass:"tag-title"},[_vm._v(_vm._s(_vm.data.info ? _vm.data.info[key].title : ''))]):_vm._e(),_vm._v(" "),_vm._l((_vm.groupedDatas[key]),function(tag,tindex){return _c('div',{key:tindex - -_vm.types.slice(0, index).reduce(function (s, type) { return s + (_vm.groupedDatas[type] || []).length; }, 0),staticClass:"tag",class:{ selected: _vm.tagIndex === tindex - -_vm.types.slice(0, index).reduce(function (s, type) { return s + (_vm.groupedDatas[type] || []).length; }, 0) },on:{"mousemove":function (e) { return _vm.tagIndex = tindex - -_vm.types.slice(0, index).reduce(function (s, type) { return s + (_vm.groupedDatas[type] || []).length; }, 0); },"click":function($event){_vm.commentTag()}}},[_c('span',{domProps:{"innerHTML":_vm._s((_vm.tagDisplay || (function (tag) { return tag.name; }))(tag).replace(new RegExp(_vm.content, 'ig'), function (m) { return '<span class=\'key\'>' + m + '</span>'; }))}})])})],2)}),0)]:[_c('div',{staticClass:"tab-empty"},[_vm._v(_vm._s(_vm.emptyMsg))])]],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_dataTag = (esExports);
// CONCATENATED MODULE: ./src/components/tool/dataTag.vue
function injectStyle (ssrContext) {
  __webpack_require__("VKZL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  dataTag,
  tool_dataTag,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_dataTag = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MsWW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTcuODU3LDUySDIuMTQzQTIuMTQzLDIuMTQzLDAsMCwxLDAsNDkuODU3VjM0LjE0M0EyLjE0MywyLjE0MywwLDAsMSwyLjE0MywzMkgxNy44NTdBMi4xNDMsMi4xNDMsMCwwLDEsMjAsMzQuMTQzVjQ5Ljg1N0EyLjE0MywyLjE0MywwLDAsMSwxNy44NTcsNTJaTTguNzE5LDQ3LjYyMmw4LjIxNC04LjIxNGEuNzE0LjcxNCwwLDAsMCwwLTEuMDFsLTEuMDEtMS4wMWEuNzE0LjcxNCwwLDAsMC0xLjAxLDBsLTYuNyw2LjdMNS4wODcsNDAuOTU5YS43MTQuNzE0LDAsMCwwLTEuMDEsMGwtMS4wMSwxLjAxYS43MTQuNzE0LDAsMCwwLDAsMS4wMWw0LjY0Myw0LjY0M0EuNzE0LjcxNCwwLDAsMCw4LjcxOSw0Ny42MjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMikiIGZpbGw9IiM4M2M5MWUiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "Mt5Y":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICA8ZyBpZD0iUmVwcm9kdWN0aXZlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTAzMiAxNDYpIj4KICAgIDxnIGlkPSLplbfmlrnlvaJfMjkzMyIgZGF0YS1uYW1lPSLplbfmlrnlvaIgMjkzMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAzMiAtMTQ2KSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjNzA3MDcwIiBzdHJva2Utd2lkdGg9IjEiIG9wYWNpdHk9IjAiPgogICAgICA8cmVjdCB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjI5IiBoZWlnaHQ9IjI5IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgICA8ZyBpZD0i44Kw44Or44O844OXXzcwOTMiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDcwOTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuNSAzKSI+CiAgICAgIDxnIGlkPSLjgrDjg6vjg7zjg5dfNzA5MiIgZGF0YS1uYW1lPSLjgrDjg6vjg7zjg5cgNzA5MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAzMiAtMTQ1LjUpIj4KICAgICAgICA8ZyBpZD0i5qWV5YaG5b2iXzIyNyIgZGF0YS1uYW1lPSLmpZXlhoblvaIgMjI3IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMi40Ij4KICAgICAgICAgIDxlbGxpcHNlIGN4PSI2Ljc1IiBjeT0iNi43NSIgcng9IjYuNzUiIHJ5PSI2Ljc1IiBzdHJva2U9Im5vbmUiLz4KICAgICAgICAgIDxlbGxpcHNlIGN4PSI2Ljc1IiBjeT0iNi43NSIgcng9IjUuNTUiIHJ5PSI1LjU1IiBmaWxsPSJub25lIi8+CiAgICAgICAgPC9nPgogICAgICAgIDxnIGlkPSLjgrDjg6vjg7zjg5dfNzA5MCIgZGF0YS1uYW1lPSLjgrDjg6vjg7zjg5cgNzA5MCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS44IDEyLjYpIj4KICAgICAgICAgIDxsaW5lIGlkPSLnt5pfMTkwIiBkYXRhLW5hbWU9Iue3miAxOTAiIHkyPSI5LjkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQuOTUpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyLjQiLz4KICAgICAgICAgIDxsaW5lIGlkPSLnt5pfMTkxIiBkYXRhLW5hbWU9Iue3miAxOTEiIHgyPSI5LjkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNC45NSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjIuNCIvPgogICAgICAgIDwvZz4KICAgICAgPC9nPgogICAgICA8ZyBpZD0i44Kw44Or44O844OXXzcwOTEiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDcwOTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwNDUuNSAtMTQ0LjUpIj4KICAgICAgICA8ZyBpZD0i5qWV5YaG5b2iXzIyNy0yIiBkYXRhLW5hbWU9IualleWGhuW9oiAyMjciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjUgMjIuNSkgcm90YXRlKC0xODApIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMi40Ij4KICAgICAgICAgIDxlbGxpcHNlIGN4PSI2Ljc1IiBjeT0iNi43NSIgcng9IjYuNzUiIHJ5PSI2Ljc1IiBzdHJva2U9Im5vbmUiLz4KICAgICAgICAgIDxlbGxpcHNlIGN4PSI2Ljc1IiBjeT0iNi43NSIgcng9IjUuNTUiIHJ5PSI1LjU1IiBmaWxsPSJub25lIi8+CiAgICAgICAgPC9nPgogICAgICAgIDxsaW5lIGlkPSLnt5pfMTkwLTIiIGRhdGEtbmFtZT0i57eaIDE5MCIgeTI9IjkuOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNi43NSA5LjkpIHJvdGF0ZSgtMTgwKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMi40Ii8+CiAgICAgICAgPHBhdGggaWQ9IuODkeOCuV8xMjg1IiBkYXRhLW5hbWU9IuODkeOCuSAxMjg1IiBkPSJNMCwwSDYuMzI4VjYuMzI4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyLjI1IDQuNDc1KSByb3RhdGUoLTQ1KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMi40Ii8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/actioncable-vue/dist/actioncablevue.js
var actioncablevue = __webpack_require__("X4fG");
var actioncablevue_default = /*#__PURE__*/__webpack_require__.n(actioncablevue);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/api/index.js
var src_api = __webpack_require__("gyMJ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/nullConditionalOperator.vue

/* harmony default export */ var nullConditionalOperator = ({
  methods: {
    nco: function nco(operation, _default) {
      try {
        var result = operation();
        return result !== null && result !== undefined ? result : _default;
      } catch (e) {
        return _default;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/mixins/nullConditionalOperator.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  nullConditionalOperator,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_nullConditionalOperator = (Component.exports);

// EXTERNAL MODULE: ./src/mixins/toastMethods.vue + 1 modules
var toastMethods = __webpack_require__("2PDt");

// EXTERNAL MODULE: ./src/mixins/responsitive.vue + 1 modules
var responsitive = __webpack_require__("E4co");

// EXTERNAL MODULE: ./src/mixins/loginData.vue + 1 modules
var loginData = __webpack_require__("P6mg");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// EXTERNAL MODULE: ./src/constants/lang/i18n.js + 9 modules
var i18n = __webpack_require__("tZBu");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/locale.vue










/* harmony default export */ var mixins_locale = ({
  data: function data() {
    return {
      locale: i18n["a" /* default */].locale
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isLogin']), {
    languageValueMap: function languageValueMap() {
      return this.languageOptions.reduce(function (map, option) {
        return extends_default()({}, map, defineProperty_default()({}, option.value, option));
      }, {});
    },

    // static
    languageOptions: function languageOptions() {
      return [{
        title: 'English',
        value: 'en'
      }, {
        title: '日本語',
        value: 'ja'
      }];
    }
  }),
  methods: {
    setLang: function setLang(locale) {
      i18n["a" /* default */].locale = locale;
      vee_validate_esm["a" /* Validator */].localize(locale);
      localStorage.setItem('locale', locale);
      this.locale = locale;
      if (this.isLogin) {
        this.setServerLang(locale);
      }
    },
    setServerLang: function setServerLang(locale) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var config;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                config = _this.$ls.get('userInfo');

                locale = locale || i18n["a" /* default */].locale;
                _context.next = 5;
                return Object(src_api["_145" /* putLocaleUserSettings */])(locale, config);

              case 5:
                _context.next = 9;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./src/mixins/locale.vue
var locale_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var locale___vue_template__ = null
/* template functional */
var locale___vue_template_functional__ = false
/* styles */
var locale___vue_styles__ = null
/* scopeId */
var locale___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var locale___vue_module_identifier__ = null
var locale_Component = locale_normalizeComponent(
  mixins_locale,
  locale___vue_template__,
  locale___vue_template_functional__,
  locale___vue_styles__,
  locale___vue_scopeId__,
  locale___vue_module_identifier__
)

/* harmony default export */ var src_mixins_locale = (locale_Component.exports);

// EXTERNAL MODULE: ./src/mixins/userPermission.vue + 1 modules
var userPermission = __webpack_require__("jlnm");

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// EXTERNAL MODULE: ./src/constants/global/config.js
var global_config = __webpack_require__("j9i1");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/header.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var header = ({
  mixins: [mixins_nullConditionalOperator, toastMethods["a" /* default */], responsitive["a" /* default */], loginData["a" /* default */], src_mixins_locale, userPermission["a" /* default */]],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isLogin', 'user']), {
    customIsLogin: function customIsLogin() {
      return this.isLogin && !['genePanel'].includes(this.$route.name);
    },
    leftHeader: function leftHeader() {
      return this.$route.name && ['genePanel', 'coverageRate'].includes(this.$route.name);
    },
    routes: function routes() {
      var _this = this;

      return {
        left: [{
          title: this.$t('LAYOUT.header.routes.title.___caseList'),
          to: { name: 'caseList' },
          icon: __webpack_require__("aYau"),
          iconStyle: { width: '16px' },
          actives: ['caseList']
        }, {
          title: this.$t('LAYOUT.header.routes.title.___phenoVarDBPopulationFrequencies'),
          to: { name: 'datasetList' },
          icon: __webpack_require__("i6O6"),
          iconStyle: { width: '16px' },
          actives: ['datasetList', 'datasetEdit', 'datasetDetail']
        }].filter(function (route) {
          return route.display !== false;
        }),
        right: [{
          info: this.$t('LAYOUT.header.routes.info.___userManual'),
          func: function func() {
            return _this.donwoladManual();
          },
          icon: __webpack_require__("t62l")
        }, {
          info: this.$t('LAYOUT.header.routes.info.___logOut'),
          func: function func() {
            return _this.userLogout();
          },
          icon: __webpack_require__("D1u2")
        }].filter(function (route) {
          return route.display !== false;
        })
      };
    },
    menuOptions: function menuOptions() {
      return [{
        title: this.$t('LAYOUT.header.menu.title.___userSetting'),
        icon: __webpack_require__("gIQ0"),
        to: { name: 'user' }
      }, {
        type: 'locale'
      }].filter(function (route) {
        return route.display !== false;
      });
    }
  }),
  watch: {
    'locale': function locale(nv) {
      this.$emit('setLang', nv);
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoginAction', 'setRouteResetAction']), {
    donwoladManual: function donwoladManual() {
      var manualData = {
        'default': {
          name: 'InheriNext-EDGE_Manual_ENG_20260825(C).pdf',
          file: 'InheriNext_manual.pdf'
        },
        'us': {
          name: 'InheriNext-EDGE_Manual_ENG_20260825(C).pdf',
          file: 'InheriNext_manual.pdf'
        },
        'jp': {
          name: 'InheriNext-EDGE_Manual_JP_20260825(C).pdf',
          file: 'InheriNext_jp_manual.pdf'
        }
      }[global_config["b" /* _WEBSITE_VERSION */]];
      manualData && Object(util["e" /* downloadFile */])(manualData.name, '../../../static/' + manualData.file, '_blank');
    },
    resetRoute: function resetRoute() {
      this.setRouteResetAction(true);
      this.$router.push({ name: 'caseList' });
    },
    userLogout: function userLogout() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var config;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                config = _this2.$ls.get('userInfo');
                _context.next = 4;
                return Object(src_api["w" /* deleteUser */])(config);

              case 4:
                _this2.setUserData(null);
                _this2.$router.push({ name: 'main' });
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                _this2.setLoginAction(true);
                _this2.addToast('error', !_context.t0.response ? _context.t0.message : _context.t0.response.data.result.message);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 8]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fcd9266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"max-width row-block"},[_c('div',{staticClass:"left row-block",style:(!_vm.customIsLogin || _vm.isMobile ? { flex: 1 } : {})},[(_vm.customIsLogin && !_vm.isMobile)?[_c('a',{staticClass:"img",on:{"click":function (e) { return _vm.resetRoute(); }}},[_c('img',{style:({ width: '108px' }),attrs:{"src":__webpack_require__("q3sG"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ width: '27.3px' })}),_vm._v(" "),_vm._l((_vm.routes['left']),function(route,index){return _c('div',{key:index,staticClass:"route-container",class:{ active: (route.actives || []).includes(_vm.$route.name), icon: !route.title },attrs:{"title":route.title.replace(/\<br\>/g, ' ')}},[(route.to)?_c('router-link',{staticClass:"route-block center-block",attrs:{"to":route.to}},[_c('div',{staticClass:"route-content link",class:[route.title ? 'row-block' : 'center-block']},[_c('img',{style:(route.iconStyle || {}),attrs:{"src":route.icon,"alt":""}}),_vm._v(" "),(route.title)?[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"route-title",domProps:{"innerHTML":_vm._s(route.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]:_vm._e()],2)]):(route.func)?_c('div',{staticClass:"route-block center-block function",class:{ icon: !route.title },on:{"click":function (e) { return route.func(); }}},[_c('div',{staticClass:"route-content",class:[route.title ? 'row-block' : 'center-block']},[_c('img',{style:(route.iconStyle || {}),attrs:{"src":route.icon,"alt":""}}),_vm._v(" "),(route.title)?[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"route-title",domProps:{"innerHTML":_vm._s(route.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]:_vm._e()],2)]):_vm._e()],1)}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]:(_vm.leftHeader)?_c('router-link',{staticClass:"img",attrs:{"to":_vm.customIsLogin ? { name: 'main' } : { name: _vm.$route.name }}},[_c('img',{style:({ width: '108px' }),attrs:{"src":__webpack_require__("q3sG"),"alt":""}})]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"center center-block",style:(_vm.customIsLogin ? { width: '10px'} : {})},[((!_vm.customIsLogin || _vm.isMobile) && !_vm.leftHeader)?_c('router-link',{staticClass:"img",attrs:{"to":_vm.customIsLogin ? { name: 'main' } : { name: _vm.$route.name }}},[_c('img',{style:({ width: '108px' }),attrs:{"src":__webpack_require__("q3sG"),"alt":""}})]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"right row-block",style:({ flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"user-locale-container row-block"},[_c('div',{staticClass:"user-locale-block row-block"},[_c('div',{staticClass:"user-locale-icon icon-block",style:({ '--size': '30px' })},[_c('img',{attrs:{"src":__webpack_require__("HSv/"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"user-locale-title"},[_vm._v(_vm._s(_vm.languageValueMap[_vm.locale].title))]),_vm._v(" "),_c('div',{staticClass:"user-locale-menu-container col-block width-full"},_vm._l((_vm.languageOptions),function(option,oindex){return _c('div',{key:oindex,staticClass:"user-locale-menu-block row-block",on:{"click":function (e) { return _vm.setLang(option.value); }}},[_c('img',{attrs:{"src":_vm.locale === option.value ? __webpack_require__("xccc") : __webpack_require__("z0Pm"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"user-locale-menu-title"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),(_vm.customIsLogin && !_vm.isMobile)?_c('div',{staticClass:"row-block"},[_c('router-link',{staticClass:"user-container row-block",attrs:{"to":{ name: 'user' }}},[(false)?_c('div',{staticClass:"user-menu-container col-block width-full"},_vm._l((_vm.menuOptions),function(option,oindex){return _c('div',{key:oindex,staticClass:"user-menu-block col-block"},[(option.type === 'locale')?[(_vm.locale)?_c('div',{staticClass:"user-menu-locale-container input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.locale),expression:"locale"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.locale=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function (e) { return _vm.setLang(_vm.locale); }]}},_vm._l((_vm.languageOptions),function(option,index){return _c('option',{key:index,domProps:{"value":option.value}},[_vm._v(_vm._s(option.title))])}),0)]):_vm._e()]:[_c(option.to ? 'router-link' : option.link ? 'a' : 'div',{tag:"component",staticClass:"user-menu-content row-block",attrs:{"to":option.to},on:{"click":function (e) { return (option.func || (function () {}))(option); }}},[_c('div',{staticClass:"icon-block user-menu-icon",style:({ '--size': '30px' })},[_c('img',{attrs:{"src":option.icon,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"user-menu-title",style:({ flex: 1 })},[_vm._v(_vm._s(option.title))])])]],2)}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"user-avatar",style:({ 'background-image': 'url(' + ((_vm.avatarUrl || __webpack_require__("GW3Y"))) + ')' })}),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"user-name"},[_vm._v(_vm._s([_vm.user.first_name, _vm.user.last_name].join(' ')))]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"col-block",style:({ height: '19px' })},[_c('div',{style:({ height: '7px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("gijb"),"alt":""}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_vm._l((_vm.routes['right']),function(route,index){return _c('div',{key:index,staticClass:"route-container",class:{ active: (route.actives || []).includes(_vm.$route.name), icon: !route.title },attrs:{"title":route.info.replace(/\<br\>/g, ' ')}},[(route.to)?_c('router-link',{staticClass:"route-block center-block",attrs:{"to":route.to}},[_c('div',{staticClass:"route-content link",class:[route.title ? 'row-block' : 'center-block']},[_c('img',{style:(route.iconStyle || {}),attrs:{"src":route.icon,"alt":""}}),_vm._v(" "),(route.title)?[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"route-title"},[_vm._v(_vm._s(route.title))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]:_vm._e()],2)]):(route.func)?_c('div',{staticClass:"route-block center-block function",class:{ icon: !route.title },on:{"click":function (e) { return route.func(); }}},[_c('div',{staticClass:"route-content",class:[route.title ? 'row-block' : 'center-block']},[_c('img',{style:(route.iconStyle || {}),attrs:{"src":route.icon,"alt":""}}),_vm._v(" "),(route.title)?[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"route-title"},[_vm._v(_vm._s(route.title))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]:_vm._e()],2)]):_vm._e()],1)})],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var layout_header = (esExports);
// CONCATENATED MODULE: ./src/components/layout/header.vue
var header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var header___vue_template_functional__ = false
/* styles */
var header___vue_styles__ = null
/* scopeId */
var header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var header___vue_module_identifier__ = null
var header_Component = header_normalizeComponent(
  header,
  layout_header,
  header___vue_template_functional__,
  header___vue_styles__,
  header___vue_scopeId__,
  header___vue_module_identifier__
)

/* harmony default export */ var components_layout_header = (header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/footer.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var footer = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a23fae7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/footer.vue
var footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var footer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"max-width"},[_c('span')])])}]
var footer_esExports = { render: footer_render, staticRenderFns: footer_staticRenderFns }
/* harmony default export */ var layout_footer = (footer_esExports);
// CONCATENATED MODULE: ./src/components/layout/footer.vue
var footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var footer___vue_template_functional__ = false
/* styles */
var footer___vue_styles__ = null
/* scopeId */
var footer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var footer___vue_module_identifier__ = null
var footer_Component = footer_normalizeComponent(
  footer,
  layout_footer,
  footer___vue_template_functional__,
  footer___vue_styles__,
  footer___vue_scopeId__,
  footer___vue_module_identifier__
)

/* harmony default export */ var components_layout_footer = (footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/toast.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var tool_toast = ({
  mixins: [loginData["a" /* default */]],
  data: function data() {
    return {
      toasts: [],
      noPermissionTimer: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['toast']), {
    noPermissionMsg: function noPermissionMsg() {
      return 'You have no permission to do this operation.'; /* ___ */
    }
  }),
  watch: {
    'toast': function toast(nv) {
      var _this = this;

      if (!this.noPermissionTimer || nv.content !== this.noPermissionMsg) {
        var id = new Date().getTime() + '';
        this.toasts.push(extends_default()({}, nv, {
          id: id,
          clearTimer: null,
          timer: setTimeout(function () {
            _this.toasts.splice(_this.toasts.indexOf(_this.toasts.find(function (toast) {
              return toast.id === id;
            })), 1);
          }, 5000)
        }));
        if (nv.content === this.noPermissionMsg) {
          this.checkAccessToken();
        }
      }
      if (nv.content === this.noPermissionMsg) {
        this.noPermissionTimer = setTimeout(function () {
          _this.noPermissionTimer = null;
        }, 500);
      }
    }
  },
  methods: {
    keepToast: function keepToast(toast) {
      toast.clearTimer = setTimeout(function () {
        clearTimeout(toast.timer);
        toast.clearTimer = null;
      }, 500);
    },
    leaveToast: function leaveToast(toast, index) {
      if (toast.clearTimer) {
        clearTimeout(toast.clearTimer);
      } else {
        this.removeToast(index);
      }
    },
    removeToast: function removeToast(index) {
      this.toasts.splice(index, 1);
    },
    checkAccessToken: function checkAccessToken() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var config;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                config = _this2.$ls.get('userInfo');
                _context.next = 4;
                return Object(src_api["_82" /* getUserToken */])(config);

              case 4:
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                _this2.setUserData(null);
                _this2.$router.push({ name: 'main' });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 6]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce26b030","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/toast.vue
var toast_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-position"},[_c('div',{staticClass:"toast-container"},[_c('transition-group',{attrs:{"name":"toastDown"}},_vm._l((_vm.toasts),function(toast,index){return _c('div',{key:index + 0,staticClass:"toast col-block",class:[toast.type],on:{"mouseenter":function (e) { return _vm.keepToast(toast); },"mouseleave":function (e) { return _vm.leaveToast(toast, index); }}},[_c('div',{staticClass:"option"},[_c('img',{attrs:{"src":__webpack_require__("nzHv"),"alt":""},on:{"click":function (e) { return _vm.removeToast(index); }}})]),_vm._v(" "),_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s({
            error: _vm.$t('COMPONENT.tool.toast.title.___error'),
            warning: _vm.$t('COMPONENT.tool.toast.title.___warning'),
            notice: _vm.$t('COMPONENT.tool.toast.title.___notice'),
            success: _vm.$t('COMPONENT.tool.toast.title.___success')
          }[toast.type])}}),_vm._v(" "),_c('div',{style:({ height: '14px' })}),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(toast.content)}})])}),0)],1)])}
var toast_staticRenderFns = []
var toast_esExports = { render: toast_render, staticRenderFns: toast_staticRenderFns }
/* harmony default export */ var components_tool_toast = (toast_esExports);
// CONCATENATED MODULE: ./src/components/tool/toast.vue
var toast_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var toast___vue_template_functional__ = false
/* styles */
var toast___vue_styles__ = null
/* scopeId */
var toast___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var toast___vue_module_identifier__ = null
var toast_Component = toast_normalizeComponent(
  tool_toast,
  components_tool_toast,
  toast___vue_template_functional__,
  toast___vue_styles__,
  toast___vue_scopeId__,
  toast___vue_module_identifier__
)

/* harmony default export */ var src_components_tool_toast = (toast_Component.exports);

// EXTERNAL MODULE: ./src/components/tool/borCor.vue + 2 modules
var tool_borCor = __webpack_require__("HALv");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/borCor.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// borCor

/* harmony default export */ var layout_borCor = ({
  components: {
    borCorCP: tool_borCor["a" /* default */]
    // borCor
  },
  data: function data() {
    return {
      borCorData: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['borCor'])),
  watch: {
    'borCor': function borCor(nv) {
      this.borCorData = nv ? extends_default()({}, nv, {
        triggerData: nv.e.target.getBoundingClientRect()
      }) : null;
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setBorCorAction']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0872e0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/borCor.vue
var borCor_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bor-cor-page",style:(_vm.borCorData ? {
    top: _vm.borCorData.triggerData.top + 'px',
    left: _vm.borCorData.triggerData.left + 'px'
  } : {})},[(_vm.borCorData)?_c('borCorCP',_vm._b({on:{"leave":function () { return _vm.setBorCorAction(); }}},'borCorCP',_vm.borCorData.options || {},false),[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"bor-cor-container",style:({
          width: _vm.borCorData.triggerData.width + 'px',
          height: _vm.borCorData.triggerData.height + 'px'
        })})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[((_vm.borCorData.content || {}).html)?_c('div',{domProps:{"innerHTML":_vm._s((_vm.borCorData.content || {}).html)}}):((_vm.borCorData.content || {}).component)?_c((_vm.borCorData.content || {}).component,{tag:"component",attrs:{"param":(_vm.borCorData.content || {}).param}}):_vm._e()],1)]):_vm._e()],1)}
var borCor_staticRenderFns = []
var borCor_esExports = { render: borCor_render, staticRenderFns: borCor_staticRenderFns }
/* harmony default export */ var components_layout_borCor = (borCor_esExports);
// CONCATENATED MODULE: ./src/components/layout/borCor.vue
var borCor_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var borCor___vue_template_functional__ = false
/* styles */
var borCor___vue_styles__ = null
/* scopeId */
var borCor___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var borCor___vue_module_identifier__ = null
var borCor_Component = borCor_normalizeComponent(
  layout_borCor,
  components_layout_borCor,
  borCor___vue_template_functional__,
  borCor___vue_styles__,
  borCor___vue_scopeId__,
  borCor___vue_module_identifier__
)

/* harmony default export */ var src_components_layout_borCor = (borCor_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/loading.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccb20d96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/loading.vue
var loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-page"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})])])}
var loading_staticRenderFns = []
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var layout_loading = (loading_esExports);
// CONCATENATED MODULE: ./src/components/layout/loading.vue
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = null
/* scopeId */
var loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  loading,
  layout_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)

/* harmony default export */ var components_layout_loading = (loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/uploading.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var uploading = ({
  props: {
    content: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c480ea5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/uploading.vue
var uploading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploading-page"},[_c('div',{staticClass:"img-box"},[_c('h1',[_vm._v(_vm._s(_vm.content !== null ? _vm.content : _vm.$t('LAYOUT.uploading.___title')))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})])])}
var uploading_staticRenderFns = []
var uploading_esExports = { render: uploading_render, staticRenderFns: uploading_staticRenderFns }
/* harmony default export */ var layout_uploading = (uploading_esExports);
// CONCATENATED MODULE: ./src/components/layout/uploading.vue
var uploading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var uploading___vue_template_functional__ = false
/* styles */
var uploading___vue_styles__ = null
/* scopeId */
var uploading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var uploading___vue_module_identifier__ = null
var uploading_Component = uploading_normalizeComponent(
  uploading,
  layout_uploading,
  uploading___vue_template_functional__,
  uploading___vue_styles__,
  uploading___vue_scopeId__,
  uploading___vue_module_identifier__
)

/* harmony default export */ var components_layout_uploading = (uploading_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var object_values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(object_values);

// EXTERNAL MODULE: ./src/api/config.js
var api_config = __webpack_require__("T452");

// EXTERNAL MODULE: ./src/mixins/customTimeout.vue + 1 modules
var customTimeout = __webpack_require__("WBdv");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/gcsResumable.vue







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var gcsResumable = ({
  mixins: [toastMethods["a" /* default */], customTimeout["a" /* default */]],
  data: function data() {
    return {
      uploadThreadDatas: [],
      metadata: {}
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isFileUpload', 'uploadCount', 'waitUploading', 'isLogin', 'user']), {
    uploadingCaseIDs: function uploadingCaseIDs() {
      return this.groupFiles.map(function (datas) {
        return datas[0].caseData.id;
      });
    },
    groupFiles: function groupFiles() {
      var _this = this;

      var groupRule = function groupRule(data) {
        var groupName = _this.getGroupName(data);
        values_default()(_this.metadata).forEach(function (m) {
          m[groupName] = m[groupName] || '';
        });
        return groupName;
      };
      return Object(util["i" /* groupBy */])(this.uploadThreadDatas, groupRule);
    }
  }),
  created: function created() {
    var _this2 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, data, state;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.userData = _this2.user;
              _context.prev = 1;

              if (global_config["a" /* _LOCAL_BUILD */]) {
                _context.next = 31;
                break;
              }

              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 6;
              _iterator = get_iterator_default()(values_default()(_this2.getResumableInfo()));

            case 8:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 17;
                break;
              }

              data = _step.value;
              _context.next = 12;
              return _this2.getUploadState(data);

            case 12:
              state = _context.sent;

              if (state) {
                _this2.uploadThreadDatas.push(extends_default()({}, data, state, {
                  state: state.loaded < data.file.size ? 'stop' : 'completed'
                }));
              }

            case 14:
              _iteratorNormalCompletion = true;
              _context.next = 8;
              break;

            case 17:
              _context.next = 23;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context['catch'](6);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 23:
              _context.prev = 23;
              _context.prev = 24;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 26:
              _context.prev = 26;

              if (!_didIteratorError) {
                _context.next = 29;
                break;
              }

              throw _iteratorError;

            case 29:
              return _context.finish(26);

            case 30:
              return _context.finish(23);

            case 31:
              _context.next = 36;
              break;

            case 33:
              _context.prev = 33;
              _context.t1 = _context['catch'](1);

              _this2.addToast('error', !_context.t1.response ? _context.t1.message : _context.t1.response.data.result.message);

            case 36:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[1, 33], [6, 19, 23, 31], [24,, 26, 30]]);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    var _this3 = this;

    this.uploadThreadDatas.filter(function (data) {
      return ['uploading'].includes(data.state);
    }).forEach(function (data) {
      _this3.stopUpload(data);
      _this3.cancelFile(data);
    });
  },

  watch: {
    'waitUploading': function waitUploading(nv) {
      if (nv) {
        this.selectFiles(nv.caseData, nv.fileSets);
      }
      this.setWaitUploadingAction();
    },
    'isLogin': function isLogin(nv) {
      if (nv === false) {
        this.deleteGroup(this.uploadThreadDatas);
      }
    },
    'groupFiles.length': function groupFilesLength(nv, ov) {
      nv > ov && this.$emit('count');
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addUploadCountAction', 'setWaitUploadingAction', 'setResumableInfoAction']), {
    // selectFiles (e) {
    //   const s = dateFormat(new Date(), 'yyyyMMddhhmmssS')
    //   this.uploadThreadDatas = this.uploadThreadDatas.concat(Array.from(e.target.files).map(file => ({
    //     file: file,
    //     groupTime: s,
    //     extention: file.name.split('.').reverse()[0]
    //   })))
    //   e.target.value = ''
    // },
    selectFiles: function selectFiles(caseData, fileSets) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var s, config, datas, signUrls, _datas;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this4.uploadingCaseIDs.includes(caseData.id)) {
                  _context2.next = 13;
                  break;
                }

                s = Object(util["d" /* dateFormat */])(new Date(), 'yyyyMMddhhmmssS');
                config = _this4.$ls.get('userInfo');
                datas = [];
                _context2.next = 6;
                return _this4.getSignUrl(caseData, fileSets);

              case 6:
                signUrls = _context2.sent;

                fileSets.forEach(function (set, index) {
                  if (caseData.dataset === 'vcf') {
                    if (signUrls[index].snv) {
                      datas.push({
                        file: set.snv,
                        signUrl: signUrls[index].snv.startsWith('https://storage.googleapis.com/') ? signUrls[index].snv : api_config["a" /* API_ROOT */] + signUrls[index].snv.replace(/^\//, '') + '?access_token=' + config['access_token'],
                        caseData: caseData,
                        groupTime: s,
                        extention: set.snv.name.split('.').reverse()[0]
                      });
                    }
                    if (signUrls[index].sv) {
                      var urlMap = signUrls[index].sv.reduce(function (map, data) {
                        return extends_default()({}, map, data);
                      }, {});
                      set.sv.forEach(function (file) {
                        var signUrl = urlMap[file.name];
                        if (signUrl) {
                          datas.push({
                            file: file,
                            signUrl: signUrl.startsWith('https://storage.googleapis.com/') ? signUrl : api_config["a" /* API_ROOT */] + signUrl.replace(/^\//, '') + '?access_token=' + config['access_token'],
                            caseData: caseData,
                            groupTime: s,
                            extention: file.name.split('.').reverse()[0]
                          });
                        }
                      });
                    }
                    if (signUrls[index].str) {
                      datas.push({
                        file: set.str,
                        signUrl: signUrls[index].str.startsWith('https://storage.googleapis.com/') ? signUrls[index].str : api_config["a" /* API_ROOT */] + signUrls[index].str.replace(/^\//, '') + '?access_token=' + config['access_token'],
                        caseData: caseData,
                        groupTime: s,
                        extention: set.str.name.split('.').reverse()[0]
                      });
                    }
                  } else if (caseData.dataset === 'fastq') {
                    datas.push({
                      file: set.r1,
                      signUrl: signUrls[index].r1.startsWith('https://storage.googleapis.com/') ? signUrls[index].r1 : api_config["a" /* API_ROOT */] + signUrls[index].r1.replace(/^\//, '') + '?access_token=' + config['access_token'],
                      caseData: caseData,
                      groupTime: s,
                      extention: set.r1.name.split('.').reverse()[0]
                    });
                    if (caseData.pipelineType === 'paired') {
                      datas.push({
                        file: set.r2,
                        signUrl: signUrls[index].r2.startsWith('https://storage.googleapis.com/') ? signUrls[index].r2 : api_config["a" /* API_ROOT */] + signUrls[index].r2.replace(/^\//, '') + '?access_token=' + config['access_token'],
                        caseData: caseData,
                        groupTime: s,
                        extention: set.r1.name.split('.').reverse()[0]
                      });
                    }
                  } else if (caseData.dataset === 'ubam') {
                    datas.push({
                      file: set.bam,
                      signUrl: signUrls[index].r1.startsWith('https://storage.googleapis.com/') ? signUrls[index].r1 : api_config["a" /* API_ROOT */] + signUrls[index].r1.replace(/^\//, '') + '?access_token=' + config['access_token'],
                      caseData: caseData,
                      groupTime: s,
                      extention: set.bam.name.split('.').reverse()[0]
                    });
                  }
                });
                _this4.uploadThreadDatas = _this4.uploadThreadDatas.concat(datas);
                _context2.next = 11;
                return _this4.uploadFile(datas);

              case 11:
                _context2.next = 15;
                break;

              case 13:
                _datas = _this4.uploadThreadDatas.filter(function (data) {
                  return data.caseData.id === caseData.id;
                });

                _this4.completeFile(fileSets, _datas);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    uploadFile: function uploadFile(datas) {
      var _this5 = this;

      var isResume = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var i, _i, state, _i2;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (datas.some(function (data) {
                  return !data.state || ['stop', 'error'].includes(data.state);
                })) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return', false);

              case 2:
                // if (datas.some(data => !data.signUrl)) {
                //   const signUrls = await this.getSignUrl(datas)
                //   for (let i = 0; i < datas.length; i++) {
                //     if (signUrls[i]) {
                //       datas[i] = this.refreshData(datas[i], { signUrl: signUrls[i].url })
                //       this.saveResumableInfo(datas[i])
                //     }
                //   }
                // }
                for (i = 0; i < datas.length; i++) {
                  if (!datas[i].state) {
                    datas[i] = _this5.refreshData(datas[i], { state: 'stop' });
                    _this5.saveResumableInfo(datas[i]);
                  }
                }

                if (!datas.every(function (data) {
                  return data.signUrl;
                })) {
                  _context3.next = 22;
                  break;
                }

                _i = 0;

              case 5:
                if (!(_i < datas.length)) {
                  _context3.next = 18;
                  break;
                }

                if (!(!datas[_i].state || ['stop', 'error'].includes(datas[_i].state))) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 9;
                return _this5.getUploadState(datas[_i]);

              case 9:
                state = _context3.sent;

                if (!(state && (!isResume || state.loaded >= datas[_i].loaded))) {
                  _context3.next = 14;
                  break;
                }

                datas[_i] = _this5.refreshData(datas[_i], state);
                _context3.next = 15;
                break;

              case 14:
                return _context3.abrupt('return', true);

              case 15:
                _i++;
                _context3.next = 5;
                break;

              case 18:
                for (_i2 = 0; _i2 < datas.length; _i2++) {
                  if (!datas[_i2].state || ['stop', 'error'].includes(datas[_i2].state)) {
                    _this5.postFile(datas, _i2);
                  }
                }
                return _context3.abrupt('return', false);

              case 22:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    getSignUrl: function getSignUrl(caseData, fileSets) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var config, id, dataset, data, response, signUrls;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                config = _this6.$ls.get('userInfo', {});
                id = caseData.id;
                dataset = caseData.dataset;
                data = {};

                if (caseData.dataset === 'vcf') {
                  data.vcf_file = Object(util["a" /* cleanObject */])({
                    snv: fileSets[0].snv ? {
                      name: fileSets[0].snv.name,
                      content_type: fileSets[0].snv.type || 'text/plain'
                    } : null,
                    sv: fileSets[0].sv ? fileSets[0].sv.map(function (file) {
                      return {
                        name: file.name,
                        content_type: file.type || 'text/plain'
                      };
                    }) : null,
                    str: fileSets[0].str ? {
                      name: fileSets[0].str.name,
                      content_type: fileSets[0].str.type || 'text/plain'
                    } : null
                  });
                } else if (caseData.dataset === 'fastq') {
                  data.omics = caseData.omics_name;
                  data.pipeline = caseData.pipeline_name;
                  data.library_type = caseData.library_type_name;
                  data.ngs_files = fileSets.map(function (set) {
                    return extends_default()({
                      r1: {
                        name: set.r1.name,
                        content_type: set.r1.type || 'text/plain'
                      }
                    }, caseData.pipelineType === 'paired' ? {
                      r2: {
                        name: set.r2.name,
                        content_type: set.r2.type || 'text/plain'
                      }
                    } : {});
                  });
                } else if (caseData.dataset === 'ubam') {
                  data.omics = caseData.omics_name;
                  data.pipeline = caseData.pipeline_name;
                  data.library_type = caseData.library_type_name;
                  data.ngs_files = fileSets.map(function (set) {
                    return {
                      r1: {
                        name: set.bam.name,
                        content_type: set.bam.type || 'text/plain'
                      }
                    };
                  });
                }
                _context4.next = 8;
                return Object(src_api["_104" /* postCaseSampleFile */])(id, dataset, data, config);

              case 8:
                response = _context4.sent;
                signUrls = response.data.data;
                return _context4.abrupt('return', caseData.dataset === 'vcf' ? [signUrls] : signUrls);

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4['catch'](0);

                _this6.addToast('error', !_context4.t0.response ? _context4.t0.message : _context4.t0.response.data.result.message);

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 13]]);
      }))();
    },
    getUploadState: function getUploadState(data) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var status;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!data.signUrl) {
                  _context5.next = 11;
                  break;
                }

                if (!data.signUrl.startsWith('https://storage.googleapis.com/')) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 4;
                return new promise_default.a(function (resolve) {
                  var xhr = _this7.createCORSRequest('PUT', data.signUrl);
                  if (xhr.upload) {
                    xhr.onerror = function (e) {
                      resolve(null);
                    };
                    xhr.onload = function (e) {
                      var headers = xhr.getAllResponseHeaders().split('\n').reduce(function (s, c) {
                        return extends_default()({}, s, defineProperty_default()({}, c.split(': ')[0], c.split(': ')[1]));
                      }, {});
                      var loaded = headers['range'] ? headers['range'].replace('bytes=0-', '') - -1 : 0;
                      resolve({
                        loaded: loaded,
                        curLoaded: 0
                      });
                    };
                    xhr.setRequestHeader('Content-Type', data.file.type || 'text/plain');
                    xhr.setRequestHeader('Content-Range', 'bytes */' + data.file.size);
                    xhr.send();
                  }
                });

              case 4:
                _context5.t1 = _context5.sent;
                _context5.next = 8;
                break;

              case 7:
                _context5.t1 = {
                  loaded: 0,
                  curLoaded: 0
                };

              case 8:
                _context5.t0 = _context5.t1;
                _context5.next = 12;
                break;

              case 11:
                _context5.t0 = null;

              case 12:
                status = _context5.t0;
                return _context5.abrupt('return', status);

              case 14:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    postFile: function postFile(datas, i) {
      var _this8 = this;

      var xhr = this.createCORSRequest('PUT', datas[i].signUrl);
      if (xhr.upload) {
        xhr.upload.addEventListener('progress', function (e) {
          if (e.lengthComputable) {
            datas[i] = _this8.refreshData(datas[i], { curLoaded: e.loaded });
          }
        }, false);
        xhr.onload = function (e) {
          datas[i] = _this8.refreshData(datas[i], { state: 'completed' });
          if (datas.every(function (data) {
            return ['completed'].includes(data.state);
          })) {
            for (var _i3 = 0; _i3 < datas.length; _i3++) {
              _this8.removeResumableInfo(datas[_i3]);
            }
            _this8.$emit('complete');
            _this8.addUploadCountAction(true);
          }
        };
        xhr.onerror = function () {
          datas[i] = _this8.stopUpload(datas[i], true);
          if (datas.every(function (data) {
            return ['completed', 'error'].includes(data.state);
          })) {
            _this8.customRecursive(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
              var result;
              return regenerator_default.a.wrap(function _callee6$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      if (!datas.every(function (data) {
                        return _this8.getResumableInfo()[data.signUrl];
                      })) {
                        _context6.next = 6;
                        break;
                      }

                      _context6.next = 3;
                      return _this8.uploadFile(datas, true);

                    case 3:
                      _context6.t0 = _context6.sent;
                      _context6.next = 7;
                      break;

                    case 6:
                      _context6.t0 = false;

                    case 7:
                      result = _context6.t0;
                      return _context6.abrupt('return', result);

                    case 9:
                    case 'end':
                      return _context6.stop();
                  }
                }
              }, _callee6, _this8);
            })), 10 * 1000);
          }
        };
        if (datas[i].signUrl.startsWith('https://storage.googleapis.com/')) {
          xhr.setRequestHeader('Content-Type', datas[i].file.type || 'text/plain');
          if (datas[i].loaded > 0) {
            xhr.setRequestHeader('Content-Range', 'bytes ' + datas[i].loaded + '-' + (datas[i].file.size - 1) + '/' + datas[i].file.size);
          }
        }
        var file = datas[i].loaded === 0 ? datas[i].file : datas[i].file.slice(datas[i].loaded, datas[i].file.size);
        datas[i] = this.refreshData(datas[i], {
          xhr: xhr,
          state: 'uploading'
        });
        xhr.send(datas[i].signUrl.startsWith('https://storage.googleapis.com/') ? file : Object(util["q" /* toFormdata */])({ file: file }));
      } else {
        this.addToast('error', this.$t('COMMON.toast.___xhrCanNotUpload'));
      }
    },
    stopUpload: function stopUpload(data) {
      var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (['uploading'].includes(data.state)) {
        data = this.refreshData(data, {
          loaded: data.curLoaded + data.loaded,
          curLoaded: 0,
          state: isError ? 'error' : 'stop'
        });
        data.xhr.abort();
      }
      return data;
    },
    cancelFile: function cancelFile(data) {
      this.removeResumableInfo(data);
      this.uploadThreadDatas.splice(this.uploadThreadDatas.indexOf(data), 1);
    },
    completeFile: function completeFile(fileSets, datas) {
      var files = Array.prototype.concat.apply([], fileSets.map(function (set) {
        return values_default()(set);
      }));
      if (files.length === datas.length) {
        for (var i = 0; i < datas.length; i++) {
          var index = files.map(function (file) {
            return file.name + '_' + file.type + '_' + file.size;
          }).indexOf(datas[i].file.name + '_' + datas[i].file.type + '_' + datas[i].file.size);
          if (index !== -1) {
            datas[i] = this.refreshData(datas[i], {
              file: files[index]
            });
          } else {
            break;
          }
        }
      }
      if (datas.every(function (data) {
        return ['completed'].includes(data.state) || data.file.lastModified;
      })) {
        for (var _i4 = 0; _i4 < datas.length; _i4++) {
          if (!datas[_i4].state || ['stop', 'error'].includes(datas[_i4].state)) {
            this.postFile(datas, _i4);
            this.saveResumableInfo(datas[_i4]);
          }
        }
      } else {
        this.addToast('error', this.$t('COMMON.toast.___wrongFiles'));
      }
    },
    saveResumableInfo: function saveResumableInfo(data) {
      var info = this.$ls.get('resumableInfo') || {};
      info[this.userData.email] = info[this.userData.email] || {};
      info[this.userData.email][data.signUrl] = extends_default()({}, data, {
        file: {
          name: data.file.name,
          type: data.file.type,
          size: data.file.size
        }
      });
      this.$ls.set('resumableInfo', info);
      this.setResumableInfoAction(info);
    },
    getResumableInfo: function getResumableInfo() {
      var info = this.$ls.get('resumableInfo') || {};
      return info[this.userData.email] || {};
    },
    removeResumableInfo: function removeResumableInfo(data) {
      var info = this.$ls.get('resumableInfo') || {};
      if (info[this.userData.email] && info[this.userData.email][data.signUrl]) {
        delete info[this.userData.email][data.signUrl];
        this.$ls.set('resumableInfo', info);
        this.setResumableInfoAction(info);
      }
    },
    createCORSRequest: function createCORSRequest(method, url) {
      var xhr = new XMLHttpRequest();
      if ('withCredentials' in xhr) {
        xhr.open(method, url, true);
      } else if (typeof XDomainRequest !== 'undefined') {
        xhr = new XDomainRequest();
        xhr.open(method, url);
      } else {
        xhr = null;
      }
      return xhr;
    },
    refreshData: function refreshData(data, _data) {
      if (!_data || !values_default()(_data).length) return data;
      var index = this.uploadThreadDatas.indexOf(data);
      this.$set(this.uploadThreadDatas, index, extends_default()({}, data, _data));
      return this.uploadThreadDatas[index];
    },
    getGroupName: function getGroupName(data) {
      var s = data.groupTime || this.dateFormat(new Date(), 'yyyyMMddhhmmssS');
      return data.caseData.id + '_' + (s || '');
    },
    getGroupState: function getGroupState(group) {
      var _this9 = this;

      var sum = group.reduce(function (s, c) {
        return s + _this9.getFilePersent(c);
      }, 0) / group.length;
      var state = group[0].state;
      return {
        uploading: Math.round(sum) + '%',
        stop: this.$t('COMPONENT.tool.gcsResumable.groupState.___pending'),
        error: this.$t('COMPONENT.tool.gcsResumable.groupState.___failed'),
        completed: '100%'
      }[state] || this.$t('COMPONENT.tool.gcsResumable.groupState.___pending');
    },
    getFilePersent: function getFilePersent(data) {
      return !data.signUrl ? 0 : Math.round(data.file.size ? (data.curLoaded + data.loaded || 0) * 100 / data.file.size : data.loaded !== undefined ? 100 : 0);
    },
    deleteGroup: function deleteGroup(datas) {
      var _this10 = this;

      this.$emit('cancel', datas.every(function (data) {
        return ['completed'].includes(data.state);
      }));
      datas.forEach(function (data) {
        // this.stopUpload(data)
        if (['uploading'].includes(data.state)) {
          data.xhr.abort();
        }
        _this10.cancelFile(data);
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2960dbbc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/gcsResumable.vue
var gcsResumable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gcs-resumable-container"}},[_c('div',{staticClass:"table-container col-block sub-shadow",style:({ height: '360px' })},[_c('div',{staticClass:"tbody",style:({ flex: 1 })},[_c('div',{style:({ height: 0 })},_vm._l((_vm.groupFiles),function(datas,cindex){return _c('div',{key:cindex,staticClass:"tr row-block"},[_c('div',{staticClass:"container-block row-block"},[_c('div',{staticClass:"td center-block",style:({ width: '140px' })},[_c('span',{attrs:{"title":datas[0].caseData.case_id}},[_vm._v(_vm._s(datas[0].caseData.case_id))])]),_vm._v(" "),_c('div',{staticClass:"td center-block",class:[datas[0].state || 'none'],style:({ width: '102px' })},[_c('span',[_vm._v(_vm._s(_vm.getGroupState(datas)))])]),_vm._v(" "),(!['error', 'completed'].includes(datas[0].state))?_c('div',{staticClass:"icon td center-block",style:({ flex: 1 }),on:{"click":function (e) { return _vm.deleteGroup(datas); }}},[_c('img',{attrs:{"src":__webpack_require__("rafa"),"alt":""}})]):_c('div',{style:({ flex: 1 })})])])}),0)])])])}
var gcsResumable_staticRenderFns = []
var gcsResumable_esExports = { render: gcsResumable_render, staticRenderFns: gcsResumable_staticRenderFns }
/* harmony default export */ var tool_gcsResumable = (gcsResumable_esExports);
// CONCATENATED MODULE: ./src/components/tool/gcsResumable.vue
function injectStyle (ssrContext) {
  __webpack_require__("8XLC")
}
var gcsResumable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var gcsResumable___vue_template_functional__ = false
/* styles */
var gcsResumable___vue_styles__ = injectStyle
/* scopeId */
var gcsResumable___vue_scopeId__ = "data-v-2960dbbc"
/* moduleIdentifier (server only) */
var gcsResumable___vue_module_identifier__ = null
var gcsResumable_Component = gcsResumable_normalizeComponent(
  gcsResumable,
  tool_gcsResumable,
  gcsResumable___vue_template_functional__,
  gcsResumable___vue_styles__,
  gcsResumable___vue_scopeId__,
  gcsResumable___vue_module_identifier__
)

/* harmony default export */ var components_tool_gcsResumable = (gcsResumable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/fileUpload.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var layout_fileUpload = ({
  components: {
    gcsResumable: components_tool_gcsResumable
  },
  data: function data() {
    return {
      count: 0,
      compeleted: 0
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isFileUpload', 'uploadCount'])),
  watch: {
    'count': function count(nv, ov) {
      this.setUnloadAlertAction(this.count > this.compeleted);
    },
    'compeleted': function compeleted(nv, ov) {
      this.setUnloadAlertAction(this.count > this.compeleted);
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setFileUploadAction', 'addUploadCountAction', 'setUnloadAlertAction']), {
    fileUploadOpen: function fileUploadOpen() {
      // if (!this.isFileUpload) {
      //   this.addUploadCountAction(false)
      // }
      this.setFileUploadAction(!this.isFileUpload);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73a1e61a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/fileUpload.vue
var fileUpload_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ open: _vm.isFileUpload },attrs:{"id":"file-upload"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.count),expression:"count"}],staticClass:"file-container col-block"},[_c('div',{staticClass:"title-container row-block",on:{"click":function (e) { return _vm.fileUploadOpen(); }}},[_c('div',{staticClass:"title-icon center-block"},[_c('img',{attrs:{"src":_vm.isFileUpload ? __webpack_require__("WGo8") : __webpack_require__("nfOD"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.isFileUpload ? '(' + _vm.compeleted + '/' + _vm.count + ')' : _vm.compeleted + '/' + _vm.count))]),_vm._v(" "),(_vm.isFileUpload)?_c('div',{style:({ flex: 1 })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"display-icon",class:{ active: _vm.isFileUpload }},[_c('img',{attrs:{"src":_vm.isFileUpload ? __webpack_require__("prJ5") : __webpack_require__("9odj"),"alt":""}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFileUpload),expression:"isFileUpload"}],staticClass:"gcs-container"},[_c('gcsResumable',{on:{"count":function () { return _vm.count += 1; },"cancel":function (c) {
          _vm.count -= 1
          if (c) {
            _vm.compeleted -= 1
          }
        },"complete":function () { return _vm.compeleted += 1; }}})],1)])])}
var fileUpload_staticRenderFns = []
var fileUpload_esExports = { render: fileUpload_render, staticRenderFns: fileUpload_staticRenderFns }
/* harmony default export */ var components_layout_fileUpload = (fileUpload_esExports);
// CONCATENATED MODULE: ./src/components/layout/fileUpload.vue
function fileUpload_injectStyle (ssrContext) {
  __webpack_require__("OoZE")
}
var fileUpload_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var fileUpload___vue_template_functional__ = false
/* styles */
var fileUpload___vue_styles__ = fileUpload_injectStyle
/* scopeId */
var fileUpload___vue_scopeId__ = "data-v-73a1e61a"
/* moduleIdentifier (server only) */
var fileUpload___vue_module_identifier__ = null
var fileUpload_Component = fileUpload_normalizeComponent(
  layout_fileUpload,
  components_layout_fileUpload,
  fileUpload___vue_template_functional__,
  fileUpload___vue_styles__,
  fileUpload___vue_scopeId__,
  fileUpload___vue_module_identifier__
)

/* harmony default export */ var src_components_layout_fileUpload = (fileUpload_Component.exports);

// EXTERNAL MODULE: ./src/mixins/licenseManager.vue + 1 modules
var licenseManager = __webpack_require__("K1x3");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/loading.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var dialog_loading = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44ebe78c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/loading.vue
var dialog_loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-dialog"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})])])}
var dialog_loading_staticRenderFns = []
var dialog_loading_esExports = { render: dialog_loading_render, staticRenderFns: dialog_loading_staticRenderFns }
/* harmony default export */ var components_dialog_loading = (dialog_loading_esExports);
// CONCATENATED MODULE: ./src/components/dialog/loading.vue
var dialog_loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dialog_loading___vue_template_functional__ = false
/* styles */
var dialog_loading___vue_styles__ = null
/* scopeId */
var dialog_loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dialog_loading___vue_module_identifier__ = null
var dialog_loading_Component = dialog_loading_normalizeComponent(
  dialog_loading,
  components_dialog_loading,
  dialog_loading___vue_template_functional__,
  dialog_loading___vue_styles__,
  dialog_loading___vue_scopeId__,
  dialog_loading___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_loading = (dialog_loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/container.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var container = ({
  components: {
    dialogLoading: src_components_dialog_loading
  },
  props: {
    width: {
      type: String,
      default: function _default() {
        return '400px';
      }
    },
    height: {
      type: String,
      default: function _default() {
        return 'auto';
      }
    },
    customStyles: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    maskClose: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      onClose: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isDialogLoading']), {
    containerStyle: function containerStyle() {
      return extends_default()({}, this.customStyles, { height: this.height, width: this.width });
    }
  }),
  methods: {
    closeModal: function closeModal(e, type) {
      if (this.maskClose) {
        if (!['modal-mask', 'modal-wrapper'].includes(e.target.className)) {
          this.onClose = false;
          return;
        }
        if (type === 'down') {
          this.onClose = true;
        } else if (this.onClose) {
          this.$emit('hide');
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61a6f74b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/container.vue
var container_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",on:{"mousedown":function (e) { return _vm.closeModal(e, 'down'); },"mouseup":function (e) { return _vm.closeModal(e, 'up'); }}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",style:(_vm.containerStyle)},[_vm._t("default"),_vm._v(" "),(_vm.isDialogLoading)?_c('dialogLoading'):_vm._e()],2)])])])}
var container_staticRenderFns = []
var container_esExports = { render: container_render, staticRenderFns: container_staticRenderFns }
/* harmony default export */ var dialog_container = (container_esExports);
// CONCATENATED MODULE: ./src/components/dialog/container.vue
function container_injectStyle (ssrContext) {
  __webpack_require__("02u3")
}
var container_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var container___vue_template_functional__ = false
/* styles */
var container___vue_styles__ = container_injectStyle
/* scopeId */
var container___vue_scopeId__ = "data-v-61a6f74b"
/* moduleIdentifier (server only) */
var container___vue_module_identifier__ = null
var container_Component = container_normalizeComponent(
  container,
  dialog_container,
  container___vue_template_functional__,
  container___vue_styles__,
  container___vue_scopeId__,
  container___vue_module_identifier__
)

/* harmony default export */ var components_dialog_container = (container_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./src/components/tool/customForm.vue + 2 modules
var customForm = __webpack_require__("uuH9");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/userConfirm.vue









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var userConfirm = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */], loginData["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      confirmData: {
        code: ''
      },
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },

    // static
    formOptions: function formOptions() {
      var _this2 = this;

      return {
        field1: [{
          title: this.$t('DIALOG.userConfirm.form.title.___code'),
          value: 'code',
          type: 'input',
          placeholder: function placeholder() {
            return _this2.$t('DIALOG.userConfirm.form.placeholder.___code');
          },
          validate: 'required'
        }]
      };
    }
  },
  methods: {
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.confirmData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    validateConfirmUser: function validateConfirmUser() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};

                _this3.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this3.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 15;
                  break;
                }

                kv = _step2.value;
                _context.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context.next = 7;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError2) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                result['custom'] = _this3.customValidate();

                if (values_default()(result).includes(false)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 33;
                return _this3.confirmUser();

              case 33:
                _this3.onSubmit = false;

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    confirmUser: function confirmUser() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var data, response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                data = extends_default()({}, _this4.result, {
                  email: _this4.param.data.email
                });
                _context2.next = 4;
                return Object(src_api["_105" /* postConfirmUser */])(data);

              case 4:
                response = _context2.sent;

                _this4.setUserData(response);
                _this4.addToast('success', response.data.result.message);
                _this4.$router.push(_this4.$route.query.redirect ? { path: _this4.$route.query.redirect } : { name: 'caseList' });
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                _this4.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.result.message);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 10]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70ac1058","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/userConfirm.vue
var userConfirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-confirm-dailog dialog col-block"},[_c('div',{staticClass:"title-container col-block"},[_c('div',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.userConfirm.___mainTitle')))])]),_vm._v(" "),_c('div',{style:({ height: '14px' })}),_vm._v(" "),_c('div',{staticClass:"title-container col-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('DIALOG.userConfirm.___title01')))]),_vm._v(" "),_c('div',{style:({ height: '0.3rem' })}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('DIALOG.userConfirm.___title02')))])]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.confirmData,"alerts":_vm.alerts,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '16px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit ? _vm.validateConfirmUser() : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___confirm')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var userConfirm_staticRenderFns = []
var userConfirm_esExports = { render: userConfirm_render, staticRenderFns: userConfirm_staticRenderFns }
/* harmony default export */ var dialog_userConfirm = (userConfirm_esExports);
// CONCATENATED MODULE: ./src/components/dialog/userConfirm.vue
var userConfirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var userConfirm___vue_template_functional__ = false
/* styles */
var userConfirm___vue_styles__ = null
/* scopeId */
var userConfirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var userConfirm___vue_module_identifier__ = null
var userConfirm_Component = userConfirm_normalizeComponent(
  userConfirm,
  dialog_userConfirm,
  userConfirm___vue_template_functional__,
  userConfirm___vue_styles__,
  userConfirm___vue_scopeId__,
  userConfirm___vue_module_identifier__
)

/* harmony default export */ var components_dialog_userConfirm = (userConfirm_Component.exports);

// EXTERNAL MODULE: ./src/constants/global/data.js
var global_data = __webpack_require__("x2hU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/editWorkgroupMember.vue









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var editWorkgroupMember = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      members: [],
      member: {
        role: 'Member'
      },
      users: [],
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },
    roleOptions: function roleOptions() {
      var _this2 = this;

      var workgroupRoleMap = global_data["_0" /* workgroupRoleOptions */].reduce(function (map, option) {
        return extends_default()({}, map, defineProperty_default()({}, option.value, option));
      }, {});
      return this.param.editableRoles.map(function (role) {
        var option = workgroupRoleMap[role];
        return { title: _this2.$t(option.title), value: option.value };
      });
    },

    // static
    formOptions: function formOptions() {
      var _this3 = this;

      return {
        field1: [{
          title: this.member.user_id ? this.$t('DIALOG.editWorkgroupMember.form.title.___member') : this.$t('DIALOG.editWorkgroupMember.form.title.___newMember'),
          value: 'email',
          type: this.member.user_id ? 'text' : 'input',
          placeholder: function placeholder() {
            return _this3.$t('DIALOG.editWorkgroupMember.form.placeholder.___member');
          },
          wrap: true,
          textDisplay: function textDisplay(value) {
            return value ? '<span>' + [_this3.member.first_name, _this3.member.last_name].filter(function (x) {
              return x;
            }).join(' ') + ' (</span><span style=color:#006ED6;>' + value + '</span>)' : value;
          },
          validate: this.member.user_id ? '' : 'required'
        }],
        field2: [{
          title: this.$t('DIALOG.editWorkgroupMember.form.title.___role'),
          value: 'role',
          type: 'select',
          options: this.roleOptions,
          placeholder: function placeholder() {
            return _this3.$t('DIALOG.editWorkgroupMember.form.placeholder.___role');
          },
          validate: 'required'
        }]
      };
    }
  },
  created: function created() {
    var member = this.param.member || this.member;
    this.members = (this.param.members || []).filter(function (m) {
      return m.email !== member.email;
    });
    this.member = member;
  },

  methods: {
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.member)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    validateSendMember: function validateSendMember() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};

                _this4.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this4.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 15;
                  break;
                }

                kv = _step2.value;
                _context.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context.next = 7;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError2) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                result['custom'] = _this4.customValidate();

                if (values_default()(result).includes(false)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 33;
                return _this4.sendMember();

              case 33:
                _this4.onSubmit = false;

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    sendMember: function sendMember() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, id, params, response, memberData, _memberData;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (_this5.members.some(function (member) {
                  return _this5.result.email === member.email;
                })) {
                  _context2.next = 19;
                  break;
                }

                config = _this5.$ls.get('userInfo');
                id = _this5.param.workgroup.id;
                params = extends_default()({}, _this5.result);

                if (id) {
                  params.workgroup_id = id;
                }

                if (_this5.member.user_id) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 9;
                return Object(src_api["_85" /* getWorkgroupCheckMember */])(params, config);

              case 9:
                response = _context2.sent;
                memberData = response.data.data;

                memberData = extends_default()({}, memberData, {
                  user_id: memberData.id
                });
                _this5.$emit('changeModal', {}, memberData);
                _context2.next = 17;
                break;

              case 15:
                _memberData = extends_default()({}, _this5.member, _this5.result);

                _this5.$emit('changeModal', {}, _memberData);

              case 17:
                _context2.next = 20;
                break;

              case 19:
                throw new Error(_this5.$t('COMMON.toast.___workgroupMemberExist'));

              case 20:
                _context2.next = 25;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2['catch'](0);

                _this5.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.result.message);

              case 25:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[0, 22]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38eca6c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/editWorkgroupMember.vue
var editWorkgroupMember_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-workgroup-member-dailog dialog col-block"},[_c('customForm',{attrs:{"init":_vm.member,"alerts":_vm.alerts,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.member,"alerts":_vm.alerts,"forms":_vm.formOptions['field2']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field2', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit ? _vm.validateSendMember() : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.member.user_id ? _vm.$t('COMMON.button.___update') : _vm.$t('COMMON.button.___add')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var editWorkgroupMember_staticRenderFns = []
var editWorkgroupMember_esExports = { render: editWorkgroupMember_render, staticRenderFns: editWorkgroupMember_staticRenderFns }
/* harmony default export */ var dialog_editWorkgroupMember = (editWorkgroupMember_esExports);
// CONCATENATED MODULE: ./src/components/dialog/editWorkgroupMember.vue
var editWorkgroupMember_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editWorkgroupMember___vue_template_functional__ = false
/* styles */
var editWorkgroupMember___vue_styles__ = null
/* scopeId */
var editWorkgroupMember___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editWorkgroupMember___vue_module_identifier__ = null
var editWorkgroupMember_Component = editWorkgroupMember_normalizeComponent(
  editWorkgroupMember,
  dialog_editWorkgroupMember,
  editWorkgroupMember___vue_template_functional__,
  editWorkgroupMember___vue_styles__,
  editWorkgroupMember___vue_scopeId__,
  editWorkgroupMember___vue_module_identifier__
)

/* harmony default export */ var components_dialog_editWorkgroupMember = (editWorkgroupMember_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./src/components/tool/pageButtons.vue + 2 modules
var pageButtons = __webpack_require__("+kXL");

// EXTERNAL MODULE: ./src/components/tool/newBorCor.vue + 2 modules
var newBorCor = __webpack_require__("jHy4");

// EXTERNAL MODULE: ./src/mixins/routeLoading.vue + 1 modules
var routeLoading = __webpack_require__("zVZS");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/editWorkgroupCase.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var editWorkgroupCase = ({
  components: {
    pageButtons: pageButtons["a" /* default */],
    borCor: newBorCor["a" /* default */]
  },
  mixins: [routeLoading["a" /* default */], responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      // data
      cases: [],
      selectedCaseIDs: [],
      disabledCaseIDs: [],
      // table
      query: '',
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [[50], [62, 62, 134, 134, 115, 124]],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // page
      displayPage: 1,
      pageData: {
        selectedPage: 1,
        display: 25,
        total: null,
        buttonRange: 7,
        pageJumpTo: ''
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user', 'userSetting']), {
    filtedDatas: function filtedDatas() {
      var _this = this;

      var filtedDatas = this.cases;
      var selectedCaseIDMap = this.param.selectedCases.reduce(function (map, caseData) {
        return extends_default()({}, map, defineProperty_default()({}, caseData.id, caseData));
      }, {});
      filtedDatas = filtedDatas.filter(function (data) {
        return data.case_id.includes(_this.query) && !selectedCaseIDMap[data.id];
      });
      return filtedDatas;
    },
    tableFiltedDatas: function tableFiltedDatas() {
      var _this2 = this;

      var tableFiltedDatas = this.filtedDatas;
      tableFiltedDatas = Object(util["m" /* sortData */])(tableFiltedDatas, this.sort.value.map(function (x) {
        return _this2.sortMap[x];
      }), this.sort.order.map(function (x) {
        return x.replace('-', '');
      }));
      tableFiltedDatas = tableFiltedDatas.filter(function (data, index) {
        var dataIndex = index - (_this2.displayPage - 1) * _this2.pageData.display;
        return dataIndex >= 0 && dataIndex < _this2.pageData.display;
      });
      return tableFiltedDatas;
    },
    tableDatas: function tableDatas() {
      var tableDatas = this.tableFiltedDatas;
      tableDatas = Object(util["i" /* groupBy */])(tableDatas, function () {
        return 'default';
      }).map(function (datas) {
        return { title: datas[0].group, isGroup: true, datas: datas };
      });
      return tableDatas;
    },
    selectedCases: function selectedCases() {
      var caseIDMap = this.cases.reduce(function (map, caseData) {
        return extends_default()({}, map, defineProperty_default()({}, caseData.id, { id: caseData.id, case_id: caseData.case_id }));
      }, {});
      return this.selectedCaseIDs.filter(function (id) {
        return caseIDMap[id];
      }).map(function (id) {
        return caseIDMap[id];
      });
    },
    allCaseDatas: function allCaseDatas() {
      var _this3 = this;

      return this.filtedDatas.filter(function (caseData) {
        return !_this3.disabledCaseIDs.includes(caseData.id);
      });
    },
    caseDatas: function caseDatas() {
      var _this4 = this;

      return this.tableFiltedDatas.filter(function (caseData) {
        return !_this4.disabledCaseIDs.includes(caseData.id);
      });
    },
    caseDataIDs: function caseDataIDs() {
      return this.caseDatas.map(function (caseData) {
        return caseData.id;
      });
    },
    sortMap: function sortMap() {
      return this.tableOptions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortMap || c.value));
      }, {});
    },
    sortValue: function sortValue() {
      return this.tableOptions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortValue || c.value));
      }, {});
    },
    totalPage: function totalPage() {
      return Math.ceil(Math.min(this.pageData.total, this.pageData.display * 5000) / this.pageData.display);
    },

    // static
    tableOptions: function tableOptions() {
      var _this5 = this;

      return [{
        value: '_SELECT',
        class: function _class() {
          return ['center'];
        },
        sortMap: null
      }, {
        title: this.$t('DIALOG.editWorkgroupCase.table.title.___Case_ID'),
        value: 'case_id'
      }, {
        title: this.$t('DIALOG.editWorkgroupCase.table.title.___Sex'),
        value: 'sex',
        class: function _class() {
          return ['center'];
        },
        display: function display(value) {
          return {
            Male: _this5.$t('COMPONENT.caseList.single.table.display.sex.___Male'),
            Female: _this5.$t('COMPONENT.caseList.single.table.display.sex.___Female'),
            Unknown: _this5.$t('COMPONENT.caseList.single.table.display.sex.___Unknown')
          }[value];
        },
        style: function style(value) {
          return { Male: { color: '#003679' }, Female: { color: '#BE0F0F' }, Unknown: { color: '#333333' } }[value];
        }
      }, {
        title: this.$t('DIALOG.editWorkgroupCase.table.title.___Age'),
        value: 'birth_year',
        class: function _class() {
          return ['center'];
        },
        display: function display(value) {
          return value ? new Date().getFullYear() - value + '' : null;
        }
      }, {
        title: this.$t('DIALOG.editWorkgroupCase.table.title.___Created_date'),
        value: 'created_at',
        display: function display(value) {
          return value ? Object(util["d" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : null;
        }
      }, {
        title: this.$t('DIALOG.editWorkgroupCase.table.title.___Modified_date'),
        value: 'updated_at',
        display: function display(value) {
          return value ? Object(util["d" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : null;
        }
      }, {
        title: this.$t('DIALOG.editWorkgroupCase.table.title.___Stage'),
        value: 'stage'
      }, {
        title: this.$t('DIALOG.editWorkgroupCase.table.title.___Workgroup'),
        value: 'workgroup_name'
      }];
    },

    // global
    pageDisplay: function pageDisplay() {
      return global_data["F" /* pageDisplay */];
    }
  }),
  watch: {
    'query': function query(nv) {
      this.searchDatas(true);
    },
    'filtedDatas': function filtedDatas(nv) {
      this.pageData.total = nv.length - 0;
    },
    'pageData.selectedPage': function pageDataSelectedPage() {
      var _this6 = this;

      if (this.pageData.selectedPage) {
        this.displayPage = this.pageData.selectedPage;
        setTimeout(function () {
          _this6.pageData.selectedPage = 0;
        });
        this.searchDatas();
      }
    },

    // table
    'tableDatas': function tableDatas() {
      this.getTableOverflow();
    },
    'windowWidth': function windowWidth(nv) {
      this.getTableWidths(nv);
      this.getTableOverflow();
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModal2Action']), {
    fetchData: function fetchData() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this7.fetchCases(true);

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this7);
      }))();
    },
    fetchCases: function fetchCases() {
      var _this8 = this;

      var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, params, response, cases;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this8.$ls.get('userInfo');
                params = {};

                if (['supervisor'].includes(_this8.user.role) && _this8.param.workgroup.user.user_id !== _this8.user.user_id) {
                  params.user_id = _this8.param.workgroup.user.user_id;
                }
                _context2.next = 6;
                return Object(src_api["_84" /* getWorkgroupCases */])(params, config);

              case 6:
                response = _context2.sent;
                cases = response.data.data;

                _this8.disabledCaseIDs = cases.filter(function (caseData) {
                  return caseData.workgroup_name;
                }).map(function (caseData) {
                  return caseData.id;
                });
                _this8.cases = cases;
                return _context2.abrupt('return', _this8.cases);

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](0);

                if (!init) {
                  _context2.next = 19;
                  break;
                }

                throw _context2.t0;

              case 19:
                _this8.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.result.message);

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8, [[0, 13]]);
      }))();
    },
    searchDatas: function searchDatas() {
      var _this9 = this;

      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // this.setLoadingAction(true)
                reset && (_this9.displayPage = 1);
                // await this.fetchCases()
                // this.setLoadingAction(false)

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this9);
      }))();
    },
    addAllCase: function addAllCase() {
      var _this10 = this;

      if (!this.param.result['auto_share_cases_to_workgroup'] && !(this.userSetting.auto_share_cases_to_workgroup && this.userSetting.auto_share_cases_to_workgroup !== this.param.workgroup.id)) {
        this.setModal2Action({
          action: 'toast',
          width: '496px',
          customStyles: {
            padding: 0,
            border: 0
          },
          param: {
            type: 'normal',
            content: this.$t('DIALOG.editWorkgroupCase.modal.content.___checkAutoShare'),
            buttons: [{
              title: this.$t('COMMON.button.___yes'),
              type: 'main',
              result: true
            }, {
              title: this.$t('COMMON.button.___no'),
              type: 'gray',
              result: false
            }]
          },
          callback: function () {
            var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(result) {
              return regenerator_default.a.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _this10.$emit('changeModal', {}, { datas: _this10.allCaseDatas, autoShare: !!result });

                    case 1:
                    case 'end':
                      return _context4.stop();
                  }
                }
              }, _callee4, _this10);
            }));

            return function callback(_x3) {
              return _ref.apply(this, arguments);
            };
          }()
        });
      } else {
        this.$emit('changeModal', {}, { datas: this.allCaseDatas });
      }
    },

    // table
    getTableOverflow: function getTableOverflow() {
      var _this11 = this;

      setTimeout(function () {
        var scrollContainer = _this11.$refs['custom-table-scroll'];
        if (scrollContainer) {
          _this11.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight;
        }
      });
    },
    getTableWidths: function getTableWidths(windowWidth) {
      var tableWidth = Math.min(912, windowWidth * 0.95) - 22 * 2;
      tableWidth = tableWidth - this.staticTableWidths[0].reduce(function (s, c) {
        return s + c;
      }, 0) - this.staticTableWidths[1].reduce(function (s, c) {
        return s + c;
      }, 0);
      var tableWidths = this.tableWidths || [].concat(toConsumableArray_default()(this.staticTableWidths[0]), [192], toConsumableArray_default()(this.staticTableWidths[1])).map(function (width) {
        return {
          value: width
        };
      });
      var tableMinWidths = this.tableMinWidths || 0.1;
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length);
      var ratio = tableWidth / tableWidths.reduce(function (s, c) {
        return s + c.value;
      }, 0);
      tableWidths = Array.prototype.concat.apply([], [this.staticTableWidths[0].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      }), tableWidths.map(function (width) {
        return {
          value: width.value * ratio,
          grab: 0
        };
      }), this.staticTableWidths[1].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      })]);
      this.tableMinWidths = tableMinWidths * ratio;
      this.tableWidths = tableWidths;
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
      this.searchDatas();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cab6158","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/editWorkgroupCase.vue
var editWorkgroupCase_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-workgroup-case-dailog dialog col-block"},[_c('div',{staticClass:"edit-workgroup-case-title-container col-block width-full"},[_c('div',{staticClass:"edit-workgroup-case-title-block row-block"},[_c('div',{staticClass:"edit-workgroup-case-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.editWorkgroupCase.___title')))]),_vm._v(" "),_c('div',{staticClass:"edit-workgroup-case-alert"},[_vm._v(" *")]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"edit-workgroup-case-info"},[_vm._v(_vm._s('(' + _vm.$tc('DIALOG.editWorkgroupCase.___info', _vm.selectedCaseIDs.length, { count: _vm.selectedCaseIDs.length }) + ')'))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.addAllCase(); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___addAll')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"edit-workgroup-case-option-container row-block"},[_c('div',{staticClass:"edit-workgroup-case-search-container input-group",style:({ width: '478px' })},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],style:({ 'padding-right': '40px' }),attrs:{"type":"text","placeholder":_vm.$t('DIALOG.editWorkgroupCase.___searchPlaceholder')},domProps:{"value":(_vm.query)},on:{"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zSkq"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"custom-table",class:{ 'auto-height': false }},[(_vm.tableWidths)?_c('div',{staticClass:"table-field col-block grab-container",style:({ width: _vm.tableWidths.reduce(function (s, c) { return s + c.value + c.grab; }, 0) + 'px' })},[_c('div',{staticClass:"table-container col-block"},[_c('div',{staticClass:"thead"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab + 'px' }),on:{"click":function (e) { return !_vm.sort.disabled && option.sortMap !== null && _vm.tableSortBy(option.value); }}},[(option.value === '_SELECT')?[_c('img',{staticClass:"select-icon",attrs:{"src":(_vm.selectedCaseIDs.concat(_vm.caseDataIDs).filter(function (x, i, s) { return s.indexOf(x) === i; }).length - _vm.selectedCaseIDs.length < _vm.caseDataIDs.length) ? (_vm.selectedCaseIDs.concat(_vm.caseDataIDs).filter(function (x, i, s) { return s.indexOf(x) === i; }).length === _vm.selectedCaseIDs.length) ? __webpack_require__("7kqe") : __webpack_require__("Z77G") : __webpack_require__("5Ivo")},on:{"click":function (e) { return (_vm.selectedCaseIDs = (_vm.selectedCaseIDs.concat(_vm.caseDataIDs).filter(function (x, i, s) { return s.indexOf(x) === i; }).length === _vm.selectedCaseIDs.length) ? [] : _vm.selectedCaseIDs.concat(_vm.caseDataIDs).filter(function (x, i, s) { return s.indexOf(x) === i; })); }}})]:[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))])],_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e()],2)}),0)])]),_vm._v(" "),_c('div',{ref:"custom-table-scroll",staticClass:"table-group-container col-block width-full"},[_c('div',{staticClass:"col-block"},_vm._l((_vm.tableDatas),function(group,gindex){return _c('div',{key:gindex,staticClass:"table-container col-block"},[_c('div',{staticClass:"tbody"},[_c('div',{staticClass:"tr group row-block",class:{ selected: false },style:(group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' })},[_c('a',{staticClass:"container-block row-block"},[_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(group[option.gValue], gindex, group),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.gstyle || (function () { return ({}); }))(group[option.gValue], gindex, group)),attrs:{"title":((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || option.gempty || '')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('center') && !(option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)]),_vm._v(" "),_vm._l((group.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"tr col-block",class:{ selectable: false, selected: false, disabled: _vm.disabledCaseIDs.includes(data.id) }},[_c('a',{staticClass:"container-block row-block",style:({ flex: 1 }),on:{"click":function (e) {}}},[_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(data[option.value], dindex, data),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[_c('div',{staticClass:"disabled-mask"}),_vm._v(" "),(option.value === '_SELECT')?[_c('borCor',{attrs:{"display":_vm.disabledCaseIDs.includes(data.id) ? null : false,"background":'white',"border":'#707070',"radius":'0px',"type":'right',"reverse":true,"blockStyle":{ padding: '6px 8px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{staticClass:"select-icon",attrs:{"src":(_vm.selectedCaseIDs.includes(data.id) || _vm.disabledCaseIDs.includes(data.id)) ? __webpack_require__("7kqe") : __webpack_require__("5Ivo")},on:{"click":function (e) { return (_vm.selectedCaseIDs = _vm.selectedCaseIDs.includes(data.id) ? _vm.selectedCaseIDs.filter(function (id) { return id !== data.id; }) : _vm.selectedCaseIDs.concat([data.id])); }}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"disabled-alert",domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.editWorkgroupCase.table.alert.___added'))}})])])]:[_c('span',{style:((option.style || (function () { return ({}); }))(data[option.value], dindex, data)),attrs:{"title":((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || option.empty || '- -')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(data[option.value], dindex, data).includes('center') && !(option.class || (function () { return []; }))(data[option.value], dindex, data).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)])})],2)])}),0)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"page-container row-block",style:({ height: '50px' })},[_c('div',{staticClass:"page-info-field row-block"},[(_vm.pageData.total !== null)?_c('div',{staticClass:"page-info-container",style:({ flex: 1 }),domProps:{"innerHTML":_vm._s(_vm.$tc('DIALOG.editWorkgroupCase.table.pageDisplay.___item', _vm.pageData.total))}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"options-container input-group row-block"},[(_vm.pageData.total)?_c('pageButtons',{style:({ flex: 1 }),attrs:{"default":_vm.pageData.selectedPage,"display":_vm.pageData.display - 0,"total":_vm.pageData.total,"buttonRange":_vm.pageData.buttonRange},on:{"selectPage":function (page) { _vm.pageData.selectedPage = page }}}):_vm._e(),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"jump-container row-block"},[_c('div',{staticClass:"jump-title"},[_vm._v(_vm._s(_vm.$t(_vm.pageDisplay.page)))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pageData.pageJumpTo),expression:"pageData.pageJumpTo"}],staticClass:"jump",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.pageData, "pageJumpTo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function (e) { return _vm.pageData.selectedPage = _vm.pageData.pageJumpTo - 0; }]}},_vm._l(((new Array(_vm.totalPage)).fill('').map(function (_, i) { return i + 1; })),function(value,index){return _c('option',{key:index,domProps:{"value":value}},[_vm._v(_vm._s(value))])}),0)])],1)]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, { datas: _vm.selectedCases }); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___add')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var editWorkgroupCase_staticRenderFns = []
var editWorkgroupCase_esExports = { render: editWorkgroupCase_render, staticRenderFns: editWorkgroupCase_staticRenderFns }
/* harmony default export */ var dialog_editWorkgroupCase = (editWorkgroupCase_esExports);
// CONCATENATED MODULE: ./src/components/dialog/editWorkgroupCase.vue
var editWorkgroupCase_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editWorkgroupCase___vue_template_functional__ = false
/* styles */
var editWorkgroupCase___vue_styles__ = null
/* scopeId */
var editWorkgroupCase___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editWorkgroupCase___vue_module_identifier__ = null
var editWorkgroupCase_Component = editWorkgroupCase_normalizeComponent(
  editWorkgroupCase,
  dialog_editWorkgroupCase,
  editWorkgroupCase___vue_template_functional__,
  editWorkgroupCase___vue_styles__,
  editWorkgroupCase___vue_scopeId__,
  editWorkgroupCase___vue_module_identifier__
)

/* harmony default export */ var components_dialog_editWorkgroupCase = (editWorkgroupCase_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/editWorkgroupStage.vue










//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var editWorkgroupStage = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      stages: [],
      stage: {},
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },
    assigneeOptions: function assigneeOptions() {
      var assigneeMap = this.stages.reduce(function (map, stage) {
        return extends_default()({}, map, defineProperty_default()({}, stage.assignee, stage));
      }, {});
      var noneOptions = [{ title: '- -', value: 'none' }];
      return [].concat(noneOptions, toConsumableArray_default()((this.param.members || []).map(function (member) {
        var value = [member.first_name, member.last_name].filter(function (x) {
          return x;
        }).join(' ') + (' (' + member.email + ')');
        return { title: value, value: value };
      }).filter(function (option) {
        return !assigneeMap[option.value];
      })));
    },

    // static
    formOptions: function formOptions() {
      var _this2 = this;

      return {
        field1: [{
          title: this.stage.stage ? this.$t('DIALOG.editWorkgroupStage.form.title.___stage') : this.$t('DIALOG.editWorkgroupStage.form.title.___newStage'),
          value: 'stage',
          type: 'input',
          placeholder: function placeholder() {
            return _this2.$t('DIALOG.editWorkgroupStage.form.placeholder.___stage');
          },
          validate: 'required|max:20'
        }],
        field2: [{
          title: this.$t('DIALOG.editWorkgroupStage.form.title.___assignee'),
          value: 'assignee',
          type: 'select',
          options: this.assigneeOptions,
          hidden: 'value',
          coverTextDisplay: function coverTextDisplay(value) {
            return value ? value !== 'none' ? value.replace(/\(([^()]+)\)/, ' (<span style=color:#006ED6;>$1</span>)') : '- -' : null;
          },
          placeholder: function placeholder() {
            return _this2.$t('DIALOG.editWorkgroupStage.form.placeholder.___assignee');
          }
        }]
      };
    }
  },
  created: function created() {
    var stage = this.param.stage || this.stage;
    this.stages = (this.param.stages || []).filter(function (s) {
      return s.stage !== stage.stage;
    });
    this.stage = stage;
  },

  methods: {
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.stage)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    validateSendStage: function validateSendStage() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};

                _this3.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this3.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 15;
                  break;
                }

                kv = _step2.value;
                _context.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context.next = 7;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError2) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                result['custom'] = _this3.customValidate();

                if (values_default()(result).includes(false)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 33;
                return _this3.sendStage();

              case 33:
                _this3.onSubmit = false;

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    sendStage: function sendStage() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _result;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (_this4.stages.some(function (stage) {
                  return _this4.result.stage === stage.stage;
                })) {
                  _context2.next = 6;
                  break;
                }

                _result = extends_default()({}, _this4.result, {
                  assignee: _this4.result.assignee !== 'none' ? _this4.result.assignee : ''
                });

                _this4.$emit('changeModal', {}, _result);
                _context2.next = 7;
                break;

              case 6:
                throw new Error(_this4.$t('COMMON.toast.___workgroupStageExist'));

              case 7:
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                _this4.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.result.message);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 9]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cf8d52f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/editWorkgroupStage.vue
var editWorkgroupStage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-workgroup-stage-dailog dialog col-block"},[_c('customForm',{attrs:{"init":_vm.stage,"alerts":_vm.alerts,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.stage,"alerts":_vm.alerts,"forms":_vm.formOptions['field2']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field2', result, validate, errors); }},scopedSlots:_vm._u([{key:"assignee_cover",fn:function(props){return [_c('div',{staticClass:"assignee-cover container-block"},[(props.result)?_c('div',{staticClass:"assignee-content-container",domProps:{"innerHTML":_vm._s(props.form.coverTextDisplay(props.result))}}):_vm._e()])]}}])}),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit ? _vm.validateSendStage() : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.stage.stage ? _vm.$t('COMMON.button.___update') : _vm.$t('COMMON.button.___add')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var editWorkgroupStage_staticRenderFns = []
var editWorkgroupStage_esExports = { render: editWorkgroupStage_render, staticRenderFns: editWorkgroupStage_staticRenderFns }
/* harmony default export */ var dialog_editWorkgroupStage = (editWorkgroupStage_esExports);
// CONCATENATED MODULE: ./src/components/dialog/editWorkgroupStage.vue
var editWorkgroupStage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editWorkgroupStage___vue_template_functional__ = false
/* styles */
var editWorkgroupStage___vue_styles__ = null
/* scopeId */
var editWorkgroupStage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editWorkgroupStage___vue_module_identifier__ = null
var editWorkgroupStage_Component = editWorkgroupStage_normalizeComponent(
  editWorkgroupStage,
  dialog_editWorkgroupStage,
  editWorkgroupStage___vue_template_functional__,
  editWorkgroupStage___vue_styles__,
  editWorkgroupStage___vue_scopeId__,
  editWorkgroupStage___vue_module_identifier__
)

/* harmony default export */ var components_dialog_editWorkgroupStage = (editWorkgroupStage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/intractableDiseaseSelect.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var intractableDiseaseSelect = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selecteds: []
    };
  },

  computed: {
    intractableDiseaseDatas: function intractableDiseaseDatas() {
      var _this = this;

      return global_data["A" /* intractableDiseaseOptions */].filter(function (option) {
        return !_this.selectedDataValueMap[option.value];
      });
    },

    // param
    selectedDataValueMap: function selectedDataValueMap() {
      return this.param.selectedDatas.reduce(function (map, data) {
        return extends_default()({}, map, defineProperty_default()({}, data.value, data));
      }, {});
    },

    // global
    intractableDiseaseOptions: function intractableDiseaseOptions() {
      return global_data["A" /* intractableDiseaseOptions */].filter(function (option) {
        return option.type === 'D006-4';
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40873a62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/intractableDiseaseSelect.vue
var intractableDiseaseSelect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intractable-disease-select-dailog dialog col-block width-full"},[_c('div',{staticClass:"intractable-disease-select-title-container row-block"},[_c('div',{staticClass:"intractable-disease-select-title-icon-block row-block",class:{ disabled: _vm.param.selectedDatas.length === _vm.intractableDiseaseOptions.length },on:{"click":function (e) { return _vm.selecteds = (_vm.selecteds.length === _vm.intractableDiseaseDatas.length ? [] : _vm.intractableDiseaseDatas); }}},[_c('img',{staticClass:"intractable-disease-select-title-icon",attrs:{"src":(_vm.param.selectedDatas.length !== _vm.intractableDiseaseOptions.length) ? _vm.selecteds.length ? (_vm.selecteds.length === _vm.intractableDiseaseDatas.length) ? __webpack_require__("7kqe") : __webpack_require__("Z77G") : __webpack_require__("5Ivo") : __webpack_require__("7kqe")}})]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"intractable-disease-select-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.intractableDiseaseSelect.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"intractable-disease-select-item-field row-block flex-start flex-wrap",style:({ flex: 1, height: 0 })},_vm._l((_vm.intractableDiseaseOptions),function(option,oindex){return _c('div',{key:oindex,staticClass:"intractable-disease-select-item-container col-block width-full",class:{ disabled: _vm.selectedDataValueMap[option.value] }},[_c('div',{staticClass:"intractable-disease-select-item-mask"}),_vm._v(" "),_c('div',{staticClass:"intractable-disease-select-item-block row-block",on:{"click":function (e) { return _vm.selecteds = (_vm.selecteds.some(function (selected) { return selected.value === option.value; }) ? _vm.selecteds.filter(function (selected) { return selected.value !== option.value; }) : _vm.selecteds.concat([option])); }}},[_c('img',{staticClass:"intractable-disease-select-item-icon",attrs:{"src":(_vm.selecteds.some(function (selected) { return selected.value === option.value; }) || _vm.selectedDataValueMap[option.value]) ? __webpack_require__("7kqe") : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"intractable-disease-select-item-title ellipsis",style:({ flex: 1 }),attrs:{"title":_vm.$t(option.title)}},[_vm._v(_vm._s(_vm.$t(option.title)))])])])}),0),_vm._v(" "),_c('div',{style:({ height: '25px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, _vm.selecteds); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___create')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var intractableDiseaseSelect_staticRenderFns = []
var intractableDiseaseSelect_esExports = { render: intractableDiseaseSelect_render, staticRenderFns: intractableDiseaseSelect_staticRenderFns }
/* harmony default export */ var dialog_intractableDiseaseSelect = (intractableDiseaseSelect_esExports);
// CONCATENATED MODULE: ./src/components/dialog/intractableDiseaseSelect.vue
var intractableDiseaseSelect_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var intractableDiseaseSelect___vue_template_functional__ = false
/* styles */
var intractableDiseaseSelect___vue_styles__ = null
/* scopeId */
var intractableDiseaseSelect___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var intractableDiseaseSelect___vue_module_identifier__ = null
var intractableDiseaseSelect_Component = intractableDiseaseSelect_normalizeComponent(
  intractableDiseaseSelect,
  dialog_intractableDiseaseSelect,
  intractableDiseaseSelect___vue_template_functional__,
  intractableDiseaseSelect___vue_styles__,
  intractableDiseaseSelect___vue_scopeId__,
  intractableDiseaseSelect___vue_module_identifier__
)

/* harmony default export */ var components_dialog_intractableDiseaseSelect = (intractableDiseaseSelect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/genePanelInfo.vue









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var genePanelInfo = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */], responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      emailData: {
        email: '',
        name: '',
        organization: ''
      },
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },

    // static
    formOptions: function formOptions() {
      var _this2 = this;

      return {
        field1: [{
          title: this.$t('DIALOG.genePanelInfo.form.title.___name'),
          errorTitle: this.$t('DIALOG.genePanelInfo.form.errorTitle.___name'),
          value: 'name',
          type: 'input',
          grid: 6,
          placeholder: function placeholder() {
            return _this2.$t('DIALOG.genePanelInfo.form.placeholder.___name');
          },
          validate: 'required'
        }, {
          title: this.$t('DIALOG.genePanelInfo.form.title.___organization'),
          errorTitle: this.$t('DIALOG.genePanelInfo.form.errorTitle.___organization'),
          value: 'organization',
          type: 'input',
          grid: 6,
          placeholder: function placeholder() {
            return _this2.$t('DIALOG.genePanelInfo.form.placeholder.___organization');
          },
          validate: 'required'
        }, {
          title: this.$t('DIALOG.genePanelInfo.form.title.___email'),
          errorTitle: this.$t('DIALOG.genePanelInfo.form.errorTitle.___email'),
          value: 'email',
          type: 'input',
          grid: 6,
          placeholder: function placeholder() {
            return _this2.$t('DIALOG.genePanelInfo.form.placeholder.___email');
          },
          validate: 'required|email'
        }]
      };
    }
  },
  methods: {
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.emailData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    validateSendEmail: function validateSendEmail() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};

                _this3.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this3.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 15;
                  break;
                }

                kv = _step2.value;
                _context.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context.next = 7;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError2) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                result['custom'] = _this3.customValidate();

                if (values_default()(result).includes(false)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 33;
                return _this3.sendEmail();

              case 33:
                _this3.onSubmit = false;

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    sendEmail: function sendEmail() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.$emit('changeModal', {}, extends_default()({}, _this4.result));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e80c5a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/genePanelInfo.vue
var genePanelInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gene-panel-info-dailog dialog col-block"},[_c('div',{staticClass:"info-container col-block"},[_c('div',{staticClass:"info-block",domProps:{"innerHTML":_vm._s([
        _vm.$t('DIALOG.genePanelInfo.___info01'),
        _vm.$t('DIALOG.genePanelInfo.___info02')
      ].join(_vm.isMobile ? '<br>' : ' '))}}),_vm._v(" "),_c('div',{staticClass:"info-block",domProps:{"innerHTML":_vm._s([
        _vm.$t('DIALOG.genePanelInfo.___info03')
      ].join(_vm.isMobile ? '<br>' : ' '))}})]),_vm._v(" "),_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.emailData,"layoutType":'grid',"groupCount":6,"alerts":_vm.alerts,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit ? _vm.validateSendEmail() : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___enter')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var genePanelInfo_staticRenderFns = []
var genePanelInfo_esExports = { render: genePanelInfo_render, staticRenderFns: genePanelInfo_staticRenderFns }
/* harmony default export */ var dialog_genePanelInfo = (genePanelInfo_esExports);
// CONCATENATED MODULE: ./src/components/dialog/genePanelInfo.vue
var genePanelInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var genePanelInfo___vue_template_functional__ = false
/* styles */
var genePanelInfo___vue_styles__ = null
/* scopeId */
var genePanelInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var genePanelInfo___vue_module_identifier__ = null
var genePanelInfo_Component = genePanelInfo_normalizeComponent(
  genePanelInfo,
  dialog_genePanelInfo,
  genePanelInfo___vue_template_functional__,
  genePanelInfo___vue_styles__,
  genePanelInfo___vue_scopeId__,
  genePanelInfo___vue_module_identifier__
)

/* harmony default export */ var components_dialog_genePanelInfo = (genePanelInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/editPanel.vue









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var editPanel = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      panelData: {
        panel: ''
      },
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },

    // static
    formOptions: function formOptions() {
      var _this2 = this;

      return {
        field1: [{
          title: this.$t('DIALOG.editPanel.form.title.___panel'),
          value: 'panel',
          type: 'input',
          placeholder: function placeholder() {
            return _this2.$t('DIALOG.editPanel.form.placeholder.___panel');
          },
          validate: 'required'
        }]
      };
    }
  },
  created: function created() {
    var panelData = this.param.panel || this.panelData;
    this.panelData = panelData;
  },

  methods: {
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.panelData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    validateSendPanel: function validateSendPanel() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};

                _this3.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this3.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 15;
                  break;
                }

                kv = _step2.value;
                _context.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context.next = 7;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError2) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                result['custom'] = _this3.customValidate();

                if (values_default()(result).includes(false)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 33;
                return _this3.sendPanel();

              case 33:
                _this3.onSubmit = false;

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    sendPanel: function sendPanel() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, id, data, response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this4.$ls.get('userInfo');
                id = _this4.panelData.id;
                data = _this4.result;

                if (!id) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 7;
                return Object(src_api["_146" /* putPhenotypePanel */])(id, data, config);

              case 7:
                _context2.t0 = _context2.sent;
                _context2.next = 13;
                break;

              case 10:
                _context2.next = 12;
                return Object(src_api["_122" /* postPhenotypePanel */])(data, config);

              case 12:
                _context2.t0 = _context2.sent;

              case 13:
                response = _context2.t0;

                _this4.addToast('success', response.data.result.message);
                _this4.$emit('changeModal', {}, true);
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t1 = _context2['catch'](0);

                _this4.addToast('error', !_context2.t1.response ? _context2.t1.message : _context2.t1.response.data.result.message);

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 18]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ce7f60c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/editPanel.vue
var editPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-panel-dailog dialog col-block"},[_c('customForm',{attrs:{"init":_vm.panelData,"alerts":_vm.alerts,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit ? _vm.validateSendPanel() : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.panelData.id ? _vm.$t('COMMON.button.___update') : _vm.$t('COMMON.button.___add')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var editPanel_staticRenderFns = []
var editPanel_esExports = { render: editPanel_render, staticRenderFns: editPanel_staticRenderFns }
/* harmony default export */ var dialog_editPanel = (editPanel_esExports);
// CONCATENATED MODULE: ./src/components/dialog/editPanel.vue
var editPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editPanel___vue_template_functional__ = false
/* styles */
var editPanel___vue_styles__ = null
/* scopeId */
var editPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editPanel___vue_module_identifier__ = null
var editPanel_Component = editPanel_normalizeComponent(
  editPanel,
  dialog_editPanel,
  editPanel___vue_template_functional__,
  editPanel___vue_styles__,
  editPanel___vue_scopeId__,
  editPanel___vue_module_identifier__
)

/* harmony default export */ var components_dialog_editPanel = (editPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/addToPanel.vue









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var dialog_addToPanel = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      panelData: {
        selectedPanelID: '',
        newPanelName: ''
      },
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },
    selectedPhenotypePanel: function selectedPhenotypePanel() {
      var _this2 = this;

      return this.param.panels.find(function (panel) {
        return panel.id === _this2.result.selectedPanelID;
      });
    },

    // static
    formOptions: function formOptions() {
      var _this3 = this;

      return {
        field1: [{
          title: this.$t('DIALOG.addToPanel.form.title.___phenotype'),
          value: 'PHENOTYPE_HPO'
        }],
        field2: [{
          title: this.$t('DIALOG.addToPanel.form.title.___panel'),
          value: 'selectedPanelID',
          type: 'select',
          options: this.param.panels.filter(function (panel) {
            return !panel.phenotypes.some(function (phenotype) {
              return phenotype.id === _this3.param.phenotype.id;
            });
          }).map(function (panel) {
            return { title: panel.panel, value: panel.id };
          }),
          placeholder: function placeholder() {
            return _this3.$t('DIALOG.addToPanel.form.placeholder.___panel');
          }
        }],
        field3: [{
          title: this.$t('DIALOG.addToPanel.form.title.___newPanel'),
          value: 'newPanelName',
          type: 'input',
          placeholder: function placeholder() {
            return _this3.$t('DIALOG.addToPanel.form.placeholder.___newPanel');
          }
        }]
      };
    }
  },
  watch: {
    'result.selectedPanelID': function resultSelectedPanelID() {
      this.customValidate([], ['newPanelName']);
    },
    'result.newPanelName': function resultNewPanelName() {
      this.customValidate([], ['newPanelName']);
    }
  },
  methods: {
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var _this4 = this;

      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {
        newPanelName: function newPanelName(value) {
          if (!value && !_this4.result.selectedPanelID) {
            return {
              type: 'error',
              msg: _this4.$t('DIALOG.addToPanel.form.alert.newPanel.___required')
            };
          }
        }
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.panelData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    validateAddToPanel: function validateAddToPanel() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};

                _this5.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this5.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 15;
                  break;
                }

                kv = _step2.value;
                _context.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context.next = 7;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError2) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                result['custom'] = _this5.customValidate();

                if (values_default()(result).includes(false)) {
                  _context.next = 37;
                  break;
                }

                if (!(!_this5.selectedPhenotypePanel || !_this5.selectedPhenotypePanel.phenotypes.some(function (phenotype) {
                  return phenotype.id === _this5.param.phenotype.id;
                }))) {
                  _context.next = 36;
                  break;
                }

                _context.next = 34;
                return _this5.addToPanel();

              case 34:
                _context.next = 37;
                break;

              case 36:
                _this5.addToast('error', _this5.$t('COMMON.toast.___addSameHPOTerm'));

              case 37:
                _this5.onSubmit = false;

              case 38:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    addToPanel: function addToPanel() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, phenotypeID, type, idType, id, panelName, response, newPanel;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this6.$ls.get('userInfo');
                phenotypeID = _this6.param.phenotype.id;
                type = _this6.param.phenotype.type;
                idType = {
                  hpo: 'hpo_id',
                  disease_term: 'disease_id'
                }[type];
                id = _this6.result.selectedPanelID;
                panelName = _this6.result.newPanelName;

                if (!panelName) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 10;
                return Object(src_api["_122" /* postPhenotypePanel */])(defineProperty_default()({ panel: panelName }, idType + 's', [phenotypeID]), config);

              case 10:
                _context2.t0 = _context2.sent;
                _context2.next = 16;
                break;

              case 13:
                _context2.next = 15;
                return Object(src_api["_87" /* postAddToPhenotypePanel */])(id, type, defineProperty_default()({}, idType, phenotypeID), config);

              case 15:
                _context2.t0 = _context2.sent;

              case 16:
                response = _context2.t0;

                _this6.addToast('success', response.data.result.message);
                newPanel = response.data.data;

                _this6.$emit('changeModal', {}, newPanel);
                _context2.next = 25;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t1 = _context2['catch'](0);

                _this6.addToast('error', !_context2.t1.response ? _context2.t1.message : _context2.t1.response.data.result.message);

              case 25:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[0, 22]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12829fd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/addToPanel.vue
var addToPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-to-panel-dailog dialog col-block"},[_c('customForm',{attrs:{"init":_vm.panelData,"alerts":_vm.alerts,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }},scopedSlots:_vm._u([{key:"PHENOTYPE_HPO",fn:function(props){return [_c('div',{attrs:{"id":props.value}},[_vm._v(_vm._s(_vm.param.phenotype.id + ' ' + _vm.param.phenotype.name))])]}}])}),_vm._v(" "),_c('div',{style:({ height: '7px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.panelData,"alerts":_vm.alerts,"forms":_vm.formOptions['field2']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field2', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"row-block",style:({ padding: '0 10px', 'box-sizing': 'border-box' })},[_c('div',{style:({ flex: 1, height: '1px', background: '#003679' })}),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{style:({ 'color': '#003679', 'font-size': '1rem', 'font-weight': 'bold' })},[_vm._v(_vm._s(_vm.$t('DIALOG.addToPanel.___or')))]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{style:({ flex: 1, height: '1px', background: '#003679' })})]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.panelData,"alerts":_vm.alerts,"forms":_vm.formOptions['field3']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field3', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit ? _vm.validateAddToPanel() : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___add')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var addToPanel_staticRenderFns = []
var addToPanel_esExports = { render: addToPanel_render, staticRenderFns: addToPanel_staticRenderFns }
/* harmony default export */ var components_dialog_addToPanel = (addToPanel_esExports);
// CONCATENATED MODULE: ./src/components/dialog/addToPanel.vue
var addToPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addToPanel___vue_template_functional__ = false
/* styles */
var addToPanel___vue_styles__ = null
/* scopeId */
var addToPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var addToPanel___vue_module_identifier__ = null
var addToPanel_Component = addToPanel_normalizeComponent(
  dialog_addToPanel,
  components_dialog_addToPanel,
  addToPanel___vue_template_functional__,
  addToPanel___vue_styles__,
  addToPanel___vue_scopeId__,
  addToPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_addToPanel = (addToPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/genePanelQuickSelection.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var genePanelQuickSelection = ({
  mixins: [responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      curDivision: null
    };
  },

  computed: {
    genePanels: function genePanels() {
      var genePanels = this.param.divisions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, []));
      }, {});
      this.datas.forEach(function (data) {
        var count = data.count || [(data.data['free_typing'] || []).length, (data.data['user_defined'] || []).length, (data.data['panel'] || []).reduce(function (s, panelData) {
          return s + panelData.data.length;
        }, 0), (data.data['hpo'] || []).reduce(function (s, panelData) {
          return s + panelData.data.length;
        }, 0), (data.data['condition'] || []).reduce(function (s, panelData) {
          return s + panelData.data.length;
        }, 0)].reduce(function (s, c) {
          return s + c;
        }, 0);
        genePanels[data.division] && genePanels[data.division].push(extends_default()({}, data, {
          count: count
        }));
      });
      return genePanels;
    },

    // param
    datas: function datas() {
      return this.param.datas;
    },
    divisions: function divisions() {
      return this.param.divisions;
    },

    // global
    toPriceString: function toPriceString() {
      return util["r" /* toPriceString */];
    },
    sortData: function sortData() {
      return util["m" /* sortData */];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d649f8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/genePanelQuickSelection.vue
var genePanelQuickSelection_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gene-panel-quick-selection-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[(_vm.curDivision)?[_c('img',{attrs:{"src":__webpack_require__("Pbv1"),"alt":""},on:{"click":function (e) { return _vm.curDivision = null; }}}),_vm._v(" "),_c('div',{style:({ width: '10px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.curDivision || _vm.$t('DIALOG.genePanelQuickSelection.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"data-container row-block flex-wrap flex-start",style:({ flex: 1, 'max-height': Math.min(_vm.windowHeight - 321, _vm.curDivision ? 630 : 530) + 'px' })},[(!_vm.curDivision)?_vm._l((_vm.sortData(_vm.divisions, function (data) { return data; })),function(division,index){return _c('div',{key:index,staticClass:"data-block",style:({ width: '33.33333%' })},[_c('div',{staticClass:"data division row-block",on:{"click":function (e) { return _vm.curDivision = division; }}},[_c('div',{staticClass:"division-icon center-block"},[_c('img',{attrs:{"src":__webpack_require__("mr+9")("./" + division + '.svg'),"alt":""}})]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"division-info col-block",style:({ flex: 1, width: 0 })},[_c('div',{staticClass:"division-title ellipsis",attrs:{"title":division}},[_vm._v(_vm._s(division))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"division-content"},[_vm._v(_vm._s(_vm.$t('DIALOG.genePanelQuickSelection.block.content.___division') + ': ' + _vm.toPriceString(_vm.genePanels[division].length)))])])])])}):_vm._l((_vm.sortData(_vm.genePanels[_vm.curDivision], function (data) { return data.name; })),function(panel,index){return _c('div',{key:index,staticClass:"data-block",style:({ width: '33.33333%' })},[_c('div',{staticClass:"data panel col-block",on:{"click":function (e) { return _vm.$emit('changeModal', {}, panel.id); }}},[_c('div',{staticClass:"panel-title ellipsis"},[_vm._v(_vm._s(panel.name))]),_vm._v(" "),_c('div',{style:({ height: '2px' })}),_vm._v(" "),_c('div',{staticClass:"panel-sub"},[(false)?_c('b',{staticClass:"main"},[_vm._v(_vm._s('(' + _vm.$t('DIALOG.genePanelQuickSelection.block.subtitle.___panel01') + ') '))]):_vm._e(),_vm._v(_vm._s(_vm.$t('DIALOG.genePanelQuickSelection.block.subtitle.___panel02') + ': ')),_c('b',[_vm._v(_vm._s(panel.count))])]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"panel-content",style:({ flex: 1 })},[_vm._v(_vm._s(panel.note ? panel.note.length > 100 ? panel.note.slice(0, 100) + '...' : panel.note : ''))])])])})],2),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var genePanelQuickSelection_staticRenderFns = []
var genePanelQuickSelection_esExports = { render: genePanelQuickSelection_render, staticRenderFns: genePanelQuickSelection_staticRenderFns }
/* harmony default export */ var dialog_genePanelQuickSelection = (genePanelQuickSelection_esExports);
// CONCATENATED MODULE: ./src/components/dialog/genePanelQuickSelection.vue
var genePanelQuickSelection_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var genePanelQuickSelection___vue_template_functional__ = false
/* styles */
var genePanelQuickSelection___vue_styles__ = null
/* scopeId */
var genePanelQuickSelection___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var genePanelQuickSelection___vue_module_identifier__ = null
var genePanelQuickSelection_Component = genePanelQuickSelection_normalizeComponent(
  genePanelQuickSelection,
  dialog_genePanelQuickSelection,
  genePanelQuickSelection___vue_template_functional__,
  genePanelQuickSelection___vue_styles__,
  genePanelQuickSelection___vue_scopeId__,
  genePanelQuickSelection___vue_module_identifier__
)

/* harmony default export */ var components_dialog_genePanelQuickSelection = (genePanelQuickSelection_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/genePanelDataSelect.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var genePanelDataSelect = ({
  mixins: [responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      data: null
    };
  },
  created: function created() {
    this.data = JSON.parse(stringify_default()(this.param.data));
  },

  computed: {
    // param
    functions: function functions() {
      return this.param.functions || {};
    }
  },
  methods: {
    toggleData: function toggleData(index) {
      if (this.functions['toggleData']) {
        var result = this.functions['toggleData'](index);
        this.data = result;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77262a31","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/genePanelDataSelect.vue
var genePanelDataSelect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gene-panel-data-select-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[(_vm.data.data.length && _vm.functions['toggleData'])?[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('img',{attrs:{"src":_vm.data.data.filter(function (data) { return data.checked !== false; }).length ? _vm.data.data.filter(function (data) { return data.checked !== false; }).length === _vm.data.data.length ? __webpack_require__("7kqe") : __webpack_require__("Z77G") : __webpack_require__("5Ivo")},on:{"click":function (e) { return _vm.toggleData('all'); }}}),_vm._v(" "),_c('div',{style:({ width: '10px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"title shrink"},[_vm._v(_vm._s(_vm.data.name))]),_vm._v(" "),(_vm.data.data.some(function (data) { return data.checked === false; }))?[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"sub"},[_vm._v(_vm._s('(' + _vm.data.data.filter(function (data) { return data.checked !== false; }).length + '/' + _vm.data.data.length + ')'))])]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),(_vm.data)?_c('div',{staticClass:"data-container row-block flex-wrap flex-start",class:{ 'only-line': _vm.data.data.length < 8 },style:({ flex: 1, 'max-height': Math.min(_vm.windowHeight - 321, 630) + 'px' })},_vm._l((_vm.data.data),function(data,index){return _c('div',{key:index,staticClass:"data-block",style:({ width: '12.5%', height: '50px' }),on:{"click":function (e) { return _vm.toggleData(index); }}},[_c('div',{staticClass:"data row-block",class:{ toggle: _vm.functions['toggleData'] }},[(_vm.functions['toggleData'])?[_c('img',{attrs:{"src":data.checked !== false ? __webpack_require__("7kqe") : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{style:({ width: '3px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"data-content col-block",style:({ flex: 1, width: 0 })},[_c('div',{staticClass:"data-content-1 ellipsis",attrs:{"title":data.symbol}},[_vm._v(_vm._s(data.symbol))]),_vm._v(" "),_c('div',{staticClass:"data-content-2",attrs:{"title":data.gene_id}},[_vm._v(_vm._s('(' + data.gene_id + ')'))])])],2)])}),0):_vm._e(),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var genePanelDataSelect_staticRenderFns = []
var genePanelDataSelect_esExports = { render: genePanelDataSelect_render, staticRenderFns: genePanelDataSelect_staticRenderFns }
/* harmony default export */ var dialog_genePanelDataSelect = (genePanelDataSelect_esExports);
// CONCATENATED MODULE: ./src/components/dialog/genePanelDataSelect.vue
var genePanelDataSelect_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var genePanelDataSelect___vue_template_functional__ = false
/* styles */
var genePanelDataSelect___vue_styles__ = null
/* scopeId */
var genePanelDataSelect___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var genePanelDataSelect___vue_module_identifier__ = null
var genePanelDataSelect_Component = genePanelDataSelect_normalizeComponent(
  genePanelDataSelect,
  dialog_genePanelDataSelect,
  genePanelDataSelect___vue_template_functional__,
  genePanelDataSelect___vue_styles__,
  genePanelDataSelect___vue_scopeId__,
  genePanelDataSelect___vue_module_identifier__
)

/* harmony default export */ var components_dialog_genePanelDataSelect = (genePanelDataSelect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/genePanelConfirm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var genePanelConfirm = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    // param
    data: function data() {
      return this.param.data;
    },
    now: function now() {
      return this.param.now;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11409916","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/genePanelConfirm.vue
var genePanelConfirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gene-panel-confirm-dailog dialog col-block"},[_c('div',{staticClass:"info-container"},[_vm._v(_vm._s(_vm.$t('DIALOG.genePanelConfirm.___info01')))]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"confirm-container col-block"},[(_vm.data.add)?_c('div',{staticClass:"confirm-block add-block col-block flex-start"},[_c('div',{staticClass:"block-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.genePanelConfirm.block.title.___add')))]),_vm._v(" "),_c('div',{style:({ height: '8px' })}),_vm._v(" "),(_vm.data.add['free_typing'])?_c('div',{staticClass:"item-container gene-ft col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.genePanelConfirm.block.content.___geneFreeTyping') + ':'))]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v(_vm._s(_vm.data.add['free_typing'].reduce(function (s, data) { return s + (s ? '、' : '') + (data.symbol + ' (' + data.gene_id + ')'); }, '')))])]):_vm._e(),_vm._v(" "),(_vm.data.add['user_defined'] || _vm.data.add['user_defined_replace'])?_c('div',{staticClass:"item-container gene-ud col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.genePanelConfirm.block.content.___geneUserDefined') + ':'))]),_vm._v(" "),_c('div',{staticClass:"item-content",domProps:{"innerHTML":_vm._s([
            _vm.data.add['user_defined_replace'] ? 'Add (' + _vm.data.add['user_defined_replace'].name + ') to <b>replace present list</b>' : null,
            (_vm.data.add['user_defined'] || []).length ? _vm.data.add['user_defined'].length + (_vm.data.add['user_defined'].length > 1 ? ' genes were' : ' gene was') + ' selected' : null
          ].filter(function (x) { return x; }).join(', '))}})]):_vm._e(),_vm._v(" "),(_vm.data.add['panel'] || _vm.data.add['panelGene'])?_c('div',{staticClass:"item-container panel col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.genePanelConfirm.block.content.___panel') + ':'))]),_vm._v(" "),_c('div',{staticClass:"item-content",domProps:{"innerHTML":_vm._s([
            (_vm.data.add['panel'] || []).reduce(function (s, panel) { return s + (s ? ', ' : '') + panel.name + (panel.data.some(function (data) { return data.checked === false; }) ? ' (' + panel.data.filter(function (data) { return data.checked !== false; }).length + (panel.data.filter(function (data) { return data.checked !== false; }).length > 1 ? ' genes were' : ' gene was') + ' selected)' : ''); }, ''),
            (_vm.data.add['panelGene'] || []).reduce(function (s, panel) { return s + (s ? ', ' : '') + panel.name + ' (' + panel.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked === false && data.checked !== data.oChecked; }).length + (panel.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked === false && data.checked !== data.oChecked; }).length > 1 ? ' genes were' : ' gene was') + ' selected)'; }, '')
          ].filter(function (x) { return x; }).join(', '))}})]):_vm._e(),_vm._v(" "),(_vm.data.add['hpo'] || _vm.data.add['hpoGene'])?_c('div',{staticClass:"item-container hpo col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.genePanelConfirm.block.content.___hpoPhenotypes') + ':'))]),_vm._v(" "),_c('div',{staticClass:"item-content",domProps:{"innerHTML":_vm._s([
            (_vm.data.add['hpo'] || []).reduce(function (s, hpo) { return s + (s ? ', ' : '') + hpo.name + (hpo.data.some(function (data) { return data.checked === false; }) ? ' (' + hpo.data.filter(function (data) { return data.checked !== false; }).length + (hpo.data.filter(function (data) { return data.checked !== false; }).length > 1 ? ' genes were' : ' gene was') + ' selected)' : ''); }, ''),
            (_vm.data.add['hpoGene'] || []).reduce(function (s, hpo) { return s + (s ? ', ' : '') + hpo.name + ' (' + hpo.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked === false && data.checked !== data.oChecked; }).length + (hpo.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked === false && data.checked !== data.oChecked; }).length > 1 ? ' genes were' : ' gene was') + ' selected)'; }, '')
          ].filter(function (x) { return x; }).join(', '))}})]):_vm._e(),_vm._v(" "),(_vm.data.add['condition'] || _vm.data.add['conditionGene'])?_c('div',{staticClass:"item-container condition col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.genePanelConfirm.block.content.___conditions') + ':'))]),_vm._v(" "),_c('div',{staticClass:"item-content",domProps:{"innerHTML":_vm._s([
            (_vm.data.add['condition'] || []).reduce(function (s, condition) { return s + (s ? ', ' : '') + condition.name + (condition.data.some(function (data) { return data.checked === false; }) ? ' (' + condition.data.filter(function (data) { return data.checked !== false; }).length + (condition.data.filter(function (data) { return data.checked !== false; }).length > 1 ? ' genes were' : ' gene was') + ' selected)' : ''); }, ''),
            (_vm.data.add['conditionGene'] || []).reduce(function (s, condition) { return s + (s ? ', ' : '') + condition.name + ' (' + condition.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked === false && data.checked !== data.oChecked; }).length + (condition.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked === false && data.checked !== data.oChecked; }).length > 1 ? ' genes were' : ' gene was') + ' selected)'; }, '')
          ].filter(function (x) { return x; }).join(', '))}})]):_vm._e(),_vm._v(" "),(_vm.data.add['pathway'] || _vm.data.add['pathwayGene'])?_c('div',{staticClass:"item-container pathway col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.genePanelConfirm.block.content.___pathways') + ':'))]),_vm._v(" "),_c('div',{staticClass:"item-content",domProps:{"innerHTML":_vm._s([
            (_vm.data.add['pathway'] || []).reduce(function (s, pathway) { return s + (s ? ', ' : '') + pathway.name + (pathway.data.some(function (data) { return data.checked === false; }) ? ' (' + pathway.data.filter(function (data) { return data.checked !== false; }).length + (pathway.data.filter(function (data) { return data.checked !== false; }).length > 1 ? ' genes were' : ' gene was') + ' selected)' : ''); }, ''),
            (_vm.data.add['pathwayGene'] || []).reduce(function (s, pathway) { return s + (s ? ', ' : '') + pathway.name + ' (' + pathway.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked === false && data.checked !== data.oChecked; }).length + (pathway.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked === false && data.checked !== data.oChecked; }).length > 1 ? ' genes were' : ' gene was') + ' selected)'; }, '')
          ].filter(function (x) { return x; }).join(', '))}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.data.add && _vm.data.remove)?_c('hr'):_vm._e(),_vm._v(" "),(_vm.data.remove)?_c('div',{staticClass:"confirm-block remove-block col-block flex-start"},[_c('div',{staticClass:"block-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.genePanelConfirm.block.title.___remove')))]),_vm._v(" "),_c('div',{style:({ height: '8px' })}),_vm._v(" "),(_vm.data.remove['free_typing'])?_c('div',{staticClass:"item-container gene-ft col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.genePanelConfirm.block.content.___geneFreeTyping') + ':'))]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v(_vm._s(_vm.data.remove['free_typing'].reduce(function (s, data) { return s + (s ? '、' : '') + (data.symbol + ' (' + data.gene_id + ')'); }, '')))])]):_vm._e(),_vm._v(" "),(_vm.data.remove['user_defined'])?_c('div',{staticClass:"item-container gene-ud col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.genePanelConfirm.block.content.___geneUserDefined') + ':'))]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v(_vm._s(_vm.data.remove['user_defined'].length + (_vm.data.remove['user_defined'].length > 1 ? ' genes were' : ' gene was') + ' unselected'))])]):_vm._e(),_vm._v(" "),(_vm.data.remove['panel'] || _vm.data.remove['panelGene'])?_c('div',{staticClass:"item-container panel col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.genePanelConfirm.block.content.___panel') + ':'))]),_vm._v(" "),_c('div',{staticClass:"item-content",domProps:{"innerHTML":_vm._s([
            (_vm.data.remove['panel'] || []).reduce(function (s, panel) { return s + (s ? ', ' : '') + panel.name + (panel.oLength < panel.data.length ? ' (' + panel.oLength + (panel.oLength > 1 ? ' genes were' : ' gene was') + ' unselected)' : ''); }, ''),
            (_vm.data.remove['panelGene'] || []).reduce(function (s, panel) { return s + (s ? ', ' : '') + panel.name + ' (' + panel.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked !== false && data.checked !== data.oChecked; }).length + (panel.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked !== false && data.checked !== data.oChecked; }).length > 1 ? ' genes were' : ' gene was') + ' unselected)'; }, '')
          ].filter(function (x) { return x; }).join(', '))}})]):_vm._e(),_vm._v(" "),(_vm.data.remove['hpo'] || _vm.data.remove['hpoGene'])?_c('div',{staticClass:"item-container hpo col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.genePanelConfirm.block.content.___hpoPhenotypes') + ':'))]),_vm._v(" "),_c('div',{staticClass:"item-content",domProps:{"innerHTML":_vm._s([
            (_vm.data.remove['hpo'] || []).reduce(function (s, hpo) { return s + (s ? ', ' : '') + hpo.name + (hpo.oLength < hpo.data.length ? ' (' + hpo.oLength + (hpo.oLength > 1 ? ' genes were' : ' gene was') + ' unselected)' : ''); }, ''),
            (_vm.data.remove['hpoGene'] || []).reduce(function (s, hpo) { return s + (s ? ', ' : '') + hpo.name + ' (' + hpo.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked !== false && data.checked !== data.oChecked; }).length + (hpo.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked !== false && data.checked !== data.oChecked; }).length > 1 ? ' genes were' : ' gene was') + ' unselected)'; }, '')
          ].filter(function (x) { return x; }).join(', '))}})]):_vm._e(),_vm._v(" "),(_vm.data.remove['condition'] || _vm.data.remove['conditionGene'])?_c('div',{staticClass:"item-container condition col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.genePanelConfirm.block.content.___conditions') + ':'))]),_vm._v(" "),_c('div',{staticClass:"item-content",domProps:{"innerHTML":_vm._s([
            (_vm.data.remove['condition'] || []).reduce(function (s, condition) { return s + (s ? ', ' : '') + condition.name + (condition.oLength < condition.data.length ? ' (' + condition.oLength + (condition.oLength > 1 ? ' genes were' : ' gene was') + ' unselected)' : ''); }, ''),
            (_vm.data.remove['conditionGene'] || []).reduce(function (s, condition) { return s + (s ? ', ' : '') + condition.name + ' (' + condition.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked !== false && data.checked !== data.oChecked; }).length + (condition.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked !== false && data.checked !== data.oChecked; }).length > 1 ? ' genes were' : ' gene was') + ' unselected)'; }, '')
          ].filter(function (x) { return x; }).join(', '))}})]):_vm._e(),_vm._v(" "),(_vm.data.remove['pathway'] || _vm.data.remove['pathwayGene'])?_c('div',{staticClass:"item-container pathway col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.genePanelConfirm.block.content.___pathways') + ':'))]),_vm._v(" "),_c('div',{staticClass:"item-content",domProps:{"innerHTML":_vm._s([
            (_vm.data.remove['pathway'] || []).reduce(function (s, pathway) { return s + (s ? ', ' : '') + pathway.name + (pathway.oLength < pathway.data.length ? ' (' + pathway.oLength + (pathway.oLength > 1 ? ' genes were' : ' gene was') + ' unselected)' : ''); }, ''),
            (_vm.data.remove['pathwayGene'] || []).reduce(function (s, pathway) { return s + (s ? ', ' : '') + pathway.name + ' (' + pathway.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked !== false && data.checked !== data.oChecked; }).length + (pathway.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked !== false && data.checked !== data.oChecked; }).length > 1 ? ' genes were' : ' gene was') + ' unselected)'; }, '')
          ].filter(function (x) { return x; }).join(', '))}})]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function($event){_vm.$emit('changeModal', {}, true)}}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___confirm')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var genePanelConfirm_staticRenderFns = []
var genePanelConfirm_esExports = { render: genePanelConfirm_render, staticRenderFns: genePanelConfirm_staticRenderFns }
/* harmony default export */ var dialog_genePanelConfirm = (genePanelConfirm_esExports);
// CONCATENATED MODULE: ./src/components/dialog/genePanelConfirm.vue
var genePanelConfirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var genePanelConfirm___vue_template_functional__ = false
/* styles */
var genePanelConfirm___vue_styles__ = null
/* scopeId */
var genePanelConfirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var genePanelConfirm___vue_module_identifier__ = null
var genePanelConfirm_Component = genePanelConfirm_normalizeComponent(
  genePanelConfirm,
  dialog_genePanelConfirm,
  genePanelConfirm___vue_template_functional__,
  genePanelConfirm___vue_styles__,
  genePanelConfirm___vue_scopeId__,
  genePanelConfirm___vue_module_identifier__
)

/* harmony default export */ var components_dialog_genePanelConfirm = (genePanelConfirm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/selectDataset.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var selectDataset = ({
  mixins: [toastMethods["a" /* default */]],
  computed: {
    // global
    priceMap: function priceMap() {
      return global_data["J" /* priceMap */];
    }
  },
  data: function data() {
    return {
      hover: {
        vcf: false,
        fastq: false
      }
    };
  },

  methods: {
    checkBatchUploadPermission: function checkBatchUploadPermission() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var config;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                config = _this.$ls.get('userInfo');
                _context.next = 4;
                return Object(src_api["z" /* getBatchUploadSet */])(config);

              case 4:
                _this.$router.push({ name: 'caseBatchUpload', params: { dataset: 'vcf' } });
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                _this.addToast('error', !_context.t0.response ? _context.t0.message : _context.t0.response.data.result.message);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fd8f312","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/selectDataset.vue
var selectDataset_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-dataset-dailog dialog col-block"},[_c('div',{staticClass:"description-container"},[_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.selectDataset.___description'))}})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('hr',{staticClass:"no-margin"}),_vm._v(" "),_c('div',{staticClass:"select-container row-block flex-start"},[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"vcf-container select-block col-block",class:{ hover: _vm.hover['vcf'] },style:({ flex: 1 }),on:{"mouseover":function (e) { return _vm.hover['vcf'] = true; },"mouseleave":function (e) { return _vm.hover['vcf'] = false; }}},[_c('div',{staticClass:"select-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.selectDataset.select.title.___vcf')))]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('button',{staticClass:"circle-button",class:['white-gray-button'],on:{"click":function (e) { return _vm.$emit('changeModal', {}, 'vcf'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___vcf')))])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('a',{staticClass:"select-option link",on:{"click":function (e) { return _vm.checkBatchUploadPermission(); }}},[_vm._v(_vm._s(_vm.$t('DIALOG.selectDataset.select.option.___batch')))]),_vm._v(" "),_c('div',{style:({ height: '20px' })})]),_vm._v(" "),_c('div',{staticClass:"fastq-container select-block col-block",class:{ hover: _vm.hover['fastq'] },style:({ flex: 1 }),on:{"mouseover":function (e) { return _vm.hover['fastq'] = true; },"mouseleave":function (e) { return _vm.hover['fastq'] = false; }}},[_c('div',{staticClass:"select-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.selectDataset.select.title.___fastq')))]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('button',{staticClass:"circle-button",class:['main-button'],on:{"click":function (e) { return _vm.$emit('changeModal', {}, 'fastq'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___fastq')))])]),_vm._v(" "),_c('div',{style:({ height: '20px' })})]),_vm._v(" "),_c('div',{staticClass:"ubam-container select-block col-block",class:{ hover: _vm.hover['ubam'] },style:({ flex: 1 }),on:{"mouseover":function (e) { return _vm.hover['ubam'] = true; },"mouseleave":function (e) { return _vm.hover['ubam'] = false; }}},[_c('div',{staticClass:"select-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.selectDataset.select.title.___ubam')))]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('button',{staticClass:"circle-button",class:['white-gray-button'],on:{"click":function (e) { return _vm.$emit('changeModal', {}, 'ubam'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___ubam')))])]),_vm._v(" "),_c('div',{style:({ height: '20px' })})]),_vm._v(" "),_c('div',{style:({ width: '10px' })})])])}
var selectDataset_staticRenderFns = []
var selectDataset_esExports = { render: selectDataset_render, staticRenderFns: selectDataset_staticRenderFns }
/* harmony default export */ var dialog_selectDataset = (selectDataset_esExports);
// CONCATENATED MODULE: ./src/components/dialog/selectDataset.vue
var selectDataset_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var selectDataset___vue_template_functional__ = false
/* styles */
var selectDataset___vue_styles__ = null
/* scopeId */
var selectDataset___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var selectDataset___vue_module_identifier__ = null
var selectDataset_Component = selectDataset_normalizeComponent(
  selectDataset,
  dialog_selectDataset,
  selectDataset___vue_template_functional__,
  selectDataset___vue_styles__,
  selectDataset___vue_scopeId__,
  selectDataset___vue_module_identifier__
)

/* harmony default export */ var components_dialog_selectDataset = (selectDataset_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/fileCloud.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var fileCloud = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedPaths: []
    };
  },

  computed: {
    fileTrees: function fileTrees() {
      var _this = this;

      var paths = this.paths.filter(function (path) {
        return path.endsWith('/') || !_this.fileTypes.length || _this.fileTypes.some(function (t) {
          return path.endsWith('.' + t);
        });
      });
      var fileTrees = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(paths), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var path = _step.value;

          var current = fileTrees;
          var pathAry = path.replace(/\//g, '/ゐ').split(/ゐ/g).filter(function (x) {
            return x;
          });
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(pathAry), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var file = _step2.value;

              var fileName = file.replace(/\/$/, '');
              var type = file.endsWith('/') ? 'folder' : 'file';
              !current.nodes && (current.nodes = {});
              !current.nodes[fileName] && (current.nodes[fileName] = {
                type: type,
                path: pathAry.slice(0, pathAry.indexOf(file) + 1).join('').replace(/\/$/, '')
              });
              current = current.nodes[fileName];
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return fileTrees;
    },

    // param
    type: function type() {
      return this.param.type || 'single';
    },
    options: function options() {
      return this.param.options || {};
    },
    fileTypes: function fileTypes() {
      return this.param.fileTypes || [];
    },
    paths: function paths() {
      return this.param.paths || [];
    },
    currentPath: function currentPath() {
      return this.param.currentPath || '';
    },
    disabledPaths: function disabledPaths() {
      return this.param.disabledPaths || [];
    },
    functions: function functions() {
      return this.param.functions || {};
    }
  },
  watch: {
    'param.defaultSelectedPaths': function paramDefaultSelectedPaths() {
      this.selectedPaths = [].concat(toConsumableArray_default()(this.param.defaultSelectedPaths));
    }
  },
  created: function created() {
    this.selectedPaths = [].concat(toConsumableArray_default()(this.param.defaultSelectedPaths));
  },

  methods: {
    pathOnSelect: function pathOnSelect(path) {
      var selectedPaths = this.selectedPaths.includes(path) || this.type === 'multiple' ? [].concat(toConsumableArray_default()(this.selectedPaths)) : [];
      selectedPaths.includes(path) ? selectedPaths.splice(selectedPaths.indexOf(path), 1) : selectedPaths.push(path);
      this.selectedPaths = selectedPaths;
      this.functions.saveCurrentPath(path);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6930d96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/fileCloud.vue
var fileCloud_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-cloud-dialog dialog col-block width-full"},[_c('div',{staticClass:"file-cloud-title-container row-block"},[_c('div',{staticClass:"file-cloud-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.fileCloud.___title')))]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"file-cloud-sub-title"},[_vm._v(_vm._s('(' + _vm.$t('DIALOG.fileCloud.___subtitle') + ')'))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tree-list-container resize-container vertical"},[_c('textarea',{style:({ height: '480px' })}),_vm._v(" "),_c('div',{staticClass:"tree-list-block"},[_c('treeList',{attrs:{"treeData":_vm.fileTrees,"options":_vm.options,"icons":{
          file: __webpack_require__("GljU"),
          select: __webpack_require__("OCMH"),
          open: __webpack_require__("09wH"),
          close: __webpack_require__("roYr"),
          boxtrue: __webpack_require__("k4Yl"),
          boxfalse: __webpack_require__("pWQO")
        },"currentPath":_vm.currentPath,"disabledPaths":_vm.disabledPaths,"selectedPaths":_vm.selectedPaths},on:{"select":function (path) { return _vm.pathOnSelect(path); }}})],1)]),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",attrs:{"disabled":!_vm.selectedPaths.length},on:{"click":function (e) { return _vm.selectedPaths.length ? _vm.$emit('changeModal', {}, _vm.selectedPaths) : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var fileCloud_staticRenderFns = []
var fileCloud_esExports = { render: fileCloud_render, staticRenderFns: fileCloud_staticRenderFns }
/* harmony default export */ var dialog_fileCloud = (fileCloud_esExports);
// CONCATENATED MODULE: ./src/components/dialog/fileCloud.vue
function fileCloud_injectStyle (ssrContext) {
  __webpack_require__("oZ+u")
}
var fileCloud_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var fileCloud___vue_template_functional__ = false
/* styles */
var fileCloud___vue_styles__ = fileCloud_injectStyle
/* scopeId */
var fileCloud___vue_scopeId__ = "data-v-e6930d96"
/* moduleIdentifier (server only) */
var fileCloud___vue_module_identifier__ = null
var fileCloud_Component = fileCloud_normalizeComponent(
  fileCloud,
  dialog_fileCloud,
  fileCloud___vue_template_functional__,
  fileCloud___vue_styles__,
  fileCloud___vue_scopeId__,
  fileCloud___vue_module_identifier__
)

/* harmony default export */ var components_dialog_fileCloud = (fileCloud_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseConfirm.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var caseConfirm = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    caseData: function caseData() {
      return this.param.caseData;
    },
    analysisData: function analysisData() {
      return this.caseData.project;
    },
    fileSets: function fileSets() {
      return this.param.fileSets;
    },
    intractableDiseaseValueMap: function intractableDiseaseValueMap() {
      return global_data["A" /* intractableDiseaseOptions */].reduce(function (map, option) {
        return extends_default()({}, map, defineProperty_default()({}, option.value, option));
      }, {});
    },

    // static
    formOptions: function formOptions() {
      var _this = this;

      return {
        'field1': [
        // 1
        {
          title: this.$t('DIALOG.caseConfirm.form.case.title.___caseID'),
          value: 'case_id',
          type: 'text',
          wrap: true,
          grid: 2
        }, {
          title: this.$t('DIALOG.caseConfirm.form.case.title.___affected'),
          value: 'affected',
          type: 'text',
          wrap: true,
          grid: 1,
          style: {
            'true': { color: '#83C91E' },
            'false': { color: '#999999' }
          }[this.caseData.affected + ''],
          inputFormat: function inputFormat(value) {
            return {
              'true': _this.$t('DIALOG.caseConfirm.form.case.format.affected.___true'),
              'false': _this.$t('DIALOG.caseConfirm.form.case.format.affected.___false')
            }[value + ''];
          }
        }, {
          title: this.$t('DIALOG.caseConfirm.form.case.title.___subjectName'),
          value: 'subject_name',
          type: 'text',
          wrap: true,
          grid: 1
        }, {
          title: this.$t('DIALOG.caseConfirm.form.case.title.___sex'),
          value: 'sex',
          type: 'text',
          wrap: true,
          grid: 1,
          style: {
            Male: { color: '#003679' },
            Female: { color: '#FA3D3D' },
            Unknown: { color: '#333333' }
          }[this.caseData.sex],
          inputFormat: function inputFormat(value) {
            return {
              Male: _this.$t('DIALOG.caseConfirm.form.case.format.sex.___male'),
              Female: _this.$t('DIALOG.caseConfirm.form.case.format.sex.___female'),
              Unknown: _this.$t('DIALOG.caseConfirm.form.case.format.sex.___unknown')
            }[value];
          }
        }, {
          title: this.$t('DIALOG.caseConfirm.form.case.title.___birthYear'),
          value: 'birth_year',
          type: 'text',
          wrap: true,
          grid: 1,
          inputFormat: function inputFormat(value) {
            return value || _this.$t('DIALOG.caseConfirm.form.case.format.birthYear.___empty');
          }
        },
        // 2
        {
          title: this.$t('DIALOG.caseConfirm.form.case.title.___population'),
          value: 'population',
          type: 'text',
          wrap: true,
          grid: 2,
          inputFormat: function inputFormat(value) {
            return value || '--';
          }
        }, {
          title: this.$t('DIALOG.caseConfirm.form.case.title.___note'),
          value: 'note',
          type: 'text',
          wrap: true,
          grid: 4,
          inputFormat: function inputFormat(value) {
            return value || '--';
          }
        }],
        'field2': global_config["a" /* _LOCAL_BUILD */] ? [{
          title: this.$t('DIALOG.caseConfirm.form.analysis.title.___name'),
          value: 'name',
          type: 'text',
          wrap: true,
          grid: 2
        }, {
          title: this.$t('DIALOG.caseConfirm.form.analysis.title.___note'),
          value: 'note',
          type: 'text',
          wrap: true,
          grid: 4,
          inputFormat: function inputFormat(value) {
            return value || '--';
          }
        }] : [{
          title: this.$t('DIALOG.caseConfirm.form.analysis.title.___name'),
          value: 'name',
          type: 'text',
          wrap: true,
          grid: 2
        }, {
          title: this.$t('DIALOG.caseConfirm.form.analysis.title.___note'),
          value: 'note',
          type: 'text',
          wrap: true,
          grid: 3,
          inputFormat: function inputFormat(value) {
            return value || '--';
          }
        }, {
          title: this.$t('DIALOG.caseConfirm.form.analysis.title.___reportPhenovardb'),
          value: 'report_phenovardb',
          type: 'text',
          wrap: true,
          grid: 1,
          style: {
            'true': { color: '#83C91E' },
            'false': { color: '#999999' }
          }[this.analysisData.report_phenovardb + ''],
          inputFormat: function inputFormat(value) {
            return {
              'true': _this.$t('DIALOG.caseConfirm.form.analysis.format.reportPhenovardb.___true'),
              'false': _this.$t('DIALOG.caseConfirm.form.analysis.format.reportPhenovardb.___false')
            }[value + ''];
          }
        }],
        'field3': [].concat(toConsumableArray_default()(!global_config["a" /* _LOCAL_BUILD */] && this.$i18n.locale === 'ja' ? [{
          title: this.$t('DIALOG.caseConfirm.form.analysis.title.___intractableDisease'),
          value: 'INTRACTABLE_DISEASE',
          type: 'custom',
          wrap: true,
          grid: 5
        }, {
          title: this.$t('DIALOG.caseConfirm.form.analysis.title.___intractableDiseaseTag'),
          value: 'intractable_disease_tag',
          type: 'text',
          wrap: true,
          grid: 1,
          style: {
            'true': { color: '#83C91E' },
            'false': { color: '#999999' }
          }[this.analysisData.intractable_disease_tag + ''],
          inputFormat: function inputFormat(value) {
            return {
              'true': _this.$t('DIALOG.caseConfirm.form.analysis.format.intractableDiseaseTag.___true'),
              'false': _this.$t('DIALOG.caseConfirm.form.analysis.format.intractableDiseaseTag.___false')
            }[value + ''];
          }
        }] : []), [{
          title: this.$t('DIALOG.caseConfirm.form.analysis.title.___phenotype'),
          value: 'PHENOTYPE',
          type: 'custom',
          wrap: true,
          grid: 3
        }, {
          title: this.$t('DIALOG.caseConfirm.form.analysis.title.___genePanel'),
          value: 'GENE_PANEL',
          type: 'custom',
          grid: 3
        },
        // 2
        {
          title: this.$t('DIALOG.caseConfirm.form.analysis.title.___aft'),
          value: 'AFT',
          type: 'custom',
          grid: 6
        },
        // 3
        {
          title: this.$t('DIALOG.caseConfirm.form.analysis.title.___st'),
          value: 'ST',
          type: 'custom',
          grid: 6
        }])
      };
    },
    AFTOptions: function AFTOptions() {
      var _this2 = this;

      return [
      // 1
      {
        title: this.$t('DIALOG.caseConfirm.form.analysis.aft.title.___ad_cutoff'),
        value: function value(data) {
          return data.ad_cutoff;
        },
        grid: 1
      }, {
        title: this.$t('DIALOG.caseConfirm.form.analysis.aft.title.___ar_cutoff'),
        value: function value(data) {
          return data.ar_cutoff;
        },
        grid: 1
      }, {
        title: this.$t('DIALOG.caseConfirm.form.analysis.aft.title.___exclude_low_quality_variants'),
        value: function value(data) {
          return data.exclude_low_quality_variants;
        },
        grid: 4,
        style: function style(value) {
          return {
            'true': { color: '#006ED6' },
            'false': { color: '#999999' }
          }[value + ''];
        },
        display: function display(value) {
          return {
            'true': _this2.$t('DIALOG.caseConfirm.form.analysis.aft.display.exclude_low_quality_variants.___true'),
            'false': _this2.$t('DIALOG.caseConfirm.form.analysis.aft.display.exclude_low_quality_variants.___false')
          }[value + ''];
        }
      },
      // 2
      {
        title: this.$t('DIALOG.caseConfirm.form.analysis.aft.title.___comp_het_cutoff'),
        value: function value(data) {
          return data.comp_het_cutoff;
        },
        grid: 2
      }, {
        title: this.$t('DIALOG.caseConfirm.form.analysis.aft.title.___enable_clinvar_benign_filter'),
        value: function value(data) {
          return data.enable_clinvar_benign_filter;
        },
        grid: 4,
        style: function style(value) {
          return {
            'true': { color: '#006ED6' },
            'false': { color: '#999999' }
          }[value + ''];
        },
        display: function display(value) {
          return {
            'true': _this2.$t('DIALOG.caseConfirm.form.analysis.aft.display.enable_clinvar_benign_filter.___true'),
            'false': _this2.$t('DIALOG.caseConfirm.form.analysis.aft.display.enable_clinvar_benign_filter.___false')
          }[value + ''];
        }
      }];
    },
    STOptions: function STOptions() {
      return [{
        title: this.$t('DIALOG.caseConfirm.form.analysis.st.title.phenotype_score_cutoff'),
        value: function value(data) {
          return data.phenotype_score_cutoff;
        },
        grid: 2
      }, {
        title: this.$t('DIALOG.caseConfirm.form.analysis.st.title.variant_score_cutoff'),
        value: function value(data) {
          return data.variant_score_cutoff;
        },
        grid: 2
      }];
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModal2Action']), {
    checkAlerts: function checkAlerts() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!['Unknown'].includes(_this3.caseData.sex)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return _this3.unknownSexAlert();

              case 3:
                if (_context.sent) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                _this3.$emit('changeModal', {}, true);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    unknownSexAlert: function unknownSexAlert() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', new promise_default.a(function (resolve) {
                  _this4.setModal2Action({
                    action: 'toast',
                    width: '496px',
                    customStyles: {
                      padding: 0,
                      border: 0
                    },
                    param: {
                      type: 'alert',
                      content: _this4.$t('DIALOG.caseConfirm.modal.content.___unknownSexAlert'),
                      buttons: [{
                        title: _this4.$t('COMMON.button.___cancel'),
                        type: 'gray',
                        result: false
                      }, {
                        title: _this4.$t('COMMON.button.___create'),
                        type: 'alert',
                        result: true
                      }]
                    },
                    callback: function () {
                      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(result) {
                        return regenerator_default.a.wrap(function _callee2$(_context2) {
                          while (1) {
                            switch (_context2.prev = _context2.next) {
                              case 0:
                                resolve(result);

                              case 1:
                              case 'end':
                                return _context2.stop();
                            }
                          }
                        }, _callee2, _this4);
                      }));

                      return function callback(_x) {
                        return _ref.apply(this, arguments);
                      };
                    }()
                  });
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e4a633a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseConfirm.vue
var caseConfirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-confirm-dailog dialog col-block width-full"},[[_c('div',{staticClass:"main-container case col-block width-full"},[_c('div',{staticClass:"form-block col-block width-full"},[_c('customForm',{attrs:{"init":_vm.caseData,"layoutType":'grid',"groupCount":6,"forms":_vm.formOptions['field1'],"reading":true,"gap":'16px 4px',"titleSmallInterval":true},on:{"change":function () {}}})],1)])],_vm._v(" "),[_c('hr',{staticClass:"custom full",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('div',{staticClass:"main-container analysis col-block width-full"},[_c('div',{staticClass:"form-block col-block width-full"},[_c('customForm',{attrs:{"init":_vm.analysisData,"layoutType":'grid',"groupCount":6,"forms":_vm.formOptions['field2'],"reading":true,"gap":'16px 4px',"titleSmallInterval":true},on:{"change":function () {}}})],1),_vm._v(" "),_c('div',{staticClass:"form-block col-block width-full"},[_c('customForm',{attrs:{"init":_vm.analysisData,"layoutType":'grid',"groupCount":6,"forms":_vm.formOptions['field3'],"reading":true,"gap":'16px 4px',"titleSmallInterval":true},on:{"change":function () {}},scopedSlots:_vm._u([{key:"INTRACTABLE_DISEASE",fn:function(props){return [_c('div',{staticClass:"INTRACTABLE_DISEASE-container col-block flex-start",attrs:{"name":props}},[(_vm.analysisData.intractable_disease_panels)?[_c('div',{domProps:{"innerHTML":_vm._s((_vm.analysisData.intractable_disease_panels || []).map(function (name) { return _vm.$t(_vm.intractableDiseaseValueMap[name].title); }).join(' 、 '))}})]:_c('div',[_vm._v("- -")])],2)]}},{key:"PHENOTYPE",fn:function(props){return [_c('div',{staticClass:"PHENOTYPE-container col-block flex-start",attrs:{"name":props}},[(_vm.analysisData.phenotypes)?[_vm._l((Object.keys(_vm.analysisData.phenotypes)),function(key,kindex){return _vm._l((_vm.analysisData.phenotypes[key]),function(data,dindex){return _c('div',{key:kindex + '_' + dindex},[_vm._v(_vm._s(data.query))])})})]:_c('div',[_vm._v("- -")])],2)]}},{key:"GENE_PANEL",fn:function(props){return [_c('div',{staticClass:"GENE_PANEL-container col-block flex-start",attrs:{"name":props}},[(_vm.analysisData.gene_panels)?_vm._l((_vm.analysisData.gene_panels),function(data,dindex){return _c('div',{key:dindex},[_vm._v(_vm._s(data.name))])}):_c('div',[_vm._v("- -")])],2)]}},{key:"AFT",fn:function(props){return [_c('div',{staticClass:"AFT-container col-block width-full",style:({ 'grid-template-columns': '1fr 1fr 1fr 1fr 1fr 1fr' }),attrs:{"name":props}},_vm._l((_vm.AFTOptions),function(option,oindex){return _c('div',{key:oindex,style:({ 'grid-column': 'span ' + option.grid + ' / auto' })},[_vm._v(_vm._s(option.title + (option.operator || ' =') + ' ')),_c('span',{style:((option.style || (function () { return ({}); }))(option.value(_vm.analysisData)))},[_vm._v(_vm._s((option.display || (function (x) { return x; }))(option.value(_vm.analysisData))))])])}),0)]}},{key:"ST",fn:function(props){return [_c('div',{staticClass:"ST-container col-block width-full",style:({ 'grid-template-columns': '1fr 1fr 1fr 1fr 1fr 1fr' }),attrs:{"name":props}},_vm._l((_vm.STOptions),function(option,oindex){return _c('div',{key:oindex,style:({ 'grid-column': 'span ' + option.grid + ' / auto' })},[_vm._v(_vm._s(option.title + (option.operator || ' =') + ' ')),_c('span',{style:((option.style || (function () { return ({}); }))(option.value(_vm.analysisData)))},[_vm._v(_vm._s((option.display || (function (x) { return x; }))(option.value(_vm.analysisData))))])])}),0)]}}])})],1)])],_vm._v(" "),(_vm.fileSets.length || _vm.caseData.omics_name)?[_c('hr',{staticClass:"custom full",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('div',{staticClass:"main-container file col-block width-full"},[_c('div',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseConfirm.___datasetTitle', { type: { 'vcf': 'VCF', 'fastq': 'FASTQ', 'ubam': 'uBAM' }[_vm.caseData.dataset] })))]),_vm._v(" "),_c('div',{staticClass:"file-field row-block",style:({ 'grid-template-columns': '1fr 1fr 1fr 1fr 1fr 1fr' })},[(['fastq', 'ubam'].includes(_vm.caseData.dataset))?_c('div',{staticClass:"pipeline-container col-block",style:({ 'grid-column': 'span 2 / auto' })},[_c('div',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseConfirm.___pipelineTitle')))]),_vm._v(" "),_c('div',{style:({ height: '8px' })}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s([_vm.caseData.omics_name, _vm.caseData.pipeline_name, _vm.caseData.library_type_name].filter(function (x) { return x; }).join(',<br>'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"set-container col-block",style:({ 'grid-column': 'span ' + ({ vcf: '6', fastq: '4', ubam: '4' }[_vm.caseData.dataset]) + ' / auto' })},_vm._l((_vm.fileSets),function(set,index){return _c('div',{key:index,staticClass:"set-block row-block"},[(_vm.caseData.dataset === 'vcf')?[(set.snv)?_c('div',{staticClass:"file-block",style:({ flex: 1 })},[_c('div',{staticClass:"file-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseConfirm.___snvVcfTitle')))]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"file-source ellipsis"},[_vm._v(_vm._s(set.snv.name))])]):_vm._e(),_vm._v(" "),(set.sv)?_c('div',{staticClass:"file-block",style:({ flex: 1 })},[_c('div',{staticClass:"file-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseConfirm.___svVcfTitle')))]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"file-source-block col-block flex-start"},_vm._l((set.sv),function(file,findex){return _c('div',{key:findex,staticClass:"file-source ellipsis"},[_vm._v(_vm._s(file.name))])}),0)]):_vm._e(),_vm._v(" "),(set.str)?_c('div',{staticClass:"file-block",style:({ flex: 1 })},[_c('div',{staticClass:"file-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseConfirm.___strVcfTitle')))]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"file-source ellipsis"},[_vm._v(_vm._s(set.str.name))])]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.caseData.dataset === 'fastq')?[_c('div',{staticClass:"file-block",style:({ flex: 1 })},[_c('div',{staticClass:"file-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseConfirm.___fastqTitle', { set: (index + 1), read: 'R1' })))]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"file-source ellipsis"},[_vm._v(_vm._s(set.r1.name))])]),_vm._v(" "),(_vm.caseData.pipelineType === 'paired')?[_c('div',{style:({ width: '16px' })}),_vm._v(" "),_c('div',{staticClass:"file-block",style:({ flex: 1 })},[_c('div',{staticClass:"file-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseConfirm.___fastqTitle', { set: (index + 1), read: 'R2' })))]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"file-source ellipsis"},[_vm._v(_vm._s(set.r2.name))])])]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.caseData.dataset === 'ubam')?[_c('div',{staticClass:"file-block",style:({ flex: 1 })},[_c('div',{staticClass:"file-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseConfirm.___ubamTitle', { set: (index + 1) })))]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"file-source ellipsis"},[_vm._v(_vm._s(set.bam.name))])])]:_vm._e()],2)}),0)])])]:_vm._e(),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.checkAlerts(); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___create')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var caseConfirm_staticRenderFns = []
var caseConfirm_esExports = { render: caseConfirm_render, staticRenderFns: caseConfirm_staticRenderFns }
/* harmony default export */ var dialog_caseConfirm = (caseConfirm_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseConfirm.vue
var caseConfirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseConfirm___vue_template_functional__ = false
/* styles */
var caseConfirm___vue_styles__ = null
/* scopeId */
var caseConfirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseConfirm___vue_module_identifier__ = null
var caseConfirm_Component = caseConfirm_normalizeComponent(
  caseConfirm,
  dialog_caseConfirm,
  caseConfirm___vue_template_functional__,
  caseConfirm___vue_styles__,
  caseConfirm___vue_scopeId__,
  caseConfirm___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseConfirm = (caseConfirm_Component.exports);

// EXTERNAL MODULE: ./src/components/case/base.vue + 8 modules
var base = __webpack_require__("+lE8");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseEdit.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var caseEdit = ({
  components: {
    caseBase: base["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      caseData: {},
      onError: false,
      onSubmit: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user']), {
    defaultData: function defaultData() {
      return {
        'case': this.caseData,
        'analysis': {}
      };
    }
  }),
  created: function created() {
    this.caseData = extends_default()({}, this.param.caseData);
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction', 'setModal2Action']), {
    validateSendCase: function validateSendCase() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var forms, success, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, form, result, datas, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _form, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.onSubmit = true;
                _context.prev = 1;
                forms = entries_default()(_this.$refs).filter(function (_ref) {
                  var _ref2 = slicedToArray_default()(_ref, 1),
                      key = _ref2[0];

                  return key.startsWith('form-');
                }).map(function (_ref3) {
                  var _ref4 = slicedToArray_default()(_ref3, 2),
                      key = _ref4[0],
                      ref = _ref4[1];

                  return ref[0] || ref;
                });
                success = true;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 7;
                _iterator = get_iterator_default()(forms);

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 18;
                  break;
                }

                form = _step.value;
                _context.next = 13;
                return form.validateSubmit();

              case 13:
                result = _context.sent;

                if (form && !result) {
                  success = false;
                }

              case 15:
                _iteratorNormalCompletion = true;
                _context.next = 9;
                break;

              case 18:
                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 24:
                _context.prev = 24;
                _context.prev = 25;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 27:
                _context.prev = 27;

                if (!_didIteratorError) {
                  _context.next = 30;
                  break;
                }

                throw _iteratorError;

              case 30:
                return _context.finish(27);

              case 31:
                return _context.finish(24);

              case 32:
                if (!success) {
                  _context.next = 68;
                  break;
                }

                datas = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 37;
                _iterator2 = get_iterator_default()(forms);

              case 39:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 52;
                  break;
                }

                _form = _step2.value;
                _context.next = 43;
                return _form.submit();

              case 43:
                data = _context.sent;

                if (!(_form && !data)) {
                  _context.next = 48;
                  break;
                }

                throw new Error();

              case 48:
                datas.push(data);

              case 49:
                _iteratorNormalCompletion2 = true;
                _context.next = 39;
                break;

              case 52:
                _context.next = 58;
                break;

              case 54:
                _context.prev = 54;
                _context.t1 = _context['catch'](37);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 58:
                _context.prev = 58;
                _context.prev = 59;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 61:
                _context.prev = 61;

                if (!_didIteratorError2) {
                  _context.next = 64;
                  break;
                }

                throw _iteratorError2;

              case 64:
                return _context.finish(61);

              case 65:
                return _context.finish(58);

              case 66:
                _context.next = 68;
                return _this.sendCase(datas[0]);

              case 68:
                _context.next = 72;
                break;

              case 70:
                _context.prev = 70;
                _context.t2 = _context['catch'](1);

              case 72:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 70], [7, 20, 24, 32], [25,, 27, 31], [37, 54, 58, 66], [59,, 61, 65]]);
      }))();
    },
    sendCase: function sendCase(formData) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var config, id, data, sendCase, owner, newOwner;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                config = _this2.$ls.get('userInfo');
                id = _this2.param.caseData.id;
                data = extends_default()({}, formData.data);

                if (['supervisor'].includes(_this2.user.role)) {
                  data.new_user_id = formData.data.user_id;
                }

                sendCase = function () {
                  var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                    var response, newCase;
                    return regenerator_default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return Object(src_api["_132" /* putCase */])(id, data, config);

                          case 3:
                            response = _context2.sent;
                            newCase = response.data.data;

                            _this2.addToast('success', response.data.result.message);
                            _this2.$emit('changeModal', {}, newCase);
                            _context2.next = 12;
                            break;

                          case 9:
                            _context2.prev = 9;
                            _context2.t0 = _context2['catch'](0);

                            _this2.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.result.message);

                          case 12:
                            _this2.onSubmit = false;

                          case 13:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2, [[0, 9]]);
                  }));

                  return function sendCase() {
                    return _ref5.apply(this, arguments);
                  };
                }();

                owner = formData.users.find(function (user) {
                  return user.id === _this2.caseData.user.id;
                });
                newOwner = formData.users.find(function (user) {
                  return user.id === formData.data.user_id;
                });

                if (!(owner && newOwner && owner.id !== newOwner.id)) {
                  _context4.next = 11;
                  break;
                }

                _this2.setModal2Action({
                  action: 'toast',
                  width: '496px',
                  customStyles: {
                    padding: 0,
                    border: 0
                  },
                  param: {
                    type: 'alert',
                    content: _this2.$t('DIALOG.caseEdit.modal.content.___changeOwner', { old_owner: [owner.first_name, owner.last_name].filter(function (x) {
                        return x;
                      }).join(' '), new_owner: [newOwner.first_name, newOwner.last_name].filter(function (x) {
                        return x;
                      }).join(' ') }),
                    buttons: [{
                      title: _this2.$t('COMMON.button.___cancel'),
                      type: 'gray',
                      result: false
                    }, {
                      title: _this2.$t('COMMON.button.___change'),
                      type: 'alert',
                      result: true
                    }]
                  },
                  callback: function () {
                    var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(result) {
                      return regenerator_default.a.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              if (!result) {
                                _context3.next = 5;
                                break;
                              }

                              _context3.next = 3;
                              return sendCase();

                            case 3:
                              _context3.next = 6;
                              break;

                            case 5:
                              _this2.onSubmit = false;

                            case 6:
                            case 'end':
                              return _context3.stop();
                          }
                        }
                      }, _callee3, _this2);
                    }));

                    return function callback(_x) {
                      return _ref6.apply(this, arguments);
                    };
                  }()
                });
                _context4.next = 13;
                break;

              case 11:
                _context4.next = 13;
                return sendCase();

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f41a2b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseEdit.vue
var caseEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-edit-dailog col-block block"},[_c('div',{staticClass:"form-container col-block width-full"},[_c('caseBase',{ref:'form-main',attrs:{"mode":'edit',"isUpdate":true,"layoutBlocks":[
        'form'
      ],"dataset":_vm.caseData.dataset,"defaultData":_vm.defaultData},on:{"onError":function (error) { return _vm.onError = error; },"unloadAlert":function (alert) { return _vm.unloadAlert = alert; }}})],1),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit && _vm.validateSendCase(); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___update')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var caseEdit_staticRenderFns = []
var caseEdit_esExports = { render: caseEdit_render, staticRenderFns: caseEdit_staticRenderFns }
/* harmony default export */ var dialog_caseEdit = (caseEdit_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseEdit.vue
var caseEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseEdit___vue_template_functional__ = false
/* styles */
var caseEdit___vue_styles__ = null
/* scopeId */
var caseEdit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseEdit___vue_module_identifier__ = null
var caseEdit_Component = caseEdit_normalizeComponent(
  caseEdit,
  dialog_caseEdit,
  caseEdit___vue_template_functional__,
  caseEdit___vue_styles__,
  caseEdit___vue_scopeId__,
  caseEdit___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseEdit = (caseEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/projectEdit.vue








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var projectEdit = ({
  components: {
    caseBase: base["a" /* default */],
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */], licenseManager["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      caseData: {},
      analysisData: {},
      importData: {},
      selectedProjectID: null,
      onError: false,
      onSubmit: {
        info: false,
        phenotype: false
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user']), {
    defaultData: function defaultData() {
      return {
        'case': this.caseData,
        'analysis': this.analysisData
      };
    },
    isGVCF: function isGVCF() {
      return this.caseData.dataset === 'vcf' && (((this.param.analysisFiles || {})['Analysis Files'] || {})['VCF file (SNV)'] || []).some(function (file) {
        return file.name.includes('.gvcf.');
      });
    },

    // static
    projectOptions: function projectOptions() {
      return this.param.projects.map(function (project) {
        return { title: project.name, value: project.id };
      });
    },
    formOptions: function formOptions() {
      var _this = this;

      return {
        'field1': [{
          title: this.$t('DIALOG.projectEdit.form.title.___import'),
          value: 'import',
          type: 'select',
          grid: 2,
          options: this.projectOptions,
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return _this.$t('DIALOG.projectEdit.form.placeholder.___import');
          }
        }, {
          title: '　',
          value: 'IMPORT_BUTTON',
          type: 'custom',
          grid: 4
        }]
      };
    }
  }),
  created: function created() {
    this.caseData = extends_default()({}, this.param.caseData);
    this.analysisData = extends_default()({}, this.param.project);
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction', 'setModalAction', 'setModal2Action']), {
    importProject: function importProject() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var keepKeyList, project, forms, datas, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, form, data, keepData;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                keepKeyList = ['id', 'name', 'note', 'report_phenovardb'];
                project = _this2.param.projects.find(function (project) {
                  return project.id === _this2.selectedProjectID;
                }) || {};
                forms = entries_default()(_this2.$refs).filter(function (_ref) {
                  var _ref2 = slicedToArray_default()(_ref, 1),
                      key = _ref2[0];

                  return key.startsWith('form-');
                }).map(function (_ref3) {
                  var _ref4 = slicedToArray_default()(_ref3, 2),
                      key = _ref4[0],
                      ref = _ref4[1];

                  return ref[0] || ref;
                });
                datas = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 7;
                _iterator = get_iterator_default()(forms);

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 22;
                  break;
                }

                form = _step.value;
                _context.next = 13;
                return form.submit();

              case 13:
                data = _context.sent;

                if (!(form && !data)) {
                  _context.next = 18;
                  break;
                }

                throw new Error();

              case 18:
                datas.push(data);

              case 19:
                _iteratorNormalCompletion = true;
                _context.next = 9;
                break;

              case 22:
                _context.next = 28;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 28:
                _context.prev = 28;
                _context.prev = 29;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 31:
                _context.prev = 31;

                if (!_didIteratorError) {
                  _context.next = 34;
                  break;
                }

                throw _iteratorError;

              case 34:
                return _context.finish(31);

              case 35:
                return _context.finish(28);

              case 36:
                keepData = keepKeyList.reduce(function (data, key) {
                  return extends_default()({}, data, defineProperty_default()({}, key, datas[0].data.project[key]));
                }, {});

                _this2.analysisData = extends_default()({}, project, keepData);

              case 38:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[7, 24, 28, 36], [29,, 31, 35]]);
      }))();
    },
    validateSendCase: function validateSendCase(isAnalysis) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _forms, success, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, form, result, _datas, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _form, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.checkLicenseStatus(_this3.licenseTypeMap[_this3.caseData.dataset], function (today) {
                  return !today ? null : ['alert'];
                });

              case 2:
                if (!_context2.sent) {
                  _context2.next = 79;
                  break;
                }

                _context2.prev = 3;
                _forms = entries_default()(_this3.$refs).filter(function (_ref5) {
                  var _ref6 = slicedToArray_default()(_ref5, 1),
                      key = _ref6[0];

                  return key.startsWith('form-');
                }).map(function (_ref7) {
                  var _ref8 = slicedToArray_default()(_ref7, 2),
                      key = _ref8[0],
                      ref = _ref8[1];

                  return ref[0] || ref;
                });
                success = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 9;
                _iterator2 = get_iterator_default()(_forms);

              case 11:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context2.next = 20;
                  break;
                }

                form = _step2.value;
                _context2.next = 15;
                return form.validateSubmit();

              case 15:
                result = _context2.sent;

                if (form && !result) {
                  success = false;
                }

              case 17:
                _iteratorNormalCompletion2 = true;
                _context2.next = 11;
                break;

              case 20:
                _context2.next = 26;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2['catch'](9);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 26:
                _context2.prev = 26;
                _context2.prev = 27;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 29:
                _context2.prev = 29;

                if (!_didIteratorError2) {
                  _context2.next = 32;
                  break;
                }

                throw _iteratorError2;

              case 32:
                return _context2.finish(29);

              case 33:
                return _context2.finish(26);

              case 34:
                if (!success) {
                  _context2.next = 75;
                  break;
                }

                _datas = [];
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context2.prev = 39;
                _iterator3 = get_iterator_default()(_forms);

              case 41:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context2.next = 54;
                  break;
                }

                _form = _step3.value;
                _context2.next = 45;
                return _form.submit();

              case 45:
                data = _context2.sent;

                if (!(_form && !data)) {
                  _context2.next = 50;
                  break;
                }

                throw new Error();

              case 50:
                _datas.push(data);

              case 51:
                _iteratorNormalCompletion3 = true;
                _context2.next = 41;
                break;

              case 54:
                _context2.next = 60;
                break;

              case 56:
                _context2.prev = 56;
                _context2.t1 = _context2['catch'](39);
                _didIteratorError3 = true;
                _iteratorError3 = _context2.t1;

              case 60:
                _context2.prev = 60;
                _context2.prev = 61;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 63:
                _context2.prev = 63;

                if (!_didIteratorError3) {
                  _context2.next = 66;
                  break;
                }

                throw _iteratorError3;

              case 66:
                return _context2.finish(63);

              case 67:
                return _context2.finish(60);

              case 68:
                _context2.next = 70;
                return _this3.checkAlerts();

              case 70:
                if (!_context2.sent) {
                  _context2.next = 75;
                  break;
                }

                _this3.setLoadingAction(true);
                _this3.onSubmit[!isAnalysis ? 'info' : 'phenotype'] = true;
                _context2.next = 75;
                return _this3.sendCase(_datas[0], isAnalysis);

              case 75:
                _context2.next = 79;
                break;

              case 77:
                _context2.prev = 77;
                _context2.t2 = _context2['catch'](3);

              case 79:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[3, 77], [9, 22, 26, 34], [27,, 29, 33], [39, 56, 60, 68], [61,, 63, 67]]);
      }))();
    },
    checkAlerts: function checkAlerts() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!['Unknown'].includes(_this4.caseData.sex)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 3;
                return _this4.unknownSexAlert();

              case 3:
                if (_context3.sent) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt('return');

              case 5:
                return _context3.abrupt('return', true);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    unknownSexAlert: function unknownSexAlert() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt('return', new promise_default.a(function (resolve) {
                  _this5.setModal2Action({
                    action: 'toast',
                    width: '496px',
                    customStyles: {
                      padding: 0,
                      border: 0
                    },
                    param: {
                      type: 'alert',
                      content: _this5.$t('DIALOG.projectEdit.modal.content.___unknownSexAlert'),
                      buttons: [{
                        title: _this5.$t('COMMON.button.___cancel'),
                        type: 'gray',
                        result: false
                      }, {
                        title: _this5.$t('COMMON.button.___create'),
                        type: 'alert',
                        result: true
                      }]
                    },
                    callback: function () {
                      var _ref9 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(result) {
                        return regenerator_default.a.wrap(function _callee4$(_context4) {
                          while (1) {
                            switch (_context4.prev = _context4.next) {
                              case 0:
                                resolve(result);

                              case 1:
                              case 'end':
                                return _context4.stop();
                            }
                          }
                        }, _callee4, _this5);
                      }));

                      return function callback(_x) {
                        return _ref9.apply(this, arguments);
                      };
                    }()
                  });
                }));

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    sendCase: function sendCase(formData, isAnalysis) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var config, id, projectID, data, sendCase;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                config = _this6.$ls.get('userInfo');
                id = _this6.param.caseData.id;
                projectID = _this6.param.project.id;
                data = formData.data;

                sendCase = function () {
                  var _ref10 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
                    var response, newProject;
                    return regenerator_default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.prev = 0;

                            if (projectID) {
                              _context6.next = 7;
                              break;
                            }

                            _context6.next = 4;
                            return Object(src_api["_123" /* postProject */])(id, data.project, config);

                          case 4:
                            _context6.t0 = _context6.sent;
                            _context6.next = 17;
                            break;

                          case 7:
                            if (!isAnalysis) {
                              _context6.next = 13;
                              break;
                            }

                            _context6.next = 10;
                            return Object(src_api["_148" /* putProjectPhenotype */])(projectID, id, data.project, config);

                          case 10:
                            _context6.t1 = _context6.sent;
                            _context6.next = 16;
                            break;

                          case 13:
                            _context6.next = 15;
                            return Object(src_api["_147" /* putProjectInfo */])(projectID, id, data.project, config);

                          case 15:
                            _context6.t1 = _context6.sent;

                          case 16:
                            _context6.t0 = _context6.t1;

                          case 17:
                            response = _context6.t0;
                            newProject = response.data.data;

                            response.data.result && _this6.addToast('success', response.data.result.message);
                            _this6.$emit('changeModal', {}, newProject);
                            _context6.next = 26;
                            break;

                          case 23:
                            _context6.prev = 23;
                            _context6.t2 = _context6['catch'](0);

                            _this6.addToast('error', !_context6.t2.response ? _context6.t2.message : _context6.t2.response.data.result.message);

                          case 26:
                            _this6.onSubmit[!isAnalysis ? 'info' : 'phenotype'] = false;
                            _this6.setLoadingAction(false);

                          case 28:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, _this6, [[0, 23]]);
                  }));

                  return function sendCase() {
                    return _ref10.apply(this, arguments);
                  };
                }();

                _context7.next = 7;
                return sendCase();

              case 7:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d67323e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/projectEdit.vue
var projectEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-edit-dailog col-block block"},[_c('div',{staticClass:"form-container col-block width-full"},[_c('caseBase',{ref:'form-main',attrs:{"mode":'analysis',"isUpdate":!!_vm.param.project.id,"layoutBlocks":[
        'form',
        'analysis'
      ],"dataset":_vm.isGVCF ? 'gvcf' : _vm.caseData.dataset,"defaultData":_vm.defaultData,"projects":_vm.param.projects},on:{"onError":function (error) { return _vm.onError = error; },"unloadAlert":function (alert) { return _vm.unloadAlert = alert; }},scopedSlots:_vm._u([{key:"analysis-update",fn:function(props){return [_c('div',{staticClass:"analysis-update-container row-block",attrs:{"name":props}},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit['info'] },attrs:{"type":"button","disabled":!props.data.project.name},on:{"click":function (e) { return !_vm.onSubmit['info'] && _vm.validateSendCase(false); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___update')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]}},{key:"analysis-import",fn:function(props){return [_c('div',{staticClass:"analysis-import-container col-block",attrs:{"name":props}},[_c('customForm',{attrs:{"init":_vm.importData,"layoutType":'grid',"groupCount":6,"forms":_vm.formOptions['field1'],"scope":'import',"reading":false},on:{"change":function (result) { return _vm.selectedProjectID = result.import; }},scopedSlots:_vm._u([{key:"IMPORT_BUTTON",fn:function(props){return [_c('div',{staticClass:"IMPORT_BUTTON-container row-block",attrs:{"name":props}},[_c('button',{staticClass:"main-button circle-button",attrs:{"type":"button","disabled":!_vm.selectedProjectID},on:{"click":function (e) { return _vm.importProject(); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___import')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]}}])})],1)]}}])})],1),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit['phenotype'] },attrs:{"disabled":false},on:{"click":function (e) { return !_vm.onSubmit['phenotype'] && _vm.validateSendCase(true); }}},[_c('span',[_vm._v(_vm._s(_vm.param.project.id ? _vm.$t('COMMON.button.___reanalysis') : _vm.$t('COMMON.button.___create')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var projectEdit_staticRenderFns = []
var projectEdit_esExports = { render: projectEdit_render, staticRenderFns: projectEdit_staticRenderFns }
/* harmony default export */ var dialog_projectEdit = (projectEdit_esExports);
// CONCATENATED MODULE: ./src/components/dialog/projectEdit.vue
var projectEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var projectEdit___vue_template_functional__ = false
/* styles */
var projectEdit___vue_styles__ = null
/* scopeId */
var projectEdit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var projectEdit___vue_module_identifier__ = null
var projectEdit_Component = projectEdit_normalizeComponent(
  projectEdit,
  dialog_projectEdit,
  projectEdit___vue_template_functional__,
  projectEdit___vue_styles__,
  projectEdit___vue_scopeId__,
  projectEdit___vue_module_identifier__
)

/* harmony default export */ var components_dialog_projectEdit = (projectEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/digitalMLPA/mainUpload.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var mainUpload = ({
  mixins: [toastMethods["a" /* default */]],
  data: function data() {
    return {
      file: null,
      alert: ''
    };
  },

  computed: {
    sendData: function sendData() {
      return { file: this.file };
    },

    // global
    fileTypeCheck: function fileTypeCheck() {
      return util["f" /* fileTypeCheck */];
    }
  },
  methods: {
    selectFile: function selectFile(e) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var file, alert;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file = e.target.files[0];
                _context.next = 3;
                return _this.checkFile();

              case 3:
                alert = _context.sent;

                if (alert) {
                  _this.alert = alert;
                } else {
                  _this.file = file;
                  _this.alert = '';
                  e.target.value = '';
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    checkFile: function checkFile(file) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-230038cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/digitalMLPA/mainUpload.vue
var mainUpload_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-digital-mlpa-main-upload-page col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-main-upload-container block col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-main-upload-block block col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-main-upload-main-container col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-main-upload-main-block row-block flex-start"},[_c('div',{staticClass:"case-digital-mlpa-main-upload-form-container col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"case-digital-mlpa-main-upload-form-title-container row-block"},[_c('div',{staticClass:"case-digital-mlpa-main-upload-form-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.digitalMLPA.mainUpload.upload.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),(_vm.file)?_c('div',{staticClass:"case-digital-mlpa-main-upload-form-file"},[_vm._v(_vm._s(_vm.file.name))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"case-digital-mlpa-main-upload-form-input col-block flex-start"},[_c('div',{staticClass:"center-block"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":'mlpa-file',"accept":"text/xml,application/xml","extension":"xml"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.selectFile(e); }, function () { return _vm.addToast('error', _vm.$t('COMMON.toast.___fileTypeAlert', { types: 'XML' })); }); }}}),_vm._v(" "),_c('label',{staticClass:"white-button circle-button center-block",attrs:{"for":'mlpa-file'}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])])])]),_vm._v(" "),(_vm.alert)?_c('div',{staticClass:"case-digital-mlpa-main-upload-form-alert"},[_vm._v(_vm._s(_vm.alert))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"case-digital-mlpa-main-upload-notification-container col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"case-digital-mlpa-main-upload-notification-title-container row-block"},[_c('div',{staticClass:"case-digital-mlpa-main-upload-notification-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.digitalMLPA.mainUpload.notification.___title', { version: 'v2.5.1' })))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"case-digital-mlpa-main-upload-notification-content",domProps:{"innerHTML":_vm._s(_vm.$t('COMPONENT.digitalMLPA.mainUpload.notification.___content'))}})])])]),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"case-digital-mlpa-main-upload-button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",attrs:{"disabled":!_vm.file},on:{"click":function (e) { return _vm.$emit('create', _vm.sendData); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___analysis')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })})])])])}
var mainUpload_staticRenderFns = []
var mainUpload_esExports = { render: mainUpload_render, staticRenderFns: mainUpload_staticRenderFns }
/* harmony default export */ var digitalMLPA_mainUpload = (mainUpload_esExports);
// CONCATENATED MODULE: ./src/components/digitalMLPA/mainUpload.vue
var mainUpload_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var mainUpload___vue_template_functional__ = false
/* styles */
var mainUpload___vue_styles__ = null
/* scopeId */
var mainUpload___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mainUpload___vue_module_identifier__ = null
var mainUpload_Component = mainUpload_normalizeComponent(
  mainUpload,
  digitalMLPA_mainUpload,
  mainUpload___vue_template_functional__,
  mainUpload___vue_styles__,
  mainUpload___vue_scopeId__,
  mainUpload___vue_module_identifier__
)

/* harmony default export */ var components_digitalMLPA_mainUpload = (mainUpload_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/digitalMLPA/mainDataInfo.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var mainDataInfo = ({
  components: {
    borCor: newBorCor["a" /* default */]
  },
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  computed: {
    infoData: function infoData() {
      var view = this.project.views || {};
      return ['MetadataView', 'QualityView'].reduce(function (data, key) {
        return extends_default()({}, data, view[key] || {});
      }, {});
    },

    // static
    dataOptions: function dataOptions() {
      var _this = this;

      return {
        'info': {
          options: [
          // 1
          {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Barcode_Name.___title'),
            value: function value(data) {
              return data.barcode_name;
            },
            grid: 3
          }, {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Sample_Name.___title'),
            value: function value(data) {
              return data.sample_name;
            },
            grid: 3
          }, {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Sample_Type.___title'),
            value: function value(data) {
              return data.sample_settings;
            },
            grid: 3
          }, {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Product_Name.___title'),
            value: function value(data) {
              return data.product_name;
            },
            grid: 3
          },
          // 2
          {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Sheet_Name.___title'),
            value: function value(data) {
              return data.sheet_name;
            },
            grid: 3
          }, {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Analyzed_Sex.___title'),
            value: function value(data) {
              return {
                'Male': _this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Analyzed_Sex.value.___Male'),
                'Female': _this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Analyzed_Sex.value.___Female')
              }[data.analysed_sex];
            },
            style: function style(data) {
              return {
                color: {
                  'Male': '#003679',
                  'Female': '#BE0F0F'
                }[data.analysed_sex]
              };
            },
            grid: 3
          }, {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.info.table.Analyzed_Panels.___title', { count: (this.infoData.aberrant_panel || []).length }),
            value: function value(data) {
              return (data.analyzed_panel || []).map(function (panel) {
                return '<span ' + ((data.aberrant_panel || []).includes(panel) ? 'class="alert bold"' : '') + '>' + panel + '</span>';
              }).join(', ');
            },
            grid: 6
          }]
        },
        'quality': {
          title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.___title'),
          options: [
          // 1
          {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Is_Passed.___title'),
            value: function value(data) {
              return {
                'true': _this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Is_Passed.value.___Pass'),
                'false': _this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Is_Passed.value.___Failed')
              }[data.is_passed];
            },
            style: function style(data) {
              return {
                color: {
                  'true': '#83C91E',
                  'false': '#FA3D3D'
                }[data.is_passed]
              };
            },
            grid: 3
          }, {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Plausible_Root_Cause.___title'),
            value: function value(data) {
              return {
                'NotApplicable': _this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Plausible_Root_Cause.value.___NotApplicable')
              }[data.plausible_root_cause] || _this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Plausible_Root_Cause.value.___Others');
            },
            style: function style(data) {
              return {
                color: {
                  'NotApplicable': '#FA3D3D'
                }[data.plausible_root_cause]
              };
            },
            grid: 3
          }, {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Plausible_Root_Cause_Description.___title'),
            value: function value(data) {
              return {
                'n/a': _this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Plausible_Root_Cause_Description.value.___NA')
              }[data.plausible_root_cause_description] || _this.$t('COMPONENT.digitalMLPA.mainDataInfo.data.quality.table.Plausible_Root_Cause_Description.value.___Others');
            },
            style: function style(data) {
              return {
                color: {
                  'n/a': '#999999'
                }[data.plausible_root_cause_description]
              };
            },
            grid: 6
          }]
        }
      };
    },
    tableOptions: function tableOptions() {
      var tableData = (((this.project.views || {}).QualityView || {}).qualityitem || []).reduce(function (data, item) {
        return extends_default()({}, data, defineProperty_default()({}, item.aspect, {
          result: !(item.classification === 'OK'),
          infos: (item.children || []).reduce(function (infos, child) {
            return extends_default()({}, infos, child.aspect ? defineProperty_default()({}, child.aspect, !(child.classification === 'OK')) : {});
          }, {})
        }));
      }, {});
      return {
        'quality': {
          options: [
          // 1
          {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Overall'),
            result: tableData['Overall'].result,
            infos: tableData['Overall'].infos,
            grid: 2
          }, {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Data_Analysis'),
            result: tableData['Data Analysis'].result,
            infos: tableData['Data Analysis'].infos,
            grid: 2
          }, {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Dna'),
            result: tableData['Dna'].result,
            infos: tableData['Dna'].infos,
            grid: 2
          }, {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Hybridisation'),
            result: tableData['Hybridisation'].result,
            infos: tableData['Hybridisation'].infos,
            grid: 2
          }, {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Identity'),
            result: tableData['Identity'].result,
            infos: tableData['Identity'].infos,
            grid: 2
          },
          // 2
          {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Ligase_Activity'),
            result: tableData['Ligase Activity'].result,
            infos: tableData['Ligase Activity'].infos,
            grid: 2
          }, {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Ligation'),
            result: tableData['Ligation'].result,
            infos: tableData['Ligation'].infos,
            grid: 2
          }, {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Polymerase'),
            result: tableData['Polymerase'].result,
            infos: tableData['Polymerase'].infos,
            grid: 2
          }, {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Program'),
            result: tableData['Program'].result,
            infos: tableData['Program'].infos,
            grid: 2
          }, {
            title: this.$t('COMPONENT.digitalMLPA.mainDataInfo.table.quality.title.___Sample_Run'),
            result: tableData['Sample Run'].result,
            infos: tableData['Sample Run'].infos,
            grid: 2
          }]
        }
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3deddc38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/digitalMLPA/mainDataInfo.vue
var mainDataInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-digital-mlpa-main-data-info-page col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-main-data-info-data-group-container col-block width-full"},_vm._l((Object.keys(_vm.dataOptions)),function(key){return _c('div',{key:key,staticClass:"case-digital-mlpa-main-data-info-data-container col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-main-data-info-data-block col-block width-full"},[(_vm.dataOptions[key].title)?_c('div',{staticClass:"case-digital-mlpa-main-data-info-data-title-container row-block"},[_c('div',{staticClass:"case-digital-mlpa-main-data-info-data-title ellipsis"},[_vm._v(_vm._s(_vm.dataOptions[key].title))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"case-digital-mlpa-main-data-info-data-table-container col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-main-data-info-data-table-block"},_vm._l((_vm.dataOptions[key].options),function(option,oindex){return _c('div',{key:oindex,staticClass:"case-digital-mlpa-main-data-info-data-table-data-container col-block width-full",style:({ '--grid': option.grid || 1 })},[_c('div',{staticClass:"case-digital-mlpa-main-data-info-data-table-data-title-container row-block"},[_c('div',{staticClass:"case-digital-mlpa-main-data-info-data-table-data-title ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"case-digital-mlpa-main-data-info-data-table-data-content-container col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-main-data-info-data-table-data-content break-line",style:((option.style || (function () {}))(_vm.infoData)),domProps:{"innerHTML":_vm._s(option.value(_vm.infoData) || '<h5>- -</h5>')}})]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])])])}),0),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"case-digital-mlpa-main-data-info-table-group-container col-block width-full"},_vm._l((Object.keys(_vm.tableOptions)),function(key){return _c('div',{key:key,staticClass:"case-digital-mlpa-main-data-info-table-container col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-main-data-info-table-block col-block width-full"},[(_vm.tableOptions[key].title)?_c('div',{staticClass:"case-digital-mlpa-main-data-info-table-title-container row-block"},[_c('div',{staticClass:"case-digital-mlpa-main-data-info-table-title ellipsis"},[_vm._v(_vm._s(_vm.tableOptions[key].title))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"case-digital-mlpa-main-data-info-table-table-container col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-main-data-info-table-table-block"},_vm._l((_vm.tableOptions[key].options),function(option,oindex){return _c('div',{key:oindex,staticClass:"case-digital-mlpa-main-data-info-table-table-data-container col-block width-full",style:({ '--grid': option.grid || 1 })},[_c('div',{staticClass:"case-digital-mlpa-main-data-info-table-table-data-block title col-block"},[_c('div',{staticClass:"case-digital-mlpa-main-data-info-table-table-data-cell-container row-block"},[_c('div',{staticClass:"case-digital-mlpa-main-data-info-table-table-data-cell-block shrink ellipsis"},[_vm._v(_vm._s(option.title))])])]),_vm._v(" "),_c('div',{staticClass:"case-digital-mlpa-main-data-info-table-table-data-block content col-block"},[_c('div',{staticClass:"case-digital-mlpa-main-data-info-table-table-data-cell-container row-block"},[_c('div',{staticClass:"case-digital-mlpa-main-data-info-table-table-data-cell-block shrink ellipsis",class:{ alert: !option.result },domProps:{"innerHTML":_vm._s(_vm.$t(option.result ? 'COMPONENT.digitalMLPA.mainDataInfo.table.quality.content.___OK' : 'COMPONENT.digitalMLPA.mainDataInfo.table.quality.content.___Warning'))}}),_vm._v(" "),(Object.keys(option.infos || {}).length)?_c('div',{staticClass:"case-digital-mlpa-main-data-info-table-table-data-cell-info-container"},[_c('borCor',{attrs:{"reverse":!((oindex + 1) % 5),"background":'white',"border":'#CCCCCC',"radius":'0px',"blockStyle":{ padding: '8px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("d5V5"),"alt":""}})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"case-digital-mlpa-main-data-info-table-table-data-cell-info-block col-block flex-start"},_vm._l((Object.keys(option.infos || {})),function(key){return _c('span',{key:key,staticClass:"case-digital-mlpa-main-data-info-table-table-data-cell-info",class:{ alert: !option.infos[key] },domProps:{"innerHTML":_vm._s(_vm.$t(option.infos[key] ? 'COMPONENT.digitalMLPA.mainDataInfo.table.quality.info.___OK' : 'COMPONENT.digitalMLPA.mainDataInfo.table.quality.info.___Failed', { field: key }))}})}),0)])])],1):_vm._e()])])])}),0)])])])}),0)])}
var mainDataInfo_staticRenderFns = []
var mainDataInfo_esExports = { render: mainDataInfo_render, staticRenderFns: mainDataInfo_staticRenderFns }
/* harmony default export */ var digitalMLPA_mainDataInfo = (mainDataInfo_esExports);
// CONCATENATED MODULE: ./src/components/digitalMLPA/mainDataInfo.vue
var mainDataInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var mainDataInfo___vue_template_functional__ = false
/* styles */
var mainDataInfo___vue_styles__ = null
/* scopeId */
var mainDataInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mainDataInfo___vue_module_identifier__ = null
var mainDataInfo_Component = mainDataInfo_normalizeComponent(
  mainDataInfo,
  digitalMLPA_mainDataInfo,
  mainDataInfo___vue_template_functional__,
  mainDataInfo___vue_styles__,
  mainDataInfo___vue_scopeId__,
  mainDataInfo___vue_module_identifier__
)

/* harmony default export */ var components_digitalMLPA_mainDataInfo = (mainDataInfo_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-echarts/dist/index.esm.min.js + 1 modules
var index_esm_min = __webpack_require__("TbzG");

// EXTERNAL MODULE: ./node_modules/echarts/core.js + 10 modules
var core = __webpack_require__("Qf3D");

// EXTERNAL MODULE: ./node_modules/echarts/renderers.js + 13 modules
var renderers = __webpack_require__("S+cJ");

// EXTERNAL MODULE: ./node_modules/echarts/charts.js + 148 modules
var charts = __webpack_require__("mCPF");

// EXTERNAL MODULE: ./node_modules/echarts/components.js + 136 modules
var components = __webpack_require__("XReE");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/digitalMLPA/mainDataChart.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






Object(core["c" /* use */])([renderers["a" /* CanvasRenderer */], charts["d" /* ScatterChart */], charts["b" /* CustomChart */], components["h" /* TooltipComponent */], components["d" /* GridComponent */], components["f" /* MarkLineComponent */]]);

/* harmony default export */ var mainDataChart = ({
  components: {
    vueCharts: index_esm_min["a" /* default */]
  },
  props: {
    panelData: {
      type: Object,
      required: true
    },
    selectData: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  computed: {
    chartDatas: function chartDatas() {
      var panelData = this.panelData || {};
      var chartDataMap = ((panelData.chart_view || {}).data || []).reduce(function (map, data) {
        return extends_default()({}, map, defineProperty_default()({}, data['Probe Number'], data));
      }, {});
      return (panelData.fragment_table || []).map(function (data) {
        return chartDataMap[data['Probe Number']];
      });
    },

    // chart
    chartOption: function chartOption() {
      return {
        'fragment_chart': {
          xAxis: [{
            type: 'category',
            name: this.$t('COMPONENT.digitalMLPA.mainDataChart.chart.axis.title.___Probe'),
            nameLocation: 'middle',
            nameGap: 60,
            nameTextStyle: {
              fontWeight: 'bold'
            },
            axisLabel: {
              fontWeight: 'bold',
              margin: 10,
              rotate: 90
            },
            axisTick: {
              alignWithLabel: true
            },
            boundaryGap: true,
            data: this.chartDatas.map(function (data) {
              return data['Probe Number'];
            })
          }, {
            position: 'top',
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              onZero: false
            }
          }],
          yAxis: [{
            type: 'value',
            name: this.$t('COMPONENT.digitalMLPA.mainDataChart.chart.axis.title.___Copy_Number_Ratio'),
            nameLocation: 'middle',
            nameGap: 40,
            nameTextStyle: {
              fontWeight: 'bold'
            },
            max: 2,
            min: 0,
            interval: 0.25,
            axisLabel: {
              fontWeight: 'bold',
              formatter: function formatter(value) {
                return value.toFixed(2);
              }
            },
            axisLine: {
              show: true
            },
            splitLine: {
              lineStyle: {
                color: '#DEDEDE'
              }
            }
          }, {
            position: 'right',
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true
            }
          }],
          grid: {
            left: 20,
            right: 5,
            top: 10,
            bottom: 15,
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            showContent: false,
            axisPointer: {
              type: 'shadow',
              shadowStyle: {
                color: 'rgba(0, 82, 140, 0.08)'
              }
            }
          },
          series: [{
            type: 'custom',
            silent: true,
            animation: false,
            renderItem: function renderItem(params, api) {
              var items = [];
              var lineData = {
                length: 15,
                weight: 1.5
              };
              var category = api.value(0);
              // reference
              if (api.value(1) && api.value(2)) {
                var referencePoints = {
                  lower: api.coord([category, api.value(1)]),
                  upper: api.coord([category, api.value(2)]),
                  center: api.coord([category, (api.value(1) - -api.value(2)) / 2])
                };
                items = [].concat(toConsumableArray_default()(items), [{
                  type: 'rect',
                  shape: {
                    x: referencePoints.lower[0] - lineData.length / 2,
                    y: referencePoints.lower[1] - lineData.weight / 2,
                    width: lineData.length,
                    height: lineData.weight
                  },
                  style: {
                    fill: '#6D6D6D'
                  }
                }, {
                  type: 'rect',
                  shape: {
                    x: referencePoints.upper[0] - lineData.length / 2,
                    y: referencePoints.upper[1] - lineData.weight / 2,
                    width: lineData.length,
                    height: lineData.weight
                  },
                  style: {
                    fill: '#6D6D6D'
                  }
                }, {
                  type: 'rect',
                  shape: {
                    x: referencePoints.lower[0] - lineData.weight / 2,
                    y: referencePoints.lower[1] - lineData.weight / 2,
                    width: 2,
                    height: referencePoints.upper[1] - referencePoints.lower[1] + lineData.weight
                  },
                  style: {
                    fill: '#6D6D6D'
                  }
                }, {
                  type: 'circle',
                  shape: {
                    cx: referencePoints.center[0],
                    cy: referencePoints.center[1],
                    r: 4
                  },
                  style: {
                    fill: '#6D6D6D'
                  }
                }]);
              }
              // expected
              if (api.value(3) && api.value(4)) {
                var expectedPoints = {
                  min: api.coord([category, api.value(3)]),
                  max: api.coord([category, api.value(4)])
                };
                items = [].concat(toConsumableArray_default()(items), [{
                  type: 'rect',
                  shape: {
                    x: expectedPoints.min[0] - lineData.length / 2,
                    y: expectedPoints.min[1] - lineData.weight / 2,
                    width: lineData.length,
                    height: lineData.weight
                  },
                  style: {
                    fill: '#FB000C'
                  }
                }, {
                  type: 'rect',
                  shape: {
                    x: expectedPoints.max[0] - lineData.length / 2,
                    y: expectedPoints.max[1] - lineData.weight / 2,
                    width: lineData.length,
                    height: lineData.weight
                  },
                  style: {
                    fill: '#0000FF'
                  }
                }]);
              }
              // result
              if (api.value(5)) {
                var resultPoint = api.coord([category, api.value(5)]);
                var aberrant = api.value(6);
                items = [].concat(toConsumableArray_default()(items), [{
                  type: 'circle',
                  shape: {
                    cx: resultPoint[0],
                    cy: resultPoint[1],
                    r: 5
                  },
                  style: {
                    fill: aberrant === 'true' ? '#F8C600' : '#000000'
                  }
                }]);
              }
              return {
                type: 'group',
                children: items
              };
            },
            data: this.chartDatas.map(function (data) {
              return [data['Probe Number'], data['Reference Lower'], data['Reference Upper'], data['Expected Min'], data['Expected Max'], data['Result'], data['Aberrant']];
            })
          }]
        },
        'statistic_chart': {
          xAxis: [{
            type: 'category',
            name: this.$t('COMPONENT.digitalMLPA.mainDataChart.chart.axis.title.___Probe'),
            nameLocation: 'middle',
            nameGap: 40,
            nameTextStyle: {
              fontWeight: 'bold'
            },
            axisLabel: {
              fontWeight: 'bold',
              margin: 10,
              rotate: 90
            },
            axisTick: {
              alignWithLabel: true
            },
            boundaryGap: true,
            data: this.chartDatas.map(function (data) {
              return data['Probe Number'].replace('Median ', '');
            })
          }, {
            position: 'top',
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              onZero: false
            }
          }],
          yAxis: [{
            type: 'value',
            name: this.$t('COMPONENT.digitalMLPA.mainDataChart.chart.axis.title.___Copy_Number_Ratio'),
            nameLocation: 'middle',
            nameGap: 34,
            nameTextStyle: {
              fontWeight: 'bold'
            },
            max: Math.max(Math.ceil(Math.max.apply(Math, toConsumableArray_default()(this.chartDatas.map(function (data) {
              return Number(data['Result']);
            }))) * 10) / 10, 1),
            min: Math.min(Math.floor(Math.min.apply(Math, toConsumableArray_default()(this.chartDatas.map(function (data) {
              return Number(data['Result']);
            }))) * 10) / 10, 1),
            interval: 0.1,
            axisLabel: {
              fontWeight: 'bold',
              formatter: function formatter(value) {
                return value.toFixed(1);
              }
            },
            axisLine: {
              show: true
            },
            splitLine: {
              show: false
            }
          }, {
            position: 'right',
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true
            }
          }],
          grid: {
            left: 20,
            right: 5,
            top: 10,
            bottom: 20,
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            showContent: false,
            axisPointer: {
              type: 'shadow',
              shadowStyle: {
                color: 'rgba(0, 82, 140, 0.08)'
              }
            }
          },
          series: [{
            type: 'scatter',
            silent: true,
            animation: false,
            symbol: 'path://M-5,-10 L-10,-5 L-3,0 L-10,5 L-5,10 L0,3 L5,10 L10,5 L3,0 L10,-5 L5,-10 L0,-3 Z',
            symbolSize: 8,
            itemStyle: {
              color: '#000000'
            },
            emphasis: {
              scale: false
            },
            markLine: {
              silent: true,
              symbol: 'none',
              lineStyle: {
                type: 'dashed',
                opacity: 0.3,
                width: 1
              },
              data: [{ yAxis: 1.0 }]
            },
            data: this.chartDatas.map(function (data) {
              return [data['Probe Number'].replace('Median ', ''), data['Result']];
            })
          }]
        }
      };
    }
  },
  watch: {
    'selectData': function selectData(nv) {
      var chart = this.$refs['mlpa-chart'];
      chart.dispatchAction({
        type: 'showTip',
        seriesIndex: 0,
        dataIndex: nv ? this.chartDatas.indexOf(this.chartDatas.find(function (data) {
          return data['Probe Number'] === nv['Probe Number'];
        })) : -1
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    var chart = this.$refs['mlpa-chart'];
    chart.chart.on('updateAxisPointer', function (params) {
      _this.$emit('select', _this.chartDatas[(params || {}).dataIndex]);
    });
  },

  methods: {
    chartOnClick: function chartOnClick(e) {},
    chartOnMouseover: function chartOnMouseover(e) {},
    chartOnMouseout: function chartOnMouseout(e) {},
    chartOnRendered: function chartOnRendered(e) {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56a5aff6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/digitalMLPA/mainDataChart.vue
var mainDataChart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-digital-mlpa-main-data-chart-page col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"case-digital-mlpa-main-data-chart-container col-block width-full",style:({ flex: 1 })},[_c('vueCharts',{ref:'mlpa-chart',style:({ width: '100%', height: '100%' }),attrs:{"autoresize":"","option":_vm.chartOption[_vm.panelData.chart_view.type]},on:{"click":function (e) { return _vm.chartOnClick(e); },"mouseover":function (e) { return _vm.chartOnMouseover(e); },"mouseout":function (e) { return _vm.chartOnMouseout(e); },"rendered":function (e) { return _vm.chartOnRendered(e); }}})],1)])}
var mainDataChart_staticRenderFns = []
var mainDataChart_esExports = { render: mainDataChart_render, staticRenderFns: mainDataChart_staticRenderFns }
/* harmony default export */ var digitalMLPA_mainDataChart = (mainDataChart_esExports);
// CONCATENATED MODULE: ./src/components/digitalMLPA/mainDataChart.vue
var mainDataChart_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var mainDataChart___vue_template_functional__ = false
/* styles */
var mainDataChart___vue_styles__ = null
/* scopeId */
var mainDataChart___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mainDataChart___vue_module_identifier__ = null
var mainDataChart_Component = mainDataChart_normalizeComponent(
  mainDataChart,
  digitalMLPA_mainDataChart,
  mainDataChart___vue_template_functional__,
  mainDataChart___vue_styles__,
  mainDataChart___vue_scopeId__,
  mainDataChart___vue_module_identifier__
)

/* harmony default export */ var components_digitalMLPA_mainDataChart = (mainDataChart_Component.exports);

// EXTERNAL MODULE: ./src/mixins/customGrab.vue + 1 modules
var customGrab = __webpack_require__("TqmH");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/digitalMLPA/mainDataTable.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var mainDataTable = ({
  mixins: [customGrab["a" /* default */], responsitive["a" /* default */]],
  props: {
    panelData: {
      type: Object,
      required: true
    },
    selectData: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      selectedTableData: null,
      hoverTableData: null,
      // table
      tableTopWidths: null,
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [[], []],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['scrollState']), {
    filtedDatas: function filtedDatas() {
      return this.panelData.fragment_table || [];
    },
    tableDatas: function tableDatas() {
      var _this = this;

      var tableDatas = this.filtedDatas;
      tableDatas = Object(util["m" /* sortData */])(tableDatas, this.sort.value.map(function (x) {
        return _this.sortMap[x];
      }), this.sort.order.map(function (x) {
        return x.replace('-', '');
      }));
      tableDatas = Object(util["i" /* groupBy */])(tableDatas, function () {
        return 'default';
      }).map(function (datas) {
        return { title: datas[0].group, isGroup: true, datas: datas };
      });
      return tableDatas;
    },
    sortMap: function sortMap() {
      return this.tableOptions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortMap || c.value));
      }, {});
    },

    // static
    topTableOptions: function topTableOptions() {
      return [{
        title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.topTitle.___Prob_Information'),
        class: function _class() {
          return ['center'];
        },
        background: '#E2F3FA',
        length: 5,
        sortMap: null
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.topTitle.___Comparison_Reference_Samples'),
        class: function _class() {
          return ['center'];
        },
        background: '#EDFAE0',
        length: 3,
        sortMap: null
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.topTitle.___Sample_Results'),
        class: function _class() {
          return ['center'];
        },
        background: '#FFF5E2',
        length: 3,
        sortMap: null
      }];
    },
    tableOptions: function tableOptions() {
      return [{
        title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Probe_No'),
        value: 'Probe Number',
        display: function display(value) {
          return value;
        },
        class: function _class() {
          return ['center'];
        },
        sortMap: null
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Function'),
        value: 'Function',
        class: function _class() {
          return ['center'];
        },
        sortMap: null
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Location'),
        value: 'Location (kb)',
        class: function _class() {
          return ['center'];
        },
        sortMap: null
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Gene'),
        value: 'Gene',
        class: function _class() {
          return ['center'];
        },
        sortMap: null
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Exon'),
        value: 'Exon',
        class: function _class() {
          return ['center'];
        },
        sortMap: null
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___CN_Exp'),
        value: 'CN Exp',
        class: function _class() {
          return ['center'];
        },
        sortMap: null
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Ref_95'),
        value: 'Ref. 95%',
        class: function _class() {
          return ['center'];
        },
        sortMap: null
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Exp_Range'),
        value: 'Exp. Range',
        class: function _class() {
          return ['center'];
        },
        sortMap: null
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Result'),
        value: 'Result',
        class: function _class() {
          return ['center'];
        },
        sortMap: null
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Aberrant'),
        value: 'Aberrant',
        display: function display(value) {
          return {
            'true': 'Yes',
            'true?': 'Yes?',
            'false': 'no'
          }[value] || value;
        },
        class: function _class(value) {
          return ['center', {
            'true': 'alert',
            'true?': 'empty',
            'Yes': 'alert',
            'Yes?': 'empty'
          }[value]];
        },
        sortMap: null
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Quality_issue'),
        value: 'Quality Issue',
        class: function _class() {
          return ['center'];
        },
        sortMap: null
      }];
    }
  }),
  watch: {
    // data
    'selectedTableData': function selectedTableData(nv, ov) {
      if (nv !== ov && stringify_default()(nv) !== stringify_default()(ov)) {
        this.selectedTableData = nv ? JSON.parse(stringify_default()(nv)) : null;
      }
    },
    'hoverTableData': function hoverTableData(nv) {
      this.$emit('select', nv);
    },
    'selectData': function selectData(nv) {
      if (nv) {
        var index = this.filtedDatas.indexOf(this.filtedDatas.find(function (data) {
          return data['Probe Number'] === nv['Probe Number'];
        }));
        if (!this.hoverTableData || nv['Probe Number'] !== this.hoverTableData['Probe Number']) {
          this.$refs['custom-table-scroll'].scrollTo({
            top: index * 31 - 300 / 2 + 30 / 2
          });
        }
      }
    },

    // table
    'tableDatas': function tableDatas() {
      this.getTableOverflow();
    },
    'windowWidth': function windowWidth(nv) {
      this.getTableWidths(nv);
      this.getTableOverflow();
    }
  },
  methods: {
    // table
    getTableOverflow: function getTableOverflow() {
      var _this2 = this;

      setTimeout(function () {
        var scrollContainer = _this2.$refs['custom-table-scroll'];
        if (scrollContainer) {
          _this2.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight;
        }
      });
    },
    getTableWidths: function getTableWidths(windowWidth) {
      window.dispatchEvent(new Event('scroll'));
      var tableWidth = Math.min(windowWidth * 0.95, 1208) - 22 * 2 - (this.scrollState.height ? this.scrollbarSize : 0);
      tableWidth = tableWidth - this.staticTableWidths[0].reduce(function (s, c) {
        return s + c;
      }, 0) - this.staticTableWidths[1].reduce(function (s, c) {
        return s + c;
      }, 0);
      var tableWidths = this.tableWidths || [].concat(toConsumableArray_default()(this.staticTableWidths[0]), [100, 85, 115, 115, 75, 105, 115, 95, 85, 105, 145], toConsumableArray_default()(this.staticTableWidths[1])).map(function (width) {
        return {
          value: width
        };
      });
      var tableMinWidths = this.tableMinWidths || 0.1;
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length);
      var ratio = tableWidth / tableWidths.reduce(function (s, c) {
        return s + c.value;
      }, 0);
      tableWidths = Array.prototype.concat.apply([], [this.staticTableWidths[0].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      }), tableWidths.map(function (width) {
        return {
          value: width.value * ratio,
          grab: 0
        };
      }), this.staticTableWidths[1].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      })]);
      this.tableMinWidths = tableMinWidths * ratio;
      this.tableTopWidths = this.getTopTableWidths(tableWidths);
      this.tableWidths = tableWidths;
    },
    getTopTableWidths: function getTopTableWidths(tableWidths) {
      var position = 0;
      return this.topTableOptions.map(function (option) {
        var length = option.length;
        var result = tableWidths.slice(position, position + length).reduce(function (a, b) {
          return {
            value: a.value + (b.value || 0),
            grab: a.grab + (b.grab || 0)
          };
        }, { value: 0, grab: 0 });
        position += length;
        return result;
      });
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
    },

    // grab
    boardResponse: function boardResponse(id, type) {
      var _this3 = this;

      return {
        'board1': {
          'start': function start(boardData) {
            _this3.sort.disabled = true;
          },
          'move': function move(boardData) {
            if (_this3.boardType['board1'] === 'grab') {
              var grabID = _this3.boardData[id].grabID;
              var tableWidths = [].concat(toConsumableArray_default()(_this3.tableWidths));
              var result = boardData.grabX - boardData.baseX;
              var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this3.staticTableWidths[1].length).reduce(function (s, c, i) {
                return s + c.value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths);
              }, 0);
              tableWidths.forEach(function (_, i) {
                if (i === grabID) {
                  tableWidths[i].grab = result;
                }if (i > grabID && i + _this3.staticTableWidths[1].length < tableWidths.length) {
                  tableWidths[i].grab = -(result * ((tableWidths[i].value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths)) / ratioBase));
                }
              });
              _this3.tableWidths = tableWidths;
            }
          },
          'end': function end(boardData) {
            var grabID = _this3.boardData[id].grabID;
            var tableWidths = [].concat(toConsumableArray_default()(_this3.tableWidths));
            var result = boardData.grabX - boardData.baseX;
            var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this3.staticTableWidths[1].length).reduce(function (s, c, i) {
              return s + c.value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths);
            }, 0);
            tableWidths.forEach(function (_, i) {
              tableWidths[i].grab = 0;
              if (i === grabID) {
                tableWidths[i].value += result;
              }if (i > grabID && i + _this3.staticTableWidths[1].length < tableWidths.length) {
                tableWidths[i].value -= result * ((tableWidths[i].value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths)) / ratioBase);
              }
            });
            _this3.tableWidths = tableWidths;
            setTimeout(function () {
              _this3.sort.disabled = false;
            });
          }
        }
      }[id][type];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32a9c0f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/digitalMLPA/mainDataTable.vue
var mainDataTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-digital-mlpa-main-data-table-page col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"case-digital-mlpa-main-data-table-container col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"custom-table",class:{ 'auto-height': false }},[(_vm.tableWidths)?_c('div',{staticClass:"table-field col-block grab-container",style:({ width: _vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) + 'px' }),on:{"mousedown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardStart]); })($event)},"mousemove":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseout":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardEnd]); })($event)}}},[_c('div',{staticClass:"table-container col-block"},[_c('div',{staticClass:"thead"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.topTableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:({ width: _vm.tableTopWidths[index].value + _vm.tableTopWidths[index].grab + 'px', background: option.background }),on:{"click":function (e) { return !_vm.sort.disabled && option.sortMap !== null && _vm.tableSortBy(option.sortValue || option.value); }}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e()],2)}),0),_vm._v(" "),_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab + 'px' }),on:{"click":function (e) { return !_vm.sort.disabled && option.sortMap !== null && _vm.tableSortBy(option.sortValue || option.value); }}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e()],2)}),0)])]),_vm._v(" "),_c('div',{ref:"custom-table-scroll",staticClass:"table-group-container col-block width-full",on:{"mouseleave":function (e) { return _vm.hoverTableData = null; }}},[_c('div',{staticClass:"col-block"},_vm._l((_vm.tableDatas),function(group,gindex){return _c('div',{key:gindex,staticClass:"table-container col-block"},[_c('div',{staticClass:"tbody"},[_c('div',{staticClass:"tr group row-block",class:{ selected: false },style:(group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' })},[_c('a',{staticClass:"container-block row-block"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(group[option.gValue], gindex, group),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.gstyle || (function () { return ({}); }))(group[option.gValue], gindex, group)),attrs:{"title":((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || option.gempty || '')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('center') && !(option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)]),_vm._v(" "),_vm._l((group.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"tr col-block",class:{ selectable: false, selected: (_vm.selectData || {})['Probe Number'] === data['Probe Number'] },on:{"mouseenter":function (e) { return _vm.hoverTableData = data; }}},[_c('a',{staticClass:"container-block row-block",style:({ flex: 1 }),on:{"click":function (e) { return false && (_vm.selectedTableData = data); }}},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(data[option.value], dindex, data),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.style || (function () { return ({}); }))(data[option.value], dindex, data)),attrs:{"title":((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || option.empty || '- -')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(data[option.value], dindex, data).includes('center') && !(option.class || (function () { return []; }))(data[option.value], dindex, data).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)])})],2)])}),0)])]):_vm._e()])])])}
var mainDataTable_staticRenderFns = []
var mainDataTable_esExports = { render: mainDataTable_render, staticRenderFns: mainDataTable_staticRenderFns }
/* harmony default export */ var digitalMLPA_mainDataTable = (mainDataTable_esExports);
// CONCATENATED MODULE: ./src/components/digitalMLPA/mainDataTable.vue
var mainDataTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var mainDataTable___vue_template_functional__ = false
/* styles */
var mainDataTable___vue_styles__ = null
/* scopeId */
var mainDataTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mainDataTable___vue_module_identifier__ = null
var mainDataTable_Component = mainDataTable_normalizeComponent(
  mainDataTable,
  digitalMLPA_mainDataTable,
  mainDataTable___vue_template_functional__,
  mainDataTable___vue_styles__,
  mainDataTable___vue_scopeId__,
  mainDataTable___vue_module_identifier__
)

/* harmony default export */ var components_digitalMLPA_mainDataTable = (mainDataTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/digitalMLPA/mainData.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var mainData = ({
  components: {
    mainDataInfo: components_digitalMLPA_mainDataInfo,
    mainDataChart: components_digitalMLPA_mainDataChart,
    mainDataTable: components_digitalMLPA_mainDataTable
  },
  props: {
    projects: {
      type: Array,
      required: true
    },
    projectID: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      data: {
        'table': null,
        'chart': null
      },
      form: {
        'panel': '',
        'subpanel': ''
      },
      display: {
        'info': true
      }
    };
  },

  computed: {
    project: function project() {
      var _this = this;

      return this.projects.find(function (project) {
        return String(project.id) === _this.projectID;
      });
    },
    panelData: function panelData() {
      return ((this.project.views || {}).ResultView || {}).panel || [];
    },
    currentPanel: function currentPanel() {
      var _this2 = this;

      return this.panelData.find(function (panel) {
        return _this2.form['panel'] === panel.panel_name;
      }) || {};
    },
    currentSubpanel: function currentSubpanel() {
      var _this3 = this;

      return (this.currentPanel.subpanel || []).find(function (subpanel) {
        return _this3.form['subpanel'] === subpanel.subpanel_name;
      }) || {};
    },

    // static
    panelOptions: function panelOptions() {
      var panelOptions = this.panelData.map(function (panel) {
        return { title: panel.panel_name, value: panel.panel_name };
      });
      this.form['panel'] = '';
      return panelOptions;
    },
    subpanelOptions: function subpanelOptions() {
      var subpanelOptions = (this.currentPanel.subpanel || []).map(function (subpanel) {
        return { title: subpanel.subpanel_name, value: subpanel.subpanel_name };
      });
      this.form['subpanel'] = (subpanelOptions[0] || {}).value || '';
      this.data = {
        'table': null,
        'chart': null
      };
      return subpanelOptions;
    },
    segmentOptions: function segmentOptions() {
      var segmentData = extends_default()({}, this.currentSubpanel.segment_view || {}, (this.currentSubpanel.segment_view || {}).extensions || {});
      var segmentOptions = [{
        title: this.$t('COMPONENT.digitalMLPA.mainData.form.Segment.data.title.___Aberrant_Count'),
        value: segmentData.aberrant_count
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainData.form.Segment.data.title.___Mean'),
        value: segmentData.Mean
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainData.form.Segment.data.title.___SD'),
        value: segmentData.StandardDeviation
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainData.form.Segment.data.title.___Med'),
        value: segmentData.Median
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainData.form.Segment.data.title.___Min'),
        value: segmentData.Minimum
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainData.form.Segment.data.title.___Max'),
        value: segmentData.Maximum
      }, {
        title: this.$t('COMPONENT.digitalMLPA.mainData.form.Segment.data.title.___Range'),
        value: segmentData.Range
      }].filter(function (option) {
        return ![null, undefined].includes(option.value);
      });
      if (segmentOptions.length > 4) {
        segmentOptions.splice(4, 0, {});
      }
      return segmentOptions;
    },
    formOptions: function formOptions() {
      return {
        'panel': {
          title: this.$t('COMPONENT.digitalMLPA.mainData.form.Panel.___title'),
          type: 'select',
          key: 'panel',
          options: this.panelOptions,
          placeholder: this.$t('COMPONENT.digitalMLPA.mainData.form.Panel.___placeholder')
        },
        'subpanel': {
          title: this.$t('COMPONENT.digitalMLPA.mainData.form.Subpanel.___title'),
          type: 'select',
          key: 'subpanel',
          options: this.subpanelOptions,
          placeholder: this.$t('COMPONENT.digitalMLPA.mainData.form.Subpanel.___placeholder')
        },
        'segment': {
          title: this.$t('COMPONENT.digitalMLPA.mainData.form.Segment.___title'),
          type: 'data',
          options: this.segmentOptions
        }
      };
    },
    stateOptions: function stateOptions() {
      return {
        'analyzing': {
          title: this.$t('COMPONENT.digitalMLPA.mainData.status.title.___analyzing')
        },
        'error': {
          title: this.$t('COMPONENT.digitalMLPA.mainData.status.title.___error')
        }
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba196fac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/digitalMLPA/mainData.vue
var mainData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-digital-mlpa-main-data-page col-block width-full"},[(_vm.stateOptions[_vm.project.state])?[_c('div',{staticClass:"case-digital-mlpa-main-data-status-container col-block"},[_c('div',{staticClass:"case-digital-mlpa-main-data-status",class:_vm.project.state,domProps:{"innerHTML":_vm._s(_vm.stateOptions[_vm.project.state].title)}})])]:[_c('div',{staticClass:"case-digital-mlpa-main-data-main-container col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-main-data-main-info-container col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-main-data-main-info-title-container row-block",class:{ display: _vm.display['info'] },on:{"click":function (e) { return _vm.display['info'] = !_vm.display['info']; }}},[_c('div',{staticClass:"case-digital-mlpa-main-data-main-info-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.digitalMLPA.mainData.info.___title')))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("1OSr"),"alt":""}})]),_vm._v(" "),(_vm.display['info'])?[_c('div',{staticClass:"case-digital-mlpa-main-data-main-info-data-container col-block width-full"},[_c('mainDataInfo',{attrs:{"project":_vm.project}})],1)]:[_c('div',{style:({ height: '4px' })}),_vm._v(" "),_vm._m(0)]],2),_vm._v(" "),_c('div',{staticClass:"case-digital-mlpa-main-data-main-panel-container col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-main-data-main-panel-option-container col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-main-data-main-panel-option-block row-block flex-start"},_vm._l(([['panel', 'subpanel'], [_vm.form['subpanel'] ? 'segment' : '']]),function(group,gindex){return _c('div',{key:gindex,staticClass:"case-digital-mlpa-main-data-main-panel-option-form-container row-block flex-start",style:({ flex: 1 })},_vm._l((group),function(key){return _c('div',{key:key,staticClass:"case-digital-mlpa-main-data-main-panel-option-form-block col-block width-full",style:({ flex: 1 })},[(key)?[_c('div',{staticClass:"case-digital-mlpa-main-data-main-panel-option-form-data-title-container row-block"},[_c('div',{staticClass:"case-digital-mlpa-main-data-main-panel-option-form-data-title"},[_vm._v(_vm._s(_vm.formOptions[key].title))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"case-digital-mlpa-main-data-main-panel-option-form-data-content-container col-block width-full",class:_vm.formOptions[key].type},[(_vm.formOptions[key].type === 'select')?[_c('div',{staticClass:"case-digital-mlpa-main-data-main-panel-option-form-data-content-select-container col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-main-data-main-panel-option-form-data-content-select-block input-group col-block width-full"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form[_vm.formOptions[key].key]),expression:"form[formOptions[key].key]"}],attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, _vm.formOptions[key].key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(_vm.formOptions[key].placeholder)?_c('option',{attrs:{"disabled":"","hidden":"","value":""}},[_vm._v(_vm._s(_vm.formOptions[key].placeholder))]):_vm._e(),_vm._v(" "),_vm._l((_vm.formOptions[key].options || []),function(option,oindex){return _c('option',{key:oindex,domProps:{"value":option.value}},[_vm._v(_vm._s(option.title))])})],2)])])]:(_vm.formOptions[key].type === 'data')?[_c('div',{staticClass:"case-digital-mlpa-main-data-main-panel-option-form-data-content-data-container col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-main-data-main-panel-option-form-data-content-data-block"},_vm._l((_vm.formOptions[key].options || []),function(option,oindex){return _c('div',{key:oindex,staticClass:"case-digital-mlpa-main-data-main-panel-option-form-data-content-data-text-block row-block",class:{ empty: !option.title }},[(option.title)?[_c('div',{staticClass:"case-digital-mlpa-main-data-main-panel-option-form-data-content-data-text-title shrink ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),_c('div',{staticClass:"case-digital-mlpa-main-data-main-panel-option-form-data-content-data-text-content"},[_vm._v(_vm._s(option.value))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]:_vm._e()],2)}),0)])]:_vm._e()],2)]:_vm._e()],2)}),0)}),0)]),_vm._v(" "),(_vm.form['subpanel'])?_c('div',{key:_vm.form['subpanel'],staticClass:"case-digital-mlpa-main-data-main-panel-data-container col-block width-full"},[(_vm.currentSubpanel.chart_view)?_c('div',{staticClass:"case-digital-mlpa-main-data-main-panel-chart-container col-block width-full",style:({ height: '320px' })},[_c('mainDataChart',{attrs:{"panelData":_vm.currentSubpanel,"selectData":_vm.data['table']},on:{"select":function (d) { return _vm.data['chart'] = d; }}})],1):_vm._e(),_vm._v(" "),(_vm.currentSubpanel.fragment_table)?_c('div',{staticClass:"case-digital-mlpa-main-data-main-panel-table-container col-block width-full",style:({ height: '360px' })},[_c('mainDataTable',{attrs:{"panelData":_vm.currentSubpanel,"selectData":_vm.data['chart']},on:{"select":function (d) { return _vm.data['table'] = d; }}})],1):_vm._e()]):_vm._e()])])]],2)}
var mainData_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-digital-mlpa-main-data-main-info-result-field row-block flex-start flex-wrap"},[_c('div',{staticClass:"case-digital-mlpa-main-data-main-info-result-container col-block"},[_c('div',{staticClass:"case-digital-mlpa-main-data-main-info-result-block"},[_c('div',{staticClass:"case-digital-mlpa-main-data-main-info-result-content-container"})])])])}]
var mainData_esExports = { render: mainData_render, staticRenderFns: mainData_staticRenderFns }
/* harmony default export */ var digitalMLPA_mainData = (mainData_esExports);
// CONCATENATED MODULE: ./src/components/digitalMLPA/mainData.vue
var mainData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var mainData___vue_template_functional__ = false
/* styles */
var mainData___vue_styles__ = null
/* scopeId */
var mainData___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mainData___vue_module_identifier__ = null
var mainData_Component = mainData_normalizeComponent(
  mainData,
  digitalMLPA_mainData,
  mainData___vue_template_functional__,
  mainData___vue_styles__,
  mainData___vue_scopeId__,
  mainData___vue_module_identifier__
)

/* harmony default export */ var components_digitalMLPA_mainData = (mainData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/digitalMLPA/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var main = ({
  components: {
    mainUpload: components_digitalMLPA_mainUpload,
    mainData: components_digitalMLPA_mainData
  },
  props: {
    projects: {
      type: Array,
      required: true
    },
    projectID: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aed304c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/digitalMLPA/main.vue
var main_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-digital-mlpa-main-page col-block width-full"},[(_vm.projectID.startsWith('date-'))?[_c('mainUpload',{on:{"create":function (data) { return _vm.$emit('create', data); }}})]:[_c('mainData',{attrs:{"projects":_vm.projects,"projectID":_vm.projectID}})]],2)}
var main_staticRenderFns = []
var main_esExports = { render: main_render, staticRenderFns: main_staticRenderFns }
/* harmony default export */ var digitalMLPA_main = (main_esExports);
// CONCATENATED MODULE: ./src/components/digitalMLPA/main.vue
var main_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var main___vue_template_functional__ = false
/* styles */
var main___vue_styles__ = null
/* scopeId */
var main___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var main___vue_module_identifier__ = null
var main_Component = main_normalizeComponent(
  main,
  digitalMLPA_main,
  main___vue_template_functional__,
  main___vue_styles__,
  main___vue_scopeId__,
  main___vue_module_identifier__
)

/* harmony default export */ var components_digitalMLPA_main = (main_Component.exports);

// EXTERNAL MODULE: ./src/components/tool/analysisBorCor.vue + 2 modules
var analysisBorCor = __webpack_require__("UKm5");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDigitalMLPA.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var caseDigitalMLPA = ({
  components: {
    digitalMLPA: components_digitalMLPA_main,
    analysisBorCor: analysisBorCor["a" /* default */]
  },
  mixins: [routeLoading["a" /* default */], toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      projectDatas: [],
      selectedProjectID: null,
      hiddenAnalysisSelect: false,
      limit: 3
    };
  },

  computed: {
    currentProject: function currentProject() {
      var _this = this;

      return this.projects.find(function (project) {
        return String(project.id) === _this.selectedProjectID;
      });
    },
    projects: function projects() {
      return this.projectDatas.map(function (projectData) {
        return extends_default()({}, projectData);
      });
    },

    // static
    projectCardOptions: function projectCardOptions() {
      return [{
        title: this.$t('DIALOG.caseDigitalMLPA.card.title.___created'),
        value: function value(data) {
          return Object(util["d" /* dateFormat */])(new Date(data.created_at), 'yyyy/MM/dd hh:mm:ss');
        }
      }];
    },
    topOptions: function topOptions() {
      var _this2 = this;

      return [{
        title: this.$t('DIALOG.caseDigitalMLPA.top.icon.title.___delete'),
        value: 'delete',
        icon: __webpack_require__("j6F1"),
        alert: true,
        display: !!this.currentProject,
        disabled: ['analyzing'].includes((this.currentProject || {}).state),
        func: function func() {
          return _this2.deleteProject(_this2.currentProject);
        }
      }];
    },

    // param
    caseData: function caseData() {
      return this.param.caseData;
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModal2Action', 'setLoadingAction']), {
    fetchData: function fetchData() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.fetchProjects();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    fetchProjects: function fetchProjects() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, caseID, response, projects;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this4.$ls.get('userInfo');
                caseID = _this4.caseData.id;
                _context2.next = 5;
                return Object(src_api["G" /* getCaseDigitalMLPA */])(caseID, config);

              case 5:
                response = _context2.sent;
                projects = response.data.data;

                projects = Object(util["m" /* sortData */])(projects.map(function (project) {
                  return _this4.parseProject(project);
                }), 'created_at', 'desc');
                _this4.setProjectID((projects[0] || {}).id);
                _this4.projectDatas = projects;
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 12]]);
      }))();
    },
    parseProject: function parseProject(project) {
      var kitName = keys_default()(project).find(function (key) {
        return key.endsWith('.xml');
      });
      var result = extends_default()({}, project);
      delete result[kitName];
      return extends_default()({
        id: project.digitalmlpa_id,
        kit_name: kitName,
        state: 'completed'
      }, result, project[kitName]);
    },
    createProject: function createProject(data) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, caseID, file, response;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.setLoadingAction(true);
                _context3.prev = 1;
                config = _this5.$ls.get('userInfo');
                caseID = _this5.caseData.id;
                file = data.file;
                _context3.next = 7;
                return Object(src_api["_92" /* postCaseDigitalMLPA */])(caseID, file, config);

              case 7:
                response = _context3.sent;
                _context3.next = 10;
                return _this5.fetchProjects();

              case 10:
                _this5.addToast('success', response.data.result.message);
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](1);

                _this5.addToast('error', !_context3.t0.response ? _context3.t0.message : _context3.t0.response.data.result.message);

              case 16:
                _this5.setLoadingAction(false);

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[1, 13]]);
      }))();
    },
    deleteProject: function deleteProject(project) {
      var _this6 = this;

      this.setModal2Action({
        action: 'toast',
        width: '496px',
        customStyles: {
          padding: 0,
          border: 0
        },
        param: {
          type: 'alert',
          content: this.$t('DIALOG.caseDigitalMLPA.modal.content.___deleteAlert'),
          buttons: [{
            title: this.$t('COMMON.button.___yes'),
            type: 'alert',
            result: true
          }, {
            title: this.$t('COMMON.button.___cancel'),
            type: 'gray',
            result: false
          }]
        },
        callback: function () {
          var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(result) {
            var config, caseID, mlpaID, response;
            return regenerator_default.a.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    if (!result) {
                      _context4.next = 18;
                      break;
                    }

                    _this6.setLoadingAction(true);
                    _context4.prev = 2;
                    config = _this6.$ls.get('userInfo');
                    caseID = _this6.caseData.id;
                    mlpaID = project.id;
                    _context4.next = 8;
                    return Object(src_api["e" /* deleteCaseDigitalMLPA */])(caseID, mlpaID, config);

                  case 8:
                    response = _context4.sent;
                    _context4.next = 11;
                    return _this6.fetchProjects();

                  case 11:
                    _this6.addToast('success', response.data.result.message);
                    _context4.next = 17;
                    break;

                  case 14:
                    _context4.prev = 14;
                    _context4.t0 = _context4['catch'](2);

                    _this6.addToast('error', !_context4.t0.response ? _context4.t0.message : _context4.t0.response.data.result.message);

                  case 17:
                    _this6.setLoadingAction(false);

                  case 18:
                  case 'end':
                    return _context4.stop();
                }
              }
            }, _callee4, _this6, [[2, 14]]);
          }));

          return function callback(_x) {
            return _ref.apply(this, arguments);
          };
        }()
      });
    },
    setProjectID: function setProjectID(id) {
      var _this7 = this;

      this.selectedProjectID = String(id || ((this.selectedProjectID || '').startsWith('date-') ? this.selectedProjectID : 'date-' + Object(util["d" /* dateFormat */])(new Date(), 'yyyyMMddhhmmssS')));
      this.hiddenAnalysisSelect = true;
      setTimeout(function () {
        _this7.hiddenAnalysisSelect = false;
      }, 10);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b912fb58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDigitalMLPA.vue
var caseDigitalMLPA_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-digital-mlpa-dailog dialog col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-container col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-title-container row-block"},[_c('div',{staticClass:"case-digital-mlpa-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDigitalMLPA.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),(_vm.selectedProjectID)?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"case-digital-mlpa-top-container col-block width-full"},[_c('div',{staticClass:"case-digital-mlpa-top-block row-block"},[_c('div',{staticClass:"case-digital-mlpa-project-list-container col-block width-full"},[_c('analysisBorCor',{attrs:{"display":_vm.projectDatas.length ? null : false,"arrow":false,"type":'right',"background":'white',"border":'#CCCCCC',"radius":'5px',"blockStyle":{ padding: '10px' },"cursorSize":'40px 40px',"translate":'-5.5px -1px'}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"icon-block",style:({ '--size': '40px' })},[_c('img',{attrs:{"src":__webpack_require__("V8N6"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[(!_vm.hiddenAnalysisSelect)?[_c('div',{staticClass:"project-list-block col-block stretch"},_vm._l((_vm.projects),function(project,pindex){return _c('div',{key:pindex,staticClass:"project-card-container col-block flex-start",class:{ active: _vm.selectedProjectID === String(project.id) },on:{"click":function (e) { return _vm.setProjectID(project.id); }}},[_c('div',{staticClass:"project-card-title-container row-block"},[_c('div',{staticClass:"project-card-title-block row-block"},[_c('div',{staticClass:"project-card-title"},[_vm._v(_vm._s(project.kit_name))])]),_vm._v(" "),_c('div',{staticClass:"project-state-icon icon-block",class:[project.state],style:({ '--size': '20px', 'cursor': 'default' })},[([
                              'analyzing',
                              'started',
                              'failed',
                              'completed'
                            ].includes(project.state))?_c('img',{attrs:{"src":__webpack_require__("MVOO")("./project-" + project.state + '-icon.svg'),"alt":""}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"project-card-info-container col-block"},_vm._l((_vm.projectCardOptions),function(option,oindex){return _c('div',{key:oindex,staticClass:"project-card-info-block row-block"},[_c('div',{staticClass:"project-card-info-title"},[_vm._v(_vm._s(option.title + ':'))]),_vm._v(" "),_c('div',{staticClass:"project-card-info-content"},[_vm._v(_vm._s(option.value(project)))])])}),0)])}),0),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"project-list-button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button",attrs:{"disabled":_vm.projectDatas.length >= _vm.limit},on:{"click":function (e) { return _vm.setProjectID(); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___newAnalysis')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]:_vm._e()],2)])],1),_vm._v(" "),_c('div',{staticClass:"case-digital-mlpa-project-title-container row-block",style:({ flex: 1 })},[_c('div',{staticClass:"case-digital-mlpa-project-title shrink ellipsis"},[_vm._v(_vm._s((_vm.currentProject || {}).kit_name || _vm.$t('DIALOG.caseDigitalMLPA.___empty')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"case-digital-mlpa-project-option-container row-block"},_vm._l((_vm.topOptions.filter(function (option) { return option.display !== false; })),function(option,index){return _c('div',{key:index,staticClass:"custom-option-block center-block",class:option.value ? {
                  default: option.hover === false,
                  hover: option.hover !== false && !option.disabled,
                  disabled: option.disabled,
                  alert: option.alert
                } : ['line'],style:({ '--size': '40px' }),on:{"click":function (e) { return !option.disabled && option.func && option.func(); }}},[(option.value)?_c('img',{style:(option.style || {}),attrs:{"src":option.icon,"alt":"","title":option.title}}):_vm._e()])}),0)])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"case-digital-mlpa-top-main-container col-block width-full"},[_c('keep-alive',[(_vm.selectedProjectID)?_c('digitalMLPA',{key:_vm.selectedProjectID,attrs:{"projects":_vm.projects,"projectID":_vm.selectedProjectID},on:{"create":function (data) { return _vm.createProject(data); }}}):_vm._e()],1)],1)]:_vm._e()],2),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var caseDigitalMLPA_staticRenderFns = []
var caseDigitalMLPA_esExports = { render: caseDigitalMLPA_render, staticRenderFns: caseDigitalMLPA_staticRenderFns }
/* harmony default export */ var dialog_caseDigitalMLPA = (caseDigitalMLPA_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDigitalMLPA.vue
var caseDigitalMLPA_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDigitalMLPA___vue_template_functional__ = false
/* styles */
var caseDigitalMLPA___vue_styles__ = null
/* scopeId */
var caseDigitalMLPA___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDigitalMLPA___vue_module_identifier__ = null
var caseDigitalMLPA_Component = caseDigitalMLPA_normalizeComponent(
  caseDigitalMLPA,
  dialog_caseDigitalMLPA,
  caseDigitalMLPA___vue_template_functional__,
  caseDigitalMLPA___vue_styles__,
  caseDigitalMLPA___vue_scopeId__,
  caseDigitalMLPA___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDigitalMLPA = (caseDigitalMLPA_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseFile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var caseFile = ({
  components: {
    borCor: newBorCor["a" /* default */]
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    fileGroups: function fileGroups() {
      if (this.param.caseData.dataset === 'vcf') {
        return Object(util["i" /* groupBy */])(this.param.sampleFiles, function (file) {
          return file.dataset;
        }, true);
      } else if (this.param.caseData.dataset === 'fastq') {
        return Object(util["i" /* groupBy */])(Object(util["m" /* sortData */])(this.param.sampleFiles, function (file) {
          return file.read_strand;
        }), function (file) {
          return file.group;
        });
      } else if (this.param.caseData.dataset === 'ubam') {
        return Object(util["i" /* groupBy */])(this.param.sampleFiles, function (file) {
          return file.group;
        });
      }
    },

    // static
    numberMap: function numberMap() {
      return {
        'en': [null, 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE', 'TEN'],
        'ja': [null, 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE', 'TEN']
      }[this.$i18n.locale];
    },

    // global
    fixNumber: function fixNumber() {
      return util["g" /* fixNumber */];
    }
  },
  methods: {
    downloadFile: function downloadFile(file) {
      var url = api_config["a" /* API_ROOT */] + 'global/files/download?file_id=' + file.id + '&class_name=' + file.class_name + '&access_token=' + this.$ls.get('userInfo').access_token;
      window.open(url);
      file.download_used++;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-222e27ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseFile.vue
var caseFile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-file-dailog col-block block"},[_c('div',{staticClass:"sample-file-container col-block"},[_c('div',{staticClass:"sample-file-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseFile.___title')))]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-content col-block"},[(['vcf'].includes(_vm.param.caseData.dataset))?[_c('div',{staticClass:"sample-file-main-field row-block flex-start"},_vm._l((_vm.fileGroups),function(fileGroup,dataset,index){return _c('div',{key:index,staticClass:"sample-file-main-container col-block flex-start",style:({ flex: 1, width: 0 })},[_c('div',{staticClass:"sample-file-main-title",domProps:{"innerHTML":_vm._s({
                'snv': _vm.$t('DIALOG.caseFile.vcf.___snvTitle'),
                'sv': _vm.$t('DIALOG.caseFile.vcf.___svTitle'),
                'str': _vm.$t('DIALOG.caseFile.vcf.___strTitle')
              }[dataset])}}),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-list-container col-block"},_vm._l((fileGroup),function(file,findex){return _c('div',{key:findex,staticClass:"sample-file-list-block row-block flex-start"},[_c('div',{staticClass:"sample-file",style:({ flex: 1, width: 0 })},[_vm._v(_vm._s(file.name))])])}),0)])}),0)]:(['fastq'].includes(_vm.param.caseData.dataset))?[_c('div',{staticClass:"sample-file-info-container row-block flex-start"},[_c('div',{staticClass:"sample-file-info-block col-block flex-start",style:({ flex: 2 })},[_c('div',{staticClass:"sample-file-info-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseFile.fastq.infoTitle.___omics')))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-info-content"},[_vm._v(_vm._s(_vm.param.caseData.omics || '--'))])]),_vm._v(" "),_c('div',{staticClass:"sample-file-info-block col-block flex-start",style:({ flex: 3 })},[_c('div',{staticClass:"sample-file-info-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseFile.fastq.infoTitle.___pipeline')))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-info-content"},[_vm._v(_vm._s(_vm.param.caseData.pipeline || '--'))])]),_vm._v(" "),_c('div',{staticClass:"sample-file-info-block col-block flex-start",style:({ flex: 3 })},[_c('div',{staticClass:"sample-file-info-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseFile.fastq.infoTitle.___libraryType')))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-info-content"},[_vm._v(_vm._s(_vm.param.caseData.library_type || '--'))])]),_vm._v(" "),_c('div',{staticClass:"sample-file-info-block col-block flex-start",style:({ flex: 2 })},[_c('div',{staticClass:"sample-file-info-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseFile.fastq.infoTitle.___totalBases')))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-info-content",attrs:{"title":_vm.param.caseData.total_bases}},[_vm._v(_vm._s(_vm.param.caseData.total_bases ? _vm.fixNumber(_vm.param.caseData.total_bases * Math.pow(10, -9), 0.01) + ' G' : '--'))])])]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-main-field row-block flex-start"},[_c('div',{staticClass:"sample-file-main-container col-block flex-start",style:({ flex: 1 })},[_c('div',{staticClass:"sample-file-main-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseFile.fastq.___title')))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-list-container col-block"},[_vm._l((_vm.fileGroups),function(fileGroup,index){return [_c('div',{key:index,staticClass:"sample-file-list-block row-block flex-start"},[_c('div',{staticClass:"sample-file",style:({ flex: 1, width: 0 }),domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.caseFile.fastq.___file', { set: fileGroup[0].group.replace(/L/, ''), read: 'R' + fileGroup[0].read_strand, file: fileGroup[0].name }))}}),_vm._v(" "),(fileGroup[1])?_c('div',{staticClass:"sample-file",style:({ flex: 1, width: 0 }),domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.caseFile.fastq.___file', { set: fileGroup[1].group.replace(/L/, ''), read: 'R' + fileGroup[1].read_strand, file: fileGroup[1].name }))}}):_vm._e()]),_vm._v(" "),(_vm.fileGroups[index + 1])?_c('hr',{key:'hr-' + index}):_vm._e()]})],2)])])]:(['ubam'].includes(_vm.param.caseData.dataset))?[_c('div',{staticClass:"sample-file-info-container row-block flex-start"},[_c('div',{staticClass:"sample-file-info-block col-block flex-start",style:({ flex: 2 })},[_c('div',{staticClass:"sample-file-info-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseFile.ubam.infoTitle.___omics')))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-info-content"},[_vm._v(_vm._s(_vm.param.caseData.omics || '--'))])]),_vm._v(" "),_c('div',{staticClass:"sample-file-info-block col-block flex-start",style:({ flex: 3 })},[_c('div',{staticClass:"sample-file-info-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseFile.ubam.infoTitle.___pipeline')))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-info-content"},[_vm._v(_vm._s(_vm.param.caseData.pipeline || '--'))])]),_vm._v(" "),_c('div',{staticClass:"sample-file-info-block col-block flex-start",style:({ flex: 3 })},[_c('div',{staticClass:"sample-file-info-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseFile.ubam.infoTitle.___libraryType')))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-info-content"},[_vm._v(_vm._s(_vm.param.caseData.library_type || '--'))])]),_vm._v(" "),_c('div',{staticClass:"sample-file-info-block col-block flex-start",style:({ flex: 2 })},[_c('div',{staticClass:"sample-file-info-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseFile.ubam.infoTitle.___totalBases')))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-info-content",attrs:{"title":_vm.param.caseData.total_bases}},[_vm._v(_vm._s(_vm.param.caseData.total_bases ? _vm.fixNumber(_vm.param.caseData.total_bases * Math.pow(10, -9), 0.01) + ' G' : '--'))])])]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-main-field row-block flex-start"},[_c('div',{staticClass:"sample-file-main-container col-block flex-start",style:({ flex: 1 })},[_c('div',{staticClass:"sample-file-main-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseFile.ubam.___title')))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-list-container col-block"},[_vm._l((_vm.fileGroups),function(fileGroup,index){return [_c('div',{key:index,staticClass:"sample-file-list-block row-block flex-start"},[_c('div',{staticClass:"sample-file",style:({ flex: 1, width: 0 }),domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.caseFile.ubam.___file', { set: fileGroup[0].group.replace(/L/, ''), file: fileGroup[0].name }))}})]),_vm._v(" "),(_vm.fileGroups[index + 1])?_c('hr',{key:'hr-' + index}):_vm._e()]})],2)])])]:_vm._e()],2)]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('hr',{staticClass:"no-margin"}),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"analysis-file-container col-block flex-start"},_vm._l((_vm.param.analysisFiles),function(fileType,type,tindex){return _c('div',{key:tindex,staticClass:"analysis-file-block"},[_c('div',{staticClass:"block-content col-block"},[_c('div',{staticClass:"af-title-block row-block"},[_c('div',{staticClass:"af-title row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(type))]),_vm._v(" "),(type === 'Analysis Files')?_c('borCor',{attrs:{"background":'white',"border":'#CCCCCC',"radius":'0px',"width":'300px',"blockStyle":{ padding: '8px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("d5V5"),"alt":""}})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.caseFile.limit.___limitInfo'))}})])]):_vm._e()],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_vm._l((fileType),function(fileGroup,group,tindex){return _c('div',{key:tindex,staticClass:"af-container row-block flex-start"},[_c('div',{staticClass:"af-group-title",style:({ flex: 1 }),domProps:{"innerHTML":_vm._s((tindex + 1) + '. ' + group + (fileGroup.some(function (file) { return file.download_limit; }) ? ' <span>(' + _vm.$t('DIALOG.caseFile.limit.___limitAlert', { times: _vm.numberMap[fileGroup.find(function (file) { return file.download_limit; }).download_limit] }) + ')</span>' : ''))}}),_vm._v(" "),_c('div',{staticClass:"af-block col-block",style:({ flex: 1 })},_vm._l((fileGroup),function(file,findex){return _c('div',{key:findex,staticClass:"file row-block flex-start"},[_c((file.download_limit && (file.download_used >= file.download_limit)) ? 'div' : 'a',{tag:"component",staticClass:"link",style:({ flex: 1 }),on:{"click":function($event){!(file.download_limit && (file.download_used >= file.download_limit)) && _vm.downloadFile(file)}}},[_vm._v(_vm._s(file.name + ((file.download_limit && (file.download_used >= file.download_limit)) ? ' (' + _vm.$t('DIALOG.caseFile.limit.___times', { times: file.download_used }) + ')' : '')))])],1)}),0)])})],2)])}),0),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var caseFile_staticRenderFns = []
var caseFile_esExports = { render: caseFile_render, staticRenderFns: caseFile_staticRenderFns }
/* harmony default export */ var dialog_caseFile = (caseFile_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseFile.vue
var caseFile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseFile___vue_template_functional__ = false
/* styles */
var caseFile___vue_styles__ = null
/* scopeId */
var caseFile___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseFile___vue_module_identifier__ = null
var caseFile_Component = caseFile_normalizeComponent(
  caseFile,
  dialog_caseFile,
  caseFile___vue_template_functional__,
  caseFile___vue_styles__,
  caseFile___vue_scopeId__,
  caseFile___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseFile = (caseFile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/caseDetail/analysisVersionTable.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var analysisVersionTable = ({
  mixins: [customGrab["a" /* default */], responsitive["a" /* default */]],
  props: {
    defaultDatas: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      selectedTableData: null,
      // table
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [[], [140, 140]],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['scrollState']), {
    tableDatas: function tableDatas() {
      var _this = this;

      var tableDatas = this.defaultDatas;
      tableDatas = Object(util["m" /* sortData */])(tableDatas, this.sort.value.map(function (x) {
        return _this.sortMap[x];
      }), this.sort.order.map(function (x) {
        return x.replace('-', '');
      }));
      tableDatas = Object(util["i" /* groupBy */])(tableDatas, function () {
        return 'default';
      }).map(function (datas) {
        return { title: datas[0].group, isGroup: true, datas: datas };
      });
      return tableDatas;
    },
    sortMap: function sortMap() {
      return this.tableOptions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortMap || c.value));
      }, {});
    },

    // static
    tableOptions: function tableOptions() {
      return [{
        title: this.$t('COMPONENT.caseDetail.analysisVersionTable.table.title.___category'),
        value: 'category',
        sortMap: null
      }, {
        title: this.$t('COMPONENT.caseDetail.analysisVersionTable.table.title.___name'),
        value: 'name',
        sortMap: null
      }, {
        title: this.$t('COMPONENT.caseDetail.analysisVersionTable.table.title.___version'),
        value: 'version',
        sortMap: null
      }, {
        title: this.$t('COMPONENT.caseDetail.analysisVersionTable.table.title.___systemVersion'),
        value: 'systemVersion',
        sortMap: null
      }];
    }
  }),
  watch: {
    // data
    'selectedTableData': function selectedTableData(nv, ov) {
      if (nv !== ov && stringify_default()(nv) !== stringify_default()(ov)) {
        this.selectedTableData = nv ? JSON.parse(stringify_default()(nv)) : null;
      }
    },

    // table
    'tableDatas': function tableDatas() {
      this.getTableOverflow();
    },
    'windowWidth': function windowWidth(nv) {
      this.getTableWidths(nv);
      this.getTableOverflow();
    }
  },
  methods: {
    // table
    getTableOverflow: function getTableOverflow() {
      var _this2 = this;

      setTimeout(function () {
        var scrollContainer = _this2.$refs['custom-table-scroll'];
        if (scrollContainer) {
          _this2.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight;
        }
      });
    },
    getTableWidths: function getTableWidths(windowWidth) {
      window.dispatchEvent(new Event('scroll'));
      var tableWidth = Math.min(windowWidth - 22 * 2, 912) - 22 * 2 - (this.scrollState.height ? this.scrollbarSize : 0);
      tableWidth = tableWidth - this.staticTableWidths[0].reduce(function (s, c) {
        return s + c;
      }, 0) - this.staticTableWidths[1].reduce(function (s, c) {
        return s + c;
      }, 0);
      var tableWidths = this.tableWidths || [].concat(toConsumableArray_default()(this.staticTableWidths[0]), [392, 340], toConsumableArray_default()(this.staticTableWidths[1])).map(function (width) {
        return {
          value: width
        };
      });
      var tableMinWidths = this.tableMinWidths || 0.1;
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length);
      var ratio = tableWidth / tableWidths.reduce(function (s, c) {
        return s + c.value;
      }, 0);
      tableWidths = Array.prototype.concat.apply([], [this.staticTableWidths[0].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      }), tableWidths.map(function (width) {
        return {
          value: width.value * ratio,
          grab: 0
        };
      }), this.staticTableWidths[1].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      })]);
      this.tableMinWidths = tableMinWidths * ratio;
      this.tableWidths = tableWidths;
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
    },

    // grab
    boardResponse: function boardResponse(id, type) {
      var _this3 = this;

      return {
        'board1': {
          'start': function start(boardData) {
            _this3.sort.disabled = true;
          },
          'move': function move(boardData) {
            if (_this3.boardType['board1'] === 'grab') {
              var grabID = _this3.boardData[id].grabID;
              var tableWidths = [].concat(toConsumableArray_default()(_this3.tableWidths));
              var result = boardData.grabX - boardData.baseX;
              var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this3.staticTableWidths[1].length).reduce(function (s, c, i) {
                return s + c.value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths);
              }, 0);
              tableWidths.forEach(function (_, i) {
                if (i === grabID) {
                  tableWidths[i].grab = result;
                }if (i > grabID && i + _this3.staticTableWidths[1].length < tableWidths.length) {
                  tableWidths[i].grab = -(result * ((tableWidths[i].value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths)) / ratioBase));
                }
              });
              _this3.tableWidths = tableWidths;
            }
          },
          'end': function end(boardData) {
            var grabID = _this3.boardData[id].grabID;
            var tableWidths = [].concat(toConsumableArray_default()(_this3.tableWidths));
            var result = boardData.grabX - boardData.baseX;
            var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this3.staticTableWidths[1].length).reduce(function (s, c, i) {
              return s + c.value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths);
            }, 0);
            tableWidths.forEach(function (_, i) {
              tableWidths[i].grab = 0;
              if (i === grabID) {
                tableWidths[i].value += result;
              }if (i > grabID && i + _this3.staticTableWidths[1].length < tableWidths.length) {
                tableWidths[i].value -= result * ((tableWidths[i].value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths)) / ratioBase);
              }
            });
            _this3.tableWidths = tableWidths;
            setTimeout(function () {
              _this3.sort.disabled = false;
            });
          }
        }
      }[id][type];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-adfee906","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/caseDetail/analysisVersionTable.vue
var analysisVersionTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-analysis-version-table-page col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"case-detail-analysis-version-table-container col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"custom-table",class:{ 'auto-height': false }},[(_vm.tableWidths)?_c('div',{staticClass:"table-field col-block grab-container",style:({ width: _vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) + 'px' }),on:{"mousedown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardStart]); })($event)},"mousemove":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseout":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardEnd]); })($event)}}},[_c('div',{staticClass:"table-container col-block"},[_c('div',{staticClass:"thead"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab + 'px' }),on:{"click":function (e) { return !_vm.sort.disabled && option.sortMap !== null && _vm.tableSortBy(option.sortValue || option.value); }}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e()],2)}),0)])]),_vm._v(" "),_c('div',{ref:"custom-table-scroll",staticClass:"table-group-container col-block width-full"},[_c('div',{staticClass:"col-block"},_vm._l((_vm.tableDatas),function(group,gindex){return _c('div',{key:gindex,staticClass:"table-container col-block"},[_c('div',{staticClass:"tbody"},[_c('div',{staticClass:"tr group row-block",class:{ selected: false },style:(group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' })},[_c('a',{staticClass:"container-block row-block"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(group[option.gValue], gindex, group),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.gstyle || (function () { return ({}); }))(group[option.gValue], gindex, group)),attrs:{"title":((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || option.gempty || '')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('center') && !(option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)]),_vm._v(" "),_vm._l((group.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"tr col-block disabled",class:{ selectable: false, selected: false }},[_c('a',{staticClass:"container-block row-block",style:({ flex: 1 }),on:{"click":function (e) { return false && (_vm.selectedTableData = data); }}},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(data[option.value], dindex, data),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.style || (function () { return ({}); }))(data[option.value], dindex, data)),attrs:{"title":((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || option.empty || '- -')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(data[option.value], dindex, data).includes('center') && !(option.class || (function () { return []; }))(data[option.value], dindex, data).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)])})],2)])}),0)])]):_vm._e()])])])}
var analysisVersionTable_staticRenderFns = []
var analysisVersionTable_esExports = { render: analysisVersionTable_render, staticRenderFns: analysisVersionTable_staticRenderFns }
/* harmony default export */ var caseDetail_analysisVersionTable = (analysisVersionTable_esExports);
// CONCATENATED MODULE: ./src/components/caseDetail/analysisVersionTable.vue
var analysisVersionTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var analysisVersionTable___vue_template_functional__ = false
/* styles */
var analysisVersionTable___vue_styles__ = null
/* scopeId */
var analysisVersionTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var analysisVersionTable___vue_module_identifier__ = null
var analysisVersionTable_Component = analysisVersionTable_normalizeComponent(
  analysisVersionTable,
  caseDetail_analysisVersionTable,
  analysisVersionTable___vue_template_functional__,
  analysisVersionTable___vue_styles__,
  analysisVersionTable___vue_scopeId__,
  analysisVersionTable___vue_module_identifier__
)

/* harmony default export */ var components_caseDetail_analysisVersionTable = (analysisVersionTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseAnalysisVersion.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var caseAnalysisVersion = ({
  components: {
    caseDetailAnalysisVersionTable: components_caseDetail_analysisVersionTable
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    // static
    mainOptions: function mainOptions() {
      var _this = this;

      var tableDataParse = function tableDataParse(datas) {
        return datas.filter(function (data) {
          return _this.analysisVersions[data.version] && (!data.display || data.display.includes('case'));
        }).map(function (data) {
          return {
            category: _this.$t(data.category),
            name: _this.$t(data.name),
            version: _this.analysisVersions[data.version],
            systemVersion: _this.systemVersions[data.systemVersion]
          };
        });
      };
      return [{
        title: this.$t('DIALOG.caseAnalysisVersion.mainData.title.___pipeline'),
        tableDatas: tableDataParse(global_data["Y" /* versionDatas */]['pipeline'])
      }, {
        title: this.$t('DIALOG.caseAnalysisVersion.mainData.title.___analysis'),
        tableDatas: tableDataParse(global_data["Y" /* versionDatas */]['analysis'])
      }];
    },

    // param
    analysisVersions: function analysisVersions() {
      return extends_default()({}, this.param.analysisVersions);
    },
    systemVersions: function systemVersions() {
      return extends_default()({}, this.param.softwareVersions, this.param.systemVersions);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a769afcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseAnalysisVersion.vue
var caseAnalysisVersion_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-analysis-version-dailog dialog col-block width-full"},[_c('div',{staticClass:"case-analysis-version-title-container row-block"},[_c('div',{staticClass:"case-analysis-version-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseAnalysisVersion.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"case-analysis-version-main-container col-block width-full",style:({ flex: 1 })},_vm._l((_vm.mainOptions),function(option,oindex){return _c('div',{key:oindex,staticClass:"case-analysis-version-main-block col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"case-analysis-version-main-title-container row-block"},[_c('div',{staticClass:"case-analysis-version-main-title",domProps:{"innerHTML":_vm._s(option.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"case-analysis-version-main-content-container col-block width-full",style:({ flex: 1 })},[_c('caseDetailAnalysisVersionTable',{attrs:{"defaultDatas":option.tableDatas}})],1)])}),0),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var caseAnalysisVersion_staticRenderFns = []
var caseAnalysisVersion_esExports = { render: caseAnalysisVersion_render, staticRenderFns: caseAnalysisVersion_staticRenderFns }
/* harmony default export */ var dialog_caseAnalysisVersion = (caseAnalysisVersion_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseAnalysisVersion.vue
var caseAnalysisVersion_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseAnalysisVersion___vue_template_functional__ = false
/* styles */
var caseAnalysisVersion___vue_styles__ = null
/* scopeId */
var caseAnalysisVersion___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseAnalysisVersion___vue_module_identifier__ = null
var caseAnalysisVersion_Component = caseAnalysisVersion_normalizeComponent(
  caseAnalysisVersion,
  dialog_caseAnalysisVersion,
  caseAnalysisVersion___vue_template_functional__,
  caseAnalysisVersion___vue_styles__,
  caseAnalysisVersion___vue_scopeId__,
  caseAnalysisVersion___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseAnalysisVersion = (caseAnalysisVersion_Component.exports);

// EXTERNAL MODULE: ./src/components/tool/geneTag.vue + 2 modules
var geneTag = __webpack_require__("H3ds");

// EXTERNAL MODULE: ./src/components/tool/switchButton.vue + 2 modules
var switchButton = __webpack_require__("BdG8");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDetailSVFilter.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var caseDetailSVFilter = ({
  components: {
    geneTag: geneTag["a" /* default */],
    switchButton: switchButton["a" /* default */],
    borCor: newBorCor["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      // tag
      tagData: {
        map: {
          phenotype: {},
          gene: {}
        },
        query: {
          phenotype: '',
          gene: ''
        },
        tag: {
          phenotypes: {},
          genes: {}
        },
        curTag: {
          gene: null
        },
        searchTimer: {
          phenotype: [],
          gene: []
        }
      },
      // data
      inputData: {
        af: '',
        gq: '0',
        nc: ''
      },
      switchData: {
        af: false,
        gq: false
      },
      searchedDatas: {
        phenotypes: [],
        genes: []
      },
      selectedDatas: {
        phenotypes: [],
        genes: [],
        clinvar: [],
        DECIPHER: [],
        dosageSensitivity: [],
        genotype: [],
        svType: []
      }
    };
  },

  computed: {
    selectedLimit: function selectedLimit() {
      return {
        phenotypes: (this.sendData.phenotypes || []).length >= 10,
        genes: (this.sendData.genes || []).length >= 10
      };
    },
    sendData: function sendData() {
      var sendData = {};
      // gene
      var selectedGenes = this.selectedDatas['genes'];
      if (selectedGenes.length) {
        sendData.genes = [].concat(toConsumableArray_default()(selectedGenes));
      }
      // phenotype
      var selectedPhenotypes = this.selectedDatas['phenotypes'];
      if (selectedPhenotypes.length) {
        sendData.phenotypes = [].concat(toConsumableArray_default()(selectedPhenotypes));
      }
      // variant databases
      sendData.clinvar = [].concat(toConsumableArray_default()(this.selectedDatas['clinvar']));
      sendData.DECIPHER = [].concat(toConsumableArray_default()(this.selectedDatas['DECIPHER']));
      // af ds
      sendData.af = {
        switch: this.switchData['af'],
        value: this.inputData['af']
      };
      sendData.dosageSensitivity = [].concat(toConsumableArray_default()(this.selectedDatas['dosageSensitivity']));
      // caller
      sendData.genotype = [].concat(toConsumableArray_default()(this.selectedDatas['genotype']));
      sendData.svType = [].concat(toConsumableArray_default()(this.selectedDatas['svType']));
      sendData.gq = {
        switch: this.switchData['gq'],
        value: this.inputData['gq']
      };
      sendData.nc = {
        value: this.inputData['nc']
      };
      return sendData;
    },

    // static
    variantDatabaseOptions: function variantDatabaseOptions() {
      return [{
        title: this.$t('DIALOG.caseDetailSVFilter.variantDatabase.ClinVar.___title'),
        value: 'clinvar',
        options: global_data["T" /* svClinvarOptions */]
      }, {
        title: this.$t('DIALOG.caseDetailSVFilter.variantDatabase.DECIPHER.___title'),
        value: 'DECIPHER',
        options: global_data["U" /* svDECIPHEROptions */]
      }];
    },
    dosageSensitivityOptions: function dosageSensitivityOptions() {
      return {
        options: global_data["V" /* svDosageSensitivityOptions */]
      };
    },
    svCallerOptions: function svCallerOptions() {
      return [{
        title: this.$t('DIALOG.caseDetailSVFilter.caller.genotype.___title'),
        value: 'genotype',
        options: global_data["W" /* svGenotypeOptions */]
      }, {
        title: this.$t('DIALOG.caseDetailSVFilter.caller.svType.___title'),
        value: 'svType',
        options: global_data["X" /* svTypeOptions */].filter(function (option) {
          return option.filter !== false;
        })
      }];
    }
  },
  watch: {
    'switchData.af': function switchDataAf(nv) {
      if (nv && [undefined, null, ''].includes(this.inputData['af'])) {
        this.inputData['af'] = 0.01;
      }
    },
    'inputData.af': function inputDataAf(nv, ov) {
      if (nv && nv !== ov) {
        if (nv < 0 || nv > 0.2) {
          this.inputData['af'] = Math.max(0, Math.min(0.2, nv));
        }
      }
    }
  },
  created: function created() {
    this.init(this.param.defaultData);
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction']), {
    init: function init(defaultData) {
      if (defaultData) {
        // gene
        this.searchedDatas['genes'] = [].concat(toConsumableArray_default()(defaultData.genes || []));
        this.selectedDatas['genes'] = [].concat(toConsumableArray_default()(defaultData.genes || []));
        // phenotype
        this.searchedDatas['phenotypes'] = [].concat(toConsumableArray_default()(defaultData.phenotypes || []));
        this.selectedDatas['phenotypes'] = [].concat(toConsumableArray_default()(defaultData.phenotypes || []));
        // variant databases
        this.selectedDatas['clinvar'] = [].concat(toConsumableArray_default()(defaultData.clinvar));
        this.selectedDatas['DECIPHER'] = [].concat(toConsumableArray_default()(defaultData.DECIPHER));
        // af ds
        this.switchData['af'] = defaultData.af.switch;
        this.inputData['af'] = defaultData.af.value;
        this.selectedDatas['dosageSensitivity'] = [].concat(toConsumableArray_default()(defaultData.dosageSensitivity));
        // caller
        this.selectedDatas['genotype'] = [].concat(toConsumableArray_default()(defaultData.genotype));
        this.selectedDatas['svType'] = [].concat(toConsumableArray_default()(defaultData.svType));
        this.switchData['gq'] = defaultData.gq.switch;
        this.inputData['gq'] = defaultData.gq.value;
        this.inputData['nc'] = defaultData.nc.value;
      }
    },
    getGenes: function getGenes(query) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if ((_this.tagData.curTag['gene'] || {}).name !== query) {
                  _this.tagData.tag['genes'] = {};
                  if (_this.tagData.searchTimer['gene']) {
                    clearTimeout(_this.tagData.searchTimer['gene']);
                  }
                  _this.tagData.searchTimer['gene'] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                    var config, response, genes;
                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(!_this.tagData.map['gene'][query] && query)) {
                              _context.next = 16;
                              break;
                            }

                            _this.setLoadingAction(true);
                            _context.prev = 2;
                            config = _this.$ls.get('userInfo');
                            response = null;
                            _context.next = 7;
                            return Object(src_api["_70" /* getSearchSVGeneEntry */])(query, config);

                          case 7:
                            response = _context.sent;
                            genes = response.data.data.data;

                            _this.tagData.map['gene'] = extends_default()({}, _this.tagData.map['gene'], defineProperty_default()({}, query, {
                              info: null,
                              datas: [].concat(toConsumableArray_default()(genes.map(function (data) {
                                return extends_default()({}, data, { id: data.name, type: 'gene' });
                              })))
                            }));
                            _context.next = 15;
                            break;

                          case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](2);

                            _this.addToast('error', !_context.t0.response ? _context.t0.message : _context.t0.response.data.result.message);

                          case 15:
                            _this.setLoadingAction(false);

                          case 16:
                            _this.tagData.tag['genes'] = _this.tagData.map['gene'][query] || {};

                          case 17:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this, [[2, 12]]);
                  })), 500);
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    getPhenotypes: function getPhenotypes(query) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!((_this2.tagData.tag['phenotypes'] || { datas: [] }).datas || []).map(function (data) {
                  return data.query;
                }).includes(query)) {
                  if (_this2.tagData.searchTimer['phenotype']) {
                    clearTimeout(_this2.tagData.searchTimer['phenotype']);
                  }
                  _this2.tagData.searchTimer['phenotype'] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                    var config, response, phenotypes;
                    return regenerator_default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!(!_this2.tagData.map['phenotype'][query] && query)) {
                              _context3.next = 15;
                              break;
                            }

                            _this2.setLoadingAction(true);
                            _context3.prev = 2;
                            config = _this2.$ls.get('userInfo');
                            _context3.next = 6;
                            return Object(src_api["_69" /* getSearchSVDiseaseEntry */])(query, config);

                          case 6:
                            response = _context3.sent;
                            phenotypes = response.data.data.data;

                            _this2.tagData.map['phenotype'] = extends_default()({}, _this2.tagData.map['phenotype'], defineProperty_default()({}, query, {
                              info: null,
                              datas: [].concat(toConsumableArray_default()(phenotypes.map(function (data) {
                                return extends_default()({}, data, { id: data.name, phenotype_id: data.name.split(' ')[0], type: 'condition' });
                              })))
                            }));
                            _context3.next = 14;
                            break;

                          case 11:
                            _context3.prev = 11;
                            _context3.t0 = _context3['catch'](2);

                            _this2.addToast('error', !_context3.t0.response ? _context3.t0.message : _context3.t0.response.data.result.message);

                          case 14:
                            _this2.setLoadingAction(false);

                          case 15:
                            _this2.tagData.tag['phenotypes'] = _this2.tagData.map['phenotype'][query] || {};

                          case 16:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this2, [[2, 11]]);
                  })), 200);
                }

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    },
    addToSearch: function addToSearch(type, data) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var gene, phenotype;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.t0 = type;
                _context5.next = _context5.t0 === 'gene' ? 3 : _context5.t0 === 'phenotype' ? 14 : 25;
                break;

              case 3:
                data = data.type ? data : (_this3.tagData.map['gene'][_this3.tagData.query['gene']] || { datas: [] }).datas[0];

                if (!data) {
                  _context5.next = 13;
                  break;
                }

                _context5.t1 = data.type;
                _context5.next = _context5.t1 === 'gene' ? 8 : 11;
                break;

              case 8:
                gene = extends_default()({}, data);

                if (!_this3.searchedDatas['genes'].some(function (g) {
                  return g.gene_id === gene.gene_id;
                })) {
                  _this3.searchedDatas['genes'].push(gene);
                  if (!_this3.selectedLimit['genes']) {
                    _this3.selectedDatas['genes'].push(gene);
                  }
                }
                return _context5.abrupt('break', 11);

              case 11:
                _this3.tagData.query['gene'] = '';
                _this3.tagData.curTag['gene'] = null;

              case 13:
                return _context5.abrupt('break', 25);

              case 14:
                data = data.type ? data : (_this3.tagData.map['phenotype'][_this3.tagData.query['phenotype']] || { datas: [] }).datas[0];

                if (!data) {
                  _context5.next = 24;
                  break;
                }

                _context5.t2 = data.type;
                _context5.next = _context5.t2 === 'condition' ? 19 : 22;
                break;

              case 19:
                phenotype = extends_default()({}, data);

                if (!_this3.searchedDatas['phenotypes'].some(function (p) {
                  return p.id === phenotype.id;
                })) {
                  _this3.searchedDatas['phenotypes'].push(phenotype);
                  if (!_this3.selectedLimit['phenotypes']) {
                    _this3.selectedDatas['phenotypes'].push(phenotype);
                  }
                }
                return _context5.abrupt('break', 22);

              case 22:
                _this3.tagData.query['phenotype'] = '';
                _this3.tagData.curTag['phenotype'] = null;

              case 24:
                return _context5.abrupt('break', 25);

              case 25:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this3);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-057366d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDetailSVFilter.vue
var caseDetailSVFilter_render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-sv-filter-dailog dialog col-block width-full"},[_c('div',{staticClass:"case-detail-sv-filter-main-container col-block width-full"},[_c('div',{staticClass:"case-detail-sv-filter-main-title-container row-block"},[_c('div',{staticClass:"case-detail-sv-filter-main-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailSVFilter.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-gene-container col-block width-full"},[_c('div',{staticClass:"case-detail-sv-filter-gene-title-container row-block"},[_c('div',{staticClass:"case-detail-sv-filter-gene-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailSVFilter.gene.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-gene-search-container row-block"},[_c('div',{staticClass:"case-detail-sv-filter-gene-search-block col-block",style:({ flex: 1 })},[_c('div',{staticClass:"row-block flex-start",style:({ width: '100%' })},[_c('div',{staticClass:"case-detail-sv-filter-gene-search-input input-group",style:({ flex: 1 })},[_c('geneTag',{style:({ width: '100%' }),attrs:{"placeholder":_vm.$t('DIALOG.caseDetailSVFilter.gene.___placeholder'),"init":_vm.tagData.query['gene'],"title":false,"dataInfo":_vm.tagData.tag['genes'].info,"genes":_vm.tagData.tag['genes'].datas,"needFilter":false},on:{"input":function (content) { _vm.tagData.query['gene'] = content; _vm.getGenes(content) },"tag":function (content) { _vm.tagData.query['gene'] = content.name; _vm.tagData.curTag['gene'] = content; },"send":function (content) { return (_vm.tagData.tag['genes'].datas || []).length && _vm.tagData.query['gene'] ? _vm.addToSearch(_vm.tagData.curTag['gene'] || _vm.tagData.query['gene']) : ''; }}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zSkq"),"alt":""}})],1),_vm._v(" "),_c('div',{style:({ width: '22px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",attrs:{"disabled":!((_vm.tagData.tag['genes'].datas || []).length && _vm.tagData.query['gene'])},on:{"click":function (e) { return (_vm.tagData.tag['genes'].datas || []).length && _vm.tagData.query['gene'] ? _vm.addToSearch('gene', _vm.tagData.curTag['gene'] || _vm.tagData.query['gene']) : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___add')))])])]),_vm._v(" "),(_vm.searchedDatas['genes'].length)?_c('div',{staticClass:"case-detail-sv-filter-gene-selected-container col-block flex-start"},[_c('div',{staticClass:"case-detail-sv-filter-gene-selected-title-container row-block"},[_c('div',{staticClass:"case-detail-sv-filter-gene-selected-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailSVFilter.gene.selected.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-gene-selected-item-container row-block flex-wrap"},_vm._l((_vm.searchedDatas['genes']),function(gene,ghindex){return _c('div',{key:ghindex,staticClass:"case-detail-sv-filter-gene-item-container case-detail-sv-filter-item-container row-block",class:{
                  disabled: _vm.selectedLimit['genes'] && !_vm.selectedDatas['genes'].includes(gene)
                },on:{"click":function (e) {
                  _vm.selectedDatas['genes'] =
                    e.currentTarget.className.split(' ').includes('disabled') ? _vm.selectedDatas['genes']
                    : _vm.selectedDatas['genes'].includes(gene) ? _vm.selectedDatas['genes'].filter(function (g) { return g.gene_id !== gene.gene_id; })
                    : _vm.selectedDatas['genes'].concat([gene])
                }}},[_c('div',{staticClass:"case-detail-sv-filter-item-block row-block"},[_c('img',{staticClass:"checkbox",attrs:{"src":_vm.selectedDatas['genes'].includes(gene) ? __webpack_require__("7kqe")
                      : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-item-title"},[_vm._v(_vm._s(gene.name))])])])}),0)]):_vm._e()])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-condition-container col-block width-full"},[_c('div',{staticClass:"case-detail-sv-filter-condition-title-container row-block"},[_c('div',{staticClass:"case-detail-sv-filter-condition-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailSVFilter.condition.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-condition-search-container row-block"},[_c('div',{staticClass:"case-detail-sv-filter-condition-search-block col-block",style:({ flex: 1 })},[_c('div',{staticClass:"row-block flex-start",style:({ width: '100%' })},[_c('div',{staticClass:"case-detail-sv-filter-condition-search-input input-group",style:({ flex: 1 })},[_c('geneTag',{style:({ width: '100%' }),attrs:{"placeholder":_vm.$t('DIALOG.caseDetailSVFilter.condition.___placeholder'),"init":_vm.tagData.query['phenotype'],"title":false,"dataInfo":_vm.tagData.tag['phenotypes'].info,"genes":_vm.tagData.tag['phenotypes'].datas,"needFilter":false},on:{"input":function (content) { _vm.tagData.query['phenotype'] = content; _vm.getPhenotypes(content) },"tag":function (content) { _vm.tagData.query['phenotype'] = content.name; _vm.tagData.curTag['phenotype'] = content; },"send":function (content) { return (_vm.tagData.tag['phenotypes'].datas || []).length && _vm.tagData.query['phenotype'] ? _vm.addToSearch(_vm.tagData.curTag['phenotype'] || _vm.tagData.query['phenotype']) : ''; }}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zSkq"),"alt":""}})],1),_vm._v(" "),_c('div',{style:({ width: '22px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",attrs:{"disabled":!((_vm.tagData.tag['phenotypes'].datas || []).length && _vm.tagData.query['phenotype'])},on:{"click":function (e) { return (_vm.tagData.tag['phenotypes'].datas || []).length && _vm.tagData.query['phenotype'] ? _vm.addToSearch('phenotype', _vm.tagData.query['phenotype']) : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___add')))])])]),_vm._v(" "),(_vm.searchedDatas['phenotypes'].length)?_c('div',{staticClass:"case-detail-sv-filter-condition-selected-container col-block flex-start"},[_c('div',{staticClass:"case-detail-sv-filter-condition-selected-title-container row-block"},[_c('div',{staticClass:"case-detail-sv-filter-condition-selected-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailSVFilter.condition.selected.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-condition-selected-item-container row-block flex-wrap"},_vm._l((_vm.searchedDatas['phenotypes']),function(phenotype,phindex){return _c('div',{key:phindex,staticClass:"case-detail-sv-filter-condition-item-container case-detail-sv-filter-item-container row-block",class:{
                  disabled: _vm.selectedLimit['phenotypes'] && !_vm.selectedDatas['phenotypes'].includes(phenotype)
                },on:{"click":function (e) {
                  _vm.selectedDatas['phenotypes'] =
                    e.currentTarget.className.split(' ').includes('disabled') ? _vm.selectedDatas['phenotypes']
                    : _vm.selectedDatas['phenotypes'].includes(phenotype) ? _vm.selectedDatas['phenotypes'].filter(function (p) { return p.id !== phenotype.id; })
                    : _vm.selectedDatas['phenotypes'].concat([phenotype])
                }}},[_c('div',{staticClass:"case-detail-sv-filter-item-block row-block"},[_c('img',{staticClass:"checkbox",attrs:{"src":_vm.selectedDatas['phenotypes'].includes(phenotype) ? __webpack_require__("7kqe")
                      : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-item-title"},[_vm._v(_vm._s(phenotype.name))])])])}),0)]):_vm._e()])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-variant-database-container col-block width-full"},[_c('div',{staticClass:"case-detail-sv-filter-variant-database-title-container row-block"},[_c('div',{staticClass:"case-detail-sv-filter-variant-database-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailSVFilter.variantDatabase.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-variant-database-main-container row-block flex-start"},_vm._l((_vm.variantDatabaseOptions),function(databaseOption,doindex){return _c('div',{key:doindex,staticClass:"case-detail-sv-filter-variant-database-main-block col-block width-full",style:({ flex: 1, 'max-width': '450px' })},[_c('div',{staticClass:"case-detail-sv-filter-variant-database-main-title-container row-block"},[_c('div',{staticClass:"case-detail-sv-filter-variant-database-main-title"},[_vm._v(_vm._s(databaseOption.title))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-variant-database-selected-item-container"},_vm._l((databaseOption.options),function(dataOption,dindex){return _c('div',{key:dindex,staticClass:"case-detail-sv-filter-variant-database-item-container case-detail-sv-filter-item-container row-block",class:{
                disabled: false
              },style:({ 'grid-column': 'span ' + (dataOption.grid) + ' / auto' }),on:{"click":function (e) {
                _vm.selectedDatas[databaseOption.value] =
                  e.currentTarget.className.split(' ').includes('disabled') ? _vm.selectedDatas[databaseOption.value]
                  : _vm.selectedDatas[databaseOption.value].includes(dataOption.value) ? _vm.selectedDatas[databaseOption.value].filter(function (data) { return data !== dataOption.value; })
                  : _vm.selectedDatas[databaseOption.value].concat([dataOption.value])
              }}},[_c('div',{staticClass:"case-detail-sv-filter-item-block row-block"},[_c('img',{staticClass:"checkbox",attrs:{"src":_vm.selectedDatas[databaseOption.value].includes(dataOption.value) ? __webpack_require__("7kqe")
                    : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-item-title ellipsis",style:({ color: dataOption.color, 'font-weight': dataOption.bold ? 'bold' : '400', flex: 1 }),attrs:{"title":_vm.$t(dataOption.title)}},[_vm._v(_vm._s(_vm.$t(dataOption.title)))])])])}),0)])}),0)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-af-ds-container row-block flex-start"},[_c('div',{staticClass:"case-detail-sv-filter-af-container col-block width-full",style:({ width: '132px' })},[_c('div',{staticClass:"case-detail-sv-filter-af-title-container row-block"},[_c('div',{staticClass:"case-detail-sv-filter-af-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailSVFilter.afFilter.___title')))]),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('switchButton',{attrs:{"disabled":false,"checked":_vm.switchData['af']},on:{"input":function (c) { return _vm.switchData['af'] = c; }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-af-main-container input-group col-block width-full"},[_c('div',{staticClass:"case-detail-sv-filter-af-mark-container row-block",class:{ disabled: !_vm.switchData['af'] }},[_c('div',{staticClass:"case-detail-sv-filter-af-mark"},[_vm._v(_vm._s('<'))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputData['af']),expression:"inputData['af']"}],attrs:{"type":"number","step":"0.01","min":"0","max":"0.2","placeholder":_vm.$t('DIALOG.caseDetailSVFilter.afFilter.___placeholder'),"disabled":!_vm.switchData['af']},domProps:{"value":(_vm.inputData['af'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inputData, 'af', $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-dosage-sensitivity-container col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"case-detail-sv-filter-dosage-sensitivity-title-container row-block"},[_c('div',{staticClass:"case-detail-sv-filter-dosage-sensitivity-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailSVFilter.DosageSensitivity.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-dosage-sensitivity-selected-item-container"},_vm._l((_vm.dosageSensitivityOptions.options),function(dataOption,dindex){return _c('div',{key:dindex,staticClass:"case-detail-sv-filter-dosage-sensitivity-item-container case-detail-sv-filter-item-container row-block",class:{
              disabled: false
            },style:({ 'grid-column': 'span 1 / auto' }),on:{"click":function (e) {
              _vm.selectedDatas['dosageSensitivity'] =
                e.currentTarget.className.split(' ').includes('disabled') ? _vm.selectedDatas['dosageSensitivity']
                : _vm.selectedDatas['dosageSensitivity'].includes(dataOption.value) ? _vm.selectedDatas['dosageSensitivity'].filter(function (data) { return data !== dataOption.value; })
                : _vm.selectedDatas['dosageSensitivity'].concat([dataOption.value])
            }}},[_c('div',{staticClass:"case-detail-sv-filter-item-block row-block"},[_c('img',{staticClass:"checkbox",attrs:{"src":_vm.selectedDatas['dosageSensitivity'].includes(dataOption.value) ? __webpack_require__("7kqe")
                  : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-item-title ellipsis",style:({ color: dataOption.color, 'font-weight': dataOption.bold ? 'bold' : '400', flex: 1 }),attrs:{"title":_vm.$t(dataOption.title)}},[_vm._v(_vm._s(_vm.$t(dataOption.title)))])])])}),0)])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-caller-container col-block width-full"},[_c('div',{staticClass:"case-detail-sv-filter-caller-title-container row-block"},[_c('div',{staticClass:"case-detail-sv-filter-caller-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailSVFilter.caller.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-caller-main-container row-block flex-start"},[_c('div',{staticClass:"case-detail-sv-filter-caller-data-main-container col-block width-full",style:({ flex: 1 })},_vm._l((_vm.svCallerOptions),function(databaseOption,doindex){return _c('div',{key:doindex,staticClass:"case-detail-sv-filter-caller-data-main-block col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"case-detail-sv-filter-caller-data-main-title-container row-block"},[_c('div',{staticClass:"case-detail-sv-filter-caller-data-main-title"},[_vm._v(_vm._s(databaseOption.title))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-caller-data-selected-item-container row-block flex-wrap"},_vm._l((databaseOption.options),function(dataOption,dindex){return _c('div',{key:dindex,staticClass:"case-detail-sv-filter-caller-data-item-container case-detail-sv-filter-item-container row-block",class:{
                  disabled: false
                },on:{"click":function (e) {
                  _vm.selectedDatas[databaseOption.value] =
                    e.currentTarget.className.split(' ').includes('disabled') ? _vm.selectedDatas[databaseOption.value]
                    : _vm.selectedDatas[databaseOption.value].includes(dataOption.value) ? _vm.selectedDatas[databaseOption.value].filter(function (data) { return data !== dataOption.value; })
                    : _vm.selectedDatas[databaseOption.value].concat([dataOption.value])
                }}},[_c('div',{staticClass:"case-detail-sv-filter-item-block row-block"},[_c('img',{staticClass:"checkbox",attrs:{"src":_vm.selectedDatas[databaseOption.value].includes(dataOption.value) ? __webpack_require__("7kqe")
                      : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-item-title",style:({ color: dataOption.color, 'font-weight': dataOption.bold ? 'bold' : '400' })},[_vm._v(_vm._s(_vm.$t(dataOption.title)))])])])}),0)])}),0),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-gq-container col-block width-full",style:({ width: '132px' })},[_c('div',{staticClass:"case-detail-sv-filter-gq-title-container row-block"},[_c('div',{staticClass:"case-detail-sv-filter-gq-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailSVFilter.caller.genotypeQuality.___title')))]),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('switchButton',{attrs:{"disabled":false,"checked":_vm.switchData['gq']},on:{"input":function (c) { return _vm.switchData['gq'] = c; }}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('borCor',{attrs:{"reverse":true,"background":'white',"border":'#CCCCCC',"radius":'0px',"blockStyle":{ padding: '10px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{style:({ width: '16px' }),attrs:{"src":__webpack_require__("Rp0L"),"alt":""}})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailSVFilter.caller.genotypeQuality.___info')))])])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-gq-main-container input-group col-block flex-start"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputData['gq']),expression:"inputData['gq']"}],attrs:{"type":"number","step":"1","disabled":!_vm.switchData['gq']},domProps:{"value":(_vm.inputData['gq'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inputData, 'gq', $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-nc-container col-block width-full",style:({ width: '132px' })},[_c('div',{staticClass:"case-detail-sv-filter-nc-title-container row-block"},[_c('div',{staticClass:"case-detail-sv-filter-nc-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailSVFilter.caller.numberOfCallers.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"case-detail-sv-filter-nc-main-container input-group col-block flex-start"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputData['nc']),expression:"inputData['nc']"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.inputData, 'nc', $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((Array(4).fill('')),function(_,index){return _c('option',{key:index,domProps:{"value":index ? index : ''}},[_vm._v(_vm._s(index ? index : ''))])}),0)])])])])]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return this$1.$emit('changeModal', {}, 'reset'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___reset')))])]),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return this$1.$emit('changeModal', {}, _vm.sendData); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___apply')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var caseDetailSVFilter_staticRenderFns = []
var caseDetailSVFilter_esExports = { render: caseDetailSVFilter_render, staticRenderFns: caseDetailSVFilter_staticRenderFns }
/* harmony default export */ var dialog_caseDetailSVFilter = (caseDetailSVFilter_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDetailSVFilter.vue
var caseDetailSVFilter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDetailSVFilter___vue_template_functional__ = false
/* styles */
var caseDetailSVFilter___vue_styles__ = null
/* scopeId */
var caseDetailSVFilter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDetailSVFilter___vue_module_identifier__ = null
var caseDetailSVFilter_Component = caseDetailSVFilter_normalizeComponent(
  caseDetailSVFilter,
  dialog_caseDetailSVFilter,
  caseDetailSVFilter___vue_template_functional__,
  caseDetailSVFilter___vue_styles__,
  caseDetailSVFilter___vue_scopeId__,
  caseDetailSVFilter___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDetailSVFilter = (caseDetailSVFilter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/case/familyPedigree.vue




//
//
//
//
//
//
//
//




/* harmony default export */ var familyPedigree = ({
  props: {
    caseData: {
      type: Object,
      required: true
    },
    variant: {
      type: Object,
      required: true
    },
    sampleAllelegts: {
      type: Object,
      required: true
    }
  },
  computed: {
    pedigreeDatas: function pedigreeDatas() {
      var _this = this;

      var familyInfos = this.variant.fam_info || [];
      var sampleAllelegt = this.sampleAllelegts[[this.variant.CHROM, this.variant.POS, this.variant.REF, this.variant.ALT].join(':')] || [];
      sampleAllelegt = sampleAllelegt.reduce(function (result, data) {
        return data.sample ? extends_default()({}, result, defineProperty_default()({}, data.sample, { 'GT': data.gt, 'RefAlt': data.refalt })) : result;
      }, {});
      var familyRelationMap = global_data["n" /* familyRelationOptions */].reduce(function (map, option) {
        return extends_default()({}, map, defineProperty_default()({}, option.value, option));
      }, {});
      var familyGroupKeys = keys_default()(Object(util["i" /* groupBy */])(global_data["n" /* familyRelationOptions */], function (option) {
        return option.group;
      }, true));
      var familyDataLayout = familyGroupKeys.reduce(function (layout, key) {
        return extends_default()({}, layout, defineProperty_default()({}, key, { main: null, subs: [] }));
      }, {});
      familyInfos.forEach(function (info) {
        var relationOption = info.relation !== 'Proband' ? familyRelationMap[info.relation] : { sex: _this.caseData.sex };
        var refalt = (sampleAllelegt[info.sample_id || info.sample_number] || {}).RefAlt || info.RefAlt;
        var gt = (sampleAllelegt[info.sample_id || info.sample_number] || {}).GT || info.GT;
        var data = {
          title: info.case_id || '- -',
          RefAlt: refalt ? refalt.replace(/\//, ' > ') : '　',
          GT: gt || '　',
          QC: [['DP', info.DP], ['AF', Object(util["g" /* fixNumber */])(info.GT_AF, 0.01)], ['GQ', info.GQ, (info.GQ || 0) < 20]].filter(function (data) {
            return data[1] || data[1] === 0;
          }).map(function (data, index) {
            return '<span ' + (data[2] ? 'class=alert' : '') + '>' + data[0] + ':' + data[1] + '</span>' + (index < 2 ? ';' : '');
          }),
          sex: relationOption.sex,
          affected: info.phenotype === 2,
          relation: info.relation
        };
        if (familyDataLayout[info.relation]) {
          familyDataLayout[info.relation].main = data;
        } else {
          familyDataLayout[relationOption.group].subs.push(data);
        }
      });
      var familyGroupDatas = familyGroupKeys.reduce(function (data, key) {
        var datas = [familyDataLayout[key].main || (familyDataLayout[key].subs.length ? {} : null)].concat(toConsumableArray_default()(familyDataLayout[key].subs)).filter(function (x) {
          return x;
        });
        return extends_default()({}, data, defineProperty_default()({}, key, datas.length ? datas : null));
      }, {});
      var grandLength = ['Paternal Grandfather', 'Paternal Grandmother', 'Maternal Grandfather', 'Maternal Grandmother'].reduce(function (length, key) {
        return length + (familyGroupDatas[key] || []).length;
      }, 0);
      var pedigreeDatas = {
        nodes: familyGroupDatas['Proband'] || [{ sex: this.caseData.sex }],
        hasParent: this.variant.type !== 'single',
        hiddenParent: false,
        fathers: {
          nodes: [].concat(toConsumableArray_default()(familyGroupDatas['Father'] || [{ sex: familyRelationMap['Father'].sex }])).reverse(),
          hasParent: grandLength > 0,
          hiddenParent: grandLength && !familyGroupDatas['Paternal Grandfather'] && !familyGroupDatas['Paternal Grandmother'],
          fathers: {
            nodes: familyGroupDatas['Paternal Grandfather'] || [{ sex: familyRelationMap['Paternal Grandfather'].sex }]
          },
          mothers: {
            nodes: familyGroupDatas['Paternal Grandmother'] || [{ sex: familyRelationMap['Paternal Grandmother'].sex }]
          }
        },
        mothers: {
          nodes: familyGroupDatas['Mother'] || [{ sex: familyRelationMap['Mother'].sex }],
          hasParent: grandLength > 0,
          hiddenParent: grandLength && !familyGroupDatas['Maternal Grandfather'] && !familyGroupDatas['Maternal Grandmother'],
          fathers: {
            nodes: familyGroupDatas['Maternal Grandfather'] || [{ sex: familyRelationMap['Maternal Grandfather'].sex }]
          },
          mothers: {
            nodes: familyGroupDatas['Maternal Grandmother'] || [{ sex: familyRelationMap['Maternal Grandmother'].sex }]
          }
        }
      };
      var setPedigreeLength = function setPedigreeLength(pedigreeData) {
        var fatherLegnth = pedigreeData.fathers && pedigreeData.hasParent ? setPedigreeLength(pedigreeData.fathers) : 0;
        var motherLegnth = pedigreeData.mothers && pedigreeData.hasParent ? setPedigreeLength(pedigreeData.mothers) : 0;
        var childLength = Math.max(fatherLegnth, motherLegnth);
        pedigreeData.fathers && (pedigreeData.fathers.nodeLength = childLength);
        pedigreeData.mothers && (pedigreeData.mothers.nodeLength = childLength);
        var nodeLength = (pedigreeData.nodes || []).length || 0;
        return Math.max(childLength * 2, nodeLength);
      };
      setPedigreeLength(pedigreeDatas);
      return pedigreeDatas;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e023aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/familyPedigree.vue
var familyPedigree_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-family-pedigree-page"},[_c('familyPedigree',{attrs:{"pedigreeDatas":_vm.pedigreeDatas}})],1)}
var familyPedigree_staticRenderFns = []
var familyPedigree_esExports = { render: familyPedigree_render, staticRenderFns: familyPedigree_staticRenderFns }
/* harmony default export */ var case_familyPedigree = (familyPedigree_esExports);
// CONCATENATED MODULE: ./src/components/case/familyPedigree.vue
var familyPedigree_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var familyPedigree___vue_template_functional__ = false
/* styles */
var familyPedigree___vue_styles__ = null
/* scopeId */
var familyPedigree___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var familyPedigree___vue_module_identifier__ = null
var familyPedigree_Component = familyPedigree_normalizeComponent(
  familyPedigree,
  case_familyPedigree,
  familyPedigree___vue_template_functional__,
  familyPedigree___vue_styles__,
  familyPedigree___vue_scopeId__,
  familyPedigree___vue_module_identifier__
)

/* harmony default export */ var components_case_familyPedigree = (familyPedigree_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDetailGenePedigree.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var caseDetailGenePedigree = ({
  components: {
    caseFamilyPedigree: components_case_familyPedigree
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    variantDatas: function variantDatas() {
      var _this = this;

      return values_default()(this.variants).map(function (variant) {
        return extends_default()({}, variant, {
          type: variant.fam_info ? 'trio' : 'single',
          fam_info: variant.fam_info || [extends_default()({}, _this.caseData, {
            GT: variant.GT_raw,
            RefAlt: [variant.REF, variant.ALT].join(' > '),
            relation: 'Proband'
          })]
        });
      });
    },

    // param
    caseData: function caseData() {
      return this.param.caseData;
    },
    project: function project() {
      return this.param.project;
    },
    type: function type() {
      return this.param.type;
    },
    gene: function gene() {
      return this.param.gene;
    },
    variants: function variants() {
      return this.param.variants;
    },
    sampleAllelegts: function sampleAllelegts() {
      return this.param.sampleAllelegts;
    }
  },
  methods: {
    openGenomeBrowser: function openGenomeBrowser(variant) {
      window.open(window.location.origin + '/genomeBrowser/' + [this.$route.params.id, this.project.id].join('-') + '/' + this.type + '/' + this.gene.SYMBOL + '/' + variant.CHROM + '%3A' + variant.POS + '%3A' + variant.REF + '%3A' + variant.ALT);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f54600","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDetailGenePedigree.vue
var caseDetailGenePedigree_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-gene-pedigree-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGenePedigree.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_vm._l((_vm.variantDatas),function(variant,vindex){return _c('div',{key:vindex,staticClass:"data-container col-block"},[_c('div',{staticClass:"data-title-container row-block"},[_c('div',{staticClass:"data-title"},[_vm._v(_vm._s(variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -'))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('img',{style:({ cursor: 'pointer' }),attrs:{"src":__webpack_require__("wtkH"),"alt":""},on:{"click":function (e) { return _vm.openGenomeBrowser(variant); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block"},[_c('caseFamilyPedigree',{attrs:{"caseData":_vm.caseData,"variant":variant,"sampleAllelegts":_vm.sampleAllelegts}})],1)])}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var caseDetailGenePedigree_staticRenderFns = []
var caseDetailGenePedigree_esExports = { render: caseDetailGenePedigree_render, staticRenderFns: caseDetailGenePedigree_staticRenderFns }
/* harmony default export */ var dialog_caseDetailGenePedigree = (caseDetailGenePedigree_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDetailGenePedigree.vue
var caseDetailGenePedigree_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDetailGenePedigree___vue_template_functional__ = false
/* styles */
var caseDetailGenePedigree___vue_styles__ = null
/* scopeId */
var caseDetailGenePedigree___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDetailGenePedigree___vue_module_identifier__ = null
var caseDetailGenePedigree_Component = caseDetailGenePedigree_normalizeComponent(
  caseDetailGenePedigree,
  dialog_caseDetailGenePedigree,
  caseDetailGenePedigree___vue_template_functional__,
  caseDetailGenePedigree___vue_styles__,
  caseDetailGenePedigree___vue_scopeId__,
  caseDetailGenePedigree___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDetailGenePedigree = (caseDetailGenePedigree_Component.exports);

// EXTERNAL MODULE: ./src/components/case/clinvarStatisticTable.vue + 2 modules
var clinvarStatisticTable = __webpack_require__("qFyz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/caseDetail/geneClinvarData.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var geneClinvarData = ({
  components: {
    clinvarStatisticTable: clinvarStatisticTable["a" /* default */]
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    gene: function gene() {
      return this.param.gene;
    },
    variants: function variants() {
      return this.param.variants;
    },
    clinvarStatistic: function clinvarStatistic() {
      return this.param.clinvarStatistic;
    },

    // static
    tableOptionGroups: function tableOptionGroups() {
      var _this = this;

      var clinvar = {
        title: this.$t('COMPONENT.caseDetail.geneClinvarData.table.clinvar.___title'),
        link: function link(variant) {
          return variant.ClinVar_URL;
        },
        options: [{
          title: this.$t('COMPONENT.caseDetail.geneClinvarData.table.clinvar.title.___interpretation'),
          value: function value(variant) {
            return Object(global_data["o" /* getClinvarACMGMapDatas */])(variant.CLIN_SIG).map(function (data) {
              return '<span' + (data.display === global_data["m" /* defaultEmptyDisplay */].empty ? '' : ' style="color:' + data.color + ';"') + '>' + _this.$t(data.display) + '</span>';
            }).join(',<br>');
          },
          color: null,
          width: '200px',
          position: 'center',
          empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
        }, {
          title: this.$t('COMPONENT.caseDetail.geneClinvarData.table.clinvar.title.___reviewStatus'),
          value: function value(variant) {
            return variant.ClinVar_CLNREVSTAT ? variant.ClinVar_CLNREVSTAT.split(',').map(function (value) {
              return value.replace(/_/g, ' ');
            }).join(',<br>') : null;
          },
          color: null,
          width: '250px',
          position: 'left',
          empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
        }, {
          title: this.$t('COMPONENT.caseDetail.geneClinvarData.table.clinvar.title.___condition'),
          value: function value(variant) {
            return variant.ClinVar_Disease_Name ? variant.ClinVar_Disease_Name.split('|').map(function (value) {
              return value.replace(/_/g, ' ');
            }).join(',<br>') : null;
          },
          color: null,
          width: null,
          position: 'left',
          empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
        }, {
          title: this.$t('COMPONENT.caseDetail.geneClinvarData.table.clinvar.title.___conflicts'),
          value: function value(variant) {
            return variant.CLIN_CONF ? variant.CLIN_CONF.split(',').map(function (value) {
              return value.replace(/_/g, ' ');
            }).join(',<br>') : null;
          },
          color: null,
          width: null,
          position: 'left',
          empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
        }]
      };
      return [clinvar].filter(function (x) {
        return x;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72c710ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/caseDetail/geneClinvarData.vue
var geneClinvarData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-gene-clinvar-data-page col-block width-full",style:({ flex: 1 })},[_vm._l((_vm.variants),function(variant,vindex){return _c('div',{key:vindex,staticClass:"data-container col-block width-full"},[_c('div',{staticClass:"data-title-container row-block"},[_c('div',{staticClass:"data-title"},[_vm._v(_vm._s(variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -'))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),(variant.ClinVar_URL)?_c('a',{attrs:{"href":variant.ClinVar_URL,"target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("wtkH"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block width-full"},_vm._l((_vm.tableOptionGroups),function(optionGroup,gindex){return _c('div',{key:gindex,staticClass:"data-content-block col-block width-full"},[_c('div',{staticClass:"data-row-container col-block width-full"},[_c('div',{staticClass:"data-row row-block stretch"},_vm._l((optionGroup.options),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position],style:(option.width ? { width: option.width } : { flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content",domProps:{"innerHTML":_vm._s(option.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0),_vm._v(" "),_c('div',{staticClass:"data-row row-block stretch"},_vm._l((optionGroup.options),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position],style:(option.width ? { width: option.width } : { flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content",style:(option.color ? { color: option.color(variant) } : {}),domProps:{"innerHTML":_vm._s(option.value(variant) || option.empty || '- -')}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])])}),0)])}),_vm._v(" "),_c('div',{staticClass:"clinvar-statistic-container col-block width-full"},[_c('div',{staticClass:"clinvar-statistic-title-container row-block"},[_c('div',{staticClass:"clinvar-statistic-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.caseDetail.geneClinvarData.___clinvarStatisticTitle')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(_vm.clinvarStatistic)?_c('clinvarStatisticTable',{attrs:{"defaultData":_vm.clinvarStatistic}}):_vm._e()],1),_vm._v(" "),_c('div',{style:({ height: 0 })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var geneClinvarData_staticRenderFns = []
var geneClinvarData_esExports = { render: geneClinvarData_render, staticRenderFns: geneClinvarData_staticRenderFns }
/* harmony default export */ var caseDetail_geneClinvarData = (geneClinvarData_esExports);
// CONCATENATED MODULE: ./src/components/caseDetail/geneClinvarData.vue
var geneClinvarData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var geneClinvarData___vue_template_functional__ = false
/* styles */
var geneClinvarData___vue_styles__ = null
/* scopeId */
var geneClinvarData___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var geneClinvarData___vue_module_identifier__ = null
var geneClinvarData_Component = geneClinvarData_normalizeComponent(
  geneClinvarData,
  caseDetail_geneClinvarData,
  geneClinvarData___vue_template_functional__,
  geneClinvarData___vue_styles__,
  geneClinvarData___vue_scopeId__,
  geneClinvarData___vue_module_identifier__
)

/* harmony default export */ var components_caseDetail_geneClinvarData = (geneClinvarData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/case/mastermindPublicationTable.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var mastermindPublicationTable = ({
  components: {
    pageButtons: pageButtons["a" /* default */]
  },
  mixins: [routeLoading["a" /* default */]],
  props: {
    pmids: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      publicationDatas: null,
      detailIndex: null,
      pageData: {
        selectedPage: 1,
        display: 20,
        total: 0,
        buttonRange: 7
      }
    };
  },

  computed: {
    filtedPublicationDatas: function filtedPublicationDatas() {
      var _this = this;

      var filtedPublicationDatas = [].concat(toConsumableArray_default()(this.publicationDatas || []));
      filtedPublicationDatas = filtedPublicationDatas.filter(function (_, i) {
        return i >= _this.pageData.display * (_this.pageData.selectedPage - 1) && i < _this.pageData.display * _this.pageData.selectedPage;
      });
      return filtedPublicationDatas;
    },

    // static
    tableOptions: function tableOptions() {
      return [{
        title: this.$t('COMPONENT.case.mastermindPublicationTable.table.title.___no'),
        value: 'index',
        style: null,
        width: '60px',
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('COMPONENT.case.mastermindPublicationTable.table.title.___details'),
        value: '_DETAILS',
        style: null,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('COMPONENT.case.mastermindPublicationTable.table.title.___PMID'),
        value: '_PMID',
        style: null,
        width: '160px',
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }];
    },

    // global
    toPriceString: function toPriceString() {
      return util["r" /* toPriceString */];
    }
  },
  watch: {
    'pageData.selectedPage': function pageDataSelectedPage() {
      var container = this.$refs['publication-container'];
      container && setTimeout(function () {
        container.scrollTo({ top: 0 });
      });
    },
    'detailIndex': function detailIndex(nv) {
      if (![null, undefined].includes(nv)) {
        var container = this.$refs['publication-container'];
        var child = this.$refs['publication-data-' + nv][0];
        setTimeout(function () {
          container.scrollTo({ top: child.offsetTop - container.offsetTop });
        });
      }
    }
  },
  activated: function activated() {
    this.pageData.selectedPage = 1;
    var container = this.$refs['publication-container'];
    container && setTimeout(function () {
      container.scrollTo({ top: 0 });
    });
  },

  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.fetchMastermindPublication();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fetchMastermindPublication: function fetchMastermindPublication() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, pmid, response, publicationDatas;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this3.$ls.get('userInfo');
                pmid = _this3.pmids.join(',');
                _context2.next = 5;
                return Object(src_api["_48" /* getMastermindPublications */])(pmid, config);

              case 5:
                response = _context2.sent;
                publicationDatas = response.data.data;

                publicationDatas = publicationDatas.filter(function (data) {
                  return data.pmid;
                }).map(function (data, index) {
                  return extends_default()({ index: index + 1 }, data);
                });
                _this3.pageData.total = publicationDatas.length;
                _this3.publicationDatas = publicationDatas;
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 12]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2819e105","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/mastermindPublicationTable.vue
var mastermindPublicationTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.publicationDatas)?_c('div',{staticClass:"mastermind-publication-table-page col-block width-full"},[_c('div',{staticClass:"data-table-container col-block width-full"},[_c('div',{staticClass:"data-table-block col-block width-full"},[_c('div',{staticClass:"data-row-container col-block width-full"},[_c('div',{staticClass:"data-row row-block stretch"},_vm._l((_vm.tableOptions),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position],style:(option.width ? { width: option.width } : { flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content",domProps:{"innerHTML":_vm._s(option.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])]),_vm._v(" "),_c('div',{ref:'publication-container',staticClass:"data-table-block col-block width-full",style:({ 'max-height': '60vh' })},_vm._l((_vm.filtedPublicationDatas),function(data){return _c('div',{key:data.index,ref:'publication-data-' + data.index,refInFor:true,staticClass:"data-row-container col-block width-full"},[_c('div',{staticClass:"data-row row-block stretch"},_vm._l((_vm.tableOptions),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position],style:(option.width ? { width: option.width } : { flex: 1, width: 0 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),(option.value === '_DETAILS')?[_c('div',{staticClass:"detail-container row-block flex-end"},[_c('div',{staticClass:"detail-content-container col-block width-full",style:({ flex: 1, width: 0 })},[_c('div',{staticClass:"detail-content-citation",attrs:{"title":data.citation}},[_vm._v(_vm._s(data.citation))]),_vm._v(" "),_c('div',{staticClass:"detail-content-title",attrs:{"title":data.title}},[_vm._v(_vm._s(data.title))])]),_vm._v(" "),_c('div',{staticClass:"detail-option-container col-block width-full"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"detail-display-abstract",class:{ active: _vm.detailIndex === data.index },on:{"click":function (e) { return _vm.detailIndex = data.index; }}},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.mastermindPublicationTable.table.info.details.___open')))])])])]:(option.value === '_PMID')?[_c('div',{staticClass:"pmid-container row-block"},[_c('div',{staticClass:"pmid"},[_vm._v(_vm._s(data.pmid))]),_vm._v(" "),_c('a',{attrs:{"href":'https://pubmed.ncbi.nlm.nih.gov/' + data.pmid,"target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("wtkH"),"alt":""}})])])]:[_c('div',{staticClass:"data-content",domProps:{"innerHTML":_vm._s(data[option.value] || option.empty || '- -')}})],_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)}),0),_vm._v(" "),(_vm.detailIndex === data.index)?_c('div',{staticClass:"data-detail-container col-block width-full"},[_c('div',{staticClass:"data-detail-hide-block row-block",on:{"click":function (e) { return _vm.detailIndex = null; }}},[_c('div',{staticClass:"data-detail-hide"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.mastermindPublicationTable.table.info.details.___hide')))]),_vm._v(" "),_c('div',{staticClass:"icon-block",style:({ '--size': '16px' })},[_c('img',{style:({ width: '11.2px' }),attrs:{"src":__webpack_require__("0Pmj"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"data-detail-block col-block width-full"},[_c('div',{staticClass:"data-detail"},[_vm._v(_vm._s(data.abstract))])])]):_vm._e()])}),0)]),_vm._v(" "),(_vm.pageData)?_c('div',{staticClass:"data-page-container row-block"},[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"data-page-total"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.mastermindPublicationTable.page.___total', { total: _vm.toPriceString(_vm.pageData.total) })))]),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-page-display"},[_vm._v(_vm._s(_vm.$t('COMPONENT.case.mastermindPublicationTable.page.___display', { display: _vm.pageData.display })))]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('pageButtons',{attrs:{"default":_vm.pageData.selectedPage,"display":_vm.pageData.display - 0,"total":_vm.pageData.total,"buttonRange":_vm.pageData.buttonRange},on:{"selectPage":function (page) { _vm.pageData.selectedPage = page }}})],1):_vm._e()]):_vm._e()}
var mastermindPublicationTable_staticRenderFns = []
var mastermindPublicationTable_esExports = { render: mastermindPublicationTable_render, staticRenderFns: mastermindPublicationTable_staticRenderFns }
/* harmony default export */ var case_mastermindPublicationTable = (mastermindPublicationTable_esExports);
// CONCATENATED MODULE: ./src/components/case/mastermindPublicationTable.vue
var mastermindPublicationTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var mastermindPublicationTable___vue_template_functional__ = false
/* styles */
var mastermindPublicationTable___vue_styles__ = null
/* scopeId */
var mastermindPublicationTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mastermindPublicationTable___vue_module_identifier__ = null
var mastermindPublicationTable_Component = mastermindPublicationTable_normalizeComponent(
  mastermindPublicationTable,
  case_mastermindPublicationTable,
  mastermindPublicationTable___vue_template_functional__,
  mastermindPublicationTable___vue_styles__,
  mastermindPublicationTable___vue_scopeId__,
  mastermindPublicationTable___vue_module_identifier__
)

/* harmony default export */ var components_case_mastermindPublicationTable = (mastermindPublicationTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/caseDetail/geneMastermindData.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var geneMastermindData = ({
  components: {
    mastermindPublicationTable: components_case_mastermindPublicationTable
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedPublication: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user']), {
    errorMessage: function errorMessage() {
      var unlockState = this.param.unlockState;
      if (!unlockState['project']) return this.$t('COMPONENT.caseDetail.geneMastermindData.___lockAlert');
      if (!unlockState['case'] && !['supervisor'].includes(this.user.role)) return this.$t('COMPONENT.caseDetail.geneMastermindData.___lockAlert');
    },

    // static
    tableOptionGroups: function tableOptionGroups() {
      var _this = this;

      var mastermind = {
        title: this.$t('COMPONENT.caseDetail.geneMastermindData.table.mastermind.___title'),
        options: [{
          title: this.$t('COMPONENT.caseDetail.geneMastermindData.table.mastermind.title.___report'),
          value: function value(mastermind, index, vindex, variants) {
            return _this.getMastermindIndex(mastermind, index, vindex, variants);
          },
          style: null,
          width: '60px',
          position: 'center',
          empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
        }, {
          title: this.$t('COMPONENT.caseDetail.geneMastermindData.table.mastermind.title.___classification'),
          value: function value(mastermind) {
            if (!mastermind.classification) return null;
            var classificationData = global_data["e" /* clinvarACMGMap */][(mastermind.classification[0].toUpperCase() + mastermind.classification.slice(1)).replace(/_/g, ' ')] || global_data["e" /* clinvarACMGMap */][mastermind.classification];
            return classificationData ? _this.$t(classificationData.title) : (mastermind.classification[0].toUpperCase() + mastermind.classification.slice(1)).replace(/_/g, ' ');
          },
          style: function style(mastermind) {
            if (!mastermind.classification) return null;
            var defaultStyles = { 'font-weight': 'bold' };
            var classificationData = global_data["e" /* clinvarACMGMap */][(mastermind.classification[0].toUpperCase() + mastermind.classification.slice(1)).replace(/_/g, ' ')] || global_data["e" /* clinvarACMGMap */][mastermind.classification];
            return extends_default()({}, defaultStyles, classificationData ? { color: classificationData.color } : null);
          },
          width: '232px',
          position: 'center',
          empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
        }, {
          title: this.$t('COMPONENT.caseDetail.geneMastermindData.table.mastermind.title.___variantIdentifiers'),
          value: function value(mastermind) {
            return mastermind.id;
          },
          style: null,
          position: 'center',
          empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
        }, {
          title: this.$t('COMPONENT.caseDetail.geneMastermindData.table.mastermind.title.___publications'),
          value: function value(mastermind) {
            if (!mastermind.pmid) return null;
            var pmidCount = mastermind.pmid.split(',').length;
            return _this.$tc('COMPONENT.caseDetail.geneMastermindData.table.mastermind.value.___publications', pmidCount, { count: pmidCount });
          },
          style: null,
          width: '292px',
          position: 'center',
          empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty),
          func: function func(mastermind, index, vindex, variants) {
            var mindex = _this.getMastermindIndex(mastermind, index, vindex, variants);
            var variant = variants[vindex];
            _this.setPublication(mastermind, mindex, variant);
          }
        }]
      };
      return [mastermind].filter(function (x) {
        return x;
      });
    },

    // param
    gene: function gene() {
      return this.param.gene;
    },
    variants: function variants() {
      var _this2 = this;

      return keys_default()(this.param.variants).map(function (vkey) {
        var variant = _this2.param.variants[vkey];
        var ids = (variant.Mastermind_MMID3 || []).filter(function (x) {
          return x;
        });
        var classifications = (variant.Mastermind_Classification || []).filter(function (x) {
          return x;
        });
        var pmids = (variant.Mastermind_PMID || []).filter(function (x) {
          return x;
        });
        return extends_default()({}, variant, {
          vkey: vkey,
          mastermindDatas: ids.length ? ids.map(function (_, index) {
            return { id: ids[index], classification: classifications[index], pmid: pmids[index] };
          }) : [{}]
        });
      });
    }
  }),
  created: function created() {
    if ((this.param.mastermind || {}).defaultPublication) {
      var index = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.variants.filter(function (variant) {
          return variant.mastermindDatas[0].id;
        })), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var variant = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(variant.mastermindDatas), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var mastermindData = _step2.value;

              index++;
              if (mastermindData.id === this.param.mastermind.defaultPublication) {
                this.setPublication(mastermindData, index, variant);
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModal2Action', 'setLoadingAction']), {
    getMastermindIndex: function getMastermindIndex(mastermind, index, vindex, variants) {
      if (!mastermind.id) return null;
      var mastermindCount = variants.slice(0, vindex).filter(function (variant) {
        return variant.mastermindDatas[0].id;
      }).reduce(function (count, variant) {
        return count + variant.mastermindDatas.length;
      }, 0);
      return mastermindCount + index + 1;
    },
    setPublication: function setPublication(mastermind, index, variant) {
      this.selectedPublication = { index: index, id: mastermind.id, pmids: mastermind.pmid.split(','), variant: [variant.Feature, variant.HGVSc].filter(function (x) {
          return x;
        }).join(':') || (variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -') };
    },
    unlockMastermind: function unlockMastermind() {
      var _this3 = this;

      var ownerName = [this.param.owner.first_name, this.param.owner.last_name].filter(function (x) {
        return x;
      }).join(' ') + '(' + this.param.owner.email + ')';
      var message = [this.$t('COMPONENT.caseDetail.geneMastermindData.modal.content.___unlockReanalyzeForOwner', { owner: ownerName }), this.$t('COMPONENT.caseDetail.geneMastermindData.modal.content.___unlockReanalyze'), this.$t('COMPONENT.caseDetail.geneMastermindData.modal.content.___unlockReloadForOwner', { owner: ownerName }), this.$t('COMPONENT.caseDetail.geneMastermindData.modal.content.___unlockReload')][(this.param.owner.id === this.user.id ? 1 : 0) + (this.param.unlockState['project'] ? 2 : 0)];
      this.setModal2Action({
        action: 'toast',
        width: '496px',
        customStyles: {
          padding: 0,
          border: 0
        },
        param: {
          type: 'normal',
          content: message,
          buttons: [{
            title: this.$t('COMMON.button.___cancel'),
            type: 'gray',
            result: false
          }, {
            title: this.$t('COMMON.button.___apply'),
            type: 'main',
            result: true
          }]
        },
        callback: function () {
          var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(result) {
            return regenerator_default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!result) {
                      _context.next = 5;
                      break;
                    }

                    _this3.setLoadingAction(true);
                    _context.next = 4;
                    return _this3.param.unlockMastermind();

                  case 4:
                    if (_this3.param.unlockState['project']) {
                      location.reload();
                    } else {
                      _this3.$emit('changeModal');
                      _this3.setLoadingAction(false);
                    }

                  case 5:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this3);
          }));

          return function callback(_x) {
            return _ref.apply(this, arguments);
          };
        }()
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cd81ffa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/caseDetail/geneMastermindData.vue
var geneMastermindData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-gene-mastermind-data-page col-block width-full",style:({ flex: 1 })},[(!_vm.errorMessage)?[_vm._l((_vm.variants),function(variant,vindex){return _c('div',{key:vindex,staticClass:"data-container col-block width-full"},[_c('div',{staticClass:"data-title-container row-block"},[_c('div',{staticClass:"data-title"},[_vm._v(_vm._s([variant.Feature, variant.HGVSc].filter(function (x) { return x; }).join(':') || (variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block width-full"},_vm._l((_vm.tableOptionGroups),function(optionGroup,gindex){return _c('div',{key:gindex,staticClass:"data-content-block col-block width-full"},[_c('div',{staticClass:"data-row-container col-block width-full"},[_c('div',{staticClass:"data-row row-block stretch"},_vm._l((optionGroup.options),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position],style:(option.width ? { width: option.width } : { flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content",domProps:{"innerHTML":_vm._s(option.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0),_vm._v(" "),_vm._l((variant.mastermindDatas),function(mastermind,mindex){return _c('div',{key:mindex,staticClass:"data-row row-block stretch"},_vm._l((optionGroup.options),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position],style:(option.width ? { width: option.width } : { flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content",class:{ link: option.value(mastermind, mindex, vindex, _vm.variants) && option.func },style:(option.style ? option.style(mastermind, mindex, vindex, _vm.variants) : {}),domProps:{"innerHTML":_vm._s(option.value(mastermind, mindex, vindex, _vm.variants) || option.empty || '- -')},on:{"click":function (e) { return (option.func || (function () {}))(mastermind, mindex, vindex, _vm.variants); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)})],2)])}),0)])}),_vm._v(" "),(_vm.selectedPublication)?_c('div',{staticClass:"publication-detail-container col-block width-full"},[_c('div',{staticClass:"publication-detail-title-container row-block"},[_c('div',{staticClass:"publication-detail-title",domProps:{"innerHTML":_vm._s(_vm.$t('COMPONENT.caseDetail.geneMastermindData.table.publication.___title', { count: _vm.selectedPublication.index, variant: _vm.selectedPublication.variant }))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('keep-alive',[_c('mastermindPublicationTable',{key:_vm.selectedPublication.id,attrs:{"pmids":_vm.selectedPublication.pmids}})],1)],1):_vm._e(),_vm._v(" "),_c('div',{style:({ height: 0 })})]:[_c('div',{staticClass:"mastermind-error-message"},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_c('div',{style:({ height: '20px' })})],_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),(Object.values(_vm.param.unlockState).some(function (state) { return state === false; }))?_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.unlockMastermind(); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___unlock')))])]):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var geneMastermindData_staticRenderFns = []
var geneMastermindData_esExports = { render: geneMastermindData_render, staticRenderFns: geneMastermindData_staticRenderFns }
/* harmony default export */ var caseDetail_geneMastermindData = (geneMastermindData_esExports);
// CONCATENATED MODULE: ./src/components/caseDetail/geneMastermindData.vue
var geneMastermindData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var geneMastermindData___vue_template_functional__ = false
/* styles */
var geneMastermindData___vue_styles__ = null
/* scopeId */
var geneMastermindData___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var geneMastermindData___vue_module_identifier__ = null
var geneMastermindData_Component = geneMastermindData_normalizeComponent(
  geneMastermindData,
  caseDetail_geneMastermindData,
  geneMastermindData___vue_template_functional__,
  geneMastermindData___vue_styles__,
  geneMastermindData___vue_scopeId__,
  geneMastermindData___vue_module_identifier__
)

/* harmony default export */ var components_caseDetail_geneMastermindData = (geneMastermindData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/caseDetail/geneMitomapData.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var geneMitomapData = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    gene: function gene() {
      return this.param.gene;
    },
    variants: function variants() {
      return this.param.variants;
    },

    // static
    tableOptionGroups: function tableOptionGroups() {
      var mitomap = {
        title: this.$t('COMPONENT.caseDetail.geneMitomapData.table.mitomap.___title'),
        options: [{
          title: this.$t('COMPONENT.caseDetail.geneMitomapData.table.mitomap.title.___af'),
          value: function value(variant) {
            return variant.mitomap_AF;
          },
          color: null,
          width: '70px',
          position: 'center',
          empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
        }, {
          title: this.$t('COMPONENT.caseDetail.geneMitomapData.table.mitomap.title.___heteroplasmy'),
          value: function value(variant) {
            return variant.mitomap_heteroplasmy;
          },
          color: null,
          width: '130px',
          position: 'center',
          empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
        }, {
          title: this.$t('COMPONENT.caseDetail.geneMitomapData.table.mitomap.title.___homoplasmy'),
          value: function value(variant) {
            return variant.mitomap_homoplasmy;
          },
          color: null,
          width: '130px',
          position: 'center',
          empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
        }, {
          title: this.$t('COMPONENT.caseDetail.geneMitomapData.table.mitomap.title.___diseaseStatus'),
          value: function value(variant) {
            return variant.mitomap_DiseaseStatus;
          },
          color: null,
          width: '250px',
          position: 'center',
          empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
        }, {
          title: this.$t('COMPONENT.caseDetail.geneMitomapData.table.mitomap.title.___disease'),
          value: function value(variant) {
            return variant.mitomap_Disease ? variant.mitomap_Disease.split('-/-').join(',<br>') : null;
          },
          color: null,
          position: 'left',
          empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
        }, {
          title: this.$t('COMPONENT.caseDetail.geneMitomapData.table.mitomap.title.___pubmedIDs'),
          value: function value(variant) {
            return variant.mitomap_PubmedIDs ? variant.mitomap_PubmedIDs.split(',').join(',<br>') : null;
          },
          color: null,
          width: '120px',
          position: 'center',
          empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
        }]
      };
      return [mitomap].filter(function (x) {
        return x;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02061fa0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/caseDetail/geneMitomapData.vue
var geneMitomapData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-gene-mitomap-data-page col-block width-full",style:({ flex: 1 })},[_vm._l((_vm.variants),function(variant,vindex){return _c('div',{key:vindex,staticClass:"data-container col-block width-full"},[_c('div',{staticClass:"data-title-container row-block"},[_c('div',{staticClass:"data-title"},[_vm._v(_vm._s(variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -'))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block width-full"},_vm._l((_vm.tableOptionGroups),function(optionGroup,gindex){return _c('div',{key:gindex,staticClass:"data-content-block col-block width-full"},[_c('div',{staticClass:"data-row-container col-block width-full"},[_c('div',{staticClass:"data-row row-block stretch"},_vm._l((optionGroup.options),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position],style:(option.width ? { width: option.width } : { flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content",domProps:{"innerHTML":_vm._s(option.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0),_vm._v(" "),_c('div',{staticClass:"data-row row-block stretch"},_vm._l((optionGroup.options),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position],style:(option.width ? { width: option.width } : { flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content",style:(option.color ? { color: option.color(variant) } : {}),domProps:{"innerHTML":_vm._s(option.value(variant) || option.empty || '- -')}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])])}),0)])}),_vm._v(" "),_c('div',{style:({ height: 0 })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var geneMitomapData_staticRenderFns = []
var geneMitomapData_esExports = { render: geneMitomapData_render, staticRenderFns: geneMitomapData_staticRenderFns }
/* harmony default export */ var caseDetail_geneMitomapData = (geneMitomapData_esExports);
// CONCATENATED MODULE: ./src/components/caseDetail/geneMitomapData.vue
var geneMitomapData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var geneMitomapData___vue_template_functional__ = false
/* styles */
var geneMitomapData___vue_styles__ = null
/* scopeId */
var geneMitomapData___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var geneMitomapData___vue_module_identifier__ = null
var geneMitomapData_Component = geneMitomapData_normalizeComponent(
  geneMitomapData,
  caseDetail_geneMitomapData,
  geneMitomapData___vue_template_functional__,
  geneMitomapData___vue_styles__,
  geneMitomapData___vue_scopeId__,
  geneMitomapData___vue_module_identifier__
)

/* harmony default export */ var components_caseDetail_geneMitomapData = (geneMitomapData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDetailGeneVariantDatabase.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var caseDetailGeneVariantDatabase = ({
  components: {
    geneClinvarData: components_caseDetail_geneClinvarData,
    geneMastermindData: components_caseDetail_geneMastermindData,
    geneMitomapData: components_caseDetail_geneMitomapData
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      tab: this.param.tab || 'clinvar'
    };
  },

  computed: {
    gene: function gene() {
      return this.param.gene || {};
    },

    // static
    tabOptions: function tabOptions() {
      var _this = this;

      var tabOptions = [{
        title: this.$t('DIALOG.caseDetailGeneVariantDatabase.tab.title.___clinvar'),
        value: 'clinvar'
      }, {
        title: this.$t('DIALOG.caseDetailGeneVariantDatabase.tab.title.___mastermind'),
        value: 'mastermind'
      }, {
        title: this.$t('DIALOG.caseDetailGeneVariantDatabase.tab.title.___MITOMAP'),
        value: 'mitomap',
        display: (this.gene.SYMBOL || '').startsWith('MT-')
      }].filter(function (option) {
        return option.display !== false && (!_this.param.tab || _this.param.tab === option.value);
      });
      var targetTab = tabOptions.find(function (option) {
        return option.value === _this.param.tab;
      });
      return targetTab ? [targetTab] : tabOptions;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad6e677","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDetailGeneVariantDatabase.vue
var caseDetailGeneVariantDatabase_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-gene-variant-database-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s([
        _vm.$t('DIALOG.caseDetailGeneVariantDatabase.___title'),
        (_vm.tabOptions.length === 1) ? _vm.tabOptions[0].title : null
      ].filter(function (x) { return x; }).join('-'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"data-container col-block",style:({ flex: 1 })},[(_vm.tabOptions.length > 1)?[_c('div',{staticClass:"data-tab-list-container row-block"},[_c('div',{staticClass:"data-tab-list-block row-block"},_vm._l((_vm.tabOptions),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-tab-field col-block width-full",class:{ active: option.value === _vm.tab },on:{"click":function (e) { return _vm.tab = option.value; }}},[_c('div',{staticClass:"data-tab-container center-block"},[_c('div',{staticClass:"data-tab-block row-block"},[_c('div',{staticClass:"data-tab-title"},[_vm._v(_vm._s(option.title))])])])])}),0),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '20px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block width-full",style:({ flex: 1 })},[(_vm.tab === 'clinvar')?[_c('geneClinvarData',{attrs:{"param":_vm.param},on:{"changeModal":function (data) { return _vm.$emit('changeModal', data); }}})]:(_vm.tab === 'mastermind')?[_c('geneMastermindData',{attrs:{"param":_vm.param},on:{"changeModal":function (data) { return _vm.$emit('changeModal', data); }}})]:_vm._e(),_vm._v(" "),(_vm.tab === 'mitomap')?[(_vm.tabOptions.some(function (option) { return option.value === 'mitomap'; }))?_c('geneMitomapData',{attrs:{"param":_vm.param},on:{"changeModal":function (data) { return _vm.$emit('changeModal', data); }}}):_vm._e()]:_vm._e()],2)],2)])}
var caseDetailGeneVariantDatabase_staticRenderFns = []
var caseDetailGeneVariantDatabase_esExports = { render: caseDetailGeneVariantDatabase_render, staticRenderFns: caseDetailGeneVariantDatabase_staticRenderFns }
/* harmony default export */ var dialog_caseDetailGeneVariantDatabase = (caseDetailGeneVariantDatabase_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDetailGeneVariantDatabase.vue
var caseDetailGeneVariantDatabase_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDetailGeneVariantDatabase___vue_template_functional__ = false
/* styles */
var caseDetailGeneVariantDatabase___vue_styles__ = null
/* scopeId */
var caseDetailGeneVariantDatabase___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDetailGeneVariantDatabase___vue_module_identifier__ = null
var caseDetailGeneVariantDatabase_Component = caseDetailGeneVariantDatabase_normalizeComponent(
  caseDetailGeneVariantDatabase,
  dialog_caseDetailGeneVariantDatabase,
  caseDetailGeneVariantDatabase___vue_template_functional__,
  caseDetailGeneVariantDatabase___vue_styles__,
  caseDetailGeneVariantDatabase___vue_scopeId__,
  caseDetailGeneVariantDatabase___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDetailGeneVariantDatabase = (caseDetailGeneVariantDatabase_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/caseDetail/geneQualityData.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var geneQualityData = ({
  props: {
    caseData: {
      type: Object,
      required: true
    },
    isFamily: {
      type: Boolean,
      required: true
    },
    gene: {
      type: Object,
      required: true
    },
    variant: {
      type: Object,
      required: true
    },
    coverages: {
      type: Object,
      required: true
    },
    sampleAllelegts: {
      type: Object,
      required: true
    }
  },
  computed: {
    qualityDatas: function qualityDatas() {
      var _this = this;

      var sampleAllelegt = this.sampleAllelegts[[this.variant.CHROM, this.variant.POS, this.variant.REF, this.variant.ALT].join(':')] || [];
      sampleAllelegt = sampleAllelegt.reduce(function (result, data) {
        return data.sample ? extends_default()({}, result, defineProperty_default()({}, data.sample, { 'GT': data.gt, 'GT_raw': data.gt, 'RefAlt': data.refalt })) : result;
      }, {});
      var qualityDatas = this.isFamily ? (this.variant.fam_info || []).map(function (data) {
        return extends_default()({}, data, sampleAllelegt[data.sample_id || data.sample_number] || {});
      }) : [this.variant];
      return qualityDatas.map(function (qualityData) {
        return extends_default()({}, qualityData, {
          GT_result: Object(global_data["q" /* getGTType */])(qualityData.GT_raw, _this.variant.CHROM, _this.caseData.sex)
        });
      });
    },

    // static
    tableOption: function tableOption() {
      var familyOptions = this.isFamily ? [{
        title: this.$t('DIALOG.caseDetailGeneQuality.table.family.title.___case_id'),
        value: 'case_id',
        color: function color(_, data) {
          return data.phenotype === 1 ? '#333333' : '#FA3D3D';
        },
        width: null,
        position: 'center',
        break: true,
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailGeneQuality.table.family.title.___relation'),
        value: 'relation',
        color: function color() {
          return '#003679';
        },
        width: '110px',
        position: 'center',
        break: true,
        display: function display(value) {
          return value ? value.replace(/ /g, '<br>') : null;
        },
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailGeneQuality.table.family.title.___ra'),
        value: 'RefAlt',
        color: null,
        width: '90px',
        position: 'center',
        break: true,
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }] : [];
      var singleOptions = (this.gene.SYMBOL || '').startsWith('MT-') ? [{
        title: this.$t('DIALOG.caseDetailGeneQuality.table.mt.title.___readDepth'),
        value: 'readDepth',
        color: null,
        width: '195px',
        info: false,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailGeneQuality.table.mt.title.___alleleFractions'),
        value: 'alleleFractions',
        color: null,
        width: '195px',
        info: false,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailGeneQuality.table.mt.title.___geneCoverage'),
        value: 'geneCoverage',
        color: null,
        width: '170px',
        options: [{ title: this.$t('DIALOG.caseDetailGeneQuality.table.mt.option.geneCoverage.___x2000Cov'), value: 'x2000_cov' }, { title: this.$t('DIALOG.caseDetailGeneQuality.table.mt.option.geneCoverage.___x3000Cov'), value: 'x3000_cov' }],
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }] : [{
        title: this.$t('DIALOG.caseDetailGeneQuality.table.default.title.___genotype'),
        value: 'genotype',
        color: null,
        width: '90px',
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailGeneQuality.table.default.title.___readDepth'),
        value: 'readDepth',
        color: null,
        width: '195px',
        info: true,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailGeneQuality.table.default.title.___alleleFractions'),
        value: 'alleleFractions',
        color: null,
        width: '195px',
        info: true,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailGeneQuality.table.default.title.___genotypeQuality'),
        value: 'genotypeQuality',
        color: null,
        width: '175px',
        info: true,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailGeneQuality.table.default.title.___geneCoverage'),
        value: 'geneCoverage',
        color: null,
        width: '170px',
        options: [{ title: this.$t('DIALOG.caseDetailGeneQuality.table.default.option.geneCoverage.___x10Cov'), value: 'x10_cov' }, { title: this.$t('DIALOG.caseDetailGeneQuality.table.default.option.geneCoverage.___x20Cov'), value: 'x20_cov' }],
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }];
      return [].concat(familyOptions, singleOptions);
    },

    // global
    fixNumber: function fixNumber() {
      return util["g" /* fixNumber */];
    }
  },
  methods: {
    getAlleleResult: function getAlleleResult(qualityData) {
      var GT_AF = qualityData.GT_AF || 0;
      return (GT_AF < 0.25 || GT_AF >= 0.85) && ['het'].includes(qualityData.GT_result) || GT_AF < 0.9 && ['homo', 'hemi', 'ref'].includes(qualityData.GT_result) || GT_AF > 0.1 && ['ref_hemi'].includes(qualityData.GT_result);
    },
    getCovGene: function getCovGene(variant) {
      var codingExon = (['Proband', undefined].includes(variant.relation) ? this.coverages['coding_exon'] : (this.coverages['fam_codin_exon'] || {})[variant.case_id]) || {};
      var allExon = (['Proband', undefined].includes(variant.relation) ? this.coverages['all_exon'] : (this.coverages['fam_all_exon'] || {})[variant.case_id]) || {};
      var result = ((codingExon[this.gene.SYMBOL || ''] || {}).transcripts || {})[(variant.Feature || '').replace(/\.\d$/, '')] || ((allExon[this.gene.SYMBOL || ''] || {}).transcripts || {})[(variant.Feature || '').replace(/\.\d$/, '')] || {};
      return result || {};
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b8a1a53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/caseDetail/geneQualityData.vue
var geneQualityData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-gene-quality-data-page col-block flex-start",class:{ 'width-full': !_vm.isFamily }},[_c('div',{staticClass:"data-content-block col-block"},[_c('div',{staticClass:"data-row row-block stretch"},_vm._l((_vm.tableOption),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position],style:((option.width && _vm.isFamily) ? { width: option.width } : { flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content",domProps:{"innerHTML":_vm._s(option.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0),_vm._v(" "),_vm._l((_vm.qualityDatas),function(qualityData,qdindex){return _c('div',{key:qdindex,staticClass:"data-row row-block stretch"},_vm._l((_vm.tableOption),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position],style:((option.width && _vm.isFamily) ? { width: option.width } : { flex: 1, width: 0 })},[(_vm.isFamily)?_c('div',{style:({ flex: 1 })}):_vm._e(),_vm._v(" "),(option.value === 'genotype'  && ![null, undefined].includes(qualityData.GT))?_c('div',{staticClass:"data-content quality-col genotype-container col-block",class:{ alert: false }},[_c('div',{staticClass:"quality-value-block row-block"},[_c('div',{staticClass:"quality-value"},[_vm._v(_vm._s(qualityData.GT_raw || qualityData.GT || 'N/A'))])])]):(option.value === 'readDepth' && ![null, undefined].includes(qualityData.DP))?_c('div',{staticClass:"data-content quality-col readDepth-container col-block",class:{ alert: option.info && (qualityData.DP || 0) < 10 }},[_c('div',{staticClass:"quality-value-block row-block"},[_c('div',{staticClass:"quality-value"},[_vm._v(_vm._s(qualityData.DP || 0))])]),_vm._v(" "),(option.info)?[_c('div',{style:({ height: '0px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info-block row-block"},[_c('img',{style:({ width: '16px' }),attrs:{"src":__webpack_require__("6v0c")("./quality-" + ((qualityData.DP || 0) < 10 ? 'nopass' : 'pass') + '-info-icon.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info",domProps:{"innerHTML":_vm._s((qualityData.DP || 0) < 10 ? _vm.$t('DIALOG.caseDetailGeneQuality.pass.readDepth.___noPass') : _vm.$t('DIALOG.caseDetailGeneQuality.pass.readDepth.___pass'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]:_vm._e()],2):(option.value === 'alleleFractions' && ![null, undefined].includes(qualityData.GT_AF))?_c('div',{staticClass:"data-content quality-col alleleFractions-container col-block",class:{ alert: option.info && _vm.getAlleleResult(qualityData) }},[_c('div',{staticClass:"quality-value-block row-block"},[_c('div',{staticClass:"quality-value"},[_vm._v(_vm._s(qualityData.GT_AF ? qualityData.GT_AF.toFixed(3).replace(/0+$/, '').replace(/\.$/, '') : 0))]),_vm._v(" "),_c('div',{style:({ width: '3px' })}),_vm._v(" "),_c('div',{staticClass:"quality-desc"},[_vm._v(_vm._s('(REF:' + (qualityData.RD || 0) + ' | ALT:' + (qualityData.AD || 0) + ')'))])]),_vm._v(" "),(option.info)?[_c('div',{style:({ height: '0px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info-block row-block"},[_c('img',{style:({ width: '16px' }),attrs:{"src":__webpack_require__("6v0c")("./quality-" + (_vm.getAlleleResult(qualityData) ? 'nopass' : 'pass') + '-info-icon.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info",domProps:{"innerHTML":_vm._s(_vm.getAlleleResult(qualityData) ? _vm.$t('DIALOG.caseDetailGeneQuality.pass.alleleFractions.___noPass') : _vm.$t('DIALOG.caseDetailGeneQuality.pass.alleleFractions.___pass'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]:_vm._e()],2):(option.value === 'genotypeQuality' && ![null, undefined].includes(qualityData.GQ))?_c('div',{staticClass:"data-content quality-col genotypeQuality-container col-block",class:{ alert: option.info && (qualityData.GQ || 0) < 20 }},[_c('div',{staticClass:"quality-value-block row-block"},[_c('div',{staticClass:"quality-value"},[_vm._v(_vm._s(qualityData.GQ || 0))])]),_vm._v(" "),(option.info)?[_c('div',{style:({ height: '0px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info-block row-block"},[_c('img',{style:({ width: '16px' }),attrs:{"src":__webpack_require__("6v0c")("./quality-" + ((qualityData.GQ || 0) < 20 ? 'nopass' : 'pass') + '-info-icon.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info",domProps:{"innerHTML":_vm._s((qualityData.GQ || 0) < 20 ? _vm.$t('DIALOG.caseDetailGeneQuality.pass.genotypeQuality.___noPass') : _vm.$t('DIALOG.caseDetailGeneQuality.pass.genotypeQuality.___pass'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]:_vm._e()],2):(option.value === 'geneCoverage')?_c('div',{staticClass:"data-content quality-col geneCoverage-container col-block",class:{ alert: false }},[(Object.keys(_vm.getCovGene(qualityData)).length)?_vm._l((option.options || []),function(option,index){return _c('div',{key:index,staticClass:"quality-value-block row-block"},[_c('div',{staticClass:"quality-value"},[_vm._v(_vm._s(option.title + ': ' + _vm.fixNumber(_vm.getCovGene(qualityData)[option.value] * 100, 0.01) + '%'))])])}):[_c('div',{staticClass:"quality-value-block row-block"},[_c('div',{staticClass:"quality-value"},[_vm._v(_vm._s('- -'))])]),_vm._v(" "),(!_vm.isFamily)?[_c('div',{style:({ height: '0px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info-block row-block"},[_c('img',{style:({ width: '16px', opacity: 0 }),attrs:{"src":__webpack_require__("i1qd"),"alt":""}})])]:_vm._e()]],2):_c('div',{staticClass:"data-content",class:[option.break ? 'break-line' : 'ellipsis'],style:(option.color ? { color: option.color(qualityData[option.value], qualityData) } : {}),attrs:{"title":qualityData[option.value]},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(qualityData[option.value], qualityData) || option.empty || '- -')}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)})],2)])}
var geneQualityData_staticRenderFns = []
var geneQualityData_esExports = { render: geneQualityData_render, staticRenderFns: geneQualityData_staticRenderFns }
/* harmony default export */ var caseDetail_geneQualityData = (geneQualityData_esExports);
// CONCATENATED MODULE: ./src/components/caseDetail/geneQualityData.vue
var geneQualityData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var geneQualityData___vue_template_functional__ = false
/* styles */
var geneQualityData___vue_styles__ = null
/* scopeId */
var geneQualityData___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var geneQualityData___vue_module_identifier__ = null
var geneQualityData_Component = geneQualityData_normalizeComponent(
  geneQualityData,
  caseDetail_geneQualityData,
  geneQualityData___vue_template_functional__,
  geneQualityData___vue_styles__,
  geneQualityData___vue_scopeId__,
  geneQualityData___vue_module_identifier__
)

/* harmony default export */ var components_caseDetail_geneQualityData = (geneQualityData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDetailGeneQuality.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var caseDetailGeneQuality = ({
  components: {
    geneQualityData: components_caseDetail_geneQualityData
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    // param
    caseData: function caseData() {
      return this.param.caseData;
    },
    project: function project() {
      return this.param.project;
    },
    gene: function gene() {
      return this.param.gene;
    },
    variants: function variants() {
      return this.param.variants;
    },
    coverages: function coverages() {
      return this.param.coverages;
    },
    sampleAllelegts: function sampleAllelegts() {
      return this.param.sampleAllelegts;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73665a20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDetailGeneQuality.vue
var caseDetailGeneQuality_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-gene-quality-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneQuality.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_vm._l((_vm.variants),function(variant,vkey,vindex){return _c('div',{key:vindex,staticClass:"data-container col-block"},[_c('div',{staticClass:"data-title-container row-block"},[_c('div',{staticClass:"data-title"},[_vm._v(_vm._s(variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -'))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block flex-start width-full"},[_c('geneQualityData',{attrs:{"isFamily":_vm.gene.dataType === 'monitor' ? !!variant.fam_info : _vm.project.fam_analyze,"caseData":_vm.caseData,"gene":_vm.gene,"variant":variant,"coverages":_vm.coverages,"sampleAllelegts":_vm.sampleAllelegts}})],1)])}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var caseDetailGeneQuality_staticRenderFns = []
var caseDetailGeneQuality_esExports = { render: caseDetailGeneQuality_render, staticRenderFns: caseDetailGeneQuality_staticRenderFns }
/* harmony default export */ var dialog_caseDetailGeneQuality = (caseDetailGeneQuality_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDetailGeneQuality.vue
var caseDetailGeneQuality_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDetailGeneQuality___vue_template_functional__ = false
/* styles */
var caseDetailGeneQuality___vue_styles__ = null
/* scopeId */
var caseDetailGeneQuality___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDetailGeneQuality___vue_module_identifier__ = null
var caseDetailGeneQuality_Component = caseDetailGeneQuality_normalizeComponent(
  caseDetailGeneQuality,
  dialog_caseDetailGeneQuality,
  caseDetailGeneQuality___vue_template_functional__,
  caseDetailGeneQuality___vue_styles__,
  caseDetailGeneQuality___vue_scopeId__,
  caseDetailGeneQuality___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDetailGeneQuality = (caseDetailGeneQuality_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/caseDetail/genePreviewDisplayForm.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var genePreviewDisplayForm = ({
  props: {
    defaultDatas: {
      type: Array,
      required: true
    },
    displayType: {
      type: String,
      required: true
    },
    variants: {
      type: Object,
      required: true
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user']), {
    selectedMap: function selectedMap() {
      var _this = this;

      return this.mainFormOptions.map(function (option) {
        var disabledDatas = [].concat(toConsumableArray_default()(_this.defaultDatas));
        var selectedDatas = disabledDatas.splice(option.index, 1);
        return {
          selected: selectedDatas,
          disabled: disabledDatas
        };
      });
    },
    previewSelectOptions: function previewSelectOptions() {
      var _this2 = this;

      var previewSelectOptions = global_data["P" /* reportPreviewOptions */][this.displayType].filter(function (option) {
        return !option.old && option.displayForm && (option.displayDisplay || function () {
          return true;
        })(_this2.variants, _this2.user);
      });
      previewSelectOptions = {
        options: previewSelectOptions,
        categoryOptions: Object(util["i" /* groupBy */])(previewSelectOptions, function (categoryOption) {
          return categoryOption.displayCategory || categoryOption.category;
        }).map(function (groupOptions) {
          return {
            title: groupOptions[0].displayCategory || groupOptions[0].category,
            options: groupOptions,
            groupOptions: Object(util["i" /* groupBy */])(groupOptions, function (groupOption) {
              return groupOption.displayGroup || groupOption.group;
            }).map(function (formOptions) {
              return {
                title: formOptions[0].displayGroup || formOptions[0].group,
                options: formOptions
              };
            })
          };
        })
      };
      return previewSelectOptions;
    },

    // static
    mainFormOptions: function mainFormOptions() {
      return [{
        title: this.$t('COMPONENT.caseDetail.genePreviewDisplayForm.mainFormOptions.title.___1st'),
        index: 0
      }, {
        title: this.$t('COMPONENT.caseDetail.genePreviewDisplayForm.mainFormOptions.title.___2nd'),
        index: 1
      }];
    }
  }),
  methods: {
    setResultDatas: function setResultDatas(key, index) {
      var resultDatas = [].concat(toConsumableArray_default()(this.defaultDatas));
      resultDatas[index] = key;
      this.$emit('dataUpdate', resultDatas);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e55073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/caseDetail/genePreviewDisplayForm.vue
var genePreviewDisplayForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-data-list-gene-preview-display-form-page col-block width-full",style:({ flex: 1 })},_vm._l((_vm.mainFormOptions),function(mainFormOption,mfoindex){return _c('div',{key:mfoindex,staticClass:"preview-main-container col-block width-full"},[_c('div',{staticClass:"preview-main-title-container row-block"},[_c('div',{staticClass:"preview-main-title-block row-block"},[_c('div',{staticClass:"preview-main-title"},[_vm._v(_vm._s(mainFormOption.title))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"preview-category-container col-block width-full"},_vm._l((_vm.previewSelectOptions.categoryOptions),function(categoryOption,coindex){return _c('div',{key:coindex,staticClass:"preview-category-block col-block width-full"},[(categoryOption.title !== '__DEFAULT')?_c('div',{staticClass:"preview-category-title-container row-block"},[_c('div',{staticClass:"preview-category-title-block row-block"},[_c('div',{staticClass:"preview-category-title"},[_vm._v(_vm._s(_vm.$t(categoryOption.title)))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"preview-category-group-container col-block width-full"},_vm._l((categoryOption.groupOptions),function(groupOption,goindex){return _c('div',{key:goindex,staticClass:"preview-category-group-block row-block stretch"},[(groupOption.title !== '__DEFAULT')?_c('div',{staticClass:"preview-category-group-cell-container title row-block",style:({ width: '146px' })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"preview-category-group-cell-block row-block"},[_c('div',{staticClass:"preview-category-group-cell break-line"},[_vm._v(_vm._s(_vm.$t(groupOption.title)))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"preview-category-group-cell-container row-block",style:({ flex: 1 })},[_c('div',{staticClass:"preview-category-group-form-list-container row-block flex-start flex-wrap"},_vm._l((groupOption.options),function(formOption,foindex){return _c('div',{key:foindex,staticClass:"preview-category-group-form-container row-block",class:{ disabled: _vm.selectedMap[mainFormOption.index]['disabled'].includes(formOption.key) },on:{"click":function (e) { return !e.currentTarget.className.split(' ').includes('disabled') && _vm.setResultDatas(formOption.key, mainFormOption.index); }}},[_c('div',{staticClass:"preview-category-group-form-mask"}),_vm._v(" "),_c('img',{attrs:{"src":_vm.selectedMap[mainFormOption.index]['selected'].includes(formOption.key) ? __webpack_require__("xccc") : __webpack_require__("z0Pm")}}),_vm._v(" "),_c('div',{staticClass:"preview-category-group-form-title"},[_vm._v(_vm._s(_vm.$t(formOption.title)))])])}),0)])])}),0)])}),0)])}),0)}
var genePreviewDisplayForm_staticRenderFns = []
var genePreviewDisplayForm_esExports = { render: genePreviewDisplayForm_render, staticRenderFns: genePreviewDisplayForm_staticRenderFns }
/* harmony default export */ var caseDetail_genePreviewDisplayForm = (genePreviewDisplayForm_esExports);
// CONCATENATED MODULE: ./src/components/caseDetail/genePreviewDisplayForm.vue
var genePreviewDisplayForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var genePreviewDisplayForm___vue_template_functional__ = false
/* styles */
var genePreviewDisplayForm___vue_styles__ = null
/* scopeId */
var genePreviewDisplayForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var genePreviewDisplayForm___vue_module_identifier__ = null
var genePreviewDisplayForm_Component = genePreviewDisplayForm_normalizeComponent(
  genePreviewDisplayForm,
  caseDetail_genePreviewDisplayForm,
  genePreviewDisplayForm___vue_template_functional__,
  genePreviewDisplayForm___vue_styles__,
  genePreviewDisplayForm___vue_scopeId__,
  genePreviewDisplayForm___vue_module_identifier__
)

/* harmony default export */ var components_caseDetail_genePreviewDisplayForm = (genePreviewDisplayForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/caseDetail/genePreviewSelectForm.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var genePreviewSelectForm = ({
  props: {
    defaultDatas: {
      type: Array,
      required: true
    },
    displayType: {
      type: String,
      required: true
    },
    variants: {
      type: Object,
      required: true
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user']), {
    selectedMap: function selectedMap() {
      return this.defaultDatas.reduce(function (map, key) {
        return extends_default()({}, map, defineProperty_default()({}, key, true));
      }, {});
    },
    selectedDatas: function selectedDatas() {
      var _this = this;

      var selectedDatas = this.previewSelectOptions.options.filter(function (option) {
        return _this.selectedMap[option.key];
      });
      this.$emit('update', selectedDatas);
      return selectedDatas;
    },
    selectedRange: function selectedRange() {
      return global_data["Q" /* reportPreviewRangeData */][this.displayType];
    },
    groupSelect: function groupSelect() {
      return {
        'ps': false,
        'pd': true
      }[this.displayType];
    },
    previewSelectOptions: function previewSelectOptions() {
      var _this2 = this;

      var previewSelectOptions = global_data["P" /* reportPreviewOptions */][this.displayType].filter(function (option) {
        return !option.old && (option.selectDisplay || function () {
          return true;
        })(_this2.variants, _this2.user);
      });
      previewSelectOptions = {
        options: previewSelectOptions,
        categoryOptions: Object(util["i" /* groupBy */])(previewSelectOptions, function (categoryOption) {
          return categoryOption.category;
        }).map(function (groupOptions) {
          return {
            title: groupOptions[0].category,
            options: groupOptions,
            optionCount: groupOptions.length,
            selectCount: groupOptions.reduce(function (count, groupOption) {
              return count + (_this2.selectedMap[groupOption.key] ? 1 : 0);
            }, 0),
            groupOptions: Object(util["i" /* groupBy */])(groupOptions, function (groupOption) {
              return groupOption.group;
            }).map(function (formOptions) {
              return {
                title: formOptions[0].group,
                options: formOptions
              };
            })
          };
        })
      };
      return previewSelectOptions;
    }
  }),
  methods: {
    setResultDatas: function setResultDatas(datas) {
      var _this3 = this;

      var resultDatas = [].concat(toConsumableArray_default()(this.defaultDatas));
      var dataKeys = datas.map(function (data) {
        return data.key;
      });
      resultDatas = dataKeys.every(function (key) {
        return _this3.selectedMap[key];
      }) ? resultDatas.filter(function (resultData) {
        return !dataKeys.includes(resultData);
      }) : resultDatas.concat(dataKeys).filter(function (x, i, s) {
        return s.indexOf(x) === i;
      });
      this.$emit('dataUpdate', resultDatas);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c66d22e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/caseDetail/genePreviewSelectForm.vue
var genePreviewSelectForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-data-list-gene-preview-select-form-page col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"preview-main-container col-block width-full"},[_c('div',{staticClass:"preview-category-container col-block width-full"},_vm._l((_vm.previewSelectOptions.categoryOptions),function(categoryOption,coindex){return _c('div',{key:coindex,staticClass:"preview-category-block col-block width-full"},[(categoryOption.title !== '__DEFAULT')?_c('div',{staticClass:"preview-category-title-container row-block"},[_c('div',{staticClass:"preview-category-title-block row-block",class:{
              selectable: _vm.groupSelect,
              disabled: _vm.groupSelect && (
                (categoryOption.selectCount === categoryOption.optionCount) && ((_vm.selectedDatas.length - categoryOption.optionCount) < _vm.selectedRange[0]) ||
                (categoryOption.selectCount !== categoryOption.optionCount) && ((_vm.selectedDatas.length + (categoryOption.optionCount - categoryOption.selectCount)) > _vm.selectedRange[1])
              )
            },on:{"click":function (e) { return !e.currentTarget.className.split(' ').includes('disabled') && _vm.groupSelect && _vm.setResultDatas(categoryOption.options); }}},[(_vm.groupSelect)?[_c('div',{staticClass:"preview-category-title-mask"}),_vm._v(" "),_c('img',{attrs:{"src":categoryOption.selectCount ? (categoryOption.selectCount === categoryOption.optionCount) ? __webpack_require__("7kqe") : __webpack_require__("Z77G") : __webpack_require__("5Ivo")}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"preview-category-title"},[_vm._v(_vm._s(_vm.$t(categoryOption.title)))])],2),_vm._v(" "),_c('div',{style:({ flex: 1 })})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"preview-category-group-container col-block width-full",class:{ group: _vm.groupSelect }},_vm._l((categoryOption.groupOptions),function(groupOption,goindex){return _c('div',{key:goindex,staticClass:"preview-category-group-block row-block stretch"},[(groupOption.title !== '__DEFAULT')?_c('div',{staticClass:"preview-category-group-cell-container title row-block",style:({ width: '146px' })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"preview-category-group-cell-block row-block"},[_c('div',{staticClass:"preview-category-group-cell break-line"},[_vm._v(_vm._s(_vm.$t(groupOption.title)))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"preview-category-group-cell-container row-block",style:({ flex: 1 })},[_c('div',{staticClass:"preview-category-group-form-list-container row-block flex-start flex-wrap"},_vm._l((groupOption.options),function(formOption,foindex){return _c('div',{key:foindex,staticClass:"preview-category-group-form-container row-block",class:{
                    disabled: (
                      _vm.selectedMap[formOption.key] && (_vm.selectedDatas.length <= _vm.selectedRange[0]) ||
                      !_vm.selectedMap[formOption.key] && (_vm.selectedDatas.length >= _vm.selectedRange[1])
                    )
                  },on:{"click":function (e) { return !e.currentTarget.className.split(' ').includes('disabled') && _vm.setResultDatas([formOption]); }}},[_c('div',{staticClass:"preview-category-group-form-mask"}),_vm._v(" "),_c('img',{attrs:{"src":_vm.selectedMap[formOption.key] ? __webpack_require__("7kqe") : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"preview-category-group-form-title"},[_vm._v(_vm._s(_vm.$t(formOption.title)))])])}),0)])])}),0)])}),0)])])}
var genePreviewSelectForm_staticRenderFns = []
var genePreviewSelectForm_esExports = { render: genePreviewSelectForm_render, staticRenderFns: genePreviewSelectForm_staticRenderFns }
/* harmony default export */ var caseDetail_genePreviewSelectForm = (genePreviewSelectForm_esExports);
// CONCATENATED MODULE: ./src/components/caseDetail/genePreviewSelectForm.vue
var genePreviewSelectForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var genePreviewSelectForm___vue_template_functional__ = false
/* styles */
var genePreviewSelectForm___vue_styles__ = null
/* scopeId */
var genePreviewSelectForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var genePreviewSelectForm___vue_module_identifier__ = null
var genePreviewSelectForm_Component = genePreviewSelectForm_normalizeComponent(
  genePreviewSelectForm,
  caseDetail_genePreviewSelectForm,
  genePreviewSelectForm___vue_template_functional__,
  genePreviewSelectForm___vue_styles__,
  genePreviewSelectForm___vue_scopeId__,
  genePreviewSelectForm___vue_module_identifier__
)

/* harmony default export */ var components_caseDetail_genePreviewSelectForm = (genePreviewSelectForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/caseDetail/genePreviewResult.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var genePreviewResult = ({
  props: {
    defaultDatas: {
      type: Array,
      required: true
    },
    displayType: {
      type: String,
      required: true
    },
    variant: {
      type: Object,
      required: true
    },
    gene: {
      type: Object,
      required: true
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user']), {
    displayAll: function displayAll() {
      return {
        'ps': true,
        'pd': false
      }[this.displayType];
    },
    selectedMap: function selectedMap() {
      return this.defaultDatas.reduce(function (map, key) {
        return extends_default()({}, map, defineProperty_default()({}, key, true));
      }, {});
    },
    previewSelectOptions: function previewSelectOptions() {
      var _this = this;

      var previewSelectOptions = global_data["P" /* reportPreviewOptions */][this.displayType].filter(function (option) {
        return !option.old && (option.resultDisplay || function () {
          return true;
        })(_this.variant, _this.user) && (_this.displayAll || _this.selectedMap[option.key]);
      });
      previewSelectOptions = {
        options: previewSelectOptions,
        categoryOptions: Object(util["i" /* groupBy */])(previewSelectOptions, function (categoryOption) {
          return categoryOption.resultCategory || categoryOption.category;
        }).map(function (groupOptions) {
          return {
            title: groupOptions[0].resultCategory || groupOptions[0].category,
            options: groupOptions,
            groupOptions: Object(util["i" /* groupBy */])(groupOptions, function (groupOption) {
              return groupOption.resultGroup || groupOption.group;
            }).map(function (formOptions) {
              return {
                title: formOptions[0].resultGroup || formOptions[0].group,
                options: formOptions
              };
            })
          };
        })
      };
      return previewSelectOptions;
    }
  }),
  methods: {
    valueMap: function valueMap(value) {
      return value || value === 0 ? value : value === null || value === '' ? this.$t(global_data["m" /* defaultEmptyDisplay */].empty) : this.$t(global_data["m" /* defaultEmptyDisplay */].noKey);
    },
    localeMap: function localeMap(value) {
      return value && (value + '').startsWith('CONSTANT.global.data') ? this.$t(value) : value;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef4635e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/caseDetail/genePreviewResult.vue
var genePreviewResult_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-data-list-gene-preview-result-page col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"preview-main-container col-block width-full"},[_c('div',{staticClass:"preview-category-container col-block width-full"},_vm._l((_vm.previewSelectOptions.categoryOptions),function(categoryOption,coindex){return _c('div',{key:coindex,staticClass:"preview-category-block col-block width-full"},[(categoryOption.title !== '__DEFAULT')?_c('div',{staticClass:"preview-category-title-container row-block"},[_c('div',{staticClass:"preview-category-title-block row-block"},[_c('div',{staticClass:"preview-category-title"},[_vm._v(_vm._s(_vm.$t(categoryOption.title)))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"preview-category-group-container col-block width-full"},_vm._l((categoryOption.groupOptions),function(groupOption,goindex){return _c('div',{key:goindex,staticClass:"preview-category-group-block col-block width-full"},[(groupOption.title !== '__DEFAULT')?_c('div',{staticClass:"preview-category-group-title-container row-block"},[_c('div',{staticClass:"preview-category-group-title-block row-block"},[_c('div',{staticClass:"preview-category-group-title"},[_vm._v(_vm._s(_vm.$t(groupOption.title)))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"preview-category-group-content-list-container row-block flex-start flex-wrap stretch"},_vm._l((groupOption.options),function(formOption,foindex){return _c('div',{key:foindex,staticClass:"preview-category-group-content-container col-block stretch",style:({ width: formOption.long ? '18.75%' : '12.5%' })},[_c('div',{staticClass:"preview-category-group-content-block center-block title",style:({ flex: 1 })},[_c('div',{staticClass:"preview-category-group-content"},[_vm._v(_vm._s(_vm.$t(formOption.title)))])]),_vm._v(" "),_c('div',{staticClass:"preview-category-group-content-block col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),(formOption.value)?_c('div',{staticClass:"preview-category-group-content ellipsis",class:formOption.class(formOption.value(_vm.variant, _vm.gene), _vm.variant, _vm.gene),attrs:{"title":_vm.localeMap((formOption.hover || formOption.value)(_vm.variant, _vm.gene))}},[_vm._v(_vm._s(_vm.valueMap(_vm.localeMap(formOption.value(_vm.variant, _vm.gene)))))]):_vm._e(),_vm._v(" "),(formOption.link)?_c('a',{staticClass:"preview-category-group-content-link-container row-block",attrs:{"href":formOption.link.url(_vm.variant, _vm.gene),"target":"_blank"}},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('a',{staticClass:"preview-category-group-content-link link break-line shrink"},[_vm._v(_vm._s(_vm.$t(formOption.link.title)))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("wtkH"),"alt":""}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}),0)])}),0)])}),0)])])}
var genePreviewResult_staticRenderFns = []
var genePreviewResult_esExports = { render: genePreviewResult_render, staticRenderFns: genePreviewResult_staticRenderFns }
/* harmony default export */ var caseDetail_genePreviewResult = (genePreviewResult_esExports);
// CONCATENATED MODULE: ./src/components/caseDetail/genePreviewResult.vue
var genePreviewResult_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var genePreviewResult___vue_template_functional__ = false
/* styles */
var genePreviewResult___vue_styles__ = null
/* scopeId */
var genePreviewResult___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var genePreviewResult___vue_module_identifier__ = null
var genePreviewResult_Component = genePreviewResult_normalizeComponent(
  genePreviewResult,
  caseDetail_genePreviewResult,
  genePreviewResult___vue_template_functional__,
  genePreviewResult___vue_styles__,
  genePreviewResult___vue_scopeId__,
  genePreviewResult___vue_module_identifier__
)

/* harmony default export */ var components_caseDetail_genePreviewResult = (genePreviewResult_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDetailGenePreview.vue







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var caseDetailGenePreview = ({
  components: {
    genePreviewDisplayForm: components_caseDetail_genePreviewDisplayForm,
    genePreviewSelectForm: components_caseDetail_genePreviewSelectForm,
    genePreviewResult: components_caseDetail_genePreviewResult
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      currentData: null,
      selectedDatas: {
        'select': []
      },
      display: {
        'form': null
      }
    };
  },
  created: function created() {
    this.setCurrentData(this.userSetting);
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['userSetting']), {
    selectedRange: function selectedRange() {
      return global_data["Q" /* reportPreviewRangeData */][this.displayType];
    },

    // static
    dataTransformMap: function dataTransformMap() {
      var map1 = {
        'SpliceAI': ['SpliceAI_DS_AL', 'SpliceAI_DS_DG', 'SpliceAI_DS_DL', 'SpliceAI_DP_AG', 'SpliceAI_DP_AL', 'SpliceAI_DP_DG', 'SpliceAI_DP_DL', 'SpliceAI_DS_AG']
      };
      var map2 = {};
      return {
        'receive': extends_default()({}, entries_default()(map1).reduce(function (map, _ref) {
          var _ref2 = slicedToArray_default()(_ref, 2),
              key = _ref2[0],
              values = _ref2[1];

          return extends_default()({}, map, values.reduce(function (map, value) {
            return extends_default()({}, map, defineProperty_default()({}, value, [key]));
          }, {}));
        }, {}), map2),
        'send': extends_default()({}, entries_default()(map2).reduce(function (map, _ref3) {
          var _ref4 = slicedToArray_default()(_ref3, 2),
              key = _ref4[0],
              values = _ref4[1];

          return extends_default()({}, map, values.reduce(function (map, value) {
            return extends_default()({}, map, defineProperty_default()({}, value, [key]));
          }, {}));
        }, {}), map1)
      };
    },
    tabOptions: function tabOptions() {
      return {
        'ps': [{
          title: this.$t('DIALOG.caseDetailGenePreview.tab.title.___display'),
          value: 'select',
          type: 'main'
        }],
        'pd': [{
          title: this.$t('DIALOG.caseDetailGenePreview.tab.title.___display'),
          value: 'display',
          type: 'main'
        }, {
          title: this.$t('DIALOG.caseDetailGenePreview.tab.title.___select'),
          value: 'select',
          type: 'sub'
        }]
      }[this.displayType];
    },

    // param
    displayType: function displayType() {
      return this.param.type;
    },
    gene: function gene() {
      return this.param.gene;
    },
    variants: function variants() {
      return this.param.variants;
    }
  }),
  watch: {
    'userSetting': function userSetting(nv) {
      this.setCurrentData(nv);
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUserSettingAction']), {
    setCurrentData: function setCurrentData(userSetting) {
      var _this = this;

      var selectDatas = Array.prototype.concat.apply([], keys_default()(global_data["P" /* reportPreviewOptions */]).map(function (type) {
        return Object(global_data["w" /* getReportPreviewColumns */])(userSetting.report_preview_af_columns, 'select', type);
      }));
      selectDatas = Array.prototype.concat.apply([], selectDatas.map(function (selectData) {
        return _this.dataTransformMap['receive'][selectData] || [selectData];
      })).filter(function (x, i, s) {
        return s.indexOf(x) === i;
      });
      var displayDatas = Object(global_data["w" /* getReportPreviewColumns */])(userSetting.report_display_af_columns, 'display');
      this.currentData = {
        'select': selectDatas,
        'display': displayDatas
      };
    },
    editUserSetting: function editUserSetting(type, result) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var config, response, data, _data, userSettings;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                config = _this2.$ls.get('userInfo');
                response = null;

                if (!(type === 'display')) {
                  _context.next = 10;
                  break;
                }

                data = {
                  report_display_af_columns: result
                };
                _context.next = 7;
                return Object(src_api["_154" /* putUserSettings */])(data, config);

              case 7:
                response = _context.sent;
                _context.next = 15;
                break;

              case 10:
                if (!(type === 'select')) {
                  _context.next = 15;
                  break;
                }

                _data = {
                  report_preview_af_columns: Array.prototype.concat.apply([], result.map(function (result) {
                    return _this2.dataTransformMap['send'][result] || [result];
                  })).filter(function (x, i, s) {
                    return s.indexOf(x) === i;
                  })
                };
                _context.next = 14;
                return Object(src_api["_154" /* putUserSettings */])(_data, config);

              case 14:
                response = _context.sent;

              case 15:
                if (response) {
                  userSettings = response.data.data;

                  _this2.setUserSettingAction(userSettings);
                }
                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](0);

                _this2.addToast('error', !_context.t0.response ? _context.t0.message : _context.t0.response.data.result.message);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 18]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b50425f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDetailGenePreview.vue
var caseDetailGenePreview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentData)?_c('div',{staticClass:"case-detail-gene-preview-dailog dialog col-block width-full"},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s({
        'ps': _vm.$t('DIALOG.caseDetailGenePreview.___psTitle'),
        'pd': _vm.$t('DIALOG.caseDetailGenePreview.___pdTitle')
      }[_vm.displayType])}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"tab-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_vm._l((_vm.tabOptions),function(option,oindex){return _c('div',{key:oindex,staticClass:"tab-block row-block",class:[{ display: _vm.display['form'] === option.value }, option.type],on:{"click":function (e) { return _vm.display['form'] = (_vm.display['form'] !== option.value ? option.value : null); }}},[_c('div',{style:({ width: '16px' })}),_vm._v(" "),_c('div',{staticClass:"tab-title"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("K4ph"),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '8px' })})])})],2),_vm._v(" "),_c('hr',{staticClass:"no-margin"}),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(_vm.display['form'])?[_c('div',{staticClass:"form-container col-block width-full"},[(_vm.display['form'] === 'display')?[_c('genePreviewDisplayForm',{attrs:{"defaultDatas":_vm.currentData['display'],"displayType":_vm.displayType,"variants":_vm.variants},on:{"dataUpdate":function (result) { return _vm.editUserSetting('display', result); }}})]:(_vm.display['form'] === 'select')?[(_vm.displayType === 'ps')?[_c('span',{class:{ alert: (_vm.selectedDatas['select'].length >= _vm.selectedRange[1]) },domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.caseDetailGenePreview.tab.info.select.___ps', { count: _vm.selectedDatas['select'].length, limit: _vm.selectedRange[1] }))}})]:_vm._e(),_vm._v(" "),_c('genePreviewSelectForm',{attrs:{"defaultDatas":_vm.currentData['select'],"displayType":_vm.displayType,"variants":_vm.variants},on:{"update":function (datas) { return _vm.selectedDatas['select'] = datas; },"dataUpdate":function (result) { return _vm.editUserSetting('select', result); }}})]:_vm._e()],2),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('hr',{staticClass:"no-margin"}),_vm._v(" "),_c('div',{style:({ height: '15px' })})]:_vm._e(),_vm._v(" "),_vm._l((_vm.variants),function(variant,vindex){return _c('div',{key:vindex,staticClass:"data-container col-block"},[_c('div',{staticClass:"data-title-container row-block"},[_c('div',{staticClass:"data-title"},[_vm._v(_vm._s(variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -'))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block width-full"},[_c('genePreviewResult',{attrs:{"defaultDatas":_vm.currentData['select'],"displayType":_vm.displayType,"gene":_vm.gene,"variant":variant}})],1)])}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2):_vm._e()}
var caseDetailGenePreview_staticRenderFns = []
var caseDetailGenePreview_esExports = { render: caseDetailGenePreview_render, staticRenderFns: caseDetailGenePreview_staticRenderFns }
/* harmony default export */ var dialog_caseDetailGenePreview = (caseDetailGenePreview_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDetailGenePreview.vue
var caseDetailGenePreview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDetailGenePreview___vue_template_functional__ = false
/* styles */
var caseDetailGenePreview___vue_styles__ = null
/* scopeId */
var caseDetailGenePreview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDetailGenePreview___vue_module_identifier__ = null
var caseDetailGenePreview_Component = caseDetailGenePreview_normalizeComponent(
  caseDetailGenePreview,
  dialog_caseDetailGenePreview,
  caseDetailGenePreview___vue_template_functional__,
  caseDetailGenePreview___vue_styles__,
  caseDetailGenePreview___vue_scopeId__,
  caseDetailGenePreview___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDetailGenePreview = (caseDetailGenePreview_Component.exports);

// EXTERNAL MODULE: ./src/components/case/acmgItem.vue + 2 modules
var acmgItem = __webpack_require__("1F0f");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDetailGeneACMG.vue







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var caseDetailGeneACMG = ({
  components: {
    acmgItem: acmgItem["a" /* default */],
    borCor: tool_borCor["a" /* default */]
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      acmg: null,
      display: {}
    };
  },

  computed: {
    acmgResults: function acmgResults() {
      var _this = this;

      return entries_default()(this.acmg[this.gene.SYMBOL || '']).reduce(function (result, _ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            vkey = _ref2[0],
            acmg = _ref2[1];

        return extends_default()({}, result, defineProperty_default()({}, vkey, entries_default()(acmg).filter(function (_ref3) {
          var _ref4 = slicedToArray_default()(_ref3, 2),
              _ = _ref4[0],
              value = _ref4[1];

          return value;
        }).map(function (_ref5) {
          var _ref6 = slicedToArray_default()(_ref5, 1),
              key = _ref6[0];

          return _this.acmgMap[key];
        }).filter(function (x) {
          return x;
        })));
      }, {});
    },

    // param
    caseData: function caseData() {
      return this.param.caseData;
    },
    gene: function gene() {
      return this.param.gene;
    },
    variants: function variants() {
      return this.param.variants;
    },
    type: function type() {
      return this.param.type;
    },

    // global
    acmgMap: function acmgMap() {
      return global_data["a" /* acmgMap */];
    }
  },
  created: function created() {
    this.acmg = this.param.acmg;
    this.display = extends_default()({}, this.display, keys_default()(this.variants).reduce(function (s, vkey) {
      return extends_default()({}, s, defineProperty_default()({}, vkey, false));
    }, {}));
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction']), {
    getACMGTag: function getACMGTag(vkey, acmgResult) {
      var acmgTag = this.acmg[this.gene.SYMBOL || ''][vkey][acmgResult.title + '_tag'] || acmgResult.title;
      return acmgResult.title + (acmgResult.title !== acmgTag ? '(' + acmgTag.match(/^([^\d]*)\d+/)[1] + ')' : '');
    },

    // parent
    getACMGConsequence: function getACMGConsequence(gene, vkey) {
      return this.param.functions['getACMGConsequence'](gene, vkey);
    },
    setACMG: function setACMG(gene, vkey, tag, newTag) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _extends4;

        var result;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.setLoadingAction(true);
                _context.next = 3;
                return _this2.param.functions['setACMG'](gene, vkey, tag, newTag);

              case 3:
                result = _context.sent;

                _this2.acmg[gene.SYMBOL || ''][vkey] = extends_default()({}, _this2.acmg[gene.SYMBOL || ''][vkey], (_extends4 = {}, defineProperty_default()(_extends4, tag, result), defineProperty_default()(_extends4, tag + '_tag', newTag || _this2.acmg[gene.SYMBOL || ''][vkey][tag + '_tag']), _extends4));
                _this2.setLoadingAction(false);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    resetACMG: function resetACMG(gene, vkey) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var variant, defaultACMG;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.setLoadingAction(true);
                _context2.next = 3;
                return _this3.param.functions['resetACMG'](gene, vkey);

              case 3:
                variant = gene.variants[vkey];
                defaultACMG = keys_default()(_this3.acmgMap).concat(['ACMG_Classification']).reduce(function (s, key) {
                  return extends_default()({}, s, defineProperty_default()({}, key, variant[key]));
                }, {});

                _this3.acmg[gene.SYMBOL || ''][vkey] = defaultACMG;
                _this3.setLoadingAction(false);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68f7cb18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDetailGeneACMG.vue
var caseDetailGeneACMG_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-gene-acmg-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),(_vm.acmg)?_c('div',{staticClass:"data-container col-block"},[_c('div',{staticClass:"acmg-table-container col-block"},_vm._l((_vm.variants),function(variant,vkey,vindex){return _c('div',{key:vindex,staticClass:"acmg-table-block"},[_c('div',{staticClass:"acmg-table"},[_c('div',{staticClass:"table-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell hgvsc col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content ellipsis",attrs:{"title":variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -'},domProps:{"innerHTML":_vm._s(variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -')}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col tab col-block",style:({ flex: 3 })},[_c('div',{staticClass:"table-cell consequence col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content",domProps:{"innerHTML":_vm._s(_vm.getACMGConsequence(_vm.gene, vkey))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"tab-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"tab-block row-block",class:{ display: _vm.display[vkey] },on:{"click":function (e) { return _vm.display[vkey] = !_vm.display[vkey]; }}},[_c('div',{style:({ width: '16px' })}),_vm._v(" "),_c('div',{staticClass:"tab-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.___tabTitle')))]),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("K4ph"),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '8px' })})])])])]),_vm._v(" "),(_vm.display[vkey])?[_c('div',{staticClass:"table-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell criteria col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_c('button',{staticClass:"reset-button gray-button circle-button",attrs:{"disabled":!_vm.caseData.edit_permission},on:{"click":function (e) { return _vm.resetACMG(_vm.gene, vkey); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___reset')))])])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell benign col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.table.title.___benignCriteria')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 2 })},[_c('div',{staticClass:"table-cell pathogenic col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.table.title.___pathogenicCriteria')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])]),_vm._v(" "),_c('div',{staticClass:"table-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 2 })},[_c('div',{staticClass:"table-cell strength-of-evidence col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.table.title.___strengthofEvidence')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell benign-strong col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.table.title.___strong')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell benign-supporting col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.table.title.___supporting')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell pathogenic-supporting col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.table.title.___supporting')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell pathogenic-moderate col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.table.title.___moderate')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell pathogenic-strong col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.table.title.___strong')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell pathogenic-very-strong col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.table.title.___veryStrong')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])]),_vm._v(" "),_c('div',{staticClass:"table-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 2 })},[_c('div',{staticClass:"table-cell acmg-col-title col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.table.title.___populationData')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'BA1',"acmgType":'benign-strong',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'BS1',"acmgType":'benign-strong',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'BS2',"acmgType":'benign-strong',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'PM2',"acmgType":'pathogenic-moderate',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'PS4',"acmgType":'pathogenic-strong',"disabled":!_vm.caseData.edit_permission,"borCorReverse":true},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('div',{style:({ flex: 1 })})])])]),_vm._v(" "),_c('div',{staticClass:"table-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 2 })},[_c('div',{staticClass:"table-cell acmg-col-title col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content",domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.table.title.___allelicEvidenceCosegrgationData'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'BS4',"acmgType":'benign-strong',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'BP2',"acmgType":'benign-supporting',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'BP5',"acmgType":'benign-supporting',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]),_vm._v(" "),_c('div',{staticClass:"table-sub-col-container col-block",style:({ flex: 3 })},[_c('div',{staticClass:"table-sub-cell-container col-block"},[_c('div',{staticClass:"table-sub-col-block low-row row-block"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'PP1',"acmgType":'pathogenic-supporting',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)])]),_vm._v(" "),_c('div',{staticClass:"table-sub-col-block row-block"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'PM3',"acmgType":'pathogenic-moderate',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'PM6',"acmgType":'pathogenic-moderate',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'PS2',"acmgType":'pathogenic-strong',"disabled":!_vm.caseData.edit_permission,"borCorReverse":true},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('div',{style:({ flex: 1 })})])])]),_vm._v(" "),_c('div',{staticClass:"table-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 2 })},[_c('div',{staticClass:"table-cell acmg-col-title col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content",domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.table.title.___computationPredictiveData'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'BP1',"acmgType":'benign-supporting',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'BP3',"acmgType":'benign-supporting',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'BP4',"acmgType":'benign-supporting',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'BP7',"acmgType":'benign-supporting',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'PP2',"acmgType":'pathogenic-supporting',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'PP3',"acmgType":'pathogenic-supporting',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'PM1',"acmgType":'pathogenic-moderate',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'PM4',"acmgType":'pathogenic-moderate',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'PM5',"acmgType":'pathogenic-moderate',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'PS1',"acmgType":'pathogenic-strong',"disabled":!_vm.caseData.edit_permission,"borCorReverse":true},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'PVS1',"acmgType":'pathogenic-very-strong',"disabled":!_vm.caseData.edit_permission,"borCorReverse":true},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)])]),_vm._v(" "),_c('div',{staticClass:"table-row low-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 2 })},[_c('div',{staticClass:"table-cell acmg-col-title col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.table.title.___functionalData')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'BS3',"acmgType":'benign-strong',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'PS3',"acmgType":'pathogenic-strong',"disabled":!_vm.caseData.edit_permission,"borCorReverse":true},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('div',{style:({ flex: 1 })})])])]),_vm._v(" "),_c('div',{staticClass:"table-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 2 })},[_c('div',{staticClass:"table-cell acmg-col-title col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.table.title.___other')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'BP6',"acmgType":'benign-supporting',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'PP4',"acmgType":'pathogenic-supporting',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('acmgItem',{attrs:{"acmgData":_vm.acmg[(_vm.gene.SYMBOL || '')][vkey],"acmgKey":'PP5',"acmgType":'pathogenic-supporting',"disabled":!_vm.caseData.edit_permission},on:{"setValue":function (tag, newTag) { return _vm.setACMG(_vm.gene, vkey, tag, newTag); }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col col-block"},[_c('div',{style:({ flex: 1 })})])])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell automated-criteria col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.table.title.___automatedCriteria')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),(_vm.display[vkey])?_c('div',{staticClass:"table-col col-block",style:({ flex: 3 })},[_c('div',{staticClass:"table-cell explanation col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailGeneACMG.table.title.___explanation')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]):_vm._e()]),_vm._v(" "),(_vm.acmgResults[vkey].length)?[(_vm.display[vkey])?_vm._l((_vm.acmgResults[vkey]),function(acmgResult,arindex){return _c('div',{key:arindex,staticClass:"table-row wrap-row row-block flex-start stretch"},[_c('div',{staticClass:"table-col col-block",style:({ width: '25%', 'min-height': '50px' })},[_c('div',{staticClass:"table-cell selected-col-title row-block",class:[acmgResult.class + '-title']},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(_vm.getACMGTag(vkey, acmgResult) + ': ')),_c('span',{staticClass:"type"},[_vm._v(_vm._s(acmgResult.type))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ width: '75%', 'min-height': '50px' })},[_c('div',{staticClass:"table-cell selected-col col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content",domProps:{"innerHTML":_vm._s(variant[acmgResult.title + '_explanation'] || '- -')}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])])}):[_c('div',{staticClass:"table-row wrap-row row-block flex-start flex-wrap stretch",class:['wrap-4']},[_vm._l((_vm.acmgResults[vkey]),function(acmgResult,arindex){return _c('div',{key:arindex,staticClass:"table-col col-block",style:({ width: '25%', height: '50px' })},[_c('div',{staticClass:"table-cell selected-col-title row-block",class:[acmgResult.class + '-title']},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(_vm.getACMGTag(vkey, acmgResult) + ': ')),_c('span',{staticClass:"type"},[_vm._v(_vm._s(acmgResult.type))])]),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),(variant[acmgResult.title + '_explanation'])?_c('borCor',{attrs:{"width":'400px',"reverse":arindex % 4 >= 2,"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{ padding: '6px 8px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(variant[acmgResult.title + '_explanation'])}})])]):_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)])}),_vm._v(" "),(_vm.acmgResults[vkey].length % 4)?_c('div',{staticClass:"table-col col-block empty",style:({ flex: 1, height: '50px' })},[_c('div',{staticClass:"table-cell selected-col-title row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]):_vm._e()],2)]]:_vm._e()],2)])}),0)]):_vm._e(),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var caseDetailGeneACMG_staticRenderFns = []
var caseDetailGeneACMG_esExports = { render: caseDetailGeneACMG_render, staticRenderFns: caseDetailGeneACMG_staticRenderFns }
/* harmony default export */ var dialog_caseDetailGeneACMG = (caseDetailGeneACMG_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDetailGeneACMG.vue
var caseDetailGeneACMG_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDetailGeneACMG___vue_template_functional__ = false
/* styles */
var caseDetailGeneACMG___vue_styles__ = null
/* scopeId */
var caseDetailGeneACMG___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDetailGeneACMG___vue_module_identifier__ = null
var caseDetailGeneACMG_Component = caseDetailGeneACMG_normalizeComponent(
  caseDetailGeneACMG,
  dialog_caseDetailGeneACMG,
  caseDetailGeneACMG___vue_template_functional__,
  caseDetailGeneACMG___vue_styles__,
  caseDetailGeneACMG___vue_scopeId__,
  caseDetailGeneACMG___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDetailGeneACMG = (caseDetailGeneACMG_Component.exports);

// EXTERNAL MODULE: ./src/components/case/errorMessage.vue + 2 modules
var errorMessage = __webpack_require__("HCbd");

// EXTERNAL MODULE: ./src/components/case/diseaseIcon.vue + 2 modules
var diseaseIcon = __webpack_require__("4r+p");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/caseDetail/regionOverlappingGeneData.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var regionOverlappingGeneData = ({
  components: {
    caseErrorMessage: errorMessage["a" /* default */],
    diseaseIcon: diseaseIcon["a" /* default */],
    borCor: newBorCor["a" /* default */]
  },
  mixins: [routeLoading["a" /* default */], responsitive["a" /* default */]],
  props: {
    onDragging: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // mainData
    dataList: {
      type: Array,
      required: true
    },
    dataIndex: {
      type: Number,
      required: true
    },
    geneData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      selectingPhenotype: null,
      tableHover: {},
      limit: {
        'phenotype': {
          value: 5,
          active: true
        },
        'network': {
          value: 5,
          active: true
        }
      }
    };
  },

  computed: {
    // static
    dataTableOption: function dataTableOption() {
      var _this = this;

      var svDosageSensitivityMap = global_data["V" /* svDosageSensitivityOptions */].reduce(function (map, option) {
        return extends_default()({}, map, defineProperty_default()({}, option.value, option));
      }, {});
      return [{
        title: this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.table.title.___Overlap_region'),
        value: function value(geneData) {
          return [geneData.location2 ? '<b>' + geneData.location2 + '</b>' : '', geneData.location].filter(function (x) {
            return x;
          }).join('<br>');
        },
        color: null,
        width: '18%',
        maxWidth: '175px',
        position: 'center',
        noKey: this.$t(global_data["m" /* defaultEmptyDisplay */].noKey),
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.table.title.___Dosage_sensitivity'),
        value: function value(geneData) {
          var haplo = ['<b>' + _this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.table.content.Dosage_sensitivity.___Haplo') + ':</b> ', svDosageSensitivityMap[geneData.HI] ? _this.$t(svDosageSensitivityMap[geneData.HI].title) : '- -'].join('');
          var triplo = ['<b>' + _this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.table.content.Dosage_sensitivity.___Triplo') + ':</b> ', svDosageSensitivityMap[geneData.TS] ? _this.$t(svDosageSensitivityMap[geneData.TS].title) : '- -'].join('');
          return ['<span' + ((svDosageSensitivityMap[geneData.HI] || {}).alert ? ' style=color:#FA3D3D' : '') + '>' + haplo + '</span>', '<span' + ((svDosageSensitivityMap[geneData.TS] || {}).alert ? ' style=color:#FA3D3D' : '') + '>' + triplo + '</span>'].join('<br>');
        },
        color: null,
        width: '45%',
        maxWidth: '410px',
        position: 'center',
        noKey: this.$t(global_data["m" /* defaultEmptyDisplay */].noKey),
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.table.title.___pLI'),
        value: function value(geneData) {
          var genomAD = ['<b>' + _this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.table.content.pLI.___GenomAD') + ':</b> ', ![undefined, null].includes(geneData.GnomAD_pLI) ? geneData.GnomAD_pLI : '- -'].join('');
          var ExAC = ['<b>' + _this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.table.content.pLI.___ExAC') + ':</b> ', ![undefined, null].includes(geneData.ExAC_pLI) ? geneData.ExAC_pLI : '- -'].join('');
          return ['<span' + (geneData.GnomAD_pLI > 0.9 ? ' style=color:#FA3D3D' : '') + '>' + genomAD + '</span>', '<span' + (geneData.ExAC_pLI > 0.9 ? ' style=color:#FA3D3D' : '') + '>' + ExAC + '</span>'].join('<br>');
        },
        color: null,
        width: '22%',
        maxWidth: '210px',
        position: 'center',
        noKey: this.$t(global_data["m" /* defaultEmptyDisplay */].noKey),
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.table.title.___LOEUF'),
        value: function value(geneData) {
          return ![undefined, null].includes(geneData.LOEUF) ? '<span' + (geneData.LOEUF < 0.35 ? ' style=color:#FA3D3D' : '') + '>' + geneData.LOEUF + '</span>' : geneData.LOEUF;
        },
        color: null,
        width: '10%',
        maxWidth: '70px',
        position: 'center',
        noKey: this.$t(global_data["m" /* defaultEmptyDisplay */].noKey),
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }];
    },

    // global
    caseDataTagOptions: function caseDataTagOptions() {
      return global_data["b" /* caseDataTagOptions */];
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModal2Action', 'setLoadingAction']), {
    // External Link
    getMainLinks: function getMainLinks(data) {
      return {};
    },
    getExternalLinks: function getExternalLinks(type, data) {
      var subData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (type === 'gene') {
        var geneData = extends_default()({}, data, subData);
        var externalLinks = [[this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___GHR'), ['https://medlineplus.gov/genetics/gene/' + (geneData.gene_name || '').toLowerCase()]], [this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___NCBI_Gene'), ['https://www.ncbi.nlm.nih.gov/gene/' + (geneData.gene_id || '')]], [this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___OMIM'), ['https://www.omim.org/entry/' + (geneData.Gene_MIM_Number || '')]], [this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___UniProt'), (geneData.UniProtKB_AC || '').split('|').filter(function (x) {
          return x;
        }).map(function (uniProt) {
          return 'https://www.uniprot.org/uniprot/' + uniProt;
        })]];
        return extends_default()({}, externalLinks.filter(function (kv) {
          return (kv[1] || []).length;
        }).reduce(function (result, kv) {
          return extends_default()({}, result, defineProperty_default()({}, kv[0], kv[1]));
        }, {}), geneData.external_links);
      } else if (type === 'phenotype') {
        var _extends4;

        var phenotype = extends_default()({}, data, subData);
        return extends_default()((_extends4 = {}, defineProperty_default()(_extends4, this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___GHR'), ['https://vsearch.nlm.nih.gov/vivisimo/cgi-bin/query-meta?&v:project=medlineplus&v:sources=medlineplus-bundle&query=' + (phenotype.Phenotype || '') + '&binning-state=group%3d%3dGenetics%0aalpha%3d%3dGenetic%20Conditions&']), defineProperty_default()(_extends4, this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___HPO'), ['https://hpo.jax.org/app/browse/disease/OMIM:' + (phenotype.id || '')]), defineProperty_default()(_extends4, this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___OMIM'), ['https://www.omim.org/entry/' + (phenotype.id || '')]), defineProperty_default()(_extends4, this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___Orphanet'), [phenotype.Orpha_id ? 'https://www.orpha.net/en/disease/detail/' + phenotype.Orpha_id : 'https://www.orpha.net/en/disease']), _extends4), phenotype.external_links);
      } else if (type === 'orphaPhenotype') {
        var _extends5;

        var orphaPhenotype = extends_default()({}, data, subData);
        return extends_default()((_extends5 = {}, defineProperty_default()(_extends5, this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___GHR'), ['https://vsearch.nlm.nih.gov/vivisimo/cgi-bin/query-meta?&v:project=medlineplus&v:sources=medlineplus-bundle&query=' + (orphaPhenotype.disease || '') + '&binning-state=group%3d%3dGenetics%0aalpha%3d%3dGenetic%20Conditions&']), defineProperty_default()(_extends5, this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___HPO'), ['https://hpo.jax.org/app/browse/disease/ORPHA:' + (orphaPhenotype.id || '')]), defineProperty_default()(_extends5, this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___OMIM'), ['https://www.omim.org/search?index=entry&search=orphanet_id:' + (orphaPhenotype.id || '')]), defineProperty_default()(_extends5, this.$t('COMPONENT.caseDetail.regionOverlappingGeneData.externalLink.title.___Orphanet'), ['https://www.orpha.net/en/disease/detail/' + (orphaPhenotype.id || '')]), _extends5), orphaPhenotype.external_links);
      }
    },
    openExternalLinks: function openExternalLinks(links) {
      links = links instanceof Array ? links : [links];
      links.forEach(function (link) {
        return window.open(link);
      });
    },

    // phenotype
    phenotypeAlertDisplay: function phenotypeAlertDisplay(phenotype) {
      return false && global_data["E" /* omimPhenotypeIDList */].includes(phenotype.id);
    },
    diseaseDisplay: function diseaseDisplay(geneData) {
      return false;
    },
    switchPhenotype: function switchPhenotype(geneData, phenotype) {
      // this.selectingPhenotype = phenotype

      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },

    // table
    dataTableValueMap: function dataTableValueMap(option, value) {
      var result = value || value === 0 ? value : value === null ? option.empty || this.$t(global_data["m" /* defaultEmptyDisplay */].empty) : option.noKey || this.$t(global_data["m" /* defaultEmptyDisplay */].noKey);
      return option.limit ? result.slice(0, option.limit) + (result.length > option.limit ? '...' : '') : result;
    },
    localeMap: function localeMap(value) {
      return value && (value + '').startsWith('CONSTANT.global.data') ? this.$t(value) : value;
    },
    tableOnHover: function tableOnHover(option, value) {
      this.tableHover = extends_default()({}, this.tableHover, defineProperty_default()({}, option.title, value));
    },
    openTableLink: function openTableLink(geneData, link) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                switch (link) {
                  default:
                    {}
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14395615","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/caseDetail/regionOverlappingGeneData.vue
var regionOverlappingGeneData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-data-list-region-overlapping-gene-data-page col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"main-data-container row-block flex-start"},[_c('div',{staticClass:"data-info-field row-block flex-start",style:({ width: '250px' })},[_c('div',{staticClass:"data-info-container col-block flex-start"},[_c('div',{staticClass:"data-info-block col-block flex-start"},[_c('div',{staticClass:"gene-name-container row-block"},[_c('div',{staticClass:"gene-name",style:({ 'max-width': '230px' })},[_vm._v(_vm._s(_vm.geneData.gene_name || '- -'))]),_vm._v(" "),_c('div',{style:({ width: '15px' })}),_vm._v(" "),_c('borCor',{attrs:{"disabled":_vm.onDragging,"arrow":false,"background":'white',"border":'#CCCCCC',"radius":'0px',"blockStyle":{ padding: '10px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"img-block"},[_c('img',{attrs:{"src":__webpack_require__("r0TN"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"content col-block flex-start",attrs:{"slot":"content"},slot:"content"},[(Object.keys(_vm.getMainLinks(_vm.geneData)).length)?[_c('div',{staticClass:"link-container col-block flex-start"},_vm._l((_vm.getMainLinks(_vm.geneData)),function(link,title,lindex){return _c('div',{key:lindex,staticClass:"link row-block",on:{"click":function (e) { return link.func(); }}},[_c('div',{staticClass:"link-title"},[_vm._v(_vm._s(title))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('img',{attrs:{"src":link.icon,"alt":""}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0),_vm._v(" "),_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '5px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"link-container col-block flex-start"},_vm._l((_vm.getExternalLinks('gene', _vm.geneData)),function(link,title,lindex){return _c('div',{key:lindex,staticClass:"link row-block",on:{"click":function (e) { return _vm.openExternalLinks(link); }}},[_c('div',{staticClass:"link-title"},[_vm._v(_vm._s(title))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("wtkH"),"alt":""}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)],2)])],1)]),_vm._v(" "),_c('div',{staticClass:"data-option-container row-block"},[_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"data-tag-container row-block flex-wrap",style:({ 'max-width': ((Math.max(1400, _vm.windowWidth) - 160) / 4) + 'px' })},[_vm._l(([].filter(function (tag) { return _vm.displayTabs.includes(tag.type || _vm.type); })),function(tag,mindex){return _c('div',{key:mindex,staticClass:"data-tag-block",on:{"click":function (e) { return (tag.func || (function () {}))(); }}},[_c('div',{staticClass:"data-tag",class:{ clickable: tag.func },style:(_vm.caseDataTagOptions[tag.type || _vm.type]),attrs:{"title":tag.title}},[_vm._v(_vm._s(tag.title))])])}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"data-table-field col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"data-table-container row-block flex-start",style:({ flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-table-block block-table"},[_c('div',{staticClass:"data-table-row row-block stretch"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_vm._l((_vm.dataTableOption.filter(function (option) { return (option.display || (function () { return true; }))(_vm.geneData); })),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-table-col col-block width-full",class:[
                option.position,
                { link: option.link }
              ],style:({
                width: option.width,
                'max-width': option.maxWidth
              }),on:{"mouseover":function (e) { return _vm.tableOnHover(option, true); },"mouseleave":function (e) { return _vm.tableOnHover(option, false); },"click":function (e) { return _vm.openTableLink(_vm.geneData, option.link); }}},[_c('div',{staticClass:"data-table-cell-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-table-cell shrink row-block"},[_c('div',{staticClass:"data-table-content",domProps:{"innerHTML":_vm._s(option.title)}}),_vm._v(" "),(option.desc)?_c('borCor',{attrs:{"disabled":_vm.onDragging,"width":'200px',"background":'white',"border":'#CCCCCC',"radius":'5px',"blockStyle":{ padding: '10px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{style:({ width: '16px' }),attrs:{"src":__webpack_require__("Rp0L"),"alt":""}})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',[_vm._v(_vm._s(option.desc))])])]):_vm._e()],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])})],2),_vm._v(" "),_c('div',{staticClass:"data-table-row row-block stretch"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_vm._l((_vm.dataTableOption.filter(function (option) { return (option.display || (function () { return true; }))(_vm.geneData); })),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-table-col col-block width-full",class:[
                option.position,
                { link: option.link }
              ],style:({
                width: option.width,
                'max-width': option.maxWidth
              }),on:{"mouseover":function (e) { return _vm.tableOnHover(option, true); },"mouseleave":function (e) { return _vm.tableOnHover(option, false); },"click":function (e) { return _vm.openTableLink(_vm.geneData, option.link); }}},[_c('div',{staticClass:"data-table-cell-block row-block",style:({ flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-table-cell shrink row-block"},[(option.value === 'option')?[_c('div',{staticClass:"data-table-option-container col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]:[_c('div',{staticClass:"data-table-content shrink",style:(option.color ? { color: option.color(_vm.geneData) } : {}),domProps:{"innerHTML":_vm._s(_vm.dataTableValueMap(option, _vm.localeMap(option.value(_vm.geneData))))}}),_vm._v(" "),(option.links)?_c('borCor',{attrs:{"disabled":_vm.onDragging,"arrow":false,"background":'white',"border":'#CCCCCC',"radius":'0px',"blockStyle":{ padding: '10px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"img-block"},[_c('img',{attrs:{"src":__webpack_require__("X9c2"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"link-container col-block flex-start"},_vm._l((option.links),function(link,lindex){return _c('a',{key:lindex,staticClass:"link row-block",attrs:{"href":link.url(_vm.geneData),"target":"_blank"}},[_c('div',{staticClass:"link-title"},[_vm._v(_vm._s(link.title))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("wtkH"),"alt":""}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])]):_vm._e()]],2),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"data-table-border",class:{ display: _vm.tableHover[option.title] }})])})],2)])])])]),_vm._v(" "),(_vm.geneData.phenotypeDatas.length > 0)?_c('div',{staticClass:"condition-disease-container row-block flex-start"},[_c('div',{staticClass:"condition-container col-block flex-start",style:({ flex: 1 })},[_c('div',{staticClass:"condition-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.caseDetail.regionOverlappingGeneData.condition.___title')))]),_vm._v(" "),_c('div',{staticClass:"row-block flex-start",style:({ gap: '10px', width: '100%' })},[_c('div',{staticClass:"condition-block col-block width-full",style:({ flex: 1, width: 0 })},[_c('div',{staticClass:"condition-phenotype-container col-block width-full"},[_vm._l((_vm.limit['phenotype'].active ? _vm.geneData.phenotypeDatas.slice(0, _vm.limit['phenotype'].value) : _vm.geneData.phenotypeDatas),function(phenotype,index){return _c('div',{key:index,staticClass:"condition-phenotype-block row-block",class:{ selected: false, selectable: false },on:{"click":function (e) { return e.currentTarget.className.split(' ').includes('selectable') && _vm.switchPhenotype(_vm.geneData, phenotype); }}},[(_vm.phenotypeAlertDisplay(phenotype))?_c('div',{staticClass:"condition-phenotype-alert center-block"},[_c('borCor',{attrs:{"disabled":_vm.onDragging,"width":'300px',"background":'white',"border":'#CCCCCC',"radius":'0px',"blockStyle":{ padding: '10px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{style:({ width: '16px' }),attrs:{"src":__webpack_require__("JYtJ"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',[_vm._v(_vm._s(_vm.$t('COMPONENT.caseDetail.regionOverlappingGeneData.condition.___alert01')))])])]),_vm._v(" "),_c('div',{style:({ width: '5px' })})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"condition-phenotype-title shrink",attrs:{"title":{ 'true': phenotype.Phenotype, 'false': phenotype.disease }[!(_vm.geneData.SYMBOL || '').startsWith('MT-') + '']},domProps:{"innerHTML":_vm._s({ 'true': phenotype.Phenotype, 'false': phenotype.disease }[!(_vm.geneData.SYMBOL || '').startsWith('MT-') + ''])}}),_vm._v(" "),_c('div',{style:({ width: '4px' })}),_vm._v(" "),_c('div',{staticClass:"condition-inheritance-container"},[_c('div',{staticClass:"condition-inheritance-block row-block"},[_c('div',{staticClass:"condition-inheritance-title row-block"},[(({ 'true': phenotype.Inheritance, 'false': phenotype.inheritance }[!(_vm.geneData.SYMBOL || '').startsWith('MT-') + ''] || []).length)?_c('div',{staticClass:"hr"},[_vm._v("|")]):_vm._e(),_vm._v(" "),_vm._l(({ 'true': phenotype.Inheritance, 'false': phenotype.inheritance }[!(_vm.geneData.SYMBOL || '').startsWith('MT-') + ''] || []),function(inheritance,iindex){return _c('div',{key:iindex,staticClass:"inheritance",class:[inheritance]},[_c('span',[_vm._v(_vm._s(iindex ? ', ' : '')),_c('span',{staticClass:"text"},[_vm._v(_vm._s(inheritance))])])])})],2),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"condition-inheritance-img-container"},[_c('borCor',{attrs:{"disabled":_vm.onDragging,"arrow":false,"type":_vm.dataList[_vm.dataIndex + 1] ? 'bottom' : 'top',"background":'white',"border":'#CCCCCC',"radius":'0px',"blockStyle":{ padding: '10px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"condition-inheritance-img-block"},[_c('img',{attrs:{"src":__webpack_require__("X9c2"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"link-container col-block flex-start"},_vm._l((_vm.getExternalLinks({ 'true': 'phenotype', 'false': 'orphaPhenotype' }[!(_vm.geneData.SYMBOL || '').startsWith('MT-') + ''], phenotype)),function(link,title,lindex){return _c('div',{key:lindex,staticClass:"link row-block",on:{"click":function (e) { return _vm.openExternalLinks(link); }}},[_c('div',{staticClass:"link-title"},[_vm._v(_vm._s(title))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("wtkH"),"alt":""}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),_vm._v(" "),(_vm.geneData.phenotypeDatas.length - _vm.limit['phenotype'].value > 0)?_c('div',{staticClass:"condition-phenotype-more",on:{"click":function (e) { return _vm.limit['phenotype'].active = !_vm.limit['phenotype'].active; }}},[_vm._v(_vm._s(!_vm.limit['phenotype'].active ? '(' + _vm.$t('COMPONENT.caseDetail.regionOverlappingGeneData.condition.___less') + ')' : '(' + _vm.$t('COMPONENT.caseDetail.regionOverlappingGeneData.condition.___more', { count: _vm.geneData.phenotypeDatas.length - _vm.limit['phenotype'].value }) + ')'))]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"condition-option-container col-block flex-start"})])]),_vm._v(" "),(_vm.diseaseDisplay(_vm.geneData))?_c('div',{staticClass:"disease-container col-block flex-start",style:({ flex: 1, 'max-width': Math.min(872, (Math.max(1400, _vm.windowWidth) - 186) / 2) + 'px' })},[(_vm.diseaseDisplay(_vm.geneData))?[_c('div',{staticClass:"disease-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.caseDetail.regionOverlappingGeneData.disease.___title')))]),_vm._v(" "),_c('div',{staticClass:"disease-block col-block width-full"},[_c('div',{staticClass:"hpo-container col-block stretch"},[_vm._l((_vm.geneData.phenotypeData.hpo_network ? (_vm.limit['network'].active ? Object.entries(_vm.geneData.phenotypeData.hpo_network).slice(0, _vm.limit['network'].value) : Object.entries(_vm.geneData.phenotypeData.hpo_network)) : [{}]),function(ref,index){
              var hpoID = ref[0];
              var hpo = ref[1];
return _c('div',{key:index,staticClass:"hpo-block row-block",class:[hpo.result]},[(hpo.name)?[_c('div',{staticClass:"hpo-link-title ellipsis",style:({ width: '240px' }),attrs:{"title":hpo.path ? [].concat( hpo.path ).reverse()[0].name : ''}},[_vm._v(_vm._s(hpo.path ? [].concat( hpo.path ).reverse()[0].name : ''))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),(hpo.path)?_c('a',{staticClass:"hpo-link",attrs:{"href":'https://hpo.jax.org/app/browse/term/' + [].concat( hpo.path ).reverse()[0].id,"target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("wtkH"),"alt":""}})]):_c('div',{style:({ opacity: 0 })},[_c('img',{attrs:{"src":__webpack_require__("wtkH"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"hpo-icon"},[_c('diseaseIcon',{attrs:{"disabled":_vm.onDragging,"paths":hpo.path || (hpo.result === 'no_hit' ? null : []),"borCorType":_vm.dataList[_vm.dataIndex + 1] ? 'bottom' : 'top'}})],1),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"hpo-title ellipsis shrink",attrs:{"title":hpo.name}},[_vm._v(_vm._s(hpo.name))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('a',{staticClass:"hpo-link",attrs:{"href":'https://hpo.jax.org/app/browse/term/' + hpoID,"target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("wtkH"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]:_c('div',{staticClass:"hpo-title",style:({ flex: 1 })},[_vm._v("- -")])],2)}),_vm._v(" "),(Object.entries(_vm.geneData.phenotypeData.hpo_network || {}).length - _vm.limit['network'].value > 0)?_c('div',{staticClass:"condition-hpo-more",on:{"click":function (e) { return _vm.limit['network'].active = !_vm.limit['network'].active; }}},[_vm._v(_vm._s(!_vm.limit['network'].active ? '(' + _vm.$t('COMPONENT.caseDetail.regionOverlappingGeneData.condition.___less') + ')' : '(' + _vm.$t('COMPONENT.caseDetail.regionOverlappingGeneData.condition.___more', { count: Object.entries(_vm.geneData.phenotypeData.hpo_network || {}).length - _vm.limit['network'].value }) + ')'))]):_vm._e()],2)])]:_vm._e()],2):_vm._e()]):_vm._e()])}
var regionOverlappingGeneData_staticRenderFns = []
var regionOverlappingGeneData_esExports = { render: regionOverlappingGeneData_render, staticRenderFns: regionOverlappingGeneData_staticRenderFns }
/* harmony default export */ var caseDetail_regionOverlappingGeneData = (regionOverlappingGeneData_esExports);
// CONCATENATED MODULE: ./src/components/caseDetail/regionOverlappingGeneData.vue
var regionOverlappingGeneData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var regionOverlappingGeneData___vue_template_functional__ = false
/* styles */
var regionOverlappingGeneData___vue_styles__ = null
/* scopeId */
var regionOverlappingGeneData___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var regionOverlappingGeneData___vue_module_identifier__ = null
var regionOverlappingGeneData_Component = regionOverlappingGeneData_normalizeComponent(
  regionOverlappingGeneData,
  caseDetail_regionOverlappingGeneData,
  regionOverlappingGeneData___vue_template_functional__,
  regionOverlappingGeneData___vue_styles__,
  regionOverlappingGeneData___vue_scopeId__,
  regionOverlappingGeneData___vue_module_identifier__
)

/* harmony default export */ var components_caseDetail_regionOverlappingGeneData = (regionOverlappingGeneData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/caseDetail/regionGeneData.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var regionGeneData = ({
  components: {
    overlappingGeneData: components_caseDetail_regionOverlappingGeneData,
    pageButtons: pageButtons["a" /* default */]
  },
  mixins: [routeLoading["a" /* default */]],
  props: {
    svID: {
      type: String,
      required: true
    },
    caseData: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      geneDatas: null,
      pageData: {
        selectedPage: 1,
        display: 20,
        total: 0,
        buttonRange: 7
      }
    };
  },

  computed: {
    // global
    toPriceString: function toPriceString() {
      return util["r" /* toPriceString */];
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction']), {
    fetchData: function fetchData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchOverlappingGenes(true);

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchOverlappingGenes: function fetchOverlappingGenes() {
      var _this2 = this;

      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, id, projectID, svID, response, tableData, tableName, data, geneDatas, phenotypeMetadatas;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this2.$ls.get('userInfo');
                id = _this2.caseData.id;
                projectID = _this2.project.id;
                svID = _this2.svID;
                response = null;
                // table

                if (_this2.tableName) {
                  _context2.next = 13;
                  break;
                }

                tableData = {};
                _context2.next = 10;
                return Object(src_api["V" /* getCaseProjectRegionGeneTable */])(id, projectID, tableData, config);

              case 10:
                response = _context2.sent;
                tableName = !global_config["a" /* _LOCAL_BUILD */] ? response.data.data.table_name : response.data.data.session;

                _this2.tableName = tableName;

              case 13:
                // query
                reset && (_this2.pageData.selectedPage = 1);
                data = {
                  table_name: _this2.tableName,
                  session: _this2.tableName,
                  limit: 20,
                  page: _this2.pageData.selectedPage
                };
                _context2.next = 17;
                return Object(src_api["U" /* getCaseProjectRegionGene */])(id, projectID, svID, data, config);

              case 17:
                response = _context2.sent;
                geneDatas = response.data.data.data;
                // data

                phenotypeMetadatas = {
                  'true': {
                    getListFunciton: global_data["v" /* getRegionPhenotypeList */]
                  },
                  'false': {
                    getListFunciton: global_data["u" /* getRegionOrphaPhenotypeList */]
                  }
                };

                geneDatas = geneDatas.map(function (regionData) {
                  return extends_default()({}, regionData, {
                    phenotypeDatas: phenotypeMetadatas[!regionData.gene_name.startsWith('MT-')].getListFunciton(regionData)
                  });
                });
                reset && (_this2.pageData.total = response.data.data.total_count - 0);
                _this2.geneDatas = geneDatas;
                _context2.next = 28;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 28:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 25]]);
      }))();
    },
    searchDatas: function searchDatas() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.setLoadingAction(true);
                _context3.next = 3;
                return _this3.fetchOverlappingGenes();

              case 3:
                _this3.$refs['gene-data-scroll'].scrollTop = 0;
                _this3.setLoadingAction(false);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cb9ee0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/caseDetail/regionGeneData.vue
var regionGeneData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.geneDatas)?_c('div',{staticClass:"case-detail-region-gene-data-page col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"region-gene-data-main-container col-block width-full",style:({ flex: 1 })},[_c('div',{ref:"gene-data-scroll",staticClass:"region-gene-data-main-list-container col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"region-gene-data-main-list-block",style:({ height: 0 })},_vm._l((_vm.geneDatas),function(geneData,gdindex){return _c('div',{key:gdindex,staticClass:"region-gene-data-main-data-container"},[_c('overlappingGeneData',{attrs:{"dataList":_vm.geneDatas,"dataIndex":gdindex,"geneData":geneData}})],1)}),0)]),_vm._v(" "),(_vm.pageData)?_c('div',{staticClass:"region-gene-data-page-container row-block"},[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"region-gene-data-page-total"},[_vm._v(_vm._s(_vm.$t('COMPONENT.caseDetail.regionGeneData.page.___total', { total: _vm.toPriceString(_vm.pageData.total) })))]),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"region-gene-data-page-display"},[_vm._v(_vm._s(_vm.$t('COMPONENT.caseDetail.regionGeneData.page.___display', { display: _vm.pageData.display })))]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('pageButtons',{attrs:{"default":_vm.pageData.selectedPage,"display":_vm.pageData.display - 0,"total":_vm.pageData.total,"buttonRange":_vm.pageData.buttonRange},on:{"selectPage":function (page) { _vm.pageData.selectedPage = page; _vm.searchDatas() }}})],1):_vm._e()])]):_vm._e()}
var regionGeneData_staticRenderFns = []
var regionGeneData_esExports = { render: regionGeneData_render, staticRenderFns: regionGeneData_staticRenderFns }
/* harmony default export */ var caseDetail_regionGeneData = (regionGeneData_esExports);
// CONCATENATED MODULE: ./src/components/caseDetail/regionGeneData.vue
var regionGeneData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var regionGeneData___vue_template_functional__ = false
/* styles */
var regionGeneData___vue_styles__ = null
/* scopeId */
var regionGeneData___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var regionGeneData___vue_module_identifier__ = null
var regionGeneData_Component = regionGeneData_normalizeComponent(
  regionGeneData,
  caseDetail_regionGeneData,
  regionGeneData___vue_template_functional__,
  regionGeneData___vue_styles__,
  regionGeneData___vue_scopeId__,
  regionGeneData___vue_module_identifier__
)

/* harmony default export */ var components_caseDetail_regionGeneData = (regionGeneData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDetailRegionGene.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var caseDetailRegionGene = ({
  components: {
    regionGeneData: components_caseDetail_regionGeneData
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    // param
    regionData: function regionData() {
      return this.param.regionData;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49833b8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDetailRegionGene.vue
var caseDetailRegionGene_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-region-gene-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailRegionGene.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"data-container col-block",style:({ flex: 1 })},[_c('div',{staticClass:"data-title-container row-block"},[_c('div',{staticClass:"data-title",domProps:{"innerHTML":_vm._s([
          _vm.regionData.region_classification,
          _vm.regionData.SV_type,
          [
            'chr' + _vm.regionData.SV_chrom,
            _vm.regionData.CytoBand
          ].map(function (v) { return '(' + v + ')'; }).join('')
        ].join(' '))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block width-full",style:({ flex: 1 })},[_c('regionGeneData',_vm._b({},'regionGeneData',_vm.param,false))],1)]),_vm._v(" "),_c('div',{style:({ height: '0' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var caseDetailRegionGene_staticRenderFns = []
var caseDetailRegionGene_esExports = { render: caseDetailRegionGene_render, staticRenderFns: caseDetailRegionGene_staticRenderFns }
/* harmony default export */ var dialog_caseDetailRegionGene = (caseDetailRegionGene_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDetailRegionGene.vue
var caseDetailRegionGene_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDetailRegionGene___vue_template_functional__ = false
/* styles */
var caseDetailRegionGene___vue_styles__ = null
/* scopeId */
var caseDetailRegionGene___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDetailRegionGene___vue_module_identifier__ = null
var caseDetailRegionGene_Component = caseDetailRegionGene_normalizeComponent(
  caseDetailRegionGene,
  dialog_caseDetailRegionGene,
  caseDetailRegionGene___vue_template_functional__,
  caseDetailRegionGene___vue_styles__,
  caseDetailRegionGene___vue_scopeId__,
  caseDetailRegionGene___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDetailRegionGene = (caseDetailRegionGene_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDetailRegionQuality.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var caseDetailRegionQuality = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    qualityDatas: function qualityDatas() {
      return [this.param.regionData];
    },

    // static
    tableOption: function tableOption() {
      var defaultOptions = [{
        title: this.$t('DIALOG.caseDetailRegionQuality.table.default.title.___genotype'),
        value: 'GT',
        color: null,
        flex: 1,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailRegionQuality.table.default.title.___filter'),
        value: 'FT',
        color: function color(value) {
          return value && value !== 'PASS' ? 'FA3D3D' : '#333333';
        },
        flex: 1,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailRegionQuality.table.default.title.___genotypeQuality'),
        value: 'genotypeQuality',
        color: null,
        flex: 2,
        info: true,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailRegionQuality.table.default.title.___phredScaled'),
        value: 'PL',
        color: null,
        flex: 2,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailRegionQuality.table.default.title.___PairedRead'),
        value: 'PR',
        color: null,
        flex: 1,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailRegionQuality.table.default.title.___SplitRead'),
        value: 'SR',
        color: null,
        flex: 1,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }];
      var info1Options = [{
        title: this.$t('DIALOG.caseDetailRegionQuality.table.info.title.___IMPRECISE'),
        value: 'IMPRECISE',
        color: null,
        flex: 1,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailRegionQuality.table.info.title.___Confidence'),
        value: 'CIPOS',
        color: null,
        flex: 2,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailRegionQuality.table.info.title.___SV_Length'),
        value: 'SVINSLEN',
        color: null,
        flex: 1,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailRegionQuality.table.info.title.___BF'),
        value: 'BF',
        color: null,
        flex: 1,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailRegionQuality.table.info.title.___RATIO'),
        value: 'RATIO',
        color: null,
        flex: 1,
        position: 'center',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        flex: 2
      }];
      var info2Options = [{
        title: this.$t('DIALOG.caseDetailRegionQuality.table.info.title.___SV_Sequence'),
        value: 'SVINSSEQ',
        color: null,
        flex: 1,
        position: 'center',
        break: true,
        maxHeight: '200px',
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        flex: 1
      }];
      return {
        default: defaultOptions,
        info1: info1Options,
        info2: info2Options
      };
    },

    // param
    regionData: function regionData() {
      return this.param.regionData;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dece2f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDetailRegionQuality.vue
var caseDetailRegionQuality_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-region-quality-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailRegionQuality.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"data-container col-block"},[_c('div',{staticClass:"data-title-container row-block"},[_c('div',{staticClass:"data-title",domProps:{"innerHTML":_vm._s([
          _vm.regionData.region_classification,
          _vm.regionData.SV_type,
          [
            'chr' + _vm.regionData.SV_chrom,
            _vm.regionData.CytoBand
          ].map(function (v) { return '(' + v + ')'; }).join('')
        ].join(' '))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block flex-start width-full"},[_c('div',{staticClass:"data-content-block col-block"},[_c('div',{staticClass:"data-row row-block stretch"},_vm._l((_vm.tableOption['default']),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position, { hidden: !option.title }],style:({ flex: option.flex })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content",domProps:{"innerHTML":_vm._s(option.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0),_vm._v(" "),_vm._l((_vm.qualityDatas),function(qualityData,qdindex){return _c('div',{key:qdindex,staticClass:"data-row row-block stretch"},_vm._l((_vm.tableOption['default']),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position, { hidden: !option.title }],style:({ flex: option.flex, width: 0 })},[(option.value === 'genotype' && qualityData.GT !== undefined)?_c('div',{staticClass:"data-content quality-col genotype-container col-block",class:{ alert: false }},[_c('div',{staticClass:"quality-value-block row-block"},[_c('div',{staticClass:"quality-value"},[_vm._v(_vm._s(qualityData.GT_raw || qualityData.GT || 'N/A'))])])]):(option.value === 'genotypeQuality' && ![null, undefined].includes(qualityData.GQ))?_c('div',{staticClass:"data-content quality-col genotypeQuality-container col-block",class:{ alert: option.info && (qualityData.GQ || 0) < 20 }},[_c('div',{staticClass:"quality-value-block row-block"},[_c('div',{staticClass:"quality-value"},[_vm._v(_vm._s(qualityData.GQ || 0))])]),_vm._v(" "),(option.info)?[_c('div',{style:({ height: '0px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info-block row-block"},[_c('img',{style:({ width: '16px' }),attrs:{"src":__webpack_require__("6v0c")("./quality-" + ((qualityData.GQ || 0) < 15 ? 'nopass' : 'pass') + '-info-icon.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info",domProps:{"innerHTML":_vm._s((qualityData.GQ || 0) < 15 ? _vm.$t('DIALOG.caseDetailRegionQuality.pass.genotypeQuality.___noPass') : _vm.$t('DIALOG.caseDetailRegionQuality.pass.genotypeQuality.___pass'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]:_vm._e()],2):_c('div',{staticClass:"data-content",class:[option.break ? 'break-line' : 'ellipsis'],style:({ color: (option.color || (function () { return null; }))(qualityData[option.value], qualityData), 'max-height': option.maxHeight || 'auto' }),attrs:{"title":qualityData[option.value]},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(qualityData[option.value], qualityData) || option.empty || '- -')}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)})],2)]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"data-title-container row-block"},[_c('div',{staticClass:"data-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailRegionQuality.___infoTitle')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block flex-start width-full"},[_c('div',{staticClass:"data-content-block col-block"},[_c('div',{staticClass:"data-row row-block stretch"},_vm._l((_vm.tableOption['info1']),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position, { hidden: !option.title }],style:({ flex: option.flex })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content",domProps:{"innerHTML":_vm._s(option.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0),_vm._v(" "),_vm._l((_vm.qualityDatas),function(qualityData,qdindex){return _c('div',{key:qdindex,staticClass:"data-row row-block stretch"},_vm._l((_vm.tableOption['info1']),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position, { hidden: !option.title }],style:({ flex: option.flex, width: 0 })},[_c('div',{staticClass:"data-content",class:[option.break ? 'break-line' : 'ellipsis'],style:({ color: (option.color || (function () { return null; }))(qualityData[option.value], qualityData), 'max-height': option.maxHeight || 'auto' }),attrs:{"title":qualityData[option.value]},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(qualityData[option.value], qualityData) || option.empty || '- -')}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)})],2)]),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block flex-start width-full"},[_c('div',{staticClass:"data-content-block col-block"},[_c('div',{staticClass:"data-row row-block stretch"},_vm._l((_vm.tableOption['info2']),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position, { hidden: !option.title }],style:({ flex: option.flex })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content",domProps:{"innerHTML":_vm._s(option.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0),_vm._v(" "),_vm._l((_vm.qualityDatas),function(qualityData,qdindex){return _c('div',{key:qdindex,staticClass:"data-row row-block stretch"},_vm._l((_vm.tableOption['info2']),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position, { hidden: !option.title }],style:({ flex: option.flex, width: 0 })},[_c('div',{staticClass:"data-content",class:[option.break ? 'break-line' : 'ellipsis'],style:({ color: (option.color || (function () { return null; }))(qualityData[option.value], qualityData), 'max-height': option.maxHeight || 'auto' }),attrs:{"title":qualityData[option.value]},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(qualityData[option.value], qualityData) || option.empty || '- -')}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)})],2)])]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var caseDetailRegionQuality_staticRenderFns = []
var caseDetailRegionQuality_esExports = { render: caseDetailRegionQuality_render, staticRenderFns: caseDetailRegionQuality_staticRenderFns }
/* harmony default export */ var dialog_caseDetailRegionQuality = (caseDetailRegionQuality_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDetailRegionQuality.vue
var caseDetailRegionQuality_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDetailRegionQuality___vue_template_functional__ = false
/* styles */
var caseDetailRegionQuality___vue_styles__ = null
/* scopeId */
var caseDetailRegionQuality___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDetailRegionQuality___vue_module_identifier__ = null
var caseDetailRegionQuality_Component = caseDetailRegionQuality_normalizeComponent(
  caseDetailRegionQuality,
  dialog_caseDetailRegionQuality,
  caseDetailRegionQuality___vue_template_functional__,
  caseDetailRegionQuality___vue_styles__,
  caseDetailRegionQuality___vue_scopeId__,
  caseDetailRegionQuality___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDetailRegionQuality = (caseDetailRegionQuality_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/case/databaseOverlapGraph.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var databaseOverlapGraph = ({
  props: {
    points: {
      type: Object,
      required: true
    },
    result: {
      type: Number,
      default: function _default() {
        return null;
      }
    }
  },
  computed: {
    pointDatas: function pointDatas() {
      var allPoints = Object(util["m" /* sortData */])([].concat(toConsumableArray_default()(this.points['s'] || []), toConsumableArray_default()(this.points['d'] || [])), function (p) {
        return p;
      }, 'asc');
      if (allPoints.length !== 4) return;
      var start = allPoints[0];
      var range = allPoints[3] - allPoints[0];
      var sPoints = [allPoints[0]].concat(toConsumableArray_default()(this.points['s']), [allPoints[3]]).map(function (p) {
        return (p - start) / range;
      });
      var dPoints = [allPoints[0]].concat(toConsumableArray_default()(this.points['d']), [allPoints[3]]).map(function (p) {
        return (p - start) / range;
      });
      allPoints = allPoints.map(function (p) {
        return (p - start) / range;
      });
      return {
        all: allPoints,
        s: sPoints,
        d: dPoints,
        result: this.result !== null ? this.result : allPoints[2] - allPoints[1]
      };
    },

    // global
    fixNumber: function fixNumber() {
      return util["g" /* fixNumber */];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0de08b16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/databaseOverlapGraph.vue
var databaseOverlapGraph_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pointDatas)?_c('div',{staticClass:"database-overlap-graph-page row-block",style:({ width: '100%' })},[_c('div',{staticClass:"database-overlap-graph-result"},[_vm._v(_vm._s((Math.floor(_vm.fixNumber(_vm.pointDatas.result, 0.0001) * 10000) / 100 + '%').padStart(3, ' ')))]),_vm._v(" "),_c('div',{staticClass:"database-overlap-graph-line-container col-block width-full",style:({ flex: 1 })},_vm._l((['s', 'd', 'all']),function(type){return _c('div',{key:type,staticClass:"database-overlap-graph-line-block row-block",class:[type],style:({ flex: 1 })},_vm._l((_vm.pointDatas[type].filter(function (_, i) { return i; })),function(_,i){return _c('div',{key:type + i,staticClass:"database-overlap-graph-line",style:({ width: (_vm.pointDatas[type][i + 1] - _vm.pointDatas[type][i]) * 100 + '%' })})}),0)}),0)]):_vm._e()}
var databaseOverlapGraph_staticRenderFns = []
var databaseOverlapGraph_esExports = { render: databaseOverlapGraph_render, staticRenderFns: databaseOverlapGraph_staticRenderFns }
/* harmony default export */ var case_databaseOverlapGraph = (databaseOverlapGraph_esExports);
// CONCATENATED MODULE: ./src/components/case/databaseOverlapGraph.vue
var databaseOverlapGraph_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var databaseOverlapGraph___vue_template_functional__ = false
/* styles */
var databaseOverlapGraph___vue_styles__ = null
/* scopeId */
var databaseOverlapGraph___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var databaseOverlapGraph___vue_module_identifier__ = null
var databaseOverlapGraph_Component = databaseOverlapGraph_normalizeComponent(
  databaseOverlapGraph,
  case_databaseOverlapGraph,
  databaseOverlapGraph___vue_template_functional__,
  databaseOverlapGraph___vue_styles__,
  databaseOverlapGraph___vue_scopeId__,
  databaseOverlapGraph___vue_module_identifier__
)

/* harmony default export */ var components_case_databaseOverlapGraph = (databaseOverlapGraph_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/caseDetail/regionVariantData.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ var regionVariantData = ({
  components: {
    databaseOverlapGraph: components_case_databaseOverlapGraph,
    pageButtons: pageButtons["a" /* default */],
    borCor: newBorCor["a" /* default */]
  },
  mixins: [responsitive["a" /* default */], customGrab["a" /* default */], routeLoading["a" /* default */]],
  props: {
    type: {
      type: String,
      required: true
    },
    svID: {
      type: String,
      required: true
    },
    caseData: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    regionData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      datas: null,
      // table
      search: '',
      selectedTableData: null,
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [[], []],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      pageData: {
        selectedPage: 1,
        display: 20,
        total: 3000,
        buttonRange: 7
      },
      detailData: null,
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    };
  },

  computed: {
    tableDatas: function tableDatas() {
      var _this = this;

      var tableDatas = this.datas || [];
      tableDatas = Object(util["m" /* sortData */])(tableDatas, this.sort.value.map(function (x) {
        return _this.sortMap[x];
      }), this.sort.order.map(function (x) {
        return x.replace('-', '');
      }));
      tableDatas = Object(util["i" /* groupBy */])(tableDatas, function () {
        return 'default';
      }).map(function (datas) {
        return { title: datas[0].group, isGroup: true, datas: datas };
      });
      return tableDatas;
    },
    sortMap: function sortMap() {
      return this.tableOptions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortMap || c.value));
      }, {});
    },

    // static
    overviewOptions: function overviewOptions() {
      var overviewOptions = {
        'dbVar': global_data["T" /* svClinvarOptions */],
        'DECIPHER': global_data["U" /* svDECIPHEROptions */]
      }[this.type];
      overviewOptions = overviewOptions.filter(function (option) {
        return (option.order || {})['overview'];
      });
      overviewOptions = Object(util["m" /* sortData */])(overviewOptions, function (option) {
        return option.order['overview'];
      }, 'asc');
      return overviewOptions;
    },
    tableOptions: function tableOptions() {
      var _this2 = this;

      var classificationOptionMap = {
        'dbVar': global_data["T" /* svClinvarOptions */].reduce(function (map, option) {
          return extends_default()({}, map, defineProperty_default()({}, option.value, option));
        }, {}),
        'DECIPHER': global_data["U" /* svDECIPHEROptions */].reduce(function (map, option) {
          return extends_default()({}, map, defineProperty_default()({}, option.value, option));
        }, {})
      };
      var tableOptions = {
        'dbVar': [{
          title: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.title.___dbVarID'),
          value: 'id',
          display: function display(_, __, data) {
            return data.d_dbvarid || data.d_regionid;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          link: function link(_, __, data) {
            return 'https://www.ncbi.nlm.nih.gov/dbvar/variants/' + (data.d_dbvarid || data.d_regionid) + '/';
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.title.___Location'),
          value: 'location',
          display: function display(_, __, data) {
            return data.d_chr + ':' + data.d_start + '-' + data.d_end;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.title.___Size'),
          value: 'd_svlen',
          display: function display(value) {
            return value ? (Object(util["b" /* convertNumberCount */])(value, ' ', 0.01, false, 2) + 'b').replace(/ b$/, ' bp') : null;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.title.___Classification'),
          value: 'd_classification',
          class: function _class() {
            return ['center', 'auto-width'];
          },
          display: function display(value) {
            value = value ? value.replace(/"/g, '').replace(/ /g, '_') : value;
            var option = classificationOptionMap['dbVar'][value];
            return option && option.title ? _this2.$t(option.title) : value;
          },
          style: function style(value) {
            value = value ? value.replace(/"/g, '').replace(/ /g, '_') : value;
            var option = classificationOptionMap['dbVar'][value];
            return option ? { color: option.color || '#333333', fontWeight: option.bold ? 'bold' : '400' } : null;
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.title.___Overlapinfo'),
          value: 'overlap_info',
          pointData: function pointData(data) {
            return { 's': [data.s_start, data.s_end], 'd': [data.d_start, data.d_end] };
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          titleInfo: '_OVERLAPINFO',
          overlapInfo: {
            title: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.___title'),
            infos: [{
              title: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.type.___pathogenic'),
              formula: {
                result: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.formula.___result'),
                denominator: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.formula.___denominatorFeature'),
                numerator: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.formula.___numerator')
              }
            }, {
              title: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.type.___other'),
              formula: {
                result: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.formula.___result'),
                denominator: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.formula.___denominatorSV'),
                numerator: this.$t('COMPONENT.caseDetail.regionVariantData.table.dbVar.titleInfo.overlapInfo.formula.___numerator')
              }
            }]
          },
          sortMap: null
        }],
        'DECIPHER': [{
          title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.title.___DECIPHERID'),
          value: 'd_patientid',
          display: function display(value) {
            return value ? value + '' : null;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          link: function link(value) {
            return 'https://www.deciphergenomics.org/patient/' + value + '/genotype/' + value + '/browser';
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.title.___Location'),
          value: 'location',
          display: function display(_, __, data) {
            return data.d_chr + ':' + data.d_start + '-' + data.d_end;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.title.___Size'),
          value: 'd_svlen',
          display: function display(value) {
            return value ? (Object(util["b" /* convertNumberCount */])(value, ' ', 0.01, false, 2) + 'b').replace(/ b$/, ' bp') : null;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.title.___Classification'),
          value: 'd_classification',
          class: function _class() {
            return ['center', 'auto-width'];
          },
          display: function display(value) {
            value = value ? value.replace(/"/g, '').replace(/ /g, '_') : value;
            var option = classificationOptionMap['dbVar'][value];
            return option && option.title ? _this2.$t(option.title) : value;
          },
          style: function style(value) {
            value = value ? value.replace(/"/g, '').replace(/ /g, '_') : value;
            var option = classificationOptionMap['dbVar'][value];
            return option ? { color: option.color || '#333333', fontWeight: option.bold ? 'bold' : '400' } : null;
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.title.___Zygosity'),
          value: 'd_genotype',
          class: function _class() {
            return ['center', 'auto-width'];
          },
          display: function display(value) {
            return value ? value.slice(0, 3) : null;
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.title.___Phenotype'),
          value: 'phenotype',
          phenotypeData: function phenotypeData(data) {
            var phenotypes = data.d_phenotype.replace(/"/g, '').split('; ').filter(function (x) {
              return x;
            });
            return {
              display: !phenotypes.length ? '- -' : phenotypes.slice(0, 2).join(';') + (phenotypes.length > 2 ? '; ...' : ''),
              datas: phenotypes
            };
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.title.___Overlapinfo'),
          value: 'overlap_info',
          pointData: function pointData(data) {
            return { 's': [data.s_start, data.s_end], 'd': [data.d_start, data.d_end] };
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          titleInfo: '_OVERLAPINFO',
          overlapInfo: {
            title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.___title'),
            infos: [{
              title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.type.___pathogenic'),
              formula: {
                result: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.formula.___result'),
                denominator: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.formula.___denominatorFeature'),
                numerator: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.formula.___numerator')
              }
            }, {
              title: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.type.___other'),
              formula: {
                result: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.formula.___result'),
                denominator: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.formula.___denominatorSV'),
                numerator: this.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.titleInfo.overlapInfo.formula.___numerator')
              }
            }]
          },
          sortMap: null
        }]
      };
      return tableOptions[this.type];
    },
    detailOptions: function detailOptions() {
      return {
        'phenotype': {
          display: function display(value) {
            return value.replace(/"/g, '');
          }
        }
      };
    },
    overlapInfoInfos: function overlapInfoInfos() {
      return [{
        title: this.$t('COMPONENT.caseDetail.regionVariantData.table.overlapInfo.title.___sample'),
        color: '#003679'
      }, {
        title: this.$t('COMPONENT.caseDetail.regionVariantData.table.overlapInfo.title.___db'),
        color: '#999999'
      }];
    },

    // global
    toPriceString: function toPriceString() {
      return util["r" /* toPriceString */];
    }
  },
  watch: {
    // table
    'selectedTableData': function selectedTableData(nv, ov) {
      if (nv !== ov && stringify_default()(nv) !== stringify_default()(ov)) {
        this.selectedTableData = nv ? JSON.parse(stringify_default()(nv)) : null;
      }
    },
    'tableDatas': function tableDatas() {
      this.getTableOverflow();
    },
    'windowWidth': function windowWidth(nv) {
      this.getTableWidths(nv);
      this.getTableOverflow();
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction']), {
    fetchData: function fetchData() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.fetchVariantDatas(true);

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    fetchVariantDatas: function fetchVariantDatas() {
      var _this4 = this;

      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, id, projectID, svID, response, tableData, tableName, data, datas;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this4.$ls.get('userInfo');
                id = _this4.caseData.id;
                projectID = _this4.project.id;
                svID = _this4.svID;
                response = null;
                // table

                if (_this4.tableName) {
                  _context2.next = 13;
                  break;
                }

                tableData = {};
                _context2.next = 10;
                return Object(src_api["_0" /* getCaseProjectRegionVariantTable */])(id, projectID, tableData, config);

              case 10:
                response = _context2.sent;
                tableName = !global_config["a" /* _LOCAL_BUILD */] ? response.data.data.table_name : response.data.data.session;

                _this4.tableName = tableName;

              case 13:
                // query
                reset && (_this4.pageData.selectedPage = 1);
                data = {
                  table_name: _this4.tableName,
                  session: _this4.tableName,
                  db_name: _this4.type,
                  limit: 20,
                  page: _this4.pageData.selectedPage
                };
                _context2.next = 17;
                return Object(src_api["Z" /* getCaseProjectRegionVariant */])(id, projectID, svID, data, config);

              case 17:
                response = _context2.sent;
                datas = response.data.data.data;

                reset && (_this4.pageData.total = response.data.data.total_count - 0);
                _this4.datas = datas;
                _context2.next = 28;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2['catch'](0);

                _this4.pageData.total = 0;
                _this4.datas = [];
                throw _context2.t0;

              case 28:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 23]]);
      }))();
    },
    searchDatas: function searchDatas() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.setLoadingAction(true);
                _context3.next = 3;
                return _this5.fetchVariantDatas();

              case 3:
                _this5.$refs['custom-table-scroll'].scrollTop = 0;
                _this5.setLoadingAction(false);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },

    // table
    getTableOverflow: function getTableOverflow() {
      var _this6 = this;

      setTimeout(function () {
        var scrollContainer = _this6.$refs['custom-table-scroll'];
        if (scrollContainer) {
          _this6.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight;
        }
      });
    },
    getTableWidths: function getTableWidths(windowWidth) {
      var tableWidth = Math.min(windowWidth * 0.95, 1208) - 22 * 2;
      tableWidth = tableWidth - this.staticTableWidths[0].reduce(function (s, c) {
        return s + c;
      }, 0) - this.staticTableWidths[1].reduce(function (s, c) {
        return s + c;
      }, 0);
      var defaultWidth = {
        'dbVar': [199, 259, 146, 244, 320],
        'DECIPHER': [106, 204, 96, 174, 90, 178, 320]
      }[this.type];
      var tableWidths = this.tableWidths || [].concat(toConsumableArray_default()(this.staticTableWidths[0]), toConsumableArray_default()(defaultWidth), toConsumableArray_default()(this.staticTableWidths[1])).map(function (width) {
        return {
          value: width
        };
      });
      var tableMinWidths = this.tableMinWidths || 0.1;
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length);
      var ratio = tableWidth / tableWidths.reduce(function (s, c) {
        return s + c.value;
      }, 0);
      tableWidths = Array.prototype.concat.apply([], [this.staticTableWidths[0].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      }), tableWidths.map(function (width) {
        return {
          value: width.value * ratio,
          grab: 0
        };
      }), this.staticTableWidths[1].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      })]);
      this.tableMinWidths = tableMinWidths * ratio;
      this.tableWidths = tableWidths;
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
    },

    // grab
    boardResponse: function boardResponse(id, type) {
      var _this7 = this;

      return {
        'board1': {
          'start': function start(boardData) {
            _this7.sort.disabled = true;
          },
          'move': function move(boardData) {
            if (_this7.boardType['board1'] === 'grab') {
              var grabID = _this7.boardData[id].grabID;
              var tableWidths = [].concat(toConsumableArray_default()(_this7.tableWidths));
              var result = boardData.grabX - boardData.baseX;
              var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this7.staticTableWidths[1].length).reduce(function (s, c, i) {
                return s + c.value - (_this7.tableOptions[i].minWidth || _this7.tableMinWidths);
              }, 0);
              tableWidths.forEach(function (_, i) {
                if (i === grabID) {
                  tableWidths[i].grab = result;
                }if (i > grabID && i + _this7.staticTableWidths[1].length < tableWidths.length) {
                  tableWidths[i].grab = -(result * ((tableWidths[i].value - (_this7.tableOptions[i].minWidth || _this7.tableMinWidths)) / ratioBase));
                }
              });
              _this7.tableWidths = tableWidths;
            }
          },
          'end': function end(boardData) {
            var grabID = _this7.boardData[id].grabID;
            var tableWidths = [].concat(toConsumableArray_default()(_this7.tableWidths));
            var result = boardData.grabX - boardData.baseX;
            var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this7.staticTableWidths[1].length).reduce(function (s, c, i) {
              return s + c.value - (_this7.tableOptions[i].minWidth || _this7.tableMinWidths);
            }, 0);
            tableWidths.forEach(function (_, i) {
              tableWidths[i].grab = 0;
              if (i === grabID) {
                tableWidths[i].value += result;
              }if (i > grabID && i + _this7.staticTableWidths[1].length < tableWidths.length) {
                tableWidths[i].value -= result * ((tableWidths[i].value - (_this7.tableOptions[i].minWidth || _this7.tableMinWidths)) / ratioBase);
              }
            });
            _this7.tableWidths = tableWidths;
            setTimeout(function () {
              _this7.sort.disabled = false;
            });
          }
        }
      }[id][type];
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48372434","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/caseDetail/regionVariantData.vue
var regionVariantData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.datas)?_c('div',{staticClass:"case-detail-region-variant-data-page col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"region-variant-data-overview-container col-block width-full"},[_c('div',{staticClass:"region-variant-data-overview-title-container row-block"},[_c('div',{staticClass:"region-variant-data-overview-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.caseDetail.regionVariantData.___overViewTitle')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"region-variant-data-overview-list-container row-block flex-wrap stretch"},_vm._l((_vm.overviewOptions),function(option,oindex){return _c('div',{key:oindex,staticClass:"region-variant-data-overview-data-container col-block stretch"},[_c('div',{staticClass:"region-variant-data-overview-data-header-container center-block"},[_c('div',{staticClass:"region-variant-data-overview-data-header",style:({ color: option.color, 'font-weight': option.bold ? 'bold' : '400' })},[_vm._v(_vm._s(_vm.$t(option.subtitle)))])]),_vm._v(" "),_c('div',{staticClass:"region-variant-data-overview-data-body-container center-block break-line"},[_c('div',{staticClass:"region-variant-data-overview-data-body"},[_vm._v(_vm._s(_vm.regionData[option.countValue]))])]),_vm._v(" "),_c('a',{style:({ flex: 1 })})])}),0)]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"region-variant-data-main-container col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"custom-table",class:{ 'auto-height': false }},[(_vm.tableWidths)?_c('div',{staticClass:"table-field col-block grab-container",style:({ width: _vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) + 'px' }),on:{"mousedown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardStart]); })($event)},"mousemove":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseout":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardEnd]); })($event)}}},[_c('div',{staticClass:"grab-line x min",style:(_vm.lineData.x.min && _vm.lineData.x.min.display ? { left: _vm.lineData.x.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x max",style:(_vm.lineData.x.max && _vm.lineData.x.max.display ? { left: _vm.lineData.x.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x main",style:(_vm.lineData.x.main && _vm.lineData.x.main.display ? { left: (_vm.lineData.x.main.base + _vm.lineData.x.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x custom",style:(_vm.lineData.x.custom && _vm.lineData.x.custom.display ? { left: _vm.lineData.x.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y min",style:(_vm.lineData.y.min && _vm.lineData.y.min.display ? { top: _vm.lineData.y.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y max",style:(_vm.lineData.y.max && _vm.lineData.y.max.display ? { top: _vm.lineData.y.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y main",style:(_vm.lineData.y.main && _vm.lineData.y.main.display ? { top: (_vm.lineData.y.main.base + _vm.lineData.y.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y custom",style:(_vm.lineData.y.custom && _vm.lineData.y.custom.display ? { top: _vm.lineData.y.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"table-container col-block"},[_c('div',{staticClass:"thead"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab + 'px' }),on:{"click":function (e) { return !_vm.sort.disabled && option.sortMap !== null && _vm.tableSortBy(option.sortValue || option.value); }}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.titleInfo)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('borCor',{attrs:{"reverse":true,"background":'white',"border":'#CCCCCC',"radius":'0px',"blockStyle":{ padding: '8px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("d5V5"),"alt":""}})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(option.titleInfo === '_OVERLAPINFO')?[_c('div',{staticClass:"overlap-info-container col-block flex-start"},[(option.overlapInfo.title)?_c('div',{staticClass:"overlap-info-title"},[_vm._v(_vm._s(option.overlapInfo.title))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"overlap-info-content-container col-block width-full"},_vm._l((option.overlapInfo.infos),function(info,iindex){return _c('div',{key:iindex,staticClass:"overlap-info-content-block col-block flex-start"},[(info.title)?_c('div',{staticClass:"overlap-info-content-title"},[_vm._v(_vm._s(info.title + ':'))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"overlap-info-formula-container row-block"},[_c('div',{staticClass:"overlap-info-formula-result"},[_vm._v(_vm._s(info.formula.result))]),_vm._v(" "),_c('div',{staticClass:"overlap-info-formula-equal"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"overlap-info-formula-content col-block"},[_c('div',{staticClass:"overlap-info-formula-numerator"},[_vm._v(_vm._s(info.formula.numerator))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"overlap-info-formula-denominator"},[_vm._v(_vm._s(info.formula.denominator))])])])])}),0)])]:[_c('div',[_vm._v(_vm._s(option.titleInfo))])]],2)])]:_vm._e(),_vm._v(" "),(option.value === 'overlap_info')?[_c('div',{staticClass:"overlap-info-info-container row-block"},_vm._l((_vm.overlapInfoInfos),function(info,oiindex){return _c('div',{key:oiindex,staticClass:"overlap-info-info-block row-block"},[_c('div',{staticClass:"overlap-info-info-icon",style:({ '--icon-color': info.color })}),_vm._v(" "),_c('div',{staticClass:"overlap-info-info-title"},[_vm._v(": "+_vm._s(info.title))])])}),0)]:_vm._e(),_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e()],2)}),0)])]),_vm._v(" "),_c('div',{ref:"custom-table-scroll",staticClass:"table-group-container col-block width-full"},[_c('div',{staticClass:"col-block"},_vm._l((_vm.tableDatas),function(group,gindex){return _c('div',{key:gindex,staticClass:"table-container col-block"},[_c('div',{staticClass:"tbody"},[_c('div',{staticClass:"tr group row-block",class:{ selected: false },style:(group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' })},[_c('a',{staticClass:"container-block row-block"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(group[option.gValue], gindex, group),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.gstyle || (function () { return ({}); }))(group[option.gValue], gindex, group)),attrs:{"title":((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || option.gempty || '')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('center') && !(option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)]),_vm._v(" "),_vm._l((group.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"tr col-block",class:{ selectable: false, selected: false }},[_c('a',{staticClass:"container-block row-block",style:({ flex: 1 }),on:{"click":function (e) { return false && (_vm.selectedTableData = data); }}},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(data[option.value], dindex, data),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[(option.value === 'overlap_info')?[_c('databaseOverlapGraph',{attrs:{"points":option.pointData(data),"result":data.d_overlap_pct}})]:(option.value === 'phenotype')?[_c('span',{staticClass:"break-line"},[_vm._v(_vm._s(option.phenotypeData(data).display)),( option.phenotypeData(data).datas.length > 2)?_c('a',{staticClass:"link",on:{"click":function (e) { return _vm.detailData = { type: 'phenotype', id: data.d_patientid, data: data }; }}},[_vm._v("("+_vm._s(_vm.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.content.___more'))+")")]):_vm._e()])]:[_c('span',{style:((option.style || (function () { return ({}); }))(data[option.value], dindex, data)),attrs:{"title":((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || option.empty || '- -')}})],_vm._v(" "),(option.link)?[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('a',{attrs:{"href":option.link(data[option.value], dindex, data),"target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("wtkH"),"alt":""}})])]:_vm._e(),_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(data[option.value], dindex, data).includes('center') && !(option.class || (function () { return []; }))(data[option.value], dindex, data).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2),_vm._v(" "),((_vm.detailData || {}).id === data.d_patientid)?_c('div',{staticClass:"data-detail-container col-block width-full"},[_c('div',{staticClass:"data-detail-hide-container col-block width-full"},[_c('div',{staticClass:"data-detail-hide-block row-block",on:{"click":function (e) { return _vm.detailData = null; }}},[_c('div',{style:({ width: '16px' })}),_vm._v(" "),_c('div',{staticClass:"data-detail-hide-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.detailData.___hideTitle')))]),_vm._v(" "),_c('img',{style:({ width: '25px' }),attrs:{"src":__webpack_require__("Lem6"),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })})])]),_vm._v(" "),(_vm.detailData.type === 'phenotype')?[_c('div',{staticClass:"data-detail-phenotype-container col-block width-full"},[_c('div',{staticClass:"data-detail-phenotype-title-container row-block"},[_c('div',{staticClass:"data-detail-phenotype-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.caseDetail.regionVariantData.table.DECIPHER.detailData.phenotype.___title', { id: data.d_patientid })))])]),_vm._v(" "),_c('div',{staticClass:"data-detail-phenotype-content-container col-block width-full"},[_c('div',{staticClass:"data-detail-phenotype-content",domProps:{"innerHTML":_vm._s(_vm.detailOptions['phenotype'].display(data.d_phenotype))}})])])]:_vm._e()],2):_vm._e()])})],2)])}),0)])]):_vm._e()]),_vm._v(" "),(_vm.pageData)?_c('div',{staticClass:"region-variant-data-page-container row-block"},[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"region-variant-data-page-total"},[_vm._v(_vm._s(_vm.$t('COMPONENT.caseDetail.regionVariantData.page.___total', { total: _vm.toPriceString(_vm.pageData.total) })))]),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"region-variant-data-page-display"},[_vm._v(_vm._s(_vm.$t('COMPONENT.caseDetail.regionVariantData.page.___display', { display: _vm.pageData.display })))]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('pageButtons',{attrs:{"default":_vm.pageData.selectedPage,"display":_vm.pageData.display - 0,"total":_vm.pageData.total,"buttonRange":_vm.pageData.buttonRange},on:{"selectPage":function (page) { _vm.pageData.selectedPage = page; _vm.searchDatas() }}})],1):_vm._e()])]):_vm._e()}
var regionVariantData_staticRenderFns = []
var regionVariantData_esExports = { render: regionVariantData_render, staticRenderFns: regionVariantData_staticRenderFns }
/* harmony default export */ var caseDetail_regionVariantData = (regionVariantData_esExports);
// CONCATENATED MODULE: ./src/components/caseDetail/regionVariantData.vue
var regionVariantData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var regionVariantData___vue_template_functional__ = false
/* styles */
var regionVariantData___vue_styles__ = null
/* scopeId */
var regionVariantData___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var regionVariantData___vue_module_identifier__ = null
var regionVariantData_Component = regionVariantData_normalizeComponent(
  regionVariantData,
  caseDetail_regionVariantData,
  regionVariantData___vue_template_functional__,
  regionVariantData___vue_styles__,
  regionVariantData___vue_scopeId__,
  regionVariantData___vue_module_identifier__
)

/* harmony default export */ var components_caseDetail_regionVariantData = (regionVariantData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDetailRegionVariant.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var caseDetailRegionVariant = ({
  components: {
    regionVariantData: components_caseDetail_regionVariantData
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      tab: this.param.tab || 'dbVar'
    };
  },

  computed: {
    // static
    tabOptions: function tabOptions() {
      return [{
        title: this.$t('DIALOG.caseDetailRegionVariant.tab.title.___DECIPHER'),
        value: 'DECIPHER'
      }, {
        title: this.$t('DIALOG.caseDetailRegionVariant.tab.title.___dbVar'),
        value: 'dbVar'
      }];
    },

    // param
    regionData: function regionData() {
      return this.param.regionData;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2416e2f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDetailRegionVariant.vue
var caseDetailRegionVariant_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-region-variant-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailRegionVariant.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"data-container col-block",style:({ flex: 1 })},[_c('div',{staticClass:"data-title-container row-block"},[_c('div',{staticClass:"data-title",domProps:{"innerHTML":_vm._s([
          _vm.regionData.region_classification,
          _vm.regionData.SV_type,
          [
            'chr' + _vm.regionData.SV_chrom,
            _vm.regionData.CytoBand
          ].map(function (v) { return '(' + v + ')'; }).join('')
        ].join(' '))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"data-tab-list-container row-block"},[_c('div',{staticClass:"data-tab-list-block row-block"},_vm._l((_vm.tabOptions),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-tab-field col-block width-full",class:{ active: option.value === _vm.tab },on:{"click":function (e) { return _vm.tab = option.value; }}},[_c('div',{staticClass:"data-tab-container center-block"},[_c('div',{staticClass:"data-tab-block row-block"},[_c('div',{staticClass:"data-tab-title"},[_vm._v(_vm._s(option.title))])])])])}),0),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block width-full",style:({ flex: 1 })},_vm._l((_vm.tabOptions),function(option,oindex){return _c('regionVariantData',_vm._b({directives:[{name:"show",rawName:"v-show",value:(option.value === _vm.tab),expression:"option.value === tab"}],key:oindex,attrs:{"type":option.value}},'regionVariantData',_vm.param,false))}),1)]),_vm._v(" "),_c('div',{style:({ height: '0' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var caseDetailRegionVariant_staticRenderFns = []
var caseDetailRegionVariant_esExports = { render: caseDetailRegionVariant_render, staticRenderFns: caseDetailRegionVariant_staticRenderFns }
/* harmony default export */ var dialog_caseDetailRegionVariant = (caseDetailRegionVariant_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDetailRegionVariant.vue
var caseDetailRegionVariant_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDetailRegionVariant___vue_template_functional__ = false
/* styles */
var caseDetailRegionVariant___vue_styles__ = null
/* scopeId */
var caseDetailRegionVariant___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDetailRegionVariant___vue_module_identifier__ = null
var caseDetailRegionVariant_Component = caseDetailRegionVariant_normalizeComponent(
  caseDetailRegionVariant,
  dialog_caseDetailRegionVariant,
  caseDetailRegionVariant___vue_template_functional__,
  caseDetailRegionVariant___vue_styles__,
  caseDetailRegionVariant___vue_scopeId__,
  caseDetailRegionVariant___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDetailRegionVariant = (caseDetailRegionVariant_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/caseDetail/regionPublicationData.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var regionPublicationData = ({
  components: {
    databaseOverlapGraph: components_case_databaseOverlapGraph,
    pageButtons: pageButtons["a" /* default */],
    borCor: newBorCor["a" /* default */]
  },
  mixins: [responsitive["a" /* default */], customGrab["a" /* default */], routeLoading["a" /* default */]],
  props: {
    type: {
      type: String,
      required: true
    },
    tableName: {
      type: String,
      required: true
    },
    svID: {
      type: String,
      required: true
    },
    caseData: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      datas: null,
      // table
      search: '',
      selectedTableData: null,
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [[], []],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      pageData: {
        selectedPage: 1,
        display: 20,
        total: 0,
        buttonRange: 7
      },
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    };
  },

  computed: {
    tableDatas: function tableDatas() {
      var _this = this;

      var tableDatas = this.datas || [];
      tableDatas = Object(util["m" /* sortData */])(tableDatas, this.sort.value.map(function (x) {
        return _this.sortMap[x];
      }), this.sort.order.map(function (x) {
        return x.replace('-', '');
      }));
      tableDatas = Object(util["i" /* groupBy */])(tableDatas, function () {
        return 'default';
      }).map(function (datas) {
        return { title: datas[0].group, isGroup: true, datas: datas };
      });
      return tableDatas;
    },
    sortMap: function sortMap() {
      return this.tableOptions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortMap || c.value));
      }, {});
    },

    // static
    tableOptions: function tableOptions() {
      var tableOptions = {
        'gnomAD': [{
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.gnomAD.title.___gnomADID'),
          value: 'd_svid',
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.gnomAD.title.___Location'),
          value: 'location',
          display: function display(_, __, data) {
            return data.d_chr + ':' + data.d_start + '-' + data.d_end;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.gnomAD.title.___Size'),
          value: 'd_svlen',
          display: function display(value) {
            return value ? (Object(util["b" /* convertNumberCount */])(value, ' ', 0.01, false, 2) + 'b').replace(/ b$/, ' bp') : null;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.gnomAD.title.___AlleleFrequency'),
          value: 'd_af',
          display: function display(value) {
            return value ? value + '' : null;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.gnomAD.title.___Overlapinfo'),
          value: 'overlap_info',
          pointData: function pointData(data) {
            return { 's': [data.s_start, data.s_end], 'd': [data.d_start, data.d_end] };
          },
          result: function result(data) {
            return data.d_overlap_pct;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          titleInfo: '_OVERLAPINFO',
          overlapInfo: {
            title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.gnomAD.titleInfo.overlapInfo.___title'),
            infos: [{
              formula: {
                result: this.$t('COMPONENT.caseDetail.regionPublicationData.table.gnomAD.titleInfo.overlapInfo.formula.___result'),
                denominator: this.$t('COMPONENT.caseDetail.regionPublicationData.table.gnomAD.titleInfo.overlapInfo.formula.___denominatorSV'),
                numerator: this.$t('COMPONENT.caseDetail.regionPublicationData.table.gnomAD.titleInfo.overlapInfo.formula.___numerator')
              }
            }]
          },
          sortMap: null
        }],
        'dbVar': [{
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.dbVar.title.___dbVarID'),
          value: 'd_svid',
          class: function _class() {
            return ['center', 'auto-width'];
          },
          link: function link(value) {
            return 'https://www.ncbi.nlm.nih.gov/dbvar/variants/' + value + '/';
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.dbVar.title.___Location'),
          value: 'location',
          display: function display(_, __, data) {
            return data.d_chr + ':' + data.d_start + '-' + data.d_end;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.dbVar.title.___Size'),
          value: 'd_svlen',
          display: function display(value) {
            return value ? (Object(util["b" /* convertNumberCount */])(value, ' ', 0.01, false, 2) + 'b').replace(/ b$/, ' bp') : null;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.dbVar.title.___AlleleFrequency'),
          value: 'd_af',
          display: function display(value) {
            return value ? value + '' : null;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.dbVar.title.___Overlapinfo'),
          value: 'overlap_info',
          pointData: function pointData(data) {
            return { 's': [data.s_start, data.s_end], 'd': [data.d_start, data.d_end] };
          },
          result: function result(data) {
            return data.d_overlap_pct;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          titleInfo: '_OVERLAPINFO',
          overlapInfo: {
            title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.dbVar.titleInfo.overlapInfo.___title'),
            infos: [{
              formula: {
                result: this.$t('COMPONENT.caseDetail.regionPublicationData.table.dbVar.titleInfo.overlapInfo.formula.___result'),
                denominator: this.$t('COMPONENT.caseDetail.regionPublicationData.table.dbVar.titleInfo.overlapInfo.formula.___denominatorSV'),
                numerator: this.$t('COMPONENT.caseDetail.regionPublicationData.table.dbVar.titleInfo.overlapInfo.formula.___numerator')
              }
            }]
          },
          sortMap: null
        }],
        'JSV2': [{
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.JSV2.title.___JSV2ID'),
          value: 'j_svid',
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.JSV2.title.___Location'),
          value: 'location',
          display: function display(_, __, data) {
            return data.j_chr + ':' + data.j_start + '-' + data.j_end;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.JSV2.title.___Size'),
          value: 'j_svlen',
          display: function display(value) {
            return value ? (Object(util["b" /* convertNumberCount */])(value, ' ', 0.01, false, 2) + 'b').replace(/ b$/, ' bp') : null;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.JSV2.title.___AlleleFrequency'),
          value: 'j_af',
          display: function display(value) {
            return value ? value + '' : null;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.JSV2.title.___Overlapinfo'),
          value: 'overlap_info',
          pointData: function pointData(data) {
            return { 's': [data.s_start, data.s_end], 'd': [data.j_start, data.j_end] };
          },
          result: function result(data) {
            return data.overlap_pct;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          titleInfo: '_OVERLAPINFO',
          overlapInfo: {
            title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.JSV2.titleInfo.overlapInfo.___title'),
            infos: [{
              formula: {
                result: this.$t('COMPONENT.caseDetail.regionPublicationData.table.JSV2.titleInfo.overlapInfo.formula.___result'),
                denominator: this.$t('COMPONENT.caseDetail.regionPublicationData.table.JSV2.titleInfo.overlapInfo.formula.___denominatorSV'),
                numerator: this.$t('COMPONENT.caseDetail.regionPublicationData.table.JSV2.titleInfo.overlapInfo.formula.___numerator')
              }
            }]
          },
          sortMap: null
        }],
        'CoLoRSdb': [{
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.CoLoRSdb.title.___CoLoRSdbID'),
          value: 'c_svid',
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.CoLoRSdb.title.___Location'),
          value: 'location',
          display: function display(_, __, data) {
            return data.c_chr + ':' + data.c_start + '-' + data.c_end;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.CoLoRSdb.title.___Size'),
          value: 'c_svlen',
          display: function display(value) {
            return value ? (Object(util["b" /* convertNumberCount */])(value, ' ', 0.01, false, 2) + 'b').replace(/ b$/, ' bp') : null;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.CoLoRSdb.title.___AlleleFrequency'),
          value: 'c_af',
          display: function display(value) {
            return value ? value + '' : null;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          sortMap: null
        }, {
          title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.CoLoRSdb.title.___Overlapinfo'),
          value: 'overlap_info',
          pointData: function pointData(data) {
            return { 's': [data.s_start, data.s_end], 'd': [data.c_start, data.c_end] };
          },
          result: function result(data) {
            return data.overlap_pct;
          },
          class: function _class() {
            return ['center', 'auto-width'];
          },
          titleInfo: '_OVERLAPINFO',
          overlapInfo: {
            title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.CoLoRSdb.titleInfo.overlapInfo.___title'),
            infos: [{
              formula: {
                result: this.$t('COMPONENT.caseDetail.regionPublicationData.table.CoLoRSdb.titleInfo.overlapInfo.formula.___result'),
                denominator: this.$t('COMPONENT.caseDetail.regionPublicationData.table.CoLoRSdb.titleInfo.overlapInfo.formula.___denominatorSV'),
                numerator: this.$t('COMPONENT.caseDetail.regionPublicationData.table.CoLoRSdb.titleInfo.overlapInfo.formula.___numerator')
              }
            }]
          },
          sortMap: null
        }]
      };
      return tableOptions[this.type];
    },
    overlapInfoInfos: function overlapInfoInfos() {
      return [{
        title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.overlapInfo.title.___sample'),
        color: '#003679'
      }, {
        title: this.$t('COMPONENT.caseDetail.regionPublicationData.table.overlapInfo.title.___db'),
        color: '#999999'
      }];
    },

    // global
    toPriceString: function toPriceString() {
      return util["r" /* toPriceString */];
    }
  },
  watch: {
    // table
    'selectedTableData': function selectedTableData(nv, ov) {
      if (nv !== ov && stringify_default()(nv) !== stringify_default()(ov)) {
        this.selectedTableData = nv ? JSON.parse(stringify_default()(nv)) : null;
      }
    },
    'tableDatas': function tableDatas() {
      this.getTableOverflow();
    },
    'windowWidth': function windowWidth(nv) {
      this.getTableWidths(nv);
      this.getTableOverflow();
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction']), {
    fetchData: function fetchData() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.fetchPublicationDatas(true);

              case 2:
                _this2.$emit('loaded', _this2.pageData.total);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fetchPublicationDatas: function fetchPublicationDatas() {
      var _this3 = this;

      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, id, projectID, svID, data, response, datas;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this3.$ls.get('userInfo');
                id = _this3.caseData.id;
                projectID = _this3.project.id;
                svID = _this3.svID;

                reset && (_this3.pageData.selectedPage = 1);
                data = {
                  table_name: _this3.tableName,
                  session: _this3.tableName,
                  db_name: _this3.type,
                  limit: 20,
                  page: _this3.pageData.selectedPage
                };
                _context2.next = 9;
                return Object(src_api["W" /* getCaseProjectRegionPublication */])(id, projectID, svID, data, config);

              case 9:
                response = _context2.sent;
                datas = response.data.data.data;

                reset && (_this3.pageData.total = response.data.data.total_count - 0);
                _this3.datas = datas;
                _context2.next = 20;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](0);

                _this3.pageData.total = 0;
                _this3.datas = [];
                throw _context2.t0;

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 15]]);
      }))();
    },
    searchDatas: function searchDatas() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.setLoadingAction(true);
                _context3.next = 3;
                return _this4.fetchPublicationDatas();

              case 3:
                _this4.$refs['custom-table-scroll'].scrollTop = 0;
                _this4.setLoadingAction(false);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },

    // table
    getTableOverflow: function getTableOverflow() {
      var _this5 = this;

      setTimeout(function () {
        var scrollContainer = _this5.$refs['custom-table-scroll'];
        if (scrollContainer) {
          _this5.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight;
        }
      });
    },
    getTableWidths: function getTableWidths(windowWidth) {
      var tableWidth = Math.min(windowWidth * 0.95, 1208) - 22 * 2;
      tableWidth = tableWidth - this.staticTableWidths[0].reduce(function (s, c) {
        return s + c;
      }, 0) - this.staticTableWidths[1].reduce(function (s, c) {
        return s + c;
      }, 0);
      var defaultWidth = {
        'gnomAD': [327, 229, 146, 146, 320],
        'dbVar': [327, 229, 146, 146, 320],
        'JSV2': [327, 229, 146, 146, 320],
        'CoLoRSdb': [327, 229, 146, 146, 320]
      }[this.type];
      var tableWidths = this.tableWidths || [].concat(toConsumableArray_default()(this.staticTableWidths[0]), toConsumableArray_default()(defaultWidth), toConsumableArray_default()(this.staticTableWidths[1])).map(function (width) {
        return {
          value: width
        };
      });
      var tableMinWidths = this.tableMinWidths || 0.1;
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length);
      var ratio = tableWidth / tableWidths.reduce(function (s, c) {
        return s + c.value;
      }, 0);
      tableWidths = Array.prototype.concat.apply([], [this.staticTableWidths[0].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      }), tableWidths.map(function (width) {
        return {
          value: width.value * ratio,
          grab: 0
        };
      }), this.staticTableWidths[1].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      })]);
      this.tableMinWidths = tableMinWidths * ratio;
      this.tableWidths = tableWidths;
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
    },

    // grab
    boardResponse: function boardResponse(id, type) {
      var _this6 = this;

      return {
        'board1': {
          'start': function start(boardData) {
            _this6.sort.disabled = true;
          },
          'move': function move(boardData) {
            if (_this6.boardType['board1'] === 'grab') {
              var grabID = _this6.boardData[id].grabID;
              var tableWidths = [].concat(toConsumableArray_default()(_this6.tableWidths));
              var result = boardData.grabX - boardData.baseX;
              var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this6.staticTableWidths[1].length).reduce(function (s, c, i) {
                return s + c.value - (_this6.tableOptions[i].minWidth || _this6.tableMinWidths);
              }, 0);
              tableWidths.forEach(function (_, i) {
                if (i === grabID) {
                  tableWidths[i].grab = result;
                }if (i > grabID && i + _this6.staticTableWidths[1].length < tableWidths.length) {
                  tableWidths[i].grab = -(result * ((tableWidths[i].value - (_this6.tableOptions[i].minWidth || _this6.tableMinWidths)) / ratioBase));
                }
              });
              _this6.tableWidths = tableWidths;
            }
          },
          'end': function end(boardData) {
            var grabID = _this6.boardData[id].grabID;
            var tableWidths = [].concat(toConsumableArray_default()(_this6.tableWidths));
            var result = boardData.grabX - boardData.baseX;
            var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this6.staticTableWidths[1].length).reduce(function (s, c, i) {
              return s + c.value - (_this6.tableOptions[i].minWidth || _this6.tableMinWidths);
            }, 0);
            tableWidths.forEach(function (_, i) {
              tableWidths[i].grab = 0;
              if (i === grabID) {
                tableWidths[i].value += result;
              }if (i > grabID && i + _this6.staticTableWidths[1].length < tableWidths.length) {
                tableWidths[i].value -= result * ((tableWidths[i].value - (_this6.tableOptions[i].minWidth || _this6.tableMinWidths)) / ratioBase);
              }
            });
            _this6.tableWidths = tableWidths;
            setTimeout(function () {
              _this6.sort.disabled = false;
            });
          }
        }
      }[id][type];
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-476bb147","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/caseDetail/regionPublicationData.vue
var regionPublicationData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.datas)?_c('div',{staticClass:"case-detail-region-publication-data-page col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"region-publication-data-main-container col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"custom-table",class:{ 'auto-height': false }},[(_vm.tableWidths)?_c('div',{staticClass:"table-field col-block grab-container",style:({ width: _vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) + 'px' }),on:{"mousedown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardStart]); })($event)},"mousemove":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseout":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardEnd]); })($event)}}},[_c('div',{staticClass:"grab-line x min",style:(_vm.lineData.x.min && _vm.lineData.x.min.display ? { left: _vm.lineData.x.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x max",style:(_vm.lineData.x.max && _vm.lineData.x.max.display ? { left: _vm.lineData.x.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x main",style:(_vm.lineData.x.main && _vm.lineData.x.main.display ? { left: (_vm.lineData.x.main.base + _vm.lineData.x.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x custom",style:(_vm.lineData.x.custom && _vm.lineData.x.custom.display ? { left: _vm.lineData.x.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y min",style:(_vm.lineData.y.min && _vm.lineData.y.min.display ? { top: _vm.lineData.y.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y max",style:(_vm.lineData.y.max && _vm.lineData.y.max.display ? { top: _vm.lineData.y.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y main",style:(_vm.lineData.y.main && _vm.lineData.y.main.display ? { top: (_vm.lineData.y.main.base + _vm.lineData.y.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y custom",style:(_vm.lineData.y.custom && _vm.lineData.y.custom.display ? { top: _vm.lineData.y.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"table-container col-block"},[_c('div',{staticClass:"thead"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab + 'px' }),on:{"click":function (e) { return !_vm.sort.disabled && option.sortMap !== null && _vm.tableSortBy(option.sortValue || option.value); }}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.titleInfo)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('borCor',{attrs:{"reverse":true,"background":'white',"border":'#CCCCCC',"radius":'0px',"blockStyle":{ padding: '8px' }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("d5V5"),"alt":""}})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(option.titleInfo === '_OVERLAPINFO')?[_c('div',{staticClass:"overlap-info-container col-block flex-start"},[(option.overlapInfo.title)?_c('div',{staticClass:"overlap-info-title"},[_vm._v(_vm._s(option.overlapInfo.title))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"overlap-info-content-container col-block width-full"},_vm._l((option.overlapInfo.infos),function(info,iindex){return _c('div',{key:iindex,staticClass:"overlap-info-content-block col-block flex-start"},[(info.title)?_c('div',{staticClass:"overlap-info-content-title"},[_vm._v(_vm._s(info.title + ':'))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"overlap-info-formula-container row-block"},[_c('div',{staticClass:"overlap-info-formula-result"},[_vm._v(_vm._s(info.formula.result))]),_vm._v(" "),_c('div',{staticClass:"overlap-info-formula-equal"},[_vm._v("=")]),_vm._v(" "),_c('div',{staticClass:"overlap-info-formula-content col-block"},[_c('div',{staticClass:"overlap-info-formula-numerator"},[_vm._v(_vm._s(info.formula.numerator))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"overlap-info-formula-denominator"},[_vm._v(_vm._s(info.formula.denominator))])])])])}),0)])]:[_c('div',[_vm._v(_vm._s(option.titleInfo))])]],2)])]:_vm._e(),_vm._v(" "),(option.value === 'overlap_info')?[_c('div',{staticClass:"overlap-info-info-container row-block"},_vm._l((_vm.overlapInfoInfos),function(info,oiindex){return _c('div',{key:oiindex,staticClass:"overlap-info-info-block row-block"},[_c('div',{staticClass:"overlap-info-info-icon",style:({ '--icon-color': info.color })}),_vm._v(" "),_c('div',{staticClass:"overlap-info-info-title"},[_vm._v(": "+_vm._s(info.title))])])}),0)]:_vm._e(),_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e()],2)}),0)])]),_vm._v(" "),_c('div',{ref:"custom-table-scroll",staticClass:"table-group-container col-block width-full"},[_c('div',{staticClass:"col-block"},_vm._l((_vm.tableDatas),function(group,gindex){return _c('div',{key:gindex,staticClass:"table-container col-block"},[_c('div',{staticClass:"tbody"},[_c('div',{staticClass:"tr group row-block",class:{ selected: false },style:(group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' })},[_c('a',{staticClass:"container-block row-block"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(group[option.gValue], gindex, group),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.gstyle || (function () { return ({}); }))(group[option.gValue], gindex, group)),attrs:{"title":((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || option.gempty || '')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('center') && !(option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)]),_vm._v(" "),_vm._l((group.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"tr col-block",class:{ selectable: false, selected: false }},[_c('a',{staticClass:"container-block row-block",style:({ flex: 1 }),on:{"click":function (e) { return false && (_vm.selectedTableData = data); }}},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(data[option.value], dindex, data),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[(option.value === 'overlap_info')?[_c('databaseOverlapGraph',{attrs:{"points":option.pointData(data),"result":option.result(data)}})]:[_c('span',{style:((option.style || (function () { return ({}); }))(data[option.value], dindex, data)),attrs:{"title":((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || option.empty || '- -')}})],_vm._v(" "),(option.link)?[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('a',{attrs:{"href":option.link(data[option.value], dindex, data),"target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("wtkH"),"alt":""}})])]:_vm._e(),_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(data[option.value], dindex, data).includes('center') && !(option.class || (function () { return []; }))(data[option.value], dindex, data).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)])})],2)])}),0)])]):_vm._e()]),_vm._v(" "),(_vm.pageData)?_c('div',{staticClass:"region-publication-data-page-container row-block"},[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"region-publication-data-page-total"},[_vm._v(_vm._s(_vm.$t('COMPONENT.caseDetail.regionPublicationData.page.___total', { total: _vm.toPriceString(_vm.pageData.total) })))]),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"region-publication-data-page-display"},[_vm._v(_vm._s(_vm.$t('COMPONENT.caseDetail.regionPublicationData.page.___display', { display: _vm.pageData.display })))]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('pageButtons',{attrs:{"default":_vm.pageData.selectedPage,"display":_vm.pageData.display - 0,"total":_vm.pageData.total,"buttonRange":_vm.pageData.buttonRange},on:{"selectPage":function (page) { _vm.pageData.selectedPage = page; _vm.searchDatas() }}})],1):_vm._e()])]):_vm._e()}
var regionPublicationData_staticRenderFns = []
var regionPublicationData_esExports = { render: regionPublicationData_render, staticRenderFns: regionPublicationData_staticRenderFns }
/* harmony default export */ var caseDetail_regionPublicationData = (regionPublicationData_esExports);
// CONCATENATED MODULE: ./src/components/caseDetail/regionPublicationData.vue
var regionPublicationData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var regionPublicationData___vue_template_functional__ = false
/* styles */
var regionPublicationData___vue_styles__ = null
/* scopeId */
var regionPublicationData___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var regionPublicationData___vue_module_identifier__ = null
var regionPublicationData_Component = regionPublicationData_normalizeComponent(
  regionPublicationData,
  caseDetail_regionPublicationData,
  regionPublicationData___vue_template_functional__,
  regionPublicationData___vue_styles__,
  regionPublicationData___vue_scopeId__,
  regionPublicationData___vue_module_identifier__
)

/* harmony default export */ var components_caseDetail_regionPublicationData = (regionPublicationData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDetailRegionPublication.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var caseDetailRegionPublication = ({
  components: {
    regionPublicationData: components_caseDetail_regionPublicationData
  },
  mixins: [routeLoading["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      tab: this.param.tab,
      tableName: null,
      dataKey: null,
      totalDatas: null
    };
  },

  computed: {
    // static
    tabOptions: function tabOptions() {
      return [{
        title: this.$t('DIALOG.caseDetailRegionPublication.tab.title.___gnomAD_SV'),
        value: 'gnomAD'
      }, {
        title: this.$t('DIALOG.caseDetailRegionPublication.tab.title.___dbVar'),
        value: 'dbVar'
      }, {
        title: this.$t('DIALOG.caseDetailRegionPublication.tab.title.___JSV2'),
        value: 'JSV2'
      }, {
        title: this.$t('DIALOG.caseDetailRegionPublication.tab.title.___CoLoRSdb'),
        value: 'CoLoRSdb'
      }];
    },

    // param
    regionData: function regionData() {
      return this.param.regionData;
    }
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchPublicationTable();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchPublicationTable: function fetchPublicationTable() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, id, projectID, tableData, response, tableName;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this2.$ls.get('userInfo');
                id = _this2.param.caseData.id;
                projectID = _this2.param.project.id;
                tableData = {};
                _context2.next = 7;
                return Object(src_api["X" /* getCaseProjectRegionPublicationTable */])(id, projectID, tableData, config);

              case 7:
                response = _context2.sent;
                tableName = !global_config["a" /* _LOCAL_BUILD */] ? response.data.data.table_name : response.data.data.session;

                _this2.tableName = tableName;
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 12]]);
      }))();
    },
    setTotalData: function setTotalData(key, value) {
      if (!this.totalDatas) {
        this.totalDatas = this.tabOptions.reduce(function (data, option) {
          return extends_default()({}, data, defineProperty_default()({}, option.value, null));
        }, {});
      }
      this.totalDatas[key] = value;
      if (value) {
        this.dataKey = key;
      }
      if (values_default()(this.totalDatas).every(function (value) {
        return value !== null;
      })) {
        this.tab = this.tab || this.dataKey || 'gnomAD';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c9314df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDetailRegionPublication.vue
var caseDetailRegionPublication_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-region-publication-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('DIALOG.caseDetailRegionPublication.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"data-container col-block",style:({ flex: 1 })},[_c('div',{staticClass:"data-title-container row-block"},[_c('div',{staticClass:"data-title",domProps:{"innerHTML":_vm._s([
          _vm.regionData.region_classification,
          _vm.regionData.SV_type,
          [
            'chr' + _vm.regionData.SV_chrom,
            _vm.regionData.CytoBand
          ].map(function (v) { return '(' + v + ')'; }).join('')
        ].join(' '))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"data-tab-list-container row-block"},[_c('div',{staticClass:"data-tab-list-block row-block"},_vm._l((_vm.tabOptions),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-tab-field col-block width-full",class:{ active: option.value === _vm.tab },on:{"click":function (e) { return _vm.tab = option.value; }}},[_c('div',{staticClass:"data-tab-container center-block"},[_c('div',{staticClass:"data-tab-block row-block"},[_c('div',{staticClass:"data-tab-title"},[_vm._v(_vm._s(option.title))])])])])}),0),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block width-full",style:({ flex: 1 })},[(_vm.tableName)?_vm._l((_vm.tabOptions),function(option,oindex){return _c('regionPublicationData',_vm._b({directives:[{name:"show",rawName:"v-show",value:(option.value === _vm.tab),expression:"option.value === tab"}],key:oindex,attrs:{"type":option.value,"tableName":_vm.tableName},on:{"loaded":function (total) { return _vm.setTotalData(option.value, total); }}},'regionPublicationData',_vm.param,false))}):_vm._e()],2)]),_vm._v(" "),_c('div',{style:({ height: '0' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var caseDetailRegionPublication_staticRenderFns = []
var caseDetailRegionPublication_esExports = { render: caseDetailRegionPublication_render, staticRenderFns: caseDetailRegionPublication_staticRenderFns }
/* harmony default export */ var dialog_caseDetailRegionPublication = (caseDetailRegionPublication_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDetailRegionPublication.vue
var caseDetailRegionPublication_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDetailRegionPublication___vue_template_functional__ = false
/* styles */
var caseDetailRegionPublication___vue_styles__ = null
/* scopeId */
var caseDetailRegionPublication___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDetailRegionPublication___vue_module_identifier__ = null
var caseDetailRegionPublication_Component = caseDetailRegionPublication_normalizeComponent(
  caseDetailRegionPublication,
  dialog_caseDetailRegionPublication,
  caseDetailRegionPublication___vue_template_functional__,
  caseDetailRegionPublication___vue_styles__,
  caseDetailRegionPublication___vue_scopeId__,
  caseDetailRegionPublication___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDetailRegionPublication = (caseDetailRegionPublication_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDetailRegionCaller.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var caseDetailRegionCaller = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    callerDatas: function callerDatas() {
      var callerData = {
        names: (this.regionData.caller_name || '').split('|'),
        descriptions: (this.regionData.QC || '').split('|').map(function (qcString) {
          return qcString.split(';').reduce(function (result, dataString) {
            var data = dataString.split('=');
            return extends_default()({}, result, data.length === 2 ? defineProperty_default()({}, data[0], data[1]) : {});
          }, {});
        }).filter(function (x) {
          return x;
        })
      };
      var callerDatas = new Array(this.regionData.support_caller_count).fill('').map(function (_, index) {
        return { name: callerData['names'][index], descriptionData: callerData['descriptions'][index] };
      });
      return callerDatas;
    },

    // static
    tableOption: function tableOption() {
      var _this = this;

      return [{
        title: this.$t('DIALOG.caseDetailRegionCaller.table.title.___caller'),
        value: 'name',
        info: function info(value) {
          return _this.param.callerFiles[value] || '';
        },
        color: null,
        flex: 1,
        position: 'center',
        break: true,
        empty: this.$t(global_data["m" /* defaultEmptyDisplay */].empty)
      }, {
        title: this.$t('DIALOG.caseDetailRegionCaller.table.title.___description'),
        value: 'description',
        flex: 3
      }];
    },

    // param
    regionData: function regionData() {
      return this.param.regionData;
    },

    // global
    svTypeValueMap: function svTypeValueMap() {
      return global_data["X" /* svTypeOptions */].reduce(function (map, option) {
        return extends_default()({}, map, defineProperty_default()({}, option.value, option));
      }, {});
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aac838b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDetailRegionCaller.vue
var caseDetailRegionCaller_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-region-caller-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$tc('DIALOG.caseDetailRegionCaller.___title', _vm.regionData.support_caller_count, { count: _vm.regionData.support_caller_count })))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"data-container col-block"},[_c('div',{staticClass:"data-title-container row-block"},[_c('div',{staticClass:"data-title",domProps:{"innerHTML":_vm._s('chr' + _vm.regionData.SV_chrom + ': ' + _vm.regionData.SV_start + '-' + _vm.regionData.SV_end + ' ' + _vm.$t(_vm.svTypeValueMap[_vm.regionData.SV_type].title))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block flex-start width-full"},[_c('div',{staticClass:"data-content-block col-block"},[_c('div',{staticClass:"data-row row-block stretch"},_vm._l((_vm.tableOption),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position, { hidden: !option.title }],style:({ flex: option.flex })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content",domProps:{"innerHTML":_vm._s(option.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0),_vm._v(" "),_vm._l((_vm.callerDatas),function(callerData,cdindex){return _c('div',{key:cdindex,staticClass:"data-row row-block stretch"},_vm._l((_vm.tableOption),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position, { hidden: !option.title }],style:({ flex: option.flex, width: 0 })},[(option.value === 'description' && Object.keys(callerData.descriptionData || {}).length)?_c('div',{staticClass:"data-content description-col col-block",class:{ alert: false }},[_c('div',{staticClass:"description-list-container row-block flex-start flex-wrap"},_vm._l((Object.entries(callerData.descriptionData)),function(kv,dindex){return _c('div',{key:dindex,staticClass:"description-block row-block",style:({ width: (100 / 3) + '%' })},[_c('div',{staticClass:"description-content",domProps:{"innerHTML":_vm._s('<b>' + kv[0] + '</b>: ' + kv[1])}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)]):_c('div',{staticClass:"data-content",class:[option.break ? 'break-line' : 'ellipsis'],style:({ color: (option.color || (function () { return null; }))(callerData[option.value], callerData), 'max-height': option.maxHeight || 'auto' }),attrs:{"title":(option.info || option.display || (function (x) { return x; }))(callerData[option.value], callerData)},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(callerData[option.value], callerData) || option.empty || '- -')}})])}),0)})],2)])]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var caseDetailRegionCaller_staticRenderFns = []
var caseDetailRegionCaller_esExports = { render: caseDetailRegionCaller_render, staticRenderFns: caseDetailRegionCaller_staticRenderFns }
/* harmony default export */ var dialog_caseDetailRegionCaller = (caseDetailRegionCaller_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDetailRegionCaller.vue
var caseDetailRegionCaller_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDetailRegionCaller___vue_template_functional__ = false
/* styles */
var caseDetailRegionCaller___vue_styles__ = null
/* scopeId */
var caseDetailRegionCaller___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDetailRegionCaller___vue_module_identifier__ = null
var caseDetailRegionCaller_Component = caseDetailRegionCaller_normalizeComponent(
  caseDetailRegionCaller,
  dialog_caseDetailRegionCaller,
  caseDetailRegionCaller___vue_template_functional__,
  caseDetailRegionCaller___vue_styles__,
  caseDetailRegionCaller___vue_scopeId__,
  caseDetailRegionCaller___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDetailRegionCaller = (caseDetailRegionCaller_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/editChapter.vue









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { postChapter, putChapter } from '../../api'


/* harmony default export */ var editChapter = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      chapter: {},
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },

    // static
    formOptions: function formOptions() {
      var _this2 = this;

      return {
        field1: [{
          title: this.param.chapter ? this.$t('DIALOG.editChapter.form.title.___title') : this.$t('DIALOG.editChapter.form.title.___newTitle'),
          value: 'title',
          type: 'input',
          placeholder: function placeholder() {
            return _this2.$t('DIALOG.editChapter.form.placeholder.___title');
          },
          validate: 'required'
        }],
        field2: [{
          title: this.$t('DIALOG.editChapter.form.title.___description'),
          value: 'description',
          type: 'textarea',
          placeholder: function placeholder() {
            return _this2.$t('DIALOG.editChapter.form.placeholder.___description');
          }
        }]
      };
    }
  },
  created: function created() {
    var chapter = this.param.chapter || this.chapter;
    this.chapter = chapter;
  },

  methods: {
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.chapter)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    validateSendChapter: function validateSendChapter() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};

                _this3.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this3.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 15;
                  break;
                }

                kv = _step2.value;
                _context.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context.next = 7;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError2) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                result['custom'] = _this3.customValidate();

                if (values_default()(result).includes(false)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 33;
                return _this3.sendChapter();

              case 33:
                _this3.onSubmit = false;

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    sendChapter: function sendChapter() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  _this4.$emit('changeModal', {}, _this4.result);
                } catch (error) {
                  _this4.addToast('error', !error.response ? error.message : error.response.data.result.message);
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f66e289","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/editChapter.vue
var editChapter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-chapter-dailog dialog col-block"},[_c('customForm',{attrs:{"init":_vm.chapter,"alerts":_vm.alerts,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.chapter,"alerts":_vm.alerts,"forms":_vm.formOptions['field2']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field2', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit ? _vm.validateSendChapter() : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.chapter.id ? _vm.$t('COMMON.button.___save') : _vm.$t('COMMON.button.___add')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var editChapter_staticRenderFns = []
var editChapter_esExports = { render: editChapter_render, staticRenderFns: editChapter_staticRenderFns }
/* harmony default export */ var dialog_editChapter = (editChapter_esExports);
// CONCATENATED MODULE: ./src/components/dialog/editChapter.vue
var editChapter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editChapter___vue_template_functional__ = false
/* styles */
var editChapter___vue_styles__ = null
/* scopeId */
var editChapter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editChapter___vue_module_identifier__ = null
var editChapter_Component = editChapter_normalizeComponent(
  editChapter,
  dialog_editChapter,
  editChapter___vue_template_functional__,
  editChapter___vue_styles__,
  editChapter___vue_scopeId__,
  editChapter___vue_module_identifier__
)

/* harmony default export */ var components_dialog_editChapter = (editChapter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/addVariantToChapter.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var addVariantToChapter = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedChapters: []
    };
  },

  computed: {
    // param
    type: function type() {
      return this.param.type;
    },
    variant: function variant() {
      return this.param.variant;
    },
    chapters: function chapters() {
      return this.param.chapters;
    },

    // global
    svTypeValueMap: function svTypeValueMap() {
      return global_data["X" /* svTypeOptions */].reduce(function (map, option) {
        return extends_default()({}, map, defineProperty_default()({}, option.value, option));
      }, {});
    },
    caseDataTypeMetadatas: function caseDataTypeMetadatas() {
      return global_data["c" /* caseDataTypeMetadatas */];
    },
    caseDataTagOptions: function caseDataTagOptions() {
      return global_data["b" /* caseDataTagOptions */];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04795a08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/addVariantToChapter.vue
var addVariantToChapter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-variant-to-chapter-dailog dialog col-block"},[_c('div',{staticClass:"block-container variant col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('DIALOG.addVariantToChapter.variant.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '16px' })}),_vm._v(" "),_c('div',{staticClass:"variant-container col-block flex-start"},[(_vm.type === 'snv')?[_c('div',{staticClass:"variant-title",domProps:{"innerHTML":_vm._s('<b>' + _vm.variant.SYMBOL + '</b>' + ' ' + _vm.variant.CHROM + ':' + _vm.variant.POS + _vm.variant.REF + '>' + _vm.variant.ALT)}}),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"gene-tag-container row-block flex-start flex-wrap"},_vm._l(((_vm.variant.source || []).filter(function (x, i, s) { return s.indexOf(x) === i; })),function(tag,tindex){return _c('div',{key:tindex,staticClass:"gene-tag-block"},[_c('div',{staticClass:"gene-tag",style:(_vm.caseDataTagOptions[tag]),attrs:{"title":_vm.$t(_vm.caseDataTypeMetadatas[tag].tagOption.title)}},[_vm._v(_vm._s(_vm.$t(_vm.caseDataTypeMetadatas[tag].tagOption.title)))])])}),0)]:(_vm.type === 'sv')?[_c('div',{staticClass:"variant-title",domProps:{"innerHTML":_vm._s([
            '<b>' + _vm.variant.region_classification + '</b>',
            '<b style=color:' + (_vm.svTypeValueMap[_vm.variant.SV_type].color || '#333333') + '>' + _vm.variant.SV_type + '</b>',
            'chr' + _vm.variant.SV_chrom + ':' + _vm.variant.SV_start + '-' + _vm.variant.SV_end ].join(' '))}})]:_vm._e()],2)]),_vm._v(" "),_c('div',{style:({ height: '26px' })}),_vm._v(" "),_c('div',{staticClass:"block-container chapter col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('DIALOG.addVariantToChapter.chapter.___title')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '12px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-container row-block"},[_c('div',{staticClass:"chapter-list-container row-block flex-wrap"},_vm._l((_vm.chapters),function(chapter,index){return _c('div',{key:index,staticClass:"chapter-item-container"},[_c('div',{staticClass:"chapter-item row-block",on:{"click":function (e) { return _vm.selectedChapters = (_vm.selectedChapters.includes(chapter.value) ? _vm.selectedChapters.slice(index, 1) : _vm.selectedChapters.concat([chapter.value])); }}},[_c('img',{attrs:{"src":_vm.selectedChapters.includes(chapter.value) ? __webpack_require__("7kqe") : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title"},[_vm._v(_vm._s(chapter.title))])])])}),0)])]),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, _vm.selectedChapters); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___add')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var addVariantToChapter_staticRenderFns = []
var addVariantToChapter_esExports = { render: addVariantToChapter_render, staticRenderFns: addVariantToChapter_staticRenderFns }
/* harmony default export */ var dialog_addVariantToChapter = (addVariantToChapter_esExports);
// CONCATENATED MODULE: ./src/components/dialog/addVariantToChapter.vue
var addVariantToChapter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addVariantToChapter___vue_template_functional__ = false
/* styles */
var addVariantToChapter___vue_styles__ = null
/* scopeId */
var addVariantToChapter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var addVariantToChapter___vue_module_identifier__ = null
var addVariantToChapter_Component = addVariantToChapter_normalizeComponent(
  addVariantToChapter,
  dialog_addVariantToChapter,
  addVariantToChapter___vue_template_functional__,
  addVariantToChapter___vue_styles__,
  addVariantToChapter___vue_scopeId__,
  addVariantToChapter___vue_module_identifier__
)

/* harmony default export */ var components_dialog_addVariantToChapter = (addVariantToChapter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/editReportVariant.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var editReportVariant = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      result: {
        'ACMG': [],
        'SIFT': [],
        'Polyphen2': [],
        'ParentalOrigin': []
      },
      multiple: {
        'ACMG': false,
        'SIFT': false,
        'Polyphen2': false,
        'ParentalOrigin': false
      }
    };
  },
  created: function created() {
    this.result = extends_default()({}, this.result, this.param.value);
    this.multiple = extends_default()({}, this.multiple, this.param.multiple);
  },

  computed: {
    formItems: function formItems() {
      var _this = this;

      return {
        'ACMG': [{ title: 'Pathogenic', value: 'Pathogenic', color: '#FA3D3D' }, { title: 'Likely pathogenic', value: 'Likely pathogenic', color: '#FF9E03' }, { title: 'Uncertain significance', value: 'Uncertain significance' }, { title: 'Likely benign', value: 'Likely benign' }, { title: 'Benign', value: 'Benign' }],
        'SIFT': [].concat(toConsumableArray_default()(entries_default()(global_data["I" /* predictionMetaDatas */]['SIFT4G'].displayMap).map(function (_ref) {
          var _ref2 = slicedToArray_default()(_ref, 2),
              value = _ref2[0],
              title = _ref2[1];

          return extends_default()({ title: _this.$t(title), value: value }, (global_data["I" /* predictionMetaDatas */]['SIFT4G'].checkPassed || function () {
            return true;
          })(null, value) ? {} : { color: '#FA3D3D' });
        })), [{ title: this.$t(global_data["m" /* defaultEmptyDisplay */].empty), value: 'N/A' }]),
        'Polyphen2': [].concat(toConsumableArray_default()(entries_default()(global_data["I" /* predictionMetaDatas */]['Polyphen'].displayMap).map(function (_ref3) {
          var _ref4 = slicedToArray_default()(_ref3, 2),
              value = _ref4[0],
              title = _ref4[1];

          return extends_default()({ title: _this.$t(title), value: value }, (global_data["I" /* predictionMetaDatas */]['Polyphen'].checkPassed || function () {
            return true;
          })(null, value) ? {} : { color: '#FA3D3D' });
        })), [{ title: this.$t(global_data["m" /* defaultEmptyDisplay */].empty), value: 'N/A' }]),
        'ParentalOrigin': entries_default()(global_data["O" /* reportParentalOriginMap */]).map(function (_ref5) {
          var _ref6 = slicedToArray_default()(_ref5, 2),
              value = _ref6[0],
              title = _ref6[1];

          return { title: title, value: value };
        })
      };
    },

    // param
    type: function type() {
      return this.param.type;
    },
    variant: function variant() {
      return this.param.variant;
    }
  },
  methods: {
    setValue: function setValue(type, item) {
      if (!this.multiple[type]) {
        this.result[type] = [];
      }
      this.result[type] = !this.result[type].includes(item.value) ? this.result[type].concat([item.value]) : this.result[type].length > 1 ? this.result[type].filter(function (value) {
        return value !== item.value;
      }) : this.result[type];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a2aa1c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/editReportVariant.vue
var editReportVariant_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-report-variant-dailog dialog col-block"},[_c('div',{staticClass:"block-container variant col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s({
          'ACMG': _vm.$t('DIALOG.editReportVariant.___acmgTitle'),
          'SIFT & Polyphen2': _vm.$t('DIALOG.editReportVariant.___siftPolyphen2Title')
        }[_vm.type])}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"variant-container col-block flex-start"},[_c('div',{staticClass:"variant-title",domProps:{"innerHTML":_vm._s('<b>' + (_vm.variant.SYMBOL || '- -') + '</b>' + ' ' + _vm.variant.CHROM + ':' + _vm.variant.POS + _vm.variant.REF + '>' + _vm.variant.ALT)}})])]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),(_vm.type === 'ACMG')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.editReportVariant.variantForm.title.___acmg'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '12px' })}),_vm._v(" "),_c('div',{staticClass:"form-container row-block"},[_c('div',{staticClass:"form-list-container row-block flex-wrap"},_vm._l((_vm.formItems['ACMG']),function(item,index){return _c('div',{key:index,staticClass:"form-item-container"},[_c('div',{staticClass:"form-item row-block",on:{"click":function (e) { return _vm.setValue('ACMG', item); }}},[_c('img',{class:{ multiple: _vm.multiple['ACMG'] },attrs:{"src":_vm.result['ACMG'].includes(item.value) ? __webpack_require__("Id76")("./" + (_vm.multiple['ACMG'] ? 'checkbox': 'radio') + '-true.svg') : __webpack_require__("AJyC")("./" + (_vm.multiple['ACMG'] ? 'checkbox': 'radio') + '-false.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title",style:(item.color ? { color: item.color } : {})},[_vm._v(_vm._s(item.title))])])])}),0)])])]:_vm._e(),_vm._v(" "),(_vm.type === 'SIFT & Polyphen2')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.editReportVariant.variantForm.title.___sift'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"form-container row-block"},[_c('div',{staticClass:"form-list-container row-block flex-wrap"},_vm._l((_vm.formItems['SIFT']),function(item,index){return _c('div',{key:index,staticClass:"form-item-container"},[_c('div',{staticClass:"form-item row-block",on:{"click":function (e) { return _vm.setValue('SIFT', item); }}},[_c('img',{class:{ multiple: _vm.multiple['SIFT'] },attrs:{"src":_vm.result['SIFT'].includes(item.value) ? __webpack_require__("Id76")("./" + (_vm.multiple['SIFT'] ? 'checkbox': 'radio') + '-true.svg') : __webpack_require__("AJyC")("./" + (_vm.multiple['SIFT'] ? 'checkbox': 'radio') + '-false.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title",style:(item.color ? { color: item.color } : {})},[_vm._v(_vm._s(item.title))])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.editReportVariant.variantForm.title.___polyphen2'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"form-container row-block"},[_c('div',{staticClass:"form-list-container row-block flex-wrap"},_vm._l((_vm.formItems['Polyphen2']),function(item,index){return _c('div',{key:index,staticClass:"form-item-container"},[_c('div',{staticClass:"form-item row-block",on:{"click":function (e) { return _vm.setValue('Polyphen2', item); }}},[_c('img',{class:{ multiple: _vm.multiple['Polyphen2'] },attrs:{"src":_vm.result['Polyphen2'].includes(item.value) ? __webpack_require__("Id76")("./" + (_vm.multiple['Polyphen2'] ? 'checkbox': 'radio') + '-true.svg') : __webpack_require__("AJyC")("./" + (_vm.multiple['Polyphen2'] ? 'checkbox': 'radio') + '-false.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title",style:(item.color ? { color: item.color } : {})},[_vm._v(_vm._s(item.title))])])])}),0)])])]:_vm._e(),_vm._v(" "),(_vm.type === 'Parental Origin')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.editReportVariant.variantForm.title.___parentalOrigin'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '12px' })}),_vm._v(" "),_c('div',{staticClass:"form-container row-block"},[_c('div',{staticClass:"form-list-container row-block flex-wrap"},_vm._l((_vm.formItems['ParentalOrigin']),function(item,index){return _c('div',{key:index,staticClass:"form-item-container"},[_c('div',{staticClass:"form-item row-block",on:{"click":function (e) { return _vm.setValue('ParentalOrigin', item); }}},[_c('img',{class:{ multiple: _vm.multiple['ParentalOrigin'] },attrs:{"src":_vm.result['ParentalOrigin'].includes(item.value) ? __webpack_require__("Id76")("./" + (_vm.multiple['ParentalOrigin'] ? 'checkbox': 'radio') + '-true.svg') : __webpack_require__("AJyC")("./" + (_vm.multiple['ParentalOrigin'] ? 'checkbox': 'radio') + '-false.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title",style:(item.color ? { color: item.color } : {})},[_vm._v(_vm._s(item.title))])])])}),0)])])]:_vm._e(),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, _vm.result); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___update')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var editReportVariant_staticRenderFns = []
var editReportVariant_esExports = { render: editReportVariant_render, staticRenderFns: editReportVariant_staticRenderFns }
/* harmony default export */ var dialog_editReportVariant = (editReportVariant_esExports);
// CONCATENATED MODULE: ./src/components/dialog/editReportVariant.vue
var editReportVariant_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editReportVariant___vue_template_functional__ = false
/* styles */
var editReportVariant___vue_styles__ = null
/* scopeId */
var editReportVariant___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editReportVariant___vue_module_identifier__ = null
var editReportVariant_Component = editReportVariant_normalizeComponent(
  editReportVariant,
  dialog_editReportVariant,
  editReportVariant___vue_template_functional__,
  editReportVariant___vue_styles__,
  editReportVariant___vue_scopeId__,
  editReportVariant___vue_module_identifier__
)

/* harmony default export */ var components_dialog_editReportVariant = (editReportVariant_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/editCNVToChapter.vue








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var editCNVToChapter = ({
  components: {
    geneTag: geneTag["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      cnv: {
        CHROM: '',
        genes: [],
        chapters: []
      },
      selectedGenes: [],
      selectedChapters: [],
      // search
      map: {
        gene: {}
      },
      query: {
        gene: ''
      },
      tag: {
        genes: {}
      },
      curTag: {
        gene: null
      },
      searchTimer: {
        gene: []
      },
      loading: {
        addToSearch: false
      }
    };
  },

  computed: {
    sendData: function sendData() {
      var cnv = {
        CHROM: this.cnv.CHROM,
        POS_START: this.cnv.POS_START,
        POS_END: this.cnv.POS_END
      };
      var nGeneIDs = this.selectedGenes.map(function (gene) {
        return gene.gene_id;
      });
      var oGeneIDs = this.cnv.genes.map(function (gene) {
        return gene.gene_id;
      });
      var iGeneIDs = nGeneIDs.filter(function (id) {
        return oGeneIDs.includes(id);
      });
      var genes = {
        add: this.selectedGenes.filter(function (gene) {
          return !iGeneIDs.includes(gene.gene_id);
        }),
        original: this.selectedGenes.filter(function (gene) {
          return iGeneIDs.includes(gene.gene_id);
        }),
        remove: this.cnv.genes.filter(function (gene) {
          return !iGeneIDs.includes(gene.gene_id);
        })
      };
      var nChapterValues = this.selectedChapters;
      var oChapterValues = this.cnv.chapters;
      var iChapterValues = nChapterValues.filter(function (value) {
        return oChapterValues.includes(value);
      });
      var chapters = {
        add: this.selectedChapters.filter(function (chapter) {
          return !iChapterValues.includes(chapter);
        }),
        original: this.selectedChapters.filter(function (chapter) {
          return iChapterValues.includes(chapter);
        }),
        remove: this.cnv.chapters.filter(function (chapter) {
          return !iChapterValues.includes(chapter);
        })
      };
      if (values_default()(cnv).every(function (x) {
        return x;
      }) && this.selectedChapters.length) {
        return { cnv: cnv, genes: genes, chapters: chapters };
      } else {
        return null;
      }
    },
    chromOptions: function chromOptions() {
      return entries_default()(global_data["d" /* chromMap */]).map(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return { title: value.title, value: key };
      });
    },

    // param
    isEdit: function isEdit() {
      return this.param.defaultData;
    },
    chapters: function chapters() {
      return this.param.chapters;
    }
  },
  watch: {
    'query.gene': function queryGene(nv) {
      this.getGenes(nv);
    },
    'cnv.CHROM': function cnvCHROM(nv) {
      if (nv) {
        if (nv === 'chrM') {
          this.selectedGenes = this.selectedGenes.filter(function (gene) {
            return gene.SYMBOL.startsWith('MT-');
          });
        } else {
          this.selectedGenes = this.selectedGenes.filter(function (gene) {
            return !gene.SYMBOL.startsWith('MT-');
          });
        }
      }
    }
  },
  created: function created() {
    if (this.param.defaultData) {
      this.cnv = extends_default()({}, this.param.defaultData);
      this.selectedGenes = [].concat(toConsumableArray_default()(this.param.defaultData.genes));
      this.selectedChapters = [].concat(toConsumableArray_default()(this.param.defaultData.chapters));
    }
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction', 'setModal2Action']), {
    getGenes: function getGenes(query) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if ((_this.curTag['gene'] || {}).name !== query) {
                  _this.tag['genes'] = {};
                  if (_this.searchTimer['gene']) {
                    clearTimeout(_this.searchTimer['gene']);
                  }
                  _this.searchTimer['gene'] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                    var config, response, genes, mtGenes;
                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(!_this.map['gene'][query] && query)) {
                              _context.next = 22;
                              break;
                            }

                            _this.setLoadingAction(true);
                            _context.prev = 2;
                            config = _this.$ls.get('userInfo');
                            response = null;
                            _context.next = 7;
                            return Object(src_api["_9" /* getCnvGenes */])(query, false, config);

                          case 7:
                            response = _context.sent;
                            genes = response.data.data;

                            genes = Object(util["i" /* groupBy */])(genes, function (gene) {
                              return gene.gene_id;
                            }).map(function (group) {
                              return group[0];
                            });
                            _context.next = 12;
                            return Object(src_api["_9" /* getCnvGenes */])(query, true, config);

                          case 12:
                            response = _context.sent;
                            mtGenes = response.data.data;

                            mtGenes = Object(util["i" /* groupBy */])(mtGenes, function (gene) {
                              return gene.gene_id;
                            }).map(function (group) {
                              return group[0];
                            });
                            _this.map['gene'] = extends_default()({}, _this.map['gene'], defineProperty_default()({}, query, {
                              info: null,
                              datas: [].concat(toConsumableArray_default()(genes.map(function (data) {
                                return extends_default()({}, data, { name: data.symbol, type: 'gene' });
                              })), toConsumableArray_default()(mtGenes.map(function (data) {
                                return extends_default()({}, data, { name: data.symbol, type: 'gene' });
                              })))
                            }));
                            _context.next = 21;
                            break;

                          case 18:
                            _context.prev = 18;
                            _context.t0 = _context['catch'](2);

                            _this.addToast('error', !_context.t0.response ? _context.t0.message : _context.t0.response.data.result.message);

                          case 21:
                            _this.setLoadingAction(false);

                          case 22:
                            _this.tag['genes'] = _this.map['gene'][query] || {};

                          case 23:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this, [[2, 18]]);
                  })), 500);
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    addToSearch: function addToSearch(data) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var oldData;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = data.type ? data : (_this2.map['gene'][_this2.query['gene']] || { datas: [] }).datas[0];

                if (!(data && !_this2.loading['addToSearch'])) {
                  _context3.next = 11;
                  break;
                }

                _this2.loading['addToSearch'] = true;
                _context3.t0 = data.type;
                _context3.next = _context3.t0 === 'gene' ? 6 : 9;
                break;

              case 6:
                oldData = _this2.selectedGenes.find(function (g) {
                  return g.SYMBOL === data.symbol;
                });

                if (!oldData) {
                  _this2.selectedGenes.push({
                    SYMBOL: data.symbol,
                    gene_id: data.gene_id
                  });
                }
                return _context3.abrupt('break', 9);

              case 9:
                _this2.query['gene'] = '';
                _this2.loading['addToSearch'] = false;

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    deleteCNV: function deleteCNV() {
      var _this3 = this;

      this.setModal2Action({
        action: 'toast',
        width: '496px',
        customStyles: {
          padding: 0,
          border: 0
        },
        param: {
          type: 'alert',
          content: this.$t('DIALOG.editCNVToChapter.modal.content.___deleteCNV'),
          buttons: [{
            title: this.$t('COMMON.button.___cancel'),
            type: 'gray',
            result: false
          }, {
            title: this.$t('COMMON.button.___delete'),
            type: 'alert',
            result: true
          }]
        },
        callback: function () {
          var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(result) {
            return regenerator_default.a.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    if (result) {
                      _this3.$emit('changeModal', {}, extends_default()({}, _this3.sendData, {
                        chapters: {
                          add: [],
                          original: [],
                          remove: [].concat(toConsumableArray_default()(_this3.sendData.chapters.original), toConsumableArray_default()(_this3.sendData.chapters.remove))
                        }
                      }));
                    }

                  case 1:
                  case 'end':
                    return _context4.stop();
                }
              }
            }, _callee4, _this3);
          }));

          return function callback(_x) {
            return _ref4.apply(this, arguments);
          };
        }()
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92701afc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/editCNVToChapter.vue
var editCNVToChapter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-cnv-to-chapter-dailog dialog col-block"},[(_vm.isEdit)?_c('div',{staticClass:"option-container"},[_c('div',{staticClass:"delete-icon icon-block",style:({ '--size': '40px' }),on:{"click":function (e) { return _vm.deleteCNV(); }}},[_c('img',{style:({ height: '21px' }),attrs:{"src":__webpack_require__("j6F1"),"alt":""}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"block-container cnv col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.isEdit ? _vm.$t('DIALOG.editCNVToChapter.___editTitle') : _vm.$t('DIALOG.editCNVToChapter.___newTitle')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"cnv-container col-block flex-start"},[_c('div',{staticClass:"form-container input-group row-block"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cnv.CHROM),expression:"cnv.CHROM"}],staticClass:"form-input chr",style:(_vm.cnv.CHROM ? {} : { color: '#A9A9A9' }),on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.cnv, "CHROM", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('DIALOG.editCNVToChapter.cnvForm.placeholder.___chrom')))]),_vm._v(" "),_vm._l((_vm.chromOptions),function(option,index){return _c('option',{key:index,domProps:{"value":option.value}},[_vm._v(_vm._s(option.title))])})],2),_vm._v(" "),_c('div',{staticClass:"split"},[_vm._v(_vm._s(':'))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cnv.POS_START),expression:"cnv.POS_START"}],staticClass:"form-input start",attrs:{"type":"text","placeholder":_vm.$t('DIALOG.editCNVToChapter.cnvForm.placeholder.___posStart')},domProps:{"value":(_vm.cnv.POS_START)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cnv, "POS_START", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"split"},[_vm._v(_vm._s('~'))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cnv.POS_END),expression:"cnv.POS_END"}],staticClass:"form-input end",attrs:{"type":"text","placeholder":_vm.$t('DIALOG.editCNVToChapter.cnvForm.placeholder.___posEnd')},domProps:{"value":(_vm.cnv.POS_END)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cnv, "POS_END", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"block-container gene col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('DIALOG.editCNVToChapter.___geneTitle')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"gene-container col-block flex-start"},[_c('div',{staticClass:"search-container row-block flex-start"},[_c('div',{staticClass:"search-input input-group",style:({ flex: 1 })},[_c('geneTag',{style:({ width: '100%' }),attrs:{"disabled":!_vm.cnv.CHROM,"tagHeight":'300px',"placeholder":_vm.$t('DIALOG.editCNVToChapter.geneTag.___placeholder'),"init":_vm.query['gene'],"title":false,"dataInfo":_vm.tag['genes'].info,"genes":_vm.tag['genes'].datas ? _vm.tag['genes'].datas.filter(function (gene) { return (_vm.cnv.CHROM === 'chrM' && (gene.symbol || '').startsWith('MT-')) || (_vm.cnv.CHROM !== 'chrM' && !(gene.symbol || '').startsWith('MT-')); }) : _vm.tag['genes'].datas,"needFilter":false},on:{"input":function (content) { _vm.query['gene'] = content; },"tag":function (content) { _vm.query['gene'] = content.name; _vm.curTag['gene'] = content; },"send":function (content) { return (_vm.tag['genes'].datas || []).length && _vm.query['gene'] ? _vm.addToSearch(_vm.curTag['gene'] || _vm.query['gene']) : ''; }}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zSkq"),"alt":""}})],1),_vm._v(" "),_c('div',{style:({ width: '16px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.loading['addToSearch'] },attrs:{"disabled":!((_vm.tag['genes'].datas || []).length && _vm.query['gene'])},on:{"click":function (e) { return (_vm.tag['genes'].datas || []).length && _vm.query['gene'] ? _vm.addToSearch(_vm.curTag['gene'] || _vm.query['gene']) : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___add')))])])])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"gene-list-container row-block flex-start flex-wrap"},_vm._l((_vm.selectedGenes),function(gene,index){return _c('div',{key:index,staticClass:"gene-block row-block",on:{"click":function (e) { return _vm.selectedGenes.splice(index, 1); }}},[_c('div',{staticClass:"gene-title"},[_vm._v(_vm._s(gene.SYMBOL))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('img',{staticClass:"gene-remove-icon",attrs:{"src":__webpack_require__("ZM3o"),"alt":""}})])}),0)]),_vm._v(" "),_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px', })}),_vm._v(" "),_c('div',{staticClass:"block-container chapter col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('DIALOG.editCNVToChapter.___chapterTitle')))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '12px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-container row-block"},[_c('div',{staticClass:"chapter-list-container row-block flex-wrap"},_vm._l((_vm.chapters),function(chapter,index){return _c('div',{key:index,staticClass:"chapter-item-container"},[_c('div',{staticClass:"chapter-item row-block",on:{"click":function (e) { return _vm.selectedChapters = (_vm.selectedChapters.includes(chapter.value) ? _vm.selectedChapters.filter(function (c) { return c !== chapter.value; }) : _vm.selectedChapters.concat([chapter.value])); }}},[_c('img',{attrs:{"src":_vm.selectedChapters.includes(chapter.value) ? __webpack_require__("7kqe") : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title"},[_vm._v(_vm._s(chapter.title))])])])}),0)])]),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, _vm.sendData); }}},[_c('span',[_vm._v(_vm._s(_vm.isEdit ? _vm.$t('COMMON.button.___update') : _vm.$t('COMMON.button.___create')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var editCNVToChapter_staticRenderFns = []
var editCNVToChapter_esExports = { render: editCNVToChapter_render, staticRenderFns: editCNVToChapter_staticRenderFns }
/* harmony default export */ var dialog_editCNVToChapter = (editCNVToChapter_esExports);
// CONCATENATED MODULE: ./src/components/dialog/editCNVToChapter.vue
var editCNVToChapter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editCNVToChapter___vue_template_functional__ = false
/* styles */
var editCNVToChapter___vue_styles__ = null
/* scopeId */
var editCNVToChapter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editCNVToChapter___vue_module_identifier__ = null
var editCNVToChapter_Component = editCNVToChapter_normalizeComponent(
  editCNVToChapter,
  dialog_editCNVToChapter,
  editCNVToChapter___vue_template_functional__,
  editCNVToChapter___vue_styles__,
  editCNVToChapter___vue_scopeId__,
  editCNVToChapter___vue_module_identifier__
)

/* harmony default export */ var components_dialog_editCNVToChapter = (editCNVToChapter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/editReportCNV.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var editReportCNV = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      result: {
        'type': [],
        'GT': '',
        'intron': '',
        'length': '',
        'ParentalOrigin': []
      },
      multiple: {
        'type': false,
        'GT': false,
        'intron': false,
        'length': false,
        'ParentalOrigin': false
      }
    };
  },
  created: function created() {
    this.result = extends_default()({}, this.result, this.param.value);
    this.multiple = extends_default()({}, this.multiple, this.param.multiple);
  },

  computed: {
    formItems: function formItems() {
      return {
        'type': entries_default()(global_data["L" /* reportCNVTypeMap */]).map(function (_ref) {
          var _ref2 = slicedToArray_default()(_ref, 2),
              value = _ref2[0],
              title = _ref2[1];

          return { title: title, value: value };
        }),
        'ParentalOrigin': entries_default()(global_data["O" /* reportParentalOriginMap */]).map(function (_ref3) {
          var _ref4 = slicedToArray_default()(_ref3, 2),
              value = _ref4[0],
              title = _ref4[1];

          return { title: title, value: value };
        })
      };
    },

    // param
    type: function type() {
      return this.param.type;
    },
    cnv: function cnv() {
      return extends_default()({}, this.param.cnv);
    }
  },
  methods: {
    setValue: function setValue(type, item) {
      if (!this.multiple[type]) {
        this.result[type] = [];
      }
      this.result[type] = !this.result[type].includes(item.value) ? this.result[type].concat([item.value]) : this.result[type].length > 1 ? this.result[type].filter(function (value) {
        return value !== item.value;
      }) : this.result[type];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46eca9c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/editReportCNV.vue
var editReportCNV_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-report-cnv-dailog dialog col-block"},[_c('div',{staticClass:"block-container cnv col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s({
          'type': _vm.$t('DIALOG.editReportCNV.___typeTitle'),
          'GT': _vm.$t('DIALOG.editReportCNV.___gtTitle'),
          'intron': _vm.$t('DIALOG.editReportCNV.___intronTitle'),
          'length': _vm.$t('DIALOG.editReportCNV.___lengthTitle')
        }[_vm.type])}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"cnv-container col-block flex-start"},[_c('div',{staticClass:"cnv-title",domProps:{"innerHTML":_vm._s('<b>SV</b>' + ' ' + _vm.cnv.CHROM + ':' + _vm.cnv.POS_START + '-' + _vm.cnv.POS_END)}})])]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),(_vm.type === 'type')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.editReportCNV.cnvForm.title.___type'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"form-container row-block"},[_c('div',{staticClass:"form-list-container row-block flex-wrap"},_vm._l((_vm.formItems['type']),function(item,index){return _c('div',{key:index,staticClass:"form-item-container"},[_c('div',{staticClass:"form-item row-block",on:{"click":function (e) { return _vm.setValue('type', item); }}},[_c('img',{class:{ multiple: _vm.multiple['type'] },attrs:{"src":_vm.result['type'].includes(item.value) ? __webpack_require__("Id76")("./" + (_vm.multiple['type'] ? 'checkbox': 'radio') + '-true.svg') : __webpack_require__("AJyC")("./" + (_vm.multiple['type'] ? 'checkbox': 'radio') + '-false.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title",style:(item.color ? { color: item.color } : {})},[_vm._v(_vm._s(item.title))])])])}),0)])])]:_vm._e(),_vm._v(" "),(_vm.type === 'GT')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"form-container input-group row-block"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result['GT']),expression:"result['GT']"}],attrs:{"type":"text","placeholder":_vm.$t('DIALOG.editReportCNV.cnvForm.placeholder.___gt')},domProps:{"value":(_vm.result['GT'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, 'GT', $event.target.value)}}})])])]:_vm._e(),_vm._v(" "),(_vm.type === 'intron')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"form-container input-group row-block"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result['intron']),expression:"result['intron']"}],attrs:{"type":"text","placeholder":_vm.$t('DIALOG.editReportCNV.cnvForm.placeholder.___intron')},domProps:{"value":(_vm.result['intron'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, 'intron', $event.target.value)}}})])])]:_vm._e(),_vm._v(" "),(_vm.type === 'length')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"form-container input-group row-block"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result['length']),expression:"result['length']"}],attrs:{"type":"text","placeholder":_vm.$t('DIALOG.editReportCNV.cnvForm.placeholder.___length')},domProps:{"value":(_vm.result['length'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, 'length', $event.target.value)}}})])])]:_vm._e(),_vm._v(" "),(_vm.type === 'Parental Origin')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.editReportCNV.cnvForm.title.___parentalOrigin'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '12px' })}),_vm._v(" "),_c('div',{staticClass:"form-container row-block"},[_c('div',{staticClass:"form-list-container row-block flex-wrap"},_vm._l((_vm.formItems['ParentalOrigin']),function(item,index){return _c('div',{key:index,staticClass:"form-item-container"},[_c('div',{staticClass:"form-item row-block",on:{"click":function (e) { return _vm.setValue('ParentalOrigin', item); }}},[_c('img',{class:{ multiple: _vm.multiple['ParentalOrigin'] },attrs:{"src":_vm.result['ParentalOrigin'].includes(item.value) ? __webpack_require__("Id76")("./" + (_vm.multiple['ParentalOrigin'] ? 'checkbox': 'radio') + '-true.svg') : __webpack_require__("AJyC")("./" + (_vm.multiple['ParentalOrigin'] ? 'checkbox': 'radio') + '-false.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title",style:(item.color ? { color: item.color } : {})},[_vm._v(_vm._s(item.title))])])])}),0)])])]:_vm._e(),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, _vm.result); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___update')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var editReportCNV_staticRenderFns = []
var editReportCNV_esExports = { render: editReportCNV_render, staticRenderFns: editReportCNV_staticRenderFns }
/* harmony default export */ var dialog_editReportCNV = (editReportCNV_esExports);
// CONCATENATED MODULE: ./src/components/dialog/editReportCNV.vue
var editReportCNV_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editReportCNV___vue_template_functional__ = false
/* styles */
var editReportCNV___vue_styles__ = null
/* scopeId */
var editReportCNV___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editReportCNV___vue_module_identifier__ = null
var editReportCNV_Component = editReportCNV_normalizeComponent(
  editReportCNV,
  dialog_editReportCNV,
  editReportCNV___vue_template_functional__,
  editReportCNV___vue_styles__,
  editReportCNV___vue_scopeId__,
  editReportCNV___vue_module_identifier__
)

/* harmony default export */ var components_dialog_editReportCNV = (editReportCNV_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/editReportSV.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var editReportSV = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      result: {
        'type': [],
        'GT': '',
        'intron': '',
        'length': '',
        'ParentalOrigin': []
      },
      multiple: {
        'type': false,
        'GT': false,
        'intron': false,
        'length': false,
        'ParentalOrigin': false
      }
    };
  },
  created: function created() {
    this.result = extends_default()({}, this.result, this.param.value);
    this.multiple = extends_default()({}, this.multiple, this.param.multiple);
  },

  computed: {
    formItems: function formItems() {
      return {
        'type': entries_default()(global_data["R" /* reportSVTypeMap */]).map(function (_ref) {
          var _ref2 = slicedToArray_default()(_ref, 2),
              value = _ref2[0],
              title = _ref2[1];

          return { title: title, value: value };
        }),
        'ParentalOrigin': entries_default()(global_data["O" /* reportParentalOriginMap */]).map(function (_ref3) {
          var _ref4 = slicedToArray_default()(_ref3, 2),
              value = _ref4[0],
              title = _ref4[1];

          return { title: title, value: value };
        })
      };
    },

    // param
    type: function type() {
      return this.param.type;
    },
    sv: function sv() {
      return extends_default()({}, this.param.sv);
    }
  },
  methods: {
    setValue: function setValue(type, item) {
      if (!this.multiple[type]) {
        this.result[type] = [];
      }
      this.result[type] = !this.result[type].includes(item.value) ? this.result[type].concat([item.value]) : this.result[type].length > 1 ? this.result[type].filter(function (value) {
        return value !== item.value;
      }) : this.result[type];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c08b5670","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/editReportSV.vue
var editReportSV_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-report-sv-dailog dialog col-block"},[_c('div',{staticClass:"block-container sv col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s({
          'type': _vm.$t('DIALOG.editReportSV.___typeTitle'),
          'GT': _vm.$t('DIALOG.editReportSV.___gtTitle'),
          'intron': _vm.$t('DIALOG.editReportSV.___intronTitle'),
          'length': _vm.$t('DIALOG.editReportSV.___lengthTitle')
        }[_vm.type])}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"sv-container col-block flex-start"},[_c('div',{staticClass:"sv-title",domProps:{"innerHTML":_vm._s('<b>SV</b>' + ' ' + _vm.sv.CHROM + ':' + _vm.sv.POS_START + '-' + _vm.sv.POS_END)}})])]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),(_vm.type === 'type')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.editReportSV.svForm.title.___type'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"form-container row-block"},[_c('div',{staticClass:"form-list-container row-block flex-wrap"},_vm._l((_vm.formItems['type']),function(item,index){return _c('div',{key:index,staticClass:"form-item-container"},[_c('div',{staticClass:"form-item row-block",on:{"click":function (e) { return _vm.setValue('type', item); }}},[_c('img',{class:{ multiple: _vm.multiple['type'] },attrs:{"src":_vm.result['type'].includes(item.value) ? __webpack_require__("Id76")("./" + (_vm.multiple['type'] ? 'checkbox': 'radio') + '-true.svg') : __webpack_require__("AJyC")("./" + (_vm.multiple['type'] ? 'checkbox': 'radio') + '-false.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title",style:(item.color ? { color: item.color } : {})},[_vm._v(_vm._s(item.title))])])])}),0)])])]:_vm._e(),_vm._v(" "),(_vm.type === 'GT')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"form-container input-group row-block"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result['GT']),expression:"result['GT']"}],attrs:{"type":"text","placeholder":_vm.$t('DIALOG.editReportSV.svForm.placeholder.___gt')},domProps:{"value":(_vm.result['GT'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, 'GT', $event.target.value)}}})])])]:_vm._e(),_vm._v(" "),(_vm.type === 'intron')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"form-container input-group row-block"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result['intron']),expression:"result['intron']"}],attrs:{"type":"text","placeholder":_vm.$t('DIALOG.editReportSV.svForm.placeholder.___intron')},domProps:{"value":(_vm.result['intron'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, 'intron', $event.target.value)}}})])])]:_vm._e(),_vm._v(" "),(_vm.type === 'length')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"form-container input-group row-block"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result['length']),expression:"result['length']"}],attrs:{"type":"text","placeholder":_vm.$t('DIALOG.editReportSV.svForm.placeholder.___length')},domProps:{"value":(_vm.result['length'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, 'length', $event.target.value)}}})])])]:_vm._e(),_vm._v(" "),(_vm.type === 'Parental Origin')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.editReportSV.svForm.title.___parentalOrigin'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '12px' })}),_vm._v(" "),_c('div',{staticClass:"form-container row-block"},[_c('div',{staticClass:"form-list-container row-block flex-wrap"},_vm._l((_vm.formItems['ParentalOrigin']),function(item,index){return _c('div',{key:index,staticClass:"form-item-container"},[_c('div',{staticClass:"form-item row-block",on:{"click":function (e) { return _vm.setValue('ParentalOrigin', item); }}},[_c('img',{class:{ multiple: _vm.multiple['ParentalOrigin'] },attrs:{"src":_vm.result['ParentalOrigin'].includes(item.value) ? __webpack_require__("Id76")("./" + (_vm.multiple['ParentalOrigin'] ? 'checkbox': 'radio') + '-true.svg') : __webpack_require__("AJyC")("./" + (_vm.multiple['ParentalOrigin'] ? 'checkbox': 'radio') + '-false.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title",style:(item.color ? { color: item.color } : {})},[_vm._v(_vm._s(item.title))])])])}),0)])])]:_vm._e(),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, _vm.result); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___update')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var editReportSV_staticRenderFns = []
var editReportSV_esExports = { render: editReportSV_render, staticRenderFns: editReportSV_staticRenderFns }
/* harmony default export */ var dialog_editReportSV = (editReportSV_esExports);
// CONCATENATED MODULE: ./src/components/dialog/editReportSV.vue
var editReportSV_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editReportSV___vue_template_functional__ = false
/* styles */
var editReportSV___vue_styles__ = null
/* scopeId */
var editReportSV___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editReportSV___vue_module_identifier__ = null
var editReportSV_Component = editReportSV_normalizeComponent(
  editReportSV,
  dialog_editReportSV,
  editReportSV___vue_template_functional__,
  editReportSV___vue_styles__,
  editReportSV___vue_scopeId__,
  editReportSV___vue_module_identifier__
)

/* harmony default export */ var components_dialog_editReportSV = (editReportSV_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/userAvatar.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var userAvatar = ({
  mixins: [toastMethods["a" /* default */], routeLoading["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedID: null,
      avatars: [],
      customAvatar: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['userSetting']), {
    // param
    defaultAvatar: function defaultAvatar() {
      return this.param.avatar || {};
    },

    // global
    fileTypeCheck: function fileTypeCheck() {
      return util["f" /* fileTypeCheck */];
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUserSettingAction', 'setModal2Action']), {
    fetchData: function fetchData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchCustomAvatar();

              case 2:
                _context.next = 4;
                return _this.fetchUserAvatarFiles();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchCustomAvatar: function fetchCustomAvatar() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, response, customAvatar;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this2.$ls.get('userInfo');
                _context2.next = 4;
                return Object(src_api["_77" /* getUserAvatarFile */])(config);

              case 4:
                response = _context2.sent;
                customAvatar = response.data.data;

                if (customAvatar) {
                  _this2.customAvatar = extends_default()({}, customAvatar, {
                    url: api_config["a" /* API_ROOT */] + 'global/files/download?file_id=' + customAvatar.id + '&class_name=' + customAvatar.class_name + '&access_token=' + config['access_token']
                  });
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    fetchUserAvatarFiles: function fetchUserAvatarFiles() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, response, avatars;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this3.$ls.get('userInfo');
                _context3.next = 4;
                return Object(src_api["_78" /* getUserAvatarFiles */])(config);

              case 4:
                response = _context3.sent;
                avatars = response.data.data;

                avatars = avatars.filter(function (avatar) {
                  return avatar.size && avatar.id !== (_this3.customAvatar || {}).id;
                }).map(function (avatar) {
                  return extends_default()({}, avatar, {
                    url: api_config["a" /* API_ROOT */] + 'global/files/download?file_id=' + avatar.id + '&class_name=' + avatar.class_name + '&access_token=' + config['access_token']
                  });
                });
                _this3.avatars = avatars;
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0;

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 10]]);
      }))();
    },
    afterSetData: function afterSetData() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var id;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                id = _this4.defaultAvatar.id || _this4.userSetting.avatar_file.id;

                _this4.selectedID = (_this4.avatars.find(function (avatar) {
                  return avatar.id === id;
                }) || {}).id || 'custom';
                _this4.customAvatar = (_this4.defaultAvatar.id || '') === 'custom' ? _this4.defaultAvatar : _this4.customAvatar;

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    selectCustomAvatar: function selectCustomAvatar(e) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var file, url;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                file = e.target.files[0];
                _context6.next = 3;
                return Object(util["k" /* imageReader */])([file]);

              case 3:
                url = _context6.sent[0];

                _this5.setModal2Action({
                  action: 'imageCropper',
                  width: '616px',
                  param: {
                    url: url
                  },
                  callback: function () {
                    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(result) {
                      return regenerator_default.a.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              if (result) {
                                _this5.customAvatar = {
                                  id: 'custom',
                                  name: file.name,
                                  url: result.url,
                                  file: result.file,
                                  class_name: 'AvatarFile'
                                };
                              }

                            case 1:
                            case 'end':
                              return _context5.stop();
                          }
                        }
                      }, _callee5, _this5);
                    }));

                    return function callback(_x) {
                      return _ref.apply(this, arguments);
                    };
                  }()
                });
                e.target.value = '';

              case 6:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    setAvatar: function setAvatar() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var result;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                result = _this6.avatars.find(function (avatar) {
                  return avatar.id === _this6.selectedID;
                }) || _this6.customAvatar;

                _this6.$emit('changeModal', {}, result);

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b575978","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/userAvatar.vue
var userAvatar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-avatar-dailog dialog col-block"},[_c('div',{staticClass:"user-avatar-container col-block flex-start"},[_c('div',{staticClass:"user-avatar-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.userAvatar.___userTitle')))]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"user-avatar-list-container row-block flex-start flex-wrap"},_vm._l((_vm.avatars),function(avatar,index){return _c('div',{key:index,staticClass:"user-avatar-block",on:{"click":function (e) { return _vm.selectedID = avatar.id; }}},[_c('div',{staticClass:"user-avatar",style:({ 'background-image': 'url(' + avatar.url + ')' })}),_vm._v(" "),_c('div',{staticClass:"user-avatar-radio-icon icon-block",style:({ '--size': '20px' })},[_c('img',{attrs:{"src":_vm.selectedID === avatar.id ? __webpack_require__("xccc") : __webpack_require__("z0Pm"),"alt":""}})])])}),0)]),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"custom-avatar-container col-block flex-start"},[_c('div',{staticClass:"custom-avatar-title-container row-block",class:{ disabled: !_vm.customAvatar },on:{"click":function (e) { return _vm.customAvatar && (_vm.selectedID = 'custom'); }}},[_c('div',{staticClass:"custom-avatar-radio-icon icon-block",style:({ '--size': '20px' })},[_c('img',{attrs:{"src":_vm.selectedID === 'custom' ? __webpack_require__("xccc") : __webpack_require__("z0Pm"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"custom-avatar-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.userAvatar.___customTitle')))])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"custom-avatar-main-container col-block"},[(_vm.customAvatar)?_c('div',{staticClass:"custom-avatar-image-block"},[_c('div',{staticClass:"custom-avatar-image mask",style:({ 'background-image': 'url(' + _vm.customAvatar.url + ')' })}),_vm._v(" "),_c('div',{staticClass:"custom-avatar-image",style:({ 'background-image': 'url(' + _vm.customAvatar.url + ')' })})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mask"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":"custom-avatar","accept":"image/*"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.selectCustomAvatar(e); }, function () { return _vm.addToast('error', _vm.$t('COMMON.toast.___fileTypeAlert', { types: 'image' })); }); }}}),_vm._v(" "),_c('label',{attrs:{"for":"custom-avatar"}}),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button"},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])])])])]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '16px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.setAvatar(); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___upload')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var userAvatar_staticRenderFns = []
var userAvatar_esExports = { render: userAvatar_render, staticRenderFns: userAvatar_staticRenderFns }
/* harmony default export */ var dialog_userAvatar = (userAvatar_esExports);
// CONCATENATED MODULE: ./src/components/dialog/userAvatar.vue
var userAvatar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var userAvatar___vue_template_functional__ = false
/* styles */
var userAvatar___vue_styles__ = null
/* scopeId */
var userAvatar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var userAvatar___vue_module_identifier__ = null
var userAvatar_Component = userAvatar_normalizeComponent(
  userAvatar,
  dialog_userAvatar,
  userAvatar___vue_template_functional__,
  userAvatar___vue_styles__,
  userAvatar___vue_scopeId__,
  userAvatar___vue_module_identifier__
)

/* harmony default export */ var components_dialog_userAvatar = (userAvatar_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-advanced-cropper/dist/index.es.js
var index_es = __webpack_require__("RIqR");

// EXTERNAL MODULE: ./node_modules/vue-advanced-cropper/dist/style.css
var dist_style = __webpack_require__("T0+N");
var style_default = /*#__PURE__*/__webpack_require__.n(dist_style);

// EXTERNAL MODULE: ./node_modules/vue-advanced-cropper/dist/theme.classic.css
var theme_classic = __webpack_require__("fRKO");
var theme_classic_default = /*#__PURE__*/__webpack_require__.n(theme_classic);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/imageCropper.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var imageCropper = ({
  components: {
    Cropper: index_es["b" /* Cropper */],
    CircleStencil: index_es["a" /* CircleStencil */]
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    defaultSize: function defaultSize(_ref) {
      var imageSize = _ref.imageSize;

      return {
        width: Math.min(imageSize.height, imageSize.width),
        height: Math.min(imageSize.height, imageSize.width)
      };
    },
    stencilSize: function stencilSize(_ref2) {
      var boundaries = _ref2.boundaries;

      return {
        width: Math.min(boundaries.height, boundaries.width) * 0.9,
        height: Math.min(boundaries.height, boundaries.width) * 0.9
      };
    },
    sendResult: function sendResult() {
      var _this = this;

      var _$refs$cropper$getRes = this.$refs.cropper.getResult(),
          canvas = _$refs$cropper$getRes.canvas;

      canvas.toBlob(function (blob) {
        var result = {
          file: blob,
          url: canvas.toDataURL()
        };
        _this.$emit('changeModal', {}, result);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ec79ff3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/imageCropper.vue
var imageCropper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-cropper-dailog dialog col-block"},[_c('cropper',{ref:"cropper",style:({
      'min-width': '160px',
      'min-height': '160px'
    }),attrs:{"stencil-component":"circle-stencil","src":_vm.param.url,"imageRestriction":'stencil',"default-size":_vm.defaultSize,"stencil-size":_vm.stencilSize,"stencil-props":{
      lines: {},
      handlers: {},
      movable: false,
      scalable: false,
      aspectRatio: 1
    },"canvas":{
      width: 320,
      height: 320
    }}}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.sendResult(); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___select')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var imageCropper_staticRenderFns = []
var imageCropper_esExports = { render: imageCropper_render, staticRenderFns: imageCropper_staticRenderFns }
/* harmony default export */ var dialog_imageCropper = (imageCropper_esExports);
// CONCATENATED MODULE: ./src/components/dialog/imageCropper.vue
var imageCropper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var imageCropper___vue_template_functional__ = false
/* styles */
var imageCropper___vue_styles__ = null
/* scopeId */
var imageCropper___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var imageCropper___vue_module_identifier__ = null
var imageCropper_Component = imageCropper_normalizeComponent(
  imageCropper,
  dialog_imageCropper,
  imageCropper___vue_template_functional__,
  imageCropper___vue_styles__,
  imageCropper___vue_scopeId__,
  imageCropper___vue_module_identifier__
)

/* harmony default export */ var components_dialog_imageCropper = (imageCropper_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/datasetSelectCase.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datasetSelectCase = ({
  components: {
    pageButtons: pageButtons["a" /* default */]
  },
  mixins: [customGrab["a" /* default */], responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      query: '',
      selectedTableData: null,
      selectedTableDatas: [],
      // table
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [[40, 172, 66, 66, 152, 152], []],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // page
      displayPage: 1,
      pageData: {
        selectedPage: 1,
        display: 20,
        total: null,
        buttonRange: 7,
        pageJumpTo: ''
      },
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['scrollState']), {
    filtedCaseDatas: function filtedCaseDatas() {
      var _this = this;

      var filtedCaseDatas = [].concat(toConsumableArray_default()(this.cases));
      filtedCaseDatas = Object(util["m" /* sortData */])((this.cases || []).filter(function (data) {
        return !_this.selectedDataMap[data.id] && [data.case_id].concat(toConsumableArray_default()(data.phenotypeDatas.map(function (phenotypeData) {
          return phenotypeData.query;
        }))).join('ゐ').includes(_this.query);
      }), this.sort.value.map(function (x) {
        return _this.sortMap[x];
      }), this.sort.order.map(function (x) {
        return x.replace('-', '');
      }));
      filtedCaseDatas = filtedCaseDatas.filter(function (_, i) {
        return i >= _this.pageData.display * (_this.displayPage - 1) && i < _this.pageData.display * _this.displayPage;
      });
      return filtedCaseDatas;
    },
    tableDatas: function tableDatas() {
      var _this2 = this;

      var tableDatas = [].concat(toConsumableArray_default()(Object(util["m" /* sortData */])(values_default()(this.selectedDataMap), this.sort.value.map(function (x) {
        return _this2.sortMap[x];
      }), this.sort.order.map(function (x) {
        return x.replace('-', '');
      }))), toConsumableArray_default()(this.filtedCaseDatas.filter(function (data) {
        return !_this2.selectedDataMap[data.id];
      })));
      tableDatas = Object(util["i" /* groupBy */])(tableDatas, function () {
        return 'default';
      }).map(function (datas) {
        return { title: datas[0].group, isGroup: true, datas: datas };
      });
      return tableDatas;
    },
    selectedDataMap: function selectedDataMap() {
      return this.selectedTableDatas.reduce(function (map, data) {
        return extends_default()({}, map, defineProperty_default()({}, data.id, extends_default()({}, data, { selected: true })));
      }, {});
    },
    sortMap: function sortMap() {
      return this.tableOptions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortMap || c.value));
      }, {});
    },
    totalPage: function totalPage() {
      this.pageData.selectedPage = 1;
      return Math.ceil(Math.min(this.cases.length, this.pageData.display * 5000) / this.pageData.display);
    },

    // static
    tableOptions: function tableOptions() {
      var _this3 = this;

      return [{
        value: '_SELECT',
        class: function _class() {
          return ['center'];
        },
        sortMap: null
      }, {
        title: this.$t('DIALOG.datasetSelectCase.table.title.___caseID'),
        value: 'case_id'
      }, {
        title: this.$t('DIALOG.datasetSelectCase.table.title.___sex'),
        value: 'sex',
        class: function _class() {
          return ['center'];
        },
        display: function display(value) {
          return { Male: 'M', Female: 'F', Unknown: 'U' }[value];
        },
        style: function style(value) {
          return { Male: { color: '#003679' }, Female: { color: '#BE0F0F' }, Unknown: { color: '#333333' } }[value];
        }
      }, {
        title: this.$t('DIALOG.datasetSelectCase.table.title.___birthYear'),
        value: 'birth_year',
        class: function _class() {
          return ['center'];
        },
        display: function display(value) {
          return value ? new Date().getFullYear() - value + '' : null;
        }
      }, {
        title: this.$t('DIALOG.datasetSelectCase.table.title.___createdAt'),
        value: 'created_at',
        display: function display(value) {
          return value ? Object(util["d" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : value;
        }
      }, {
        title: this.$t('DIALOG.datasetSelectCase.table.title.___updatedAt'),
        value: 'updated_at',
        display: function display(value) {
          return value ? Object(util["d" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : value;
        }
      }, {
        title: this.$t('DIALOG.datasetSelectCase.table.title.___phenotypeDatas'),
        value: 'phenotypeDatas',
        description: function description(value) {
          return (value || []).length > 1 ? '& ' + _this3.$t(global_data["F" /* pageDisplay */].item, value.length, { count: value.length - 1 }) : '';
        },
        style: function style(value) {
          return { 'font-weight': 'bold' };
        },
        display: function display(value) {
          return value ? (value[0] || {}).query : value;
        },
        sortMap: null
      }, {
        title: this.$t('DIALOG.datasetSelectCase.table.title.___genePanels'),
        value: 'gene_panels',
        description: function description(value) {
          return (value || []).length > 1 ? '& ' + _this3.$t(global_data["F" /* pageDisplay */].item, value.length, { count: value.length - 1 }) : '';
        },
        style: function style(value) {
          return { 'font-weight': 'bold' };
        },
        display: function display(value) {
          return value ? (value[0] || {}).name : value;
        },
        sortMap: null
      }];
    },

    // param
    cases: function cases() {
      return this.param.cases;
    },

    // global
    pageDisplay: function pageDisplay() {
      return global_data["F" /* pageDisplay */];
    },
    toPriceString: function toPriceString() {
      return util["r" /* toPriceString */];
    }
  }),
  watch: {
    // data
    'selectedTableData': function selectedTableData(nv, ov) {
      if (nv !== ov && stringify_default()(nv) !== stringify_default()(ov)) {
        this.selectedTableData = nv ? JSON.parse(stringify_default()(nv)) : null;
      }
    },

    // table
    'tableDatas': function tableDatas() {
      this.getTableOverflow();
    },
    'windowWidth': function windowWidth(nv) {
      this.getTableWidths(nv);
      this.getTableOverflow();
    },

    // page
    'pageData.selectedPage': function pageDataSelectedPage() {
      var _this4 = this;

      if (this.pageData.selectedPage) {
        this.displayPage = this.pageData.selectedPage;
        setTimeout(function () {
          _this4.pageData.selectedPage = 0;
        });
      }
    }
  },
  methods: {
    // table
    tableOnSelect: function tableOnSelect(datas, value) {
      var _this5 = this;

      if (value === 'all') {
        if (!this.filtedCaseDatas.some(function (data) {
          return !_this5.selectedDataMap[data.id];
        })) {
          datas = this.selectedTableDatas;
          value = false;
        } else {
          datas = this.filtedCaseDatas;
          value = true;
        }
      }
      var dataMap = datas.reduce(function (map, data) {
        return extends_default()({}, map, defineProperty_default()({}, data.id, data));
      }, {});
      this.selectedTableDatas = value ? [].concat(toConsumableArray_default()(datas.filter(function (data) {
        return !_this5.selectedDataMap[data.id];
      })), toConsumableArray_default()(this.selectedTableDatas)) : this.selectedTableDatas.filter(function (result) {
        return !dataMap[result.id];
      });
    },
    getTableOverflow: function getTableOverflow() {
      var _this6 = this;

      setTimeout(function () {
        var scrollContainer = _this6.$refs['custom-table-scroll'];
        if (scrollContainer) {
          _this6.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight;
        }
      });
    },
    getTableWidths: function getTableWidths(windowWidth) {
      window.dispatchEvent(new Event('scroll'));
      var tableWidth = Math.min(windowWidth - 20 * 2, 1208) - 22 * 2 - (this.scrollState.height ? this.scrollbarSize : 0);
      tableWidth = tableWidth - this.staticTableWidths[0].reduce(function (s, c) {
        return s + c;
      }, 0) - this.staticTableWidths[1].reduce(function (s, c) {
        return s + c;
      }, 0);
      var tableWidths = this.tableWidths || [].concat(toConsumableArray_default()(this.staticTableWidths[0]), [1, 1], toConsumableArray_default()(this.staticTableWidths[1])).map(function (width) {
        return {
          value: width
        };
      });
      var tableMinWidths = this.tableMinWidths || 0.1;
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length);
      var ratio = tableWidth / tableWidths.reduce(function (s, c) {
        return s + c.value;
      }, 0);
      tableWidths = Array.prototype.concat.apply([], [this.staticTableWidths[0].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      }), tableWidths.map(function (width) {
        return {
          value: width.value * ratio,
          grab: 0
        };
      }), this.staticTableWidths[1].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      })]);
      this.tableMinWidths = tableMinWidths * ratio;
      this.tableWidths = tableWidths;
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
    },

    // grab
    boardResponse: function boardResponse(id, type) {
      var _this7 = this;

      return {
        'board1': {
          'start': function start(boardData) {
            _this7.sort.disabled = true;
          },
          'move': function move(boardData) {
            if (_this7.boardType['board1'] === 'grab') {
              var grabID = _this7.boardData[id].grabID;
              var tableWidths = [].concat(toConsumableArray_default()(_this7.tableWidths));
              var result = boardData.grabX - boardData.baseX;
              var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this7.staticTableWidths[1].length).reduce(function (s, c, i) {
                return s + c.value - (_this7.tableOptions[i].minWidth || _this7.tableMinWidths);
              }, 0);
              tableWidths.forEach(function (_, i) {
                if (i === grabID) {
                  tableWidths[i].grab = result;
                }if (i > grabID && i + _this7.staticTableWidths[1].length < tableWidths.length) {
                  tableWidths[i].grab = -(result * ((tableWidths[i].value - (_this7.tableOptions[i].minWidth || _this7.tableMinWidths)) / ratioBase));
                }
              });
              _this7.tableWidths = tableWidths;
            }
          },
          'end': function end(boardData) {
            var grabID = _this7.boardData[id].grabID;
            var tableWidths = [].concat(toConsumableArray_default()(_this7.tableWidths));
            var result = boardData.grabX - boardData.baseX;
            var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this7.staticTableWidths[1].length).reduce(function (s, c, i) {
              return s + c.value - (_this7.tableOptions[i].minWidth || _this7.tableMinWidths);
            }, 0);
            tableWidths.forEach(function (_, i) {
              tableWidths[i].grab = 0;
              if (i === grabID) {
                tableWidths[i].value += result;
              }if (i > grabID && i + _this7.staticTableWidths[1].length < tableWidths.length) {
                tableWidths[i].value -= result * ((tableWidths[i].value - (_this7.tableOptions[i].minWidth || _this7.tableMinWidths)) / ratioBase);
              }
            });
            _this7.tableWidths = tableWidths;
            setTimeout(function () {
              _this7.sort.disabled = false;
            });
          }
        }
      }[id];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-281db63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/datasetSelectCase.vue
var datasetSelectCase_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataset-select-case-dailog dialog col-block width-full"},[_c('div',{staticClass:"top-container row-block flex-end"},[_c('div',{staticClass:"top-title",domProps:{"innerHTML":_vm._s([
        _vm.$t('DIALOG.datasetSelectCase.___topTitle01', { count: _vm.toPriceString(_vm.cases.length) }),
        _vm.cases.length ? _vm.$t('DIALOG.datasetSelectCase.___topTitle02') : ''
      ].filter(function (x) { return x; }).join(' '))}}),_vm._v(" "),_c('div',{staticClass:"top-option-container row-block"},[(_vm.cases.length)?_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, _vm.cases.map(function (caseData) { return caseData.id; })); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___addAll')))])]):_vm._e()]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),(_vm.cases.length)?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"table-search-container row-block"},[_c('div',{staticClass:"search-title",domProps:{"innerHTML":_vm._s('<b>' + _vm.toPriceString(_vm.selectedTableDatas.length) + '</b> samples are selected.')}}),_vm._v(" "),_c('div',{staticClass:"search-container input-group",style:({ width: '420px' })},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],attrs:{"type":"text","placeholder":_vm.$t('DIALOG.datasetSelectCase.___searchPlaceholder')},domProps:{"value":(_vm.query)},on:{"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zSkq"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"table-main-container col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"custom-table",class:{ 'auto-height': false }},[(_vm.tableWidths)?_c('div',{staticClass:"table-field col-block grab-container",style:({ width: _vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) + 'px' }),on:{"mousedown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardStart]); })($event)},"mousemove":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseout":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardEnd]); })($event)}}},[_c('div',{staticClass:"grab-line x min",style:(_vm.lineData.x.min && _vm.lineData.x.min.display ? { left: _vm.lineData.x.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x max",style:(_vm.lineData.x.max && _vm.lineData.x.max.display ? { left: _vm.lineData.x.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x main",style:(_vm.lineData.x.main && _vm.lineData.x.main.display ? { left: (_vm.lineData.x.main.base + _vm.lineData.x.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x custom",style:(_vm.lineData.x.custom && _vm.lineData.x.custom.display ? { left: _vm.lineData.x.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y min",style:(_vm.lineData.y.min && _vm.lineData.y.min.display ? { top: _vm.lineData.y.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y max",style:(_vm.lineData.y.max && _vm.lineData.y.max.display ? { top: _vm.lineData.y.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y main",style:(_vm.lineData.y.main && _vm.lineData.y.main.display ? { top: (_vm.lineData.y.main.base + _vm.lineData.y.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y custom",style:(_vm.lineData.y.custom && _vm.lineData.y.custom.display ? { top: _vm.lineData.y.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"table-container col-block"},[_c('div',{staticClass:"thead"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab + 'px' }),on:{"click":function (e) { return !_vm.sort.disabled && option.sortMap !== null && _vm.tableSortBy(option.sortValue || option.value); }}},[(option.value === '_SELECT')?[_c('div',{staticClass:"_SELECT center-block"},[_c('img',{attrs:{"src":_vm.selectedTableDatas.length ? !_vm.filtedCaseDatas.some(function (data) { return !_vm.selectedDataMap[data.id]; }) ? __webpack_require__("7kqe") : __webpack_require__("Z77G") : __webpack_require__("5Ivo"),"alt":""},on:{"click":function (e) { return _vm.tableOnSelect(null, 'all'); }}})])]:[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e()],_vm._v(" "),(index + 1 > _vm.staticTableWidths[0].length && _vm.tableOptions[index + 1 + _vm.staticTableWidths[1].length])?_c('div',{staticClass:"grab-box grab-x",class:{ grabbing: _vm.boardData['board1'].grabID === index },attrs:{"grab-id":index,"grab-type":'x' + { line: '', grab: '*' }[_vm.boardType['board1']],"grab-x-min":_vm.tableWidths.slice(0, index).reduce(function (s, c) { return s + c.value; }, 0) + (option.minWidth || _vm.tableMinWidths) + '*',"grab-x-max":_vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) - _vm.tableOptions.slice(index + 1, _vm.tableOptions.length - _vm.staticTableWidths[1].length).reduce(function (s, c) { return s + (c.minWidth || _vm.tableMinWidths); }, 0) - _vm.staticTableWidths[1].reduce(function (s, c) { return s + c; }, 0) + '*',"grab-x-custom":_vm.tableWidths.slice(0, index).reduce(function (s, c) { return s + c.value; }, 0) + { line: '', grab: '*' }[_vm.boardType['board1']]}}):_vm._e()],2)}),0)])]),_vm._v(" "),_c('div',{ref:"custom-table-scroll",staticClass:"table-group-container col-block width-full"},[_c('div',{staticClass:"col-block"},_vm._l((_vm.tableDatas),function(group,gindex){return _c('div',{key:gindex,staticClass:"table-container col-block"},[_c('div',{staticClass:"tbody"},[_c('div',{staticClass:"tr group row-block",class:{ selected: group.datas.some(function (data) { return (_vm.selectedTableData || {}).id === data.id; }) },style:(group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' })},[_c('a',{staticClass:"container-block row-block"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(group[option.gValue], gindex, group),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.gstyle || (function () { return ({}); }))(group[option.gValue], gindex, group)),attrs:{"title":((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || option.gempty || '')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('center') && !(option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)]),_vm._v(" "),_vm._l((group.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"tr col-block",class:{ selectable: false, selected: (_vm.selectedTableData || {}).id === data.id }},[_c('a',{staticClass:"container-block row-block",style:({ flex: 1 }),on:{"click":function (e) { return false && (_vm.selectedTableData = data); }}},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(data[option.value], dindex, data),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[(option.value === '_SELECT')?[_c('div',{staticClass:"_SELECT center-block"},[_c('img',{attrs:{"src":data.selected ? __webpack_require__("7kqe") : __webpack_require__("5Ivo"),"alt":""},on:{"click":function (e) { return _vm.tableOnSelect([data], !data.selected); }}})])]:[_c('span',{style:((option.style || (function () { return ({}); }))(data[option.value], dindex, data)),attrs:{"title":((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || option.empty || '- -')}})],_vm._v(" "),((option.description || (function () {}))(data[option.value]))?[_c('span',{style:({ flex: 'inherit' }),domProps:{"innerHTML":_vm._s((option.description || (function () {}))(data[option.value]))}})]:_vm._e(),_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(data[option.value], dindex, data).includes('center') && !(option.class || (function () { return []; }))(data[option.value], dindex, data).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)])})],2)])}),0)])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"table-page-container row-block",style:({ height: '50px' })},[_c('div',{staticClass:"options-container input-group row-block",style:({ flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"display-container row-block"},[_c('div',{staticClass:"display-title"},[_vm._v(_vm._s(_vm.$t(_vm.pageDisplay.display)))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pageData.display),expression:"pageData.display"}],staticClass:"display",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.pageData, "display", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"200"}},[_vm._v("200")])])])])]),_vm._v(" "),_c('div',{staticClass:"options-container input-group row-block"},[_c('pageButtons',{attrs:{"default":_vm.pageData.selectedPage,"display":_vm.pageData.display - 0,"total":_vm.totalPage * _vm.pageData.display,"buttonRange":_vm.pageData.buttonRange},on:{"selectPage":function (page) { _vm.pageData.selectedPage = page }}})],1),_vm._v(" "),_c('div',{staticClass:"options-container input-group row-block",style:({ flex: 1 })},[_c('div',{staticClass:"jump-container row-block"},[_c('div',{staticClass:"jump-title"},[_vm._v(_vm._s(_vm.$t(_vm.pageDisplay.jump)))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pageData.pageJumpTo),expression:"pageData.pageJumpTo"}],staticClass:"jump",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.pageData, "pageJumpTo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function (e) { return _vm.pageData.selectedPage = _vm.pageData.pageJumpTo - 0; }]}},_vm._l(((new Array(_vm.totalPage)).fill('').map(function (_, i) { return i + 1; })),function(value,index){return _c('option',{key:index,domProps:{"value":value}},[_vm._v(_vm._s(value))])}),0)]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])]:[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"table-page-container row-block"})],_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),(_vm.cases.length)?_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, Object.keys(_vm.selectedDataMap).map(function (id) { return id - 0; })); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___add')))])]):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var datasetSelectCase_staticRenderFns = []
var datasetSelectCase_esExports = { render: datasetSelectCase_render, staticRenderFns: datasetSelectCase_staticRenderFns }
/* harmony default export */ var dialog_datasetSelectCase = (datasetSelectCase_esExports);
// CONCATENATED MODULE: ./src/components/dialog/datasetSelectCase.vue
var datasetSelectCase_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datasetSelectCase___vue_template_functional__ = false
/* styles */
var datasetSelectCase___vue_styles__ = null
/* scopeId */
var datasetSelectCase___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datasetSelectCase___vue_module_identifier__ = null
var datasetSelectCase_Component = datasetSelectCase_normalizeComponent(
  datasetSelectCase,
  dialog_datasetSelectCase,
  datasetSelectCase___vue_template_functional__,
  datasetSelectCase___vue_styles__,
  datasetSelectCase___vue_scopeId__,
  datasetSelectCase___vue_module_identifier__
)

/* harmony default export */ var components_dialog_datasetSelectCase = (datasetSelectCase_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/datasetDetail.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var datasetDetail = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  mixins: [customGrab["a" /* default */], responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedTableData: null,
      // table
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [[], [66, 67, 167, 167]],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['scrollState']), {
    tableDatas: function tableDatas() {
      var _this = this;

      var tableDatas = [].concat(toConsumableArray_default()(this.cases));
      tableDatas = Object(util["m" /* sortData */])(tableDatas, this.sort.value.map(function (x) {
        return _this.sortMap[x];
      }), this.sort.order.map(function (x) {
        return x.replace('-', '');
      }));
      tableDatas = Object(util["i" /* groupBy */])(tableDatas, function () {
        return 'default';
      }).map(function (datas) {
        return { title: datas[0].group, isGroup: true, datas: datas };
      });
      return tableDatas;
    },
    sortMap: function sortMap() {
      return this.tableOptions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortMap || c.value));
      }, {});
    },

    // static
    formOptions: function formOptions() {
      return {
        field1: [{
          title: this.$t('DIALOG.datasetDetail.form.title.___name'),
          value: 'name',
          type: 'text',
          wrap: true,
          grid: 3
        }, {
          title: this.$t('DIALOG.datasetDetail.form.title.___sampleSize'),
          value: 'sample_size',
          type: 'text',
          wrap: true,
          grid: 1,
          inputFormat: function inputFormat(value) {
            return value ? Object(util["r" /* toPriceString */])(value) : value;
          }
        }, {
          title: this.$t('DIALOG.datasetDetail.form.title.___user'),
          value: 'user',
          type: 'text',
          wrap: true,
          grid: 2,
          inputFormat: function inputFormat(value) {
            return value ? [value.first_name, value.last_name].filter(function (x) {
              return x;
            }).join(' ') + (value.email ? ' (' + [value.email].filter(function (x) {
              return x;
            }).join(' ') + ')' : '') : value;
          }
        }]
      };
    },
    tableOptions: function tableOptions() {
      return [{
        title: this.$t('DIALOG.datasetDetail.table.title.___caseID'),
        value: 'case_id'
      }, {
        title: this.$t('DIALOG.datasetDetail.table.title.___sex'),
        value: 'sex',
        width: 66,
        class: function _class() {
          return ['center'];
        },
        display: function display(value) {
          return { Male: 'M', Female: 'F', Unknown: 'U' }[value];
        },
        style: function style(value) {
          return { Male: { color: '#003679' }, Female: { color: '#BE0F0F' }, Unknown: { color: '#333333' } }[value];
        }
      }, {
        title: this.$t('DIALOG.datasetDetail.table.title.___birthYear'),
        value: 'birth_year',
        width: 67,
        class: function _class() {
          return ['center'];
        },
        display: function display(value) {
          return value ? new Date().getFullYear() - value + '' : null;
        }
      }, {
        title: this.$t('DIALOG.datasetDetail.table.title.___createdAt'),
        value: 'created_at',
        width: 167,
        display: function display(value) {
          return value ? Object(util["d" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : value;
        }
      }, {
        title: this.$t('DIALOG.datasetDetail.table.title.___updatedAt'),
        value: 'updated_at',
        width: 167,
        display: function display(value) {
          return value ? Object(util["d" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : value;
        }
      }];
    },

    // param
    dataset: function dataset() {
      return this.param.dataset;
    },
    cases: function cases() {
      return this.param.cases;
    }
  }),
  watch: {
    // data
    'selectedTableData': function selectedTableData(nv, ov) {
      if (nv !== ov && stringify_default()(nv) !== stringify_default()(ov)) {
        this.selectedTableData = nv ? JSON.parse(stringify_default()(nv)) : null;
      }
    },

    // table
    'tableDatas': function tableDatas() {
      this.getTableOverflow();
    },
    'windowWidth': function windowWidth(nv) {
      this.getTableWidths(nv);
      this.getTableOverflow();
    }
  },
  methods: {
    // table
    getTableOverflow: function getTableOverflow() {
      var _this2 = this;

      setTimeout(function () {
        var scrollContainer = _this2.$refs['custom-table-scroll'];
        if (scrollContainer) {
          _this2.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight;
        }
      });
    },
    getTableWidths: function getTableWidths(windowWidth) {
      window.dispatchEvent(new Event('scroll'));
      var tableWidth = Math.min(windowWidth - 20 * 2, 912) - 22 * 2 - (this.scrollState.height ? this.scrollbarSize : 0);
      tableWidth = tableWidth - this.staticTableWidths[0].reduce(function (s, c) {
        return s + c;
      }, 0) - this.staticTableWidths[1].reduce(function (s, c) {
        return s + c;
      }, 0);
      var tableWidths = this.tableWidths || [].concat(toConsumableArray_default()(this.staticTableWidths[0]), [1], toConsumableArray_default()(this.staticTableWidths[1])).map(function (width) {
        return {
          value: width
        };
      });
      var tableMinWidths = this.tableMinWidths || 0.1;
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length);
      var ratio = tableWidth / tableWidths.reduce(function (s, c) {
        return s + c.value;
      }, 0);
      tableWidths = Array.prototype.concat.apply([], [this.staticTableWidths[0].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      }), tableWidths.map(function (width) {
        return {
          value: width.value * ratio,
          grab: 0
        };
      }), this.staticTableWidths[1].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      })]);
      this.tableMinWidths = tableMinWidths * ratio;
      this.tableWidths = tableWidths;
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
    },

    // grab
    boardResponse: function boardResponse(id, type) {
      var _this3 = this;

      return {
        'board1': {
          'start': function start(boardData) {
            _this3.sort.disabled = true;
          },
          'move': function move(boardData) {
            if (_this3.boardType['board1'] === 'grab') {
              var grabID = _this3.boardData[id].grabID;
              var tableWidths = [].concat(toConsumableArray_default()(_this3.tableWidths));
              var result = boardData.grabX - boardData.baseX;
              var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this3.staticTableWidths[1].length).reduce(function (s, c, i) {
                return s + c.value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths);
              }, 0);
              tableWidths.forEach(function (_, i) {
                if (i === grabID) {
                  tableWidths[i].grab = result;
                }if (i > grabID && i + _this3.staticTableWidths[1].length < tableWidths.length) {
                  tableWidths[i].grab = -(result * ((tableWidths[i].value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths)) / ratioBase));
                }
              });
              _this3.tableWidths = tableWidths;
            }
          },
          'end': function end(boardData) {
            var grabID = _this3.boardData[id].grabID;
            var tableWidths = [].concat(toConsumableArray_default()(_this3.tableWidths));
            var result = boardData.grabX - boardData.baseX;
            var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this3.staticTableWidths[1].length).reduce(function (s, c, i) {
              return s + c.value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths);
            }, 0);
            tableWidths.forEach(function (_, i) {
              tableWidths[i].grab = 0;
              if (i === grabID) {
                tableWidths[i].value += result;
              }if (i > grabID && i + _this3.staticTableWidths[1].length < tableWidths.length) {
                tableWidths[i].value -= result * ((tableWidths[i].value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths)) / ratioBase);
              }
            });
            _this3.tableWidths = tableWidths;
            setTimeout(function () {
              _this3.sort.disabled = false;
            });
          }
        }
      }[id][type];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11899619","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/datasetDetail.vue
var datasetDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataset-detail-dailog dialog col-block width-full"},[_c('div',{staticClass:"form-container col-block width-full"},[_c('customForm',{attrs:{"layoutType":'grid',"groupCount":6,"init":_vm.dataset,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) {}}})],1),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"table-main-container col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"custom-table",class:{ 'auto-height': false }},[(_vm.tableWidths)?_c('div',{staticClass:"table-field col-block grab-container",style:({ width: _vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) + 'px' }),on:{"mousedown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardStart]); })($event)},"mousemove":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseout":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardEnd]); })($event)}}},[_c('div',{staticClass:"grab-line x min",style:(_vm.lineData.x.min && _vm.lineData.x.min.display ? { left: _vm.lineData.x.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x max",style:(_vm.lineData.x.max && _vm.lineData.x.max.display ? { left: _vm.lineData.x.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x main",style:(_vm.lineData.x.main && _vm.lineData.x.main.display ? { left: (_vm.lineData.x.main.base + _vm.lineData.x.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x custom",style:(_vm.lineData.x.custom && _vm.lineData.x.custom.display ? { left: _vm.lineData.x.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y min",style:(_vm.lineData.y.min && _vm.lineData.y.min.display ? { top: _vm.lineData.y.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y max",style:(_vm.lineData.y.max && _vm.lineData.y.max.display ? { top: _vm.lineData.y.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y main",style:(_vm.lineData.y.main && _vm.lineData.y.main.display ? { top: (_vm.lineData.y.main.base + _vm.lineData.y.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y custom",style:(_vm.lineData.y.custom && _vm.lineData.y.custom.display ? { top: _vm.lineData.y.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"table-container col-block"},[_c('div',{staticClass:"thead"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab + 'px' }),on:{"click":function (e) { return !_vm.sort.disabled && option.sortMap !== null && _vm.tableSortBy(option.sortValue || option.value); }}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e(),_vm._v(" "),(index + 1 > _vm.staticTableWidths[0].length && _vm.tableOptions[index + 1 + _vm.staticTableWidths[1].length])?_c('div',{staticClass:"grab-box grab-x",class:{ grabbing: _vm.boardData['board1'].grabID === index },attrs:{"grab-id":index,"grab-type":'x' + { line: '', grab: '*' }[_vm.boardType['board1']],"grab-x-min":_vm.tableWidths.slice(0, index).reduce(function (s, c) { return s + c.value; }, 0) + (option.minWidth || _vm.tableMinWidths) + '*',"grab-x-max":_vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) - _vm.tableOptions.slice(index + 1, _vm.tableOptions.length - _vm.staticTableWidths[1].length).reduce(function (s, c) { return s + (c.minWidth || _vm.tableMinWidths); }, 0) - _vm.staticTableWidths[1].reduce(function (s, c) { return s + c; }, 0) + '*',"grab-x-custom":_vm.tableWidths.slice(0, index).reduce(function (s, c) { return s + c.value; }, 0) + { line: '', grab: '*' }[_vm.boardType['board1']]}}):_vm._e()],2)}),0)])]),_vm._v(" "),_c('div',{ref:"custom-table-scroll",staticClass:"table-group-container col-block width-full"},[_c('div',{staticClass:"col-block"},_vm._l((_vm.tableDatas),function(group,gindex){return _c('div',{key:gindex,staticClass:"table-container col-block"},[_c('div',{staticClass:"tbody"},[_c('div',{staticClass:"tr group row-block",class:{ selected: group.datas.some(function (data) { return (_vm.selectedTableData || {}).id === data.id; }) },style:(group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' })},[_c('a',{staticClass:"container-block row-block"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(group[option.gValue], gindex, group),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.gstyle || (function () { return ({}); }))(group[option.gValue], gindex, group)),attrs:{"title":((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || option.gempty || '')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('center') && !(option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)]),_vm._v(" "),_vm._l((group.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"tr col-block",class:{ selectable: false, selected: (_vm.selectedTableData || {}).id === data.id }},[_c('a',{staticClass:"container-block row-block",style:({ flex: 1 }),on:{"click":function (e) { return false && (_vm.selectedTableData = data); }}},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(data[option.value], dindex, data),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.style || (function () { return ({}); }))(data[option.value], dindex, data)),attrs:{"title":((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || option.empty || '- -')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(data[option.value], dindex, data).includes('center') && !(option.class || (function () { return []; }))(data[option.value], dindex, data).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)])})],2)])}),0)])]):_vm._e()])]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var datasetDetail_staticRenderFns = []
var datasetDetail_esExports = { render: datasetDetail_render, staticRenderFns: datasetDetail_staticRenderFns }
/* harmony default export */ var dialog_datasetDetail = (datasetDetail_esExports);
// CONCATENATED MODULE: ./src/components/dialog/datasetDetail.vue
var datasetDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datasetDetail___vue_template_functional__ = false
/* styles */
var datasetDetail___vue_styles__ = null
/* scopeId */
var datasetDetail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datasetDetail___vue_module_identifier__ = null
var datasetDetail_Component = datasetDetail_normalizeComponent(
  datasetDetail,
  dialog_datasetDetail,
  datasetDetail___vue_template_functional__,
  datasetDetail___vue_styles__,
  datasetDetail___vue_scopeId__,
  datasetDetail___vue_module_identifier__
)

/* harmony default export */ var components_dialog_datasetDetail = (datasetDetail_Component.exports);

// EXTERNAL MODULE: ./src/components/dataset/base.vue + 2 modules
var dataset_base = __webpack_require__("+9L4");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/datasetEdit.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datasetEdit = ({
  components: {
    datasetBase: dataset_base["a" /* default */],
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dataset: null,
      onError: false,
      onSubmit: false,
      // alert
      unloadAlert: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user']), {
    // static
    formOptions: function formOptions() {
      return {
        field1: this.dataset.shareAlert ? [{
          title: this.$t('DIALOG.datasetEdit.form.title.___shareAlert'),
          value: '_SHAREALERT',
          type: 'custom',
          grid: 6
        }] : [{
          title: this.$t('DIALOG.datasetEdit.form.title.___sharing'),
          value: '_SHARING',
          type: 'custom',
          grid: 2
        }, {
          title: this.$t('DIALOG.datasetEdit.form.title.___url'),
          value: '_URL',
          type: 'custom',
          grid: 4
        }, {
          title: this.$t('DIALOG.datasetEdit.form.title.___user'),
          value: '_USER',
          type: 'custom',
          grid: 2
        }, {
          title: this.$t('DIALOG.datasetEdit.form.title.___key'),
          value: '_KEY',
          type: 'custom',
          grid: 4
        }]
      };
    },

    // global
    datasetPermissionMap: function datasetPermissionMap() {
      return global_data["h" /* datasetPermissionMap */];
    }
  }),
  watch: {
    // unload alert
    'unloadAlert': function unloadAlert(nv) {
      if (nv) {
        this.setUnloadAlertAction(true);
      } else {
        this.setUnloadAlertAction(false);
      }
    }
  },
  created: function created() {
    this.dataset = extends_default()({}, this.param.defaultData);
  },
  beforeDestroy: function beforeDestroy() {
    this.setUnloadAlertAction(false);
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUnloadAlertAction']), {
    copyDatasetUrl: function copyDatasetUrl() {
      navigator.clipboard.writeText(this.dataset.url);
    },
    validateEditDataset: function validateEditDataset() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var forms, success, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, form, result, datas, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _form, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.onSubmit = true;
                _context.prev = 1;
                forms = values_default()(_this.$refs).map(function (ref) {
                  return ref[0] || ref;
                });
                success = true;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 7;
                _iterator = get_iterator_default()(forms);

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 18;
                  break;
                }

                form = _step.value;
                _context.next = 13;
                return form.validateSubmit();

              case 13:
                result = _context.sent;

                if (form && !result) {
                  success = false;
                }

              case 15:
                _iteratorNormalCompletion = true;
                _context.next = 9;
                break;

              case 18:
                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 24:
                _context.prev = 24;
                _context.prev = 25;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 27:
                _context.prev = 27;

                if (!_didIteratorError) {
                  _context.next = 30;
                  break;
                }

                throw _iteratorError;

              case 30:
                return _context.finish(27);

              case 31:
                return _context.finish(24);

              case 32:
                if (!success) {
                  _context.next = 68;
                  break;
                }

                datas = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 37;
                _iterator2 = get_iterator_default()(forms);

              case 39:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 52;
                  break;
                }

                _form = _step2.value;
                _context.next = 43;
                return _form.submit();

              case 43:
                data = _context.sent;

                if (!(_form && !data)) {
                  _context.next = 48;
                  break;
                }

                throw new Error();

              case 48:
                datas.push(data);

              case 49:
                _iteratorNormalCompletion2 = true;
                _context.next = 39;
                break;

              case 52:
                _context.next = 58;
                break;

              case 54:
                _context.prev = 54;
                _context.t1 = _context['catch'](37);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 58:
                _context.prev = 58;
                _context.prev = 59;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 61:
                _context.prev = 61;

                if (!_didIteratorError2) {
                  _context.next = 64;
                  break;
                }

                throw _iteratorError2;

              case 64:
                return _context.finish(61);

              case 65:
                return _context.finish(58);

              case 66:
                _context.next = 68;
                return _this.editDataset(datas[0]);

              case 68:
                _context.next = 72;
                break;

              case 70:
                _context.prev = 70;
                _context.t2 = _context['catch'](1);

              case 72:
                _this.onSubmit = false;

              case 73:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 70], [7, 20, 24, 32], [25,, 27, 31], [37, 54, 58, 66], [59,, 61, 65]]);
      }))();
    },
    editDataset: function editDataset(formData) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, id, data, file, response, dataset;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this2.$ls.get('userInfo');
                id = _this2.dataset.id;
                data = formData.data;

                if (!(['custom'].includes(data.dataset_picture_file_id) && formData.customPicture)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 7;
                return _this2.uploadCustomPicture(_this2.dataset, formData.customPicture);

              case 7:
                file = _context2.sent;

                data.dataset_picture_file_id = file.id;

              case 9:
                _context2.next = 11;
                return Object(src_api["_138" /* putDataset */])(id, data, config);

              case 11:
                response = _context2.sent;
                dataset = response.data.data;
                // this.addToast('success', response.data.result.message)

                _this2.$emit('changeModal', {}, dataset);
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](0);

                _this2.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.result.message);

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 16]]);
      }))();
    },
    uploadCustomPicture: function uploadCustomPicture(dataset, customPicture) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, id, data, response, url, result, file;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this3.$ls.get('userInfo');
                id = dataset.id;
                data = {
                  name: customPicture.name,
                  content_type: customPicture.file.type
                };
                _context3.next = 6;
                return Object(src_api["_110" /* postDatasetPictureFile */])(id, data, config);

              case 6:
                response = _context3.sent;
                url = response.data.data.url;
                _context3.next = 10;
                return _this3.uploadPictureFile(url, customPicture.file);

              case 10:
                result = _context3.sent;

                if (!result) {
                  _context3.next = 16;
                  break;
                }

                _context3.next = 14;
                return _this3.getCustomPicture(id);

              case 14:
                file = _context3.sent;
                return _context3.abrupt('return', file);

              case 16:
                _context3.next = 21;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3['catch'](0);

                _this3.addToast('error', !_context3.t0.response ? _context3.t0.message : _context3.t0.response.data.result.message);

              case 21:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 18]]);
      }))();
    },
    uploadPictureFile: function uploadPictureFile(url, file) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var result;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return new promise_default.a(function (resolve) {
                  var xhr = _this4.createCORSRequest('PUT', url);
                  if (xhr.upload) {
                    xhr.onload = function () {
                      resolve(true);
                    };
                    xhr.onerror = function () {
                      resolve(true);
                    };
                    xhr.setRequestHeader('Content-Type', file.type);
                    xhr.send(file);
                  } else {
                    _this4.addToast('error', _this4.$t('COMMON.toast.___xhrCanNotUpload'));
                  }
                });

              case 2:
                result = _context4.sent;
                return _context4.abrupt('return', result);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    getCustomPicture: function getCustomPicture(id) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var config, response, file;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                config = _this5.$ls.get('userInfo');
                _context5.next = 4;
                return Object(src_api["_20" /* getDatasetPictureFile */])(id, config);

              case 4:
                response = _context5.sent;
                file = response.data.data;
                return _context5.abrupt('return', file);

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](0);

                _this5.addToast('error', !_context5.t0.response ? _context5.t0.message : _context5.t0.response.data.result.message);

              case 12:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 9]]);
      }))();
    },
    createCORSRequest: function createCORSRequest(method, url) {
      var xhr = new XMLHttpRequest();
      if ('withCredentials' in xhr) {
        xhr.open(method, url, true);
      } else if (typeof XDomainRequest !== 'undefined') {
        xhr = new XDomainRequest();
        xhr.open(method, url);
      } else {
        xhr = null;
      }
      return xhr;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d083a63","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/datasetEdit.vue
var datasetEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataset-edit-dailog dialog col-block"},[_c('div',{staticClass:"main-container col-block width-full"},[_c('datasetBase',{ref:'main',attrs:{"defaultData":_vm.dataset,"form":{}},on:{"onError":function (error) { return _vm.onError = error; },"unloadAlert":function (alert) { return _vm.unloadAlert = alert; }}})],1),_vm._v(" "),_c('div',{staticClass:"sharing-container col-block width-full"},[_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('customForm',{attrs:{"layoutType":'grid',"groupCount":6,"displayMode":true,"init":{},"alerts":{},"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) {}},scopedSlots:_vm._u([{key:"_SHAREALERT",fn:function(props){return [_c('div',{staticClass:"_SHAREALERT row-block flex-start",attrs:{"name":props}},[_c('div',{staticClass:"content break-line shrink",domProps:{"innerHTML":_vm._s([
              _vm.$t('DIALOG.datasetEdit.customForm.shareAlert.___content'),
              _vm.$t(_vm.dataset.shareAlert)
            ].join('<br>'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]}},{key:"_SHARING",fn:function(props){return [_c('div',{staticClass:"_SHARING row-block flex-start",attrs:{"name":props}},[_c('div',{staticClass:"content break-line shrink",domProps:{"innerHTML":_vm._s([
              _vm.$t('DIALOG.datasetEdit.customForm.sharing.___content') + ':',
              _vm.$t(_vm.datasetPermissionMap[_vm.dataset.community_permission].title)
            ].join('<br>'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button",attrs:{"type":"button"},on:{"click":function (e) { return _vm.$emit('changeModal', {}, { tab: 'share' }); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___shareSetting')))])]),_vm._v(" "),_c('div',{style:({ width: '10px' })})])]}},{key:"_URL",fn:function(props){return [_c('div',{staticClass:"_URL row-block",attrs:{"name":props}},[_c('div',{staticClass:"content break-line shrink",domProps:{"innerHTML":_vm._s([
              _vm.dataset.url
            ].join('<br>'))}}),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"icon-block",style:({ '--size': '20px' }),attrs:{"title":_vm.$t('DIALOG.datasetEdit.customForm.url.___copyIconTitle')},on:{"click":function (e) { return _vm.copyDatasetUrl(); }}},[_c('img',{attrs:{"src":__webpack_require__("qL9y"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]}},{key:"_USER",fn:function(props){return [_c('div',{staticClass:"_USER row-block",attrs:{"name":props}},[_c('div',{staticClass:"content break-line shrink",style:({ flex: 1 }),domProps:{"innerHTML":_vm._s([
              _vm.$tc('DIALOG.datasetEdit.customForm.user.___content', _vm.dataset.shares.length, { count: _vm.dataset.shares.length })
            ].join('<br>'))}})])]}},{key:"_KEY",fn:function(props){return [_c('div',{staticClass:"_KEY row-block",attrs:{"name":props}},[_c('div',{staticClass:"content break-line shrink",style:({ flex: 1 }),domProps:{"innerHTML":_vm._s([
              _vm.dataset.access_key || '- -'
            ].join('<br>'))}})])]}}])})],1),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '16px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit && _vm.validateEditDataset(); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___update')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var datasetEdit_staticRenderFns = []
var datasetEdit_esExports = { render: datasetEdit_render, staticRenderFns: datasetEdit_staticRenderFns }
/* harmony default export */ var dialog_datasetEdit = (datasetEdit_esExports);
// CONCATENATED MODULE: ./src/components/dialog/datasetEdit.vue
var datasetEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datasetEdit___vue_template_functional__ = false
/* styles */
var datasetEdit___vue_styles__ = null
/* scopeId */
var datasetEdit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datasetEdit___vue_module_identifier__ = null
var datasetEdit_Component = datasetEdit_normalizeComponent(
  datasetEdit,
  dialog_datasetEdit,
  datasetEdit___vue_template_functional__,
  datasetEdit___vue_styles__,
  datasetEdit___vue_scopeId__,
  datasetEdit___vue_module_identifier__
)

/* harmony default export */ var components_dialog_datasetEdit = (datasetEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/datasetShareEdit.vue









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var datasetShareEdit = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      shareData: {},
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },

    // static
    formOptions: function formOptions() {
      return {
        field1: [
        // 1
        {
          title: this.$t('DIALOG.datasetShareEdit.form.title.___user'),
          value: 'user',
          type: 'text',
          displayMode: true,
          grid: 4
        }, {
          title: this.$t('DIALOG.datasetShareEdit.form.title.___permission'),
          value: 'permission',
          type: 'select',
          options: this.param.permissionOptions,
          grid: 2
        },
        // 2
        {
          title: this.$t('DIALOG.datasetShareEdit.form.title.___email'),
          value: 'email',
          type: 'text',
          displayMode: true,
          grid: 4
        }, {
          grid: 2
        }]
      };
    }
  },
  created: function created() {
    var shareData = this.param.shareData || this.shareData;
    var user = shareData.user;
    this.shareData = extends_default()({}, shareData, {
      user: [user.first_name, user.last_name].filter(function (x) {
        return x;
      }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) {
        return x;
      }).join(' ') + ')' : ''),
      email: user.email
    });
  },

  methods: {
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.shareData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    validateEditDatasetShare: function validateEditDatasetShare() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};

                _this2.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this2.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 15;
                  break;
                }

                kv = _step2.value;
                _context.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context.next = 7;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError2) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                result['custom'] = _this2.customValidate();

                if (values_default()(result).includes(false)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 33;
                return _this2.editDatasetShare();

              case 33:
                _this2.onSubmit = false;

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    editDatasetShare: function editDatasetShare() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, id, datasetID, data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this3.$ls.get('userInfo');
                id = _this3.shareData.id;
                datasetID = _this3.param.datasetData.id;
                data = {
                  permission: _this3.result.permission
                };
                _context2.next = 7;
                return Object(src_api["_140" /* putDatasetShare */])(id, datasetID, data, config);

              case 7:
                _this3.$emit('changeModal', {}, true);
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                _this3.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.result.message);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 10]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5642bdc3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/datasetShareEdit.vue
var datasetShareEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataset-share-edit-dailog dialog col-block"},[_c('customForm',{attrs:{"layoutType":'grid',"groupCount":6,"gap":'0px 16px',"init":_vm.shareData,"alerts":{},"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '0' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit ? _vm.validateEditDatasetShare() : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___update')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var datasetShareEdit_staticRenderFns = []
var datasetShareEdit_esExports = { render: datasetShareEdit_render, staticRenderFns: datasetShareEdit_staticRenderFns }
/* harmony default export */ var dialog_datasetShareEdit = (datasetShareEdit_esExports);
// CONCATENATED MODULE: ./src/components/dialog/datasetShareEdit.vue
var datasetShareEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datasetShareEdit___vue_template_functional__ = false
/* styles */
var datasetShareEdit___vue_styles__ = null
/* scopeId */
var datasetShareEdit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datasetShareEdit___vue_module_identifier__ = null
var datasetShareEdit_Component = datasetShareEdit_normalizeComponent(
  datasetShareEdit,
  dialog_datasetShareEdit,
  datasetShareEdit___vue_template_functional__,
  datasetShareEdit___vue_styles__,
  datasetShareEdit___vue_scopeId__,
  datasetShareEdit___vue_module_identifier__
)

/* harmony default export */ var components_dialog_datasetShareEdit = (datasetShareEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/datasetDeleteConfirm.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var datasetDeleteConfirm = ({
  mixins: [customGrab["a" /* default */], responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedTableData: null,
      // table
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [[], [127]],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['scrollState']), {
    tableDatas: function tableDatas() {
      var _this = this;

      var tableDatas = [].concat(toConsumableArray_default()(this.shares));
      tableDatas = Object(util["m" /* sortData */])(tableDatas, this.sort.value.map(function (x) {
        return _this.sortMap[x];
      }), this.sort.order.map(function (x) {
        return x.replace('-', '');
      }));
      if (!['private'].includes(this.communityPermission)) {
        tableDatas = [{
          id: -1,
          user: {
            title: this.$t('DIALOG.datasetDeleteConfirm.table.data.___user')
          },
          permission: this.communityPermission
        }].concat(toConsumableArray_default()(tableDatas));
      }
      tableDatas = Object(util["i" /* groupBy */])(tableDatas, function () {
        return 'default';
      }).map(function (datas) {
        return { title: datas[0].group, isGroup: true, datas: datas };
      });
      return tableDatas;
    },
    sortMap: function sortMap() {
      return this.tableOptions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortMap || c.value));
      }, {});
    },

    // static
    tableOptions: function tableOptions() {
      var _this2 = this;

      return [{
        title: this.$t('DIALOG.datasetDeleteConfirm.table.title.___accectedUserID'),
        value: '_USERID',
        display: function display(_, __, data) {
          var user = data.user;
          return user ? ([user.title, user.first_name, user.last_name].filter(function (x) {
            return x;
          }).join(' ') + ' (' + [user.email, user.organization || user.division ? [user.organization, user.division].filter(function (x) {
            return x;
          }).join(' ') : ''].filter(function (x) {
            return x;
          }).join(', ') + ')').replace(/ \(\)$/, '') : user;
        },
        sortMap: function sortMap(data) {
          var user = data.user;
          return user ? ([user.title, user.first_name, user.last_name].filter(function (x) {
            return x;
          }).join(' ') + ' (' + [user.email, user.organization || user.division ? [user.organization, user.division].filter(function (x) {
            return x;
          }).join(' ') : ''].filter(function (x) {
            return x;
          }).join(', ') + ')').replace(/ \(\)$/, '') : user;
        }
      }, {
        title: this.$t('DIALOG.datasetDeleteConfirm.table.title.___permission'),
        value: 'permission',
        display: function display(value) {
          return _this2.$t((global_data["h" /* datasetPermissionMap */][value] || {}).title);
        }
      }];
    },

    // param
    communityPermission: function communityPermission() {
      return this.param.communityPermission || 'private';
    },
    shares: function shares() {
      return this.param.shares || [];
    }
  }),
  watch: {
    // data
    'selectedTableData': function selectedTableData(nv, ov) {
      if (nv !== ov && stringify_default()(nv) !== stringify_default()(ov)) {
        this.selectedTableData = nv ? JSON.parse(stringify_default()(nv)) : null;
      }
    },

    // table
    'tableDatas': function tableDatas() {
      this.getTableOverflow();
    },
    'windowWidth': function windowWidth(nv) {
      this.getTableWidths(nv);
      this.getTableOverflow();
    }
  },
  methods: {
    // table
    getTableOverflow: function getTableOverflow() {
      var _this3 = this;

      setTimeout(function () {
        var scrollContainer = _this3.$refs['custom-table-scroll'];
        if (scrollContainer) {
          _this3.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight;
        }
      });
    },
    getTableWidths: function getTableWidths(windowWidth) {
      window.dispatchEvent(new Event('scroll'));
      var tableWidth = Math.min(windowWidth - 20 * 2, 912) - 22 * 2 - (this.scrollState.height ? this.scrollbarSize : 0);
      tableWidth = tableWidth - this.staticTableWidths[0].reduce(function (s, c) {
        return s + c;
      }, 0) - this.staticTableWidths[1].reduce(function (s, c) {
        return s + c;
      }, 0);
      var tableWidths = this.tableWidths || [].concat(toConsumableArray_default()(this.staticTableWidths[0]), [1], toConsumableArray_default()(this.staticTableWidths[1])).map(function (width) {
        return {
          value: width
        };
      });
      var tableMinWidths = this.tableMinWidths || 0.1;
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length);
      var ratio = tableWidth / tableWidths.reduce(function (s, c) {
        return s + c.value;
      }, 0);
      tableWidths = Array.prototype.concat.apply([], [this.staticTableWidths[0].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      }), tableWidths.map(function (width) {
        return {
          value: width.value * ratio,
          grab: 0
        };
      }), this.staticTableWidths[1].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      })]);
      this.tableMinWidths = tableMinWidths * ratio;
      this.tableWidths = tableWidths;
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
    },

    // grab
    boardResponse: function boardResponse(id, type) {
      var _this4 = this;

      return {
        'board1': {
          'start': function start(boardData) {
            _this4.sort.disabled = true;
          },
          'move': function move(boardData) {
            if (_this4.boardType['board1'] === 'grab') {
              var grabID = _this4.boardData[id].grabID;
              var tableWidths = [].concat(toConsumableArray_default()(_this4.tableWidths));
              var result = boardData.grabX - boardData.baseX;
              var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this4.staticTableWidths[1].length).reduce(function (s, c, i) {
                return s + c.value - (_this4.tableOptions[i].minWidth || _this4.tableMinWidths);
              }, 0);
              tableWidths.forEach(function (_, i) {
                if (i === grabID) {
                  tableWidths[i].grab = result;
                }if (i > grabID && i + _this4.staticTableWidths[1].length < tableWidths.length) {
                  tableWidths[i].grab = -(result * ((tableWidths[i].value - (_this4.tableOptions[i].minWidth || _this4.tableMinWidths)) / ratioBase));
                }
              });
              _this4.tableWidths = tableWidths;
            }
          },
          'end': function end(boardData) {
            var grabID = _this4.boardData[id].grabID;
            var tableWidths = [].concat(toConsumableArray_default()(_this4.tableWidths));
            var result = boardData.grabX - boardData.baseX;
            var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this4.staticTableWidths[1].length).reduce(function (s, c, i) {
              return s + c.value - (_this4.tableOptions[i].minWidth || _this4.tableMinWidths);
            }, 0);
            tableWidths.forEach(function (_, i) {
              tableWidths[i].grab = 0;
              if (i === grabID) {
                tableWidths[i].value += result;
              }if (i > grabID && i + _this4.staticTableWidths[1].length < tableWidths.length) {
                tableWidths[i].value -= result * ((tableWidths[i].value - (_this4.tableOptions[i].minWidth || _this4.tableMinWidths)) / ratioBase);
              }
            });
            _this4.tableWidths = tableWidths;
            setTimeout(function () {
              _this4.sort.disabled = false;
            });
          }
        }
      }[id][type];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24d42792","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/datasetDeleteConfirm.vue
var datasetDeleteConfirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataset-delete-confirm-dailog dialog col-block width-full"},[_c('div',{staticClass:"information-container col-block"},[_c('div',{staticClass:"information",domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.datasetArchiveConfirm.___info01'))}}),_vm._v(" "),_c('div',{staticClass:"information",domProps:{"innerHTML":_vm._s(_vm.$tc('DIALOG.datasetArchiveConfirm.___info02', _vm.shares.length, { count: _vm.shares.length }))}})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"table-container col-block width-full"},[_c('div',{staticClass:"custom-table",class:{ 'auto-height': true }},[(_vm.tableWidths)?_c('div',{staticClass:"table-field col-block grab-container",style:({ width: _vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) + 'px' }),on:{"mousedown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardStart]); })($event)},"mousemove":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseout":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardEnd]); })($event)}}},[_c('div',{staticClass:"grab-line x min",style:(_vm.lineData.x.min && _vm.lineData.x.min.display ? { left: _vm.lineData.x.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x max",style:(_vm.lineData.x.max && _vm.lineData.x.max.display ? { left: _vm.lineData.x.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x main",style:(_vm.lineData.x.main && _vm.lineData.x.main.display ? { left: (_vm.lineData.x.main.base + _vm.lineData.x.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x custom",style:(_vm.lineData.x.custom && _vm.lineData.x.custom.display ? { left: _vm.lineData.x.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y min",style:(_vm.lineData.y.min && _vm.lineData.y.min.display ? { top: _vm.lineData.y.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y max",style:(_vm.lineData.y.max && _vm.lineData.y.max.display ? { top: _vm.lineData.y.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y main",style:(_vm.lineData.y.main && _vm.lineData.y.main.display ? { top: (_vm.lineData.y.main.base + _vm.lineData.y.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y custom",style:(_vm.lineData.y.custom && _vm.lineData.y.custom.display ? { top: _vm.lineData.y.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"table-container col-block"},[_c('div',{staticClass:"thead"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab + 'px' }),on:{"click":function (e) { return !_vm.sort.disabled && option.sortMap !== null && _vm.tableSortBy(option.sortValue || option.value); }}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e(),_vm._v(" "),(index + 1 > _vm.staticTableWidths[0].length && _vm.tableOptions[index + 1 + _vm.staticTableWidths[1].length])?_c('div',{staticClass:"grab-box grab-x",class:{ grabbing: _vm.boardData['board1'].grabID === index },attrs:{"grab-id":index,"grab-type":'x' + { line: '', grab: '*' }[_vm.boardType['board1']],"grab-x-min":_vm.tableWidths.slice(0, index).reduce(function (s, c) { return s + c.value; }, 0) + (option.minWidth || _vm.tableMinWidths) + '*',"grab-x-max":_vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) - _vm.tableOptions.slice(index + 1, _vm.tableOptions.length - _vm.staticTableWidths[1].length).reduce(function (s, c) { return s + (c.minWidth || _vm.tableMinWidths); }, 0) - _vm.staticTableWidths[1].reduce(function (s, c) { return s + c; }, 0) + '*',"grab-x-custom":_vm.tableWidths.slice(0, index).reduce(function (s, c) { return s + c.value; }, 0) + { line: '', grab: '*' }[_vm.boardType['board1']]}}):_vm._e()],2)}),0)])]),_vm._v(" "),_c('div',{ref:"custom-table-scroll",staticClass:"table-group-container col-block width-full"},[_c('div',{staticClass:"col-block"},_vm._l((_vm.tableDatas),function(group,gindex){return _c('div',{key:gindex,staticClass:"table-container col-block"},[_c('div',{staticClass:"tbody"},[_c('div',{staticClass:"tr group row-block",class:{ selected: group.datas.some(function (data) { return (_vm.selectedTableData || {}).id === data.id; }) },style:(group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' })},[_c('a',{staticClass:"container-block row-block"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(group[option.gValue], gindex, group),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.gstyle || (function () { return ({}); }))(group[option.gValue], gindex, group)),attrs:{"title":((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || option.gempty || '')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('center') && !(option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)]),_vm._v(" "),_vm._l((group.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"tr col-block",class:{ selectable: false, selected: (_vm.selectedTableData || {}).id === data.id }},[_c('a',{staticClass:"container-block row-block",style:({ flex: 1 }),on:{"click":function (e) { return false && (_vm.selectedTableData = data); }}},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(data[option.value], dindex, data),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.style || (function () { return ({}); }))(data[option.value], dindex, data)),attrs:{"title":((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || option.empty || '- -')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(data[option.value], dindex, data).includes('center') && !(option.class || (function () { return []; }))(data[option.value], dindex, data).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)])})],2)])}),0)])]):_vm._e()])]),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"alert-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, true); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___delete')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var datasetDeleteConfirm_staticRenderFns = []
var datasetDeleteConfirm_esExports = { render: datasetDeleteConfirm_render, staticRenderFns: datasetDeleteConfirm_staticRenderFns }
/* harmony default export */ var dialog_datasetDeleteConfirm = (datasetDeleteConfirm_esExports);
// CONCATENATED MODULE: ./src/components/dialog/datasetDeleteConfirm.vue
var datasetDeleteConfirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datasetDeleteConfirm___vue_template_functional__ = false
/* styles */
var datasetDeleteConfirm___vue_styles__ = null
/* scopeId */
var datasetDeleteConfirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datasetDeleteConfirm___vue_module_identifier__ = null
var datasetDeleteConfirm_Component = datasetDeleteConfirm_normalizeComponent(
  datasetDeleteConfirm,
  dialog_datasetDeleteConfirm,
  datasetDeleteConfirm___vue_template_functional__,
  datasetDeleteConfirm___vue_styles__,
  datasetDeleteConfirm___vue_scopeId__,
  datasetDeleteConfirm___vue_module_identifier__
)

/* harmony default export */ var components_dialog_datasetDeleteConfirm = (datasetDeleteConfirm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/datasetArchiveConfirm.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var datasetArchiveConfirm = ({
  mixins: [customGrab["a" /* default */], responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedTableData: null,
      // table
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [[], [255, 352]],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['scrollState']), {
    tableDatas: function tableDatas() {
      var _this = this;

      var tableDatas = [].concat(toConsumableArray_default()(this.datasets));
      tableDatas = Object(util["m" /* sortData */])(tableDatas, this.sort.value.map(function (x) {
        return _this.sortMap[x];
      }), this.sort.order.map(function (x) {
        return x.replace('-', '');
      }));
      tableDatas = Object(util["i" /* groupBy */])(tableDatas, function () {
        return 'default';
      }).map(function (datas) {
        return { title: datas[0].group, isGroup: true, datas: datas };
      });
      return tableDatas;
    },
    sortMap: function sortMap() {
      return this.tableOptions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortMap || c.value));
      }, {});
    },

    // static
    tableOptions: function tableOptions() {
      return [{
        title: this.$t('DIALOG.datasetArchiveConfirm.table.title.___name'),
        value: 'name'
      }, {
        title: this.$t('DIALOG.datasetArchiveConfirm.table.title.___owner'),
        value: '_USERID',
        display: function display(_, __, data) {
          var user = data.user;
          return user ? ([user.title, user.first_name, user.last_name].filter(function (x) {
            return x;
          }).join(' ') + ' (' + [user.email, user.organization || user.division ? [user.organization, user.division].filter(function (x) {
            return x;
          }).join(' ') : ''].filter(function (x) {
            return x;
          }).join(', ') + ')').replace(/ \(\)$/, '') : user;
        },
        sortMap: function sortMap(data) {
          var user = data.user;
          return user ? ([user.title, user.first_name, user.last_name].filter(function (x) {
            return x;
          }).join(' ') + ' (' + [user.email, user.organization || user.division ? [user.organization, user.division].filter(function (x) {
            return x;
          }).join(' ') : ''].filter(function (x) {
            return x;
          }).join(', ') + ')').replace(/ \(\)$/, '') : user;
        }
      }, {
        title: this.$t('DIALOG.datasetArchiveConfirm.table.title.___description'),
        value: 'description'
      }];
    },

    // param
    datasets: function datasets() {
      return this.param.datasets || [];
    }
  }),
  watch: {
    // data
    'selectedTableData': function selectedTableData(nv, ov) {
      if (nv !== ov && stringify_default()(nv) !== stringify_default()(ov)) {
        this.selectedTableData = nv ? JSON.parse(stringify_default()(nv)) : null;
      }
    },

    // table
    'tableDatas': function tableDatas() {
      this.getTableOverflow();
    },
    'windowWidth': function windowWidth(nv) {
      this.getTableWidths(nv);
      this.getTableOverflow();
    }
  },
  methods: {
    // table
    getTableOverflow: function getTableOverflow() {
      var _this2 = this;

      setTimeout(function () {
        var scrollContainer = _this2.$refs['custom-table-scroll'];
        if (scrollContainer) {
          _this2.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight;
        }
      });
    },
    getTableWidths: function getTableWidths(windowWidth) {
      window.dispatchEvent(new Event('scroll'));
      var tableWidth = Math.min(windowWidth - 20 * 2, 912) - 22 * 2 - (this.scrollState.height ? this.scrollbarSize : 0);
      tableWidth = tableWidth - this.staticTableWidths[0].reduce(function (s, c) {
        return s + c;
      }, 0) - this.staticTableWidths[1].reduce(function (s, c) {
        return s + c;
      }, 0);
      var tableWidths = this.tableWidths || [].concat(toConsumableArray_default()(this.staticTableWidths[0]), [1], toConsumableArray_default()(this.staticTableWidths[1])).map(function (width) {
        return {
          value: width
        };
      });
      var tableMinWidths = this.tableMinWidths || 0.1;
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length);
      var ratio = tableWidth / tableWidths.reduce(function (s, c) {
        return s + c.value;
      }, 0);
      tableWidths = Array.prototype.concat.apply([], [this.staticTableWidths[0].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      }), tableWidths.map(function (width) {
        return {
          value: width.value * ratio,
          grab: 0
        };
      }), this.staticTableWidths[1].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      })]);
      this.tableMinWidths = tableMinWidths * ratio;
      this.tableWidths = tableWidths;
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
    },

    // grab
    boardResponse: function boardResponse(id, type) {
      var _this3 = this;

      return {
        'board1': {
          'start': function start(boardData) {
            _this3.sort.disabled = true;
          },
          'move': function move(boardData) {
            if (_this3.boardType['board1'] === 'grab') {
              var grabID = _this3.boardData[id].grabID;
              var tableWidths = [].concat(toConsumableArray_default()(_this3.tableWidths));
              var result = boardData.grabX - boardData.baseX;
              var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this3.staticTableWidths[1].length).reduce(function (s, c, i) {
                return s + c.value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths);
              }, 0);
              tableWidths.forEach(function (_, i) {
                if (i === grabID) {
                  tableWidths[i].grab = result;
                }if (i > grabID && i + _this3.staticTableWidths[1].length < tableWidths.length) {
                  tableWidths[i].grab = -(result * ((tableWidths[i].value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths)) / ratioBase));
                }
              });
              _this3.tableWidths = tableWidths;
            }
          },
          'end': function end(boardData) {
            var grabID = _this3.boardData[id].grabID;
            var tableWidths = [].concat(toConsumableArray_default()(_this3.tableWidths));
            var result = boardData.grabX - boardData.baseX;
            var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this3.staticTableWidths[1].length).reduce(function (s, c, i) {
              return s + c.value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths);
            }, 0);
            tableWidths.forEach(function (_, i) {
              tableWidths[i].grab = 0;
              if (i === grabID) {
                tableWidths[i].value += result;
              }if (i > grabID && i + _this3.staticTableWidths[1].length < tableWidths.length) {
                tableWidths[i].value -= result * ((tableWidths[i].value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths)) / ratioBase);
              }
            });
            _this3.tableWidths = tableWidths;
            setTimeout(function () {
              _this3.sort.disabled = false;
            });
          }
        }
      }[id][type];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6af194d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/datasetArchiveConfirm.vue
var datasetArchiveConfirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataset-archive-confirm-dailog dialog col-block width-full"},[_c('div',{staticClass:"information-container col-block"},[_c('div',{staticClass:"information",domProps:{"innerHTML":_vm._s(_vm.$t('DIALOG.datasetArchiveConfirm.___info01'))}}),_vm._v(" "),_c('div',{staticClass:"information",domProps:{"innerHTML":_vm._s(_vm.$tc('DIALOG.datasetArchiveConfirm.___info02', _vm.datasets.length, { count: _vm.datasets.length }))}})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"table-container col-block width-full"},[_c('div',{staticClass:"custom-table",class:{ 'auto-height': true }},[(_vm.tableWidths)?_c('div',{staticClass:"table-field col-block grab-container",style:({ width: _vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) + 'px' }),on:{"mousedown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardStart]); })($event)},"mousemove":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseout":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardEnd]); })($event)}}},[_c('div',{staticClass:"grab-line x min",style:(_vm.lineData.x.min && _vm.lineData.x.min.display ? { left: _vm.lineData.x.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x max",style:(_vm.lineData.x.max && _vm.lineData.x.max.display ? { left: _vm.lineData.x.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x main",style:(_vm.lineData.x.main && _vm.lineData.x.main.display ? { left: (_vm.lineData.x.main.base + _vm.lineData.x.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x custom",style:(_vm.lineData.x.custom && _vm.lineData.x.custom.display ? { left: _vm.lineData.x.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y min",style:(_vm.lineData.y.min && _vm.lineData.y.min.display ? { top: _vm.lineData.y.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y max",style:(_vm.lineData.y.max && _vm.lineData.y.max.display ? { top: _vm.lineData.y.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y main",style:(_vm.lineData.y.main && _vm.lineData.y.main.display ? { top: (_vm.lineData.y.main.base + _vm.lineData.y.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y custom",style:(_vm.lineData.y.custom && _vm.lineData.y.custom.display ? { top: _vm.lineData.y.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"table-container col-block"},[_c('div',{staticClass:"thead"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab + 'px' }),on:{"click":function (e) { return !_vm.sort.disabled && option.sortMap !== null && _vm.tableSortBy(option.sortValue || option.value); }}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e(),_vm._v(" "),(index + 1 > _vm.staticTableWidths[0].length && _vm.tableOptions[index + 1 + _vm.staticTableWidths[1].length])?_c('div',{staticClass:"grab-box grab-x",class:{ grabbing: _vm.boardData['board1'].grabID === index },attrs:{"grab-id":index,"grab-type":'x' + { line: '', grab: '*' }[_vm.boardType['board1']],"grab-x-min":_vm.tableWidths.slice(0, index).reduce(function (s, c) { return s + c.value; }, 0) + (option.minWidth || _vm.tableMinWidths) + '*',"grab-x-max":_vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) - _vm.tableOptions.slice(index + 1, _vm.tableOptions.length - _vm.staticTableWidths[1].length).reduce(function (s, c) { return s + (c.minWidth || _vm.tableMinWidths); }, 0) - _vm.staticTableWidths[1].reduce(function (s, c) { return s + c; }, 0) + '*',"grab-x-custom":_vm.tableWidths.slice(0, index).reduce(function (s, c) { return s + c.value; }, 0) + { line: '', grab: '*' }[_vm.boardType['board1']]}}):_vm._e()],2)}),0)])]),_vm._v(" "),_c('div',{ref:"custom-table-scroll",staticClass:"table-group-container col-block width-full"},[_c('div',{staticClass:"col-block"},_vm._l((_vm.tableDatas),function(group,gindex){return _c('div',{key:gindex,staticClass:"table-container col-block"},[_c('div',{staticClass:"tbody"},[_c('div',{staticClass:"tr group row-block",class:{ selected: group.datas.some(function (data) { return (_vm.selectedTableData || {}).id === data.id; }) },style:(group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' })},[_c('a',{staticClass:"container-block row-block"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(group[option.gValue], gindex, group),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.gstyle || (function () { return ({}); }))(group[option.gValue], gindex, group)),attrs:{"title":((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || option.gempty || '')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('center') && !(option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)]),_vm._v(" "),_vm._l((group.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"tr col-block",class:{ selectable: false, selected: (_vm.selectedTableData || {}).id === data.id }},[_c('a',{staticClass:"container-block row-block",style:({ flex: 1 }),on:{"click":function (e) { return false && (_vm.selectedTableData = data); }}},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(data[option.value], dindex, data),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.style || (function () { return ({}); }))(data[option.value], dindex, data)),attrs:{"title":((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || option.empty || '- -')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(data[option.value], dindex, data).includes('center') && !(option.class || (function () { return []; }))(data[option.value], dindex, data).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)])})],2)])}),0)])]):_vm._e()])]),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"alert-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, true); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___archive')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var datasetArchiveConfirm_staticRenderFns = []
var datasetArchiveConfirm_esExports = { render: datasetArchiveConfirm_render, staticRenderFns: datasetArchiveConfirm_staticRenderFns }
/* harmony default export */ var dialog_datasetArchiveConfirm = (datasetArchiveConfirm_esExports);
// CONCATENATED MODULE: ./src/components/dialog/datasetArchiveConfirm.vue
var datasetArchiveConfirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datasetArchiveConfirm___vue_template_functional__ = false
/* styles */
var datasetArchiveConfirm___vue_styles__ = null
/* scopeId */
var datasetArchiveConfirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datasetArchiveConfirm___vue_module_identifier__ = null
var datasetArchiveConfirm_Component = datasetArchiveConfirm_normalizeComponent(
  datasetArchiveConfirm,
  dialog_datasetArchiveConfirm,
  datasetArchiveConfirm___vue_template_functional__,
  datasetArchiveConfirm___vue_styles__,
  datasetArchiveConfirm___vue_scopeId__,
  datasetArchiveConfirm___vue_module_identifier__
)

/* harmony default export */ var components_dialog_datasetArchiveConfirm = (datasetArchiveConfirm_Component.exports);

// EXTERNAL MODULE: ./src/components/dataset/card.vue + 2 modules
var card = __webpack_require__("DGt+");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/datasetInvitationConfirm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var datasetInvitationConfirm = ({
  components: {
    datasetCard: card["a" /* default */]
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    // param
    dataset: function dataset() {
      return this.param.dataset;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24905c7d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/datasetInvitationConfirm.vue
var datasetInvitationConfirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataset-invitation-confirm-dailog dialog col-block"},[_c('datasetCard',{attrs:{"type":'community',"dataset":_vm.dataset,"layoutType":'confirm'}}),_vm._v(" "),_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('div',{staticClass:"information-container col-block"},[_c('div',{staticClass:"information",domProps:{"innerHTML":_vm._s([
        _vm.$t('DIALOG.datasetInvitationConfirm.___info01', { user: [_vm.dataset.user.first_name, _vm.dataset.user.last_name].filter(function (x) { return x; }).join(' ') })
      ].join('<br>'))}})]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, true); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___accept')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var datasetInvitationConfirm_staticRenderFns = []
var datasetInvitationConfirm_esExports = { render: datasetInvitationConfirm_render, staticRenderFns: datasetInvitationConfirm_staticRenderFns }
/* harmony default export */ var dialog_datasetInvitationConfirm = (datasetInvitationConfirm_esExports);
// CONCATENATED MODULE: ./src/components/dialog/datasetInvitationConfirm.vue
var datasetInvitationConfirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datasetInvitationConfirm___vue_template_functional__ = false
/* styles */
var datasetInvitationConfirm___vue_styles__ = null
/* scopeId */
var datasetInvitationConfirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datasetInvitationConfirm___vue_module_identifier__ = null
var datasetInvitationConfirm_Component = datasetInvitationConfirm_normalizeComponent(
  datasetInvitationConfirm,
  dialog_datasetInvitationConfirm,
  datasetInvitationConfirm___vue_template_functional__,
  datasetInvitationConfirm___vue_styles__,
  datasetInvitationConfirm___vue_scopeId__,
  datasetInvitationConfirm___vue_module_identifier__
)

/* harmony default export */ var components_dialog_datasetInvitationConfirm = (datasetInvitationConfirm_Component.exports);

// EXTERNAL MODULE: ./node_modules/marked/lib/marked.umd.js
var marked_umd = __webpack_require__("xt7F");
var marked_umd_default = /*#__PURE__*/__webpack_require__.n(marked_umd);

// EXTERNAL MODULE: ./node_modules/dompurify/dist/purify.js
var purify = __webpack_require__("OvQW");
var purify_default = /*#__PURE__*/__webpack_require__.n(purify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/display.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var chat_display = ({
  mixins: [userPermission["a" /* default */]],
  props: {
    chats: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    botState: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    botChatData: {
      type: Object,
      required: true
    }
  },
  computed: {
    botStatus: function botStatus() {
      var status = this.botChatData.status || [];
      return status[status.length - 1];
    },
    botAnswering: function botAnswering() {
      return Object(util["m" /* sortData */])(this.botChatData.message || [], function (data) {
        return data.timestamp;
      }, 'asc').map(function (data) {
        return data.data;
      }).join('');
    },
    chatDatas: function chatDatas() {
      var _this = this;

      var botChats = {
        'loading': [{
          type: 'loading',
          msgType: 'answer',
          message: this.parseMDToHTML(this.botAnswering)
        }],
        'stop': [{
          type: 'stop'
        }]
      }[this.botState] || [];
      return [].concat(toConsumableArray_default()(this.chats.map(function (chat) {
        return chat.msgType === 'answer' ? extends_default()({}, chat, { message: _this.parseMDToHTML(chat.message) }) : chat;
      })), toConsumableArray_default()(botChats));
    }
  },
  methods: {
    parseMDToHTML: function parseMDToHTML() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var html = marked_umd["marked"].parse(msg);
      return purify_default.a.sanitize(html);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1a353ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/display.vue
var display_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-display-page col-block width-full"},[_c('div',{staticClass:"chat-display-container col-block width-full"},_vm._l((_vm.chatDatas),function(chatData,cdindex){return _c('div',{key:cdindex,staticClass:"chat-display-block row-block flex-start"},[(chatData.msgType)?_c('div',{staticClass:"avatar-block",style:({ '--size': '40px' })},[(chatData.msgType === 'answer')?_c('img',{attrs:{"src":__webpack_require__("vNtb"),"alt":""}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"chat-display-content-container col-block",class:[{
          'answer': 'flex-start',
          'question': 'flex-end'
        }[chatData.msgType]] || 'stretch',style:({ flex: 1, width: 0 })},[(chatData.type === 'loading')?[(chatData.message)?_c('div',{staticClass:"chat-display-content-block bot-answer col-block flex-start",domProps:{"innerHTML":_vm._s(chatData.message)}}):_c('div',{staticClass:"chat-display-content-block row-block bot-loading"},[_c('img',{style:({ height: '3em' }),attrs:{"src":__webpack_require__("5xS/"),"alt":""}}),_vm._v(" "),(_vm.botStatus)?_c('span',{staticClass:"shrink ellipsis",attrs:{"title":_vm.botStatus.message}},[_vm._v(_vm._s(_vm.botStatus.message))]):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]:(chatData.type === 'stop')?[_c('div',{staticClass:"chat-display-content-block bot-stop break-line"},[_c('span',[_vm._v(_vm._s(_vm.$t('COMPONENT.chat.display.___stopMsg')))])])]:[(chatData.msgType === 'question')?_c('div',{staticClass:"chat-display-content-block break-line"},[_c('span',[_vm._v(_vm._s(chatData.message))])]):(chatData.msgType === 'answer')?_c('div',{staticClass:"chat-display-content-block bot-answer col-block flex-start",domProps:{"innerHTML":_vm._s(chatData.message)}}):_vm._e()]],2),_vm._v(" "),(chatData.msgType)?_c('div',{staticClass:"avatar-block",style:({ '--size': '40px' })},[(chatData.msgType === 'question')?_c('img',{attrs:{"src":_vm.avatarUrl,"alt":""}}):_vm._e()]):_vm._e()])}),0)])}
var display_staticRenderFns = []
var display_esExports = { render: display_render, staticRenderFns: display_staticRenderFns }
/* harmony default export */ var components_chat_display = (display_esExports);
// CONCATENATED MODULE: ./src/components/chat/display.vue
var display_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var display___vue_template_functional__ = false
/* styles */
var display___vue_styles__ = null
/* scopeId */
var display___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var display___vue_module_identifier__ = null
var display_Component = display_normalizeComponent(
  chat_display,
  components_chat_display,
  display___vue_template_functional__,
  display___vue_styles__,
  display___vue_scopeId__,
  display___vue_module_identifier__
)

/* harmony default export */ var src_components_chat_display = (display_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chat/summary.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var chat_summary = ({
  mixins: [userPermission["a" /* default */]],
  props: {
    chats: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    botState: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    botChatData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      display: {}
    };
  },

  computed: {
    summaryDatas: function summaryDatas() {
      if (this.botChatData.summary.timestamp) {
        this.display = extends_default()({}, this.display, defineProperty_default()({}, this.botChatData.summary.timestamp, true));
      }
      return [].concat(toConsumableArray_default()(this.chats.filter(function (chat) {
        return chat.msgType === 'answer';
      }).map(function (chat) {
        return chat.summary;
      })), [this.botChatData.summary]).filter(function (summary) {
        return summary.contents;
      }).map(function (summary) {
        return extends_default()({}, summary, {
          contents: Object(util["m" /* sortData */])(values_default()(summary.contents), function (data) {
            return data.timestamp;
          }, 'asc')
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b2a2135","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/summary.vue
var summary_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-summary-page col-block width-full"},[_c('div',{staticClass:"chat-summary-container col-block width-full"},_vm._l((_vm.summaryDatas),function(summaryData){return _c('div',{key:summaryData.timestamp,staticClass:"chat-summary-block col-block width-full",class:{ active: _vm.display[summaryData.timestamp] }},[_c('div',{staticClass:"chat-summary-data-container col-block width-full"},[_c('div',{staticClass:"chat-summary-data-title-container row-block",class:_vm.display[summaryData.timestamp] ? ['flex-start'] : []},[_c('div',{staticClass:"chat-summary-data-title",class:_vm.display[summaryData.timestamp] ? ['break-line'] : ['ellipsis'],style:({ flex: 1 })},[_vm._v(_vm._s(summaryData.title))]),_vm._v(" "),_c('div',{staticClass:"chat-summary-data-display-icon icon-block",style:({ '--size': '30px' }),on:{"click":function (e) { return _vm.display[summaryData.timestamp] = !_vm.display[summaryData.timestamp]; }}},[_c('img',{attrs:{"src":__webpack_require__("0Pmj"),"alt":""}})])]),_vm._v(" "),(_vm.display[summaryData.timestamp] && (summaryData.contents || []).length)?_c('div',{staticClass:"chat-summary-data-block col-block width-full"},[_c('div',{staticClass:"chat-summary-data-content-container col-block width-full"},_vm._l((summaryData.contents),function(content){return _c('div',{key:content.timestamp,staticClass:"chat-summary-data-content-block col-block flex-start"},[_c('div',{staticClass:"chat-summary-data-content-title break-line"},[_vm._v(_vm._s([
                { 'complete': '✓' }[content.status] || '•',
                content.title
              ].join(' ')))]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"chat-summary-data-content-summary break-line"},[_vm._v(_vm._s(content.summary))]),_vm._v(" "),(content.source)?_c('div',{staticClass:"chat-summary-data-content-source break-line"},[_vm._v(_vm._s(_vm.$t('COMPONENT.chat.summary.___source'))),_c('span',[_vm._v(_vm._s(content.source))])]):_vm._e()])}),0)]):_vm._e()])])}),0)])}
var summary_staticRenderFns = []
var summary_esExports = { render: summary_render, staticRenderFns: summary_staticRenderFns }
/* harmony default export */ var components_chat_summary = (summary_esExports);
// CONCATENATED MODULE: ./src/components/chat/summary.vue
var summary_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var summary___vue_template_functional__ = false
/* styles */
var summary___vue_styles__ = null
/* scopeId */
var summary___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var summary___vue_module_identifier__ = null
var summary_Component = summary_normalizeComponent(
  chat_summary,
  components_chat_summary,
  summary___vue_template_functional__,
  summary___vue_styles__,
  summary___vue_scopeId__,
  summary___vue_module_identifier__
)

/* harmony default export */ var src_components_chat_summary = (summary_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/webSocket.vue






/* harmony default export */ var webSocket = ({
  data: function data() {
    return {
      wsUrl: null,
      wsToken: null,
      wsSubscribeChannels: []
    };
  },
  beforeDestroy: function beforeDestroy() {
    var wsSubscribeChannels = [].concat(toConsumableArray_default()(this.wsSubscribeChannels));
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = get_iterator_default()(wsSubscribeChannels), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var channel = _step.value;

        this.unSubscribeWs(channel);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    this.unConnectWs();
  },

  methods: {
    initWs: function initWs(url, token) {
      var manual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      this.wsUrl = url || api_config["b" /* WS_ROOT */];
      this.wsToken = token || this.$ls.get('userInfo').access_token;
      if (!manual) {
        this.connectWs();
        this.subscribeWs();
      }
    },
    connectWs: function connectWs() {
      var url = this.wsUrl + '?access_token=' + this.wsToken;
      this.$cable.connection.connect(url);
    },
    subscribeWs: function subscribeWs() {
      var channel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ChatChannel';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.$cable.subscribe(extends_default()({
        channel: channel
      }, options));
      this.wsSubscribeChannels.push('ChatChannel');
    },
    unConnectWs: function unConnectWs() {
      this.$cable.connection.disconnect();
    },
    unSubscribeWs: function unSubscribeWs() {
      var channel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ChatChannel';

      this.wsSubscribeChannels.splice(this.wsSubscribeChannels.indexOf(channel), 1);
      this.$cable.unsubscribe(channel);
    },
    sendWs: function sendWs(content) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var channel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ChatChannel';

      this.$cable.perform({
        channel: channel,
        data: extends_default()({
          content: content
        }, options)
      });
    }
  }
});
// CONCATENATED MODULE: ./src/mixins/webSocket.vue
var webSocket_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var webSocket___vue_template__ = null
/* template functional */
var webSocket___vue_template_functional__ = false
/* styles */
var webSocket___vue_styles__ = null
/* scopeId */
var webSocket___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var webSocket___vue_module_identifier__ = null
var webSocket_Component = webSocket_normalizeComponent(
  webSocket,
  webSocket___vue_template__,
  webSocket___vue_template_functional__,
  webSocket___vue_styles__,
  webSocket___vue_scopeId__,
  webSocket___vue_module_identifier__
)

/* harmony default export */ var mixins_webSocket = (webSocket_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/chatbot.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var chatbot = ({
  components: {
    chatDisplay: src_components_chat_display,
    chatSummary: src_components_chat_summary
  },
  mixins: [routeLoading["a" /* default */], toastMethods["a" /* default */], userPermission["a" /* default */], responsitive["a" /* default */], mixins_webSocket],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      threadID: null,
      content: '',
      chats: [],
      buttonPhase: 'default',
      botState: '',
      botChatData: {
        status: [],
        summary: {},
        message: []
      },
      display: {
        'defaultButton': false,
        'agentSummary': false
      }
    };
  },

  channels: {
    ChatChannel: {
      connected: function connected() {
        if (!this.chats.length) {
          this.display['defaultButton'] = true;
        }
        this.botState = '';
        this.setLoadingAction(false);
      },
      rejected: function rejected() {
        var _this = this;

        setTimeout(function () {
          _this.initWebSocket();
        }, 5000);
      },
      received: function received(data) {
        var _this2 = this;

        switch ((data || {}).event) {
          case 'status':
            {
              this.botChatData.status.push(data);
              break;
            }
          case 'agent_activity':
            {
              this.botChatData.summary.contents[data.title] = extends_default()({}, data, this.botChatData.summary.contents[data.title] || {}, {
                status: data.status
              });
              this.setScrollToBottom('summary-scroll');
              break;
            }
          case 'answer_delta':
            {
              this.botChatData.message.push(data);
              this.setScrollToBottom('chatbot-scroll');
              break;
            }
          case 'answer_image':
            {
              this.botChatData.message.push(extends_default()({}, data, {
                data: ['', this.parseAssetToString(data.asset), ''].join('\n\n')
              }));
              this.setScrollToBottom('chatbot-scroll');
              break;
            }
          case 'media':
            {
              // this.botChatData.message.push({
              //   ...data,
              //   data: [
              //     '',
              //     ...data.visual_assets.map(asset => this.parseAssetToString(asset)),
              //     ''
              //   ].join('\n\n')
              // })
              // this.setScrollToBottom('chatbot-scroll')
              break;
            }
          case 'done':
            {
              var answer = data.stream_layout_stable ? Object(util["m" /* sortData */])(this.botChatData.message || [], function (data) {
                return data.timestamp;
              }, 'asc').map(function (data) {
                return data.data;
              }).join('') : data.content_blocks ? data.content_blocks.map(function (block) {
                return _this2.parseContentBlock(block);
              }).filter(function (x) {
                return x;
              }).join('\n\n') : data.answer;
              this.botState = '';
              this.chats.push(extends_default()({}, this.botChatData, {
                message: answer,
                msgType: 'answer'
              }));
              this.botChatData = {
                status: [],
                summary: {},
                message: []
              };
              break;
            }
          case 'error':
            {
              if (data.message) {
                this.addToast('error', data.data);
              }
              break;
            }
        }
      },
      disconnected: function disconnected() {
        this.display['defaultButton'] = false;
        this.botState = 'busy';
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user']), {
    currentButtonOptions: function currentButtonOptions() {
      return {
        'default': [{
          icon: __webpack_require__("Q05p"),
          title: this.$t('DIALOG.chatbot.button.default.clinVar.___title'),
          content: 'DIALOG.chatbot.button.default.clinVar.___content'
        }, {
          icon: __webpack_require__("0VYF"),
          title: this.$t('DIALOG.chatbot.button.default.caseReports.___title'),
          content: 'DIALOG.chatbot.button.default.caseReports.___content'
        }, {
          icon: __webpack_require__("bk/E"),
          title: this.$t('DIALOG.chatbot.button.default.prevalence.___title'),
          content: 'DIALOG.chatbot.button.default.prevalence.___content'
        }, {
          icon: __webpack_require__("WpIV"),
          title: this.$t('DIALOG.chatbot.button.default.disease.___title'),
          content: 'DIALOG.chatbot.button.default.disease.___content'
        }]
      }[this.buttonPhase];
    },

    // param
    caseData: function caseData() {
      return this.param.caseData;
    },
    project: function project() {
      return this.param.project;
    },
    phenotype: function phenotype() {
      return this.param.phenotype;
    },
    phenotypeName: function phenotypeName() {
      return this.phenotype.Phenotype || this.phenotype.disease;
    }
  }),
  watch: {
    'chats.length': function chatsLength() {
      this.setScrollToBottom('chatbot-scroll');
      this.setScrollToBottom('summary-scroll');
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction', 'setModal2Action']), {
    fetchData: function fetchData() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.fetehWebSocketConnections();

              case 2:
                if (!_context.sent) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return _this3.fetchChat();

              case 5:
                _this3.initWebSocket();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    fetehWebSocketConnections: function fetehWebSocketConnections() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', true);

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    fetchChat: function fetchChat() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, projectID, response, chats, types;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this5.$ls.get('userInfo');
                projectID = _this5.project.id;
                _context3.next = 5;
                return Object(src_api["_6" /* getChat */])(projectID, config);

              case 5:
                response = _context3.sent;
                chats = response.data.data;
                types = ['question', 'answer'];

                chats = Array.prototype.concat.apply([], chats.map(function (chat) {
                  return types.map(function (type) {
                    return { message: chat[type], msgType: type };
                  }).filter(function (chat) {
                    return chat.message;
                  });
                }));
                _this5.threadID = entries_default()({
                  'user': _this5.user.id,
                  'case': _this5.caseData.id,
                  'date': Object(util["d" /* dateFormat */])(new Date(), 'yyyyMMddhhmmssS')
                }).map(function (_ref) {
                  var _ref2 = slicedToArray_default()(_ref, 2),
                      key = _ref2[0],
                      value = _ref2[1];

                  return key + value;
                }).join('-');
                _this5.chats = chats;
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0;

              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 13]]);
      }))();
    },
    retryConnect: function retryConnect() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.setLoadingAction(true);
                _context4.next = 3;
                return _this6.fetchData();

              case 3:
                _this6.setLoadingAction(false);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    initWebSocket: function initWebSocket() {
      this.setLoadingAction(true);
      this.initWs();
    },
    sendButtonContent: function sendButtonContent(option) {
      this.sendContent(this.$t(option.content), this.$t(option.content));
    },
    sendContent: function sendContent(content, wsContent) {
      this.chats.push({
        message: content,
        msgType: 'question'
      });
      this.display['defaultButton'] = false;
      this.content = '';
      this.botState = 'loading';
      this.botChatData.summary = {
        title: wsContent || content,
        timestamp: Date.now(),
        contents: {}
      };
      this.sendWs(wsContent || content, {
        case_id: this.caseData.id,
        thread_id: this.threadID
      });
    },
    deleteContentsAlert: function deleteContentsAlert() {
      var _this7 = this;

      this.setModal2Action({
        action: 'toast',
        width: '496px',
        customStyles: {
          padding: 0,
          border: 0
        },
        param: {
          type: 'alert',
          content: '<span style=color:#FA3D3D>' + this.$t('DIALOG.chatbot.___deleteAlert') + '</span>',
          buttons: [{
            title: this.$t('COMMON.button.___cancel'),
            type: 'gray',
            result: false
          }, {
            title: this.$t('COMMON.button.___delete'),
            type: 'alert',
            result: true
          }]
        },
        callback: function () {
          var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(result) {
            return regenerator_default.a.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    if (!result) {
                      _context5.next = 5;
                      break;
                    }

                    _this7.setLoadingAction(true);
                    _context5.next = 4;
                    return _this7.deleteContents();

                  case 4:
                    _this7.setLoadingAction(false);

                  case 5:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee5, _this7);
          }));

          return function callback(_x) {
            return _ref3.apply(this, arguments);
          };
        }()
      });
    },
    deleteContents: function deleteContents() {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var config, projectID;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                config = _this8.$ls.get('userInfo');
                projectID = _this8.project.id;
                _context6.next = 5;
                return Object(src_api["n" /* deleteChat */])(projectID, config);

              case 5:
                _this8.chats = [];
                _this8.display['defaultButton'] = true;
                _context6.next = 11;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6['catch'](0);

              case 11:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[0, 9]]);
      }))();
    },
    stopBot: function stopBot() {
      var _this9 = this;

      this.unSubscribeWs();
      this.botState = 'stop';
      setTimeout(function () {
        _this9.subscribeWs();
      }, 100);
    },
    parseContentBlock: function parseContentBlock(block) {
      switch (block.type) {
        case 'text':
          {
            return block.markdown;
          }
        case 'image':
          {
            return this.parseAssetToString(block.asset);
          }
      }
    },
    parseAssetToString: function parseAssetToString(asset) {
      return '![' + (asset.alt || '') + '](' + asset.url + ')';
    },
    setScrollToBottom: function setScrollToBottom(key) {
      var _this10 = this;

      if (this.$refs[key]) {
        setTimeout(function () {
          _this10.$refs[key].scrollTop = _this10.$refs[key].scrollHeight;
        });
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-617d4887","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/chatbot.vue
var chatbot_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chatbot-dialog col-block width-full"},[_c('div',{staticClass:"chatbot-main-container row-block height-full",style:({ height: (_vm.windowHeight - 350) + 'px', 'max-height': '500px' })},[_c('div',{staticClass:"chatbot-main-block col-block width-full",style:({ flex: 5, width: 0 })},[_c('div',{staticClass:"chatbot-default-button-container col-block width-full",class:{ active: _vm.display['defaultButton'], disabled: ['loading', 'stop', 'busy'].includes(_vm.botState) },style:({ right: (_vm.scrollbarSize + 10) + 'px' })},[_c('div',{staticClass:"chatbot-default-button-block row-block flex-start"},[(_vm.display['defaultButton'])?[_c('div',{staticClass:"avatar-block",style:({ '--size': '40px' })}),_vm._v(" "),_c('div',{staticClass:"chatbot-default-button-main-container col-block",style:({ flex: 1 })},[_c('div',{staticClass:"chatbot-default-button-main-block",style:({
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gridGap: '10px 12px',
                  'max-width': '772px'
                })},_vm._l((_vm.currentButtonOptions),function(buttonOption,boindex){return _c('div',{key:boindex,staticClass:"chatbot-default-button-content-container col-block",style:({
                    grid: 'span 1'
                  }),on:{"click":function (e) { return !['loading', 'stop', 'busy'].includes(_vm.botState) && _vm.sendButtonContent(buttonOption); }}},[_c('div',{staticClass:"chatbot-default-button-content icon-block",style:({ '--size': '40px' })},[_c('img',{attrs:{"src":buttonOption.icon,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"chatbot-default-button-content",domProps:{"innerHTML":_vm._s(buttonOption.title)}})])}),0)])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"chatbot-default-button-avatar-container avatar-block center-block",style:({ '--size': '40px' }),on:{"click":function (e) { return _vm.display['defaultButton'] = !['loading', 'stop', 'busy'].includes(_vm.botState) ? !_vm.display['defaultButton'] : false; }}},[_c('img',{style:({ width: '16.5px' }),attrs:{"src":__webpack_require__("wlFF"),"alt":""}})])],2)]),_vm._v(" "),(['busy'].includes(_vm.botState))?[_c('div',{staticClass:"chatbot-bot-busy-container col-block",style:({ flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"chatbot-bot-busy-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.chatbot.___busyTitle')))]),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"chatbot-bot-busy-button-container row-block"},[_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.retryConnect(); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___retry')))])])]),_vm._v(" "),_c('div',{style:({ flex: 5 })})])]:[_c('div',{ref:"chatbot-scroll",staticClass:"chatbot-display-container",style:({ flex: 1 })},[_c('div',{staticClass:"col-block width-full",style:({ height: 0 })},[_c('chatDisplay',{attrs:{"chats":_vm.chats,"botState":_vm.botState,"botChatData":_vm.botChatData}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)])]],2),_vm._v(" "),_c('div',{staticClass:"chatbot-agent-container col-block width-full",style:(_vm.display['agentSummary'] ? { flex: 3, width: 0 } : { width: '44px' })},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display['agentSummary']),expression:"display['agentSummary']"}],staticClass:"chatbot-agent-main-container col-block width-full",style:({ flex: 1, height: 0 })},[_c('div',{staticClass:"chatbot-agent-main-title-container row-block"},[_c('div',{staticClass:"chatbot-agent-main-title",style:({ flex: 1 })},[_vm._v(_vm._s(_vm.$t('DIALOG.chatbot.agent.___title')))]),_vm._v(" "),_c('img',{staticClass:"active-icon",attrs:{"src":__webpack_require__("gyhp"),"alt":""},on:{"click":function (e) { return _vm.display['agentSummary'] = false; }}})]),_vm._v(" "),_c('div',{ref:"summary-scroll",staticClass:"chatbot-agent-main-content-container",style:({ flex: 1 })},[_c('div',{staticClass:"col-block width-full",style:({ height: 0 })},[_c('chatSummary',{attrs:{"chats":_vm.chats,"botState":_vm.botState,"botChatData":_vm.botChatData}})],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.display['agentSummary']),expression:"!display['agentSummary']"}],staticClass:"chatbot-agent-bar-container col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"col-block",style:({ flex: 1 })},[_c('img',{staticClass:"active-icon",attrs:{"src":__webpack_require__("gyhp"),"alt":""},on:{"click":function (e) { return _vm.display['agentSummary'] = true; }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"chatbot-agent-bar-title-container col-block"},[_c('div',{staticClass:"chatbot-agent-bar-title"},[_vm._v(_vm._s(_vm.$t('DIALOG.chatbot.agent.___title')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"chatbot-form-container col-block width-full"},[_c('div',{staticClass:"chatbot-form-block row-block",style:({ 'max-width': '772px' })},[_c('div',{staticClass:"chatbot-form col-block width-full input-group",style:({ flex: 1 })},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],attrs:{"type":"text","placeholder":_vm.$t('DIALOG.chatbot.___inputPlaceholder'),"disabled":['loading', 'stop', 'busy'].includes(_vm.botState)},domProps:{"value":(_vm.content)},on:{"keypress":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.sendContent(_vm.content); })($event)},"input":function($event){if($event.target.composing){ return; }_vm.content=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"chatbot-form-button-container row-block"},[_c('div',{staticClass:"chatbot-form-button-block row-block"},[_c('button',{staticClass:"send-button main-button circle-button",attrs:{"disabled":!_vm.content || ['loading', 'stop', 'busy'].includes(_vm.botState)},on:{"click":function (e) { return _vm.sendContent(_vm.content); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___send')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"chatbot-button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___return')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var chatbot_staticRenderFns = []
var chatbot_esExports = { render: chatbot_render, staticRenderFns: chatbot_staticRenderFns }
/* harmony default export */ var dialog_chatbot = (chatbot_esExports);
// CONCATENATED MODULE: ./src/components/dialog/chatbot.vue
var chatbot_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var chatbot___vue_template_functional__ = false
/* styles */
var chatbot___vue_styles__ = null
/* scopeId */
var chatbot___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var chatbot___vue_module_identifier__ = null
var chatbot_Component = chatbot_normalizeComponent(
  chatbot,
  dialog_chatbot,
  chatbot___vue_template_functional__,
  chatbot___vue_styles__,
  chatbot___vue_scopeId__,
  chatbot___vue_module_identifier__
)

/* harmony default export */ var components_dialog_chatbot = (chatbot_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/addLicenseID.vue









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var addLicenseID = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      licenseData: {},
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },

    // static
    formOptions: function formOptions() {
      var _this2 = this;

      return {
        field1: [{
          title: this.$t('DIALOG.addLicenseID.form.title.___create'),
          value: 'CREATE_BUTTON'
        }],
        field2: [{
          title: this.$t('DIALOG.addLicenseID.form.title.___import'),
          value: 'license_id',
          type: 'input',
          placeholder: function placeholder() {
            return _this2.$t('DIALOG.addLicenseID.form.placeholder.___import');
          },
          validate: 'required'
        }]
      };
    }
  },
  methods: {
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.licenseData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    validateImportLicenseID: function validateImportLicenseID() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};

                _this3.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this3.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 15;
                  break;
                }

                kv = _step2.value;
                _context.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context.next = 7;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError2) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                result['custom'] = _this3.customValidate();

                if (values_default()(result).includes(false)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 33;
                return _this3.importLicenseID();

              case 33:
                _this3.onSubmit = false;

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    importLicenseID: function importLicenseID() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, licenseID, response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this4.$ls.get('userInfo');
                licenseID = _this4.result.license_id;
                _context2.next = 5;
                return Object(src_api["_144" /* putGenerateLicenseID */])(licenseID, config);

              case 5:
                response = _context2.sent;

                _this4.addToast('success', response.data.result.message);
                _this4.$emit('changeModal', {}, true);
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                _this4.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.result.message);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 10]]);
      }))();
    },
    createLicenseID: function createLicenseID() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, response;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.onSubmit = true;
                _context3.prev = 1;
                config = _this5.$ls.get('userInfo');
                _context3.next = 5;
                return Object(src_api["_119" /* postGenerateLicenseID */])(config);

              case 5:
                response = _context3.sent;

                _this5.addToast('success', response.data.result.message);
                _this5.$emit('changeModal', {}, true);
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](1);

                _this5.addToast('error', !_context3.t0.response ? _context3.t0.message : _context3.t0.response.data.result.message);

              case 13:
                _this5.onSubmit = false;

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[1, 10]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd6dd55a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/addLicenseID.vue
var addLicenseID_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-license-id-dailog dialog col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"main-title small"},[_vm._v(_vm._s(_vm.$t('DIALOG.addLicenseID.___title')))])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.licenseData,"alerts":_vm.alerts,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }},scopedSlots:_vm._u([{key:"CREATE_BUTTON",fn:function(props){return [_c('div',{staticClass:"col-block flex-start",attrs:{"name":props}},[_c('button',{staticClass:"main-button circle-button auto-button",attrs:{"type":"button"},on:{"click":function (e) { return _vm.createLicenseID(); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___create')))])])])]}}])}),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"row-block",style:({ padding: '0 10px', 'box-sizing': 'border-box' })},[_c('div',{style:({ flex: 1, height: '1px', background: '#003679' })}),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{style:({ 'color': '#003679', 'font-size': '1rem', 'font-weight': 'bold' })},[_vm._v(_vm._s(_vm.$t('DIALOG.addLicenseID.___or')))]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{style:({ flex: 1, height: '1px', background: '#003679' })})]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.licenseData,"alerts":_vm.alerts,"forms":_vm.formOptions['field2']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field2', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___cancel')))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit ? _vm.validateImportLicenseID() : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.$t('COMMON.button.___add')))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var addLicenseID_staticRenderFns = []
var addLicenseID_esExports = { render: addLicenseID_render, staticRenderFns: addLicenseID_staticRenderFns }
/* harmony default export */ var dialog_addLicenseID = (addLicenseID_esExports);
// CONCATENATED MODULE: ./src/components/dialog/addLicenseID.vue
var addLicenseID_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addLicenseID___vue_template_functional__ = false
/* styles */
var addLicenseID___vue_styles__ = null
/* scopeId */
var addLicenseID___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var addLicenseID___vue_module_identifier__ = null
var addLicenseID_Component = addLicenseID_normalizeComponent(
  addLicenseID,
  dialog_addLicenseID,
  addLicenseID___vue_template_functional__,
  addLicenseID___vue_styles__,
  addLicenseID___vue_scopeId__,
  addLicenseID___vue_module_identifier__
)

/* harmony default export */ var components_dialog_addLicenseID = (addLicenseID_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/toast.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var dialog_toast = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      confirm: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60b50183","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/toast.vue
var dialog_toast_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-toast col-block",class:_vm.param.type},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.param.content)}}),_vm._v(" "),(_vm.param.confirm)?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"toast-confirm input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirm),expression:"confirm"}],attrs:{"type":"text","placeholder":_vm.param.confirm.placeholder},domProps:{"value":(_vm.confirm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirm=$event.target.value}}})])]:_vm._e(),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-row row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_vm._l((_vm.param.buttons || []),function(button,index){return _c('button',{key:index,class:[button.type + '-button', 'circle-button'],attrs:{"disabled":button.result && (_vm.param.confirm || {}).value && ((_vm.param.confirm || {}).value !== _vm.confirm)},on:{"click":function($event){_vm.$emit('changeModal', {}, button.result)}}},[_c('span',[_vm._v(_vm._s(button.title))])])}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)],2)}
var dialog_toast_staticRenderFns = []
var dialog_toast_esExports = { render: dialog_toast_render, staticRenderFns: dialog_toast_staticRenderFns }
/* harmony default export */ var components_dialog_toast = (dialog_toast_esExports);
// CONCATENATED MODULE: ./src/components/dialog/toast.vue
var dialog_toast_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dialog_toast___vue_template_functional__ = false
/* styles */
var dialog_toast___vue_styles__ = null
/* scopeId */
var dialog_toast___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dialog_toast___vue_module_identifier__ = null
var dialog_toast_Component = dialog_toast_normalizeComponent(
  dialog_toast,
  components_dialog_toast,
  dialog_toast___vue_template_functional__,
  dialog_toast___vue_styles__,
  dialog_toast___vue_scopeId__,
  dialog_toast___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_toast = (dialog_toast_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















// modals



















































__webpack_require__("5W8o");

/* harmony default export */ var App = ({
  name: 'app',
  components: {
    layoutHeader: components_layout_header,
    layoutFooter: components_layout_footer,
    layoutToast: src_components_tool_toast,
    layoutBorCor: src_components_layout_borCor,
    layoutLoading: components_layout_loading,
    layoutUploading: components_layout_uploading,
    layoutFileUpload: src_components_layout_fileUpload,
    // modals
    modal: components_dialog_container,
    userConfirm: components_dialog_userConfirm,
    editWorkgroupMember: components_dialog_editWorkgroupMember,
    editWorkgroupCase: components_dialog_editWorkgroupCase,
    editWorkgroupStage: components_dialog_editWorkgroupStage,
    intractableDiseaseSelect: components_dialog_intractableDiseaseSelect,
    genePanelInfo: components_dialog_genePanelInfo,
    editPanel: components_dialog_editPanel,
    addToPanel: src_components_dialog_addToPanel,
    genePanelQuickSelection: components_dialog_genePanelQuickSelection,
    genePanelDataSelect: components_dialog_genePanelDataSelect,
    genePanelConfirm: components_dialog_genePanelConfirm,
    selectDataset: components_dialog_selectDataset,
    fileCloud: components_dialog_fileCloud,
    caseConfirm: components_dialog_caseConfirm,
    caseEdit: components_dialog_caseEdit,
    projectEdit: components_dialog_projectEdit,
    caseDigitalMLPA: components_dialog_caseDigitalMLPA,
    caseFile: components_dialog_caseFile,
    caseAnalysisVersion: components_dialog_caseAnalysisVersion,
    caseDetailSVFilter: components_dialog_caseDetailSVFilter,
    caseDetailGenePedigree: components_dialog_caseDetailGenePedigree,
    caseDetailGeneVariantDatabase: components_dialog_caseDetailGeneVariantDatabase,
    caseDetailGeneQuality: components_dialog_caseDetailGeneQuality,
    caseDetailGenePreview: components_dialog_caseDetailGenePreview,
    caseDetailGeneACMG: components_dialog_caseDetailGeneACMG,
    caseDetailRegionGene: components_dialog_caseDetailRegionGene,
    caseDetailRegionQuality: components_dialog_caseDetailRegionQuality,
    caseDetailRegionVariant: components_dialog_caseDetailRegionVariant,
    caseDetailRegionPublication: components_dialog_caseDetailRegionPublication,
    caseDetailRegionCaller: components_dialog_caseDetailRegionCaller,
    editChapter: components_dialog_editChapter,
    addVariantToChapter: components_dialog_addVariantToChapter,
    editReportVariant: components_dialog_editReportVariant,
    editCNVToChapter: components_dialog_editCNVToChapter,
    editReportCNV: components_dialog_editReportCNV,
    editReportSV: components_dialog_editReportSV,
    userAvatar: components_dialog_userAvatar,
    imageCropper: components_dialog_imageCropper,
    datasetSelectCase: components_dialog_datasetSelectCase,
    datasetDetail: components_dialog_datasetDetail,
    datasetEdit: components_dialog_datasetEdit,
    datasetShareEdit: components_dialog_datasetShareEdit,
    datasetDeleteConfirm: components_dialog_datasetDeleteConfirm,
    datasetArchiveConfirm: components_dialog_datasetArchiveConfirm,
    datasetInvitationConfirm: components_dialog_datasetInvitationConfirm,
    chatbot: components_dialog_chatbot,
    addLicenseID: components_dialog_addLicenseID,
    toast: src_components_dialog_toast
  },
  mixins: [responsitive["a" /* default */], loginData["a" /* default */], toastMethods["a" /* default */], src_mixins_locale, licenseManager["a" /* default */]],
  data: function data() {
    return {
      userAgent: '',
      minHeight: '300px'
    };
  },

  watch: {
    '$route': function $route() {
      var _this = this;

      var _document = document,
          body = _document.body;

      body.scroll(0, 0);
      this.setModalAction({});
      this.setModal2Action({});
      window.dispatchEvent(new Event('resize'));
      if (this.initial !== null) {
        this.setLoadingAction(true);
        this.validateRoute(this.isLogin);
      }
      setTimeout(function () {
        return _this.setRouteResetAction(false);
      });
    },
    'isLogin': function isLogin(n, o) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(o !== null)) {
                  _context.next = 13;
                  break;
                }

                _this2.setLoadingAction(true);
                _context.next = 4;
                return _this2.preFetchDataGuest();

              case 4:
                if (!n) {
                  _context.next = 10;
                  break;
                }

                _context.next = 7;
                return _this2.preFetchData();

              case 7:
                _this2.setServerLang();
                _context.next = 11;
                break;

              case 10:
                _this2.setUnloadAlertAction();

              case 11:
                _this2.appInitialAction(n);
                _this2.setLoadingAction(false);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    'unloadAlert': function unloadAlert(nv) {
      if (nv) {
        window.document.body.onbeforeunload = function () {
          return '';
        };
      } else {
        window.document.body.onbeforeunload = null;
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['normalPage', 'userPage', 'adminPage', 'initial', 'isLogin', 'isLoading', 'isDialogLoading', 'isUploading', 'routeReset', 'modal', 'modal2', 'unloadAlert']), {
    isMainPage: function isMainPage() {
      return this.$route.name && [
      // normal page
      'main', 'deviceAlert', 'forget', 'reset', 'register', 'active', 'genePanel', 'phenotypeDisease', 'coverageRate',
      // user page
      'user', 'phenotype', 'config', 'point', 'systemInfo', 'datasetInvitationConfirm',
      //
      ''].includes(this.$route.name);
    },
    isLargePage: function isLargePage() {
      return this.$route.name && [
      // normal page
      // user page
      //
      ''].includes(this.$route.name);
    },
    noHeader: function noHeader() {
      return this.$route.name && ['main', ''].includes(this.$route.name);
    }
  }),
  created: function created() {
    var _this3 = this;

    this.userAgent = navigator.userAgent;
    this.setLocale();
    this.setModalAction({});
    this.setModal2Action({});
    this.setLoadingAction(true);
    var validateLogin = function validateLogin() {
      if (_this3.$route.name) {
        _this3.validateLogin();
      } else {
        setTimeout(function () {
          return validateLogin();
        }, 100);
      }
    };
    validateLogin();
  },
  beforeMount: function beforeMount() {
    var _this4 = this;

    var _document2 = document,
        body = _document2.body;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var headerHeight = _this4.noHeader ? 0 : 60;
        var footerHeight = 0;
        var height = rect.height - headerHeight - footerHeight + 0;
        _this4.minHeight = height + 'px';
      }
    };
    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },
  mounted: function mounted() {
    var _this5 = this;

    window.addEventListener('scroll', function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      var offsetHeight = document.documentElement.offsetHeight || document.body.offsetHeight;
      _this5.setScrollStateAction({
        top: scrollTop,
        height: scrollHeight - offsetHeight
      });
    });
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['appInitialAction', 'setLoadingAction', 'setDialogLoadingAction', 'clearLoadingAction', 'clearDialogLoadingAction', 'setModalAction', 'setModal2Action', 'setUnloadAlertAction', 'setScrollStateAction', 'setRouteResetAction',
  // global
  'setUserSettingAction', 'setUserAvatarAction']), {
    setLocale: function setLocale() {
      var langMap = function langMap(l) {
        if (!l) return null;
        l = l.toLowerCase();
        // if (l === 'zh-cn') return 'tc'
        // if (l.startsWith('zh')) return 'tc'
        if (l === 'ja-JP') return 'ja';
        if (l.startsWith('ja')) return 'ja';
        return 'en';
      };
      var locale = localStorage.getItem('locale');
      if (!this.languageOptions.map(function (option) {
        return option.value;
      }).includes(locale)) {
        locale = langMap(window.navigator.language || navigator.userLanguage) || 'en';
      }
      this.setLang(locale);
    },
    preFetchDataGuest: function preFetchDataGuest() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    preFetchData: function preFetchData() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this7.fetchUserSettings();

              case 2:
                _context3.next = 4;
                return _this7.setLicenseStatus();

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },
    fetchUserSettings: function fetchUserSettings() {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var config, response, userSettings;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                config = _this8.$ls.get('userInfo');
                _context4.next = 4;
                return Object(src_api["_81" /* getUserSettings */])(config);

              case 4:
                response = _context4.sent;
                userSettings = response.data.data;

                userSettings = Object(global_data["G" /* parseUserSetting */])(userSettings || {});
                _this8.setUserSettingAction(userSettings);
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0;

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this8, [[0, 10]]);
      }))();
    },
    validateLogin: function validateLogin() {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var userInfo;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                userInfo = _this9.$ls.get('userInfo') || {};
                _context5.next = 3;
                return _this9.preFetchDataGuest();

              case 3:
                if (!userInfo['access_token']) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 6;
                return _this9.getUserByToken(userInfo);

              case 6:
                _context5.next = 11;
                break;

              case 8:
                _this9.setUserData(null);
                _this9.appInitialAction(false);
                _this9.validateRoute(false);

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this9);
      }))();
    },
    getUserByToken: function getUserByToken(data) {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var response, user;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return Object(src_api["_82" /* getUserToken */])(data);

              case 3:
                response = _context6.sent;
                _context6.next = 6;
                return _this10.preFetchData();

              case 6:
                user = response.data.user || response.data.data || { role: {} };

                _this10.setUserData(response, data);
                _this10.appInitialAction(true);
                _this10.validateRoute(true, user.role, ['supervisor'].includes(user.role));
                _context6.next = 18;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6['catch'](0);

                _this10.setUserData(null);
                _this10.appInitialAction(true);
                _this10.addToast('error', !_context6.t0.response ? _context6.t0.message : _context6.t0.response.data.result.message);
                _this10.validateRoute(false);

              case 18:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this10, [[0, 12]]);
      }))();
    },
    validateRoute: function validateRoute(isLogin, role, admin) {
      var array = [];
      if (isLogin) {
        switch (role) {
          default:
            {
              array = lodash_default.a.union(this.userPage, this.normalPage);
            }
        }
      } else {
        array = this.normalPage;
      }
      if (admin) {
        array = lodash_default.a.union(array, this.adminPage);
      }
      this.validateRole(isLogin, array);
    },
    validateRole: function validateRole(isLogin, pages) {
      var routeName = this.$route.name;
      if (routeName && !lodash_default.a.includes(pages, routeName)) {
        this.addToast('error', isLogin ? this.$t('COMMON.toast.___noPermission') : this.$t('COMMON.toast.___pleaseLogin'));
        this.$router.push(isLogin ? { name: 'main' } : { name: 'main', query: { redirect: this.$route.fullPath } });
        this.setLoadingAction(false);
      } else {
        if (isLogin && lodash_default.a.includes(this.normalPage, routeName) && !['active', 'datasetInvitationConfirm', 'genePanel', 'phenotypeDisease', 'coverageRate', 'datasetDetail'].includes(routeName)) {
          this.$router.push({ name: 'caseList' });
        }
        this.setLoadingAction(false);
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74e34fcb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-root",class:[_vm.locale],attrs:{"id":"app"}},[(!_vm.noHeader)?_c('layout-header',{on:{"setLang":function (l) { return _vm.locale = l; }}}):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"scroll-box"}}),_vm._v(" "),_c('div',{staticClass:"app-container",style:({ position: _vm.modal.action && !_vm.isDialogLoading ? 'relative' : 'relative' })},[_c('div',{staticClass:"app-pages",class:{ 'no-header': _vm.noHeader }},[(!_vm.isMainPage)?_c('div',{staticClass:"max-width",class:{ 'large-page': _vm.isLargePage },style:({ minHeight: _vm.minHeight, display: _vm.isMainPage ? 'flex' : 'block', 'align-items': 'center' })},[_c('div',{staticClass:"view-container"},[_c('div',{staticClass:"view-field responsitive-color transparent-transparent"},[_c('keep-alive',{attrs:{"include":_vm.routeReset ? [] : ['caseList', 'datasetList']}},[_c('router-view',{attrs:{"minHeight":_vm.minHeight}})],1)],1)])]):_c('div',{staticClass:"app-main-container"},[_c('keep-alive',{attrs:{"include":[]}},[_c('router-view',{attrs:{"minHeight":_vm.minHeight}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-container"},[(_vm.modal.action)?_c('modal',{style:(!_vm.isDialogLoading ? {} : { display: 'none' }),attrs:{"width":_vm.modal.width,"height":_vm.modal.height,"customStyles":_vm.modal.customStyles,"maskClose":_vm.modal.maskClose},on:{"hide":function () {
      _vm.modal.callback && _vm.modal.callback()
      _vm.setModalAction({})
    }}},[_c(_vm.modal.action,{tag:"component",attrs:{"param":_vm.modal.param},on:{"changeModal":function (option, param) {
        _vm.modal.callback && _vm.modal.callback(param)
        this$1.setModalAction(option || {})
      }}})],1):_vm._e(),_vm._v(" "),(_vm.modal2.action)?_c('modal',{style:(!_vm.isDialogLoading ? {} : { display: 'none' }),attrs:{"width":_vm.modal2.width,"height":_vm.modal2.height,"customStyles":_vm.modal2.customStyles,"maskClose":_vm.modal2.maskClose},on:{"hide":function () {
      _vm.modal2.callback && _vm.modal2.callback()
      _vm.setModal2Action({})
    }}},[_c(_vm.modal2.action,{tag:"component",attrs:{"param":_vm.modal2.param},on:{"changeModal":function (option, param) {
        _vm.modal2.callback && _vm.modal2.callback(param)
        this$1.setModal2Action(option || {})
      }}})],1):_vm._e()],1),_vm._v(" "),(_vm.isLogin)?_c('layoutFileUpload'):_vm._e(),_vm._v(" "),_c('layoutToast'),_vm._v(" "),_c('layoutBorCor'),_vm._v(" "),(_vm.isLoading)?_c('layoutLoading'):_vm._e(),_vm._v(" "),(_vm.isUploading !== undefined)?_c('layoutUploading',{attrs:{"content":_vm.isUploading}}):_vm._e()],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("pbJc")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js




vue_esm["default"].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: [{
    path: '/',
    name: 'root',
    redirect: { name: 'main' }
  }, {
    path: '/main',
    name: 'main',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8too")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/deviceAlert',
    name: 'deviceAlert',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gr8x")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/forget',
    name: 'forget',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HHUW")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    buildType: 'online'
  }, {
    path: '/reset',
    name: 'reset',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8jyM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/register',
    name: 'register',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Dhdo")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/active',
    name: 'active',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("T4tO")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/datasetAccess/:id',
    name: 'datasetAccess',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aWKw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/coverageRate',
    name: 'coverageRate',
    component: function component(resolve) {
      __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ljaW")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/genePanel',
    name: 'genePanel',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XLX7")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/phenotypeDisease',
    name: 'phenotypeDisease',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GUIV")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/user/:tab?',
    name: 'user',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("FNn1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/workgroup',
    name: 'workgroup',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("juEX")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/panel',
    name: 'panel',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PU4H")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/config',
    name: 'config',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("szT4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/systemInfo',
    name: 'systemInfo',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JCCc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/caseList/:tab?',
    name: 'caseList',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("oytU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/caseEdit/:dataset',
    name: 'caseEdit',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4DmU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/caseBatchUpload/:dataset',
    name: 'caseBatchUpload',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("T5Mm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/caseDetail/:type/:id',
    name: 'caseDetail',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("qrhr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/datasetList',
    name: 'datasetList',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("BfKk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/datasetEdit',
    name: 'datasetEdit',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+rS8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/datasetDetail/:type/:id',
    name: 'datasetDetail',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("q/8J")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/datasetInvitationConfirm',
    name: 'datasetInvitationConfirm',
    component: function component(resolve) {
      __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gaYw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/genomeBrowser/:id/:type/:symbol/:vkey',
    name: 'genomeBrowser',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gYSt")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '*',
    redirect: { name: 'main' }
  }].filter(function (route) {
    return !route.buildType || route.buildType === { 'true': 'local', 'false': 'online' }[global_config["a" /* _LOCAL_BUILD */] + ''];
  })
}));
// CONCATENATED MODULE: ./src/store/modules/app.js



var _mutations;

var app_state = {
  initial: null,
  isLogin: null,
  isLoading: 0,
  isDialogLoading: 0,
  isUploading: undefined,
  routeReset: false,
  modal: {
    action: null,
    param: null,
    callback: null,
    height: null,
    width: null,
    closeButton: true,
    customStyles: {}
  },
  modal2: {
    action: null,
    param: null,
    callback: null,
    height: null,
    width: null,
    closeButton: true,
    customStyles: {}
  },
  toast: null,
  borCor: null,
  unloadAlert: 0,
  scrollState: {
    top: null,
    height: null
  },
  pageDisplayData: {},
  // const
  normalPage: ['main', 'deviceAlert', 'forget', 'reset', 'register', 'active', 'genePanel', 'phenotypeDisease', 'coverageRate', 'datasetAccess', 'datasetDetail'],
  userPage: ['user', 'workgroup', 'panel', 'point', 'config', 'systemInfo', 'caseList', 'caseEdit', 'caseBatchUpload', 'caseDetail', 'datasetList', 'datasetEdit', 'datasetInvitationConfirm', 'genomeBrowser', 'tpehealthAPP'],
  adminPage: []
};

var getters = {
  initial: function initial(state) {
    return state.initial;
  },
  isLogin: function isLogin(state) {
    return state.isLogin;
  },
  isLoading: function isLoading(state) {
    return state.isLoading > 0;
  },
  isDialogLoading: function isDialogLoading(state) {
    return state.isDialogLoading > 0;
  },
  isUploading: function isUploading(state) {
    return state.isUploading;
  },
  routeReset: function routeReset(state) {
    return state.routeReset;
  },
  modal: function modal(state) {
    return state.modal;
  },
  modal2: function modal2(state) {
    return state.modal2;
  },
  toast: function toast(state) {
    return state.toast;
  },
  borCor: function borCor(state) {
    return state.borCor;
  },
  unloadAlert: function unloadAlert(state) {
    return state.unloadAlert;
  },
  scrollState: function scrollState(state) {
    return state.scrollState;
  },
  pageDisplayData: function pageDisplayData(state) {
    return state.pageDisplayData;
  },
  // const
  normalPage: function normalPage(state) {
    return state.normalPage;
  },
  userPage: function userPage(state) {
    return state.userPage;
  },
  adminPage: function adminPage(state) {
    return state.adminPage;
  }
};

var app_types = {
  appInitial: 'app/appInitial',
  setLogin: 'app/setLogin',
  setLoading: 'app/setLoading',
  clearLoading: 'app/clearLoading',
  setDialogLoading: 'app/setDialogLoading',
  clearDialogLoading: 'app/clearDialogLoading',
  setUploading: 'app/setUploading',
  setRouteReset: 'app/setRouteReset',
  setModal: 'app/setModal',
  setModal2: 'app/setModal2',
  addToast: 'app/addToast',
  deleteToast: 'app/deleteToast',
  setUnloadAlert: 'app/setUnloadAlert',
  setScrollState: 'app/setScrollState',
  setPageDisplayData: 'app/setPageDisplayData'
};

var mutations = (_mutations = {}, defineProperty_default()(_mutations, app_types.appInitial, function (state, boolean) {
  state.initial = boolean;
}), defineProperty_default()(_mutations, app_types.setLogin, function (state, boolean) {
  state.isLogin = boolean;
}), defineProperty_default()(_mutations, app_types.setLoading, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.isLoading += 1;
    } else {
      state.isLoading -= 1;
    }
  }
}), defineProperty_default()(_mutations, app_types.clearLoading, function (state) {
  state.isLoading = 0;
}), defineProperty_default()(_mutations, app_types.setDialogLoading, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.isDialogLoading += 1;
    } else {
      state.isDialogLoading -= 1;
    }
  }
}), defineProperty_default()(_mutations, app_types.clearDialogLoading, function (state) {
  state.isDialogLoading = 0;
}), defineProperty_default()(_mutations, app_types.setUploading, function (state, content) {
  state.isUploading = content;
}), defineProperty_default()(_mutations, app_types.setRouteReset, function (state, boolean) {
  state.routeReset = boolean;
}), defineProperty_default()(_mutations, app_types.setModal, function (state, object) {
  state.modal = object;
}), defineProperty_default()(_mutations, app_types.setModal2, function (state, object) {
  state.modal2 = object;
}), defineProperty_default()(_mutations, app_types.addToast, function (state, object) {
  state.toast = extends_default()({}, object);
}), defineProperty_default()(_mutations, app_types.setBorCor, function (state, object) {
  state.borCor = object;
}), defineProperty_default()(_mutations, app_types.setUnloadAlert, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.unloadAlert += 1;
    } else {
      state.unloadAlert -= 1;
    }
  } else {
    state.unloadAlert = 0;
  }
}), defineProperty_default()(_mutations, app_types.setScrollState, function (state, object) {
  state.scrollState = object;
}), defineProperty_default()(_mutations, app_types.setPageDisplayData, function (state, object) {
  state.pageDisplayData = object;
}), _mutations);

var actions = {
  appInitialAction: function appInitialAction(_ref, boolean) {
    var commit = _ref.commit;

    commit(app_types.appInitial, boolean);
  },
  setLoginAction: function setLoginAction(_ref2, boolean) {
    var commit = _ref2.commit;

    commit(app_types.setLogin, boolean);
  },
  setLoadingAction: function setLoadingAction(_ref3, boolean) {
    var commit = _ref3.commit;

    commit(app_types.setLoading, boolean);
  },
  clearLoadingAction: function clearLoadingAction(_ref4) {
    var commit = _ref4.commit;

    commit(app_types.clearLoading);
  },
  setDialogLoadingAction: function setDialogLoadingAction(_ref5, boolean) {
    var commit = _ref5.commit;

    commit(app_types.setDialogLoading, boolean);
  },
  clearDialogLoadingAction: function clearDialogLoadingAction(_ref6) {
    var commit = _ref6.commit;

    commit(app_types.clearDialogLoading);
  },
  setUploadingAction: function setUploadingAction(_ref7, content) {
    var commit = _ref7.commit;

    commit(app_types.setUploading, content);
  },
  setRouteResetAction: function setRouteResetAction(_ref8, boolean) {
    var commit = _ref8.commit;

    commit(app_types.setRouteReset, boolean);
  },
  setModalAction: function setModalAction(_ref9, object) {
    var commit = _ref9.commit;

    commit(app_types.setModal, object);
  },
  setModal2Action: function setModal2Action(_ref10, object) {
    var commit = _ref10.commit;

    commit(app_types.setModal2, object);
  },
  addToastAction: function addToastAction(_ref11, object) {
    var commit = _ref11.commit;

    commit(app_types.addToast, object);
  },
  setBorCorAction: function setBorCorAction(_ref12, object) {
    var commit = _ref12.commit;

    commit(app_types.setBorCor, object);
  },
  setUnloadAlertAction: function setUnloadAlertAction(_ref13, boolean) {
    var commit = _ref13.commit;

    commit(app_types.setUnloadAlert, boolean);
  },
  setScrollStateAction: function setScrollStateAction(_ref14, object) {
    var commit = _ref14.commit;

    commit(app_types.setScrollState, object);
  },
  setPageDisplayDataAction: function setPageDisplayDataAction(_ref15, boolean) {
    var commit = _ref15.commit;

    commit(app_types.setPageDisplayData, boolean);
  }
};

/* harmony default export */ var app = ({
  state: app_state,
  getters: getters,
  mutations: mutations,
  actions: actions
});
// CONCATENATED MODULE: ./src/store/modules/gcs.js


var gcs__mutations;

var gcs_state = {
  isFileUpload: false,
  uploadCount: 0,
  waitUploading: null,
  resumableInfo: null
};

var gcs_getters = {
  isFileUpload: function isFileUpload(state) {
    return state.isFileUpload;
  },
  uploadCount: function uploadCount(state) {
    return state.uploadCount;
  },
  waitUploading: function waitUploading(state) {
    return state.waitUploading;
  },
  resumableInfo: function resumableInfo(state) {
    return state.resumableInfo;
  }
};

var gcs_types = {
  setFileUpload: 'gcs/setFileUpload',
  addUploadCount: 'gcs/addUploadCount',
  setWaitUploading: 'gcs/setWaitUploading',
  setResumableInfo: 'gcs/setResumableInfo'
};

var gcs_mutations = (gcs__mutations = {}, defineProperty_default()(gcs__mutations, gcs_types.setFileUpload, function (state, boolean) {
  state.isFileUpload = boolean;
}), defineProperty_default()(gcs__mutations, gcs_types.addUploadCount, function (state, boolean) {
  state.uploadCount = boolean ? state.uploadCount + 1 : 0;
}), defineProperty_default()(gcs__mutations, gcs_types.setWaitUploading, function (state, data) {
  state.waitUploading = data;
}), defineProperty_default()(gcs__mutations, gcs_types.setResumableInfo, function (state, data) {
  state.resumableInfo = data;
}), gcs__mutations);

var gcs_actions = {
  setFileUploadAction: function setFileUploadAction(_ref, boolean) {
    var commit = _ref.commit;

    commit(gcs_types.setFileUpload, boolean);
  },
  addUploadCountAction: function addUploadCountAction(_ref2, boolean) {
    var commit = _ref2.commit;

    commit(gcs_types.addUploadCount, boolean);
  },
  setWaitUploadingAction: function setWaitUploadingAction(_ref3, data) {
    var commit = _ref3.commit;

    commit(gcs_types.setWaitUploading, data);
  },
  setResumableInfoAction: function setResumableInfoAction(_ref4, data) {
    var commit = _ref4.commit;

    commit(gcs_types.setResumableInfo, data);
  }
};

/* harmony default export */ var gcs = ({
  state: gcs_state,
  getters: gcs_getters,
  mutations: gcs_mutations,
  actions: gcs_actions
});
// CONCATENATED MODULE: ./src/store/modules/global.js


var global__mutations;

var global_state = {
  userSetting: {},
  userAvatar: {},
  userLicense: {}
};

var global_getters = {
  userSetting: function userSetting(state) {
    return state.userSetting;
  },
  userAvatar: function userAvatar(state) {
    return state.userAvatar;
  },
  userLicense: function userLicense(state) {
    return state.userLicense;
  }
};

var global_types = {
  setUserSetting: 'global/userSetting',
  setUserAvatar: 'global/setUserAvatar',
  setUserLicense: 'global/setUserLicense'
};

var global_mutations = (global__mutations = {}, defineProperty_default()(global__mutations, global_types.setUserSetting, function (state, obj) {
  state.userSetting = obj;
}), defineProperty_default()(global__mutations, global_types.setUserAvatar, function (state, obj) {
  state.userAvatar = obj;
}), defineProperty_default()(global__mutations, global_types.setUserLicense, function (state, obj) {
  state.userLicense = obj;
}), global__mutations);

var global_actions = {
  setUserSettingAction: function setUserSettingAction(_ref, obj) {
    var commit = _ref.commit;

    commit(global_types.setUserSetting, obj);
  },
  setUserLicenseAction: function setUserLicenseAction(_ref2, obj) {
    var commit = _ref2.commit;

    commit(global_types.setUserLicense, obj);
  }
};

/* harmony default export */ var global = ({
  state: global_state,
  getters: global_getters,
  mutations: global_mutations,
  actions: global_actions
});
// CONCATENATED MODULE: ./src/store/modules/user.js



var user__mutations;

var user_state = {
  data: null,
  info: null
};

var user_getters = {
  user: function user(state) {
    return state.data ? extends_default()({}, state.data) : state.data;
  },
  userInfo: function userInfo(state) {
    return state.info ? extends_default()({}, state.info) : state.info;
  }
};

var user_types = {
  setUser: 'user/setUser',
  setUserInfo: 'user/setUserInfo'
};

var user_mutations = (user__mutations = {}, defineProperty_default()(user__mutations, user_types.setUser, function (state, object) {
  state.data = object;
}), defineProperty_default()(user__mutations, user_types.setUserInfo, function (state, object) {
  state.info = object;
}), user__mutations);

var user_actions = {
  setUserAction: function setUserAction(_ref, object) {
    var commit = _ref.commit;

    commit(user_types.setUser, object);
  },
  setUserInfoAction: function setUserInfoAction(_ref2, object) {
    var commit = _ref2.commit;

    commit(user_types.setUserInfo, object);
  }
};

/* harmony default export */ var modules_user = ({
  state: user_state,
  getters: user_getters,
  mutations: user_mutations,
  actions: user_actions
});
// CONCATENATED MODULE: ./src/store/index.js








vue_esm["default"].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  modules: {
    app: app,
    gcs: gcs,
    global: global,
    user: modules_user
  }
}));
// EXTERNAL MODULE: ./src/constants/font/font.sass
var font = __webpack_require__("bPG1");
var font_default = /*#__PURE__*/__webpack_require__.n(font);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










vee_validate_esm["a" /* Validator */].extend('youtubeLink', {
  getMessage: function getMessage() {
    return '';
  },
  validate: function validate(value) {
    return (/(?:src="|^)https:\/\/www\.youtube\.com\/embed\/([a-zA-Z0-9]+)(?="|$)/.test(value)
    );
  }
});

__webpack_require__("DBs5");
__webpack_require__("598Q");

vue_esm["default"].config.productionTip = false;

vue_esm["default"].component('item', {
  template: '\n    <li>\n      <div class="mask"></div>\n      <div class="line-container">\n        <div class="line"></div>\n      </div>\n      <div class="item-container row-block" :class="{ open: tree.type === \'folder\' && open && !disabled, selected: selected && !disabled, disabled: disabled }" @click.stop="e => !disabled && toggle()">\n        <div class="item-icon" v-if="tree.title">\n          <img :src="tree.type === \'folder\' ? open ? icons.open : icons.close : selected ? icons.select : icons.file" alt="">\n        </div>\n        <div :style="{ width: \'5px\' }"></div>\n        <div class="item-title shrink">{{ tree.title }}</div>\n        <div :style="{ flex: 1 }"></div>\n        <img v-if="tree.type === \'file\' && !disabled && options.checkbox !== false" class="item-check" :src="selected ? icons.boxtrue : icons.boxfalse">\n      </div>\n      <ul v-show="open" v-if="Object.keys(tree.nodes || {}).length > 0 && !disabled">\n        <div class="line"></div>\n        <item v-for="(node, title, index) in tree.nodes" :key="index" :tree="{ ...node, title: title }" :options="options" :icons="icons" :currentPath="currentPath" :selectedPaths="selectedPaths" :disabledPaths="disabledPaths" @select="path => $emit(\'select\', path)">\n        </item>\n      </ul>\n    </li>\n  ',
  props: {
    tree: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    icons: {
      type: Object,
      required: true
    },
    currentPath: {
      type: Array,
      required: true
    },
    selectedPaths: {
      type: Array,
      required: true
    },
    disabledPaths: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      open: this.currentPath.includes(this.tree.title) || !this.tree.title
    };
  },

  computed: {
    selected: function selected() {
      return this.selectedPaths.includes(this.tree.path);
    },
    disabled: function disabled() {
      return this.disabledPaths.includes(this.tree.path);
    }
  },
  methods: {
    toggle: function toggle() {
      switch (this.tree.type) {
        case 'folder':
          {
            if (this.tree.title) {
              this.open = !this.open;
            }
            break;
          }
        case 'file':
          {
            if (this.tree.title) {
              this.$emit('select', this.tree.path);
            }
          }
      }
    }
  }
});

vue_esm["default"].component('treeList', {
  template: '\n    <ul id="root" :class="{ \'no-root\': !treeData.title }">\n      <item :tree="treeData" :options="options" :icons="icons" :currentPath="(currentPath || \'\').split(\'/\')" :selectedPaths="selectedPaths" :disabledPaths="disabledPaths" @select="path => $emit(\'select\', path)"></item>\n    </ul>\n  ',
  props: {
    treeData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    icons: {
      type: Object,
      required: true
    },
    currentPath: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    selectedPaths: {
      type: Array,
      required: true
    },
    disabledPaths: {
      type: Array,
      required: true
    }
  }
});

vue_esm["default"].component('familyPedigree', {
  template: '\n    <div\n      class="family-pedigree-main-field col-block stretch"\n      :style="{\n        width: pedigreeDatas.nodeLength ? (pedigreeDatas.nodeLength * 170 - 20 + \'px\') : \'auto\',\n        gap: \'20px\'\n      }"\n    >\n      <div\n        v-if="hasParent"\n        class="family-pedigree-parent-container row-block stretch"\n        :class="{ hidden: hiddenParent }"\n        :style="{ gap: \'20px\' }"\n      >\n        <familyPedigree\n          :pedigreeDatas="pedigreeDatas.fathers"\n          :depth="depth + 1"\n          :position="\'left\'"\n        ></familyPedigree>\n        <familyPedigree\n          :pedigreeDatas="pedigreeDatas.mothers"\n          :depth="depth + 1"\n          :position="\'right\'"\n        ></familyPedigree>\n      </div>\n      <div class="family-pedigree-main-container row-block stretch">\n        <div class="family-pedigree-parent-line-container col-block" :style="{ flex: position === \'right\' ? 0 : 1, width: 0, height: \'calc(100% + 20px - 2.9px)\' }">\n          <div\n            v-if="position === \'right\'"\n            class="family-pedigree-parent-line-block main-line-container"\n            :style="{\n              flex: 1,\n              width: \'calc(100% + 10px + 50px)\',\n              marginRight: \'-50px\',\n              marginLeft: \'-10px\'\n            }"\n          >\n            <svg width="100%" height="100%">\n              <line\n                x1="0%"\n                y1="40px"\n                x2="100%"\n                y2="40px"\n              />\n              <line\n                x1="0%"\n                y1="40px"\n                x2="0%"\n                y2="100%"\n              />\n            </svg>\n          </div>\n        </div>\n        <div class="family-pedigree-main-block col-block stretch">\n          <div\n            class="family-pedigree-sibling-line-container main-line-container"\n            :style="{\n              height: \'20px\'\n            }"\n          >\n            <svg width="100%" height="20">\n              <line\n                x1="75px"\n                y1="0"\n                x2="50%"\n                y2="0"\n              />\n            </svg>\n            <svg width="100%" height="20" :style="{ transform: \'rotate(180deg)\' }">\n              <line\n                x1="75px"\n                y1="100%"\n                x2="50%"\n                y2="100%"\n              />\n            </svg>\n          </div>\n          <div\n            class="family-pedigree-sibling-node-list-container row-block flex-start"\n            :style="{\n              gap: \'20px\'\n            }"\n          >\n            <div\n              class="family-pedigree-sibling-node-container col-block stretch"\n              v-for="(node, index) in pedigreeDatas.nodes"\n              :key="index"\n              :class="{ empty: !node.title, affected: node.affected, proband: node.relation === \'Proband\' }"\n              :style="{\n                width: \'150px\'\n              }"\n            >\n              <div\n                class="family-pedigree-sibling-node-line-container main-line-container"\n                :style="{\n                  height: \'20px\'\n                }"\n              >\n                <svg v-if="(hasParent && !hiddenParent) || (nodeLength > 1)" width="100%" height="20">\n                  <line\n                    class="cover"\n                    x1="50%"\n                    y1="0%"\n                    x2="50%"\n                    y2="100%"\n                  />\n                </svg>\n              </div>\n              <div class="family-pedigree-sibling-node-main-container row-block">\n                <div class="family-pedigree-sibling-node-main-sub-container col-block" :style="{ flex: 1 }">\n                  <div :style="{ flex: 1 }"></div>\n                  <div class="family-pedigree-sibling-node-main-proband-container row-block">\n                    <div :style="{ flex: 1 }"></div>\n                    <div class="family-pedigree-sibling-node-main-proband-icon"></div>\n                    <div :style="{ width: \'10px\' }"></div>\n                  </div>\n                  <div :style="{ flex: 1 }"></div>\n                </div>\n                <div class="family-pedigree-sibling-node-main-block">\n                  <svg width="50" height="50">\n                    <component\n                      :is="{ \'Male\': \'rect\', \'Female\': \'circle\' }[node.sex] || \'rect\'"\n                      x="1"\n                      y="1"\n                      width="47"\n                      height="47"\n                      cx="25"\n                      cy="25"\n                      r="23"\n                      :style="{ \'stroke-width\': [\'Male\', \'Female\'].includes(node.sex) ? \'3px\' : \'4px\' }"\n                      :transform="![\'Male\', \'Female\'].includes(node.sex) ? \'translate(25, 0) scale(0.72) rotate(45)\' : null"\n                    />\n                  </svg>\n                </div>\n                <div class="family-pedigree-sibling-node-main-sub-container col-block" :style="{ flex: 1 }"></div>\n              </div>\n              <div :style="{ height: \'5px\' }"></div>\n              <div class="family-pedigree-sibling-node-text-container col-block width-full">\n                <div class="family-pedigree-sibling-node-title-container ellipsis" :title="node.title" v-html="node.title || \'N/A\'"></div>\n                <div class="family-pedigree-sibling-node-ra-container ellipsis" :class="{ empty: !node.RefAlt }" :title="node.RefAlt" v-html="node.RefAlt || \'-\'"></div>\n                <div class="family-pedigree-sibling-node-gt-container ellipsis" :class="{ empty: !node.GT }" :title="node.GT" v-html="node.GT || \'-\'"></div>\n                <div class="family-pedigree-sibling-node-qc-list-container row-block flex-wrap" :class="{ empty: !(node.QC || []).length }">\n                  <div class="family-pedigree-sibling-node-qc-container" v-for="(qc, qcIndex) in (node.QC || [])" :key="qcIndex" :title="qc" v-html="qc || \'-\'"></div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div :style="{ flex: 1 }"></div>\n        </div>\n        <div class="family-pedigree-parent-line-container col-block" :style="{ flex: position === \'left\' ? 0 : 1, width: 0, height: \'calc(100% + 20px - 2.9px)\' }">\n          <div\n            v-if="position === \'left\'"\n            class="family-pedigree-parent-line-block main-line-container"\n            :style="{\n              flex: 1,\n              width: \'calc(100% + 10px + 50px)\',\n              marginLeft: \'-50px\',\n              marginRight: \'-10px\'\n            }"\n          >\n            <svg width="100%" height="100%">\n              <line\n                x1="0%"\n                y1="40px"\n                x2="100%"\n                y2="40px"\n              />\n              <line\n                x1="100%"\n                y1="40px"\n                x2="100%"\n                y2="100%"\n              />\n            </svg>\n          </div>\n        </div>\n      </div>\n    </div>\n  ',
  props: {
    pedigreeDatas: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    position: {
      type: String,
      default: function _default() {
        return 'center';
      }
    }
  },
  computed: {
    hasParent: function hasParent() {
      return this.pedigreeDatas.hasParent;
    },
    hiddenParent: function hiddenParent() {
      return this.pedigreeDatas.hiddenParent;
    },
    nodeLength: function nodeLength() {
      return (this.pedigreeDatas.nodes || []).length;
    }
  }
});

vue_esm["default"].use(actioncablevue_default.a, {
  connectImmediately: false
});

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  router: router,
  store: store,
  i18n: i18n["a" /* default */],
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "NMi8":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE2IDE0Ij4KICA8cGF0aCBpZD0idGFibGUtbGlnaHQiIGQ9Ik0xNC41LDMySDEuNUExLjUsMS41LDAsMCwwLDAsMzMuNXYxMUExLjUsMS41LDAsMCwwLDEuNSw0NmgxM0ExLjUsMS41LDAsMCwwLDE2LDQ0LjV2LTExQTEuNSwxLjUsMCwwLDAsMTQuNSwzMlpNNSw0NUgxLjVhLjUuNSwwLDAsMS0uNS0uNVY0Mkg1Wm0wLTRIMVYzOEg1Wm0wLTRIMVYzNEg1Wm01LDhINlY0Mmg0Wm0wLTRINlYzOGg0Wm0wLTRINlYzNGg0Wm01LDV2Mi41YS41LjUsMCwwLDEtLjUuNUgxMVY0MlptMC0xSDExVjM4aDRabTAtNEgxMVYzNGg0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMzIpIiBmaWxsPSIjOTk5Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "O+D1":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0i44Kw44Or44O844OXXzMxNDIiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDMxNDIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiPgogIDxwYXRoIGlkPSJjaGVjay1zcXVhcmUtc29saWQiIGQ9Ik0xNy44NTcsNTJIMi4xNDNBMi4xNDMsMi4xNDMsMCwwLDEsMCw0OS44NTdWMzQuMTQzQTIuMTQzLDIuMTQzLDAsMCwxLDIuMTQzLDMySDE3Ljg1N0EyLjE0MywyLjE0MywwLDAsMSwyMCwzNC4xNDNWNDkuODU3QTIuMTQzLDIuMTQzLDAsMCwxLDE3Ljg1Nyw1MlpNOC43MTksNDcuNjIybDguMjE0LTguMjE0YS43MTQuNzE0LDAsMCwwLDAtMS4wMWwtMS4wMS0xLjAxYS43MTQuNzE0LDAsMCwwLTEuMDEsMGwtNi43LDYuN0w1LjA4Nyw0MC45NTlhLjcxNC43MTQsMCwwLDAtMS4wMSwwbC0xLjAxLDEuMDFhLjcxNC43MTQsMCwwLDAsMCwxLjAxbDQuNjQzLDQuNjQzQS43MTQuNzE0LDAsMCwwLDguNzE5LDQ3LjYyMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTMyKSIgZmlsbD0ibm9uZSIvPgogIDxnIGlkPSLjgrDjg6vjg7zjg5dfMzMwMyIgZGF0YS1uYW1lPSLjgrDjg6vjg7zjg5cgMzMwMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE5NzIgLTE1MzMpIj4KICAgIDxnIGlkPSLjg5HjgrlfNDY5IiBkYXRhLW5hbWU9IuODkeOCuSA0NjkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5NzIgMTUzMykiIGZpbGw9IiNmZmYiPgogICAgICA8cGF0aCBkPSJNIDE3IDE5LjUgTCAzIDE5LjUgQyAxLjYyMTUwMDAxNTI1ODc4OSAxOS41IDAuNSAxOC4zNzg0OTk5ODQ3NDEyMSAwLjUgMTcgTCAwLjUgMyBDIDAuNSAxLjYyMTUwMDAxNTI1ODc4OSAxLjYyMTUwMDAxNTI1ODc4OSAwLjUgMyAwLjUgTCAxNyAwLjUgQyAxOC4zNzg0OTk5ODQ3NDEyMSAwLjUgMTkuNSAxLjYyMTUwMDAxNTI1ODc4OSAxOS41IDMgTCAxOS41IDE3IEMgMTkuNSAxOC4zNzg0OTk5ODQ3NDEyMSAxOC4zNzg0OTk5ODQ3NDEyMSAxOS41IDE3IDE5LjUgWiIgc3Ryb2tlPSJub25lIi8+CiAgICAgIDxwYXRoIGQ9Ik0gMyAxIEMgMS44OTcxOTk2MzA3MzczMDUgMSAxIDEuODk3MTk5NjMwNzM3MzA1IDEgMyBMIDEgMTcgQyAxIDE4LjEwMjgwMDM2OTI2MjcgMS44OTcxOTk2MzA3MzczMDUgMTkgMyAxOSBMIDE3IDE5IEMgMTguMTAyODAwMzY5MjYyNyAxOSAxOSAxOC4xMDI4MDAzNjkyNjI3IDE5IDE3IEwgMTkgMyBDIDE5IDEuODk3MTk5NjMwNzM3MzA1IDE4LjEwMjgwMDM2OTI2MjcgMSAxNyAxIEwgMyAxIE0gMyAwIEwgMTcgMCBDIDE4LjY1Njg1MDgxNDgxOTM0IDAgMjAgMS4zNDMxNDkxODUxODA2NjQgMjAgMyBMIDIwIDE3IEMgMjAgMTguNjU2ODUwODE0ODE5MzQgMTguNjU2ODUwODE0ODE5MzQgMjAgMTcgMjAgTCAzIDIwIEMgMS4zNDMxNDkxODUxODA2NjQgMjAgMCAxOC42NTY4NTA4MTQ4MTkzNCAwIDE3IEwgMCAzIEMgMCAxLjM0MzE0OTE4NTE4MDY2NCAxLjM0MzE0OTE4NTE4MDY2NCAwIDMgMCBaIiBzdHJva2U9Im5vbmUiIGZpbGw9IiMzMzMiLz4KICAgIDwvZz4KICAgIDxwYXRoIGlkPSJ0aW1lcy1zcXVhcmUtcmVndWxhciIgZD0iTTE0LjU0NSwzOS4yMjMsMTEuNzY4LDQybDIuNzc3LDIuNzc3YS41MzYuNTM2LDAsMCwxLDAsLjc1OWwtMS4wMDksMS4wMDlhLjUzNi41MzYsMCwwLDEtLjc1OSwwTDEwLDQzLjc2OCw3LjIyMyw0Ni41NDVhLjUzNi41MzYsMCwwLDEtLjc1OSwwTDUuNDU1LDQ1LjUzNmEuNTM2LjUzNiwwLDAsMSwwLS43NTlMOC4yMzIsNDIsNS40NTUsMzkuMjIzYS41MzYuNTM2LDAsMCwxLDAtLjc1OWwxLjAwOS0xLjAwOWEuNTM2LjUzNiwwLDAsMSwuNzU5LDBMMTAsNDAuMjMybDIuNzc3LTIuNzc3YS41MzYuNTM2LDAsMCwxLC43NTksMGwxLjAwOSwxLjAwOWEuNTM2LjUzNiwwLDAsMSwwLC43NTlaTTIwLDM0LjE0M1Y0OS44NTdBMi4xNDMsMi4xNDMsMCwwLDEsMTcuODU3LDUySDIuMTQzQTIuMTQzLDIuMTQzLDAsMCwxLDAsNDkuODU3VjM0LjE0M0EyLjE0MywyLjE0MywwLDAsMSwyLjE0MywzMkgxNy44NTdBMi4xNDMsMi4xNDMsMCwwLDEsMjAsMzQuMTQzWk0xNy44NTcsNDkuNTg5VjM0LjQxMWEuMjY5LjI2OSwwLDAsMC0uMjY4LS4yNjhIMi40MTFhLjI2OS4yNjksMCwwLDAtLjI2OC4yNjhWNDkuNTg5YS4yNjkuMjY5LDAsMCwwLC4yNjguMjY4SDE3LjU4OUEuMjY5LjI2OSwwLDAsMCwxNy44NTcsNDkuNTg5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3MiAxNTAxKSIgZmlsbD0iI2NjYyIvPgogICAgPGcgaWQ9IumVt+aWueW9ol8xNDgiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDE0OCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3MiAxNTMzKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMzMzIiBzdHJva2Utd2lkdGg9IjEiPgogICAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIzIiBzdHJva2U9Im5vbmUiLz4KICAgICAgPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSIgcng9IjIuNSIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "OCMH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzEyMTUiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDEyMTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNTQ2NyAzMjcwKSI+CiAgICA8cmVjdCBpZD0i6ZW35pa55b2iXzEyMzgiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDEyMzgiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTU0NjcgLTMyNzApIiBmaWxsPSIjZmZmIiBvcGFjaXR5PSIwIi8+CiAgICA8cGF0aCBpZD0iZmlsZS1hbHQtbGlnaHQiIGQ9Ik0xMS41NTcsMi45NjIsOC45MzYuMzQxQTEuNSwxLjUsMCwwLDAsNy44NzctLjFIMS41QTEuNSwxLjUsMCwwLDAsMCwxLjR2MTNhMS41LDEuNSwwLDAsMCwxLjUsMS41aDlBMS41LDEuNSwwLDAsMCwxMiwxNC40VjQuMDI0YTEuNTA3LDEuNTA3LDAsMCwwLS40NDEtMS4wNjJabS0uNzA2LjcwOWEuNDkyLjQ5MiwwLDAsMSwuMTMxLjIzMUg4Vi45MTlhLjQ5Mi40OTIsMCwwLDEsLjIzMS4xMzFaTTEwLjUsMTQuOWgtOWEuNS41LDAsMCwxLS41LS41VjEuNEEuNS41LDAsMCwxLDEuNS45SDdWNC4xNTJhLjc0OC43NDgsMCwwLDAsLjc1Ljc1SDExdjkuNUEuNS41LDAsMCwxLDEwLjUsMTQuOVpNOSw3LjI3N3YuMjVhLjM3Ni4zNzYsMCwwLDEtLjM3NS4zNzVIMy4zNzRBLjM3Ni4zNzYsMCwwLDEsMyw3LjUyN3YtLjI1QS4zNzYuMzc2LDAsMCwxLDMuMzc0LDYuOUg4LjYyM0EuMzc2LjM3NiwwLDAsMSw5LDcuMjc3Wm0wLDJ2LjI1YS4zNzYuMzc2LDAsMCwxLS4zNzUuMzc1SDMuMzc0QS4zNzYuMzc2LDAsMCwxLDMsOS41MjZ2LS4yNUEuMzc2LjM3NiwwLDAsMSwzLjM3NCw4LjlIOC42MjNBLjM3Ni4zNzYsMCwwLDEsOSw5LjI3NlptMCwydi4yNWEuMzc2LjM3NiwwLDAsMS0uMzc1LjM3NUgzLjM3NEEuMzc2LjM3NiwwLDAsMSwzLDExLjUyNnYtLjI1YS4zNzYuMzc2LDAsMCwxLC4zNzUtLjM3NUg4LjYyM0EuMzc2LjM3NiwwLDAsMSw5LDExLjI3NloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1NDcxIC0zMjY3LjkpIiBmaWxsPSIjZmZmIiBzdHJva2U9IiNmN2Y3ZjciIHN0cm9rZS13aWR0aD0iMC4yNSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "OlcD":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE2IDE0Ij4KICA8cGF0aCBpZD0idGFibGUtbGlnaHQiIGQ9Ik0xNC41LDMySDEuNUExLjUsMS41LDAsMCwwLDAsMzMuNXYxMUExLjUsMS41LDAsMCwwLDEuNSw0NmgxM0ExLjUsMS41LDAsMCwwLDE2LDQ0LjV2LTExQTEuNSwxLjUsMCwwLDAsMTQuNSwzMlpNNSw0NUgxLjVhLjUuNSwwLDAsMS0uNS0uNVY0Mkg1Wm0wLTRIMVYzOEg1Wm0wLTRIMVYzNEg1Wm01LDhINlY0Mmg0Wm0wLTRINlYzOGg0Wm0wLTRINlYzNGg0Wm01LDV2Mi41YS41LjUsMCwwLDEtLjUuNUgxMVY0MlptMC0xSDExVjM4aDRabTAtNEgxMVYzNGg0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMzIpIiBmaWxsPSIjOTk5Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "OoZE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P6mg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/loginData.vue




/* harmony default export */ var loginData = ({
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUserAction', 'setLoginAction', 'setUserInfoAction']), {
    setUserData: function setUserData(response, token) {
      this.setUserAction(response ? response.data.user || response.data.data : null);
      this.setLoginAction(!!response);
      this.setUserInfo(token || (response ? response.data.auth : null));
    },
    setUserInfo: function setUserInfo(token) {
      if (token) {
        // let expiry = new Date(token.expired_at) - new Date()
        var info = {
          access_token: token.access_token
        };
        this.setUserInfoAction(info);
        this.$ls.set('userInfo', info);
      } else {
        this.setUserInfoAction(null);
        this.$ls.remove('userInfo');
      }
    }
  })
});
// CONCATENATED MODULE: ./src/mixins/loginData.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  loginData,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_loginData = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PQd3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pbv1":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgdmlld0JveD0iMCAwIDYwIDYwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzcwNzgiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDcwNzgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNjApIHJvdGF0ZSgtOTApIj4KICAgIDxyZWN0IGlkPSLplbfmlrnlvaJfMjkxNCIgZGF0YS1uYW1lPSLplbfmlrnlvaIgMjkxNCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIiBmaWxsPSIjZmZmIiBvcGFjaXR5PSIwIi8+CiAgICA8cGF0aCBpZD0iY2hldnJvbi1kb3duLXJlZ3VsYXIiIGQ9Ik0zMS43NDUsMS40NzQsMzAuMzE1LjIyM2EuOTU4Ljk1OCwwLDAsMC0xLjIyOCwwTDE2LDExLjYzOSwyLjkxNC4yMjNhLjk1OC45NTgsMCwwLDAtMS4yMjgsMEwuMjU1LDEuNDc0YS42OTMuNjkzLDAsMCwwLDAsMS4wNzRsMTUuMTMxLDEzLjIzYS45NTguOTU4LDAsMCwwLDEuMjI4LDBMMzEuNzQ1LDIuNTQ4QS42OTMuNjkzLDAsMCwwLDMxLjc0NSwxLjQ3NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ2IDM4KSByb3RhdGUoMTgwKSIgZmlsbD0iIzAwMzY3OSIgc3Ryb2tlPSIjMDUzNjc5IiBzdHJva2Utd2lkdGg9IjAuNSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "Q05p":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDE4IDI0Ij4KICA8cGF0aCBpZD0iZG5hLXNoYXJwLWxpZ2h0IiBkPSJNNTAsMFYuNzVjMCw1LjYzNC00LjQxNiw4Ljg0MS04LjQyMywxMS43NjFsLS4xMzEuMWE0MC4zNjksNDAuMzY5LDAsMCwwLTQuODIzLDMuOWg4Ljc2NmEyOS45MjIsMjkuOTIyLDAsMCwwLTMuMTY0LTIuNjcyYy4xNS0uMTA4LjMtLjIxNi40NTUtLjMyMy4yNzctLjIuNTQ4LS4zOTQuODI1LS42LDMuMzc1LDIuNTczLDYuNSw1LjYsNi41LDEwLjMzNlYyNEg0OC41di0uNzVjMC0uMjU4LS4wMDktLjUwNi0uMDMzLS43NUgzMy41MzNjLS4wMTkuMjQ0LS4wMzMuNDkyLS4wMzMuNzVWMjRIMzJ2LS43NWMwLTUuMzA2LDMuOTE5LTguNDYxLDcuNzI1LTExLjI1QzM1LjkxOSw5LjIxMSwzMiw2LjA1NiwzMiwuNzVWMGgxLjVWLjc1YzAsLjI1OC4wMDkuNTA2LjAzMy43NUg0OC40NjdjLjAxOS0uMjQ0LjAzMy0uNDkyLjAzMy0uNzVWMFpNNDguMiwzSDMzLjhhOSw5LDAsMCwwLDEuNTA5LDNINDYuN0E5LDksMCwwLDAsNDguMiwzWk00NS4zODMsNy41SDM2LjYxN0EzNi44NzQsMzYuODc0LDAsMCwwLDQxLDExLjA3MiwzNi44NzQsMzYuODc0LDAsMCwwLDQ1LjM4Myw3LjVaTTMzLjgsMjFINDguMmE5LjAyNCw5LjAyNCwwLDAsMC0xLjUwOS0zYy0uMDIzLDAtLjA0MiwwLS4wNjYsMEgzNS4zNzVhLjMwOS4zMDksMCwwLDEtLjA2NiwwQTguOTM2LDguOTM2LDAsMCwwLDMzLjgsMjFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzIpIiBmaWxsPSIjOTk5Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "Qd2E":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "RBQ8":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0i44Kw44Or44O844OXXzMxNDIiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDMxNDIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiPgogIDxnIGlkPSLplbfmlrnlvaJfMTQ4IiBkYXRhLW5hbWU9IumVt+aWueW9oiAxNDgiIGZpbGw9IiNmZmYiIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLXdpZHRoPSIxIj4KICAgIDxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcng9IjMiIHN0cm9rZT0ibm9uZSIvPgogICAgPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSIgcng9IjIuNSIgZmlsbD0ibm9uZSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "RCqP":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi41IiBoZWlnaHQ9IjE2LjUiIHZpZXdCb3g9IjAgMCAxNi41IDE2LjUiPgogIDxwYXRoIGlkPSJpbmZvLWNpcmNsZS1saWdodCIgZD0iTTE2LDkuMDMyQTYuOTY4LDYuOTY4LDAsMSwxLDkuMDMyLDE2LDYuOTY5LDYuOTY5LDAsMCwxLDE2LDkuMDMyTTE2LDhhOCw4LDAsMSwwLDgsOEE4LDgsMCwwLDAsMTYsOFpNMTQuODM5LDE5LjFoLjM4N1YxNS4yMjZoLS4zODdhLjM4Ny4zODcsMCwwLDEtLjM4Ny0uMzg3di0uMjU4YS4zODcuMzg3LDAsMCwxLC4zODctLjM4N2gxLjU0OGEuMzg3LjM4NywwLDAsMSwuMzg3LjM4N1YxOS4xaC4zODdhLjM4Ny4zODcsMCwwLDEsLjM4Ny4zODd2LjI1OGEuMzg3LjM4NywwLDAsMS0uMzg3LjM4N0gxNC44MzlhLjM4Ny4zODcsMCwwLDEtLjM4Ny0uMzg3di0uMjU4QS4zODcuMzg3LDAsMCwxLDE0LjgzOSwxOS4xWk0xNiwxMS4zNTVhMS4wMzIsMS4wMzIsMCwxLDAsMS4wMzIsMS4wMzJBMS4wMzIsMS4wMzIsMCwwLDAsMTYsMTEuMzU1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcuNzUgLTcuNzUpIiBmaWxsPSIjZmEzZDNkIiBzdHJva2U9IiNmYTNkM2QiIHN0cm9rZS13aWR0aD0iMC41Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "RRJv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rp0L":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi41IiBoZWlnaHQ9IjE2LjUiIHZpZXdCb3g9IjAgMCAxNi41IDE2LjUiPgogIDxwYXRoIGlkPSJpbmZvLWNpcmNsZS1saWdodCIgZD0iTTE2LDkuMDMyQTYuOTY4LDYuOTY4LDAsMSwxLDkuMDMyLDE2LDYuOTY5LDYuOTY5LDAsMCwxLDE2LDkuMDMyTTE2LDhhOCw4LDAsMSwwLDgsOEE4LDgsMCwwLDAsMTYsOFpNMTQuODM5LDE5LjFoLjM4N1YxNS4yMjZoLS4zODdhLjM4Ny4zODcsMCwwLDEtLjM4Ny0uMzg3di0uMjU4YS4zODcuMzg3LDAsMCwxLC4zODctLjM4N2gxLjU0OGEuMzg3LjM4NywwLDAsMSwuMzg3LjM4N1YxOS4xaC4zODdhLjM4Ny4zODcsMCwwLDEsLjM4Ny4zODd2LjI1OGEuMzg3LjM4NywwLDAsMS0uMzg3LjM4N0gxNC44MzlhLjM4Ny4zODcsMCwwLDEtLjM4Ny0uMzg3di0uMjU4QS4zODcuMzg3LDAsMCwxLDE0LjgzOSwxOS4xWk0xNiwxMS4zNTVhMS4wMzIsMS4wMzIsMCwxLDAsMS4wMzIsMS4wMzJBMS4wMzIsMS4wMzIsMCwwLDAsMTYsMTEuMzU1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcuNzUgLTcuNzUpIiBmaWxsPSIjMDAzNjc5IiBzdHJva2U9IiMwMDM2NzkiIHN0cm9rZS13aWR0aD0iMC41Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "RzRW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTcuODU3LDUySDIuMTQzQTIuMTQzLDIuMTQzLDAsMCwxLDAsNDkuODU3VjM0LjE0M0EyLjE0MywyLjE0MywwLDAsMSwyLjE0MywzMkgxNy44NTdBMi4xNDMsMi4xNDMsMCwwLDEsMjAsMzQuMTQzVjQ5Ljg1N0EyLjE0MywyLjE0MywwLDAsMSwxNy44NTcsNTJaTTguNzE5LDQ3LjYyMmw4LjIxNC04LjIxNGEuNzE0LjcxNCwwLDAsMCwwLTEuMDFsLTEuMDEtMS4wMWEuNzE0LjcxNCwwLDAsMC0xLjAxLDBsLTYuNyw2LjdMNS4wODcsNDAuOTU5YS43MTQuNzE0LDAsMCwwLTEuMDEsMGwtMS4wMSwxLjAxYS43MTQuNzE0LDAsMCwwLDAsMS4wMWw0LjY0Myw0LjY0M0EuNzE0LjcxNCwwLDAsMCw4LjcxOSw0Ny42MjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMikiIGZpbGw9IiMzNDljY2YiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "SQy7":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "SRag":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICA8ZyBpZD0iQ2FyZGlvbG9neSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEzMzUgNDM4KSI+CiAgICA8ZyBpZD0i6ZW35pa55b2iXzI5MjMiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDI5MjMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMzUgLTQzOCkiIGZpbGw9IiNmZmYiIHN0cm9rZT0iIzcwNzA3MCIgc3Ryb2tlLXdpZHRoPSIxIiBvcGFjaXR5PSIwIj4KICAgICAgPHJlY3Qgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIiBzdHJva2U9Im5vbmUiLz4KICAgICAgPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIyOSIgaGVpZ2h0PSIyOSIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogICAgPHBhdGggaWQ9IkNhcmRpb2xvZ3ktMiIgZGF0YS1uYW1lPSJDYXJkaW9sb2d5IiBkPSJNMjUuNjIsMTIuMzg2QTguNDUsOC40NSwwLDAsMCwxNSwxNC40MSw4LjQ4Myw4LjQ4MywwLDAsMCwuNDE5LDIyLjQ3NGE3LjgzNSw3LjgzNSwwLDAsMCwuNTY4LDEuNjA5SDYuNDZsMS4zNzMtMi4zMTFhMS4xMzMsMS4xMzMsMCwwLDEsMS45MjgtLjAzNmwxLjk4MiwzLjA3LDIuNDM3LTYuNjE3YTEuMTM2LDEuMTM2LDAsMCwxLDEuMDYzLS43NDZoMGExLjEzNywxLjEzNywwLDAsMSwxLjA2NS43NDRsMi4xODQsNS45aDMuNzU2YTEuMTQxLDEuMTQxLDAsMCwxLDAsMi4yODJIMTcuNzA3YTEuMTQyLDEuMTQyLDAsMCwxLTEuMDY2LS43NDJsLTEuMzkxLTMuNzU2LTIuMTU5LDUuODY3YTEuMTM4LDEuMTM4LDAsMCwxLS45MzkuNzM4LDEuMjA2LDEuMjA2LDAsMCwxLS4xMjQuMDA3LDEuMTQxLDEuMTQxLDAsMCwxLS45NTQtLjUxOUw4Ljg1MiwyNC41MTZsLS43NywxLjI5NGExLjE0LDEuMTQsMCwwLDEtLjk3Ni41NTdIMi4zNjlDNi40MjUsMzEuOTExLDE1LDM3LjMyOSwxNSwzNy4zMjlzMTMuMTI1LTguMjg3LDE0LjU3OS0xNC44NTVBOC41Myw4LjUzLDAsMCwwLDI1LjYyLDEyLjM4NloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMzUgLTQ0Ni4zMjkpIiBmaWxsPSIjZmZmIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "SkAt":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "T0+N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T452":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WS_ROOT; });
// export const API_ROOT = 'https://api-edge-dev.inherinext.compassbioinfo.jp/'
var API_ROOT = 'https://server-edge.inherinext.jp/';

// export const WS_ROOT = 'wss://api-edge-dev.inherinext.compassbioinfo.jp/cable'
var WS_ROOT = 'wss://server-edge.inherinext.jp/cable';

/***/ }),

/***/ "TqmH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/customGrab.vue




/* harmony default export */ var customGrab = ({
  data: function data() {
    return {
      lineData: {
        x: {
          min: null,
          max: null,
          main: null,
          custom: null
        },
        y: {
          min: null,
          max: null,
          main: null,
          custom: null
        }
      }
    };
  },
  created: function created() {
    var _this = this;

    keys_default()(this.boardData).forEach(function (id) {
      _this.boardInit(id);
    });
  },

  methods: {
    boardInit: function boardInit(id) {
      var boardData = {
        grabID: -1,
        grabType: '',
        grabTarget: null,
        baseX: 0,
        grabX: 0,
        baseY: 0,
        grabY: 0
      };
      this.boardData[id] = extends_default()({}, this.boardData[id], boardData);
    },
    boardEvent: function boardEvent(id, e, functions) {
      // rect
      var targetData = e.target.getBoundingClientRect();
      var containerData = e.currentTarget.getBoundingClientRect();
      // line
      var lx = targetData.x - containerData.x + targetData.width / 2;
      var ly = targetData.y - containerData.y + targetData.height / 2;
      // grab
      var grabID = e.target.getAttribute('grab-id');
      grabID = grabID || grabID === 0 ? grabID - 0 : -1;
      var grabType = (e.target.getAttribute('grab-type') || '').split('*');
      var grabXMin = (e.target.getAttribute('grab-x-min') || '').split('*');
      grabXMin = grabXMin.length && grabXMin[0] ? {
        value: lx - Math.max(Math.min(lx, grabXMin[0] - 0), 0),
        display: grabXMin.length <= 1
      } : {
        value: lx - (0 + targetData.width / 2),
        display: false
      };
      var grabXMax = (e.target.getAttribute('grab-x-max') || '').split('*');
      grabXMax = grabXMax.length && grabXMax[0] ? {
        value: Math.min(Math.max(lx, grabXMax[0] - 0), containerData.width) - lx,
        display: grabXMax.length <= 1
      } : {
        value: containerData.width - targetData.width / 2 - lx,
        display: false
      };
      var grabXCustom = (e.target.getAttribute('grab-x-custom') || '').split('*');
      grabXCustom = grabXCustom.length && grabXCustom[0] ? {
        value: Math.min(Math.max(0, grabXCustom[0] - 0), containerData.width),
        display: grabXCustom.length <= 1
      } : {
        value: containerData.width - targetData.width / 2 - lx,
        display: false
      };
      var grabYMin = (e.target.getAttribute('grab-y-min') || '').split('*');
      grabYMin = grabYMin.length && grabYMin[0] ? {
        value: ly - Math.max(Math.min(ly, grabYMin[0] - 0), 0),
        display: grabYMin.length <= 1
      } : {
        value: ly - (0 + targetData.height / 2),
        display: false
      };
      var grabYMax = (e.target.getAttribute('grab-y-max') || '').split('*');
      grabYMax = grabYMax.length && grabYMax[0] ? {
        value: Math.min(Math.max(ly, grabYMax[0] - 0), containerData.width) - ly,
        display: grabYMax.length <= 1
      } : {
        value: containerData.height - targetData.height / 2 - ly,
        display: false
      };
      var grabYCustom = (e.target.getAttribute('grab-y-custom') || '').split('*');
      grabYCustom = grabYCustom.length && grabYCustom[0] ? {
        value: Math.min(Math.max(0, grabYCustom[0] - 0), containerData.width),
        display: grabYCustom.length <= 1
      } : {
        value: containerData.width - targetData.width / 2 - lx,
        display: false
      };
      var cx = Math.max(Math.min(e.clientX - containerData.x, containerData.width), 0);
      var cy = Math.max(Math.min(e.clientY - containerData.y, containerData.height), 0);
      // data
      var grabData = {
        id: grabID,
        type: grabType[0],
        xRange: [grabXMin, grabXMax, grabXCustom],
        yRange: [grabYMin, grabYMax, grabYCustom],
        target: e.target,
        x: cx,
        y: cy
      };
      var lineData = {
        x: lx,
        y: ly,
        display: grabType.length <= 1
        // f
      };var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(functions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var f = _step.value;

          f(id, grabData, lineData);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    boardStart: function boardStart(id, grabData, lineData) {
      if (grabData.id >= 0 && grabData.type) {
        this.boardData[id].grabID = grabData.id;
        this.boardData[id].grabType = grabData.type;
        this.boardData[id].grabTarget = grabData.target;
        if (['all', 'x'].includes(grabData.type)) {
          this.boardData[id].baseX = this.boardData[id].grabX = grabData.x;
          this.lineData.x.main = {
            base: lineData.x,
            grab: 0,
            display: lineData.display
          };
          if (grabData.xRange[0]) {
            this.lineData.x.min = {
              value: lineData.x - grabData.xRange[0].value,
              display: grabData.xRange[0].display
            };
          }
          if (grabData.xRange[1]) {
            this.lineData.x.max = {
              value: lineData.x + grabData.xRange[1].value,
              display: grabData.xRange[1].display
            };
          }
          if (grabData.xRange[2]) {
            this.lineData.x.custom = {
              value: grabData.xRange[2].value,
              display: grabData.xRange[2].display
            };
          }
        }
        if (['all', 'y'].includes(grabData.type)) {
          this.boardData[id].baseY = this.boardData[id].grabY = grabData.y;
          this.lineData.y.main = {
            base: lineData.y,
            grab: 0,
            display: lineData.display
          };
          if (grabData.yRange[0]) {
            this.lineData.y.min = {
              value: lineData.y - grabData.yRange[0].value,
              display: grabData.yRange[0].display
            };
          }
          if (grabData.yRange[1]) {
            this.lineData.y.max = {
              value: lineData.y + grabData.yRange[1].value,
              display: grabData.yRange[1].display
            };
          }
          if (grabData.yRange[2]) {
            this.lineData.y.custom = {
              value: grabData.yRange[2].value,
              display: grabData.yRange[2].display
            };
          }
        }
        (this.boardData[id].onStart || function () {})(extends_default()({}, this.boardData[id]));
      }
    },
    boardMove: function boardMove(id, grabData) {
      if (this.boardData[id].grabID >= 0) {
        if (['all', 'x'].includes(this.boardData[id].grabType)) {
          var grabX = grabData.x;
          var lineGrab = this.boardData[id].grabX - this.boardData[id].baseX;
          if (this.lineData.x.min) {
            grabX = Math.max(grabX, this.lineData.x.min.value - this.lineData.x.main.base + this.boardData[id].baseX);
            lineGrab = Math.max(lineGrab, this.lineData.x.min.value - this.lineData.x.main.base);
          }
          if (this.lineData.x.max) {
            grabX = Math.min(grabX, this.lineData.x.max.value - this.lineData.x.main.base + this.boardData[id].baseX);
            lineGrab = Math.min(lineGrab, this.lineData.x.max.value - this.lineData.x.main.base);
          }
          this.boardData[id].grabX = grabX;
          this.lineData.x.main.grab = lineGrab;
        }
        if (['all', 'y'].includes(this.boardData[id].grabType)) {
          var grabY = grabData.y;
          var _lineGrab = this.boardData[id].grabY - this.boardData[id].baseY;
          if (this.lineData.y.min) {
            grabY = Math.max(grabY, this.lineData.y.min.value - this.lineData.y.main.base + this.boardData[id].baseY);
            _lineGrab = Math.max(_lineGrab, this.lineData.y.min.value - this.lineData.y.main.base);
          }
          if (this.lineData.y.max) {
            grabY = Math.min(grabY, this.lineData.y.max.value - this.lineData.y.main.base + this.boardData[id].baseY);
            _lineGrab = Math.min(_lineGrab, this.lineData.y.max.value - this.lineData.y.main.base);
          }
          this.boardData[id].grabY = grabY;
          this.lineData.y.main.grab = _lineGrab;
        }
        (this.boardData[id].onMove || function () {})(extends_default()({}, this.boardData[id]));
      }
    },
    boardEnd: function boardEnd(id) {
      if (this.boardData[id].grabID >= 0) {
        (this.boardData[id].onEnd || function () {})(extends_default()({}, this.boardData[id]));
      }
      this.boardInit(id);
      this.lineData = {
        x: {
          min: null,
          max: null,
          main: null
        },
        y: {
          min: null,
          max: null,
          main: null
        }
      };
    }
  }
});
// CONCATENATED MODULE: ./src/mixins/customGrab.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  customGrab,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_customGrab = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UKm5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/analysisBorCor.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var analysisBorCor = ({
  props: {
    type: {
      type: String,
      default: function _default() {
        return 'bottom';
      }
    },
    reverse: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    arrow: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    tooltip: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    display: {
      type: Boolean,
      default: function _default() {
        return null;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // style
    width: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    background: {
      type: String,
      default: function _default() {
        return 'white';
      }
    },
    border: {
      type: String,
      default: function _default() {
        return '#aaaaaa';
      }
    },
    radius: {
      type: String,
      default: function _default() {
        return '3px';
      }
    },
    shadow: {
      type: String,
      default: function _default() {
        return '1px 2px 3px rgba(0, 0, 0, 0.16)';
      }
    },
    translate: {
      type: String,
      default: function _default() {
        return '0px 0px';
      }
    },
    deviation: {
      type: String,
      default: function _default() {
        return '15px 15px';
      }
    },
    arrowSize: {
      type: String,
      default: function _default() {
        return '10px 10px';
      }
    },
    cursorSize: {
      type: String,
      default: function _default() {
        return '40px 40px';
      }
    },
    blockStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    menuBlockStyle: function menuBlockStyle() {
      var width = this.width || 'auto';
      var style = {
        width: width,
        'white-space': width !== 'auto' ? 'pre-line' : 'nowrap',
        '--bg-color': this.background,
        '--bd-color': this.border,
        '--br-value': this.radius
      };
      return extends_default()({}, style, this.blockStyle);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-016ec92e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/analysisBorCor.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analysis-bor-cor",class:{ 'no-arrow': !_vm.arrow, 'is-tooltip': _vm.tooltip }},[_c('div',{staticClass:"trigger",class:{ display: _vm.display !== false, 'always-display': _vm.display }},[_vm._t("trigger")],2),_vm._v(" "),(!_vm.disabled)?_c('div',{staticClass:"menu-container",class:[_vm.type, { reverse: _vm.reverse }],style:({
      'transform': 'translate(' + _vm.translate.split(' ').join(', ') + ')',
      '--sd-style': _vm.shadow,
      '--dvt-v': _vm.deviation.split(' ')[0],
      '--dvt-h': _vm.deviation.split(' ')[1],
      '--arw-w': _vm.arrowSize.split(' ')[0],
      '--arw-h': _vm.arrowSize.split(' ')[1],
      '--cbc-w': _vm.cursorSize.split(' ')[0],
      '--cbc-h': _vm.cursorSize.split(' ')[1],
      '--tt-v': (_vm.tooltip || {}).v || '5px',
      '--tt-h': (_vm.tooltip || {}).h || '5px'
    }),on:{"mouseleave":function (e) { return _vm.$emit('leave'); }}},[_c('div',{staticClass:"menu-block",style:(_vm.menuBlockStyle)},[_vm._t("content")],2),_vm._v(" "),(!_vm.tooltip)?_c('div',{staticClass:"cursor-bor-cor",style:({ '--bd-color': _vm.border, '--bg-color': _vm.background, '--br-value': _vm.radius })},[_c('img',{staticClass:"analysis-list-icon",attrs:{"src":__webpack_require__("V8N6"),"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.arrow && !_vm.tooltip)?[_c('span',{staticClass:"menu-bor-cor shadow-top",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-left",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-right",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor",style:({ '--bg-color': _vm.background })})]:_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_analysisBorCor = (esExports);
// CONCATENATED MODULE: ./src/components/tool/analysisBorCor.vue
function injectStyle (ssrContext) {
  __webpack_require__("PQd3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  analysisBorCor,
  tool_analysisBorCor,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_analysisBorCor = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V8EM":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMC4zIiBoZWlnaHQ9IjMwLjMyNCIgdmlld0JveD0iMCAwIDMwLjMgMzAuMzI0Ij4KICA8cGF0aCBpZD0iRW5kb2NyaW5vbG9neSIgZD0iTTcwOS41ODYtMjIuMDg3bC42MzUtNS4xMDYtNS42MDUtMy4yODMtNS43NzYsMy4zODNMNjkyLjUtMzAuOHYtNy40MjJsNi4zMzYtMy43MTIsNS40MzgsMy4xODUtLjY1LTQuOTcxSDcwNS42bC0uNjE3LDQuOTUxLDQuODQ1LTIuODM3di02Ljc2Nmw2LjMzNi0zLjcxMSw2LjMzNiwzLjcxMXY3LjQyM2wtNS43NzUsMy4zODN2NS44MThsMi44NjYsMS42NzgtLjMyLjU2M0w3MTYuNzI5LTMxdi4ybC0uMi4xMTcsMi41NiwxLjUtLjMyLjU2My0yLjg4MS0xLjY4Ny01LjM1NywzLjEzNy42NjYsNS4wODhabS4zNjQtLjMyNWguODgybC0uNDUyLTMuNDU3Wk03MDUuMTc3LTM3LjU3djYuMTFsNS4yMTYsMy4wNTUsNS4yMTUtMy4wNTVWLTM3LjU3bC01LjIxNi0zLjA1NlptLTExLjU1MiwwdjYuMTFsNS4yMTUsMy4wNTUsNS4yMTYtMy4wNTV2LTYuMTFsLTUuMjE2LTMuMDU1Wm0xNy4zMjgtMTAuMTQ4djYuMTA5bDUuMjE2LDMuMDU1LDUuMjE1LTMuMDU1di02LjEwOWwtNS4yMTUtMy4wNTVabS0xNi43LDE1Ljg1LjQ0NS0uNzgxLDQuOCwyLjgxLS40NDUuNzgxWk03MDkuODY4LTM5LjFsLjQ0NS0uNzgxLDQuOCwyLjgwOS0uNDQ1Ljc4MVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02OTIuMzU0IDUyLjI2KSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMC4zIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "V8N6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNy41IiB2aWV3Qm94PSIwIDAgMjAgMTcuNSI+CiAgPHBhdGggaWQ9Imxpc3QtcmFkaW8tcmVndWxhciIgZD0iTTIuNSwzMkEyLjUsMi41LDAsMSwxLDAsMzQuNSwyLjUsMi41LDAsMCwxLDIuNSwzMlptMTYuNTYzLDEuNTYzYS45MzcuOTM3LDAsMSwxLDAsMS44NzVINy4xODhhLjkzNy45MzcsMCwxLDEsMC0xLjg3NVptMCw2LjI1YS45MzguOTM4LDAsMCwxLDAsMS44NzVINy4xODhhLjkzOC45MzgsMCwwLDEsMC0xLjg3NVptMCw2LjI1YS45MzcuOTM3LDAsMSwxLDAsMS44NzVINy4xODhhLjkzNy45MzcsMCwxLDEsMC0xLjg3NVpNMi41LDM4LjI1QTIuNSwyLjUsMCwxLDEsMCw0MC43NSwyLjUsMi41LDAsMCwxLDIuNSwzOC4yNVptLS45MzcsMi41YS45MzcuOTM3LDAsMSwwLC45MzctLjkzOEEuOTM2LjkzNiwwLDAsMCwxLjU2Myw0MC43NVpNMi41LDQ5LjVBMi41LDIuNSwwLDEsMSw1LDQ3LDIuNSwyLjUsMCwwLDEsMi41LDQ5LjVaTTMuNDM3LDQ3YS45MzcuOTM3LDAsMSwwLS45MzcuOTM4QS45MzYuOTM2LDAsMCwwLDMuNDM3LDQ3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMzIpIiBmaWxsPSIjMDAzNjc5Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "VBfA":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "VKZL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vse0":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2lyY2xlLWV4Y2xhbWF0aW9uLXNvbGlkIiBkPSJNMTAsMEExMCwxMCwwLDEsMCwyMCwxMCwxMCwxMCwwLDAsMCwxMCwwWk05LjA2Myw1LjkzOGEuOTM4LjkzOCwwLDAsMSwxLjg3NSwwdjVhLjkzOC45MzgsMCwwLDEtMS44NzUsMFpNMTAsMTUuNjI1QTEuMjI4LDEuMjI4LDAsMSwxLDExLjIyOCwxNC40LDEuMjI4LDEuMjI4LDAsMCwxLDEwLDE1LjYyNVoiIGZpbGw9IiNmYTNkM2QiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "WBdv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/customTimeout.vue




/* harmony default export */ var customTimeout = ({
  data: function data() {
    return {
      r_timer: {},
      d_timer: {}
    };
  },

  methods: {
    customRecursive: function customRecursive() {
      var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        return false;
      };

      var _this = this;

      var defaultTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
      var key = arguments[2];
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var recursive;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                key = key || new Date().toJSON();

                recursive = function () {
                  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                    var time;
                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return func();

                          case 2:
                            time = _context.sent;

                            if (time) {
                              time = typeof time === 'number' && time > 0 ? time : defaultTime;
                              _this.r_timer[key] = setTimeout(recursive, time);
                            }

                          case 4:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function recursive() {
                    return _ref.apply(this, arguments);
                  };
                }();

                _context2.next = 4;
                return recursive();

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    customDelay: function customDelay() {
      var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

      var _this2 = this;

      var defaultTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
      var key = arguments[2];
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                key = key || new Date().toJSON();
                if (_this2.d_timer[key]) {
                  clearTimeout(_this2.d_timer[key]);
                }
                _this2.d_timer[key] = setTimeout(func, defaultTime);
                return _context3.abrupt('return', key);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    [values_default()(this.r_timer), values_default()(this.d_timer)].forEach(function (timer) {
      return clearTimeout(timer);
    });
  }
});
// CONCATENATED MODULE: ./src/mixins/customTimeout.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  customTimeout,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_customTimeout = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WGo8":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDIwIDE0Ij4KICA8cGF0aCBpZD0iY2xvdWQtdXBsb2FkLXNvbGlkIiBkPSJNMTYuOCwzOC4wODFBMywzLDAsMCwwLDE0LDM0YTIuOTg1LDIuOTg1LDAsMCwwLTEuNjY2LjUwNkE1LDUsMCwwLDAsMywzN2MwLC4wODQsMCwuMTY5LjAwNi4yNTNBNC41LDQuNSwwLDAsMCw0LjUsNDZIMTZhNCw0LDAsMCwwLC44LTcuOTE5Wm0tNC4zNzIsMS45OTEtLjMzNy4zMzhhLjc1My43NTMsMCwwLDEtMS4wNzgtLjAxNkwxMCwzOS4zMTZWNDMuMjVhLjc0OC43NDgsMCwwLDEtLjc1Ljc1aC0uNUEuNzQ4Ljc0OCwwLDAsMSw4LDQzLjI1VjM5LjMxNkw2Ljk4OCw0MC4zOTRhLjc1Ljc1LDAsMCwxLTEuMDc4LjAxNmwtLjMzOC0uMzM4YS43NDcuNzQ3LDAsMCwxLDAtMS4wNTlsMi45LTIuOWEuNzQ3Ljc0NywwLDAsMSwxLjA1OSwwbDIuOSwyLjlBLjc1Ljc1LDAsMCwxLDEyLjQyOCw0MC4wNzJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMikiIGZpbGw9IiNmZmYiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "WpIV":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDE4IDI0Ij4KICA8cGF0aCBpZD0iZmlsZS1tYWduaWZ5aW5nLWdsYXNzLWxpZ2h0IiBkPSJNMTEuMjUsMTVhMywzLDAsMSwwLTMsM0EzLDMsMCwwLDAsMTEuMjUsMTVabS0uMzk0LDMuNjdhNC41LDQuNSwwLDEsMSwxLjA2NC0xLjA2NGwyLjExNCwyLjExNGEuNzQ5Ljc0OSwwLDAsMS0xLjA1OSwxLjA1OWwtMi4xMTQtMi4xMTRaTTE2LjUsMjFWOUgxMS4yNUEyLjI1MSwyLjI1MSwwLDAsMSw5LDYuNzVWMS41SDNBMS41LDEuNSwwLDAsMCwxLjUsM1YyMUExLjUsMS41LDAsMCwwLDMsMjIuNUgxNUExLjUsMS41LDAsMCwwLDE2LjUsMjFaTTE2LjQ3Nyw3LjVhLjcxNi43MTYsMCwwLDAtLjItLjM0N0wxMC44NDcsMS43MmEuNzM3LjczNywwLDAsMC0uMzQ3LS4yVjYuNzVhLjc1Mi43NTIsMCwwLDAsLjc1Ljc1Wk0wLDNBMywzLDAsMCwxLDMsMGg3LjMxN2EyLjI1LDIuMjUsMCwwLDEsMS41ODkuNjYxbDUuNDMzLDUuNDI4QTIuMjUsMi4yNSwwLDAsMSwxOCw3LjY3OFYyMWEzLDMsMCwwLDEtMywzSDNhMywzLDAsMCwxLTMtM1oiIGZpbGw9IiM5OTkiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "X9c2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTAgOCI+CiAgPHBhdGggaWQ9IuWkmuinkuW9ol8yMyIgZGF0YS1uYW1lPSLlpJrop5LlvaIgMjMiIGQ9Ik01LDBsNSw4SDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMCA4KSByb3RhdGUoMTgwKSIgZmlsbD0iIzk5OSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "XE98":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICA8ZyBpZD0iT3RoZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00OTMgLTMzNSkiPgogICAgPHJlY3QgaWQ9IumVt+aWueW9ol8xMzU2IiBkYXRhLW5hbWU9IumVt+aWueW9oiAxMzU2IiB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ5MyAzMzUpIiBmaWxsPSIjZGNkY2RjIiBvcGFjaXR5PSIwIi8+CiAgICA8ZyBpZD0i44Kw44Or44O844OXXzIxNzgiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDIxNzgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY1IC0xOSkiPgogICAgICA8cGF0aCBpZD0i5ZCI5L2TXzIwIiBkYXRhLW5hbWU9IuWQiOS9kyAyMCIgZD0iTTE5LjI0OSwyNmExLjM0MiwxLjM0MiwwLDAsMS0xLjM0LTEuMzQyVjIwLjE4YTEuMzQyLDEuMzQyLDAsMCwxLDEuMzQtMS4zNDRoNC40ODRhMS4zNDIsMS4zNDIsMCwwLDEsMS4zNCwxLjM0NHY0LjQ3N0ExLjM0MiwxLjM0MiwwLDAsMSwyMy43MzIsMjZabS04Ljk1NCwwYTEuMzQyLDEuMzQyLDAsMCwxLTEuMzQtMS4zNDJWMjAuMThhMS4zNDIsMS4zNDIsMCwwLDEsMS4zNC0xLjM0NGg0LjQ4NGExLjM0MSwxLjM0MSwwLDAsMSwxLjM0LDEuMzQ0djQuNDc3QTEuMzQxLDEuMzQxLDAsMCwxLDE0Ljc3OCwyNlpNMS4zNCwyNkExLjM0MiwxLjM0MiwwLDAsMSwwLDI0LjY1N1YyMC4xOGExLjM0MiwxLjM0MiwwLDAsMSwxLjM0LTEuMzQ0SDUuODI1QTEuMzQxLDEuMzQxLDAsMCwxLDcuMTYzLDIwLjE4djQuNDc3QTEuMzQsMS4zNCwwLDAsMSw1LjgyNSwyNlptOC45NTQtOC45NTRBMS4zNDEsMS4zNDEsMCwwLDEsOC45NTQsMTUuN1YxMS4yMjVhMS4zNDIsMS4zNDIsMCwwLDEsMS4zNC0xLjM0NGg0LjQ4NGExLjM0MSwxLjM0MSwwLDAsMSwxLjM0LDEuMzQ0VjE1LjdhMS4zNCwxLjM0LDAsMCwxLTEuMzQsMS4zNDJabS04Ljk1NCwwQTEuMzQxLDEuMzQxLDAsMCwxLDAsMTUuN1YxMS4yMjVBMS4zNDIsMS4zNDIsMCwwLDEsMS4zNCw5Ljg4Mkg1LjgyNWExLjM0MSwxLjM0MSwwLDAsMSwxLjMzOCwxLjM0NFYxNS43YTEuMzQsMS4zNCwwLDAsMS0xLjMzOCwxLjM0MlptMTkuMi04LjQxOEwxNy4zNzIsNS40NTZhMS4zNCwxLjM0LDAsMCwxLDAtMS45TDIwLjU0LjM5NGExLjM0MiwxLjM0MiwwLDAsMSwxLjksMGwzLjE3MSwzLjE3MWExLjM0LDEuMzQsMCwwLDEsMCwxLjlMMjIuNDQsOC42MjZhMS4zNDIsMS4zNDIsMCwwLDEtMS45LDBaTTEuMzQsOC4wOTJBMS4zNDIsMS4zNDIsMCwwLDEsMCw2Ljc0OFYyLjI3MUExLjM0MiwxLjM0MiwwLDAsMSwxLjM0LjkyOUg1LjgyNUExLjM0LDEuMzQsMCwwLDEsNy4xNjMsMi4yNzFWNi43NDhBMS4zNDEsMS4zNDEsMCwwLDEsNS44MjUsOC4wOTJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MzAgMzU2KSIgZmlsbD0iI2ZmZiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "Xb65":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE0IDE2Ij4KICA8cGF0aCBpZD0iZmlsZXMtbWVkaWNhbC1saWdodCIgZD0iTTEzLjU2MSwyLjA2MSwxMS45MzkuNDM5QTEuNSwxLjUsMCwwLDAsMTAuODc5LDBINS41QTEuNSwxLjUsMCwwLDAsNCwxLjVWM0gxLjVBMS41LDEuNSwwLDAsMCwwLDQuNXYxMEExLjUsMS41LDAsMCwwLDEuNSwxNmg3QTEuNSwxLjUsMCwwLDAsMTAsMTQuNVYxM2gyLjVBMS41LDEuNSwwLDAsMCwxNCwxMS41VjMuMTIxYTEuNSwxLjUsMCwwLDAtLjQzOS0xLjA2MVpNMTEsMS4wMTVhLjUuNSwwLDAsMSwuMjMyLjEzMWwxLjYyMSwxLjYyMUEuNS41LDAsMCwxLDEyLjk4NSwzSDExWk05LDE0LjVhLjUuNSwwLDAsMS0uNS41aC03YS41LjUsMCwwLDEtLjUtLjVWNC41QS41LjUsMCwwLDEsMS41LDRINHY3LjVBMS41LDEuNSwwLDAsMCw1LjUsMTNIOVptNC0zYS41LjUsMCwwLDEtLjUuNWgtN2EuNS41LDAsMCwxLS41LS41VjEuNUEuNS41LDAsMCwxLDUuNSwxSDEwVjMuMjVhLjc1Mi43NTIsMCwwLDAsLjc1Ljc1SDEzWk05LjgzMyw1LjcwOEEuMjA4LjIwOCwwLDAsMCw5LjYyNSw1LjVIOC4zNzVhLjIwOC4yMDgsMCwwLDAtLjIwOC4yMDhWNy4xNjdINi43MDhhLjIwOC4yMDgsMCwwLDAtLjIwOC4yMDh2MS4yNWEuMjA4LjIwOCwwLDAsMCwuMjA4LjIwOEg4LjE2N3YxLjQ1OGEuMjA4LjIwOCwwLDAsMCwuMjA4LjIwOGgxLjI1YS4yMDguMjA4LDAsMCwwLC4yMDgtLjIwOFY4LjgzM2gxLjQ1OGEuMjA4LjIwOCwwLDAsMCwuMjA4LS4yMDhWNy4zNzVhLjIwOC4yMDgsMCwwLDAtLjIwOC0uMjA4SDkuODMzWiIgZmlsbD0iIzk5OSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "Z77G":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzcwMzkiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDcwMzkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTcyIC0xNTMzKSI+CiAgICA8cGF0aCBpZD0ibWludXMtc3F1YXJlLXNvbGlkIiBkPSJNMTYuMDcxLDMySDEuOTI5QTEuOTI5LDEuOTI5LDAsMCwwLDAsMzMuOTI5VjQ4LjA3MUExLjkyOSwxLjkyOSwwLDAsMCwxLjkyOSw1MEgxNi4wNzFBMS45MjksMS45MjksMCwwLDAsMTgsNDguMDcxVjMzLjkyOUExLjkyOSwxLjkyOSwwLDAsMCwxNi4wNzEsMzJaTTMuNyw0Mi42MDdhLjQ4NC40ODQsMCwwLDEtLjQ4Mi0uNDgydi0yLjI1YS40ODQuNDg0LDAsMCwxLC40ODItLjQ4MkgxNC4zYS40ODQuNDg0LDAsMCwxLC40ODIuNDgydjIuMjVhLjQ4NC40ODQsMCwwLDEtLjQ4Mi40ODJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOTcyIDE1MDEpIiBmaWxsPSIjODBjNTFkIi8+CiAgICA8ZyBpZD0i6ZW35pa55b2iXzI4MDYiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDI4MDYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5NzIgMTUzMykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLXdpZHRoPSIxIj4KICAgICAgPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiByeD0iMiIgc3Ryb2tlPSJub25lIi8+CiAgICAgIDxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMTciIGhlaWdodD0iMTciIHJ4PSIxLjUiIGZpbGw9Im5vbmUiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "ZM3o":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICA8cGF0aCBpZD0ibWludXMtY2lyY2xlLXNvbGlkIiBkPSJNMTUsOGE3LDcsMCwxLDAsNyw3QTcsNywwLDAsMCwxNSw4Wm0tMy43MjYsOC4xMjlhLjM0LjM0LDAsMCwxLS4zMzktLjMzOVYxNC4yMWEuMzQuMzQsMCwwLDEsLjMzOS0uMzM5aDcuNDUyYS4zNC4zNCwwLDAsMSwuMzM5LjMzOVYxNS43OWEuMzQuMzQsMCwwLDEtLjMzOS4zMzlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOCAtOCkiIGZpbGw9IiNmYTNkM2QiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "aYau":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi41IiBoZWlnaHQ9IjE0LjUiIHZpZXdCb3g9IjAgMCAxNi41IDE0LjUiPgogIDxwYXRoIGlkPSJ0aC1saXN0LWxpZ2h0IiBkPSJNMCwzMy41djExQTEuNSwxLjUsMCwwLDAsMS41LDQ2aDEzQTEuNSwxLjUsMCwwLDAsMTYsNDQuNXYtMTFBMS41LDEuNSwwLDAsMCwxNC41LDMySDEuNUExLjUsMS41LDAsMCwwLDAsMzMuNVptMTUsMHYyLjgzM0g2VjMzaDguNUEuNS41LDAsMCwxLDE1LDMzLjVabTAsNy4xNjdINlYzNy4zMzNoOVpNMSwzNy4zMzNINXYzLjMzM0gxWk01LDMzdjMuMzMzSDFWMzMuNWEuNS41LDAsMCwxLC41LS41Wk0xLDQ0LjVWNDEuNjY3SDVWNDVIMS41QS41LjUsMCwwLDEsMSw0NC41Wk02LDQ1VjQxLjY2N2g5VjQ0LjVhLjUuNSwwLDAsMS0uNS41WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4yNSAtMzEuNzUpIiBmaWxsPSIjMDAzNjc5IiBzdHJva2U9IiMwMDM2NzkiIHN0cm9rZS13aWR0aD0iMC41Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "bCWW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMi41IiBoZWlnaHQ9IjYuNTU1IiB2aWV3Qm94PSIwIDAgMTIuNSA2LjU1NSI+CiAgPHBhdGggaWQ9ImNoZXZyb24tZG93bi1yZWd1bGFyIiBkPSJNMTEuOS41NTMsMTEuMzY4LjA4NGEuMzU5LjM1OSwwLDAsMC0uNDYxLDBMNiw0LjM2NSwxLjA5My4wODRhLjM1OS4zNTksMCwwLDAtLjQ2MSwwTC4xLjU1M2EuMjYuMjYsMCwwLDAsMCwuNEw1Ljc3LDUuOTE2YS4zNTkuMzU5LDAsMCwwLC40NjEsMEwxMS45Ljk1NUEuMjYuMjYsMCwwLDAsMTEuOS41NTNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMi4yNSA2LjI3Nykgcm90YXRlKDE4MCkiIGZpbGw9IiMwMDM2NzkiIHN0cm9rZT0iIzA1MzY3OSIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "bPG1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bk/E":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDIwIj4KICA8cGF0aCBpZD0idXNlcnMtbGlnaHQiIGQ9Ik0zLjYsMy4xMjVBMS44MzksMS44MzksMCwwLDEsNS40LDEuMjUsMS44MzksMS44MzksMCwwLDEsNy4yLDMuMTI1LDEuODM5LDEuODM5LDAsMCwxLDUuNCw1LDEuODM5LDEuODM5LDAsMCwxLDMuNiwzLjEyNVptNC44LDBBMy4wNjQsMy4wNjQsMCwwLDAsNS40LDBhMy4wNjQsMy4wNjQsMCwwLDAtMywzLjEyNSwzLjA2NCwzLjA2NCwwLDAsMCwzLDMuMTI1LDMuMDY0LDMuMDY0LDAsMCwwLDMtMy4xMjVaTTEyLDYuMjVhMi40NTIsMi40NTIsMCwwLDEsMi40LDIuNSwyLjQsMi40LDAsMSwxLTQuOCwwQTIuNDUyLDIuNDUyLDAsMCwxLDEyLDYuMjVabTAsNi4yNWEzLjY3NywzLjY3NywwLDAsMCwzLjYtMy43NUEzLjY3NywzLjY3NywwLDAsMCwxMiw1LDMuNjc3LDMuNjc3LDAsMCwwLDguNCw4Ljc1LDMuNjc3LDMuNjc3LDAsMCwwLDEyLDEyLjVaTTkuOCwxNWg0LjRBMy44NzIsMy44NzIsMCwwLDEsMTgsMTguNzVINkEzLjg3MiwzLjg3MiwwLDAsMSw5LjgsMTVabTAtMS4yNWE1LjEwNyw1LjEwNywwLDAsMC01LDUuMjA3QTEuMDIzLDEuMDIzLDAsMCwwLDUuOCwyMEgxOC4yYTEuMDIzLDEuMDIzLDAsMCwwLDEtMS4wNDMsNS4xMDcsNS4xMDcsMCwwLDAtNS01LjIwN1ptOS40LTEyLjVBMS44MzksMS44MzksMCwwLDEsMjEsMy4xMjVhMS44LDEuOCwwLDEsMS0zLjYsMEExLjgzOSwxLjgzOSwwLDAsMSwxOS4yLDEuMjVabTAsNWEzLjA2NCwzLjA2NCwwLDAsMCwzLTMuMTI1LDMsMywwLDEsMC02LDBBMy4wNjQsMy4wNjQsMCwwLDAsMTkuMiw2LjI1Wm0uNiwyLjVhMy4wNjQsMy4wNjQsMCwwLDEsMywzLjEyNS42LjYsMCwxLDAsMS4yLDBBNC4yODgsNC4yODgsMCwwLDAsMTkuOCw3LjVIMTYuNjVhNS4yNzQsNS4yNzQsMCwwLDEsLjE1LDEuMjVabS0xMi42LDBBNS4yNzQsNS4yNzQsMCwwLDEsNy4zNSw3LjVINC4yQTQuMjg4LDQuMjg4LDAsMCwwLDAsMTEuODc1YS42MTUuNjE1LDAsMCwwLC42LjYyNS42MTUuNjE1LDAsMCwwLC42LS42MjUsMy4wNjQsMy4wNjQsMCwwLDEsMy0zLjEyNVoiIGZpbGw9IiM5OTkiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "bxm6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cEaC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "cmUn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "d5V5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBpZD0iaW5mby1jaXJjbGUtcmVndWxhciIgZD0iTTE2LDhhOCw4LDAsMSwwLDgsOEE4LDgsMCwwLDAsMTYsOFptMCwxNC40NTJBNi40NTIsNi40NTIsMCwxLDEsMjIuNDUyLDE2LDYuNDQ4LDYuNDQ4LDAsMCwxLDE2LDIyLjQ1MlptMC0xMC45QTEuMzU1LDEuMzU1LDAsMSwxLDE0LjY0NSwxMi45LDEuMzU1LDEuMzU1LDAsMCwxLDE2LDExLjU0OFptMS44MDYsOC4xOTRhLjM4Ny4zODcsMCwwLDEtLjM4Ny4zODdIMTQuNTgxYS4zODcuMzg3LDAsMCwxLS4zODctLjM4N3YtLjc3NGEuMzg3LjM4NywwLDAsMSwuMzg3LS4zODdoLjM4N1YxNi41MTZoLS4zODdhLjM4Ny4zODcsMCwwLDEtLjM4Ny0uMzg3di0uNzc0YS4zODcuMzg3LDAsMCwxLC4zODctLjM4N2gyLjA2NWEuMzg3LjM4NywwLDAsMSwuMzg3LjM4N3YzLjIyNmguMzg3YS4zODcuMzg3LDAsMCwxLC4zODcuMzg3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTggLTgpIiBmaWxsPSIjMDAzNjc5Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "f65q":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMi4wMzgiIGhlaWdodD0iMjAuNSIgdmlld0JveD0iMCAwIDIyLjAzOCAyMC41Ij4KICA8cGF0aCBpZD0icm90YXRlLWV4Y2xhbWF0aW9uLWxpZ2h0IiBkPSJNNDIuNzI2LDQ5LjUzOGE4LjgzNyw4LjgzNywwLDAsMC04LjQ1MSw2LjM3LjgwOS44MDksMCwwLDEtLjk1NC41MjQuNzczLjc3MywwLDAsMS0uNTI0LS45NTdBMTAuNCwxMC40LDAsMCwxLDUyLDUzLjU4MnYtMi41YS43NjkuNzY5LDAsMSwxLDEuNTM4LDB2NC42MTVhLjc3MS43NzEsMCwwLDEtLjc2OS43NjlINDguMTU0YS43NjkuNzY5LDAsMSwxLDAtMS41MzhoMi43NmE4Ljg2Niw4Ljg2NiwwLDAsMC04LjE4OC01LjM4NVptLjgxMyw5LjIzMWEuNzY5Ljc2OSwwLDAsMS0xLjUzOCwwVjUyLjYxNWEuNzY5Ljc2OSwwLDAsMSwxLjUzOCwwWm0tMS45MjMsMy44NDZhMS4xNTQsMS4xNTQsMCwxLDEsMS4xNTQsMS4xNTRBMS4xNTEsMS4xNTEsMCwwLDEsNDEuNjE1LDYyLjYxNVptLTguODQ2LDMuMDc3QS43Ny43NywwLDAsMSwzMiw2NC45MjNWNjAuMzA4YS43Ny43NywwLDAsMSwuNzY5LS43NjloLjc1Yy4wMTItLjA0My4wMjMtLjA0My4wMzUsMGgzLjgzMWEuNzY5Ljc2OSwwLDAsMSwwLDEuNTM4SDM0LjYyNWE4Ljg1LDguODUsMCwwLDAsMTYuNjM5LS45ODYuNzcuNzcsMCwwLDEsLjk1Mi0uNTI0Ljc1My43NTMsMCwwLDEsLjUyNC45NTcsMTAuMzg3LDEwLjM4NywwLDAsMS0xOS4yLDEuODUxdjIuNTQ4YS43Ny43NywwLDAsMS0uNzY5Ljc2OVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMS43NSAtNDcuNzUpIiBmaWxsPSIjZmY5ZTAzIiBzdHJva2U9IiNmZjllMDMiIHN0cm9rZS13aWR0aD0iMC41Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "fRKO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gIQ0":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "gijb":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTIgOCI+CiAgPHBhdGggaWQ9IuWkmuinkuW9ol81MyIgZGF0YS1uYW1lPSLlpJrop5LlvaIgNTMiIGQ9Ik01LjIsMS4wNjdhMSwxLDAsMCwxLDEuNiwwbDQsNS4zMzNBMSwxLDAsMCwxLDEwLDhIMmExLDEsMCwwLDEtLjgtMS42WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIgOCkgcm90YXRlKDE4MCkiIGZpbGw9IiMwMDM2NzkiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "gsUn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gvao":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./acmg-checkbox-benign-strong.svg": "xg5u",
	"./acmg-checkbox-benign-supporting.svg": "RzRW",
	"./acmg-checkbox-disabled.svg": "O+D1",
	"./acmg-checkbox-empty.svg": "RBQ8",
	"./acmg-checkbox-pathogenic-moderate.svg": "qfup",
	"./acmg-checkbox-pathogenic-strong.svg": "xMCn",
	"./acmg-checkbox-pathogenic-supporting.svg": "MsWW",
	"./acmg-checkbox-pathogenic-very-strong.svg": "5Ggm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gvao";

/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return getSearchPhenotype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return getSearchGeneEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return getSearchSVDiseaseEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return getSearchSVGeneEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return getGenePanelDivisions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return getGenePanelHpo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return getGenePanelCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return getGenePanelSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return getManagedUsers; });
/* unused harmony export getExchangeRates */
/* unused harmony export getProducts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return getToolVersions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return getOmicss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return getMethodDescriptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return getGeneSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return getGeneMTSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return getVariantDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return getSummaryVariantDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return getSummaryCNVVariantDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return getSummarySVVariantDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return getMissensePrediction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return getCnvGenes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return getGeneOmimPhenotype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return getGeneOrphanetPhenotype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return getGeneClinvarStatistic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return getUserAvatarFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return getDatasetPictureFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return getFamilyCases; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return getMastermindPublications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return getSoftwareVersions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return postEmailCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return postEmailConfirm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return getEnableUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return postEnableUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return getCoverageRates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return getDisimJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return putDisimJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return getUserToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return postUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return postConfirmUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return deleteUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return postRegisterUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return postForgetUserPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return getResetUserPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return postResetUserPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return putUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return putUserPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return getUserAvatarFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return postUserAvatarFile; });
/* unused harmony export deleteUserAvatarFile */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return getUserSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return putUserSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return putAutoShareUserSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return putLocaleUserSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return getUserLicenseID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return postGenerateLicenseID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return putGenerateLicenseID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return deleteUserLicenseID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return getLicenseRequestCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return postLicenseActivationCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return getLicenseRequestCodeFile; });
/* unused harmony export getLicenseActivationCodeFile */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return getLicenseInformations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return getChat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return deleteChat; });
/* unused harmony export getOrders */
/* unused harmony export getOrder */
/* unused harmony export postOrder */
/* unused harmony export getOrderPaymentPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return getWorkgroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return postWorkgroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return putWorkgroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return deleteWorkgroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return deleteLeaveWorkgroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return getWorkgroupCheckMember; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return getWorkgroupCases; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return putCaseWorkgroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return getPhenotypePanels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return postPhenotypePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return putPhenotypePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return deletePhenotypePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return postAddToPhenotypePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return deletePhenotype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return getGenePanels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return getGenePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return postGenePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return putGenePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return deleteGenePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return postHistoryPanel; });
/* unused harmony export postSendGenePanel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return getGenePanelConditionPathway; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return getUserGenePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return putUserGenePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return getFilterConfigs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return getFilterConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return postFilterConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return putFilterConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return deleteFilterConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return postCaseSampleFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return getCaseSampleFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getCaseAnalysisFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return getCloudFilePaths; });
/* unused harmony export getCloudFileLink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getBatchUploadSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return postBatchUploadSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteBatchUploadSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return postBatchUploadFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteBatchUploadFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteBatchUploadCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return putBatchUploadItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return postBatchUploadSubmit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return getCases; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return postCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return putCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return getCaseTimeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getCaseIgvData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getCaseCovGenes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getCaseCoverages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return getCaseSampleAllelegt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return getCaseLinkedDatasets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getCaseAnalysisVersions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getCaseCallerFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return postCaseRestartPipeline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getCaseDigitalMLPA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return postCaseDigitalMLPA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteCaseDigitalMLPA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return getProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return getProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return postProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return putProjectInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return putProjectPhenotype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return deleteProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return putUnlockProjectMastermind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return getCaseProjectReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return getCaseProjectCandidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return postCaseProjectCandidate; });
/* unused harmony export deleteCaseProjectCandidate */
/* unused harmony export getCaseProjectReporting */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return postCaseProjectReporting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return deleteCaseProjectReporting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return putCaseProjectReportACMGTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return deleteCaseProjectReportACMGTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return getCaseProjectRegionTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return getCaseProjectRegionFilterTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return getCaseProjectRegion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return getCaseProjectRegionGeneTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return getCaseProjectRegionGene; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return getCaseProjectRegionVariantTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return getCaseProjectRegionVariant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return getCaseProjectRegionPublicationTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return getCaseProjectRegionPublication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return postCaseProjectRegionMonitorReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return postCaseProjectRegionReporting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return deleteCaseProjectRegionReporting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return getCaseMonitorReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return postCaseMonitorReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deleteCaseMonitorReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return getCaseMonitorCandidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return postCaseMonitorCandidate; });
/* unused harmony export deleteCaseMonitorCandidate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getCaseMonitorReporting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return postCaseMonitorReporting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deleteCaseMonitorReporting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return postCaseMonitorRegionReporting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deleteCaseMonitorRegionReporting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return putCaseMonitorReportACMGTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deleteCaseMonitorReportACMGTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return getCaseMonitorReportSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return putCaseMonitorReportSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return postCaseFilterTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getCaseFilterTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getCaseFilterTableQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getCaseFilterState; });
/* unused harmony export getCaseFilterReporting */
/* unused harmony export postCaseFilterReporting */
/* unused harmony export deleteCaseFilterReporting */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return postCaseFilterMonitorReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getCaseFilterReportACMGTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return putCaseFilterReportACMGTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return deleteCaseFilterReportACMGTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return getExportFilterTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return getReportSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return putReportSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return getReportSettingsConstitution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return getReportSettingsConstitutionSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return getReportSettingsDrugMeta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return getReportSettingsDrugMetaSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return getReportSettingsCovGenes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return getReportSettingsIncidentalFindingGenes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return getReportSettingsVariantQualityDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return postReportSettingsActData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return getReportSettingExportReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return getReportSettingDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return getDatasets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return getCommunityDatasets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return getSharedWithMeDatasets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return getMyShareDatasets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return getFullAccessDatasets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return getDataset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return postDataset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return putDataset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return deleteDataset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return getDatasetTimeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return getCreateDatasetCases; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return getCheckDatasetPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return getDatasetPictureFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return postDatasetPictureFile; });
/* unused harmony export deleteDatasetPictureFile */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return getDatasetExistingState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return getDatasetCases; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return getDatasetArchiveAffectedDatasets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return getDatasetShares; });
/* unused harmony export getDatasetShare */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return putDatasetShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return deleteDatasetShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return getDatasetAccessKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return postDatasetAccessKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return getDatasetInvitationTokens; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return postDatasetInvitationToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return getDatasetConfirmInvitation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return postDatasetConfirmInvitation; });
/* unused harmony export getDatasetConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return putDatasetConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return postDatasetSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return postDatasetSummaryNF; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("T452");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__ = __webpack_require__("tZBu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_global_util__ = __webpack_require__("Cduz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_global_config__ = __webpack_require__("j9i1");










__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);

// auto complete
var getSearchPhenotype = function getSearchPhenotype(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/phenotypes', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getSearchGeneEntry = function getSearchGeneEntry(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/gene_panel_entries', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getSearchSVDiseaseEntry = function getSearchSVDiseaseEntry(query, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/sv_disease_terms_entries', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { q: query, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getSearchSVGeneEntry = function getSearchSVGeneEntry(query, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/sv_gene_symbols_entries', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { q: query, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getGenePanelDivisions = function getGenePanelDivisions(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/gene_panel_divisions', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getGenePanelHpo = function getGenePanelHpo(query, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/hpo_genes', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { q: query, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getGenePanelCondition = function getGenePanelCondition(query, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/condition_genes', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { q: query, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getGenePanelSymbol = function getGenePanelSymbol(query, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/gene_symbols', { q: query }, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getManagedUsers = function getManagedUsers(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/managed_users', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getExchangeRates = function getExchangeRates(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/exchange_rates', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getProducts = function getProducts(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/products', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getToolVersions = function getToolVersions(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/tool_versions', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getOmicss = function getOmicss(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/omics', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getMethodDescriptions = function getMethodDescriptions(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/method_description', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getGeneSummary = function getGeneSummary(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/gene_summary', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getGeneMTSummary = function getGeneMTSummary(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/medlineplus_gene_function', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getVariantDescription = function getVariantDescription(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/variant_description', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getSummaryVariantDescription = function getSummaryVariantDescription(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/summary_variant_description', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getSummaryCNVVariantDescription = function getSummaryCNVVariantDescription(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/summary_cnv_variant_description', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getSummarySVVariantDescription = function getSummarySVVariantDescription(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/summary_cnv_variant_description', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getMissensePrediction = function getMissensePrediction(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/missense_prediction_with_color', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCnvGenes = function getCnvGenes(query, chrm, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/cnv_gene_symbols', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { q: query, on_chrm: chrm, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getGeneOmimPhenotype = function getGeneOmimPhenotype(geneID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/omim_genes', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { gene_id: geneID, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getGeneOrphanetPhenotype = function getGeneOrphanetPhenotype(geneID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/orphanet_genes', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { gene_id: geneID, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getGeneClinvarStatistic = function getGeneClinvarStatistic(geneID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/clinvar_gene_stats', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { entrez: geneID, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getUserAvatarFiles = function getUserAvatarFiles(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/avatar_files', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getDatasetPictureFiles = function getDatasetPictureFiles(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/dataset_picture_files', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getFamilyCases = function getFamilyCases(caseID, query, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/fam_cases', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { case_id: caseID, q: query, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getMastermindPublications = function getMastermindPublications(pmid, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/mastermind_publication', { pmid: pmid }, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getSoftwareVersions = function getSoftwareVersions(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/software_versions', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// verify
var postEmailCode = function postEmailCode(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/send_email_confirmation_code', data, { params: { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale } });
};
var postEmailConfirm = function postEmailConfirm(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/confirm_email', data, { params: { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale } });
};
var getEnableUser = function getEnableUser(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/enable_user', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postEnableUser = function postEnableUser(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/enable_user', data, { params: { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale } });
};
// coverage rate
var getCoverageRates = function getCoverageRates() {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get('https://storage.googleapis.com/inherinext-public/KAPA_V6_data_merge.txt');
};
// phenotype disease
var getDisimJob = function getDisimJob(lineToken) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'line/disim_query_jobs/current', { params: { line_access_token: lineToken, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale } });
};
var putDisimJob = function putDisimJob(phenotypes, lineToken) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'line/disim_query_jobs/current', { phenotypes: phenotypes }, { params: { line_access_token: lineToken, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale } });
};
// user
var getUserToken = function getUserToken(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/current', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postUser = function postUser(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/sign_in', data, { params: { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale } });
};
var postConfirmUser = function postConfirmUser(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/confirm_sign_in', data, { params: { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale } });
};
var deleteUser = function deleteUser(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/sign_out', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postRegisterUser = function postRegisterUser(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/sign_up', data, { params: { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale } });
};
var postForgetUserPassword = function postForgetUserPassword(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/forgot_password', data, { params: { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale } });
};
var getResetUserPassword = function getResetUserPassword(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/reset_password', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postResetUserPassword = function postResetUserPassword(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/reset_password', data, { params: { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale } });
};
var putUser = function putUser(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/current', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putUserPassword = function putUserPassword(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/current/password', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// user avatar
var getUserAvatarFile = function getUserAvatarFile(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/current/avatar_file', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postUserAvatarFile = function postUserAvatarFile(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/current/avatar_file', data.file ? Object(__WEBPACK_IMPORTED_MODULE_6__constants_global_util__["q" /* toFormdata */])(data) : data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteUserAvatarFile = function deleteUserAvatarFile(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/current/avatar_file', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// user setting
var getUserSettings = function getUserSettings(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'user_setting', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putUserSettings = function putUserSettings(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'user_setting', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putAutoShareUserSettings = function putAutoShareUserSettings(workgroupID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'user_setting/auto_share_cases_to_workgroup', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ auto_share_cases_to_workgroup: workgroupID }, data), { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putLocaleUserSettings = function putLocaleUserSettings(locale, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'user_setting/locale', { locale: locale }, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config) });
};
// license
var getUserLicenseID = function getUserLicenseID(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'licenses/user_license_id', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postGenerateLicenseID = function postGenerateLicenseID(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'licenses/generate_license_id', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putGenerateLicenseID = function putGenerateLicenseID(licenseID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'licenses/update_license_id', { license_id: licenseID }, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteUserLicenseID = function deleteUserLicenseID(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'licenses/remove_license_id', {}, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getLicenseRequestCode = function getLicenseRequestCode(licenseID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'licenses/generate_request_code', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { license_id: licenseID, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postLicenseActivationCode = function postLicenseActivationCode(file, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'licenses/imported_activation_code', Object(__WEBPACK_IMPORTED_MODULE_6__constants_global_util__["q" /* toFormdata */])({ activation_code: file }), { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getLicenseRequestCodeFile = function getLicenseRequestCodeFile(licenseID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'licenses/download_request_code', { responseType: 'blob', params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { license_id: licenseID, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getLicenseActivationCodeFile = function getLicenseActivationCodeFile(licenseID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'licenses/download_activation_request_code', { responseType: 'blob', params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { license_id: licenseID, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getLicenseInformations = function getLicenseInformations(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'licenses' + (__WEBPACK_IMPORTED_MODULE_7__constants_global_config__["a" /* _LOCAL_BUILD */] ? '/show_license' : ''), { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// chat
var getChat = function getChat(projectID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'chat_sessions/projects/' + projectID + '/chat_messages', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteChat = function deleteChat(projectID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'chat_sessions/projects/' + projectID + '/chat_messages', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// order
var getOrders = function getOrders(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'orders', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getOrder = function getOrder(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'orders/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postOrder = function postOrder(prodoctID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'orders', { product_id: prodoctID }, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getOrderPaymentPage = function getOrderPaymentPage(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'orders/' + id + '/payment', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// workgroup
var getWorkgroups = function getWorkgroups(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'workgroups', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postWorkgroup = function postWorkgroup(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'workgroups', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putWorkgroup = function putWorkgroup(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'workgroups/' + id, data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteWorkgroup = function deleteWorkgroup(id, params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'workgroups/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteLeaveWorkgroup = function deleteLeaveWorkgroup(id, params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'workgroups/' + id + '/leave_workgroup', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getWorkgroupCheckMember = function getWorkgroupCheckMember(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'workgroups/check_member', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getWorkgroupCases = function getWorkgroupCases(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'workgroups/search_cases', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putCaseWorkgroup = function putCaseWorkgroup(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'workgroups/' + id + '/update_cases_list', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// phenotype panel
var getPhenotypePanels = function getPhenotypePanels(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'phenotype_panels', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postPhenotypePanel = function postPhenotypePanel(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'phenotype_panels', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putPhenotypePanel = function putPhenotypePanel(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'phenotype_panels/' + id, data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deletePhenotypePanel = function deletePhenotypePanel(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'phenotype_panels/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postAddToPhenotypePanel = function postAddToPhenotypePanel(id, type, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'phenotype_panels/' + id + '/phenotypes/' + type, data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deletePhenotype = function deletePhenotype(id, type, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'phenotypes/' + type + '/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// gene panel
var getGenePanels = function getGenePanels(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'gene_panels', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getGenePanel = function getGenePanel(id, params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'gene_panels/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postGenePanel = function postGenePanel(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'gene_panels', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putGenePanel = function putGenePanel(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'gene_panels/' + id, data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteGenePanel = function deleteGenePanel(id, params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'gene_panels/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postHistoryPanel = function postHistoryPanel(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'gene_panels/' + id + '/history', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postSendGenePanel = function postSendGenePanel(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'gene_panels/' + id + '/send_result', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getGenePanelConditionPathway = function getGenePanelConditionPathway(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'pathways/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getUserGenePanel = function getUserGenePanel(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'user_gene_panels', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putUserGenePanel = function putUserGenePanel(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'user_gene_panels', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// filter conifg
var getFilterConfigs = function getFilterConfigs(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'filter_configs', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getFilterConfig = function getFilterConfig(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'filter_configs/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postFilterConfig = function postFilterConfig(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'filter_configs', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putFilterConfig = function putFilterConfig(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'filter_configs/' + id, data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteFilterConfig = function deleteFilterConfig(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'filter_configs/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// data file
var postCaseSampleFile = function postCaseSampleFile(id, dataset, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/sample_files/' + dataset, data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseSampleFiles = function getCaseSampleFiles(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/sample_files', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseAnalysisFiles = function getCaseAnalysisFiles(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/analysis_files', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// cloud file
var getCloudFilePaths = function getCloudFilePaths(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cloudspace/paths', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCloudFileLink = function getCloudFileLink(path, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cloudspace/paths/download', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { path: path, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// batch upload
var getBatchUploadSet = function getBatchUploadSet(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'vcf_batch_upload_sets', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postBatchUploadSet = function postBatchUploadSet(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'vcf_batch_upload_sets/upload_sample_sheet', Object(__WEBPACK_IMPORTED_MODULE_6__constants_global_util__["q" /* toFormdata */])(data), { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteBatchUploadSet = function deleteBatchUploadSet(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'vcf_batch_upload_sets/reset', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postBatchUploadFiles = function postBatchUploadFiles(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'vcf_batch_upload_sets/upload_files', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteBatchUploadFile = function deleteBatchUploadFile(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'vcf_batch_upload_sets/delete_file/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteBatchUploadCase = function deleteBatchUploadCase(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'vcf_batch_upload_sets/delete_item/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putBatchUploadItem = function putBatchUploadItem(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'vcf_batch_upload_sets/update_item/' + id, data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postBatchUploadSubmit = function postBatchUploadSubmit(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'vcf_batch_upload_sets/submit', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// case
var getCases = function getCases(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCase = function getCase(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postCase = function postCase(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putCase = function putCase(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id, data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteCase = function deleteCase(id, params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseTimeout = function getCaseTimeout(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/job_timeout', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseIgvData = function getCaseIgvData(id, params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/igv_data', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseCovGenes = function getCaseCovGenes(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/cov_genes', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseCoverages = function getCaseCoverages(id, projectID, locations, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/coverage', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { location: locations, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseSampleAllelegt = function getCaseSampleAllelegt(id, projectID, chrom, pos, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/sample_allelegt', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { chrom: chrom, pos: pos, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseLinkedDatasets = function getCaseLinkedDatasets(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/linked_datasets', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseAnalysisVersions = function getCaseAnalysisVersions(id, projectID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/analysis_version', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseCallerFiles = function getCaseCallerFiles(id, projectID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/show_caller_files', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postCaseRestartPipeline = function postCaseRestartPipeline(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/restart_variant_discovery_pipeline_job', {}, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseDigitalMLPA = function getCaseDigitalMLPA(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/show_digitalmlpa', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postCaseDigitalMLPA = function postCaseDigitalMLPA(id, file, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/upload_digitalmlpa_file', Object(__WEBPACK_IMPORTED_MODULE_6__constants_global_util__["q" /* toFormdata */])({ file: file }), { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteCaseDigitalMLPA = function deleteCaseDigitalMLPA(id, mlpaID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/delete_digitalmlpa', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { digitalmlpa_id: mlpaID, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// project
var getProjects = function getProjects(caseID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + caseID + '/projects', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getProject = function getProject(id, caseID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + caseID + '/projects/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postProject = function postProject(caseID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + caseID + '/projects', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putProjectInfo = function putProjectInfo(id, caseID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + caseID + '/projects/' + id + '/info', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putProjectPhenotype = function putProjectPhenotype(id, caseID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + caseID + '/projects/' + id + '/phenotypes', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteProject = function deleteProject(id, caseID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + caseID + '/projects/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putUnlockProjectMastermind = function putUnlockProjectMastermind(id, caseID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + caseID + '/projects/' + id + '/update_unlock_mastermind', {}, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// gene
var getCaseProjectReport = function getCaseProjectReport(id, projectID, type, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_report', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseProjectCandidate = function getCaseProjectCandidate(id, projectID, type, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_candidates', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postCaseProjectCandidate = function postCaseProjectCandidate(id, projectID, type, symbol, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_candidates/' + symbol, data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteCaseProjectCandidate = function deleteCaseProjectCandidate(id, projectID, type, symbol, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_candidates/' + symbol, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseProjectReporting = function getCaseProjectReporting(id, projectID, type, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_reporting', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postCaseProjectReporting = function postCaseProjectReporting(id, projectID, type, symbol, vkey, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_reporting/' + symbol, { var_id: vkey }, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteCaseProjectReporting = function deleteCaseProjectReporting(id, projectID, type, symbol, vkey, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_reporting/' + symbol, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { var_id: vkey, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putCaseProjectReportACMGTag = function putCaseProjectReportACMGTag(id, projectID, type, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_report/acmg_tags', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteCaseProjectReportACMGTag = function deleteCaseProjectReportACMGTag(id, projectID, type, params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_report/acmg_tags', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// region
var getCaseProjectRegionTable = function getCaseProjectRegionTable(id, projectID, type, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/sv', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseProjectRegionFilterTable = function getCaseProjectRegionFilterTable(id, projectID, type, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/sv/filter', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseProjectRegion = function getCaseProjectRegion(id, projectID, type, queryType, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/sv/' + queryType, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseProjectRegionGeneTable = function getCaseProjectRegionGeneTable(id, projectID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/sv/genes', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseProjectRegionGene = function getCaseProjectRegionGene(id, projectID, svID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/sv/genes/' + svID, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseProjectRegionVariantTable = function getCaseProjectRegionVariantTable(id, projectID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/sv/variant', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseProjectRegionVariant = function getCaseProjectRegionVariant(id, projectID, svID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/sv/variant/' + svID, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseProjectRegionPublicationTable = function getCaseProjectRegionPublicationTable(id, projectID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/sv/population', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseProjectRegionPublication = function getCaseProjectRegionPublication(id, projectID, svID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/sv/population/' + svID, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postCaseProjectRegionMonitorReport = function postCaseProjectRegionMonitorReport(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report/sv', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postCaseProjectRegionReporting = function postCaseProjectRegionReporting(id, projectID, type, svID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_reporting/' + svID, {}, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteCaseProjectRegionReporting = function deleteCaseProjectRegionReporting(id, projectID, type, svID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_reporting/' + svID, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// monitor
var getCaseMonitorReport = function getCaseMonitorReport(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postCaseMonitorReport = function postCaseMonitorReport(id, projectID, symbol, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/monitor_report/' + symbol, data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteCaseMonitorReport = function deleteCaseMonitorReport(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseMonitorCandidate = function getCaseMonitorCandidate(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_candidates', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postCaseMonitorCandidate = function postCaseMonitorCandidate(id, symbol, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_candidates/' + symbol, data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteCaseMonitorCandidate = function deleteCaseMonitorCandidate(id, symbol, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_candidates/' + symbol, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseMonitorReporting = function getCaseMonitorReporting(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_reporting', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postCaseMonitorReporting = function postCaseMonitorReporting(id, symbol, vkey, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_reporting/' + symbol, { var_id: vkey }, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteCaseMonitorReporting = function deleteCaseMonitorReporting(id, symbol, vkey, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_reporting/' + symbol, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { var_id: vkey, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postCaseMonitorRegionReporting = function postCaseMonitorRegionReporting(id, svID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_reporting/' + svID, {}, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteCaseMonitorRegionReporting = function deleteCaseMonitorRegionReporting(id, svID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_reporting/' + svID, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putCaseMonitorReportACMGTag = function putCaseMonitorReportACMGTag(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report/acmg_tags', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteCaseMonitorReportACMGTag = function deleteCaseMonitorReportACMGTag(id, params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report/acmg_tags', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseMonitorReportSetting = function getCaseMonitorReportSetting(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report_settings', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putCaseMonitorReportSetting = function putCaseMonitorReportSetting(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report_settings', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// filter
var postCaseFilterTable = function postCaseFilterTable(id, projectID, filterConfigID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/filter/table', filterConfigID ? { filter_config_id: filterConfigID } : {}, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseFilterTable = function getCaseFilterTable(id, projectID, filterConfigID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/filter/table', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, filterConfigID ? { filter_config_id: filterConfigID } : {}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseFilterTableQuery = function getCaseFilterTableQuery(id, projectID, params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/filter/table/query', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseFilterState = function getCaseFilterState(id, projectID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/filter/custom_filter_query_job', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseFilterReporting = function getCaseFilterReporting(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/filter_reporting', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postCaseFilterReporting = function postCaseFilterReporting(id, symbol, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/filter_reporting', { data: symbol }, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteCaseFilterReporting = function deleteCaseFilterReporting(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/filter_reporting', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postCaseFilterMonitorReport = function postCaseFilterMonitorReport(id, projectID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/monitor_report/filter', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCaseFilterReportACMGTag = function getCaseFilterReportACMGTag(id, projectID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/filter/acmg_tags', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putCaseFilterReportACMGTag = function putCaseFilterReportACMGTag(id, projectID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/filter/acmg_tags', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteCaseFilterReportACMGTag = function deleteCaseFilterReportACMGTag(id, projectID, params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/filter/acmg_tags', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getExportFilterTable = function getExportFilterTable(id, projectID, data, responseType, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/filter/table/export', { responseType: responseType, params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// report
var getReportSettings = function getReportSettings(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putReportSettings = function putReportSettings(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getReportSettingsConstitution = function getReportSettingsConstitution(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/constitution', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getReportSettingsConstitutionSummary = function getReportSettingsConstitutionSummary(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/constitution_summary', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getReportSettingsDrugMeta = function getReportSettingsDrugMeta(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/drug_meta', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getReportSettingsDrugMetaSummary = function getReportSettingsDrugMetaSummary(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/drug_meta_summary', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getReportSettingsCovGenes = function getReportSettingsCovGenes(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/cov_genes', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getReportSettingsIncidentalFindingGenes = function getReportSettingsIncidentalFindingGenes(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/incidental_finding_genes', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getReportSettingsVariantQualityDescription = function getReportSettingsVariantQualityDescription(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/variant_quality_description', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postReportSettingsActData = function postReportSettingsActData(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/check_act_csv', Object(__WEBPACK_IMPORTED_MODULE_6__constants_global_util__["q" /* toFormdata */])(data), { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getReportSettingExportReport = function getReportSettingExportReport(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/export_report', { responseType: 'blob', params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getReportSettingDatas = function getReportSettingDatas(id, chapter, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/' + chapter, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
// dataset population
var getDatasets = function getDatasets(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCommunityDatasets = function getCommunityDatasets(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/community', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getSharedWithMeDatasets = function getSharedWithMeDatasets(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/shared_with_me', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getMyShareDatasets = function getMyShareDatasets(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/my_shares', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getFullAccessDatasets = function getFullAccessDatasets(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/full_access', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getDataset = function getDataset(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postDataset = function postDataset(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putDataset = function putDataset(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id, data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteDataset = function deleteDataset(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getDatasetTimeout = function getDatasetTimeout(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/job_timeout', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCreateDatasetCases = function getCreateDatasetCases(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/dataset_creation', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getCheckDatasetPermission = function getCheckDatasetPermission(id) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/permissions', { params: { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale } });
};
var getDatasetPictureFile = function getDatasetPictureFile(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/dataset_picture_file', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postDatasetPictureFile = function postDatasetPictureFile(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/dataset_picture_file', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteDatasetPictureFile = function deleteDatasetPictureFile(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/dataset_picture_file', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getDatasetExistingState = function getDatasetExistingState(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/existing_state', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getDatasetCases = function getDatasetCases(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/linked_cases', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getDatasetArchiveAffectedDatasets = function getDatasetArchiveAffectedDatasets(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/archive_affected_datasets', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getDatasetShares = function getDatasetShares(datasetID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + datasetID + '/dataset_shares', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getDatasetShare = function getDatasetShare(id, datasetID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + datasetID + '/dataset_shares/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putDatasetShare = function putDatasetShare(id, datasetID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + datasetID + '/dataset_shares/' + id, data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var deleteDatasetShare = function deleteDatasetShare(id, datasetID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + datasetID + '/dataset_shares/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getDatasetAccessKey = function getDatasetAccessKey(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/access_key', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postDatasetAccessKey = function postDatasetAccessKey(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/access_key', {}, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getDatasetInvitationTokens = function getDatasetInvitationTokens(datasetID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + datasetID + '/dataset_invitation_tokens', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postDatasetInvitationToken = function postDatasetInvitationToken(datasetID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + datasetID + '/dataset_invitation_tokens', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getDatasetConfirmInvitation = function getDatasetConfirmInvitation(accessKey, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/confirm_dataset_invitation', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { access_key: accessKey, locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postDatasetConfirmInvitation = function postDatasetConfirmInvitation(accessKey, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/confirm_dataset_invitation', { access_key: accessKey }, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var getDatasetConfig = function getDatasetConfig(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/dataset_config', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var putDatasetConfig = function putDatasetConfig(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/dataset_config', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postDatasetSummary = function postDatasetSummary(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/summary_jobs', data, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};
var postDatasetSummaryNF = function postDatasetSummaryNF(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/summary_jobs/nf', {}, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { locale: __WEBPACK_IMPORTED_MODULE_5__constants_lang_i18n__["a" /* default */].locale }) });
};

/***/ }),

/***/ "gyhp":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzYzNzEiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDYzNzEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNDApIHJvdGF0ZSgtOTApIj4KICAgIDxyZWN0IGlkPSLplbfmlrnlvaJfMTQ5MyIgZGF0YS1uYW1lPSLplbfmlrnlvaIgMTQ5MyIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBmaWxsPSIjMDAzNjc5IiBvcGFjaXR5PSIwIi8+CiAgICA8cGF0aCBpZD0iY2hldnJvbi1kb3VibGUtbGVmdC1saWdodCIgZD0iTTIwLjc3Niw0OC43NDhsLTcuNjMxLTcuNTY3YS40MjguNDI4LDAsMCwxLDAtLjYxTDIwLjc3NiwzM2EuNDM3LjQzNywwLDAsMSwuNjE1LDBsLjI1Ny4yNTVhLjQyOC40MjgsMCwwLDEsMCwuNjFsLTcuMDY3LDcuMDA3LDcuMDY3LDcuMDExYS40MjguNDI4LDAsMCwxLDAsLjYxbC0uMjU3LjI1NUEuNDQuNDQsMCwwLDEsMjAuNzc2LDQ4Ljc0OFptLTUuNjI1LDAsLjI1Ny0uMjU1YS40MjguNDI4LDAsMCwwLDAtLjYxTDguMzQxLDQwLjg3NywxNS40LDMzLjg2NmEuNDI4LjQyOCwwLDAsMCwwLS42MUwxNS4xNDgsMzNhLjQzNy40MzcsMCwwLDAtLjYxNSwwTDYuOSw0MC41NjhhLjQyOC40MjgsMCwwLDAsMCwuNjFsNy42MzEsNy41NjdBLjQzOC40MzgsMCwwLDAsMTUuMTUxLDQ4Ljc0OFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDYwLjM3NSA1LjcyNSkgcm90YXRlKDkwKSIgZmlsbD0iIzAwMzY3OSIgc3Ryb2tlPSIjMDAzNjc5IiBzdHJva2Utd2lkdGg9IjAuNSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "hVPs":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICA8ZyBpZD0iTkJTIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE0MyAtNDE3KSI+CiAgICA8ZyBpZD0i6ZW35pa55b2iXzI5MjciIGRhdGEtbmFtZT0i6ZW35pa55b2iIDI5MjciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNDMgNDE3KSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjNzA3MDcwIiBzdHJva2Utd2lkdGg9IjEiIG9wYWNpdHk9IjAiPgogICAgICA8cmVjdCB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjI5IiBoZWlnaHQ9IjI5IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgICA8cGF0aCBpZD0ibmJzLTIiIGRhdGEtbmFtZT0ibmJzIiBkPSJNMjEuNDY3LDM5LjIzYTQuNDI3LDQuNDI3LDAsMSwxLDQuNDIzLDQuMjNBNC4zMzMsNC4zMzMsMCwwLDEsMjEuNDY3LDM5LjIzWm04LjkyNCw1LjYzMmEyLjY1NCwyLjY1NCwwLDAsMC0xLjktLjc1MUgyMy4yMWEyLjUyOSwyLjUyOSwwLDAsMC0xLjg0Ny43NTFsLTUuOTA2LDUuNjgxYy0xLjYxMywxLjU1Mi41NzIsMy41MjksMi4xODYsMmwzLjU2NC0zLjQ1NFY1Mi4zMkgzMC41VjQ5LjA2NkwzNC4xOSw1Mi42YzEuNDgzLDEuNSwzLjcyMS0uNSwyLjE4Ni0yWk0zMC41LDU0bC0zLjQ4NiwzLjM3OSwyLjU3NiwyLjQ3OC0yLjYyOCwyLjUyOGExLjUxMywxLjUxMywwLDEsMCwyLjE4NiwyLjA3N0wzMy4zMDUsNjAuM2EyLjQ0OSwyLjQ0OSwwLDAsMCwuMTgyLTMuNDI5Wm0tOC4zNTIsNS44MzIsMi41NzYtMi40NzhMMjEuMjMzLDU0bC0zLjAxOCwyLjg3OEEyLjQ3NCwyLjQ3NCwwLDAsMCwxOC40LDYwLjNsNC4xNjMsNC4xNTVhMS41MjIsMS41MjIsMCwxLDAsMi4yMTEtMi4wNzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTMyLjEwOSAzODIpIiBmaWxsPSIjZmZmIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "hWQF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i1qd":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi41IiBoZWlnaHQ9IjE2LjUiIHZpZXdCb3g9IjAgMCAxNi41IDE2LjUiPgogIDxwYXRoIGlkPSJpbmZvLWNpcmNsZS1saWdodCIgZD0iTTE2LDkuMDMyQTYuOTY4LDYuOTY4LDAsMSwxLDkuMDMyLDE2LDYuOTY5LDYuOTY5LDAsMCwxLDE2LDkuMDMyTTE2LDhhOCw4LDAsMSwwLDgsOEE4LDgsMCwwLDAsMTYsOFpNMTQuODM5LDE5LjFoLjM4N1YxNS4yMjZoLS4zODdhLjM4Ny4zODcsMCwwLDEtLjM4Ny0uMzg3di0uMjU4YS4zODcuMzg3LDAsMCwxLC4zODctLjM4N2gxLjU0OGEuMzg3LjM4NywwLDAsMSwuMzg3LjM4N1YxOS4xaC4zODdhLjM4Ny4zODcsMCwwLDEsLjM4Ny4zODd2LjI1OGEuMzg3LjM4NywwLDAsMS0uMzg3LjM4N0gxNC44MzlhLjM4Ny4zODcsMCwwLDEtLjM4Ny0uMzg3di0uMjU4QS4zODcuMzg3LDAsMCwxLDE0LjgzOSwxOS4xWk0xNiwxMS4zNTVhMS4wMzIsMS4wMzIsMCwxLDAsMS4wMzIsMS4wMzJBMS4wMzIsMS4wMzIsMCwwLDAsMTYsMTEuMzU1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcuNzUgLTcuNzUpIiBmaWxsPSIjMDAzNjc5IiBzdHJva2U9IiMwMDM2NzkiIHN0cm9rZS13aWR0aD0iMC41Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "i6O6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMC41IiBoZWlnaHQ9IjE0LjUiIHZpZXdCb3g9IjAgMCAyMC41IDE0LjUiPgogIDxwYXRoIGlkPSJ1c2Vycy1saWdodCIgZD0iTTE3LDM4YTIuNSwyLjUsMCwxLDAtMi41LTIuNUEyLjUsMi41LDAsMCwwLDE3LDM4Wm0wLTRhMS41LDEuNSwwLDEsMS0xLjUsMS41QTEuNSwxLjUsMCwwLDEsMTcsMzRabS03LDVhMy41LDMuNSwwLDEsMC0zLjUtMy41QTMuNSwzLjUsMCwwLDAsMTAsMzlabTAtNmEyLjUsMi41LDAsMSwxLTIuNSwyLjVBMi41LDIuNSwwLDAsMSwxMCwzM1ptNy42MjUsNmgtMS4yNWEyLjI2MSwyLjI2MSwwLDAsMC0xLjI4NC40LDQuMjM2LDQuMjM2LDAsMCwxLC43OTQuNywxLjI0MywxLjI0MywwLDAsMSwuNDkxLS4xaDEuMjVBMS40NDQsMS40NDQsMCwwLDEsMTksNDEuNWEuNS41LDAsMCwwLDEsMEEyLjQ0MywyLjQ0MywwLDAsMCwxNy42MjUsMzlaTTMsMzhBMi41LDIuNSwwLDEsMCwuNSwzNS41LDIuNSwyLjUsMCwwLDAsMywzOFptMC00YTEuNSwxLjUsMCwxLDEtMS41LDEuNUExLjUsMS41LDAsMCwxLDMsMzRabTkuNSw1LjYyNWMtMS4wNDQsMC0xLjMuMzc1LTIuNS4zNzVzLTEuNDU5LS4zNzUtMi41LS4zNzVhMy40NDQsMy40NDQsMCwwLDAtMi44ODQsMS40NjZBMy41ODEsMy41ODEsMCwwLDAsNCw0My4xdjEuNEExLjUsMS41LDAsMCwwLDUuNSw0Nmg5QTEuNSwxLjUsMCwwLDAsMTYsNDQuNVY0My4xYTMuNTgxLDMuNTgxLDAsMCwwLS42MTItMi4wMDlBMy40NDQsMy40NDQsMCwwLDAsMTIuNSwzOS42MjVaTTE1LDQ0LjVhLjUuNSwwLDAsMS0uNS41aC05YS41LjUsMCwwLDEtLjUtLjVWNDMuMWEyLjYsMi42LDAsMCwxLC40NDEtMS40NSwyLjQ0NiwyLjQ0NiwwLDAsMSwyLjA1My0xLjAyNUM4LjM1LDQwLjYyNSw4LjY1Niw0MSwxMCw0MXMxLjY1LS4zNzUsMi41LS4zNzVhMi40NDYsMi40NDYsMCwwLDEsMi4wNTMsMS4wMjVBMi42LDIuNiwwLDAsMSwxNSw0My4xdjEuNFpNNC45MDksMzkuNEEyLjI3NiwyLjI3NiwwLDAsMCwzLjYyNSwzOUgyLjM3NUEyLjQ0MywyLjQ0MywwLDAsMCwwLDQxLjVhLjUuNSwwLDAsMCwxLDBBMS40NDQsMS40NDQsMCwwLDEsMi4zNzUsNDBoMS4yNWExLjI0MywxLjI0MywwLDAsMSwuNDkxLjEsNC4zMzYsNC4zMzYsMCwwLDEsLjc5NC0uN1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMjUgLTMxLjc1KSIgZmlsbD0iIzAwMzY3OSIgc3Ryb2tlPSIjMDAzNTc3IiBzdHJva2Utd2lkdGg9IjAuNSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "iva/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Immunology.900c89c.svg";

/***/ }),

/***/ "j6F1":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOC4zNzUiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAxOC4zNzUgMjEiPgogIDxwYXRoIGlkPSJ0cmFzaC1hbHQtbGlnaHQiIGQ9Ik0xMi4xNDEsMTcuNzE5SDEyLjhhLjMyOC4zMjgsMCwwLDAsLjMyOC0uMzI4VjYuMjM0YS4zMjguMzI4LDAsMCwwLS4zMjgtLjMyOGgtLjY1NmEuMzI4LjMyOCwwLDAsMC0uMzI4LjMyOFYxNy4zOTFBLjMyOC4zMjgsMCwwLDAsMTIuMTQxLDE3LjcxOVptLTYuNTYyLDBoLjY1NmEuMzI4LjMyOCwwLDAsMCwuMzI4LS4zMjhWNi4yMzRhLjMyOC4zMjgsMCwwLDAtLjMyOC0uMzI4SDUuNTc4YS4zMjguMzI4LDAsMCwwLS4zMjguMzI4VjE3LjM5MUEuMzI4LjMyOCwwLDAsMCw1LjU3OCwxNy43MTlaTTE4LjA0NywyLjYyNUgxMy43ODFMMTIuNC43ODhBMS45NjksMS45NjksMCwwLDAsMTAuODI4LDBINy41NDdBMS45NjksMS45NjksMCwwLDAsNS45NzIuNzg3TDQuNTk0LDIuNjI1SC4zMjhBLjMyOC4zMjgsMCwwLDAsMCwyLjk1M3YuNjU2YS4zMjguMzI4LDAsMCwwLC4zMjguMzI4aC45ODRWMTkuMDMxQTEuOTY5LDEuOTY5LDAsMCwwLDMuMjgxLDIxSDE1LjA5NGExLjk2OSwxLjk2OSwwLDAsMCwxLjk2OS0xLjk2OVYzLjkzOGguOTg0YS4zMjguMzI4LDAsMCwwLC4zMjgtLjMyOFYyLjk1M0EuMzI4LjMyOCwwLDAsMCwxOC4wNDcsMi42MjVaTTcuMDIyLDEuNTc1YS42Ni42NiwwLDAsMSwuNTI1LS4yNjNoMy4yODFhLjY2LjY2LDAsMCwxLC41MjUuMjYzbC43ODgsMS4wNUg2LjIzNFpNMTUuNzUsMTkuMDMxYS42NTYuNjU2LDAsMCwxLS42NTYuNjU2SDMuMjgxYS42NTYuNjU2LDAsMCwxLS42NTYtLjY1NlYzLjkzOEgxNS43NVpNOC44NTksMTcuNzE5aC42NTZhLjMyOC4zMjgsMCwwLDAsLjMyOC0uMzI4VjYuMjM0YS4zMjguMzI4LDAsMCwwLS4zMjgtLjMyOEg4Ljg1OWEuMzI4LjMyOCwwLDAsMC0uMzI4LjMyOFYxNy4zOTFBLjMyOC4zMjgsMCwwLDAsOC44NTksMTcuNzE5WiIgZmlsbD0iI2ZhM2QzZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "j9i1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _WEBSITE_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _LOCAL_BUILD; });
/* unused harmony export _LAB_BUILD */
var _WEBSITE_VERSION = 'jp';
var _LOCAL_BUILD = false;
var _LAB_BUILD = false;

/***/ }),

/***/ "jHy4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/newBorCor.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var newBorCor = ({
  props: {
    type: {
      type: String,
      default: function _default() {
        return 'bottom';
      }
    },
    reverse: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    arrow: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    tooltip: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    display: {
      type: Boolean,
      default: function _default() {
        return null;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // style
    customStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    width: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    background: {
      type: String,
      default: function _default() {
        return 'white';
      }
    },
    border: {
      type: String,
      default: function _default() {
        return '#aaaaaa';
      }
    },
    radius: {
      type: String,
      default: function _default() {
        return '3px';
      }
    },
    shadow: {
      type: String,
      default: function _default() {
        return '1px 2px 3px rgba(0, 0, 0, 0.16)';
      }
    },
    translate: {
      type: String,
      default: function _default() {
        return '0px';
      }
    },
    deviation: {
      type: String,
      default: function _default() {
        return '15px 15px';
      }
    },
    arrowSize: {
      type: String,
      default: function _default() {
        return '10px 10px';
      }
    },
    cursorSize: {
      type: String,
      default: function _default() {
        return '40px 40px';
      }
    },
    blockStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    menuBlockStyle: function menuBlockStyle() {
      var width = this.width || 'auto';
      var style = {
        width: width,
        'white-space': width !== 'auto' ? 'pre-line' : 'nowrap',
        '--bg-color': this.background,
        '--bd-color': this.border,
        '--br-value': this.radius
      };
      return extends_default()({}, style, this.blockStyle);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcec4504","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/newBorCor.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bor-cor new",class:{ 'no-arrow': !_vm.arrow, 'is-tooltip': _vm.tooltip },style:(_vm.customStyle)},[_c('div',{staticClass:"trigger",class:{ display: _vm.display !== false, 'always-display': _vm.display }},[_vm._t("trigger")],2),_vm._v(" "),(!_vm.disabled && (_vm.display !== false))?_c('div',{staticClass:"menu-container",class:[_vm.type, { reverse: _vm.reverse }],style:({
      'transform': 'translateX(' + _vm.translate + ')',
      '--sd-style': _vm.shadow,
      '--dvt-v': _vm.deviation.split(' ')[0],
      '--dvt-h': _vm.deviation.split(' ')[1],
      '--arw-w': _vm.arrowSize.split(' ')[0],
      '--arw-h': _vm.arrowSize.split(' ')[1],
      '--cbc-w': _vm.cursorSize.split(' ')[0],
      '--cbc-h': _vm.cursorSize.split(' ')[1],
      '--tt-v': (_vm.tooltip || {}).v || '5px',
      '--tt-h': (_vm.tooltip || {}).h || '5px'
    }),on:{"mouseleave":function (e) { return _vm.$emit('leave'); }}},[_c('div',{staticClass:"menu-block",style:(_vm.menuBlockStyle)},[_vm._t("content")],2),_vm._v(" "),(!_vm.tooltip)?_c('span',{staticClass:"cursor-bor-cor"}):_vm._e(),_vm._v(" "),(_vm.arrow && !_vm.tooltip)?[_c('span',{staticClass:"menu-bor-cor shadow-top",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-left",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-right",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor",style:({ '--bg-color': _vm.background })})]:_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_newBorCor = (esExports);
// CONCATENATED MODULE: ./src/components/tool/newBorCor.vue
function injectStyle (ssrContext) {
  __webpack_require__("L+Gk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  newBorCor,
  tool_newBorCor,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_newBorCor = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jNsU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),

/***/ "jlnm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/api/config.js
var api_config = __webpack_require__("T452");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/userPermission.vue





/* harmony default export */ var userPermission = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user', 'userSetting']), {
    avatarUrl: function avatarUrl() {
      var avatar = this.avatar || (this.userSetting || {}).avatar_file || {};
      if (avatar.id || avatar.url) {
        var config = this.$ls.get('userInfo');
        return avatar.url || api_config["a" /* API_ROOT */] + 'global/files/download?file_id=' + avatar.id + '&class_name=' + avatar.class_name + '&access_token=' + config['access_token'];
      } else {
        return __webpack_require__("GW3Y");
      }
    }
  }),
  methods: {
    rolePermission: function rolePermission(roles) {
      return roles.includes((this.user || {}).role);
    }
  }
});
// CONCATENATED MODULE: ./src/mixins/userPermission.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  userPermission,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_userPermission = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k4Yl":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzY4ODMiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDY4ODMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTcyIC0xNTMzKSI+CiAgICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTYuMDcxLDUwSDEuOTI5QTEuOTI5LDEuOTI5LDAsMCwxLDAsNDguMDcxVjMzLjkyOUExLjkyOSwxLjkyOSwwLDAsMSwxLjkyOSwzMkgxNi4wNzFBMS45MjksMS45MjksMCwwLDEsMTgsMzMuOTI5VjQ4LjA3MUExLjkyOSwxLjkyOSwwLDAsMSwxNi4wNzEsNTBaTTcuODQ3LDQ2LjA2bDcuMzkzLTcuMzkzYS42NDMuNjQzLDAsMCwwLDAtLjkwOWwtLjkwOS0uOTA5YS42NDMuNjQzLDAsMCwwLS45MDksMEw3LjM5Myw0Mi44NzgsNC41NzgsNDAuMDYzYS42NDMuNjQzLDAsMCwwLS45MDksMGwtLjkwOS45MDlhLjY0My42NDMsMCwwLDAsMCwuOTA5TDYuOTM4LDQ2LjA2QS42NDMuNjQzLDAsMCwwLDcuODQ3LDQ2LjA2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3MiAxNTAxKSIgZmlsbD0iI2ZmZmZmZiIvPgogICAgPGcgaWQ9IuODkeOCuV81MTUiIGRhdGEtbmFtZT0i44OR44K5IDUxNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3MiAxNTMzKSIgZmlsbD0ibm9uZSI+CiAgICAgIDxwYXRoIGQ9Ik0yLDBIMTZhMiwyLDAsMCwxLDIsMlYxNmEyLDIsMCwwLDEtMiwySDJhMiwyLDAsMCwxLTItMlYyQTIsMiwwLDAsMSwyLDBaIiBzdHJva2U9Im5vbmUiLz4KICAgICAgPHBhdGggZD0iTSAyIDEgQyAxLjQ0ODYwMDc2OTA0Mjk2OSAxIDEgMS40NDg2MDA3NjkwNDI5NjkgMSAyIEwgMSAxNiBDIDEgMTYuNTUxMzk5MjMwOTU3MDMgMS40NDg2MDA3NjkwNDI5NjkgMTcgMiAxNyBMIDE2IDE3IEMgMTYuNTUxMzk5MjMwOTU3MDMgMTcgMTcgMTYuNTUxMzk5MjMwOTU3MDMgMTcgMTYgTCAxNyAyIEMgMTcgMS40NDg2MDA3NjkwNDI5NjkgMTYuNTUxMzk5MjMwOTU3MDMgMSAxNiAxIEwgMiAxIE0gMiAwIEwgMTYgMCBDIDE3LjEwNDU3MDM4ODc5Mzk1IDAgMTggMC44OTU0Mjk2MTEyMDYwNTQ3IDE4IDIgTCAxOCAxNiBDIDE4IDE3LjEwNDU3MDM4ODc5Mzk1IDE3LjEwNDU3MDM4ODc5Mzk1IDE4IDE2IDE4IEwgMiAxOCBDIDAuODk1NDI5NjExMjA2MDU0NyAxOCAwIDE3LjEwNDU3MDM4ODc5Mzk1IDAgMTYgTCAwIDIgQyAwIDAuODk1NDI5NjExMjA2MDU0NyAwLjg5NTQyOTYxMTIwNjA1NDcgMCAyIDAgWiIgc3Ryb2tlPSJub25lIiBmaWxsPSJ0cmFuc3BhcmVudCIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "kz4M":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2lyY2xlLXF1YXJ0ZXJzLXNvbGlkIiBkPSJNMTAsMEExMCwxMCwwLDEsMCwyMCwxMCwxMCwxMCwwLDAsMCwxMCwwWm01LjMsMTUuM0wxMCwxMCw0LjcsMTUuM0E3LjUwNSw3LjUwNSwwLDAsMSw0LjcsNC43TDEwLDEwbDUuMy01LjNhNy41MDcsNy41MDcsMCwwLDEsMCwxMC42MDlaIiBmaWxsPSIjODNjOTFlIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "mf7a":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4LjIiIGhlaWdodD0iMTIuMiIgdmlld0JveD0iMCAwIDguMiAxMi4yIj4KICA8cGF0aCBpZD0ic2xpZGVycy1zaW1wbGUtbGlnaHQiIGQ9Ik0xLjg3NSw2OUExLjEyNSwxLjEyNSwwLDEsMCwzLDcwLjEyNSwxLjEyNSwxLjEyNSwwLDAsMCwxLjg3NSw2OVptMS44MzcuNzVoNy45MTJhLjM3NS4zNzUsMCwwLDEsMCwuNzVIMy43MTJhMS44NzUsMS44NzUsMCwxLDEsMC0uNzVaTTksNjUuODc1YTEuMTI1LDEuMTI1LDAsMSwwLDEuMTI1LTEuMTI1QTEuMTI1LDEuMTI1LDAsMCwwLDksNjUuODc1Wk04LjI4Nyw2NS41YTEuODc1LDEuODc1LDAsMSwxLDAsLjc1SC4zNzVhLjM3NS4zNzUsMCwxLDEsMC0uNzVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjMuOSAxMi4xKSByb3RhdGUoLTkwKSIgZmlsbD0iIzAwMzY3OSIgc3Ryb2tlPSIjMDAzNjc5IiBzdHJva2Utd2lkdGg9IjAuMiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "mr+9":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Cardiology.svg": "SRag",
	"./Dermatology.svg": "SQy7",
	"./Ear, Nose & Throat.svg": "6Qul",
	"./Endocrinology.svg": "V8EM",
	"./Gastroenterology & Hepatology.svg": "vOTy",
	"./Hematology.svg": "x9yG",
	"./Hereditary Cancer.svg": "HCoM",
	"./Immunology.svg": "iva/",
	"./Malformations.svg": "VBfA",
	"./Metabolic and Mitochondrial Disorders.svg": "HZ4l",
	"./NBS.svg": "hVPs",
	"./Nephrology.svg": "FUqK",
	"./Neurology.svg": "M0RH",
	"./Ophthalmology.svg": "K4Tr",
	"./Osteology.svg": "F9Jn",
	"./Others.svg": "XE98",
	"./Pulmonology.svg": "SkAt",
	"./Reproductive.svg": "Mt5Y"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mr+9";

/***/ }),

/***/ "n3Bz":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTYgOCI+CiAgPHBhdGggaWQ9ImNoZXZyb24tZG93bi1yZWd1bGFyIiBkPSJNMTUuODczLjczNywxNS4xNTcuMTExYS40NzkuNDc5LDAsMCwwLS42MTQsMEw4LDUuODIsMS40NTcuMTExYS40NzkuNDc5LDAsMCwwLS42MTQsMEwuMTI3LjczN2EuMzQ3LjM0NywwLDAsMCwwLC41MzdMNy42OTMsNy44ODlhLjQ3OS40NzksMCwwLDAsLjYxNCwwbDcuNTY2LTYuNjE1QS4zNDcuMzQ3LDAsMCwwLDE1Ljg3My43MzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNiA4KSByb3RhdGUoMTgwKSIgZmlsbD0iIzAwMzY3OSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "nfOD":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDIwIDE0Ij4KICA8cGF0aCBpZD0iY2xvdWQtdXBsb2FkLXNvbGlkIiBkPSJNMTYuOCwzOC4wODFBMywzLDAsMCwwLDE0LDM0YTIuOTg1LDIuOTg1LDAsMCwwLTEuNjY2LjUwNkE1LDUsMCwwLDAsMywzN2MwLC4wODQsMCwuMTY5LjAwNi4yNTNBNC41LDQuNSwwLDAsMCw0LjUsNDZIMTZhNCw0LDAsMCwwLC44LTcuOTE5Wm0tNC4zNzIsMS45OTEtLjMzNy4zMzhhLjc1My43NTMsMCwwLDEtMS4wNzgtLjAxNkwxMCwzOS4zMTZWNDMuMjVhLjc0OC43NDgsMCwwLDEtLjc1Ljc1aC0uNUEuNzQ4Ljc0OCwwLDAsMSw4LDQzLjI1VjM5LjMxNkw2Ljk4OCw0MC4zOTRhLjc1Ljc1LDAsMCwxLTEuMDc4LjAxNmwtLjMzOC0uMzM4YS43NDcuNzQ3LDAsMCwxLDAtMS4wNTlsMi45LTIuOWEuNzQ3Ljc0NywwLDAsMSwxLjA1OSwwbDIuOSwyLjlBLjc1Ljc1LDAsMCwxLDEyLjQyOCw0MC4wNzJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMikiIGZpbGw9IiMwMDM2NzkiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "nzHv":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzY1MTAiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDY1MTAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwMzQ0IDU2MDIpIj4KICAgIDxyZWN0IGlkPSLplbfmlrnlvaJfMTc3MyIgZGF0YS1uYW1lPSLplbfmlrnlvaIgMTc3MyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjAzNDQgLTU2MDIpIiBmaWxsPSIjZmZmIiBvcGFjaXR5PSIwIi8+CiAgICA8cGF0aCBpZD0idGltZXMtbGlnaHQiIGQ9Ik03LjI3MywxMDJsMy44NDYtMy44NDYuNzkzLS43OTNhLjMuMywwLDAsMCwwLS40MjRsLS44NDktLjg0OWEuMy4zLDAsMCwwLS40MjQsMEw2LDEwMC43MjdsLTQuNjM5LTQuNjRhLjMuMywwLDAsMC0uNDI0LDBsLS44NDkuODQ5YS4zLjMsMCwwLDAsMCwuNDI0TDQuNzI3LDEwMmwtNC42NCw0LjYzOWEuMy4zLDAsMCwwLDAsLjQyNGwuODQ5Ljg0OWEuMy4zLDAsMCwwLC40MjQsMEw2LDEwMy4yNzNsMy44NDYsMy44NDYuNzkzLjc5M2EuMy4zLDAsMCwwLC40MjQsMGwuODQ5LS44NDlhLjMuMywwLDAsMCwwLS40MjRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjAzNDAgLTU2OTQpIiBmaWxsPSIjOTk5IiBvcGFjaXR5PSIwLjYiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "o5Lq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oZ+u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oeo/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/@vue/composition-api/dist/vue-composition-api.mjs
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/**
 * Displays a warning message (using console.error) with a stack trace if the
 * function is called inside of active component.
 *
 * @param message warning message to be displayed
 */
function warn$1(message) {
    var _a;
    warn(message, (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy);
}

var activeEffectScope;
var effectScopeStack = [];
var EffectScopeImpl = /** @class */ (function () {
    function EffectScopeImpl(vm) {
        this.active = true;
        this.effects = [];
        this.cleanups = [];
        this.vm = vm;
    }
    EffectScopeImpl.prototype.run = function (fn) {
        if (this.active) {
            try {
                this.on();
                return fn();
            }
            finally {
                this.off();
            }
        }
        else if ((false)) {
            warn$1("cannot run an inactive effect scope.");
        }
        return;
    };
    EffectScopeImpl.prototype.on = function () {
        if (this.active) {
            effectScopeStack.push(this);
            activeEffectScope = this;
        }
    };
    EffectScopeImpl.prototype.off = function () {
        if (this.active) {
            effectScopeStack.pop();
            activeEffectScope = effectScopeStack[effectScopeStack.length - 1];
        }
    };
    EffectScopeImpl.prototype.stop = function () {
        if (this.active) {
            this.vm.$destroy();
            this.effects.forEach(function (e) { return e.stop(); });
            this.cleanups.forEach(function (cleanup) { return cleanup(); });
            this.active = false;
        }
    };
    return EffectScopeImpl;
}());
var EffectScope = /** @class */ (function (_super) {
    __extends(EffectScope, _super);
    function EffectScope(detached) {
        if (detached === void 0) { detached = false; }
        var _this = this;
        var vm = undefined;
        withCurrentInstanceTrackingDisabled(function () {
            vm = defineComponentInstance(getVueConstructor());
        });
        _this = _super.call(this, vm) || this;
        if (!detached) {
            recordEffectScope(_this);
        }
        return _this;
    }
    return EffectScope;
}(EffectScopeImpl));
function recordEffectScope(effect, scope) {
    var _a;
    scope = scope || activeEffectScope;
    if (scope && scope.active) {
        scope.effects.push(effect);
        return;
    }
    // destory on parent component unmounted
    var vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    vm && vm.$on('hook:destroyed', function () { return effect.stop(); });
}
function effectScope(detached) {
    return new EffectScope(detached);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) {
        activeEffectScope.cleanups.push(fn);
    }
    else if ((false)) {
        warn$1("onScopeDispose() is called when there is no active effect scope" +
            " to be associated with.");
    }
}
/**
 * @internal
 **/
function getCurrentScopeVM() {
    var _a, _b;
    return ((_a = getCurrentScope()) === null || _a === void 0 ? void 0 : _a.vm) || ((_b = getCurrentInstance()) === null || _b === void 0 ? void 0 : _b.proxy);
}
/**
 * @internal
 **/
function bindCurrentScopeToVM(vm) {
    if (!vm.scope) {
        var scope_1 = new EffectScopeImpl(vm.proxy);
        vm.scope = scope_1;
        vm.proxy.$on('hook:destroyed', function () { return scope_1.stop(); });
    }
    return vm.scope;
}

var vueDependency = undefined;
try {
    var requiredVue = __webpack_require__("7+uW");
    if (requiredVue && isVue(requiredVue)) {
        vueDependency = requiredVue;
    }
    else if (requiredVue &&
        'default' in requiredVue &&
        isVue(requiredVue.default)) {
        vueDependency = requiredVue.default;
    }
}
catch (_a) {
    // not available
}
var vueConstructor = null;
var currentInstance = null;
var currentInstanceTracking = true;
var PluginInstalledFlag = '__composition_api_installed__';
function isVue(obj) {
    return obj && isFunction(obj) && obj.name === 'Vue';
}
function isVueRegistered(Vue) {
    // resolve issue: https://github.com/vuejs/composition-api/issues/876#issue-1087619365
    return vueConstructor && hasOwn(Vue, PluginInstalledFlag);
}
function getVueConstructor() {
    if ((false)) {
        assert(vueConstructor, "must call Vue.use(VueCompositionAPI) before using any function.");
    }
    return vueConstructor;
}
// returns registered vue or `vue` dependency
function getRegisteredVueOrDefault() {
    var constructor = vueConstructor || vueDependency;
    if ((false)) {
        assert(constructor, "No vue dependency found.");
    }
    return constructor;
}
function setVueConstructor(Vue) {
    // @ts-ignore
    if (false) {
        warn('[vue-composition-api] another instance of Vue installed');
    }
    vueConstructor = Vue;
    Object.defineProperty(Vue, PluginInstalledFlag, {
        configurable: true,
        writable: true,
        value: true,
    });
}
/**
 * For `effectScope` to create instance without populate the current instance
 * @internal
 **/
function withCurrentInstanceTrackingDisabled(fn) {
    var prev = currentInstanceTracking;
    currentInstanceTracking = false;
    try {
        fn();
    }
    finally {
        currentInstanceTracking = prev;
    }
}
function setCurrentInstance(instance) {
    if (!currentInstanceTracking)
        return;
    var prev = currentInstance;
    prev === null || prev === void 0 ? void 0 : prev.scope.off();
    currentInstance = instance;
    currentInstance === null || currentInstance === void 0 ? void 0 : currentInstance.scope.on();
}
function getCurrentInstance() {
    return currentInstance;
}
var instanceMapCache = new WeakMap();
function toVue3ComponentInstance(vm) {
    if (instanceMapCache.has(vm)) {
        return instanceMapCache.get(vm);
    }
    var instance = {
        proxy: vm,
        update: vm.$forceUpdate,
        type: vm.$options,
        uid: vm._uid,
        // $emit is defined on prototype and it expected to be bound
        emit: vm.$emit.bind(vm),
        parent: null,
        root: null, // to be immediately set
    };
    bindCurrentScopeToVM(instance);
    // map vm.$props =
    var instanceProps = [
        'data',
        'props',
        'attrs',
        'refs',
        'vnode',
        'slots',
    ];
    instanceProps.forEach(function (prop) {
        proxy(instance, prop, {
            get: function () {
                return vm["$".concat(prop)];
            },
        });
    });
    proxy(instance, 'isMounted', {
        get: function () {
            // @ts-expect-error private api
            return vm._isMounted;
        },
    });
    proxy(instance, 'isUnmounted', {
        get: function () {
            // @ts-expect-error private api
            return vm._isDestroyed;
        },
    });
    proxy(instance, 'isDeactivated', {
        get: function () {
            // @ts-expect-error private api
            return vm._inactive;
        },
    });
    proxy(instance, 'emitted', {
        get: function () {
            // @ts-expect-error private api
            return vm._events;
        },
    });
    instanceMapCache.set(vm, instance);
    if (vm.$parent) {
        instance.parent = toVue3ComponentInstance(vm.$parent);
    }
    if (vm.$root) {
        instance.root = toVue3ComponentInstance(vm.$root);
    }
    return instance;
}

var vue_composition_api_toString = function (x) { return Object.prototype.toString.call(x); };
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' &&
    isNative(Symbol) &&
    typeof Reflect !== 'undefined' &&
    isNative(Reflect.ownKeys);
var noopFn = function (_) { return _; };
function proxy(target, key, _a) {
    var get = _a.get, set = _a.set;
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: get || noopFn,
        set: set || noopFn,
    });
}
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true,
    });
}
function hasOwn(obj, key) {
    return Object.hasOwnProperty.call(obj, key);
}
function assert(condition, msg) {
    if (!condition) {
        throw new Error("[vue-composition-api] ".concat(msg));
    }
}
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        // $flow-disable-line
        typeof value === 'symbol' ||
        typeof value === 'boolean');
}
function isArray(x) {
    return Array.isArray(x);
}
var objectToString = Object.prototype.toString;
var toTypeString = function (value) {
    return objectToString.call(value);
};
var isMap = function (val) {
    return toTypeString(val) === '[object Map]';
};
var isSet = function (val) {
    return toTypeString(val) === '[object Set]';
};
var MAX_VALID_ARRAY_LENGTH = 4294967295; // Math.pow(2, 32) - 1
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return (n >= 0 &&
        Math.floor(n) === n &&
        isFinite(val) &&
        n <= MAX_VALID_ARRAY_LENGTH);
}
function isObject(val) {
    return val !== null && typeof val === 'object';
}
function isPlainObject(x) {
    return vue_composition_api_toString(x) === '[object Object]';
}
function isFunction(x) {
    return typeof x === 'function';
}
function isUndef(v) {
    return v === undefined || v === null;
}
function warn(msg, vm) {
    var Vue = getRegisteredVueOrDefault();
    if (!Vue || !Vue.util)
        console.warn("[vue-composition-api] ".concat(msg));
    else
        Vue.util.warn(msg, vm);
}
function logError(err, vm, info) {
    if ((false)) {
        warn("Error in ".concat(info, ": \"").concat(err.toString(), "\""), vm);
    }
    if (typeof window !== 'undefined' && typeof console !== 'undefined') {
        console.error(err);
    }
    else {
        throw err;
    }
}
/**
 * Object.is polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 * */
function isSame(value1, value2) {
    if (value1 === value2) {
        return value1 !== 0 || 1 / value1 === 1 / value2;
    }
    else {
        return value1 !== value1 && value2 !== value2;
    }
}

function getCurrentInstanceForFn(hook, target) {
    target = target || getCurrentInstance();
    if (false) {
        warn("".concat(hook, " is called when there is no active component instance to be ") +
            "associated with. " +
            "Lifecycle injection APIs can only be used during execution of setup().");
    }
    return target;
}
function defineComponentInstance(Ctor, options) {
    if (options === void 0) { options = {}; }
    var silent = Ctor.config.silent;
    Ctor.config.silent = true;
    var vm = new Ctor(options);
    Ctor.config.silent = silent;
    return vm;
}
function isComponentInstance(obj) {
    var Vue = getVueConstructor();
    return Vue && obj instanceof Vue;
}
function createSlotProxy(vm, slotName) {
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!vm.$scopedSlots[slotName]) {
            if ((false))
                return warn("slots.".concat(slotName, "() got called outside of the \"render()\" scope"), vm);
            return;
        }
        return vm.$scopedSlots[slotName].apply(vm, args);
    });
}
function resolveSlots(slots, normalSlots) {
    var res;
    if (!slots) {
        res = {};
    }
    else if (slots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return slots._normalized;
    }
    else {
        res = {};
        for (var key in slots) {
            if (slots[key] && key[0] !== '$') {
                res[key] = true;
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key in normalSlots) {
        if (!(key in res)) {
            res[key] = true;
        }
    }
    return res;
}
var vueInternalClasses;
var getVueInternalClasses = function () {
    if (!vueInternalClasses) {
        var vm = defineComponentInstance(getVueConstructor(), {
            computed: {
                value: function () {
                    return 0;
                },
            },
        });
        // to get Watcher class
        var Watcher = vm._computedWatchers.value.constructor;
        // to get Dep class
        var Dep = vm._data.__ob__.dep.constructor;
        vueInternalClasses = {
            Watcher: Watcher,
            Dep: Dep,
        };
        vm.$destroy();
    }
    return vueInternalClasses;
};

function createSymbol(name) {
    return hasSymbol ? Symbol.for(name) : name;
}
var WatcherPreFlushQueueKey = createSymbol('composition-api.preFlushQueue');
var WatcherPostFlushQueueKey = createSymbol('composition-api.postFlushQueue');
// must be a string, symbol key is ignored in reactive
var RefKey = 'composition-api.refKey';

var accessModifiedSet = new WeakMap();
var rawSet = new WeakMap();
var readonlySet = new WeakMap();

/**
 * Set a property on an object. Adds the new property, triggers change
 * notification and intercept it's subsequent access if the property doesn't
 * already exist.
 */
function set$1(target, key, val) {
    var Vue = getVueConstructor();
    // @ts-expect-error https://github.com/vuejs/vue/pull/12132
    var _a = Vue.util, warn = _a.warn, defineReactive = _a.defineReactive;
    if (false) {
        warn("Cannot set reactive property on undefined, null, or primitive value: ".concat(target));
    }
    var ob = target.__ob__;
    function ssrMockReactivity() {
        // in SSR, there is no __ob__. Mock for reactivity check
        if (ob && isObject(val) && !hasOwn(val, '__ob__')) {
            mockReactivityDeep(val);
        }
    }
    if (isArray(target)) {
        if (isValidArrayIndex(key)) {
            target.length = Math.max(target.length, key);
            target.splice(key, 1, val);
            ssrMockReactivity();
            return val;
        }
        else if (key === 'length' && val !== target.length) {
            target.length = val;
            ob === null || ob === void 0 ? void 0 : ob.dep.notify();
            return val;
        }
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        ssrMockReactivity();
        return val;
    }
    if (target._isVue || (ob && ob.vmCount)) {
        ("production" !== 'production') &&
            warn('Avoid adding reactive properties to a Vue instance or its root $data ' +
                'at runtime - declare it upfront in the data option.');
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val);
    // IMPORTANT: define access control before trigger watcher
    defineAccessControl(target, key, val);
    ssrMockReactivity();
    ob.dep.notify();
    return val;
}

var _isForceTrigger = false;
function isForceTrigger() {
    return _isForceTrigger;
}
function setForceTrigger(v) {
    _isForceTrigger = v;
}

var RefImpl = /** @class */ (function () {
    function RefImpl(_a) {
        var get = _a.get, set = _a.set;
        proxy(this, 'value', {
            get: get,
            set: set,
        });
    }
    return RefImpl;
}());
function createRef(options, isReadonly, isComputed) {
    if (isReadonly === void 0) { isReadonly = false; }
    if (isComputed === void 0) { isComputed = false; }
    var r = new RefImpl(options);
    // add effect to differentiate refs from computed
    if (isComputed)
        r.effect = true;
    // seal the ref, this could prevent ref from being observed
    // It's safe to seal the ref, since we really shouldn't extend it.
    // related issues: #79
    var sealed = Object.seal(r);
    if (isReadonly)
        readonlySet.set(sealed, true);
    return sealed;
}
function ref(raw) {
    var _a;
    if (isRef(raw)) {
        return raw;
    }
    var value = reactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function isRef(value) {
    return value instanceof RefImpl;
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
function toRefs(obj) {
    if (false) {
        warn("toRefs() expects a reactive object but received a plain one.");
    }
    if (!isPlainObject(obj))
        return obj;
    var ret = {};
    for (var key in obj) {
        ret[key] = toRef(obj, key);
    }
    return ret;
}
function customRef(factory) {
    var version = ref(0);
    return createRef(factory(function () { return void version.value; }, function () {
        ++version.value;
    }));
}
function toRef(object, key) {
    if (!(key in object))
        set$1(object, key, undefined);
    var v = object[key];
    if (isRef(v))
        return v;
    return createRef({
        get: function () { return object[key]; },
        set: function (v) { return (object[key] = v); },
    });
}
function shallowRef(raw) {
    var _a;
    if (isRef(raw)) {
        return raw;
    }
    var value = shallowReactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function triggerRef(value) {
    if (!isRef(value))
        return;
    setForceTrigger(true);
    value.value = value.value;
    setForceTrigger(false);
}
function proxyRefs(objectWithRefs) {
    var _a, e_1, _b;
    if (isReactive(objectWithRefs)) {
        return objectWithRefs;
    }
    var value = reactive((_a = {}, _a[RefKey] = objectWithRefs, _a));
    def(value, RefKey, value[RefKey], false);
    var _loop_1 = function (key) {
        proxy(value, key, {
            get: function () {
                if (isRef(value[RefKey][key])) {
                    return value[RefKey][key].value;
                }
                return value[RefKey][key];
            },
            set: function (v) {
                if (isRef(value[RefKey][key])) {
                    return (value[RefKey][key].value = unref(v));
                }
                value[RefKey][key] = unref(v);
            },
        });
    };
    try {
        for (var _c = __values(Object.keys(objectWithRefs)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var key = _d.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return value;
}

function isRaw(obj) {
    var _a;
    return Boolean(obj &&
        hasOwn(obj, '__ob__') &&
        typeof obj.__ob__ === 'object' &&
        ((_a = obj.__ob__) === null || _a === void 0 ? void 0 : _a.__raw__));
}
function isReactive(obj) {
    var _a;
    return Boolean(obj &&
        hasOwn(obj, '__ob__') &&
        typeof obj.__ob__ === 'object' &&
        !((_a = obj.__ob__) === null || _a === void 0 ? void 0 : _a.__raw__));
}
/**
 * Proxing property access of target.
 * We can do unwrapping and other things here.
 */
function setupAccessControl(target) {
    if (!isPlainObject(target) ||
        isRaw(target) ||
        isArray(target) ||
        isRef(target) ||
        isComponentInstance(target) ||
        accessModifiedSet.has(target))
        return;
    accessModifiedSet.set(target, true);
    var keys = Object.keys(target);
    for (var i = 0; i < keys.length; i++) {
        defineAccessControl(target, keys[i]);
    }
}
/**
 * Auto unwrapping when access property
 */
function defineAccessControl(target, key, val) {
    if (key === '__ob__')
        return;
    if (isRaw(target[key]))
        return;
    var getter;
    var setter;
    var property = Object.getOwnPropertyDescriptor(target, key);
    if (property) {
        if (property.configurable === false) {
            return;
        }
        getter = property.get;
        setter = property.set;
        if ((!getter || setter) /* not only have getter */ &&
            arguments.length === 2) {
            val = target[key];
        }
    }
    setupAccessControl(val);
    proxy(target, key, {
        get: function getterHandler() {
            var value = getter ? getter.call(target) : val;
            // if the key is equal to RefKey, skip the unwrap logic
            if (key !== RefKey && isRef(value)) {
                return value.value;
            }
            else {
                return value;
            }
        },
        set: function setterHandler(newVal) {
            if (getter && !setter)
                return;
            // If the key is equal to RefKey, skip the unwrap logic
            // If and only if "value" is ref and "newVal" is not a ref,
            // the assignment should be proxied to "value" ref.
            if (key !== RefKey && isRef(val) && !isRef(newVal)) {
                val.value = newVal;
            }
            else if (setter) {
                setter.call(target, newVal);
                val = newVal;
            }
            else {
                val = newVal;
            }
            setupAccessControl(newVal);
        },
    });
}
function observe(obj) {
    var Vue = getRegisteredVueOrDefault();
    var observed;
    if (Vue.observable) {
        observed = Vue.observable(obj);
    }
    else {
        var vm = defineComponentInstance(Vue, {
            data: {
                $$state: obj,
            },
        });
        observed = vm._data.$$state;
    }
    // in SSR, there is no __ob__. Mock for reactivity check
    if (!hasOwn(observed, '__ob__')) {
        mockReactivityDeep(observed);
    }
    return observed;
}
/**
 * Mock __ob__ for object recursively
 */
function mockReactivityDeep(obj, seen) {
    var e_1, _a;
    if (seen === void 0) { seen = new Set(); }
    if (seen.has(obj) || hasOwn(obj, '__ob__') || !Object.isExtensible(obj))
        return;
    def(obj, '__ob__', mockObserver(obj));
    seen.add(obj);
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            var value = obj[key];
            if (!(isPlainObject(value) || isArray(value)) ||
                isRaw(value) ||
                !Object.isExtensible(value)) {
                continue;
            }
            mockReactivityDeep(value, seen);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function mockObserver(value) {
    if (value === void 0) { value = {}; }
    return {
        value: value,
        dep: {
            notify: noopFn,
            depend: noopFn,
            addSub: noopFn,
            removeSub: noopFn,
        },
    };
}
function createObserver() {
    return observe({}).__ob__;
}
function shallowReactive(obj) {
    var e_2, _a;
    if (!isObject(obj)) {
        if ((false)) {
            warn('"shallowReactive()" must be called on an object.');
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        isRaw(obj) ||
        !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(isArray(obj) ? [] : {});
    var ob = observed.__ob__;
    var _loop_1 = function (key) {
        var val = obj[key];
        var getter;
        var setter;
        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property) {
            if (property.configurable === false) {
                return "continue";
            }
            getter = property.get;
            setter = property.set;
        }
        proxy(observed, key, {
            get: function getterHandler() {
                var _a;
                var value = getter ? getter.call(obj) : val;
                (_a = ob.dep) === null || _a === void 0 ? void 0 : _a.depend();
                return value;
            },
            set: function setterHandler(newVal) {
                var _a;
                if (getter && !setter)
                    return;
                var value = getter ? getter.call(obj) : val;
                if (!isForceTrigger() && value === newVal)
                    return;
                if (setter) {
                    setter.call(obj, newVal);
                }
                else {
                    val = newVal;
                }
                (_a = ob.dep) === null || _a === void 0 ? void 0 : _a.notify();
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return observed;
}
/**
 * Make obj reactivity
 */
function reactive(obj) {
    if (!isObject(obj)) {
        if ((false)) {
            warn('"reactive()" must be called on an object.');
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        isRaw(obj) ||
        !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(obj);
    setupAccessControl(observed);
    return observed;
}
/**
 * Make sure obj can't be a reactive
 */
function markRaw(obj) {
    if (!(isPlainObject(obj) || isArray(obj)) || !Object.isExtensible(obj)) {
        return obj;
    }
    // set the vue observable flag at obj
    var ob = createObserver();
    ob.__raw__ = true;
    def(obj, '__ob__', ob);
    // mark as Raw
    rawSet.set(obj, true);
    return obj;
}
function toRaw(observed) {
    var _a, _b;
    if (isRaw(observed) || !Object.isExtensible(observed)) {
        return observed;
    }
    return ((_b = (_a = observed) === null || _a === void 0 ? void 0 : _a.__ob__) === null || _b === void 0 ? void 0 : _b.value) || observed;
}

function isReadonly(obj) {
    return readonlySet.has(obj);
}
/**
 * **In @vue/composition-api, `reactive` only provides type-level readonly check**
 *
 * Creates a readonly copy of the original object. Note the returned copy is not
 * made reactive, but `readonly` can be called on an already reactive object.
 */
function readonly(target) {
    if (false) {
        warn("value cannot be made reactive: ".concat(String(target)));
    }
    else {
        readonlySet.set(target, true);
    }
    return target;
}
function shallowReadonly(obj) {
    var e_1, _a;
    if (!isObject(obj)) {
        if ((false)) {
            warn("value cannot be made reactive: ".concat(String(obj)));
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        (!Object.isExtensible(obj) && !isRef(obj))) {
        return obj;
    }
    var readonlyObj = isRef(obj)
        ? new RefImpl({})
        : isReactive(obj)
            ? observe({})
            : {};
    var source = reactive({});
    var ob = source.__ob__;
    var _loop_1 = function (key) {
        var val = obj[key];
        var getter;
        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property) {
            if (property.configurable === false && !isRef(obj)) {
                return "continue";
            }
            getter = property.get;
        }
        proxy(readonlyObj, key, {
            get: function getterHandler() {
                var value = getter ? getter.call(obj) : val;
                ob.dep.depend();
                return value;
            },
            set: function (v) {
                if ((false)) {
                    warn("Set operation on key \"".concat(key, "\" failed: target is readonly."));
                }
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    readonlySet.set(readonlyObj, true);
    return readonlyObj;
}

/**
 * Delete a property and trigger change if necessary.
 */
function del(target, key) {
    var Vue = getVueConstructor();
    var warn = Vue.util.warn;
    if (false) {
        warn("Cannot delete reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
        ("production" !== 'production') &&
            warn('Avoid deleting properties on a Vue instance or its root $data ' +
                '- just set it to null.');
        return;
    }
    if (!hasOwn(target, key)) {
        return;
    }
    delete target[key];
    if (!ob) {
        return;
    }
    ob.dep.notify();
}

var genName = function (name) { return "on".concat(name[0].toUpperCase() + name.slice(1)); };
function createLifeCycle(lifeCyclehook) {
    return function (callback, target) {
        var instance = getCurrentInstanceForFn(genName(lifeCyclehook), target);
        return (instance &&
            injectHookOption(getVueConstructor(), instance, lifeCyclehook, callback));
    };
}
function injectHookOption(Vue, instance, hook, val) {
    var options = instance.proxy.$options;
    var mergeFn = Vue.config.optionMergeStrategies[hook];
    var wrappedHook = wrapHookCall(instance, val);
    options[hook] = mergeFn(options[hook], wrappedHook);
    return wrappedHook;
}
function wrapHookCall(instance, fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var prev = getCurrentInstance();
        setCurrentInstance(instance);
        try {
            return fn.apply(void 0, __spreadArray([], __read(args), false));
        }
        finally {
            setCurrentInstance(prev);
        }
    };
}
var onBeforeMount = createLifeCycle('beforeMount');
var onMounted = createLifeCycle('mounted');
var onBeforeUpdate = createLifeCycle('beforeUpdate');
var onUpdated = createLifeCycle('updated');
var onBeforeUnmount = createLifeCycle('beforeDestroy');
var onUnmounted = createLifeCycle('destroyed');
var onErrorCaptured = createLifeCycle('errorCaptured');
var onActivated = createLifeCycle('activated');
var onDeactivated = createLifeCycle('deactivated');
var onServerPrefetch = createLifeCycle('serverPrefetch');

var fallbackVM;
function flushPreQueue() {
    flushQueue(this, WatcherPreFlushQueueKey);
}
function flushPostQueue() {
    flushQueue(this, WatcherPostFlushQueueKey);
}
function hasWatchEnv(vm) {
    return vm[WatcherPreFlushQueueKey] !== undefined;
}
function installWatchEnv(vm) {
    vm[WatcherPreFlushQueueKey] = [];
    vm[WatcherPostFlushQueueKey] = [];
    vm.$on('hook:beforeUpdate', flushPreQueue);
    vm.$on('hook:updated', flushPostQueue);
}
function getWatcherOption(options) {
    return __assign({
        immediate: false,
        deep: false,
        flush: 'pre',
    }, options);
}
function getWatchEffectOption(options) {
    return __assign({
        flush: 'pre',
    }, options);
}
function getWatcherVM() {
    var vm = getCurrentScopeVM();
    if (!vm) {
        if (!fallbackVM) {
            fallbackVM = defineComponentInstance(getVueConstructor());
        }
        vm = fallbackVM;
    }
    else if (!hasWatchEnv(vm)) {
        installWatchEnv(vm);
    }
    return vm;
}
function flushQueue(vm, key) {
    var queue = vm[key];
    for (var index = 0; index < queue.length; index++) {
        queue[index]();
    }
    queue.length = 0;
}
function queueFlushJob(vm, fn, mode) {
    // flush all when beforeUpdate and updated are not fired
    var fallbackFlush = function () {
        vm.$nextTick(function () {
            if (vm[WatcherPreFlushQueueKey].length) {
                flushQueue(vm, WatcherPreFlushQueueKey);
            }
            if (vm[WatcherPostFlushQueueKey].length) {
                flushQueue(vm, WatcherPostFlushQueueKey);
            }
        });
    };
    switch (mode) {
        case 'pre':
            fallbackFlush();
            vm[WatcherPreFlushQueueKey].push(fn);
            break;
        case 'post':
            fallbackFlush();
            vm[WatcherPostFlushQueueKey].push(fn);
            break;
        default:
            assert(false, "flush must be one of [\"post\", \"pre\", \"sync\"], but got ".concat(mode));
            break;
    }
}
function createVueWatcher(vm, getter, callback, options) {
    var index = vm._watchers.length;
    // @ts-ignore: use undocumented options
    vm.$watch(getter, callback, {
        immediate: options.immediateInvokeCallback,
        deep: options.deep,
        lazy: options.noRun,
        sync: options.sync,
        before: options.before,
    });
    return vm._watchers[index];
}
// We have to monkeypatch the teardown function so Vue will run
// runCleanup() when it tears down the watcher on unmounted.
function patchWatcherTeardown(watcher, runCleanup) {
    var _teardown = watcher.teardown;
    watcher.teardown = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        _teardown.apply(watcher, args);
        runCleanup();
    };
}
function createWatcher(vm, source, cb, options) {
    var _a;
    if (false) {
        if (options.immediate !== undefined) {
            warn("watch() \"immediate\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
        if (options.deep !== undefined) {
            warn("watch() \"deep\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
    }
    var flushMode = options.flush;
    var isSync = flushMode === 'sync';
    var cleanup;
    var registerCleanup = function (fn) {
        cleanup = function () {
            try {
                fn();
            }
            catch (
            // FIXME: remove any
            error) {
                logError(error, vm, 'onCleanup()');
            }
        };
    };
    // cleanup before running getter again
    var runCleanup = function () {
        if (cleanup) {
            cleanup();
            cleanup = null;
        }
    };
    var createScheduler = function (fn) {
        if (isSync ||
            /* without a current active instance, ignore pre|post mode */ vm ===
                fallbackVM) {
            return fn;
        }
        return (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return queueFlushJob(vm, function () {
                fn.apply(void 0, __spreadArray([], __read(args), false));
            }, flushMode);
        });
    };
    // effect watch
    if (cb === null) {
        var running_1 = false;
        var getter_1 = function () {
            // preventing the watch callback being call in the same execution
            if (running_1) {
                return;
            }
            try {
                running_1 = true;
                source(registerCleanup);
            }
            finally {
                running_1 = false;
            }
        };
        var watcher_1 = createVueWatcher(vm, getter_1, noopFn, {
            deep: options.deep || false,
            sync: isSync,
            before: runCleanup,
        });
        patchWatcherTeardown(watcher_1, runCleanup);
        // enable the watcher update
        watcher_1.lazy = false;
        var originGet = watcher_1.get.bind(watcher_1);
        // always run watchEffect
        watcher_1.get = createScheduler(originGet);
        return function () {
            watcher_1.teardown();
        };
    }
    var deep = options.deep;
    var isMultiSource = false;
    var getter;
    if (isRef(source)) {
        getter = function () { return source.value; };
    }
    else if (isReactive(source)) {
        getter = function () { return source; };
        deep = true;
    }
    else if (isArray(source)) {
        isMultiSource = true;
        getter = function () {
            return source.map(function (s) {
                if (isRef(s)) {
                    return s.value;
                }
                else if (isReactive(s)) {
                    return traverse(s);
                }
                else if (isFunction(s)) {
                    return s();
                }
                else {
                    ("production" !== 'production') &&
                        warn("Invalid watch source: ".concat(JSON.stringify(s), ".\n          A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."), vm);
                    return noopFn;
                }
            });
        };
    }
    else if (isFunction(source)) {
        getter = source;
    }
    else {
        getter = noopFn;
        ("production" !== 'production') &&
            warn("Invalid watch source: ".concat(JSON.stringify(source), ".\n      A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."), vm);
    }
    if (deep) {
        var baseGetter_1 = getter;
        getter = function () { return traverse(baseGetter_1()); };
    }
    var applyCb = function (n, o) {
        if (!deep &&
            isMultiSource &&
            n.every(function (v, i) { return isSame(v, o[i]); }))
            return;
        // cleanup before running cb again
        runCleanup();
        return cb(n, o, registerCleanup);
    };
    var callback = createScheduler(applyCb);
    if (options.immediate) {
        var originalCallback_1 = callback;
        // `shiftCallback` is used to handle the first sync effect run.
        // The subsequent callbacks will redirect to `callback`.
        var shiftCallback_1 = function (n, o) {
            shiftCallback_1 = originalCallback_1;
            // o is undefined on the first call
            return applyCb(n, isArray(n) ? [] : o);
        };
        callback = function (n, o) {
            return shiftCallback_1(n, o);
        };
    }
    // @ts-ignore: use undocumented option "sync"
    var stop = vm.$watch(getter, callback, {
        immediate: options.immediate,
        deep: deep,
        sync: isSync,
    });
    // Once again, we have to hack the watcher for proper teardown
    var watcher = vm._watchers[vm._watchers.length - 1];
    // if the return value is reactive and deep:true
    // watch for changes, this might happen when new key is added
    if (isReactive(watcher.value) && ((_a = watcher.value.__ob__) === null || _a === void 0 ? void 0 : _a.dep) && deep) {
        watcher.value.__ob__.dep.addSub({
            update: function () {
                // this will force the source to be revaluated and the callback
                // executed if needed
                watcher.run();
            },
        });
    }
    patchWatcherTeardown(watcher, runCleanup);
    return function () {
        stop();
    };
}
function watchEffect(effect, options) {
    var opts = getWatchEffectOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, effect, null, opts);
}
function watchPostEffect(effect) {
    return watchEffect(effect, { flush: 'post' });
}
function watchSyncEffect(effect) {
    return watchEffect(effect, { flush: 'sync' });
}
// implementation
function watch(source, cb, options) {
    var callback = null;
    if (isFunction(cb)) {
        // source watch
        callback = cb;
    }
    else {
        // effect watch
        if ((false)) {
            warn("`watch(fn, options?)` signature has been moved to a separate API. " +
                "Use `watchEffect(fn, options?)` instead. `watch` now only " +
                "supports `watch(source, cb, options?) signature.");
        }
        options = cb;
        callback = null;
    }
    var opts = getWatcherOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, source, callback, opts);
}
function traverse(value, seen) {
    if (seen === void 0) { seen = new Set(); }
    if (!isObject(value) || seen.has(value) || rawSet.has(value)) {
        return value;
    }
    seen.add(value);
    if (isRef(value)) {
        traverse(value.value, seen);
    }
    else if (isArray(value)) {
        for (var i = 0; i < value.length; i++) {
            traverse(value[i], seen);
        }
    }
    else if (isSet(value) || isMap(value)) {
        value.forEach(function (v) {
            traverse(v, seen);
        });
    }
    else if (isPlainObject(value)) {
        for (var key in value) {
            traverse(value[key], seen);
        }
    }
    return value;
}

// implement
function computed(getterOrOptions) {
    var vm = getCurrentScopeVM();
    var getter;
    var setter;
    if (isFunction(getterOrOptions)) {
        getter = getterOrOptions;
    }
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var computedSetter;
    var computedGetter;
    if (vm && !vm.$isServer) {
        var _a = getVueInternalClasses(), Watcher_1 = _a.Watcher, Dep_1 = _a.Dep;
        var watcher_1;
        computedGetter = function () {
            if (!watcher_1) {
                watcher_1 = new Watcher_1(vm, getter, noopFn, { lazy: true });
            }
            if (watcher_1.dirty) {
                watcher_1.evaluate();
            }
            if (Dep_1.target) {
                watcher_1.depend();
            }
            return watcher_1.value;
        };
        computedSetter = function (v) {
            if (false) {
                warn('Write operation failed: computed value is readonly.', vm);
                return;
            }
            if (setter) {
                setter(v);
            }
        };
    }
    else {
        // fallback
        var computedHost_1 = defineComponentInstance(getVueConstructor(), {
            computed: {
                $$state: {
                    get: getter,
                    set: setter,
                },
            },
        });
        vm && vm.$on('hook:destroyed', function () { return computedHost_1.$destroy(); });
        computedGetter = function () { return computedHost_1.$$state; };
        computedSetter = function (v) {
            if (false) {
                warn('Write operation failed: computed value is readonly.', vm);
                return;
            }
            computedHost_1.$$state = v;
        };
    }
    return createRef({
        get: computedGetter,
        set: computedSetter,
    }, !setter, true);
}

var NOT_FOUND = {};
function resolveInject(provideKey, vm) {
    var source = vm;
    while (source) {
        // @ts-ignore
        if (source._provided && hasOwn(source._provided, provideKey)) {
            //@ts-ignore
            return source._provided[provideKey];
        }
        source = source.$parent;
    }
    return NOT_FOUND;
}
function provide(key, value) {
    var _a;
    var vm = (_a = getCurrentInstanceForFn('provide')) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!vm)
        return;
    if (!vm._provided) {
        var provideCache_1 = {};
        proxy(vm, '_provided', {
            get: function () { return provideCache_1; },
            set: function (v) { return Object.assign(provideCache_1, v); },
        });
    }
    vm._provided[key] = value;
}
function inject(key, defaultValue, treatDefaultAsFactory) {
    var _a;
    if (treatDefaultAsFactory === void 0) { treatDefaultAsFactory = false; }
    var vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!vm) {
        ("production" !== 'production') &&
            warn("inject() can only be used inside setup() or functional components.");
        return;
    }
    if (!key) {
        ("production" !== 'production') && warn("injection \"".concat(String(key), "\" not found."), vm);
        return defaultValue;
    }
    var val = resolveInject(key, vm);
    if (val !== NOT_FOUND) {
        return val;
    }
    if (defaultValue === undefined && ("production" !== 'production')) {
        warn("Injection \"".concat(String(key), "\" not found"), vm);
    }
    return treatDefaultAsFactory && isFunction(defaultValue)
        ? defaultValue()
        : defaultValue;
}

var EMPTY_OBJ = ( false)
    ? Object.freeze({})
    : {};
var useCssModule = function (name) {
    var _a;
    if (name === void 0) { name = '$style'; }
    var instance = getCurrentInstance();
    if (!instance) {
        ("production" !== 'production') && warn("useCssModule must be called inside setup()");
        return EMPTY_OBJ;
    }
    var mod = (_a = instance.proxy) === null || _a === void 0 ? void 0 : _a[name];
    if (!mod) {
        ("production" !== 'production') &&
            warn("Current instance does not have CSS module named \"".concat(name, "\"."));
        return EMPTY_OBJ;
    }
    return mod;
};
/**
 * @deprecated use `useCssModule` instead.
 */
var useCSSModule = useCssModule;

function createApp(rootComponent, rootProps) {
    if (rootProps === void 0) { rootProps = undefined; }
    var V = getVueConstructor();
    var mountedVM = undefined;
    var app = {
        config: V.config,
        use: V.use.bind(V),
        mixin: V.mixin.bind(V),
        component: V.component.bind(V),
        directive: function (name, dir) {
            if (dir) {
                V.directive(name, dir);
                return app;
            }
            else {
                return V.directive(name);
            }
        },
        mount: function (el, hydrating) {
            if (!mountedVM) {
                mountedVM = new V(__assign({ propsData: rootProps }, rootComponent));
                mountedVM.$mount(el, hydrating);
                return mountedVM;
            }
            else {
                if ((false)) {
                    warn("App has already been mounted.\n" +
                        "If you want to remount the same app, move your app creation logic " +
                        "into a factory function and create fresh app instances for each " +
                        "mount - e.g. `const createMyApp = () => createApp(App)`");
                }
                return mountedVM;
            }
        },
        unmount: function () {
            if (mountedVM) {
                mountedVM.$destroy();
                mountedVM = undefined;
            }
            else if ((false)) {
                warn("Cannot unmount an app that is not mounted.");
            }
        },
    };
    return app;
}

var nextTick = function nextTick() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return (_a = getVueConstructor()) === null || _a === void 0 ? void 0 : _a.nextTick.apply(this, args);
};

var fallbackCreateElement;
var createElement = function createElement() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var instance = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!instance) {
        ("production" !== 'production') &&
            warn('`createElement()` has been called outside of render function.');
        if (!fallbackCreateElement) {
            fallbackCreateElement = defineComponentInstance(getVueConstructor()).$createElement;
        }
        return fallbackCreateElement.apply(fallbackCreateElement, args);
    }
    return instance.$createElement.apply(instance, args);
};

function useSlots() {
    return getContext().slots;
}
function useAttrs() {
    return getContext().attrs;
}
function getContext() {
    var i = getCurrentInstance();
    if (false) {
        warn("useContext() called without active instance.");
    }
    return i.setupContext;
}

function set(vm, key, value) {
    var state = (vm.__composition_api_state__ =
        vm.__composition_api_state__ || {});
    state[key] = value;
}
function get(vm, key) {
    return (vm.__composition_api_state__ || {})[key];
}
var vmStateManager = {
    set: set,
    get: get,
};

function asVmProperty(vm, propName, propValue) {
    var props = vm.$options.props;
    if (!(propName in vm) && !(props && hasOwn(props, propName))) {
        if (isRef(propValue)) {
            proxy(vm, propName, {
                get: function () { return propValue.value; },
                set: function (val) {
                    propValue.value = val;
                },
            });
        }
        else {
            proxy(vm, propName, {
                get: function () {
                    if (isReactive(propValue)) {
                        propValue.__ob__.dep.depend();
                    }
                    return propValue;
                },
                set: function (val) {
                    propValue = val;
                },
            });
        }
        if ((false)) {
            // expose binding to Vue Devtool as a data property
            // delay this until state has been resolved to prevent repeated works
            vm.$nextTick(function () {
                if (Object.keys(vm._data).indexOf(propName) !== -1) {
                    return;
                }
                if (isRef(propValue)) {
                    proxy(vm._data, propName, {
                        get: function () { return propValue.value; },
                        set: function (val) {
                            propValue.value = val;
                        },
                    });
                }
                else {
                    proxy(vm._data, propName, {
                        get: function () { return propValue; },
                        set: function (val) {
                            propValue = val;
                        },
                    });
                }
            });
        }
    }
    else if ((false)) {
        if (props && hasOwn(props, propName)) {
            warn("The setup binding property \"".concat(propName, "\" is already declared as a prop."), vm);
        }
        else {
            warn("The setup binding property \"".concat(propName, "\" is already declared."), vm);
        }
    }
}
function updateTemplateRef(vm) {
    var rawBindings = vmStateManager.get(vm, 'rawBindings') || {};
    if (!rawBindings || !Object.keys(rawBindings).length)
        return;
    var refs = vm.$refs;
    var oldRefKeys = vmStateManager.get(vm, 'refs') || [];
    for (var index = 0; index < oldRefKeys.length; index++) {
        var key = oldRefKeys[index];
        var setupValue = rawBindings[key];
        if (!refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = null;
        }
    }
    var newKeys = Object.keys(refs);
    var validNewKeys = [];
    for (var index = 0; index < newKeys.length; index++) {
        var key = newKeys[index];
        var setupValue = rawBindings[key];
        if (refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = refs[key];
            validNewKeys.push(key);
        }
    }
    vmStateManager.set(vm, 'refs', validNewKeys);
}
function afterRender(vm) {
    var stack = [vm._vnode];
    while (stack.length) {
        var vnode = stack.pop();
        if (vnode.context)
            updateTemplateRef(vnode.context);
        if (vnode.children) {
            for (var i = 0; i < vnode.children.length; ++i) {
                stack.push(vnode.children[i]);
            }
        }
    }
}
function updateVmAttrs(vm, ctx) {
    var e_1, _a;
    if (!vm) {
        return;
    }
    var attrBindings = vmStateManager.get(vm, 'attrBindings');
    if (!attrBindings && !ctx) {
        // fix 840
        return;
    }
    if (!attrBindings) {
        var observedData = reactive({});
        attrBindings = { ctx: ctx, data: observedData };
        vmStateManager.set(vm, 'attrBindings', attrBindings);
        proxy(ctx, 'attrs', {
            get: function () {
                return attrBindings === null || attrBindings === void 0 ? void 0 : attrBindings.data;
            },
            set: function () {
                ("production" !== 'production') &&
                    warn("Cannot assign to '$attrs' because it is a read-only property", vm);
            },
        });
    }
    var source = vm.$attrs;
    var _loop_1 = function (attr) {
        if (!hasOwn(attrBindings.data, attr)) {
            proxy(attrBindings.data, attr, {
                get: function () {
                    // to ensure it always return the latest value
                    return vm.$attrs[attr];
                },
            });
        }
    };
    try {
        for (var _b = __values(Object.keys(source)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var attr = _c.value;
            _loop_1(attr);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function resolveScopedSlots(vm, slotsProxy) {
    var parentVNode = vm.$options._parentVnode;
    if (!parentVNode)
        return;
    var prevSlots = vmStateManager.get(vm, 'slots') || [];
    var curSlots = resolveSlots(parentVNode.data.scopedSlots, vm.$slots);
    // remove staled slots
    for (var index = 0; index < prevSlots.length; index++) {
        var key = prevSlots[index];
        if (!curSlots[key]) {
            delete slotsProxy[key];
        }
    }
    // proxy fresh slots
    var slotNames = Object.keys(curSlots);
    for (var index = 0; index < slotNames.length; index++) {
        var key = slotNames[index];
        if (!slotsProxy[key]) {
            slotsProxy[key] = createSlotProxy(vm, key);
        }
    }
    vmStateManager.set(vm, 'slots', slotNames);
}
function activateCurrentInstance(instance, fn, onError) {
    var preVm = getCurrentInstance();
    setCurrentInstance(instance);
    try {
        return fn(instance);
    }
    catch (
    // FIXME: remove any
    err) {
        if (onError) {
            onError(err);
        }
        else {
            throw err;
        }
    }
    finally {
        setCurrentInstance(preVm);
    }
}

function mixin(Vue) {
    Vue.mixin({
        beforeCreate: functionApiInit,
        mounted: function () {
            afterRender(this);
        },
        beforeUpdate: function () {
            updateVmAttrs(this);
        },
        updated: function () {
            afterRender(this);
        },
    });
    /**
     * Vuex init hook, injected into each instances init hooks list.
     */
    function functionApiInit() {
        var vm = this;
        var $options = vm.$options;
        var setup = $options.setup, render = $options.render;
        if (render) {
            // keep currentInstance accessible for createElement
            $options.render = function () {
                var _this = this;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return activateCurrentInstance(toVue3ComponentInstance(vm), function () {
                    return render.apply(_this, args);
                });
            };
        }
        if (!setup) {
            return;
        }
        if (!isFunction(setup)) {
            if ((false)) {
                warn('The "setup" option should be a function that returns a object in component definitions.', vm);
            }
            return;
        }
        var data = $options.data;
        // wrapper the data option, so we can invoke setup before data get resolved
        $options.data = function wrappedData() {
            initSetup(vm, vm.$props);
            return isFunction(data)
                ? data.call(vm, vm)
                : data || {};
        };
    }
    function initSetup(vm, props) {
        if (props === void 0) { props = {}; }
        var setup = vm.$options.setup;
        var ctx = createSetupContext(vm);
        var instance = toVue3ComponentInstance(vm);
        instance.setupContext = ctx;
        // fake reactive for `toRefs(props)`
        def(props, '__ob__', createObserver());
        // resolve scopedSlots and slots to functions
        resolveScopedSlots(vm, ctx.slots);
        var binding;
        activateCurrentInstance(instance, function () {
            // make props to be fake reactive, this is for `toRefs(props)`
            binding = setup(props, ctx);
        });
        if (!binding)
            return;
        if (isFunction(binding)) {
            // keep typescript happy with the binding type.
            var bindingFunc_1 = binding;
            // keep currentInstance accessible for createElement
            vm.$options.render = function () {
                resolveScopedSlots(vm, ctx.slots);
                return activateCurrentInstance(instance, function () { return bindingFunc_1(); });
            };
            return;
        }
        else if (isObject(binding)) {
            if (isReactive(binding)) {
                binding = toRefs(binding);
            }
            vmStateManager.set(vm, 'rawBindings', binding);
            var bindingObj_1 = binding;
            Object.keys(bindingObj_1).forEach(function (name) {
                var bindingValue = bindingObj_1[name];
                if (!isRef(bindingValue)) {
                    if (!isReactive(bindingValue)) {
                        if (isFunction(bindingValue)) {
                            var copy_1 = bindingValue;
                            bindingValue = bindingValue.bind(vm);
                            Object.keys(copy_1).forEach(function (ele) {
                                bindingValue[ele] = copy_1[ele];
                            });
                        }
                        else if (!isObject(bindingValue)) {
                            bindingValue = ref(bindingValue);
                        }
                        else if (hasReactiveArrayChild(bindingValue)) {
                            // creates a custom reactive properties without make the object explicitly reactive
                            // NOTE we should try to avoid this, better implementation needed
                            customReactive(bindingValue);
                        }
                    }
                    else if (isArray(bindingValue)) {
                        bindingValue = ref(bindingValue);
                    }
                }
                asVmProperty(vm, name, bindingValue);
            });
            return;
        }
        if ((false)) {
            assert(false, "\"setup\" must return a \"Object\" or a \"Function\", got \"".concat(Object.prototype.toString
                .call(binding)
                .slice(8, -1), "\""));
        }
    }
    function customReactive(target, seen) {
        if (seen === void 0) { seen = new Set(); }
        if (seen.has(target))
            return;
        if (!isPlainObject(target) ||
            isRef(target) ||
            isReactive(target) ||
            isRaw(target))
            return;
        var Vue = getVueConstructor();
        // @ts-expect-error https://github.com/vuejs/vue/pull/12132
        var defineReactive = Vue.util.defineReactive;
        Object.keys(target).forEach(function (k) {
            var val = target[k];
            defineReactive(target, k, val);
            if (val) {
                seen.add(val);
                customReactive(val, seen);
            }
            return;
        });
    }
    function hasReactiveArrayChild(target, visited) {
        if (visited === void 0) { visited = new Map(); }
        if (visited.has(target)) {
            return visited.get(target);
        }
        visited.set(target, false);
        if (isArray(target) && isReactive(target)) {
            visited.set(target, true);
            return true;
        }
        if (!isPlainObject(target) || isRaw(target) || isRef(target)) {
            return false;
        }
        return Object.keys(target).some(function (x) {
            return hasReactiveArrayChild(target[x], visited);
        });
    }
    function createSetupContext(vm) {
        var ctx = { slots: {} };
        var propsPlain = [
            'root',
            'parent',
            'refs',
            'listeners',
            'isServer',
            'ssrContext',
        ];
        var methodReturnVoid = ['emit'];
        propsPlain.forEach(function (key) {
            var srcKey = "$".concat(key);
            proxy(ctx, key, {
                get: function () { return vm[srcKey]; },
                set: function () {
                    ("production" !== 'production') &&
                        warn("Cannot assign to '".concat(key, "' because it is a read-only property"), vm);
                },
            });
        });
        updateVmAttrs(vm, ctx);
        methodReturnVoid.forEach(function (key) {
            var srcKey = "$".concat(key);
            proxy(ctx, key, {
                get: function () {
                    return function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        var fn = vm[srcKey];
                        fn.apply(vm, args);
                    };
                },
            });
        });
        if (false) {
            ctx._vm = vm;
        }
        return ctx;
    }
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(from, to) {
    if (!from)
        return to;
    if (!to)
        return from;
    var key;
    var toVal;
    var fromVal;
    var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__')
            continue;
        toVal = to[key];
        fromVal = from[key];
        if (!hasOwn(to, key)) {
            to[key] = fromVal;
        }
        else if (toVal !== fromVal &&
            isPlainObject(toVal) &&
            !isRef(toVal) &&
            isPlainObject(fromVal) &&
            !isRef(fromVal)) {
            mergeData(fromVal, toVal);
        }
    }
    return to;
}
function install(Vue) {
    if (isVueRegistered(Vue)) {
        if ((false)) {
            warn('[vue-composition-api] already installed. Vue.use(VueCompositionAPI) should be called only once.');
        }
        return;
    }
    if ((false)) {
        if (Vue.version) {
            if (Vue.version[0] !== '2' || Vue.version[1] !== '.') {
                warn("[vue-composition-api] only works with Vue 2, v".concat(Vue.version, " found."));
            }
        }
        else {
            warn('[vue-composition-api] no Vue version found');
        }
    }
    Vue.config.optionMergeStrategies.setup = function (parent, child) {
        return function mergedSetupFn(props, context) {
            return mergeData(isFunction(parent) ? parent(props, context) || {} : undefined, isFunction(child) ? child(props, context) || {} : undefined);
        };
    };
    setVueConstructor(Vue);
    mixin(Vue);
}
var Plugin = {
    install: function (Vue) { return install(Vue); },
};

// implementation, close to no-op
function defineComponent(options) {
    return options;
}

function defineAsyncComponent(source) {
    if (isFunction(source)) {
        source = { loader: source };
    }
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _a = source.delay, delay = _a === void 0 ? 200 : _a, timeout = source.timeout, // undefined = never times out
    _b = source.suspensible, // undefined = never times out
    suspensible = _b === void 0 ? false : _b, // in Vue 3 default is true
    userOnError = source.onError;
    if (false) {
        warn("The suspensiblbe option for async components is not supported in Vue2. It is ignored.");
    }
    var pendingRequest = null;
    var retries = 0;
    var retry = function () {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function () {
        var thisRequest;
        return (pendingRequest ||
            (thisRequest = pendingRequest =
                loader()
                    .catch(function (err) {
                    err = err instanceof Error ? err : new Error(String(err));
                    if (userOnError) {
                        return new Promise(function (resolve, reject) {
                            var userRetry = function () { return resolve(retry()); };
                            var userFail = function () { return reject(err); };
                            userOnError(err, userRetry, userFail, retries + 1);
                        });
                    }
                    else {
                        throw err;
                    }
                })
                    .then(function (comp) {
                    if (thisRequest !== pendingRequest && pendingRequest) {
                        return pendingRequest;
                    }
                    if (false) {
                        warn("Async component loader resolved to undefined. " +
                            "If you are using retry(), make sure to return its return value.");
                    }
                    // interop module default
                    if (comp &&
                        (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                        comp = comp.default;
                    }
                    if (false) {
                        throw new Error("Invalid async component load result: ".concat(comp));
                    }
                    return comp;
                })));
    };
    return function () {
        var component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent,
        };
    };
}

var version = "1.4.9";
// auto install when using CDN
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Plugin);
}



// CONCATENATED MODULE: ./node_modules/vue-demi/lib/index.mjs
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Vue2; });
/* unused harmony export isVue2 */
/* unused harmony export isVue3 */
/* unused harmony export version */
/* unused harmony export install */
/* unused concated harmony import EffectScope */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return EffectScope; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return computed; });
/* unused concated harmony import createApp */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return createApp; });
/* unused concated harmony import createRef */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return createRef; });
/* unused concated harmony import customRef */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return customRef; });
/* unused concated harmony import defineAsyncComponent */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defineAsyncComponent; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return defineComponent; });
/* unused concated harmony import del */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return del; });
/* unused concated harmony import effectScope */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return effectScope; });
/* unused concated harmony import getCurrentInstance */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getCurrentInstance; });
/* unused concated harmony import getCurrentScope */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getCurrentScope; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return createElement; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return inject; });
/* unused concated harmony import isRaw */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isRaw; });
/* unused concated harmony import isReactive */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isReactive; });
/* unused concated harmony import isReadonly */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isReadonly; });
/* unused concated harmony import isRef */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isRef; });
/* unused concated harmony import markRaw */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return markRaw; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return nextTick; });
/* unused concated harmony import onActivated */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return onActivated; });
/* unused concated harmony import onBeforeMount */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return onBeforeMount; });
/* unused concated harmony import onBeforeUnmount */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return onBeforeUnmount; });
/* unused concated harmony import onBeforeUpdate */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return onBeforeUpdate; });
/* unused concated harmony import onDeactivated */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return onDeactivated; });
/* unused concated harmony import onErrorCaptured */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return onErrorCaptured; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return onMounted; });
/* unused concated harmony import onScopeDispose */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return onScopeDispose; });
/* unused concated harmony import onServerPrefetch */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return onServerPrefetch; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return onUnmounted; });
/* unused concated harmony import onUpdated */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return onUpdated; });
/* unused concated harmony import provide */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return provide; });
/* unused concated harmony import proxyRefs */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return proxyRefs; });
/* unused concated harmony import reactive */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return reactive; });
/* unused concated harmony import readonly */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return readonly; });
/* unused concated harmony import ref */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return ref; });
/* unused concated harmony import set */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return set$1; });
/* unused concated harmony import shallowReactive */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return shallowReactive; });
/* unused concated harmony import shallowReadonly */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return shallowReadonly; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return shallowRef; });
/* unused concated harmony import toRaw */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return toRaw; });
/* unused concated harmony import toRef */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return toRef; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return toRefs; });
/* unused concated harmony import triggerRef */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return triggerRef; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return unref; });
/* unused concated harmony import useAttrs */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return useAttrs; });
/* unused concated harmony import useCSSModule */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return useCSSModule; });
/* unused concated harmony import useCssModule */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return useCssModule; });
/* unused concated harmony import useSlots */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return useSlots; });
/* unused concated harmony import warn */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return warn$1; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return watch; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return watchEffect; });
/* unused concated harmony import watchPostEffect */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return watchPostEffect; });
/* unused concated harmony import watchSyncEffect */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return watchSyncEffect; });
/* unused concated harmony import Vue */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return vue_esm["default"]; });



function lib_install(_vue) {
  _vue = _vue || vue_esm["default"]
  if (_vue && !_vue['__composition_api_installed__'])
    vue_esm["default"].use(Plugin)
}

lib_install(vue_esm["default"])

var isVue2 = true
var isVue3 = false
var Vue2 = vue_esm["default"]
var lib_version = vue_esm["default"].version

/**VCA-EXPORTS**/

/**VCA-EXPORTS**/




/***/ }),

/***/ "of+2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),

/***/ "pWQO":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzY5NzUiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDY5NzUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTcyIC0xNTMzKSI+CiAgICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTYuMDcxLDUwSDEuOTI5QTEuOTI5LDEuOTI5LDAsMCwxLDAsNDguMDcxVjMzLjkyOUExLjkyOSwxLjkyOSwwLDAsMSwxLjkyOSwzMkgxNi4wNzFBMS45MjksMS45MjksMCwwLDEsMTgsMzMuOTI5VjQ4LjA3MUExLjkyOSwxLjkyOSwwLDAsMSwxNi4wNzEsNTBaTTcuODQ3LDQ2LjA2bDcuMzkzLTcuMzkzYS42NDMuNjQzLDAsMCwwLDAtLjkwOWwtLjkwOS0uOTA5YS42NDMuNjQzLDAsMCwwLS45MDksMEw3LjM5Myw0Mi44NzgsNC41NzgsNDAuMDYzYS42NDMuNjQzLDAsMCwwLS45MDksMGwtLjkwOS45MDlhLjY0My42NDMsMCwwLDAsMCwuOTA5TDYuOTM4LDQ2LjA2QS42NDMuNjQzLDAsMCwwLDcuODQ3LDQ2LjA2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3MiAxNTAxKSIgZmlsbD0iI2ZmZiIvPgogICAgPGcgaWQ9IumVt+aWueW9ol8yODY4IiBkYXRhLW5hbWU9IumVt+aWueW9oiAyODY4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOTcyIDE1MzMpIiBmaWxsPSJub25lIiBzdHJva2U9IiMzMzMiIHN0cm9rZS13aWR0aD0iMSI+CiAgICAgIDxyZWN0IHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgcng9IjIiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjE3IiBoZWlnaHQ9IjE3IiByeD0iMS41IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "pbJc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "prJ5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMC41IiBoZWlnaHQ9IjIwLjUiIHZpZXdCb3g9IjAgMCAyMC41IDIwLjUiPgogIDxwYXRoIGlkPSJjaGV2cm9uLWNpcmNsZS1kb3duLWxpZ2h0IiBkPSJNMTgsOEExMCwxMCwwLDEsMCwyOCwxOCwxMCwxMCwwLDAsMCwxOCw4Wm04LjcxLDEwQTguNzEsOC43MSwwLDEsMSwxOCw5LjI5LDguNzA5LDguNzA5LDAsMCwxLDI2LjcxLDE4Wm0tOC4zNjcsMy40OTIsNC42MzctNC42NDFhLjQ4NC40ODQsMCwwLDAsMC0uNjg1bC0uMjg2LS4yODZhLjQ4NC40ODQsMCwwLDAtLjY4NSwwTDE4LDE5LjlsLTQuMDEyLTQuMDEyYS40ODQuNDg0LDAsMCwwLS42ODUsMGwtLjI4Ni4yODZhLjQ4NC40ODQsMCwwLDAsMCwuNjg1TDE3LjY1MywyMS41QS40OTMuNDkzLDAsMCwwLDE4LjM0MywyMS40OTJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOC4yNSAyOC4yNSkgcm90YXRlKDE4MCkiIGZpbGw9IiNmZmYiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "py3r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/svg/dataset-annotation-admin-solid.vue
//
//
//
//
//
//

/* harmony default export */ var dataset_annotation_admin_solid = ({
  props: {
    color: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c74a02ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/dataset-annotation-admin-solid.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"24","viewBox":"0 0 18 24"}},[_c('path',{attrs:{"id":"clipboard-list-check-solid","d":"M15.75,3H12A3,3,0,0,0,6,3H2.25A2.251,2.251,0,0,0,0,5.25v16.5A2.251,2.251,0,0,0,2.25,24h13.5A2.251,2.251,0,0,0,18,21.75V5.25A2.251,2.251,0,0,0,15.75,3ZM9,1.875A1.125,1.125,0,1,1,7.875,3,1.122,1.122,0,0,1,9,1.875ZM3.075,9.816l.6-.591a.252.252,0,0,1,.356,0l.966.975L7.223,7.987a.252.252,0,0,1,.356,0l.591.6a.252.252,0,0,1,0,.356L5.161,11.92a.252.252,0,0,1-.356,0l-1.73-1.748A.252.252,0,0,1,3.075,9.816ZM4.5,18.375A1.125,1.125,0,1,1,5.625,17.25,1.122,1.122,0,0,1,4.5,18.375Zm10.5-.75a.376.376,0,0,1-.375.375H7.875a.376.376,0,0,1-.375-.375v-.75a.376.376,0,0,1,.375-.375h6.75a.376.376,0,0,1,.375.375Zm0-6a.418.418,0,0,1-.45.375H7.223l1.514-1.5H14.55a.418.418,0,0,1,.45.375v.75Z","fill":_vm.color}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var svg_dataset_annotation_admin_solid = (esExports);
// CONCATENATED MODULE: ./src/components/svg/dataset-annotation-admin-solid.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  dataset_annotation_admin_solid,
  svg_dataset_annotation_admin_solid,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_svg_dataset_annotation_admin_solid = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q3sG":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "qElK":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBpZD0i5qWV5YaG5b2iXzExMCIgZGF0YS1uYW1lPSLmpZXlhoblvaIgMTEwIiBmaWxsPSIjZmEzZDNkIiBzdHJva2U9IiNmYTNkM2QiIHN0cm9rZS13aWR0aD0iMSI+CiAgICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iOCIgc3Ryb2tlPSJub25lIi8+CiAgICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iNy41IiBmaWxsPSJub25lIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "qFyz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/constants/global/data.js
var data = __webpack_require__("x2hU");

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/case/clinvarStatisticTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var clinvarStatisticTable = ({
  props: {
    defaultData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      clinvarTableData: null
    };
  },

  computed: {
    // global
    toPriceString: function toPriceString() {
      return util["r" /* toPriceString */];
    },
    fixNumber: function fixNumber() {
      return util["g" /* fixNumber */];
    }
  },
  watch: {
    'defaultData': function defaultData() {
      this.init();
    }
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.clinvarTableData = Object(data["p" /* getClinvarStatisticData */])(this.defaultData);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e57332b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/clinvarStatisticTable.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clinvarTableData)?_c('div',{staticClass:"clinvar-statistic-table-page col-block width-full"},[_c('div',{staticClass:"clinvar-statistic-table-container col-block width-full"},_vm._l((Object.keys(_vm.clinvarTableData['config']['csq'])),function(csqKey,csqIndex){return _c('div',{key:csqIndex,staticClass:"clinvar-statistic-table-row row-block stretch",class:['csq-' + csqKey]},_vm._l((Object.keys(_vm.clinvarTableData['config']['gs'])),function(gsKey,gsIndex){return _c('div',{key:gsIndex,staticClass:"clinvar-statistic-table-col col-block",class:['csq-' + csqKey, 'gs-' + gsKey],style:({
          flex: _vm.clinvarTableData['config']['gs'][gsKey].flex || 1,
          'min-height': '50px',
          '--color': _vm.clinvarTableData['config']['gs'][gsKey].color,
          '--bgColor': (
            _vm.clinvarTableData['config']['gs'][gsKey].color +
            (!(['title', 'total'].includes(csqKey) || ['title', 'total'].includes(gsKey)) ?
            _vm.clinvarTableData['function'].getOpacity(_vm.clinvarTableData['data']['csq'][csqKey][gsKey].n ? _vm.clinvarTableData['data']['csq'][csqKey][gsKey].n / _vm.clinvarTableData['data']['gs'][gsKey].total : 0)
            : '')
          )
        })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"clinvar-statistic-table-cell row-block flex-wrap"},[(['title'].includes(csqKey))?[(true)?[_c('div',{staticClass:"clinvar-statistic-table-content break-line"},[_vm._v(_vm._s(_vm.$t(_vm.clinvarTableData['config']['gs'][gsKey].title)))])]:_vm._e()]:(['total'].includes(csqKey))?[(['title'].includes(gsKey))?[_c('div',{staticClass:"clinvar-statistic-table-content break-line"},[_vm._v(_vm._s(_vm.$t(_vm.clinvarTableData['config']['csq'][csqKey].title)))])]:(['total'].includes(gsKey))?[_c('div',{staticClass:"clinvar-statistic-table-content break-line"},[_vm._v(_vm._s(_vm.toPriceString(_vm.clinvarTableData['data']['csq'].total)))])]:[_c('div',{staticClass:"clinvar-statistic-table-content break-line"},[_vm._v(_vm._s(_vm.toPriceString(_vm.clinvarTableData['data']['gs'][gsKey].total)))])]]:[(['title'].includes(gsKey))?[_c('div',{staticClass:"clinvar-statistic-table-content break-line"},[_vm._v(_vm._s(_vm.$t(_vm.clinvarTableData['config']['csq'][csqKey].title)))])]:(['total'].includes(gsKey))?[_c('div',{staticClass:"clinvar-statistic-table-content break-line"},[_vm._v(_vm._s(_vm.toPriceString(_vm.clinvarTableData['data']['csq'][csqKey].total)))])]:[_c('div',{staticClass:"clinvar-statistic-table-content break-line",class:{ 'empty': !_vm.clinvarTableData['data']['csq'][csqKey][gsKey].n }},[_vm._v(_vm._s(_vm.toPriceString(_vm.clinvarTableData['data']['csq'][csqKey][gsKey].n) + (_vm.clinvarTableData['data']['csq'][csqKey][gsKey].n ? ' /' : '')))]),_vm._v(" "),(_vm.clinvarTableData['data']['csq'][csqKey][gsKey].n)?_c('div',{staticClass:"clinvar-statistic-table-content break-line"},[_vm._v(_vm._s(_vm.fixNumber(100 * _vm.clinvarTableData['data']['csq'][csqKey][gsKey].n / _vm.clinvarTableData['data']['gs'][gsKey].total, 0.001) + '%'))]):_vm._e()]]],2),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var case_clinvarStatisticTable = (esExports);
// CONCATENATED MODULE: ./src/components/case/clinvarStatisticTable.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  clinvarStatisticTable,
  case_clinvarStatisticTable,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_case_clinvarStatisticTable = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qL9y":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE0IDE2Ij4KICA8cGF0aCBpZD0iY29weS1saWdodCIgZD0iTTEzLjU2MSwyLjA2MSwxMS45MzkuNDM5QTEuNSwxLjUsMCwwLDAsMTAuODc5LDBINS41QTEuNSwxLjUsMCwwLDAsNCwxLjVWM0gxLjVBMS41LDEuNSwwLDAsMCwwLDQuNXYxMEExLjUsMS41LDAsMCwwLDEuNSwxNmg3QTEuNSwxLjUsMCwwLDAsMTAsMTQuNVYxM2gyLjVBMS41LDEuNSwwLDAsMCwxNCwxMS41VjMuMTIxYTEuNSwxLjUsMCwwLDAtLjQzOS0xLjA2MVpNMTEsMS4wMTVhLjUuNSwwLDAsMSwuMjMyLjEzMWwxLjYyMSwxLjYyMUEuNS41LDAsMCwxLDEyLjk4NSwzSDExWk05LDE0LjVhLjUuNSwwLDAsMS0uNS41aC03YS41LjUsMCwwLDEtLjUtLjVWNC41QS41LjUsMCwwLDEsMS41LDRINHY3LjVBMS41LDEuNSwwLDAsMCw1LjUsMTNIOVptNC0zYS41LjUsMCwwLDEtLjUuNWgtN2EuNS41LDAsMCwxLS41LS41VjEuNUEuNS41LDAsMCwxLDUuNSwxSDEwVjMuMjVhLjc1Mi43NTIsMCwwLDAsLjc1Ljc1SDEzWiIgZmlsbD0iI2FhYSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "qfup":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTcuODU3LDUySDIuMTQzQTIuMTQzLDIuMTQzLDAsMCwxLDAsNDkuODU3VjM0LjE0M0EyLjE0MywyLjE0MywwLDAsMSwyLjE0MywzMkgxNy44NTdBMi4xNDMsMi4xNDMsMCwwLDEsMjAsMzQuMTQzVjQ5Ljg1N0EyLjE0MywyLjE0MywwLDAsMSwxNy44NTcsNTJaTTguNzE5LDQ3LjYyMmw4LjIxNC04LjIxNGEuNzE0LjcxNCwwLDAsMCwwLTEuMDFsLTEuMDEtMS4wMWEuNzE0LjcxNCwwLDAsMC0xLjAxLDBsLTYuNyw2LjdMNS4wODcsNDAuOTU5YS43MTQuNzE0LDAsMCwwLTEuMDEsMGwtMS4wMSwxLjAxYS43MTQuNzE0LDAsMCwwLDAsMS4wMWw0LjY0Myw0LjY0M0EuNzE0LjcxNCwwLDAsMCw4LjcxOSw0Ny42MjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMikiIGZpbGw9IiNmZjllMDMiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "r0TN":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDE1IDEyIj4KICA8cGF0aCBpZD0i5aSa6KeS5b2iXzQ1IiBkYXRhLW5hbWU9IuWkmuinkuW9oiA0NSIgZD0iTTcuNSwwLDE1LDEySDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNSAxMikgcm90YXRlKDE4MCkiIGZpbGw9IiM5OTkiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "rafa":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICA8cGF0aCBpZD0idGltZXMtcmVndWxhciIgZD0iTTkuMDksMTAzLDEzLjgsOTguMjg1YS43LjcsMCwwLDAsMC0uOTg4bC0xLjEtMS4xYS43LjcsMCwwLDAtLjk4OCwwbC00LjcxMiw0LjcxM0wyLjI5NCw5Ni4yYS43LjcsMCwwLDAtLjk4OCwwTC4yMTIsOTcuM2EuNy43LDAsMCwwLDAsLjk4OEw0LjkyNSwxMDMsLjIxMiwxMDcuNzExYS43LjcsMCwwLDAsMCwuOTg4bDEuMSwxLjFhLjcuNywwLDAsMCwuOTg4LDBsNC43MTItNC43MTMsNC43MTMsNC43MTNhLjcuNywwLDAsMCwuOTg4LDBsMS4xLTEuMWEuNy43LDAsMCwwLDAtLjk4OFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjAwOCAtOTUuOTk3KSIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "roYr":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzEyMDAiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDEyMDAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNTU1MyAzMjcwKSI+CiAgICA8cmVjdCBpZD0i6ZW35pa55b2iXzEyMzkiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDEyMzkiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTU1NTMgLTMyNzApIiBmaWxsPSIjZmZmIi8+CiAgICA8cGF0aCBpZD0iZm9sZGVyLWxpZ2h0IiBkPSJNNi4wODYsNjVsMS43MDcsMS43MDdBMSwxLDAsMCwwLDguNSw2N2g2YS41LjUsMCwwLDEsLjUuNXY3YS41LjUsMCwwLDEtLjUuNUgxLjVhLjUuNSwwLDAsMS0uNS0uNXYtOWEuNS41LDAsMCwxLC41LS41SDYuMDg2TTEuNSw2NEExLjUsMS41LDAsMCwwLDAsNjUuNXY5QTEuNSwxLjUsMCwwLDAsMS41LDc2aDEzQTEuNSwxLjUsMCwwLDAsMTYsNzQuNXYtN0ExLjUsMS41LDAsMCwwLDE0LjUsNjZoLTZMNi43OTMsNjQuMjkzQTEsMSwwLDAsMCw2LjA4Niw2NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1NTU0IC0zMzMwKSIgZmlsbD0iIzAwMzY3OSIgc3Ryb2tlPSIjMDAzNTc3IiBzdHJva2Utd2lkdGg9IjAuMjUiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "sdWU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/phenotypeTag.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var phenotypeTag = ({
  props: {
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    init: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    dataInfo: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    phenotypes: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    placeholder: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      content: '',
      tagIndex: 0,
      onCompelete: false,
      focus: false,
      mouse: false,
      display: false
    };
  },

  computed: {
    filtedPhenotypes: function filtedPhenotypes() {
      return Object(util["i" /* groupBy */])(this.phenotypes, function (phenotype) {
        return phenotype.type;
      }, true);
    },

    // static
    typeList: function typeList() {
      return ['hpo', 'disease_term'];
    }
  },
  watch: {
    'init': function init() {
      if (this.content !== this.init) {
        this.content = this.init;
      }
    },
    'focus': function focus() {
      this.display = this.focus || this.mouse;
    }
  },
  created: function created() {
    if (this.content !== this.init) {
      this.content = this.init;
    }
  },

  methods: {
    commentOnInput: function commentOnInput(compelete) {
      compelete && (this.onCompelete = false);
      this.tagIndex = 0;
      this.$emit('input', this.content);
    },
    moveTagIndex: function moveTagIndex(type) {
      switch (type) {
        case 'up':
          {
            this.tagIndex = (this.tagIndex - -this.phenotypes.length - 1) % this.phenotypes.length;
            break;
          }
        case 'down':
          {
            this.tagIndex = (this.tagIndex - -1) % this.phenotypes.length;
            break;
          }
      }
      this.$refs['tag-block'].scrollTop = 28 * this.tagIndex;
    },
    commentTag: function commentTag() {
      var curTag = this.phenotypes[this.tagIndex];
      this.onCompelete = true;
      this.content = curTag.query;
      this.$emit('tag', curTag);
      this.commentOnInput();
      this.$refs['comment-input'].focus();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e9c7ede","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/phenotypeTag.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"phenotype-tag-container"},on:{"mouseenter":function (e) { return _vm.mouse = true; },"mouseleave":function (e) { return _vm.mouse = false; }}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],ref:"comment-input",attrs:{"type":"text","disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":(_vm.content)},on:{"focus":function (e) { return _vm.focus = true; },"blur":function (e) { return _vm.focus = false; },"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.moveTagIndex('up'); })($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.moveTagIndex('down'); })($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return (_vm.phenotypes || []).length <= 1 ? _vm.$emit('send', _vm.content) : _vm.commentTag(); })($event)}],"input":[function($event){if($event.target.composing){ return; }_vm.content=$event.target.value},function (e) { return _vm.commentOnInput(true); }],"change":function (e) { return _vm.$emit('change', _vm.content); }}}),_vm._v(" "),(_vm.phenotypes && !_vm.onCompelete && _vm.display && _vm.content)?_c('div',{staticClass:"input-tag"},[_c('div',{staticClass:"tag-block"},[(_vm.phenotypes.length > 0)?[(_vm.dataInfo && (_vm.typeList.every(function (type) { return _vm.dataInfo[type]; })))?_c('div',{staticClass:"tag-info-container"},[_c('div',{staticClass:"tag-info-block"},[_c('span',[_vm._v(_vm._s(_vm.$t('COMPONENT.tool.phenotypeTag.info.___show') + ' ' + _vm.typeList.map(function (type) { return ((_vm.dataInfo[type] || {}).displayed ? (_vm.dataInfo[type].displayed + '/' + _vm.dataInfo[type].total + ' ' + _vm.$t('COMPONENT.tool.phenotypeTag.info.___' + type)) : ''); }).filter(function (x) { return x; }).join(' ' + _vm.$t('COMPONENT.tool.phenotypeTag.info.___and') +' ')))])])]):_vm._e(),_vm._v(" "),_c('div',{ref:"tag-block",staticClass:"tag-group-container"},_vm._l((_vm.typeList.filter(function (type) { return (_vm.filtedPhenotypes[type] || []).length; })),function(type,tindex){return _c('div',{key:tindex,staticClass:"tag-group-block"},[_c('div',{staticClass:"tag-title"},[_vm._v(_vm._s(_vm.$t('COMPONENT.tool.phenotypeTag.title.___' + type)))]),_vm._v(" "),_vm._l((_vm.filtedPhenotypes[type]),function(tag,index){return _c('div',{key:index,staticClass:"tag",class:{ selected: _vm.tagIndex === (index + _vm.typeList.slice(0, _vm.typeList.indexOf(type)).reduce(function (value, type) { return value + (_vm.filtedPhenotypes[type] || []).length; }, 0)) },on:{"mousemove":function (e) { return _vm.tagIndex = (index + _vm.typeList.slice(0, _vm.typeList.indexOf(type)).reduce(function (value, type) { return value + (_vm.filtedPhenotypes[type] || []).length; }, 0)); },"click":function($event){_vm.commentTag()}}},[_c('span',{domProps:{"innerHTML":_vm._s(tag.query.replace(new RegExp(_vm.content, 'ig'), function (m) { return '<span class=\'key\'>' + m + '</span>'; }))}})])})],2)}),0)]:[_c('div',{staticClass:"tab-empty"},[_vm._v(_vm._s(_vm.$t('COMPONENT.tool.phenotypeTag.___empty')))])]],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_phenotypeTag = (esExports);
// CONCATENATED MODULE: ./src/components/tool/phenotypeTag.vue
function injectStyle (ssrContext) {
  __webpack_require__("gsUn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  phenotypeTag,
  tool_phenotypeTag,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_phenotypeTag = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t62l":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNyIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI3IDI0Ij4KICA8cGF0aCBpZD0ibWVtby1jaXJjbGUtaW5mby1saWdodCIgZD0iTTE1LDEuNUgzQTEuNSwxLjUsMCwwLDAsMS41LDNWMjFBMS41LDEuNSwwLDAsMCwzLDIyLjVIMTMuODg0YTcuNDQzLDcuNDQzLDAsMCwwLDEuNTcsMS40NjdBMy41NzgsMy41NzgsMCwwLDEsMTUsMjRIM2EzLDMsMCwwLDEtMy0zVjNBMywzLDAsMCwxLDMsMEgxNWEzLDMsMCwwLDEsMywzVjkuMzA5YTguMTgyLDguMTgyLDAsMCwwLTEuNS41OTFWM0ExLjUsMS41LDAsMCwwLDE1LDEuNVpNMyw2Ljc1QS43NTEuNzUxLDAsMCwxLDMuNzUsNmgxMC41YS43NS43NSwwLDAsMSwwLDEuNUgzLjc1QS43NTEuNzUxLDAsMCwxLDMsNi43NVptOS43NSwzLjc1YS43NS43NSwwLDAsMSwwLDEuNWgtOWEuNzUuNzUsMCwxLDEsMC0xLjVabS0zLDQuNWEuNzUuNzUsMCwxLDEsMCwxLjVoLTZhLjc1Ljc1LDAsMSwxLDAtMS41Wm0xMC41LTEuNWExLjEyNSwxLjEyNSwwLDEsMS0xLjEyNSwxLjEyNUExLjEyMiwxLjEyMiwwLDAsMSwyMC4yNSwxMy41Wm0tLjc5Miw2VjE4YS43NzUuNzc1LDAsMCwxLS43MDgtLjc1Ljc1Mi43NTIsMCwwLDEsLjc1LS43NWguNzA4YS43MjYuNzI2LDAsMCwxLC43NS43NUwyMSwxOS41QS43NS43NSwwLDAsMSwyMSwyMUgxOS41YS43NTEuNzUxLDAsMCwxLS4wNDItMS41Wk0yMC4yNSwyNEE2Ljc1LDYuNzUsMCwxLDEsMjcsMTcuMjUsNi43NTIsNi43NTIsMCwwLDEsMjAuMjUsMjRabTUuMjUtNi43NWE1LjI1LDUuMjUsMCwxLDAtNS4yNSw1LjI1QTUuMjQ3LDUuMjQ3LDAsMCwwLDI1LjUsMTcuMjVaIiBmaWxsPSIjMDAzNjc5Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "tIXw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tZBu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// CONCATENATED MODULE: ./src/constants/lang/_akagiReport/ja/lang.js
/* harmony default export */ var lang = ({
  // report
  AKAGIREPORT: {
    chapter: {
      header: {
        ___info01: 'Report Date',
        ___info02: 'Sample ID'
      },
      footer: {
        ___info01: '＊本報告書は臨床参考用であり、診断結果とは異なります。臨床的意義は、医療従事者によってさらに解釈され、説明される必要があります。',
        ___info02: '〒162-0056 東京都新宿区若松町２−２ TWIns先端生命医科学研究教育施設3F N102|Compass株式会社| www.compassbioinfo.jp',
        ___info03: 'P.{page} / {total}'
      },
      title: {
        ___subject: '基本情報',
        ___hereditary_cancer: '遺伝性腫瘍・血液疾患リスク検査',
        ___metabolic_syndrome: '遺伝性代謝性疾患リスク検査',
        ___cardio: '遺伝性心・血管系疾患リスク検査',
        ___drug_meta: '薬物副作用予測検査',
        ___constitution: '生活・環境関連遺伝子検査',
        ___method: '付録'
      },
      basic: {},
      variantResult: {},
      variantDetail: {},
      drugAnalysis: {},
      attachmentMethod: {}
    }
  }
});
// CONCATENATED MODULE: ./src/constants/lang/_tpeReport/tc/lang.js
/* harmony default export */ var tc_lang = ({
  // report
  TPEREPORT: {
    chapter: {
      header: {
        ___info01: '病歷號',
        ___info02: '檢測日期'
      },
      footer: {
        ___info01: '＊本報告為臨床參考之用，不等同實際結果，臨床意義需由合格醫療人員進一步判讀與說明。',
        ___info02: 'P.{page} / {total}'
      },
      title: {
        ___subject: '基本資訊與總結',
        ___active_screening: '主動篩查',
        ___hereditary_cancer: '遺傳性癌症風險',
        ___metabolic_syndrome: '代謝症候群',
        ___cardio: '心血管相關',
        ___constitution_tpehealth: '體質相關',
        ___drug_meta: '藥物代謝',
        ___alzheimer_tpehealth: '阿茲海默症風險評估',
        ___neurodegeneration_tpehealth: '神經退化相關',
        ___carrier_screening_tpehealth: '帶因篩查',
        ___ethnic: '族裔分析',
        ___reproductive_health_tpehealth: '生殖與生育',
        ___method: '附錄：檢測方法',
        ___appendix_carrier_screening_tpehealth: '附錄：帶因篩查參考清單',
        ___appendix_reproductive_tpehealth: '附錄：生殖與生育基因參考清單',
        ___appendix_carrier_screening_tpehealth_qrcode: '附錄：帶因篩查參考連結',
        ___appendix_reproductive_tpehealth_qrcode: '附錄：生殖與生育基因參考連結'
      },
      basic: {
        ___title: '全基因體檢測報告',
        ___indexTitle: '總　結',
        form: {
          title: {
            ___case_id: '病歷號',
            ___sex: '性別',
            ___age: '年齡',
            ___report_date: '檢測日期',
            ___testing_category: '樣本種類',
            ___detection_type: '檢測類型',
            ___sequencing_platform: '定序技術'
          }
        },
        index: {
          ___resultFalse: '未檢出',
          active_screening: {
            ___title: '主動篩查',
            ___content01: '在 ACMG SF 及 ClinVar 資料庫登載為 P/LP 致病突變中，共發現<b> {count}個基因 </b>攜帶可能致病的變異。'
          },
          hereditary_cancer: {
            ___title: '遺傳性癌症風險',
            ___content01: '於 {total} 個遺傳性癌症相關基因中，共發現<b> {count}個基因 </b>攜帶可能致病的突變。'
          },
          metabolic_syndrome: {
            ___title: '代謝症候群',
            ___content01: '肥胖風險較高項目：<b>{items}</b>',
            ___content02: '血壓風險較高項目：<b>{items}</b>',
            ___content03: '血糖風險較高項目：<b>{items}</b>',
            ___content04: '脂質代謝風險較高項目：<b>{items}</b>'
          },
          cardio: {
            ___title: '心血管相關',
            ___content01: '風險較高項目：<b>{items}</b>'
          },
          constitution_tpehealth: {
            ___title: '體質相關',
            ___content01: '風險較高項目：<b>{items}</b>'
          },
          drug_meta: {
            ___title: '藥物代謝',
            ___content01: '風險較高項目：<b>{items}</b>'
          },
          alzheimer_tpehealth: {
            ___title: '阿茲海默症風險評估',
            ___content01: '在 {total} 種基因型中，您的基因型為<b> {type}</b>'
          },
          neurodegeneration_tpehealth: {
            ___title: '神經退化相關',
            ___content01: '在 {total} 項神經退化相關基因中，共發現<b> {count}個基因 </b>攜帶可能致病的突變。'
          },
          carrier_screening_tpehealth: {
            ___title: '帶因篩查',
            ___content01: '於 {total} 個帶因篩查基因中，共發現<b> {count}個基因 </b>攜帶可能致病的突變。'
          },
          ethnic: {
            ___title: '族裔分析',
            ___empty: '無',
            ___content01: '於 {total} 個分群中，主要族裔來自<b> {resource}</b>。'
          },
          reproductive_health_tpehealth: {
            ___title: '生殖與生育',
            ___content01: '於 {total} 個基因中，共發現<b> {count}個基因 </b>攜帶可能致病的突變。'
          }
        }
      },
      info: {
        table: {
          geneItemPart: {
            title: {
              ___項目: '項目',
              ___堆積部位: '堆積部位',
              ___檢測基因: '檢測基因',
              ___檢測位點: '檢測位點(基因型結果)',
              ___潛在影響: '潛在影響'
            }
          },
          geneItem: {
            title: {
              ___項目: '項目',
              ___檢測基因: '檢測基因',
              ___檢測位點: '檢測位點(基因型結果)',
              ___潛在影響: '潛在影響'
            }
          },
          geneDrug: {
            title: {
              ___藥物名稱: '藥物名稱',
              ___藥物作用: '藥物作用',
              ___檢測基因: '檢測基因',
              ___檢測位點: '檢測位點(基因型結果)',
              ___臨床意義: '臨床意義',
              ___潛在影響: '潛在影響'
            }
          },
          geneResultItem: {
            title: {
              ___檢測項目: '檢測項目',
              ___檢測基因: '檢測基因',
              ___檢測位點: '檢測位點(基因型結果)',
              ___臨床意義: '臨床意義'
            }
          },
          geneResultItemImpact: {
            title: {
              ___檢測項目: '檢測項目',
              ___檢測基因: '檢測基因',
              ___檢測位點: '檢測位點(基因型結果)',
              ___潛在影響: '潛在影響'
            }
          },
          geneResultItemCombine: {
            title: {
              ___檢測項目: '檢測項目',
              ___檢測基因: '檢測基因',
              ___檢測位點: '檢測位點(基因型結果)',
              ___臨床意義: '臨床意義'
            }
          },
          genotypeRate: {
            title: {
              ___基因型: '基因型 (Genotype)',
              ___人口常見率: '人口常見率',
              ___風險等級: '風險等級',
              ___臨床意義: '臨床意義'
            }
          },
          diseaseGenes: {
            title: {
              ___疾病名稱: '疾病名稱',
              ___相關基因清單: '相關基因清單',
              ___檢測結果: '檢測結果'
            }
          },
          diseaseGene: {
            title: {
              ___疾病名稱: '疾病名稱',
              ___疾病類型簡述: '疾病類型簡述',
              ___檢測基因: '檢測基因',
              ___檢測結果: '檢測結果'
            }
          },
          detailGene: {
            title: {
              ___基因名稱: '基因名稱',
              ___突變位點: '突變位點',
              ___突變類型: '突變類型',
              ___合子型: '合子型',
              ___OMIM: 'OMIM 資料庫記載疾病',
              ___ClinVar: 'ClinVar 資料庫記載疾病'
            }
          }
        },
        '主動篩查-結果': {
          info: {
            ___content01: '說明文字: 本項主動篩查係針對尚未出現特定臨床症狀或已知遺傳性疾病診斷之受檢者，透過基因體分析評估是否帶有與遺傳性疾病相關之致病性基因變異，以協助及早發現潛在健康風險，作為疾病預防、健康管理及遺傳諮詢之參考。本次篩查主要涵蓋美國醫學遺傳與基因體學學會（ACMG）建議回報之 84 個具臨床介入價值基因 (Secondary Findings, SF)，以及 ClinVar 資料庫中已分類為「致病（Pathogenic, P）」或「可能致病（Likely Pathogenic, LP）」之基因變異。檢測結果係依據目前國際公認之資料庫、科學文獻及變異判讀指引進行分析，僅供臨床風險評估與健康管理參考，不作為疾病診斷之唯一依據。'
          },
          summary: {
            total: {
              ___value: '在 ACMG SF 及 ClinVar 資料庫'
            },
            count: {
              ___value: '共檢測<b> {count} </b>項',
              ___title: '文獻已知之致病性突變'
            }
          },
          result: {
            variant: {
              ___title: '檢測結果說明',
              ___subtitleEmpty: '於「美國人類遺傳學會(ACMG)及相關生物醫學資料庫之基因清單」中，共發現 <span style=color:#BF8F00>{count}</span> 個基因有可能致病的突變。',
              ___subtitle: '於「美國人類遺傳學會(ACMG)及相關生物醫學資料庫之基因清單」中，共發現 <span style=color:#BF8F00>{count}</span> 個基因有可能致病的突變。'
            },
            textarea: {
              ___title: '備註'
            }
          }
        },
        '遺傳性癌症風險-結果': {
          info: {
            ___content01: '遺傳性癌症風險篩查是以系統性篩查，檢測個案是否攜帶基因突變。若您家族中有兩人以上罹患癌症，或是早發性癌症，更應注意相關資訊。由於每種癌症的追蹤方式不同，了解自我風險，檢視自身是否帶有遺傳性癌症基因，才能及早針對高風險癌別定期追蹤。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>項',
              ___title: '遺傳性癌症相關基因'
            },
            count: {
              ___value: '共檢出<b> {count} </b>項',
              ___title: '文獻已知之致病性變異'
            }
          },
          result: {
            variant: {
              ___title: '檢測結果說明',
              ___subtitleEmpty: '於「美國人類遺傳學會(ACMG)及相關生物醫學資料庫之基因清單」中，共發現 <span style=color:#BF8F00>{count}</span> 個基因有可能致病的突變。',
              ___subtitle: '於「美國人類遺傳學會(ACMG)及相關生物醫學資料庫之基因清單」中，共發現 <span style=color:#BF8F00>{count}</span> 個基因有可能致病的突變。'
            },
            table: {
              ___title: '指標性檢測項目',
              ___titleInfo: '註:<span style=color:#0070C0>藍色標記</span>為美國人類遺傳學會 (ACMG)建議基因',
              title: {
                ___腦瘤: '<b>腦瘤 / 神經系統相關腫瘤</b>',
                ___腫瘤症候群: '<b>腫瘤症候群</b>',
                ___全方位篩檢基因清單: '<b>全方位篩檢基因清單</b>'
              }
            }
          }
        },
        '代謝症候群-結果': {
          info: {
            ___content01: '代謝症候群是一組彼此高度相關的代謝異常狀態，主要包含肥胖、血壓升高、血糖調控異常以及脂質代謝失衡。這些因子若同時存在，將顯著增加罹患第二型糖尿病、心血管疾病及其他慢性疾病的風險。代謝症候群的發生同時受到遺傳背景與生活型態影響，基因變異可能影響能量利用、胰島素敏感性、脂質運輸及血壓調節，使個體在相似飲食或生活環境下表現出不同的健康風險。本檢測透過分析與代謝相關的基因位點，評估個人在體重控制、血糖穩定、血脂代謝與血壓調節方面的遺傳傾向，協助作為個人化健康管理與預防策略的參考依據，並非疾病診斷。',
            ___title02: '肥胖檢測',
            ___content02: '肥胖基因檢測是一種透過分析特定基因變異，來評估個人肥胖風險及相關代謝問題的科學方法。通過檢測與肥胖相關的基因群，可以幫助了解肥胖的原因，並根據檢測結果制定個人化的減肥策略。建議在檢測後與專業醫生或營養師討論，制定適合自己的健康管理計劃。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>項',
              ___title: '肥胖相關基因'
            },
            count: {
              ___value: '共檢出<b> {count} </b>項',
              ___title: '文獻已知之相關基因'
            }
          },
          result: {
            item: {
              ___title: '檢測結果說明',
              content: {
                ___容易儲存脂肪: '<b>容易儲存脂肪：</b>肥胖相關基因群(PPARGC1B)的異常影響體內脂肪的代謝及產生，使 BMI 超標，易伴隨高血壓的發生。建議提高脂肪燃燒效率及飲食上減少高脂肪、高糖分食物的攝取，增加富含纖維的食物(如蔬菜、全穀類)為適宜的減肥方法。',
                ___無法控制的食慾: '<b>無法控制的食慾：</b>與中樞神經系統食慾與能量恆定調控相關的基因（如 FTO, MC4R, LEP, LEPR, POMC, SIM1, BDNF, NTRK2, SH2B1, ADCY3, SDC3）之功能變異，可能影響下視丘對飽足訊號的整合與食慾抑制機制，降低進食行為的調控效率，使個體在相同環境與飲食條件下，較容易出現進食量增加或偏好高熱量食物的情形，進而提高體重上升與代謝症候群的風險。建議採取有助於提升飽足感與穩定能量攝取的飲食策略，如增加高纖維食物（蔬菜、全穀類）與足量蛋白質的攝取，以協助控制總熱量攝入；若食慾調控困難，必要時可在醫師專業評估下，考慮以藥物方式進行輔助性的食慾管理。',
                ___不平衡的新陳代謝: '<b>不平衡的新陳代謝/中樞性肥胖：</b>人體下視丘透過多個神經核與神經肽訊號，協同調控食慾、能量攝取與能量消耗，維持身體能量平衡的動態穩定。與能量消耗及脂肪代謝相關的基因（如 UCP3, ADRB2）之功能變異，可能影響脂肪氧化效率、交感神經介導的脂解作用與熱生成反應，使個體在高熱量飲食或久坐生活型態下，較易出現體脂堆積與中樞性肥胖，並增加代謝異常的風險。建議透過提升能量消耗與脂肪燃燒效率來進行體重管理，包括規律進行有氧運動及高強度間歇訓練（HIIT）；飲食上應避免高糖與高脂肪食物，並適量增加富含 Omega-3 脂肪酸的食物（如魚類、堅果），以支持代謝健康並有助於情緒調節。',
                ___內分泌失調: '<b>內分泌失調：</b>負責調節胰島素或雌激素活性的基因群（PCSK1, ESR1）功能下降，使BMI超標的人可能帶有較高的糖尿病風險。宜使用低升糖飲食及增加抗氧化食物的攝取（如藍莓、綠茶），提高身體的抗氧化能力。'
              }
            },
            table: {
              ___title: '詳細檢測項目',
              容易儲存脂肪: {
                ___title: '容易儲存脂肪',
                ___part: '腹部、\n大腿內側'
              },
              無法控制的食慾: {
                ___title: '無法控制的食慾',
                ___part: '腰部、\n臀部、\n手臂'
              },
              不平衡的新陳代謝: {
                ___title: '不平衡的新陳代謝',
                ___part: '內臟'
              },
              內分泌失調: {
                ___title: '內分泌失調',
                ___part: '腹部、\n大腿內側'
              }
            }
          }
        },
        '代謝症候群-血壓檢測': {
          info: {
            ___title01: '血壓檢測',
            ___content01: '血壓調節相關基因反映個體在面對壓力、飲食與環境變化時，身體調控血壓的生理傾向。此組基因結果顯示，你的身體在調節血壓時，較容易透過血管收縮與鈉滯留等機制來維持循環穩定，因此在高鹽飲食、心理壓力增加、睡眠不足或活動量偏低的生活型態下，血壓相對較容易出現上升趨勢。此結果代表的是生理調節傾向，並非高血壓的診斷，建議搭配定期血壓監測與生活型態管理，以降低長期心血管風險。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>項',
              ___title: '血壓相關基因'
            },
            count: {
              ___value: '共檢出<b> {count} </b>項',
              ___title: '文獻已知之相關基因'
            }
          },
          result: {
            item: {
              ___title: '檢測結果說明',
              content: {
                ___血管收縮: '<b>血管收縮：</b>此類基因主要影響血管平滑肌的收縮與放鬆反應，決定血管在面對壓力、情緒波動或交感神經刺激時的調節方式。若此調控途徑較為活躍，身體在壓力增加、睡眠不足或長期緊張的情況下，較傾向透過血管收縮來維持血流與血壓穩定，使血壓較容易出現短期或情境性的上升。這類型的血壓變化通常與心理壓力、作息與自律神經狀態密切相關。',
                ___鈉離子平衡: '<b>鈉離子平衡：</b>此類基因主要參與腎臟對鈉離子與體液平衡的調控，影響身體對飲食中鹽分的反應能力。當此調控途徑較為明顯時，身體在攝取較高鹽分的飲食或水分代謝負擔增加時，較容易出現鈉與水分滯留，進而導致血容量上升，使血壓逐漸偏高。此類型的血壓調節特性通常與飲食內容、鹽分攝取量及長期生活習慣高度相關。'
              }
            },
            table: {
              ___title: '詳細檢測項目',
              血管收縮: {
                ___title: '血管收縮'
              },
              鈉離子平衡: {
                ___title: '鈉離子平衡'
              }
            }
          }
        },
        '代謝症候群-血糖檢測': {
          info: {
            ___title01: '血糖檢測',
            ___content01: '血糖調控基因異常，代表個體在攝取碳水化合物、作息不規律或長期處於壓力狀態時，體內血糖調控系統的穩定性較低。此類型體質常見胰島素調節效率下降，使餐後血糖上升幅度較大、回落速度較慢，長期可能增加血糖波動與代謝失衡的風險。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>項',
              ___title: '血糖相關基因'
            },
            count: {
              ___value: '共檢出<b> {count} </b>項',
              ___title: '文獻已知之相關基因'
            }
          },
          result: {
            item: {
              ___title: '檢測結果說明',
              content: {
                ___胰島素敏感度: '<b>胰島素敏感度：</b>此類基因主要影響肌肉、脂肪與肝臟等周邊組織對胰島素訊號的反應效率。當胰島素敏感度較低時，即使胰島素正常分泌，細胞對葡萄糖的攝取與利用仍受限，特別是在高碳水飲食或久坐生活型態下，血糖上升風險更為明顯。',
                ___胰島素分泌能力: '<b>胰島素分泌能力：</b>此類基因主要影響胰臟 β 細胞對血糖刺激的感知能力與胰島素釋放反應。當分泌調控效率較弱時，在進食後無法即時或足量分泌胰島素，容易出現餐後血糖快速升高的情形。'
              }
            },
            table: {
              ___title: '詳細檢測項目',
              胰島素敏感度: {
                ___title: '胰島素敏感度'
              },
              胰島素分泌能力: {
                ___title: '胰島素分泌能力'
              }
            }
          }
        },
        '代謝症候群-脂質代謝檢測': {
          info: {
            ___title01: '脂質代謝檢測',
            ___content01: '脂質代謝基因異常，代表個體在攝取較高脂肪、精緻碳水或長期能量過剩的狀態下，體內脂質的分解、清除與運輸效率相對較低。此類生理傾向常使血中三酸甘油酯(TG)或低密度脂蛋白膽固醇(LDL)較容易累積，進而提高血脂波動與心血管代謝負擔。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>項',
              ___title: '脂質代謝相關基因'
            },
            count: {
              ___value: '共檢出<b> {count} </b>項',
              ___title: '文獻已知之相關基因'
            }
          },
          result: {
            item: {
              ___title: '檢測結果說明',
              content: {
                ___三酸甘油酯調控: '<b>三酸甘油酯調控：</b>此類基因主要影響膳食脂肪與肝臟合成脂質的處理能力，包括脂蛋白脂肪酶活性、脂質動員與脂肪酸氧化效率。當TG調控效率較低時，餐後脂質清除速度減慢，血中TG較容易在進食後上升並維持較高水平，特別是在高脂飲食、頻繁進食或胰島素阻抗狀態下更為明顯。',
                ___膽固醇轉運: '<b>膽固醇轉運：</b>此類基因主要影響膽固醇在血液中的運輸、回收與再分配效率，包括LDL 的清除能力以及高密度脂蛋白膽固醇 (HDL) 逆向運輸膽固醇的功能。當膽固醇轉運效率較弱時，LD較容易在血中滯留，而 HDL 的保護性清除作用相對不足，使動脈粥狀硬化風險提高。'
              }
            },
            table: {
              ___title: '詳細檢測項目',
              三酸甘油酯調控: {
                ___title: '三酸甘油酯調控'
              },
              膽固醇轉運: {
                ___title: '膽固醇轉運'
              }
            }
          }
        },
        '心血管相關-結果': {
          info: {
            ___content01: '心血管相關基因檢測聚焦於影響血管結構完整性、心肌功能、心臟電生理穩定性及脂質代謝平衡的關鍵遺傳因子。此模組涵蓋多種已知與遺傳性心血管疾病高度相關的基因，包括主動脈疾病、遺傳性心肌病、致命性心律不整，以及家族性高膽固醇血症等。相關基因變異可能影響血管彈性與結締組織強度、心肌收縮與能量利用效率、離子通道與鈣離子調控，以及血中膽固醇的清除與轉運能力。',
            ___content02: '透過此檢測，可評估個體在結構性心臟疾病、心律不整風險及動脈粥硬化相關疾病上的遺傳傾向，作為早期風險分層、追蹤監測與生活型態或臨床管理策略制定的重要參考依據。此類遺傳風險即使在無明顯臨床症狀時亦可能存在，及早辨識有助於降低突發性心血管事件的長期風險。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>項',
              ___title: '心血管相關基因'
            },
            count: {
              ___value: '共檢出<b> {count} </b>項',
              ___title: '文獻已知之致病性變異'
            }
          },
          result: {
            variant: {
              ___title: '檢測結果說明',
              ___subtitleEmpty: '於「美國人類遺傳學會(ACMG)及相關生物醫學資料庫之基因清單」中，共發現 <span style=color:#BF8F00>{count}</span> 個基因有可能致病的突變。',
              ___subtitle: '於「美國人類遺傳學會(ACMG)及相關生物醫學資料庫之基因清單」中，共發現 <span style=color:#BF8F00>{count}</span> 個基因有可能致病的突變。'
            },
            table: {
              ___title: '指標性檢測項目',
              ___titleInfo: '註:<span style=color:#0070C0>藍色標記</span>為美國人類遺傳學會 (ACMG)建議基因',
              ___note: '<span>註：LPA(rs10455872、rs3798220) 為風險相關變異，檢出結果不具疾病診斷意義，僅供風險評估參考。</span>'
            }
          }
        },
        '體質相關-結果': {
          info: {
            ___content01: '基因位點的變異與許多體質特點相關，包含物質的代謝、過敏、血栓、酒精不耐等，檢測分析目前醫學上影 響較為明確之位點，檢測是否有與群體不同之基因位點差異，造成體質上的特殊之處，可作為生活型態之參考，協助疾病預防，非疾病診斷。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>項',
              ___title: '體質相關檢測'
            },
            count: {
              ___value: '共檢出<b> {count} </b>項'
            }
          },
          result: {
            item: {
              ___title: '檢測結果說明',
              content: {
                ___乳糖代謝相關: '<b>乳糖代謝相關：</b>乳糖不耐症是一種因小腸乳糖酶活性不足所引起的消化表現型，主要與 LCT 基因在斷奶後表現量逐漸下降有關。乳糖酶能否於成年期持續生成，關鍵取決於 MCM6 基因調控區域的遺傳變異;當其調控功能減弱時，會導致 LCT 基因轉錄活性降 低，使乳糖酶分泌量隨年齡增⻑而逐步減少。此類變化通常於成⻑過程中逐漸顯現，因 此相關症狀多在青少年後期至成人階段出現，個體對乳糖的耐受性亦隨之下降，進而在 攝取乳製品後產生腹脹、腹痛或腹瀉等腸胃不適，其症狀表現則與乳糖攝取量、腸道菌 相及消化道生理狀態密切相關。',
                ___澱粉代謝相關: '<b>澱粉代謝相關：</b>澱粉代謝相關檢測是評估個體對碳水化合物的飲食偏好、澱粉與醣類在 腸道中的消化吸收能力與體內血糖調節的穩定程度。分析內容涵蓋從大腦對醣類的渴望 與攝取傾向，到小腸的分解吸收效率，再到胰島素與血糖控制機制，完整呈現碳水化合 物在體內的代謝流程。透過這些基因資訊協助了解個人對澱粉類食物的反應差異，可作 為制定個人化飲食策略與生活型態調整的參考依據。',
                ___睡眠傾向: '<b>睡眠傾向：</b>睡眠是維持神經修復、代謝穩定與免疫功能的重要基礎，而個體之間在最佳 入睡時間與精神巔峰時段上的差異，主要源自於體內的生理時鐘(晝夜節律，Circadian Rhythm)。本項檢測聚焦於關鍵生理時鐘基因，解析個人先天的節律特徵。在白天， CLOCK 蛋白會與 BMAL1 結合，啟動下游 PER 與 CRY 基因的轉錄;隨著夜晚來臨，PER 與 CRY 蛋白逐漸累積並形成複合體，回過頭抑制 CLOCK:BMAL1 的活性，關閉基因表 現。這套週期性啟動與抑制的分子機制，構成約 24 小時的生理節律循環，進而影響個體 的睡眠時間偏好、清醒程度與日間表現。',
                ___酒精耐受性: '<b>酒精耐受性：</b>酒精在體內主要經由肝臟的兩階段酵素反應進行代謝。本檢測分析關鍵基 因 ADH1B 與 ALDH2，評估個人酒精代謝能力。第一階段由 ADH1B 將酒精轉化為具毒性 的乙醛，可能引發臉紅、心悸與頭痛;第二階段則由 ALDH2 將乙醛進一步分解為無毒的 乙酸並排出體外。這兩個基因的變異會影響乙醛累積程度，進而決定酒精耐受度及酒精 對身體造成傷害的風險。',
                ___血栓傾向: '<b>血栓傾向：</b>血栓風險除了生活習慣外，也深受體內葉酸與維生素B代謝效率影響，而這套機制的核心在於MTHFR、MTRR等基因所構成的同型半胱胺酸（HCY）代謝系統。其中，MTHFR 將一般葉酸轉換為可被身體利用的活性甲基形式；MTR維持維生素B12的活性，使甲基能順利參與代謝反應，而B12是將HCY酸轉化為甲硫胺酸的必要輔因子。當上述任一環節功能下降，HCY便可能在血液中累積，損傷血管內皮，進而提高血栓、心血管疾病與中風的風險。',
                ___咖啡因耐受性: '<b>咖啡因耐受性：</b>個體對咖啡因的耐受差異，主要來自「清除速度」與「神經反應強度」 兩個層面。CYP1A2 影響肝臟分解咖啡因的效率，代謝較慢時，咖啡因在體內停留較久， 較容易干擾心臟負荷與睡眠節律;ADORA2A 則調控大腦對咖啡因的刺激反應，部分基 因型會使神經系統對咖啡因反應放大，即使少量攝取也可能出現緊張、焦躁或不適感。'
              }
            }
          }
        },
        '體質相關-乳糖代謝相關': {
          result: {
            table: {
              ___title: '詳細檢測項目',
              info: {
                ___title: '乳糖代謝相關',
                ___content01: '<b>乳糖不耐症是人類的「節能本能」。</b>',
                ___content02: '人體為了節省能量，設定在斷奶後由 MCM6（開關）自動關閉 LCT 基因（生產線）來停止製造乳糖酶；除非你的基因發生變異讓開關保持開啟（乳糖耐受），否則成年後因無法分解乳糖而產生不適，是身體遵循原始進化設定、避免浪費資源的正常表現。'
              }
            }
          }
        },
        '體質相關-澱粉代謝相關': {
          result: {
            table: {
              info: {
                ___title: '澱粉代謝相關',
                ___content01: '這些澱粉代謝相關基因位點反映了個體在葡萄糖吸收、胰島素分泌、肝臟葡萄糖利用及能量平衡的綜合代謝特質，不同基因型的組合會影響餐前與餐後血糖水平、胰島素反應速率、血脂生成及能量儲存傾向，使個體在澱粉攝取後的代謝表現呈現差異。透過此分析，可辨識日常飲食中較易受影響的環節，例如血糖波動較大或脂肪累積傾向，並作為個人化飲食與生活型態調整的參考;具體策略仍建議搭配專業醫師諮詢與評估。'
              }
            }
          }
        },
        '體質相關-睡眠傾向': {
          result: {
            table: {
              info: {
                ___title: '睡眠傾向',
                ___content01: '早上時，CLOCK 蛋白會與另一個名為 BMAL1 的蛋白結合啟動下游基因 (PER, CRY) 的轉錄。晚上時，當這些蛋白質累積到一定濃度後，它們會互相結合(形成 PER:CRY 複合體)，並接黏在 CLOCK:BMAL1 複合體上，關掉開關。'
              }
            }
          }
        },
        '體質相關-酒精耐受性': {
          result: {
            table: {
              info: {
                ___title: '酒精耐受性',
                grid: {
                  title: {
                    ___組合類型: '組合類型',
                    ___乙醛代謝正常: 'ALDH2(G/G)\n乙醛代謝正常',
                    ___乙醛代謝差: 'ALDH2(G/A)\n乙醛代謝差',
                    ___乙醛代謝超差: 'ALDH2(A/A)\n乙醛代謝超差',
                    ___超快解酒: 'ADH1B(T/T)超快解酒',
                    ___快速解酒: 'ADH1B(T/C)快速解酒',
                    ___正常解酒: 'ADH1B(C/C)正常解酒'
                  },
                  content: {
                    ___超快解酒_乙醛代謝正常: '海量型',
                    ___超快解酒_乙醛代謝差: '易醉易紅型',
                    ___超快解酒_乙醛代謝超差: '酒精毒害型',
                    ___快速解酒_乙醛代謝正常: '穩健暢飲型',
                    ___快速解酒_乙醛代謝差: '紅臉敏感型',
                    ___快速解酒_乙醛代謝超差: '不勝酒力型',
                    ___正常解酒_乙醛代謝正常: '標準社交型',
                    ___正常解酒_乙醛代謝差: '淺嚐即止型',
                    ___正常解酒_乙醛代謝超差: '滴酒不沾型'
                  }
                }
              }
            }
          }
        },
        '體質相關-血栓傾向': {
          result: {
            table: {
              info: {
                ___title: '血栓傾向',
                ___content01: 'MTHFR 把「一般葉酸」轉換為可用甲基;MTRR 維持 B12 活性,決定甲基「能不能真的交出去」,B12 是 HCY(同型半胱胺酸) 轉化為 Methionine(甲硫胺酸)的必要輔因子。'
              }
            }
          }
        },
        '體質相關-咖啡因耐受性': {
          result: {
            table: {
              info: {
                ___title: '咖啡因耐受性',
                ___content01: '本檢測分析 CYP1A2 與 ADORA2A 基因型，評估個體對咖啡因的代謝速度與敏感性，進而預測咖啡因反應。CYP1A2 影響咖啡因在體內的分解快慢，而 ADORA2A 影響腦部對咖啡因的刺激敏感度。透過基因型資訊，可了解個人對咖啡因的耐受程度，幫助調整飲用量，降低心悸、焦慮或睡眠干擾等不適風險，並提升提神效果的穩定性。'
              }
            }
          }
        },
        '藥物代謝-結果': {
          info: {
            ___content01: '由於每個人的基因組成不同，進而影響藥物在體內的代謝速度與反應。因此藥物代謝基因檢測是現代醫學的重要工具，能幫助醫師為患者選擇最適合的藥物與劑量，避免不必要的副作用與毒性反應，並提升治療效果。透過基因檢測與個人化的醫療策略，我們可以更好地「對症下藥」，避免「一藥通用」的風險，為患者提供更安全、有效的治療選擇。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>項',
              ___title: '藥物代謝相關位點'
            },
            count: {
              ___value: '共檢出<b> {count} </b>項',
              ___title: '有潛在影響'
            }
          },
          result: {
            item: {
              ___title: '檢測結果說明',
              content: {
                ___default01: '本項臨床用藥安全與個人化醫療檢測,涵蓋從日常止痛、心血管與神經精神治療,到手術麻醉、抗感染及腫瘤化療等六大關鍵用藥領域,旨在解析個體在藥物活性發揮與毒性耐受上的遺傳差異。藥物若無法在體內被正確代謝,可能導致療效不足或副作用風險上升,例如抗血栓藥物保護力不足、精神科藥物引發代謝異常、麻醉或抗感染藥物造成罕見但嚴重的過敏與器官毒性,甚至化療與止痛藥引發心腎損傷、造血抑制或藥物蓄積。透過藥物代謝基因檢測,醫療團隊可在治療前即辨識潛在風險,調整合適的藥物與劑量,避免反覆試藥,將醫療從事後處理轉為事前預防,提升用藥安全性與整體生活品質。本結果評估的是基因與藥物反應之關聯性,非直接用藥或劑量建議,實際治療仍需由醫師綜合臨床判斷。'
              }
            },
            table: {
              ___title: '詳細檢測項目'
            }
          }
        },
        '阿茲海默症風險評估-結果': {
          info: {
            ___content01: '由於每個人的基因組成不同，進而影響藥物在體內的代謝速度與反應。因此藥物代謝基因檢測是現代醫學的重要工具，能幫助醫師為患者選擇最適合的藥物與劑量，避免不必要的副作用與毒性反應，並提升治療效果。透過基因檢測與個人化的醫療策略，我們可以更好地「對症下藥」，避免「一藥通用」的風險，為患者提供更安全、有效的治療選擇。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>個阿茲海默風險評估相關位點'
            },
            count: {
              ___value: '檢驗為<b> {type} </b>類型'
            }
          },
          result: {
            table: {
              ___title: '檢測結果說明',
              content: {
                ___default01: 'ApoE 基因是目前已知與阿茲海默症最密切相關的遺傳因子，尤其是其ε4 等位基因(ApoE ε4)，被廣泛認為是晚發型阿茲海默症的最強風險因子。',
                ___default02: 'ApoE 基因位於第 19 對染色體，主要參與脂質代謝與腦部神經修復。人類共有三種主要等位型:ε2、ε3 與 ε4。其中 ε3 是最常見型，屬中性;而 ε2 被認為具有保護作用;相對地，攜帶一個ε4 等位基因者，發展阿茲海默症的風險提高約 3-5 倍，若為雙等位基因(ε4/ε4)，風險更可高達 10-15 倍。',
                ___default03: '此外，ApoE ε4 攜帶者的發病年齡往往較早，並且在病程中出現更明顯的類澱粉蛋白沉積與 tau 病變，這使得 ApoE 檢測不僅能提供個人化的風險預測，也成為臨床研究中進行分層篩選的重要工具。'
              },
              data: {
                'ε2/ε2': {
                  ___基因型: 'ε2/ε2',
                  ___人口常見率: '0.70%',
                  ___風險等級: '最低風險',
                  ___臨床意義: '具有最強的保護作用，患病風險最低。'
                },
                'ε2/ε3': {
                  ___基因型: 'ε2/ε3',
                  ___人口常見率: '17.10%',
                  ___風險等級: '低風險',
                  ___臨床意義: '攜帶保護性 ε2，風險低於平均。'
                },
                'ε3/ε3': {
                  ___基因型: 'ε3/ε3',
                  ___人口常見率: '55.80%',
                  ___風險等級: '低風險',
                  ___臨床意義: '最常見的基因型,風險與一般人群相似。'
                },
                'ε2/ε4': {
                  ___基因型: 'ε2/ε4',
                  ___人口常見率: '4.10%',
                  ___風險等級: '中風險',
                  ___臨床意義: 'ε2 的保護作用可能部分抵消 ε4 的風險,但仍需注意。'
                },
                'ε3/ε4': {
                  ___基因型: 'ε3/ε4',
                  ___人口常見率: '20.00%',
                  ___風險等級: '中高風險',
                  ___臨床意義: '攜帶一個高風險 ε4,患病機率增加 3-5 倍。'
                },
                'ε4/ε4': {
                  ___基因型: 'ε4/ε4',
                  ___人口常見率: '2.30%',
                  ___風險等級: '最高風險',
                  ___臨床意義: '攜帶兩個 ε4,患病機率增加 10-15 倍,被視為高危險群。'
                }
              }
            }
          }
        },
        '神經退化相關-結果': {
          info: {
            ___content01: '該項基因檢測專注於多種神經退化性疾病（Neurodegenerative Diseases）及部分相關的遺傳性神經系統疾病。這些疾病的共同核心特徵是神經細胞（包括大腦和脊髓的神經元）會發生進行性的功能喪失或死亡，最終導致患者出現持續惡化的功能障礙。 臨床表現的多樣性取決於受影響的神經元類型和分佈區域：',
            ___list01: '<b>認知障礙：</b>當大腦皮質和海馬體的神經元受損時，會導致記憶力、判斷、語言和執行功能下降，這是阿茲海默氏症和遺傳性腦部小動脈血管病變等疾病的主要特徵。',
            ___list02: '<b>運動障礙：</b>若影響基底核和運動神經元，則會出現震顫、僵硬、運動遲緩（如帕金森氏症）、協調性變差（如亨廷頓氏病），或全身肌肉無力與萎縮（如脊髓性肌萎縮症和肌萎縮脊髓側索硬化症）。',
            ___list03: '<b>周邊神經病變：</b>當周邊神經系統受到影響時，會表現為感覺異常、麻木或疼痛，以及遠端肌肉無力，常見於家族性類澱粉多發性神經病變。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>項',
              ___title: '神經退化相關基因'
            },
            count: {
              ___value: '共檢出<b> {count} </b>項',
              ___title: '文獻已知之相關基因'
            }
          },
          result: {
            variant: {
              ___title: '檢測結果說明',
              ___subtitle: '受檢者攜帶以下曾被記載可能致病的突變位點，共 <span style=color:#BF8F00>{count}</span> 項'
            },
            table: {
              ___title: '詳細檢測項目'
            }
          }
        },
        '帶因篩查-結果': {
          info: {
            ___content01: '帶因篩查的主要目的是檢測個案是否攜帶隱性基因突變，特別是那些可能導致嚴重遺傳疾病的基因變異。這項檢測在婚前和產前階段具有重要意義，能幫助夫妻了解自身攜帶基因突變的風險，並為未來的生育計劃提供科學依據。透過早期的檢測與專業的遺傳諮詢，夫妻可以採取適當的預防措施，以降低下一代罹患遺傳疾病的風險，為家庭健康奠定堅實的基礎。',
            ___content02: '<b>＊依據人類孟德爾遺傳學資料庫 ( O M I M ) 記載</b>'
          },
          summary: {
            totald: {
              ___value: '在<b> {count} </b>項',
              ___title: '相關疾病'
            },
            totalg: {
              ___value: '在<b> {count} </b>項',
              ___title: '相關基因'
            },
            count: {
              ___value: '共檢出<b> {count} </b>項',
              ___title: '文獻已知之致病性變異'
            }
          },
          result: {
            variant: {
              ___title: '檢測結果說明',
              ___subtitle: '受檢者攜帶以下曾被記載可能致病的突變位點，共 <span style=color:#BF8F00>{count}</span> 項'
            },
            note: {
              ___title: '檢測說明',
              ___subtitle: '未檢出',
              ___content: '基因名：<b>{gene}</b>，若夫妻雙方皆帶有此突變時，<b>下一代將有 25% 的機率罹患「{disease}」</b>，建議於婚前 / 產前諮詢相關醫師。',
              ___more: '<span style=color:#FF0000>*更多資訊：</span>若您想檢視更詳細的帶因者資訊，我們也在「附錄」中為您逐項列舉最常見之遺傳疾病。'
            }
          }
        },
        '族裔分析-結果': {
          info: {
            ___content01: '在族裔報告中，了解自己的祖源不僅能滿足對祖先來源的好奇心，更能深化對自身文化背景的認同感，進一步強化個人與家族、族群的連結，並在多元文化的社會中找到歸屬感。此外，由於不同種族在基因上存在差異，這些差異可能影響某些疾病的發生率、藥物反應以及健康風險。因此，了解自己的種族背景不僅具有文化意義，更具有重要的醫學價值。透過族裔報告，個人可以獲得更精準的健康資訊，並與醫療專業人員合作，制定更適合自己的預防與治療方案。'
          },
          result: {
            chart: {
              title: {
                ___主要: '主要',
                ___其他: '其他',
                ___無: '無\n（0%）'
              }
            }
          }
        },
        '生殖與生育-結果': {
          info: {
            ___content01: '本基因篩檢涵蓋多項已知與男性及女性生殖功能異常高度相關的遺傳疾病與生理機制,重點包含精子生成障礙、性腺與性別分化異常、下視丘–腦下垂體–性腺軸(HPG axis)調控缺陷、類固醇生成與荷爾蒙代謝異常,以及部分全身性症候群中伴隨之生殖功能受損表現。相關遺傳變異可能影響配子形成、荷爾蒙分泌與反應、性腺發育或生殖道結構完整性,進而降低自然受孕的機率。透過此篩檢,辨識潛在遺傳風險,作為生育規劃、性別特異風險評估、後續醫療諮詢與生殖策略選擇(如輔助生殖技術)的重要參考依據。',
            ___content02: '<b>＊依據人類孟德爾遺傳學資料庫 ( O M I M ) 記載</b>'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>項',
              ___title: '相關基因'
            },
            count: {
              ___value: '共檢出<b> {count} </b>項',
              ___title: '文獻已知之致病性變異'
            }
          },
          result: {
            variant: {
              ___title: '檢測結果說明',
              ___subtitle: '受檢者攜帶以下曾被記載可能致病的突變位點，共 <span style=color:#BF8F00>{count}</span> 項'
            },
            note: {
              ___title: '檢測說明',
              ___subtitle: '未檢出',
              ___content: '基因名：<b>{gene}</b>，若檢出帶有此變異時，有可能罹患<b>「{disease}」</b>，建議於婚前 / 產前諮詢相關醫師。',
              ___more: '<span style=color:#FF0000>*更多資訊：</span>若您想檢視更詳細的資訊，我們也在「附錄」中為您逐項列舉{sex}生殖與生育相關基因清單。'
            }
          }
        }
      }
    },
    template: {
      testingMethod: {
        sampleInfo: {
          title: {
            ___樣本庫試劑組: '樣本庫試劑組',
            ___數據量: '數據量',
            ___定序平台: '定序平台',
            ___覆蓋深度: '覆蓋深度',
            ___VariantCalling: 'Variant Calling 軟體',
            ___數據品質: '數據品質'
          },
          content: {
            檢測說明: {
              ___title: '檢測說明',
              ___content: '<ul>\n  <li>1000ng \u5F85\u6E2C\u6AA2\u9AD4\u7684\u57FA\u56E0\u9AD4 DNA \u7D93\u8D85\u97F3\u6CE2\u9707\u76EA\u8655\u7406\uFF0C\u7247\u65B7\u5316\u6210\u70BA\u5E73\u5747\u70BA 250~450bp \u7684 DNA \u7247\u6BB5\u3002\u63A1 \u7528\u7B26\u5408 Illumina \u5E73\u53F0\u7684 Whole Genome Sequencing PCR-Free \u9032\u884C\u6587\u5EAB\u88FD\u5099\u3002DNA \u7247\u6BB5\u7D93\u904E\u653E\u5927 \u5F8C\uFF0C\u653E\u5927\u5F8C\u7684\u7522\u7269\u6703\u7D93\u7531 NovaSeq \u5B9A\u5E8F\u5100\u9032\u884C 2 x 150 bp Paired-End \u7684\u5B9A\u5E8F\u3002</li>\n  <li>\u5206\u6790\u65B9\u6CD5\u4F9D\u751F\u7269\u8CC7\u8A0A\u516C\u53F8\u6240\u5EFA\u7ACB\u4E4B\u5206\u6790\u6D41\u7A0B\u9032\u884C\uFF0C\u4E0B\u6A5F\u4E4B\u5E8F\u5217\u7D93\u5206\u7FA4\u53BB\u6A19\u7C64\u5316\u5F8C\uFF0C\u6839\u64DA GRCh38 \u4F7F\u7528 Parabrick (4.5.0-1) \u9032\u884C\u5E8F\u5217\u6BD4\u5C0D\u53CA Parabrick (4.5.0-1) \u9032\u884C\u8B8A\u7570\u4F4D\u9EDE\u627E\u5C0B\u3002\u78BA\u8A8D\u7684\u8B8A\u7570\u4F4D\u9EDE\u7D93\u7531 Variant Effect Predictor (v101) \u53CA Jannovar(0.35) \u9032\u884C\u8A3B\u89E3\u3002\u6839\u64DA ACMG / AMP 2015 \u6307\u5357\u5C0D\u907A\u50B3\u8B8A\u7570 \u9032\u884C\u81E8\u5E8A\u89E3\u91CB\u3002</li>\n  <li>\n    <span>\u672C\u6AA2\u6E2C\u65B9\u6CD5\u5B58\u5728\u4EE5\u4E0B\u9650\u5236:</span>\n    <ul>\n      <li>\u91CD\u8907\u5E8F\u5217:\u57FA\u56E0\u9AD4\u4E2D\u5145\u6EFF\u4E86\u9AD8\u5EA6\u91CD\u8907\u7684\u5E8F\u5217\u3002\u7576\u788E\u7247\u592A\u5C0F\u6642\uFF0C\u96E3\u4EE5\u5224\u65B7\u9019\u4E9B\u788E\u7247\u8A72\u6B78\u4F4D\u5728\u54EA\u88E1(\u5982X \u67D3\u8272\u9AD4\u8106\u6298\u75C7)\u3002</li>\n      <li>\u7D50\u69CB\u8B8A\u7570:\u5C0D\u65BC\u5927\u578B\u7684 DNA \u5012\u7F6E\u3001\u8F49\u4F4D\u6216\u5927\u7247\u6BB5\u7F3A\u5931\uFF0C\u77ED\u8B80\u2ED1\u6280\u8853\u96E3\u4EE5\u7CBE\u78BA\u5075\u6E2C\u3002</li>\n      <li>\u52D5\u614B\u7A81\u8B8A:\u67D0\u4E9B\u75BE\u75C5(\u5982\u5C0F\u8166\u840E\u7E2E\u75C7\u3001\u4EA8\u4E01\u9813\u821E\u8E48\u75C7)\u662F\u7531\u7279\u5B9A\u5E8F\u5217\u7684\u5927\u91CF\u91CD\u8907\u5F15\u8D77\u7684\uFF0C\u5168\u57FA\u56E0\u9AD4\u5B9A\u5E8F(WGS)\u5728\u7CBE\u78BA\u8A08\u7B97\u9019\u4E9B\u91CD\u8907\u6B21\u6578\u4E0A\u4ECD\u6709\u6311\u6230\u3002</li>\n      <li>\u9AD8\u5EA6\u540C\u6E90\u5340\u57DF:\u67D0\u4E9B\u529F\u80FD\u57FA\u56E0\u8207\u300C\u507D\u57FA\u56E0\u300D\u5E8F\u5217\u6975\u70BA\u76F8\u4F3C\uFF0CWGS \u53EF\u80FD\u6703\u767C\u751F\u300C\u8AA4\u8A8D\u300D\u6216\u96E3\u4EE5\u5C0D\u9F4A\u7684\u60C5\u6CC1\u3002</li>\n      <li>\u8868\u89C0\u907A\u50B3\u5B78:\u6A19\u6E96 WGS \u7121\u6CD5\u5075\u6E2C DNA \u7532\u57FA\u5316\u6216\u7D44\u86CB\u767D\u4FEE\u98FE\u3002\u5373\u4FBF\u5E8F\u5217\u5B8C\u5168\u6B63\u5E38\uFF0C\u5982\u679C\u958B\u95DC(\u7532\u57FA\u5316)\u51FA\u554F\u984C\uFF0C\u57FA\u56E0\u4ECD\u53EF\u80FD\u4E0D\u8868\u73FE\u3002</li>\n      <li>\u5D4C\u5408\u9AD4\u73FE\u8C61:\u5982\u679C\u8B8A\u7570\u50C5\u5B58\u5728\u65BC\u5C11\u6578\u7D30\u80DE\u4E2D(\u4F8B\u5982\u53EA\u6709 5%\u7684\u7D30\u80DE\u6709\u7A81\u8B8A)\uFF0C\u6A19\u6E96\u6FC3\u5EA6\u7684 WGS \u53EF\u80FD\u6703\u5C07\u5176\u8996\u70BA\u80CC\u666F\u96DC\u8A0A\u800C\u5FFD\u7565\u3002</li>\n      <li>\u7C92\u7DDA\u9AD4 DNA:\u96D6\u7136 WGS \u5305\u542B\u7C92\u7DDA\u9AD4\uFF0C\u4F46\u7531\u65BC\u7C92\u7DDA\u9AD4\u8207\u6838 DNA \u7684\u6BD4\u4F8B\u5DEE\u7570\u5DE8\u5927\uFF0C\u6709\u6642\u9700\u8981\u5C08\u9580\u7684\u5206\u6790\u6D41\u7A0B\u624D\u80FD\u78BA\u4FDD\u6E96\u78BA\u5EA6\u3002</li>\n      <li>\u975E\u7DE8\u78BC\u5340\u7684\u8FF7\u601D:WGS \u6DB5\u84CB\u4E86 98%\u7684\u975E\u7DE8\u78BC\u5340\uFF0C\u4F46\u76EE\u524D\u4EBA\u985E\u5C0D\u9019\u4E9B\u5340\u57DF\u7684\u529F\u80FD\u77AD\u89E3\u6975\u5176\u6709\u9650\uFF0C\u7121\u6CD5\u7D66\u51FA\u7D50\u8AD6\u3002</li>\n      <li>\u67D3\u8272\u9AD4\u6578\u76EE\u7570\u5E38:\u91DD\u5C0D\u67D3\u8272\u9AD4\u6578\u76EE\u7570\u5E38\u75BE\u75C5(\u5982:\u5510\u6C0F\u75C7\u3001Turner syndrome\u3001\u514B\u85CD\u8CBB\u7279\u6C0F\u75C7\u3001Trisomy X \u7B49)\uFF0CWGS \u50C5\u80FD\u4EE5\u8B80\u5E8F\u6DF1\u5EA6\u63A8\u4F30\u6574\u9AD4\u62F7\u8C9D\u6578\u8B8A\u5316\u800C\u7121\u6CD5\u5B9A\u8AD6\uFF0C\u6545\u61C9\u4EE5\u67D3\u8272\u9AD4\u6AA2\u67E5\u512A\u5148\u3002</li>\n    </ul>\n  </li>\n</ul>'
            },
            技術極限與聲明: {
              ___title: '技術極限與聲明',
              ___content: '<ul>\n  <li>\u7531\u65BC\u73FE\u5B58\u5BE6\u9A57\u6280\u8853\u6975\u9650\uFF0C\u90E8\u5206\u57FA\u56E0\u4E4B\u8986\u84CB\u6DF1\u5EA6\u53EF\u80FD\u672A\u9054 10X > 95%\u7684\u6A19\u6E96\u3002</li>\n  <li>\u672C\u6AA2\u6E2C\u4EE5\u7F8E\u570B\u4EBA\u985E\u907A\u50B3\u5B78\u6703 (ACMG) \u53CA\u4EBA\u985E\u57FA\u56E0\u7D44\u8B8A\u7570\u8CC7\u6599\u5EAB (ClinVar) \u4F5C\u70BA\u81F4\u75C5\u6027\u5224\u5B9A\u4F9D\u64DA\uFF0C\u4E26\u53C3\u8003\u4EBA\u985E\u5B5F\u5FB7\u723E\u907A\u50B3\u5B78\u8CC7\u6599\u5EAB (OMIM) \u6240\u8A18\u8F09\u4E4B\u57FA\u56E0\u76F8\u95DC\u8868\u73FE\u578B\u3002\u7136\u800C\uFF0C\u672A\u66FE\u88AB\u767B\u8F09\u7684\u4F4D\u9EDE\uFF0C\u4ECD\u6709\u53EF\u80FD\u5C0E\u81F4\u75BE\u75C5\u6216\u5F71\u97FF\u8868\u73FE\u578B\u3002</li>\n  <li>\u672C\u5831\u544A\u4E26\u975E\u6700\u7D42\u98A8\u96AA\u8A55\u4F30\u7D50\u679C\uFF0C\u4ECD\u9700\u7D93\u5408\u683C\u91AB\u5E2B\u3001\u907A\u50B3\u8AEE\u8A62\u5E2B\u9032\u884C\u7D9C\u5408\u81E8\u5E8A\u8A55\u4F30\u8207\u5EFA\u8B70\u3002</li>\n  <li>\u672C\u6AA2\u6E2C\u7CFB\u7D71\u53EF\u80FD\u6703\u96A8\u6642\u66F4\u65B0\u8CC7\u6599\u5EAB\u3001\u6F14\u7B97\u6CD5\u3001\u6AA2\u6E2C\u57FA\u56E0\u8207\u4F4D\u9EDE\uFF0C\u4EE5\u53CA\u76F8\u95DC\u4E4B\u6AA2\u6E2C\u9805\u76EE\u63CF\u8FF0\u8207\u5167\u5BB9\uFF0C\u5C0D\u65BC\u6AA2\u6E2C\u7CFB\u7D71\u53CA\u5831\u544A\u4E4B\u66F4\u65B0\uFF0C\u672C\u9662\u64C1\u6709\u6700\u7D42\u89E3\u91CB\u6B0A\u3002</li>\n  <li>\u672C\u6AA2\u6E2C\u4E2D\u85E5\u7269\u4EE3\u8B1D\u76F8\u95DC\u57FA\u56E0\u4E4B\u81E8\u5E8A\u89E3\u8B80\uFF0C\u4FC2\u4F9D\u64DA PharmGKB(Pharmacogenomics Knowledgebase\uFF0C\u85E5\u7269\u57FA\u56E0\u9AD4\u8CC7\u6599\u5EAB) \u8207 ClinPGx(Clinical Pharmacogenomics\uFF0C\u81E8\u5E8A\u85E5\u7269\u57FA\u56E0\u9AD4\u5B78) \u8CC7\u6599\u5EAB\u9032\u884C\u5F59\u6574 \u8207\u5224\u8B80\u3002PharmGKB \u70BA\u7F8E\u570B\u570B\u5BB6\u885B\u751F\u7814\u7A76\u9662(NIH)\u8CC7\u52A9\u5EFA\u7ACB\u4E4B\u6B0A\u5A01\u85E5\u7269\u57FA\u56E0\u9AD4\u5B78\u8CC7\u6599\u5EAB\uFF0C\u7CFB\u7D71\u6027\u6574\u5408 \u57FA\u56E0\u8B8A\u7570\u8207\u85E5\u7269\u53CD\u61C9\u3001\u4EE3\u8B1D\u9014\u5F91\u3001\u4E0D\u826F\u53CD\u61C9\u53CA\u81E8\u5E8A\u7528\u85E5\u6307\u5F15\u7B49\u76F8\u95DC\u8B49\u64DA\uFF0C\u4E26\u4F9D\u64DA\u8B49\u64DA\u5F37\u5EA6\u5C0D\u5404\u57FA\u56E0\u4F4D\u9EDE \u9032\u884C\u5206\u7D1A\u3002\u70BA\u78BA\u4FDD\u5831\u544A\u4E4B\u79D1\u5B78\u6027\u8207\u53EF\u4FE1\u5EA6\uFF0C\u672C\u6AA2\u6E2C\u50C5\u9078\u53D6 <b>Level 3 \u4EE5\u4E0A</b> \u5177\u5145\u5206\u6587\u737B\u652F\u6301\u4E4B\u57FA\u56E0\u4F4D\u9EDE\u9032\u884C \u89E3\u8B80\u3002ClinPGx \u5247\u4FC2\u5C07\u85E5\u7269\u57FA\u56E0\u9AD4\u5B78\u61C9\u7528\u65BC\u81E8\u5E8A\u91AB\u7642\u6C7A\u7B56\uFF0C\u900F\u904E\u5206\u6790\u500B\u9AD4\u57FA\u56E0\u8B8A\u7570\u5C0D\u85E5\u7269\u7642\u6548\u3001\u4EE3\u8B1D\u80FD \u529B\u53CA\u4E0D\u826F\u53CD\u61C9\u98A8\u96AA\u4E4B\u5F71\u97FF\uFF0C\u5354\u52A9\u81E8\u5E8A\u91AB\u5E2B\u9032\u884C\u66F4\u7CBE\u6E96\u4E4B\u7528\u85E5\u9078\u64C7\u8207\u5291\u91CF\u8ABF\u6574\u3002</li>\n  <li>\u4F9D\u64DA\u7F8E\u570B\u91AB\u5B78\u907A\u50B3\u5B78\u8207\u57FA\u56E0\u9AD4\u5B78\u5C0D\u64F4\u5C55\u6027\u5E36\u56E0\u8005\u7BE9\u6AA2(Expanded Carrier Screening, ECS)\u4E4B\u5EFA\u8B70\uFF0C\u5E36 \u56E0\u8005\u7BE9\u6AA2\u9805\u76EE\u61C9\u63A1\u5206\u5C64\u5F0F(tier-based)\u8A2D\u8A08\uFF0C\u4EE5\u517C\u9867\u81E8\u5E8A\u91CD\u8981\u6027\u8207\u65CF\u7FA4\u98A8\u96AA\u8A55\u4F30\u3002ACMG \u5C07\u5EFA\u8B70\u7BE9\u6AA2 \u4E4B\u75BE\u75C5\u5340\u5206\u70BA\u4E09\u500B\u968E\u5C64:<b>Tier 1</b> \u70BA\u6240\u6709\u65CF\u7FA4\u7686\u61C9\u63A5\u53D7\u4E4B\u57FA\u672C\u7BE9\u6AA2\u9805\u76EE\uFF0C\u5305\u62EC\u56CA\u72C0\u7E96\u7DAD\u5316\u75C7(Cystic Fibrosis, CF)\u8207\u810A\u9AD3\u6027\u808C\u8089\u840E\u7E2E\u75C7(Spinal Muscular Atrophy, SMA)\uFF0C\u4E26\u53EF\u4F9D\u4E0D\u540C\u65CF\u7FA4\u4E4B\u9AD8\u98A8\u96AA\u75BE\u75C5 \u9032\u884C\u88DC\u5145;<b>Tier 2</b> \u70BA\u5177\u56B4\u91CD\u6216\u4E2D\u5EA6\u81E8\u5E8A\u8868\u578B\uFF0C\u4E14\u65BC\u4E00\u822C\u65CF\u7FA4\u4E2D\u5E36\u56E0\u8005\u983B\u7387\u81F3\u5C11\u70BA 1/100 \u4E4B\u907A\u50B3\u75BE\u75C5;<b>Tier 3</b> \u5247\u9032\u4E00\u6B65\u6DB5\u84CB\u5E36\u56E0\u8005\u983B\u7387\u9054 \u22651/200 \u4E4B\u907A\u50B3\u75BE\u75C5\uFF0C\u4EE5\u63D0\u4F9B\u66F4\u5168\u9762\u4E4B\u751F\u80B2\u98A8\u96AA\u8A55\u4F30\u3002\u672C\u6AA2\u6E2C\u9805\u76EE\u4E4B\u8A2D\u8A08\u4FC2 \u4F9D\u5FAA\u4E0A\u8FF0\u539F\u5247\uFF0C\u4F5C\u70BA\u8A55\u4F30\u53D7\u6AA2\u8005\u6F5B\u5728\u96B1\u6027\u907A\u50B3\u75BE\u75C5\u5E36\u56E0\u98A8\u96AA\u4E4B\u4F9D\u64DA\u3002</li>\n</ul>'
            },
            族裔分析檢測說明: {
              ___title: '族裔分析檢測說明',
              ___content: '<ul>\n  <li>\u6B64\u5206\u6790\u7D50\u5408 1000 Genomes Project(1000G)\u8207 Human Genome Diversity Project(HGDP)\u5169\u5927\u516C\u958B \u6578\u64DA\u5EAB\uFF0C\u900F\u904E\u6578\u64DA\u6574\u5408\u8207\u524D\u8655\u7406\uFF0C\u5229\u7528 PLINK \u9032\u884C\u9023\u9396\u4E0D\u5E73\u8861(Linkage Disequilibrium, LD)\u904E\u6FFE\uFF0C\u78BA \u4FDD\u57FA\u56E0\u578B\u6578\u64DA\u7684\u7368\u7ACB\u6027\uFF0C\u7136\u5F8C\u61C9\u7528 ADMIXTURE \u5DE5\u5177\u63A8\u7B97\u500B\u9AD4\u7684\u7956\u6E90\u6210\u5206\u3002\u6B64\u65B9\u6CD5\u900F\u904E\u6700\u5927\u4F3C\u7136\u6CD5 (Maximum Likelihood Estimation)\u8A55\u4F30\u4E0D\u540C\u65CF\u7FA4\u7684\u57FA\u56E0\u8CA2\u737B\uFF0C\u4E26\u4EE5\u53EF\u8996\u5316\u7D50\u679C\u5448\u73FE\u7956\u6E90\u7D44\u6210\u3002</li>\n  <li>\u4F7F\u7528\u8005\u7684\u6578\u64DA\u5C07\u5F9E FASTQ \u539F\u59CB\u6E2C\u5E8F\u6578\u64DA\u958B\u59CB\u8655\u7406\uFF0C\u9996\u5148\u9032\u884C\u6BD4\u5C0D(Mapping)\uFF0C\u5C07\u8B80\u53D6\u5E8F\u5217\u5C0D\u9F4A\u5230\u53C3\u8003 \u57FA\u56E0\u7D44\uFF0C\u63A5\u8457\u57F7\u884C**\u8B8A\u7570\u6AA2\u6E2C(Variant Calling)**\u4EE5\u8B58\u5225 SNP \u8207 Indel \u8B8A\u7570\u3002\u96A8\u5F8C\uFF0C\u5F9E\u8B8A\u7570\u6578\u64DA\u4E2D\u7BE9\u9078 \u8207\u7956\u6E90\u5206\u6790\u76F8\u95DC\u7684\u4F4D\u9EDE\uFF0C\u78BA\u4FDD\u8207\u53C3\u8003\u6578\u64DA\u96C6\u4E2D\u7684\u6A19\u8A18\u4F4D\u9EDE\u4E00\u81F4\uFF0C\u5F9E\u800C\u63D0\u9AD8\u6BD4\u8F03\u7684\u6E96\u78BA\u6027\u3002</li>\n  <li>\u7136\u800C\uFF0C\u672C\u65B9\u6CD5\u7684\u6E96\u78BA\u6027\u53D7\u5230\u53C3\u8003\u6578\u64DA\u5EAB\u7684\u4EE3\u8868\u6027\u5F71\u97FF\uFF0C\u4F8B\u5982\u67D0\u4E9B\u65CF\u7FA4\u5728 1000G \u8207 HGDP \u6578\u64DA\u4E2D\u7684\u6DB5\u84CB\u7BC4 \u570D\u8F03\u5C11\uFF0C\u53EF\u80FD\u5C0E\u81F4\u7D50\u679C\u504F\u5DEE\u3002\u6B64\u5916\uFF0CADMIXTURE \u7684\u5047\u8A2D\u57FA\u65BC\u7279\u5B9A\u7956\u5148\u7FA4\u9AD4\u6A21\u578B\uFF0C\u672A\u5FC5\u80FD\u5B8C\u5168\u53CD\u6620\u6B77\u53F2 \u4E0A\u8907\u96DC\u7684\u65CF\u7FA4\u9077\u79FB\u8207\u6DF7\u5408\u904E\u7A0B\u3002LD \u904E\u6FFE\u96D6\u53EF\u6E1B\u5C11\u57FA\u56E0\u578B\u9023\u9396\u5F71\u97FF\uFF0C\u4F46\u53EF\u80FD\u5F71\u97FF\u67D0\u4E9B\u65CF\u7FA4\u7279\u7570\u6027\u6A19\u8A18\u7684\u4FDD \u7559\u3002\u6B64\u5916\uFF0C\u6E2C\u5E8F\u8CEA\u91CF\u3001\u8B8A\u7570\u6AA2\u6E2C\u7684\u6E96\u78BA\u5EA6\u4EE5\u53CA\u6578\u64DA\u524D\u8655\u7406\u7684\u7B56\u7565\u4E5F\u6703\u5C0D\u5206\u6790\u7D50\u679C\u7522\u751F\u5F71\u97FF\u3002\u56E0\u6B64\uFF0C\u5728\u89E3 \u8B80\u7D50\u679C\u6642\uFF0C\u9700\u8003\u616E\u9019\u4E9B\u6F5B\u5728\u9650\u5236\uFF0C\u4E26\u8F14\u4EE5\u5176\u4ED6\u5206\u6790\u65B9\u6CD5\u9032\u884C\u4EA4\u53C9\u9A57\u8B49\u3002</li>\n</ul>'
            }
          }
        }
      },
      carrierScreening: {
        ___title: '說明',
        ___content01: '以下為您逐項列舉最常見之遺傳疾病，讓您更了解帶因篩查的詳細項目。',
        table: {
          title: {
            ___基因名稱: '基因名稱',
            ___疾病名稱: '疾病名稱',
            ___遺傳模式: '遺傳模式'
          }
        }
      },
      pregnancyGene: {
        ___titlef: '女性相關基因清單',
        ___titlem: '男性相關基因清單',
        table: {
          title: {
            ___基因名稱: '基因名稱',
            ___疾病名稱: '疾病名稱',
            ___遺傳模式: '遺傳模式'
          }
        }
      },
      carrierScreeningLink: {
        ___title: '說明',
        ___content01: '以下為您逐項列舉最常見之遺傳疾病，讓您更了解帶因篩查的詳細項目。請掃描以下QR Code或拜訪網址：'
      },
      pregnancyGeneLink: {
        ___title: '說明',
        ___content01: '以下為您逐項列舉最常見之男性與女性生殖與生育相關基因清單，讓您更了解生殖與生育的詳細項目。請掃描以下QR Code或拜訪網址：'
      }
    }
  }
});
// CONCATENATED MODULE: ./src/constants/lang/_tpeReport/sc/lang.js
/* harmony default export */ var sc_lang = ({
  // report
  TPEREPORT: {
    chapter: {
      header: {
        ___info01: '病历号',
        ___info02: '报告日'
      },
      footer: {
        ___info01: '＊本报告为临床参考之用，不等同实际结果，临床意义需由合格医疗人员进一步判读与说明。',
        ___info02: 'P.{page} / {total}'
      },
      title: {
        ___subject: '基本资讯与总结',
        ___hereditary_cancer: '遗传性癌症风险',
        ___metabolic_syndrome: '代谢症候群',
        ___cardio: '心血管相关',
        ___constitution_tpehealth: '体质相关',
        ___drug_meta: '药物代谢',
        ___alzheimer_tpehealth: '阿兹海默症风险评估',
        ___neurodegeneration_tpehealth: '神经退化相关',
        ___carrier_screening_tpehealth: '带因筛查',
        ___ethnic: '族裔分析',
        ___reproductive_health_tpehealth: '生殖与生育',
        ___method: '附录：检测方法',
        ___appendix_carrier_screening_tpehealth: '附录：带因筛查参考清单',
        ___appendix_reproductive_tpehealth: '附录：生殖与生育基因参考清单',
        ___appendix_carrier_screening_tpehealth_qrcode: '附录：带因筛查参考连结',
        ___appendix_reproductive_tpehealth_qrcode: '附录：生殖与生育基因参考连结'
      },
      basic: {
        ___title: '全基因体检测报告',
        ___indexTitle: '总　结',
        form: {
          title: {
            ___case_id: '病历号',
            ___sex: '性别',
            ___age: '年龄',
            ___report_date: '检测日期',
            ___testing_category: '样本种类',
            ___detection_type: '检测类型',
            ___sequencing_platform: '定序技术'
          }
        },
        index: {
          ___resultFalse: '未检出',
          hereditary_cancer: {
            ___title: '遗传性癌症风险',
            ___content01: '于 {total} 个遗传性癌症相关基因中，共发现<b> {count}个基因 </b>携带可能致病的突变。'
          },
          metabolic_syndrome: {
            ___title: '代谢症候群',
            ___content01: '肥胖风险较高项目：<b>{items}</b>',
            ___content02: '血压风险较高项目：<b>{items}</b>',
            ___content03: '血糖风险较高项目：<b>{items}</b>',
            ___content04: '脂质代谢风险较高项目：<b>{items}</b>'
          },
          cardio: {
            ___title: '心血管相关',
            ___content01: '风险较高项目：<b>{items}</b>'
          },
          constitution_tpehealth: {
            ___title: '体质相关',
            ___content01: '风险较高项目：<b>{items}</b>'
          },
          drug_meta: {
            ___title: '药物代谢',
            ___content01: '风险较高项目：<b>{items}</b>'
          },
          alzheimer_tpehealth: {
            ___title: '阿兹海默症风险评估',
            ___content01: '在 {total} 种基因型中，您的基因型为<b> {type}</b>'
          },
          neurodegeneration_tpehealth: {
            ___title: '神经退化相关',
            ___content01: '在 {total} 项神经退化相关基因中，共发现<b> {count}个基因 </b>携带可能致病的突变。'
          },
          carrier_screening_tpehealth: {
            ___title: '带因筛查',
            ___content01: '于 {total} 个带因筛查基因中，共发现<b> {count}个基因 </b>携带可能致病的突变。'
          },
          ethnic: {
            ___title: '族裔分析',
            ___empty: '无',
            ___content01: '于 {total} 个分群中，主要族裔来自<b> {resource}</b>。'
          },
          reproductive_health_tpehealth: {
            ___title: '生殖与生育',
            ___content01: '于 {total} 个基因中，共发现<b> {count}个基因 </b>携带可能致病的突变。'
          }
        }
      },
      info: {
        table: {
          geneItemPart: {
            title: {
              ___項目: '项目',
              ___堆積部位: '堆积部位',
              ___檢測基因: '检测基因',
              ___檢測位點: '检测位点(基因型结果)',
              ___潛在影響: '潜在影响'
            }
          },
          geneItem: {
            title: {
              ___項目: '项目',
              ___檢測基因: '检测基因',
              ___檢測位點: '检测位点(基因型结果)',
              ___潛在影響: '潜在影响'
            }
          },
          geneDrug: {
            title: {
              ___藥物名稱: '药物名称',
              ___藥物作用: '药物作用',
              ___檢測基因: '检测基因',
              ___檢測位點: '检测位点(基因型结果)',
              ___臨床意義: '临床意义',
              ___潛在影響: '潜在影响'
            }
          },
          geneResultItem: {
            title: {
              ___檢測項目: '检测项目',
              ___檢測基因: '检测基因',
              ___檢測位點: '检测位点(基因型结果)',
              ___臨床意義: '临床意义'
            }
          },
          geneResultItemImpact: {
            title: {
              ___檢測項目: '检测项目',
              ___檢測基因: '检测基因',
              ___檢測位點: '检测位点(基因型结果)',
              ___潛在影響: '潜在影响'
            }
          },
          geneResultItemCombine: {
            title: {
              ___檢測項目: '检测项目',
              ___檢測基因: '检测基因',
              ___檢測位點: '检测位点(基因型结果)',
              ___臨床意義: '临床意义'
            }
          },
          genotypeRate: {
            title: {
              ___基因型: '基因型 (Genotype)',
              ___人口常見率: '人口常见率',
              ___風險等級: '风险等级',
              ___臨床意義: '临床意义'
            }
          },
          diseaseGenes: {
            title: {
              ___疾病名稱: '疾病名称',
              ___相關基因清單: '相关基因清单',
              ___檢測結果: '检测结果'
            }
          },
          diseaseGene: {
            title: {
              ___疾病名稱: '疾病名称',
              ___疾病類型簡述: '疾病类型简述',
              ___檢測基因: '检测基因',
              ___檢測結果: '检测结果'
            }
          },
          detailGene: {
            title: {
              ___基因名稱: '基因名称',
              ___突變位點: '突变位点',
              ___突變類型: '突变类型',
              ___合子型: '合子型',
              ___OMIM: 'OMIM 资料库记载疾病',
              ___ClinVar: 'ClinVar 资料库记载疾病'
            }
          }
        },
        '遺傳性癌症風險-結果': {
          info: {
            ___content01: '遗传性癌症风险筛查是以系统性筛查，检测个案是否携带基因突变。若您家族中有两人以上罹患癌症，或是早发性癌症，更应注意相关资讯。由于每种癌症的追踪方式不同，了解自我风险，检视自身是否带有遗传性癌症基因，才能及早针对高风险癌别定期追踪。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>项',
              ___title: '遗传性癌症相关基因'
            },
            count: {
              ___value: '共检出<b> {count} </b>项',
              ___title: '文献已知之致病性变异'
            }
          },
          result: {
            variant: {
              ___title: '检测结果说明',
              ___subtitleEmpty: '于「美国人类遗传学会(ACMG)及相关生物医学资料库之基因清单」中，共发现 <span style=color:#BF8F00>{count}</span> 个基因有可能致病的突变。',
              ___subtitle: '于「美国人类遗传学会(ACMG)及相关生物医学资料库之基因清单」中，共发现 <span style=color:#BF8F00>{count}</span> 个基因有可能致病的突变。'
            },
            table: {
              ___title: '指标性检测项目',
              ___titleInfo: '注:<span style=color:#0070C0>蓝色标记</span>为美国人类遗传学会 (ACMG)建议基因',
              title: {
                ___腦瘤: '<b>脑瘤 / 神经系统相关肿瘤</b>',
                ___腫瘤症候群: '<b>肿瘤症候群</b>',
                ___全方位篩檢基因清單: '<b>全方位筛检基因清单</b>'
              }
            }
          }
        },
        '代謝症候群-結果': {
          info: {
            ___content01: '代谢症候群是一组彼此高度相关的代谢异常状态，主要包含肥胖、血压升高、血糖调控异常以及脂质代谢失衡。这些因子若同时存在，将显著增加罹患第二型糖尿病、心血管疾病及其他慢性疾病的风险。代谢症候群的发生同时受到遗传背景与生活型态影响，基因变异可能影响能量利用、胰岛素敏感性、脂质运输及血压调节，使个体在相似饮食或生活环境下表现出不同的健康风险。本检测透过分析与代谢相关的基因位点，评估个人在体重控制、血糖稳定、血脂代谢与血压调节方面的遗传倾向，协助作为个人化健康管理与预防策略的参考依据，并非疾病诊断。',
            ___title02: '肥胖检测',
            ___content02: '肥胖基因检测是一种透过分析特定基因变异，来评估个人肥胖风险及相关代谢问题的科学方法。通过检测与肥胖相关的基因群，可以帮助了解肥胖的原因，并根据检测结果制定个人化的减肥策略。建议在检测后与专业医生或营养师讨论，制定适合自己的健康管理计划。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>项',
              ___title: '肥胖相关基因'
            },
            count: {
              ___value: '共检出<b> {count} </b>项',
              ___title: '文献已知之相关基因'
            }
          },
          result: {
            item: {
              ___title: '检测结果说明',
              content: {
                ___容易儲存脂肪: '<b>容易储存脂肪：</b>肥胖相关基因群(PPARGC1B)的异常影响体内脂肪的代谢及产生，使 BMI 超标，易伴随高血压的发生。建议提高脂肪燃烧效率及饮食上减少高脂肪、高糖分食物的摄取，增加富含纤维的食物(如蔬菜、全穀类)为适宜的减肥方法。',
                ___無法控制的食慾: '<b>无法控制的食慾：</b>与中枢神经系统食慾与能量恆定调控相关的基因（如 FTO, MC4R, LEP, LEPR, POMC, SIM1, BDNF, NTRK2, SH2B1, ADCY3, SDC3）之功能变异，可能影响下视丘对饱足讯号的整合与食慾抑制机制，降低进食行为的调控效率，使个体在相同环境与饮食条件下，较容易出现进食量增加或偏好高热量食物的情形，进而提高体重上升与代谢症候群的风险。建议採取有助于提升饱足感与稳定能量摄取的饮食策略，如增加高纤维食物（蔬菜、全穀类）与足量蛋白质的摄取，以协助控制总热量摄入；若食慾调控困难，必要时可在医师专业评估下，考虑以药物方式进行辅助性的食慾管理。',
                ___不平衡的新陳代謝: '<b>不平衡的新陈代谢/中枢性肥胖：</b>人体下视丘透过多个神经核与神经肽讯号，协同调控食慾、能量摄取与能量消耗，维持身体能量平衡的动态稳定。与能量消耗及脂肪代谢相关的基因（如 UCP3, ADRB2）之功能变异，可能影响脂肪氧化效率、交感神经介导的脂解作用与热生成反应，使个体在高热量饮食或久坐生活型态下，较易出现体脂堆积与中枢性肥胖，并增加代谢异常的风险。建议透过提升能量消耗与脂肪燃烧效率来进行体重管理，包括规律进行有氧运动及高强度间歇训练（HIIT）；饮食上应避免高糖与高脂肪食物，并适量增加富含 Omega-3 脂肪酸的食物（如鱼类、坚果），以支持代谢健康并有助于情绪调节。',
                ___內分泌失調: '<b>内分泌失调：</b>负责调节胰岛素或雌激素活性的基因群（PCSK1, ESR1）功能下降，使BMI超标的人可能带有较高的糖尿病风险。宜使用低升糖饮食及增加抗氧化食物的摄取（如蓝莓、绿茶），提高身体的抗氧化能力。'
              }
            },
            table: {
              ___title: '详细检测项目',
              容易儲存脂肪: {
                ___title: '容易储存脂肪',
                ___part: '腹部、\n大腿内侧'
              },
              無法控制的食慾: {
                ___title: '无法控制的食慾',
                ___part: '腰部、\n臀部、\n手臂'
              },
              不平衡的新陳代謝: {
                ___title: '不平衡的新陈代谢',
                ___part: '内脏'
              },
              內分泌失調: {
                ___title: '内分泌失调',
                ___part: '腹部、\n大腿内侧'
              }
            }
          }
        },
        '代謝症候群-血壓檢測': {
          info: {
            ___title01: '血压检测',
            ___content01: '血压调节相关基因反映个体在面对压力、饮食与环境变化时，身体调控血压的生理倾向。此组基因结果显示，你的身体在调节血压时，较容易透过血管收缩与钠滞留等机制来维持循环稳定，因此在高盐饮食、心理压力增加、睡眠不足或活动量偏低的生活型态下，血压相对较容易出现上升趋势。此结果代表的是生理调节倾向，并非高血压的诊断，建议搭配定期血压监测与生活型态管理，以降低长期心血管风险。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>项',
              ___title: '血压相关基因'
            },
            count: {
              ___value: '共检出<b> {count} </b>项',
              ___title: '文献已知之相关基因'
            }
          },
          result: {
            item: {
              ___title: '检测结果说明',
              content: {
                ___血管收縮: '<b>血管收缩：</b>此类基因主要影响血管平滑肌的收缩与放鬆反应，决定血管在面对压力、情绪波动或交感神经刺激时的调节方式。若此调控途径较为活跃，身体在压力增加、睡眠不足或长期紧张的情况下，较倾向透过血管收缩来维持血流与血压稳定，使血压较容易出现短期或情境性的上升。这类型的血压变化通常与心理压力、作息与自律神经状态密切相关。',
                ___鈉離子平衡: '<b>钠离子平衡：</b>此类基因主要参与肾脏对钠离子与体液平衡的调控，影响身体对饮食中盐分的反应能力。当此调控途径较为明显时，身体在摄取较高盐分的饮食或水分代谢负担增加时，较容易出现钠与水分滞留，进而导致血容量上升，使血压逐渐偏高。此类型的血压调节特性通常与饮食内容、盐分摄取量及长期生活习惯高度相关。'
              }
            },
            table: {
              ___title: '详细检测项目',
              血管收縮: {
                ___title: '血管收缩'
              },
              鈉離子平衡: {
                ___title: '钠离子平衡'
              }
            }
          }
        },
        '代謝症候群-血糖檢測': {
          info: {
            ___title01: '血糖检测',
            ___content01: '血糖调控基因异常，代表个体在摄取碳水化合物、作息不规律或长期处于压力状态时，体内血糖调控系统的稳定性较低。此类型体质常见胰岛素调节效率下降，使餐后血糖上升幅度较大、回落速度较慢，长期可能增加血糖波动与代谢失衡的风险。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>项',
              ___title: '血糖相关基因'
            },
            count: {
              ___value: '共检出<b> {count} </b>项',
              ___title: '文献已知之相关基因'
            }
          },
          result: {
            item: {
              ___title: '检测结果说明',
              content: {
                ___胰島素敏感度: '<b>胰岛素敏感度：</b>此类基因主要影响肌肉、脂肪与肝脏等周边组织对胰岛素讯号的反应效率。当胰岛素敏感度较低时，即使胰岛素正常分泌，细胞对葡萄糖的摄取与利用仍受限，特别是在高碳水饮食或久坐生活型态下，血糖上升风险更为明显。',
                ___胰島素分泌能力: '<b>胰岛素分泌能力：</b>此类基因主要影响胰脏 β 细胞对血糖刺激的感知能力与胰岛素释放反应。当分泌调控效率较弱时，在进食后无法即时或足量分泌胰岛素，容易出现餐后血糖快速升高的情形。'
              }
            },
            table: {
              ___title: '详细检测项目',
              胰島素敏感度: {
                ___title: '胰岛素敏感度'
              },
              胰島素分泌能力: {
                ___title: '胰岛素分泌能力'
              }
            }
          }
        },
        '代謝症候群-脂質代謝檢測': {
          info: {
            ___title01: '脂质代谢检测',
            ___content01: '脂质代谢基因异常，代表个体在摄取较高脂肪、精緻碳水或长期能量过剩的状态下，体内脂质的分解、清除与运输效率相对较低。此类生理倾向常使血中三酸甘油酯(TG)或低密度脂蛋白胆固醇(LDL)较容易累积，进而提高血脂波动与心血管代谢负担。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>项',
              ___title: '脂质代谢相关基因'
            },
            count: {
              ___value: '共检出<b> {count} </b>项',
              ___title: '文献已知之相关基因'
            }
          },
          result: {
            item: {
              ___title: '检测结果说明',
              content: {
                ___三酸甘油酯調控: '<b>三酸甘油酯调控：</b>此类基因主要影响膳食脂肪与肝脏合成脂质的处理能力，包括脂蛋白脂肪酶活性、脂质动员与脂肪酸氧化效率。当TG调控效率较低时，餐后脂质清除速度减慢，血中TG较容易在进食后上升并维持较高水平，特别是在高脂饮食、频繁进食或胰岛素阻抗状态下更为明显。',
                ___膽固醇轉運: '<b>胆固醇转运：</b>此类基因主要影响胆固醇在血液中的运输、回收与再分配效率，包括LDL 的清除能力以及高密度脂蛋白胆固醇 (HDL) 逆向运输胆固醇的功能。当胆固醇转运效率较弱时，LD较容易在血中滞留，而 HDL 的保护性清除作用相对不足，使动脉粥状硬化风险提高。'
              }
            },
            table: {
              ___title: '详细检测项目',
              三酸甘油酯調控: {
                ___title: '三酸甘油酯调控'
              },
              膽固醇轉運: {
                ___title: '胆固醇转运'
              }
            }
          }
        },
        '心血管相關-結果': {
          info: {
            ___content01: '心血管相关基因检测聚焦于影响血管结构完整性、心肌功能、心脏电生理稳定性及脂质代谢平衡的关键遗传因子。此模组涵盖多种已知与遗传性心血管疾病高度相关的基因，包括主动脉疾病、遗传性心肌病、致命性心律不整，以及家族性高胆固醇血症等。相关基因变异可能影响血管弹性与结缔组织强度、心肌收缩与能量利用效率、离子通道与钙离子调控，以及血中胆固醇的清除与转运能力。',
            ___content02: '透过此检测，可评估个体在结构性心脏疾病、心律不整风险及动脉粥硬化相关疾病上的遗传倾向，作为早期风险分层、追踪监测与生活型态或临床管理策略制定的重要参考依据。此类遗传风险即使在无明显临床症状时亦可能存在，及早辨识有助于降低突发性心血管事件的长期风险。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>项',
              ___title: '心血管相关基因'
            },
            count: {
              ___value: '共检出<b> {count} </b>项',
              ___title: '文献已知之致病性变异'
            }
          },
          result: {
            variant: {
              ___title: '检测结果说明',
              ___subtitleEmpty: '于「美国人类遗传学会(ACMG)及相关生物医学资料库之基因清单」中，共发现 <span style=color:#BF8F00>{count}</span> 个基因有可能致病的突变。',
              ___subtitle: '于「美国人类遗传学会(ACMG)及相关生物医学资料库之基因清单」中，共发现 <span style=color:#BF8F00>{count}</span> 个基因有可能致病的突变。'
            },
            table: {
              ___title: '指标性检测项目',
              ___titleInfo: '注:<span style=color:#0070C0>蓝色标记</span>为美国人类遗传学会 (ACMG)建议基因',
              ___note: '<span>注：LPA(rs10455872、rs3798220) 为风险相关变异，检出结果不具疾病诊断意义，仅供风险评估参考。</span>'
            }
          }
        },
        '體質相關-結果': {
          info: {
            ___content01: '基因位点的变异与许多体质特点相关，包含物质的代谢、过敏、血栓、酒精不耐等，检测分析目前医学上影 响较为明确之位点，检测是否有与群体不同之基因位点差异，造成体质上的特殊之处，可作为生活型态之参考，协助疾病预防，非疾病诊断。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>项',
              ___title: '体质相关检测'
            },
            count: {
              ___value: '共检出<b> {count} </b>项'
            }
          },
          result: {
            item: {
              ___title: '检测结果说明',
              content: {
                ___乳糖代謝相關: '<b>乳糖代谢相关：</b>乳糖不耐症是一种因小肠乳糖酶活性不足所引起的消化表现型，主要与 LCT 基因在断奶后表现量逐渐下降有关。乳糖酶能否于成年期持续生成，关键取决于 MCM6 基因调控区域的遗传变异;当其调控功能减弱时，会导致 LCT 基因转录活性降 低，使乳糖酶分泌量随年龄增⻑而逐步减少。此类变化通常于成⻑过程中逐渐显现，因 此相关症状多在青少年后期至成人阶段出现，个体对乳糖的耐受性亦随之下降，进而在 摄取乳製品后产生腹胀、腹痛或腹泻等肠胃不适，其症状表现则与乳糖摄取量、肠道菌 相及消化道生理状态密切相关。',
                ___澱粉代謝相關: '<b>淀粉代谢相关：</b>淀粉代谢相关检测是评估个体对碳水化合物的饮食偏好、淀粉与醣类在 肠道中的消化吸收能力与体内血糖调节的稳定程度。分析内容涵盖从大脑对醣类的渴望 与摄取倾向，到小肠的分解吸收效率，再到胰岛素与血糖控制机制，完整呈现碳水化合 物在体内的代谢流程。透过这些基因资讯协助了解个人对淀粉类食物的反应差异，可作 为制定个人化饮食策略与生活型态调整的参考依据。',
                ___睡眠傾向: '<b>睡眠倾向：</b>睡眠是维持神经修复、代谢稳定与免疫功能的重要基础，而个体之间在最佳 入睡时间与精神巅峰时段上的差异，主要源自于体内的生理时钟(昼夜节律，Circadian Rhythm)。本项检测聚焦于关键生理时钟基因，解析个人先天的节律特徵。在白天， CLOCK 蛋白会与 BMAL1 结合，启动下游 PER 与 CRY 基因的转录;随著夜晚来临，PER 与 CRY 蛋白逐渐累积并形成複合体，回过头抑制 CLOCK:BMAL1 的活性，关闭基因表 现。这套週期性启动与抑制的分子机制，构成约 24 小时的生理节律循环，进而影响个体 的睡眠时间偏好、清醒程度与日间表现。',
                ___酒精耐受性: '<b>酒精耐受性：</b>酒精在体内主要经由肝脏的两阶段酵素反应进行代谢。本检测分析关键基 因 ADH1B 与 ALDH2，评估个人酒精代谢能力。第一阶段由 ADH1B 将酒精转化为具毒性 的乙醛，可能引发脸红、心悸与头痛;第二阶段则由 ALDH2 将乙醛进一步分解为无毒的 乙酸并排出体外。这两个基因的变异会影响乙醛累积程度，进而决定酒精耐受度及酒精 对身体造成伤害的风险。',
                ___血栓傾向: '<b>血栓倾向：</b>血栓风险除了生活习惯外，也深受体内叶酸与维生素B代谢效率影响，而这套机制的核心在于MTHFR、MTRR等基因所构成的同型半胱胺酸（HCY）代谢系统。其中，MTHFR 将一般叶酸转换为可被身体利用的活性甲基形式；MTR维持维生素B12的活性，使甲基能顺利参与代谢反应，而B12是将HCY酸转化为甲硫胺酸的必要辅因子。当上述任一环节功能下降，HCY便可能在血液中累积，损伤血管内皮，进而提高血栓、心血管疾病与中风的风险。',
                ___咖啡因耐受性: '<b>咖啡因耐受性：</b>个体对咖啡因的耐受差异，主要来自「清除速度」与「神经反应强度」 两个层面。CYP1A2 影响肝脏分解咖啡因的效率，代谢较慢时，咖啡因在体内停留较久， 较容易干扰心脏负荷与睡眠节律;ADORA2A 则调控大脑对咖啡因的刺激反应，部分基 因型会使神经系统对咖啡因反应放大，即使少量摄取也可能出现紧张、焦躁或不适感。'
              }
            }
          }
        },
        '體質相關-乳糖代謝相關': {
          result: {
            table: {
              ___title: '详细检测项目',
              info: {
                ___title: '乳糖代谢相关',
                ___content01: '<b>乳糖不耐症是人类的「节能本能」。</b>',
                ___content02: '人体为了节省能量，设定在断奶后由 MCM6（开关）自动关闭 LCT 基因（生产线）来停止製造乳糖酶；除非你的基因发生变异让开关保持开启（乳糖耐受），否则成年后因无法分解乳糖而产生不适，是身体遵循原始进化设定、避免浪费资源的正常表现。'
              }
            }
          }
        },
        '體質相關-澱粉代謝相關': {
          result: {
            table: {
              info: {
                ___title: '淀粉代谢相关',
                ___content01: '这些淀粉代谢相关基因位点反映了个体在葡萄糖吸收、胰岛素分泌、肝脏葡萄糖利用及能量平衡的综合代谢特质，不同基因型的组合会影响餐前与餐后血糖水平、胰岛素反应速率、血脂生成及能量储存倾向，使个体在淀粉摄取后的代谢表现呈现差异。透过此分析，可辨识日常饮食中较易受影响的环节，例如血糖波动较大或脂肪累积倾向，并作为个人化饮食与生活型态调整的参考;具体策略仍建议搭配专业医师谘询与评估。'
              }
            }
          }
        },
        '體質相關-睡眠傾向': {
          result: {
            table: {
              info: {
                ___title: '睡眠倾向',
                ___content01: '早上时，CLOCK 蛋白会与另一个名为 BMAL1 的蛋白结合启动下游基因 (PER, CRY) 的转录。晚上时，当这些蛋白质累积到一定浓度后，它们会互相结合(形成 PER:CRY 複合体)，并接黏在 CLOCK:BMAL1 複合体上，关掉开关。'
              }
            }
          }
        },
        '體質相關-酒精耐受性': {
          result: {
            table: {
              info: {
                ___title: '酒精耐受性',
                grid: {
                  title: {
                    ___組合類型: '组合类型',
                    ___乙醛代謝正常: 'ALDH2(G/G)\n乙醛代谢正常',
                    ___乙醛代謝差: 'ALDH2(G/A)\n乙醛代谢差',
                    ___乙醛代謝超差: 'ALDH2(A/A)\n乙醛代谢超差',
                    ___超快解酒: 'ADH1B(T/T)超快解酒',
                    ___快速解酒: 'ADH1B(T/C)快速解酒',
                    ___正常解酒: 'ADH1B(C/C)正常解酒'
                  },
                  content: {
                    ___超快解酒_乙醛代謝正常: '海量型',
                    ___超快解酒_乙醛代謝差: '易醉易红型',
                    ___超快解酒_乙醛代謝超差: '酒精毒害型',
                    ___快速解酒_乙醛代謝正常: '稳健畅饮型',
                    ___快速解酒_乙醛代謝差: '红脸敏感型',
                    ___快速解酒_乙醛代謝超差: '不胜酒力型',
                    ___正常解酒_乙醛代謝正常: '标准社交型',
                    ___正常解酒_乙醛代謝差: '浅嚐即止型',
                    ___正常解酒_乙醛代謝超差: '滴酒不沾型'
                  }
                }
              }
            }
          }
        },
        '體質相關-血栓傾向': {
          result: {
            table: {
              info: {
                ___title: '血栓倾向',
                ___content01: 'MTHFR 把「一般叶酸」转换为可用甲基;MTRR 维持 B12 活性,决定甲基「能不能真的交出去」,B12 是 HCY(同型半胱胺酸) 转化为 Methionine(甲硫胺酸)的必要辅因子。'
              }
            }
          }
        },
        '體質相關-咖啡因耐受性': {
          result: {
            table: {
              info: {
                ___title: '咖啡因耐受性',
                ___content01: '本检测分析 CYP1A2 与 ADORA2A 基因型，评估个体对咖啡因的代谢速度与敏感性，进而预测咖啡因反应。CYP1A2 影响咖啡因在体内的分解快慢，而 ADORA2A 影响脑部对咖啡因的刺激敏感度。透过基因型资讯，可了解个人对咖啡因的耐受程度，帮助调整饮用量，降低心悸、焦虑或睡眠干扰等不适风险，并提升提神效果的稳定性。'
              }
            }
          }
        },
        '藥物代謝-結果': {
          info: {
            ___content01: '由于每个人的基因组成不同，进而影响药物在体内的代谢速度与反应。因此药物代谢基因检测是现代医学的重要工具，能帮助医师为患者选择最适合的药物与剂量，避免不必要的副作用与毒性反应，并提升治疗效果。透过基因检测与个人化的医疗策略，我们可以更好地「对症下药」，避免「一药通用」的风险，为患者提供更安全、有效的治疗选择。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>项',
              ___title: '药物代谢相关位点'
            },
            count: {
              ___value: '共检出<b> {count} </b>项',
              ___title: '有潜在影响'
            }
          },
          result: {
            item: {
              ___title: '检测结果说明',
              content: {
                ___default01: '本项临床用药安全与个人化医疗检测,涵盖从日常止痛、心血管与神经精神治疗,到手术麻醉、抗感染及肿瘤化疗等六大关键用药领域,旨在解析个体在药物活性发挥与毒性耐受上的遗传差异。药物若无法在体内被正确代谢,可能导致疗效不足或副作用风险上升,例如抗血栓药物保护力不足、精神科药物引发代谢异常、麻醉或抗感染药物造成罕见但严重的过敏与器官毒性,甚至化疗与止痛药引发心肾损伤、造血抑制或药物蓄积。透过药物代谢基因检测,医疗团队可在治疗前即辨识潜在风险,调整合适的药物与剂量,避免反覆试药,将医疗从事后处理转为事前预防,提升用药安全性与整体生活品质。本结果评估的是基因与药物反应之关联性,非直接用药或剂量建议,实际治疗仍需由医师综合临床判断。'
              }
            },
            table: {
              ___title: '详细检测项目'
            }
          }
        },
        '阿茲海默症風險評估-結果': {
          info: {
            ___content01: '由于每个人的基因组成不同，进而影响药物在体内的代谢速度与反应。因此药物代谢基因检测是现代医学的重要工具，能帮助医师为患者选择最适合的药物与剂量，避免不必要的副作用与毒性反应，并提升治疗效果。透过基因检测与个人化的医疗策略，我们可以更好地「对症下药」，避免「一药通用」的风险，为患者提供更安全、有效的治疗选择。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>个阿兹海默风险评估相关位点'
            },
            count: {
              ___value: '检验为<b> {type} </b>类型'
            }
          },
          result: {
            table: {
              ___title: '检测结果说明',
              content: {
                ___default01: 'ApoE 基因是目前已知与阿兹海默症最密切相关的遗传因子，尤其是其ε4 等位基因(ApoE ε4)，被广泛认为是晚发型阿兹海默症的最强风险因子。',
                ___default02: 'ApoE 基因位于第 19 对染色体，主要参与脂质代谢与脑部神经修复。人类共有三种主要等位型:ε2、ε3 与 ε4。其中 ε3 是最常见型，属中性;而 ε2 被认为具有保护作用;相对地，携带一个ε4 等位基因者，发展阿兹海默症的风险提高约 3-5 倍，若为双等位基因(ε4/ε4)，风险更可高达 10-15 倍。',
                ___default03: '此外，ApoE ε4 携带者的发病年龄往往较早，并且在病程中出现更明显的类淀粉蛋白沉积与 tau 病变，这使得 ApoE 检测不仅能提供个人化的风险预测，也成为临床研究中进行分层筛选的重要工具。'
              },
              data: {
                'ε2/ε2': {
                  ___基因型: 'ε2/ε2',
                  ___人口常見率: '0.70%',
                  ___風險等級: '最低风险',
                  ___臨床意義: '具有最强的保护作用，患病风险最低。'
                },
                'ε2/ε3': {
                  ___基因型: 'ε2/ε3',
                  ___人口常見率: '17.10%',
                  ___風險等級: '低风险',
                  ___臨床意義: '携带保护性 ε2，风险低于平均。'
                },
                'ε3/ε3': {
                  ___基因型: 'ε3/ε3',
                  ___人口常見率: '55.80%',
                  ___風險等級: '低风险',
                  ___臨床意義: '最常见的基因型,风险与一般人群相似。'
                },
                'ε2/ε4': {
                  ___基因型: 'ε2/ε4',
                  ___人口常見率: '4.10%',
                  ___風險等級: '中风险',
                  ___臨床意義: 'ε2 的保护作用可能部分抵消 ε4 的风险,但仍需注意。'
                },
                'ε3/ε4': {
                  ___基因型: 'ε3/ε4',
                  ___人口常見率: '20.00%',
                  ___風險等級: '中高风险',
                  ___臨床意義: '携带一个高风险 ε4,患病机率增加 3-5 倍。'
                },
                'ε4/ε4': {
                  ___基因型: 'ε4/ε4',
                  ___人口常見率: '2.30%',
                  ___風險等級: '最高风险',
                  ___臨床意義: '携带两个 ε4,患病机率增加 10-15 倍,被视为高危险群。'
                }
              }
            }
          }
        },
        '神經退化相關-結果': {
          info: {
            ___content01: '该项基因检测专注于多种神经退化性疾病（Neurodegenerative Diseases）及部分相关的遗传性神经系统疾病。这些疾病的共同核心特徵是神经细胞（包括大脑和脊髓的神经元）会发生进行性的功能丧失或死亡，最终导致患者出现持续恶化的功能障碍。 临床表现的多样性取决于受影响的神经元类型和分佈区域：',
            ___list01: '<b>认知障碍：</b>当大脑皮质和海马体的神经元受损时，会导致记忆力、判断、语言和执行功能下降，这是阿兹海默氏症和遗传性脑部小动脉血管病变等疾病的主要特徵。',
            ___list02: '<b>运动障碍：</b>若影响基底核和运动神经元，则会出现震颤、僵硬、运动迟缓（如帕金森氏症）、协调性变差（如亨廷顿氏病），或全身肌肉无力与萎缩（如脊髓性肌萎缩症和肌萎缩脊髓侧索硬化症）。',
            ___list03: '<b>周边神经病变：</b>当周边神经系统受到影响时，会表现为感觉异常、麻木或疼痛，以及远端肌肉无力，常见于家族性类淀粉多发性神经病变。'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>项',
              ___title: '神经退化相关基因'
            },
            count: {
              ___value: '共检出<b> {count} </b>项',
              ___title: '文献已知之相关基因'
            }
          },
          result: {
            variant: {
              ___title: '检测结果说明',
              ___subtitle: '受检者携带以下曾被记载可能致病的突变位点，共 <span style=color:#BF8F00>{count}</span> 项'
            },
            table: {
              ___title: '详细检测项目'
            }
          }
        },
        '帶因篩查-結果': {
          info: {
            ___content01: '带因筛查的主要目的是检测个案是否携带隐性基因突变，特别是那些可能导致严重遗传疾病的基因变异。这项检测在婚前和产前阶段具有重要意义，能帮助夫妻了解自身携带基因突变的风险，并为未来的生育计划提供科学依据。透过早期的检测与专业的遗传谘询，夫妻可以採取适当的预防措施，以降低下一代罹患遗传疾病的风险，为家庭健康奠定坚实的基础。',
            ___content02: '<b>＊依据人类孟德尔遗传学资料库 ( O M I M ) 记载</b>'
          },
          summary: {
            totald: {
              ___value: '在<b> {count} </b>项',
              ___title: '相关疾病'
            },
            totalg: {
              ___value: '在<b> {count} </b>项',
              ___title: '相关基因'
            },
            count: {
              ___value: '共检出<b> {count} </b>项',
              ___title: '文献已知之致病性变异'
            }
          },
          result: {
            variant: {
              ___title: '检测结果说明',
              ___subtitle: '受检者携带以下曾被记载可能致病的突变位点，共 <span style=color:#BF8F00>{count}</span> 项'
            },
            note: {
              ___title: '检测说明',
              ___subtitle: '未检出',
              ___content: '基因名：<b>{gene}</b>，若夫妻双方皆带有此突变时，<b>下一代将有 25% 的机率罹患「{disease}」</b>，建议于婚前 / 产前谘询相关医师。',
              ___more: '<span style=color:#FF0000>*更多资讯：</span>若您想检视更详细的带因者资讯，我们也在「附录」中为您逐项列举最常见之遗传疾病。'
            }
          }
        },
        '族裔分析-結果': {
          info: {
            ___content01: '在族裔报告中，了解自己的祖源不仅能满足对祖先来源的好奇心，更能深化对自身文化背景的认同感，进一步强化个人与家族、族群的连结，并在多元文化的社会中找到归属感。此外，由于不同种族在基因上存在差异，这些差异可能影响某些疾病的发生率、药物反应以及健康风险。因此，了解自己的种族背景不仅具有文化意义，更具有重要的医学价值。透过族裔报告，个人可以获得更精准的健康资讯，并与医疗专业人员合作，制定更适合自己的预防与治疗方案。'
          },
          result: {
            chart: {
              title: {
                ___主要: '主要',
                ___其他: '其他',
                ___無: '无\n（0%）'
              }
            }
          }
        },
        '生殖與生育-結果': {
          info: {
            ___content01: '本基因筛检涵盖多项已知与男性及女性生殖功能异常高度相关的遗传疾病与生理机制,重点包含精子生成障碍、性腺与性别分化异常、下视丘–脑下垂体–性腺轴(HPG axis)调控缺陷、类固醇生成与荷尔蒙代谢异常,以及部分全身性症候群中伴随之生殖功能受损表现。相关遗传变异可能影响配子形成、荷尔蒙分泌与反应、性腺发育或生殖道结构完整性,进而降低自然受孕的机率。透过此筛检,辨识潜在遗传风险,作为生育规划、性别特异风险评估、后续医疗谘询与生殖策略选择(如辅助生殖技术)的重要参考依据。',
            ___content02: '<b>＊依据人类孟德尔遗传学资料库 ( O M I M ) 记载</b>'
          },
          summary: {
            total: {
              ___value: '在<b> {count} </b>项',
              ___title: '相关基因'
            },
            count: {
              ___value: '共检出<b> {count} </b>项',
              ___title: '文献已知之致病性变异'
            }
          },
          result: {
            variant: {
              ___title: '检测结果说明',
              ___subtitle: '受检者携带以下曾被记载可能致病的突变位点，共 <span style=color:#BF8F00>{count}</span> 项'
            },
            note: {
              ___title: '检测说明',
              ___subtitle: '未检出',
              ___content: '基因名：<b>{gene}</b>，若检出带有此变异时，有可能罹患<b>「{disease}」</b>，建议于婚前 / 产前谘询相关医师。',
              ___more: '<span style=color:#FF0000>*更多资讯：</span>若您想检视更详细的资讯，我们也在「附录」中为您逐项列举{sex}生殖与生育相关基因清单。'
            }
          }
        }
      }
    },
    template: {
      testingMethod: {
        sampleInfo: {
          title: {
            ___樣本庫試劑組: '样本库试剂组',
            ___數據量: '数据量',
            ___定序平台: '定序平台',
            ___覆蓋深度: '覆盖深度',
            ___VariantCalling: 'Variant Calling 软体',
            ___數據品質: '数据品质'
          },
          content: {
            檢測說明: {
              ___title: '检测说明',
              ___content: '<ul>\n  <li>1000ng \u5F85\u6D4B\u68C0\u4F53\u7684\u57FA\u56E0\u4F53 DNA \u7ECF\u8D85\u97F3\u6CE2\u9707\u76EA\u5904\u7406\uFF0C\u7247\u65AD\u5316\u6210\u4E3A\u5E73\u5747\u4E3A 250~450bp \u7684 DNA \u7247\u6BB5\u3002\u63A1 \u7528\u7B26\u5408 Illumina \u5E73\u53F0\u7684 Whole Genome Sequencing PCR-Free \u8FDB\u884C\u6587\u5E93\u88FD\u5907\u3002DNA \u7247\u6BB5\u7ECF\u8FC7\u653E\u5927 \u540E\uFF0C\u653E\u5927\u540E\u7684\u4EA7\u7269\u4F1A\u7ECF\u7531 NovaSeq \u5B9A\u5E8F\u4EEA\u8FDB\u884C 2 x 150 bp Paired-End \u7684\u5B9A\u5E8F\u3002</li>\n  <li>\u5206\u6790\u65B9\u6CD5\u4F9D\u751F\u7269\u8D44\u8BAF\u516C\u53F8\u6240\u5EFA\u7ACB\u4E4B\u5206\u6790\u6D41\u7A0B\u8FDB\u884C\uFF0C\u4E0B\u673A\u4E4B\u5E8F\u5217\u7ECF\u5206\u7FA4\u53BB\u6807\u7C64\u5316\u540E\uFF0C\u6839\u636E GRCh38 \u4F7F\u7528 Parabrick (4.5.0-1) \u8FDB\u884C\u5E8F\u5217\u6BD4\u5BF9\u53CA Parabrick (4.5.0-1) \u8FDB\u884C\u53D8\u5F02\u4F4D\u70B9\u627E\u5BFB\u3002\u786E\u8BA4\u7684\u53D8\u5F02\u4F4D\u70B9\u7ECF\u7531 Variant Effect Predictor (v101) \u53CA Jannovar(0.35) \u8FDB\u884C\u6CE8\u89E3\u3002\u6839\u636E ACMG / AMP 2015 \u6307\u5357\u5BF9\u9057\u4F20\u53D8\u5F02 \u8FDB\u884C\u4E34\u5E8A\u89E3\u91CA\u3002</li>\n  <li>\n    <span>\u672C\u68C0\u6D4B\u65B9\u6CD5\u5B58\u5728\u4EE5\u4E0B\u9650\u5236:</span>\n    <ul>\n      <li>\u91CD\u8907\u5E8F\u5217:\u57FA\u56E0\u4F53\u4E2D\u5145\u6EE1\u4E86\u9AD8\u5EA6\u91CD\u8907\u7684\u5E8F\u5217\u3002\u5F53\u788E\u7247\u592A\u5C0F\u65F6\uFF0C\u96BE\u4EE5\u5224\u65AD\u8FD9\u4E9B\u788E\u7247\u8BE5\u5F52\u4F4D\u5728\u54EA\u88E1(\u5982X \u67D3\u8272\u4F53\u8106\u6298\u75C7)\u3002</li>\n      <li>\u7ED3\u6784\u53D8\u5F02:\u5BF9\u4E8E\u5927\u578B\u7684 DNA \u5012\u7F6E\u3001\u8F6C\u4F4D\u6216\u5927\u7247\u6BB5\u7F3A\u5931\uFF0C\u77ED\u8BFB\u2ED1\u6280\u672F\u96BE\u4EE5\u7CBE\u786E\u4FA6\u6D4B\u3002</li>\n      <li>\u52A8\u6001\u7A81\u53D8:\u67D0\u4E9B\u75BE\u75C5(\u5982\u5C0F\u8111\u840E\u7F29\u75C7\u3001\u4EA8\u4E01\u987F\u821E\u8E48\u75C7)\u662F\u7531\u7279\u5B9A\u5E8F\u5217\u7684\u5927\u91CF\u91CD\u8907\u5F15\u8D77\u7684\uFF0C\u5168\u57FA\u56E0\u4F53\u5B9A\u5E8F(WGS)\u5728\u7CBE\u786E\u8BA1\u7B97\u8FD9\u4E9B\u91CD\u8907\u6B21\u6570\u4E0A\u4ECD\u6709\u6311\u6218\u3002</li>\n      <li>\u9AD8\u5EA6\u540C\u6E90\u533A\u57DF:\u67D0\u4E9B\u529F\u80FD\u57FA\u56E0\u4E0E\u300C\u4F2A\u57FA\u56E0\u300D\u5E8F\u5217\u6781\u4E3A\u76F8\u4F3C\uFF0CWGS \u53EF\u80FD\u4F1A\u53D1\u751F\u300C\u8BEF\u8BA4\u300D\u6216\u96BE\u4EE5\u5BF9\u9F50\u7684\u60C5\u51B5\u3002</li>\n      <li>\u8868\u89C2\u9057\u4F20\u5B66:\u6807\u51C6 WGS \u65E0\u6CD5\u4FA6\u6D4B DNA \u7532\u57FA\u5316\u6216\u7EC4\u86CB\u767D\u4FEE\u9970\u3002\u5373\u4FBF\u5E8F\u5217\u5B8C\u5168\u6B63\u5E38\uFF0C\u5982\u679C\u5F00\u5173(\u7532\u57FA\u5316)\u51FA\u95EE\u9898\uFF0C\u57FA\u56E0\u4ECD\u53EF\u80FD\u4E0D\u8868\u73B0\u3002</li>\n      <li>\u5D4C\u5408\u4F53\u73B0\u8C61:\u5982\u679C\u53D8\u5F02\u4EC5\u5B58\u5728\u4E8E\u5C11\u6570\u7EC6\u80DE\u4E2D(\u4F8B\u5982\u53EA\u6709 5%\u7684\u7EC6\u80DE\u6709\u7A81\u53D8)\uFF0C\u6807\u51C6\u6D53\u5EA6\u7684 WGS \u53EF\u80FD\u4F1A\u5C06\u5176\u89C6\u4E3A\u80CC\u666F\u6742\u8BAF\u800C\u5FFD\u7565\u3002</li>\n      <li>\u7C92\u7EBF\u4F53 DNA:\u867D\u7136 WGS \u5305\u542B\u7C92\u7EBF\u4F53\uFF0C\u4F46\u7531\u4E8E\u7C92\u7EBF\u4F53\u4E0E\u6838 DNA \u7684\u6BD4\u4F8B\u5DEE\u5F02\u5DE8\u5927\uFF0C\u6709\u65F6\u9700\u8981\u4E13\u95E8\u7684\u5206\u6790\u6D41\u7A0B\u624D\u80FD\u786E\u4FDD\u51C6\u786E\u5EA6\u3002</li>\n      <li>\u975E\u7F16\u7801\u533A\u7684\u8FF7\u601D:WGS \u6DB5\u76D6\u4E86 98%\u7684\u975E\u7F16\u7801\u533A\uFF0C\u4F46\u76EE\u524D\u4EBA\u7C7B\u5BF9\u8FD9\u4E9B\u533A\u57DF\u7684\u529F\u80FD\u77AD\u89E3\u6781\u5176\u6709\u9650\uFF0C\u65E0\u6CD5\u7ED9\u51FA\u7ED3\u8BBA\u3002</li>\n      <li>\u67D3\u8272\u4F53\u6570\u76EE\u5F02\u5E38:\u9488\u5BF9\u67D3\u8272\u4F53\u6570\u76EE\u5F02\u5E38\u75BE\u75C5(\u5982:\u5510\u6C0F\u75C7\u3001Turner syndrome\u3001\u514B\u84DD\u8D39\u7279\u6C0F\u75C7\u3001Trisomy X \u7B49)\uFF0CWGS \u4EC5\u80FD\u4EE5\u8BFB\u5E8F\u6DF1\u5EA6\u63A8\u4F30\u6574\u4F53\u62F7\u8D1D\u6570\u53D8\u5316\u800C\u65E0\u6CD5\u5B9A\u8BBA\uFF0C\u6545\u5E94\u4EE5\u67D3\u8272\u4F53\u68C0\u67E5\u4F18\u5148\u3002</li>\n    </ul>\n  </li>\n</ul>'
            },
            技術極限與聲明: {
              ___title: '技术极限与声明',
              ___content: '<ul>\n  <li>\u7531\u4E8E\u73B0\u5B58\u5B9E\u9A8C\u6280\u672F\u6781\u9650\uFF0C\u90E8\u5206\u57FA\u56E0\u4E4B\u8986\u76D6\u6DF1\u5EA6\u53EF\u80FD\u672A\u8FBE 10X > 95%\u7684\u6807\u51C6\u3002</li>\n  <li>\u672C\u68C0\u6D4B\u4EE5\u7F8E\u56FD\u4EBA\u7C7B\u9057\u4F20\u5B66\u4F1A (ACMG) \u53CA\u4EBA\u7C7B\u57FA\u56E0\u7EC4\u53D8\u5F02\u8D44\u6599\u5E93 (ClinVar) \u4F5C\u4E3A\u81F4\u75C5\u6027\u5224\u5B9A\u4F9D\u636E\uFF0C\u5E76\u53C2\u8003\u4EBA\u7C7B\u5B5F\u5FB7\u5C14\u9057\u4F20\u5B66\u8D44\u6599\u5E93 (OMIM) \u6240\u8BB0\u8F7D\u4E4B\u57FA\u56E0\u76F8\u5173\u8868\u73B0\u578B\u3002\u7136\u800C\uFF0C\u672A\u66FE\u88AB\u767B\u8F7D\u7684\u4F4D\u70B9\uFF0C\u4ECD\u6709\u53EF\u80FD\u5BFC\u81F4\u75BE\u75C5\u6216\u5F71\u54CD\u8868\u73B0\u578B\u3002</li>\n  <li>\u672C\u62A5\u544A\u5E76\u975E\u6700\u7EC8\u98CE\u9669\u8BC4\u4F30\u7ED3\u679C\uFF0C\u4ECD\u9700\u7ECF\u5408\u683C\u533B\u5E08\u3001\u9057\u4F20\u8C18\u8BE2\u5E08\u8FDB\u884C\u7EFC\u5408\u4E34\u5E8A\u8BC4\u4F30\u4E0E\u5EFA\u8BAE\u3002</li>\n  <li>\u672C\u68C0\u6D4B\u7CFB\u7EDF\u53EF\u80FD\u4F1A\u968F\u65F6\u66F4\u65B0\u8D44\u6599\u5E93\u3001\u6F14\u7B97\u6CD5\u3001\u68C0\u6D4B\u57FA\u56E0\u4E0E\u4F4D\u70B9\uFF0C\u4EE5\u53CA\u76F8\u5173\u4E4B\u68C0\u6D4B\u9879\u76EE\u63CF\u8FF0\u4E0E\u5185\u5BB9\uFF0C\u5BF9\u4E8E\u68C0\u6D4B\u7CFB\u7EDF\u53CA\u62A5\u544A\u4E4B\u66F4\u65B0\uFF0C\u672C\u9662\u62E5\u6709\u6700\u7EC8\u89E3\u91CA\u6743\u3002</li>\n  <li>\u672C\u68C0\u6D4B\u4E2D\u836F\u7269\u4EE3\u8C22\u76F8\u5173\u57FA\u56E0\u4E4B\u4E34\u5E8A\u89E3\u8BFB\uFF0C\u4FC2\u4F9D\u636E PharmGKB(Pharmacogenomics Knowledgebase\uFF0C\u836F\u7269\u57FA\u56E0\u4F53\u8D44\u6599\u5E93) \u4E0E ClinPGx(Clinical Pharmacogenomics\uFF0C\u4E34\u5E8A\u836F\u7269\u57FA\u56E0\u4F53\u5B66) \u8D44\u6599\u5E93\u8FDB\u884C\u5F59\u6574 \u4E0E\u5224\u8BFB\u3002PharmGKB \u4E3A\u7F8E\u56FD\u56FD\u5BB6\u536B\u751F\u7814\u7A76\u9662(NIH)\u8D44\u52A9\u5EFA\u7ACB\u4E4B\u6743\u5A01\u836F\u7269\u57FA\u56E0\u4F53\u5B66\u8D44\u6599\u5E93\uFF0C\u7CFB\u7EDF\u6027\u6574\u5408 \u57FA\u56E0\u53D8\u5F02\u4E0E\u836F\u7269\u53CD\u5E94\u3001\u4EE3\u8C22\u9014\u5F84\u3001\u4E0D\u826F\u53CD\u5E94\u53CA\u4E34\u5E8A\u7528\u836F\u6307\u5F15\u7B49\u76F8\u5173\u8BC1\u636E\uFF0C\u5E76\u4F9D\u636E\u8BC1\u636E\u5F3A\u5EA6\u5BF9\u5404\u57FA\u56E0\u4F4D\u70B9 \u8FDB\u884C\u5206\u7EA7\u3002\u4E3A\u786E\u4FDD\u62A5\u544A\u4E4B\u79D1\u5B66\u6027\u4E0E\u53EF\u4FE1\u5EA6\uFF0C\u672C\u68C0\u6D4B\u4EC5\u9009\u53D6 <b>Level 3 \u4EE5\u4E0A</b> \u5177\u5145\u5206\u6587\u732E\u652F\u6301\u4E4B\u57FA\u56E0\u4F4D\u70B9\u8FDB\u884C \u89E3\u8BFB\u3002ClinPGx \u5219\u4FC2\u5C06\u836F\u7269\u57FA\u56E0\u4F53\u5B66\u5E94\u7528\u4E8E\u4E34\u5E8A\u533B\u7597\u51B3\u7B56\uFF0C\u900F\u8FC7\u5206\u6790\u4E2A\u4F53\u57FA\u56E0\u53D8\u5F02\u5BF9\u836F\u7269\u7597\u6548\u3001\u4EE3\u8C22\u80FD \u529B\u53CA\u4E0D\u826F\u53CD\u5E94\u98CE\u9669\u4E4B\u5F71\u54CD\uFF0C\u534F\u52A9\u4E34\u5E8A\u533B\u5E08\u8FDB\u884C\u66F4\u7CBE\u51C6\u4E4B\u7528\u836F\u9009\u62E9\u4E0E\u5242\u91CF\u8C03\u6574\u3002</li>\n  <li>\u4F9D\u636E\u7F8E\u56FD\u533B\u5B66\u9057\u4F20\u5B66\u4E0E\u57FA\u56E0\u4F53\u5B66\u5BF9\u6269\u5C55\u6027\u5E26\u56E0\u8005\u7B5B\u68C0(Expanded Carrier Screening, ECS)\u4E4B\u5EFA\u8BAE\uFF0C\u5E26 \u56E0\u8005\u7B5B\u68C0\u9879\u76EE\u5E94\u63A1\u5206\u5C42\u5F0F(tier-based)\u8BBE\u8BA1\uFF0C\u4EE5\u517C\u987E\u4E34\u5E8A\u91CD\u8981\u6027\u4E0E\u65CF\u7FA4\u98CE\u9669\u8BC4\u4F30\u3002ACMG \u5C06\u5EFA\u8BAE\u7B5B\u68C0 \u4E4B\u75BE\u75C5\u533A\u5206\u4E3A\u4E09\u4E2A\u9636\u5C42:<b>Tier 1</b> \u4E3A\u6240\u6709\u65CF\u7FA4\u7686\u5E94\u63A5\u53D7\u4E4B\u57FA\u672C\u7B5B\u68C0\u9879\u76EE\uFF0C\u5305\u62EC\u56CA\u72B6\u7EA4\u7EF4\u5316\u75C7(Cystic Fibrosis, CF)\u4E0E\u810A\u9AD3\u6027\u808C\u8089\u840E\u7F29\u75C7(Spinal Muscular Atrophy, SMA)\uFF0C\u5E76\u53EF\u4F9D\u4E0D\u540C\u65CF\u7FA4\u4E4B\u9AD8\u98CE\u9669\u75BE\u75C5 \u8FDB\u884C\u8865\u5145;<b>Tier 2</b> \u4E3A\u5177\u4E25\u91CD\u6216\u4E2D\u5EA6\u4E34\u5E8A\u8868\u578B\uFF0C\u4E14\u4E8E\u4E00\u822C\u65CF\u7FA4\u4E2D\u5E26\u56E0\u8005\u9891\u7387\u81F3\u5C11\u4E3A 1/100 \u4E4B\u9057\u4F20\u75BE\u75C5;<b>Tier 3</b> \u5219\u8FDB\u4E00\u6B65\u6DB5\u76D6\u5E26\u56E0\u8005\u9891\u7387\u8FBE \u22651/200 \u4E4B\u9057\u4F20\u75BE\u75C5\uFF0C\u4EE5\u63D0\u4F9B\u66F4\u5168\u9762\u4E4B\u751F\u80B2\u98CE\u9669\u8BC4\u4F30\u3002\u672C\u68C0\u6D4B\u9879\u76EE\u4E4B\u8BBE\u8BA1\u4FC2 \u4F9D\u5FAA\u4E0A\u8FF0\u539F\u5219\uFF0C\u4F5C\u4E3A\u8BC4\u4F30\u53D7\u68C0\u8005\u6F5C\u5728\u9690\u6027\u9057\u4F20\u75BE\u75C5\u5E26\u56E0\u98CE\u9669\u4E4B\u4F9D\u636E\u3002</li>\n</ul>'
            },
            族裔分析檢測說明: {
              ___title: '族裔分析检测说明',
              ___content: '<ul>\n  <li>\u6B64\u5206\u6790\u7ED3\u5408 1000 Genomes Project(1000G)\u4E0E Human Genome Diversity Project(HGDP)\u4E24\u5927\u516C\u5F00 \u6570\u636E\u5E93\uFF0C\u900F\u8FC7\u6570\u636E\u6574\u5408\u4E0E\u524D\u5904\u7406\uFF0C\u5229\u7528 PLINK \u8FDB\u884C\u8FDE\u9501\u4E0D\u5E73\u8861(Linkage Disequilibrium, LD)\u8FC7\u6EE4\uFF0C\u786E \u4FDD\u57FA\u56E0\u578B\u6570\u636E\u7684\u72EC\u7ACB\u6027\uFF0C\u7136\u540E\u5E94\u7528 ADMIXTURE \u5DE5\u5177\u63A8\u7B97\u4E2A\u4F53\u7684\u7956\u6E90\u6210\u5206\u3002\u6B64\u65B9\u6CD5\u900F\u8FC7\u6700\u5927\u4F3C\u7136\u6CD5 (Maximum Likelihood Estimation)\u8BC4\u4F30\u4E0D\u540C\u65CF\u7FA4\u7684\u57FA\u56E0\u8D21\u732E\uFF0C\u5E76\u4EE5\u53EF\u89C6\u5316\u7ED3\u679C\u5448\u73B0\u7956\u6E90\u7EC4\u6210\u3002</li>\n  <li>\u4F7F\u7528\u8005\u7684\u6570\u636E\u5C06\u4ECE FASTQ \u539F\u59CB\u6D4B\u5E8F\u6570\u636E\u5F00\u59CB\u5904\u7406\uFF0C\u9996\u5148\u8FDB\u884C\u6BD4\u5BF9(Mapping)\uFF0C\u5C06\u8BFB\u53D6\u5E8F\u5217\u5BF9\u9F50\u5230\u53C2\u8003 \u57FA\u56E0\u7EC4\uFF0C\u63A5\u8457\u6267\u884C**\u53D8\u5F02\u68C0\u6D4B(Variant Calling)**\u4EE5\u8BC6\u522B SNP \u4E0E Indel \u53D8\u5F02\u3002\u968F\u540E\uFF0C\u4ECE\u53D8\u5F02\u6570\u636E\u4E2D\u7B5B\u9009 \u4E0E\u7956\u6E90\u5206\u6790\u76F8\u5173\u7684\u4F4D\u70B9\uFF0C\u786E\u4FDD\u4E0E\u53C2\u8003\u6570\u636E\u96C6\u4E2D\u7684\u6807\u8BB0\u4F4D\u70B9\u4E00\u81F4\uFF0C\u4ECE\u800C\u63D0\u9AD8\u6BD4\u8F83\u7684\u51C6\u786E\u6027\u3002</li>\n  <li>\u7136\u800C\uFF0C\u672C\u65B9\u6CD5\u7684\u51C6\u786E\u6027\u53D7\u5230\u53C2\u8003\u6570\u636E\u5E93\u7684\u4EE3\u8868\u6027\u5F71\u54CD\uFF0C\u4F8B\u5982\u67D0\u4E9B\u65CF\u7FA4\u5728 1000G \u4E0E HGDP \u6570\u636E\u4E2D\u7684\u6DB5\u76D6\u8303 \u56F4\u8F83\u5C11\uFF0C\u53EF\u80FD\u5BFC\u81F4\u7ED3\u679C\u504F\u5DEE\u3002\u6B64\u5916\uFF0CADMIXTURE \u7684\u5047\u8BBE\u57FA\u4E8E\u7279\u5B9A\u7956\u5148\u7FA4\u4F53\u6A21\u578B\uFF0C\u672A\u5FC5\u80FD\u5B8C\u5168\u53CD\u6620\u5386\u53F2 \u4E0A\u8907\u6742\u7684\u65CF\u7FA4\u8FC1\u79FB\u4E0E\u6DF7\u5408\u8FC7\u7A0B\u3002LD \u8FC7\u6EE4\u867D\u53EF\u51CF\u5C11\u57FA\u56E0\u578B\u8FDE\u9501\u5F71\u54CD\uFF0C\u4F46\u53EF\u80FD\u5F71\u54CD\u67D0\u4E9B\u65CF\u7FA4\u7279\u5F02\u6027\u6807\u8BB0\u7684\u4FDD \u7559\u3002\u6B64\u5916\uFF0C\u6D4B\u5E8F\u8D28\u91CF\u3001\u53D8\u5F02\u68C0\u6D4B\u7684\u51C6\u786E\u5EA6\u4EE5\u53CA\u6570\u636E\u524D\u5904\u7406\u7684\u7B56\u7565\u4E5F\u4F1A\u5BF9\u5206\u6790\u7ED3\u679C\u4EA7\u751F\u5F71\u54CD\u3002\u56E0\u6B64\uFF0C\u5728\u89E3 \u8BFB\u7ED3\u679C\u65F6\uFF0C\u9700\u8003\u8651\u8FD9\u4E9B\u6F5C\u5728\u9650\u5236\uFF0C\u5E76\u8F85\u4EE5\u5176\u4ED6\u5206\u6790\u65B9\u6CD5\u8FDB\u884C\u4EA4\u53C9\u9A8C\u8BC1\u3002</li>\n</ul>'
            }
          }
        }
      },
      carrierScreening: {
        ___title: '说明',
        ___content01: '以下为您逐项列举最常见之遗传疾病，让您更了解带因筛查的详细项目。',
        table: {
          title: {
            ___基因名稱: '基因名称',
            ___疾病名稱: '疾病名称',
            ___遺傳模式: '遗传模式'
          }
        }
      },
      pregnancyGene: {
        ___titlef: '女性相关基因清单',
        ___titlem: '男性相关基因清单',
        table: {
          title: {
            ___基因名稱: '基因名称',
            ___疾病名稱: '疾病名称',
            ___遺傳模式: '遗传模式'
          }
        }
      },
      carrierScreeningLink: {
        ___title: '说明',
        ___content01: '以下为您逐项列举最常见之遗传疾病，让您更了解带因筛查的详细项目。请扫描以下QR Code或拜访网址：'
      },
      pregnancyGeneLink: {
        ___title: '说明',
        ___content01: '以下为您逐项列举最常见之男性与女性生殖与生育相关基因清单，让您更了解生殖与生育的详细项目。请扫描以下QR Code或拜访网址：'
      }
    }
  }
});
// CONCATENATED MODULE: ./src/constants/lang/_tpeReport/ja/lang.js
/* harmony default export */ var ja_lang = ({
  // report
  TPEREPORT: {
    chapter: {
      header: {
        ___info01: '名前',
        ___info02: '報告日'
      },
      footer: {
        ___info01: '＊本報告書は臨床参考用であり、診断結果とは異なります。臨床的意義は、医療従事者によってさらに解釈され、説明される必要があります。',
        ___info02: 'P.{page} / {total}'
      },
      title: {
        ___subject: '基本情報および総合結果  ',
        ___hereditary_cancer: '遺伝性腫瘍のリスク',
        ___metabolic_syndrome: 'メタボリックシンドローム',
        ___cardio: '心血管関連',
        ___constitution_tpehealth: '体質関連',
        ___drug_meta: '薬物代謝',
        ___alzheimer_tpehealth: 'アルツハイマー病のリスク',
        ___neurodegeneration_tpehealth: '神経変性関連',
        ___carrier_screening_tpehealth: 'キャリアスクリーニング',
        ___ethnic: '民族解析（祖先解析）',
        ___reproductive_health_tpehealth: '生殖・生育関連',
        ___method: '付録：検査方法',
        ___appendix_carrier_screening_tpehealth: '付録：キャリアスクリーニング参考リスト',
        ___appendix_reproductive_tpehealth: '付録：生殖・生育遺伝子参照一覧',
        ___appendix_carrier_screening_tpehealth_qrcode: '付録：キャリアスクリーニング参考リンク',
        ___appendix_reproductive_tpehealth_qrcode: '付録：生殖・生育遺伝子参照リンク'
      },
      basic: {
        ___title: '健康者向け全ゲノム検査報告書',
        ___indexTitle: '総　合　結　果',
        form: {
          title: {
            ___case_id: '名前',
            ___sex: '性別',
            ___age: '年齡',
            ___report_date: '検査日',
            ___testing_category: '検体種類',
            ___detection_type: '検査タイプ',
            ___sequencing_platform: 'シーケンスプラットフォーム'
          }
        },
        index: {
          ___resultFalse: '未検出',
          hereditary_cancer: {
            ___title: '遺伝性腫瘍のリスク',
            ___content01: '{total}の遺伝性腫瘍の関連遺伝子の中で、病原性がある可能性のある変異は計<b>{count} 遺伝子</b>です。'
          },
          metabolic_syndrome: {
            ___title: 'メタボリックシンドローム',
            ___content01: '肥満リスクの高い項目：<b>{items}</b>',
            ___content02: '血圧リスクの高い項目：<b>{items}</b>',
            ___content03: '血糖リスクの高い項目：<b>{items}</b>',
            ___content04: '脂質代謝リスクの高い項目：<b>{items}</b>'
          },
          cardio: {
            ___title: '心血管関連',
            ___content01: 'リスクの高い項目：<b>{items}</b>'
          },
          constitution_tpehealth: {
            ___title: '体質関連',
            ___content01: 'リスクの高い項目：<b>{items}</b>のリスクが示唆されます。'
          },
          drug_meta: {
            ___title: '薬物代謝',
            ___content01: 'リスクの高い項目：<b>{items}</b>に関連する遺伝的特性が認められます。'
          },
          alzheimer_tpehealth: {
            ___title: 'アルツハイマー病のリスク',
            ___content01: '{total}種類の遺伝子型のうち、あなたの遺伝子型は<b>{type}</b>です。'
          },
          neurodegeneration_tpehealth: {
            ___title: '神経変性関連',
            ___content01: '{total}項目の神経変性関連遺伝子のうち、<b>{count}個の遺伝子</b>に疾患発症に関連する可能性のある変異が認められました。'
          },
          carrier_screening_tpehealth: {
            ___title: 'キャリアスクリーニング',
            ___content01: '{total}のキャリアスクリーニング対象遺伝子のうち、<b>{count} 遺伝子</b>において、病的である可能性のある変異が検出されました。'
          },
          ethnic: {
            ___title: '民族解析（祖先解析）',
            ___empty: 'なし',
            ___content01: '{total}の集団分類のうち、主な祖先は<b>{resource}</b>と推定されます。'
          },
          reproductive_health_tpehealth: {
            ___title: '生殖・生育関連',
            ___content01: '{total}の生殖・生育関連遺伝子の中で、病原性がある可能性のある変異は計<b>{count} 遺伝子</b>です。'
          }
        }
      },
      info: {
        table: {
          geneItemPart: {
            title: {
              ___項目: '項目',
              ___堆積部位: '堆積部位',
              ___檢測基因: '検査対象遺伝子',
              ___檢測位點: '検査変異箇所',
              ___潛在影響: '潜在的影響'
            }
          },
          geneItem: {
            title: {
              ___項目: '項目',
              ___檢測基因: '検査対象遺伝子',
              ___檢測位點: '検査変異箇所',
              ___潛在影響: '潜在的影響'
            }
          },
          geneDrug: {
            title: {
              ___藥物名稱: '薬剤名',
              ___藥物作用: '薬理作用',
              ___檢測基因: '検査対象遺伝子',
              ___檢測位點: '検査変異箇所',
              ___臨床意義: '臨床的意義',
              ___潛在影響: '潜在的影響'
            }
          },
          geneResultItem: {
            title: {
              ___檢測項目: '検査項目',
              ___檢測基因: '検査対象遺伝子',
              ___檢測位點: '検査変異箇所',
              ___臨床意義: '臨床的意義'
            }
          },
          geneResultItemImpact: {
            title: {
              ___檢測項目: '検査項目',
              ___檢測基因: '検査対象遺伝子',
              ___檢測位點: '検査変異箇所',
              ___潛在影響: '潜在的影響'
            }
          },
          geneResultItemCombine: {
            title: {
              ___檢測項目: '検査項目',
              ___檢測基因: '検査対象遺伝子',
              ___檢測位點: '検査変異箇所',
              ___臨床意義: '臨床的意義'
            }
          },
          genotypeRate: {
            title: {
              ___基因型: '遺伝子型<br><h5>(Genotype)</h5>',
              ___人口常見率: '一般集団に<br>おける頻度',
              ___風險等級: 'リスクレベル',
              ___臨床意義: '臨床的意義'
            }
          },
          diseaseGenes: {
            title: {
              ___疾病名稱: '疾患名',
              ___相關基因清單: '関連遺伝子リスト',
              ___檢測結果: '検査結果'
            }
          },
          diseaseGene: {
            title: {
              ___疾病名稱: '疾患名',
              ___疾病類型簡述: '疾患概要',
              ___檢測基因: '検査対象遺伝子',
              ___檢測結果: '検査結果'
            }
          },
          detailGene: {
            title: {
              ___基因名稱: '遺伝子名',
              ___突變位點: '変異箇所',
              ___突變類型: '変異タイプ',
              ___合子型: '遺伝形式',
              ___OMIM: 'OMIMデータベースに記載された疾患',
              ___ClinVar: 'ClinVarデータベースに記載された疾患'
            }
          }
        },
        '遺傳性癌症風險-結果': {
          info: {
            ___content01: '遺伝性腫瘍のスクリーニングは、システマチックなスクリーニングによって、対象者が潜在的な遺伝子変異を保有しているかどうかを検査するものです。<br>ご家族の中にがんに罹患された方が２名以上いる場合や、若年発症のがんがある場合は、特に関連情報をご注意ください。<br>がんの種類ごとに追跡方法が異なるため、自身のリスクを把握し、遺伝性腫瘍の関連遺伝子を保有しているかを確認することで、リスクの高いがんを早期に発見し、定期的に追跡することが可能になります。'
          },
          summary: {
            total: {
              ___value: '<b>{count} </b>項目の',
              ___title: '遺伝性主要の関連遺伝子において、'
            },
            count: {
              ___value: '計<b> {count} </b>項目が検出されました',
              ___title: '*これらは文献により報告されている<br>既知の病原性変異です'
            }
          },
          result: {
            variant: {
              ___title: '検査結果の説明',
              ___subtitleEmpty: '「米国人類遺伝学会（ACMG）および関連する生物医学データベースの遺伝子リスト」において、文献で既知の病原性変異は検出されませんでした。',
              ___subtitle: '米国人類遺伝学会（ACMG）および関連する生物医学データベースの遺伝子リスト」において、文献で既知の病原性変異が計 <span style=color:#BF8F00>{count}</span> 項目検出されました。'
            },
            table: {
              ___title: '指標的な検査項目',
              ___titleInfo: '（<span style=color:#0070C0>青色で表示されているもの</span>は米国人類遺伝学会（ACMG）で推奨されている遺伝子です）',
              title: {
                ___腦瘤: '<b>脳腫瘍 / 神経系関連腫瘍</b>',
                ___腫瘤症候群: '<b>腫瘍症候群</b>',
                ___全方位篩檢基因清單: '<b>包括的遺伝子スクリーニングリスト</b>'
              }
            }
          }
        },
        '代謝症候群-結果': {
          info: {
            ___content01: 'メタボリックシンドロームは、互いに関連の深い代謝異常が重なった状態であり、主に肥満、血圧上昇、糖代謝異常、および脂質代謝異常が含まれます。これらの要因が重なることで、2型糖尿病や心血管疾患、その他の慢性疾患の発症リスクが著しく高まります。<br>メタボリックシンドロームの発症には、遺伝的背景とライフスタイルの双方が影響します。遺伝子変異は、エネルギー代謝、インスリン感受性、脂質輸送、および血圧調節に影響を与える可能性があり、その結果、同様の食事や生活環境にあっても、個々の健康リスクに差異が生じます。<br>本検査は、代謝に関連する遺伝子座を解析することで、体重管理、血糖値の安定、脂質代謝、および血圧調節における個人の遺伝的傾向を評価するものです。これは個別化された健康管理および予防戦略の参考資料として活用されることを目的としており、疾患の診断を行うものではありません。',
            ___title02: '肥満検査',
            ___content02: '肥満遺伝子検査は、特定の遺伝子変異を解析することで、個人の肥満リスクや関連する代謝異常を評価する科学的な方法です。肥満に関係する複数の遺伝子を検査することで、肥満の根本的な原因を理解し、検査結果に基づいて個別化された減量計画を立てることが可能になります。検査後は、専門医や栄養士と相談し、個人に適した健康管理プランを立てることをお勧めします。'
          },
          summary: {
            total: {
              ___value: '<b>{count} </b>項目の',
              ___title: '肥満関連遺伝子変異のうち、'
            },
            count: {
              ___value: '検出された変異は計<b> {count} </b>項目でした',
              ___title: '＊これらは文献により報告されている<br>既知の関連遺伝子変異です'
            }
          },
          result: {
            item: {
              ___title: '検査結果の說明',
              content: {
                ___容易儲存脂肪: '<b>脂肪を蓄積しやすい体質：</b>肥満関連遺伝子群（PPARGC1B）の異常により、体内の脂肪代謝と生成に影響が出やすく、BMIが基準を超えやすく、高血圧を伴う可能性があります。脂肪燃焼効率を高め、食事では高脂肪・高糖質の摂取を控え、野菜や全粒穀物など食物繊維の豊富な食品を増やすことが適切な減量法とされています。',
                ___無法控制的食慾: '<b>食慾を抑えられない体質：</b>細胞のエネルギー代謝に関わる遺伝子群（MC4R、LEP、LEPR、SDC3、POMC、SIM1、NTRK2、BDNF、SH2B1、ADCY3）の働きが低下しており、食欲のコントロールが乱れ、摂取カロリーが少なくても余分な脂肪が蓄積しやすく、代謝症候群のリスクも高まります。満腹感を得られる食事（食物繊維や高タンパク質食品）を選び、必要であれば医師の指導のもと、食欲抑制剤やサプリメントの使用も検討されます。',
                ___不平衡的新陳代謝: '<b>新陳代謝のバランス不良/中枢性肥満：</b>人間の脳内の視床下部には「満腹中枢」と「摂食中枢」があり、それぞれ食欲の抑制と促進を担当し、通常は相互にバランスをとっています。これらを制御する遺伝子群（UCP3、PPARG-2\\、ADRB2）の働きが低下すると、暴飲暴食が起こりやすく、うつ傾向や脂肪肝のリスクも高まります。脂肪燃焼効率を高めるために、HIIT（高強度インターバルトレーニング）や有酸素運動を行い、食事では高糖質・高脂肪を避け、オメガ3脂肪酸（魚類、ナッツ類など）を含む食品を取り入れることが、情緒や代謝の改善に有効です。',
                ___內分泌失調: '<b>ホルモンバランスの乱れ：</b>インスリンやエストロゲンの働きを調節する遺伝子群（PCSK1、ESR1）の機能が低下しており、BMIが基準を超える人は糖尿病のリスクが高い可能性があります。低GI食品を取り入れ、抗酸化作用のある食品（ブルーベリー、緑茶など）を多く摂取し、体の抗酸化力を高めることが推奨されます。'
              }
            },
            table: {
              ___title: '詳細検査項目',
              容易儲存脂肪: {
                ___title: '脂肪を蓄積しやすい',
                ___part: '腹部、\n大腿の內側'
              },
              無法控制的食慾: {
                ___title: '食欲の抑制が困難',
                ___part: '腰部、\n臀部、\n手臂'
              },
              不平衡的新陳代謝: {
                ___title: '新陳代謝のバランス不良',
                ___part: '內臟'
              },
              內分泌失調: {
                ___title: 'ホルモンバランスの乱れ',
                ___part: '腹部、\n大腿の內側'
              }
            }
          }
        },
        '代謝症候群-血壓檢測': {
          info: {
            ___title01: '血圧検査',
            ___content01: '血圧調節関連遺伝子は、ストレスや食事、環境の変化に直面した際、身体が血圧を調整する生理的な傾向を反映しています。<br>今回の解析結果から、あなたの身体は血圧を調節する際、血管収縮やナトリウム貯留などのメカニズムを通じて循環の安定を維持しやすい傾向にあることが示されました。そのため、高塩分の食事、心理的ストレスの増加、睡眠不足、あるいは活動量の低いライフスタイルにおいては、血圧が比較的上昇しやすい傾向にあります。<br>この結果はあくまで生理的な調節の傾向を示すものであり、高血圧の診断ではありません。長期的な心血管リスクを低減させるために、定期的な血圧測定とライフスタイル管理を併せて行うことをお勧めします。'
          },
          summary: {
            total: {
              ___value: '<b>{count} </b>項目の',
              ___title: '血圧関連の遺伝子座のうち、'
            },
            count: {
              ___value: '計<b> {count} </b>項目が検出されました',
              ___title: '文＊これらは文献により報告されている<br>既知の関連遺伝子座です'
            }
          },
          result: {
            item: {
              ___title: '検査結果の說明',
              content: {
                ___血管收縮: '<b>血管収縮：</b>このカテゴリーの遺伝子は、主に血管平滑筋の収縮および弛緩反応に影響を与え、ストレスや感情の起伏、あるいは交感神経の刺激に対する血管の調節機能に深く関わっています。この調節経路が活性化しやすい傾向にある場合、身体はストレスの増加や睡眠不足、持続的な緊張状態において、血流と血圧の安定を維持するために血管を収縮させる方向に働きやすく、その結果、一時的または状況に応じて血圧が上昇しやすくなります。このような血圧の変化は、心理的ストレス、生活リズム、および自律神経の状態と密接に関連しています。',
                ___鈉離子平衡: '<b>ナトリウム平衡：</b>このカテゴリーの遺伝子は、主に腎臓におけるナトリウムと体液バランスの調節に関与しており、食事中の塩分に対する身体の反応能力に影響を与えます。この調節経路が顕著な場合、塩分の多い食事や水分代謝の負担が増加した際に、ナトリウムや水分が体内に貯留しやすくなります。その結果、血液量（血漿量）が増加し、血圧が徐々に上昇する傾向にあります。このような血圧調節の特性は、食事内容や塩分摂取量、および長期的な生活習慣と極めて密接に関連しています。'
              }
            },
            table: {
              ___title: '詳細検査項目',
              血管收縮: {
                ___title: '血管収縮'
              },
              鈉離子平衡: {
                ___title: 'ナトリウム平衡'
              }
            }
          }
        },
        '代謝症候群-血糖檢測': {
          info: {
            ___title01: '血糖検査',
            ___content01: '糖代謝調節遺伝子の異常は、炭水化物の摂取、不規則な生活習慣、あるいは持続的なストレス状態において、体内における血糖調節システムの安定性が低いことを示唆しています。このタイプの体質では、インスリンによる調節効率の低下が見られることが多く、食後の血糖値の上昇幅が大きくなり、元の数値に戻るまでの速度も緩やかになる傾向があります。このような状態が長期化すると、血糖値の変動幅が増大し、代謝異常のリスクを高める可能性があります。'
          },
          summary: {
            total: {
              ___value: '<b>{count} </b>項目の',
              ___title: '血糖関連の遺伝子座のうち、'
            },
            count: {
              ___value: '計<b> {count} </b>項目が検出されました',
              ___title: '＊これらは文献により報告されている<br>既知の関連遺伝子座です'
            }
          },
          result: {
            item: {
              ___title: '検査結果の說明',
              content: {
                ___胰島素敏感度: '<b>インスリン感受性：</b>このカテゴリーの遺伝子は、主に筋肉、脂肪、肝臓などの末梢組織におけるインスリンシグナルへの反応効率に影響を与えます。インスリン感受性が低い状態では、インスリンが正常に分泌されていても、細胞によるグルコース（ブドウ糖）の取り込みや利用が制限されます。特に、高炭水化物の食事や座位時間の長いライフスタイルにおいては、血糖値上昇のリスクがより顕著になります。',
                ___胰島素分泌能力: '<b>インスリン分泌能力：</b>このカテゴリーの遺伝子は、主に膵β細胞における血糖刺激の感知能力と、それに応じたインスリン放出反応に影響を与えます。分泌調節の効率が弱い場合、食後に即座に、あるいは十分な量のインスリンを分泌することができず、食後高血糖を招きやすくなります。'
              }
            },
            table: {
              ___title: '詳細検査項目',
              胰島素敏感度: {
                ___title: 'インスリン感受性'
              },
              胰島素分泌能力: {
                ___title: 'インスリン分泌能力'
              }
            }
          }
        },
        '代謝症候群-脂質代謝檢測': {
          info: {
            ___title01: '脂質代謝検査',
            ___content01: '脂質代謝関連遺伝子の異常は、高脂肪食や精製された炭水化物の過剰摂取、あるいは長期的なエネルギー過剰状態において、体内での脂質の分解、除去、および輸送の効率が相対的に低いことを示唆しています。<br>このような生理的傾向により、血液中の中性脂肪（TG）やLDLコレステロール（悪玉コレステロール）が蓄積しやすくなり、その結果、血脂値の変動や心血管系への代謝負荷を高める要因となります。'
          },
          summary: {
            total: {
              ___value: '<b>{count} </b>項目の',
              ___title: '脂質代謝関連の遺伝子座のうち、'
            },
            count: {
              ___value: '計<b> {count} </b>項目が検出されました',
              ___title: '＊これらは文献により報告されている<br>既知の関連遺伝子座です'
            }
          },
          result: {
            item: {
              ___title: '検査結果の說明',
              content: {
                ___三酸甘油酯調控: '<b>中性脂肪（TG）調節：</b>このカテゴリーの遺伝子は、食事由来の脂肪や肝臓で合成された脂質の処理能力に影響を与えます。これには、リポタンパク質リパーゼ（LPL）の活性、脂質の動員、および脂肪酸酸化の効率が含まれます。TG調節効率が低い場合、食後の脂質クリアランス速度が低下し、血液中の中性脂肪値が食後に上昇しやすく、かつ高値が持続しやすくなります。特に高脂肪食、頻繁な食事、あるいはインスリン抵抗性の状態において、その傾向はより顕著になります。',
                ___膽固醇轉運: '<b>コレステロール輸送：</b>このカテゴリーの遺伝子は、血液中におけるコレステロールの輸送、回収、および再分配の効率に影響を与えます。これには、LDLの除去能力や、HDL（善玉コレステロール）によるコレステロールの逆転送機能が含まれます。コレステロールの輸送効率が弱い場合、LDLが血液中に滞留しやすくなる一方で、HDLによる保護的な除去作用が相対的に不足し、動脈硬化のリスクを高める要因となります。'
              }
            },
            table: {
              ___title: '詳細検査項目',
              三酸甘油酯調控: {
                ___title: '中性脂肪調節'
              },
              膽固醇轉運: {
                ___title: 'コレステロール輸送'
              }
            }
          }
        },
        '心血管相關-結果': {
          info: {
            ___content01: '心血管関連遺伝子検査は、血管構造の完全性、心筋機能、心臓電気生理学的な安定性、および脂質代謝バランスに影響を与える主要な遺伝的要因に焦点を当てています。このモジュールは、大動脈疾患、遺伝性心筋症、致死性不整脈、および家族性高コレステロール血症など、遺伝性心血管疾患との高い関連性が知られている多様な遺伝子を網羅しています。<br>関連する遺伝子変異は、血管の弾力性や結合組織の強度、心筋の収縮およびエネルギー利用効率、イオンチャネルやカルシウムイオンの調節、さらには血液中のコレステロールの除去および輸送能力に影響を及ぼす可能性があります。',
            ___content02: '本検査を通じて、構造的心疾患、不整脈リスク、および動脈硬化性疾患における個人の遺伝的傾向を評価することが可能です。これは、早期のリスク層別化、追跡モニタリング、およびライフスタイルや臨床管理戦略の策定における重要な参考指標となります。このような遺伝的リスクは、明らかな臨床症状がない場合でも存在する可能性があり、早期に特定することで、突然の心血管イベントの長期的リスク低減に寄与します。'
          },
          summary: {
            total: {
              ___value: '<b>{count} </b>項目の',
              ___title: '心血管関連の遺伝子座のうち、'
            },
            count: {
              ___value: '計<b> {count} </b>項目が検出されました',
              ___title: '＊これらは文献により報告されている<br>既知の関連遺伝子座です'
            }
          },
          result: {
            variant: {
              ___title: '検査結果の説明',
              ___subtitleEmpty: '「米国人類遺伝学会（ACMG）および関連する生物医学データベースの遺伝子リスト」において、文献で既知の病原性変異は検出されませんでした。',
              ___subtitle: '米国人類遺伝学会（ACMG）および関連する生物医学データベースの遺伝子リスト」において、文献で既知の病原性変異が計 <span style=color:#BF8F00>{count}</span> 項目検出されました。'
            },
            table: {
              ___title: '指標的な検査項目',
              ___titleInfo: '（<span style=color:#0070C0>青色で表示されているもの</span>は米国人類遺伝学会（ACMG）で推奨されている遺伝子です）',
              ___note: '<span>注：LPA（rs10455872、rs3798220）はリスク関連変異であり、その検出結果は疾患の診断を確定させるものではありません。<br>あくまでリスク評価の参考資料としてご利用ください。</span>'
            }
          }
        },
        '體質相關-結果': {
          info: {
            ___content01: '体質関連遺伝子の変異は、物質の代謝、アレルギー、血栓、アルコール不耐症など、多くの体質的特徴に関係しています。本検査では、現在の医学で影響が比較的明確とされている遺伝子座について分析を行い、集団と異なる遺伝的変異の有無を調べることで、体質上の特異性を明らかにし、生活習慣の見直しや病気の予防に役立てることができます。'
          },
          summary: {
            total: {
              ___value: '<b>{count} </b>項目の',
              ___title: '体質関連検査において、'
            },
            count: {
              ___value: '計<b> {count} </b>項目で異常が検出されました'
            }
          },
          result: {
            item: {
              ___title: '検査結果の説明',
              content: {
                ___乳糖代謝相關: '<b>乳糖代謝関連：</b>乳糖不耐症は、小腸におけるラクターゼ（乳糖分解酵素）の活性不足に起因する消化器系の表現型であり、主に離乳後の LCT 遺伝子の発現量低下に関連しています。成人期におけるラクターゼ生成の持続性は、MCM6 遺伝子の調節領域における遺伝子変異に依存します。この調節機能が低下すると、LCT 遺伝子の転写活性が減少し、加齢とともにラクターゼの分泌量が段階的に減少します。このような変化は成長過程で顕著になるため、思春期後半から成人期にかけて症状が現れることが多く、乳製品の摂取後に腹部膨満感、腹痛、下痢などの消化器不快感を引き起こします。症状の程度は、乳糖の摂取量、腸内フローラ、および消化管の生理状態と密接に関連しています。',
                ___澱粉代謝相關: '<b>デンプン代謝関連：</b>デンプン代謝関連検査は、炭水化物に対する嗜好性、腸道におけるデンプンや糖類の消化吸収能力、および体内における血糖調節の安定性を評価するものです。解析内容は、脳による糖類への欲求や摂取傾向から、小腸での分解吸収効率、さらにはインスリンと血糖コントロールのメカニズムまで、体内における炭水化物の代謝プロセスを包括的に網羅しています。これらの遺伝子情報は、デンプン質の食物に対する個人差を理解し、個別化された食事戦略やライフスタイルの調整を行うための重要な参考指標となります。',
                ___睡眠傾向: '<b>睡眠傾向：</b>睡眠は神経の修復、代謝の安定、および免疫機能の維持に不可欠な基盤です。最適な入睡時間や覚醒のピーク時間に見られる個人差は、主に体内の概日リズム（サーカディアンリズム）に由来します。本検査は、主要な時計遺伝子に焦点を当て、先天的、遺伝的なリズムの特徴を解析します。日中、CLOCK 蛋白質は BMAL1 と結合して下流の PER および CRY 遺伝子の転写を開始させます。夜が深まるにつれ、蓄積された PER と CRY 蛋白質が複合体を形成し、逆に CLOCK:BMAL1 の活性を抑制することで遺伝子発現を停止させます。この周期的な起動と抑制の分子メカニズムが約 24 時間の生理リズムを形成し、個人の睡眠時間の嗜好性や日中のパフォーマンスに影響を与えます。',
                ___酒精耐受性: '<b>アルコール耐性：</b>体内に入ったアルコールは、主に肝臓における二段階の酵素反応によって代謝されます。本検査では、主要な代謝酵素である ADH1B と ALDH2 遺伝子を解析し、個人のアルコール代謝能力を評価します。第一段階では ADH1B がアルコールを毒性のあるアセトアルデヒドに変換し、これが顔面紅潮、動悸、頭痛などの原因となります。第二段階では ALDH2 がアセトアルデヒドを無毒な酢酸に分解し、体外へ排出します。これら二つの遺伝子の変異はアセトアルデヒドの蓄積量に影響を与え、アルコール耐性や身体への健康リスクを決定づけます。',
                ___血栓傾向: '<b>血栓傾向：</b>血栓のリスクは生活習慣だけでなく、体内の葉酸およびビタミンB群の代謝効率に深く関わっています。このメカニズムの核心となるのは、MTHFR、MTRR、CBS などの遺伝子によって構成されるホモシステイン（HCY）代謝システムです。MTHFR は、通常の葉酸を身体が利用可能な活性型（メチル基供与体）へと変換します。MTR はビタミンB12の活性を維持し、メチル基が代謝反応に円滑に寄与するように働きます（ビタミンB12はホモシステインをメチオニンへ再メチル化する際の必須の補因子です）。CBS は過剰なホモシステインを下流の代謝経路へと誘導し、抗酸化作用を持つ物質を生成します。また、ビタミンB6 は、CBS経路においてホモシステインをシステインやグルタチオンなどの下流産物へ変換する際の重要な補酵素であり、抗酸化反応と血管保護をサポートします。<br>上記のいずれかのプロセスで機能が低下すると、ホモシステインが血液中に蓄積し、血管内皮を損傷させることで、血栓症、心血管疾患、および脳卒中のリスクを高める可能性があります。',
                ___咖啡因耐受性: '<b>カフェイン耐性：</b>カフェイン耐性の個人差は、主に「除去（代謝）速度」と「神経反応の強度」という二つの側面から生じます。CYP1A2 遺伝子は肝臓におけるカフェイン分解の効率に影響を与えます。代謝が遅いタイプでは、カフェインが体内に長く留まるため、心臓への負荷や睡眠リズムの乱れを招きやすくなります。一方、ADORA2A 遺伝子は大脳のカフェイン刺激に対する反応を調節しています。特定の遺伝子型では、神経系がカフェインに対して過敏に反応するため、少量であっても緊張感、焦燥感、あるいは不快感を覚えることがあります。'
              }
            }
          }
        },
        '體質相關-乳糖代謝相關': {
          result: {
            table: {
              ___title: '詳細な検査項目',
              info: {
                ___title: '乳糖代謝関連',
                ___content01: '<b>乳糖不耐症は、人類における「省エネの本能」といえます。</b>',
                ___content02: '人体はエネルギーを節約するために、離乳後は MCM6（スイッチ）が自動的に LCT 遺伝子（生産ライン）をオフにし、ラクターゼの製造を停止するように設計されています。遺伝子の変異によってこのスイッチがオンのまま維持される「乳糖耐性」を持つ場合を除き、成人後に乳糖を分解できず不快感が生じるのは、身体が原始的な進化のプログラミングに従い、リソースの浪費を避けている正常な反応なのです。'
              }
            }
          }
        },
        '體質相關-澱粉代謝相關': {
          result: {
            table: {
              info: {
                ___title: 'デンプン代謝関連',
                ___content01: 'これらのデンプン代謝関連遺伝子座は、グルコース吸収、インスリン分泌、肝臓でのグルコース利用、およびエネルギーバランスにおける個人の総合的な代謝特性を反映しています。遺伝子型の組み合わせの違いは、空腹時および食後の血糖値、インスリン反応速度、脂質生成、およびエネルギー蓄積の傾向に影響を与え、デンプン摂取後の代謝パフォーマンスに個体差を生じさせます。本解析を通じて、血糖値の大きな変動や脂肪蓄積の傾向など、日常の食事において影響を受けやすいプロセスを特定することが可能です。これは個別化された食事療法やライフスタイルの調整を行うための参考指標となります。具体的な戦略については、専門医によるカウンセリングと評価を併せて受けることをお勧めします。'
              }
            }
          }
        },
        '體質相關-睡眠傾向': {
          result: {
            table: {
              info: {
                ___title: '睡眠傾向',
                ___content01: '朝、CLOCK 蛋白質は BMAL1 と呼ばれる別の蛋白質と結合し、下流遺伝子（PER および CRY）の転写を活性化させます。夜になり、これらの蛋白質が一定の濃度まで蓄積すると、それらは互いに結合して（PER:CRY 複合体を形成）、CLOCK:BMAL1 複合体に結合し、その働きを抑制することで「スイッチ」をオフにします。'
              }
            }
          }
        },
        '體質相關-酒精耐受性': {
          result: {
            table: {
              info: {
                ___title: 'アルコール耐性',
                grid: {
                  title: {
                    ___組合類型: '組み合わせタイプ',
                    ___乙醛代謝正常: 'ALDH2(G/G)\nアセトアルデヒド代謝：正常',
                    ___乙醛代謝差: 'ALDH2(G/A)\nアセトアルデヒド代謝：低い',
                    ___乙醛代謝超差: 'ALDH2(A/A)\nアセトアルデヒド代謝：極めて低い',
                    ___超快解酒: 'ADH1B(T/T)アルコール分解：超速',
                    ___快速解酒: 'ADH1B(T/C)アルコール分解：速い',
                    ___正常解酒: 'ADH1B(C/C)アルコール分解：標準'
                  },
                  content: {
                    ___超快解酒_乙醛代謝正常: '酒豪タイプ',
                    ___超快解酒_乙醛代謝差: 'すぐ酔う赤顔タイプ',
                    ___超快解酒_乙醛代謝超差: 'アルコール拒絶タイプ',
                    ___快速解酒_乙醛代謝正常: '安定のんべえタイプ',
                    ___快速解酒_乙醛代謝差: 'フラッシング敏感タイプ',
                    ___快速解酒_乙醛代謝超差: '下戸タイプ',
                    ___正常解酒_乙醛代謝正常: '一般的・社交タイプ',
                    ___正常解酒_乙醛代謝差: 'たしなみ程度タイプ',
                    ___正常解酒_乙醛代謝超差: '全く飲めないタイプ'
                  }
                }
              }
            }
          }
        },
        '體質相關-血栓傾向': {
          result: {
            table: {
              info: {
                ___title: '血栓傾向',
                ___content01: 'MTRR はビタミンB12の活性を維持し、メチル基が実際に供与できるかどうかを決定します（ビタミンB12はホモシステインをメチオニンへと変換する際の必須の補因子です）。CBS はホモシステインをシスタチオニンへと変換する際の鍵となる酵素であり、抗氧化物質の生成をサポートし、血管の健康維持に寄与します。'
              }
            }
          }
        },
        '體質相關-咖啡因耐受性': {
          result: {
            table: {
              info: {
                ___title: 'カフェイン耐性',
                ___content01: '本検査では CYP1A2 および ADORA2A の遺伝子型を解析し、カフェインに対する代謝速度と感受性を評価することで、個人のカフェイン反応を予測します。CYP1A2 は体内でのカフェイン分解速度に影響を与え、ADORA2A は脳におけるカフェインの刺激に対する感受性を左右します。これらの遺伝子情報を活用することで、自身のカフェイン耐性を把握し、摂取量の調整に役立てることが可能です。これにより、動悸、焦燥感、睡眠障害などの不快なリスクを低減させ、覚醒効果の安定性を高めることが期待できます。'
              }
            }
          }
        },
        '藥物代謝-結果': {
          info: {
            ___content01: '個々人の遺伝的構成により、薬物の体内での代謝速度や反応が異なります。<br>そのため、薬物代謝遺伝学的検査は現代医学において重要なツールであり、医師が患者に最適な薬物と投与量を選択し、不必要な副作用や毒性反応を避け、治療効果を高めるのに役立ちます。遺伝学的検査と個別化された医療戦略を通じて、「対症療法」の目標をより良く実現し、「一律の薬」のリスクを避け、患者により安全で効果的な治療選択肢を提供できます。'
          },
          summary: {
            total: {
              ___value: '<b> {count} </b>項目の',
              ___title: '薬物代謝関連の遺伝子座のうち、'
            },
            count: {
              ___value: '計<b> {count} </b>項目が検出されました',
              ___title: '＊これらは文献により報告されている<br>既知の関連遺伝子座です'
            }
          },
          result: {
            item: {
              ___title: '検査結果の說明',
              content: {
                ___default01: '本項目の臨床における薬物の安全性および個別化医療を目的とし、日常的な鎮痛剤、心血管系および神経精神系の治療薬から、手術時の麻酔、抗感染症治療、さらには腫瘍化学療法に至るまでの6つの主要な薬物領域を対象としています。薬剤の有効性発現および毒性耐性に関わる個体差を規定する遺伝的要因の解明を目的としています。<br>>薬物が体内で適切に代謝されない場合、治療効果の不十分さや副作用リスクの増大を招く可能性があります。例えば、抗血栓薬の効果不足、精神科薬による代謝異常、麻酔薬や抗感染症薬によるまれではあるものの重篤な過敏反応や臓器毒性、さらに化学療法薬や鎮痛剤による心腎障害、造血抑制、薬物の蓄積などが挙げられます。<br>>薬物代謝関連遺伝子の検査を実施することにより、医療チームは治療開始前の段階で潜在的なリスクを把握し、適切な薬剤および用量の調整を行うことが可能となります。これにより、反復的な試行投与を回避し、医療を事後対応から事前予防へと転換することで、用薬の安全性および生活の質の向上が期待されます。<br>>なお、本結果は遺伝子と薬物反応との関連性を評価するものであり、直接的な薬剤選択や用量を指示するものではありません。実際の治療方針については、医師が臨床所見を踏まえて総合的に判断する必要があります。'
              }
            },
            table: {
              ___title: '詳細検査項目'
            }
          }
        },
        '阿茲海默症風險評估-結果': {
          info: {
            ___content01: 'アルツハイマー病（AD）は、高齢者に多くみられる神経変性性認知症の一つです。ApoE 遺伝子（Apolipoprotein E）は、遅発型アルツハイマー病のリスクに最も強く関連する遺伝因子として知られているます。ApoE 遺伝子によって産生されるタンパク質は、脳内において脂質の輸送および、アルツハイマー病の原因とされるβ-アミロイドの除去を担う「清掃機能」を果たしています。ApoE 遺伝子の多型（例えば、高リスクとされるε4や、保護的とされるε2）は、この除去効率に影響を与え、アルツハイマー病の発症リスクに関与します。<br>なお、本検査結果はリスク傾向を示すものであり、疾患の発症を直接示すものではありません。'
          },
          summary: {
            total: {
              ___value: '<b> {count} </b>つのアルツハイマー病リスク評価に関連する<br>遺伝子多型おいて、'
            },
            count: {
              ___value: '<b>{type} </b>型と判定されました'
            }
          },
          result: {
            table: {
              ___title: '検査結果の說明',
              content: {
                ___default01: 'ApoE遺伝子は、現在知られている中でアルツハイマー病と最も強く関連する遺伝子であり、特にε4アレル（ApoE ε4）は遅発型アルツハイマー病の最も重要なリスク因子とされています。',
                ___default02: 'ApoE遺伝子は第19染色体上に存在し、脂質代謝および脳の神経修復に関与しています。主なアレルにはε2、ε3、ε4の３種類があり、ε3は最も一般的で中立な型、ε2は保護的な作用を有するとされています。一方で、ε4アレルを1つ保有する場合、アルツハイマー病の発症リスクは約3〜5倍に上昇し、2つ保有する場合（ε4/ε4）には約10〜15倍に上昇すると報告されています。',
                ___default03: 'さらに、ApoE ε4保有者では発症年齢が比較的早い傾向があり、疾患の進行過程においてβアミロイドの沈着やタウ病へんがより顕著に認められることが知られています。このため、ApoE検査は個人のリスク評価に加え、臨床研究における層別化にも重要な指標として用いられています。'
              },
              data: {
                'ε2/ε2': {
                  ___基因型: 'ε2/ε2',
                  ___人口常見率: '0.70%',
                  ___風險等級: '最低リスク',
                  ___臨床意義: '最も強い保護効果を有し、発症リスクは最も低い'
                },
                'ε2/ε3': {
                  ___基因型: 'ε2/ε3',
                  ___人口常見率: '17.10%',
                  ___風險等級: '低リスク',
                  ___臨床意義: '保護的なε2を有し、平均より低リスク'
                },
                'ε3/ε3': {
                  ___基因型: 'ε3/ε3',
                  ___人口常見率: '55.80%',
                  ___風險等級: '低リスク',
                  ___臨床意義: '最も一般的な遺伝子型であり、一般集団と同程度のリスク'
                },
                'ε2/ε4': {
                  ___基因型: 'ε2/ε4',
                  ___人口常見率: '4.10%',
                  ___風險等級: '中リスク',
                  ___臨床意義: 'ε2の保護効果によりε4のリスクが一部相殺される可能性があるが、注意必須'
                },
                'ε3/ε4': {
                  ___基因型: 'ε3/ε4',
                  ___人口常見率: '20.00%',
                  ___風險等級: '中〜高リスク',
                  ___臨床意義: 'ε4を１つ保有し、発症リスクは約3〜5 倍'
                },
                'ε4/ε4': {
                  ___基因型: 'ε4/ε4',
                  ___人口常見率: '2.30%',
                  ___風險等級: '最高リスク',
                  ___臨床意義: 'ε4を２つ保有し、発症リスクは約10〜15倍に上昇'
                }
              }
            }
          }
        },
        '神經退化相關-結果': {
          info: {
            ___content01: '本項目の遺伝子検査は、複数の神経変性疾患（Neurodegenerative Diseases）および関連する遺伝性神経系疾患を対象としています。これらの疾患は共通して、脳や脊髄の神経細胞（ニューロン）が進行性に機能低下または細胞死を起こし、最終的に持続的な機能障害を引き起こすことを特徴とします。<br>臨床症状は、障害を受ける神経細胞の種類や分布により多様に現れます。',
            ___list01: '<b>認知機能障害：</b>大脳皮質や海馬の神経細胞が傷害されることで、記憶力、判断力、言語能力、実行機能の低下が生じます。これはアルツハイマー病や遺伝性脳小血管病変などにおいて主な特徴とされます。',
            ___list02: '<b>運動障害：</b>基底核や運動ニューロンが影響を受ける場合、振戦、筋強剛、運動緩慢（例：バーキンソン病）、協調運動障害（例：ハンチントン病）、あるいは全身の筋力低下や筋萎縮（例：脊髄性筋萎縮症や筋萎縮性側索硬化症）などが認められます。',
            ___list03: '<b>末梢神経障害：</b>末梢神経系が障害されると、感覚異常、しびれ、疼痛、遠位筋の筋力低下などが生じ、家族性アミロイドポリニューロパチーなどで見られます。'
          },
          summary: {
            total: {
              ___value: '<b>{count} </b>項目の',
              ___title: '神経変性関連遺伝子座のうち'
            },
            count: {
              ___value: '検出された変異は計<b> {count} </b>項目でした',
              ___title: '＊これらは文献により報告されている<br>既知の関連遺伝子変異です'
            }
          },
          result: {
            variant: {
              ___title: '検査結果の說明',
              ___subtitle: '受検者は、過去に病原性があると報告された以下の遺伝子変異を <span style=color:#BF8F00>{count}</span> 項目保有していることが確認されました。'
            },
            table: {
              ___title: '詳細檢測項目'
            }
          }
        },
        '帶因篩查-結果': {
          info: {
            ___content01: 'キャリアスクリーニングの主な目的は、対象者が潜性遺伝子変異を保有しているかどうかを検出することです。特に、重篤な遺伝性疾患を引き起こす可能性のある遺伝子変異を対象としています。この検査は婚前や妊娠前の段階で非常に重要な意義を持ち、夫婦が自身の保因リスクを把握し、将来の出産計画に科学的な根拠を提供することができます。早期の検査と専門的な遺伝カウンセリングを通じて、夫婦は適切な予防策を講じることが可能となり、次世代における遺伝性疾患の発症リスクを低減し、家族の健康を支える基盤を築くことができます。',
            ___content02: '<b>＊本内容はヒトの遺伝性疾患とそれに関連する遺伝子・バリアントのデータベース (OMIM) に基づいています</b>'
          },
          summary: {
            totald: {
              ___value: '<b>{count} </b>項目',
              ___title: 'の関連疾患'
            },
            totalg: {
              ___value: '<b>{count} </b>項目',
              ___title: 'の関連遺伝子'
            },
            count: {
              ___value: '計<b> {count} </b>項目を検査',
              ___title: '＊これらは文献により<br>報告されている<br>既知の病原性変異です'
            }
          },
          result: {
            variant: {
              ___title: '検査の結果',
              ___subtitle: '受検者は、過去に病原性があると報告された以下の遺伝子変異を <span style=color:#BF8F00>{count}</span> 項目保有していることが確認されました。'
            },
            note: {
              ___title: '検査の說明',
              ___subtitle: '未検出',
              ___content: '遺伝子名：<b>{gene}</b>，夫婦双方がこの変異を保有している場合、<b>次世代が 「{disease}」 を発症する確率は 25% です</b>。結婚前または出生前に関連専門医への相談を推奨します。',
              ___more: '<span style=color:#FF0000>※さらに詳しい情報：</span>さらに詳しい保因者情報をご希望の場合は、「附録」に最も一般的な遺伝性疾患を個別に記載しておりますのでご参照ください。'
            }
          }
        },
        '族裔分析-結果': {
          info: {
            ___content01: '民族解析レポートを通じて個人のルーツを知ることは、祖先に対する好奇心を満たすだけでなく、自身の文化的背景への理解と認識を深める助けとなります。これにより、個人と家族・民族とのつながりが強まり、多様な文化が共存する社会の中で自らのアイデンティティと帰属意識を育むことができます。<br>さらに、異なる民族間には遺伝的な違いが存在し、これが特定の疾患の発症率や薬物反応、健康リスクに影響を与える可能性があります。そのため、自身の民族的背景を把握することには文化的意義だけでなく、医学的な価値もあります。民族解析レポートを活用することで、より正確な健康情報を得ることができ、医療専門家と連携しながら、個人に適した予防・治療計画を立てることが可能になります。'
          },
          result: {
            chart: {
              title: {
                ___主要: '主要',
                ___其他: 'その他',
                ___無: 'なし\n（0%）'
              }
            }
          }
        },
        '生殖與生育-結果': {
          info: {
            ___content01: '本遺伝子スクリーニングは、男性および女性の生殖機能異常と高い関連が知られている遺伝性疾患および生理メカニズムを対象としています。主な対象には、精子形成障害、性腺および性分化異常、視床下部―下垂体―性腺軸（HPG axis）の調節異常、ステロイド合成およびホルモン代謝異常、ならびに一部の全身性症候群に伴う生殖機能障害が含まれます。これらの遺伝的変異は、配偶子の形成、ホルモンの分泌およびその作用、性腺の発達、あるいは生殖器の構造に影響を及ぼし、自然妊娠の可能性を低下させる要因となることがあります。<br>本検査により潜在的な遺伝的リスクを把握することで、妊娠・出産に関する計画、性別特異的リスク評価、医療相談、さらには生殖医療（補助生殖技術を含む）における意思決定の参考情報として活用することが可能です。',
            ___content02: '<b>＊本内容はヒトの遺伝性疾患とそれに関連する遺伝子・バリアントのデータベース( O M I M ) に基づいています</b>'
          },
          summary: {
            total: {
              ___value: '<b>{count} </b>項目の',
              ___title: '関連遺伝子のうち、'
            },
            count: {
              ___value: '検出された変異は計<b> {count} </b>項目でした',
              ___title: '＊これらは文献により報告されている<br>既知の関連遺伝子変異です'
            }
          },
          result: {
            variant: {
              ___title: '検査の結果',
              ___subtitle: '受検者は、過去に病原性があると報告された以下の遺伝子変異を <span style=color:#BF8F00>{count}</span> 項目保有していることが確認されました。'
            },
            note: {
              ___title: '検査の說明',
              ___subtitle: '未検出',
              ___content: '遺伝子名：<b>{gene}</b>，本変異が検出された場合、<b>「{disease}」</br>を発症する可能性があります。詳細につきましては、専門医または遺伝カウンセラーにご相談いただき、十分な医療評価および助言を受けられることを推奨いたします。',
              ___more: '<span style=color:#FF0000>*より詳細な情報をご希望の場合：</span>「付録」に{sex}の生殖・生育に関する遺伝子一覧を掲載しておりますのでご参照ください。'
            }
          }
        }
      }
    },
    template: {
      testingMethod: {
        sampleInfo: {
          title: {
            ___樣本庫試劑組: 'サンプル庫試薬キット',
            ___數據量: 'データ量',
            ___定序平台: 'シーケンシングプラットフォーム',
            ___覆蓋深度: 'カバレッジ深度',
            ___VariantCalling: 'Variant Calling ソフトウェア',
            ___數據品質: 'データ品質'
          },
          content: {
            檢測說明: {
              ___title: '検査の説明',
              ___content: '<ul>\n  <li>1000ng\u306E\u907A\u4F1D\u5B50\u4F53DNA\u691C\u4F53\u306F\u8D85\u97F3\u6CE2\u7834\u7815\u6CD5\u306B\u3088\u308A\u51E6\u7406\u3055\u308C\u3001\u5E73\u5747250~450bp\u306EDNA\u65AD\u7247\u306B\u5206\u65AD\u3055\u308C\u307E\u3059\u3002Illumina\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306B\u9069\u3057\u305FWhole Genome Sequencing\uFF08WGS\uFF09 PCR-Free\u6CD5\u3092\u7528\u3044\u3066\u30E9\u30A4\u30D6\u30E9\u30EA\u30FC\u3092\u4F5C\u88FD\u3057\u3066\u3044\u307E\u3059\u3002DNA\u65AD\u7247\u306F\u5897\u5E45\u5F8C\u3001NovaSeq\u30B7\u30FC\u30B1\u30F3\u30B5\u30FC\u306B\u3088\u308A2x150 bp \u306E\u30DA\u30A2\u30A8\u30F3\u30C9\u30B7\u30FC\u30B1\u30F3\u30B7\u30F3\u30B0\u3092\u5B9F\u65BD\u3057\u3066\u3044\u307E\u3059</li>\n  <li>\u89E3\u6790\u306F\u3001Compass\u682A\u5F0F\u4F1A\u793E\u306B\u3088\u308A\u78BA\u7ACB\u3055\u308C\u305F\u89E3\u6790\u30D5\u30ED\u30FC\u306B\u5F93\u3063\u3066\u884C\u308F\u308C\u3066\u3044\u307E\u3059\u3002\u30B7\u30FC\u30B1\u30F3\u30B5\u30FC\u304B\u3089\u5F97\u3089\u308C\u305F\u914D\u5217\u30C7\u30FC\u30BF\u306F\u30AF\u30E9\u30B9\u30BF\u30EA\u30F3\u30B0\u5F8C\u3001GRCh38\u3092\u53C2\u7167\u914D\u5217\u3068\u3057\u3066Parabrick (4.5.0-1)\u3092\u7528\u3044\u3066\u30A2\u30E9\u30A4\u30F3\u30E1\u30F3\u30C8\u3092\u884C\u3044\u3001\u540C\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u3088\u308A\u5909\u7570\u7B87\u6240\u3092\u691C\u51FA\u3057\u3066\u3044\u307E\u3059\u3002\u691C\u51FA\u3055\u308C\u305F\u5909\u7570\u7B87\u6240\u306FVariant Effect Predictor (v101) \u304A\u3088\u3073Jannovar (0.35)\u3092\u7528\u3044\u3066\u6CE8\u91C8\u304C\u4ED8\u3051\u3089\u308C\u3066\u304A\u308A\u3001\u907A\u4F1D\u7684\u5909\u7570\u306FACMG / AMP 2015\u30AC\u30A4\u30C9\u30E9\u30A4\u30F3\u306B\u57FA\u3065\u3044\u3066\u81E8\u5E8A\u7684\u89E3\u91C8\u3092\u884C\u3063\u3066\u3044\u307E\u3059\u3002</li>\n  <li>\n    <span>\u672C\u691C\u67FB\u6CD5\u306B\u306F\u3001\u4EE5\u4E0B\u306E\u3088\u3046\u306A\u9650\u754C\u304C\u3042\u308A\u307E\u3059\uFF1A</span>\n    <ul>\n      <li>\u53CD\u5FA9\u914D\u5217\uFF1A\u30B2\u30CE\u30E0\u4E2D\u306B\u306F\u9AD8\u5EA6\u306B\u53CD\u5FA9\u3057\u305F\u914D\u5217\u304C\u591A\u304F\u5B58\u5728\u3057\u3001\u65AD\u7247\u30B5\u30A4\u30BA\u304C\u5C0F\u3055\u3044\u5834\u5408\u3001\u6B63\u78BA\u306A\u30DE\u30C3\u30D4\u30F3\u30B0\u304C\u56F0\u96E3\u3068\u306A\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\uFF08\u4F8B\uFF1A\u8106\u5F31X\u75C7\u5019\u7FA4\uFF09\u3002</li>\n      <li>\u69CB\u9020\u5909\u7570\uFF1A\u5927\u898F\u6A21\u306A\u9006\u4F4D\u3001\u8EE2\u5EA7\u3001\u3042\u308B\u3044\u306F\u5927\u304D\u306A\u6B20\u5931\u306A\u3069\u306E\u69CB\u9020\u5909\u7570\u306F\u3001\u77ED\u9396\u30EA\u30FC\u30C9\u6280\u8853\u3067\u306F\u6B63\u78BA\u306A\u691C\u51FA\u304C\u56F0\u96E3\u306A\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002</li>\n      <li>\u52D5\u7684\u5909\u7570\uFF1A\u4E00\u90E8\u306E\u75BE\u60A3\uFF08\u4F8B\uFF1A\u810A\u9AC4\u5C0F\u8133\u5909\u6027\u75C7\u3001\u30CF\u30F3\u30C1\u30F3\u30C8\u30F3\u75C5\uFF09\u306F\u53CD\u5FA9\u914D\u5217\u306E\u7570\u5E38\u4F38\u9577\u306E\u3088\u3063\u3066\u767A\u75C7\u3057\u307E\u3059\u304C\u3001WGS\u3067\u306F\u3053\u308C\u3089\u306E\u53CD\u5FA9\u56DE\u6570\u3092\u6B63\u78BA\u306B\u8A55\u4FA1\u3059\u308B\u3053\u3068\u306B\u9650\u754C\u304C\u3042\u308A\u307E\u3059\u3002</li>\n      <li>\u9AD8\u76F8\u540C\u6027\u9818\u57DF\uFF1A\u6A5F\u80FD\u907A\u4F1D\u5B50\u3068\u507D\u907A\u4F1D\u5B50\u304C\u9AD8\u3044\u76F8\u540C\u6027\u3092\u6709\u3059\u308B\u5834\u5408\u3001\u8AA4\u8A8D\u8B58\u3084\u30A2\u30E9\u30A4\u30F3\u30E1\u30F3\u30C8\u306E\u56F0\u96E3\u304C\u751F\u3058\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002</li>\n      <li>\u30A8\u30D4\u30B8\u30A7\u30CD\u30C6\u30A3\u30AF\u30B9\uFF1A\u6A19\u6E96\u7684\u306AWGS\u3067\u306FDNA\u30E1\u30C1\u30EB\u5316\u3084\u30D2\u30B9\u30C8\u30F3\u4FEE\u98FE\u306A\u3069\u306E\u30A8\u30D4\u30B8\u30A7\u30CD\u30C6\u30A3\u30C3\u30AF\u5909\u5316\u306F\u691C\u51FA\u3067\u304D\u307E\u305B\u3093\u3002</li>\n      <li>\u30E2\u30B6\u30A4\u30AF\u73FE\u8C61\uFF1A\u5909\u7570\u304C\u4E00\u90E8\u306E\u7D30\u80DE\u306E\u307F\u306B\u5B58\u5728\u3059\u308B\u5834\u5408\uFF08\u4F8B\uFF1A\uFF15\uFF05\u7A0B\u5EA6\uFF09\u3001WGS\u3067\u306F\u691C\u51FA\u306E\u9650\u754C\u306B\u3088\u308A\u898B\u9003\u3055\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002</li>\n      <li>\u30DF\u30C8\u30B3\u30F3\u30C9\u30EA\u30A2 DNA\uFF1AWGS\u306B\u306F\u30DF\u30C8\u30B3\u30F3\u30C9\u30EA\u30A2DNA\u3082\u542B\u307E\u308C\u307E\u3059\u304C\u3001\u6838DNA\u3068\u306E\u5B58\u5728\u6BD4\u306E\u9055\u3044\u306B\u3088\u308A\u3001\u6B63\u78BA\u306A\u8A55\u4FA1\u306B\u306F\u5C02\u7528\u306E\u89E3\u6790\u304C\u5FC5\u8981\u3068\u306A\u308B\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u3002</li>\n      <li>\u975E\u30B3\u30FC\u30C9\u9818\u57DF\uFF1AWGS\u306F98\uFF05\u306E\u975E\u30B3\u30FC\u30C9\u9818\u57DF\u3092\u30AB\u30D0\u30FC\u3057\u307E\u3059\u304C\u3001\u3053\u308C\u3089\u306E\u6A5F\u80FD\u306B\u3064\u3044\u3066\u306F\u672A\u89E3\u660E\u306A\u90E8\u5206\u304C\u591A\u304F\u3001\u81E8\u5E8A\u7684\u89E3\u91C8\u304C\u56F0\u96E3\u306A\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002</li>\n      <li>\u67D3\u8272\u4F53\u6570\u306E\u7570\u5E38\uFF1A\u30C0\u30A6\u30F3\u75C7\u5019\u7FA4\u3001\u30BF\u30FC\u30CA\u30FC\u75C7\u5019\u7FA4\u3001\u30AF\u30E9\u30A4\u30F3\u30D5\u30A7\u30EB\u30BF\u30FC\u75C7\u5019\u7FA4\u3001\u30C8\u30EA\u30BD\u30DF\u30FCX\u306A\u3069\u306E\u67D3\u8272\u4F53\u6570\u306E\u7570\u5E38\u306B\u3064\u3044\u3066\u306F\u3001WGS\u3067\u306F\u30EA\u30FC\u30C9\u6DF1\u5EA6\u306B\u57FA\u3065\u304F\u63A8\u5B9A\u306B\u6B62\u307E\u308A\u3001\u78BA\u5B9A\u8A3A\u65AD\u306B\u306F\u67D3\u8272\u4F53\u691C\u67FB\u304C\u63A8\u5968\u3055\u308C\u307E\u3059\u3002</li>\n    </ul>\n  </li>\n</ul>'
            },
            技術極限與聲明: {
              ___title: '技術的限界および声明',
              ___content: '<ul>\n  <li>\u73FE\u5B58\u3059\u308B\u5B9F\u9A13\u6280\u8853\u306E\u9650\u754C\u306B\u3088\u308A\u3001\u3044\u304F\u3064\u304B\u306E\u907A\u4F1D\u5B50\u306B\u3064\u3044\u3066\u30AB\u30D0\u30EC\u30C3\u30B8\u6DF1\u5EA6\u304C10X > 95%\u306E\u57FA\u6E96\u306B\u9054\u3057\u3066\u3044\u306A\u3044\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002</li>\n  <li>\u672C\u691C\u67FB\u306F\u3001\u30A2\u30E1\u30EA\u30AB\u4EBA\u985E\u907A\u4F1D\u5B66\u4F1A (ACMG)\u304A\u3088\u3073\u30D2\u30C8\u30B2\u30CE\u30E0\u5909\u7570\u30C7\u30FC\u30BF\u30D9\u30FC\u30B9 (ClinVar)\u3092\u75C5\u56E0\u5224\u5B9A\u57FA\u6E96\u3068\u3057\u3066\u7528\u3044\u3001\u307E\u305F\u30D2\u30C8\u306E\u907A\u4F1D\u6027\u75BE\u60A3\u3068\u305D\u308C\u306B\u95A2\u9023\u3059\u308B\u907A\u4F1D\u5B50\u30FB\u30D0\u30EA\u30A2\u30F3\u30C8\u306E\u30C7\u30FC\u30BF\u30D9\u30FC\u30B9 (OMIM)\u306E\u8A18\u8F09\u3092\u53C2\u8003\u306B\u3057\u3066\u3044\u307E\u3059\u3002\u3057\u304B\u3057\u3001\u672A\u8A18\u8F09\u306E\u5909\u7570\u5730\u70B9\u3067\u3082\u75BE\u60A3\u3092\u5F15\u304D\u8D77\u3053\u3057\u305F\u308A\u3001\u8868\u73FE\u578B\u306B\u5F71\u97FF\u3092\u4E0E\u3048\u305F\u308A\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308B\u3053\u3068\u3092\u8003\u616E\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002</li>\n  <li>\u672C\u5831\u544A\u66F8\u306F\u6700\u7D42\u7684\u306A\u81E8\u5E8A\u8A3A\u65AD\u7D50\u679C\u3067\u306F\u306A\u304F\u3001\u62C5\u5F53\u533B\u5E2B\u307E\u305F\u306F\u907A\u4F1D\u30AB\u30A6\u30F3\u30BB\u30E9\u30FC\u306B\u3088\u308B\u7DCF\u5408\u7684\u306A\u81E8\u5E8A\u8A55\u4FA1\u3068\u30A2\u30C9\u30D0\u30A4\u30B9\u304C\u5FC5\u8981\u3067\u3059\u3002</li>\n  <li>\u672C\u691C\u67FB\u30B7\u30B9\u30C6\u30E0\u306F\u3001\u30C7\u30FC\u30BF\u30D9\u30FC\u30B9\u3001\u30A2\u30EB\u30B4\u30EA\u30BA\u30E0\u3001\u691C\u67FB\u5BFE\u8C61\u907A\u4F1D\u5B50\u304A\u3088\u3073\u5909\u7570\u7B87\u6240\u3001\u307E\u305F\u306F\u95A2\u9023\u3059\u308B\u691C\u67FB\u9805\u76EE\u306E\u8AAC\u660E\u30FB\u5185\u5BB9\u304C\u968F\u6642\u66F4\u65B0\u3055\u308C\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u66F4\u65B0\u306B\u95A2\u3057\u3066\u3001\u5F53\u793E\u306F\u6700\u7D42\u7684\u306A\u89E3\u91C8\u6A29\u3092\u6709\u3057\u307E\u3059\u3002</li>\n  <li>\u672C\u691C\u67FB\u306B\u304A\u3051\u308B\u85AC\u7269\u4EE3\u8B1D\u95A2\u9023\u907A\u4F1D\u5B50\u306E\u81E8\u5E8A\u7684\u89E3\u91C8\u306F\u3001PharmGKB\uFF08Pharmacogenomics Knowledgebase\uFF1A\u85AC\u7269\u30B2\u30CE\u30DF\u30AF\u30B9\u30C7\u30FC\u30BF\u30D9\u30FC\u30B9\uFF09\u304A\u3088\u3073ClinPGx\uFF08Clinical Pharmacogenomics\uFF1A\u81E8\u5E8A\u85AC\u7269\u30B2\u30CE\u30DF\u30AF\u30B9\uFF09\u30C7\u30FC\u30BF\u30D9\u30FC\u30B9\u306B\u57FA\u3065\u304D\u3001\u7D71\u5408\u7684\u306B\u8A55\u4FA1\u30FB\u5224\u8AAD\u3057\u3066\u3044\u307E\u3059\u3002PharmGKB\u306F\u3001\u7C73\u56FD\u56FD\u7ACB\u885B\u751F\u7814\u7A76\u6240\uFF08NIH\uFF09\u306E\u652F\u63F4\u306B\u3088\u308A\u69CB\u7BC9\u3055\u308C\u305F\u9AD8\u4FE1\u983C\u6027\u306E\u85AC\u7269\u30B2\u30CE\u30DF\u30AF\u30B9\u30C7\u30FC\u30BF\u30D9\u30FC\u30B9\u3067\u3042\u308A\u3001\u907A\u4F1D\u5B50\u5909\u7570\u3068\u85AC\u7269\u4F5C\u7528\u3001\u4EE3\u8B1D\u7D4C\u8DEF\u3001\u526F\u4F5C\u7528\u3001\u81E8\u5E8A\u6295\u4E0E\u6307\u91DD\u306A\u3069\u306E\u95A2\u9023\u60C5\u5831\u3092\u4F53\u7CFB\u7684\u306B\u96C6\u7D04\u3057\u3001\u30A8\u30D3\u30C7\u30F3\u30B9\u306E\u5F37\u5EA6\u306B\u57FA\u3065\u3044\u3066\u5404\u907A\u4F1D\u5B50\u5909\u7570\u3092\u5206\u985E\u3057\u3066\u3044\u307E\u3059\u3002\u672C\u691C\u67FB\u3067\u306F\u3001\u79D1\u5B66\u7684\u59A5\u5F53\u6027\u304A\u3088\u3073\u4FE1\u983C\u6027\u3092\u78BA\u4FDD\u3059\u308B\u305F\u3081\u3001\u5341\u5206\u306A\u6587\u732E\u7684\u6839\u62E0\u3092\u6709\u3059\u308BLevel 3\u4EE5\u4E0A\u306E\u30A8\u30D3\u30C7\u30F3\u30B9\u306B\u57FA\u3065\u304F\u907A\u4F1D\u5B50\u5909\u7570\u306E\u307F\u3092\u5BFE\u8C61\u3068\u3057\u3066\u89E3\u91C8\u3092\u884C\u3063\u3066\u3044\u307E\u3059\u3002<br>\u307E\u305F\u3001ClinPGx\u306F\u85AC\u7269\u30B2\u30CE\u30DF\u30AF\u30B9\u306E\u77E5\u898B\u3092\u81E8\u5E8A\u533B\u7642\u306B\u5FDC\u7528\u3059\u308B\u3082\u306E\u3067\u3042\u308A\u3001\u500B\u3005\u306E\u907A\u4F1D\u5B50\u5909\u7570\u304C\u85AC\u52B9\u3001\u4EE3\u8B1D\u80FD\u529B\u304A\u3088\u3073\u526F\u4F5C\u7528\u30EA\u30B9\u30AF\u306B\u4E0E\u3048\u308B\u5F71\u97FF\u3092\u8A55\u4FA1\u3059\u308B\u3053\u3068\u3067\u3001\u3088\u308A\u9069\u5207\u306A\u85AC\u5264\u9078\u629E\u304A\u3088\u3073\u7528\u91CF\u8ABF\u6574\u306E\u652F\u63F4\u3092\u76EE\u7684\u3068\u3057\u3066\u3044\u307E\u3059\u3002</li>\n  <li>\u30AD\u30E3\u30EA\u30A2\u30B9\u30AF\u30EA\u30FC\u30CB\u30F3\u30B0\u306E\u9805\u76EE\u306F\u3001\u62E1\u5F35\u30AD\u30E3\u30EA\u30A2\u30B9\u30AF\u30EA\u30FC\u30CB\u30F3\u30B0\uFF08Expanded Carrier Screening\uFF1AECS\uFF09\u306B\u95A2\u3059\u308B\u30A2\u30E1\u30EA\u30AB\u4EBA\u985E\u907A\u4F1D\u5B66\u4F1A\uFF08ACMG\uFF09\u306E\u63A8\u5968\u306B\u57FA\u3065\u304D\u3001\u81E8\u5E8A\u7684\u610F\u7FA9\u304A\u3088\u3073\u96C6\u56E3\u30EA\u30B9\u30AF\u3092\u8003\u616E\u3057\u305F\u968E\u5C64\u7684\uFF08tier-based\uFF09\u8A2D\u8A08\u306B\u306A\u3063\u3066\u304A\u308A\u307E\u3059\u3002<br>ACMG\u3067\u306F\u3001\u63A8\u5968\u3055\u308C\u308B\u691C\u67FB\u5BFE\u8C61\u75BE\u60A3\u3092\u4EE5\u4E0B\u306E3\u3064\u306E\u968E\u5C64\u306B\u5206\u985E\u3057\u3066\u3044\u307E\u3059\u3002Tier 1\uFF1A\u3059\u3079\u3066\u306E\u96C6\u56E3\u306B\u5BFE\u3057\u3066\u63A8\u5968\u3055\u308C\u308B\u57FA\u672C\u7684\u306A\u30B9\u30AF\u30EA\u30FC\u30CB\u30F3\u30B0\u9805\u76EE\u3067\u3042\u308A\u3001\u56A2\u80DE\u6027\u7DDA\u7DAD\u75C7\uFF08Cystic Fibrosis\uFF1ACF\uFF09\u304A\u3088\u3073\u810A\u9AC4\u6027\u7B4B\u840E\u7E2E\u75C7\uFF08Spinal Muscular Atrophy\uFF1ASMA\uFF09\u3092\u542B\u307F\u3001\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u7279\u5B9A\u96C6\u56E3\u306B\u304A\u3051\u308B\u9AD8\u30EA\u30B9\u30AF\u75BE\u60A3\u3092\u5BFE\u8C61\u3068\u3057\u307E\u3059\u3002 Tier 2\uFF1A\u91CD\u5EA6\u307E\u305F\u306F\u4E2D\u7B49\u5EA6\u306E\u81E8\u5E8A\u8868\u73FE\u578B\u3092\u793A\u3057\u3001\u4E00\u822C\u96C6\u56E3\u306B\u304A\u3051\u308B\u4FDD\u56E0\u8005\u983B\u5EA6\u304C1/100\u4EE5\u4E0A\u306E\u907A\u4F1D\u6027\u75BE\u60A3\u3092\u5BFE\u8C61\u3068\u3057\u307E\u3059\u3002Tier 3\uFF1A\u4FDD\u56E0\u8005\u983B\u5EA6\u304C1/200\u4EE5\u4E0A\u306E\u907A\u4F1D\u6027\u75BE\u60A3\u3092\u542B\u307F\u3001\u3088\u308A\u5305\u62EC\u7684\u306A\u751F\u6B96\u30EA\u30B9\u30AF\u8A55\u4FA1\u3092\u76EE\u7684\u3068\u3057\u3066\u3044\u307E\u3059\u3002<br>\u306A\u304A\u3001\u672C\u691C\u67FB\u9805\u76EE\u306F\u3001\u4E0A\u8A18\u306E\u539F\u5247\u306B\u57FA\u3065\u3044\u3066\u8A2D\u8A08\u3055\u308C\u3066\u304A\u308A\u3001\u53D7\u691C\u8005\u306B\u304A\u3051\u308B\u6F5C\u5728\u7684\u306A\u52A3\u6027\u907A\u4F1D\u75BE\u60A3\u306E\u4FDD\u56E0\u30EA\u30B9\u30AF\u3092\u8A55\u4FA1\u3059\u308B\u305F\u3081\u306E\u6307\u6A19\u3068\u3057\u3066\u7528\u3044\u3089\u308C\u307E\u3059\u3002</li>\n</ul>'
            },
            族裔分析檢測說明: {
              ___title: '民族解析検査の説明',
              ___content: '<ul>\n  <li>\u672C\u89E3\u6790\u306F\u30011000 Genomes Project\uFF081000G\uFF09\u304A\u3088\u3073Human Genome Diversity Project\uFF08HGDP\uFF09\u306E2\u3064\u306E\u516C\u958B\u30C7\u30FC\u30BF\u30D9\u30FC\u30B9\u3092\u7D44\u307F\u5408\u308F\u305B\u3001\u30C7\u30FC\u30BF\u3092\u7D71\u5408\u30FB\u524D\u51E6\u7406\u3057\u305F\u5F8C\u3001PLINK\u3092\u7528\u3044\u3066\u30EA\u30F3\u30B1\u30FC\u30B8\u4E0D\u5E73\u8861\uFF08Linkage Disequilibrium\u3001LD\uFF09\u30D5\u30A3\u30EB\u30BF\u30EA\u30F3\u30B0\u3092\u884C\u3044\u3001\u907A\u4F1D\u5B50\u578B\u30C7\u30FC\u30BF\u306E\u72EC\u7ACB\u6027\u3092\u78BA\u4FDD\u3057\u3066\u3044\u307E\u3059\u3002\u305D\u306E\u5F8C\u3001ADMIXTURE\u30C4\u30FC\u30EB\u3092\u7528\u3044\u3066\u500B\u4F53\u306E\u7956\u6E90\u6210\u5206\u3092\u63A8\u5B9A\u3057\u3066\u3044\u307E\u3059\u3002\u3053\u306E\u65B9\u6CD5\u306F\u6700\u5C24\u63A8\u5B9A\u91CF\u6CD5\uFF08Maximum Likelihood Estimation\uFF09\u3092\u4F7F\u7528\u3057\u3066\u7570\u306A\u308B\u96C6\u56E3\u306E\u907A\u4F1D\u7684\u5BC4\u4E0E\u3092\u8A55\u4FA1\u3057\u3001\u7956\u6E90\u7D44\u6210\u3092\u8996\u899A\u5316\u3057\u305F\u7D50\u679C\u3092\u63D0\u4F9B\u3057\u3066\u3044\u307E\u3059\u3002</li>\n  <li>\u53D7\u691C\u8005\u306E\u30C7\u30FC\u30BF\u306FFASTQ\u306E\u539F\u59CB\u30B7\u30FC\u30B1\u30F3\u30B9\u30C7\u30FC\u30BF\u304B\u3089\u51E6\u7406\u3092\u958B\u59CB\u3057\u3001\u307E\u305A\u30DE\u30C3\u30D4\u30F3\u30B0\uFF08Mapping\uFF09\u3092\u884C\u3044\u3001\u30EA\u30FC\u30C9\u30B7\u30FC\u30B1\u30F3\u30B9\u3092\u53C2\u7167\u30B2\u30CE\u30E0\u306B\u30A2\u30E9\u30A4\u30E1\u30F3\u30C8\u3057\u3066\u3044\u307E\u3059\u3002\u6B21\u306B\u5909\u7570\u691C\u51FA\uFF08Variant Calling\uFF09\u3092\u5B9F\u884C\u3057\u3001SNP\u304A\u3088\u3073\u30A4\u30F3\u30C7\u30EB\u5909\u7570\u3092\u7279\u5B9A\u3057\u307E\u3059\u3002\u305D\u306E\u5F8C\u3001\u7956\u6E90\u5206\u6790\u306B\u95A2\u9023\u3059\u308B\u5909\u7570\u7B87\u6240\u3092\u9078\u5225\u3057\u3001\u53C2\u7167\u30C7\u30FC\u30BF\u30BB\u30C3\u30C8\u306B\u4E00\u81F4\u3059\u308B\u30DE\u30FC\u30AB\u30FC\u3092\u78BA\u4FDD\u3057\u3066\u6BD4\u8F03\u306E\u7CBE\u5EA6\u3092\u9AD8\u3081\u3066\u3044\u307E\u3059\u3002</li>\n  <li>\u3057\u304B\u3057\u3001\u3053\u306E\u65B9\u6CD5\u306E\u7CBE\u5EA6\u306F\u53C2\u7167\u30C7\u30FC\u30BF\u30D9\u30FC\u30B9\u306E\u4EE3\u8868\u6027\u306B\u5F71\u97FF\u3055\u308C\u307E\u3059\u3002\u4F8B\u3048\u3070\u3001\u7279\u5B9A\u306E\u96C6\u56E3\u304C1000G\u304A\u3088\u3073HGDP\u30C7\u30FC\u30BF\u306B\u304A\u3044\u3066\u5341\u5206\u306B\u30AB\u30D0\u30FC\u3055\u308C\u3066\u3044\u306A\u3044\u5834\u5408\u3001\u7D50\u679C\u306B\u504F\u308A\u304C\u751F\u3058\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u307E\u305F\u3001ADMIXTURE\u306E\u4EEE\u5B9A\u306F\u7279\u5B9A\u306E\u7956\u5148\u96C6\u56E3\u30E2\u30C7\u30EB\u306B\u57FA\u3065\u3044\u3066\u304A\u308A\u3001\u6B74\u53F2\u7684\u306A\u96C6\u56E3\u79FB\u52D5\u3084\u6DF7\u5408\u904E\u7A0B\u3092\u5B8C\u5168\u306B\u53CD\u6620\u3057\u3066\u3044\u306A\u3044\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002LD\u30D5\u30A3\u30EB\u30BF\u30EA\u30F3\u30B0\u306F\u907A\u4F1D\u5B50\u578B\u9023\u9396\u306E\u5F71\u97FF\u3092\u6E1B\u3089\u3059\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u304C\u3001\u96C6\u56E3\u7279\u7570\u7684\u306A\u30DE\u30FC\u30AB\u30FC\u306E\u4FDD\u6301\u306B\u306F\u5F71\u97FF\u3092\u4E0E\u3048\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002\u3055\u3089\u306B\u3001\u30B7\u30FC\u30B1\u30F3\u30B7\u30F3\u30B0\u54C1\u8CEA\u3001\u5909\u7570\u691C\u51FA\u306E\u7CBE\u5EA6\u3001\u304A\u3088\u3073\u30C7\u30FC\u30BF\u524D\u51E6\u7406\u306E\u6226\u7565\u3082\u5206\u6790\u7D50\u679C\u306B\u5F71\u97FF\u3092\u4E0E\u3048\u308B\u53EF\u80FD\u6027\u304C\u3042\u308B\u305F\u3081\u3001\u3053\u308C\u3089\u306E\u6F5C\u5728\u7684\u306A\u5236\u9650\u3092\u8003\u616E\u3057\u3001\u4ED6\u306E\u89E3\u6790\u65B9\u6CD5\u3068\u7D44\u307F\u5408\u308F\u305B\u3066\u7D50\u679C\u3092\u4EA4\u5DEE\u691C\u8A3C\u3059\u308B\u3053\u3068\u304C\u91CD\u8981\u3068\u306A\u308A\u307E\u3059\u3002</li>\n</ul>'
            }
          }
        }
      },
      carrierScreening: {
        ___title: '說明',
        ___content01: '以下は、キャリアスクリーニングの詳細項目について最も一般的な遺伝疾患を列挙し、リスト化したものです。これにより、キャリアスクリーニングについてより理解を深めていただけます。<br>ご注意いただきたいのは、InheriNext遺伝学的検査が「すべての遺伝子のエクソン領域」をカバーしており、遺伝学のデータベースに基づいて、7,000種類以上の疾患に対するキャリアリスクを一度にスキャンするため、以下の疾患リストよりも広範囲にわたる篩選が行われるという点です。',
        table: {
          title: {
            ___基因名稱: '遺伝子名',
            ___疾病名稱: '疾患名',
            ___遺傳模式: '遺伝形式'
          }
        }
      },
      pregnancyGene: {
        ___titlef: '女性関連遺伝子一覧',
        ___titlem: '男性関連遺伝子一覧',
        table: {
          title: {
            ___基因名稱: '遺伝子名',
            ___疾病名稱: '疾患名',
            ___遺傳模式: '遺伝形式'
          }
        }
      },
      carrierScreeningLink: {
        ___title: '說明',
        ___content01: '以下為您逐項列舉最常見之遺傳疾病，讓您更了解帶因篩查的詳細項目。請掃描以下QR Code或拜訪網址：'
      },
      pregnancyGeneLink: {
        ___title: '說明',
        ___content01: '以下為您逐項列舉最常見之男性與女性生殖與生育相關基因清單，讓您更了解生殖與生育的詳細項目。請掃描以下QR Code或拜訪網址：'
      }
    }
  }
});
// CONCATENATED MODULE: ./src/constants/lang/_report/tc/lang.js
/* harmony default export */ var _report_tc_lang = ({
  // report
  REPORT: {
    chapter: {
      ___appendix: '附錄',
      title: {
        ___subject: '受檢者基本資訊',
        ___intractable_disease: 'D006-4 指定難病の遺伝学的検査',
        ___disease_diagnosis: '疾病診斷',
        ___disease_diagnosis_ruo: '病徵篩查',
        ___active_screening: '主動篩查',
        ___cause_screening: '帶因篩查',
        ___acmg_incidental: 'ACMG偶然發現',
        ___custom1: '自訂頁面1',
        ___custom2: '自訂頁面2',
        ___custom3: '自訂頁面3',
        ___constitution: '體質相關基因',
        ___drug_meta: '藥物代謝',
        ___method: '檢測方法',
        ___appendix_intractable_disease_list: 'D006_4 遺傳子リスト',
        ___appendix_disease_gene: '疾病診斷之基因清單',
        ___appendix_disease_gene_ruo: '病徵篩查之基因清單',
        ___appendix_us_gene: '美國人類遺傳學會規範之基因'
      },
      item: {
        title: {
          ___resultSummary: '結果表格',
          ___interpretation: '文字說明'
        }
      },
      header: {
        ___info01: 'Report Date',
        ___info02: 'Sample ID'
      },
      footer: {
        ___info01: '＊ 本報告內容須經專業醫療人員解釋。',
        ___infoRuo01: '＊ 本報告內容僅作為專業醫療人員參考資訊。',
        ___info02: '300 新竹市東區慈雲路118號17樓之10 | 康百事生物資訊 | 03-574-5009',
        ___infoAct01: '行動基因是美國病理學會認證實驗室，認證實驗室號碼:9028096',
        ___infoAct02: '行動基因僅提供技術檢測服務及檢測報告，檢測結果之臨床解釋及相關醫療處置，請諮詢專業醫師。報告結果僅對此試驗件有效。',
        ___infoAct03: '行動基因臨床分子醫學實驗室 台北市內湖區新湖二路 345 號 3F',
        ___infoAct04: 'Email:service@actgenomics.com T: +886-2-2795-3660 F: +886-2-2795-5016'
      },
      basicInfo: {
        ___title: '受檢者基本資訊',
        ___signTitle: '署名',
        form: {
          title: {
            ___case_id: '姓名',
            ___sex: '性別',
            ___age: '年齡',
            ___testing_date: '檢測日期',
            ___testing_category: '檢測種類',
            ___sequencing_range: '定序範圍',
            ___sequencing_tech: '定序技術',
            ___doctor_name: '送檢醫師',
            ___organization: '機構院所',
            ___medical_number: '病歷號',
            ___family_medical_history: '備註'
          }
        }
      },
      variantResult: {
        mainData: {
          default: {
            ___title: '文字說明',
            ___contentTitle01_01: '本次基因檢測中，共發現 <b>{count}</b> 個基因攜帶可能致病的突變，',
            ___contentTitle01_02: '本次基因檢測中，共發現 <b>{count}</b> 個基因攜帶可能致病的突變',
            ___contentTitle02: '其中<b> {count} </b>個位於粒線體 DNA 區域',
            detail: {
              title: {
                ___ClinVar: 'ClinVar 資料庫登載為{result}',
                ___ClinVar_empty: 'ClinVar 資料庫無登載',
                ___ACMG: 'ACMG 指南預測為{result}',
                ___OMIM: 'OMIM 資料庫記載可能相關的疾病為，',
                ___OMIM_empty: 'OMIM 資料庫未記載可能相關的疾病',
                ___Orphanet: 'Orphanet 資料庫記載可能相關的疾病為，',
                ___Orphanet_empty: 'Orphanet 資料庫未記載可能相關的疾病'
              }
            }
          },
          sv: {
            ___title: 'SV文字說明',
            ___contentTitle01: '本次基因檢測中，共發現 <b>{count}</b> 個區域產生可能致病的突變',
            detail: {
              title: {
                ___genes: '該區域涵蓋之相關基因為{result}',
                ___OMIM: 'OMIM 資料庫記載可能相關的疾病為，',
                ___OMIM_empty: 'OMIM 資料庫未記載可能相關的疾病'
              }
            }
          }
        }
      },
      variantDetail: {
        ___symbolContainerTitle: '結果表格',
        ___variantContainerTitle: '相關疾病與表型',
        ___phenotypeTableEmpty: '無資料',
        ___variantNotePlaceholder: '備註',
        variantSubBlock: {
          title: {
            ___ClinVar: 'ClinVar登載',
            ___ACMG: 'ACMG指南預測',
            ___SIFT_PolyPhen: 'SIFT / PolyPhen-2',
            ___SIFT: 'SIFT',
            ___PolyPhen: 'PolyPhen-2',
            ___CADD: 'CADD',
            ___AF_MT: 'Homoplasmy EAS AF / Heteroplasmy EAS AF',
            ___AF: 'TW Biobank / gnomAD EAS',
            ___AF_EN: 'GnomAD Exomes AF / GnomAD Genomes AF',
            ___AF_JP: 'GnomAD Genomes AF / ToMMo 60K JPN',
            ___Population_Databases: '變異頻率',
            ___Prediction_Score: '蛋白質功能預測',
            ___Sequencing_Quality: '定序品質'
          }
        },
        info: {
          title: {
            ___phenotypes: '臨床表徵',
            ___gene_panels: '基因套組',
            ___related_genes: '基因範圍'
          }
        },
        portraitVariantTable: {
          title: {
            ___custom_details_pos: '位置',
            ___custom_details_Rank: '外顯子/<br>內含子編號',
            ___custom_details_HGVSm: '核苷酸變異位點<br>HGVSm',
            ___custom_details_HGVSc: '核苷酸變異位點<br>HGVSc',
            ___custom_details_HGVSp: '胺基酸變異位點<br>HGVSp',
            ___custom_details_GT_AF: '異質性程度 (%)',
            ___custom_details_GT: '合子型',
            ___custom_details_Consequence: '變異類型',
            ___custom_details_dbSNP_ID: 'rs ID',
            ___custom_parental_origin: 'Parental<br>Origin'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '臨床表徵',
            ___id: 'OMIM表徵編號',
            ___Inheritance: '遺傳模式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '臨床表徵',
            ___id: 'ORPHA表徵編號'
          }
        },
        dbTable: {
          title: {
            ___KG_AF: '1000 Genomes',
            ___KG_EAS_AF: '1000 Genomes EAS',
            ___gnomAD_AF: 'GnomAD Exomes',
            ___gnomAD_g_AF: 'GnomAD Genomes',
            ___gnomAD_g_AF_eas: 'GnomAD Genomes<br>EAS',
            ___TW_AF: '台灣人基因型頻率',
            ___TOPMED_AF: 'TOPMED',
            ___UK10K_AF: 'UK10K',
            ___GA_AF: 'Genome Asia100',
            ___tommo_60kjpn_AF: 'ToMMo 60K JPN',
            ___gnomAD_g_mt_AF_het: 'GnomAD Genomes<br>Heteroplasmy',
            ___gnomAD_g_mt_pop_AF_het_eas: 'GnomAD Genomes<br>Heteroplasmy EAS',
            ___gnomAD_g_mt_AF_hom: 'GnomAD Genomes<br>Homoplasmy',
            ___gnomAD_g_mt_pop_AF_hom_eas: 'GnomAD Genomes<br>Homoplasmy EAS'
          }
        },
        psTable: {
          title: {
            ___SIFT4G: 'SIFT4G',
            ___FATHMM: 'FATHMM',
            ___PROVEAN: 'PROVEAN',
            ___MetaLR: 'MetaLR',
            ___MetaSVM: 'MetaSVM',
            ___BayesDel_noAF: 'BayesDel noAF',
            ___gnomAD_g_mt_mitotip: 'MitoTip',
            ___ada: 'ada',
            ___rf: 'rf',
            ___GERPpp_RS: 'GERP++RS',
            ___SiPhy_29way_logOdds: 'SiPhy 29way logOdds'
          }
        }
      },
      variantSV: {
        ___mainTableTitle: 'SV 結果表格',
        ___symbolContainerTitle: '相關基因',
        ___geneContainerTitle: '相關疾病與表型',
        ___phenotypeTableEmpty: '無資料',
        ___svNotePlaceholder: '備註',
        svTable: {
          title: {
            ___Position: '變異區域',
            ___Exon_Intron: '外顯子 / 內含子編號',
            ___Zygosity: '合子型',
            ___Consequence: '變異類型',
            ___Fragment_size: '片段大小',
            ___Parental_Origin: 'Parental Origin'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '臨床表徵',
            ___id: 'OMIM表徵編號',
            ___Inheritance: '遺傳模式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '臨床表徵',
            ___id: 'ORPHA表徵編號'
          }
        }
      },
      variantCNV: {
        ___mainTableTitle: 'SV 結果表格',
        ___symbolContainerTitle: '相關基因',
        ___geneContainerTitle: '相關疾病與表型',
        ___phenotypeTableEmpty: '無資料',
        ___cnvNotePlaceholder: '備註',
        cnvTable: {
          title: {
            ___Position: '變異區域',
            ___Exon_Intron: '外顯子 / 內含子編號',
            ___Zygosity: '合子型',
            ___Consequence: '變異類型',
            ___Fragment_size: '片段大小',
            ___Parental_Origin: 'Parental Origin'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '臨床表徵',
            ___id: 'OMIM表徵編號',
            ___Inheritance: '遺傳模式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '臨床表徵',
            ___id: 'ORPHA表徵編號'
          }
        }
      },
      intractableDiseaseResult: {
        ___title: 'D006-4 指定難病の遺伝学的検査',
        diseaseList: {
          ___title: '指定難病'
        },
        diseaseRange: {
          ___title: '遺伝子の範囲',
          content: {
            ___list: '<b>{name}</b>に関連する遺伝子を対象として、{count}個の遺伝子に対する関連性解析をすでに実施しております。',
            ___suffix: '詳細は別添の「D006-4 遺伝子リスト」をご参照ください。'
          }
        }
      },
      constitutionGene: {
        ___title: '體質相關基因',
        ___subTitle: '許多基因被發現與過敏、⾎栓、酒精不耐有關，這些重要資訊能提醒你更多⽣活注意事項。',
        mainData: {
          testSummary: {
            ___title: '檢測結果說明'
          }
        },
        mainTable: {
          testingItems: {
            ___title: '詳細檢測項目'
          }
        },
        table: {
          title: {
            ___title: '檢測項目',
            ___SYMBOL: '檢測基因',
            ___Location2: '檢測位點',
            ___Result: '檢測結果'
          },
          value: {
            Result: {
              ___true: '檢出',
              ___false: '未檢出'
            }
          }
        }
      },
      drugAnalysis: {
        ___title: '藥物代謝分析',
        ___subTitle: '藥物相關基因可提供醫師作為參考，選擇對⾃⼰最適合的藥物，預防嚴重副作⽤、毒性，並達到最佳的治療反應。同⼀種藥物，有些⼈⽤藥後全⾝過敏或副作⽤特別強，是因為⽤了不適合⾃⼰的藥物或劑量。',
        customInfos: {
          ___info01: '＊ 紅色標示之基因型為檢測出之風險基因型。'
        },
        mainData: {
          testSummary: {
            ___title: '檢測結果說明'
          }
        },
        mainTable: {
          testingItems: {
            ___title: '詳細檢測項目'
          }
        },
        table: {
          title: {
            ___name: '藥物名稱',
            ___type: '藥物作用',
            ___SYMBOL: '檢測基因',
            ___risk_genotype2: '檢測位點',
            ___clinical_phenotype: '臨床意義',
            ___Result: '檢測結果'
          },
          value: {
            Result: {
              ___true: '檢出',
              ___false: '未檢出'
            }
          }
        }
      },
      detectMethod: {
        ___title: '檢測方法、檢測品質與分析軟體版本資訊',
        ___subTitle: '檢測方法說明',
        option: {
          title: {
            ___metrics: '上傳 Metrics'
          }
        },
        table: {
          title: {
            ___library_kit: '樣本庫試劑組',
            ___sequencing_platform: '定序平台',
            ___sequencing_length: '定序長度',
            ___average_sequencing_length: '平均定序深度',
            ___pct_target_bases_xx: '所有定序範圍內之<br>20X檢測覆蓋率',
            ___reference: '參考序列',
            ___alignment_version: '序列比對<br>Alignment軟體',
            ___variant_calling_version: '序列比對<br>Variant Calling軟體',
            ___jannovar_version: '變異點位註解軟體<br>jANNOVAR 版本',
            ___vep_version: '變異點位註解軟體<br>VEP 版本',
            ___hpo_version: 'HPO版本',
            ___omim_version: 'OMIM版本',
            ___dbsnp_version: 'dbSNP版本',
            ___clinvar_version: 'ClinVar版本',
            ___mitomap_version: 'MITOMAP版本',
            ___dbnsfp_version: 'dbNSFP 版本'
          }
        }
      },
      detectMethodComment: {
        ___subTitle: '檢測方法注釋',
        list: {
          list01: {
            ___title: '檢測結果比對參考序列為人類GRCh38 (或稱 hg38) 版本。'
          },
          list02: {
            ___title: '<b>基因型 (genotype)</b>',
            detail: {
              detail01: {
                ___title: 'Homozygous：在2條相對的對偶基因(allele)中，皆出現此基因變異位點。'
              },
              detail02: {
                ___title: 'Heterozygous：此基因變異位點僅出於1條對偶基因中，另1條對偶基因上無位點變異。'
              },
              detail03: {
                ___title: 'Hemizygous：在男性受測者中，因僅有1條X或Y染色體，稱為半合子。若基因變異位點出現於性染色體上，則以Hemizygous表示之。'
              }
            }
          },
          list03: {
            ___title: '<b>臨床意義 (clinical significance)</b>：主要引用ClinVar資料庫註解或依據2015年版ACMG準則進行分類',
            detail: {
              detail01: {
                ___title: 'Pathogenic：此基因變異位點具致病性。'
              },
              detail02: {
                ___title: 'Likely pathogenic：此基因變異位點可能具致病性。'
              },
              detail03: {
                ___title: 'Uncertain significance：此基因變異位點對於臨床上的影響目前尚無定論。'
              },
              detail04: {
                ___title: 'Likely benign：此基因變異位點可能不具致病性。'
              },
              detail05: {
                ___title: 'Benign：此基因變異位點不具致病性。'
              },
              detail06: {
                ___title: 'Conflicting interpretations of pathogenicity：此基因變異位點對於臨床上影響程度的定義並未有一致性解釋，有的文獻認為具致病性，有的文獻則認為不具致病性。'
              },
              detail07: {
                ___title: 'Disease-associated polymorphism：有文獻報導此基因多型性與疾病有顯著相關性。'
              },
              detail08: {
                ___title: 'SNP：在1000 Genomes資料庫中，此基因變異點在東南族群 (East Asian, EAS) 的發生比例大於1%，並無與疾病相關之文獻報導。'
              },
              detail09: {
                ___title: 'Drug response：此基因變異位點會影響藥物反應，可能干擾藥物療效或藥物副作用的產生與否有關。'
              }
            }
          },
          list04: {
            ___title: '<b>參考資料</b>',
            detail: {
              detail01: {
                ___title: '1000 Genomes EAS：在1000 Genomes資料庫中，為此基因變異位點在東亞族 (East Asian, EAS) 的基因型比例。'
              },
              detail02: {
                ___title: 'gnomAD EAS：在 gnomAD 資料庫，為此基因變異位點在東亞族 (East Asian, EAS) 的基因型比例。'
              },
              detail03: {
                ___title: 'Taiwan BioBank: 在臺灣人體生物資料庫中，為此基因變異位點的基因型比例。臨床意義正確性仍無法確認，僅供參考。'
              },
              detail04: {
                ___title: '參考文獻：報導過此突變位點文獻，會列出文獻第一作者、出版年份、期刊名稱、卷號、和起始碼。'
              },
              detail05: {
                ___title: 'SIFT 與 PolyPhen-2 為預測胺基酸變異對於臨床上影響程度的 2 種統計工具。在 SIFT 中將預測結果標示為「有害」(Damaing) 或「無害」(Tolerated)，括弧內的數字為統計結果 ; 在 PolyPhen-2 中，將預測結果標示為「有害」(Damaging)、「可能有害」(Possibly damaging) 和「無害」(Benign)，括弧內的數字為統計結果，然而此預測結果缺乏對於蛋白質或基因學研究的相關證據，其預測出的臨床意義正確性仍無法確認，僅供參考。'
              }
            }
          }
        }
      },
      attachmentIntractableDiseaseDetail: {
        ___title: 'D006_4 遺傳子リスト',
        table: {
          title: {
            ___disease: 'D006-4 遺伝学的検査の疾患名',
            ___gene: '代表的な疾患原因遺伝子<br>(指定難病の診断基準の遺伝子)'
          }
        }
      },
      attachmentDiagnosisGene: {
        ___title: '疾病診斷之基因清單',
        ___title_ruo: '病徵篩查之基因清單',
        ___geneListTitle01: '覆蓋率 ≥ {cov}之基因',
        ___geneListTitle02: '覆蓋率未達{cov}之基因'
      },
      attachmentASoHGGene: {
        ___title: '美國人類遺傳學會規範之基因清單'
      }
    }
  }
});
// CONCATENATED MODULE: ./src/constants/lang/_report/en/lang.js
/* harmony default export */ var en_lang = ({
  // report
  REPORT: {
    chapter: {
      ___appendix: 'Appendix',
      title: {
        ___subject: 'Patient Information',
        ___intractable_disease: 'D006-4 指定難病の遺伝学的検査',
        ___disease_diagnosis: 'Candidate List',
        ___active_screening: 'Proactive Test',
        ___cause_screening: 'Carrier Screening',
        ___acmg_incidental: 'ACMG Incidental',
        ___custom1: 'custom1',
        ___custom2: 'custom2',
        ___custom3: 'custom3',
        ___constitution: 'Constitution-related genes',
        ___drug_meta: 'Pharmacogenetics',
        ___method: 'Method',
        ___appendix_intractable_disease_list: 'D006_4 遺傳子リスト',
        ___appendix_disease_gene: 'Candidate Gene List',
        ___appendix_us_gene: 'ACMG Guideline'
      },
      item: {
        title: {
          ___resultSummary: 'Result Summary',
          ___interpretation: 'Interpretation'
        }
      },
      header: {
        ___info01: 'Report Date',
        ___info02: 'Sample ID'
      },
      footer: {
        ___info01: '＊The report has to be interpreted by medical professionals.',
        ___info02: '17F.-10, No. 118, Ciyun Rd., Hsinchu City 300 , Taiwan (R.O.C.) | Compass Bioinformatics Inc. | 886-3-574-5009',
        ___infoAct01: 'ACT Genomics laboratory is accredited by CAP. CAP number: 9028096.',
        ___infoAct02: 'ACT Genomics only provides a technical report of the test, please consult a specialist physician to determine the appropriate clinical solution and follow the instruction of the physician. The results are only valid for the tested sample(s).',
        ___infoAct03: 'ACT Genomics Laboratory HQ: 3F, No. 345, Xinhu 2nd Rd, Taipei, Taiwan 11494',
        ___infoAct04: 'Email:service@actgenomics.com T: +886-2-2795-3660 F: +886-2-2795-5016'
      },
      basicInfo: {
        ___title: 'Patient Information',
        ___signTitle: '署名',
        form: {
          title: {
            ___case_id: 'Name',
            ___sex: 'Sex',
            ___age: 'Age',
            ___testing_date: 'Test Date',
            ___testing_category: 'Sample\ntype',
            ___sequencing_range: 'Test',
            ___sequencing_tech: 'Seqencing \nPlatform',
            ___doctor_name: 'Doctor',
            ___organization: 'Hospital',
            ___medical_number: 'Clinical\nID',
            ___family_medical_history: 'Note'
          }
        }
      },
      variantResult: {
        mainData: {
          default: {
            ___title: 'Interpretation',
            ___contentTitle01_01: 'We detected <b>{count}</b> gene with likely disease-causing variants | We detected <b>{count}</b> genes with likely disease-causing variants',
            ___contentTitle01_02: 'We detected <b>{count}</b> gene with likely disease-causing variants.  | We detected <b>{count}</b> genes with likely disease-causing variants. ',
            ___contentTitle02: 'there is {count} <b>gene located in the mitochondria. | there are<b> {count} <b>genes located in the mitochondria.',
            detail: {
              title: {
                ___ClinVar: 'The clinical interpretation of ClinVar is {result}',
                ___ClinVar_empty: 'ClinVar data is not available',
                ___ACMG: 'The classification of ACMG is {result}',
                ___OMIM: 'There are associated-diseases were found in OMIM, which are:',
                ___OMIM_empty: 'No gene associated-diseases were found in OMIM',
                ___Orphanet: 'There are associated-diseases were found in Orphanet, which are:',
                ___Orphanet_empty: 'No gene associated-diseases were found in Orphanet'
              }
            }
          },
          sv: {
            ___title: 'SV Interpretation',
            ___contentTitle01: 'We detected <b>{count}</b> gene with likely disease-causing variants | We detected <b>{count}</b> genes with likely disease-causing variants',
            detail: {
              title: {
                ___genes: 'Affected genes within this region are {result}',
                ___OMIM: 'There are associated-diseases were found in OMIM, which are:',
                ___OMIM_empty: 'No gene associated-diseases were found in OMIM'
              }
            }
          }
        }
      },
      variantDetail: {
        ___symbolContainerTitle: 'Result Summary',
        ___variantContainerTitle: 'Related Diseases and Phenotypes',
        ___phenotypeTableEmpty: 'No Data',
        ___variantNotePlaceholder: 'Note',
        variantSubBlock: {
          title: {
            ___ClinVar: 'ClinVar Database',
            ___ACMG: 'ACMG Guideline',
            ___SIFT_PolyPhen: 'SIFT / PolyPhen-2',
            ___SIFT: 'SIFT',
            ___PolyPhen: 'PolyPhen-2',
            ___CADD: 'CADD',
            ___AF_MT: 'Homoplasmy EAS AF / Heteroplasmy EAS AF',
            ___AF: 'TW Biobank / gnomAD EAS',
            ___AF_EN: 'GnomAD Exomes AF / GnomAD Genomes AF',
            ___AF_JP: 'GnomAD Genomes AF / ToMMo 60K JPN',
            ___Population_Databases: 'Population Databases',
            ___Prediction_Score: 'Prediction Score',
            ___Sequencing_Quality: 'Sequencing Quality'
          }
        },
        info: {
          title: {
            ___phenotypes: 'Phenotype',
            ___gene_panels: 'Gene Panels',
            ___related_genes: 'Gene'
          }
        },
        portraitVariantTable: {
          title: {
            ___custom_details_pos: 'Position<br>(HG38)',
            ___custom_details_Rank: 'Exon/Intron',
            ___custom_details_HGVSm: 'HGVSm',
            ___custom_details_HGVSc: 'HGVSc',
            ___custom_details_HGVSp: 'HGVSp',
            ___custom_details_GT_AF: 'Heteroplasmy<br>Level (%)',
            ___custom_details_GT: 'Zygosity',
            ___custom_details_Consequence: 'Consequence',
            ___custom_details_dbSNP_ID: 'rs ID',
            ___custom_parental_origin: 'Parental<br>Origin'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: 'Phenotypes',
            ___id: 'OMIM number',
            ___Inheritance: 'Inheritance Patterns'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: 'Phenotypes',
            ___id: 'ORPHA number'
          }
        },
        dbTable: {
          title: {
            ___KG_AF: '1000 Genomes',
            ___KG_EAS_AF: '1000 Genomes EAS',
            ___gnomAD_AF: 'GnomAD Exomes',
            ___gnomAD_g_AF: 'GnomAD Genomes',
            ___gnomAD_g_AF_eas: 'GnomAD Genomes<br>EAS',
            ___TW_AF: 'TW Biobank',
            ___TOPMED_AF: 'TOPMED',
            ___UK10K_AF: 'UK10K',
            ___GA_AF: 'Genome Asia100',
            ___tommo_60kjpn_AF: 'ToMMo 60K JPN',
            ___gnomAD_g_mt_AF_het: 'GnomAD Genomes<br>Heteroplasmy',
            ___gnomAD_g_mt_pop_AF_het_eas: 'GnomAD Genomes<br>Heteroplasmy EAS',
            ___gnomAD_g_mt_AF_hom: 'GnomAD Genomes<br>Homoplasmy',
            ___gnomAD_g_mt_pop_AF_hom_eas: 'GnomAD Genomes<br>Homoplasmy EAS'
          }
        },
        psTable: {
          title: {
            ___SIFT4G: 'SIFT4G',
            ___FATHMM: 'FATHMM',
            ___PROVEAN: 'PROVEAN',
            ___MetaLR: 'MetaLR',
            ___MetaSVM: 'MetaSVM',
            ___BayesDel_noAF: 'BayesDel noAF',
            ___gnomAD_g_mt_mitotip: 'MitoTip',
            ___ada: 'ada',
            ___rf: 'rf',
            ___GERPpp_RS: 'GERP++RS',
            ___SiPhy_29way_logOdds: 'SiPhy 29way logOdds'
          }
        }
      },
      variantSV: {
        ___mainTableTitle: 'SV Result Summary',
        ___symbolContainerTitle: 'Related Gene',
        ___geneContainerTitle: 'Related Diseases ana Phenotypes',
        ___phenotypeTableEmpty: 'No Data',
        ___svNotePlaceholder: 'Note',
        svTable: {
          title: {
            ___Position: 'Position',
            ___Exon_Intron: 'Exon/Intron',
            ___Zygosity: 'Zygosity',
            ___Consequence: 'Consequence',
            ___Fragment_size: 'Fragment size',
            ___Parental_Origin: 'Parental Origin'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: 'Phenotypes',
            ___id: 'OMIM number',
            ___Inheritance: 'Inheritance Patterns'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: 'Phenotypes',
            ___id: 'ORPHA number'
          }
        }
      },
      variantCNV: {
        ___mainTableTitle: 'SV Result Summary',
        ___symbolContainerTitle: 'Related Gene',
        ___geneContainerTitle: 'Related Diseases ana Phenotypes',
        ___phenotypeTableEmpty: 'No Data',
        ___cnvNotePlaceholder: 'Note',
        cnvTable: {
          title: {
            ___Position: 'Position',
            ___Exon_Intron: 'Exon/Intron',
            ___Zygosity: 'Zygosity',
            ___Consequence: 'Consequence',
            ___Fragment_size: 'Fragment size',
            ___Parental_Origin: 'Parental Origin'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: 'Phenotypes',
            ___id: 'OMIM number',
            ___Inheritance: 'Inheritance Patterns'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: 'Phenotypes',
            ___id: 'ORPHA number'
          }
        }
      },
      intractableDiseaseResult: {
        ___title: 'D006-4 指定難病の遺伝学的検査',
        diseaseList: {
          ___title: '指定難病'
        },
        diseaseRange: {
          ___title: '遺伝子の範囲',
          content: {
            ___list: '<b>{name}</b>に関連する遺伝子を対象として、{count}個の遺伝子に対する関連性解析をすでに実施しております。',
            ___suffix: '詳細は別添の「D006-4 遺伝子リスト」をご参照ください。'
          }
        }
      },
      constitutionGene: {
        ___title: 'Constitution-related genes',
        ___subTitle: 'Many genes have been found to be associated with allergies, blood clots, and alcohol intolerance. This important information provides lifestyle precautions for you.',
        mainData: {
          testSummary: {
            ___title: 'Test summary'
          }
        },
        mainTable: {
          testingItems: {
            ___title: 'Detailed testing items'
          }
        },
        table: {
          title: {
            ___title: 'Items',
            ___SYMBOL: 'Gene',
            ___Location2: 'Position',
            ___Result: 'Results'
          },
          value: {
            Result: {
              ___true: 'Positive',
              ___false: 'Negative'
            }
          }
        }
      },
      drugAnalysis: {
        ___title: 'Pharmacogenetics',
        ___subTitle: 'Pharmacogenetics provides doctors with references to choose the most suitable medication for individuals, preventing severe side effects and toxicity, and achieving the optimal treatment response. In the case of the same medication, some individuals may experience severe allergies or heightened side effects, which can be attributed to using medication or dosages that are not suitable for them.',
        customInfos: {
          ___info01: '＊ The genotype marked in red indicates the detected risk genotype.'
        },
        mainData: {
          testSummary: {
            ___title: 'Test summary'
          }
        },
        mainTable: {
          testingItems: {
            ___title: 'Detailed testing items'
          }
        },
        table: {
          title: {
            ___name: 'Chemicals',
            ___type: 'Type',
            ___SYMBOL: 'Gene',
            ___risk_genotype2: 'Position',
            ___clinical_phenotype: 'Clinical phenotype',
            ___Result: 'Results'
          },
          value: {
            Result: {
              ___true: 'Positive',
              ___false: 'Negative'
            }
          }
        }
      },
      detectMethod: {
        ___title: 'Test method/quality and analysis software versions',
        ___subTitle: 'Description of testing method',
        option: {
          title: {
            ___metrics: 'Upload Metrics'
          }
        },
        table: {
          title: {
            ___library_kit: 'Library preparation kit',
            ___sequencing_platform: 'Sequencing platform',
            ___sequencing_length: 'Sequencing length',
            ___average_sequencing_length: 'Sequencing throughput',
            ___pct_target_bases_xx: '10/20X coverage of target region',
            ___reference: 'Reference genome',
            ___alignment_version: 'Alignment software',
            ___variant_calling_version: 'Variant calling software',
            ___jannovar_version: 'Variant annotation software jANNOVAR',
            ___vep_version: 'Variant annotation software VEP',
            ___hpo_version: 'HPO version',
            ___omim_version: 'OMIM version',
            ___dbsnp_version: 'dbSNP version',
            ___clinvar_version: 'ClinVar version',
            ___mitomap_version: 'MITOMAP version',
            ___dbnsfp_version: 'dbNSFP version'
          }
        }
      },
      detectMethodComment: {
        ___subTitle: 'Terminologies',
        list: {
          list01: {
            ___title: 'The reference genome used for this examination is GRCh38 (or hg38)'
          },
          list02: {
            ___title: '<b>Genotype</b>',
            detail: {
              detail01: {
                ___title: 'Homozygous: A homozygous genotype may include two normal alleles or two alleles that have the same variant.'
              },
              detail02: {
                ___title: 'Heterozygous: A heterozygous genotype may include one normal allele and one mutated allele or two different mutated alleles (compound heterozygote).'
              },
              detail03: {
                ___title: 'Hemizygous: A term that describes a person who has only one copy of a gene rather than the usual two copies. Hemizygosity can occur under normal conditions. For example, because most males have one X chromosome and one Y chromosome, they are hemizygous for genes on those chromosomes.'
              }
            }
          },
          list03: {
            ___title: '<b>Clinical significance</b>: Refer to ClinVar database interpretation or ACMG (2015) classification.',
            detail: {
              detail01: {
                ___title: 'Pathogenic: The variant of a given gene is pathogenic.'
              },
              detail02: {
                ___title: 'Likely pathogenic: The variant of a given gene is likely to be pathogenic.'
              },
              detail03: {
                ___title: 'Uncertain significance: The variant of a given gene is uncertain significance'
              },
              detail04: {
                ___title: 'Likely benign: The variant of a given gene is likely to be benign.'
              },
              detail05: {
                ___title: 'Benign： The variant of a given gene is benign.'
              },
              detail06: {
                ___title: 'Conflicting interpretations of pathogenicity:Only for submissions from a consortium, where groups within the consortium have conflicting interpretations of a variant but provide a single submission to ClinVar.'
              },
              detail07: {
                ___title: 'Disease-associated polymorphism: It has been reported that polymorphism in a particular gene is associated with the disease.'
              },
              detail08: {
                ___title: 'SNP:The allele frequency of the variant is greater than 1% in 1000 Genomes, and no related diseases have been reported.'
              },
              detail09: {
                ___title: 'Drug response: A general term for a variant that affects a drug response, not a disease.'
              }
            }
          },
          list04: {
            ___title: '<b>Refereces</b>',
            detail: {
              detail01: {
                ___title: '1000 Genomes EAS: The allele frequency from the East Asian population of the 1000 Genomes project.'
              },
              detail02: {
                ___title: 'gnomAD EAS: The allele frequency from the East Asian population of the gnomAD project.'
              },
              detail03: {
                ___title: 'Taiwan BioBank: The allele frequency from Taiwan BioBank'
              },
              detail04: {
                ___title: 'References：If this variant has been reported in literature, the reference will list the first author, publication year, journal name, volume number, and starting page.'
              },
              detail05: {
                ___title: 'SIFT and PolyPhen-2 are two tools used to predict the clinical impact of amino acid variations. In SIFT, the prediction result is labeled as "damaging" or "tolerated", with the number in parentheses being the predicted result. In PolyPhen-2, the prediction result is labeled as "damaging", "possibly damaging", or "benign", with the number in parentheses being the predicted result. However, this prediction result lacks relevant evidence for protein or genomic research, and the accuracy of its predicted clinical significance cannot be confirmed, and is for reference only.'
              }
            }
          }
        }
      },
      attachmentIntractableDiseaseDetail: {
        ___title: 'D006_4 遺傳子リスト',
        table: {
          title: {
            ___disease: 'D006-4 遺伝学的検査の疾患名',
            ___gene: '代表的な疾患原因遺伝子<br>(指定難病の診断基準の遺伝子)'
          }
        }
      },
      attachmentDiagnosisGene: {
        ___title: 'Candidate Gene List',
        ___geneListTitle01: 'The coverage of genes ≥ {cov}',
        ___geneListTitle02: 'The coverage of genes < {cov}'
      },
      attachmentASoHGGene: {
        ___title: 'ACMG Guideline'
      }
    }
  }
});
// CONCATENATED MODULE: ./src/constants/lang/_report/ja/lang.js
/* harmony default export */ var _report_ja_lang = ({
  // report
  REPORT: {
    chapter: {
      ___appendix: '付録',
      title: {
        ___subject: '基本項目',
        ___subject_TPO: '報告書カバーページ（患者情報）',
        ___findings_TPO: '所見',
        ___intractable_disease: 'D006-4 指定難病の遺伝学的検査',
        ___disease_diagnosis: '解析結果',
        ___disease_diagnosis_TPO: '結果',
        ___active_screening: 'プロアクティブ・テスト',
        ___cause_screening: 'キャリア・スクリーニング',
        ___acmg_incidental: 'ACMG Incidental',
        ___custom1: 'custom1',
        ___custom2: 'custom2',
        ___custom3: 'custom3',
        ___constitution: '体質関連遺伝子',
        ___drug_meta: '薬理遺伝学',
        ___method: '検査方法',
        ___method_TPO: '検査方法、検査品質および解析ソフト',
        ___appendix_intractable_disease_list: 'D006_4 遺傳子リスト',
        ___appendix_disease_gene: '解析結果に含まれる遺伝子リスト',
        ___appendix_disease_gene_ID: '症状絞り込みのための遺伝子リスト',
        ___appendix_disease_gene_TPO: '遺伝子リスト',
        ___appendix_us_gene: 'ACMGガイドラインに含まれる遺伝子リスト'
      },
      item: {
        title: {
          ___resultSummary: '結果一覧',
          ___interpretation: '注釈'
        }
      },
      header: {
        ___info01: '報告日',
        ___info02: 'サンプルID',
        ___infoTPO01: 'Sample ID'
      },
      footer: {
        ___info01: '＊この研究用報告書は、医療専門家による解釈が必要です。',
        ___infoRuo01: '＊この報告は、専門の医療関係者向けの参考情報としてのみお使いください。',
        ___infoSaitama01: '＊この報告書は、遺伝専門医による解釈が必要です。',
        ___info02: '〒162-0056 東京都新宿区若松町 2-2 TWIns 先端生命医科学研究教育施設 3 階 N102 | COMPASS株式会社 | supportjp@compassbioinfo.com',
        ___infoSaitama02: '〒362-0806 埼玉県北足立郡伊奈町小室 780 | 埼玉県立がんセンター 遺伝科 | g.idenshi02@saitama-pho.jp'
      },
      basicInfo: {
        ___title: '検査結果報告書<br>基本項目',
        ___signTitle: '担当医師署名欄',
        ___signTitle_Saitama: '説明担当者署名',
        form: {
          title: {
            ___case_id: '患者氏名',
            ___case_id_ID: '匿名化番号',
            ___sex: '性別',
            ___age: '年齢',
            ___testing_date: '測定日',
            ___testing_date_ID: '検査日',
            ___testing_category: 'サンプル',
            ___sequencing_range: '検査方法',
            ___sequencing_tech: '使用機器',
            ___doctor_name: '医師',
            ___doctor_name_ID: '依賴医',
            ___doctor_name_Saitama: '依頼医師',
            ___organization: '施設名',
            ___organization_ID: '依頼機関名',
            ___medical_number: '症例ID',
            ___disclaimer_Saitama: '免責事項',
            ___family_medical_history: '備考'
          }
        }
      },
      basicInfoTPO: {
        ___title: '溶血性貧血関連遺伝子検査<br>報告書',
        ___signTitle: '署名',
        form: {
          title: {
            ___case_id: '匿名化番号',
            ___birthday: '生年月日',
            ___sex: '性別',
            ___testing_date: '検体受取日',
            ___report_date: '結果報告日',
            ___organization: '依頼機関名・診療科',
            ___doctor_name: '依頼医師名'
          },
          birthdayInfo: {
            ___years: '{count}歳',
            ___month: '{count}か月',
            ___day: '日齢{count}日'
          }
        },
        info: {
          ___content01: '遺伝子検査には一定の検出限界があることをご理解くださいまたSanger法でのre-sequenceは行っておりません',
          ___content02: '解析は臨床研究目的のもので、診療に供するものではありません',
          ___content03: '最終診断につきましては、臨床像、他の検査結果と併せて総合的に判断をお願い致します',
          ___content04: 'この結果を公表する時は、事前にご一報(info@anemia-support.org)頂けますと幸いです'
        }
      },
      findingsTPO: {
        ___title: '所見',
        ___placeholder: '結果に対するコメントを入力する',
        footer: {
          ___info01: 'NPO法人 血液難病診療サポート',
          ___info02: '(東京女子医科大学内)',
          ___info03: '菅野 仁',
          ___info04: '小倉 浩美'
        }
      },
      variantResult: {
        mainData: {
          ___saitamaEmpty: '報告対象となる遺伝子の変化は検出されませんでした。',
          default: {
            ___title: '注釈',
            ___contentTitle01_01: '疾患を引き起こす可能性のある変異を含む遺伝子が<b> {count} </b>個検出され、',
            ___contentTitle01_02: '疾患を引き起こす可能性のある変異を含む遺伝子が<b> {count} </b>個検出されました。',
            ___contentTitle02: 'そのうちミトコンドリアに存在する遺伝子は<b> {count} </b>個でした。',
            detail: {
              title: {
                ___ClinVar: 'ClinVarの臨床解釈は{result}です。',
                ___ClinVar_empty: 'ClinVarに情報がありません。',
                ___ACMG: 'ACMGの分類は{result}です。',
                ___OMIM: 'OMIMでは次のような関連疾患が見つかりました。',
                ___OMIM_empty: 'OMIMでは遺伝子関連疾患は見つかりませんでした。',
                ___Orphanet: 'Orphanetでは次のような関連疾患が見つかりました。',
                ___Orphanet_empty: 'Orphanetでは遺伝子関連疾患は見つかりませんでした。'
              }
            }
          },
          sv: {
            ___title: 'SV注釈',
            ___contentTitle01: '遺伝子検査により、原因となる可能性のある変異を持つ領域が計 <b>{count}</b> 個特定されました。',
            detail: {
              title: {
                ___genes: 'この領域内の影響を受ける遺伝子は{result}です。',
                ___OMIM: 'OMIMでは次のような関連疾患が見つかりました。',
                ___OMIM_empty: 'OMIMでは遺伝子関連疾患は見つかりませんでした。'
              }
            }
          }
        }
      },
      variantDetail: {
        ___symbolContainerTitle: '結果一覧',
        ___variantContainerTitle: '関連する疾患と表現型',
        ___phenotypeTableEmpty: 'データなし',
        ___variantNotePlaceholder: '備考',
        variantSubBlock: {
          title: {
            ___ClinVar: 'ClinVarデータベース',
            ___ACMG: 'ACMGガイドライン',
            ___SIFT_PolyPhen: 'SIFT / PolyPhen-2',
            ___SIFT: 'SIFT',
            ___PolyPhen: 'PolyPhen-2',
            ___CADD: 'CADD',
            ___AF_MT: 'Homoplasmy EAS AF / Heteroplasmy EAS AF',
            ___AF: 'TW Biobank / gnomAD EAS',
            ___AF_EN: 'GnomAD Exomes AF / GnomAD Genomes AF',
            ___AF_JP: 'GnomAD Genomes AF / ToMMo 60K JPN',
            ___Population_Databases: '集団データベース',
            ___Prediction_Score: 'タンパク質の機能予測',
            ___Sequencing_Quality: 'シーケンス品質'
          }
        },
        info: {
          title: {
            ___phenotypes: '表現型',
            ___gene_panels: '遺伝子パネル',
            ___related_genes: '遺伝子'
          }
        },
        portraitVariantTable: {
          title: {
            ___custom_details_pos: '位置<br>(HG38)',
            ___custom_details_Rank: 'エクソン/イントロン',
            ___custom_details_Rank_Saitama: 'エクソン ( イントロン ) 位置 / 全エクソン ( イントロン )',
            ___custom_details_HGVSm: 'HGVSm',
            ___custom_details_HGVSc: 'HGVSc',
            ___custom_details_HGVSp: 'HGVSp',
            ___custom_details_GT_AF: 'Heteroplasmy<br>Level (%)',
            ___custom_details_GT: '接合性',
            ___custom_details_Consequence: '変異タイプ',
            ___custom_details_Consequence_Saitama: 'バリアントタイプ',
            ___custom_details_dbSNP_ID: 'rs ID',
            ___custom_parental_origin: '親の起源',
            ___custom_parental_origin_Saitama: '遺伝伝達<br>（父 / 母）'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '表現型',
            ___id: 'OMIM番号',
            ___Inheritance: '遺伝形式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '表現型',
            ___id: 'ORPHA番号'
          }
        },
        dbTable: {
          title: {
            ___KG_AF: '1000 Genomes',
            ___KG_EAS_AF: '1000 Genomes EAS',
            ___gnomAD_AF: 'GnomAD Exomes',
            ___gnomAD_g_AF: 'GnomAD Genomes',
            ___gnomAD_g_AF_eas: 'GnomAD Genomes<br>EAS',
            ___TW_AF: 'TW Biobank',
            ___TOPMED_AF: 'TOPMED',
            ___UK10K_AF: 'UK10K',
            ___GA_AF: 'Genome Asia100',
            ___tommo_60kjpn_AF: 'ToMMo 60K JPN',
            ___gnomAD_g_mt_AF_het: 'GnomAD Genomes<br>Heteroplasmy',
            ___gnomAD_g_mt_pop_AF_het_eas: 'GnomAD Genomes<br>Heteroplasmy EAS',
            ___gnomAD_g_mt_AF_hom: 'GnomAD Genomes<br>Homoplasmy',
            ___gnomAD_g_mt_pop_AF_hom_eas: 'GnomAD Genomes<br>Homoplasmy EAS'
          }
        },
        psTable: {
          title: {
            ___SIFT4G: 'SIFT4G',
            ___FATHMM: 'FATHMM',
            ___PROVEAN: 'PROVEAN',
            ___MetaLR: 'MetaLR',
            ___MetaSVM: 'MetaSVM',
            ___BayesDel_noAF: 'BayesDel noAF',
            ___gnomAD_g_mt_mitotip: 'MitoTip',
            ___ada: 'ada',
            ___rf: 'rf',
            ___GERPpp_RS: 'GERP++RS',
            ___SiPhy_29way_logOdds: 'SiPhy 29way logOdds'
          }
        }
      },
      variantDetailTPO: {
        ___title: '結果',
        ___chapterMainInfo: 'A.疾患を引き起こす可能性を含む遺伝子変化が<b>{count}</b>個検出されました | A.疾患を引き起こす可能性を含む遺伝子変化が<b>{count}</b>個検出されました（A-1～A-{count}）',
        ___variantContainerNumber: 'A-{count}.',
        ___variantContainerTitle: '[関連する疾患と表現型]',
        ___variantContainerContent: '<b>{symbol}</b> 遺伝子変異によって引き起こされる関連疾患には以下のものがあります',
        ___phenotypeTableEmpty: 'データなし',
        variantSubBlock: {
          title: {
            ___ClinVar: 'ClinVar Database',
            ___ACMG: 'ACMG/AMP 2015 Guideline',
            ___SIFT: 'SIFT',
            ___PolyPhen: 'PolyPhen-2',
            ___CADD: 'CADD',
            ___AF_MT1: 'Homoplasmy EAS AF',
            ___AF_MT2: 'Heteroplasmy EAS AF',
            ___AF_JP1: 'ToMMo 60K JPN',
            ___AF_JP2: 'gnomAD EAS'
          }
        },
        portraitVariantTable: {
          title: {
            ___custom_gene: 'Gene',
            ___custom_details_pos: 'Position',
            ___custom_details_Rank: 'エクソン/イントロン',
            ___custom_details_HGVSc: 'HGVSc',
            ___custom_details_HGVSp: 'HGVSp',
            ___custom_details_GT: '接合型',
            ___custom_details_OMIM: 'OMIM',
            ___custom_details_Consequence: 'Function',
            ___custom_details_dbSNP_ID: 'rs ID'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '表現型',
            ___id: 'OMIM番号',
            ___Inheritance: '遺伝形式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '表現型',
            ___id: 'ORPHA番号'
          }
        }
      },
      variantSV: {
        ___mainTableTitle: 'SV 結果一覧',
        ___symbolContainerTitle: '関連遺伝子',
        ___geneContainerTitle: '関連する疾患と表現型',
        ___phenotypeTableEmpty: 'データなし',
        ___svNotePlaceholder: '備考',
        svTable: {
          title: {
            ___Position: '位置',
            ___Exon_Intron: 'エクソン/イントロン',
            ___Zygosity: '接合性',
            ___Consequence: '変異タイプ',
            ___Fragment_size: 'フラグメントサイズ',
            ___Parental_Origin: '親の起源'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '表現型',
            ___id: 'OMIM番号',
            ___Inheritance: '遺伝形式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '表現型',
            ___id: 'ORPHA番号'
          }
        }
      },
      variantCNV: {
        ___mainTableTitle: 'SV 結果一覧',
        ___symbolContainerTitle: '関連遺伝子',
        ___geneContainerTitle: '関連する疾患と表現型',
        ___phenotypeTableEmpty: 'データなし',
        ___cnvNotePlaceholder: '備考',
        cnvTable: {
          title: {
            ___Position: '位置',
            ___Exon_Intron: 'エクソン/イントロン',
            ___Zygosity: '接合性',
            ___Consequence: '変異タイプ',
            ___Fragment_size: 'フラグメントサイズ',
            ___Parental_Origin: '親の起源'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '表現型',
            ___id: 'OMIM番号',
            ___Inheritance: '遺伝形式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '表現型',
            ___id: 'ORPHA番号'
          }
        }
      },
      variantSVTPO: {
        ___title: '結果',
        ___chapterMainInfo: 'B.疾患を引き起こす可能性を含むCNVの領域が<b>{count}</b>個検出されました | B.疾患を引き起こす可能性を含むCNVの領域が<b>{count}</b>個検出されました（1.～{count}.）',
        ___geneContainerNumber: 'B-{count}.',
        ___geneContainerTitle: '関連する疾患と表現型',
        ___geneContainerContent: '<b>{symbol}</b>遺伝子変異によって引き起こされる関連疾患には以下のものがあります',
        ___phenotypeTableEmpty: 'データなし',
        svTable: {
          title: {
            ___Position: 'Position',
            ___Exon_Intron: 'エクソン/イントロン',
            ___Zygosity: '接合性',
            ___Consequence: '変異タイプ',
            ___Fragment_size: 'フラグメントサイズ',
            ___Parental_Origin: '親の起源'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '表現型',
            ___id: 'OMIM番号',
            ___Inheritance: '遺伝形式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '表現型',
            ___id: 'ORPHA番号'
          }
        }
      },
      variantCNVTPO: {
        ___title: '結果',
        ___chapterMainInfo: 'B.疾患を引き起こす可能性を含むCNVの領域が<b>{count}</b>個検出されました | B.疾患を引き起こす可能性を含むCNVの領域が<b>{count}</b>個検出されました（1.～{count}.）',
        ___geneContainerNumber: 'B-{count}.',
        ___geneContainerTitle: '関連する疾患と表現型',
        ___geneContainerContent: '<b>{symbol}</b>遺伝子変異によって引き起こされる関連疾患には以下のものがあります',
        ___phenotypeTableEmpty: 'データなし',
        cnvTable: {
          title: {
            ___Position: 'Position',
            ___Exon_Intron: 'エクソン/イントロン',
            ___Zygosity: '接合性',
            ___Consequence: '変異タイプ',
            ___Fragment_size: 'フラグメントサイズ',
            ___Parental_Origin: '親の起源'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '表現型',
            ___id: 'OMIM番号',
            ___Inheritance: '遺伝形式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '表現型',
            ___id: 'ORPHA番号'
          }
        }
      },
      intractableDiseaseResult: {
        ___title: 'D006-4 指定難病の遺伝学的検査',
        diseaseList: {
          ___title: '指定難病'
        },
        diseaseRange: {
          ___title: '遺伝子の範囲',
          content: {
            ___list: '<b>{name}</b>に関連する遺伝子を対象として、{count}個の遺伝子に対する関連性解析をすでに実施しております。',
            ___suffix: '詳細は別添の「D006-4 遺伝子リスト」をご参照ください。'
          }
        }
      },
      constitutionGene: {
        ___title: '体質関連遺伝子',
        ___subTitle: '多くの遺伝子がアレルギー、血栓、アルコール不耐症に関連していることが明らかになっています。この重要な情報は、生活における予防策を提供します。',
        ___subTitleSaitama: '<b>検出基準：</b><br>シーケンスの深度DP≧10、クオリティGQ≧20<br><b>遺伝子型判定：</b><br>アリル頻度が≧0.9の場合、ホモ接合<br>アリル頻度が0.25〜0.75の場合、ヘテロ接合と判定されます。<br>上記以外の場合(<0.25または0.75〜0.9)には品質フィルタの基準を満たさないため「未検出(0/0)」として判定 されます。',
        mainData: {
          testSummary: {
            ___title: '検査結果の説明'
          }
        },
        mainTable: {
          testingItems: {
            ___title: '各種検査項目'
          }
        },
        table: {
          title: {
            ___title: '検査項目',
            ___SYMBOL: '遺伝子',
            ___Location2: '位置',
            ___Result: '結果'
          },
          value: {
            Result: {
              ___true: '検出',
              ___false: '未検出'
            }
          }
        }
      },
      drugAnalysis: {
        ___title: '薬理遺伝学',
        ___subTitle: '薬理遺伝学は、重篤な副作用や毒性を防ぎ、最適な治療反応を達成するために、個人に最適な薬剤を選択するための参考情報を提供します。同じ薬でも、個人によっては重篤なアレルギーや副作用の増強が発生する可能性があり、それは、不適切な薬や用量を使用したことが原因であると考えられます。',
        ___subTitleSaitama: '<b>検出基準：</b><br>シーケンスの深度DP≧10、クオリティGQ≧20<br><b>遺伝子型判定：</b><br>アリル頻度が≧0.9の場合、ホモ接合<br>アリル頻度が0.25〜0.75の場合、ヘテロ接合と判定されます。<br>上記以外の場合(<0.25または0.75〜0.9)には品質フィルタの基準を満たさないため「未検出(0/0)」として判定 されます。',
        customInfos: {
          ___info01: '＊ 赤で示された遺伝子型は、検出されたリスク遺伝子型を示しています。'
        },
        mainData: {
          testSummary: {
            ___title: '検査結果の説明'
          }
        },
        mainTable: {
          testingItems: {
            ___title: '各種検査項目'
          }
        },
        table: {
          title: {
            ___name: '薬剤名',
            ___type: '効果',
            ___SYMBOL: '遺伝子',
            ___risk_genotype2: '位置',
            ___clinical_phenotype: '説明',
            ___Result: '結果'
          },
          value: {
            Result: {
              ___true: '検出',
              ___false: '未検出'
            }
          }
        }
      },
      detectMethod: {
        ___title: '検査およびシーケンス品質に関する情報',
        ___subTitle: '検査方法の説明',
        table: {
          title: {
            ___library_kit: 'ライブラリー作成キット',
            ___sequencing_platform: 'シーケンス・プラットフォーム',
            ___sequencing_length: 'リード長',
            ___average_sequencing_length: 'リード深度',
            ___pct_target_bases_xx: '標的領域の10/20Xカバレッジ',
            ___reference: 'リファレンスゲノム',
            ___alignment_version: 'アライメントソフトウェア',
            ___variant_calling_version: 'バリアントコーリングソフトウェア',
            ___jannovar_version: 'バリアントアノテーションソフトウェアjANNOVAR',
            ___vep_version: 'バリアントアノテーションソフトウェア VEP',
            ___hpo_version: 'HPOバージョン',
            ___omim_version: 'OMIMバージョン',
            ___dbsnp_version: 'dbSNPバージョン',
            ___clinvar_version: 'ClinVarバージョン',
            ___mitomap_version: 'MITOMAPバージョン',
            ___dbnsfp_version: 'dbNSFPバージョン',
            ___gene_panel_version_TPO: '遺伝子パネル',
            ___report_version_TPO: 'Report version'
          }
        }
      },
      detectMethodTPO: {
        ___title: '検査方法、検査品質および解析ソフト',
        ___subTitle: '検査方法の説明',
        table: {
          title: {
            ___library_kit: 'Library kit',
            ___sequencing_platform: 'Sequence platform',
            ___sequencing_length: 'Read length',
            ___average_sequencing_length: 'Read depth',
            ___pct_target_bases_xx: '20×Coverage of target region',
            ___reference: 'Reference genome',
            ___alignment_version: 'Alignment software',
            ___variant_calling_version: 'Variant calling software',
            ___jannovar_version: 'Variant annotation software<br>(jANNOVAR)',
            ___vep_version: 'Variant annotation software<br>(Variant Effect Predictor)',
            ___hpo_version: 'HPO version',
            ___omim_version: 'OMIM version',
            ___dbsnp_version: 'dbSNP version',
            ___clinvar_version: 'ClinVar version',
            ___dbnsfp_version: 'dbNSFP version'
          }
        }
      },
      detectMethodComment: {
        ___subTitle: '検査用語などの注釈',
        list: {
          list01: {
            ___title: 'この検査に使用された参照ゲノムはGRCh38（またはhg38）です。'
          },
          list02: {
            ___title: '<b>遺伝子型</b>',
            detail: {
              detail01: {
                ___title: 'ホモ接合性：ホモ接合性の遺伝子型には、2個の正常な対立遺伝子、または同じ変異を持つ2個の対立遺伝子が含まれる場合があります。'
              },
              detail02: {
                ___title: 'ヘテロ接合性：ヘテロ接合性の遺伝子型には、1個の正常対立遺伝子と1個の変異対立遺伝子、または2個の異なる変異対立遺伝子(複合ヘテロ接合)が含まれる場合があります。'
              },
              detail03: {
                ___title: 'ヘミ接合性：ある遺伝子を通常2コピー持つところを1コピーしか持たない人を表す用語です。ヘミ接合性はは正常な状態でも起こり得ます。例えば、ほとんどの男性はX染色体とY染色体を1本ずつ持っているため、これらの染色体上の遺伝子はヘミ接合性です。'
              }
            }
          },
          list03: {
            ___title: '<b>臨床的意義</b>：ClinVar データベースの解釈または ACMG (2015) 分類を参照してください。',
            detail: {
              detail01: {
                ___title: '病原性：ある遺伝子の変異が病原性です。'
              },
              detail02: {
                ___title: '病原性の可能性が高い：ある遺伝子の変異は病原性です可能性が高いです。'
              },
              detail03: {
                ___title: '重要性が不明：ある遺伝子の変異は重要性が不明です。'
              },
              detail04: {
                ___title: '良性です可能性が高い：ある遺伝子の変異は良性です可能性が高いです。'
              },
              detail05: {
                ___title: '良性：ある遺伝子の変異は良性です。'
              },
              detail06: {
                ___title: '病原性の解釈の対立：コンソーシアムからの提出に限り、コンソーシアム内のグループが変異について相反する解釈を持ちながら、ClinVarに単一の提出を行う場合です。'
              },
              detail07: {
                ___title: '疾患関連多型：特定の遺伝子の多型が疾患と関連していることが報告されています。'
              },
              detail08: {
                ___title: 'SNP：バリアントのアレル頻度は1000ゲノムで1％以上であり、関連する疾患は報告されていません。'
              },
              detail09: {
                ___title: '薬物反応：疾患ではなく、薬物反応に影響を及ぼすバリアントの総称です。'
              }
            }
          },
          list04: {
            ___title: '<b>参考資料</b>',
            detail: {
              detail01: {
                ___title: '1000 Genomes EAS：1000 Genomesプロジェクトの東アジア集団のアレル頻度です。'
              },
              detail02: {
                ___title: 'gnomAD EAS：gnomADプロジェクトの東アジア集団のアレル頻度です。'
              },
              detail03: {
                ___title: 'ToMMo 60k：東北メディカル・メガバンク機構（ToMMo）のアレル頻度です。'
              },
              detail04: {
                ___title: '参考文献：このバリアントが文献で報告されている場合、参考文献には筆頭著者、出版年、雑誌名、巻数、開始ページが記載されます。'
              },
              detail05: {
                ___title: 'SIFTとPolyPhen-2は、アミノ酸変異の臨床的影響を予測するために使用される2つのツールです。SIFTでは、予測結果は 「有害」または「許容」と表記され、括弧内の数字は予測結果です。PolyPhen-2では、予測結果は「有害」、「有害の可能性あり」、「良性」と表記され、括弧内の数字は予測結果です。ただし、この予測結果はタンパク質やゲノム研究に関連するエビデンスを欠いており、予測された臨床的意義の正確性は確認できないため、あくまで参考までにご覧ください。'
              }
            }
          }
        }
      },
      detectMethodCommentTPO: {
        ___subTitle: '注釈',
        list: {
          list01: {
            ___title: '[検査の限界]<br>この検査も同様ですが、WESは単一の塩基の変異に対して高い感度を示しますが、小さな挿入‧欠失に対する感度は低く、Exon- Intron junctionから離れた変異、プロモーター領域の変異[TA1] [KY2] [KY3] 、大規模なExonの欠失や重複、およびその他の構造変異 [TA4] は検出が困難です'
          },
          list02: {
            ___title: '[臨床的意義の判定]ClinvardatabaseまたはACMG(2015)分類が判定基準',
            detail: {
              detail01: {
                ___title: 'Pathogenic: 変異は病原性がある'
              },
              detail02: {
                ___title: 'Likely pathogenic: 変異は病原性の可能性が高い'
              },
              detail03: {
                ___title: 'Uncertain significance: 変異の病原性は不明'
              },
              detail04: {
                ___title: 'Likely benign: 変異は良性の可能性が高い'
              },
              detail05: {
                ___title: 'Benign: 変異は良性である'
              }
            }
          },
          list03: {
            ___title: 'SIFTとPolyphen-2は変異がタンパク質に与える影響を予測するためのツールです。あくまでも予測ですので臨床的意義の正確性を保 証していません',
            detail: {
              detail01: {
                ___title: 'SIFTは<有害>D: Deleteriousまたは<許容>T: Tolerated'
              },
              detail02: {
                ___title: 'Polyphen-2は<有害>D: Probably damagingまたは<有害の可能性あり>P:Possibly damagingまたは<良性>B:Benignと表記され、 カッコ内の数字は予測結果です'
              }
            }
          },
          list04: {
            ___title: '[用語]',
            detail: {
              detail01: {
                ___title: '1000Genome EAS:1000Genomeプロジェクトの東アジア集団のアレル頻度'
              },
              detail02: {
                ___title: 'genomAD EAS: genomADプロジェクトの東アジア集団のアレル頻度'
              },
              detail03: {
                ___title: 'ToMMo 60K JPN: ToMMo 60K JPNのアレル頻度'
              }
            }
          }
        }
      },
      attachmentIntractableDiseaseDetail: {
        ___title: 'D006_4 遺傳子リスト',
        table: {
          title: {
            ___disease: 'D006-4 遺伝学的検査の疾患名',
            ___gene: '代表的な疾患原因遺伝子<br>(指定難病の診断基準の遺伝子)'
          }
        }
      },
      attachmentDiagnosisGene: {
        ___title: '解析結果に含まれる遺伝子リスト',
        ___title_ID: '症状絞り込みのための遺伝子リスト',
        ___geneListTitle01: '遺伝子のカバレッジ ≥ {cov}',
        ___geneListTitle02: '遺伝子のカバレッジ < {cov}'
      },
      attachmentDiagnosisGeneTPO: {
        ___title: '遺伝子リスト',
        ___info: '*HBA1は配列の特性から検出が困難な場合があります。',
        ___geneListTitle01: '遺伝子のCoverage ≥ {cov}',
        ___geneListTitle02: '遺伝子のCoverage < {cov}',
        footer: {
          ___info01: '[本検査の問い合わせ先]',
          ___info02: 'NPO法人血液難病診療サポート',
          ___info03: '（東京女子医科大学内）'
        }
      },
      attachmentASoHGGene: {
        ___title: 'ACMGガイドラインに含まれる遺伝子リスト'
      }
    }
  }
});
// CONCATENATED MODULE: ./src/constants/lang/en/lang.js
/* harmony default export */ var lang_en_lang = ({
  // layout
  LAYOUT: {
    header: {
      routes: {
        title: {
          ___caseList: 'Case List',
          ___phenoVarDBPopulationFrequencies: 'PhenoVarDB<br>Population Frequencies'
        },
        info: {
          ___userManual: 'User Manual',
          ___logOut: 'Log out'
        }
      },
      menu: {
        title: {
          ___userSetting: 'User setting'
        }
      }
    },
    footer: {},
    pageFooter: {
      ___compassBioinformatics: 'Compass Bioinformatics Inc.',
      ___cookie_policy: 'Cookie policy',
      ___privacy_policy: 'Privacy policy',
      ___alert: 'For Research Only'
    },
    uploading: {
      ___title: 'Uploading'
    }
  },
  // mixin
  MIXIN: {
    routeLoading: {
      ___noPermission: 'No permission'
    }
  },
  // page
  PAGE: {
    main: {
      ___forgetPassword: 'Forget Password？',
      ___or: 'OR',
      form: {
        title: {
          ___email: 'Account (E-mail)',
          ___password: 'Password'
        }
      }
    },
    forget: {
      ___info01: 'Please Enter the account (e-mail) which has been registered.',
      ___info02: 'We will send Reset Password letter to your email.',
      form: {
        title: {
          ___email: 'Account (E-mail)'
        },
        placeholder: {
          ___email: 'wiseTony@compassbioinfo.com'
        }
      }
    },
    reset: {
      ___info01: 'Here is reset password page,',
      ___info02: 'Please reset the password for account:',
      form: {
        title: {
          ___newPassword: 'New Password',
          ___confirmed: 'Confirm New Password'
        },
        errorTitle: {
          ___newPassword: 'Password',
          ___confirmed: 'Password'
        },
        placeholder: {
          ___newPassword: 'Please enter 14-100 characters',
          ___confirmed: 'Please enter your password again'
        },
        customValidate: {
          ___confirmed: 'Password confirmation is incorrect.'
        }
      }
    },
    active: {
      ___info01: 'Dear Manager, there is a new user sign up.',
      ___info02: 'Please review the user information and activate the account.',
      form: {
        title: {
          ___email: 'Account (E-mail)',
          ___firstName: 'First Name',
          ___lastName: 'Last Name',
          ___country: 'Country',
          ___organization: 'Service Unit',
          ___appliedDate: 'Apply Date'
        }
      }
    },
    deviceAlert: {
      ___info01: 'It is recommended to log in with a computer or laptop,',
      ___info02: 'or may affect your operating experience.'
    },
    datasetAccess: {
      form: {
        title: {
          ___accessKey: 'Access Key'
        },
        placeholder: {
          ___accessKey: 'Please enter 16 digitals access key'
        }
      }
    },
    genePanel: {
      ___title: 'Gene Panel Search',
      geneTag: {
        ___placeholder: 'Type disease or gene panel'
      },
      introduction: {
        collapse: {
          ___content01: 'If you don\'t know how to begin, here are…'
        },
        display: {
          ___content01: 'If you don\'t know how to begin, here are',
          ___content02: 'some phenotypes for hereditary diseases:',
          ___content03: 'e. g. Marfan syndrome、Leber hereditary optic neuropathy、Fabry disease、Epilepsy、Noonan and RASopathies…'
        }
      }
    },
    phenotypeDisease: {
      ___title01: 'Similarity between',
      ___title02: 'Phenotypes and Diseases',
      ___alert01: 'The results are only for reference,',
      ___alert02: 'not for diagnosis.',
      ___selectedTitle: 'Selected',
      ___selectedRemind: 'you can discard a phenotype with unselect the checkbox.',
      ___resultPhenotypeTitle: 'Imported Phenotypes',
      ___resultTableTitle: 'Results',
      phenotypeTag: {
        ___placeholder: 'Type phenotypes'
      },
      introduction: {
        collapse: {
          ___content01: 'If you don\'t know how to begin, here are…'
        },
        display: {
          ___content01: 'If you don\'t know how to begin, here are',
          ___content02: 'some phenotypes for hereditary diseases:',
          ___content03: 'e. g. Global developmental delay、Short stature、 Hypotonia、 Nystagmus、Hearing impairment、Intellectual disability、Microcephaly…',
          ___content04: 'But <span class="alert">do NOT</span> over 10 terms.',
          ___content05: 'You can also find suitable phenotype terms on <a href="https://hpo.jax.org/app/" target="_blank">HPO website</a>.'
        }
      },
      table: {
        title: {
          ___index: 'Rk',
          ___omimID: 'OMIM ID',
          ___name: 'Disease Name'
        }
      },
      uploading: {
        ___pleaseWait: 'Please do not leave the page and wait for a moment'
      }
    },
    coverageRate: {
      ___title: 'Coverage Rate Search Tool',
      ___searchPlaceholder: 'RefSeq id (eg: NM_000059.4) or gene symbol (eg: BRCA1)',
      table: {
        title: {
          ___refseqID: 'RefSeq id',
          ___symbol: 'Symbol',
          ___region: 'Region',
          ___libraryKit: 'Library kit',
          ___10XPctMeanCov: '10X pct mean cov',
          ___20XPctMeanCov: '20X pct mean cov'
        }
      }
    },
    register: {
      ___info01: 'Welcome to inheriNext, an AI Genetic Variants Screening System.',
      ___info02: 'please fill in the information and agree to the user terms to register,',
      ___info03: 'A specialist will activate the account for you, please be patient.',
      ___agreementCheckTitle: 'I have carefully read and fully agree to the Terms and <a class="link" href="{link}" target="_blank">Privacy Policy</a>.',
      ___agreementDownloadPDFTitle: 'Download Terms of Use (Traditional Chinese)',
      ___agreementContent: '<span style="font-size:1.5rem; font-weight:500;">Welcome to InheriNext\xAE Edge</span>\nWelcome to the InheriNext\xAE Edge platform developed by Compass Bioinformatics Inc. Your use of InheriNext\xAE Edge infers your agreement with our Terms and Conditions. If you have any problems or concerns with the Terms and Conditions as described below, please stop using InheriNext\xAE Edge.\n\n<span style="font-size:1rem; font-weight:500;">The Application of InheriNext\xAE Edge</span>\nInheriNext\xAE Edge provides the analysis of genetic data for scientific users. InheriNext\xAE Edge does not contain any diagnostic or medical advice. InheriNext\xAE Edge has no other application except as described above.\n\n<span style="font-size:1rem; font-weight:500;">The Data Ownership Statement</span>\nThe ownership of all data uploaded into InheriNext\xAE Edge is fully retained by the user. Compass Bioinformatics Inc only uses the uploaded data to deliver a report. Compass Bioinformatics Inc. uses summarized (aggregated) data from these reports to improve the accuracy of its methods. Data is never sold or transferred to a third party.\n\n<span style="font-size:1rem; font-weight:500;">Personal Information Protection</span>\nThe data uploaded into InheriNext\xAE Edge is stored securely and is protected consistent with our privacy policy. Registered users will be notified by email of system updates, maintenance, new versions. Users can unsubscribe from release notifications via the email\'s unsubscribe button. Personal information is not shared with or sold to third parties.\n\n<span style="font-size:1rem; font-weight:500;">Suspend and Stop the Service</span>\nYou agree that Compass Bioinformatics Inc. has the right to suspend or stop the overall or partial functions of InheriNext\xAE Edge for any reason. Refunds will only be processed for the incomplete service. Compass Bioinformatics Inc assumes no additional service responsibilities.\n\n<span style="font-size:1rem; font-weight:500;">Warranty and Disclaimer</span>\nYou agree that the knowledge bases used by InheriNext\xAE Edge are scientifically plausible, but that they may not be 100% accurate or complete. You agree to apply independent thought when reading the results from InheriNext\xAE Edge\'s analyses, and that any insights so derived are entirely from yourself.\n\n<span style="font-size:1rem; font-weight:500;">Optimization</span>\nYou agree that InheriNext\xAE Edge may be optimized through your usage, but that you are not entitled to any ownership of InheriNext\xAE Edge, partial or otherwise.\n\n<span style="font-size:1rem; font-weight:500;">Local Laws Application</span>\nYou confirm that you will abide by the Terms and Conditions of InheriNext\xAE Edge, and that you are also in compliance with your local laws.',
      form: {
        title: {
          ___email: 'Account (E-mail)',
          ___verification: 'Verification',
          ___firstName: 'First Name',
          ___lastName: 'Last Name',
          ___country: 'Country',
          ___countryCode: 'Phone',
          ___organization: 'Organization',
          ___division: 'Division or subunit',
          ___managerID: 'Manager Code',
          ___password: 'New Password',
          ___confirmed: 'Confirm New Password'
        },
        placeholder: {
          ___email: 'wiseTony@compassbioinfo.com',
          ___verification: '6 digits code',
          ___firstName: 'John',
          ___lastName: 'William',
          ___country: 'Taiwan',
          ___countryCode: '+886',
          ___phone: 'Your phone number',
          ___organization: 'Compass Bioinfomatics Inc.',
          ___division: 'Clinical research department',
          ___managerID: '3 digits code',
          ___password: 'Please enter 14-100 characters',
          ___confirmed: 'Please enter your password again'
        },
        errorTitle: {
          ___email: 'account (E-mail)',
          ___password: 'Password',
          ___confirmed: 'Password'
        },
        customValidate: {
          ___country: 'The country name format is wrong. Please check it.',
          ___countryCode: 'The country code doesn\'t exist',
          ___confirmed: 'Password confirmation is incorrect.',
          ___verificationCode: 'Verification code is wrong.'
        }
      }
    },
    user: {
      ___avatarTitle: 'Avatar',
      tab: {
        ___info: 'Basic information',
        ___password: 'Password setting',
        ___license: 'License manager'
      },
      form: {
        title: {
          ___email: 'Account (E-mail)',
          ___firstName: 'First Name',
          ___lastName: 'Last Name',
          ___country: 'Country ',
          ___countryCode: 'Phone',
          ___manager: 'Supported manager',
          ___organization: 'Organization',
          ___division: 'Division or subunit',
          ___emailVerification: 'E-mail verification',
          ___originalPassword: 'Old Password',
          ___password: 'New Password',
          ___confirmed: 'Confirm New Password'
        },
        placeholder: {
          ___firstName: 'John',
          ___lastName: 'William',
          ___country: 'Taiwan',
          ___countryCode: '+886',
          ___phone: 'Your phone number',
          ___organization: 'Compass Bioinfomatics Inc.',
          ___division: 'Clinical research department',
          ___originalPassword: 'Please enter 14-100 characters',
          ___password: 'Please enter 14-100 characters',
          ___confirmed: 'Please enter your password again'
        },
        errorTitle: {
          ___originalPassword: 'Password',
          ___password: 'Password',
          ___confirmed: 'Password'
        },
        customValidate: {
          ___country: 'The country name format is wrong. Please check it.',
          ___countryCode: 'The country code doesn\'t exist',
          ___confirmed: 'Password confirmation is incorrect.',
          ___verificationCode: 'Verification code is wrong.'
        }
      }
    },
    systemInfo: {
      tab: {
        ___database: 'Version info.'
      },
      group: {
        ___version: 'version',
        ___result: '{count} components inside',
        title: {
          ___pipeline: 'Pipeline Version',
          ___analysis: 'Annotation Version'
        }
      },
      table: {
        title: {
          ___category: 'Category',
          ___title: 'Name',
          ___version: 'Version'
        }
      }
    },
    panel: {
      tab: {
        ___phenotype: 'Phenotype set',
        ___gene: 'Gene Panel'
      }
    },
    config: {
      tab: {
        ___filter: 'Config filter'
      }
    },
    workgroup: {
      tab: {
        ___case: 'Case'
      }
    },
    genomeBrowser: {
      table: {
        title: {
          ___position: 'Position (HG38)',
          ___location: 'Exon/Intron location',
          ___HGVSc: 'HGVSc',
          ___HGVSp: 'HGVSp'
        }
      }
    },
    caseBatchUpload: {
      form: {
        title: {
          ___owner: 'Owner'
        }
      },
      alert: {
        ___content: 'If no edits are made <b>within 5 days</b>, all records for this batch upload,<br>including the VCF and sample sheet file, will be deleted automatically.',
        ___date: '<b>Created at:</b> {create} | <b>Modified at:</b> {update}'
      }
    },
    caseDetail: {
      title: {
        ___deleted: 'DEL'
      },
      project: {
        title: {
          alert: {
            ___sexDifferent: 'The sex info of the analysis is different from the case. You can re-analysis by editing the parameters of the analysis.'
          }
        },
        card: {
          title: {
            ___modified: 'Modified'
          }
        },
        info: {
          title: {
            ___status: 'Status',
            ___created: 'Created',
            ___modified: 'Modified'
          }
        },
        icon: {
          title: {
            ___delete: 'Delete'
          }
        },
        detail: {
          intractablePanel: {
            ___title: 'D006-4 遺伝学的検査疾患名',
            ___less: 'less',
            ___more: '{count} items more'
          },
          phenotype: {
            ___title: 'Phenotype',
            ___less: 'less',
            ___more: '{count} items more'
          },
          genePanel: {
            ___title: 'Gene / Disease panel',
            ___infoTitle: 'Mendelian',
            ___info: 'If the switch is turned on, the selected loci conform to Mendelian inheritance. The reasons for filtering loci that don\'t fit Mendelian inheritance are: 1.The technical limitations of NGS may cause the misjudgment of inheritance pattern. 2.Some specific diseases cause symptoms even the loci don\'t fit Mendelian inheritance.',
            ___less: 'less',
            ___more: '{count} items more'
          },
          mendelian: {
            ___title: 'Mendelian'
          },
          afThreshold: {
            ___title: 'AF threshold for MOI',
            ___info: 'The allele frequency threshold depends on the prevalence of diseases and should be adjusted accordingly. The value should be > 0 and ≤ 1. If you want to edit the values of threshold, Click edit button nearby phenotype.',
            item: {
              title: {
                ___ad: 'AD',
                ___compHet: 'Comp. het.',
                ___ar: 'AR',
                ___exclLQ: 'Excl. LQ'
              }
            }
          },
          phenotypeVariant: {
            ___title: 'Phenotype & Variant score thresholds',
            ___info: 'Phenotype scores were calculated using semantic similarity based on phenotypes user provided. Variant scores were calculated by multiple prediction scores (e.g SIFT, CADD) and population allele frequencies. If you want to edit the values of threshold, click the edit button nearby phenotype.',
            item: {
              title: {
                ___phenotypeScore: 'Phenotype score',
                ___variantScore: 'Variant score'
              }
            }
          }
        }
      },
      top: {
        icon: {
          title: {
            ___digitalMLPA: 'digitalMLPA',
            ___file: 'Files',
            ___analysisVersion: 'Analysis Version',
            ___qc: 'Quality Control',
            ___delete: 'Delete'
          }
        }
      },
      caseInfo: {
        title: {
          ___owner: 'Owner',
          ___subjectName: 'Name',
          ___sex: 'Sex',
          ___birthYear: 'Year of birth',
          ___population: 'Population',
          ___note: 'Note',
          ___workgroup_name: 'Workgroup',
          ___workgroup_stage: '- Stage',
          ___workgroup_due_date: '- Due date',
          ___workgroup_assignee: '- Assignee'
        },
        empty: {
          ___birthYear: 'Unknown'
        }
      },
      tab: {
        data: {
          ___defaultTitle: 'default',
          examinationIntractableDisease: {
            ___title: '保険検査と指定難病',
            subTab: {
              intractableDiseaseResults: {
                ___title: 'D006-4の結果'
              },
              designatedIntractableDiseaseResults: {
                ___title: '指定難病の結果'
              }
            }
          },
          diagnosticTest: {
            ___title: 'Candidate list',
            subTab: {
              phenotypeResults: {
                ___title: 'Phenotype results'
              },
              genePanelResults: {
                ___title: 'Gene Panel results'
              },
              repeatResults: {
                ___title: 'repeat results'
              }
            }
          },
          proactiveTest: {
            ___title: 'Proactive test',
            subTab: {
              pathogenicVariants: {
                ___title: 'Pathogenic Variants'
              },
              nullVariants: {
                ___title: 'Null Variants'
              },
              carrier: {
                ___title: 'Carrier'
              },
              incidentalFindings: {
                ___title: 'Incidental findings'
              }
            }
          },
          filter: {
            ___title: 'Filter'
          },
          monitor: {
            ___title: 'Monitor'
          },
          report: {
            ___title: 'Report'
          }
        },
        info: {
          ___limit: 'The records have reached the limit of 200. Please be aware that some of the data is not available.'
        }
      },
      displayView: {
        title: {
          ___SNV: 'SNV',
          ___SV: 'SV',
          ___STR: 'STR'
        }
      },
      edit: {
        ___info: 'You can edit the case and analysis information before you finish to upload NGS data (FASTQ, uBAM or VCF).'
      },
      modal: {
        content: {
          ___delete: 'Once you delete this case, the case\'s results will be removed from InheriNext. Do you want to delete this case?',
          ___user: 'This case has been used for the dataset build of {dataset} in the PhenoVarDB. Please delete the dataset mentioned above before you delete the case. | This case has been used for the datasets build of {dataset} in the PhenoVarDB. Please delete the datasets mentioned above before you delete the case.',
          ___admin: 'This case has been used for the dataset build of {dataset} in the PhenoVarDB. The accessibility of datasets shown above will be affected upon you delete this sample. Do you want to delete this case? | This case has been used for the datasets build of {dataset} in the PhenoVarDB. The accessibility of datasets shown above will be affected upon you delete this sample. Do you want to delete this case?',
          ___truelyDelete: 'All the files and information of this case will be PERMANENTLY removed. Do you want to continue?',
          ___truelyAdmin: 'This case has been used for the dataset build of {dataset} in the PhenoVarDB. The accessibility of datasets shown above will be affected upon you delete this sample. Do you want to delete this case? | This case has been used for the datasets build of {dataset} in the PhenoVarDB. The accessibility of datasets shown above will be affected upon you delete this sample. Do you want to delete this case?',
          ___restartPipeline: '<span style="color:#FA3D3D">Please make sure the error has been corrected, otherwise the analysis may fail again.</span>',
          ___deleteProject: '<span style="color:#FF414D">Once you delete the analysis, associated results will be removed from InheriNext. Do you want to delete it?</span>'
        }
      }
    },
    caseList: {
      tab: {
        title: {
          ___single: 'Single'
        }
      }
    },
    datasetDetail: {
      top: {
        icon: {
          content: {
            ___adminAnnotation: 'Select for annotation of admin.',
            ___annotation: 'Select for annotation.',
            ___unchiveDataset: 'Unchive the dataset',
            ___archiveDataset: 'Archive the dataset'
          }
        }
      },
      info: {
        title: {
          ___create: 'Create',
          ___modified: 'Modified',
          ___sampleSize: 'Sample size',
          ___externalData: 'External data',
          ___owner: 'Owner',
          ___description: 'Description',
          ___tags: 'Tags',
          ___sharing: 'Sharing',
          ___users: 'Users',
          ___datasetURL: 'Dataset URL',
          ___accessKey: 'Access Key'
        },
        content: {
          externalData: {
            ___yes: 'Yes',
            ___no: 'No'
          },
          sharing: {
            ___community: 'Community',
            ___notAvailable: 'Not available'
          },
          users: {
            ___users: '{count} user | {count} users'
          }
        },
        icon: {
          title: {
            ___datasetURL: 'Copy'
          }
        }
      },
      tab: {
        title: {
          ___summary: 'Summary',
          ___samplesList: 'Samples list'
        }
      },
      modal: {
        content: {
          ___deleteDataset: '<span style="color:#FF414D">If you delete this dataset, it will be removed permanently.<br>Do you want to delete the dataset?</span>',
          ___setDatasetAnnotation01: 'Select this dataset for the annotation of PhenoVarDB {type} in Population Databases of your case.',
          ___setDatasetAnnotation02: 'Please make sure you re-analyse the case to update the annotation of PhenoVarDB {type}.',
          ___setDatasetAnnotation03: '<span>{dataset} dataset has been selected for annotation.<br>Would you like to select this dataset?</span>'
        }
      }
    },
    datasetList: {
      ___roleFilterTitle: 'Role',
      ___roleFilterPlaceholder: 'all',
      ___sortTitle: 'Sort by',
      ___searchPlaceholder: 'Type Keywords of dataset to search, e.g., breast cancer.',
      sortOption: {
        default: {
          title: {
            ___name: 'Dataset name',
            ___createdAt: 'Created date',
            ___updatedAt: 'Modified date',
            ___sampleSize: 'Sample size',
            ___externalDataIncluded: 'External data',
            ___state: 'Status'
          }
        },
        community: {
          title: {
            ___name: 'Dataset name',
            ___createdAt: 'Created date',
            ___updatedAt: 'Modified date',
            ___sampleSize: 'Sample size',
            ___communityPermission: 'Permission'
          }
        }
      },
      tab: {
        title: {
          ___default: 'My Dataset',
          ___community: 'Community'
        }
      },
      subTab: {
        default: {},
        community: {
          title: {
            ___default: 'Community datasets',
            ___sharedWithMe: 'Shared with me',
            ___myShares: 'My shares'
          }
        }
      }
    },
    common: {
      accountTab: {
        ___user: 'Account',
        ___workgroup: 'Workgroup',
        ___panel: 'Panel',
        ___config: 'Config',
        ___systemInfo: 'System Info.'
      }
    }
  },
  // component
  COMPONENT: {
    case: {
      base: {
        customForm: {
          affected: {
            ___title: 'Affected'
          },
          reportPhenovardb: {
            ___off: 'Off',
            ___on: 'On'
          }
        },
        analysis: {
          ___title: 'Phenotype prioritization',
          ___familyTitle: 'Family Analysis',
          panel: {
            ___title: 'Phenotype Panel',
            ___empty: 'You don\'t have any panel yet. you can create a panel here'
          },
          phenotype: {
            ___selectedTitle: 'Selected',
            phenotypeTag: {
              ___placeholder: 'Phenotype (eg: Dyspnea) or Disease (eg: Breast Cancer)'
            }
          },
          gene: {
            ___title: 'Gene filter',
            ___selectedTitle: 'Selected',
            geneTag: {
              ___placeholder: 'Gene Panel (eg: Additional findings health related)'
            }
          },
          genePanel: {
            ___title: 'Gene / Disease panel'
          },
          alleleFrequencyThreshold: {
            ___title: 'Allele frequency threshold for inheritance modes',
            ___info: 'The allele frequency threshold depends on the prevalence of diseases and should be adjusted accordingly. The value should be > 0 and ≤ 1.'
          },
          scoreThreshold: {
            ___title: 'Score threshold for phenotype/gene panel selection',
            ___info: 'Phenotype scores were calculated using semantic similarity based on phenotypes user provided. Variant scores were calculated by multiple prediction scores (e.g SIFT, CADD) and population allele frequencies. The value should be ≥ 0.6 and ≤ 1'
          },
          familyAnalysis: {
            ___title: 'Family Members',
            alert: {
              ___vcf: 'The format of vcf file does NOT support for the family analysis.'
            },
            option: {
              title: {
                ___excludeVariant: 'Exclude variants by family segregation algorithm'
              }
            }
          }
        },
        file: {
          ___afterAlert: 'If you don\'t have data yet, you can upload later.',
          ___cloudTitle: 'Upload from google bucket',
          vcf: {
            ___title: 'VCF Dataset',
            file: {
              ___snvTitle: 'SNV/INDEL VCF File',
              ___svTitle: 'SV VCF File',
              ___strTitle: 'STR VCF File (ExpansionHunter/TRGT/Straglr)',
              ___svInfo: 'Multiple SV VCF files are supported (Maximum {count}).',
              ___source01: 'Currently, we only support genome build version GRCh38/hg38.',
              ___source02: 'Please make sure a concordant genome build version of vcf file is uploaded.'

            }
          },
          fastq: {
            ___title: 'FASTQ Dataset',
            file: {
              ___title: 'Set{set}-Fastq-{read}'
            }
          },
          ubam: {
            ___title: 'uBAM Dataset',
            file: {
              ___title: 'Set{set}-uBAM'
            }
          },
          alert: {
            ___content: '<b>Notice!</b>  We only support genome build version GRCh38/hg38. Ensure  a concordant genome build version of VCF file is uploaded.'
          },
          pipeline: {
            title: {
              ___single: 'Single-end',
              ___paired: 'Paired-end'
            }
          }
        },
        option: {
          sex: {
            title: {
              ___male: 'Male',
              ___female: 'Female',
              ___unknown: 'Unknown'
            }
          },
          popuplation: {
            title: {
              ___AfricanAfricanAmerican: 'African/African-American',
              ___LatinoAdmixedAmerican: 'Latino/Admixed American',
              ___AshkenaziJewish: 'Ashkenazi Jewish',
              ___EastAsian: 'East Asian',
              ___Koreans: 'Koreans',
              ___Japanese: 'Japanese',
              ___OtherEastAsian: 'Other East Asian',
              ___Finnish: 'Finnish',
              ___NonFinnishEuropean: 'Non-Finnish European',
              ___Bulgarian: 'Bulgarian',
              ___Estonian: 'Estonian',
              ___NorthWesternEuropean: 'North-Western European',
              ___SouthernEuropean: 'Southern European',
              ___Swedish: 'Swedish',
              ___OthernonFinnishEuropean: 'Other non-Finnish European',
              ___SouthAsian: 'South Asian',
              ___Other: 'Other'
            }
          }
        },
        form: {
          case: {
            title: {
              ___owner: 'Owner',
              ___caseID: 'Case ID',
              ___affected: 'Sample type',
              ___subjectName: 'Name',
              ___sex: 'Sex',
              ___birthYear: 'Year of Birth',
              ___population: 'Population',
              ___note: 'Note'
            },
            placeholder: {
              ___caseID: 'Case ID',
              ___subjectName: 'John',
              ___sex: 'Sex',
              ___birthYear: 'Year',
              ___population: 'Population',
              ___note: 'Ex: Compassbioinfomatics. Inc'
            },
            format: {
              affected: {
                ___true: 'Affected',
                ___false: 'Unaffected'
              }
            },
            option: {
              birthYear: {
                ___unknown: 'Unknown'
              }
            }
          },
          analysis: {
            title: {
              ___name: 'Analysis Name',
              ___note: 'Analysis Note',
              ___report: 'Report to PhenoVarDB'
            },
            placeholder: {
              ___name: 'breast cancer panel',
              ___note: 'Ex: Compassbioinfomatics. Inc'
            }
          },
          alleleFrequencyThreshold: {
            title: {
              ___ad_cutoff: 'Autosomal dominant (AD)',
              ___ar_cutoff: 'Autosomal recessive (AR)',
              ___comp_het_cutoff: 'Compound heterozygosity',
              ___exclude_low_quality_variants: 'Exclude LQ variants',
              ___enable_clinvar_benign_filter: 'Lower priority for known benign variants'
            },
            errorTitle: {
              ___ad_cutoff: 'AD',
              ___ar_cutoff: 'AR'
            },
            placeholder: {
              ___ad_cutoff: '0.001',
              ___ar_cutoff: '0.05',
              ___comp_het_cutoff: '0.05'
            }
          },
          scoreThreshold: {
            title: {
              ___phenotype_score_cutoff: 'Phenotype score',
              ___variant_score_cutoff: 'Variant score'
            },
            placeholder: {
              ___phenotype_score_cutoff: '0.3',
              ___variant_score_cutoff: '0.7'
            }
          },
          pipeline: {
            title: {
              ___omics_name: 'Pipeline'
            },
            errorTitle: {
              ___omics_name: 'Omics',
              ___pipeline_name: 'Pipeline',
              ___library_type_name: 'Library type'
            },
            placeholder: {
              ___omics_name: 'Omics',
              ___pipeline_name: 'Types, eg: WGS',
              ___library_type_name: 'Library kit eg: Roche KAPA HyperExome kit'
            }
          }
        }
      },
      baseFamilyCase: {
        ___searchPlaceholder: 'Case ID (e.g., Case1)',
        table: {
          title: {
            ___case_id: 'Case ID',
            ___type: 'Sample type',
            ___relation: 'Relation'
          },
          option: {
            type: {
              title: {
                ___Affected: 'Affected',
                ___Unaffected: 'Unaffected'
              }
            },
            relation: {
              ___placeholder: 'Select a relation'
            }
          }
        }
      },
      genotypeIcon: {
        altMessage: {
          relation: {
            ___father: 'Father',
            ___mother: 'Mother',
            ___proband: 'Proband'
          },
          result: {
            ___ref: 'ref',
            ___homo: 'homo',
            ___hemi: 'hemi',
            ___ref_hemi: 'ref',
            ___het: 'het',
            ___unknown: 'unknown'
          }
        }
      },
      diseaseIcon: {
        ___text01: 'It directly maps to the condition-<br>associated HPO.',
        ___text02: 'It indirectly maps to the condition-associated HPO.',
        ___text03: 'A path of similarity shows a connection from the provided HPO term to the condition-associated HPO term through <b>{length}</b> neighborhood(s).'
      },
      errorMessage: {
        ___uploading: 'Data is uploading…',
        ___analyzing: 'Data Analysis is processing…',
        ___failed01: 'An unpredictable problem occurred,',
        ___failed02: 'we are troubleshooting this problem right now.',
        ___failed03: 'An unpredictable problem occurred:'
      },
      intractableDisease: {
        select: {
          ___title: 'D006-4 遺伝学的検査'
        },
        switch: {
          ___title: '指定難病分析',
          switchButton: {
            ___off: 'オフ',
            ___on: 'オン'
          }
        },
        selectResult: {
          ___title: 'selected'
        }
      },
      mastermindFilterTable: {
        table: {
          title: {
            ___report: 'REPT',
            ___classification: 'Classification',
            ___variantIdentifiers: 'Variant identifiers',
            ___publications: 'Publications'
          },
          value: {
            ___publications: '{count} Publication | {count} Publications',
            ___empty: 'Mastermind is locked. Please unlock to view results.'
          }
        }
      },
      mastermindPublicationTable: {
        table: {
          title: {
            ___no: 'No.',
            ___details: 'Details',
            ___PMID: 'PMID'
          },
          info: {
            details: {
              ___open: '(detail)',
              ___hide: 'Hide'
            }
          }
        },
        page: {
          ___total: 'Total {total} results',
          ___display: '{display} results per page'
        }
      }
    },
    caseBatchUpload: {
      base: {
        modal: {
          content: {
            ___deleteSet: '<span style="color:#FA3D3D">This action will permanently delete all upload records. Are you sure you want to delete the batch uploads?</span>',
            ___confirmSuccess: '<span style="color:#003679"><b>All {count} samples are ready.</b> Do you want to submit?</span>',
            ___confirmFailed: '<span style="color:#FA3D3D"><b>{count} samples are not ready.</b> If you continue, these unready samples will not be created. Do you want to submit?</span>'
          }
        }
      },
      sheetUpload: {
        form: {
          ___title: 'Sample sheet',
          ___info: '<span>template</span>'
        },
        result: {
          ___title: 'Sample sheet check',
          group: {
            title: {
              ___error: '{count} error | {count} error | {count} errors'
            },
            error: {
              ___invalidFilesize: 'File too large'
            }
          }
        }
      },
      fileUpload: {
        form: {
          ___title: 'VCF data set',
          upload: {
            ___title: 'Drag the files here',
            ___content: 'Or <span>select files</span> from you dervice.'
          }
        },
        result: {
          ___title: 'Upload files',
          ___info: 'Finished: <b>{upload}</b>/{total}',
          group: {
            title: {
              ___uploading: 'Uploading {info}',
              ___finished: 'Finished {info}',
              ___failed: 'Failed & error {info}'
            }
          },
          file: {
            info: {
              ___uploading: '(<span class=uploading>waiting</span>)',
              ___pending: '(<span class=uploading>pending</span>)',
              ___finished: '(<span class=finished>complete</span>)',
              ___matched: '(<span class=finished>Filename matched</span>)',
              error: {
                ___invalidFormat: 'Invalid file format',
                ___duplicatedFilename: 'Duplicated filename',
                ___invalidFilesize: 'File too large'
              }
            }
          }
        }
      },
      sheetResult: {
        ___title: 'Confirm uploads',
        ___info: '(<span>{count}/{total} matched</span>)',
        search: {
          ___placeholder: 'Type Keywords, e.g., Case ID, sex… to search'
        },
        table: {
          title: {
            ___case_id: 'Case ID',
            ___sampleType: 'Sample Type',
            ___sex: 'Sex',
            ___analysisName: 'Analysis Name',
            ___phenotype: 'Phenotype',
            ___snvVCF: 'SNV VCF',
            ___svVCF: 'SV VCF',
            ___strVCF: 'STR VCF',
            ___delete: 'DEL',
            info: {
              ___phenotype: 'If you want to edit the phenotype, please update the sample sheet and upload again.'
            }
          },
          display: {
            sampleType: {
              ___true: 'Affected',
              ___false: 'Unaffected'
            },
            sex: {
              ___Male: 'M',
              ___Female: 'F',
              ___Unknown: 'U'
            }
          },
          content: {
            info: {
              ___phenotype: 'Not found in the HPO database.'
            },
            empty: {
              ___phenotype: 'No phenotype',
              ___file: 'No File'
            }
          }
        },
        page: {
          ___total: 'Total {total} results',
          ___display: '{display} results per page'
        }
      }
    },
    caseDetail: {
      analysisVersionTable: {
        table: {
          title: {
            ___category: 'Category',
            ___name: 'Name',
            ___version: 'Version',
            ___systemVersion: 'System Version'
          }
        }
      },
      filter: {
        ___empty: '0 Item',
        table: {
          title: {
            ___CHROM: 'Chr',
            ___POS: 'Pos',
            ___REF: 'Ref / Alt',
            ___dbSNP_ID: 'rsID',
            ___Consequence: 'Consequences',
            ___GT: 'Genotype',
            ___SYMBOL: 'Symbol',
            ___HGVSc: 'HGVSc',
            ___HGVSp: 'HGVSp'
          }
        },
        modal: {
          content: {
            ___retryAlert: '<span>Job failed. Would you like to resend the job?</span>'
          }
        }
      },
      dataList: {
        page: {
          ___total: 'Total {total} results',
          ___display: '{display} results per page'
        },
        error: {
          ___text: 'No likely disease-causative variants were found.',
          ___empty: 'No data.'
        }
      },
      geneData: {
        table: {
          ___variantAlert: 'Variant phasing has not been considered yet.',
          icon: {
            monitor: {
              ___title01: 'add to monitor',
              ___title02: 'remove from monitor'
            },
            report: {
              ___title01: 'add to report',
              ___title02: 'remove from report'
            }
          },
          title: {
            ___position: 'Position<br>(HG38)',
            ___rank: 'Exon/Intron<br>location',
            ___HGVSm: 'HGVSm',
            ___HGVSc: 'HGVSc',
            ___HGVSp: 'HGVSp',
            ___Zygosity: 'Zygosity',
            ___HeteroplasmyLevel: 'Heteroplasmy<br>Level (%)',
            ___Consequence: 'Consequence',
            ___Prediction: 'Prediction<br>scores',
            ___AlleleFrequency: 'Allele Frequency',
            ___Homoplasmy: 'Homoplasmy<br>EAS AF',
            ___Heteroplasmy: 'Heteroplasmy<br>EAS AF',
            ___variantDatabase: 'Variant<br>Databases',
            ___ACMG: 'ACMG',
            ___rsID: 'rs ID',
            ___parentalOrigin: 'Parental origin'
          },
          link: {
            position: {
              ___UCSC: 'UCSC',
              ___Ensembl: 'Ensembl',
              ___Genomebrowser: 'Genome browser'
            }
          }
        },
        mainLink: {
          title: {
            ___Pedigree: 'Pedigree'
          }
        },
        externalLink: {
          title: {
            ___GHR: 'GHR',
            ___NCBI_Gene: 'NCBI Gene',
            ___OMIM: 'OMIM',
            ___UniProt: 'UniProt',
            ___HPO: 'HPO',
            ___Orphanet: 'Orphanet'
          }
        },
        intractableDiseaseLink: {
          title: {
            ___center: '難病情報センター',
            ___other: '他の関連情報',
            ___nando: 'NanbyoData 難病データ'
          }
        },
        condition: {
          ___title: 'Conditions',
          ___alert01: 'The condition recommended for reporting of incidental findings.',
          ___less: 'less',
          ___more: '{count} items more'
        },
        disease: {
          ___title: 'Phenotype network of selected condition',
          ___less: 'less',
          ___more: '{count} items more'
        }
      },
      genePreviewDisplayForm: {
        mainFormOptions: {
          title: {
            ___1st: '1st Column',
            ___2nd: '2nd Column'
          }
        }
      },
      geneClinvarData: {
        ___clinvarStatisticTitle: 'ClinVar gene statistics',
        table: {
          clinvar: {
            ___title: 'ClinVar',
            title: {
              ___interpretation: 'Interpretation',
              ___reviewStatus: 'Review status',
              ___condition: 'Condition',
              ___conflicts: 'Conflicts'
            }
          }
        }
      },
      geneMastermindData: {
        ___lockAlert: 'Mastermind is locked. Please unlock to view results.',
        table: {
          mastermind: {
            ___title: 'Mastermind',
            title: {
              ___report: 'REPT',
              ___classification: 'Classification',
              ___variantIdentifiers: 'Variant identifiers',
              ___publications: 'Publications'
            },
            value: {
              ___publications: '{count} Publication | {count} Publications'
            }
          },
          publication: {
            ___title: 'Publication details of <b>Report {count}</b> on <b>{variant}</b>'
          }
        },
        modal: {
          content: {
            ___unlockReanalyze: 'Once you apply the annotation, the system will reanalyze this case and update the results with <b>Mastermind annotation</b>. Would you like to apply to this analysis?',
            ___unlockReanalyzeForOwner: 'Once you apply the annotation, the system will <span class=alert>consume your license quota</span> and reanalyze this case and update the results with <b>Mastermind annotation for {owner}</b>. Would you like to apply to this analysis?',
            ___unlockReload: 'Once you apply the annotation, the page will reload, and you need to reopen this page to see the updated results with <b>Mastermind annotation</b>. Would you like to apply to this analysis?',
            ___unlockReloadForOwner: 'Once you apply the annotation, the system will <span class=alert>consume your license quota</span> <b>for {owner}</b>, and the page will reload. You need to reopen the page to see the updated results with <b>Mastermind annotation</b>. Would you like to apply to this analysis?'
          }
        }
      },
      geneMitomapData: {
        table: {
          mitomap: {
            ___title: 'MITOMAP',
            title: {
              ___af: 'AF',
              ___heteroplasmy: 'Heteroplasmy',
              ___homoplasmy: 'Homoplasmy',
              ___diseaseStatus: 'Disease Status',
              ___disease: 'Disease',
              ___pubmedIDs: 'PubMed ID'
            }
          }
        }
      },
      regionData: {
        ___geneTitle: 'Overlapping gene(s)',
        table: {
          icon: {
            monitor: {
              ___title01: 'add to monitor',
              ___title02: 'remove from monitor'
            },
            report: {
              ___title01: 'add to report',
              ___title02: 'remove from report'
            }
          },
          title: {
            ___Cytoband: 'Cytoband',
            ___Length: 'Length',
            ___Zygosity: 'Zygosity',
            ___dbVar: 'dbVar',
            ___DECIPHER: 'DECIPHER',
            ___AF: 'AF',
            ___SV_Caller: 'SV Caller',
            ___ACMG_SV: 'ACMG SV'
          },
          value: {
            Zygosity: {
              ___no_call: 'No call',
              ___unknown: 'Unknown',
              ___hemizygote: 'Hem',
              ___homozygote: 'Hom',
              ___heterozygote: 'Het'
            }
          }
        },
        externalLink: {
          title: {
            ___DGV: 'DGV',
            ___DECIPHER: 'DECIPHER',
            ___GHR: 'GHR',
            ___OMIM: 'OMIM',
            ___HPO: 'HPO',
            ___Orphanet: 'Orphanet'
          }
        },
        condition: {
          // ___title: 'Conditions',
          ___title: 'Top 5 genes & Gene Associated Conditions',
          ___emptyText: 'Click the <a class=link>overlapping gene(s)</a> for conditions of every gene',
          ___alert01: 'The condition recommended for reporting of incidental findings.',
          ___less: 'less',
          ___more: '{count} items more',
          inheritance: {
            ___info: 'and {count} other condition | and {count} other conditions'
          }
        },
        disease: {
          ___title: 'Phenotype network of DECIPHER',
          ___less: 'less',
          ___more: '{count} items more'
        }
      },
      regionOverlappingGeneData: {
        table: {
          title: {
            ___Overlap_region: 'Overlap region',
            ___Dosage_sensitivity: 'Dosage sensitivity',
            ___pLI: 'pLI',
            ___LOEUF: 'LOEUF'
          },
          content: {
            Dosage_sensitivity: {
              ___Haplo: 'Haplo',
              ___Triplo: 'Triplo'
            },
            pLI: {
              ___GenomAD: 'genomAD',
              ___ExAC: 'ExAC'
            }
          }
        },
        externalLink: {
          title: {
            ___GHR: 'GHR',
            ___NCBI_Gene: 'NCBI Gene',
            ___OMIM: 'OMIM',
            ___UniProt: 'UniProt',
            ___HPO: 'HPO',
            ___Orphanet: 'Orphanet'
          }
        },
        condition: {
          ___title: 'Associated conditions',
          ___alert01: 'The condition recommended for reporting of incidental findings.',
          ___less: 'less',
          ___more: '{count} items more'
        },
        disease: {
          ___title: 'Phenotype network of selected condition',
          ___less: 'less',
          ___more: '{count} items more'
        }
      },
      regionGeneData: {
        page: {
          ___total: 'Total {total} results',
          ___display: '{display} results per page'
        }
      },
      regionVariantData: {
        ___overViewTitle: 'Overview',
        table: {
          dbVar: {
            title: {
              ___dbVarID: 'dbVar ID',
              ___Location: 'Location',
              ___Size: 'Size',
              ___Classification: 'Classification',
              ___Zygosity: 'Zygosity',
              ___Overlapinfo: 'Overlap info'
            },
            titleInfo: {
              overlapInfo: {
                ___title: 'An annotation with features overlapping the SV',
                type: {
                  ___pathogenic: 'Pathogenic SV',
                  ___other: 'Others'
                },
                formula: {
                  ___result: 'overlap (%)',
                  ___denominatorSV: 'SV to annotate length',
                  ___denominatorFeature: 'feature length',
                  ___numerator: '(length of overlap between the SV to annotate and the feature) ∗ 100'
                }
              }
            }
          },
          DECIPHER: {
            title: {
              ___DECIPHERID: 'DECIPHER ID',
              ___Location: 'Location',
              ___Size: 'Size',
              ___Classification: 'Classification',
              ___Zygosity: 'Zygosity',
              ___Phenotype: 'Phenotype',
              ___Overlapinfo: 'Overlap info'
            },
            titleInfo: {
              overlapInfo: {
                ___title: 'An annotation with features overlapping the SV',
                type: {
                  ___pathogenic: 'Pathogenic SV',
                  ___other: 'Others'
                },
                formula: {
                  ___result: 'overlap (%)',
                  ___denominatorSV: 'SV to annotate length',
                  ___denominatorFeature: 'feature length',
                  ___numerator: '(length of overlap between the SV to annotate and the feature) ∗ 100'
                }
              }
            },
            content: {
              ___more: 'more'
            },
            detailData: {
              ___hideTitle: 'Hide',
              phenotype: {
                ___title: 'Phenotype list of {id}'
              }
            }
          },
          overlapInfo: {
            title: {
              ___db: 'Database',
              ___sample: 'Case'
            }
          }
        },
        page: {
          ___total: 'Total {total} results',
          ___display: '{display} results per page'
        }
      },
      regionPublicationData: {
        table: {
          gnomAD: {
            title: {
              ___gnomADID: 'gnomAD ID',
              ___Location: 'Location',
              ___Size: 'Size',
              ___AlleleFrequency: 'Allele Frequency',
              ___Overlapinfo: 'Overlap info'
            },
            titleInfo: {
              overlapInfo: {
                ___title: 'An annotation with features overlapping the SV',
                formula: {
                  ___result: 'overlap (%)',
                  ___denominatorSV: 'SV to annotate length',
                  ___denominatorFeature: 'feature length',
                  ___numerator: '(length of overlap between the SV to annotate and the feature) ∗ 100'
                }
              }
            }
          },
          dbVar: {
            title: {
              ___dbVarID: 'dbVar ID',
              ___Location: 'Location',
              ___Size: 'Size',
              ___AlleleFrequency: 'Allele Frequency',
              ___Overlapinfo: 'Overlap info'
            },
            titleInfo: {
              overlapInfo: {
                ___title: 'An annotation with features overlapping the SV',
                formula: {
                  ___result: 'overlap (%)',
                  ___denominatorSV: 'SV to annotate length',
                  ___denominatorFeature: 'feature length',
                  ___numerator: '(length of overlap between the SV to annotate and the feature) ∗ 100'
                }
              }
            }
          },
          JSV2: {
            title: {
              ___JSV2ID: 'JSV2 ID',
              ___Location: 'Location',
              ___Size: 'Size',
              ___AlleleFrequency: 'Allele Frequency',
              ___Overlapinfo: 'Overlap info'
            },
            titleInfo: {
              overlapInfo: {
                ___title: 'An annotation with features overlapping the SV',
                formula: {
                  ___result: 'overlap (%)',
                  ___denominatorSV: 'SV to annotate length',
                  ___denominatorFeature: 'feature length',
                  ___numerator: '(length of overlap between the SV to annotate and the feature) ∗ 100'
                }
              }
            }
          },
          CoLoRSdb: {
            title: {
              ___CoLoRSdbID: 'CoLoRSdb ID',
              ___Location: 'Location',
              ___Size: 'Size',
              ___AlleleFrequency: 'Allele Frequency',
              ___Overlapinfo: 'Overlap info'
            },
            titleInfo: {
              overlapInfo: {
                ___title: 'An annotation with features overlapping the SV',
                formula: {
                  ___result: 'overlap (%)',
                  ___denominatorSV: 'SV to annotate length',
                  ___denominatorFeature: 'feature length',
                  ___numerator: '(length of overlap between the SV to annotate and the feature) ∗ 100'
                }
              }
            }
          },
          overlapInfo: {
            title: {
              ___db: 'Database',
              ___sample: 'Case'
            }
          }
        },
        page: {
          ___total: 'Total {total} results',
          ___display: '{display} results per page'
        }
      },
      repeatData: {
        table: {
          ___variantAlert: 'Variant phasing has not been considered yet.',
          icon: {
            monitor: {
              ___title01: 'add to monitor',
              ___title02: 'remove from monitor'
            },
            report: {
              ___title01: 'add to report',
              ___title02: 'remove from report'
            }
          },
          title: {
            ___position: 'Position<br>(HG38)',
            ___Region: 'Region',
            ___Repeat_unit: 'Repeat unit',
            ___REF: 'Reference copy number',
            ___ALT: 'ALT',
            ___Zygosity: 'Zygosity',
            ___Allele_Repeat_Copy_Number: 'Allele Repeat<br>Copy Number (CI)',
            ___Classification: 'Classification'
          }
        },
        externalLink: {
          title: {
            ___STRipy: 'STRipy',
            ___gnomAD: 'gnomAD',
            ___OMIM: 'OMIM',
            ___HPO: 'HPO'
          }
        },
        condition: {
          ___title: 'Conditions',
          ___alert01: 'The condition recommended for reporting of incidental findings.',
          ___more: '{count} items more'
        }
      },
      report: {
        ___editTitle: 'Report Tool box',
        ___templateTitle: 'Template',
        ___reportTitle: 'Report Preview & Editing',
        page: {
          title: {
            ___pre: 'previous section',
            ___next: 'next section'
          }
        }
      }
    },
    caseList: {
      single: {
        ___roleFilterTitle: 'Role',
        ___roleFilterPlaceholder: 'all',
        ___searchPlaceholder: 'Type Keywords, e.g., Case ID, name… to search',
        table: {
          title: {
            ___case_id: 'Case ID',
            ___sex: 'Sex',
            ___birth_year: 'Age',
            ___population: 'Population',
            ___created_at: 'Create Date',
            ___updated_at: 'Modified Date',
            ___user: 'Owner',
            ___seq: 'Seq',
            ___state: 'Status',
            ___note: 'Note',
            ___workgroup: 'Workgroup',
            ___stage: 'Stage',
            ___due_date: 'Due date',
            ___assignee: 'Assignee'
          },
          content: {
            seq: {
              ___WES: 'WES',
              ___WES_MT: 'WES+MT',
              ___WGS: 'WGS'
            },
            workgroup_stage: {
              ___select: 'Select a Stage'
            }
          },
          display: {
            sex: {
              ___Male: 'M',
              ___Female: 'F',
              ___Unknown: 'U'
            }
          }
        },
        modal: {
          content: {
            ___pointAlert: '<span style="color:#FA3D3D">Create a case need {price} points, you don’t have enough points. Do you want to buy more?</span>'
          }
        }
      }
    },
    digitalMLPA: {
      mainUpload: {
        upload: {
          ___title: 'Upload XML file'
        },
        notification: {
          ___title: 'digitalMLPA Integration Version: {version}.',
          ___content: 'Please upload the .Coffa.xml file exported from Coffalyser for the sample to be analyzed. Currently supported digitalMLPA kits include D001, D002, D006, D007, D008, D024, and D028. Files generated using unsupported kits or unsupported kit versions are not currently available for analysis. Analysis results are displayed according to the corresponding Coffalyser product definition, preserving the original panel structure and content.'
        }
      },
      mainData: {
        status: {
          title: {
            ___analyzing: 'Data Analysis is processing…',
            ___error: 'An unpredictable problem occurred, <br>we are excluding this problem right now.'
          }
        },
        info: {
          ___title: 'Information & Quality Summary'
        },
        form: {
          Panel: {
            ___title: 'Panel',
            ___placeholder: 'Please select a panel'
          },
          Subpanel: {
            ___title: 'Subpanel',
            ___placeholder: 'Please select a subpanel'
          },
          Segment: {
            ___title: 'Segment',
            data: {
              title: {
                ___Aberrant_Count: 'Aberrant Count',
                ___Mean: 'Mean',
                ___SD: 'SD',
                ___Med: 'Med',
                ___Min: 'Min',
                ___Max: 'Max',
                ___Range: 'Range'
              }
            }
          }
        }
      },
      mainDataInfo: {
        data: {
          info: {
            table: {
              Barcode_Name: {
                ___title: 'Barcode Name'
              },
              Sample_Name: {
                ___title: 'Sample Name'
              },
              Sample_Type: {
                ___title: 'Sample Type'
              },
              Product_Name: {
                ___title: 'Product Name '
              },
              Sheet_Name: {
                ___title: 'Sheet Name'
              },
              Analyzed_Sex: {
                ___title: 'Analyzed Sex',
                value: {
                  ___Male: 'Male',
                  ___Female: 'Female'
                }
              },
              Analyzed_Panels: {
                ___title: 'Analyzed Panels (abnormal: {count})'
              }
            }
          },
          quality: {
            ___title: 'Quality',
            table: {
              Is_Passed: {
                ___title: 'Is Passed',
                value: {
                  ___Pass: 'Pass',
                  ___Failed: 'Failed'
                }
              },
              Plausible_Root_Cause: {
                ___title: 'Plausible Root Cause',
                value: {
                  ___NotApplicable: 'Not Applicable',
                  ___Others: 'Others'
                }
              },
              Plausible_Root_Cause_Description: {
                ___title: 'Plausible Root Cause Description',
                value: {
                  ___NA: 'n/a',
                  ___Others: 'Others'
                }
              }
            }
          }
        },
        table: {
          quality: {
            title: {
              ___Overall: 'Overall',
              ___Data_Analysis: 'Data Analysis',
              ___Dna: 'Dna',
              ___Hybridisation: 'Hybridisation',
              ___Identity: 'Identity',
              ___Ligase_Activity: 'Ligase Activity',
              ___Ligation: 'Ligation',
              ___Polymerase: 'Polymerase',
              ___Program: 'Program',
              ___Sample_Run: 'Sample Run'
            },
            content: {
              ___OK: 'OK',
              ___Warning: 'Warning'
            },
            info: {
              ___OK: '{field} <b>OK</b>',
              ___Failed: '{field} <b>Failed</b>'
            }
          }
        }
      },
      mainDataChart: {
        chart: {
          axis: {
            title: {
              ___Copy_Number_Ratio: 'Copy Number Ratio',
              ___Probe: 'Probe'
            }
          }
        }
      },
      mainDataTable: {
        table: {
          topTitle: {
            ___Prob_Information: 'Prob Information',
            ___Comparison_Reference_Samples: 'Comparison Reference Samples',
            ___Sample_Results: 'Sample Results'
          },
          title: {
            ___Probe_No: 'Probe No.',
            ___Function: 'Function',
            ___Location: 'Location(kb)',
            ___Gene: 'Gene',
            ___Exon: 'Exon',
            ___CN_Exp: 'CN Exp',
            ___Ref_95: 'Ref. 95%',
            ___Exp_Range: 'Exp Range',
            ___Result: 'Result',
            ___Aberrant: 'Aberrant',
            ___Quality_issue: 'Quality issue'
          }
        }
      }
    },
    dataset: {
      base: {
        customForm: {
          tag: {
            ___dataTagPlaceholder: 'Name of tags'
          }
        },
        picture: {
          ___title: 'Picture of dataset',
          ___customTitle: 'Custom picture'
        },
        sample: {
          ___title: 'Samples of the dataset',
          ___info: '{count} sample selected | {count} samples selected',
          viewTitle: {
            ___detail: 'Detail view',
            ___list: 'List view'
          },
          searchPlaceholder: {
            ___case: 'Case ID of the samples',
            ___dataset: 'Keywords of dataset'
          },
          emptyText: {
            ___case: 'No sample was selected to the dataset.'
          }
        },
        sampleTable: {
          case: {
            ___case_id: 'Case ID',
            ___sex: 'Sex',
            ___birth_year: 'Age',
            ___created_at: 'Create',
            ___updated_at: 'Modified'
          },
          dataset: {
            ___name: 'Dataset name',
            ___sample_size: 'Sample Size',
            ___user: 'Owner',
            ___detail: 'Detail'
          }
        },
        sampleList: {
          title: {
            ___case: 'My selected samples',
            ___dataset: 'Community datasets'
          }
        },
        form: {
          title: {
            ___owner: 'Owner',
            ___name: 'Dataset name',
            ___tag: 'Add tags',
            ___pipeline: 'Pipeline',
            ___description: 'Dataset description'
          },
          placeholder: {
            ___name: 'Dataset name.',
            ___tag: 'Name of tags',
            ___pipeline: 'Pipeline',
            ___description: 'Note any description of the dataset.'
          },
          customValidate: {
            ___user_id: 'Name has already been taken.',
            ___sample_size: 'Sample size is too small.'
          }
        }
      },
      card: {
        annotation: {
          default: {
            ___info01: 'The dataset with all your data',
            ___info02: 'is selected for annotation.'
          },
          community: {
            ___info01: 'The dataset with community data',
            ___info02: 'is selected for annotation.'
          }
        },
        information: {
          title: {
            ___Create: 'Create',
            ___Modified: 'Modified',
            ___Samplesize: 'Sample size',
            ___Pipeline: 'Pipeline',
            ___Externaldata: 'External data',
            ___Status: 'Status',
            ___Permission: 'Permission',
            ___Description: 'Description',
            ___Owner: 'Owner',
            ___Tags: 'Tags'
          },
          value: {
            external_data_included: {
              ___Yes: 'Yes',
              ___No: 'No'
            }
          }
        }
      },
      disabledMsg: {
        ___title01: 'One or more samples/datasets have been removed from the {dataset} ({time} Created). This dataset is no longer available to you. The table below shows the datasets that revoke the sharing.',
        ___title02: 'One or more samples/datasets have been archived from the {dataset} ({time} Created). This dataset is no longer available to you.',
        table: {
          title: {
            ___category: 'Category',
            ___title: 'Dataset name / Case ID',
            ___modified: 'Modified',
            ___owner: 'Owner'
          }
        }
      },
      msg: {
        ___created: 'Analysis creation failed.',
        ___analyzing: 'Data Analysis is processing…',
        ___failed01: 'An unpredictable problem occurred,',
        ___failed02: 'we are troubleshooting this problem right now.',
        ___failed03: 'An unpredictable problem occurred:'
      }
    },
    datasetDetail: {
      sample: {
        ___title: 'There are {count} sample in the dataset. | There are {count} samples in the dataset.',
        ___searchPlaceholder: 'Case ID of the samples',
        viewTitle: {
          ___detail: 'Detail view',
          ___list: 'List view'
        },
        table: {
          title: {
            ___case_id: 'Case ID',
            ___sex: 'Sex',
            ___birth_year: 'Age',
            ___created_at: 'Create',
            ___updated_at: 'Modified',
            ___dataset_name: 'Dataset name',
            ___user: 'Owner'
          }
        }
      },
      share: {
        ___invitationIconTitle: 'Copy',
        customForm: {
          url: {
            icon: {
              ___title: 'Copy'
            }
          },
          public_permission: {
            ___title: 'Public permission',
            ___alert: 'This permission allows any user to access the summary page of your dataset. It would be very convenient if you intend to demonstrate your collections to the public. Please use this permission with caution if you consider your dataset contains sensitive information. If you like to demonstrate your dataset to the users you granted, please use the Access key.'
          },
          access_key: {
            ___title: 'Access Key'
          },
          invitation_permission: {
            ___selectPlaceholder: 'Select a permission'
          }
        },
        userList: {
          ___title: 'User list',
          ___info: 'This dataset has been shared with {count} user | This dataset has been shared with {count} users'
        },
        table: {
          title: {
            ___user_id: 'User ID (organization, email)',
            ___permission: 'Permission',
            ___option: 'Edit'
          }
        },
        form: {
          title: {
            ___url: 'Dataset URL',
            ___community_permission: 'Community permission',
            ___invitation_url: 'Invitation URL'
          }
        },
        modal: {
          content: {
            ___deleteShare: '<span>If you delete the user, the permission will also be removed. <br>Do you want to delete the user?</span>'
          }
        }
      },
      summary: {
        ___filterPlaceholder01: 'Filter Selection',
        ___filterPlaceholder02: 'Operator',
        ___filterSelectPlaceholder: 'Range',
        ___filterNumberPlaceholder: 'Range',
        ___conditionJoin: 'or',
        defaultOperatorOption: {
          title: {
            in: {
              ___true: 'in',
              ___false: 'not in'
            },
            like: {
              ___true: 'in',
              ___false: 'not in'
            }
          }
        },
        summaryFilter: {
          title: {
            ___VARIANT_CLASS: 'Variant class',
            ___F_MISSING: 'Variant missing rate',
            ___AC: 'AC',
            ___AN: 'AN',
            ___AF: 'AF',
            ___NS: 'NS',
            ___DP: 'DP',
            ___AC_Het: 'AC Het',
            ___AC_Hom: 'AC Hom',
            ___AC_Hemi: 'AC Hemi',
            ___Consequence: 'Consequence',
            ___SYMBOL: 'Gene',
            ___Sex: 'Sex',
            ___HPO: 'HPO'
          },
          rangeOption: {
            title: {
              VARIANT_CLASS: {
                ___SNV: 'SNV',
                ___Ins: 'Insertion',
                ___Del: 'Deletion'
              },
              Sex: {
                ___Male: 'Male',
                ___Female: 'Female',
                ___Unknown: 'Unknown'
              }
            }
          }
        },
        summaryMain: {
          title: {
            ___dataCounts: 'Data Counts',
            ___variantCounts: 'Variant counts',
            ___geneStatistics: 'Gene statistics',
            ___phenotypeStatistics: 'Phenotype statistics',
            ___consequenceStatistics: 'Consequence statistics',
            ___consequencePerSample: 'Consequence per sample',
            ___populationDatabase: 'Comparison of AF distribution'
          },
          option: {
            geneStatisticsType: {
              ___Caseaffected: 'Case affected',
              ___Variantcount: 'Variant count'
            }
          },
          info: {
            geneStatistics: {
              ___info01: 'Case affected: Proportion of affected cases per gene.',
              ___info02: 'Mutation count: Number of variants per gene.'
            },
            phenotypeStatistics: {
              ___info01: 'Phenogram plot. The number shown in the center indicates the sum of term occurrences of path from patient\'s phenotype to HP:0000118.'
            },
            consequenceStatistics: {
              ___info01: 'The proportion of variant consequences.'
            },
            consequencePerSample: {
              ___info01: 'Number of variants per sample grouped by<br>variant consequences.'
            }
          }
        },
        chartOption: {
          geneStatisticstestChart: {
            ___yAxis01: '% of Cases Affected',
            ___yAxis02: '# of Variants'
          },
          consequencePerSample: {
            ___xAxis: '# of Variants per sample',
            ___yAxis: 'Counts',
            seriesName: {
              ___Missense: 'Missense',
              ___Null: 'Null',
              ___Synonymous: 'Synonymous'
            }
          },
          populationDatabase: {
            ___xAxis: '# of Variant (M)',
            seriesName: {
              ___cohort: 'My cohort',
              ___TOPMED: 'My cohort + TOPMed',
              ___gnomAD: 'My cohort + gnomAD Genome',
              ___all: 'My cohort + TOPMed + gnomAD Genome'
            }
          }
        },
        dataTotal: {
          title: {
            ___Total: 'Total',
            ___Male: 'M',
            ___Female: 'F'
          }
        },
        variantTotal: {
          title: {
            ___Total: 'Total variants',
            ___SNV: 'SNVs',
            ___Ins: 'Insertion',
            ___Del: 'Deletion'
          }
        },
        consequenceMapDatas: {
          title: {
            ___transcript_ablation: 'Transcript ablation',
            ___splice_acceptor_variant: 'Splice acceptor variant',
            ___splice_donor_variant: 'Splice donor variant',
            ___stop_gained: 'Stop gained',
            ___frameshift_variant: 'Frameshift variant',
            ___stop_lost: 'Stop lost',
            ___start_lost: 'Start lost',
            ___transcript_amplification: 'Transcript amplification',
            ___inframe_insertion: 'Inframe insertion',
            ___inframe_deletion: 'Inframe deletion',
            ___missense_variant: 'Missense variant',
            ___protein_altering_variant: 'Protein altering variant',
            ___splice_region_variant: 'Splice region variant',
            ___incomplete_terminal_codon_variant: 'Incomplete terminal codon variant',
            ___start_retained_variant: 'Start retained variant',
            ___stop_retained_variant: 'Stop retained variant',
            ___synonymous_variant: 'Synonymous variant',
            ___coding_sequence_variant: 'Coding sequence variant',
            ___mature_miRNA_variant: 'Mature miRNA variant',
            ___5_prime_UTR_variant: '5 prime UTR variant',
            ___3_prime_UTR_variant: '3 prime UTR variant',
            ___non_coding_transcript_exon_variant: 'Non coding transcript exon variant',
            ___intron_variant: 'Intron variant',
            ___NMD_transcript_variant: 'NMD transcript variant',
            ___non_coding_transcript_variant: 'Non coding transcript variant',
            ___upstream_gene_variant: 'Upstream gene variant',
            ___downstream_gene_variant: 'Downstream gene variant',
            ___TFBS_ablation: 'TFBS ablation',
            ___TFBS_amplification: 'TFBS amplification',
            ___TF_binding_site_variant: 'TF binding site variant',
            ___regulatory_region_ablation: 'Regulatory region ablation',
            ___regulatory_region_amplification: 'Regulatory region amplification',
            ___feature_elongation: 'Feature elongation',
            ___regulatory_region_variant: 'Regulatory region variant',
            ___feature_truncation: 'Feature truncation',
            ___intergenic_variant: 'Intergenic variant'
          }
        }
      }
    },
    setting: {
      workgroupCase: {
        ___selectAll: 'all',
        ___emptyContent: 'Select a workgroup first.',
        workgroupList: {
          ___roleTitle: 'Role',
          ___roleSelectTitle: 'Select a role',
          group: {
            title: {
              ___default: 'My Workgroups (The max number of groups is {limit})',
              ___shared: 'Shared Workgroups'
            }
          }
        },
        workgroupResult: {
          member: {
            ___default: 'No member in the group | {count} member in the group | {count} members in the group'
          },
          case: {
            ___default: 'No case in the group | {count} case in the group | {count} cases in the group'
          },
          stage: {
            ___default: 'No stage in the group | {count} stage in the group | {count} stages in the group'
          }
        },
        workgroupData: {
          member: {
            ___title: 'Members'
          },
          case: {
            ___title: 'Cases'
          },
          stage: {
            ___title: 'Stage'
          }
        },
        form: {
          title: {
            ___name: 'Group Name',
            ___user: 'Created By',
            ___createdAt: 'Create Date',
            ___updatedAt: 'Modified Date',
            ___permissionSetting: 'Permission Settings',
            ___userSetting: 'User Settings'
          },
          placeholder: {
            ___name: 'Type the group name'
          },
          switchData: {
            title: {
              ___memberChange: 'Allow <b>Members</b> edit cases of group',
              ___memberEdit: 'Allow <b>Members</b> change status & assignment of cases',
              ___autoShare: 'Auto-share cases to this workgroup'
            },
            info: {
              ___memberChange: 'Case editing permission is granted to the Director by default. Configure this option to decide whether to grant editing permissions to members.',
              ___autoShare: 'Once enabled, all your newly uploaded cases will be automatically shared with this workgroup.'
            },
            disabled: {
              ___autoShare: 'You already have auto-share enabled in another workgroup.'
            }
          }
        },
        modal: {
          content: {
            ___deleteWorkgroup: '<span style="color:#FF414D">If you delete the group, shared cases and members will also be removed. Do you want to delete the group: {name}?</span>',
            ___leaveWorkgroup: '<span style="color:#FF414D">If you leave the group, shared cases will also be removed. Do you want to leave the group: {name}?</span>'
          }
        }
      },
      panelGene: {
        ___selectAll: 'all',
        ___panelSearchPlaceholder: 'Gene Panel (eg: Additional findings health related)',
        ___panelDefault: 'Default',
        ___panelGeneCount: '{count} gene | {count} genes',
        ___emptyContent: 'Select a gene panel first.',
        geneTag: {
          ___placeholder: 'Gene (eg: BRCA1), phenotype (eg: Headache), condition (eg: Breast Cancer)…'
        },
        panelResult: {
          ___selected: 'selected',
          gene: {
            ___type01: 'Free-typing',
            ___type02: 'User defined',
            ___title: 'gene | genes',
            ___empty: 'No gene'
          },
          panel: {
            ___title: 'panel | panels',
            ___empty: 'No panel'
          },
          phenotype: {
            ___title: 'phenotype | phenotypes',
            ___empty: 'No phenotype'
          },
          condition: {
            ___title: 'condition | conditions',
            ___empty: 'No condition'
          },
          pathway: {
            ___title: 'pathway | pathways',
            ___empty: 'No pathway'
          }
        },
        panelData: {
          ___searchTitle: 'Gene / Disease panel set',
          gene: {
            ___title: 'Genes',
            freeTyping: {
              ___title: 'Free-typing list'
            },
            userDefined: {
              ___title: 'User defined',
              ___updateTitle: 'Update with new excel file',
              ___updateTemplate: 'template',
              ___downloadList: 'Download list'
            }
          },
          panel: {
            ___title: 'Panels',
            item: {
              ___createdAt: 'Added at <b>{time}</b> from <b>{panel}</b>',
              ___updatedAt: 'latest update: {time}'
            }
          },
          phenotype: {
            ___title: 'HPO phenotype'
          },
          condition: {
            ___title: 'Conditions'
          },
          pathway: {
            ___title: 'Pathways'
          }
        },
        form: {
          edit: {
            title: {
              ___name: 'Gene Panel',
              ___newName: 'New Gene Panel',
              ___division: 'Division',
              ___note: 'Note',
              ___updatedAt: 'Last update',
              ___createdAt: 'Create Date'
            },
            placeholder: {
              ___name: 'ex: Seizures',
              ___division: 'Please select a division',
              ___note: 'You can type anything as your note.'
            }
          },
          default: {
            title: {
              ___name: 'Default Gene Panel',
              ___division: 'Division'
            }
          }
        },
        modal: {
          content: {
            ___deletePanel: '<span style="color:#FF414D">If you delete this panel, all the setting inside will also be deleted. Do you want to delete the panel?</span>',
            ___overwriteGeneList: '<span style="color:#FA3D3D">Overwrite the previously uploaded gene list?</span>'
          }
        }
      },
      panelPhenotype: {
        ___emptyContent: 'Select a phenotype panel first.',
        phenotypeTag: {
          ___placeholder: 'Phenotype (eg: Dyspnea) or Disease (eg: Breast Cancer)'
        },
        form: {
          title: {
            ___name: 'Phenotype Set',
            ___newName: 'New Phenotype Set'
          },
          placeholder: {
            ___name: 'ex: Seizures'
          }
        },
        table: {
          panel: {
            title: {
              ___panel: 'Phenotype Set'
            }
          },
          phenotype: {
            title: {
              ___query: 'Phenotype / Disease'
            }
          }
        },
        modal: {
          content: {
            ___deletePanel: '<span style="color:#FF414D">If you delete this panel, the phenotypes inside will also be deleted. Do you want to delete the panel?</span>',
            ___deleteFromPanel: '<span style="color:#FF414D">Do you want to delete the phenotype in panel: {panel}?</span>'
          }
        }
      },
      configFilter: {
        ___emptyContent: 'Select a config first.',
        form: {
          title: {
            ___name: 'Config Name',
            ___updatedAt: 'Last update',
            ___createdAt: 'Create Date'
          },
          placeholder: {
            ___name: 'Config Name'
          }
        },
        table: {
          config: {
            title: {
              ___name: 'Config Name'
            }
          }
        },
        modal: {
          content: {
            ___deleteConfig: '<span style="color:#FF414D">Do you want to delete the filter config:<br>{config}?</span>'
          }
        }
      }
    },
    workgroupCase: {
      memberTable: {
        title: {
          ___Name: 'Name',
          ___Organization: 'Organization & Division or subunit',
          ___Email: 'E-mail',
          ___Role: 'Role',
          ___Edit: 'Edit'
        },
        modal: {
          content: {
            ___deleteAlert: '<span style="color:#FA3D3D">If you delete the member, some shared cases will also be removed. Do you want to delete the member: {member}?</span>'
          }
        }
      },
      caseTable: {
        title: {
          ___Case_ID: 'Case ID',
          ___Owner: 'Owner',
          ___Workgroup_Stage: 'Stage',
          ___Due_date: 'Due date',
          ___Assignee: 'Assignee',
          ___Edit: 'Edit'
        },
        placeholder: {
          ___Workgroup_Stage: 'Select a Stage'
        },
        modal: {
          content: {
            ___deleteAlert: '<span style="color:#FA3D3D">If you delete the case, the shared permission will also be removed. Do you want to delete the case: {case}?</span>'
          }
        }
      },
      stageTable: {
        title: {
          ___Workgroup_Stage: 'Stage',
          ___Assignee: 'Assignee',
          ___Edit: 'Edit'
        },
        modal: {
          content: {
            ___deleteAlert: '<span style="color:#FA3D3D">If you delete the stage, the auto-assign function will also be canceled. Do you want to delete the stage: {stage}?</span>'
          }
        }
      }
    },
    config: {
      filter: {
        customConfig: {
          databaseSet: {
            ___valuePlaceholder: 'ex: 0.001'
          },
          genePanel: {
            geneTag: {
              ___placeholder: 'Gene, panel, phenotype, condition.'
            }
          },
          rsID: {
            ___valuePlaceholder: 'rs123456'
          }
        },
        defaultPlaceholder: {
          ___compare: '>, …',
          ___select: 'Type',
          ___value: 'Num.'
        },
        selectOption: {
          criteria: {
            title: {
              ___union: 'Union',
              ___intersection: 'Intersection'
            },
            resultTitle: {
              ___union: 'Union of criterias',
              ___intersection: 'Intersection of criterias'
            }
          },
          annotation: {
            title: {
              ___withAnnotation: 'With annotation',
              ___withoutAnnotation: 'Without annotation'
            },
            resultTitle: {
              ___withAnnotation: 'With annotation',
              ___withoutAnnotation: 'Without annotation'
            }
          }
        },
        configOption: {
          qualityFilter: {
            ___title: 'Quality Filter',
            configGroup: {
              default01: {
                config: {
                  filter_pass: {
                    ___valueTitle: 'Filter Pass',
                    ___resultTitle: 'Pass'
                  },
                  dp: {
                    ___switchTitle: 'DP'
                  },
                  ad: {
                    ___switchTitle: 'AD'
                  },
                  ad_dp: {
                    ___switchTitle: 'AD/DP'
                  },
                  genotype: {
                    ___switchTitle: 'Genotype filter'
                  }
                }
              }
            }
          },
          populationDatabase: {
            ___title: 'Population Databases',
            configGroup: {
              default01: {
                ___title: 'All database set',
                config: {
                  database_include_empty_values: {
                    ___valueTitle: 'Include empty values'
                  }
                }
              },
              populationDatabase_1000Genomes: {
                ___title: '1000 Genomes',
                config: {
                  KG_AF: {
                    ___checkTitle: 'AF'
                  },
                  KG_AFR_AF: {
                    ___checkTitle: 'AFR AF'
                  },
                  KG_AMR_AF: {
                    ___checkTitle: 'AMR AF'
                  },
                  KG_EAS_AF: {
                    ___checkTitle: 'EAS AF'
                  },
                  KG_EUR_AF: {
                    ___checkTitle: 'EUR AF'
                  },
                  KG_SAS_AF: {
                    ___checkTitle: 'SAS AF'
                  }
                }
              },
              populationDatabase_gnomAD: {
                ___title: 'gnomAD Exomes',
                config: {
                  gnomAD_AF: {
                    ___checkTitle: 'AF'
                  },
                  gnomAD_AFR_AF: {
                    ___checkTitle: 'AFR AF'
                  },
                  gnomAD_AMR_AF: {
                    ___checkTitle: 'AMR AF'
                  },
                  gnomAD_ASJ_AF: {
                    ___checkTitle: 'ASJ AF'
                  },
                  gnomAD_EAS_AF: {
                    ___checkTitle: 'EAS AF'
                  },
                  gnomAD_FIN_AF: {
                    ___checkTitle: 'FIN AF'
                  },
                  gnomAD_NFE_AF: {
                    ___checkTitle: 'NFE AF'
                  },
                  gnomAD_OTH_AF: {
                    ___checkTitle: 'OTH AF'
                  },
                  gnomAD_SAS_AF: {
                    ___checkTitle: 'SAS AF'
                  },
                  gnomAD_MID_AF: {
                    ___checkTitle: 'MID AF'
                  }
                }
              },
              populationDatabase_gnomAD_g: {
                ___title: 'gnomAD Genomes',
                config: {
                  gnomAD_g_AF: {
                    ___checkTitle: 'AF'
                  },
                  gnomAD_g_AF_afr: {
                    ___checkTitle: 'AFR AF'
                  },
                  gnomAD_g_AF_ami: {
                    ___checkTitle: 'AMI AF'
                  },
                  gnomAD_g_AF_amr: {
                    ___checkTitle: 'AMR AF'
                  },
                  gnomAD_g_AF_asj: {
                    ___checkTitle: 'ASJ AF'
                  },
                  gnomAD_g_AF_eas: {
                    ___checkTitle: 'EAS AF'
                  },
                  gnomAD_g_AF_fin: {
                    ___checkTitle: 'FIN AF'
                  },
                  gnomAD_g_AF_mid: {
                    ___checkTitle: 'MID AF'
                  },
                  gnomAD_g_AF_nfe: {
                    ___checkTitle: 'NFE AF'
                  },
                  gnomAD_g_AF_oth: {
                    ___checkTitle: 'OTH AF'
                  },
                  gnomAD_g_AF_sas: {
                    ___checkTitle: 'SAS AF'
                  },
                  gnomAD_g_mt_AF_het: {
                    ___checkTitle: 'Heteroplasmy AF'
                  },
                  gnomAD_g_mt_pop_AF_het_afr: {
                    ___checkTitle: 'Heteroplasmy AFR AF'
                  },
                  gnomAD_g_mt_pop_AF_het_ami: {
                    ___checkTitle: 'Heteroplasmy AMI AF'
                  },
                  gnomAD_g_mt_pop_AF_het_amr: {
                    ___checkTitle: 'Heteroplasmy AMR AF'
                  },
                  gnomAD_g_mt_pop_AF_het_asj: {
                    ___checkTitle: 'Heteroplasmy ASJ AF'
                  },
                  gnomAD_g_mt_pop_AF_het_eas: {
                    ___checkTitle: 'Heteroplasmy EAS AF'
                  },
                  gnomAD_g_mt_pop_AF_het_fin: {
                    ___checkTitle: 'Heteroplasmy FIN AF'
                  },
                  gnomAD_g_mt_pop_AF_het_mid: {
                    ___checkTitle: 'Heteroplasmy MID AF'
                  },
                  gnomAD_g_mt_pop_AF_het_nfe: {
                    ___checkTitle: 'Heteroplasmy NFE AF'
                  },
                  gnomAD_g_mt_pop_AF_het_oth: {
                    ___checkTitle: 'Heteroplasmy OTH AF'
                  },
                  gnomAD_g_mt_pop_AF_het_sas: {
                    ___checkTitle: 'Heteroplasmy SAS AF'
                  },
                  gnomAD_g_mt_AF_hom: {
                    ___checkTitle: 'Homoplasmy AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_afr: {
                    ___checkTitle: 'Homoplasmy AFR AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_ami: {
                    ___checkTitle: 'Homoplasmy AMI AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_amr: {
                    ___checkTitle: 'Homoplasmy AMR AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_asj: {
                    ___checkTitle: 'Homoplasmy ASJ AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_eas: {
                    ___checkTitle: 'Homoplasmy EAS AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_fin: {
                    ___checkTitle: 'Homoplasmy FIN AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_mid: {
                    ___checkTitle: 'Homoplasmy MID AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_nfe: {
                    ___checkTitle: 'Homoplasmy NFE AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_oth: {
                    ___checkTitle: 'Homoplasmy OTH AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_sas: {
                    ___checkTitle: 'Homoplasmy SAS AF'
                  }
                }
              },
              populationDatabase_others: {
                ___title: 'Others',
                config: {
                  ExAC_AF: {
                    ___checkTitle: 'ExAC AF'
                  },
                  ESP6500_AA_AF: {
                    ___checkTitle: 'ESP6500 AA'
                  },
                  ESP6500_EA_AF: {
                    ___checkTitle: 'ESP6500 EA'
                  },
                  TW_AF: {
                    ___checkTitle: 'TW AF'
                  },
                  TOPMED_AF: {
                    ___checkTitle: 'TOPMed AF'
                  },
                  ChinaMAP_AF: {
                    ___checkTitle: 'ChinaMAP AF'
                  }
                }
              },
              default02: {
                ___title: 'Set of Criteria'
              }
            }
          },
          computationalPredictiveData: {
            ___title: 'Computational & Predictive data',
            configGroup: {
              default01: {
                config: {
                  predictive_include_empty_values: {
                    ___valueTitle: 'Include empty values'
                  }
                }
              },
              computationalPredictiveData_splicingImpact: {
                ___title: 'Splicing impact',
                config: {
                  ada_score: {
                    ___checkTitle: 'ada score'
                  },
                  rf_score: {
                    ___checkTitle: 'rf score'
                  },
                  CI_SpliceAI: {
                    ___checkTitle: 'CI SpliceAI'
                  },
                  SpliceAI_DS_AG: {
                    ___checkTitle: 'SpliceAI DS AG'
                  },
                  SpliceAI_DS_AL: {
                    ___checkTitle: 'SpliceAI DS AL'
                  },
                  SpliceAI_DS_DG: {
                    ___checkTitle: 'SpliceAI DS DG'
                  },
                  SpliceAI_DS_DL: {
                    ___checkTitle: 'SpliceAI DS DL'
                  }
                }
              },
              computationalPredictiveData_proteinFunction: {
                ___title: 'Protein function',
                config: {
                  ESM1b: {
                    ___checkTitle: 'ESM1b'
                  },
                  ESM1b_pred: {
                    ___checkTitle: 'ESM1b pred'
                  },
                  VARITY_ER_LOO: {
                    ___checkTitle: 'VARITY ER LOO'
                  },
                  VARITY_ER_LOO_pred: {
                    ___checkTitle: 'VARITY ER LOO pred'
                  },
                  VARITY_R_LOO: {
                    ___checkTitle: 'VARITY R LOO'
                  },
                  VARITY_R_LOO_pred: {
                    ___checkTitle: 'VARITY R LOO pred'
                  },
                  VARITY_ER: {
                    ___checkTitle: 'VARITY ER'
                  },
                  VARITY_ER_pred: {
                    ___checkTitle: 'VARITY ER pred'
                  },
                  VARITY_R: {
                    ___checkTitle: 'VARITY R'
                  },
                  VARITY_R_pred: {
                    ___checkTitle: 'VARITY R pred'
                  },
                  Alphamissense_score: {
                    ___checkTitle: 'Alphamissense score'
                  },
                  Alphamissense_class: {
                    ___checkTitle: 'Alphamissense class'
                  },
                  SIFT4G_score: {
                    ___checkTitle: 'SIFT4G score'
                  },
                  SIFT4G_pred: {
                    ___checkTitle: 'SIFT4G pred'
                  },
                  Polyphen_score: {
                    ___checkTitle: 'Polyphen-2 HDIV'
                  },
                  Polyphen_pred: {
                    ___checkTitle: 'Polyphen-2 HDIV pred'
                  },
                  FATHMM_score: {
                    ___checkTitle: 'FATHMM score'
                  },
                  FATHMM_pred: {
                    ___checkTitle: 'FATHMM pred'
                  },
                  PROVEAN_score: {
                    ___checkTitle: 'PROVEAN score'
                  },
                  PROVEAN_pred: {
                    ___checkTitle: 'PROVEAN pred'
                  }
                }
              },
              computationalPredictiveData_ensemble: {
                ___title: 'Ensemble',
                config: {
                  CADD_phred: {
                    ___checkTitle: 'CADD phred'
                  },
                  CADD_raw: {
                    ___checkTitle: 'CADD raw'
                  },
                  MetaLR_score: {
                    ___checkTitle: 'MetaLR score'
                  },
                  MetaLR_pred: {
                    ___checkTitle: 'MetaLR pred'
                  },
                  MetaSVM_score: {
                    ___checkTitle: 'MetaSVM score'
                  },
                  MetaSVM_pred: {
                    ___checkTitle: 'MetaSVM pred'
                  },
                  REVEL_score: {
                    ___checkTitle: 'REVEL score'
                  },
                  REVEL_pred: {
                    ___checkTitle: 'REVEL pred'
                  },
                  BayesDel_noAF_score: {
                    ___checkTitle: 'BayesDel noAF score'
                  },
                  BayesDel_noAF_pred: {
                    ___checkTitle: 'BayesDel noAF pred'
                  }
                }
              },
              computationalPredictiveData_conservation: {
                ___title: 'Conservation',
                config: {
                  GERPpp_NR: {
                    ___checkTitle: 'GERP++ NR'
                  },
                  GERPpp_RS: {
                    ___checkTitle: 'GERP++ RS'
                  }
                }
              },
              computationalPredictiveData_gnomADConstraint: {
                ___title: 'gnomAD Constraint',
                config: {
                  oe_syn: {
                    ___checkTitle: 'Synonymous o/e'
                  },
                  oe_mis: {
                    ___checkTitle: 'Missense o/e'
                  },
                  oe_lof: {
                    ___checkTitle: 'pLoF o/e'
                  },
                  syn_z: {
                    ___checkTitle: 'Synonymous z-score'
                  },
                  mis_z: {
                    ___checkTitle: 'Missense z-score'
                  },
                  pLI: {
                    ___checkTitle: 'pLI'
                  }
                }
              },
              default02: {
                ___title: 'Set of Criteria'
              }
            }
          },
          consequences: {
            ___title: 'Consequences',
            configGroup: {
              consequences_high: {
                ___title: 'High',
                config: {
                  frameshift_elongation: {
                    ___valueTitle: 'Frameshift elongation'
                  },
                  frameshift_truncation: {
                    ___valueTitle: 'Frameshift truncation'
                  },
                  frameshift_variant: {
                    ___valueTitle: 'Frameshift variant'
                  },
                  splice_acceptor_variant: {
                    ___valueTitle: 'Splice acceptor variant'
                  },
                  splice_donor_variant: {
                    ___valueTitle: 'Splice donor variant'
                  },
                  start_lost: {
                    ___valueTitle: 'Start lost'
                  },
                  stop_gained: {
                    ___valueTitle: 'Stop gained'
                  },
                  stop_lost: {
                    ___valueTitle: 'Stop lost'
                  },
                  transcript_ablation: {
                    ___valueTitle: 'Transcript ablation'
                  },
                  transcript_amplification: {
                    ___valueTitle: 'Transcript amplification'
                  }
                }
              },
              consequences_low: {
                ___title: 'Low',
                config: {
                  incomplete_terminal_codon_variant: {
                    ___valueTitle: 'Incomplete terminal codon variant'
                  },
                  splice_region_variant: {
                    ___valueTitle: 'Splice region variant'
                  },
                  start_retained_variant: {
                    ___valueTitle: 'Start retained variant'
                  },
                  stop_retained_variant: {
                    ___valueTitle: 'Stop retained variant'
                  },
                  synonymous_variant: {
                    ___valueTitle: 'Synonymous variant'
                  }
                }
              },
              consequences_moderate: {
                ___title: 'Moderate',
                config: {
                  direct_tandem_duplication: {
                    ___valueTitle: 'Direct tandem duplication'
                  },
                  disruptive_inframe_deletion: {
                    ___valueTitle: 'Disruptive inframe deletion'
                  },
                  disruptive_inframe_insertion: {
                    ___valueTitle: 'Disruptive inframe insertion'
                  },
                  inframe_deletion: {
                    ___valueTitle: 'Inframe deletion'
                  },
                  inframe_insertion: {
                    ___valueTitle: 'Inframe insertion'
                  },
                  missense_variant: {
                    ___valueTitle: 'Missense variant'
                  },
                  protein_altering_variant: {
                    ___valueTitle: 'Protein altering variant'
                  },
                  regulatory_region_ablation: {
                    ___valueTitle: 'Regulatory region ablation'
                  }
                }
              },
              consequences_modifier: {
                ___title: 'Modifier',
                config: {
                  __3_prime_UTR_exon_variant: {
                    ___valueTitle: '3 prime UTR exon variant'
                  },
                  __3_prime_UTR_intron_variant: {
                    ___valueTitle: '3 prime UTR intron variant'
                  },
                  __3_prime_UTR_variant: {
                    ___valueTitle: '3 prime UTR variant'
                  },
                  __5_prime_UTR_exon_variant: {
                    ___valueTitle: '5 prime UTR exon variant'
                  },
                  __5_prime_UTR_intron_variant: {
                    ___valueTitle: '5 prime UTR intron variant'
                  },
                  __5_prime_UTR_variant: {
                    ___valueTitle: '5 prime UTR variant'
                  },
                  coding_sequence_variant: {
                    ___valueTitle: 'Coding sequence variant'
                  },
                  coding_transcript_intron_variant: {
                    ___valueTitle: 'Coding transcript intron variant'
                  },
                  feature_elongation: {
                    ___valueTitle: 'Feature elongation'
                  },
                  feature_truncation: {
                    ___valueTitle: 'Feature truncation'
                  },
                  intergenic_variant: {
                    ___valueTitle: 'Intergenic variant'
                  },
                  intron_variant: {
                    ___valueTitle: 'Intron variant'
                  },
                  mature_miRNA_variant: {
                    ___valueTitle: 'Mature miRNA variant'
                  },
                  NMD_transcript_variant: {
                    ___valueTitle: 'NMD transcript variant'
                  },
                  non_coding_transcript_exon_variant: {
                    ___valueTitle: 'Non coding transcript exon variant'
                  },
                  non_coding_transcript_intron_variant: {
                    ___valueTitle: 'Non coding transcript intron variant'
                  },
                  non_coding_transcript_variant: {
                    ___valueTitle: 'Non coding transcript variant'
                  },
                  regulatory_region_amplification: {
                    ___valueTitle: 'Regulatory region amplification'
                  },
                  regulatory_region_variant: {
                    ___valueTitle: 'Regulatory region variant'
                  },
                  TF_binding_site_variant: {
                    ___valueTitle: 'TF binding site variant'
                  },
                  TFBS_ablation: {
                    ___valueTitle: 'TFBS ablation'
                  },
                  TFBS_amplification: {
                    ___valueTitle: 'TFBS amplification'
                  }
                }
              },
              default01: {
                config: {
                  consequences_exact_match: {
                    ___valueTitle: 'Exact match'
                  }
                }
              }
            }
          },
          miscellaneous: {
            ___title: 'Miscellaneous',
            configGroup: {
              default01: {
                ___resultTitle: 'Gene Filter'
              },
              miscellaneous_genome_coordinate: {
                ___title: 'Genome coordinate filter',
                ___resultTitle: 'Genome Filter',
                config: {
                  genome_coordinate_filter: {
                    ___valuePlaceholder: 'X or 1:12345-12345 or 1:13456-150213…'
                  }
                }
              },
              miscellaneous_rs_id: {
                ___title: 'rs ID filter',
                ___resultTitle: 'rs ID Filter'
              },
              miscellaneous_clinVar: {
                ___title: 'ClinVar',
                config: {
                  clinvar_Pathogenic: {
                    ___valueTitle: 'Pathogenic'
                  },
                  clinvar_Likely_pathogenic: {
                    ___valueTitle: 'Likely pathogenic'
                  },
                  clinvar_Uncertain_significance: {
                    ___valueTitle: 'Uncertain significance'
                  },
                  clinvar_Conflicting_interpretations_of_pathogenicity: {
                    ___valueTitle: 'Conflicting interpretations of pathogenicity'
                  },
                  clinvar_Benign: {
                    ___valueTitle: 'Benign'
                  },
                  clinvar_Likely_benign: {
                    ___valueTitle: 'Likely benign'
                  },
                  clinvar_risk_factor: {
                    ___valueTitle: 'Risk factor'
                  },
                  clinvar_other: {
                    ___valueTitle: 'Other'
                  },
                  clinvar_drug_response: {
                    ___valueTitle: 'Drug response'
                  },
                  clinvar_exclude_selections: {
                    ___valueTitle: 'Exclude selections'
                  }
                }
              },
              miscellaneous_mastermind: {
                ___title: 'Mastermind',
                config: {
                  mastermind_Pathogenic: {
                    ___valueTitle: 'Pathogenic'
                  },
                  mastermind_Likely_pathogenic: {
                    ___valueTitle: 'Likely pathogenic'
                  },
                  mastermind_Conflict: {
                    ___valueTitle: 'Conflict'
                  },
                  mastermind_VUS: {
                    ___valueTitle: 'VUS'
                  },
                  mastermind_Likely_benign: {
                    ___valueTitle: 'Likely benign'
                  },
                  mastermind_Benign: {
                    ___valueTitle: 'Benign'
                  },
                  mastermind_exclude_selections: {
                    ___valueTitle: 'Exclude selections'
                  }
                }
              },
              miscellaneous_acmg: {
                ___title: 'ACMG Classification',
                config: {
                  acmg_Pathogenic: {
                    ___valueTitle: 'Pathogenic'
                  },
                  acmg_Likely_pathogenic: {
                    ___valueTitle: 'Likely pathogenic'
                  },
                  acmg_Uncertain_significance: {
                    ___valueTitle: 'Uncertain significance'
                  },
                  acmg_Benign: {
                    ___valueTitle: 'Benign'
                  },
                  acmg_Likely_benign: {
                    ___valueTitle: 'Likely benign'
                  },
                  acmg_exclude_selections: {
                    ___valueTitle: 'Exclude selections'
                  }
                }
              },
              default02: {
                config: {
                  clinvar_exclude_selections: {
                    ___valueTitle: 'Exclude selections'
                  }
                }
              },
              miscellaneous_omim: {
                ___title: 'OMIM',
                config: {
                  omim_annotation_filter: {
                    ___switchTitle: 'OMIM annotation filter'
                  }
                }
              },
              miscellaneous_inheritance: {
                ___title: 'Inheritance',
                config: {
                  inheritance_AR: {
                    ___valueTitle: 'AR'
                  },
                  inheritance_AD: {
                    ___valueTitle: 'AD'
                  },
                  inheritance_XL: {
                    ___valueTitle: 'XL'
                  },
                  inheritance_XLD: {
                    ___valueTitle: 'XLD'
                  },
                  inheritance_XLR: {
                    ___valueTitle: 'XLR'
                  },
                  inheritance_YL: {
                    ___valueTitle: 'YL'
                  },
                  inheritance_DD: {
                    ___valueTitle: 'DD'
                  },
                  inheritance_DR: {
                    ___valueTitle: 'DR'
                  },
                  inheritance_IC: {
                    ___valueTitle: 'IC'
                  },
                  inheritance_Mi: {
                    ___valueTitle: 'Mi'
                  },
                  inheritance_Mu: {
                    ___valueTitle: 'Mu'
                  },
                  inheritance_PD: {
                    ___valueTitle: 'PD'
                  },
                  inheritance_PR: {
                    ___valueTitle: 'PR'
                  },
                  inheritance_SMo: {
                    ___valueTitle: 'SMo'
                  },
                  inheritance_SMu: {
                    ___valueTitle: 'SMu'
                  }
                }
              },
              miscellaneous_family_analysis: {
                ___title: 'Family analysis',
                config: {
                  family_analysis_AD_De_Novo: {
                    ___valueTitle: 'AD De Novo'
                  },
                  family_analysis_AD: {
                    ___valueTitle: 'AD'
                  },
                  family_analysis_AR_De_Novo: {
                    ___valueTitle: 'AR De Novo'
                  },
                  family_analysis_AR: {
                    ___valueTitle: 'AR'
                  },
                  family_analysis_AR_Compound_Heterozygosity: {
                    ___valueTitle: 'AR Compound Heterozygosity'
                  },
                  family_analysis_XL_De_Novo: {
                    ___valueTitle: 'XL De Novo'
                  },
                  family_analysis_XL: {
                    ___valueTitle: 'XL'
                  },
                  family_analysis_YL_De_Novo: {
                    ___valueTitle: 'YL De Novo'
                  },
                  family_analysis_YL: {
                    ___valueTitle: 'YL'
                  }
                }
              }
            }
          }
        }
      }
    },
    filter: {
      config: {
        ___title: 'Filter Tool box',
        ___selectPlaceholder: 'Select a filter config.'
      },
      data: {
        tab: {
          title: {
            ___transcript: 'Transcript',
            ___variantDatabase: 'Variant Database',
            ___populationDatabase: 'Population Database',
            ___predictionScore: 'Prediction Score',
            ___samples: 'Samples',
            ___acmg: 'ACMG',
            ___conditions: 'Conditions'
          }
        },
        table: {
          transcript: {
            title: {
              ___symbol: 'Symbol',
              ___gene: 'Gene',
              ___feature: 'Transcript',
              ___biotype: 'Biotype',
              ___rank: 'Rank',
              ___HGVSc: 'HGVSc',
              ___HGVSp: 'HGVSp',
              ___cDNAPosition: 'cDNA position',
              ___CDSPosition: 'CDS position',
              ___proteinPosition: 'Protein position'
            }
          },
          variantDB: {
            clinVar: {
              ___title: 'ClinVar',
              title: {
                ___clinVarAccession: 'ClinVar Accession',
                ___clinVarDisease_Name: 'ClinVar Disease Name',
                ___clinVarCLNREVSTAT: 'ClinVar Review Status',
                ___cLINSIG: 'ClinVar Interpretation',
                ___cLINCONF: 'ClinVar Conflict'
              }
            },
            clinVarGeneStatistic: {
              ___title: 'ClinVar Gene Statistic'
            },
            mastermind: {
              ___title: 'Mastermind'
            },
            mitomap: {
              ___title: 'MITOMAP',
              title: {
                ___mitomapAF: 'AF',
                ___mitomapAachange: 'Amino acid changes',
                ___mitomapHomoplasmy: 'Homoplasmy',
                ___mitomapHeteroplasmy: 'Heteroplasmy',
                ___mitomapPubmedIDs: 'PubMed ID',
                ___mitomapDisease: 'Disease',
                ___mitomapDiseaseStatus: 'Disease Status',
                ___mitomapHGFL: 'HGFL'
              }
            }
          },
          populationDB: {},
          prediction: {},
          samples: {
            title: {
              ___case_id: 'CASE ID',
              ___genotype: 'Genotype',
              ___DP: 'DP',
              ___RD: 'RD',
              ___AD: 'AD',
              ___GT_AF: 'Allele Fractions',
              ___QUAL: 'QUAL',
              ___GQ: 'Genotype Quality',
              ___FILTER: 'FILTER',
              ___x10_cov: 'Gene Coverage (10X)',
              ___x20_cov: 'Gene Coverage (20X)',
              ___x2000_cov: 'Gene Coverage (2000X)',
              ___x3000_cov: 'Gene Coverage (3000X)'
            }
          },
          condition: {
            orphanet: {
              ___title: 'Orphanet',
              linkTitle: {
                ___orphanet: 'Orphanet'
              }
            },
            omim: {
              ___title: 'OMIM',
              linkTitle: {
                ___omim: 'OMIM'
              }
            }
          }
        }
      }
    },
    report: {
      config: {
        group: {
          chapter: {
            ___title: 'Edit Section',
            display: {
              ___variantEmpty: 'No variants have been added yet.'
            }
          },
          variant: {
            ___title: 'Variants in Monitor',
            type: {
              ___snv: 'SNV',
              ___sv: 'SV'
            },
            configResult: {
              ___result: '{count} variant with the tag. | {count} variants with the tag.'
            },
            result: {
              ___result: '{count} variant selected in monitor. | {count} variants selected in monitor.'
            }
          },
          cnv: {
            ___title: 'SV management',
            result: {
              ___result: '{count} SV in the section. | {count} SVs in the section.'
            }
          }
        },
        subChpater: {
          default: {
            title: {
              ___displaySummary: '結果摘要',
              ___displayDetails: '詳細資訊'
            }
          },
          portrait: {
            title: {
              ___displayDetails: '結果表格',
              ___displaySummary: '文字說明'
            }
          }
        },
        modal: {
          content: {
            ___removeChapter: '<span style="color:#FA3D3D">If you delete this section, all the content inside will also be deleted. Do you want to delete the section?</span>',
            ___removeFromChapter: '<span style="color:#FA3D3D">If you delete this variant, all the content inside will also be deleted. Do you want to delete the variant?</span>',
            ___removeCNVFromChapter: '<span style="color:#FA3D3D">If you delete this variant, all the content inside will also be deleted. Do you want to delete the variant?</span>'
          }
        }
      }
    },
    chat: {
      display: {
        ___stopMsg: 'The content has been stopped.'
      },
      summary: {
        ___source: 'Source: '
      }
    },
    user: {
      licenseManager: {
        ___empty: 'Please contact sales to activate your access.',
        title: {
          ___License_ID: 'License ID',
          ___Request_Code: 'Step1: Generate Activation Request Code',
          ___Activation_Code: 'Step2: Upload Activation Code',
          ___Licensed_Information: 'Licensed Information'
        },
        file: {
          title: {
            ___Request_Code: 'request_code.txt',
            ___Activation_Code: 'activation_request_code.txt'
          }
        },
        table: {
          title: {
            ___Modules: 'Modules',
            ___Status: 'Status',
            ___Started_at: 'Started at',
            ___Expired_at: 'Expired at',
            ___Licensed_Usage: 'Licensed Usage <h5>(left/total)</h5>'
          }
        },
        modal: {
          content: {
            ___removeCreateLicenseID: '<span style="color:#FA3D3D">If you delete the license, you and the users sharing this license will not be able to access this licensed function. Do you want to delete the license?</span>',
            ___removeImportLicenseID: '<span style="color:#FA3D3D">If you delete the license, you will not be able to access this licensed function. Do you want to delete the license?</span>'
          },
          confirm: {
            ___placeholder: 'Type “{confirm}” to confirm'
          }
        }
      }
    },
    tool: {
      gcsResumable: {
        gcsTable: {
          title: {
            ___caseID: 'Case ID',
            ___status: 'Status'
          }
        },
        groupState: {
          ___pending: 'Pending',
          ___failed: 'Failed'
        }
      },
      geneTag: {
        ___empty: 'No result has been found.',
        ___filterTitle: 'Search filter',
        info: {
          ___gene: 'genes',
          ___panel: 'gene panels',
          ___hpo: 'phenotypes',
          ___condition: 'conditions',
          ___pathway: 'pathways',
          ___and: 'and'
        },
        title: {
          ___all: 'All',
          ___gene: 'Genes',
          ___panel: 'Panels',
          ___hpo: 'Phenotypes',
          ___condition: 'Conditions',
          ___pathway: 'Pathways'
        }
      },
      phenotypeTag: {
        info: {
          ___hpo: 'phenotypes',
          ___disease_term: 'diseases',
          ___show: 'Showing',
          ___and: 'and'
        },
        title: {
          ___hpo: 'Phenotypes',
          ___disease_term: 'Diseases'
        },
        ___empty: 'No result has been found.'
      },
      igv: {
        ___loading: 'Loading...'
      },
      toast: {
        title: {
          ___error: 'Error !',
          ___warning: 'Warning !',
          ___notice: 'Notice !',
          ___success: 'Success !'
        }
      }
    }
  },
  // dialog
  DIALOG: {
    addLicenseID: {
      ___title: 'License ID Import',
      ___or: 'OR',
      form: {
        title: {
          ___create: 'Create a new ID',
          ___import: 'Import present license ID'
        },
        placeholder: {
          ___import: 'Please enter a present license ID'
        }
      }
    },
    addToPanel: {
      ___or: 'OR',
      form: {
        title: {
          ___phenotype: 'Phenotype',
          ___panel: 'Select a Panel',
          ___newPanel: 'Add to new panel'
        },
        placeholder: {
          ___panel: 'Please Select a Panel you need',
          ___newPanel: 'Please create a new panel name'
        },
        alert: {
          newPanel: {
            ___required: 'New panel name should not be empty.'
          }
        }
      }
    },
    addVariantToChapter: {
      variant: {
        ___title: 'Add a variant to section'
      },
      chapter: {
        ___title: 'Select at least one section'
      }
    },
    caseConfirm: {
      ___datasetTitle: '{type} Dataset',
      ___pipelineTitle: 'Pipeline',
      ___snvVcfTitle: 'SNV/INDEL VCF File',
      ___svVcfTitle: 'SV VCF File',
      ___strVcfTitle: 'STR VCF File (ExpansionHunter/TRGT/Straglr)',
      ___fastqTitle: 'Set{set}-Fastq-{read}',
      ___ubamTitle: 'Set{set}-uBAM',
      form: {
        case: {
          title: {
            ___caseID: 'Case ID',
            ___affected: 'Sample type',
            ___subjectName: 'Name',
            ___sex: 'Sex',
            ___birthYear: 'Birth Year',
            ___population: 'Population',
            ___note: 'Note'
          },
          format: {
            affected: {
              ___true: 'Affected',
              ___false: 'Unaffected'
            },
            sex: {
              ___male: 'Male',
              ___female: 'Female',
              ___unknown: 'Unknown'
            },
            birthYear: {
              ___empty: 'Unknown'
            }
          }
        },
        analysis: {
          title: {
            ___name: 'Analysis Name',
            ___note: 'Analysis note',
            ___reportPhenovardb: 'Report to PhenoVarDB',
            ___intractableDisease: 'D006-4 遺伝学的検査',
            ___intractableDiseaseTag: '指定難病分析',
            ___phenotype: 'Phenotype',
            ___genePanel: 'Gene Panel',
            ___aft: 'Allele frequency threshold for inheritance modes',
            ___st: 'Score threshold for phenotype/gene panel selection'
          },
          aft: {
            title: {
              ___ad_cutoff: 'AD',
              ___ar_cutoff: 'AR',
              ___exclude_low_quality_variants: 'Exclude LQ variants',
              ___comp_het_cutoff: 'Compound heterozygosity',
              ___enable_clinvar_benign_filter: 'Lower priority for known benign variants'
            },
            display: {
              exclude_low_quality_variants: {
                ___true: 'ON',
                ___false: 'OFF'
              },
              enable_clinvar_benign_filter: {
                ___true: 'ON',
                ___false: 'OFF'
              }
            }
          },
          st: {
            title: {
              phenotype_score_cutoff: 'Phenotype score',
              variant_score_cutoff: 'Variant score'
            }
          },
          format: {
            reportPhenovardb: {
              ___true: 'On',
              ___false: 'Off'
            },
            intractableDiseaseTag: {
              ___true: 'Off',
              ___false: 'On'
            }
          }
        }
      },
      modal: {
        content: {
          ___unknownSexAlert: '<span style="color:#FA3D3D">Unknown sex may affect subsequent analysis results. Would you like to continue?</span>'
        }
      }
    },
    caseDetailGenePedigree: {
      ___title: 'Pedigree'
    },
    caseDetailGeneACMG: {
      ___title: 'ACMG',
      ___tabTitle: 'Rules',
      table: {
        title: {
          ___benignCriteria: 'Benign Criteria',
          ___pathogenicCriteria: 'Pathogenic Criteria',
          ___strengthofEvidence: 'Strength of Evidence',
          ___strong: 'Strong',
          ___supporting: 'Supporting',
          ___moderate: 'Moderate',
          ___veryStrong: 'Very Strong',
          ___populationData: 'Population Data',
          ___allelicEvidenceCosegrgationData: 'Allelic Evidence &<br>Cosegregation Data',
          ___computationPredictiveData: 'Computation &<br>Predictive Data',
          ___functionalData: 'Functional Data',
          ___other: 'Other',
          ___automatedCriteria: 'Automated Criteria',
          ___explanation: 'Explanation'
        }
      }
    },
    caseDetailGeneVariantDatabase: {
      ___title: 'Variant Databases',
      tab: {
        title: {
          ___clinvar: 'ClinVar',
          ___mastermind: 'Mastermind',
          ___MITOMAP: 'MITOMAP'
        }
      }
    },
    caseDetailGeneQuality: {
      ___title: 'Quality Control',
      pass: {
        readDepth: {
          ___pass: 'Read depth ≥ 10, pass.',
          ___noPass: 'Read depth < 10, no pass.'
        },
        genotypeQuality: {
          ___pass: 'Quality ≥ 20, pass.',
          ___noPass: 'Quality < 20, no pass.'
        },
        alleleFractions: {
          ___pass: 'Fractions pass.',
          ___noPass: 'Fractions no pass.'
        }
      },
      table: {
        family: {
          title: {
            ___case_id: 'Case ID',
            ___relation: 'Relation',
            ___ra: 'Ref/Alt'
          }
        },
        default: {
          title: {
            ___genotype: 'Genotype',
            ___readDepth: 'Read depth',
            ___alleleFractions: 'Allele Fractions',
            ___genotypeQuality: 'Genotype Quality',
            ___geneCoverage: 'Gene Coverage(CDS)'
          },
          option: {
            geneCoverage: {
              ___x10Cov: '10X',
              ___x20Cov: '20X'
            }
          }
        },
        mt: {
          title: {
            ___readDepth: 'Read depth',
            ___alleleFractions: 'Allele Fractions',
            ___geneCoverage: 'Gene Coverage(CDS)'
          },
          option: {
            geneCoverage: {
              ___x2000Cov: '2000X',
              ___x3000Cov: '3000X'
            }
          }
        }
      }
    },
    caseDetailGenePreview: {
      ___psTitle: 'Prediction Scores',
      ___pdTitle: 'Population Databases',
      tab: {
        title: {
          ___display: 'Display DB',
          ___select: 'DB select'
        },
        info: {
          select: {
            ___ps: '<b style=color:#003679>You can select {limit} databases <span>({count} of {limit} databases selected)</span> to show on the table.</b>'
          }
        }
      }
    },
    caseDetailRegionGene: {
      ___title: 'Genes List'
    },
    caseDetailRegionQuality: {
      ___title: 'Quality and Info',
      ___infoTitle: 'Info',
      pass: {
        genotypeQuality: {
          ___pass: 'Quality ≥ 15, pass.',
          ___noPass: 'Quality < 15, no pass.'
        }
      },
      table: {
        default: {
          title: {
            ___genotype: 'Genotype',
            ___filter: 'Filter',
            ___genotypeQuality: 'Genotype Quality',
            ___phredScaled: 'The phred-scaled genotype likelihoods',
            ___PairedRead: 'Paired Read',
            ___SplitRead: 'Split Read'
          }
        },
        info: {
          title: {
            ___IMPRECISE: 'IMPRECISE',
            ___Confidence: 'Confidence interval around position',
            ___SV_Length: 'SV Insert Length',
            ___BF: 'BF',
            ___RATIO: 'RATIO',
            ___SV_Sequence: 'SV Insert Sequence'
          }
        }
      }
    },
    caseDetailRegionVariant: {
      ___title: 'Variant Databases',
      tab: {
        title: {
          ___dbVar: 'dbVar',
          ___DECIPHER: 'DECIPHER'
        }
      }
    },
    caseDetailRegionPublication: {
      ___title: 'Population Databases',
      tab: {
        title: {
          ___gnomAD_SV: 'gnomAD SV',
          ___dbVar: 'dbVar',
          ___JSV2: 'JSV2',
          ___CoLoRSdb: 'CoLoRSdb'
        }
      }
    },
    caseDetailRegionCaller: {
      ___title: 'Detail of {count} Support Caller | Detail of {count} Support Callers',
      table: {
        title: {
          ___caller: 'Caller',
          ___description: 'Description'
        }
      }
    },
    caseEdit: {
      modal: {
        content: {
          ___changeOwner: '<span style="color:#FA3D3D">Once you change the owner, the case will be transferred from {old_owner} to {new_owner}. Do you want to transfer it?</span>'
        }
      }
    },
    caseDigitalMLPA: {
      ___title: 'DigitalMLPA',
      ___empty: 'No Result inside',
      card: {
        title: {
          ___created: 'Created'
        }
      },
      top: {
        icon: {
          title: {
            ___delete: 'Delete'
          }
        }
      },
      modal: {
        content: {
          ___deleteAlert: '<span style="color:#FA3D3D">If you delete this analysis, all the content inside will also be deleted. Do you want to delete the analysis?</span>'
        }
      }
    },
    caseFile: {
      ___title: 'Data Information',
      vcf: {
        ___snvTitle: 'SNV/INDEL VCF File',
        ___svTitle: 'SV VCF File',
        ___strTitle: 'STR VCF File (ExpansionHunter/TRGT/Straglr)'
      },
      fastq: {
        ___title: 'Fastq Files',
        ___file: '<b>Set{set}-{read}: </b>{file}',
        infoTitle: {
          ___omics: 'Omics',
          ___pipeline: 'Pipeline',
          ___libraryType: 'Library Type',
          ___totalBases: 'Total Bases'
        }
      },
      ubam: {
        ___title: 'uBAM Files',
        ___file: '<b>Set{set}: </b>{file}',
        infoTitle: {
          ___omics: 'Omics',
          ___pipeline: 'Pipeline',
          ___libraryType: 'Library Type',
          ___totalBases: 'Total Bases'
        }
      },
      limit: {
        ___limitInfo: 'Due to bandwidth limits, <b>users are allowed to download large files (e.g., BAM files) once by default</b>. If you need additional quota, please contact our sales representative.',
        ___limitAlert: 'can only be download ONCE',
        ___times: 'Downloaded times: {times}'
      }
    },
    caseAnalysisVersion: {
      ___title: 'Analysis Version',
      mainData: {
        title: {
          ___pipeline: 'Pipeline Version <span>(Step1 of analysis)</span>',
          ___analysis: 'Annotation Version <span>(Step2 of analysis)</span>'
        }
      },
      tableData: {
        pipeline: {
          category: {
            ___Hardware_Accelerated_Pipeline: 'Hardware-Accelerated Pipeline',
            ___GPU_Accelerated_Pipeline_Wrapper: 'GPU-Accelerated Pipeline Wrapper',
            ___Read_Aligner_GPU_Accelerated: 'Read Aligner (GPU-Accelerated)',
            ___Read_Aligner: 'Read Aligner',
            ___Variant_Caller_GPU_Accelerated: 'Variant Caller (GPU-Accelerated)',
            ___Variant_Caller_Mitochondria: 'Variant Caller (Mitochondria)',
            ___Variant_Phasing_Tool: 'Variant Phasing Tool',
            ___Structural_Variant_Caller: 'Structural Variant Caller',
            ___CNV_Caller_Exome_Based: 'CNV Caller (Exome-Based)',
            ___CNV_Caller_Control_Dataset: 'CNV Caller Control Dataset',
            ___CNV_Caller_WGS: 'CNV Caller (WGS)',
            ___Repeat_Expansion_Caller: 'Repeat Expansion Caller',
            ___HLA_Aligner: 'HLA Aligner',
            ___HLA_Genotyper: 'HLA Genotyper',
            ___Methylation_Caller: 'Methylation Caller',
            ___Pharmacogenomics_Tools: 'Pharmacogenomics Tools'
          },
          name: {
            ___DRAGEN: 'DRAGEN',
            ___Parabrick_pbrun: 'Parabrick pbrun',
            ___Parabrick_BWA_mem: 'Parabrick BWA mem',
            ___Parabricks_Minimap2: 'Parabricks Minimap2',
            ___Minimap2: 'Minimap2',
            ___Parabrick_deepvariant: 'Parabrick deepvariant',
            ___Mitorsaw: 'Mitorsaw',
            ___GATK: 'GATK',
            ___WhatsHap: 'WhatsHap',
            ___Hiphase: 'Hiphase',
            ___Manta: 'Manta',
            ___CuteSV: 'CuteSV',
            ___Sawfish: 'Sawfish',
            ___MitoSAlt: 'MitoSAlt',
            ___Sniffles: 'Sniffles',
            ___ExomeDepth: 'ExomeDepth',
            ___ExomeDepth_Baseline: 'ExomeDepth Baseline',
            ___CNVpytor: 'CNVpytor',
            ___ExpansionHunter: 'ExpansionHunter',
            ___TRGT: 'TRGT',
            ___Straglr: 'Straglr',
            ___HISAT2: 'HISAT2',
            ___HISAT_genotype: 'HISAT-genotype',
            ___Methbat: 'Methbat',
            ___Modkit: 'Modkit',
            ___PharmCAT: 'PharmCAT',
            ___pb_StarPhase: 'pb-StarPhase'
          }
        },
        analysis: {
          category: {
            ___Variant_Annotation_Tools: 'Variant Annotation Tools',
            ___Variant_Annotation_Tools_Database: 'Variant Annotation Tools Database',
            ___Canonical_Transcript_Reference: 'Canonical Transcript Reference',
            ___Protein_Function_Database: 'Protein Function Database',
            ___NCBI_RefSeq_Nucleotide_Protein_Mapping: 'NCBI RefSeq Nucleotide–Protein Mapping',
            ___Structural_Variant_Database: 'Structural Variant Database',
            ___Population_Frequency_Database: 'Population Frequency Database',
            ___Clinical_Variant_Database: 'Clinical Variant Database',
            ___In_Silico_Prediction_Database: 'In Silico Prediction Database',
            ___Variant_Identifier_Database: 'Variant Identifier Database',
            ___Disease_Gene_Database: 'Disease Gene Database',
            ___Mitochondrial_Variant_Database: 'Mitochondrial Variant Database',
            ___Phenotype_Ontology_Database: 'Phenotype Ontology Database',
            ___Others: 'Others'
          },
          name: {
            ___Jannovar: 'Jannovar',
            ___VEP: 'VEP',
            ___AnnotSV: 'AnnotSV',
            ___Jannovar_DB_Version: 'Jannovar DB Version',
            ___MANE: 'MANE',
            ___UniProt: 'UniProt',
            ___Refseq_nuc_prot: 'Refseq_nuc_prot',
            ___dbVar: 'dbVar (SV)',
            ___Decipher: 'DECIPHER (SV)',
            ___GnomAD: 'gnomAD (SV)',
            ___ClinVar: 'ClinVar',
            ___Mastermind: 'Mastermind',
            ___dbNSFP: 'dbNSFP',
            ___dbscSNV: 'dbscSNV',
            ___SpliceAI: 'CI-SpliceAI',
            ___AlphaMissense: 'AlphaMissense',
            ___VARITY: 'VARITY',
            ___ESM1b: 'ESM1b',
            ___dbSNP: 'dbSNP',
            ___ESP6500: 'ESP6500',
            ___ExAC: 'ExAC',
            ___GenomeAsia_100K: 'GenomeAsia 100K',
            ___gnomAD_Exomes: 'gnomAD Exomes',
            ___gnomAD_Exomes_Coverage: 'gnomAD Exomes Coverage',
            ___gnomAD_Exomes_constraint: 'gnomAD Exomes constraint',
            ___gnomAD_Genomes: 'gnomAD Genomes',
            ___gnomAD_Genomes_Coverage: 'gnomAD Genomes Coverage',
            ___gnomAD_Genomes_mtDNA: 'gnomAD Genomes mtDNA',
            ___1000_Genomes: '1000 Genomes',
            ___TaiwanBioBank: 'Taiwan BioBank',
            ___tommo_60kjpn: 'ToMMo 60KJPN',
            ___TOPMed: 'TOPMed',
            ___OMIM: 'OMIM',
            ___Orphanet: 'Orphanet',
            ___Mondo: 'Mondo',
            ___MITOMAP: 'MITOMAP',
            ___HPO: 'HPO',
            ___Pathway: 'Pathway'
          }
        }
      }
    },
    caseDetailSVFilter: {
      ___title: 'SV Filter',
      gene: {
        ___title: 'Gene Symbol',
        ___placeholder: 'ROR1, TP53, or BRCA1...',
        selected: {
          ___title: 'Selected (The upper limit is 10 genes.)'
        }
      },
      condition: {
        ___title: 'Conditions',
        ___placeholder: 'Disease (eg: Breast Cancer)',
        selected: {
          ___title: 'Selected (The upper limit is 10 conditions.)'
        }
      },
      variantDatabase: {
        ___title: 'Variant databases',
        ClinVar: {
          ___title: 'ClinVar'
        },
        DECIPHER: {
          ___title: 'DECIPHER'
        }
      },
      afFilter: {
        ___title: 'AF filter',
        ___placeholder: '0~0.2, eg:0.01'
      },
      DosageSensitivity: {
        ___title: 'Dosage Sensitivity'
      },
      caller: {
        ___title: 'SV Callers',
        genotype: {
          ___title: 'Genotype'
        },
        svType: {
          ___title: 'SV Type'
        },
        genotypeQuality: {
          ___title: 'GQ',
          ___info: 'Genotype Quality (GQ) ≥ 30 recommended.'
        },
        numberOfCallers: {
          ___title: 'Number of Callers'
        }
      }
    },
    datasetArchiveConfirm: {
      info01: 'The following community dataset will be archived from your data pool, and any dataset associated with this community dataset will no longer be available to you.',
      info02: '<b>{count}</b> dataset will be not available. | <b>{count}</b> datasets will be not available.',
      table: {
        title: {
          ___name: 'Dataset name',
          ___owner: 'Owner',
          ___description: 'Dataset description'
        }
      }
    },
    datasetDeleteConfirm: {
      info01: 'This dataset has been shared with the community or other users. Would you like to revoke the sharing and delete the dataset?',
      info02: '<b>{count}</b> dataset will be not available. | <b>{count}</b> datasets will be not available.',
      table: {
        data: {
          ___user: 'PhenoVarDB Community'
        },
        title: {
          ___accectedUserID: 'Affected User ID (organization, email)',
          ___permission: 'Permission'
        }
      }
    },
    datasetDetail: {
      form: {
        title: {
          ___name: 'Dataset name',
          ___sampleSize: 'Sample size',
          ___user: 'Owner'
        }
      },
      table: {
        title: {
          ___caseID: 'Case ID',
          ___sex: 'Sex',
          ___birthYear: 'Age',
          ___createdAt: 'Create',
          ___updatedAt: 'Modified'
        }
      }
    },
    datasetEdit: {
      customForm: {
        shareAlert: {
          ___content: '<b>Not available</b>'
        },
        sharing: {
          ___content: 'Community'
        },
        url: {
          ___copyIconTitle: 'Copy'
        },
        user: {
          ___content: '{count} user | {count} users'
        }
      },
      form: {
        title: {
          ___shareAlert: 'Sharing',
          ___sharing: 'Sharing',
          ___url: 'Dataset URL',
          ___user: 'Users',
          ___key: 'Access Key'
        }
      }
    },
    datasetInvitationConfirm: {
      info01: '{user} has granted you access to the dataset shown above. Would you like to accept the invitation?'
    },
    datasetSelectCase: {
      ___topTitle01: 'Total samples are <b>{count}</b>.',
      ___topTitle02: 'You can import all of them with the button.',
      ___searchPlaceholder: 'Keywords of the samples',
      table: {
        title: {
          ___caseID: 'Case ID',
          ___sex: 'Sex',
          ___birthYear: 'Age',
          ___createdAt: 'Create',
          ___updatedAt: 'Modified',
          ___phenotypeDatas: 'Phenotype',
          ___genePanels: 'Gene / Disease panel'
        }
      }
    },
    datasetShareEdit: {
      form: {
        title: {
          ___user: 'User',
          ___permission: 'Permission',
          ___email: 'E-mail'
        }
      }
    },
    editChapter: {
      form: {
        title: {
          ___title: 'Name of the section',
          ___newTitle: 'Name of the new section',
          ___description: 'Description of the section'
        },
        placeholder: {
          ___title: 'New section',
          ___description: 'Please type the introduction or description of the section.'
        }
      }
    },
    editCNVToChapter: {
      ___editTitle: 'Edit the new SV',
      ___newTitle: 'Create a new SV',
      ___geneTitle: 'Enter relevant gene symbols',
      ___chapterTitle: 'Select at least one section',
      cnvForm: {
        placeholder: {
          ___chrom: 'Chr',
          ___posStart: 'Start Position',
          ___posEnd: 'End Position'
        }
      },
      geneTag: {
        ___placeholder: 'Gene name'
      },
      modal: {
        content: {
          ___deleteCNV: '<span style="color:#FA3D3D">If you delete this variant, all the content inside will also be deleted. Do you want to delete the variant?</span>'
        }
      }
    },
    editPanel: {
      form: {
        title: {
          ___panel: 'New panel name'
        },
        placeholder: {
          ___panel: 'Please create a new panel name'
        }
      }
    },
    editReportCNV: {
      ___typeTitle: 'Change mutation classification of the SV',
      ___gtTitle: 'Change GT of SV',
      ___intronTitle: 'Change intron / exon of the SV',
      ___lengthTitle: 'Change length of the SV',
      cnvForm: {
        title: {
          ___type: 'Select a type of the <b>SV</b>',
          ___parentalOrigin: 'Select a Parental Origin of <b>SV</b>'
        },
        placeholder: {
          ___gt: 'GT of SV',
          ___intron: 'intron / exon of the SV',
          ___length: 'length of the SV'
        }
      }
    },
    editReportSV: {
      ___typeTitle: 'Change mutation classification of the SV',
      ___gtTitle: 'Change GT of SV',
      ___intronTitle: 'Change intron / exon of the SV',
      ___lengthTitle: 'Change length of the SV',
      svForm: {
        title: {
          ___type: 'Select a type of the <b>SV</b>',
          ___parentalOrigin: 'Select a Parental Origin of <b>SV</b>'
        },
        placeholder: {
          ___gt: 'GT of SV',
          ___intron: 'intron / exon of the SV',
          ___length: 'length of the SV'
        }
      }
    },
    editReportVariant: {
      ___acmgTitle: 'Change the ACMG classification of the variant',
      ___siftPolyphen2Title: 'Change the SIFT & Polyphen2 classification of the variant',
      variantForm: {
        title: {
          ___acmg: 'Select a classification',
          ___sift: 'Select a classification of <b>SIFT</b>',
          ___polyphen2: 'Select a classification of <b>Polyphen2</b>',
          ___parentalOrigin: 'Select a Parental Origin'
        }
      }
    },
    fileCloud: {
      ___title: 'List of google bucket file',
      ___subtitle: 'Please select SINGLE file to upload.'
    },
    editWorkgroupMember: {
      form: {
        title: {
          ___member: 'Member',
          ___newMember: 'New member',
          ___role: 'Role'
        },
        placeholder: {
          ___member: 'ex: InheriNext@compassbioinfo.com',
          ___role: 'Please Select a Role'
        }
      }
    },
    editWorkgroupCase: {
      ___title: 'Case list',
      ___info: '{count} case selected | {count} case selected | {count} cases selected',
      ___searchPlaceholder: 'Type Keywords of case ID to search',
      table: {
        title: {
          ___Case_ID: 'Case ID',
          ___Sex: 'Sex',
          ___Age: 'Age',
          ___Created_date: 'Created date',
          ___Modified_date: 'Modified date',
          ___Stage: 'Stage',
          ___Workgroup: 'Workgroup'
        },
        alert: {
          ___added: 'The case has been added to the workgroup.'
        },
        pageDisplay: {
          ___item: '{count} case | {count} cases',
          ___jump: 'Go to'
        }
      },
      modal: {
        content: {
          ___checkAutoShare: '<span>Do you want to automatically share your future cases with this workgroup?</span>'
        }
      }
    },
    editWorkgroupStage: {
      form: {
        title: {
          ___stage: 'stage',
          ___newStage: 'New stage',
          ___assignee: 'Assignee'
        },
        placeholder: {
          ___stage: 'Please enter a maximum of 20 characters for the stage.',
          ___assignee: 'Please Select a member'
        }
      }
    },
    genePanelConfirm: {
      ___info01: 'The following list is the modified detail, please confirm again before update.',
      block: {
        title: {
          ___add: 'Add',
          ___remove: 'Remove'
        },
        content: {
          ___geneFreeTyping: 'Gene-Free typing',
          ___geneUserDefined: 'Gene-User defined',
          ___panel: 'Panel',
          ___hpoPhenotypes: 'HPO phenotypes',
          ___conditions: 'Conditions',
          ___pathways: 'Pathways'
        }
      }
    },
    genePanelInfo: {
      ___info01: 'Welcome to <b>Gene panel tool</b>,',
      ___info02: 'a free and public search tool.',
      ___info03: '<span>Please leave your information first, thank you.</span>',
      form: {
        title: {
          ___name: 'Your Name',
          ___organization: 'Organization',
          ___email: 'Your Email'
        },
        errorTitle: {
          ___name: 'Name',
          ___organization: 'Organization',
          ___email: 'E-mail'
        },
        placeholder: {
          ___name: 'Ex: Eric Tsai or 李大平',
          ___organization: 'Ex: Taiwan Biobank or 康百事生物資訊股份有限公司',
          ___email: 'Your E-mail eg: info@compassbioinfo.com'
        }
      }
    },
    genePanelQuickSelection: {
      ___title: 'Quick selection by Division',
      block: {
        subtitle: {
          ___panel01: 'Default',
          ___panel02: 'Gene counts'
        },
        content: {
          ___division: 'Panel counts'
        }
      }
    },
    projectEdit: {
      form: {
        title: {
          ___import: 'Import Parameters'
        },
        placeholder: {
          ___import: 'Select a analysis'
        }
      },
      modal: {
        content: {
          ___unknownSexAlert: '<span style="color:#FA3D3D">Unknown sex may affect subsequent analysis results. Would you like to continue?</span>'
        }
      }
    },
    selectDataset: {
      ___description: 'Please choose the format before creating a case.<br>InheriNext also support creating VCF cases by batch-upload.',
      select: {
        title: {
          ___vcf: 'VCF',
          ___fastq: 'FASTQ',
          ___ubam: 'uBAM'
        },
        description: {
          ___vcf: '<b>{price}</b> points/case',
          ___fastq: '<b>{price}</b> points/case',
          ___ubam: '<b>{price}</b> points/case'
        },
        option: {
          ___batch: 'Batch-upload'
        }
      }
    },
    userAvatar: {
      ___userTitle: 'Select a avatar from default set or upload from drive',
      ___customTitle: 'Custom avatar'
    },
    userConfirm: {
      ___mainTitle: 'Success !',
      ___title01: 'We\'ve sent a verification code to your E-mail address.',
      ___title02: 'Please enter verification code to login.',
      form: {
        title: {
          ___code: 'Verification'
        },
        placeholder: {
          ___code: '6 digits code'
        }
      }
    },
    intractableDiseaseSelect: {
      ___title: 'D006-4 遺伝学的検査疾患名'
    },
    chatbot: {
      ___busyTitle: 'All instances are busy, please wait 10 minutes and retry again.',
      ___inputPlaceholder: 'tell me about KABUKI SYNDROME',
      ___deleteAlert: 'This converstion will be deleted!<br>Would you like to continue?',
      agent: {
        ___title: 'AI agent summary'
      },
      button: {
        default: {
          clinVar: {
            ___title: 'Information of variant annotation in ClinVar, e.g. the clinical significance of chr3:37042330C>T variant',
            ___content: 'What is the clinical significance of chr3:37042330C>T variant?'
          },
          caseReports: {
            ___title: 'Source links for case reports on the variant, e.g. the case reports of chr1:69589G>A variant',
            ___content: 'What are the case reports of chr1:69589G>A variant?'
          },
          prevalence: {
            ___title: 'Provide the prevalence, etiology and inheritance of the disease, e.g. the prevalence of Kabuki Syndrome',
            ___content: 'What is the prevalence of Kabuki Syndrome?'
          },
          disease: {
            ___title: 'References and source links for the disease, e.g. the references related to Alzheimer disease',
            ___content: 'What are the references related to Alzheimer disease?'
          }
        }
      }
    }

  },
  // constant
  CONSTANT: {
    data: {
      countryCode: {
        name: {
          ___AF: 'Afghanistan',
          ___AX: 'Aland Islands',
          ___AL: 'Albania',
          ___DZ: 'Algeria',
          ___AS: 'American Samoa',
          ___AD: 'Andorra',
          ___AO: 'Angola',
          ___AI: 'Anguilla',
          ___AQ: 'Antarctica',
          ___AG: 'Antigua and Barbuda',
          ___AR: 'Argentina',
          ___AM: 'Armenia',
          ___AW: 'Aruba',
          ___AU: 'Australia',
          ___AT: 'Austria',
          ___AZ: 'Azerbaijan',
          ___BS: 'Bahamas',
          ___BH: 'Bahrain',
          ___BD: 'Bangladesh',
          ___BB: 'Barbados',
          ___BY: 'Belarus',
          ___BE: 'Belgium',
          ___BZ: 'Belize',
          ___BJ: 'Benin',
          ___BM: 'Bermuda',
          ___BT: 'Bhutan',
          ___BO: 'Bolivia',
          ___BQ: 'Bonaire, Saint Eustatius and Saba ',
          ___BA: 'Bosnia and Herzegovina',
          ___BW: 'Botswana',
          ___BV: 'Bouvet Island',
          ___BR: 'Brazil',
          ___IO: 'British Indian Ocean Territory',
          ___VG: 'British Virgin Islands',
          ___BN: 'Brunei',
          ___BG: 'Bulgaria',
          ___BF: 'Burkina Faso',
          ___BI: 'Burundi',
          ___KH: 'Cambodia',
          ___CM: 'Cameroon',
          ___CA: 'Canada',
          ___CV: 'Cape Verde',
          ___KY: 'Cayman Islands',
          ___CF: 'Central African Republic',
          ___TD: 'Chad',
          ___CL: 'Chile',
          ___CN: 'China',
          ___CX: 'Christmas Island',
          ___CC: 'Cocos Islands',
          ___CO: 'Colombia',
          ___KM: 'Comoros',
          ___CK: 'Cook Islands',
          ___CR: 'Costa Rica',
          ___HR: 'Croatia',
          ___CU: 'Cuba',
          ___CW: 'Curacao',
          ___CY: 'Cyprus',
          ___CZ: 'Czech Republic',
          ___CD: 'Democratic Republic of the Congo',
          ___DK: 'Denmark',
          ___DJ: 'Djibouti',
          ___DM: 'Dominica',
          ___DO: 'Dominican Republic',
          ___TL: 'East Timor',
          ___EC: 'Ecuador',
          ___EG: 'Egypt',
          ___SV: 'El Salvador',
          ___GQ: 'Equatorial Guinea',
          ___ER: 'Eritrea',
          ___EE: 'Estonia',
          ___ET: 'Ethiopia',
          ___FK: 'Falkland Islands',
          ___FO: 'Faroe Islands',
          ___FJ: 'Fiji',
          ___FI: 'Finland',
          ___FR: 'France',
          ___GF: 'French Guiana',
          ___PF: 'French Polynesia',
          ___TF: 'French Southern Territories',
          ___GA: 'Gabon',
          ___GM: 'Gambia',
          ___GE: 'Georgia',
          ___DE: 'Germany',
          ___GH: 'Ghana',
          ___GI: 'Gibraltar',
          ___GR: 'Greece',
          ___GL: 'Greenland',
          ___GD: 'Grenada',
          ___GP: 'Guadeloupe',
          ___GU: 'Guam',
          ___GT: 'Guatemala',
          ___GG: 'Guernsey',
          ___GN: 'Guinea',
          ___GW: 'Guinea-Bissau',
          ___GY: 'Guyana',
          ___HT: 'Haiti',
          ___HM: 'Heard Island and McDonald Islands',
          ___HN: 'Honduras',
          ___HK: 'Hong Kong',
          ___HU: 'Hungary',
          ___IS: 'Iceland',
          ___IN: 'India',
          ___ID: 'Indonesia',
          ___IR: 'Iran',
          ___IQ: 'Iraq',
          ___IE: 'Ireland',
          ___IM: 'Isle of Man',
          ___IL: 'Israel',
          ___IT: 'Italy',
          ___CI: 'Ivory Coast',
          ___JM: 'Jamaica',
          ___JP: 'Japan',
          ___JE: 'Jersey',
          ___JO: 'Jordan',
          ___KZ: 'Kazakhstan',
          ___KE: 'Kenya',
          ___KI: 'Kiribati',
          ___XK: 'Kosovo',
          ___KW: 'Kuwait',
          ___KG: 'Kyrgyzstan',
          ___LA: 'Laos',
          ___LV: 'Latvia',
          ___LB: 'Lebanon',
          ___LS: 'Lesotho',
          ___LR: 'Liberia',
          ___LY: 'Libya',
          ___LI: 'Liechtenstein',
          ___LT: 'Lithuania',
          ___LU: 'Luxembourg',
          ___MO: 'Macao',
          ___MK: 'Macedonia',
          ___MG: 'Madagascar',
          ___MW: 'Malawi',
          ___MY: 'Malaysia',
          ___MV: 'Maldives',
          ___ML: 'Mali',
          ___MT: 'Malta',
          ___MH: 'Marshall Islands',
          ___MQ: 'Martinique',
          ___MR: 'Mauritania',
          ___MU: 'Mauritius',
          ___YT: 'Mayotte',
          ___MX: 'Mexico',
          ___FM: 'Micronesia',
          ___MD: 'Moldova',
          ___MC: 'Monaco',
          ___MN: 'Mongolia',
          ___ME: 'Montenegro',
          ___MS: 'Montserrat',
          ___MA: 'Morocco',
          ___MZ: 'Mozambique',
          ___MM: 'Myanmar',
          ___NA: 'Namibia',
          ___NR: 'Nauru',
          ___NP: 'Nepal',
          ___NL: 'Netherlands',
          ___NC: 'New Caledonia',
          ___NZ: 'New Zealand',
          ___NI: 'Nicaragua',
          ___NE: 'Niger',
          ___NG: 'Nigeria',
          ___NU: 'Niue',
          ___NF: 'Norfolk Island',
          ___KP: 'North Korea',
          ___MP: 'Northern Mariana Islands',
          ___NO: 'Norway',
          ___OM: 'Oman',
          ___PK: 'Pakistan',
          ___PW: 'Palau',
          ___PS: 'Palestinian Territory',
          ___PA: 'Panama',
          ___PG: 'Papua New Guinea',
          ___PY: 'Paraguay',
          ___PE: 'Peru',
          ___PH: 'Philippines',
          ___PN: 'Pitcairn',
          ___PL: 'Poland',
          ___PT: 'Portugal',
          ___PR: 'Puerto Rico',
          ___QA: 'Qatar',
          ___CG: 'Republic of the Congo',
          ___RE: 'Reunion',
          ___RO: 'Romania',
          ___RU: 'Russia',
          ___RW: 'Rwanda',
          ___BL: 'Saint Barthelemy',
          ___SH: 'Saint Helena',
          ___KN: 'Saint Kitts and Nevis',
          ___LC: 'Saint Lucia',
          ___MF: 'Saint Martin',
          ___PM: 'Saint Pierre and Miquelon',
          ___VC: 'Saint Vincent and the Grenadines',
          ___WS: 'Samoa',
          ___SM: 'San Marino',
          ___ST: 'Sao Tome and Principe',
          ___SA: 'Saudi Arabia',
          ___SN: 'Senegal',
          ___RS: 'Serbia',
          ___SC: 'Seychelles',
          ___SL: 'Sierra Leone',
          ___SG: 'Singapore',
          ___SX: 'Sint Maarten',
          ___SK: 'Slovakia',
          ___SI: 'Slovenia',
          ___SB: 'Solomon Islands',
          ___SO: 'Somalia',
          ___ZA: 'South Africa',
          ___GS: 'South Georgia and the South Sandwich Islands',
          ___KR: 'South Korea',
          ___SS: 'South Sudan',
          ___ES: 'Spain',
          ___LK: 'Sri Lanka',
          ___SD: 'Sudan',
          ___SR: 'Suriname',
          ___SJ: 'Svalbard and Jan Mayen',
          ___SZ: 'Swaziland',
          ___SE: 'Sweden',
          ___CH: 'Switzerland',
          ___SY: 'Syria',
          ___TW: 'Taiwan',
          ___TJ: 'Tajikistan',
          ___TZ: 'Tanzania',
          ___TH: 'Thailand',
          ___TG: 'Togo',
          ___TK: 'Tokelau',
          ___TO: 'Tonga',
          ___TT: 'Trinidad and Tobago',
          ___TN: 'Tunisia',
          ___TR: 'Turkey',
          ___TM: 'Turkmenistan',
          ___TC: 'Turks and Caicos Islands',
          ___TV: 'Tuvalu',
          ___VI: 'U.S. Virgin Islands',
          ___UG: 'Uganda',
          ___UA: 'Ukraine',
          ___AE: 'United Arab Emirates',
          ___GB: 'United Kingdom',
          ___US: 'United States',
          ___UM: 'United States Minor Outlying Islands',
          ___UY: 'Uruguay',
          ___UZ: 'Uzbekistan',
          ___VU: 'Vanuatu',
          ___VA: 'Vatican',
          ___VE: 'Venezuela',
          ___VN: 'Vietnam',
          ___WF: 'Wallis and Futuna',
          ___EH: 'Western Sahara',
          ___YE: 'Yemen',
          ___ZM: 'Zambia',
          ___ZW: 'Zimbabwe'
        }
      }
    },
    global: {
      data: {
        caseDataTypeMetadatas: {
          tag: {
            title: {
              ___intractableDisease: 'D006-4',
              ___designatedIntractableDisease: '指定難病',
              ___pgp: 'Phenotype',
              ___gene_filter: 'Gene Panel',
              ___str: 'STR',
              ___nbs_pathovar: 'Pathogenic Variants',
              ___nbs_nullvar: 'Null Variants',
              ___nbs_carrier: 'Carrier',
              ___incidental: 'Incidental findings',
              ___monitor: 'Monitor',
              ___filter: 'Filter',
              ___clinvar: 'ClinVar',
              ___nbs: 'nbs',
              ___nbs_nonmendelian: 'Nonmendelian'
            }
          }
        },
        predictionMetaDataDisplayTitles: {
          ___Damaging: 'Damaging',
          ___Tolerated: 'Tolerated',
          ___ProbablyDamaging: 'Probably Damaging',
          ___PossiblyDamaging: 'Possibly Damaging',
          ___Benign: 'Benign',
          ___High: 'High',
          ___Medium: 'Medium',
          ___Low: 'Low',
          ___Neutral: 'Neutral',
          ___Splicealtering: 'Splice-altering',
          ___Conserved: 'Conserved',
          ___Nonconserved: 'Non-conserved',
          ___Likelyorpossiblypathogenic: 'Likely or possibly pathogenic',
          ___Likelyorpossiblybenign: 'Likely or possibly benign',
          ___Ambiguous: 'Ambiguous',
          ___Likelybenign: 'Likely benign',
          ___LikelyPathogenic: 'Likely pathogenic'
        },
        getClinvarStatisticData: {
          ___title: 'Coding Impact',
          ___Pathogenic: 'Pathogenic',
          ___Likely_pathogenic: 'Likely Pathogenic',
          ___Conflicting_interpretations_of_pathogenicity: 'Conflicting interpretations of pathogenicity',
          ___Uncertain_significance: 'Uncertain Significance',
          ___Likely_benign: 'Likely benign',
          ___Benign: 'Benign',
          ___stop_gained: 'Stop Gained',
          ___splice_site: 'Splice Site',
          ___frameshift: 'Frameshift Variant',
          ___stop_lost: 'Stop Lost',
          ___start_lost: 'Start Lost',
          ___missense: 'Missense',
          ___inframe_indel: 'Inframe Indel',
          ___synonymous: 'Synonymous Variant',
          ___non_coding: 'Non Coding',
          ___total: 'Total'
        },
        clinvarACMGMap: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___PathogenicLikelypathogenic: 'Pathogenic/Likely pathogenic',
            ___Likelypathogenic: 'Likely pathogenic',
            ___Conflictinginterpretationsofpathogenicity: 'Conflicting interpretations of pathogenicity',
            ___Conflictingclassificationsofpathogenicity: 'Conflicting classifications of pathogenicity',
            ___Uncertainsignificance: 'Uncertain significance',
            ___riskfactor: 'risk factor',
            ___Benign: 'Benign',
            ___BenignLikelybenign: 'Benign/Likely benign',
            ___Likelybenign: 'Likely benign',
            ___drugresponse: 'drug response',
            ___protective: 'protective',
            ___other: 'other',
            ___Affects: 'Affects',
            ___vus: 'VUS'
          },
          display: {
            ___Pathogenic: 'Pathogenic',
            ___PathogenicLikelypathogenic: 'Pathogenic/Likely pathogenic',
            ___Likelypathogenic: 'Likely pathogenic',
            ___Conflictinginterpretationsofpathogenicity: 'Conflicting interpretations of pathogenicity',
            ___Conflictingclassificationsofpathogenicity: 'Conflicting classifications of pathogenicity',
            ___Uncertainsignificance: 'Uncertain significance',
            ___riskfactor: 'risk factor',
            ___Benign: 'Benign',
            ___BenignLikelybenign: 'Benign/Likely benign',
            ___Likelybenign: 'Likely benign',
            ___drugresponse: 'drug response',
            ___protective: 'protective',
            ___other: 'other',
            ___Affects: 'Affects',
            ___vus: 'VUS'
          }
        },
        repeatClassificationMap: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___Indeterminate: 'Indeterminate',
            ___Intermediate: 'Intermediate',
            ___Normal: 'Normal'
          }
        },
        acmgMap: {
          info: {
            ___BA1: 'Allele frequency is >5% in population databases.',
            ___BS1: 'Allele frequency is greater than expected for disorder.',
            ___BS2: 'Observed in a healthy adult individual for a recessive (homozygous), dominant (heterozygous), or X-linked (hemizygous) disorder, with full penetrance expected at an early age.',
            ___BS4: 'Lack of segregation in affected members of a family.',
            ___BS3: 'Well-established in vitro or in vivo functional studies show no damaging effect on protein function or splicing.',
            ___BP2: 'Observed in trans with a pathogenic variant for a fully penetrant dominant gene/disorder or observed in cis with a pathogenic variant in any inheritance pattern.',
            ___BP5: 'Variant found in a case with an alternate molecular basis for disease.',
            ___BP1: 'Missense variant in a gene for which primarily truncating variants are known to cause disease.',
            ___BP3: 'In-frame deletions/insertions in a repetitive region without a known function.',
            ___BP4: 'Multiple lines of computational evidence suggest no impact on gene or gene product (conservation, evolutionary, splicing impact, etc.).',
            ___BP7: 'A synonymous (silent) variant for which splicing prediction algorithms predict no impact to the splice consensus sequence nor the creation of a new splice site AND the nucleotide is not highly conserved.',
            ___BP6: 'Reputable source recently reports variant as benign, but the evidence is not available to the laboratory to perform an independent evaluation.',
            ___PP1: 'Cosegregation with disease in multiple affected family members in a gene definitively known to cause the disease.',
            ___PP2: 'Missense variant in a gene that has a low rate of benign missense variation and in which missense variants are a common mechanism of disease.',
            ___PP3: 'Multiple lines of computational evidence support a deleterious effect on the gene or gene product (conservation, evolutionary, splicing impact, etc.).',
            ___PP4: 'Patient’s phenotype or family history is highly specific for a disease with a single genetic etiology.',
            ___PP5: 'Reputable source recently reports variant as pathogenic, but the evidence is not available to the laboratory to perform an independent evaluation.',
            ___PM2: 'Absent from controls (or at extremely low frequency if recessive) in population databases.',
            ___PM3: 'For recessive disorders, detected in trans with a pathogenic variant.',
            ___PM6: 'Assumed de novo, but without confirmation of paternity and maternity.',
            ___PM1: 'Located in a mutational hot spot and/or critical and well-established functional domain (e.g., active site of an enzyme) without benign variation.',
            ___PM4: 'Protein length changes as a result of in-frame deletions/insertions in a nonrepeat region or stop-loss variants.',
            ___PM5: 'Novel missense change at an amino acid residue where a different missense change determined to be pathogenic has been seen before.',
            ___PS4: 'The prevalence of the variant in affected individuals is significantly increased compared with the prevalence in controls.',
            ___PS2: 'De novo (both maternity and paternity confirmed) in a patient with the disease and no family history.',
            ___PS1: 'Same amino acid change as a previously established pathogenic variant regardless of nucleotide change.',
            ___PS3: 'Well-established in vitro or in vivo functional studies supportive of a damaging effect on the gene or gene product.',
            ___PVS1: 'null variant (nonsense, frameshift, canonical ±1 or 2 splice sites, initiation codon, single or multiexon deletion) in a gene where LOF is a known mechanism of disease.'
          },
          explanations: {
            ___BA1: '// EXPLANATIONS',
            ___BS1: '// EXPLANATIONS',
            ___BS2: '// EXPLANATIONS',
            ___BS4: '// EXPLANATIONS',
            ___BS3: '// EXPLANATIONS',
            ___BP2: '// EXPLANATIONS',
            ___BP5: '// EXPLANATIONS',
            ___BP1: '// EXPLANATIONS',
            ___BP3: '// EXPLANATIONS',
            ___BP4: '// EXPLANATIONS',
            ___BP7: '// EXPLANATIONS',
            ___BP6: '// EXPLANATIONS',
            ___PP1: '// EXPLANATIONS',
            ___PP2: '// EXPLANATIONS',
            ___PP3: '// EXPLANATIONS',
            ___PP4: '// EXPLANATIONS',
            ___PP5: '// EXPLANATIONS',
            ___PM2: '// EXPLANATIONS',
            ___PM3: '// EXPLANATIONS',
            ___PM6: '// EXPLANATIONS',
            ___PM1: '// EXPLANATIONS',
            ___PM4: '// EXPLANATIONS',
            ___PM5: '// EXPLANATIONS',
            ___PS4: '// EXPLANATIONS',
            ___PS2: '// EXPLANATIONS',
            ___PS1: '// EXPLANATIONS',
            ___PS3: '// EXPLANATIONS',
            ___PVS1: '// EXPLANATIONS'
          }
        },
        datasetStatusMap: {
          title: {
            ___created: 'created',
            ___analyzing: 'Analyzing…',
            ___completed: 'Done',
            ___failed: 'Failed',
            ___disabled: 'Disabled'
          }
        },
        datasetPermissionTypeMap: {
          title: {
            ___private: 'Private',
            ___community: 'Community'
          }
        },
        datasetPermissionMap: {
          title: {
            ___private: 'Private',
            ___basic: 'Basic',
            ___explore: 'Data Explore',
            ___full: 'Full access'
          }
        },
        datasetInvitationPermissionMap: {
          title: {
            ___explore: 'Data Explore',
            ___full: 'Full access'
          }
        },
        datasetPipelineMap: {
          title: {
            ___WES: 'Whole Exome Sequencing',
            ___WGS: 'Whole Genome Sequencing'
          }
        },
        datasetShareAlert: {
          ___external_data_included: 'Because it contains community data. If you want to share dataset, create a dataset with all your data.',
          ___disabled: 'Because dataset is disable',
          ___analyzing: 'Because data analysis is processing',
          ___failed: 'Because data analysis is failed'
        },
        windowConfirm: {
          ___default: 'Do you really want to leave? you have unsaved changes!'
        },
        defaultEmptyDisplay: {
          ___empty: 'N/A',
          ___noKey: '?'
        },
        pageDisplay: {
          ___item: '{count} item | {count} items',
          ___display: 'Items per page',
          ___jump: 'Go to',
          ___page: 'Page'
        },
        projectState: {
          ___created: 'no data',
          ___uploading: 'Uploading',
          ___analyzing: 'Analyzing',
          ___completed: 'Completed',
          ___failed: 'Analysis Failed',
          ___noAffected: 'Not affected'
        },
        jobState: {
          ___running: 'Pipeline',
          ___default: 'Phenotype'
        },
        familyRelationOptions: {
          title: {
            ___Father: 'Father',
            ___Mother: 'Mother',
            ___Brother: 'Brother',
            ___Sister: 'Sister',
            ___PaternalGrandfather: 'Paternal Grandfather',
            ___PaternalGrandmother: 'Paternal Grandmother',
            ___MaternalGrandfather: 'Maternal Grandfather',
            ___MaternalGrandmother: 'Maternal Grandmother',
            ___PaternalUncle: 'Paternal Uncle',
            ___PaternalAunt: 'Paternal Aunt',
            ___MaternalUncle: 'Maternal Uncle',
            ___MaternalAunt: 'Maternal Aunt'
          }
        },
        svClinvarOptions: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___Likely_Pathogenic: 'Likely Pathogenic',
            ___Benign: 'Benign',
            ___Likely_Benign: 'Likely Benign',
            ___Variant_of_Uncertain_Significance: 'Uncertain Significance',
            ___Conflicting_interpretations_of_pathogenicity: 'Conflicting interpretations of pathogenicity'
          },
          subtitle: {
            ___Pathogenic: 'Pathogenic',
            ___Likely_Pathogenic: 'Likely Pathogenic',
            ___Benign: 'Benign',
            ___Likely_Benign: 'Likely Benign',
            ___Variant_of_Uncertain_Significance: 'Uncertain Significance',
            ___Conflicting_interpretations_of_pathogenicity: 'Conflicting interpretations of pathogenicity'
          }
        },
        svDECIPHEROptions: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___Likely_Pathogenic: 'Likely Pathogenic',
            ___Benign: 'Benign',
            ___Likely_Benign: 'Likely Benign',
            ___Uncertain_Significance: 'Uncertain Significance',
            ___Others: 'Others'
          },
          subtitle: {
            ___Pathogenic: 'Pathogenic',
            ___Likely_Pathogenic: 'Likely Pathogenic',
            ___Benign: 'Benign',
            ___Likely_Benign: 'Likely Benign',
            ___Uncertain_Significance: 'Uncertain Significance',
            ___Others: 'Others'
          }
        },
        svDosageSensitivityOptions: {
          title: {
            ___Sufficient_evidence_for_dosage_pathogenicity: 'Sufficient evidence for dosage pathogenicity',
            ___Some_evidence_for_dosage_pathogenicity: 'Some evidence for dosage pathogenicity',
            ___Little_evidence_for_dosage_pathogenicity: 'Little evidence for dosage pathogenicity',
            ___No_evidence_for_dosage_pathogenicity: 'No evidence for dosage pathogenicity',
            ___Evidence_suggests_the_gene_is_not_dosage_sensitive: 'Evidence suggests the gene is not dosage sensitive',
            ___Gene_associated_with_autosomal_recessive_phenotype: 'Gene associated with autosomal recessive phenotype'
          }
        },
        svGenotypeOptions: {
          title: {
            ___Homozygous_reference: 'Homozygous reference',
            ___Heterozygous: 'Heterozygous',
            ___Homozygous_alternate: 'Homozygous alternate'
          }
        },
        svTypeOptions: {
          title: {
            ___DEL: 'DEL',
            ___INS: 'INS',
            ___DUP: 'DUP',
            ___INV: 'INV',
            ___CTX: 'CTX',
            ___CNV: 'CNV',
            ___BND: 'BND'
          }
        },
        strClassificationMap: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___Indeterminate: 'Indeterminate',
            ___Intermediate: 'Intermediate',
            ___Normal: 'Normal',
            ___RU_mismatch: 'RU mismatch',
            ___Catalog_mismatch: 'Catalog mismatch'
          }
        },
        intractableDiseaseDifficutyMap: {
          title: {
            ___easy: '処理が容易なもの',
            ___hard: '処理が複雑なもの',
            ___very_hard: '処理が極めて複雑なもの'
          }
        },
        intractableDiseaseMethodMap: {
          title: {
            ___A: 'ア',
            ___I: 'イ',
            ___U: 'ウ',
            ___E: 'エ',
            ___O: 'オ'
          },
          info: {
            ___A: '<span>ＰＣＲ法、ＤＮＡシーケンス法、ＦＩＳＨ法又はサザンブロット法による場合に算定できるもの</span>',
            ___I: '<span>ＰＣＲ法による場合に算定できるもの</span>',
            ___U: '<span>ア、イ、エ及びオ以外のもの</span>',
            ___E: '<span>別に<a href=http://www.kentaikensa.jp/files/37089.pdf target=_blank>厚生労働大臣が定める施設基準に適合しているものとして地方厚生（支）局長に届け出</a>た保険医療機関において検査が行われる場合に算定できるもの</span>',
            ___O: '<span>臨床症状や他の検査等では診断がつかない場合に、別に<a href=http://www.kentaikensa.jp/files/37089.pdf target=_blank>厚生労働大臣が定める施設基準に適合しているものとして地方厚生（支）局長に届け出</a>た保険医療機関において検査が行われる場合に算定できるもの</span>'
          }
        },
        intractableDiseaseOptions: {
          title: {
            ___Duchenne_muscular_dystrophy: 'Duchenne muscular dystrophy',
            ___Becker_muscular_dystrophy: 'Becker muscular dystrophy',
            ___Familial_amyloidosis: 'Familial amyloidosis',
            ___Spinal_and_bulbar_muscular_atrophy_SBMA: 'Spinal and bulbar muscular atrophy (SBMA)',
            ___Myotonic_dystrophy: 'Myotonic dystrophy',
            ___Lysosomal_storage_diseases_including_mucopolysaccharidosis_type_I_mucopolysaccharidosis_type_II_Gaucher_disease_Fabry_disease_and_Pompe_disease: 'Lysosomal storage diseases (including mucopolysaccharidosis type I, mucopolysaccharidosis type II, Gaucher disease, Fabry disease, and Pompe disease)',
            ___Fragile_X_syndrome: 'Fragile X syndrome',
            ___TNF_receptor_associated_periodic_syndrome_TRAPS: 'TNF receptor-associated periodic syndrome (TRAPS)',
            ___Nakajo_Nishimura_syndrome: 'Nakajo-Nishimura syndrome',
            ___Familial_Mediterranean_fever: 'Familial Mediterranean fever',
            ___Bethlem_myopathy: 'Bethlem myopathy',
            ___X_linked_myopathy_with_excessive_autophagy: 'X-linked myopathy with excessive autophagy',
            ___Non_dystrophic_myotonia_syndromes: 'Non-dystrophic myotonia syndromes',
            ___Hereditary_periodic_limb_paralysis: 'Hereditary periodic (limb) paralysis',
            ___Autosomal_recessive_leukodystrophy_with_alopecia_and_spondylometaphyseal_dysplasia: 'Autosomal recessive leukodystrophy with alopecia and spondylometaphyseal dysplasia',
            ___Tuberous_sclerosis: 'Tuberous sclerosis',
            ___Pachydermoperiostosis: 'Pachydermoperiostosis',
            // ___Neurofibromatosis_Type_I: 'Neurofibromatosis Type I',
            // ___Neurofibromatosis_Type_2: 'Neurofibromatosis Type 2',
            ___Alexander_disease: 'Alexander disease',
            ___Chronic_non_specific_multiple_ulcers_of_the_small_intestine: 'Chronic non-specific multiple ulcers of the small intestine',
            ___TRPV4_related_disorder: 'TRPV4-related disorder',
            ___Fukuyama_congenital_muscular_dystrophy: 'Fukuyama congenital muscular dystrophy',
            ___Spinal_muscular_atrophy: 'Spinal muscular atrophy',
            ___Huntingtons_disease: 'Huntington\'s disease',
            ___Retinoblastoma: 'Retinoblastoma',
            ___Medullary_thyroid_carcinoma: 'Medullary thyroid carcinoma',
            ___Multiple_endocrine_neoplasia_type_1_MEN1: 'Multiple endocrine neoplasia type 1 (MEN1)',
            ___Phenylketonuria_PKU: 'Phenylketonuria (PKU)',
            ___Homocystinuria: 'Homocystinuria',
            ___Citrullinemia_type_I: 'Citrullinemia type I',
            ___Argininosuccinic_aciduria_Urea_cycle_disorder: 'Argininosuccinic aciduria (Urea cycle disorder)',
            ___Isovaleric_acidemia: 'Isovaleric acidemia',
            ___HMG_CoA_lyase_deficiency: 'HMG-CoA lyase deficiency',
            ___Multiple_carboxylase_deficiency: 'Multiple carboxylase deficiency',
            ___Glutaric_acidemia_type_1: 'Glutaric acidemia type 1',
            ___MCAD_deficiency_Medium_chain_acyl_CoA_dehydrogenase_deficiency: 'MCAD deficiency (Medium-chain acyl-CoA dehydrogenase deficiency)',
            ___VLCAD_deficiency_Very_long_chain_acyl_CoA_dehydrogenase_deficiency: 'VLCAD deficiency (Very long-chain acyl-CoA dehydrogenase deficiency)',
            ___CPT1_deficiency_Carnitine_palmitoyltransferase_I_deficiency: 'CPT1 deficiency (Carnitine palmitoyltransferase I deficiency)',
            // ___Menkes_Disease_Congenital_disorder_of_copper_metabolism: 'Menkes Disease (Congenital disorder of copper metabolism)',
            // ___Occipital_Horn_Syndrome_Congenital_disorder_of_copper_metabolism: 'Occipital Horn Syndrome (Congenital disorder of copper metabolism)',
            // ___Wilson_Disease_Congenital_disorder_of_copper_metabolism: 'Wilson Disease (Congenital disorder of copper metabolism)',
            ___Cryopyrin_associated_periodic_syndromes_CAPS: 'Cryopyrin-associated periodic syndromes (CAPS)',
            ___Neurodegeneration_with_brain_iron_accumulation_NBIA: 'Neurodegeneration with brain iron accumulation (NBIA)',
            ___Congenital_cerebral_leukodystrophy_including_central_nervous_system_hypomyelination: 'Congenital cerebral leukodystrophy (including central nervous system hypomyelination)',
            ___PCDH19_related_disorder: 'PCDH19-related disorder',
            ___Hypophosphatasia: 'Hypophosphatasia',
            ___Apert_syndrome: 'Apert syndrome',
            ___Rothmund_Thomson_syndrome: 'Rothmund-Thomson syndrome',
            ___Prader_Willi_syndrome: 'Prader-Willi syndrome',
            ___Angelman_syndrome: 'Angelman syndrome',
            ___Smith_Magenis_syndrome: 'Smith-Magenis syndrome',
            ___Fragile_X_associated_disorders: 'Fragile X-associated disorders',
            ___Wolfram_syndrome: 'Wolfram syndrome',
            ___Hyper_IgD_syndrome: 'Hyper IgD syndrome',
            ___PAPA_syndrome_Pyogenic_sterile_arthritis_pyoderma_gangrenosum_and_acne: 'PAPA syndrome (Pyogenic sterile arthritis, pyoderma gangrenosum, and acne)',
            ___Congenital_anomaly_syndromes: 'Congenital anomaly syndromes',
            ___ACTH_resistance_syndrome: 'ACTH resistance syndrome',
            ___Autosomal_recessive_punctate_epiphyseal_dysplasia_type_1_Peroxisomal_diseases_excluding_adrenoleukodystrophy: 'Autosomal recessive punctate epiphyseal dysplasia type 1(Peroxisomal diseases (excluding adrenoleukodystrophy))',
            ___Familial_partial_lipodystrophy: 'Familial partial lipodystrophy',
            ___Sotos_syndrome: 'Sotos syndrome',
            ___Carnitine_deficiency_Carnitine_palmitoyltransferase_II_deficiency: 'Carnitine deficiency (Carnitine palmitoyltransferase II deficiency)',
            ___Carnitine_deficiency_Carnitine_acylcarnitine_translocase_deficiency: 'Carnitine deficiency (Carnitine-acylcarnitine translocase deficiency)',
            ___Carnitine_deficiency_OCTN2_deficiency_Primary_carnitine_deficiency: 'Carnitine deficiency (OCTN2 deficiency (Primary carnitine deficiency))',
            ___Citrin_deficiency: 'Citrin deficiency',
            ___Non_ketotic_hyperglycinemia: 'Non-ketotic hyperglycinemia',
            ___Beta_ketothiolase_deficiency: 'Beta-ketothiolase deficiency',
            ___3_Methylglutaconic_aciduria: '3-Methylglutaconic aciduria',
            ___Glutaric_acidemia_type_2: 'Glutaric acidemia type 2',
            ___Congenital_adrenal_hypoplasia: 'Congenital adrenal hypoplasia',
            ___ATR_X_syndrome_Alpha_thalassemia_X_linked_intellectual_disability_syndrome: 'ATR-X syndrome (Alpha-thalassemia X-linked intellectual disability syndrome)',
            ___Hutchinson_Gilford_progeria_syndrome: 'Hutchinson-Gilford progeria syndrome',
            ___Achondroplasia: 'Achondroplasia',
            ___Progressive_Myoclonic_Epilepsy_Lafora_disease: 'Progressive Myoclonic Epilepsy (Lafora disease)',
            ___Sepiapterin_reductase_SR_deficiency: 'Sepiapterin reductase (SR) deficiency',
            ___Aromatic_L_amino_acid_decarboxylase_deficiency: 'Aromatic L-amino acid decarboxylase deficiency',
            ___Osler_disease_Hereditary_hemorrhagic_telangiectasia: 'Osler disease (Hereditary hemorrhagic telangiectasia)',
            ___CFC_syndrome_Cardiofaciocutaneous_syndrome: 'CFC syndrome (Cardiofaciocutaneous syndrome)',
            ___Costello_syndrome: 'Costello syndrome',
            ___CHARGE_syndrome: 'CHARGE syndrome',
            ___Lysinuric_protein_intolerance: 'Lysinuric protein intolerance',
            ___Adrenoleukodystrophy: 'Adrenoleukodystrophy',
            ___Blau_syndrome: 'Blau syndrome',
            ___Branchio_oto_renal_syndrome: 'Branchio-oto-renal syndrome',
            ___Young_Simpson_syndrome: 'Young-Simpson syndrome',
            ___Congenital_nephrogenic_diabetes_insipidus: 'Congenital nephrogenic diabetes insipidus',
            ___Vitamin_D_dependent_rickets_osteomalacia: 'Vitamin D-dependent rickets/osteomalacia',
            ___Nail_patella_syndrome_LMX1B_associated_nephropathy: 'Nail-patella syndrome / LMX1B-associated nephropathy',
            ___GLUT1_deficiency_syndrome: 'GLUT1 deficiency syndrome',
            ___Resistance_to_thyroid_hormone: 'Resistance to thyroid hormone',
            ___Weaver_syndrome: 'Weaver syndrome',
            ___Coffin_Lowry_syndrome: 'Coffin-Lowry syndrome',
            ___Mowat_Wilson_syndrome: 'Mowat-Wilson syndrome',
            ___Hepatic_glycogen_storage_diseases_types_I_III_VI_IXa_IXb_IXc_IV: 'Hepatic glycogen storage diseases (types I, III, VI, IXa, IXb, IXc, IV)',
            ___Myopathic_glycogen_storage_diseases_types_III_IV_IXd: 'Myopathic glycogen storage diseases (types III, IV, IXd)',
            ___Congenital_protein_C_deficiency: 'Congenital protein C deficiency',
            ___Congenital_protein_S_deficiency: 'Congenital protein S deficiency',
            ___Congenital_antithrombin_deficiency: 'Congenital antithrombin deficiency',
            ___Amyotrophic_lateral_sclerosis_ALS: 'Amyotrophic lateral sclerosis (ALS)',
            ___Distal_myopathy_with_rimmed_vacuoles: 'Distal myopathy with rimmed vacuoles',
            ___Schwartz_Jampel_syndrome: 'Schwartz-Jampel syndrome',
            ___Hypertrophic_cardiomyopathy: 'Hypertrophic cardiomyopathy',
            ___Familial_hypercholesterolemia_holmozygous: 'Familial hypercholesterolemia (holmozygous)',
            ___Congenital_myopathy: 'Congenital myopathy',
            ___CADASIL_Cerebral_autosomal_dominant_arteriopathy_with_subcortical_infarcts_and_leukoencephalopathy: 'CADASIL (Cerebral autosomal dominant arteriopathy with subcortical infarcts and leukoencephalopathy)',
            ___Hereditary_diffuse_leukoencephalopathy_with_axonal_spheroids: 'Hereditary diffuse leukoencephalopathy with axonal spheroids',
            ___Congenital_insensitivity_to_pain_with_anhidrosis: 'Congenital insensitivity to pain with anhidrosis',
            ___Familial_benign_chronic_pemphigus_Hailey_Hailey_disease: 'Familial benign chronic pemphigus (Hailey-Hailey disease)',
            ___Nasu_Hakola_disease: 'Nasu-Hakola disease',
            ___Carney_complex: 'Carney complex',
            ___Peroxisome_biogenesis_disorder: 'Peroxisome biogenesis disorder',
            ___Peroxisomal_beta_oxidation_enzyme_deficiency: 'Peroxisomal beta-oxidation enzyme deficiency',
            ___Plasmalogen_synthesis_enzyme_deficiency: 'Plasmalogen synthesis enzyme deficiency',
            ___Acatalasemia: 'Acatalasemia',
            ___Primary_hyperoxaluria_type_I: 'Primary hyperoxaluria type I',
            ___Refsum_disease: 'Refsum disease',
            ___Hereditary_folate_malabsorption: 'Hereditary folate malabsorption',
            ___Atypical_porphyria: 'Atypical porphyria',
            ___Congenital_erythropoietic_porphyria: 'Congenital erythropoietic porphyria',
            ___Acute_intermittent_porphyria: 'Acute intermittent porphyria',
            ___Erythropoietic_protoporphyria: 'Erythropoietic protoporphyria',
            ___X_linked_protoporphyria: 'X-linked protoporphyria',
            ___Hereditary_coproporphyria: 'Hereditary coproporphyria',
            ___Porphyria_cutanea_tarda: 'Porphyria cutanea tarda',
            ___Hepatoerythropoietic_porphyria: 'Hepatoerythropoietic porphyria',
            ___Primary_hyperchylomicronemia: 'Primary hyperchylomicronemia',
            ___Abetalipoproteinemia: 'Abetalipoproteinemia',
            ___Thanatophoric_dysplasia: 'Thanatophoric dysplasia',
            ___Hereditary_pancreatitis: 'Hereditary pancreatitis',
            ___Cystic_fibrosis: 'Cystic fibrosis',
            ___Usher_syndrome_type_1_type_2_type_3: 'Usher syndrome (type 1, type 2, type 3)',
            ___Canavan_disease: 'Canavan disease',
            ___Congenital_glycosylphosphatidylinositol_deficiency: 'Congenital glycosylphosphatidylinositol deficiency',
            ___Osteopetrosis: 'Osteopetrosis',
            ___Cerebral_creatine_deficiency_syndrome: 'Cerebral creatine deficiency syndrome',
            ___Nephronophthisis: 'Nephronophthisis',
            ___Familial_hypobetalipoproteinemia_type_1_homozygous_form: 'Familial hypobetalipoproteinemia type 1 (homozygous form)',
            ___Progressive_familial_intrahepatic_cholestasis: 'Progressive familial intrahepatic cholestasis',
            ___Nutritional_epidermolysis_bullosa: 'Nutritional epidermolysis bullosa',
            ___Congenital_long_QT_syndrome: 'Congenital long QT syndrome',
            ___Maple_syrup_urine_disease: 'Maple syrup urine disease',
            ___Methylmalonic_acidemia: 'Methylmalonic acidemia',
            ___Propionic_acidemia: 'Propionic acidemia',
            ___3_Methylcrotonylglycinuria: '3-Methylcrotonylglycinuria',
            ___MTP_LCHAD_deficiency_Triple_Enzyme_Deficiency: 'MTP (LCHAD) deficiency (Triple Enzyme Deficiency)',
            ___Xeroderma_pigmentosum: 'Xeroderma pigmentosum',
            ___Loeys_Dietz_syndrome: 'Loeys-Dietz syndrome',
            ___Familial_thoracic_aortic_aneurysm_and_dissection: 'Familial thoracic aortic aneurysm and dissection',
            ___Neuroacanthocytosis: 'Neuroacanthocytosis',
            ___Congenital_myasthenic_syndrome: 'Congenital myasthenic syndrome',
            ___Primary_immunodeficiency_syndrome: 'Primary immunodeficiency syndrome',
            ___Perry_syndrome: 'Perry syndrome',
            ___Crouzon_syndrome: 'Crouzon syndrome',
            ___Pfeiffer_syndrome: 'Pfeiffer syndrome',
            ___Antley_Bixler_syndrome: 'Antley-Bixler syndrome',
            ___Tangier_disease: 'Tangier disease',
            ___Congenital_dyserythropoietic_anemia: 'Congenital dyserythropoietic anemia',
            ___Early_onset_bilateral_sensorineural_hearing_loss: 'Early-onset bilateral sensorineural hearing loss',
            ___Urea_cycle_disorder: 'Urea cycle disorder',
            ___Marfan_syndrome_Loeys_Dietz_Syndrome: 'Marfan syndrome/Loeys-Dietz Syndrome',
            ___Vascular_Ehlers_Danlos_syndrome: 'Vascular Ehlers-Danlos syndrome',
            ___Hereditary_autoinflammatory_disease: 'Hereditary autoinflammatory disease',
            ___Hereditary_dystonia: 'Hereditary dystonia',
            ___Dravet_syndrome: 'Dravet syndrome',
            ___Coffin_Siris_syndrome: 'Coffin-Siris syndrome',
            ___Kabuki_syndrome: 'Kabuki syndrome',
            ___Pulmonary_alveolar_proteinosis_autoimmune_or_congenital: 'Pulmonary alveolar proteinosis (autoimmune or congenital)',
            ___Noonan_syndrome: 'Noonan syndrome',
            ___Osteogenesis_imperfecta: 'Osteogenesis imperfecta',
            ___Spinocerebellar_degeneration_excluding_multiple_system_atrophy: 'Spinocerebellar degeneration (excluding multiple system atrophy)',
            ___Classical_Ehlers_Danlos_syndrome: 'Classical Ehlers-Danlos syndrome',
            ___Atypical_hemolytic_uremic_syndrome_aHUS: 'Atypical hemolytic uremic syndrome (aHUS)',
            ___Alport_syndrome: 'Alport syndrome',
            ___Fanconi_anemia: 'Fanconi anemia',
            ___Alagille_syndrome: 'Alagille syndrome',
            ___Rubinstein_Taybi_syndrome: 'Rubinstein-Taybi syndrome',
            ___Primary_ciliary_dyskinesia_including_Kartagener_syndrome: 'Primary ciliary dyskinesia (including Kartagener syndrome)',
            ___Proteinuria_group: 'Proteinuria group',
            ___Cardiomyopathy_group: 'Cardiomyopathy group',
            ___Growth_disorder_intellectual_disability_and_characteristic_facial_features_group: 'Growth disorder, intellectual disability, and characteristic facial features group',
            ___Intellectual_disability_and_epilepsy_group: 'Intellectual disability and epilepsy group',
            ___Fever_inflammation_rash_and_osteoarticular_syndrome_group: 'Fever, inflammation, rash, and osteoarticular syndrome group',
            ___Muscle_weakness_group: 'Muscle weakness group',
            ___Rett_syndrome: 'Rett syndrome',
            ___Lowe_syndrome_oculocerebrorenal_syndrome: 'Lowe syndrome (oculocerebrorenal syndrome)',
            ___Miyoshi_myopathy: 'Miyoshi myopathy',
            ___Lecithin_cholesterol_acyltransferase_LCAT_deficiency: 'Lecithin-cholesterol acyltransferase (LCAT) deficiency',
            ___Sitosterolemia: 'Sitosterolemia',
            ___Pseudohypoparathyroidism: 'Pseudohypoparathyroidism',
            ___Marinesco_Sjögren_syndrome: 'Marinesco-Sjögren syndrome',
            ___Galactose_1_phosphate_uridyltransferase_deficiency: 'Galactose-1-phosphate uridyltransferase deficiency',
            ___Fibrodysplasia_ossificans_progressiva_FOP: 'Fibrodysplasia ossificans progressiva (FOP)',
            ___Aniridia: 'Aniridia',
            ___PURA_related_neurodevelopmental_disorders: 'PURA-related neurodevelopmental disorders',
            ___Leber_hereditary_optic_neuropathy_LHON: 'Leber hereditary optic neuropathy (LHON)',
            ___Alveolar_hypoventilation_syndrome: 'Alveolar hypoventilation syndrome',
            ___Cerebrotendinous_xanthomatosis_CTX: 'Cerebrotendinous xanthomatosis (CTX)',
            ___Joubert_syndrome_and_related_disorders_JSRD: 'Joubert syndrome and related disorders (JSRD)',
            ___Werner_syndrome: 'Werner syndrome',
            ___Cockayne_syndrome: 'Cockayne syndrome',
            ___Pseudoxanthoma_elasticum_PXE: 'Pseudoxanthoma elasticum (PXE)',
            ___Diamond_Blackfan_anemia: 'Diamond-Blackfan anemia',
            ___LMNB1_related_leukoencephalopathy_ADLD: 'LMNB1-related leukoencephalopathy (ADLD)',
            ___Congenital_ichthyosis: 'Congenital ichthyosis',
            ___Oculocutaneous_albinism: 'Oculocutaneous albinism',
            ___STING_stimulator_of_interferon_genes_associated_vasculopathy_with_onset_in_infancy: 'STING (stimulator of interferon genes)-associated vasculopathy with onset in infancy',
            ___Progressive_leukoencephalopathy: 'Progressive leukoencephalopathy',
            ___Charcot_Marie_Tooth_disease_CMT: 'Charcot-Marie-Tooth disease (CMT)',
            ___Congenital_adrenal_hyperplasia_congenital_adrenal_enzyme_deficiency: 'Congenital adrenal hyperplasia (congenital adrenal enzyme deficiency)',
            ___Hemorrhagic_disorders_due_to_abnormal_fibrinolysis: 'Hemorrhagic disorders due to abnormal fibrinolysis',
            ___Mitochondrial_diseases: 'Mitochondrial diseases',
            ___Epstein_syndrome: 'Epstein syndrome',
            ___neurofibromatosis: 'Neurofibromatosis',
            ___congenital_hearing_loss: 'Congenital hearing loss',
            ___prion_disease: 'Prion disease',
            ___familial_idiopathic_basal_ganglia_calcification: 'Familial idiopathic basal ganglia calcification',
            ___williams_syndrome: 'Williams syndrome',
            ___1p36_deletion_syndrome: '1p36 deletion syndrome',
            ___4p_deletion_syndrome: '4p deletion syndrome',
            ___5p_deletion_syndrome: '5p deletion syndrome',
            ___paternal_uniparental_disomy_of_chromosome_14: 'Paternal uniparental disomy of chromosome 14',
            ___22q11_2_deletion_syndrome: '22q11.2 deletion syndrome',
            ___unverricht_lundborg_disease: 'Unverricht-Lundborg disease',
            ___congenital_disorder_of_copper_metabolism: 'Congenital disorder of copper metabolism',
            ___hereditary_sideroblastic_anemia: 'Hereditary sideroblastic anemia',
            ___ring_chromosome_20_syndrome: 'Ring chromosome 20 syndrome',
            ___emanuel_syndrome: 'Emanuel syndrome',
            ___dermatofibrosarcoma_protuberans: 'Dermatofibrosarcoma protuberans',
            ___Primary_lateral_sclerosis: 'Primary lateral sclerosis',
            ___Progressive_supranuclear_palsy: 'Progressive supranuclear palsy',
            ___Parkinsons_disease: 'Parkinson\'s disease',
            ___Corticobasal_degeneration: 'Corticobasal degeneration',
            ___Charcot_Marie_Tooth_disease: 'Charcot-Marie-Tooth disease',
            ___Myasthenia_gravis: 'Myasthenia gravis',
            ___Multiple_sclerosis_Neuromyelitis_optica_spectrum_disorders: 'Multiple sclerosis/Neuromyelitis optica spectrum disorders',
            ___Chronic_inflammatory_demyelinating_polyneuropathy_Multifocal_motor_neuropathy: 'Chronic inflammatory demyelinating polyneuropathy/Multifocal motor neuropathy',
            ___Sporadic_inclusion_body_myositis: 'Sporadic inclusion body myositis',
            ___Multiple_system_atrophy: 'Multiple system atrophy',
            ___Moyamoya_disease: 'Moyamoya disease',
            ___Pemphigus: 'Pemphigus',
            ___Pustular_psoriasis: 'Pustular psoriasis',
            ___Stevens_Johnson_syndrome: 'Stevens-Johnson syndrome',
            ___Toxic_epidermal_necrolysis: 'Toxic epidermal necrolysis',
            ___Takayasu_arteritis: 'Takayasu arteritis',
            ___Giant_cell_arteritis: 'Giant cell arteritis',
            ___Polyarteritis_nodosa: 'Polyarteritis nodosa',
            ___Granulomatosis_with_polyangiitis: 'Granulomatosis with polyangiitis',
            ___Systemic_lupus_erythematosus: 'Systemic lupus erythematosus',
            ___Systemic_sclerosis: 'Systemic sclerosis',
            ___Behcets_disease: 'Behcet\'s disease',
            ___Idiopathic_dilated_cardiomyopathy: 'Idiopathic dilated cardiomyopathy',
            ___Restrictive_cardiomyopathy: 'Restrictive cardiomyopathy',
            ___Aplastic_anemia: 'Aplastic anemia',
            ___Paroxysmal_nocturnal_hemoglobinuria: 'Paroxysmal nocturnal hemoglobinuria',
            ___Immune_thrombocytopenia: 'Immune thrombocytopenia',
            ___Thrombotic_thrombocytopenic_purpura: 'Thrombotic thrombocytopenic purpura',
            ___IgA_nephropathy: 'IgA nephropathy',
            ___Polycystic_kidney_disease: 'Polycystic kidney disease',
            ___Ossification_of_posterior_longitudinal_ligament: 'Ossification of posterior longitudinal ligament',
            ___Idiopathic_osteonecrosis_of_femoral_head: 'Idiopathic osteonecrosis of femoral head',
            ___Diencephalo_hypophysial_insufficiency_inappropriate_ADH_syndrome: 'Diencephalo-hypophysial insufficiency-inappropriate ADH syndrome',
            ___Diencephalo_hypophysial_insufficiency_inappropriate_thyroid_stimulating_hormone_syndrome: 'Diencephalo-hypophysial insufficiency-inappropriate thyroid stimulating hormone syndrome',
            ___Diencephalo_hypophysial_insufficiency_inappropriate_prolactin_syndrome: 'Diencephalo-hypophysial insufficiency-inappropriate prolactin syndrome',
            ___Cushing_disease: 'Cushing disease',
            ___Diencephalo_hypophysial_dysfunction_syndrome_of_abnormal_secretion_of_gonadotropin: 'Diencephalo-hypophysial dysfunction-syndrome of abnormal secretion of gonadotropin',
            ___Diencephalo_hypophysial_dysfunction_syndrome_of_abnormal_secretion_of_growth_hormone: 'Diencephalo-hypophysial dysfunction-syndrome of abnormal secretion of growth hormone',
            ___Hypopituitarism_syndrome: 'Hypopituitarism syndrome',
            ___Congenital_adrenal_enzyme_deficiency: 'Congenital adrenal enzyme deficiency',
            ___Addisons_disease: 'Addison\'s disease',
            ___Sarcoidosis: 'Sarcoidosis',
            ___Pulmonary_arterial_hypertension: 'Pulmonary arterial hypertension',
            ___Pulmonary_veno_occlusive_disease_pulmonary_capillary_hemangiomatosis: 'Pulmonary veno-occlusive disease / pulmonary capillary hemangiomatosis',
            ___Chronic_thromboembolic_pulmonary_hypertension: 'Chronic thromboembolic pulmonary hypertension',
            ___Lymphangioleiomyomatosis: 'Lymphangioleiomyomatosis',
            ___Retinitis_pigmentosa: 'Retinitis pigmentosa',
            ___Budd_Chiari_syndrome: 'Budd-Chiari syndrome',
            ___Primary_biliary_cholangitis: 'Primary biliary cholangitis',
            ___Primary_sclerosing_cholangitis: 'Primary sclerosing cholangitis',
            ___Crohns_disease: 'Crohn\'s disease',
            ___Ulcerative_colitis: 'Ulcerative colitis',
            ___Chronic_idiopathic_intestinal_pseudo_obstruction: 'Chronic idiopathic intestinal pseudo-obstruction',
            ___Megacystis_microcolon_intestinal_hypoperistalsis_syndrome: 'Megacystis-microcolon-intestinal hypoperistalsis syndrome',
            ___Juvenile_idiopathic_arthritis: 'Juvenile idiopathic arthritis',
            ___Marinesco_Sjogren_syndrome: 'Marinesco-Sjogren syndrome',
            ___Myelomeningocele: 'Myelomeningocele',
            ___Frontotemporal_lobar_degeneration: 'Frontotemporal lobar degeneration',
            ___Acute_encephalopathy_with_biphasic_seizures_and_late_reduced_diffusion: 'Acute encephalopathy with biphasic seizures and late reduced diffusion',
            ___Moebius_syndrome: 'Moebius syndrome',
            ___Septo_optic_dysplasia_De_Morsier_syndrome: 'Septo-optic dysplasia / De Morsier syndrome',
            ___Aicardi_syndrome: 'Aicardi syndrome',
            ___Hemimegalencephaly: 'Hemimegalencephaly',
            ___Focal_cortical_dysplasia: 'Focal cortical dysplasia',
            ___Neuronal_migration_defects: 'Neuronal migration defects',
            ___Epilepsy_with_myoclonic_atonic_seizures: 'Epilepsy with myoclonic atonic seizures',
            ___Lennox_Gastaut_syndrome: 'Lennox-Gastaut syndrome',
            ___West_syndrome: 'West syndrome',
            ___Ohtahara_syndrome: 'Ohtahara syndrome',
            ___Early_myoclonic_encephalopathy: 'Early myoclonic encephalopathy',
            ___Epilepsy_of_infancy_with_migrating_focal_seizures: 'Epilepsy of infancy with migrating focal seizures',
            ___Hemiconvulsion_hemiplegia_epilepsy_syndrome: 'Hemiconvulsion-hemiplegia-epilepsy syndrome',
            ___Rasmussens_encephalitis: 'Rasmussen\'s encephalitis',
            ___Developmental_and_or_epileptic_encephalopathy_with_spike_wave_activation_in_sleep: 'Developmental and/or epileptic encephalopathy with spike-wave activation in sleep',
            ___Landau_Kleffner_syndrome: 'Landau-Kleffner syndrome',
            // ___Rett_syndrome: 'Rett syndrome',
            ___Sturge_Weber_syndrome: 'Sturge-Weber syndrome',
            // ___Congenital_ichthyosis: 'Congenital ichthyosis',
            ___Pemphigoid_including_Epidermolysis_bullosa_acquisita: 'Pemphigoid (including Epidermolysis bullosa acquisita)',
            // ___Oculocutaneous_albinism: 'Oculocutaneous albinism',
            ___Pseudoxanthoma_elasticum: 'Pseudoxanthoma elasticum',
            ___VATER_syndrome: 'VATER syndrome',
            ___Joubert_syndrome_and_related_disorders: 'Joubert syndrome and related disorders',
            ___Polysplenia_syndrome: 'Polysplenia syndrome',
            ___Asplenia_syndrome: 'Asplenia syndrome',
            // ___Werner_syndrome: 'Werner syndrome',
            // ___Cockayne_syndrome: 'Cockayne syndrome',
            ___Truncus_arteriosus_communis: 'Truncus arteriosus communis',
            ___Corrected_transposition_of_great_arteries: 'Corrected transposition of great arteries',
            ___Complete_transposition_of_the_great_arteries: 'Complete transposition of the great arteries',
            ___Hypoplastic_left_heart_syndrome: 'Hypoplastic left heart syndrome',
            ___Tetralogy_of_Fallot: 'Tetralogy of Fallot',
            ___Double_outlet_right_ventricle: 'Double outlet right ventricle',
            ___Ebsteins_anomaly: 'Ebstein\'s anomaly',
            ___Galloway_Mowat_syndrome: 'Galloway-Mowat syndrome',
            ___Primary_nephrotic_syndrome: 'Primary nephrotic syndrome',
            ___Primary_membranoproliferative_glomerulonephritis: 'Primary membranoproliferative glomerulonephritis',
            // ___Alveolar_hypoventilation_syndrome: 'Alveolar hypoventilation syndrome',
            ___Alpha_1_antitrypsin_deficiency: 'Alpha-1-antitrypsin deficiency',
            ___Hypoparathyroidism: 'Hypoparathyroidism',
            // ___Pseudohypoparathyroidism: 'Pseudohypoparathyroidism',
            ___Vitamin_D_resistant_rickets_Vitamin_D_resistant_osteomalacia: 'Vitamin D-resistant rickets/Vitamin D-resistant osteomalacia',
            ___Tyrosinemia_type_1: 'Tyrosinemia type 1',
            ___Tyrosinemia_type_2: 'Tyrosinemia type 2',
            ___Tyrosinemia_type_3: 'Tyrosinemia type 3',
            // ___Galactose_1_phosphate_uridyltransferase_deficiency: 'Galactose-1-phosphate uridyltransferase deficiency',
            ___Lecithin_cholesterol_acyltransferase_deficiency: 'Lecithin cholesterol acyltransferase deficiency',
            // ___Sitosterolemia: 'Sitosterolemia',
            ___Cerebrotendinous_xanthomatosis: 'Cerebrotendinous xanthomatosis',
            ___Chronic_recurrent_multifocal_osteomyelitis: 'Chronic recurrent multifocal osteomyelitis',
            ___Ankylosing_spondylitis: 'Ankylosing spondylitis',
            ___Fibrodysplasia_ossificans_progressiva: 'Fibrodysplasia ossificans progressiva',
            ___Congenital_scoliosis_with_rib_anomalies: 'Congenital scoliosis with rib anomalies',
            ___Giant_lymphatic_malformation_cervicofacial_lesion: 'Giant lymphatic malformation (cervicofacial lesion)',
            ___Giant_venous_malformation_cervical_oral_and_oropharyngeal_diffuse_lesion: 'Giant venous malformation (cervical, oral and oropharyngeal diffuse lesion)',
            ___Klippel_Trenaunay_Weber_syndrome: 'Klippel-Trenaunay-Weber syndrome',
            // ___Diamond_Blackfan_anemia: 'Diamond-Blackfan anemia',
            ___Hirschsprung_disease: 'Hirschsprung disease',
            ___Congenital_diaphragmatic_hernia: 'Congenital diaphragmatic hernia',
            ___Biliary_atresia: 'Biliary atresia',
            ___Macular_dystrophy: 'Macular dystrophy',
            // ___Progressive_leukoencephalopathy: 'Progressive leukoencephalopathy',
            ___Anterior_segment_dysgenesis: 'Anterior segment dysgenesis',
            // ___Aniridia: 'Aniridia',
            ___Idiopathic_multicentric_Castlemans_disease: 'Idiopathic multicentric Castleman\'s disease',
            ___Gelatinous_drop_like_corneal_dystrophy: 'Gelatinous drop-like corneal dystrophy',
            ___MECP2_Duplication_Syndrome: 'MECP2 Duplication Syndrome',
            ___Autosomal_Dominant_Adult_Onset_Demyelinating_Leukodystrophy: 'Autosomal Dominant Adult-Onset Demyelinating Leukodystrophy',
            ___PURA_related_severe_neonatal_hypotonia_seizures_encephalopathy_syndrome: 'PURA-related severe neonatal hypotonia-seizures-encephalopathy syndrome',
            ___very_long_chain_acyl_CoA_dehydrogenase: 'very long-chain acyl-CoA dehydrogenase',
            // ___STING_stimulator_of_interferon_genes_associated_vasculopathy_with_onset_in_infancy: 'STING (stimulator of interferon genes)-associated vasculopathy with onset in infancy',
            ___Bleeding_disorder_with_abnormal_fibrinolysis: 'Bleeding disorder with abnormal fibrinolysis',
            ___Lowe_syndrome: 'Lowe syndrome'
          }
        },
        workgroupRoleOptions: {
          title: {
            ___owner: 'Owner',
            ___director: 'Director',
            ___member: 'Member'
          }
        },
        reportPreviewOptions: {
          categoryTitle: {
            ___AlleleFrequency: 'Allele Frequency',
            ___coverage: 'Coverage',
            ___psSpliceSite: 'Splice Site',
            ___psFunctionPrediction: 'Function Prediction',
            ___psEnsemble: 'Ensemble',
            ___psConservation: 'Conservation',
            ___psgnomADConstraint: 'gnomAD Constraint'
          },
          groupTitle: {
            ___1000Genomes: '1000 Genomes',
            ___gnomADExomes: 'gnomAD Exomes',
            ___gnomADGenomes: 'gnomAD Genomes',
            ___phenoVarDBPrivate: 'PhenoVarDB Private',
            ___phenoVarDBCommunity: 'PhenoVarDB Community',
            ___phenoVarDBAdmin: 'PhenoVarDB Admin',
            ___other: 'Other',
            ___coverageGnomADExomes: 'gnomAD Exomes',
            ___coverageGnomADGenomes: 'gnomAD Genomes'
          },
          linkTitle: {
            ___SpliceAI: 'Click here to look up SpliceAI scores'
          },
          title: {
            ___KG_AF: 'AF',
            ___KG_EAS_AF: 'EAS AF',
            ___KG_AMR_AF: 'AMR AF',
            ___KG_AFR_AF: 'AFR AF',
            ___KG_EUR_AF: 'EUR AF',
            ___KG_SAS_AF: 'SAS AF',
            ___gnomAD_AF: 'AF',
            ___gnomAD_AFR_AF: 'AFR AF',
            ___gnomAD_AMR_AF: 'AMR AF',
            ___gnomAD_ASJ_AF: 'ASJ AF',
            ___gnomAD_EAS_AF: 'EAS AF',
            ___gnomAD_FIN_AF: 'FIN AF',
            ___gnomAD_NFE_AF: 'NFE AF',
            ___gnomAD_OTH_AF: 'OTH AF',
            ___gnomAD_SAS_AF: 'SAS AF',
            ___gnomAD_MID_AF: 'MID AF',
            ___gnomAD_g_AF: 'AF',
            ___gnomAD_g_AF_afr: 'AFR AF',
            ___gnomAD_g_AF_ami: 'AMI AF',
            ___gnomAD_g_AF_amr: 'AMR AF',
            ___gnomAD_g_AF_asj: 'ASJ AF',
            ___gnomAD_g_AF_eas: 'EAS AF',
            ___gnomAD_g_AF_fin: 'FIN AF',
            ___gnomAD_g_AF_mid: 'MID AF',
            ___gnomAD_g_AF_nfe: 'NFE AF',
            ___gnomAD_g_AF_oth: 'OTH AF',
            ___gnomAD_g_AF_sas: 'SAS AF',
            ___gnomAD_g_mt_AF_het: 'Heteroplasmy AF',
            ___gnomAD_g_mt_pop_AF_het_afr: 'Heteroplasmy AFR AF',
            ___gnomAD_g_mt_pop_AF_het_ami: 'Heteroplasmy AMI AF',
            ___gnomAD_g_mt_pop_AF_het_amr: 'Heteroplasmy AMR AF',
            ___gnomAD_g_mt_pop_AF_het_asj: 'Heteroplasmy ASJ AF',
            ___gnomAD_g_mt_pop_AF_het_eas: 'Heteroplasmy EAS AF',
            ___gnomAD_g_mt_pop_AF_het_fin: 'Heteroplasmy FIN AF',
            ___gnomAD_g_mt_pop_AF_het_mid: 'Heteroplasmy MID AF',
            ___gnomAD_g_mt_pop_AF_het_nfe: 'Heteroplasmy NFE AF',
            ___gnomAD_g_mt_pop_AF_het_oth: 'Heteroplasmy OTH AF',
            ___gnomAD_g_mt_pop_AF_het_sas: 'Heteroplasmy SAS AF',
            ___gnomAD_g_mt_AF_hom: 'Homoplasmy AF',
            ___gnomAD_g_mt_pop_AF_hom_afr: 'Homoplasmy AFR AF',
            ___gnomAD_g_mt_pop_AF_hom_ami: 'Homoplasmy AMI AF',
            ___gnomAD_g_mt_pop_AF_hom_amr: 'Homoplasmy AMR AF',
            ___gnomAD_g_mt_pop_AF_hom_asj: 'Homoplasmy ASJ AF',
            ___gnomAD_g_mt_pop_AF_hom_eas: 'Homoplasmy EAS AF',
            ___gnomAD_g_mt_pop_AF_hom_fin: 'Homoplasmy FIN AF',
            ___gnomAD_g_mt_pop_AF_hom_mid: 'Homoplasmy MID AF',
            ___gnomAD_g_mt_pop_AF_hom_nfe: 'Homoplasmy NFE AF',
            ___gnomAD_g_mt_pop_AF_hom_oth: 'Homoplasmy OTH AF',
            ___gnomAD_g_mt_pop_AF_hom_sas: 'Homoplasmy SAS AF',
            ___PVDB_P_FILTER: 'Filter',
            ___PVDB_P_F_MISSING: 'Missing rate',
            ___PVDB_P_AC: 'AC',
            ___PVDB_P_AN: 'AN',
            ___PVDB_P_AF: 'AF',
            ___PVDB_P_DP: 'DP',
            ___PVDB_P_AC_Het: 'AC in heterozygous genotypes',
            ___PVDB_P_AC_Hom: 'AC in homozygous genotypes',
            ___PVDB_P_AC_Hemi: 'AC in hemizygous genotypes',
            ___PVDB_S_FILTER: 'Filter',
            ___PVDB_S_F_MISSING: 'Missing rate',
            ___PVDB_S_AC: 'AC',
            ___PVDB_S_AN: 'AN',
            ___PVDB_S_AF: 'AF',
            ___PVDB_S_DP: 'DP',
            ___PVDB_S_AC_Het: 'AC in heterozygous genotypes',
            ___PVDB_S_AC_Hom: 'AC in homozygous genotypes',
            ___PVDB_S_AC_Hemi: 'AC in hemizygous genotypes',
            ___PVDB_A_FILTER: 'Filter',
            ___PVDB_A_F_MISSING: 'Missing rate',
            ___PVDB_A_AC: 'AC',
            ___PVDB_A_AN: 'AN',
            ___PVDB_A_AF: 'AF',
            ___PVDB_A_DP: 'DP',
            ___PVDB_A_AC_Het: 'AC in heterozygous genotypes',
            ___PVDB_A_AC_Hom: 'AC in homozygous genotypes',
            ___PVDB_A_AC_Hemi: 'AC in hemizygous genotypes',
            ___ESP6500_AF: 'ESP6500 AF',
            ___ESP6500_AA_AF: 'ESP6500 AA',
            ___ESP6500_EA_AF: 'ESP6500 EA',
            ___TW_AF: 'Taiwan Biobank AF',
            ___TOPMED_AF: 'TOPMed AF',
            ___UK10K_AF: 'UK10K AF',
            ___ChinaMAP_AF: 'ChinaMAP AF',
            ___GA_AF: 'GenomeAsia 100K AF',
            ___KJ_AF: '4.7KJPN AF',
            ___ExAC_AF: 'ExAC AF',
            ___tommo_60kjpn_AF: 'ToMMo 60KJPN AF',
            ___tommo_60kjpn_AN: 'ToMMo 60KJPN AN',
            ___gnomAD_cov_MEAN: 'Mean',
            ___gnomAD_cov_MEDIAN: ' Median',
            ___gnomAD_cov_PCT_20X: '>20x coverage (%)',
            ___gnomAD_g_cov_MEAN: 'Mean',
            ___gnomAD_g_cov_MEDIAN: 'Median',
            ___gnomAD_g_cov_PCT_20X: '>20x coverage (%)',
            ___ESM1b: 'ESMb1',
            ___ESM1b_pred: 'ESMb1 pred',
            ___VARITY_ER_LOO: 'VARITY ER LOO',
            ___VARITY_ER_LOO_pred: 'VARITY ER LOO pred',
            ___VARITY_R_LOO: 'VARITY R LOO',
            ___VARITY_R_LOO_pred: 'VARITY R LOO pred',
            ___VARITY_ER: 'VARITY ER',
            ___VARITY_ER_pred: 'VARITY ER pred',
            ___VARITY_R: 'VARITY R',
            ___VARITY_R_pred: 'VARITY R pred',
            ___Alphamissense_score: 'Alphamissense score',
            ___Alphamissense_class: 'Alphamissense class',
            ___SIFT4G_score: 'SIFT4G score',
            ___SIFT4G_pred: 'SIFT4G pred',
            ___Polyphen: 'Polyphen-2 HDIV',
            ___Polyphen_pred: 'Polyphen-2 HDIV pred',
            ___FATHMM_score: 'FATHMM score',
            ___FATHMM_pred: 'FATHMM pred',
            ___PROVEAN_score: 'PROVEAN score',
            ___PROVEAN_pred: 'PROVEAN pred',
            ___CADD_phred: 'CADD phred',
            ___CADD_phred_pred: 'CADD phred pred',
            ___MetaLR_score: 'MetaLR score',
            ___MetaLR_pred: 'MetaLR pred',
            ___MetaSVM_score: 'MetaSVM score',
            ___MetaSVM_pred: 'MetaSVM pred',
            ___REVEL_score: 'REVEL score',
            ___REVEL_pred: 'REVEL pred',
            ___BayesDel_noAF_score: 'BayesDel noAF score',
            ___BayesDel_noAF_pred: 'BayesDel noAF pred',
            ___gnomAD_g_mt_mitotip_score: 'MitoTip score',
            ___gnomAD_g_mt_mitotip_score_pred: 'MitoTip pred',
            ___ada_score: 'ada score',
            ___ada_pred: 'ada pred',
            ___rf_score: 'rf score',
            ___rf_pred: 'rf pred',
            ___CI_SpliceAI_DS_AG: 'CI-SpliceAI DS AG',
            ___CI_SpliceAI_DS_AL: 'CI-SpliceAI DS AL',
            ___CI_SpliceAI_DS_DG: 'CI-SpliceAI DS DG',
            ___CI_SpliceAI_DS_DL: 'CI-SpliceAI DS DL',
            ___CI_SpliceAI_DP_AG: 'CI-SpliceAI DP AG',
            ___CI_SpliceAI_DP_AL: 'CI-SpliceAI DP AL',
            ___CI_SpliceAI_DP_DG: 'CI-SpliceAI DP DG',
            ___CI_SpliceAI_DP_DL: 'CI-SpliceAI DP DL',
            ___SpliceAI: 'SpliceAI',
            ___SpliceAI_DS_AG: 'SpliceAI Acceptor gain score',
            ___SpliceAI_DS_AL: 'SpliceAI Acceptor loss score',
            ___SpliceAI_DS_DG: 'SpliceAI Donor gain score',
            ___SpliceAI_DS_DL: 'SpliceAI Donor loss score',
            ___SpliceAI_DP_AG: 'SpliceAI Acceptor gain position',
            ___SpliceAI_DP_AL: 'SpliceAI Acceptor loss position',
            ___SpliceAI_DP_DG: 'SpliceAI Donor gain position',
            ___SpliceAI_DP_DL: 'SpliceAI Donor loss positon',
            ___GERPpp_NR: 'GERP++NR',
            ___GERPpp_RS: 'GERP++RS',
            ___GERPpp_RS_pred: 'GERP++RS pred',
            ___SiPhy_29way_logOdds: 'SiPhy 29way logOdds',
            ___SiPhy_29way_logOdds_pred: 'SiPhy 29way logOdds pred',
            ___SiPhy_29way_pi: 'SiPhy 29way pi',
            ___oe_syn: 'Synonymous o/e',
            ___oe_mis: 'Missense o/e',
            ___oe_lof: 'pLoF o/e',
            ___syn_z: 'Synonymous z-score',
            ___mis_z: 'Missense z-score',
            ___pLI: 'pLI'
          }
        },
        licenseStatusMap: {
          title: {
            ___inactive: 'Inactive',
            ___active: 'Active',
            ___exceeded: 'Exceeded',
            ___expired: 'Expired',
            ___unlimited: 'Unlimited'
          }
        },
        licenseApiMap: {
          title: {
            ___vcf_analysis: 'VCF Analysis',
            ___fastq_analysis: 'FASTQ Analysis',
            ___report_module: 'Report Module',
            ___mastermind: 'Mastermind'
          }
        }
      }
    }
  },
  // common
  COMMON: {
    button: {
      ___add: 'Add',
      ___select: 'Select',
      ___export: 'Export',
      ___hideDeleted: 'Hide deleted',
      ___showDeleted: 'Show deleted',
      ___reset: 'Reset',
      ___apply: 'Apply',
      ___generate: 'Generate',
      ___regenerate: 'Regenerate',
      ___createUrl: 'Create URL',
      ___search: 'Search',
      ___cancel: 'Cancel',
      ___create: 'Create',
      ___return: 'Return',
      ___update: 'Update',
      ___archive: 'Archive',
      ___delete: 'Delete',
      ___leave: 'Leave',
      ___shareSetting: 'Share setting',
      ___accept: 'Accept',
      ___addAll: 'Add all',
      ___save: 'Save',
      ___confirm: 'Confirm',
      ___enter: 'Enter',
      ___import: 'Import',
      ___reanalysis: 'Reanalysis',
      ___vcf: 'VCF',
      ___fastq: 'fastq',
      ___ubam: 'uBAM',
      ___upload: 'Upload',
      ___newChapter: 'New Section',
      ___newCNV: 'New SV',
      ___newWorkgroup: 'New Group',
      ___newConfig: 'New Config',
      ___addMember: 'Add Member',
      ___addCases: 'Add Cases',
      ___addStage: 'Add Stage',
      ___newPanel: 'New Panel',
      ___newAnalysis: 'New Analysis',
      ___analysis: 'Analysis',
      ___submit: 'Submit',
      ___hideArchives: 'Hide archives',
      ___showArchives: 'Show archives',
      ___active: 'Active',
      ___send: 'Send',
      ___ignore: 'Ignore',
      ___login: 'Login',
      ___signUp: 'Sign Up',
      ___backToSearch: 'Back to Search',
      ___buyMore: 'Buy more',
      ___contactUs: 'Contact us',
      ___verify: 'Verify',
      ___change: 'Change',
      ___proceed: 'Proceed',
      ___set: 'Set',
      ___retry: 'Retry',
      ___stop: 'Stop',
      ___date: 'Date',
      ___none: 'None',
      ___yes: 'Yes',
      ___no: 'No',
      ___unlock: 'Unlock'
    },
    toast: {
      ___licenseInvalid: 'License ID is invalid.',
      ___licenseExceeded: 'Function usage limit exceeded.',
      ___licenseExpired: 'License is expired.',
      ___noPermission: 'No permission',
      ___pleaseLogin: 'Please login',
      ___xhrCanNotUpload: 'Xhr can not upload.',
      ___pleaseAgreeTerms: 'Please agree terms',
      ___phenotypesAnalyzeLimit: 'More than {amount} phenotypes cannot be analyzed.',
      ___datasetReachLimit: 'Datasets have reached the maximum capacity.',
      ___analysisTimeout: 'Analysis timeout has been notified to relevant personnel.',
      ___wrongFiles: 'Wrong Files',
      ___getSignUrlFailed: 'Get sign url failed.',
      ___addSameHPOTerm: 'You have added a HPO term with the same HPO identity.',
      ___geneSymbolInvalidFormat: 'Invalid format for gene symbol or Entrez ID.',
      ___fileTypeAlert: 'The file format is invalid. Please upload a file in {types} format.',
      ___variantInAllChapter: 'This variant has been added to all the sections.',
      ___noPermissionToOpenDataset: 'You have no permission to open this dataset.',
      ___reportUpdated: 'The report is updated.',
      ___tsvExportLimit: 'TSV export limit to {amount} records.',
      ___atLeastOneCardOpen: 'At least one card should be left open.',
      ___noPermissionToUploadFile: 'You have no permission to upload the file.',
      ___snvFileRequired: 'SNV file should not be empty.',
      ___dataShouldBePaired: 'The data should be paired, please check you file numbers.',
      ___sampleFamilyAnalysis: 'This sample is temporarily protected owing to the sample usage of family analysis.',
      ___familyMemberLimit: 'The numberof selected members can not be greater than {limit}.',
      ___workgroupLimit: 'The max number of groups is {limit} and has reached its limit.',
      ___workgroupMemberExist: 'The member has been exist in the group.',
      ___addWorkgroupMember: 'A member has been added successfully.',
      ___editWorkgroupMember: 'A member has been updated successfully.',
      ___addWorkgroupCase: '{count} case has been added successfully. | {count} cases have been added successfully.',
      ___addWorkgroupCaseAutoShare: '{count} case has been added successfully. Auto-share has been enabled, and your future uploaded cases will be automatically shared with this workgroup. | {count} cases have been added successfully. Auto-share has been enabled, and your future uploaded cases will be automatically shared with this workgroup.',
      ___workgroupStageLimit: 'The max number of stage is {limit} and has reached its limit.',
      ___workgroupStageExist: 'The stage has been exist in the group.',
      ___addWorkgroupStage: 'A stage has been added successfully.',
      ___editWorkgroupStage: 'A stage has been updated successfully.',
      ___batchExpired: 'Due to the batch, <b>created at {created}</b>, <span style="color:#FA3D3D">has not been edited for more than 5 days</span>, all records,<br>including the VCF and sample sheet file, has been deleted. Please create a new batch again.',
      ___exportCaseReport: 'The password to open the report is your account email.',
      ___fileUploadLimit: 'You can upload a maximum of {count} files.',
      ___genePanelItemExist: 'The selected {type} has already been added.',
      ___mastermindLicense: 'Unlock insights by purchasing a Mastermind license or contacting your sales representative.'
    }
  }
});
// CONCATENATED MODULE: ./src/constants/lang/ja/lang.js
/* harmony default export */ var lang_ja_lang = ({
  // layout
  LAYOUT: {
    header: {
      routes: {
        title: {
          ___caseList: '症例リスト',
          ___phenoVarDBPopulationFrequencies: 'PhenoVarDB<br>集団頻度'
        },
        info: {
          ___userManual: 'ユーザーマニュアル',
          ___logOut: 'ログアウト'
        }
      },
      menu: {
        title: {
          ___userSetting: 'ユーザー設定'
        }
      }
    },
    footer: {},
    pageFooter: {
      ___compassBioinformatics: 'コンパスバイオインフォマティクス株式会社',
      ___cookie_policy: 'Cookie policy',
      ___privacy_policy: 'Privacy policy',
      ___alert: '本製品は研究目的にのみご利用いただけます。'
    },
    uploading: {
      ___title: 'アップロード'
    }
  },
  // mixin
  MIXIN: {
    routeLoading: {
      ___noPermission: '権限がありません。'
    }
  },
  // page
  PAGE: {
    main: {
      ___forgetPassword: 'パスワードをお忘れですか？',
      ___or: 'または',
      form: {
        title: {
          ___email: 'アカウント（メールアドレス）',
          ___password: 'パスワード'
        }
      }
    },
    forget: {
      ___info01: 'ご登録のアカウント（メールアドレス）を入力してください。',
      ___info02: 'パスワード再設定メールをご登録のメールアドレスに送信します。',
      form: {
        title: {
          ___email: 'アカウント（メールアドレス）'
        },
        placeholder: {
          ___email: 'wiseTony@compassbioinfo.com'
        }
      }
    },
    reset: {
      ___info01: 'こちらがパスワード再設定ページです。',
      ___info02: 'アカウントのパスワードを再設定してください：',
      form: {
        title: {
          ___newPassword: '新しいパスワード',
          ___confirmed: '新しいパスワードを確認する'
        },
        errorTitle: {
          ___newPassword: 'パスワード',
          ___confirmed: 'パスワード'
        },
        placeholder: {
          ___newPassword: '14～100文字を入力してください。',
          ___confirmed: 'パスワードをもう一度入力してください。'
        },
        customValidate: {
          ___confirmed: '入力されたパスワードは一致しません。'
        }
      }
    },
    active: {
      ___info01: 'ご担当者さまへ、新規ユーザー登録があります。',
      ___info02: 'ユーザー情報を確認し、アカウントの認証を行なってください。',
      form: {
        title: {
          ___email: 'アカウント（メールアドレス）',
          ___firstName: '名前',
          ___lastName: '苗字',
          ___country: '国や地域',
          ___organization: '所属機関',
          ___appliedDate: '申請日'
        }
      }
    },
    deviceAlert: {
      ___info01: 'パソコンまたはノートパソコンでのログインを推奨します。',
      ___info02: 'それ以外の場合、使用体験に影響を及ぼす可能性があります。'
    },
    datasetAccess: {
      form: {
        title: {
          ___accessKey: 'アクセスキー'
        },
        placeholder: {
          ___accessKey: '16桁のアクセスキーを入力してください。'
        }
      }
    },
    genePanel: {
      ___title: '遺伝子パネル検索',
      geneTag: {
        ___placeholder: '疾患または遺伝子パネルを入力してください。'
      },
      introduction: {
        collapse: {
          ___content01: '始め方がわからない場合は、以下の内容を参考にしてください。'
        },
        display: {
          ___content01: '始め方がわからない場合は、以下の内容を参考にしてください。',
          ___content02: '遺伝性疾患の代表的な表現型は以下の通りです：',
          ___content03: '例：マルファン症候群、レーベル遺伝性視神経症、ファブリー病、てんかん、ヌーナン症候群とラソパシーズなど。'
        }
      }
    },
    phenotypeDisease: {
      ___title01: '両者の類似度',
      ___title02: '表現型と疾患',
      ___alert01: '本結果はあくまでも可能性を示す参考情報であり、',
      ___alert02: '確定診断を目的とするものではありません。',
      ___selectedTitle: '選択する',
      ___selectedRemind: 'チェックボックスの選択を解除すると、表現型を削除できます。',
      ___resultPhenotypeTitle: '入力された表現型',
      ___resultTableTitle: '結果',
      phenotypeTag: {
        ___placeholder: '表現型を入力してください。'
      },
      introduction: {
        collapse: {
          ___content01: '始め方がわからない場合は、以下の内容を参考にしてください。'
        },
        display: {
          ___content01: '始め方がわからない場合は、以下の内容を参考にしてください。',
          ___content02: '遺伝性疾患の代表的な表現型は以下の通りです：',
          ___content03: '例：全般的発達遅滞、低身長、筋緊張低下、 眼球振とう、聴覚障害、知的障害、小頭症など。',
          ___content04: 'ただし、<span class="alert"> 10項目を超えないように </span> してください。',
          ___content05: '<a href="https://hpo.jax.org/app/" target="_blank">HPOのウェブサイト</a> からも関連する表現型を検索することができます。</a>.'
        }
      },
      table: {
        title: {
          ___index: 'Rk',
          ___omimID: 'OMIM ID',
          ___name: '疾患名'
        }
      },
      uploading: {
        ___pleaseWait: 'ページを表示した状態でしばらくお待ちください。'
      }
    },
    coverageRate: {
      ___title: 'カバレッジ率の検索ツール',
      ___searchPlaceholder: 'RefSeq ID（例：NM_000059.4）または遺伝子名（例：BRCA1）',
      table: {
        title: {
          ___refseqID: 'RefSeq ID',
          ___symbol: '遺伝子名',
          ___region: '遺伝子領域',
          ___libraryKit: 'ライブラリーキット',
          ___10XPctMeanCov: '10X 以上カバー率(%)',
          ___20XPctMeanCov: '20X 以上カバー率(%)'
        }
      }
    },
    register: {
      ___info01: 'AI遺伝子スクリーニングシステムのInheriNextへようこそ。',
      ___info02: '必要事項をご記入の上、利用規約に同意してご登録ください。',
      ___info03: '当社にてご利用の審査と承認を行いますので、しばらくお待ちください。',
      ___agreementCheckTitle: '利用規約および<a class="link" href="{link}" target="_blank">プライバシーポリシー</a>を注意深く読み、すべてに同意します。',
      ___agreementDownloadPDFTitle: '利用規約（繁体字中国語版）PDF ダウンロード',
      ___agreementContent: '<span style="font-size:1.5rem; font-weight:500;">InheriNext\xAE Edge\u3078\u3088\u3046\u3053\u305D</span>\nInheriNext\xAE Edge\u306F\u3001Compass Bioinformatics Inc.\u306B\u3088\u3063\u3066\u958B\u767A\u3055\u308C\u305F\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3067\u3059\u3002InheriNext\xAE Edge\u3092\u3054\u5229\u7528\u3044\u305F\u3060\u304F\u3053\u3068\u3067\u3001\u4EE5\u4E0B\u306E\u5229\u7528\u898F\u7D04\u306B\u540C\u610F\u3055\u308C\u305F\u3082\u306E\u3068\u307F\u306A\u3055\u308C\u307E\u3059\u3002\u3082\u3057\u3001\u4EE5\u4E0B\u306E\u5229\u7528\u898F\u7D04\u306B\u95A2\u3057\u3066\u4E0D\u660E\u70B9\u3084\u61F8\u5FF5\u304C\u3042\u308B\u5834\u5408\u306F\u3001InheriNext\xAE Edge\u306E\u4F7F\u7528\u3092\u4E2D\u6B62\u3057\u3066\u304F\u3060\u3055\u3044\u3002\n\n<span style="font-size:1rem; font-weight:500;">InheriNext\xAE Edge\u306E\u7528\u9014</span>\nInheriNext\xAE Edge\u306F\u3001\u79D1\u5B66\u7684\u306A\u30E6\u30FC\u30B6\u30FC\u5411\u3051\u306B\u907A\u4F1D\u5B66\u7684\u30C7\u30FC\u30BF\u306E\u89E3\u6790\u7D50\u679C\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002InheriNext\xAE Edge\u306F\u3001\u8A3A\u65AD\u7D50\u679C\u307E\u305F\u306F\u533B\u7642\u7684\u306A\u30A2\u30C9\u30D0\u30A4\u30B9\u3092\u542B\u307F\u307E\u305B\u3093\u3002\u4E0A\u8A18\u4EE5\u5916\u306E\u76EE\u7684\u3067\u4F7F\u7528\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002\n\n<span style="font-size:1rem; font-weight:500;">\u30C7\u30FC\u30BF\u306E\u6240\u6709\u6A29\u306B\u3064\u3044\u3066</span>\nInheriNext\xAE Edge\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3055\u308C\u305F\u3059\u3079\u3066\u306E\u30C7\u30FC\u30BF\u306E\u6240\u6709\u6A29\u306F\u3001\u5B8C\u5168\u306B\u30E6\u30FC\u30B6\u30FC\u306B\u5E30\u5C5E\u3057\u307E\u3059\u3002Compass Bioinformatics Inc.\u306F\u3001\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3055\u308C\u305F\u30C7\u30FC\u30BF\u3092\u30EC\u30DD\u30FC\u30C8\u306E\u4F5C\u6210\u306E\u307F\u306B\u4F7F\u7528\u3057\u307E\u3059\u3002Compass Bioinformatics Inc.\u306F\u3001\u3053\u308C\u3089\u306E\u30EC\u30DD\u30FC\u30C8\u304B\u3089\u5F97\u3089\u308C\u308B\u96C6\u8A08\u30C7\u30FC\u30BF\uFF08\u8981\u7D04\u30C7\u30FC\u30BF\uFF09\u3092\u3001\u89E3\u6790\u624B\u6CD5\u306E\u7CBE\u5EA6\u5411\u4E0A\u306E\u305F\u3081\u306B\u4F7F\u7528\u3057\u307E\u3059\u3002\u30C7\u30FC\u30BF\u304C\u7B2C\u4E09\u8005\u306B\u8CA9\u58F2\u307E\u305F\u306F\u8B72\u6E21\u3055\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002\n\n<span style="font-size:1rem; font-weight:500;">\u500B\u4EBA\u60C5\u5831\u306E\u4FDD\u8B77</span>\nInheriNext\xAE Edge\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3055\u308C\u305F\u30C7\u30FC\u30BF\u306F\u3001\u5B89\u5168\u306B\u4FDD\u7BA1\u3055\u308C\u3001\u5F53\u793E\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC\u306B\u57FA\u3065\u304D\u4FDD\u8B77\u3055\u308C\u307E\u3059\u3002\u767B\u9332\u30E6\u30FC\u30B6\u30FC\u306B\u306F\u3001\u30B7\u30B9\u30C6\u30E0\u306E\u66F4\u65B0\u3001\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u3001\u65B0\u30D0\u30FC\u30B8\u30E7\u30F3\u306A\u3069\u306B\u3064\u3044\u3066E\u30E1\u30FC\u30EB\u3067\u901A\u77E5\u3055\u308C\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u901A\u77E5\u306F\u3001E\u30E1\u30FC\u30EB\u5185\u306E\u300C\u914D\u4FE1\u505C\u6B62\u300D\u30EA\u30F3\u30AF\u304B\u3089\u89E3\u9664\u53EF\u80FD\u3067\u3059\u3002\u500B\u4EBA\u60C5\u5831\u304C\u7B2C\u4E09\u8005\u306B\u5171\u6709\u3055\u308C\u305F\u308A\u8CA9\u58F2\u3055\u308C\u305F\u308A\u3059\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002\n\n<span style="font-size:1rem; font-weight:500;">\u30B5\u30FC\u30D3\u30B9\u306E\u505C\u6B62\u30FB\u4E2D\u65AD</span>\nCompass Bioinformatics Inc.\u306F\u3001\u4EFB\u610F\u306E\u7406\u7531\u306B\u3088\u308AInheriNext\xAE Edge\u306E\u4E00\u90E8\u307E\u305F\u306F\u3059\u3079\u3066\u306E\u6A5F\u80FD\u3092\u4E2D\u65AD\u307E\u305F\u306F\u505C\u6B62\u3059\u308B\u6A29\u5229\u3092\u6709\u3057\u307E\u3059\u3002\u672A\u4F7F\u7528\u306E\u30B5\u30FC\u30D3\u30B9\u306B\u3064\u3044\u3066\u306E\u307F\u8FD4\u91D1\u304C\u884C\u308F\u308C\u307E\u3059\u3002Compass Bioinformatics Inc.\u306F\u3001\u305D\u308C\u4EE5\u5916\u306E\u30B5\u30FC\u30D3\u30B9\u8CAC\u4EFB\u3092\u4E00\u5207\u8CA0\u3044\u307E\u305B\u3093\u3002\n\n<span style="font-size:1rem; font-weight:500;">\u4FDD\u8A3C\u304A\u3088\u3073\u514D\u8CAC\u4E8B\u9805</span>\nInheriNext\xAE Edge\u304C\u4F7F\u7528\u3059\u308B\u30CA\u30EC\u30C3\u30B8\u30D9\u30FC\u30B9\u306F\u79D1\u5B66\u7684\u306B\u59A5\u5F53\u3067\u3042\u308B\u3068\u8003\u3048\u3089\u308C\u307E\u3059\u304C\u3001100%\u306E\u6B63\u78BA\u6027\u307E\u305F\u306F\u5B8C\u5168\u6027\u304C\u4FDD\u8A3C\u3055\u308C\u308B\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002InheriNext\xAE Edge\u306B\u3088\u308B\u89E3\u6790\u7D50\u679C\u306E\u89E3\u91C8\u306B\u3042\u305F\u3063\u3066\u306F\u3001\u72EC\u7ACB\u3057\u305F\u5224\u65AD\u3092\u884C\u3046\u3053\u3068\u306B\u540C\u610F\u3057\u3001\u305D\u306E\u7D50\u679C\u5F97\u3089\u308C\u308B\u77E5\u898B\u306B\u3064\u3044\u3066\u306F\u3059\u3079\u3066\u81EA\u5DF1\u306E\u8CAC\u4EFB\u3067\u3042\u308B\u3053\u3068\u306B\u540C\u610F\u3057\u307E\u3059\u3002\n\n<span style="font-size:1rem; font-weight:500;">\u6700\u9069\u5316\u306B\u3064\u3044\u3066</span>\nInheriNext\xAE Edge\u306F\u30E6\u30FC\u30B6\u30FC\u306E\u4F7F\u7528\u3092\u901A\u3058\u3066\u6700\u9069\u5316\u3055\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u304C\u3001\u305D\u306E\u3053\u3068\u306B\u3088\u3063\u3066\u30E6\u30FC\u30B6\u30FC\u304CInheriNext\xAE Edge\u306E\u5168\u4F53\u307E\u305F\u306F\u4E00\u90E8\u306B\u5BFE\u3059\u308B\u6240\u6709\u6A29\u3092\u6301\u3064\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002\n\n<span style="font-size:1rem; font-weight:500;">\u73FE\u5730\u306E\u6CD5\u4EE4\u306E\u9075\u5B88</span>\nInheriNext\xAE Edge\u306E\u5229\u7528\u898F\u7D04\u306B\u5F93\u3046\u3053\u3068\u3001\u305D\u3057\u3066\u3054\u81EA\u8EAB\u306E\u5C45\u4F4F\u5730\u306E\u6CD5\u4EE4\u306B\u3082\u6E96\u62E0\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u307E\u3059\u3002',
      form: {
        title: {
          ___email: 'アカウント（メールアドレス）',
          ___verification: '認証',
          ___firstName: '名前',
          ___lastName: '苗字',
          ___country: '国や地域',
          ___countryCode: '電話番号',
          ___organization: '所属機関',
          ___division: '部署や役職',
          ___managerID: '管理者ID',
          ___password: '新しいパスワード',
          ___confirmed: '新しいパスワードの確認'
        },
        placeholder: {
          ___email: 'wiseTony@compassbioinfo.com',
          ___verification: '6桁の認証コード',
          ___firstName: '花子',
          ___lastName: '山田',
          ___country: '日本',
          ___countryCode: '+886',
          ___phone: '電話番号',
          ___organization: 'コンパスバイオインフォマティクス株式会社',
          ___division: '臨床研究部門',
          ___managerID: '3桁のコード',
          ___password: '14～100文字を入力してください。',
          ___confirmed: 'パスワードをもう一度入力してください。'
        },
        errorTitle: {
          ___email: 'アカウント（メールアドレス）',
          ___password: 'パスワード',
          ___confirmed: 'パスワード'
        },
        customValidate: {
          ___country: '国名の形式が間違っています。入力内容を再度確認してください。',
          ___countryCode: '国番号が存在していません。',
          ___confirmed: '入力されたパスワードが一致していません。',
          ___verificationCode: '認証コードが間違っています。'
        }
      }
    },
    user: {
      ___avatarTitle: 'アバター',
      tab: {
        ___info: '基本情報',
        ___password: 'パスワード設定',
        ___license: 'ライセンスマネージャー'
      },
      form: {
        title: {
          ___email: 'アカウント（メールアドレス）',
          ___firstName: '名前',
          ___lastName: '苗字',
          ___country: '国や地域',
          ___countryCode: '電話番号',
          ___manager: 'ご担当の管理者名',
          ___organization: '所属機関',
          ___division: '部署や役職',
          ___emailVerification: 'メール認証ログイン',
          ___originalPassword: '前のパスワード',
          ___password: '新しいパスワード',
          ___confirmed: '新しいパスワードの確認'
        },
        placeholder: {
          ___firstName: '花子',
          ___lastName: '山田',
          ___country: '日本',
          ___countryCode: '+886',
          ___phone: '電話番号',
          ___organization: 'コンパスバイオインフォマティクス株式会社',
          ___division: '臨床研究部門',
          ___originalPassword: '14～100文字を入力してください。',
          ___password: '14～100文字を入力してください。',
          ___confirmed: 'パスワードをもう一度入力してください。'
        },
        errorTitle: {
          ___originalPassword: 'パスワード',
          ___password: 'パスワード',
          ___confirmed: 'パスワード'
        },
        customValidate: {
          ___country: '国名の形式が間違っています。入力内容を再度確認してください。',
          ___countryCode: '国番号が存在していません。',
          ___confirmed: '入力されたパスワードが一致していません。',
          ___verificationCode: '認証コードが間違っています。'
        }
      }
    },
    systemInfo: {
      tab: {
        ___database: 'バージョン情報'
      },
      group: {
        ___version: 'バージョン',
        ___result: '{count}の項目',
        title: {
          ___pipeline: '解析パイプラインバージョン',
          ___analysis: 'アノテーションバージョン'
        }
      },
      table: {
        title: {
          ___category: 'カテゴリー',
          ___title: 'タイトル',
          ___version: 'バージョン'
        }
      }
    },
    panel: {
      tab: {
        ___phenotype: '表現型の設定',
        ___gene: '遺伝子パネル'
      }
    },
    config: {
      tab: {
        ___filter: '設定フィルター'
      }
    },
    workgroup: {
      tab: {
        ___case: '症例'
      }
    },
    genomeBrowser: {
      table: {
        title: {
          ___position: '位置 (HG38)',
          ___location: 'エクソンやイントロンの位置',
          ___HGVSc: 'HGVSc',
          ___HGVSp: 'HGVSp'
        }
      }
    },
    caseBatchUpload: {
      form: {
        title: {
          ___owner: '所有者'
        }
      },
      alert: {
        ___content: '<b>5日以内</b>に編集が行われない場合、本バッチアップロードに関するすべての記録<br>（VCFおよびサンプルシートを含む）は自動的に削除されます。',
        ___date: '<b>作成日:</b> {create} | <b>更新日:</b> {update}'
      }
    },
    caseDetail: {
      title: {
        ___deleted: '削除'
      },
      project: {
        title: {
          alert: {
            ___sexDifferent: '解析の性別情報が症例と異なっています。解析のパラメータを編集することで再解析が可能です。'
          }
        },
        card: {
          title: {
            ___modified: '更新日'
          }
        },
        info: {
          title: {
            ___status: 'ステータス',
            ___created: '作成日',
            ___modified: '更新日'
          }
        },
        icon: {
          title: {
            ___delete: '削除'
          }
        },
        detail: {
          intractablePanel: {
            ___title: 'D006-4 遺伝学的検査疾患名',
            ___less: '閉じる',
            ___more: '{count} もっと見る'
          },
          phenotype: {
            ___title: '表現型',
            ___less: '閉じる',
            ___more: '{count} もっと見る'
          },
          genePanel: {
            ___title: '遺伝子/疾患パネル',
            ___infoTitle: 'メンデル遺伝形式',
            ___info: 'スイッチがオンになっている場合、選択された遺伝子座はメンデル遺伝学の法則に従います。メンデル遺伝学の法則に適合しない遺伝子座をフィルタリングする理由は次の通りです: 1.NGS（次世代シーケンス）の技術的制限により、遺伝型の判断ミスが発生する可能性があります。 2.特定の疾患によって、遺伝子座がメンデル遺伝学の法則に適合しなくても症状が引き起こされることがあります。',
            ___less: '閉じる',
            ___more: '{count} もっと見る'
          },
          mendelian: {
            ___title: 'メンデル遺伝形式'
          },
          afThreshold: {
            ___title: 'MOIのAF閾値',
            ___info: 'アレル頻度の閾値は、疾患の流行率に依存するので、それに応じて調整すべきである。その値は0以上で1以下でなければならない。閾値を編集したい場合は、表現型の近くにある編集ボタンをクリックしてください。',
            item: {
              title: {
                ___ad: 'AD',
                ___compHet: '複合ヘテロ接合体',
                ___ar: 'AR',
                ___exclLQ: '低品質除外'
              }
            }
          },
          phenotypeVariant: {
            ___title: '表現型及びバリアントスコアの閾値',
            ___info: '表現型スコアは、ユーザーが提供した表現型に基づいて、類似性の観点から算出された。バリアントスコアは、複数の予測スコア（例：SIFT、CADDなど）と集団のアレル頻度から計算された。閾値を編集したい場合は、表現型の近くにある編集ボタンをクリックしてください。',
            item: {
              title: {
                ___phenotypeScore: '表現型スコア',
                ___variantScore: 'バリアントスコア'
              }
            }
          }
        }
      },
      top: {
        icon: {
          title: {
            ___digitalMLPA: 'digitalMLPA',
            ___file: 'ファイル',
            ___analysisVersion: '解析バージョン',
            ___qc: '品質管理',
            ___delete: '削除'
          }
        }
      },
      caseInfo: {
        title: {
          ___owner: '所有者',
          ___subjectName: '被検者名',
          ___sex: '性別',
          ___birthYear: '生年',
          ___population: '集団',
          ___note: '注釈',
          ___workgroup_name: 'ワークグループ',
          ___workgroup_stage: '- 作業段階',
          ___workgroup_due_date: '- 締切日',
          ___workgroup_assignee: '- 担当者'
        },
        empty: {
          ___birthYear: '不明'
        }
      },
      tab: {
        data: {
          ___defaultTitle: 'デフォルト',
          examinationIntractableDisease: {
            ___title: '保険検査と指定難病',
            subTab: {
              intractableDiseaseResults: {
                ___title: 'D006-4の結果'
              },
              designatedIntractableDiseaseResults: {
                ___title: '指定難病の結果'
              }
            }
          },
          diagnosticTest: {
            ___title: '解析結果',
            subTab: {
              intractableDiseaseResults: {
                ___title: 'D006-4の結果'
              },
              phenotypeResults: {
                ___title: '表現型の結果'
              },
              genePanelResults: {
                ___title: '遺伝子パネルの結果'
              },
              repeatResults: {
                ___title: 'repeatの結果'
              }
            }
          },
          proactiveTest: {
            ___title: 'プロアクティブ・テスト',
            subTab: {
              pathogenicVariants: {
                ___title: '病原性バリアント'
              },
              nullVariants: {
                ___title: 'ヌルバリアント'
              },
              carrier: {
                ___title: 'キャリア'
              },
              incidentalFindings: {
                ___title: '二次的所見'
              }
            }
          },
          filter: {
            ___title: 'フィルター'
          },
          monitor: {
            ___title: 'モニター'
          },
          report: {
            ___title: 'レポート'
          }
        },
        info: {
          ___limit: '記録が200件の上限に達しました。一部のデータはご利用いただけませんのでご了承ください。'
        }
      },
      displayView: {
        title: {
          ___SNV: 'SNV',
          ___SV: 'SV',
          ___STR: 'STR'
        }
      },
      edit: {
        ___info: 'NGSデータ（FASTQ、uBAMまたはVCF）をアップロードする前に、症例と解析情報を編集することができます。'
      },
      modal: {
        content: {
          ___delete: '症例を削除すると、その症例の結果はInheriNextから削除されます。この症例を削除しますか？',
          ___user: 'この症例は、PhenoVarDB の {dataset} のデータセット構築に使用されています。症例を削除する前に、上記のデータセットを削除してください。 | これらの症例は、PhenoVarDB の {dataset} のデータセット構築に使用されています。症例を削除する前に、上記のデータセットを削除してください。',
          ___admin: 'この症例は、PhenoVarDB の {dataset} のデータセット構築に使用されています。サンプルを削除すると、上記のデータセットへのアクセシビリティに影響が出ます。この症例を削除しますか？| これらの症例はPhenoVarDBの {dataset} のデータセットビルドに使用されています。サンプルを削除すると、上記のデータセットへのアクセスに影響があります。これらの症例を削除しますか？',
          ___truelyDelete: 'この症例のファイルおよび情報はすべて永久に削除されます。それでも続けますか？',
          ___truelyAdmin: 'この症例は、PhenoVarDBの {dataset} のデータセットビルドに使用されています。サンプルを削除すると、上記のデータセットへのアクセシビリティに影響が出ます。この症例を削除しますか？| これらの症例は、PhenoVarDBの {dataset} のデータセットビルドに使用されています。サンプルを削除すると、上記のデータセットへのアクセシビリティに影響が出ます。これらの症例を削除しますか？',
          ___restartPipeline: '<span style="color:#FA3D3D">エラーが修正されていることを確認してください。修正がされていない場合、解析が再び失敗する可能性があります。</span>',
          ___deleteProject: '<span style="color:#FF414D">解析を削除すると、関連する結果はInheriNextから削除されます。それでも削除しますか？</span>'
        }
      }
    },
    caseList: {
      tab: {
        title: {
          ___single: 'シングル'
        }
      }
    },
    datasetDetail: {
      top: {
        icon: {
          content: {
            ___adminAnnotation: '管理者の注釈を選択する。',
            ___annotation: '注釈を選択する。',
            ___unchiveDataset: 'データセットのアーカイブを解除する。',
            ___archiveDataset: 'データセットをアーカイブします。'
          }
        }
      },
      info: {
        title: {
          ___create: '作成日',
          ___modified: '更新日',
          ___sampleSize: 'サンプルサイズ',
          ___externalData: '外部データ',
          ___owner: '所有者',
          ___description: '詳細',
          ___tags: 'タグ一覧',
          ___sharing: '共有',
          ___users: 'ユーザー',
          ___datasetURL: 'データセットのURL',
          ___accessKey: 'アクセスキー'
        },
        content: {
          externalData: {
            ___yes: 'はい',
            ___no: 'いいえ'
          },
          sharing: {
            ___community: 'コミュニティー',
            ___notAvailable: 'ご利用できません。'
          },
          users: {
            ___users: '{count} ユーザー'
          }
        },
        icon: {
          title: {
            ___datasetURL: 'コピー'
          }
        }
      },
      tab: {
        title: {
          ___summary: '概要',
          ___samplesList: 'サンプルリスト'
        }
      },
      modal: {
        content: {
          ___deleteDataset: '<span style="color:#FF414D">このデータセットを削除すると、永久に削除されます。<br>データセットを削除しますか？</span>',
          ___setDatasetAnnotation01: 'この症例の集団データベースで、PhenoVarDB {type} の注釈にこのデータセットを選択してください。',
          ___setDatasetAnnotation02: 'PhenoVarDB {type} の注釈を更新するために、必ず症例を再度解析してください。',
          ___setDatasetAnnotation03: '<span>データセット {dataset} が注釈の為に選択されました。<br>このデータセットを選択しますか？</span>'
        }
      }
    },
    datasetList: {
      ___roleFilterTitle: '役割',
      ___roleFilterPlaceholder: 'すべて',
      ___sortTitle: '並び替え',
      ___searchPlaceholder: '検索するデータセットのキーワードを入力してください（例：乳がん）。',
      sortOption: {
        default: {
          title: {
            ___name: 'データセット名',
            ___createdAt: '作成日',
            ___updatedAt: '更新日',
            ___sampleSize: 'サンプルサイズ',
            ___externalDataIncluded: '外部データ',
            ___state: 'ステータス'
          }
        },
        community: {
          title: {
            ___name: 'データセット名',
            ___createdAt: '作成日',
            ___updatedAt: '更新日',
            ___sampleSize: 'サンプルサイズ',
            ___communityPermission: '権限'
          }
        }
      },
      tab: {
        title: {
          ___default: 'マイデータセット',
          ___community: 'コミュニティー'
        }
      },
      subTab: {
        default: {},
        community: {
          title: {
            ___default: 'コミュニティー・データセット',
            ___sharedWithMe: '共有されたデータセット',
            ___myShares: '私が共有したデータセット'
          }
        }
      }
    },
    common: {
      accountTab: {
        ___user: 'アカウント',
        ___workgroup: 'ワークグループ',
        ___panel: 'パネル',
        ___config: '構成',
        ___systemInfo: 'システム情報'
      }
    }
  },
  // component
  COMPONENT: {
    case: {
      base: {
        customForm: {
          affected: {
            ___title: '疾患あり<br>（Affected）'
          },
          reportPhenovardb: {
            ___off: 'オフ',
            ___on: 'オン'
          }
        },
        analysis: {
          ___title: '表現型の優先順位付け',
          ___familyTitle: '家族解析',
          panel: {
            ___title: '表現型パネル',
            ___empty: 'パネルがまだありません。こちらでパネルを作成できます。'
          },
          phenotype: {
            ___selectedTitle: '選択する',
            phenotypeTag: {
              ___placeholder: '表現型(例：呼吸困難)または疾患(例：乳がん)'
            }
          },
          gene: {
            ___title: '遺伝子フィルター',
            ___selectedTitle: '選択する',
            geneTag: {
              ___placeholder: '遺伝子パネル(例：健康関連所見の追加)'
            }
          },
          genePanel: {
            ___title: '遺伝子/疾患パネル'
          },
          alleleFrequencyThreshold: {
            ___title: '遺伝モードのアレル頻度閾値',
            ___info: 'アレル頻度の閾値は、疾患の流行率に依存するので、それに応じて調整すべきである。その値は0以上で1以下でなければならない。'
          },
          scoreThreshold: {
            ___title: '表現型・遺伝子パネル選択のスコア閾値',
            ___info: '表現型スコアは、ユーザーが提供した表現型に基づいて、類似性の観点から算出された。バリアントスコアは、複数の予測スコア（例：SIFT、CADDなど）と集団のアレル頻度から計算された。その値は0.6以上で1以下でなければならない。'
          },
          familyAnalysis: {
            ___title: '家族メンバー',
            alert: {
              ___vcf: 'この VCF ファイルの形式は家族解析に対応していません。'
            },
            option: {
              title: {
                ___excludeVariant: '家系分離アルゴリズムによりバリアントを除外する'
              }
            }
          }
        },
        file: {
          ___afterAlert: 'データなしでも後からアップロード可',
          ___cloudTitle: 'Google Bucketからアップロード',
          vcf: {
            ___title: 'VCFデータセット',
            file: {
              ___snvTitle: 'SNV/INDEL VCFファイル',
              ___svTitle: 'SV VCFファイル',
              ___strTitle: 'STR VCFファイル (ExpansionHunter/TRGT/Straglr)',
              ___svInfo: '複数のSV VCFファイルに対応しています（最大{count}つまで）。',
              ___source01: '現時点では、ゲノムビルドバージョン GRCh38/hg38 のみサポートしています。',
              ___source02: 'VCFファイルのゲノムビルドバージョンがアップロードされていることを確認してください。'

            }
          },
          fastq: {
            ___title: 'FASTQデータセット',
            file: {
              ___title: 'Set{set}-Fastq-{read}'
            }
          },
          ubam: {
            ___title: 'uBAMデータセット',
            file: {
              ___title: 'Set{set}-uBAM'
            }
          },
          alert: {
            ___content: '<b>重要なお知らせ！</b>ゲノムビルドバージョン GRCh38/hg38 のみサポートしています。VCFファイルのゲノムビルドバージョンがアップロードされていることを確認してください。'
          },
          pipeline: {
            title: {
              ___single: 'Single-end',
              ___paired: 'Paired-end'
            }
          }
        },
        option: {
          sex: {
            title: {
              ___male: '男性',
              ___female: '女性',
              ___unknown: '不明'
            }
          },
          popuplation: {
            title: {
              ___AfricanAfricanAmerican: 'アフリカン/アフリカ系アメリカ人',
              ___LatinoAdmixedAmerican: 'ラテン系/混血アメリカ人',
              ___AshkenaziJewish: 'アシュケナージ系ユダヤ人',
              ___EastAsian: '東アジア人',
              ___Koreans: '韓国人',
              ___Japanese: '日本人',
              ___OtherEastAsian: 'その他の東アジア人',
              ___Finnish: 'フィンランド人',
              ___NonFinnishEuropean: 'フィンランド以外のヨーロッパ人',
              ___Bulgarian: 'ブルガリア人',
              ___Estonian: 'エストニア人',
              ___NorthWesternEuropean: '北西ヨーロッパ人',
              ___SouthernEuropean: '南ヨーロッパ人',
              ___Swedish: 'スウェーデン人',
              ___OthernonFinnishEuropean: 'その他のフィンランド以外のヨーロッパ人',
              ___SouthAsian: '南アジア人',
              ___Other: 'その他'
            }
          }
        },
        form: {
          case: {
            title: {
              ___owner: '所有者',
              ___caseID: '症例ID',
              ___affected: 'サンプルの種類',
              ___subjectName: '被検者名',
              ___sex: '性別',
              ___birthYear: '生年',
              ___population: '集団',
              ___note: '注釈'
            },
            placeholder: {
              ___caseID: '症例ID',
              ___subjectName: 'John',
              ___sex: '性別',
              ___birthYear: '生年',
              ___population: '集団',
              ___note: '例：コンパスバイオインフォマティクス株式会社'
            },
            format: {
              affected: {
                ___true: '疾患あり<br>（Affected）',
                ___false: '疾患なし<br>（Unaffected）'
              }
            },
            option: {
              birthYear: {
                ___unknown: '不明'
              }
            }
          },
          analysis: {
            title: {
              ___name: '解析名',
              ___note: '解析注釈',
              ___report: 'PhenoVarDBに報告する'
            },
            placeholder: {
              ___name: '乳がんパネル',
              ___note: '例：コンパスバイオインフォマティクス株式会社'
            }
          },
          alleleFrequencyThreshold: {
            title: {
              ___ad_cutoff: '常染色体優性遺伝(AD)',
              ___ar_cutoff: '常染色体劣性遺伝(AR)',
              ___comp_het_cutoff: '複合ヘテロ接合性',
              ___exclude_low_quality_variants: 'LQバリアントを除外する。',
              ___enable_clinvar_benign_filter: '既知の良性バリアントの優先度は低い。'
            },
            errorTitle: {
              ___ad_cutoff: '常染色体優性遺伝(AD)',
              ___ar_cutoff: '常染色体劣性遺伝(AR)'
            },
            placeholder: {
              ___ad_cutoff: '0.001',
              ___ar_cutoff: '0.05',
              ___comp_het_cutoff: '0.05'
            }
          },
          scoreThreshold: {
            title: {
              ___phenotype_score_cutoff: '表現型スコア',
              ___variant_score_cutoff: 'バリアントスコア'
            },
            placeholder: {
              ___phenotype_score_cutoff: '0.3',
              ___variant_score_cutoff: '0.7'
            }
          },
          pipeline: {
            title: {
              ___omics_name: 'パイプライン'
            },
            errorTitle: {
              ___omics_name: 'オーミクス',
              ___pipeline_name: 'パイプライン',
              ___library_type_name: 'ライブラリーの種類'
            },
            placeholder: {
              ___omics_name: 'オーミクス',
              ___pipeline_name: '類型（例：WGS）',
              ___library_type_name: 'ライブラリーキット（例：Roche KAPA HyperExome kit）'
            }
          }
        }
      },
      baseFamilyCase: {
        ___searchPlaceholder: '症例ID（例：Case1）',
        table: {
          title: {
            ___case_id: '症例ID',
            ___type: 'サンプルの種類',
            ___relation: '関係'
          },
          option: {
            type: {
              title: {
                ___Affected: '疾患あり<br>（Affected）',
                ___Unaffected: '疾患なし</br>（Unaffected）'
              }
            },
            relation: {
              ___placeholder: '関係を選択してください'
            }
          }
        }
      },
      genotypeIcon: {
        altMessage: {
          relation: {
            ___father: '父',
            ___mother: '母',
            ___proband: '発端者'
          },
          result: {
            ___ref: 'ref',
            ___homo: 'homo',
            ___hemi: 'hemi',
            ___ref_hemi: 'ref',
            ___het: 'het',
            ___unknown: '不明'
          }
        }
      },
      diseaseIcon: {
        ___text01: '疾患に関連するHPOに<br>直接マップします。',
        ___text02: '疾患に関連するHPOに間接的にマップします。',
        ___text03: '類似性のパスは、提供されたHPO項から、長さ <b>{length}</b> 近隣のHPO項を介した疾患関連HPO項への関連性を示す。'
      },
      errorMessage: {
        ___uploading: 'データをアップロード中...',
        ___analyzing: 'データを解析中...',
        ___failed01: '予期しない問題が発生しました。',
        ___failed02: '現在、この問題を解決しています。',
        ___failed03: '予期しない問題が発生しました：'
      },
      intractableDisease: {
        select: {
          ___title: 'D006-4 遺伝学的検査'
        },
        switch: {
          ___title: '指定難病分析',
          switchButton: {
            ___off: 'オフ',
            ___on: 'オン'
          }
        },
        selectResult: {
          ___title: '選択する'
        }
      },
      mastermindFilterTable: {
        table: {
          title: {
            ___report: 'レポート',
            ___classification: '分類',
            ___variantIdentifiers: 'バリアント識別子',
            ___publications: '文献'
          },
          value: {
            ___publications: '{count} 文献 | {count} 文献',
            ___empty: 'Mastermind はロックされています。結果を表示するには、ロックを解除してください。'
          }
        }
      },
      mastermindPublicationTable: {
        table: {
          title: {
            ___no: 'No.',
            ___details: '詳細',
            ___PMID: 'PMID'
          },
          info: {
            details: {
              ___open: '(詳細)',
              ___hide: '非表示'
            }
          }
        },
        page: {
          ___total: '合計 {total} 件',
          ___display: 'ページあたりの表示件数：{display}'
        }
      }
    },
    caseBatchUpload: {
      base: {
        modal: {
          content: {
            ___deleteSet: '<span style="color:#FA3D3D">この操作により、アップロード記録はすべて完全に削除されます。バッチアップロードを削除してもよろしいですか？</span>',
            ___confirmSuccess: '<span style="color:#003679"><b>{count} 件のサンプルの準備がすべて完了しました。</b>送信しますか？</span>',
            ___confirmFailed: '<span style="color:#FA3D3D"><b>{count} 件のサンプルが未準備です。</b>続行すると、未準備サンプルは作成されません。送信しますか？</span>'
          }
        }
      },
      sheetUpload: {
        form: {
          ___title: 'サンプルシート',
          ___info: '<span>テンプレート</span>'
        },
        result: {
          ___title: 'サンプルシートチェック',
          group: {
            title: {
              ___error: '{count} 件のエラー | {count} 件のエラー | {count} 件のエラー'
            },
            error: {
              ___invalidFilesize: 'ファイルサイズが大きすぎます'
            }
          }
        }
      },
      fileUpload: {
        form: {
          ___title: 'VCF データセット',
          upload: {
            ___title: 'ここにファイルをドラッグしてください',
            ___content: 'またはデバイスから<br><span>ファイルを選択</span> してください。'
          }
        },
        result: {
          ___title: 'ファイルをアップロード',
          ___info: '完了: <b>{upload}</b>/{total}',
          group: {
            title: {
              ___uploading: 'アップロード中 {info}',
              ___finished: '完了 {info}',
              ___failed: '失敗・エラー {info}'
            }
          },
          file: {
            info: {
              ___uploading: '(<span class=uploading>処理待ち</span>)',
              ___pending: '(<span class=uploading>保留中</span>)',
              ___finished: '(<span class=finished>完了</span>)',
              ___matched: '(<span class=finished>ファイル名が一致</span>)',
              error: {
                ___invalidFormat: '無効なファイル形式です',
                ___duplicatedFilename: 'ファイル名が重複しています',
                ___invalidFilesize: 'ファイルサイズが大きすぎます'
              }
            }
          }
        }
      },
      sheetResult: {
        ___title: 'アップロード内容を確認',
        ___info: '(<span>{count}/{total} が一致</span>)',
        search: {
          ___placeholder: '検索キーワードを入力してください（例：Case ID、性別 など）'
        },
        table: {
          title: {
            ___case_id: '症例ID',
            ___sampleType: 'サンプルの種類',
            ___sex: '性別',
            ___analysisName: '解析名',
            ___phenotype: '表現型',
            ___snvVCF: 'SNV VCF',
            ___svVCF: 'SV VCF',
            ___strVCF: 'STR VCF',
            ___delete: 'DEL',
            info: {
              ___phenotype: '表現型を編集する場合は、サンプルシートを更新のうえ再度アップロードしてください。'
            }
          },
          display: {
            sampleType: {
              ___true: '疾患あり<br>（Affected）',
              ___false: '疾患なし<br>（Unaffected）'
            },
            sex: {
              ___Male: 'M',
              ___Female: 'F',
              ___Unknown: 'U'
            }
          },
          content: {
            info: {
              ___phenotype: 'HPOデータベースに該当がありません。'
            },
            empty: {
              ___phenotype: '表現型なし',
              ___file: 'ファイルなし'
            }
          }
        },
        page: {
          ___total: '合計 {total} 件',
          ___display: 'ページあたりの表示件数： {display}'
        }
      }
    },
    caseDetail: {
      analysisVersionTable: {
        table: {
          title: {
            ___category: 'カテゴリー',
            ___name: '名称',
            ___version: 'バージョン',
            ___systemVersion: 'システムバージョン'
          }
        }
      },
      filter: {
        ___empty: '0件',
        table: {
          title: {
            ___CHROM: 'Chr',
            ___POS: 'Pos',
            ___REF: 'Ref / Alt',
            ___dbSNP_ID: 'rsID',
            ___Consequence: '変異タイプ',
            ___GT: '遺伝子型',
            ___SYMBOL: '遺伝子名',
            ___HGVSc: 'HGVSc',
            ___HGVSp: 'HGVSp'
          }
        },
        modal: {
          content: {
            ___retryAlert: '<span>ジョブが失敗しました。ジョブを再送信しますか？</span>'
          }
        }
      },
      dataList: {
        page: {
          ___total: '合計 {total} 件',
          ___display: 'ページあたりの表示件数：{display}'
        },
        error: {
          ___text: '疾患の原因となりうるバリアントは見つかりませんでした。',
          ___empty: 'データなし'
        }
      },
      geneData: {
        table: {
          ___variantAlert: 'バリアントのフェージングは考慮されていません。',
          icon: {
            monitor: {
              ___title01: 'モニターに追加する',
              ___title02: 'モニターから外す'
            },
            report: {
              ___title01: 'レポートに追加する',
              ___title02: 'レポートから外す'
            }
          },
          title: {
            ___position: '位置<br>(HG38)',
            ___rank: 'エクソン/<br>イントロン<br>位置',
            ___HGVSm: 'HGVSm',
            ___HGVSc: 'HGVSc',
            ___HGVSp: 'HGVSp',
            ___Zygosity: '接合性',
            ___HeteroplasmyLevel: 'ヘテロプラスミー・<br>レベル(%)',
            ___Consequence: '変異タイプ',
            ___Prediction: '予測<br>スコア',
            ___AlleleFrequency: 'アレル頻度',
            ___Homoplasmy: 'ホモプラスミー<br>EAS AF',
            ___Heteroplasmy: 'ヘテロプラスミー<br>EAS AF',
            ___variantDatabase: 'バリアントデータベース',
            ___ACMG: 'ACMG',
            ___rsID: 'rs ID',
            ___parentalOrigin: '親由来'
          },
          link: {
            position: {
              ___UCSC: 'UCSC',
              ___Ensembl: 'Ensembl',
              ___Genomebrowser: 'ゲノム・ブラウザ'
            }
          }
        },
        mainLink: {
          title: {
            ___Pedigree: '家系図'
          }
        },
        externalLink: {
          title: {
            ___GHR: 'GHR',
            ___NCBI_Gene: 'NCBI Gene',
            ___OMIM: 'OMIM',
            ___UniProt: 'UniProt',
            ___HPO: 'HPO',
            ___Orphanet: 'Orphanet'
          }
        },
        intractableDiseaseLink: {
          title: {
            ___center: '難病情報センター',
            ___other: '他の関連情報',
            ___nando: 'NanbyoData 難病データ'
          }
        },
        condition: {
          ___title: '疾患',
          ___alert01: '二次的所見の報告を推奨する疾患。',
          ___less: '閉じる',
          ___more: '{count} もっと見る'
        },
        disease: {
          ___title: '選択した疾患の表現型ネットワーク',
          ___less: '閉じる',
          ___more: '{count} もっと見る'
        }
      },
      genePreviewDisplayForm: {
        mainFormOptions: {
          title: {
            ___1st: '第1カラム',
            ___2nd: '第2カラム'
          }
        }
      },
      geneClinvarData: {
        ___clinvarStatisticTitle: 'ClinVar遺伝子統計',
        table: {
          clinvar: {
            ___title: 'ClinVar',
            title: {
              ___interpretation: '解釈',
              ___reviewStatus: 'レビュー状況',
              ___condition: '疾患',
              ___conflicts: '競合'
            }
          }
        }
      },
      geneMastermindData: {
        ___lockAlert: 'Mastermind はロックされています。結果を表示するには、ロックを解除してください。',
        table: {
          mastermind: {
            ___title: 'Mastermind',
            title: {
              ___report: 'レポート',
              ___classification: '分類',
              ___variantIdentifiers: 'バリアント識別子',
              ___publications: '文献'
            },
            value: {
              ___publications: '{count} 文献 | {count} 文献'
            }
          },
          publication: {
            ___title: '<b>レポート {count}</b> の <b>{variant}</b> に関する文献詳細'
          }
        },
        modal: {
          content: {
            ___unlockReanalyze: 'この解析に<b>Mastermindのアノテーション</b>を適用しますか？適用後、システムがこのケースを再解析します。再解析が完了すると、更新された結果が表示されます。',
            ___unlockReanalyzeForOwner: '<b>{owner}の解析にMastermindのアノテーション</b>を適用しますか？この操作を実行すると、<span class=alert>あなたのライセンスのクオータが消費されます</span>。適用後、システムがこのケースを再解析し、再解析が完了すると更新された結果が表示されます。',
            ___unlockReload: 'この解析に<b>Mastermindのアノテーション</b>を適用しますか？適用後、ページが再読み込みされます。更新された結果を表示するには、このページを再度開いてください。',
            ___unlockReloadForOwner: '<b>{owner}の解析にMastermindのアノテーション</b>を適用しますか？この操作を実行すると、<span class=alert>あなたのライセンスのクオータが消費されます</span>。適用後、ページが再読み込みされます。更新された結果を表示するには、このページを再度開いてください。'
          }
        }
      },
      geneMitomapData: {
        table: {
          mitomap: {
            ___title: 'MITOMAP',
            title: {
              ___af: 'AF',
              ___heteroplasmy: 'ヘテロプラスミー',
              ___homoplasmy: 'ホモプラスミー',
              ___diseaseStatus: '病状',
              ___disease: '疾患',
              ___pubmedIDs: 'PubMed ID'
            }
          }
        }
      },
      regionData: {
        ___geneTitle: 'オーバーラップ遺伝子',
        table: {
          icon: {
            monitor: {
              ___title01: 'モニターに追加する',
              ___title02: 'モニターから外す'
            },
            report: {
              ___title01: 'レポートに追加する',
              ___title02: 'レポートから外す'
            }
          },
          title: {
            ___Cytoband: 'サイトバンド',
            ___Length: '長さ',
            ___Zygosity: '接合性',
            ___dbVar: 'dbVar',
            ___DECIPHER: 'DECIPHER',
            ___AF: 'AF',
            ___SV_Caller: 'SV コーラー',
            ___ACMG_SV: 'ACMG SV'
          },
          value: {
            Zygosity: {
              ___no_call: 'No call',
              ___unknown: 'Unknown',
              ___hemizygote: 'Hem',
              ___homozygote: 'Hom',
              ___heterozygote: 'Het'
            }
          }
        },
        externalLink: {
          title: {
            ___DGV: 'DGV',
            ___DECIPHER: 'DECIPHER',
            ___GHR: 'GHR',
            ___OMIM: 'OMIM',
            ___HPO: 'HPO',
            ___Orphanet: 'Orphanet'
          }
        },
        condition: {
          // ___title: '疾患',
          ___title: '上位5遺伝子と関連疾患',
          ___emptyText: '<a class=link>オーバーラップ遺伝子</a>をクリックすると、各遺伝子に関連する疾患が表示されます',
          ___alert01: '二次的所見の報告を推奨する疾患。',
          ___less: '閉じる',
          ___more: '{count} もっと見る',
          inheritance: {
            ___info: 'ほか {count} 件の疾患'
          }
        },
        disease: {
          ___title: 'DECIPHERの表現型ネットワーク',
          ___less: '閉じる',
          ___more: '{count} もっと見る'
        }
      },
      regionOverlappingGeneData: {
        table: {
          title: {
            ___Overlap_region: '重複領域',
            ___Dosage_sensitivity: '遺伝子量感受性',
            ___pLI: 'pLI',
            ___LOEUF: 'LOEUF'
          },
          content: {
            Dosage_sensitivity: {
              ___Haplo: 'Haplo',
              ___Triplo: 'Triplo'
            },
            pLI: {
              ___GenomAD: 'genomAD',
              ___ExAC: 'ExAC'
            }
          }
        },
        externalLink: {
          title: {
            ___GHR: 'GHR',
            ___NCBI_Gene: 'NCBI Gene',
            ___OMIM: 'OMIM',
            ___UniProt: 'UniProt',
            ___HPO: 'HPO',
            ___Orphanet: 'Orphanet'
          }
        },
        condition: {
          ___title: '関連する疾患',
          ___alert01: '二次的所見の報告を推奨する疾患。',
          ___less: '閉じる',
          ___more: '{count} もっと見る'
        },
        disease: {
          ___title: '選択した疾患の表現型ネットワーク',
          ___less: '閉じる',
          ___more: '{count} もっと見る'
        }
      },
      regionGeneData: {
        page: {
          ___total: '合計 {total} 件',
          ___display: 'ページあたりの表示件数：{display}'
        }
      },
      regionVariantData: {
        ___overViewTitle: '概要',
        table: {
          dbVar: {
            title: {
              ___dbVarID: 'dbVar ID',
              ___Location: '位置',
              ___Size: 'サイズ',
              ___Classification: '分類',
              ___Zygosity: '接合性',
              ___Overlapinfo: 'オーバーラップ情報'
            },
            titleInfo: {
              overlapInfo: {
                ___title: '構造変異（SV）と重複する領域に関するアノテーション',
                type: {
                  ___pathogenic: '病原性SVの場合',
                  ___other: 'その他の場合'
                },
                formula: {
                  ___result: 'オーバーラップ率（％）',
                  ___denominatorSV: 'アノテーション対象SVの長さ',
                  ___denominatorFeature: '特徴の長さ',
                  ___numerator: 'アノテーション対象SVと特徴との重複部分の長さ×100'
                }
              }
            }
          },
          DECIPHER: {
            title: {
              ___DECIPHERID: 'DECIPHER ID',
              ___Location: '位置',
              ___Size: 'サイズ',
              ___Classification: '分類',
              ___Zygosity: '接合性',
              ___Phenotype: '表現型',
              ___Overlapinfo: 'オーバーラップ情報'
            },
            titleInfo: {
              overlapInfo: {
                ___title: '構造変異（SV）と重複する領域に関するアノテーション',
                type: {
                  ___pathogenic: '病原性SVの場合',
                  ___other: 'その他の場合'
                },
                formula: {
                  ___result: 'オーバーラップ率（％）',
                  ___denominatorSV: 'アノテーション対象SVの長さ',
                  ___denominatorFeature: '特徴の長さ',
                  ___numerator: 'アノテーション対象SVと特徴との重複部分の長さ×100'
                }
              }
            },
            content: {
              ___more: 'もっと見る'
            },
            detailData: {
              ___hideTitle: '非表示',
              phenotype: {
                ___title: '{id} の表現型リスト'
              }
            }
          },
          overlapInfo: {
            title: {
              ___db: 'データベース',
              ___sample: '症例'
            }
          }
        },
        page: {
          ___total: '合計 {total} 件',
          ___display: 'ページあたりの表示件数：{display}'
        }
      },
      regionPublicationData: {
        table: {
          gnomAD: {
            title: {
              ___gnomADID: 'gnomAD ID',
              ___Location: '位置',
              ___Size: 'サイズ',
              ___AlleleFrequency: 'アレル頻度',
              ___Overlapinfo: 'オーバーラップ情報'
            },
            titleInfo: {
              overlapInfo: {
                ___title: '構造変異（SV）と重複する特徴についてのアノテーションアノテーション',
                formula: {
                  ___result: 'オーバーラップ率（％）',
                  ___denominatorSV: 'アノテーション対象SVの長さ',
                  ___denominatorFeature: '特徴の長さ',
                  ___numerator: 'アノテーション対象SVと特徴との重複部分の長さ×100'
                }
              }
            }
          },
          dbVar: {
            title: {
              ___dbVarID: 'dbVar ID',
              ___Location: '位置',
              ___Size: 'サイズ',
              ___AlleleFrequency: 'アレル頻度',
              ___Overlapinfo: 'オーバーラップ情報'
            },
            titleInfo: {
              overlapInfo: {
                ___title: '構造変異（SV）と重複する特徴についてのアノテーションアノテーション',
                formula: {
                  ___result: 'オーバーラップ率（％）',
                  ___denominatorSV: 'アノテーション対象SVの長さ',
                  ___denominatorFeature: '特徴の長さ',
                  ___numerator: 'アノテーション対象SVと特徴との重複部分の長さ×100'
                }
              }
            }
          },
          JSV2: {
            title: {
              ___JSV2ID: 'JSV2 ID',
              ___Location: '位置',
              ___Size: 'サイズ',
              ___AlleleFrequency: 'アレル頻度',
              ___Overlapinfo: 'オーバーラップ情報'
            },
            titleInfo: {
              overlapInfo: {
                ___title: '構造変異（SV）と重複する特徴についてのアノテーションアノテーション',
                formula: {
                  ___result: 'オーバーラップ率（％）',
                  ___denominatorSV: 'アノテーション対象SVの長さ',
                  ___denominatorFeature: '特徴の長さ',
                  ___numerator: 'アノテーション対象SVと特徴との重複部分の長さ×100'
                }
              }
            }
          },
          CoLoRSdb: {
            title: {
              ___CoLoRSdbID: 'CoLoRSdb ID',
              ___Location: '位置',
              ___Size: 'サイズ',
              ___AlleleFrequency: 'アレル頻度',
              ___Overlapinfo: 'オーバーラップ情報'
            },
            titleInfo: {
              overlapInfo: {
                ___title: '構造変異（SV）と重複する特徴についてのアノテーションアノテーション',
                formula: {
                  ___result: 'オーバーラップ率（％）',
                  ___denominatorSV: 'アノテーション対象SVの長さ',
                  ___denominatorFeature: '特徴の長さ',
                  ___numerator: 'アノテーション対象SVと特徴との重複部分の長さ×100'
                }
              }
            }
          },
          overlapInfo: {
            title: {
              ___db: 'データベース',
              ___sample: '症例'
            }
          }
        },
        page: {
          ___total: '合計 {total} 件',
          ___display: 'ページあたりの表示件数：{display}'
        }
      },
      repeatData: {
        table: {
          ___variantAlert: 'バリアントのフェージングは考慮されていません。',
          icon: {
            monitor: {
              ___title01: 'モニターに追加する',
              ___title02: 'モニターから外す'
            },
            report: {
              ___title01: 'レポートに追加する',
              ___title02: 'レポートから外す'
            }
          },
          title: {
            ___position: '位置<br>(HG38)',
            ___Region: '領域',
            ___Repeat_unit: '反復単位',
            ___REF: '参照コピー数',
            ___ALT: 'ALT',
            ___Zygosity: '接合性',
            ___Allele_Repeat_Copy_Number: 'アレル反復回数<br>（CI）',
            ___Classification: '分類'
          }
        },
        externalLink: {
          title: {
            ___STRipy: 'STRipy',
            ___gnomAD: 'gnomAD',
            ___OMIM: 'OMIM',
            ___HPO: 'HPO'
          }
        },
        condition: {
          ___title: '疾患',
          ___alert01: '二次的所見の報告を推奨する疾患。',
          ___less: '閉じる',
          ___more: '{count} もっと見る'
        }
      },
      report: {
        ___editTitle: '報告書ツールボックス',
        ___templateTitle: 'テンプレート',
        ___reportTitle: '報告書のプレビューと編集',
        page: {
          title: {
            ___pre: '前章',
            ___next: '次章'
          }
        }
      }
    },
    caseList: {
      single: {
        ___roleFilterTitle: '役割',
        ___roleFilterPlaceholder: 'すべて',
        ___searchPlaceholder: 'キーワード（例：症例ID、名前、...）を入力して検索してください。',
        table: {
          title: {
            ___case_id: '症例ID',
            ___sex: '性別',
            ___birth_year: '生年',
            ___population: '集団',
            ___created_at: '作成日',
            ___updated_at: '更新日',
            ___user: '所有者',
            ___seq: 'Seq',
            ___state: '解析ステータス',
            ___note: '注釈',
            ___workgroup: 'ワークグループ',
            ___stage: '作業段階',
            ___due_date: '締切日',
            ___assignee: '担当者'
          },
          content: {
            seq: {
              ___WES: 'WES',
              ___WES_MT: 'WES+MT',
              ___WGS: 'WGS'
            },
            workgroup_stage: {
              ___select: '作業段階を選択してください'
            }
          },
          display: {
            sex: {
              ___Male: '男性',
              ___Female: '女性',
              ___Unknown: '不明'
            }
          }
        },
        modal: {
          content: {
            ___pointAlert: '<span style="color:#FA3D3D">症例を作成するには {price} ポイントが必要です。所持ポイントが足りません。追加購入しますか？</span>'
          }
        }
      }
    },
    digitalMLPA: {
      mainUpload: {
        upload: {
          ___title: 'XMLファイルをアップロード'
        },
        notification: {
          ___title: 'digitalMLPA 統合バージョン：{version}',
          ___content: '解析するサンプルについて、Coffalyserからエクスポートした.Coffa.xmlファイルをアップロードしてください。現在対応しているdigitalMLPAキットは、D001、D002、D006、D007、D008、D024、D028です。未対応のキットまたは未対応バージョンのキットで作成されたファイルは、現在解析できません。解析結果は、対応するCoffalyserの製品定義に基づき、元のパネル構成および内容を保持した状態で表示されます。'
        }
      },
      mainData: {
        status: {
          title: {
            ___analyzing: 'データ解析中…',
            ___error: '予期しない問題が発生しました。<br>現在、問題の解決を進めています。'
          }
        },
        info: {
          ___title: '基本情報・品質サマリー'
        },
        form: {
          Panel: {
            ___title: 'パネル',
            ___placeholder: 'パネルを選択してください'
          },
          Subpanel: {
            ___title: 'サブパネル',
            ___placeholder: 'サブパネルを選択してください'
          },
          Segment: {
            ___title: 'セグメント',
            data: {
              title: {
                ___Aberrant_Count: '異常数',
                ___Mean: '平均値',
                ___SD: '標準偏差',
                ___Med: '中央値',
                ___Min: '最小値',
                ___Max: '最大値',
                ___Range: '範囲'
              }
            }
          }
        }
      },
      mainDataInfo: {
        data: {
          info: {
            table: {
              Barcode_Name: {
                ___title: 'バーコード名'
              },
              Sample_Name: {
                ___title: 'サンプル名'
              },
              Sample_Type: {
                ___title: 'サンプルタイプ'
              },
              Product_Name: {
                ___title: '製品名 '
              },
              Sheet_Name: {
                ___title: 'シート名'
              },
              Analyzed_Sex: {
                ___title: '解析された性別',
                value: {
                  ___Male: '男性',
                  ___Female: '女性'
                }
              },
              Analyzed_Panels: {
                ___title: '解析済みパネル（異常：{count}）'
              }
            }
          },
          quality: {
            ___title: '品質',
            table: {
              Is_Passed: {
                ___title: '判定',
                value: {
                  ___Pass: '合格',
                  ___Failed: '不合格'
                }
              },
              Plausible_Root_Cause: {
                ___title: '推定原因',
                value: {
                  ___NotApplicable: '該当なし',
                  ___Others: 'その他'
                }
              },
              Plausible_Root_Cause_Description: {
                ___title: '推定原因の詳細',
                value: {
                  ___NA: '該当なし',
                  ___Others: 'その他'
                }
              }
            }
          }
        },
        table: {
          quality: {
            title: {
              ___Overall: '総合',
              ___Data_Analysis: 'データ解析',
              ___Dna: 'DNA',
              ___Hybridisation: 'ハイブリダイゼーション',
              ___Identity: '同一性',
              ___Ligase_Activity: 'リガーゼ活性',
              ___Ligation: 'ライゲーション',
              ___Polymerase: 'ポリメラーゼ',
              ___Program: 'プログラム',
              ___Sample_Run: 'サンプルラン'
            },
            content: {
              ___OK: '正常',
              ___Warning: '警告'
            },
            info: {
              ___OK: '{field} <b>正常</b>',
              ___Failed: '{field} <b>不合格</b>'
            }
          }
        }
      },
      mainDataChart: {
        chart: {
          axis: {
            title: {
              ___Copy_Number_Ratio: 'コピー数比(Copy Number Ratio)',
              ___Probe: 'プローブ'
            }
          }
        }
      },
      mainDataTable: {
        table: {
          topTitle: {
            ___Prob_Information: 'プローブ情報',
            ___Comparison_Reference_Samples: '比較用リファレンスサンプル',
            ___Sample_Results: 'サンプル解析結果'
          },
          title: {
            ___Probe_No: 'プローブ番号',
            ___Function: '機能',
            ___Location: '位置（kb）',
            ___Gene: '遺伝子',
            ___Exon: 'エクソン',
            ___CN_Exp: '期待コピー数',
            ___Ref_95: 'リファレンス95%',
            ___Exp_Range: '期待範囲',
            ___Result: '結果',
            ___Aberrant: '異常',
            ___Quality_issue: '品質上の問題'
          }
        }
      }
    },
    dataset: {
      base: {
        customForm: {
          tag: {
            ___dataTagPlaceholder: 'タグ名'
          }
        },
        picture: {
          ___title: 'データセット画像',
          ___customTitle: 'カスタム画像'
        },
        sample: {
          ___title: 'データセットのサンプル',
          ___info: '{count} 選択済みサンプル',
          viewTitle: {
            ___detail: '詳細表示',
            ___list: '一覧表示'
          },
          searchPlaceholder: {
            ___case: 'サンプルの症例ID',
            ___dataset: 'データセットのキーワード'
          },
          emptyText: {
            ___case: 'データセットにはサンプルが選択されていません。'
          }
        },
        sampleTable: {
          case: {
            ___case_id: '症例ID',
            ___sex: '性別',
            ___birth_year: '生年',
            ___created_at: '作成日',
            ___updated_at: '更新日'
          },
          dataset: {
            ___name: 'データセット名',
            ___sample_size: 'サンプルサイズ',
            ___user: 'ユーザー',
            ___detail: '詳細'
          }
        },
        sampleList: {
          title: {
            ___case: '選択済みサンプル',
            ___dataset: 'コミュニティー・データセット'
          }
        },
        form: {
          title: {
            ___owner: '所有者',
            ___name: 'データセット名',
            ___tag: 'タグを追加する',
            ___pipeline: 'パイプライン',
            ___description: 'データセットの説明'
          },
          placeholder: {
            ___name: 'データセット名',
            ___tag: 'タグ名',
            ___pipeline: 'パイプライン',
            ___description: 'データセットに関するあらゆる説明を注釈する。'
          },
          customValidate: {
            ___user_id: 'この名前はすでに使われています。',
            ___sample_size: 'サンプルサイズが小さすぎます。'
          }
        }
      },
      card: {
        annotation: {
          default: {
            ___info01: '全データを含むデータセットが、',
            ___info02: '注釈の為に選択されている。'
          },
          community: {
            ___info01: 'コミュニティー・データセットを含むデータセットが、',
            ___info02: '注釈の為に選択されている。'
          }
        },
        information: {
          title: {
            ___Create: '作成日',
            ___Modified: '更新日',
            ___Samplesize: 'サンプルサイズ',
            ___Pipeline: 'パイプライン',
            ___Externaldata: '外部データ',
            ___Status: 'ステータス',
            ___Permission: '権限',
            ___Description: '詳細',
            ___Owner: '所有者',
            ___Tags: 'タグ一覧'
          },
          value: {
            external_data_included: {
              ___Yes: 'はい',
              ___No: 'いいえ'
            }
          }
        }
      },
      disabledMsg: {
        ___title01: 'データセット {dataset} (時間 {time} に作成済み) から1つ以上のサンプル/データセットが削除されましたので、このデータセットはもうご利用になれません。下の表は、共有が解除されたデータセットを示しています。',
        ___title02: 'データセット {dataset} (時間 {time} に作成済み) から1つ以上のサンプル/データセットが削除されましたので、このデータセットはもうご利用になれません。',
        table: {
          title: {
            ___category: 'カテゴリー',
            ___title: 'データセット名 / 症例ID',
            ___modified: '更新日',
            ___owner: '所有者'
          }
        }
      },
      msg: {
        ___created: '解析の作成に失敗しました。',
        ___analyzing: 'データを解析中...',
        ___failed01: '予期しない問題が発生しました。',
        ___failed02: '現在、この問題を解決しています。',
        ___failed03: '予期しない問題が発生しました：'
      }
    },
    datasetDetail: {
      sample: {
        ___title: 'データセットには {count} つのサンプルがあります。',
        ___searchPlaceholder: 'サンプルの症例ID',
        viewTitle: {
          ___detail: '詳細表示',
          ___list: '一覧表示'
        },
        table: {
          title: {
            ___case_id: '症例ID',
            ___sex: '性別',
            ___birth_year: '生年',
            ___created_at: '作成日',
            ___updated_at: '更新日',
            ___dataset_name: 'データセット名',
            ___user: 'ユーザー'
          }
        }
      },
      share: {
        ___invitationIconTitle: 'コピー',
        customForm: {
          url: {
            icon: {
              ___title: 'コピー'
            }
          },
          public_permission: {
            ___title: '公開権限',
            ___alert: 'この権限によって、どんなユーザーでもあなたのデータセットの要約ページにアクセスできるようになる。あなたのデータ集合を一般に公開する場合、この権限を使用すると便利です。あなたのデータセットに機密情報が含まれている可能性がある場合は、この権限を使用しないでください。あなたが許可したユーザーに、あなたのデータセットを公開したい場合は、アクセスキーを使ってください。'
          },
          access_key: {
            ___title: 'アクセスキー'
          },
          invitation_permission: {
            ___selectPlaceholder: '権限を選択する'
          }
        },
        userList: {
          ___title: 'ユーザー一覧',
          ___info: 'このデータセットは {count} 人のユーザーと共有されています。'
        },
        table: {
          title: {
            ___user_id: 'ユーザーID（所属、メールアドレス）',
            ___permission: '権限',
            ___option: '編集'
          }
        },
        form: {
          title: {
            ___url: 'データセットのURL',
            ___community_permission: 'コミュニティー権限',
            ___invitation_url: '招待URL'
          }
        },
        modal: {
          content: {
            ___deleteShare: '<span>ユーザーを削除すると、権限も削除されます。ユーザーを削除しますか？</span>'
          }
        }
      },
      summary: {
        ___filterPlaceholder01: 'フィルター選択',
        ___filterPlaceholder02: 'オペレーター',
        ___filterSelectPlaceholder: '範囲',
        ___filterNumberPlaceholder: '範囲',
        ___conditionJoin: 'または',
        defaultOperatorOption: {
          title: {
            in: {
              ___true: '含む',
              ___false: '含まない'
            },
            like: {
              ___true: '含む',
              ___false: '含まない'
            }
          }
        },
        summaryFilter: {
          title: {
            ___VARIANT_CLASS: 'バリアント・クラス',
            ___F_MISSING: 'バリアント欠損率',
            ___AC: 'AC',
            ___AN: 'AN',
            ___AF: 'AF',
            ___NS: 'NS',
            ___DP: 'DP',
            ___AC_Het: 'AC Het',
            ___AC_Hom: 'AC Hom',
            ___AC_Hemi: 'AC Hemi',
            ___Consequence: '変異タイプ',
            ___SYMBOL: '遺伝子',
            ___Sex: '性別',
            ___HPO: 'HPO'
          },
          rangeOption: {
            title: {
              VARIANT_CLASS: {
                ___SNV: 'SNV',
                ___Ins: '挿入',
                ___Del: '欠失'
              },
              Sex: {
                ___Male: '男性',
                ___Female: '女性',
                ___Unknown: '不明'
              }
            }
          }
        },
        summaryMain: {
          title: {
            ___dataCounts: 'データ数',
            ___variantCounts: 'バリアント数',
            ___geneStatistics: '遺伝子統計',
            ___phenotypeStatistics: '表現型統計',
            ___consequenceStatistics: '変異タイプ別統計',
            ___consequencePerSample: 'サンプルごとの変異タイプ',
            ___populationDatabase: 'AF分布の比較'
          },
          option: {
            geneStatisticsType: {
              ___Caseaffected: '疾患のある症例（Case affected）',
              ___Variantcount: 'バリアント数'
            }
          },
          info: {
            geneStatistics: {
              ___info01: '罹患症例（Case affected）：遺伝子ごとの罹患症例の割合',
              ___info02: 'バリアント数：遺伝子ごとのバリアント数'
            },
            phenotypeStatistics: {
              ___info01: 'フェノグラムプロット。中央に示されている数字は、患者の表現型からHP:0000118へのパスの項の出現回数の合計を示す。'
            },
            consequenceStatistics: {
              ___info01: '変異タイプ別の割合。'
            },
            consequencePerSample: {
              ___info01: '変異タイプ別にグループ化したサンプルごとのバリアント数。'
            }
          }
        },
        chartOption: {
          geneStatisticstestChart: {
            ___yAxis01: '疾患のある症例（Case affected）の割合 %',
            ___yAxis02: 'バリアント数'
          },
          consequencePerSample: {
            ___xAxis: 'サンプルごとのバリアント数',
            ___yAxis: '件数',
            seriesName: {
              ___Missense: 'ミスセンス',
              ___Null: 'ヌル',
              ___Synonymous: 'シノニマス'
            }
          },
          populationDatabase: {
            ___xAxis: 'バリアント数 (M)',
            seriesName: {
              ___cohort: '私のコホート',
              ___TOPMED: '私のコホート + TOPMed',
              ___gnomAD: '私のコホート + gnomAD Genome',
              ___all: '私のコホート + TOPMed + gnomAD Genome'
            }
          }
        },
        dataTotal: {
          title: {
            ___Total: '合計',
            ___Male: '男性',
            ___Female: '女性'
          }
        },
        variantTotal: {
          title: {
            ___Total: '合計バリアント',
            ___SNV: 'SNVs',
            ___Ins: '挿入',
            ___Del: '欠失'
          }
        },
        consequenceMapDatas: {
          title: {
            ___transcript_ablation: 'Transcript ablation',
            ___splice_acceptor_variant: 'Splice acceptor variant',
            ___splice_donor_variant: 'Splice donor variant',
            ___stop_gained: 'Stop gained',
            ___frameshift_variant: 'Frameshift variant',
            ___stop_lost: 'Stop lost',
            ___start_lost: 'Start lost',
            ___transcript_amplification: 'Transcript amplification',
            ___inframe_insertion: 'Inframe insertion',
            ___inframe_deletion: 'Inframe deletion',
            ___missense_variant: 'Missense variant',
            ___protein_altering_variant: 'Protein altering variant',
            ___splice_region_variant: 'Splice region variant',
            ___incomplete_terminal_codon_variant: 'Incomplete terminal codon variant',
            ___start_retained_variant: 'Start retained variant',
            ___stop_retained_variant: 'Stop retained variant',
            ___synonymous_variant: 'Synonymous variant',
            ___coding_sequence_variant: 'Coding sequence variant',
            ___mature_miRNA_variant: 'Mature miRNA variant',
            ___5_prime_UTR_variant: '5 prime UTR variant',
            ___3_prime_UTR_variant: '3 prime UTR variant',
            ___non_coding_transcript_exon_variant: 'Non coding transcript exon variant',
            ___intron_variant: 'Intron variant',
            ___NMD_transcript_variant: 'NMD transcript variant',
            ___non_coding_transcript_variant: 'Non coding transcript variant',
            ___upstream_gene_variant: 'Upstream gene variant',
            ___downstream_gene_variant: 'Downstream gene variant',
            ___TFBS_ablation: 'TFBS ablation',
            ___TFBS_amplification: 'TFBS amplification',
            ___TF_binding_site_variant: 'TF binding site variant',
            ___regulatory_region_ablation: 'Regulatory region ablation',
            ___regulatory_region_amplification: 'Regulatory region amplification',
            ___feature_elongation: 'Feature elongation',
            ___regulatory_region_variant: 'Regulatory region variant',
            ___feature_truncation: 'Feature truncation',
            ___intergenic_variant: 'Intergenic variant'
          }
        }
      }
    },
    setting: {
      workgroupCase: {
        ___selectAll: 'すべて',
        ___emptyContent: '最初にワークグループをお選びください。',
        workgroupList: {
          ___roleTitle: '役割',
          ___roleSelectTitle: 'ユーザーを選択してください',
          group: {
            title: {
              ___default: '私のワークグループ (最大グループ数は{limit}組です)',
              ___shared: '共有ワークグループ'
            }
          }
        },
        workgroupResult: {
          member: {
            ___default: 'グループにメンバーがいません。 | グループに{count} 人のメンバーがいます。 | グループに{count} 人のメンバーがいます。'
          },
          case: {
            ___default: 'グループに症例がありません。 | グループに{count}件の症例があります。 | グループに{count}件の症例があります。'
          },
          stage: {
            ___default: 'グループに作業段階がありません。 | グループに{count}個の作業段階があります。 | グループに{count}個の作業段階があります。'
          }
        },
        workgroupData: {
          member: {
            ___title: 'メンバー'
          },
          case: {
            ___title: '症例'
          },
          stage: {
            ___title: '作業段階'
          }
        },
        form: {
          title: {
            ___name: 'グループ名',
            ___user: '作成者',
            ___createdAt: '作成日',
            ___updatedAt: '更新日',
            ___permissionSetting: '権限設定',
            ___userSetting: 'ユーザー設定'
          },
          placeholder: {
            ___name: 'グループ名を入力してください。'
          },
          switchData: {
            title: {
              ___memberChange: '<b>メンバー</b>にグループの症例編集を許可します。',
              ___memberEdit: '<b>メンバー</b>に症例の状態および割り当ての変更を許可します。',
              ___autoShare: 'このワークグループに症例を自動共有'
            },
            info: {
              ___memberChange: '症例の編集権限は初期設定でディレクターに付与されています。このオプションを設定することで、メンバーにも編集権限を付与するかどうかを選択できます。',
              ___autoShare: '有効にすると、今後アップロードするすべての症例が自動的にこのワークグループへ共有されます。'
            },
            disabled: {
              ___autoShare: '他のワークグループで自動共有がすでに有効になっています。'
            }
          }
        },
        modal: {
          content: {
            ___deleteWorkgroup: '<span style="color:#FF414D">グループを削除すると、共有症例およびメンバーも削除されます。 グループ：{name} を削除しますか？</span>',
            ___leaveWorkgroup: '<span style="color:#FF414D">グループを退出すると、共有症例も削除されます。グループ：{name} を退出されますか？</span>'
          }
        }
      },
      panelGene: {
        ___selectAll: 'すべて',
        ___panelSearchPlaceholder: '遺伝子パネル(例：健康関連所見の追加)',
        ___panelDefault: 'デフォルト',
        ___panelGeneCount: '{count} 遺伝子',
        ___emptyContent: 'まず遺伝子パネルを選択してください。',
        geneTag: {
          ___placeholder: '遺伝子（例：BRCA1）、表現型（例：頭痛）、疾患（例：乳がん）など。'
        },
        panelResult: {
          ___selected: '選択済み',
          gene: {
            ___type01: '自由入力',
            ___type02: 'ユーザー定義',
            ___title: '遺伝子',
            ___empty: '遺伝子なし'
          },
          panel: {
            ___title: 'パネル',
            ___empty: 'パネルなし'
          },
          phenotype: {
            ___title: '表現型',
            ___empty: '表現型なし'
          },
          condition: {
            ___title: '疾患',
            ___empty: '疾患なし'
          },
          pathway: {
            ___title: '経路',
            ___empty: '経路なし'
          }
        },
        panelData: {
          ___searchTitle: '遺伝子/疾患パネル',
          gene: {
            ___title: '遺伝子',
            freeTyping: {
              ___title: '自由入力リスト'
            },
            userDefined: {
              ___title: 'ユーザー定義',
              ___updateTitle: '新しいエクセルファイルで更新する。',
              ___updateTemplate: 'テンプレート',
              ___downloadList: 'ダウンロードリスト'
            }
          },
          panel: {
            ___title: 'パネル',
            item: {
              ___createdAt: '{time} にパネル <b>{panel}</b> へ追加',
              ___updatedAt: '最終更新時間：{time}'
            }
          },
          phenotype: {
            ___title: 'HPO表現型'
          },
          condition: {
            ___title: '疾患'
          },
          pathway: {
            ___title: '経路'
          }
        },
        form: {
          edit: {
            title: {
              ___name: '遺伝子パネル',
              ___newName: '新しい遺伝子パネル',
              ___division: 'ディビジョン',
              ___note: '注釈',
              ___updatedAt: '最終更新日',
              ___createdAt: '作成日'
            },
            placeholder: {
              ___name: '例：てんかん発作',
              ___division: 'ディビジョンを選択してください。',
              ___note: '注釈は自由に入力できます。'
            }
          },
          default: {
            title: {
              ___name: 'デフォルトの遺伝子パネル',
              ___division: 'ディビジョン'
            }
          }
        },
        modal: {
          content: {
            ___deletePanel: '<span style="color:#FF414D">このパネルを削除すると、中の設定もすべて削除されます。パネルを削除しますか？</span>',
            ___overwriteGeneList: '<span style="color:#FA3D3D">過去にアップロードした遺伝子リストを上書きしますか？</span>'
          }
        }
      },
      panelPhenotype: {
        ___emptyContent: 'まず表現型パネルを選択してください。',
        phenotypeTag: {
          ___placeholder: '表現型(例：呼吸困難)または疾患(例：乳がん)'
        },
        form: {
          title: {
            ___name: '表現型設定',
            ___newName: '新しい表現型設定'
          },
          placeholder: {
            ___name: '例：てんかん発作'
          }
        },
        table: {
          panel: {
            title: {
              ___panel: '表現型設定'
            }
          },
          phenotype: {
            title: {
              ___query: '表現型または疾患'
            }
          }
        },
        modal: {
          content: {
            ___deletePanel: '<span style="color:#FF414D">このパネルを削除すると、中の表現型も削除されます。パネルを削除しますか？</span>',
            ___deleteFromPanel: '<span style="color:#FF414D">パネル {panel} の表現型を削除しますか？</span>'
          }
        }
      },
      configFilter: {
        ___emptyContent: 'まず構成を選択してください。',
        form: {
          title: {
            ___name: '構成名',
            ___updatedAt: '最終更新日',
            ___createdAt: '作成日'
          },
          placeholder: {
            ___name: '構成名'
          }
        },
        table: {
          config: {
            title: {
              ___name: '構成名'
            }
          }
        },
        modal: {
          content: {
            ___deleteConfig: '<span style="color:#FF414D">フィルター構成 <br>{config} を削除しますか？</span>'
          }
        }
      }
    },
    workgroupCase: {
      memberTable: {
        title: {
          ___Name: 'ユーザー名',
          ___Organization: '所属機関・部署',
          ___Email: 'メールアドレス',
          ___Role: '役割',
          ___Edit: '編集'
        },
        modal: {
          content: {
            ___deleteAlert: '<span style="color:#FA3D3D">メンバーを削除すると、一部の共有症例も削除されます。メンバー：{member} を削除しますか？</span>'
          }
        }
      },
      caseTable: {
        title: {
          ___Case_ID: '症例ID',
          ___Owner: '所有者',
          ___Workgroup_Stage: '作業段階',
          ___Due_date: '締切日',
          ___Assignee: '担当者',
          ___Edit: '編集'
        },
        placeholder: {
          ___Workgroup_Stage: '作業段階を選択してください。'
        },
        modal: {
          content: {
            ___deleteAlert: '<span style="color:#FA3D3D">症例を削除すると、共有権限も削除されます。症例：{case} を削除しますか？</span>'
          }
        }
      },
      stageTable: {
        title: {
          ___Workgroup_Stage: '作業段階',
          ___Assignee: '担当者',
          ___Edit: '編集'
        },
        modal: {
          content: {
            ___deleteAlert: '<span style="color:#FA3D3D">作業段階を削除すると、自動割り当て機能も解除されます。作業段階：{stage} を削除しますか？</span>'
          }
        }
      }
    },
    config: {
      filter: {
        customConfig: {
          databaseSet: {
            ___valuePlaceholder: 'ex：0.001'
          },
          genePanel: {
            geneTag: {
              ___placeholder: '遺伝子、パネル、表現型、疾患。'
            }
          },
          rsID: {
            ___valuePlaceholder: 'rs123456'
          }
        },
        defaultPlaceholder: {
          ___compare: '>, …',
          ___select: 'タイプ',
          ___value: 'ナンバー'
        },
        selectOption: {
          criteria: {
            title: {
              ___union: '和集合',
              ___intersection: '積集合'
            },
            resultTitle: {
              ___union: '判定基準の和集合',
              ___intersection: '判定基準の積集合'
            }
          },
          annotation: {
            title: {
              ___withAnnotation: '注釈付き',
              ___withoutAnnotation: '注釈なし'
            },
            resultTitle: {
              ___withAnnotation: '注釈付き',
              ___withoutAnnotation: '注釈なし'
            }
          }
        },
        configOption: {
          qualityFilter: {
            ___title: '品質フィルター',
            configGroup: {
              default01: {
                config: {
                  filter_pass: {
                    ___valueTitle: 'フィルター・パス',
                    ___resultTitle: 'パス'
                  },
                  dp: {
                    ___switchTitle: 'DP'
                  },
                  ad: {
                    ___switchTitle: 'AD'
                  },
                  ad_dp: {
                    ___switchTitle: 'AD/DP'
                  },
                  genotype: {
                    ___switchTitle: '遺伝子型フィルター'
                  }
                }
              }
            }
          },
          populationDatabase: {
            ___title: '集団データベース',
            configGroup: {
              default01: {
                ___title: 'すべてのデータベース・セット',
                config: {
                  database_include_empty_values: {
                    ___valueTitle: '空の値を含む'
                  }
                }
              },
              populationDatabase_1000Genomes: {
                ___title: '1000 Genomes',
                config: {
                  KG_AF: {
                    ___checkTitle: 'AF'
                  },
                  KG_AFR_AF: {
                    ___checkTitle: 'AFR AF'
                  },
                  KG_AMR_AF: {
                    ___checkTitle: 'AMR AF'
                  },
                  KG_EAS_AF: {
                    ___checkTitle: 'EAS AF'
                  },
                  KG_EUR_AF: {
                    ___checkTitle: 'EUR AF'
                  },
                  KG_SAS_AF: {
                    ___checkTitle: 'SAS AF'
                  }
                }
              },
              populationDatabase_gnomAD: {
                ___title: 'gnomAD Exomes',
                config: {
                  gnomAD_AF: {
                    ___checkTitle: 'AF'
                  },
                  gnomAD_AFR_AF: {
                    ___checkTitle: 'AFR AF'
                  },
                  gnomAD_AMR_AF: {
                    ___checkTitle: 'AMR AF'
                  },
                  gnomAD_ASJ_AF: {
                    ___checkTitle: 'ASJ AF'
                  },
                  gnomAD_EAS_AF: {
                    ___checkTitle: 'EAS AF'
                  },
                  gnomAD_FIN_AF: {
                    ___checkTitle: 'FIN AF'
                  },
                  gnomAD_NFE_AF: {
                    ___checkTitle: 'NFE AF'
                  },
                  gnomAD_OTH_AF: {
                    ___checkTitle: 'OTH AF'
                  },
                  gnomAD_SAS_AF: {
                    ___checkTitle: 'SAS AF'
                  },
                  gnomAD_MID_AF: {
                    ___checkTitle: 'MID AF'
                  }
                }
              },
              populationDatabase_gnomAD_g: {
                ___title: 'gnomAD Genomes',
                config: {
                  gnomAD_g_AF: {
                    ___checkTitle: 'AF'
                  },
                  gnomAD_g_AF_afr: {
                    ___checkTitle: 'AFR AF'
                  },
                  gnomAD_g_AF_ami: {
                    ___checkTitle: 'AMI AF'
                  },
                  gnomAD_g_AF_amr: {
                    ___checkTitle: 'AMR AF'
                  },
                  gnomAD_g_AF_asj: {
                    ___checkTitle: 'ASJ AF'
                  },
                  gnomAD_g_AF_eas: {
                    ___checkTitle: 'EAS AF'
                  },
                  gnomAD_g_AF_fin: {
                    ___checkTitle: 'FIN AF'
                  },
                  gnomAD_g_AF_mid: {
                    ___checkTitle: 'MID AF'
                  },
                  gnomAD_g_AF_nfe: {
                    ___checkTitle: 'NFE AF'
                  },
                  gnomAD_g_AF_oth: {
                    ___checkTitle: 'OTH AF'
                  },
                  gnomAD_g_AF_sas: {
                    ___checkTitle: 'SAS AF'
                  },
                  gnomAD_g_mt_AF_het: {
                    ___checkTitle: 'ヘテロプラスミー AF'
                  },
                  gnomAD_g_mt_pop_AF_het_afr: {
                    ___checkTitle: 'ヘテロプラスミー AFR AF'
                  },
                  gnomAD_g_mt_pop_AF_het_ami: {
                    ___checkTitle: 'ヘテロプラスミー AMI AF'
                  },
                  gnomAD_g_mt_pop_AF_het_amr: {
                    ___checkTitle: 'ヘテロプラスミー AMR AF'
                  },
                  gnomAD_g_mt_pop_AF_het_asj: {
                    ___checkTitle: 'ヘテロプラスミー ASJ AF'
                  },
                  gnomAD_g_mt_pop_AF_het_eas: {
                    ___checkTitle: 'ヘテロプラスミー EAS AF'
                  },
                  gnomAD_g_mt_pop_AF_het_fin: {
                    ___checkTitle: 'ヘテロプラスミー FIN AF'
                  },
                  gnomAD_g_mt_pop_AF_het_mid: {
                    ___checkTitle: 'ヘテロプラスミー MID AF'
                  },
                  gnomAD_g_mt_pop_AF_het_nfe: {
                    ___checkTitle: 'ヘテロプラスミー NFE AF'
                  },
                  gnomAD_g_mt_pop_AF_het_oth: {
                    ___checkTitle: 'ヘテロプラスミー OTH AF'
                  },
                  gnomAD_g_mt_pop_AF_het_sas: {
                    ___checkTitle: 'ヘテロプラスミー SAS AF'
                  },
                  gnomAD_g_mt_AF_hom: {
                    ___checkTitle: 'ホモプラスミー AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_afr: {
                    ___checkTitle: 'ホモプラスミー AFR AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_ami: {
                    ___checkTitle: 'ホモプラスミー AMI AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_amr: {
                    ___checkTitle: 'ホモプラスミー AMR AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_asj: {
                    ___checkTitle: 'ホモプラスミー ASJ AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_eas: {
                    ___checkTitle: 'ホモプラスミー EAS AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_fin: {
                    ___checkTitle: 'ホモプラスミー FIN AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_mid: {
                    ___checkTitle: 'ホモプラスミー MID AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_nfe: {
                    ___checkTitle: 'ホモプラスミー NFE AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_oth: {
                    ___checkTitle: 'ホモプラスミー OTH AF'
                  },
                  gnomAD_g_mt_pop_AF_hom_sas: {
                    ___checkTitle: 'ホモプラスミー SAS AF'
                  }
                }
              },
              populationDatabase_others: {
                ___title: 'その他',
                config: {
                  ExAC_AF: {
                    ___checkTitle: 'ExAC AF'
                  },
                  ESP6500_AA_AF: {
                    ___checkTitle: 'ESP6500 AA'
                  },
                  ESP6500_EA_AF: {
                    ___checkTitle: 'ESP6500 EA AF'
                  },
                  TW_AF: {
                    ___checkTitle: 'TW AF'
                  },
                  TOPMED_AF: {
                    ___checkTitle: 'TOPMed AF'
                  },
                  ChinaMAP_AF: {
                    ___checkTitle: 'ChinaMAP AF'
                  }
                }
              },
              default02: {
                ___title: '判定基準の設定'
              }
            }
          },
          computationalPredictiveData: {
            ___title: '計算・予測データ',
            configGroup: {
              default01: {
                config: {
                  predictive_include_empty_values: {
                    ___valueTitle: '空の値を含む'
                  }
                }
              },
              computationalPredictiveData_splicingImpact: {
                ___title: 'スプライシングの影響',
                config: {
                  ada_score: {
                    ___checkTitle: 'adaスコア'
                  },
                  rf_score: {
                    ___checkTitle: 'rfスコア'
                  },
                  CI_SpliceAI: {
                    ___checkTitle: 'CI SpliceAI'
                  },
                  SpliceAI_DS_AG: {
                    ___checkTitle: 'SpliceAI DS AG'
                  },
                  SpliceAI_DS_AL: {
                    ___checkTitle: 'SpliceAI DS AL'
                  },
                  SpliceAI_DS_DG: {
                    ___checkTitle: 'SpliceAI DS DG'
                  },
                  SpliceAI_DS_DL: {
                    ___checkTitle: 'SpliceAI DS DL'
                  }
                }
              },
              computationalPredictiveData_proteinFunction: {
                ___title: 'タンパク質機能',
                config: {
                  ESM1b: {
                    ___checkTitle: 'ESM1b'
                  },
                  ESM1b_pred: {
                    ___checkTitle: 'ESM1b予測'
                  },
                  VARITY_ER_LOO: {
                    ___checkTitle: 'VARITY ER LOO'
                  },
                  VARITY_ER_LOO_pred: {
                    ___checkTitle: 'VARITY ER LOO予測'
                  },
                  VARITY_R_LOO: {
                    ___checkTitle: 'VARITY R LOO'
                  },
                  VARITY_R_LOO_pred: {
                    ___checkTitle: 'VARITY R LOO予測'
                  },
                  VARITY_ER: {
                    ___checkTitle: 'VARITY ER'
                  },
                  VARITY_ER_pred: {
                    ___checkTitle: 'VARITY ER予測'
                  },
                  VARITY_R: {
                    ___checkTitle: 'VARITY R'
                  },
                  VARITY_R_pred: {
                    ___checkTitle: 'VARITY R予測'
                  },
                  Alphamissense_score: {
                    ___checkTitle: 'Alphamissenseスコア'
                  },
                  Alphamissense_class: {
                    ___checkTitle: 'Alphamissense class'
                  },
                  SIFT4G_score: {
                    ___checkTitle: 'SIFT4Gスコア'
                  },
                  SIFT4G_pred: {
                    ___checkTitle: 'SIFT4G予測'
                  },
                  Polyphen_score: {
                    ___checkTitle: 'Polyphen-2 HDIV'
                  },
                  Polyphen_pred: {
                    ___checkTitle: 'Polyphen-2 HDIV予測'
                  },
                  FATHMM_score: {
                    ___checkTitle: 'FATHMMスコア'
                  },
                  FATHMM_pred: {
                    ___checkTitle: 'FATHMM予測'
                  },
                  PROVEAN_score: {
                    ___checkTitle: 'PROVEANスコア'
                  },
                  PROVEAN_pred: {
                    ___checkTitle: 'PROVEAN予測'
                  }
                }
              },
              computationalPredictiveData_ensemble: {
                ___title: 'Ensemble',
                config: {
                  CADD_phred: {
                    ___checkTitle: 'CADD予測'
                  },
                  CADD_raw: {
                    ___checkTitle: 'CADD raw'
                  },
                  MetaLR_score: {
                    ___checkTitle: 'MetaLRスコア'
                  },
                  MetaLR_pred: {
                    ___checkTitle: 'MetaLR予測'
                  },
                  MetaSVM_score: {
                    ___checkTitle: 'MetaSVMスコア'
                  },
                  MetaSVM_pred: {
                    ___checkTitle: 'MetaSVM予測'
                  },
                  REVEL_score: {
                    ___checkTitle: 'REVELスコア'
                  },
                  REVEL_pred: {
                    ___checkTitle: 'REVEL予測'
                  },
                  BayesDel_noAF_score: {
                    ___checkTitle: 'BayesDel noAFスコア'
                  },
                  BayesDel_noAF_pred: {
                    ___checkTitle: 'BayesDel noAF予測'
                  }
                }
              },
              computationalPredictiveData_conservation: {
                ___title: 'コンサベーション',
                config: {
                  GERPpp_NR: {
                    ___checkTitle: 'GERP++ NR'
                  },
                  GERPpp_RS: {
                    ___checkTitle: 'GERP++ RS'
                  }
                }
              },
              computationalPredictiveData_gnomADConstraint: {
                ___title: 'gnomAD制約',
                config: {
                  oe_syn: {
                    ___checkTitle: 'シノニマス o/e'
                  },
                  oe_mis: {
                    ___checkTitle: 'ミスセンス o/e'
                  },
                  oe_lof: {
                    ___checkTitle: 'pLoF o/e'
                  },
                  syn_z: {
                    ___checkTitle: 'シノニマス z-スコア'
                  },
                  mis_z: {
                    ___checkTitle: 'ミスセンス z-スコア'
                  },
                  pLI: {
                    ___checkTitle: 'pLI'
                  }
                }
              },
              default02: {
                ___title: '判定基準の設定'
              }
            }
          },
          consequences: {
            ___title: '変異タイプ',
            configGroup: {
              consequences_high: {
                ___title: '高い',
                config: {
                  frameshift_elongation: {
                    ___valueTitle: 'Frameshift elongation'
                  },
                  frameshift_truncation: {
                    ___valueTitle: 'Frameshift truncation'
                  },
                  frameshift_variant: {
                    ___valueTitle: 'Frameshift variant'
                  },
                  splice_acceptor_variant: {
                    ___valueTitle: 'Splice acceptor variant'
                  },
                  splice_donor_variant: {
                    ___valueTitle: 'Splice donor variant'
                  },
                  start_lost: {
                    ___valueTitle: 'Start lost'
                  },
                  stop_gained: {
                    ___valueTitle: 'Stop gained'
                  },
                  stop_lost: {
                    ___valueTitle: 'Stop lost'
                  },
                  transcript_ablation: {
                    ___valueTitle: 'Transcript ablation'
                  },
                  transcript_amplification: {
                    ___valueTitle: 'Transcript amplification'
                  }
                }
              },
              consequences_low: {
                ___title: '低い',
                config: {
                  incomplete_terminal_codon_variant: {
                    ___valueTitle: 'Incomplete terminal codon variant'
                  },
                  splice_region_variant: {
                    ___valueTitle: 'Splice region variant'
                  },
                  start_retained_variant: {
                    ___valueTitle: 'Start retained variant'
                  },
                  stop_retained_variant: {
                    ___valueTitle: 'Stop retained variant'
                  },
                  synonymous_variant: {
                    ___valueTitle: 'Synonymous variant'
                  }
                }
              },
              consequences_moderate: {
                ___title: '中程度',
                config: {
                  direct_tandem_duplication: {
                    ___valueTitle: 'Direct tandem duplication'
                  },
                  disruptive_inframe_deletion: {
                    ___valueTitle: 'Disruptive inframe deletion'
                  },
                  disruptive_inframe_insertion: {
                    ___valueTitle: 'Disruptive inframe insertion'
                  },
                  inframe_deletion: {
                    ___valueTitle: 'Inframe deletion'
                  },
                  inframe_insertion: {
                    ___valueTitle: 'Inframe insertion'
                  },
                  missense_variant: {
                    ___valueTitle: 'Missense variant'
                  },
                  protein_altering_variant: {
                    ___valueTitle: 'Protein altering variant'
                  },
                  regulatory_region_ablation: {
                    ___valueTitle: 'Regulatory region ablation'
                  }
                }
              },
              consequences_modifier: {
                ___title: 'Modifier',
                config: {
                  __3_prime_UTR_exon_variant: {
                    ___valueTitle: '3 prime UTR exon variant'
                  },
                  __3_prime_UTR_intron_variant: {
                    ___valueTitle: '3 prime UTR intron variant'
                  },
                  __3_prime_UTR_variant: {
                    ___valueTitle: '3 prime UTR variant'
                  },
                  __5_prime_UTR_exon_variant: {
                    ___valueTitle: '5 prime UTR exon variant'
                  },
                  __5_prime_UTR_intron_variant: {
                    ___valueTitle: '5 prime UTR intron variant'
                  },
                  __5_prime_UTR_variant: {
                    ___valueTitle: '5 prime UTR variant'
                  },
                  coding_sequence_variant: {
                    ___valueTitle: 'Coding sequence variant'
                  },
                  coding_transcript_intron_variant: {
                    ___valueTitle: 'Coding transcript intron variant'
                  },
                  feature_elongation: {
                    ___valueTitle: 'Feature elongation'
                  },
                  feature_truncation: {
                    ___valueTitle: 'Feature truncation'
                  },
                  intergenic_variant: {
                    ___valueTitle: 'Intergenic variant'
                  },
                  intron_variant: {
                    ___valueTitle: 'Intron variant'
                  },
                  mature_miRNA_variant: {
                    ___valueTitle: 'Mature miRNA variant'
                  },
                  NMD_transcript_variant: {
                    ___valueTitle: 'NMD transcript variant'
                  },
                  non_coding_transcript_exon_variant: {
                    ___valueTitle: 'Non coding transcript exon variant'
                  },
                  non_coding_transcript_intron_variant: {
                    ___valueTitle: 'Non coding transcript intron variant'
                  },
                  non_coding_transcript_variant: {
                    ___valueTitle: 'Non coding transcript variant'
                  },
                  regulatory_region_amplification: {
                    ___valueTitle: 'Regulatory region amplification'
                  },
                  regulatory_region_variant: {
                    ___valueTitle: 'Regulatory region variant'
                  },
                  TF_binding_site_variant: {
                    ___valueTitle: 'TF binding site variant'
                  },
                  TFBS_ablation: {
                    ___valueTitle: 'TFBS ablation'
                  },
                  TFBS_amplification: {
                    ___valueTitle: 'TFBS amplification'
                  }
                }
              },
              default01: {
                config: {
                  consequences_exact_match: {
                    ___valueTitle: '完全一致'
                  }
                }
              }
            }
          },
          miscellaneous: {
            ___title: '種々雑多な',
            configGroup: {
              default01: {
                ___resultTitle: '遺伝子フィルター'
              },
              miscellaneous_genome_coordinate: {
                ___title: '遺伝子配列フィルター',
                ___resultTitle: '遺伝子フィルター',
                config: {
                  genome_coordinate_filter: {
                    ___valuePlaceholder: 'X or 1:12345-12345 or 1:13456-150213…'
                  }
                }
              },
              miscellaneous_rs_id: {
                ___title: 'rs ID フィルター',
                ___resultTitle: 'rs ID フィルター'
              },
              miscellaneous_clinVar: {
                ___title: 'ClinVar',
                config: {
                  clinvar_Pathogenic: {
                    ___valueTitle: 'Pathogenic'
                  },
                  clinvar_Likely_pathogenic: {
                    ___valueTitle: 'Likely pathogenic'
                  },
                  clinvar_Uncertain_significance: {
                    ___valueTitle: 'Uncertain significance'
                  },
                  clinvar_Conflicting_interpretations_of_pathogenicity: {
                    ___valueTitle: 'Conflicting interpretations of pathogenicity'
                  },
                  clinvar_Benign: {
                    ___valueTitle: 'Benign'
                  },
                  clinvar_Likely_benign: {
                    ___valueTitle: 'Likely benign'
                  },
                  clinvar_risk_factor: {
                    ___valueTitle: 'Risk factor'
                  },
                  clinvar_other: {
                    ___valueTitle: 'Other'
                  },
                  clinvar_drug_response: {
                    ___valueTitle: 'Drug response'
                  },
                  clinvar_exclude_selections: {
                    ___valueTitle: 'Exclude selections'
                  }
                }
              },
              miscellaneous_mastermind: {
                ___title: 'Mastermind',
                config: {
                  mastermind_Pathogenic: {
                    ___valueTitle: 'Pathogenic'
                  },
                  mastermind_Likely_pathogenic: {
                    ___valueTitle: 'Likely pathogenic'
                  },
                  mastermind_Conflict: {
                    ___valueTitle: 'Conflict'
                  },
                  mastermind_VUS: {
                    ___valueTitle: 'VUS'
                  },
                  mastermind_Likely_benign: {
                    ___valueTitle: 'Likely benign'
                  },
                  mastermind_Benign: {
                    ___valueTitle: 'Benign'
                  },
                  mastermind_exclude_selections: {
                    ___valueTitle: 'Exclude selections'
                  }
                }
              },
              miscellaneous_acmg: {
                ___title: 'ACMG分類',
                config: {
                  acmg_Pathogenic: {
                    ___valueTitle: 'Pathogenic'
                  },
                  acmg_Likely_pathogenic: {
                    ___valueTitle: 'Likely pathogenic'
                  },
                  acmg_Uncertain_significance: {
                    ___valueTitle: 'Uncertain significance'
                  },
                  acmg_Benign: {
                    ___valueTitle: 'Benign'
                  },
                  acmg_Likely_benign: {
                    ___valueTitle: 'Likely benign'
                  },
                  acmg_exclude_selections: {
                    ___valueTitle: 'Exclude selections'
                  }
                }
              },
              default02: {
                config: {
                  clinvar_exclude_selections: {
                    ___valueTitle: '選択項目を除く'
                  }
                }
              },
              miscellaneous_omim: {
                ___title: 'OMIM',
                config: {
                  omim_annotation_filter: {
                    ___switchTitle: 'OMIM注釈フィルター'
                  }
                }
              },
              miscellaneous_inheritance: {
                ___title: '継承',
                config: {
                  inheritance_AR: {
                    ___valueTitle: 'AR'
                  },
                  inheritance_AD: {
                    ___valueTitle: 'AD'
                  },
                  inheritance_XL: {
                    ___valueTitle: 'XL'
                  },
                  inheritance_XLD: {
                    ___valueTitle: 'XLD'
                  },
                  inheritance_XLR: {
                    ___valueTitle: 'XLR'
                  },
                  inheritance_YL: {
                    ___valueTitle: 'YL'
                  },
                  inheritance_DD: {
                    ___valueTitle: 'DD'
                  },
                  inheritance_DR: {
                    ___valueTitle: 'DR'
                  },
                  inheritance_IC: {
                    ___valueTitle: 'IC'
                  },
                  inheritance_Mi: {
                    ___valueTitle: 'Mi'
                  },
                  inheritance_Mu: {
                    ___valueTitle: 'Mu'
                  },
                  inheritance_PD: {
                    ___valueTitle: 'PD'
                  },
                  inheritance_PR: {
                    ___valueTitle: 'PR'
                  },
                  inheritance_SMo: {
                    ___valueTitle: 'SMo'
                  },
                  inheritance_SMu: {
                    ___valueTitle: 'SMu'
                  }
                }
              },
              miscellaneous_family_analysis: {
                ___title: 'Family analysis',
                config: {
                  family_analysis_AD_De_Novo: {
                    ___valueTitle: 'AD De Novo'
                  },
                  family_analysis_AD: {
                    ___valueTitle: 'AD'
                  },
                  family_analysis_AR_De_Novo: {
                    ___valueTitle: 'AR De Novo'
                  },
                  family_analysis_AR: {
                    ___valueTitle: 'AR'
                  },
                  family_analysis_AR_Compound_Heterozygosity: {
                    ___valueTitle: 'AR Compound Heterozygosity'
                  },
                  family_analysis_XL_De_Novo: {
                    ___valueTitle: 'XL De Novo'
                  },
                  family_analysis_XL: {
                    ___valueTitle: 'XL'
                  },
                  family_analysis_YL_De_Novo: {
                    ___valueTitle: 'YL De Novo'
                  },
                  family_analysis_YL: {
                    ___valueTitle: 'YL'
                  }
                }
              }
            }
          }
        }
      }
    },
    filter: {
      config: {
        ___title: 'フィルターツールボックス',
        ___selectPlaceholder: 'フィルター構成を選択してください。'
      },
      data: {
        tab: {
          title: {
            ___transcript: 'トランスクリプト',
            ___variantDatabase: 'バリアントデータベース',
            ___populationDatabase: '集団データベース',
            ___predictionScore: '予測スコア',
            ___samples: 'サンプル',
            ___acmg: 'ACMG',
            ___conditions: '疾患'
          }
        },
        table: {
          transcript: {
            title: {
              ___symbol: '遺伝子名',
              ___gene: '遺伝子',
              ___feature: 'トランスクリプト',
              ___biotype: 'バイオタイプ',
              ___rank: 'エクソン/<br>イントロン番号',
              ___HGVSc: 'HGVSc',
              ___HGVSp: 'HGVSp',
              ___cDNAPosition: 'cDNA位置',
              ___CDSPosition: 'CDS位置',
              ___proteinPosition: 'タンパク質位置'
            }
          },
          variantDB: {
            clinVar: {
              ___title: 'ClinVar',
              title: {
                ___clinVarAccession: 'ClinVarアクセッション',
                ___clinVarDisease_Name: 'ClinVar疾患名',
                ___clinVarCLNREVSTAT: 'ClinVarレビュー状況',
                ___cLINSIG: 'ClinVar解釈',
                ___cLINCONF: 'ClinVar競合'
              }
            },
            clinVarGeneStatistic: {
              ___title: 'ClinVar遺伝子統計'
            },
            mastermind: {
              ___title: 'Mastermind'
            },
            mitomap: {
              ___title: 'MITOMAP',
              title: {
                ___mitomapAF: 'AF',
                ___mitomapAachange: 'アミノ酸の変化',
                ___mitomapHomoplasmy: 'ホモプラスミー',
                ___mitomapHeteroplasmy: 'ヘテロプラスミー',
                ___mitomapPubmedIDs: 'PubMed ID',
                ___mitomapDisease: '疾患',
                ___mitomapDiseaseStatus: '病状',
                ___mitomapHGFL: 'HGFL'
              }
            }
          },
          populationDB: {},
          prediction: {},
          samples: {
            title: {
              ___case_id: '症例ID',
              ___genotype: '遺伝子型',
              ___DP: 'DP',
              ___RD: 'RD',
              ___AD: 'AD',
              ___GT_AF: 'アレル頻度',
              ___QUAL: 'QUAL',
              ___GQ: '遺伝子型品質',
              ___FILTER: 'フィルター',
              ___x10_cov: '遺伝子カバレッジ率(10X)',
              ___x20_cov: '遺伝子カバレッジ率(20X)',
              ___x2000_cov: '遺伝子カバレッジ率(2000X)',
              ___x3000_cov: '遺伝子カバレッジ率(3000X)'
            }
          },
          condition: {
            orphanet: {
              ___title: 'Orphanet',
              linkTitle: {
                ___orphanet: 'Orphanet'
              }
            },
            omim: {
              ___title: 'OMIM',
              linkTitle: {
                ___omim: 'OMIM'
              }
            }
          }
        }
      }
    },
    report: {
      config: {
        group: {
          chapter: {
            ___title: 'チャプターを編集する。',
            display: {
              ___variantEmpty: 'バリアントがまだ追加されていません。'
            }
          },
          variant: {
            ___title: 'モニターにあるバリアント',
            type: {
              ___snv: 'SNV',
              ___sv: 'SV'
            },
            configResult: {
              ___result: 'タグの付いたバリアントが {count} 個あります。'
            },
            result: {
              ___result: 'モニターで {count} 個のバリアントが選択されました。'
            }
          },
          cnv: {
            ___title: 'SVマネジメント',
            result: {
              ___result: 'セクションにSVが {count} 個あります。'
            }
          }
        },
        subChpater: {
          default: {
            title: {
              ___displaySummary: '結果の要約',
              ___displayDetails: '詳しい情報'
            }
          },
          portrait: {
            title: {
              ___displayDetails: '結果テーブル',
              ___displaySummary: 'テキスト説明'
            }
          }
        },
        modal: {
          content: {
            ___removeChapter: '<span style="color:#FA3D3D">チャプターを削除すると、中のコンテンツもすべて削除されます。このチャプターを削除しますか？</span>',
            ___removeFromChapter: '<span style="color:#FA3D3D">バリアントを削除すると、中のすべてのコンテンツも削除されます。このバリアントを削除しますか？</span>',
            ___removeCNVFromChapter: '<span style="color:#FA3D3D">バリアントを削除すると、中のすべてのコンテンツも削除されます。このバリアントを削除しますか？</span>'
          }
        }
      }
    },
    chat: {
      display: {
        ___stopMsg: '生成を停止しました。'
      },
      summary: {
        ___source: 'ソース：'
      }
    },
    user: {
      licenseManager: {
        ___empty: 'アクセスを有効化するには、営業担当者までお問い合わせください。',
        title: {
          ___License_ID: 'ライセンスID',
          ___Request_Code: 'ステップ1：アクティベーションリクエストコードを生成',
          ___Activation_Code: 'ステップ2：アクティベーションコードをアップロード',
          ___Licensed_Information: 'ライセンス情報'
        },
        file: {
          title: {
            ___Request_Code: 'request_code.txt',
            ___Activation_Code: 'activation_request_code.txt'
          }
        },
        table: {
          title: {
            ___Modules: 'モジュール',
            ___Status: 'ステータス',
            ___Started_at: '開始日',
            ___Expired_at: '有効期限',
            ___Licensed_Usage: 'ライセンス使用量 <h5>(残り/合計)</h5>'
          }
        },
        modal: {
          content: {
            ___removeCreateLicenseID: '<span style="color:#FA3D3D">ライセンスを削除すると、このライセンスを共有しているあなたおよび他のユーザーは、このライセンス機能にアクセスできなくなります。ライセンスを削除しますか？</span>',
            ___removeImportLicenseID: '<span style="color:#FA3D3D">ライセンスを削除すると、このライセンス機能にアクセスできなくなります。ライセンスを削除しますか？</span>'
          },
          confirm: {
            ___placeholder: '確認するには「{confirm}」と入力してください。'
          }
        }
      }
    },
    tool: {
      gcsResumable: {
        gcsTable: {
          title: {
            ___caseID: '症例ID',
            ___status: 'ステータス'
          }
        },
        groupState: {
          ___pending: 'ペンディング',
          ___failed: '失敗'
        }
      },
      geneTag: {
        ___empty: '該当する結果は見つかりませんでした。',
        ___filterTitle: '検索フィルター',
        info: {
          ___gene: '遺伝子',
          ___panel: '遺伝子パネル',
          ___hpo: '表現型',
          ___condition: '疾患',
          ___pathway: '経路',
          ___and: ''
        },
        title: {
          ___all: '全カテゴリ',
          ___gene: '遺伝子',
          ___panel: 'パネル',
          ___hpo: '表現型',
          ___condition: '疾患',
          ___pathway: '経路'
        }
      },
      phenotypeTag: {
        info: {
          ___hpo: '表現型',
          ___disease_term: '疾患',
          ___show: '表示',
          ___and: '追加'
        },
        title: {
          ___hpo: '表現型',
          ___disease_term: '疾患'
        },
        ___empty: '該当する結果は見つかりませんでした。'
      },
      igv: {
        ___loading: '読み込み中...'
      },
      toast: {
        title: {
          ___error: 'エラー！',
          ___warning: '警告！',
          ___notice: 'ご注意！',
          ___success: '成功！'
        }
      }
    }
  },
  // dialog
  DIALOG: {
    addLicenseID: {
      ___title: 'ライセンスIDのインポート',
      ___or: 'または',
      form: {
        title: {
          ___create: 'IDを新規作成',
          ___import: '既存のライセンスIDをインポート'
        },
        placeholder: {
          ___import: 'ライセンスIDを入力してください'
        }
      }
    },
    addToPanel: {
      ___or: 'または',
      form: {
        title: {
          ___phenotype: '表現型',
          ___panel: 'パネルを選択してください。',
          ___newPanel: '新しいパネルに追加する。'
        },
        placeholder: {
          ___panel: 'ご希望のパネルを選択してください。',
          ___newPanel: 'パネル名を新規作成してください。'
        },
        alert: {
          newPanel: {
            ___required: '新しいパネル名は必須です。'
          }
        }
      }
    },
    addVariantToChapter: {
      variant: {
        ___title: 'チャプターにバリアントを追加してください。'
      },
      chapter: {
        ___title: '最低1チャプターを選択してください。'
      }
    },
    caseConfirm: {
      ___datasetTitle: '{type} データセット',
      ___pipelineTitle: 'パイプライン',
      ___snvVcfTitle: 'SNV/INDEL VCFファイル',
      ___svVcfTitle: 'SV VCFファイル',
      ___strVcfTitle: 'STR VCFファイル (ExpansionHunter/TRGT/Straglr)',
      ___fastqTitle: 'Set{set}-Fastq-{read}',
      ___ubamTitle: 'Set{set}-uBAM',
      form: {
        case: {
          title: {
            ___caseID: '症例ID',
            ___affected: 'サンプルの種類',
            ___subjectName: '被検者名',
            ___sex: '性別',
            ___birthYear: '生年',
            ___population: '集団',
            ___note: '注釈'
          },
          format: {
            affected: {
              ___true: '疾患あり（Affected）',
              ___false: '疾患なし（Unaffected）'
            },
            sex: {
              ___male: '男性',
              ___female: '女性',
              ___unknown: '不明'
            },
            birthYear: {
              ___empty: '不明'
            }
          }
        },
        analysis: {
          title: {
            ___name: '解析名',
            ___note: '解析注釈',
            ___reportPhenovardb: 'PhenoVarDBに報告する',
            ___intractableDisease: 'D006-4 遺伝学的検査',
            ___intractableDiseaseTag: '指定難病分析',
            ___phenotype: '表現型',
            ___genePanel: '遺伝子パネル',
            ___aft: '遺伝モードのアレル頻度閾値',
            ___st: '表現型・遺伝子パネル選択のスコア閾値'
          },
          aft: {
            title: {
              ___ad_cutoff: 'AD',
              ___ar_cutoff: 'AR',
              ___exclude_low_quality_variants: 'LQバリアントを除く',
              ___comp_het_cutoff: '複合ヘテロ接合性',
              ___enable_clinvar_benign_filter: '既知の良性バリアントの優先度は低い。'
            },
            display: {
              exclude_low_quality_variants: {
                ___true: 'オン',
                ___false: 'オフ'
              },
              enable_clinvar_benign_filter: {
                ___true: 'オン',
                ___false: 'オフ'
              }
            }
          },
          st: {
            title: {
              phenotype_score_cutoff: '表現型スコア',
              variant_score_cutoff: 'バリアントスコア'
            }
          },
          format: {
            reportPhenovardb: {
              ___true: 'オン',
              ___false: 'オフ'
            },
            intractableDiseaseTag: {
              ___true: 'オフ',
              ___false: 'オン'
            }
          }
        }
      },
      modal: {
        content: {
          ___unknownSexAlert: '<span style="color:#FA3D3D">性別が不明な場合、後の解析結果に影響を与える可能性があります。それでも続けますか？</span>'
        }
      }
    },
    caseDetailGenePedigree: {
      ___title: '家系図'
    },
    caseDetailGeneACMG: {
      ___title: 'ACMG',
      ___tabTitle: '判定基準',
      table: {
        title: {
          ___benignCriteria: 'Benignの判定基準',
          ___pathogenicCriteria: 'Pathogenicの判定基準',
          ___strengthofEvidence: 'エビデンスの強度',
          ___strong: '強い',
          ___supporting: '支持的（Supporting）',
          ___moderate: '中程度',
          ___veryStrong: '非常に強い',
          ___populationData: '集団データ',
          ___allelicEvidenceCosegrgationData: '対立遺伝子エビデンスと<br>共分離データ',
          ___computationPredictiveData: '計算・<br>予測データ',
          ___functionalData: '機能データ',
          ___other: 'その他',
          ___automatedCriteria: '自動化基準',
          ___explanation: '説明'
        }
      }
    },
    caseDetailGeneVariantDatabase: {
      ___title: 'バリアントデータベース',
      tab: {
        title: {
          ___clinvar: 'ClinVar',
          ___mastermind: 'Mastermind',
          ___MITOMAP: 'MITOMAP'
        }
      }
    },
    caseDetailGeneQuality: {
      ___title: '品質管理',
      pass: {
        readDepth: {
          ___pass: 'リード深度 ≥ 10<br>の場合は、可とする。',
          ___noPass: 'リード深度 < 10<br>の場合は、不可とする。'
        },
        genotypeQuality: {
          ___pass: '品質 ≥ 20 の場合は、<br>適合です。',
          ___noPass: '品質 < 20 の場合は、<br>不適合です。'
        },
        alleleFractions: {
          ___pass: 'アレル割合が基準を<br>満たしています。',
          ___noPass: 'アレル割合が基準を<br>満たしていません。'
        }
      },
      table: {
        family: {
          title: {
            ___case_id: '症例ID',
            ___relation: '関係',
            ___ra: 'Ref/Alt'
          }
        },
        default: {
          title: {
            ___genotype: '遺伝子型',
            ___readDepth: 'リード深度',
            ___alleleFractions: 'アレル割合',
            ___genotypeQuality: '遺伝子型品質',
            ___geneCoverage: '遺伝子カバレッジ率(CDS)'
          },
          option: {
            geneCoverage: {
              ___x10Cov: '10X',
              ___x20Cov: '20X'
            }
          }
        },
        mt: {
          title: {
            ___readDepth: 'リード深度',
            ___alleleFractions: 'アレル割合',
            ___geneCoverage: '遺伝子カバレッジ率(CDS)'
          },
          option: {
            geneCoverage: {
              ___x2000Cov: '2000X',
              ___x3000Cov: '3000X'
            }
          }
        }
      }
    },
    caseDetailGenePreview: {
      ___psTitle: '予測スコア',
      ___pdTitle: '集団データベース',
      tab: {
        title: {
          ___display: '表示するDBを選択',
          ___select: '選択されたDB'
        },
        info: {
          select: {
            ___ps: '<b style=color:#003679>最大{limit}つのデータベースを選択できます<span>（現在 {count} / {limit} 件選択中）</span>。選択したデータベースがテーブルに表示されます。</b>'
          }
        }
      }
    },
    caseDetailRegionGene: {
      ___title: '遺伝子リスト'
    },
    caseDetailRegionQuality: {
      ___title: '品質と情報',
      ___infoTitle: '情報',
      pass: {
        genotypeQuality: {
          ___pass: '品質 ≥ 15 の場合は、適合です。',
          ___noPass: '品質 < 15 の場合は、不適合です。'
        }
      },
      table: {
        default: {
          title: {
            ___genotype: '遺伝子型',
            ___filter: 'フィルター',
            ___genotypeQuality: '遺伝子型品質',
            ___phredScaled: 'Phred スケールの遺伝子型尤度',
            ___PairedRead: 'ペアリード',
            ___SplitRead: 'スプリットリード'
          }
        },
        info: {
          title: {
            ___IMPRECISE: 'IMPRECISE',
            ___Confidence: '位置の信頼区間（CI）',
            ___SV_Length: 'SV 挿入長',
            ___BF: 'BF',
            ___RATIO: 'RATIO',
            ___SV_Sequence: 'SV 挿入配列'
          }
        }
      }
    },
    caseDetailRegionVariant: {
      ___title: 'バリアントデータベース',
      tab: {
        title: {
          ___dbVar: 'dbVar',
          ___DECIPHER: 'DECIPHER'
        }
      }
    },
    caseDetailRegionPublication: {
      ___title: '集団データベース',
      tab: {
        title: {
          ___gnomAD_SV: 'gnomAD SV',
          ___dbVar: 'dbVar',
          ___JSV2: 'JSV2',
          ___CoLoRSdb: 'CoLoRSdb'
        }
      }
    },
    caseDetailRegionCaller: {
      ___title: 'コーラーの詳細（{count}件）',
      table: {
        title: {
          ___caller: 'コーラー',
          ___description: '説明'
        }
      }
    },
    caseEdit: {
      modal: {
        content: {
          ___changeOwner: '<span style="color:#FA3D3D">所有者を変更すると、症例は {old_owner} から {new_owner} に転送されます。このまま転送しますか？</span>'
        }
      }
    },
    caseDigitalMLPA: {
      ___title: 'DigitalMLPA',
      ___empty: '解析結果がありません',
      card: {
        title: {
          ___created: '作成日'
        }
      },
      top: {
        icon: {
          title: {
            ___delete: '削除'
          }
        }
      },
      modal: {
        content: {
          ___deleteAlert: '<span style="color:#FA3D3D">この解析を削除すると、解析内のすべてのデータも削除されます。この解析を削除しますか？</span>'
        }
      }
    },
    caseFile: {
      ___title: 'データ情報',
      vcf: {
        ___snvTitle: 'SNV/INDEL VCFファイル',
        ___svTitle: 'SV VCFファイル',
        ___strTitle: 'STR VCFファイル (ExpansionHunter/TRGT/Straglr)'
      },
      fastq: {
        ___title: 'Fastqファイル',
        ___file: '<b>Set{set}-{read}: </b>{file}',
        infoTitle: {
          ___omics: 'オーミクス',
          ___pipeline: 'パイプライン',
          ___libraryType: 'ライブラリーの種類',
          ___totalBases: '合計ベース数'
        }
      },
      ubam: {
        ___title: 'uBAMファイル',
        ___file: '<b>Set{set}: </b>{file}',
        infoTitle: {
          ___omics: 'オーミクス',
          ___pipeline: 'パイプライン',
          ___libraryType: 'ライブラリーの種類',
          ___totalBases: '合計ベース数'
        }
      },
      limit: {
        ___limitInfo: '帯域制限のため、<b>大容量ファイル（BAM ファイル等）のダウンロードは既定で 1 回のみ</b>です。追加が必要な場合は営業担当者までお問い合わせください。',
        ___limitAlert: 'ダウンロードは 1 回のみ可能です',
        ___times: 'ダウンロード回数：{times}'
      }
    },
    caseAnalysisVersion: {
      ___title: '解析バージョン',
      mainData: {
        title: {
          ___pipeline: '解析パイプラインバージョン<span>（解析 第1段階）</span>',
          ___analysis: 'アノテーションバージョン<span>（解析 第2段階）</span>'
        }
      },
      tableData: {
        pipeline: {
          category: {
            ___Hardware_Accelerated_Pipeline: 'Hardware-Accelerated Pipeline',
            ___GPU_Accelerated_Pipeline_Wrapper: 'GPU-Accelerated Pipeline Wrapper',
            ___Read_Aligner_GPU_Accelerated: 'Read Aligner (GPU-Accelerated)',
            ___Read_Aligner: 'Read Aligner',
            ___Variant_Caller_GPU_Accelerated: 'Variant Caller (GPU-Accelerated)',
            ___Variant_Caller_Mitochondria: 'Variant Caller (Mitochondria)',
            ___Variant_Phasing_Tool: 'Variant Phasing Tool',
            ___Structural_Variant_Caller: 'Structural Variant Caller',
            ___CNV_Caller_Exome_Based: 'CNV Caller (Exome-Based)',
            ___CNV_Caller_Control_Dataset: 'CNV Caller Control Dataset',
            ___CNV_Caller_WGS: 'CNV Caller (WGS)',
            ___Repeat_Expansion_Caller: 'Repeat Expansion Caller',
            ___HLA_Aligner: 'HLA Aligner',
            ___HLA_Genotyper: 'HLA Genotyper',
            ___Methylation_Caller: 'Methylation Caller',
            ___Pharmacogenomics_Tools: 'Pharmacogenomics Tools'
          },
          name: {
            ___DRAGEN: 'DRAGEN',
            ___Parabrick_pbrun: 'Parabrick pbrun',
            ___Parabrick_BWA_mem: 'Parabrick BWA mem',
            ___Parabricks_Minimap2: 'Parabricks Minimap2',
            ___Minimap2: 'Minimap2',
            ___Parabrick_deepvariant: 'Parabrick deepvariant',
            ___Mitorsaw: 'Mitorsaw',
            ___GATK: 'GATK',
            ___WhatsHap: 'WhatsHap',
            ___Hiphase: 'Hiphase',
            ___Manta: 'Manta',
            ___CuteSV: 'CuteSV',
            ___Sawfish: 'Sawfish',
            ___MitoSAlt: 'MitoSAlt',
            ___Sniffles: 'Sniffles',
            ___ExomeDepth: 'ExomeDepth',
            ___ExomeDepth_Baseline: 'ExomeDepth Baseline',
            ___CNVpytor: 'CNVpytor',
            ___ExpansionHunter: 'ExpansionHunter',
            ___TRGT: 'TRGT',
            ___Straglr: 'Straglr',
            ___HISAT2: 'HISAT2',
            ___HISAT_genotype: 'HISAT-genotype',
            ___Methbat: 'Methbat',
            ___Modkit: 'Modkit',
            ___PharmCAT: 'PharmCAT',
            ___pb_StarPhase: 'pb-StarPhase'
          }
        },
        analysis: {
          category: {
            ___Variant_Annotation_Tools: 'Variant Annotation Tools',
            ___Variant_Annotation_Tools_Database: 'Variant Annotation Tools Database',
            ___Canonical_Transcript_Reference: 'Canonical Transcript Reference',
            ___Protein_Function_Database: 'Protein Function Database',
            ___NCBI_RefSeq_Nucleotide_Protein_Mapping: 'NCBI RefSeq Nucleotide–Protein Mapping',
            ___Structural_Variant_Database: 'Structural Variant Database',
            ___Population_Frequency_Database: 'Population Frequency Database',
            ___Clinical_Variant_Database: 'Clinical Variant Database',
            ___In_Silico_Prediction_Database: 'In Silico Prediction Database',
            ___Variant_Identifier_Database: 'Variant Identifier Database',
            ___Disease_Gene_Database: 'Disease Gene Database',
            ___Mitochondrial_Variant_Database: 'Mitochondrial Variant Database',
            ___Phenotype_Ontology_Database: 'Phenotype Ontology Database',
            ___Others: 'Others'
          },
          name: {
            ___Jannovar: 'Jannovar',
            ___VEP: 'VEP',
            ___AnnotSV: 'AnnotSV',
            ___Jannovar_DB_Version: 'Jannovar DB Version',
            ___MANE: 'MANE',
            ___UniProt: 'UniProt',
            ___Refseq_nuc_prot: 'Refseq_nuc_prot',
            ___dbVar: 'dbVar (SV)',
            ___Decipher: 'DECIPHER (SV)',
            ___GnomAD: 'gnomAD (SV)',
            ___ClinVar: 'ClinVar',
            ___Mastermind: 'Mastermind',
            ___dbNSFP: 'dbNSFP',
            ___dbscSNV: 'dbscSNV',
            ___SpliceAI: 'CI-SpliceAI',
            ___AlphaMissense: 'AlphaMissense',
            ___VARITY: 'VARITY',
            ___ESM1b: 'ESM1b',
            ___dbSNP: 'dbSNP',
            ___ESP6500: 'ESP6500',
            ___ExAC: 'ExAC',
            ___GenomeAsia_100K: 'GenomeAsia 100K',
            ___gnomAD_Exomes: 'gnomAD Exomes',
            ___gnomAD_Exomes_Coverage: 'gnomAD Exomes Coverage',
            ___gnomAD_Exomes_constraint: 'gnomAD Exomes constraint',
            ___gnomAD_Genomes: 'gnomAD Genomes',
            ___gnomAD_Genomes_Coverage: 'gnomAD Genomes Coverage',
            ___gnomAD_Genomes_mtDNA: 'gnomAD Genomes mtDNA',
            ___1000_Genomes: '1000 Genomes',
            ___TaiwanBioBank: 'Taiwan BioBank',
            ___tommo_60kjpn: 'ToMMo 60KJPN',
            ___TOPMed: 'TOPMed',
            ___OMIM: 'OMIM',
            ___Orphanet: 'Orphanet',
            ___Mondo: 'Mondo',
            ___MITOMAP: 'MITOMAP',
            ___HPO: 'HPO',
            ___Pathway: 'Pathway'
          }
        }
      }
    },
    caseDetailSVFilter: {
      ___title: 'SV フィルター',
      gene: {
        ___title: '遺伝子記号',
        ___placeholder: 'ROR1、TP53、または BRCA1...',
        selected: {
          ___title: '選択済み（最大10遺伝子）'
        }
      },
      condition: {
        ___title: '疾患',
        ___placeholder: '疾患名（例：乳がん）',
        selected: {
          ___title: '選択済み（最大10疾患名）'
        }
      },
      variantDatabase: {
        ___title: 'バリアントデータベース',
        ClinVar: {
          ___title: 'ClinVar'
        },
        DECIPHER: {
          ___title: 'DECIPHER'
        }
      },
      afFilter: {
        ___title: 'AF フィルター',
        ___placeholder: '0~0.2, eg:0.01'
      },
      DosageSensitivity: {
        ___title: '遺伝子量感受性'
      },
      caller: {
        ___title: 'SVコーラー',
        genotype: {
          ___title: '遺伝子型'
        },
        svType: {
          ___title: 'SVタイプ'
        },
        genotypeQuality: {
          ___title: 'GQ',
          ___info: '推奨：Genotype Quality (GQ) ≥ 30。'
        },
        numberOfCallers: {
          ___title: 'コーラー数'
        }
      }
    },
    datasetArchiveConfirm: {
      info01: '下記コミュニティ・データセットをあなたのデータプールからアーカイブし、このコミュニティ・データセットに関連するデータセットを利用できなくなります。',
      info02: '<b>{count}</b> 個のデータセットが利用できなくなります。',
      table: {
        title: {
          ___name: 'データセット名',
          ___owner: '所有者',
          ___description: 'データセットの説明'
        }
      }
    },
    datasetDeleteConfirm: {
      info01: 'このデータセットはコミュニティーや他のユーザーと共有されています。共有の取り消しとデータセットの削除を希望しますか？',
      info02: '<b>{count}</b> 個のデータセットが利用できなくなります。',
      table: {
        data: {
          ___user: 'PhenoVarDBコミュニティー'
        },
        title: {
          ___accectedUserID: '影響を受けるユーザーID (所属、メールアドレス)',
          ___permission: '権限'
        }
      }
    },
    datasetDetail: {
      form: {
        title: {
          ___name: 'データセット名',
          ___sampleSize: 'サンプルサイズ',
          ___user: 'ユーザー'
        }
      },
      table: {
        title: {
          ___caseID: '症例ID',
          ___sex: '性別',
          ___birthYear: '生年',
          ___createdAt: '作成日',
          ___updatedAt: '更新日'
        }
      }
    },
    datasetEdit: {
      customForm: {
        shareAlert: {
          ___content: '<b>使用不可</b>'
        },
        sharing: {
          ___content: 'コミュニティー'
        },
        url: {
          ___copyIconTitle: 'コピー'
        },
        user: {
          ___content: '{count} ユーザー'
        }
      },
      form: {
        title: {
          ___shareAlert: '共有',
          ___sharing: '共有',
          ___url: 'データセットのURL',
          ___user: 'ユーザー',
          ___key: 'アクセスキー'
        }
      }
    },
    datasetInvitationConfirm: {
      info01: 'ユーザー {user} があなたに上記のデータセットへのアクセスを許可しました。招待を承認しますか？'
    },
    datasetSelectCase: {
      ___topTitle01: '総サンプル数は <b>{count}</b> です。',
      ___topTitle02: 'このボタンで全てをインポートすることができます。',
      ___searchPlaceholder: 'サンプルのキーワード',
      table: {
        title: {
          ___caseID: '症例ID',
          ___sex: '性別',
          ___birthYear: '生年',
          ___createdAt: '作成日',
          ___updatedAt: '更新日',
          ___phenotypeDatas: '表現型',
          ___genePanels: '遺伝子/疾患パネル'
        }
      }
    },
    datasetShareEdit: {
      form: {
        title: {
          ___user: 'ユーザー',
          ___permission: '権限',
          ___email: 'メールアドレス'
        }
      }
    },
    editChapter: {
      form: {
        title: {
          ___title: 'チャプター名',
          ___newTitle: '新チャプター名',
          ___description: 'チャプターの説明'
        },
        placeholder: {
          ___title: '新チャプター',
          ___description: 'チャプターの概要や説明を入力してください。'
        }
      }
    },
    editCNVToChapter: {
      ___editTitle: '新しいSVを編集する。',
      ___newTitle: '新しいSVを作成する。',
      ___geneTitle: '関連する遺伝子名を入力してください。',
      ___chapterTitle: '最低1チャプターを選択してください。',
      cnvForm: {
        placeholder: {
          ___chrom: 'Chr',
          ___posStart: 'スタート位置',
          ___posEnd: 'エンド位置'
        }
      },
      geneTag: {
        ___placeholder: '遺伝子名'
      },
      modal: {
        content: {
          ___deleteCNV: '<span style="color:#FA3D3D">バリアントを削除すると、中のすべてのコンテンツも削除されます。このバリアントを削除しますか？</span>'
        }
      }
    },
    editPanel: {
      form: {
        title: {
          ___panel: '新しいパネル名'
        },
        placeholder: {
          ___panel: '新しいパネル名を作成してください。'
        }
      }
    },
    editReportCNV: {
      ___typeTitle: 'SVの種類を変更する。',
      ___gtTitle: 'SVのGTを変更する。',
      ___intronTitle: 'SVのイントロン/エクソンを変更する。',
      ___lengthTitle: 'SVの長さを変更する。',
      cnvForm: {
        title: {
          ___type: '<b>SV</b> の種類を選択してください。',
          ___parentalOrigin: '<b>SV</b> の親由来を選択してください。'
        },
        placeholder: {
          ___gt: 'SVの遺伝子型(GT)',
          ___intron: 'SVのイントロン/エクソン',
          ___length: 'SVの長さ'
        }
      }
    },
    editReportSV: {
      ___typeTitle: 'SVの種類を変更する。',
      ___gtTitle: 'SVのGTを変更する。',
      ___intronTitle: 'SVのイントロン/エクソンを変更する。',
      ___lengthTitle: 'SVの長さを変更する。',
      svForm: {
        title: {
          ___type: '<b>SV</b> の種類を選択してください。',
          ___parentalOrigin: '<b>SV</b> の親由来を選択してください。'
        },
        placeholder: {
          ___gt: 'SVの遺伝子型(GT)',
          ___intron: 'SVのイントロン/エクソン',
          ___length: 'SVの長さ'
        }
      }
    },
    editReportVariant: {
      ___acmgTitle: 'バリアントのACMG分類を変更する。',
      ___siftPolyphen2Title: 'バリアントのSIFT&Polyphen2分類を変更する。',
      variantForm: {
        title: {
          ___acmg: '分類を選択してください。',
          ___sift: '<b>SIFT</b> の分類を選択してください。',
          ___polyphen2: '<b>Polyphen2</b> の分類を選択してください。',
          ___parentalOrigin: '親由来を選択してください。'
        }
      }
    },
    fileCloud: {
      ___title: 'Google バケットファイル一覧',
      ___subtitle: 'アップロードするファイルを1つだけ選択してください。'
    },
    editWorkgroupMember: {
      form: {
        title: {
          ___member: 'メンバー',
          ___newMember: '招待するユーザーのメールアドレス',
          ___role: '役割'
        },
        placeholder: {
          ___member: 'ex: InheriNext@compassbioinfo.com',
          ___role: '役割を選択してください。'
        }
      }
    },
    editWorkgroupCase: {
      ___title: '症例リスト',
      ___info: '{count}件の症例が選択されました。 | {count}件の症例が選択されました。 | {count}件の症例が選択されました。',
      ___searchPlaceholder: '症例IDのキーワードを入力して検索してください。',
      table: {
        title: {
          ___Case_ID: '症例ID',
          ___Sex: '性別',
          ___Age: '年齢',
          ___Created_date: '作成日',
          ___Modified_date: '更新日',
          ___Stage: '作業段階',
          ___Workgroup: 'ワークグループ'
        },
        alert: {
          ___added: 'この症例はワークグループに追加されました。'
        },
        pageDisplay: {
          ___item: '{count} 件 | {count} 件'
        }
      },
      modal: {
        content: {
          ___checkAutoShare: '<span>今後の症例をこのワークグループに自動的に共有しますか？</span>'
        }
      }
    },
    editWorkgroupStage: {
      form: {
        title: {
          ___stage: '作業段階',
          ___newStage: '新規作業段階',
          ___assignee: '担当者'
        },
        placeholder: {
          ___stage: '作業段階名は最大20文字で入力してください。',
          ___assignee: 'メンバーを選択してください。'
        }
      }
    },
    genePanelConfirm: {
      ___info01: '下記のリストは変更内容一覧です。更新前に再度ご確認ください。',
      block: {
        title: {
          ___add: '追加',
          ___remove: '削除'
        },
        content: {
          ___geneFreeTyping: '遺伝子-自由入力',
          ___geneUserDefined: '遺伝子-ユーザー定義',
          ___panel: 'パネル',
          ___hpoPhenotypes: 'HPO表現型',
          ___conditions: '疾患',
          ___pathways: '経路'
        }
      }
    },
    genePanelInfo: {
      ___info01: '<b>遺伝子パネルツール</b>へようこそ。',
      ___info02: 'これは無料で公開されている検索ツールです。',
      ___info03: '<span>まずはお客様の情報をご記入いただきますようお願いいたします。</span>',
      form: {
        title: {
          ___name: 'お名前',
          ___organization: '所属機関',
          ___email: 'メールアドレス'
        },
        errorTitle: {
          ___name: 'お名前',
          ___organization: '所属機関',
          ___email: 'メールアドレス'
        },
        placeholder: {
          ___name: '例：Eric Tsai、李大平...',
          ___organization: '例：Taiwan Biobank、コンパスバイオインフォマティクス株式会社...',
          ___email: 'メールアドレス、例：info@compassbioinfo.com'
        }
      }
    },
    genePanelQuickSelection: {
      ___title: 'ディビジョンのクイック選択',
      block: {
        subtitle: {
          ___panel01: 'デフォルト',
          ___panel02: '遺伝子数'
        },
        content: {
          ___division: 'パネル数'
        }
      }
    },
    projectEdit: {
      form: {
        title: {
          ___import: 'パラメータをインポート'
        },
        placeholder: {
          ___import: '解析を選択する。'
        }
      },
      modal: {
        content: {
          ___unknownSexAlert: '<span style="color:#FA3D3D">性別が不明な場合、後の解析結果に影響を与える可能性があります。それでも続けますか？</span>'
        }
      }
    },
    selectDataset: {
      ___description: 'ケースを作成する前にフォーマットを選択してください。<br>InheriNext は、VCF ケースの一括アップロードにも対応しています。',
      select: {
        title: {
          ___vcf: 'VCF',
          ___fastq: 'FASTQ',
          ___ubam: 'uBAM'
        },
        description: {
          ___vcf: '<b>{price}</b> ポイント/症例',
          ___fastq: '<b>{price}</b> ポイント/症例',
          ___ubam: '<b>{price}</b> ポイント/症例'
        },
        option: {
          ___batch: 'バッチアップロード'
        }
      }
    },
    userAvatar: {
      ___userTitle: 'アバターをデフォルトセットから選択するか、ドライブからアップロードしてください。',
      ___customTitle: 'カスタム・アバター'
    },
    userConfirm: {
      ___mainTitle: '成功！',
      ___title01: 'ご登録のメールアドレスに認証コードが送信されました。',
      ___title02: 'ログインするには認証コードを入力してください。',
      form: {
        title: {
          ___code: '認証'
        },
        placeholder: {
          ___code: '6桁の認証コード'
        }
      }
    },
    intractableDiseaseSelect: {
      ___title: 'D006-4 遺伝学的検査疾患名'
    },
    chatbot: {
      ___busyTitle: '現在すべてのインスタンスが混み合っています。10 分ほど時間をおいて再度お試しください。',
      ___inputPlaceholder: '歌舞伎症候群について教えてください。',
      ___deleteAlert: 'この会話は削除されます。<br>続行しますか？',
      agent: {
        ___title: 'AIエージェントの処理概要'
      },
      button: {
        default: {
          clinVar: {
            ___title: 'ClinVarにおけるバリアントの注釈情報。例えばchr3:37042330C>Tのバリアントの臨床的意義。',
            ___content: 'chr3:37042330C>Tのバリアントの臨床的意義は何ですか？'
          },
          caseReports: {
            ___title: 'バリアントに関する症例報告の出典リンク。例えばchr1:69589G>Aのバリアントの症例報告。',
            ___content: 'chr1:69589G>Aのバリアントの症例報告は？'
          },
          prevalence: {
            ___title: '疾患の有病率、病因、および疾患の遺伝性情報。例えば歌舞伎症候群の有病率。',
            ___content: '歌舞伎症候群の有病率は？'
          },
          disease: {
            ___title: '疾患に関する参考文献と出典リンク。例えばアルツハイマー病に関する参考文献。',
            ___content: 'アルツハイマー病に関する参考文献は？'
          }
        }
      }
    }
  },
  // constant
  CONSTANT: {
    data: {
      countryCode: {
        name: {
          ___AF: 'アフガニスタン',
          ___AX: 'アランド諸島',
          ___AL: 'アルバニア',
          ___DZ: 'アルジェリア',
          ___AS: 'アメリカ領サモア',
          ___AD: 'アンドラ',
          ___AO: 'アンゴラ',
          ___AI: 'アンギラ',
          ___AQ: '南極大陸',
          ___AG: 'アンティグア・バーブーダ',
          ___AR: 'アルゼンチン',
          ___AM: 'アルメニア',
          ___AW: 'アルバ',
          ___AU: 'オーストラリア',
          ___AT: 'オーストリア',
          ___AZ: 'アゼルバイジャン',
          ___BS: 'バハマ',
          ___BH: 'バーレーン',
          ___BD: 'バングラデシュ',
          ___BB: 'バルバドス',
          ___BY: 'ベラルーシ',
          ___BE: 'ベルギー',
          ___BZ: 'ベリーズ',
          ___BJ: 'ベナン',
          ___BM: 'バミューダ',
          ___BT: 'ブータン',
          ___BO: 'ボリビア',
          ___BQ: 'ボネール、セント・ユースタティウス、サバ',
          ___BA: 'ボスニア・ヘルツェゴビナ',
          ___BW: 'ボツワナ',
          ___BV: 'ブーベ島',
          ___BR: 'ブラジル',
          ___IO: 'イギリス領インド洋地域',
          ___VG: '英領バージン諸島',
          ___BN: 'ブルネイ',
          ___BG: 'ブルガリア',
          ___BF: 'ブルキナファソ',
          ___BI: 'ブルンジ',
          ___KH: 'カンボジア',
          ___CM: 'カメルーン',
          ___CA: 'カナダ',
          ___CV: 'カーボベルデ',
          ___KY: 'ケイマン諸島',
          ___CF: '中央アフリカ共和国',
          ___TD: 'チャド',
          ___CL: 'チリ',
          ___CN: '中国',
          ___CX: 'クリスマス島',
          ___CC: 'ココス諸島',
          ___CO: 'コロンビア',
          ___KM: 'コモロ',
          ___CK: 'クック諸島',
          ___CR: 'コスタリカ',
          ___HR: 'クロアチア',
          ___CU: 'キューバ',
          ___CW: 'キュラソー',
          ___CY: 'キプロス',
          ___CZ: 'チェコ共和国',
          ___CD: 'コンゴ民主共和国',
          ___DK: 'デンマーク',
          ___DJ: 'ジブチ',
          ___DM: 'ドミニカ国',
          ___DO: 'ドミニカ共和国',
          ___TL: '東ティモール',
          ___EC: 'エクアドル',
          ___EG: 'エジプト',
          ___SV: 'エルサルバドル',
          ___GQ: '赤道ギニア',
          ___ER: 'エリトリア',
          ___EE: 'エストニア',
          ___ET: 'エチオピア',
          ___FK: 'フォークランド諸島',
          ___FO: 'フェロー諸島',
          ___FJ: 'フィジー',
          ___FI: 'フィンランド',
          ___FR: 'フランス',
          ___GF: 'フランス領ギアナ',
          ___PF: 'フランス領ポリネシア',
          ___TF: 'フランス領南方領土',
          ___GA: 'ガボン',
          ___GM: 'ガンビア',
          ___GE: 'グルジア',
          ___DE: 'ドイツ',
          ___GH: 'ガーナ',
          ___GI: 'ジブラルタル',
          ___GR: 'ギリシャ',
          ___GL: 'グリーンランド',
          ___GD: 'グレナダ',
          ___GP: 'グアドループ',
          ___GU: 'グアム',
          ___GT: 'グアテマラ',
          ___GG: 'ガーンジー',
          ___GN: 'ギニア',
          ___GW: 'ギニアビサウ',
          ___GY: 'ガイアナ',
          ___HT: 'ハイチ',
          ___HM: 'ハード島とマクドナルド諸島',
          ___HN: 'ホンジュラス',
          ___HK: '香港',
          ___HU: 'ハンガリー',
          ___IS: 'アイスランド',
          ___IN: 'インド',
          ___ID: 'インドネシア',
          ___IR: 'イラン',
          ___IQ: 'イラク',
          ___IE: 'アイルランド',
          ___IM: 'マン島',
          ___IL: 'イスラエル',
          ___IT: 'イタリア',
          ___CI: 'コートジボワール',
          ___JM: 'ジャマイカ',
          ___JP: '日本',
          ___JE: 'ジャージー',
          ___JO: 'ヨルダン',
          ___KZ: 'カザフスタン',
          ___KE: 'ケニア',
          ___KI: 'キリバス',
          ___XK: 'コソボ',
          ___KW: 'クウェート',
          ___KG: 'キルギス',
          ___LA: 'ラオス',
          ___LV: 'ラトビア',
          ___LB: 'レバノン',
          ___LS: 'レソト',
          ___LR: 'リベリア',
          ___LY: 'リビア',
          ___LI: 'リヒテンシュタイン',
          ___LT: 'リトアニア',
          ___LU: 'ルクセンブルク',
          ___MO: 'マカオ',
          ___MK: 'マケドニア',
          ___MG: 'マダガスカル',
          ___MW: 'マラウイ',
          ___MY: 'マレーシア',
          ___MV: 'モルディブ',
          ___ML: 'マリ',
          ___MT: 'マルタ',
          ___MH: 'マーシャル諸島',
          ___MQ: 'マルティニーク',
          ___MR: 'モーリタニア',
          ___MU: 'モーリシャス',
          ___YT: 'マヨット',
          ___MX: 'メキシコ',
          ___FM: 'ミクロネシア',
          ___MD: 'モルドバ',
          ___MC: 'モナコ',
          ___MN: 'モンゴル',
          ___ME: 'モンテネグロ',
          ___MS: 'モンセラート',
          ___MA: 'モロッコ',
          ___MZ: 'モザンビーク',
          ___MM: 'ミャンマー',
          ___NA: 'ナミビア',
          ___NR: 'ナウル',
          ___NP: 'ネパール',
          ___NL: 'オランダ',
          ___NC: 'ニューカレドニア',
          ___NZ: 'ニュージーランド',
          ___NI: 'ニカラグア',
          ___NE: 'ニジェール',
          ___NG: 'ナイジェリア',
          ___NU: 'ニウエ',
          ___NF: 'ノーフォーク島',
          ___KP: '北朝鮮',
          ___MP: '北マリアナ諸島',
          ___NO: 'ノルウェー',
          ___OM: 'オマーン',
          ___PK: 'パキスタン',
          ___PW: 'パラオ',
          ___PS: 'パレスチナ自治区',
          ___PA: 'パナマ',
          ___PG: 'パプアニューギニア',
          ___PY: 'パラグアイ',
          ___PE: 'ペルー',
          ___PH: 'フィリピン',
          ___PN: 'ピトケアン',
          ___PL: 'ポーランド',
          ___PT: 'ポルトガル',
          ___PR: 'プエルトリコ',
          ___QA: 'カタール',
          ___CG: 'コンゴ共和国',
          ___RE: 'レユニオン',
          ___RO: 'ルーマニア',
          ___RU: 'ロシア',
          ___RW: 'ルワンダ',
          ___BL: 'サン・バルテルミー島',
          ___SH: 'セントヘレナ',
          ___KN: 'セントクリストファー・ネイビス',
          ___LC: 'セントルシア',
          ___MF: 'セント・マーチン島',
          ___PM: 'サンピエール島・ミクロン島',
          ___VC: 'サウスジョージア・サウスサンドウィッチ諸島',
          ___WS: 'サモア',
          ___SM: 'サンマリノ',
          ___ST: 'サントメ・プリンシペ',
          ___SA: 'サウジアラビア',
          ___SN: 'セネガル',
          ___RS: 'セルビア',
          ___SC: 'セーシェル',
          ___SL: 'シエラレオネ',
          ___SG: 'シンガポール',
          ___SX: 'シント・マールテン',
          ___SK: 'スロバキア',
          ___SI: 'スロベニア',
          ___SB: 'ソロモン諸島',
          ___SO: 'ソマリア',
          ___ZA: '南アフリカ共和国',
          ___GS: 'サウスジョージア・サウスサンドウィッチ諸島',
          ___KR: '韓国',
          ___SS: '南スーダン',
          ___ES: 'スペイン',
          ___LK: 'スリランカ',
          ___SD: 'スーダン',
          ___SR: 'スリナム',
          ___SJ: 'スバールバル諸島とヤンマイエン島',
          ___SZ: 'スワジランド',
          ___SE: 'スウェーデン',
          ___CH: 'スイス',
          ___SY: 'シリア',
          ___TW: '台湾',
          ___TJ: 'タジキスタン',
          ___TZ: 'タンザニア',
          ___TH: 'タイ',
          ___TG: 'トーゴ',
          ___TK: 'トケラウ',
          ___TO: 'トンガ',
          ___TT: 'トリニダード・トバゴ',
          ___TN: 'チュニジア',
          ___TR: 'トルコ',
          ___TM: 'トルクメニスタン',
          ___TC: 'タークス・カイコス諸島',
          ___TV: 'ツバル',
          ___VI: '米領バージン諸島',
          ___UG: 'ウガンダ',
          ___UA: 'ウクライナ',
          ___AE: 'アラブ首長国連邦',
          ___GB: 'イギリス',
          ___US: '米国',
          ___UM: '合衆国領有小離島',
          ___UY: 'ウルグアイ',
          ___UZ: 'ウズベキスタン',
          ___VU: 'バヌアツ',
          ___VA: 'バチカン',
          ___VE: 'ベネズエラ',
          ___VN: 'ベトナム',
          ___WF: 'ウォリス・フテュナ',
          ___EH: '西サハラ',
          ___YE: 'イエメン',
          ___ZM: 'ザンビア',
          ___ZW: 'ジンバブエ'
        }
      }
    },
    global: {
      data: {
        caseDataTypeMetadatas: {
          tag: {
            title: {
              ___intractableDisease: 'D006-4',
              ___designatedIntractableDisease: '指定難病',
              ___pgp: '表現型',
              ___gene_filter: '遺伝子パネル',
              ___str: 'STR',
              ___nbs_pathovar: '病原性バリアント',
              ___nbs_nullvar: 'ヌルバリアント',
              ___nbs_carrier: 'キャリア',
              ___incidental: '二次的所見',
              ___monitor: 'モニター',
              ___filter: 'フィルター',
              ___clinvar: 'ClinVar',
              ___nbs: 'nbs',
              ___nbs_nonmendelian: '非メンデル遺伝'
            }
          }
        },
        predictionMetaDataDisplayTitles: {
          ___Damaging: 'Damaging',
          ___Tolerated: 'Tolerated',
          ___ProbablyDamaging: 'Probably Damaging',
          ___PossiblyDamaging: 'Possibly Damaging',
          ___Benign: 'Benign',
          ___High: 'High',
          ___Medium: 'Medium',
          ___Low: 'Low',
          ___Neutral: 'Neutral',
          ___Splicealtering: 'Splice-altering',
          ___Conserved: 'Conserved',
          ___Nonconserved: 'Non-conserved',
          ___Likelyorpossiblypathogenic: 'Likely or possibly pathogenic',
          ___Likelyorpossiblybenign: 'Likely or possibly benign',
          ___Ambiguous: 'Ambiguous',
          ___Likelybenign: 'Likely benign',
          ___LikelyPathogenic: 'Likely pathogenic'
        },
        getClinvarStatisticData: {
          ___title: 'コード領域への影響',
          ___Pathogenic: 'Pathogenic',
          ___Likely_pathogenic: 'Likely Pathogenic',
          ___Conflicting_interpretations_of_pathogenicity: 'Conflicting interpretations of pathogenicity',
          ___Uncertain_significance: 'Uncertain Significance',
          ___Likely_benign: 'Likely benign',
          ___Benign: 'Benign',
          ___stop_gained: 'Stop Gained',
          ___splice_site: 'Splice Site',
          ___frameshift: 'Frameshift Variant',
          ___stop_lost: 'Stop Lost',
          ___start_lost: 'Start Lost',
          ___missense: 'Missense',
          ___inframe_indel: 'Inframe Indel',
          ___synonymous: 'Synonymous Variant',
          ___non_coding: 'Non Coding',
          ___total: '合計'
        },
        clinvarACMGMap: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___PathogenicLikelypathogenic: 'Pathogenic/Likely pathogenic',
            ___Likelypathogenic: 'Likely pathogenic',
            ___Conflictinginterpretationsofpathogenicity: 'Conflicting interpretations of pathogenicity',
            ___Conflictingclassificationsofpathogenicity: 'Conflicting classifications of pathogenicity',
            ___Uncertainsignificance: 'Uncertain significance',
            ___riskfactor: 'risk factor',
            ___Benign: 'Benign',
            ___BenignLikelybenign: 'Benign/Likely benign',
            ___Likelybenign: 'Likely benign',
            ___drugresponse: 'drug response',
            ___protective: 'protective',
            ___other: 'other',
            ___Affects: 'Affects',
            ___vus: 'VUS'
          },
          display: {
            ___Pathogenic: 'Pathogenic',
            ___PathogenicLikelypathogenic: 'Pathogenic/Likely pathogenic',
            ___Likelypathogenic: 'Likely pathogenic',
            ___Conflictinginterpretationsofpathogenicity: 'Conflicting interpretations of pathogenicity',
            ___Conflictingclassificationsofpathogenicity: 'Conflicting classifications of pathogenicity',
            ___Uncertainsignificance: 'Uncertain significance',
            ___riskfactor: 'risk factor',
            ___Benign: 'Benign',
            ___BenignLikelybenign: 'Benign/Likely benign',
            ___Likelybenign: 'Likely benign',
            ___drugresponse: 'drug response',
            ___protective: 'protective',
            ___other: 'other',
            ___Affects: 'Affects',
            ___vus: 'VUS'
          }
        },
        repeatClassificationMap: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___Indeterminate: 'Indeterminate',
            ___Intermediate: 'Intermediate',
            ___Normal: 'Normal'
          }
        },
        acmgMap: {
          info: {
            ___BA1: '集団データベースにおけるアレル頻度が5％以上である。',
            ___BS1: 'アレル頻度が保因者頻度よりも高い。',
            ___BS2: '健康な成人において、劣性（ホモ接合体）、優性（ヘテロ接合体）、またはX連鎖性（半接合体）の障害が観察され、早期の完全浸透が予想されている。',
            ___BS4: '家系内の罹患者においてsegregationが取れない。',
            ___BS3: 'in vitroまたはin vivoの機能解析において、タンパク質の機能やスプライシングに障害を及ぼさないことが確認されている。',
            ___BP2: '既知の病的変異とcisの状態で見出された変異、またはADの病的変異とtransに見出された変異。',
            ___BP5: '他の遺伝子に原因となる変異が見出されている。',
            ___BP1: 'Truncating変異が疾患を引き起こす遺伝子から新規に見出されたミスセンス変異。',
            ___BP3: 'フレーム内欠失／挿入変異が機能未知の繰り返し領域に見出されている。',
            ___BP4: '遺伝子や遺伝子産物への影響（保全、進化、スプライシングの影響など）がないことを複数のコンピューター予測により支持されている。',
            ___BP7: '同義（サイレント）置換を起こす変異でスプライシングにも影響がないと予測され、保存性も低い塩基置換。',
            ___BP6: '他のデータベース等で病的でないことが報告されているが、検査施設における独自に評価する証拠がない。',
            ___PP1: '疾患の原因として確認されている遺伝子において、家系内の複数の罹患者とバリアントがCo-segregationした。',
            ___PP2: '良性ミスセンス変異率が低く、ミスセンス変異が疾患を引き起こすと考えられている遺伝子のミスセンスバリアント。',
            ___PP3: '遺伝子または遺伝子産物への有害な影響（保全、進化、スプライシングの影響など）を複数のコンピューター予測により支持されている。',
            ___PP4: '患者の表現型や家族歴から、一つの遺伝子が原因として想定されている。',
            ___PP5: '他のデータベース等で病的変異であることが報告されているが、検査施設における独自に評価する証拠がない。',
            ___PM2: '集団データベースでは、変異が大規模コントロールに認められない（あるいは頻度が非常に低い）。',
            ___PM3: '劣性遺伝性疾患では、病原性バリアントとtransで見出されている。',
            ___PM6: 'de novo変異だと思われるが、両親のいずれかの確認が取れていない。',
            ___PM1: '変異がhot spotや機能上重要なドメイン（例：酵素の活性部位）にあり、良性の変異がない。',
            ___PM4: 'タンパク質の長さが変わるようなフレーム内欠失／挿入変異およびストップ・ロス変異',
            ___PM5: '異なる種類のアミノ酸置換がすでに病的変異として報告されている。',
            ___PS4: '罹患者におけるアレル頻度が、コントロールと比較して有意的に高い。',
            ___PS2: '家族歴のない患者から見出されたde novo変異（両親ともに確認できている）。',
            ___PS1: '既知の病的変異と同じアミノ酸置換を生じる異なる種類の塩基置換。',
            ___PS3: 'in vitroまたはin vivoの機能解析で障害を及ぼす証拠がある。',
            ___PVS1: 'LOFが疾患の原因で知られている遺伝子のヌル変異（ナンセンス変異、フレームシフト変異、スプライス部位±1～2塩基の変異、開始コドン、シングルまたはマルチエクソン欠失）。'
          },
          explanations: {
            ___BA1: '// 説明',
            ___BS1: '// 説明',
            ___BS2: '// 説明',
            ___BS4: '// 説明',
            ___BS3: '// 説明',
            ___BP2: '// 説明',
            ___BP5: '// 説明',
            ___BP1: '// 説明',
            ___BP3: '// 説明',
            ___BP4: '// 説明',
            ___BP7: '// 説明',
            ___BP6: '// 説明',
            ___PP1: '// 説明',
            ___PP2: '// 説明',
            ___PP3: '// 説明',
            ___PP4: '// 説明',
            ___PP5: '// 説明',
            ___PM2: '// 説明',
            ___PM3: '// 説明',
            ___PM6: '// 説明',
            ___PM1: '// 説明',
            ___PM4: '// 説明',
            ___PM5: '// 説明',
            ___PS4: '// 説明',
            ___PS2: '// 説明',
            ___PS1: '// 説明',
            ___PS3: '// 説明',
            ___PVS1: '// 説明'
          }
        },
        datasetStatusMap: {
          title: {
            ___created: '作成済み',
            ___analyzing: '解析中...',
            ___completed: '完了',
            ___failed: '失敗',
            ___disabled: '無効'
          }
        },
        datasetPermissionTypeMap: {
          title: {
            ___private: 'プライベート',
            ___community: 'コミュニティー'
          }
        },
        datasetPermissionMap: {
          title: {
            ___private: 'プライベート',
            ___basic: 'ベーシック',
            ___explore: 'データ探索',
            ___full: 'フル・アクセス'
          }
        },
        datasetInvitationPermissionMap: {
          title: {
            ___explore: 'データ探索',
            ___full: 'フル・アクセス'
          }
        },
        datasetPipelineMap: {
          title: {
            ___WES: '全エクソーム解析（WES）',
            ___WGS: '全ゲノム解析（WGS）'
          }
        },
        datasetShareAlert: {
          ___external_data_included: 'コミュニティーのデータが含まれています。データセットを共有したい場合は、すべてのデータを含むデータセットを作成してください。',
          ___disabled: 'データセットが無効です。',
          ___analyzing: 'データ解析が実行中です。',
          ___failed: 'データ解析が失敗しました。'
        },
        windowConfirm: {
          ___default: '変更内容が保存されていませんが、このまま終了しますか？'
        },
        defaultEmptyDisplay: {
          ___empty: 'N/A',
          ___noKey: '?'
        },
        pageDisplay: {
          ___item: '{count} 項目',
          ___display: '各ページの項目',
          ___jump: 'へ行く',
          ___page: 'ページ'
        },
        projectState: {
          ___created: 'データなし',
          ___uploading: 'アップロード中',
          ___analyzing: '解析中',
          ___completed: '完了',
          ___failed: '解析失敗',
          ___noAffected: '疾患なし<br>（Unaffected）'
        },
        jobState: {
          ___running: 'パイプライン',
          ___default: '表現型'
        },
        familyRelationOptions: {
          title: {
            ___Father: '父',
            ___Mother: '母',
            ___Brother: '兄・弟',
            ___Sister: '姉・妹',
            ___PaternalGrandfather: '祖父（父方）',
            ___PaternalGrandmother: '祖母（父方）',
            ___MaternalGrandfather: '祖父（母方）',
            ___MaternalGrandmother: '祖母（母方）',
            ___PaternalUncle: '伯父・叔父（父方）',
            ___PaternalAunt: '伯母・叔母（父方）',
            ___MaternalUncle: '伯父・叔父（母方）',
            ___MaternalAunt: '伯母・叔母（母方）'
          }
        },
        svClinvarOptions: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___Likely_Pathogenic: 'Likely Pathogenic',
            ___Benign: 'Benign',
            ___Likely_Benign: 'Likely Benign',
            ___Variant_of_Uncertain_Significance: 'Uncertain Significance',
            ___Conflicting_interpretations_of_pathogenicity: 'Conflicting interpretations of pathogenicity'
          },
          subtitle: {
            ___Pathogenic: 'Pathogenic',
            ___Likely_Pathogenic: 'Likely Pathogenic',
            ___Benign: 'Benign',
            ___Likely_Benign: 'Likely Benign',
            ___Variant_of_Uncertain_Significance: 'Uncertain Significance',
            ___Conflicting_interpretations_of_pathogenicity: 'Conflicting interpretations of pathogenicity'
          }
        },
        svDECIPHEROptions: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___Likely_Pathogenic: 'Likely Pathogenic',
            ___Benign: 'Benign',
            ___Likely_Benign: 'Likely Benign',
            ___Uncertain_Significance: 'Uncertain Significance',
            ___Others: 'Others'
          },
          subtitle: {
            ___Pathogenic: 'Pathogenic',
            ___Likely_Pathogenic: 'Likely Pathogenic',
            ___Benign: 'Benign',
            ___Likely_Benign: 'Likely Benign',
            ___Uncertain_Significance: 'Uncertain Significance',
            ___Others: 'Others'
          }
        },
        svDosageSensitivityOptions: {
          title: {
            ___Sufficient_evidence_for_dosage_pathogenicity: '病的遺伝子量に十分な証拠あり',
            ___Some_evidence_for_dosage_pathogenicity: '病的遺伝子量に一定の証拠あり',
            ___Little_evidence_for_dosage_pathogenicity: '病的遺伝子量にわずかな証拠あり',
            ___No_evidence_for_dosage_pathogenicity: '病的遺伝子量に関する証拠なし',
            ___Evidence_suggests_the_gene_is_not_dosage_sensitive: '遺伝子が量依存的でないことを示す証拠あり',
            ___Gene_associated_with_autosomal_recessive_phenotype: '常染色体劣性表現型に関連する遺伝子'
          }
        },
        svGenotypeOptions: {
          title: {
            ___Homozygous_reference: 'リファレンスホモ',
            ___Heterozygous: 'ヘテロ',
            ___Homozygous_alternate: '変異ホモ'
          }
        },
        svTypeOptions: {
          title: {
            ___DEL: 'DEL',
            ___INS: 'INS',
            ___DUP: 'DUP',
            ___INV: 'INV',
            ___CTX: 'CTX',
            ___CNV: 'CNV',
            ___BND: 'BND'
          }
        },
        strClassificationMap: {
          title: {
            ___Pathogenic: 'Pathogenic',
            ___Indeterminate: 'Indeterminate',
            ___Intermediate: 'Intermediate',
            ___Normal: 'Normal',
            ___RU_mismatch: 'RU mismatch',
            ___Catalog_mismatch: 'Catalog mismatch'
          }
        },
        intractableDiseaseDifficutyMap: {
          title: {
            ___easy: '処理が容易なもの',
            ___hard: '処理が複雑なもの',
            ___very_hard: '処理が極めて複雑なもの'
          }
        },
        intractableDiseaseMethodMap: {
          title: {
            ___A: 'ア',
            ___I: 'イ',
            ___U: 'ウ',
            ___E: 'エ',
            ___O: 'オ'
          },
          symbol: {
            ___A: '㋐',
            ___I: '㋑',
            ___U: '㋒',
            ___E: '㋓',
            ___O: '㋔'
          },
          info: {
            ___A: '<span>ＰＣＲ法、ＤＮＡシーケンス法、ＦＩＳＨ法またはサザンブロット法による場合に算定できるもの</span>',
            ___I: '<span>ＰＣＲ法による場合に算定できるもの</span>',
            ___U: '<span>ア、イ、エ及びオ以外のもの</span>',
            ___E: '<span>別に<a href=http://www.kentaikensa.jp/files/37089.pdf target=_blank>厚生労働大臣が定める施設基準に適合しているものとして地方厚生（支）局長に届け出</a>た保険医療機関において検査が行われる場合に算定できるもの</span>',
            ___O: '<span>臨床症状や他の検査等では診断がつかない場合に、別に<a href=http://www.kentaikensa.jp/files/37089.pdf target=_blank>厚生労働大臣が定める施設基準に適合しているものとして地方厚生（支）局長に届け出</a>た保険医療機関において検査が行われる場合に算定できるもの</span>'
          }
        },
        intractableDiseaseOptions: {
          title: {
            ___Duchenne_muscular_dystrophy: 'デュシェンヌ型筋ジストロフィー',
            ___Becker_muscular_dystrophy: 'ベッカー型筋ジストロフィー',
            ___Familial_amyloidosis: '家族性アミロイドーシス(全身性アミロイドーシス)',
            ___Spinal_and_bulbar_muscular_atrophy_SBMA: '球脊髄性筋萎縮症',
            ___Myotonic_dystrophy: '筋強直性ジストロフィー (筋緊張性ジストロフィー)',
            ___Lysosomal_storage_diseases_including_mucopolysaccharidosis_type_I_mucopolysaccharidosis_type_II_Gaucher_disease_Fabry_disease_and_Pompe_disease: 'ライソゾーム病（ムコ多糖症Ⅰ型、ムコ多糖症Ⅱ型、ゴーシェ病、ファブリー病及びポンペ病を含む）',
            ___Fragile_X_syndrome: '脆弱Ｘ症候群',
            ___TNF_receptor_associated_periodic_syndrome_TRAPS: 'TNF受容体関連周期性症候群',
            ___Nakajo_Nishimura_syndrome: '中條－西村症候群',
            ___Familial_Mediterranean_fever: '家族性地中海熱',
            ___Bethlem_myopathy: 'ベスレムミオパチー',
            ___X_linked_myopathy_with_excessive_autophagy: '過剰自己貪食を伴うＸ連鎖性ミオパチー',
            ___Non_dystrophic_myotonia_syndromes: '非ジストロフィー性ミオトニー症候群',
            ___Hereditary_periodic_limb_paralysis: '遺伝性周期性四肢麻痺',
            ___Autosomal_recessive_leukodystrophy_with_alopecia_and_spondylometaphyseal_dysplasia: '禿頭と変形性脊椎症を伴う常染色体劣性白質脳症',
            ___Tuberous_sclerosis: '結節性硬化症',
            ___Pachydermoperiostosis: '肥厚性皮膚骨膜症',
            // ___Neurofibromatosis_Type_I: '神経線維腫症I型',
            // ___Neurofibromatosis_Type_2: '神経線維腫症II型',
            ___Alexander_disease: 'アレキサンダー病',
            ___Chronic_non_specific_multiple_ulcers_of_the_small_intestine: '非特異性多発性小腸潰瘍症',
            ___TRPV4_related_disorder: 'ＴＲＰＶ４異常症',
            ___Fukuyama_congenital_muscular_dystrophy: '福山型先天性筋ジストロフィー',
            ___Spinal_muscular_atrophy: '脊髄性筋萎縮症',
            ___Huntingtons_disease: 'ハンチントン病',
            ___Retinoblastoma: '網膜芽細胞腫',
            ___Medullary_thyroid_carcinoma: '甲状腺髄様癌',
            ___Multiple_endocrine_neoplasia_type_1_MEN1: '多発性内分泌腫瘍症１型',
            ___Phenylketonuria_PKU: 'フェニルケトン尿症',
            ___Homocystinuria: 'ホモシスチン尿症',
            ___Citrullinemia_type_I: 'シトルリン血症（１型）',
            ___Argininosuccinic_aciduria_Urea_cycle_disorder: 'アルギノコハク酸血症（尿素サイクル異常症）',
            ___Isovaleric_acidemia: 'イソ吉草酸血症',
            ___HMG_CoA_lyase_deficiency: 'ＨＭＧ血症 (ＨＭＧ-CoAリアリーゼ血症)',
            ___Multiple_carboxylase_deficiency: '複合カルボキシラーゼ欠損症',
            ___Glutaric_acidemia_type_1: 'グルタル酸血症１型',
            ___MCAD_deficiency_Medium_chain_acyl_CoA_dehydrogenase_deficiency: '中鎖アシルCoA脱水素酵素欠損症（ＭＣＡＤ欠損症）',
            ___VLCAD_deficiency_Very_long_chain_acyl_CoA_dehydrogenase_deficiency: '極長鎖アシルCoA脱水素酵素欠損症（ＶＬＣＡＤ欠損症）',
            ___CPT1_deficiency_Carnitine_palmitoyltransferase_I_deficiency: 'ＣＰＴ１欠損症（カルニチン回路異常症）',
            // ___Menkes_Disease_Congenital_disorder_of_copper_metabolism: 'メンケス病（先天性銅代謝異常症）',
            // ___Occipital_Horn_Syndrome_Congenital_disorder_of_copper_metabolism: 'オクシピタル・ホーン症候群（先天性銅代謝異常症）',
            // ___Wilson_Disease_Congenital_disorder_of_copper_metabolism: 'ウィルソン病（先天性銅代謝異常症）',
            ___Cryopyrin_associated_periodic_syndromes_CAPS: 'クリオピリン関連周期熱症候群',
            ___Neurodegeneration_with_brain_iron_accumulation_NBIA: '脳内鉄沈着神経変性症',
            ___Congenital_cerebral_leukodystrophy_including_central_nervous_system_hypomyelination: '先天性大脳白質形成不全症（中枢神経白質形成異常症を含む。）',
            ___PCDH19_related_disorder: 'ＰＣＤＨ19関連症候群',
            ___Hypophosphatasia: '低ホスファターゼ症',
            ___Apert_syndrome: 'アペール症候群',
            ___Rothmund_Thomson_syndrome: 'ロスムンド・トムソン症候群',
            ___Prader_Willi_syndrome: 'プラダー・ウィリ症候群',
            ___Angelman_syndrome: 'アンジェルマン症候群',
            ___Smith_Magenis_syndrome: 'スミス・マギニス症候群',
            ___Fragile_X_associated_disorders: '脆弱Ｘ症候群関連疾患',
            ___Wolfram_syndrome: 'ウォルフラム症候群',
            ___Hyper_IgD_syndrome: '高ＩｇＤ症候群',
            ___PAPA_syndrome_Pyogenic_sterile_arthritis_pyoderma_gangrenosum_and_acne: '化膿性無菌性関節炎・壊疽性膿皮症・アクネ症候群',
            ___Congenital_anomaly_syndromes: '先天異常症候群',
            ___ACTH_resistance_syndrome: '副腎皮質刺激ホルモン不応症',
            ___Autosomal_recessive_punctate_epiphyseal_dysplasia_type_1_Peroxisomal_diseases_excluding_adrenoleukodystrophy: '根性点状軟骨異形成症１型 （ペルオキシソーム病（副腎白質ジストロフィーを除く））',
            ___Familial_partial_lipodystrophy: '家族性部分性脂肪萎縮症',
            ___Sotos_syndrome: 'ソトス症候群',
            ___Carnitine_deficiency_Carnitine_palmitoyltransferase_II_deficiency: 'CPT2欠損症（カルニチン回路異常症）',
            ___Carnitine_deficiency_Carnitine_acylcarnitine_translocase_deficiency: 'CACT欠損症（カルニチン回路異常症）',
            ___Carnitine_deficiency_OCTN2_deficiency_Primary_carnitine_deficiency: 'OCTN-2異常症（カルニチン回路異常症）',
            ___Citrin_deficiency: 'シトリン欠損症',
            ___Non_ketotic_hyperglycinemia: '非ケトーシス型高グリシン血症',
            ___Beta_ketothiolase_deficiency: 'β-ケトチオラーゼ欠損症',
            ___3_Methylglutaconic_aciduria: 'メチルグルタコン酸血症 (メチルグルタコン酸尿症)',
            ___Glutaric_acidemia_type_2: 'グルタル酸血症２型',
            ___Congenital_adrenal_hypoplasia: '先天性副腎低形成症',
            ___ATR_X_syndrome_Alpha_thalassemia_X_linked_intellectual_disability_syndrome: 'ATR-X症候群',
            ___Hutchinson_Gilford_progeria_syndrome: 'ハッチンソン・ギルフォード症候群',
            ___Achondroplasia: '軟骨無形成症',
            ___Progressive_Myoclonic_Epilepsy_Lafora_disease: '進行性ミオクローヌスてんかん（ラフォラ病）',
            ___Sepiapterin_reductase_SR_deficiency: 'セピアプテリン還元酵素（SR）欠損症',
            ___Aromatic_L_amino_acid_decarboxylase_deficiency: '芳香族L-アミノ酸脱炭酸酵素欠損症',
            ___Osler_disease_Hereditary_hemorrhagic_telangiectasia: 'オスラー病（遺伝性出血性末梢血管拡張症）',
            ___CFC_syndrome_Cardiofaciocutaneous_syndrome: 'ＣＦＣ症候群',
            ___Costello_syndrome: 'コステロ症候群',
            ___CHARGE_syndrome: 'チャージ症候群',
            ___Lysinuric_protein_intolerance: 'リジン尿性蛋白不耐症',
            ___Adrenoleukodystrophy: '副腎白質ジストロフィー',
            ___Blau_syndrome: 'ブラウ症候群',
            ___Branchio_oto_renal_syndrome: '鰓耳腎症候群',
            ___Young_Simpson_syndrome: 'ヤング・シンプソン症候群',
            ___Congenital_nephrogenic_diabetes_insipidus: '先天性腎性尿崩症',
            ___Vitamin_D_dependent_rickets_osteomalacia: 'ビタミンD依存性くる病/骨軟化症',
            ___Nail_patella_syndrome_LMX1B_associated_nephropathy: 'ネイルパテラ症候群（爪膝蓋症候群）/LMX1B 関連腎症',
            ___GLUT1_deficiency_syndrome: 'グルコーストランスポーター1欠損症',
            ___Resistance_to_thyroid_hormone: '甲状腺ホルモン不応症',
            ___Weaver_syndrome: 'ウィーバー症候群',
            ___Coffin_Lowry_syndrome: 'コフィン・ローリー症候群',
            ___Mowat_Wilson_syndrome: 'モワット・ウィルソン症候群',
            ___Hepatic_glycogen_storage_diseases_types_I_III_VI_IXa_IXb_IXc_IV: '肝型糖原病（糖原病Ⅰ型、Ⅲ型、Ⅵ型、Ⅸa型、Ⅸb型、Ⅸc型、Ⅳ型）',
            ___Myopathic_glycogen_storage_diseases_types_III_IV_IXd: '筋型糖原病（糖原病Ⅲ型、Ⅳ型、Ⅸd型）',
            ___Congenital_protein_C_deficiency: '先天性プロテインC欠乏症（特発性血栓症（遺伝性血栓性素因によるものに限る））',
            ___Congenital_protein_S_deficiency: '先天性プロテインS欠乏症（特発性血栓症（遺伝性血栓性素因によるものに限る））',
            ___Congenital_antithrombin_deficiency: '先天性アンチトロンビン欠乏症',
            ___Amyotrophic_lateral_sclerosis_ALS: '筋萎縮性側索硬化症',
            ___Distal_myopathy_with_rimmed_vacuoles: '縁取り空砲を伴う遠位型ミオパチー',
            ___Schwartz_Jampel_syndrome: 'シュワルツ・ヤンペル症候群',
            ___Hypertrophic_cardiomyopathy: '肥大型心筋症',
            ___Familial_hypercholesterolemia_holmozygous: '家族性高コレステロール血症（ホモ接合体）',
            ___Congenital_myopathy: '先天性ミオパチー',
            ___CADASIL_Cerebral_autosomal_dominant_arteriopathy_with_subcortical_infarcts_and_leukoencephalopathy: '皮質下梗塞と白質脳症を伴う常染色体優性脳動脈症',
            ___Hereditary_diffuse_leukoencephalopathy_with_axonal_spheroids: '神経軸索スフェロイド形成を伴う遺伝性びまん性白質脳症',
            ___Congenital_insensitivity_to_pain_with_anhidrosis: '先天性無痛無汗症',
            ___Familial_benign_chronic_pemphigus_Hailey_Hailey_disease: '家族性良性慢性天疱瘡',
            ___Nasu_Hakola_disease: '那須・ハコラ病',
            ___Carney_complex: 'カーニー複合',
            ___Peroxisome_biogenesis_disorder: 'ペルオキシソーム形成異常症',
            ___Peroxisomal_beta_oxidation_enzyme_deficiency: 'ペルオキシソームβ酸化系酵素欠損症',
            ___Plasmalogen_synthesis_enzyme_deficiency: 'プラスマローゲン合成酵素欠損症',
            ___Acatalasemia: 'アカタラセミア',
            ___Primary_hyperoxaluria_type_I: '原発性高シュウ酸尿症Ⅰ型',
            ___Refsum_disease: 'レフサム病',
            ___Hereditary_folate_malabsorption: '先天性葉酸吸収不全症',
            ___Atypical_porphyria: '異型ポルフィリン症',
            ___Congenital_erythropoietic_porphyria: '先天性骨髄性ポルフィリン症',
            ___Acute_intermittent_porphyria: '急性間欠性ポルフィリン症',
            ___Erythropoietic_protoporphyria: '赤芽球性プロトポルフィリン症',
            ___X_linked_protoporphyria: 'Ｘ連鎖優性プロトポルフィリン症',
            ___Hereditary_coproporphyria: '遺伝性コプロポルフィリン症',
            ___Porphyria_cutanea_tarda: '晩発性皮膚ポルフィリン症',
            ___Hepatoerythropoietic_porphyria: '肝性骨髄性ポルフィリン症',
            ___Primary_hyperchylomicronemia: '原発性高カイロミクロン血症',
            ___Abetalipoproteinemia: '無βリポタンパク血症',
            ___Thanatophoric_dysplasia: 'タナトフォリック骨異形成症',
            ___Hereditary_pancreatitis: '遺伝性膵炎',
            ___Cystic_fibrosis: '嚢胞性線維症',
            ___Usher_syndrome_type_1_type_2_type_3: 'アッシャー症候群（タイプ１、タイプ２、タイプ３）',
            ___Canavan_disease: 'カナバン病',
            ___Congenital_glycosylphosphatidylinositol_deficiency: '先天性グリコシルホスファチジルイノシトール欠損症',
            ___Osteopetrosis: '大理石骨病',
            ___Cerebral_creatine_deficiency_syndrome: '脳クレアチン欠乏症候群',
            ___Nephronophthisis: 'ネフロン癆',
            ___Familial_hypobetalipoproteinemia_type_1_homozygous_form: '家族性低βリポタンパク血症１（ホモ接合体）',
            ___Progressive_familial_intrahepatic_cholestasis: '進行性家族性肝内胆汁うっ滞症',
            ___Nutritional_epidermolysis_bullosa: '栄養障害型表皮水疱症',
            ___Congenital_long_QT_syndrome: '先天性ＱＴ延長症候群',
            ___Maple_syrup_urine_disease: 'メープルシロップ尿症',
            ___Methylmalonic_acidemia: 'メチルマロン酸血症',
            ___Propionic_acidemia: 'プロピオン酸血症',
            ___3_Methylcrotonylglycinuria: 'メチルクロトニルグリシン尿症',
            ___MTP_LCHAD_deficiency_Triple_Enzyme_Deficiency: 'ＭＴＰ（ＬＣＨＡＤ）欠損症（三頭酵素欠損症）',
            ___Xeroderma_pigmentosum: '色素性乾皮症',
            ___Loeys_Dietz_syndrome: 'ロイスディーツ症候群',
            ___Familial_thoracic_aortic_aneurysm_and_dissection: '家族性大動脈瘤・解離',
            ___Neuroacanthocytosis: '神経有棘赤血球症',
            ___Congenital_myasthenic_syndrome: '先天性筋無力症候群',
            ___Primary_immunodeficiency_syndrome: '原発性免疫不全症候群',
            ___Perry_syndrome: 'ペリー症候群',
            ___Crouzon_syndrome: 'クルーゾン症候群',
            ___Pfeiffer_syndrome: 'ファイファー症候群',
            ___Antley_Bixler_syndrome: 'アントレー・ビクスラー症候群',
            ___Tangier_disease: 'タンジール病',
            ___Congenital_dyserythropoietic_anemia: '先天性赤血球形成異常性貧血',
            ___Early_onset_bilateral_sensorineural_hearing_loss: '若年発症型両側性感音難聴',
            ___Urea_cycle_disorder: '尿素サイクル異常症',
            ___Marfan_syndrome_Loeys_Dietz_Syndrome: 'マルファン症候群/ロイス・ディーツ症候群',
            ___Vascular_Ehlers_Danlos_syndrome: '血管型エーラスダンロス症候群',
            ___Hereditary_autoinflammatory_disease: '遺伝性自己炎症疾患',
            ___Hereditary_dystonia: '遺伝性ジストニア',
            ___Dravet_syndrome: 'ドラベ症候群',
            ___Coffin_Siris_syndrome: 'コフィン・シリス症候群',
            ___Kabuki_syndrome: '歌舞伎症候群',
            ___Pulmonary_alveolar_proteinosis_autoimmune_or_congenital: '肺胞蛋白症（自己免疫性又は先天性）',
            ___Noonan_syndrome: 'ヌーナン症候群',
            ___Osteogenesis_imperfecta: '骨形成不全症',
            ___Spinocerebellar_degeneration_excluding_multiple_system_atrophy: '脊髄小脳変性症（多系統萎縮症を除く）',
            ___Classical_Ehlers_Danlos_syndrome: '古典型エーラス・ダンロス症候群',
            ___Atypical_hemolytic_uremic_syndrome_aHUS: '非典型溶血性尿毒症症候群',
            ___Alport_syndrome: 'アルポート症候群',
            ___Fanconi_anemia: 'ファンコニ貧血',
            ___Alagille_syndrome: 'アラジール症候群',
            ___Rubinstein_Taybi_syndrome: 'ルビンシュタイン・テイビ症候群',
            ___Primary_ciliary_dyskinesia_including_Kartagener_syndrome: '線毛機能不全症候群（カルタゲナー症候群を含む）',
            ___Proteinuria_group: 'タンパク尿群',
            ___Cardiomyopathy_group: '心筋症群',
            ___Growth_disorder_intellectual_disability_and_characteristic_facial_features_group: '成長障害・知的障害・特徴的な顔貌群',
            ___Intellectual_disability_and_epilepsy_group: '知的障害・てんかん群',
            ___Fever_inflammation_rash_and_osteoarticular_syndrome_group: '発熱・炎症・皮疹・骨関節症候群',
            ___Muscle_weakness_group: '筋力低下群',
            ___Rett_syndrome: 'レット症候群',
            ___Lowe_syndrome_oculocerebrorenal_syndrome: 'ロウ症候群',
            ___Miyoshi_myopathy: '三好型ミオパチー',
            ___Lecithin_cholesterol_acyltransferase_LCAT_deficiency: 'レシチンコレステロールアシルトランスフェラーゼ欠損症',
            ___Sitosterolemia: 'シトステロール血症',
            ___Pseudohypoparathyroidism: '偽性副甲状腺機能低下症',
            ___Marinesco_Sjögren_syndrome: 'マリネスコ・シェーグレン症候群',
            ___Galactose_1_phosphate_uridyltransferase_deficiency: 'ガラクトース−1−リン酸ウリジルトランスフェラーゼ欠損症',
            ___Fibrodysplasia_ossificans_progressiva_FOP: '進行性骨化性線維異形成症',
            ___Aniridia: '無虹彩症',
            ___PURA_related_neurodevelopmental_disorders: 'PURA関連神経発達異常症',
            ___Leber_hereditary_optic_neuropathy_LHON: 'レーベル遺伝性視神経症',
            ___Alveolar_hypoventilation_syndrome: '肺胞低換気症候群',
            ___Cerebrotendinous_xanthomatosis_CTX: '脳腱黄色腫症',
            ___Joubert_syndrome_and_related_disorders_JSRD: 'ジュベール症候群関連疾患',
            ___Werner_syndrome: 'ウェルナー症候群',
            ___Cockayne_syndrome: 'コケイン症候群',
            ___Pseudoxanthoma_elasticum_PXE: '弾性線維性仮性黄色腫',
            ___Diamond_Blackfan_anemia: 'ダイアモンド・ブラックファン貧血',
            ___LMNB1_related_leukoencephalopathy_ADLD: 'LMNB1関連大脳白質脳症',
            ___Congenital_ichthyosis: '先天性魚鱗癬',
            ___Oculocutaneous_albinism: '眼皮膚白皮症',
            ___STING_stimulator_of_interferon_genes_associated_vasculopathy_with_onset_in_infancy: '乳児発症STING関連血管炎',
            ___Progressive_leukoencephalopathy: '進行性白質脳症',
            ___Charcot_Marie_Tooth_disease_CMT: 'シャルコー・マリー・トゥース病',
            ___Congenital_adrenal_hyperplasia_congenital_adrenal_enzyme_deficiency: '先天性副腎皮質酵素欠損症',
            ___Hemorrhagic_disorders_due_to_abnormal_fibrinolysis: '出血性線溶異常症',
            ___Mitochondrial_diseases: 'ミトコンドリア病',
            ___Epstein_syndrome: 'エプスタイン症候群',
            ___neurofibromatosis: '神経線維腫症',
            ___congenital_hearing_loss: '先天性難聴',
            ___prion_disease: 'プリオン病',
            ___familial_idiopathic_basal_ganglia_calcification: '家族性特発性基底核石灰化症',
            ___williams_syndrome: 'ウィリアムズ症候群',
            ___1p36_deletion_syndrome: '1p36欠失症候群',
            ___4p_deletion_syndrome: '4p欠失症候群',
            ___5p_deletion_syndrome: '5p欠失症候群',
            ___paternal_uniparental_disomy_of_chromosome_14: '第14番染色体父親性ダイソミー症候群',
            ___22q11_2_deletion_syndrome: '22q11.2欠失症候群',
            ___unverricht_lundborg_disease: 'ウンフェルリヒト・ルンドボルグ病',
            ___congenital_disorder_of_copper_metabolism: '先天性銅代謝異常症',
            ___hereditary_sideroblastic_anemia: '遺伝性鉄芽球性貧血',
            ___ring_chromosome_20_syndrome: '環状20番染色体症候群',
            ___emanuel_syndrome: 'エマヌエル症候群',
            ___dermatofibrosarcoma_protuberans: '隆起性皮膚線維肉腫',
            ___Primary_lateral_sclerosis: '原発性側索硬化症',
            ___Progressive_supranuclear_palsy: '進行性核上性麻痺',
            ___Parkinsons_disease: 'パーキンソン病',
            ___Corticobasal_degeneration: '大脳皮質基底核変性症',
            ___Charcot_Marie_Tooth_disease: 'シャルコー・マリー・トゥース病',
            ___Myasthenia_gravis: '重症筋無力症',
            ___Multiple_sclerosis_Neuromyelitis_optica_spectrum_disorders: '多発性硬化症/視神経脊髄炎',
            ___Chronic_inflammatory_demyelinating_polyneuropathy_Multifocal_motor_neuropathy: '慢性炎症性脱髄性多発神経炎/多巣性運動ニューロパチー',
            ___Sporadic_inclusion_body_myositis: '封入体筋炎',
            ___Multiple_system_atrophy: '多系統萎縮症',
            ___Moyamoya_disease: 'もやもや病',
            ___Pemphigus: '天疱瘡',
            ___Pustular_psoriasis: '膿疱性乾癬(汎発型)',
            ___Stevens_Johnson_syndrome: 'スティーヴンス・ジョンソン症候群',
            ___Toxic_epidermal_necrolysis: '中毒性表皮壊死症',
            ___Takayasu_arteritis: '高安動脈炎',
            ___Giant_cell_arteritis: '巨細胞性動脈炎',
            ___Polyarteritis_nodosa: '結節性多発動脈炎',
            ___Granulomatosis_with_polyangiitis: '多発血管炎性肉芽腫症',
            ___Systemic_lupus_erythematosus: '全身性エリテマトーデス',
            ___Systemic_sclerosis: '全身性強皮症',
            ___Behcets_disease: 'ベーチェット病',
            ___Idiopathic_dilated_cardiomyopathy: '特発性拡張型心筋症',
            ___Restrictive_cardiomyopathy: '拘束型心筋症',
            ___Aplastic_anemia: '再生不良性貧血',
            ___Paroxysmal_nocturnal_hemoglobinuria: '発作性夜間ヘモグロビン尿症',
            ___Immune_thrombocytopenia: '免疫性血小板減少症',
            ___Thrombotic_thrombocytopenic_purpura: '血栓性血小板減少性紫斑病',
            ___IgA_nephropathy: 'IgA腎症',
            ___Polycystic_kidney_disease: '多発性嚢胞腎',
            ___Ossification_of_posterior_longitudinal_ligament: '後縦靱帯骨化症',
            ___Idiopathic_osteonecrosis_of_femoral_head: '特発性大腿骨頭壊死症',
            ___Diencephalo_hypophysial_insufficiency_inappropriate_ADH_syndrome: '下垂体性ADH分泌異常症',
            ___Diencephalo_hypophysial_insufficiency_inappropriate_thyroid_stimulating_hormone_syndrome: '下垂体性TSH分泌亢進症',
            ___Diencephalo_hypophysial_insufficiency_inappropriate_prolactin_syndrome: '下垂体性PRL分泌亢進症',
            ___Cushing_disease: 'クッシング病',
            ___Diencephalo_hypophysial_dysfunction_syndrome_of_abnormal_secretion_of_gonadotropin: '下垂体性ゴナドトロピン分泌亢進症',
            ___Diencephalo_hypophysial_dysfunction_syndrome_of_abnormal_secretion_of_growth_hormone: '下垂体性成長ホルモン分泌亢進症',
            ___Hypopituitarism_syndrome: '下垂体前葉機能低下症',
            ___Congenital_adrenal_enzyme_deficiency: '先天性副腎皮質酵素欠損症',
            ___Addisons_disease: 'アジソン病',
            ___Sarcoidosis: 'サルコイドーシス',
            ___Pulmonary_arterial_hypertension: '肺動脈性肺高血圧症',
            ___Pulmonary_veno_occlusive_disease_pulmonary_capillary_hemangiomatosis: '肺静脈閉塞症/肺毛細血管腫症',
            ___Chronic_thromboembolic_pulmonary_hypertension: '慢性血栓塞栓性肺高血圧症',
            ___Lymphangioleiomyomatosis: 'リンパ脈管筋腫症',
            ___Retinitis_pigmentosa: '網膜色素変性症',
            ___Budd_Chiari_syndrome: 'バッド・キアリ症候群',
            ___Primary_biliary_cholangitis: '原発性胆汁性胆管炎',
            ___Primary_sclerosing_cholangitis: '原発性硬化性胆管炎',
            ___Crohns_disease: 'クローン病',
            ___Ulcerative_colitis: '潰瘍性大腸炎',
            ___Chronic_idiopathic_intestinal_pseudo_obstruction: '慢性特発性偽性腸閉塞症',
            ___Megacystis_microcolon_intestinal_hypoperistalsis_syndrome: '巨大膀胱短小結腸腸管蠕動不全症',
            ___Juvenile_idiopathic_arthritis: '若年性特発性関節炎',
            ___Marinesco_Sjogren_syndrome: 'マリネスコ・シェーグレン症候群',
            ___Myelomeningocele: '脊髄髄膜瘤',
            ___Frontotemporal_lobar_degeneration: '前頭側頭葉変性症',
            ___Acute_encephalopathy_with_biphasic_seizures_and_late_reduced_diffusion: '痙攣重積型(二相性)急性脳症',
            ___Moebius_syndrome: 'メビウス症候群',
            ___Septo_optic_dysplasia_De_Morsier_syndrome: '中隔視神経形成異常症/ドモルシア症候群',
            ___Aicardi_syndrome: 'アイカルディ症候群',
            ___Hemimegalencephaly: '片側巨脳症',
            ___Focal_cortical_dysplasia: '限局性皮質異形成',
            ___Neuronal_migration_defects: '神経細胞移動異常症',
            ___Epilepsy_with_myoclonic_atonic_seizures: 'ミオクロニー脱力発作を伴うてんかん',
            ___Lennox_Gastaut_syndrome: 'レノックス・ガストー症候群',
            ___West_syndrome: 'ウエスト症候群',
            ___Ohtahara_syndrome: '大田原症候群',
            ___Early_myoclonic_encephalopathy: '早期ミオクロニー脳症',
            ___Epilepsy_of_infancy_with_migrating_focal_seizures: '遊走性焦点発作を伴う乳児てんかん',
            ___Hemiconvulsion_hemiplegia_epilepsy_syndrome: '片側痙攣・片麻痺・てんかん症候群',
            ___Rasmussens_encephalitis: 'ラスムッセン脳炎',
            ___Developmental_and_or_epileptic_encephalopathy_with_spike_wave_activation_in_sleep: '睡眠時棘徐波活性化を示す発達性てんかん性脳症およびてんかん性脳症',
            ___Landau_Kleffner_syndrome: 'ランドウ・クレフナー症候群',
            // ___Rett_syndrome: 'レット症候群',
            ___Sturge_Weber_syndrome: 'スタージ・ウェーバー症候群',
            // ___Congenital_ichthyosis: '先天性魚鱗癬',
            ___Pemphigoid_including_Epidermolysis_bullosa_acquisita: '類天疱瘡(後天性表皮水疱症を含む。)',
            // ___Oculocutaneous_albinism: '眼皮膚白皮症',
            ___Pseudoxanthoma_elasticum: '弾性線維性仮性黄色腫',
            ___VATER_syndrome: 'VATER症候群',
            ___Joubert_syndrome_and_related_disorders: 'ジュベール症候群関連疾患',
            ___Polysplenia_syndrome: '多脾症候群',
            ___Asplenia_syndrome: '無脾症候群',
            // ___Werner_syndrome: 'ウェルナー症候群',
            // ___Cockayne_syndrome: 'コケイン症候群',
            ___Truncus_arteriosus_communis: '総動脈幹遺残症',
            ___Corrected_transposition_of_great_arteries: '修正大血管転位症',
            ___Complete_transposition_of_the_great_arteries: '完全大血管転位症',
            ___Hypoplastic_left_heart_syndrome: '左心低形成症候群',
            ___Tetralogy_of_Fallot: 'ファロー四徴症',
            ___Double_outlet_right_ventricle: '両大血管右室起始症',
            ___Ebsteins_anomaly: 'エプスタイン病',
            ___Galloway_Mowat_syndrome: 'ギャロウェイ・モワト症候群',
            ___Primary_nephrotic_syndrome: '一次性ネフローゼ症候群',
            ___Primary_membranoproliferative_glomerulonephritis: '一次性膜性増殖性糸球体腎炎',
            // ___Alveolar_hypoventilation_syndrome: '肺胞低換気症候群',
            ___Alpha_1_antitrypsin_deficiency: 'α1-アンチトリプシン欠乏症',
            ___Hypoparathyroidism: '副甲状腺機能低下症',
            // ___Pseudohypoparathyroidism: '偽性副甲状腺機能低下症',
            ___Vitamin_D_resistant_rickets_Vitamin_D_resistant_osteomalacia: 'ビタミンD抵抗性くる病/骨軟化症',
            ___Tyrosinemia_type_1: '高チロシン血症1型',
            ___Tyrosinemia_type_2: '高チロシン血症2型',
            ___Tyrosinemia_type_3: '高チロシン血症3型',
            // ___Galactose_1_phosphate_uridyltransferase_deficiency: 'ガラクトース-1-リン酸ウリジルトランスフェラーゼ欠損症',
            ___Lecithin_cholesterol_acyltransferase_deficiency: 'レシチンコレステロールアシルトランスフェラーゼ欠損症',
            // ___Sitosterolemia: 'シトステロール血症',
            ___Cerebrotendinous_xanthomatosis: '脳腱黄色腫症',
            ___Chronic_recurrent_multifocal_osteomyelitis: '慢性再発性多発性骨髄炎',
            ___Ankylosing_spondylitis: '強直性脊椎炎',
            ___Fibrodysplasia_ossificans_progressiva: '進行性骨化性線維異形成症',
            ___Congenital_scoliosis_with_rib_anomalies: '肋骨異常を伴う先天性側弯症',
            ___Giant_lymphatic_malformation_cervicofacial_lesion: '巨大リンパ管奇形(頚部顔面病変)',
            ___Giant_venous_malformation_cervical_oral_and_oropharyngeal_diffuse_lesion: '巨大静脈奇形(頚部口腔咽頭びまん性病変)',
            ___Klippel_Trenaunay_Weber_syndrome: 'クリッペル・トレノネー・ウェーバー症候群',
            // ___Diamond_Blackfan_anemia: 'ダイアモンド・ブラックファン貧血',
            ___Hirschsprung_disease: 'ヒルシュスプルング病(全結腸型又は小腸型)',
            ___Congenital_diaphragmatic_hernia: '先天性横隔膜ヘルニア',
            ___Biliary_atresia: '胆道閉鎖症',
            ___Macular_dystrophy: '黄斑ジストロフィー',
            // ___Progressive_leukoencephalopathy: '進行性白質脳症',
            ___Anterior_segment_dysgenesis: '前眼部形成異常',
            // ___Aniridia: '無虹彩症',
            ___Idiopathic_multicentric_Castlemans_disease: '特発性多中心性キャッスルマン病',
            ___Gelatinous_drop_like_corneal_dystrophy: '膠様滴状角膜ジストロフィー',
            ___MECP2_Duplication_Syndrome: 'MECP2重複症候群',
            ___Autosomal_Dominant_Adult_Onset_Demyelinating_Leukodystrophy: 'LMNB1関連大脳白質脳症',
            ___PURA_related_severe_neonatal_hypotonia_seizures_encephalopathy_syndrome: 'PURA関連神経発達異常症',
            ___very_long_chain_acyl_CoA_dehydrogenase: '極長鎖アシル-CoA脱水素酵素欠損症',
            // ___STING_stimulator_of_interferon_genes_associated_vasculopathy_with_onset_in_infancy: '乳児発症STING関連血管炎',
            ___Bleeding_disorder_with_abnormal_fibrinolysis: '出血性線溶異常症',
            ___Lowe_syndrome: 'ロウ症候群'
          }
        },
        workgroupRoleOptions: {
          title: {
            ___owner: '管理者',
            ___director: 'ディレクター',
            ___member: 'メンバー'
          }
        },
        reportPreviewOptions: {
          categoryTitle: {
            ___AlleleFrequency: 'アレル頻度',
            ___coverage: 'カバレッジ率',
            ___psSpliceSite: 'スプライス・サイト',
            ___psFunctionPrediction: '機能予測',
            ___psEnsemble: 'Ensemble',
            ___psConservation: 'コンサベーション',
            ___psgnomADConstraint: 'gnomAD制約'
          },
          groupTitle: {
            ___1000Genomes: '1000 Genomes',
            ___gnomADExomes: 'gnomAD Exomes',
            ___gnomADGenomes: 'gnomAD Genomes',
            ___phenoVarDBPrivate: 'PhenoVarDBプライベート',
            ___phenoVarDBCommunity: 'PhenoVarDB コミュニティー',
            ___phenoVarDBAdmin: 'PhenoVarDB管理者',
            ___other: 'その他',
            ___coverageGnomADExomes: 'gnomAD Exomes',
            ___coverageGnomADGenomes: 'gnomAD Genomes'
          },
          linkTitle: {
            ___SpliceAI: 'ここをクリックしてSpliceAIスコアを調べてください。'
          },
          title: {
            ___KG_AF: 'AF',
            ___KG_EAS_AF: 'EAS AF',
            ___KG_AMR_AF: 'AMR AF',
            ___KG_AFR_AF: 'AFR AF',
            ___KG_EUR_AF: 'EUR AF',
            ___KG_SAS_AF: 'SAS AF',
            ___gnomAD_AF: 'AF',
            ___gnomAD_AFR_AF: 'AFR AF',
            ___gnomAD_AMR_AF: 'AMR AF',
            ___gnomAD_ASJ_AF: 'ASJ AF',
            ___gnomAD_EAS_AF: 'EAS AF',
            ___gnomAD_FIN_AF: 'FIN AF',
            ___gnomAD_NFE_AF: 'NFE AF',
            ___gnomAD_OTH_AF: 'OTH AF',
            ___gnomAD_SAS_AF: 'SAS AF',
            ___gnomAD_MID_AF: 'MID AF',
            ___gnomAD_g_AF: 'AF',
            ___gnomAD_g_AF_afr: 'AFR AF',
            ___gnomAD_g_AF_ami: 'AMI AF',
            ___gnomAD_g_AF_amr: 'AMR AF',
            ___gnomAD_g_AF_asj: 'ASJ AF',
            ___gnomAD_g_AF_eas: 'EAS AF',
            ___gnomAD_g_AF_fin: 'FIN AF',
            ___gnomAD_g_AF_mid: 'MID AF',
            ___gnomAD_g_AF_nfe: 'NFE AF',
            ___gnomAD_g_AF_oth: 'OTH AF',
            ___gnomAD_g_AF_sas: 'SAS AF',
            ___gnomAD_g_mt_AF_het: 'ヘテロプラスミー AF',
            ___gnomAD_g_mt_pop_AF_het_afr: 'ヘテロプラスミー AFR AF',
            ___gnomAD_g_mt_pop_AF_het_ami: 'ヘテロプラスミー AMI AF',
            ___gnomAD_g_mt_pop_AF_het_amr: 'ヘテロプラスミー AMR AF',
            ___gnomAD_g_mt_pop_AF_het_asj: 'ヘテロプラスミー ASJ AF',
            ___gnomAD_g_mt_pop_AF_het_eas: 'ヘテロプラスミー EAS AF',
            ___gnomAD_g_mt_pop_AF_het_fin: 'ヘテロプラスミー FIN AF',
            ___gnomAD_g_mt_pop_AF_het_mid: 'ヘテロプラスミー MID AF',
            ___gnomAD_g_mt_pop_AF_het_nfe: 'ヘテロプラスミー NFE AF',
            ___gnomAD_g_mt_pop_AF_het_oth: 'ヘテロプラスミー OTH AF',
            ___gnomAD_g_mt_pop_AF_het_sas: 'ヘテロプラスミー SAS AF',
            ___gnomAD_g_mt_AF_hom: 'ホモプラスミー AF',
            ___gnomAD_g_mt_pop_AF_hom_afr: 'ホモプラスミー AFR AF',
            ___gnomAD_g_mt_pop_AF_hom_ami: 'ホモプラスミー AMI AF',
            ___gnomAD_g_mt_pop_AF_hom_amr: 'ホモプラスミー AMR AF',
            ___gnomAD_g_mt_pop_AF_hom_asj: 'ホモプラスミー ASJ AF',
            ___gnomAD_g_mt_pop_AF_hom_eas: 'ホモプラスミー EAS AF',
            ___gnomAD_g_mt_pop_AF_hom_fin: 'ホモプラスミー FIN AF',
            ___gnomAD_g_mt_pop_AF_hom_mid: 'ホモプラスミー MID AF',
            ___gnomAD_g_mt_pop_AF_hom_nfe: 'ホモプラスミー NFE AF',
            ___gnomAD_g_mt_pop_AF_hom_oth: 'ホモプラスミー OTH AF',
            ___gnomAD_g_mt_pop_AF_hom_sas: 'ホモプラスミー SAS AF',
            ___PVDB_P_FILTER: 'フィルター',
            ___PVDB_P_F_MISSING: '欠損率',
            ___PVDB_P_AC: 'AC',
            ___PVDB_P_AN: 'AN',
            ___PVDB_P_AF: 'AF',
            ___PVDB_P_DP: 'DP',
            ___PVDB_P_AC_Het: 'ヘテロ接合体遺伝子型におけるAC',
            ___PVDB_P_AC_Hom: 'ホモ接合体遺伝子型におけるAC',
            ___PVDB_P_AC_Hemi: 'ヘミ接合体遺伝子型におけるAC',
            ___PVDB_S_FILTER: 'フィルター',
            ___PVDB_S_F_MISSING: '欠損率',
            ___PVDB_S_AC: 'AC',
            ___PVDB_S_AN: 'AN',
            ___PVDB_S_AF: 'AF',
            ___PVDB_S_DP: 'DP',
            ___PVDB_S_AC_Het: 'ヘテロ接合体遺伝子型におけるAC',
            ___PVDB_S_AC_Hom: 'ホモ接合体遺伝子型におけるAC',
            ___PVDB_S_AC_Hemi: 'ヘミ接合体遺伝子型におけるAC',
            ___PVDB_A_FILTER: 'フィルター',
            ___PVDB_A_F_MISSING: '欠損率',
            ___PVDB_A_AC: 'AC',
            ___PVDB_A_AN: 'AN',
            ___PVDB_A_AF: 'AF',
            ___PVDB_A_DP: 'DP',
            ___PVDB_A_AC_Het: 'ヘテロ接合体遺伝子型におけるAC',
            ___PVDB_A_AC_Hom: 'ホモ接合体遺伝子型におけるAC',
            ___PVDB_A_AC_Hemi: 'ヘミ接合体遺伝子型におけるAC',
            ___ESP6500_AF: 'ESP6500 AF',
            ___ESP6500_AA_AF: 'ESP6500 AA',
            ___ESP6500_EA_AF: 'ESP6500 EA',
            ___TW_AF: 'Taiwan Biobank AF',
            ___TOPMED_AF: 'TOPMed AF',
            ___UK10K_AF: 'UK10K AF',
            ___ChinaMAP_AF: 'ChinaMAP AF',
            ___GA_AF: 'GenomeAsia 100K AF',
            ___KJ_AF: '4.7KJPN AF',
            ___ExAC_AF: 'ExAC AF',
            ___tommo_60kjpn_AF: 'ToMMo 60KJPN AF',
            ___tommo_60kjpn_AN: 'ToMMo 60KJPN AN',
            ___gnomAD_cov_MEAN: '平均値',
            ___gnomAD_cov_MEDIAN: '中央値',
            ___gnomAD_cov_PCT_20X: '>20xカバレッジ率(%)',
            ___gnomAD_g_cov_MEAN: '平均値',
            ___gnomAD_g_cov_MEDIAN: '中央値',
            ___gnomAD_g_cov_PCT_20X: '>20xカバレッジ率(%)',
            ___ESM1b: 'ESMb1',
            ___ESM1b_pred: 'ESMb1予測',
            ___VARITY_ER_LOO: 'VARITY ER LOO',
            ___VARITY_ER_LOO_pred: 'VARITY ER LOO予測',
            ___VARITY_R_LOO: 'VARITY R LOO',
            ___VARITY_R_LOO_pred: 'VARITY R LOO予測',
            ___VARITY_ER: 'VARITY ER',
            ___VARITY_ER_pred: 'VARITY ER予測',
            ___VARITY_R: 'VARITY R',
            ___VARITY_R_pred: 'VARITY R予測',
            ___Alphamissense_score: 'Alphamissenseスコア',
            ___Alphamissense_class: 'Alphamissense class',
            ___SIFT4G_score: 'SIFT4Gスコア',
            ___SIFT4G_pred: 'SIFT4G予測',
            ___Polyphen: 'Polyphen-2 HDIV',
            ___Polyphen_pred: 'Polyphen-2 HDIV予測',
            ___FATHMM_score: 'FATHMMスコア',
            ___FATHMM_pred: 'FATHMM予測',
            ___PROVEAN_score: 'PROVEANスコア',
            ___PROVEAN_pred: 'PROVEAN予測',
            ___CADD_phred: 'CADD phred',
            ___CADD_phred_pred: 'CADD phred予測',
            ___MetaLR_score: 'MetaLRスコア',
            ___MetaLR_pred: 'MetaLR予測',
            ___MetaSVM_score: 'MetaSVMスコア',
            ___MetaSVM_pred: 'MetaSVM予測',
            ___REVEL_score: 'REVELスコア',
            ___REVEL_pred: 'REVEL予測',
            ___BayesDel_noAF_score: 'BayesDel noAFスコア',
            ___BayesDel_noAF_pred: 'BayesDel noAF予測',
            ___gnomAD_g_mt_mitotip_score: 'MitoTipスコア',
            ___gnomAD_g_mt_mitotip_score_pred: 'MitoTip予測',
            ___ada_score: 'adaスコア',
            ___ada_pred: 'ada予測',
            ___rf_score: 'rfスコア',
            ___rf_pred: 'rf予測',
            ___CI_SpliceAI_DS_AG: 'CI-SpliceAI DS AG',
            ___CI_SpliceAI_DS_AL: 'CI-SpliceAI DS AL',
            ___CI_SpliceAI_DS_DG: 'CI-SpliceAI DS DG',
            ___CI_SpliceAI_DS_DL: 'CI-SpliceAI DS DL',
            ___CI_SpliceAI_DP_AG: 'CI-SpliceAI DP AG',
            ___CI_SpliceAI_DP_AL: 'CI-SpliceAI DP AL',
            ___CI_SpliceAI_DP_DG: 'CI-SpliceAI DP DG',
            ___CI_SpliceAI_DP_DL: 'CI-SpliceAI DP DL',
            ___SpliceAI: 'SpliceAI',
            ___SpliceAI_DS_AG: 'SpliceAI アクセプター・ゲイン・スコア',
            ___SpliceAI_DS_AL: 'SpliceAI アクセプター・ロス・スコア',
            ___SpliceAI_DS_DG: 'SpliceAI ドナー・ゲイン・スコア',
            ___SpliceAI_DS_DL: 'SpliceAI ドナー・ロス・スコア',
            ___SpliceAI_DP_AG: 'SpliceAI アクセプター・ゲイン・ポジション',
            ___SpliceAI_DP_AL: 'SpliceAI アクセプター・ロス・ポジション',
            ___SpliceAI_DP_DG: 'SpliceAI ドナー・ゲイン・ポジション',
            ___SpliceAI_DP_DL: 'SpliceAI ドナー・ロス・ポジション',
            ___GERPpp_NR: 'GERP++NR',
            ___GERPpp_RS: 'GERP++RS',
            ___GERPpp_RS_pred: 'GERP++RS予測',
            ___SiPhy_29way_logOdds: 'SiPhy 29way logOdds',
            ___SiPhy_29way_logOdds_pred: 'SiPhy 29way logOdds予測',
            ___SiPhy_29way_pi: 'SiPhy 29way pi',
            ___oe_syn: 'シノニマス o/e',
            ___oe_mis: 'ミスセンス o/e',
            ___oe_lof: 'pLoF o/e',
            ___syn_z: 'シノニマス z-スコア',
            ___mis_z: 'ミスセンス z-スコア',
            ___pLI: 'pLI'
          }
        },
        licenseStatusMap: {
          title: {
            ___inactive: '非アクティブ',
            ___active: '有効化済み',
            ___exceeded: '使用上限超過',
            ___expired: '期限切れ',
            ___unlimited: '無制限'
          }
        },
        licenseApiMap: {
          title: {
            ___vcf_analysis: 'VCF解析',
            ___fastq_analysis: 'FASTQ解析',
            ___report_module: 'レポートモジュール',
            ___mastermind: 'Mastermind'
          }
        }
      }
    }
  },
  // common
  COMMON: {
    button: {
      ___add: '追加',
      ___select: '選択',
      ___export: 'エクスポート',
      ___hideDeleted: '削除されたものを非表示にする',
      ___showDeleted: '削除されたものを表示する',
      ___reset: 'リセット',
      ___apply: '適用する',
      ___generate: '生成',
      ___regenerate: '再生成',
      ___createUrl: 'URLを作成',
      ___search: '検索',
      ___cancel: 'キャンセル',
      ___create: '作成',
      ___return: '戻る',
      ___update: '更新',
      ___archive: 'アーカイブ',
      ___delete: '削除',
      ___leave: '退出',
      ___shareSetting: '設定の共有',
      ___accept: '承認',
      ___addAll: 'すべて追加',
      ___save: '保存',
      ___confirm: '確認',
      ___enter: '入力',
      ___import: 'インポート',
      ___reanalysis: '再解析',
      ___vcf: 'VCF',
      ___fastq: 'fastq',
      ___ubam: 'uBAM',
      ___upload: 'アップロード',
      ___newChapter: '新しいチャプター',
      ___newCNV: '新しいSV',
      ___newWorkgroup: 'グループを作成',
      ___newConfig: '新しい構成',
      ___addMember: 'メンバーを追加',
      ___addCases: '症例を追加',
      ___addStage: '作業段階を追加',
      ___newPanel: '新しいパネル',
      ___newAnalysis: '新しい解析',
      ___analysis: '解析',
      ___submit: '提出',
      ___hideArchives: 'アーカイブを非表示にする',
      ___showArchives: 'アーカイブを表示する',
      ___active: 'アクティブ',
      ___send: '送信',
      ___ignore: '無視',
      ___login: 'ログイン',
      ___signUp: '登録',
      ___backToSearch: '検索に戻る',
      ___buyMore: '追加購入',
      ___contactUs: 'お問い合わせ',
      ___verify: '認証',
      ___change: '変更',
      ___proceed: '続行',
      ___set: '設定',
      ___retry: '再実行',
      ___stop: '停止',
      ___date: '日付',
      ___none: 'なし',
      ___yes: 'はい',
      ___no: 'いいえ',
      ___unlock: 'ロック解除'
    },
    toast: {
      ___licenseInvalid: 'ライセンスIDが無効です。',
      ___licenseExceeded: '機能の使用制限を超えました。',
      ___licenseExpired: 'ライセンスの有効期限が切れています。',
      ___noPermission: '権限がありません。',
      ___pleaseLogin: 'ログインしてください。',
      ___xhrCanNotUpload: 'Xhrはアップロードできません。',
      ___pleaseAgreeTerms: '規約に同意してください。',
      ___phenotypesAnalyzeLimit: '{amount} 個以上の表現型を解析できません。',
      ___datasetReachLimit: 'データセットが最大容量に達しました。',
      ___analysisTimeout: '解析がタイムアウトしました。担当チームに通知済みです。',
      ___wrongFiles: 'ファイルが間違っています。',
      ___getSignUrlFailed: '署名付きURLの発行に失敗しました。',
      ___addSameHPOTerm: '同じ HPO ID がすでに追加されています。',
      ___geneSymbolInvalidFormat: '遺伝子名または Entrez ID の形式が無効です。',
      ___fileTypeAlert: 'ファイル形式が無効です。{types}形式のファイルをアップロードしてください。',
      ___variantInAllChapter: 'このバリアントはすべてのチャプターに追加されました。',
      ___noPermissionToOpenDataset: 'このデータセットを表示する権限がありません。',
      ___reportUpdated: '報告書が更新されました。',
      ___tsvExportLimit: 'TSV エクスポートは最大 {amount} 件までです。',
      ___atLeastOneCardOpen: 'カードは最低1枚オープンにしてください。',
      ___noPermissionToUploadFile: 'ファイルをアップロードする権限がありません。',
      ___snvFileRequired: 'SNV ファイルは必須です。',
      ___dataShouldBePaired: 'データはペアである必要があります。ファイル数をご確認ください。',
      ___sampleFamilyAnalysis: 'このサンプルは家族分析のサンプル使用のため、一時的に保護されています。',
      ___familyMemberLimit: '選択できるメンバーは {limit} 名までです。',
      ___workgroupLimit: 'グループの最大数は{limit}であり、制限に達しました。',
      ___workgroupMemberExist: 'このメンバーはすでにグループに存在しています。',
      ___addWorkgroupMember: 'メンバーが追加されました。',
      ___editWorkgroupMember: 'メンバーが更新されました。',
      ___addWorkgroupCase: '{count}件の症例が追加されました。 | {count}件の症例が追加されました。',
      ___addWorkgroupCaseAutoShare: '{count}件の症例が追加されました。自動共有が有効になり、今後アップロードされる症例は自動的にこのワークグループに共有されます。 | {count}件の症例が追加されました。自動共有が有効になり、今後アップロードされる症例は自動的にこのワークグループに共有されます。',
      ___workgroupStageLimit: '作業段階の最大数は{limit}であり、制限に達しました。',
      ___workgroupStageExist: 'この作業段階はすでにグループに存在しています。',
      ___addWorkgroupStage: '作業段階が追加されました。',
      ___editWorkgroupStage: '作業段階が更新されました。',
      ___batchExpired: '{created} に作成されたバッチは、<span style="color:#FA3D3D">5日以上編集されていないため</span>、VCF およびサンプルシートを含むすべての記録が削除されました。新しいバッチを作成してください。',
      ___exportCaseReport: 'レポートを開くパスワードは、ご利用のアカウントのメールアドレスです。',
      ___fileUploadLimit: 'ファイルは最大{count}件までアップロードできます。',
      ___genePanelItemExist: '選択した{type}は、すでに追加されています。',
      ___mastermindLicense: 'Mastermind のライセンスをご購入いただくか、営業担当者にお問い合わせいただくことで、アノテーションの内容をご覧いただけます。'
    }
  }
});
// CONCATENATED MODULE: ./src/constants/lang/i18n.js












vue_esm["default"].use(vue_i18n_esm["a" /* default */]);

var locale = localStorage.getItem('locale') || 'tc';

var i18n = new vue_i18n_esm["a" /* default */]({
  locale: locale,
  messages: {
    arja: lang,
    trtc: tc_lang,
    trsc: sc_lang,
    trja: ja_lang,
    rtc: _report_tc_lang,
    ren: en_lang,
    rja: _report_ja_lang,
    en: lang_en_lang,
    ja: lang_ja_lang
  }
});

/* harmony default export */ var lang_i18n = __webpack_exports__["a"] = (i18n);

/***/ }),

/***/ "uu87":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE1IDE1Ij4KICA8cGF0aCBpZD0idGltZXMtc29saWQiIGQ9Ik0xMC4zNDMsODcuNWw0LjI2NC00LjI2NGExLjM0LDEuMzQsMCwwLDAsMC0xLjlsLS45NDgtLjk0OGExLjM0MSwxLjM0MSwwLDAsMC0xLjksMEw3LjUsODQuNjU3LDMuMjM2LDgwLjM5MmExLjM0MSwxLjM0MSwwLDAsMC0xLjksMGwtLjk0OC45NDhhMS4zNCwxLjM0LDAsMCwwLDAsMS45TDQuNjU3LDg3LjUuMzkyLDkxLjc2NGExLjM0MSwxLjM0MSwwLDAsMCwwLDEuOWwuOTQ4Ljk0OGExLjM0MSwxLjM0MSwwLDAsMCwxLjksMEw3LjUsOTAuMzQzbDQuMjY0LDQuMjY0YTEuMzQxLDEuMzQxLDAsMCwwLDEuOSwwbC45NDgtLjk0OGExLjM0MSwxLjM0MSwwLDAsMCwwLTEuOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTgwKSIgZmlsbD0iI2ZmNDE0ZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "uuH9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./src/components/tool/switchButton.vue + 2 modules
var switchButton = __webpack_require__("BdG8");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/customForm.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var customForm = ({
  components: {
    switchButton: switchButton["a" /* default */]
  },
  props: {
    forms: {
      type: Array,
      required: true
    },
    init: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    alerts: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    scope: {
      type: String,
      default: function _default() {
        return 'form';
      }
    },
    reading: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    displayMode: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    titleSmallInterval: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // style
    layoutType: {
      type: String,
      default: function _default() {
        return 'flex';
      }
    },
    groupCount: {
      type: Number,
      default: function _default() {
        return 4;
      }
    },
    gap: {
      type: String,
      default: function _default() {
        return '16px';
      }
    }
  },
  data: function data() {
    return {
      result: {},
      output: {},
      display: true
    };
  },

  watch: {
    'forms': function forms() {},
    'init': function init() {
      this.initialResults();
    },

    'result': {
      handler: function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
          return regenerator_default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.afterTreatment(this.result);

                case 2:
                  this.output = _context.sent;

                  this.$emit('change', this.output, this.$validator, this.errors);

                case 4:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function handler() {
          return _ref.apply(this, arguments);
        }

        return handler;
      }(),
      deep: true
    }
  },
  created: function created() {
    this.initialResults();
  },

  methods: {
    initialResults: function initialResults() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var input, initials;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.preTreatment(_this.init);

              case 2:
                input = _context2.sent;
                initials = {
                  input: '',
                  datalist: '',
                  password: '',
                  textarea: '',
                  boolean: false,
                  select: '',
                  single: '',
                  multiple: [],
                  number: '',
                  date: '',
                  time: '',
                  datetime: '',
                  file: [],
                  text: ''
                };

                _this.result = _this.forms.reduce(function (s, c) {
                  return extends_default()({}, s, c.value ? defineProperty_default()({}, c.value, input[c.value] !== null && input[c.value] !== undefined ? input[c.value] : initials[c.type]) : {});
                }, {});

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    preTreatment: function preTreatment(init) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var input, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, form;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                input = {};
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 4;
                _iterator = get_iterator_default()(_this2.forms);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context4.next = 16;
                  break;
                }

                form = _step.value;
                _context4.t0 = form.value;

                if (!_context4.t0) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 12;
                return (form.inputFormat || function () {
                  var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(x) {
                    return regenerator_default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            return _context3.abrupt('return', x);

                          case 1:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this2);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }())(init[form.value]);

              case 12:
                input[form.value] = _context4.sent;

              case 13:
                _iteratorNormalCompletion = true;
                _context4.next = 6;
                break;

              case 16:
                _context4.next = 22;
                break;

              case 18:
                _context4.prev = 18;
                _context4.t1 = _context4['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context4.t1;

              case 22:
                _context4.prev = 22;
                _context4.prev = 23;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 25:
                _context4.prev = 25;

                if (!_didIteratorError) {
                  _context4.next = 28;
                  break;
                }

                throw _iteratorError;

              case 28:
                return _context4.finish(25);

              case 29:
                return _context4.finish(22);

              case 30:
                return _context4.abrupt('return', input);

              case 31:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2, [[4, 18, 22, 30], [23,, 25, 29]]);
      }))();
    },
    afterTreatment: function afterTreatment(result) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var output, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, form;

        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                output = {};
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context6.prev = 4;
                _iterator2 = get_iterator_default()(_this3.forms);

              case 6:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context6.next = 16;
                  break;
                }

                form = _step2.value;
                _context6.t0 = form.value;

                if (!_context6.t0) {
                  _context6.next = 13;
                  break;
                }

                _context6.next = 12;
                return (form.outputFormat || function () {
                  var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(x) {
                    return regenerator_default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            return _context5.abrupt('return', x);

                          case 1:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this3);
                  }));

                  return function (_x2) {
                    return _ref4.apply(this, arguments);
                  };
                }())(result[form.value]);

              case 12:
                output[form.value] = _context6.sent;

              case 13:
                _iteratorNormalCompletion2 = true;
                _context6.next = 6;
                break;

              case 16:
                _context6.next = 22;
                break;

              case 18:
                _context6.prev = 18;
                _context6.t1 = _context6['catch'](4);
                _didIteratorError2 = true;
                _iteratorError2 = _context6.t1;

              case 22:
                _context6.prev = 22;
                _context6.prev = 23;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 25:
                _context6.prev = 25;

                if (!_didIteratorError2) {
                  _context6.next = 28;
                  break;
                }

                throw _iteratorError2;

              case 28:
                return _context6.finish(25);

              case 29:
                return _context6.finish(22);

              case 30:
                return _context6.abrupt('return', output);

              case 31:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this3, [[4, 18, 22, 30], [23,, 25, 29]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74a8b690","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/customForm.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{ small: _vm.titleSmallInterval, 'row-block': _vm.layoutType === 'flex' }, _vm.layoutType],style:({
    flex: {
      gap: _vm.gap
    },
    grid: {
      gridTemplateColumns: (new Array(_vm.groupCount)).fill('').map(function () { return '1fr'; }).join(' '),
      gridGap: _vm.gap
    }
  }[_vm.layoutType]),attrs:{"id":"custom-form-container"}},_vm._l((_vm.forms.filter(function (form) { return form.display ? form.display(_vm.result) : true; })),function(form,index){return _c('div',{key:index,staticClass:"form-group",class:{
      disabled: (form.disabled || (function () { return false; }))(_vm.result),
      reading: _vm.reading,
      'display-mode': _vm.displayMode || form.displayMode
    },style:({
      flex: form.width ? { flexBasis: form.width } : { flex: form.flex || 1 },
      grid: form.grid ? { gridColumn: 'span ' + form.grid } : {}
    }[_vm.layoutType])},[_c('div',[(_vm.display)?_c('form',{attrs:{"data-vv-scope":_vm.scope}},[(form.type || form.title)?_c('div',[(form.title)?_c('div',{staticClass:"label"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(form.title))]),_vm._v(" "),(form.validate && form.validate.includes('required') && form.title !== '　')?_c('span',{staticClass:"required"},[_vm._v(_vm._s((form.requiredMsg || (function () { return '*'; }))(form)))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"description"},[_vm._v(_vm._s(form.description))]),_vm._v(" "),_c('span',{staticClass:"invisible"},[_vm._v(_vm._s(form.invisible))])]):_vm._e(),_vm._v(" "),(form.type && _vm.result[form.value] !== undefined)?_c('div',{staticClass:"options",class:[
              form.type,
              {
                error: _vm.alerts[form.value] || _vm.errors.has(_vm.scope + '.' + form.value) || form.error,
                hidden: form.hidden === true,
                'value-hidden': form.hidden === 'value'
              }
            ],style:(form.optionWidth ? { width: form.optionWidth, flex: 1 } : { flex: 1 })},[(form.type === 'input')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"text","id":form.value,"name":form.value,"tabindex":form.tabindex,"disabled":(form.disabled || (function () { return false; }))(_vm.result) || form.inputDisabled,"placeholder":(form.placeholder || (function () { return ''; }))(form),"autocomplete":form.autocomplete || 'on'},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:_vm._e(),_vm._v(" "),(form.type === 'datalist')?[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"text","id":form.value,"name":form.value,"list":form.value + '-list',"tabindex":form.tabindex,"disabled":(form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}}),_vm._v(" "),_c('datalist',{attrs:{"id":form.value + '-list'}},_vm._l((form.lists),function(option,index){return _c('option',{key:index,domProps:{"value":option}})}),0)])]:_vm._e(),_vm._v(" "),(form.type === 'password')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group",class:{ hidden: form.hidden === true, valueHidden: form.hidden === 'value' }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"password","id":form.value,"name":form.value,"tabindex":form.tabindex,"disabled":(form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form),"autocomplete":form.autocomplete || 'on'},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:_vm._e(),_vm._v(" "),(form.type === 'textarea')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"id":form.value,"name":form.value,"tabindex":form.tabindex,"rows":form.row,"disabled":(form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:_vm._e(),_vm._v(" "),(form.type === 'select')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],style:(_vm.result[form.value] ? {} : { color: '#A9A9A9' }),attrs:{"id":form.value,"name":form.value,"tabindex":form.tabindex,"disabled":(form.disabled || (function () { return false; }))(_vm.result)},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.result, form.value, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(form.placeholder)?_c('option',{attrs:{"value":"","disabled":""}},[_vm._v(_vm._s(form.placeholder(form)))]):_vm._e(),_vm._v(" "),_vm._l((form.options),function(option,index){return _c('option',{key:index,style:({ color: '#333333' }),attrs:{"disabled":option.disabled},domProps:{"value":option.value || ''}},[_vm._v(_vm._s(option.title))])})],2),_vm._v(" "),_c('div',{staticClass:"cover"},[_vm._t(form.value + '_cover',null,{data:_vm.result,result:_vm.result[form.value],output:_vm.output[form.value],form:form})],2)])]:(form.type === 'boolean')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('switchButton',{attrs:{"disabled":(form.disabled || (function () { return false; }))(_vm.result),"checked":_vm.result[form.value]},on:{"input":function (c) { return _vm.result[form.value] = c; }}})],1)]:(form.type === 'single')?_vm._l((form.options),function(option,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],key:index},[_c('label',{class:{ diabled: (form.disabled || (function () { return false; }))(_vm.result) },attrs:{"for":form.value + '-' + option.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"radio","id":form.value + '-' + option.value,"name":form.value,"disabled":(form.disabled || (function () { return false; }))(_vm.result)},domProps:{"value":option.value,"checked":_vm._q(_vm.result[form.value],option.value)},on:{"change":function($event){_vm.$set(_vm.result, form.value, option.value)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(option.title))])])])}):(form.type === 'multiple')?_vm._l((form.options),function(option,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],key:index},[_c('label',{class:{ diabled: (form.disabled || (function () { return false; }))(_vm.result) || form.range && ((form.range[0] === (_vm.result[form.value] || []).length && _vm.result[form.value].includes(option.value)) || (form.range[1] === (_vm.result[form.value] || []).length && !_vm.result[form.value].includes(option.value))) },attrs:{"for":form.value + '-' + option.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"checkbox","id":form.value + '-' + option.value,"name":form.value,"disabled":(form.disabled || (function () { return false; }))(_vm.result) || (form.range && ((form.range[0] === (_vm.result[form.value] || []).length && _vm.result[form.value].includes(option.value)) || (form.range[1] === (_vm.result[form.value] || []).length && !_vm.result[form.value].includes(option.value))))},domProps:{"value":option.value,"checked":Array.isArray(_vm.result[form.value])?_vm._i(_vm.result[form.value],option.value)>-1:(_vm.result[form.value])},on:{"change":function($event){var $$a=_vm.result[form.value],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=option.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.result, form.value, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.result, form.value, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.result, form.value, $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(option.title))])])])}):(form.type === 'number')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],style:(form.inputWidth ? { width: form.inputWidth } : {}),attrs:{"type":"number","id":form.value,"name":form.value,"tabindex":form.tabindex,"step":form.step,"min":form.range ? form.range[0] : null,"max":form.range ? form.range[1] : null,"disabled":(form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:(form.type === 'date')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],style:(_vm.result[form.value] ? {} : { color: '#777777' }),attrs:{"type":"date","id":form.value,"name":form.value,"tabindex":form.tabindex,"min":form.range ? form.range[0] : null,"max":form.range ? form.range[1] : '9999-12-31',"disabled":(form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:(form.type === 'time')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],style:(_vm.result[form.value] ? {} : { color: '#777777' }),attrs:{"type":"time","id":form.value,"name":form.value,"tabindex":form.tabindex,"step":form.step,"min":form.range ? form.range[0] : null,"max":form.range ? form.range[1] : null,"disabled":(form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:(form.type === 'datetime')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],style:(_vm.result[form.value] ? {} : { color: '#777777' }),attrs:{"type":"datetime-local","id":form.value,"name":form.value,"tabindex":form.tabindex,"step":form.step,"min":form.range ? form.range[0] : null,"max":form.range ? form.range[1] : null,"disabled":(form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:(form.type === 'file')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}]},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"file","id":form.value,"name":form.value,"multiple":form.multiple,"accept":form.accept,"disabled":(form.disabled || (function () { return false; }))(_vm.result)},on:{"change":function (e) { return e.target.files.length ? Array.from(e.target.files) : []; }}}),_vm._v(" "),_c('button',{attrs:{"tabindex":form.tabindex}},[_c('span',[_vm._v(_vm._s(form.text || 'select'))]),_vm._v(" "),_c('label',{class:{ diabled: (form.disabled || (function () { return false; }))(_vm.result) },attrs:{"for":form.value}})]),_vm._v(" "),(!_vm.$scopedSlots[form.value])?_vm._l((_vm.result[form.value] || []),function(file,index){return _c('div',{key:index},[_c('span',[_vm._v(_vm._s(file.name))])])}):_vm._e()],2)]:(form.type === 'text')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('span',{class:{ noWrap: !form.wrap },style:(form.style || {}),attrs:{"title":_vm.result[form.value]},domProps:{"innerHTML":_vm._s((form.textDisplay || (function (x) { return x; }))(_vm.result[form.value]) || '--')}})])]:_vm._e(),_vm._v(" "),(_vm.alerts[form.value] || _vm.errors.has(_vm.scope + '.' + form.value) || form.error)?_c('div',{class:(_vm.alerts[form.value] || { type: 'error' }).type,style:(form.inputWidth ? { left: (form.inputWidth.replace('px', '') - 25) + 'px' } : {})},[_c('div',[_c('img',{attrs:{"src":{
                    error: __webpack_require__("uu87"),
                    success: __webpack_require__("Lkm/")
                  }[(_vm.alerts[form.value] || { type: 'error' }).type]}}),_vm._v(" "),(!_vm.alerts[form.value] || _vm.alerts[form.value].msg)?_c('div',{staticClass:"menu-container"},[_c('div',{staticClass:"menu-block default-shadow"},[(_vm.alerts[form.value])?_c('span',[_vm._v(_vm._s(_vm.alerts[form.value].msg))]):(_vm.errors.has(_vm.scope + '.' + form.value) || form.error)?_c('span',[_vm._v(_vm._s((form.alert || (function () { return null; }))(form, _vm.errors.first(_vm.scope + '.' + form.value)) || (_vm.errors.first(_vm.scope + '.' + form.value) || form.error).replace(form.value, form.errorTitle || form.title)))]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"cursor-bor-cor"}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-top"}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-left"}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-right"}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor"})]):_vm._e()])]):_vm._e()],2):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$scopedSlots[form.value])?_c('div',{staticClass:"custom",class:{ 'main-custom': !form.type && !form.title }},[_vm._t(form.value,null,{data:_vm.result,result:_vm.result[form.value],output:_vm.output[form.value],form:form})],2):_vm._e()]):_vm._e()])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_customForm = (esExports);
// CONCATENATED MODULE: ./src/components/tool/customForm.vue
function injectStyle (ssrContext) {
  __webpack_require__("RRJv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  customForm,
  tool_customForm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_customForm = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vNtb":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzgyNzciIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDgyNzciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5MTgyIDM4NzkpIj4KICAgIDxyZWN0IGlkPSLplbfmlrnlvaJfMzA2NCIgZGF0YS1uYW1lPSLplbfmlrnlvaIgMzA2NCIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTE4MiAtMzg3OSkiIGZpbGw9IiNmZmZjZjUiIG9wYWNpdHk9IjAuOTk5Ii8+CiAgICA8ZyBpZD0iR3JvdXBfMjIxMC0yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTkxNjkgLTM4NzIpIj4KICAgICAgPHBhdGggaWQ9IlBhdGhfNDUwIiBkPSJNMjE0LjM1OSwzNS4xNjFWMzMuNTcyYTYuMTQxLDYuMTQxLDAsMCwwLTMuNjExLTUuNDE3LDE3LDE3LDAsMCwwLTMuMTc4LTEuMjI4LDkuMDQ0LDkuMDQ0LDAsMCwxLTIuODg5LTEuNDQ0LDMuNTcxLDMuNTcxLDAsMCwxLTEuMy0yLjc0NFYxNS4zSDIwMXYyLjY3MmgwdjQuNTVhNS45MzIsNS45MzIsMCwwLDAsMi40NTUsNC45ODMsMTEuNDIzLDExLjQyMywwLDAsMCwzLjM5NCwxLjY2MSwxNy41OTQsMTcuNTk0LDAsMCwxLDMuMTc4LDEuMzcyLDMuNzYzLDMuNzYzLDAsMCwxLDEuODc4LDMuNDY3Yy0uMDcyLDEuNTg5LDAsMy4yNSwwLDQuOTExdjIuMTY3aDIuNDU1VjM1LjE2MVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMDAuOTY5IC0xNS4wODMpIiBmaWxsPSIjNDc0NjQ1Ii8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzQ1MSIgZD0iTTIwNC4wMjIsMzcuMDkxYTEuMjQ3LDEuMjQ3LDAsMCwwLTEuNzMzLjE0NCw0LjgsNC44LDAsMCwwLTEuMjI4LDIuMzExLDYuNDEzLDYuNDEzLDAsMCwwLS4wNzIsMS42NjFoMHY1Ljg1aDIuNDU1VjQwLjdhMi43NzQsMi43NzQsMCwwLDEsLjY1LTEuODA2LDEuMjI0LDEuMjI0LDAsMCwwLDAtMS42NjFDMjA0LjA5NCwzNy4xNjMsMjA0LjA5NCwzNy4wOTEsMjA0LjAyMiwzNy4wOTFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjAwLjk1OSAtMjEuMDU3KSIgZmlsbD0iIzQ3NDY0NSIvPgogICAgICA8ZyBpZD0iR3JvdXBfMjIwNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy43ODkgMCkiPgogICAgICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMTE5IiBjeD0iMS4yMjgiIGN5PSIxLjIyOCIgcj0iMS4yMjgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcuNTExIDApIiBmaWxsPSIjMDAzNjc5Ii8+CiAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xMzY0IiB3aWR0aD0iNy42NTUiIGhlaWdodD0iMC4zNjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMS4wMTEpIiBmaWxsPSIjMDAzNjc5Ii8+CiAgICAgIDwvZz4KICAgICAgPGcgaWQ9Ikdyb3VwXzIyMDciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUuNDMxIDMuOTI5KSI+CiAgICAgICAgPHBhdGggaWQ9IlBhdGhfNDUyIiBkPSJNMTAuMDU1LDEuMjI4YTEuMjI4LDEuMjI4LDAsMSwxLTIuNDU1LDBBMS4yMTcsMS4yMTcsMCwwLDEsOC44MjgsMCwxLjI2NiwxLjI2NiwwLDAsMSwxMC4wNTUsMS4yMjhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi4xMTEpIiBmaWxsPSIjZmEzZDNkIi8+CiAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xMzY1IiB3aWR0aD0iNS43MDUiIGhlaWdodD0iMC4zNjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMS4wMTEpIiBmaWxsPSIjZmEzZDNkIi8+CiAgICAgIDwvZz4KICAgICAgPGcgaWQ9Ikdyb3VwXzIyMDgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcuNDE1IDguMDI2KSI+CiAgICAgICAgPGNpcmNsZSBpZD0iRWxsaXBzZV8xMjAiIGN4PSIxLjIyOCIgY3k9IjEuMjI4IiByPSIxLjIyOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi42NzIgMCkiIGZpbGw9IiNmOGM2MDAiLz4KICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzEzNjYiIHdpZHRoPSIyLjg4OSIgaGVpZ2h0PSIwLjM2MSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxLjAxMSkiIGZpbGw9IiNmOGM2MDAiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "vOTy":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "wlFF":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi41IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMTYuNSAyNCI+CiAgPHBhdGggaWQ9ImxpZ2h0YnVsYi1saWdodCIgZD0iTTI5LjgsMTIuMWE2Ljc1LDYuNzUsMCwxLDAtMTEuMDkxLDBjLjE5Mi4yNzcuNDEzLjU3Ny42MzguODkxaDBhMjYuMDEzLDI2LjAxMywwLDAsMSwxLjc4MSwyLjY3N0E2Ljk3Niw2Ljk3NiwwLDAsMSwyMS44ODMsMThIMjAuMzU5YTUuMzc1LDUuMzc1LDAsMCwwLS41NTMtMS42MTcsMjMuMjM1LDIzLjIzNSwwLDAsMC0xLjYxNy0yLjQyOGgwYy0uMjQ0LS4zMzMtLjQ4Ny0uNjY2LS43MjItMWE4LjI1NCw4LjI1NCwwLDEsMSwxMy41NjEsMGMtLjIzNC4zMzctLjQ3OC42Ny0uNzIyLDFoMGEyMi4yOSwyMi4yOSwwLDAsMC0xLjYxNywyLjQyOEE1LjM3NSw1LjM3NSwwLDAsMCwyOC4xMzYsMThIMjYuNjE3YTYuOTc2LDYuOTc2LDAsMCwxLC43NTktMi4zMzksMjUuMDMzLDI1LjAzMywwLDAsMSwxLjc4MS0yLjY3N2MuMjMtLjMxNC40NDUtLjYwOS42MzctLjg5MVpNMjQuMjUsNC41QTMuNzQ5LDMuNzQ5LDAsMCwwLDIwLjUsOC4yNWEuNzUuNzUsMCwxLDEtMS41LDBBNS4yNDcsNS4yNDcsMCwwLDEsMjQuMjUsM2EuNzUuNzUsMCwxLDEsMCwxLjVaTTIyLjEyNywyMWEyLjI1MywyLjI1MywwLDAsMCw0LjI0NywwWk0yMC41LDIwLjI1VjIwYS41LjUsMCwwLDEsLjUtLjVoNi41YS41LjUsMCwwLDEsLjUuNXYuMjQ4YTMuNzUsMy43NSwwLDAsMS03LjUsMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNikiIGZpbGw9IiMwMDM2NzkiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "wtkH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIj4KICA8cGF0aCBpZD0iZXh0ZXJuYWwtbGluay1yZWd1bGFyIiBkPSJNMTEuNjYzLDAsNy44MzcsMEEuMzM3LjMzNywwLDAsMCw3LjUuMzQxdi43ODFhLjMzOC4zMzgsMCwwLDAsLjM0NC4zMzhMOS41NywxLjRsLjA0OC4wNDhMMy4wODIsNy45OGEuMjgxLjI4MSwwLDAsMCwwLC40bC41MzkuNTM5YS4yODEuMjgxLDAsMCwwLC40LDBsNi41MzYtNi41MzYuMDQ4LjA0OEwxMC41NCw0LjE1NmEuMzM4LjMzOCwwLDAsMCwuMzM3LjM0NGguNzgxQS4zMzcuMzM3LDAsMCwwLDEyLDQuMTYzTDEyLC4zMzdBLjMzNy4zMzcsMCwwLDAsMTEuNjYzLDBaTTEwLjEyNSw2Ljc1SDkuNzVhLjM3NS4zNzUsMCwwLDAtLjM3NS4zNzV2My42MDlhLjE0MS4xNDEsMCwwLDEtLjE0MS4xNDFIMS4yNjZhLjE0MS4xNDEsMCwwLDEtLjE0MS0uMTQxVjIuNzY2YS4xNDEuMTQxLDAsMCwxLC4xNDEtLjE0MUg0Ljg3NUEuMzc1LjM3NSwwLDAsMCw1LjI1LDIuMjVWMS44NzVBLjM3NS4zNzUsMCwwLDAsNC44NzUsMS41SDEuMTI1QTEuMTI1LDEuMTI1LDAsMCwwLDAsMi42MjV2OC4yNUExLjEyNSwxLjEyNSwwLDAsMCwxLjEyNSwxMmg4LjI1QTEuMTI1LDEuMTI1LDAsMCwwLDEwLjUsMTAuODc1VjcuMTI1QS4zNzUuMzc1LDAsMCwwLDEwLjEyNSw2Ljc1WiIgZmlsbD0iIzAwNmVkNiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "x2hU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return windowConfirm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return defaultEmptyDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return pageDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return projectState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return jobState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return parseUserSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return priceMap; });
/* unused harmony export impactMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return consequenceColorMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return chromMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return versionDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return caseDataTypeMetadatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return caseDataTagOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return predictionMetaDataDisplayTitles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return predictionMetaDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return omimPhenotypeIDList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getGeneEntriesConditionData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getPhenotypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getOrphaPhenotypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getSTRPhenotypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getRegionPhenotypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getRegionOrphaPhenotypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getClinvarACMGMapDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getClinvarStatisticData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clinvarACMGMap; });
/* unused harmony export repeatClassificationMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getGTType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return reportGTMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return reportEnGTMap; });
/* unused harmony export reportClinvarACMGZHMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return reportCNVTypeMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return reportSVTypeMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return reportParentalOriginMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return acmgMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return reportPreviewRangeData; });
/* unused harmony export reportPreviewDefaultDatas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getReportPreviewColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return reportPreviewOptions; });
/* unused harmony export reportPreviewTypeMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return datasetStatusMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return datasetPermissionTypeMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return datasetPermissionMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return datasetInvitationPermissionMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return datasetPipelineMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return datasetShareAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return familyRelationOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return svClinvarOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return svDECIPHEROptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return svDosageSensitivityOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return svGenotypeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return svTypeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return strClassificationMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return intractableDiseaseDifficutyMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return intractableDiseaseMethodMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return intractableDiseaseOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return workgroupRoleOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return licenseApiMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return licenseStatusMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__("j9i1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__("Cduz");











var windowConfirm = {
  default: 'CONSTANT.global.data.windowConfirm.___default'
};

var defaultEmptyDisplay = {
  empty: 'CONSTANT.global.data.defaultEmptyDisplay.___empty',
  noKey: 'CONSTANT.global.data.defaultEmptyDisplay.___noKey'
};

var pageDisplay = {
  item: 'CONSTANT.global.data.pageDisplay.___item',
  display: 'CONSTANT.global.data.pageDisplay.___display',
  jump: 'CONSTANT.global.data.pageDisplay.___jump',
  page: 'CONSTANT.global.data.pageDisplay.___page'
};

var projectState = {
  created: 'CONSTANT.global.data.projectState.___created',
  uploading: 'CONSTANT.global.data.projectState.___uploading',
  analyzing: 'CONSTANT.global.data.projectState.___analyzing',
  started: 'CONSTANT.global.data.projectState.___analyzing',
  completed: 'CONSTANT.global.data.projectState.___completed',
  failed: 'CONSTANT.global.data.projectState.___failed',
  no_affected: 'CONSTANT.global.data.projectState.___noAffected'
};

var jobState = {
  running: 'CONSTANT.global.data.jobState.___running',
  default: 'CONSTANT.global.data.jobState.___default'
};

var parseUserSetting = function parseUserSetting(setting) {
  var userColumns = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(setting.report_preview_af_columns || []));
  var previewColumnMap = ['pd', 'ps'].reduce(function (map, key) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, map, reportPreviewOptions[key].filter(function (option) {
      return !option.old;
    }).reduce(function (map, option) {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, map, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, option.key, true));
    }, {}));
  }, {});
  userColumns = userColumns.filter(function (column) {
    return previewColumnMap[column];
  });
  return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, setting, {
    report_preview_af_columns: userColumns
  });
};

var priceMap = {
  'vcf': {
    price: 59
  },
  'fastq': {
    price: 99
  },
  'ubam': {
    price: -1
  }
};

var impactMap = {
  'HIGH': {
    color: '#FA3D3D',
    font: 'white'
  },
  'MODERATE': {
    color: '#F8C600',
    font: '#333333'
  },
  'LOW': {
    color: '#83C91E',
    font: '#333333'
  },
  'MODIFIER': {
    color: '#006ED6',
    font: 'white'
  },
  'N/A': {
    color: '#AAAAAA',
    font: 'white'
  }
};

var consequenceColorMap = {
  'red': {
    color: '#FA3D3D',
    font: 'white'
  },
  'yellow': {
    color: '#F8C600',
    font: '#333333'
  },
  'green': {
    color: '#83C91E',
    font: '#333333'
  },
  'blue': {
    color: '#006ED6',
    font: 'white'
  },
  'black': {
    color: '#AAAAAA',
    font: 'white'
  }
};

var chromMap = {
  'chr1': {
    title: '1'
  },
  'chr2': {
    title: '2'
  },
  'chr3': {
    title: '3'
  },
  'chr4': {
    title: '4'
  },
  'chr5': {
    title: '5'
  },
  'chr6': {
    title: '6'
  },
  'chr7': {
    title: '7'
  },
  'chr8': {
    title: '8'
  },
  'chr9': {
    title: '9'
  },
  'chr10': {
    title: '10'
  },
  'chr11': {
    title: '11'
  },
  'chr12': {
    title: '12'
  },
  'chr13': {
    title: '13'
  },
  'chr14': {
    title: '14'
  },
  'chr15': {
    title: '15'
  },
  'chr16': {
    title: '16'
  },
  'chr17': {
    title: '17'
  },
  'chr18': {
    title: '18'
  },
  'chr19': {
    title: '19'
  },
  'chr20': {
    title: '20'
  },
  'chr21': {
    title: '21'
  },
  'chr22': {
    title: '22'
  },
  'chrX': {
    title: 'X'
  },
  'chrY': {
    title: 'Y'
  },
  'chrM': {
    title: 'M'
  }
};

var versionDatas = {
  'pipeline': [{
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Hardware_Accelerated_Pipeline',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___DRAGEN',
    version: 'DRAGEN',
    systemVersion: 'DRAGEN'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___GPU_Accelerated_Pipeline_Wrapper',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Parabrick_pbrun',
    version: 'Parabrick pbrun',
    systemVersion: 'pbrun'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Read_Aligner_GPU_Accelerated',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Parabrick_BWA_mem',
    version: 'Parabrick BWA mem',
    systemVersion: 'BWA mem'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Read_Aligner_GPU_Accelerated',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Parabricks_Minimap2',
    version: 'Parabricks Minimap2',
    systemVersion: 'Parabricks Minimap2'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Read_Aligner',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Minimap2',
    version: 'Minimap2',
    systemVersion: 'Minimap2'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Variant_Caller_GPU_Accelerated',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Parabrick_deepvariant',
    version: 'Parabrick deepvariant',
    systemVersion: 'DeepVariant'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Variant_Caller_Mitochondria',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Mitorsaw',
    version: 'MitorSaw',
    systemVersion: 'Mitorsaw'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Variant_Caller_Mitochondria',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___GATK',
    version: 'GATK',
    systemVersion: 'GATK'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Variant_Phasing_Tool',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___WhatsHap',
    version: 'WhatsHap',
    systemVersion: 'WhatsHap'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Variant_Phasing_Tool',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Hiphase',
    version: 'HiPhase',
    systemVersion: 'Hiphase'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Structural_Variant_Caller',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Manta',
    version: 'Manta',
    systemVersion: 'Manta'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Structural_Variant_Caller',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___CuteSV',
    version: 'cuteSV',
    systemVersion: 'CuteSV'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Structural_Variant_Caller',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Sawfish',
    version: 'Sawfish',
    systemVersion: 'Sawfish'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Structural_Variant_Caller',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___MitoSAlt',
    version: 'MitoSAlt',
    systemVersion: 'MitoSAlt'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Structural_Variant_Caller',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Sniffles',
    version: 'Sniffles',
    systemVersion: 'Sniffles'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___CNV_Caller_Exome_Based',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___ExomeDepth',
    version: 'ExomeDepth',
    systemVersion: 'ExomeDepth'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___CNV_Caller_Control_Dataset',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___ExomeDepth_Baseline',
    version: 'ExomeDepth Baseline',
    systemVersion: 'ExomeDepth Baseline',
    display: ['case']
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___CNV_Caller_WGS',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___CNVpytor',
    version: 'CNVpytor',
    systemVersion: 'CNVpytor'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Repeat_Expansion_Caller',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___ExpansionHunter',
    version: 'ExpansionHunter',
    systemVersion: 'ExpansionHunter'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Repeat_Expansion_Caller',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___TRGT',
    version: 'TRGT',
    systemVersion: 'TRGT'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Repeat_Expansion_Caller',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Straglr',
    version: 'straglr',
    systemVersion: 'Straglr'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___HLA_Aligner',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___HISAT2',
    version: 'HISAT2',
    systemVersion: 'HISAT2'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___HLA_Genotyper',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___HISAT_genotype',
    version: 'HISAT-genotype',
    systemVersion: 'HISAT-Genotype'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Methylation_Caller',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Methbat',
    version: 'MethBat',
    systemVersion: 'Methbat'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Methylation_Caller',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Modkit',
    version: 'Modkit',
    systemVersion: 'Modkit'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Pharmacogenomics_Tools',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___PharmCAT',
    version: 'PharmCAT',
    systemVersion: 'PharmCAT'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Pharmacogenomics_Tools',
    name: 'DIALOG.caseAnalysisVersion.tableData.pipeline.name.___pb_StarPhase',
    version: 'StarPhase',
    systemVersion: 'pb-StarPhase'
  }],
  'analysis': [{
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Variant_Annotation_Tools',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___Jannovar',
    version: 'Jannovar',
    systemVersion: 'Jannovar'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Variant_Annotation_Tools',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___VEP',
    version: 'VEP',
    systemVersion: 'VEP'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Variant_Annotation_Tools',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___AnnotSV',
    version: 'AnnotSV',
    systemVersion: 'AnnotSV'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Variant_Annotation_Tools_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___Jannovar_DB_Version',
    version: 'jannovar_gff',
    systemVersion: 'jannovar_gff'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Canonical_Transcript_Reference',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___MANE',
    version: 'MANE',
    systemVersion: 'MANE'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Protein_Function_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___UniProt',
    version: 'UniProt',
    systemVersion: 'UniProt'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___NCBI_RefSeq_Nucleotide_Protein_Mapping',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___Refseq_nuc_prot',
    version: 'Refseq_nuc_prot',
    systemVersion: 'Refseq_nuc_prot'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Structural_Variant_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___dbVar',
    version: 'dbVar',
    systemVersion: 'dbVar'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Structural_Variant_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___Decipher',
    version: 'Decipher',
    systemVersion: 'Decipher'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___GnomAD',
    version: 'GnomAD',
    systemVersion: 'GnomAD'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Clinical_Variant_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___ClinVar',
    version: 'ClinVar',
    systemVersion: 'ClinVar'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Clinical_Variant_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___Mastermind',
    version: 'Mastermind',
    systemVersion: 'Mastermind'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___In_Silico_Prediction_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___dbNSFP',
    version: 'dbNSFP',
    systemVersion: 'dbNSFP'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___In_Silico_Prediction_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___dbscSNV',
    version: 'dbscSNV',
    systemVersion: 'dbscSNV'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___In_Silico_Prediction_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___SpliceAI',
    version: 'SpliceAI',
    systemVersion: 'SpliceAI'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___In_Silico_Prediction_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___AlphaMissense',
    version: 'AlphaMissense',
    systemVersion: 'AlphaMissense'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___In_Silico_Prediction_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___VARITY',
    version: 'Varity',
    systemVersion: 'Varity'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___In_Silico_Prediction_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___ESM1b',
    version: 'ESM1b',
    systemVersion: 'ESM1b'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Variant_Identifier_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___dbSNP',
    version: 'dbSNP',
    systemVersion: 'dbSNP'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___ESP6500',
    version: 'ESP6500',
    systemVersion: 'ESP6500'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___ExAC',
    version: 'ExAC',
    systemVersion: 'ExAC'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___GenomeAsia_100K',
    version: 'GenomeAsia 100K',
    systemVersion: 'GenomeAsia 100K'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___gnomAD_Exomes',
    version: 'gnomAD Exomes',
    systemVersion: 'gnomAD Exomes'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___gnomAD_Exomes_Coverage',
    version: 'gnomAD Exomes Coverage',
    systemVersion: 'gnomAD Exomes Coverage'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___gnomAD_Exomes_constraint',
    version: 'gnomAD Exomes constraint',
    systemVersion: 'gnomAD Exomes constraint'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___gnomAD_Genomes',
    version: 'gnomAD Genomes',
    systemVersion: 'gnomAD Genomes'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___gnomAD_Genomes_Coverage',
    version: 'gnomAD Genomes Coverage',
    systemVersion: 'gnomAD Genomes Coverage'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___gnomAD_Genomes_mtDNA',
    version: 'gnomAD Genomes mtDNA',
    systemVersion: 'gnomAD Genomes mtDNA'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___1000_Genomes',
    version: '1000 Genomes',
    systemVersion: '1000 Genomes'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___TaiwanBioBank',
    version: 'TaiwanBioBank',
    systemVersion: 'TaiwanBioBank'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___tommo_60kjpn',
    version: 'tommo_60kjpn',
    systemVersion: 'tommo_60kjpn'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___TOPMed',
    version: 'TOPMed',
    systemVersion: 'TOPMed'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Disease_Gene_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___OMIM',
    version: 'OMIM',
    systemVersion: 'OMIM'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Disease_Gene_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___Orphanet',
    version: 'Orphanet',
    systemVersion: 'Orphanet'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Disease_Gene_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___Mondo',
    version: 'Mondo',
    systemVersion: 'Mondo'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Mitochondrial_Variant_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___MITOMAP',
    version: 'MITOMAP',
    systemVersion: 'MITOMAP'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Phenotype_Ontology_Database',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___HPO',
    version: 'HPO',
    systemVersion: 'HPO'
  }, {
    category: 'DIALOG.caseAnalysisVersion.tableData.analysis.category.___Others',
    name: 'DIALOG.caseAnalysisVersion.tableData.analysis.name.___Pathway',
    version: 'Pathway',
    systemVersion: 'Pathway'
  }]
};

var caseDataTypeMetadatas = {
  'intractable_disease': {
    sortOption: {
      key: 'Gene_Variant_score',
      order: 'desc'
    },
    tagOption: {
      groups: ['intractable_disease', 'designated_intractable_disease'],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___intractableDisease'
    },
    phenotypeFilter: function phenotypeFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {});
    },
    variantFilter: function variantFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(gene.variants || {}).filter(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            _ = _ref2[0],
            variant = _ref2[1];

        return variant.Mendelian === undefined || variant.Mendelian === mode['mendelian'];
      }).map(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 1),
            vkey = _ref4[0];

        return vkey;
      });
    }
  },
  'designated_intractable_disease': {
    sortOption: {
      key: 'Gene_Variant_score',
      order: 'desc'
    },
    tagOption: {
      groups: ['intractable_disease', 'designated_intractable_disease'],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___designatedIntractableDisease'
    },
    phenotypeFilter: function phenotypeFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {});
    },
    variantFilter: function variantFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(gene.variants || {}).filter(function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            _ = _ref6[0],
            variant = _ref6[1];

        return variant.Mendelian === undefined || variant.Mendelian === mode['mendelian'];
      }).map(function (_ref7) {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref7, 1),
            vkey = _ref8[0];

        return vkey;
      });
    }
  },
  'pgp': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: ['pgp', 'gene_filter'],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___pgp'
    },
    phenotypeFilter: function phenotypeFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {});
    },
    variantFilter: function variantFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(gene.variants || {}).filter(function (_ref9) {
        var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref9, 2),
            _ = _ref10[0],
            variant = _ref10[1];

        return variant.Mendelian === undefined || variant.Mendelian === mode['mendelian'];
      }).map(function (_ref11) {
        var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref11, 1),
            vkey = _ref12[0];

        return vkey;
      });
    }
  },
  'gene_filter': {
    sortOption: {
      key: 'Gene_Variant_score',
      order: 'desc'
    },
    tagOption: {
      groups: ['pgp', 'gene_filter'],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___gene_filter'
    },
    phenotypeFilter: function phenotypeFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {});
    },
    variantFilter: function variantFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(gene.variants || {}).filter(function (_ref13) {
        var _ref14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref13, 2),
            _ = _ref14[0],
            variant = _ref14[1];

        return variant.Mendelian === undefined || variant.Mendelian === mode['mendelian'];
      }).map(function (_ref15) {
        var _ref16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref15, 1),
            vkey = _ref16[0];

        return vkey;
      });
    }
  },
  'str': {
    sortOption: {
      key: function key(data) {
        return Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(Array.prototype.concat.apply([], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(data.variants || {}).map(function (variant) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variant.Diseases || {}).map(function (diseases) {
            return (diseases.highlight_gene || 0) - -(1 / (1 - -(diseases.allele_score || 0)));
          });
        }))));
      },
      order: 'desc'
    },
    tagOption: {
      groups: [],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___str'
    },
    phenotypeFilter: function phenotypeFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {});
    },
    variantFilter: function variantFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(gene.variants || {});
    }
  },
  'nbs_pathovar': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: ['nbs_pathovar', 'nbs_nullvar', 'nbs_carrier', 'incidental'],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___nbs_pathovar'
    },
    phenotypeFilter: function phenotypeFilter(symbol, gene, caseData, project, mode) {
      var phenotypes = (!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {};
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(phenotypes).some(function (_ref17) {
        var _ref18 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref17, 2),
            _ = _ref18[0],
            phenotype = _ref18[1];

        return phenotype.disease_score !== -1;
      }) ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(phenotypes) : null;
    },
    variantFilter: function variantFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(gene.variants || {});
    }
  },
  'nbs_nullvar': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: ['nbs_pathovar', 'nbs_nullvar', 'nbs_carrier', 'incidental'],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___nbs_nullvar'
    },
    phenotypeFilter: function phenotypeFilter(symbol, gene, caseData, project, mode) {
      var phenotypes = (!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {};
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(phenotypes).some(function (_ref19) {
        var _ref20 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref19, 2),
            _ = _ref20[0],
            phenotype = _ref20[1];

        return phenotype.disease_score !== -1;
      }) ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(phenotypes) : null;
    },
    variantFilter: function variantFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(gene.variants || {});
    }
  },
  'nbs_carrier': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: ['nbs_pathovar', 'nbs_nullvar', 'nbs_carrier', 'incidental'],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___nbs_carrier'
    },
    phenotypeFilter: function phenotypeFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {});
    },
    variantFilter: function variantFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(gene.variants || {});
    }
  },
  'incidental': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: ['nbs_pathovar', 'nbs_nullvar', 'nbs_carrier', 'incidental'],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___incidental'
    },
    phenotypeFilter: function phenotypeFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {});
    },
    variantFilter: function variantFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(gene.variants || {});
    }
  },
  'filter': {
    display: false,
    tagOption: {
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___filter'
    }
  },
  // old
  'clinvar': {
    old: true,
    tagOption: {
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___clinvar'
    }
  },
  'nbs': {
    old: true,
    tagOption: {
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___nbs'
    }
  },
  'nbs_nonmendelian': {
    old: true,
    tagOption: {
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___nbs_nonmendelian'
    }
  }
};

var caseDataTagOptions = {
  'intractable_disease': {
    background: '#FA3D3D',
    color: 'white'
  },
  'designated_intractable_disease': {
    background: '#F7D1D1',
    color: '#FA3D3D'
  },
  'pgp': {
    background: '#003679',
    color: 'white'
  },
  'gene_filter': {
    background: '#006ED6',
    color: 'white'
  },
  'nbs_pathovar': {
    background: '#B2D3F2',
    color: '#003679'
  },
  'nbs_nullvar': {
    background: '#B2D3F2',
    color: '#003679'
  },
  'nbs_nonmendelian': {
    background: '#B2D3F2',
    color: '#003679'
  },
  'nbs_carrier': {
    background: '#B2D3F2',
    color: '#003679'
  },
  'incidental': {
    background: '#B2D3F2',
    color: '#003679'
  },
  'filter': {
    background: '#B2D3F2',
    color: '#003679'
  },
  'project': {
    background: '#FF9E03',
    color: 'white'
  },
  // old
  'nbs': {
    background: '#B2D3F2',
    color: '#003679'
  }
};

var predictionMetaDataDisplayTitles = {
  Damaging: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Damaging',
  Tolerated: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Tolerated',
  ProbablyDamaging: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___ProbablyDamaging',
  PossiblyDamaging: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___PossiblyDamaging',
  Benign: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Benign',
  High: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___High',
  Medium: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Medium',
  Low: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Low',
  Neutral: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Neutral',
  Splicealtering: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Splicealtering',
  Conserved: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Conserved',
  Nonconserved: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Nonconserved',
  Likelyorpossiblypathogenic: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Likelyorpossiblypathogenic',
  Likelyorpossiblybenign: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Likelyorpossiblybenign',
  ambiguous: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Ambiguous',
  likely_benign: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Likelybenign',
  likely_pathogenic: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___LikelyPathogenic'
};

var predictionMetaDatas = {
  'ESM1b': {
    key: {
      score: 'ESM1b',
      pred: 'ESM1b_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'T': true
      }[pred];
    }
  },
  'VARITY_ER_LOO': {
    key: {
      score: 'VARITY_ER_LOO',
      pred: 'VARITY_ER_LOO_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'T': true
      }[pred];
    }
  },
  'VARITY_R_LOO': {
    key: {
      score: 'VARITY_R_LOO',
      pred: 'VARITY_R_LOO_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'T': true
      }[pred];
    }
  },
  'VARITY_ER': {
    key: {
      score: 'VARITY_ER',
      pred: 'VARITY_ER_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'T': true
      }[pred];
    }
  },
  'VARITY_R': {
    key: {
      score: 'VARITY_R',
      pred: 'VARITY_R_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'T': true
      }[pred];
    }
  },
  'Alphamissense': {
    key: {
      score: 'Alphamissense_score',
      pred: 'Alphamissense_class'
    },
    displayMap: {
      'ambiguous': predictionMetaDataDisplayTitles['ambiguous'],
      'likely_benign': predictionMetaDataDisplayTitles['likely_benign'],
      'likely_pathogenic': predictionMetaDataDisplayTitles['likely_pathogenic']
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score < 0.567 : undefined;
    }
  },
  'SIFT4G': {
    key: {
      score: 'SIFT4G_score',
      pred: 'SIFT4G_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'T': true
      }[pred];
    }
  },
  'Polyphen': {
    key: {
      score: 'Polyphen',
      pred: 'Polyphen_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['ProbablyDamaging'],
      'P': predictionMetaDataDisplayTitles['PossiblyDamaging'],
      'B': predictionMetaDataDisplayTitles['Benign']
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'P': false,
        'B': true
      }[pred];
    }
  },
  'FATHMM': {
    key: {
      score: 'FATHMM_score',
      pred: 'FATHMM_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'T': true
      }[pred];
    }
  },
  'MutationAssessor': {
    key: {
      score: 'MutationAssessor_score',
      pred: 'MutationAssessor_pred'
    },
    displayMap: {
      'H': predictionMetaDataDisplayTitles['High'],
      'M': predictionMetaDataDisplayTitles['Medium'],
      'L': predictionMetaDataDisplayTitles['Low'],
      'N': predictionMetaDataDisplayTitles['Neutral']
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'H': false,
        'M': false,
        'L': true,
        'N': true
      }[pred];
    }
  },
  'PROVEAN': {
    key: {
      score: 'PROVEAN_score',
      pred: 'PROVEAN_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'N': predictionMetaDataDisplayTitles['Neutral']
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 0.7 : undefined;
    }
  },
  'CADD_phred': {
    key: {
      score: 'CADD_phred',
      pred: 'CADD_phred_pred'
    },
    displayMap: {
      'red': predictionMetaDataDisplayTitles['Damaging'],
      'black': predictionMetaDataDisplayTitles['Neutral']
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 30 : undefined;
    }
  },
  'M_CAP': {
    key: {
      score: 'M_CAP_score',
      pred: 'M_CAP_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 0.025 : undefined;
    }
  },
  'MetaLR': {
    key: {
      score: 'MetaLR_score',
      pred: 'MetaLR_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'T': true
      }[pred];
    }
  },
  'MetaSVM': {
    key: {
      score: 'MetaSVM_score',
      pred: 'MetaSVM_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'T': true
      }[pred];
    }
  },
  'REVEL': {
    key: {
      score: 'REVEL_score',
      pred: 'REVEL_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 0.7 : undefined;
    }
  },
  'BayesDel_noAF': {
    key: {
      score: 'BayesDel_noAF_score',
      pred: 'BayesDel_noAF_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'T': true
      }[pred];
    }
  },
  'ada': {
    key: {
      score: 'ada_score',
      pred: 'ada_pred'
    },
    displayMap: {
      'red': predictionMetaDataDisplayTitles['Splicealtering'],
      'black': predictionMetaDataDisplayTitles['Neutral']
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 0.6 : undefined;
    }
  },
  'rf': {
    key: {
      score: 'rf_score',
      pred: 'rf_pred'
    },
    displayMap: {
      'red': predictionMetaDataDisplayTitles['Splicealtering'],
      'black': predictionMetaDataDisplayTitles['Neutral']
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 0.6 : undefined;
    }
  },
  'GERPpp_NR': {
    key: {
      score: 'GERPpp_NR',
      pred: 'GERPpp_NR_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'GERPpp_RS': {
    key: {
      score: 'GERPpp_RS',
      pred: 'GERPpp_RS_pred'
    },
    displayMap: {
      'red': predictionMetaDataDisplayTitles['Conserved'],
      'black': predictionMetaDataDisplayTitles['Nonconserved']
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 2 : undefined;
    }
  },
  'SiPhy_29way_logOdds': {
    key: {
      score: 'SiPhy_29way_logOdds',
      pred: 'SiPhy_29way_logOdds_pred'
    },
    displayMap: {
      'red': predictionMetaDataDisplayTitles['Conserved'],
      'black': predictionMetaDataDisplayTitles['Nonconserved']
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 12.17 : undefined;
    }
  },
  'SiPhy_29way_pi': {
    key: {
      score: 'SiPhy_29way_pi',
      pred: 'SiPhy_29way_pi_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'gnomAD_g_mt_mitotip': {
    key: {
      score: 'gnomAD_g_mt_mitotip_score',
      pred: 'gnomAD_g_mt_mitotip_score_pred'
    },
    displayMap: {
      'red': predictionMetaDataDisplayTitles['Likelyorpossiblypathogenic'],
      'black': predictionMetaDataDisplayTitles['Likelyorpossiblybenign']
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score < 12.66 : undefined;
    }
  },
  'CI_SpliceAI_DS_AG': {
    key: {
      score: 'CI_SpliceAI_DS_AG',
      pred: 'CI_SpliceAI_DS_AG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score < 0.5 : undefined;
    }
  },
  'CI_SpliceAI_DS_AL': {
    key: {
      score: 'CI_SpliceAI_DS_AL',
      pred: 'CI_SpliceAI_DS_AL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score < 0.5 : undefined;
    }
  },
  'CI_SpliceAI_DS_DG': {
    key: {
      score: 'CI_SpliceAI_DS_DG',
      pred: 'CI_SpliceAI_DS_DG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score < 0.5 : undefined;
    }
  },
  'CI_SpliceAI_DS_DL': {
    key: {
      score: 'CI_SpliceAI_DS_DL',
      pred: 'CI_SpliceAI_DS_DL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score < 0.5 : undefined;
    }
  },
  'CI_SpliceAI_DP_AG': {
    key: {
      score: 'CI_SpliceAI_DP_AG',
      pred: 'CI_SpliceAI_DP_AG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'CI_SpliceAI_DP_AL': {
    key: {
      score: 'CI_SpliceAI_DP_AL',
      pred: 'CI_SpliceAI_DP_AL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'CI_SpliceAI_DP_DG': {
    key: {
      score: 'CI_SpliceAI_DP_DG',
      pred: 'CI_SpliceAI_DP_DG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'CI_SpliceAI_DP_DL': {
    key: {
      score: 'CI_SpliceAI_DP_DL',
      pred: 'CI_SpliceAI_DP_DL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'SpliceAI_DS_AG': {
    key: {
      score: 'SpliceAI_DS_AG',
      pred: 'SpliceAI_DS_AG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score < 0.5 : undefined;
    }
  },
  'SpliceAI_DS_AL': {
    key: {
      score: 'SpliceAI_DS_AL',
      pred: 'SpliceAI_DS_AL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score < 0.5 : undefined;
    }
  },
  'SpliceAI_DS_DG': {
    key: {
      score: 'SpliceAI_DS_DG',
      pred: 'SpliceAI_DS_DG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score < 0.5 : undefined;
    }
  },
  'SpliceAI_DS_DL': {
    key: {
      score: 'SpliceAI_DS_DL',
      pred: 'SpliceAI_DS_DL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score < 0.5 : undefined;
    }
  },
  'SpliceAI_DP_AG': {
    key: {
      score: 'SpliceAI_DP_AG',
      pred: 'SpliceAI_DP_AG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'SpliceAI_DP_AL': {
    key: {
      score: 'SpliceAI_DP_AL',
      pred: 'SpliceAI_DP_AL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'SpliceAI_DP_DG': {
    key: {
      score: 'SpliceAI_DP_DG',
      pred: 'SpliceAI_DP_DG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'SpliceAI_DP_DL': {
    key: {
      score: 'SpliceAI_DP_DL',
      pred: 'SpliceAI_DP_DL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'oe_syn': {
    key: {
      score: 'oe_syn',
      pred: 'oe_syn_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'oe_mis': {
    key: {
      score: 'oe_mis',
      pred: 'oe_mis_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'oe_lof': {
    key: {
      score: 'oe_lof',
      pred: 'oe_lof_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'syn_z': {
    key: {
      score: 'syn_z',
      pred: 'syn_z_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'mis_z': {
    key: {
      score: 'mis_z',
      pred: 'mis_z_pred'
    },
    displayMap: {},
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 3.09 : undefined;
    }
  },
  'pLI': {
    key: {
      score: 'pLI',
      pred: 'pLI_pred'
    },
    displayMap: {},
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 0.9 : undefined;
    }
  }
};

var omimPhenotypeIDList = ['300100', '611788', '612098', '600376', '175100', '144010', '277900', '613881', '612954', '174900', '604370', '612555', '253260', '601887', '616247', '614916', '616249', '618782', '611938', '130050', '213700', '604765', '601419', '610476', '610193', '607450', '615821', '187300', '154700', '617047', '609524', '232300', '301500', '235200', '600496', '613688', '192500', '143890', '115200', '171300', '131100', '609310', '120435', '614350', '608456', '115197', '132900', '192600', '613426', '608758', '608751', '101000', '311250', '114480', '603776', '609040', '609909', '614337', '600858', '158350', '180200', '613172', '155240', '171400', '162300', '204100', '145600', '604772', '603830', '601144', '601154', '601650', '115310', '605373', '168000', '613795', '175050', '175200', '609192', '610168', '604400', '611879', '613690', '601494', '115195', '151623', '115196', '615441', '191100', '613254', '604145', '613794'];

var getGeneEntriesConditionData = function getGeneEntriesConditionData() {
  var condition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var types = ['disease_term', 'mondo', 'orphanet'];
  return {
    data: condition.data || Array.prototype.concat.apply([], types.map(function (type) {
      return (condition[type] || { data: [] }).data.map(function (data) {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, data, { condition_type: type });
      });
    }))
  };
};

var getPhenotypeList = function getPhenotypeList(values) {
  var phenotypes = values ? Object(__WEBPACK_IMPORTED_MODULE_9__util__["m" /* sortData */])(Array.prototype.concat.apply([], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(values).map(function (_ref21) {
    var _ref22 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref21, 2),
        id = _ref22[0],
        phenotype = _ref22[1];

    var length = !phenotype.Phenotype ? 0 : phenotype.Phenotype instanceof Array ? phenotype.Phenotype.length : 1;
    var isArray = phenotype.Phenotype instanceof Array;
    return new Array(length).fill('').map(function (_, i) {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, phenotype, {
        id: id,
        index: i,
        Orpha_id: isArray && phenotype.Orpha_id ? phenotype.Orpha_id[i] : phenotype.Orpha_id,
        Inheritance: isArray ? (phenotype.Inheritance[i] || '').split(',') : phenotype.Inheritance instanceof Array ? phenotype.Inheritance : [phenotype.Inheritance],
        Phenotype: isArray ? phenotype.Phenotype[i] : phenotype.Phenotype
      });
    });
  })), 'disease_score', 'desc') : [];
  return phenotypes;
};

var getOrphaPhenotypeList = function getOrphaPhenotypeList(values) {
  var phenotypes = values ? Object(__WEBPACK_IMPORTED_MODULE_9__util__["m" /* sortData */])(Array.prototype.concat.apply([], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(values).map(function (_ref23) {
    var _ref24 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref23, 2),
        id = _ref24[0],
        phenotype = _ref24[1];

    var length = !phenotype.disease ? 0 : phenotype.disease instanceof Array ? phenotype.disease.length : 1;
    var isArray = phenotype.disease instanceof Array;
    return new Array(length).fill('').map(function (_, i) {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, phenotype, {
        id: id,
        index: i,
        inheritance: isArray ? (phenotype.inheritance[i] || '').split(',') : phenotype.inheritance instanceof Array ? phenotype.inheritance : [phenotype.inheritance],
        disease: isArray ? phenotype.disease[i] : phenotype.disease
      });
    });
  })), 'disease_score', 'desc') : [];
  return phenotypes;
};

var getSTRPhenotypeList = function getSTRPhenotypeList(variants) {
  var phenotypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants || {}).reduce(function (phenotypes, variant) {
    var results = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(variant.Diseases || {}).map(function (_ref25) {
      var _ref26 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref25, 2),
          key = _ref26[0],
          data = _ref26[1];

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, data, { Phenotype: key, Inheritance: (data.Inheritance || '').split(',') });
    });
    return [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(phenotypes), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(results));
  }, []);
  return phenotypes;
};

var getRegionPhenotypeList = function getRegionPhenotypeList(regionData) {
  if (!regionData.Phenotype_MIM_number) return [];
  var ids = (regionData.Phenotype_MIM_number || '').split('|');
  var phenotypes = (regionData.Phenotype || '').split('|');
  var inheritances = (regionData.Inheritance || '').split('|');
  var orphaIDs = (regionData.at_orpha_id || '').split('|');
  return ids.map(function (id, i) {
    return {
      id: id,
      index: i,
      Orpha_id: orphaIDs[i],
      Inheritance: inheritances[i] ? inheritances[i].split(',') : [],
      Phenotype: phenotypes[i]
    };
  });
};

var getRegionOrphaPhenotypeList = function getRegionOrphaPhenotypeList(regionData) {
  if (!regionData.at_orpha_id && !regionData.mt_orpha_id) return [];
  var ids = (regionData.at_orpha_id || regionData.mt_orpha_id || '').split('|');
  var diseases = (regionData.orphanet_disease || '').split('|');
  var inheritances = (regionData.orphanet_inheritance || '').split('|');
  return ids.map(function (id, i) {
    return {
      id: id,
      index: i,
      inheritance: inheritances[i] ? inheritances[i].split(',') : [],
      disease: diseases[i]
    };
  });
};

var getClinvarACMGMapDatas = function getClinvarACMGMapDatas(values) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';

  var ary = values ? values.split(/,|\||\//).map(function (value) {
    return (value || 'N/A').replace(/_/g, ' ').trim();
  }) : ['N/A'];
  var map = {
    default: clinvarACMGMap,
    report: clinvarACMGMap
  }[type];
  var datas = Object(__WEBPACK_IMPORTED_MODULE_9__util__["m" /* sortData */])(ary.map(function (value) {
    return map[value] ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, map[value], {
      display_zh: reportClinvarACMGZHMap[value]
    }) : {
      display: value,
      title: value,
      color: '#AAAAAA',
      index: -1
    };
  }), function (data) {
    return data.index;
  }, 'desc');
  return datas;
};

var getClinvarStatisticData = function getClinvarStatisticData(clinvarStatistic) {
  var defaultDataGenerator = function defaultDataGenerator() {
    return {
      n: 0
    };
  };
  var tableTitles = {
    title: 'CONSTANT.global.data.getClinvarStatisticData.___title',
    Pathogenic: 'CONSTANT.global.data.getClinvarStatisticData.___Pathogenic',
    Likely_pathogenic: 'CONSTANT.global.data.getClinvarStatisticData.___Likely_pathogenic',
    Conflicting_interpretations_of_pathogenicity: 'CONSTANT.global.data.getClinvarStatisticData.___Conflicting_interpretations_of_pathogenicity',
    Uncertain_significance: 'CONSTANT.global.data.getClinvarStatisticData.___Uncertain_significance',
    Likely_benign: 'CONSTANT.global.data.getClinvarStatisticData.___Likely_benign',
    Benign: 'CONSTANT.global.data.getClinvarStatisticData.___Benign',
    stop_gained: 'CONSTANT.global.data.getClinvarStatisticData.___stop_gained',
    splice_site: 'CONSTANT.global.data.getClinvarStatisticData.___splice_site',
    frameshift: 'CONSTANT.global.data.getClinvarStatisticData.___frameshift',
    stop_lost: 'CONSTANT.global.data.getClinvarStatisticData.___stop_lost',
    start_lost: 'CONSTANT.global.data.getClinvarStatisticData.___start_lost',
    missense: 'CONSTANT.global.data.getClinvarStatisticData.___missense',
    inframe_indel: 'CONSTANT.global.data.getClinvarStatisticData.___inframe_indel',
    synonymous: 'CONSTANT.global.data.getClinvarStatisticData.___synonymous',
    non_coding: 'CONSTANT.global.data.getClinvarStatisticData.___non_coding',
    total: 'CONSTANT.global.data.getClinvarStatisticData.___total'
  };
  var defaultTableConfig = {
    'gs': {
      'title': {
        data: false,
        title: [tableTitles['title']].join(' '),
        flex: 146,
        color: '#FFFFFF'
      },
      'Pathogenic': {
        title: [tableTitles['Pathogenic']].join(' '),
        flex: 135,
        color: '#FA3D3D'
      },
      'Likely_pathogenic': {
        title: [tableTitles['Likely_pathogenic']].join(' '),
        flex: 135,
        color: '#FF9E03'
      },
      'Conflicting_interpretations_of_pathogenicity': {
        title: [tableTitles['Conflicting_interpretations_of_pathogenicity']].join(' '),
        flex: 210,
        color: '#999999'
      },
      'Uncertain_significance': {
        title: [tableTitles['Uncertain_significance']].join(' '),
        flex: 135,
        color: '#F8C600'
      },
      'Likely_benign': {
        title: [tableTitles['Likely_benign']].join(' '),
        flex: 135,
        color: '#83C91E'
      },
      'Benign': {
        title: [tableTitles['Benign']].join(' '),
        flex: 135,
        color: '#349CCF'
      },
      'total': {
        data: false,
        title: [tableTitles['total']].join(' '),
        flex: 135,
        color: '#FFFFFF'
      }
    },
    'csq': {
      'title': {
        data: false,
        title: [tableTitles['title']].join(' '),
        flex: 1,
        color: '#FFFFFF'
      },
      'stop_gained': {
        title: [tableTitles['stop_gained']].join(' '),
        flex: 1,
        color: '#FFFFFF'
      },
      'splice_site': {
        title: [tableTitles['splice_site']].join(' '),
        flex: 1,
        color: '#FFFFFF'
      },
      'frameshift': {
        title: [tableTitles['frameshift']].join(' '),
        flex: 1,
        color: '#FFFFFF'
      },
      'stop_lost': {
        title: [tableTitles['stop_lost']].join(' '),
        flex: 1,
        color: '#FFFFFF'
      },
      'start_lost': {
        title: [tableTitles['start_lost']].join(' '),
        flex: 1,
        color: '#FFFFFF'
      },
      'missense': {
        title: [tableTitles['missense']].join(' '),
        flex: 1,
        color: '#FFFFFF'
      },
      'inframe_indel': {
        title: [tableTitles['inframe_indel']].join(' '),
        flex: 1,
        color: '#FFFFFF'
      },
      'synonymous': {
        title: [tableTitles['synonymous']].join(' '),
        flex: 1,
        color: '#FFFFFF'
      },
      'non_coding': {
        title: [tableTitles['non_coding']].join(' '),
        flex: 1,
        color: '#FFFFFF'
      },
      'total': {
        data: false,
        title: [tableTitles['total']].join(' '),
        flex: 1,
        color: '#FFFFFF'
      }
    }
  };
  var clinvarTableData = {};
  clinvarTableData['function'] = {
    getOpacity: function getOpacity(p) {
      if (p === 0) return '00';else if (p < 0.02) return '02';else if (p <= 0.1) return '10';else if (p <= 0.2) return '20';else if (p <= 0.3) return '30';else if (p <= 0.4) return '40';else if (p <= 0.5) return '50';else if (p <= 0.6) return '60';else if (p <= 0.7) return '70';else if (p <= 0.8) return '80';else if (p <= 0.9) return '90';else return '';
    }
  };
  clinvarTableData['config'] = defaultTableConfig;
  clinvarTableData['data'] = {
    gs: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(defaultTableConfig['gs']).filter(function (_ref27) {
      var _ref28 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref27, 2),
          _ = _ref28[0],
          value = _ref28[1];

      return value.data !== false;
    }).reduce(function (r, _ref29) {
      var _ref30 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref29, 1),
          key = _ref30[0];

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, r, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, key, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(defaultTableConfig['csq']).filter(function (_ref31) {
        var _ref32 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref31, 2),
            _ = _ref32[0],
            value = _ref32[1];

        return value.data !== false;
      }).reduce(function (r, _ref33) {
        var _ref34 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref33, 1),
            key = _ref34[0];

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, r, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, key, defaultDataGenerator()));
      }, {}), {
        total: 0
      })));
    }, {}), {
      total: 0
    }),
    csq: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(defaultTableConfig['csq']).filter(function (_ref35) {
      var _ref36 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref35, 2),
          _ = _ref36[0],
          value = _ref36[1];

      return value.data !== false;
    }).reduce(function (r, _ref37) {
      var _ref38 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref37, 1),
          key = _ref38[0];

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, r, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, key, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(defaultTableConfig['gs']).filter(function (_ref39) {
        var _ref40 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref39, 2),
            _ = _ref40[0],
            value = _ref40[1];

        return value.data !== false;
      }).reduce(function (r, _ref41) {
        var _ref42 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref41, 1),
            key = _ref42[0];

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, r, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, key, defaultDataGenerator()));
      }, {}), {
        total: 0
      })));
    }, {}), {
      total: 0
    })
  };
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(clinvarStatistic), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var data = _step.value;

      var keys = {
        gs_clinsig: data.gs_clinsig.replace(/_variant$/, ''),
        csq: data.csq.replace(/_variant$/, '')
      };
      clinvarTableData['data']['gs'].total += data.n;
      clinvarTableData['data']['gs'][keys.gs_clinsig].total += data.n;
      clinvarTableData['data']['gs'][keys.gs_clinsig][keys.csq].n += data.n;
      clinvarTableData['data']['csq'].total += data.n;
      clinvarTableData['data']['csq'][keys.csq].total += data.n;
      clinvarTableData['data']['csq'][keys.csq][keys.gs_clinsig].n += data.n;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return clinvarTableData;
};

var clinvarACMGMap = {
  'Pathogenic': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___Pathogenic',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___Pathogenic',
    color: '#FA3D3D',
    index: 12
  },
  'Pathogenic/Likely pathogenic': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___PathogenicLikelypathogenic',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___PathogenicLikelypathogenic',
    color: '#FF9E03',
    index: 5
  },
  'Likely pathogenic': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___Likelypathogenic',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___Likelypathogenic',
    color: '#FF9E03',
    index: 11
  },
  'Conflicting interpretations of pathogenicity': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___Conflictinginterpretationsofpathogenicity',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___Conflictinginterpretationsofpathogenicity',
    color: '#F8C600',
    index: 10
  },
  'Conflicting classifications of pathogenicity': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___Conflictingclassificationsofpathogenicity',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___Conflictingclassificationsofpathogenicity',
    color: '#F8C600',
    index: 10
  },
  'Uncertain significance': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___Uncertainsignificance',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___Uncertainsignificance',
    color: '#F8C600',
    index: 9
  },
  'risk factor': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___riskfactor',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___riskfactor',
    color: '#FF0000',
    index: 8
  },
  'Benign': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___Benign',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___Benign',
    color: '#006ED6',
    index: 6
  },
  'Benign/Likely benign': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___BenignLikelybenign',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___BenignLikelybenign',
    color: '#83C91E',
    index: 4
  },
  'Likely benign': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___Likelybenign',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___Likelybenign',
    color: '#83C91E',
    index: 7
  },
  'drug response': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___drugresponse',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___drugresponse',
    color: '#F8C600',
    index: 3
  },
  'protective': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___protective',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___protective',
    color: '#F8C600',
    index: 2
  },
  'other': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___other',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___other',
    color: '#333333',
    index: 1
  },
  'Affects': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___Affects',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___Affects',
    color: '#333333',
    index: 1
  },
  'vus': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___vus',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___vus',
    color: '#333333',
    index: 1
  },
  'N/A': {
    display: defaultEmptyDisplay.empty,
    title: defaultEmptyDisplay.empty,
    color: '#AAAAAA',
    index: 0
  }
};

var repeatClassificationMap = {
  'Pathogenic': {
    title: 'CONSTANT.global.data.repeatClassificationMap.title.___Pathogenic',
    color: '#FA3D3D'
  },
  'Indeterminate': {
    title: 'CONSTANT.global.data.repeatClassificationMap.title.___Indeterminate',
    color: '#F8C600'
  },
  'Intermediate': {
    title: 'CONSTANT.global.data.repeatClassificationMap.title.___Intermediate',
    color: '#FF9E03'
  },
  'Normal': {
    title: 'CONSTANT.global.data.repeatClassificationMap.title.___Normal',
    color: '#349CCF'
  }
};

var getGTType = function getGTType(GT, CHROM, sex) {
  if (['Male'].includes(sex) && ['chrX', 'chrY'].includes(CHROM)) {
    if (['0', '0/0', '0|0'].includes(GT)) return 'ref_hemi';
    if (['1', '1/1', '1|1'].includes(GT)) return 'hemi';
  }
  if (['0/1', '0|1', '1|0', './1', '1/.'].includes(GT)) return 'het';
  if (['0/0', '0|0'].includes(GT)) return 'ref';
  if (/^[1-9][/|][1-9]$/.test(GT)) return 'homo';
  return 'unknown';
};

var reportGTMap = {
  'heterozygous': 'hetero<br>(雜合子)',
  'homozygous': 'homo<br>(純合子)',
  'hemizygous': 'hemi<br>(半合子)',
  'heterozygote': 'hetero<br>(雜合子)',
  'homozygote': 'homo<br>(純合子)',
  'hemizygote': 'hemi<br>(半合子)'
};

var reportEnGTMap = {
  'heterozygous': 'hetero',
  'homozygous': 'homo',
  'hemizygous': 'hemi',
  'heterozygote': 'hetero',
  'homozygote': 'homo',
  'hemizygote': 'hemi'
};

var reportClinvarACMGZHMap = {
  'Benign': '良性的',
  'Benign/Likely benign': '良性的/可能良性的',
  'Conflicting interpretations of pathogenicity': '致病性意義衝突',
  'Likely benign': '可能良性的',
  'drug response': '藥物反應',
  'risk factor': '風險因子',
  'protective': '有保護性的',
  'Uncertain significance': '不明確的',
  'Pathogenic': '致病的',
  'other': '其他',
  'Likely pathogenic': '可能致病的',
  'Pathogenic/Likely pathogenic': '致病的/可能致病的',
  'Affects': '非疾病相關表徵反應'
};

var reportCNVTypeMap = {
  'deletion': 'Deletion',
  'duplication': 'Duplication',
  'insertion': 'Insertion',
  'inversion': 'Inversion',
  'translocation': 'Translocation',
  'complex_sv': 'Complex SV'
};

var reportSVTypeMap = {
  'deletion': 'Deletion',
  'duplication': 'Duplication',
  'insertion': 'Insertion',
  'inversion': 'Inversion',
  'translocation': 'Translocation',
  'complex_sv': 'Complex SV'
};

var reportParentalOriginMap = {
  'De Novo': 'De Novo',
  'Paternal': 'Paternal',
  'Maternal': 'Maternal',
  'Biparental': 'Biparental',
  'Unknown': 'Unknown'
};

var acmgMap = {
  // BA
  BA1: {
    title: 'BA1',
    type: 'Strong',
    class: 'benign-strong',
    informations: ['CONSTANT.global.data.acmgMap.info.___BA1'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___BA1']
  },
  // BS
  BS1: {
    title: 'BS1',
    type: 'Strong',
    class: 'benign-strong',
    informations: ['CONSTANT.global.data.acmgMap.info.___BS1'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___BS1']
  },
  BS2: {
    title: 'BS2',
    type: 'Strong',
    class: 'benign-strong',
    informations: ['CONSTANT.global.data.acmgMap.info.___BS2'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___BS2']
  },
  BS4: {
    title: 'BS4',
    type: 'Strong',
    class: 'benign-strong',
    informations: ['CONSTANT.global.data.acmgMap.info.___BS4'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___BS4']
  },
  BS3: {
    title: 'BS3',
    type: 'Strong',
    class: 'benign-strong',
    informations: ['CONSTANT.global.data.acmgMap.info.___BS3'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___BS3']
  },
  // BP
  BP2: {
    title: 'BP2',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: ['CONSTANT.global.data.acmgMap.info.___BP2'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___BP2']
  },
  BP5: {
    title: 'BP5',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: ['CONSTANT.global.data.acmgMap.info.___BP5'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___BP5']
  },
  BP1: {
    title: 'BP1',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: ['CONSTANT.global.data.acmgMap.info.___BP1'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___BP1']
  },
  BP3: {
    title: 'BP3',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: ['CONSTANT.global.data.acmgMap.info.___BP3'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___BP3']
  },
  BP4: {
    title: 'BP4',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: ['CONSTANT.global.data.acmgMap.info.___BP4'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___BP4']
  },
  BP7: {
    title: 'BP7',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: ['CONSTANT.global.data.acmgMap.info.___BP7'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___BP7']
  },
  BP6: {
    title: 'BP6',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: ['CONSTANT.global.data.acmgMap.info.___BP6'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___BP6']
  },
  // PP
  PP1: {
    title: 'PP1',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: ['CONSTANT.global.data.acmgMap.info.___PP1'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___PP1']
  },
  PP2: {
    title: 'PP2',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: ['CONSTANT.global.data.acmgMap.info.___PP2'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___PP2']
  },
  PP3: {
    title: 'PP3',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: ['CONSTANT.global.data.acmgMap.info.___PP3'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___PP3']
  },
  PP4: {
    title: 'PP4',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: ['CONSTANT.global.data.acmgMap.info.___PP4'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___PP4']
  },
  PP5: {
    title: 'PP5',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: ['CONSTANT.global.data.acmgMap.info.___PP5'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___PP5']
  },
  // PM
  PM2: {
    title: 'PM2',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: ['CONSTANT.global.data.acmgMap.info.___PM2'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___PM2']
  },
  PM3: {
    title: 'PM3',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: ['CONSTANT.global.data.acmgMap.info.___PM3'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___PM3']
  },
  PM6: {
    title: 'PM6',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: ['CONSTANT.global.data.acmgMap.info.___PM6'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___PM6']
  },
  PM1: {
    title: 'PM1',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: ['CONSTANT.global.data.acmgMap.info.___PM1'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___PM1']
  },
  PM4: {
    title: 'PM4',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: ['CONSTANT.global.data.acmgMap.info.___PM4'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___PM4']
  },
  PM5: {
    title: 'PM5',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: ['CONSTANT.global.data.acmgMap.info.___PM5'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___PM5']
  },
  // PS
  PS4: {
    title: 'PS4',
    type: 'Strong',
    class: 'pathogenic-strong',
    informations: ['CONSTANT.global.data.acmgMap.info.___PS4'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___PS4']
  },
  PS2: {
    title: 'PS2',
    type: 'Strong',
    class: 'pathogenic-strong',
    informations: ['CONSTANT.global.data.acmgMap.info.___PS2'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___PS2']
  },
  PS1: {
    title: 'PS1',
    type: 'Strong',
    class: 'pathogenic-strong',
    informations: ['CONSTANT.global.data.acmgMap.info.___PS1'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___PS1']
  },
  PS3: {
    title: 'PS3',
    type: 'Strong',
    class: 'pathogenic-strong',
    informations: ['CONSTANT.global.data.acmgMap.info.___PS3'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___PS3']
  },
  // PVS
  PVS1: {
    title: 'PVS1',
    type: 'Very Strong',
    class: 'pathogenic-very-strong',
    informations: ['CONSTANT.global.data.acmgMap.info.___PVS1'],
    explanations: ['CONSTANT.global.data.acmgMap.explanations.___PVS1']
  }
};

var reportPreviewRangeData = {
  'ps': [1, 5],
  'pd': [3, Number.MAX_VALUE]
};

var reportPreviewDefaultDatas = {
  'select': {
    'ps': ['SIFT4G_score', 'Polyphen', 'CADD_phred', 'REVEL_score', 'BayesDel_noAF_score'],
    'pd': ['KG_EAS_AF', 'gnomAD_EAS_AF', 'TW_AF']
  },
  'display': {
    'default': ['gnomAD_AF', 'gnomAD_g_AF'],
    'us': ['gnomAD_AF', 'gnomAD_g_AF'],
    'jp': ['tommo_60kjpn_AF', 'gnomAD_g_AF']
  }[__WEBPACK_IMPORTED_MODULE_8__config__["b" /* _WEBSITE_VERSION */]] || ['gnomAD_AF', 'gnomAD_g_AF']
};

var getReportPreviewColumns = function getReportPreviewColumns() {
  var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var selectType = arguments[1];
  var dataType = arguments[2];

  if (selectType === 'select') {
    var range = reportPreviewRangeData[dataType];
    columns = columns.filter(function (column) {
      return reportPreviewTypeMap[column] === dataType;
    });
    if (dataType === 'pd') {
      return columns.length >= range[0] && columns.length <= range[1] ? columns : reportPreviewDefaultDatas['select']['pd'];
    } else if (dataType === 'ps') {
      return columns.length >= range[0] && columns.length <= range[1] ? columns : reportPreviewDefaultDatas['select']['ps'];
    }
  } else if (selectType === 'display') {
    return columns.length ? columns : reportPreviewDefaultDatas['display'];
  }
};

var reportPreviewOptions = {
  'pd': [
  // // Allele Frequency
  // 1000 Genomes
  {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___KG_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___1000Genomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'KG_AF',
    value: function value(variant) {
      return variant.KG_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___KG_EAS_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___1000Genomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'KG_EAS_AF',
    value: function value(variant) {
      return variant.KG_EAS_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___KG_AMR_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___1000Genomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'KG_AMR_AF',
    value: function value(variant) {
      return variant.KG_AMR_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___KG_AFR_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___1000Genomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'KG_AFR_AF',
    value: function value(variant) {
      return variant.KG_AFR_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___KG_EUR_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___1000Genomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'KG_EUR_AF',
    value: function value(variant) {
      return variant.KG_EUR_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___KG_SAS_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___1000Genomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'KG_SAS_AF',
    value: function value(variant) {
      return variant.KG_SAS_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  },
  // gnomAD Exomes
  {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_AF',
    value: function value(variant) {
      return variant.gnomAD_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_AFR_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_AFR_AF',
    value: function value(variant) {
      return variant.gnomAD_AFR_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_AMR_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_AMR_AF',
    value: function value(variant) {
      return variant.gnomAD_AMR_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_ASJ_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_ASJ_AF',
    value: function value(variant) {
      return variant.gnomAD_ASJ_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_EAS_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_EAS_AF',
    value: function value(variant) {
      return variant.gnomAD_EAS_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_FIN_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_FIN_AF',
    value: function value(variant) {
      return variant.gnomAD_FIN_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_NFE_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_NFE_AF',
    value: function value(variant) {
      return variant.gnomAD_NFE_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_OTH_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_OTH_AF',
    value: function value(variant) {
      return variant.gnomAD_OTH_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    // displayForm: true,
    old: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_SAS_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_SAS_AF',
    value: function value(variant) {
      return variant.gnomAD_SAS_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_MID_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_MID_AF',
    value: function value(variant) {
      return variant.gnomAD_MID_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    displayForm: true
  },
  // gnomAD Genomes
  {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_AF',
    value: function value(variant) {
      return variant.gnomAD_g_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM !== 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM !== 'chrM';
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_afr',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_AF_afr',
    value: function value(variant) {
      return variant.gnomAD_g_AF_afr;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM !== 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM !== 'chrM';
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_ami',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_AF_ami',
    value: function value(variant) {
      return variant.gnomAD_g_AF_ami;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM !== 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM !== 'chrM';
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_amr',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_AF_amr',
    value: function value(variant) {
      return variant.gnomAD_g_AF_amr;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM !== 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM !== 'chrM';
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_asj',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_AF_asj',
    value: function value(variant) {
      return variant.gnomAD_g_AF_asj;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM !== 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM !== 'chrM';
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_eas',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_AF_eas',
    value: function value(variant) {
      return variant.gnomAD_g_AF_eas;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM !== 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM !== 'chrM';
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_fin',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_AF_fin',
    value: function value(variant) {
      return variant.gnomAD_g_AF_fin;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM !== 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM !== 'chrM';
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_mid',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_AF_mid',
    value: function value(variant) {
      return variant.gnomAD_g_AF_mid;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM !== 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM !== 'chrM';
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_nfe',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_AF_nfe',
    value: function value(variant) {
      return variant.gnomAD_g_AF_nfe;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM !== 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM !== 'chrM';
    },
    displayForm: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_oth',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_AF_oth',
    value: function value(variant) {
      return variant.gnomAD_g_AF_oth;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM !== 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM !== 'chrM';
    },
    // displayForm: true
    old: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_sas',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_AF_sas',
    value: function value(variant) {
      return variant.gnomAD_g_AF_sas;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM !== 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM !== 'chrM';
    },
    displayForm: true
  },
  // gnomAD Genomes MT
  {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_AF_het',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_AF_het',
    value: function value(variant) {
      return variant.gnomAD_g_mt_AF_het;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_afr',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_het_afr',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_het_afr;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_ami',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_het_ami',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_het_ami;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_amr',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_het_amr',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_het_amr;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_asj',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_het_asj',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_het_asj;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_eas',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_het_eas',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_het_eas;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_fin',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_het_fin',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_het_fin;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_mid',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_het_mid',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_het_mid;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_nfe',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_het_nfe',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_het_nfe;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_oth',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_het_oth',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_het_oth;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_sas',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_het_sas',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_het_sas;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_AF_hom',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_AF_hom',
    value: function value(variant) {
      return variant.gnomAD_g_mt_AF_hom;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_afr',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_hom_afr',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_hom_afr;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_ami',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_hom_ami',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_hom_ami;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_amr',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_hom_amr',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_hom_amr;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_asj',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_hom_asj',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_hom_asj;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_eas',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_hom_eas',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_hom_eas;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_fin',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_hom_fin',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_hom_fin;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_mid',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_hom_mid',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_hom_mid;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_nfe',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_hom_nfe',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_hom_nfe;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_oth',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_hom_oth',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_hom_oth;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_sas',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_pop_AF_hom_sas',
    value: function value(variant) {
      return variant.gnomAD_g_mt_pop_AF_hom_sas;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(variants).some(function (variant) {
        return variant.CHROM === 'chrM';
      });
    },
    resultDisplay: function resultDisplay(variant) {
      return variant.CHROM === 'chrM';
    }
  },
  // Other
  {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___ESP6500_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'ESP6500_AF',
    value: function value(variant) {
      return variant.ESP6500_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___ESP6500_AA_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'ESP6500_AA_AF',
    value: function value(variant) {
      return variant.ESP6500_AA_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___ESP6500_EA_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'ESP6500_EA_AF',
    value: function value(variant) {
      return variant.ESP6500_EA_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___TW_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'TW_AF',
    value: function value(variant) {
      return variant.TW_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___TOPMED_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'TOPMED_AF',
    value: function value(variant) {
      return variant.TOPMED_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    displayForm: true,
    formGroupDisplay: false
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___UK10K_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'UK10K_AF',
    value: function value(variant) {
      return variant.UK10K_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    displayForm: true,
    formGroupDisplay: false
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___ChinaMAP_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'ChinaMAP_AF',
    value: function value(variant) {
      return variant.ChinaMAP_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    old: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___GA_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'GA_AF',
    value: function value(variant) {
      return variant.GA_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___KJ_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'KJ_AF',
    value: function value(variant) {
      return variant.KJ_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    old: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___ExAC_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'ExAC_AF',
    value: function value(variant) {
      return variant.ExAC_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___tommo_60kjpn_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    displayCategory: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'tommo_60kjpn_AF',
    value: function value(variant) {
      return variant.tommo_60kjpn_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    displayForm: true,
    formGroupDisplay: false
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___tommo_60kjpn_AN',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'tommo_60kjpn_AN',
    value: function value(variant) {
      return variant.tommo_60kjpn_AN;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  },
  // PhenoVarDB Private
  {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_FILTER',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_P_FILTER',
    value: function value(variant) {
      return variant.PVDB_P_FILTER;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_F_MISSING',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_P_F_MISSING',
    value: function value(variant) {
      return variant.PVDB_P_F_MISSING;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_AC',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_P_AC',
    value: function value(variant) {
      return variant.PVDB_P_AC;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_AN',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_P_AN',
    value: function value(variant) {
      return variant.PVDB_P_AN;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_P_AF',
    value: function value(variant) {
      return variant.PVDB_P_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_DP',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_P_DP',
    value: function value(variant) {
      return variant.PVDB_P_DP;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_AC_Het',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_P_AC_Het',
    value: function value(variant) {
      return variant.PVDB_P_AC_Het;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    long: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_AC_Hom',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_P_AC_Hom',
    value: function value(variant) {
      return variant.PVDB_P_AC_Hom;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    long: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_AC_Hemi',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_P_AC_Hemi',
    value: function value(variant) {
      return variant.PVDB_P_AC_Hemi;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    long: true
  },
  // PhenoVarDB Community
  {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_FILTER',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_S_FILTER',
    value: function value(variant) {
      return variant.PVDB_S_FILTER;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_F_MISSING',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_S_F_MISSING',
    value: function value(variant) {
      return variant.PVDB_S_F_MISSING;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_AC',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_S_AC',
    value: function value(variant) {
      return variant.PVDB_S_AC;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_AN',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_S_AN',
    value: function value(variant) {
      return variant.PVDB_S_AN;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_S_AF',
    value: function value(variant) {
      return variant.PVDB_S_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_DP',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_S_DP',
    value: function value(variant) {
      return variant.PVDB_S_DP;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_AC_Het',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_S_AC_Het',
    value: function value(variant) {
      return variant.PVDB_S_AC_Het;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    long: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_AC_Hom',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_S_AC_Hom',
    value: function value(variant) {
      return variant.PVDB_S_AC_Hom;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    long: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_AC_Hemi',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_S_AC_Hemi',
    value: function value(variant) {
      return variant.PVDB_S_AC_Hemi;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    long: true
  },
  // PhenoVarDB Admin
  {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_FILTER',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_A_FILTER',
    value: function value(variant) {
      return variant.PVDB_A_FILTER;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants, user) {
      return ['supervisor'].includes(user.role);
    },
    resultDisplay: function resultDisplay(variant, user) {
      return ['supervisor'].includes(user.role);
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_F_MISSING',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_A_F_MISSING',
    value: function value(variant) {
      return variant.PVDB_A_F_MISSING;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants, user) {
      return ['supervisor'].includes(user.role);
    },
    resultDisplay: function resultDisplay(variant, user) {
      return ['supervisor'].includes(user.role);
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_AC',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_A_AC',
    value: function value(variant) {
      return variant.PVDB_A_AC;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants, user) {
      return ['supervisor'].includes(user.role);
    },
    resultDisplay: function resultDisplay(variant, user) {
      return ['supervisor'].includes(user.role);
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_AN',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_A_AN',
    value: function value(variant) {
      return variant.PVDB_A_AN;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants, user) {
      return ['supervisor'].includes(user.role);
    },
    resultDisplay: function resultDisplay(variant, user) {
      return ['supervisor'].includes(user.role);
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_AF',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_A_AF',
    value: function value(variant) {
      return variant.PVDB_A_AF;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants, user) {
      return ['supervisor'].includes(user.role);
    },
    resultDisplay: function resultDisplay(variant, user) {
      return ['supervisor'].includes(user.role);
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_DP',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_A_DP',
    value: function value(variant) {
      return variant.PVDB_A_DP;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants, user) {
      return ['supervisor'].includes(user.role);
    },
    resultDisplay: function resultDisplay(variant, user) {
      return ['supervisor'].includes(user.role);
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_AC_Het',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_A_AC_Het',
    value: function value(variant) {
      return variant.PVDB_A_AC_Het;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants, user) {
      return ['supervisor'].includes(user.role);
    },
    resultDisplay: function resultDisplay(variant, user) {
      return ['supervisor'].includes(user.role);
    },
    long: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_AC_Hom',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_A_AC_Hom',
    value: function value(variant) {
      return variant.PVDB_A_AC_Hom;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants, user) {
      return ['supervisor'].includes(user.role);
    },
    resultDisplay: function resultDisplay(variant, user) {
      return ['supervisor'].includes(user.role);
    },
    long: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_AC_Hemi',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
    resultCategory: '__DEFAULT',
    key: 'PVDB_A_AC_Hemi',
    value: function value(variant) {
      return variant.PVDB_A_AC_Hemi;
    },
    class: function _class(value) {
      return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
    },
    selectDisplay: function selectDisplay(variants, user) {
      return ['supervisor'].includes(user.role);
    },
    resultDisplay: function resultDisplay(variant, user) {
      return ['supervisor'].includes(user.role);
    },
    long: true
  },
  // // Coverage
  // gnomAD Exomes
  {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_cov_MEAN',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___coverageGnomADExomes',
    filterGroup: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___coverage',
    key: 'gnomAD_cov_MEAN',
    value: function value(variant) {
      return variant.gnomAD_cov_MEAN;
    },
    class: function _class(value) {
      return value || value === 0 ? ['normal'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_cov_MEDIAN',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___coverageGnomADExomes',
    filterGroup: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___coverage',
    key: 'gnomAD_cov_MEDIAN',
    value: function value(variant) {
      return variant.gnomAD_cov_MEDIAN;
    },
    class: function _class(value) {
      return value || value === 0 ? ['normal'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_cov_PCT_20X',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___coverageGnomADExomes',
    filterGroup: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___coverage',
    key: 'gnomAD_cov_PCT_20X',
    value: function value(variant) {
      return variant.gnomAD_cov_PCT_20X;
    },
    class: function _class(value) {
      return value || value === 0 ? ['normal'] : ['empty'];
    }
  },
  // gnomAD Genomes
  {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_cov_MEAN',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___coverageGnomADGenomes',
    filterGroup: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___coverage',
    key: 'gnomAD_g_cov_MEAN',
    value: function value(variant) {
      return variant.gnomAD_g_cov_MEAN;
    },
    class: function _class(value) {
      return value || value === 0 ? ['normal'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_cov_MEDIAN',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___coverageGnomADGenomes',
    filterGroup: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___coverage',
    key: 'gnomAD_g_cov_MEDIAN',
    value: function value(variant) {
      return variant.gnomAD_g_cov_MEDIAN;
    },
    class: function _class(value) {
      return value || value === 0 ? ['normal'] : ['empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_cov_PCT_20X',
    group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___coverageGnomADGenomes',
    filterGroup: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___coverage',
    key: 'gnomAD_g_cov_PCT_20X',
    value: function value(variant) {
      return variant.gnomAD_g_cov_PCT_20X;
    },
    class: function _class(value) {
      return value || value === 0 ? ['normal'] : ['empty'];
    }
  }],
  'ps': [
  // // Function Prediction
  // default
  {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___ESM1b',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'ESM1b',
    value: function value(variant) {
      return variant.ESM1b;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['ESM1b'].checkPassed || function () {
        return true;
      })(variant.ESM1b, variant.ESM1b_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___ESM1b_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'ESM1b_pred',
    value: function value(variant) {
      return predictionMetaDatas['ESM1b'].displayMap[variant.ESM1b_pred] || variant.ESM1b_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['ESM1b'].checkPassed || function () {
        return true;
      })(variant.ESM1b, variant.ESM1b_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___VARITY_ER_LOO',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'VARITY_ER_LOO',
    value: function value(variant) {
      return variant.VARITY_ER_LOO;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['VARITY_ER_LOO'].checkPassed || function () {
        return true;
      })(variant.VARITY_ER_LOO, variant.VARITY_ER_LOO_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___VARITY_ER_LOO_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'VARITY_ER_LOO_pred',
    value: function value(variant) {
      return predictionMetaDatas['VARITY_ER_LOO'].displayMap[variant.VARITY_ER_LOO_pred] || variant.VARITY_ER_LOO_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['VARITY_ER_LOO'].checkPassed || function () {
        return true;
      })(variant.VARITY_ER_LOO, variant.VARITY_ER_LOO_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___VARITY_R_LOO',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'VARITY_R_LOO',
    value: function value(variant) {
      return variant.VARITY_R_LOO;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['VARITY_R_LOO'].checkPassed || function () {
        return true;
      })(variant.VARITY_R_LOO, variant.VARITY_R_LOO_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___VARITY_R_LOO_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'VARITY_R_LOO_pred',
    value: function value(variant) {
      return predictionMetaDatas['VARITY_R_LOO'].displayMap[variant.VARITY_R_LOO_pred] || variant.VARITY_R_LOO_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['VARITY_R_LOO'].checkPassed || function () {
        return true;
      })(variant.VARITY_R_LOO, variant.VARITY_R_LOO_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___VARITY_ER',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'VARITY_ER',
    value: function value(variant) {
      return variant.VARITY_ER;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['VARITY_ER'].checkPassed || function () {
        return true;
      })(variant.VARITY_ER, variant.VARITY_ER_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___VARITY_ER_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'VARITY_ER_pred',
    value: function value(variant) {
      return predictionMetaDatas['VARITY_ER'].displayMap[variant.VARITY_ER_pred] || variant.VARITY_ER_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['VARITY_ER'].checkPassed || function () {
        return true;
      })(variant.VARITY_ER, variant.VARITY_ER_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___VARITY_R',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'VARITY_R',
    value: function value(variant) {
      return variant.VARITY_R;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['VARITY_R'].checkPassed || function () {
        return true;
      })(variant.VARITY_R, variant.VARITY_R_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___VARITY_R_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'VARITY_R_pred',
    value: function value(variant) {
      return predictionMetaDatas['VARITY_R'].displayMap[variant.VARITY_R_pred] || variant.VARITY_R_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['VARITY_R'].checkPassed || function () {
        return true;
      })(variant.VARITY_R, variant.VARITY_R_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___Alphamissense_score',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'Alphamissense_score',
    value: function value(variant) {
      return variant.Alphamissense_score;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['Alphamissense'].checkPassed || function () {
        return true;
      })(variant.Alphamissense_score, variant.Alphamissense_class) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___Alphamissense_class',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'Alphamissense_class',
    value: function value(variant) {
      return predictionMetaDatas['Alphamissense'].displayMap[variant.Alphamissense_class] || variant.Alphamissense_class;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['Alphamissense'].checkPassed || function () {
        return true;
      })(variant.Alphamissense_score, variant.Alphamissense_class) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___SIFT4G_score',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'SIFT4G_score',
    value: function value(variant) {
      return ((variant.transcripts || {})[variant.Feature] || variant).SIFT4G_score;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SIFT4G'].checkPassed || function () {
        return true;
      })(((variant.transcripts || {})[variant.Feature] || variant).SIFT4G_score, ((variant.transcripts || {})[variant.Feature] || variant).SIFT4G_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___SIFT4G_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'SIFT4G_pred',
    value: function value(variant) {
      return predictionMetaDatas['SIFT4G'].displayMap[((variant.transcripts || {})[variant.Feature] || variant).SIFT4G_pred] || ((variant.transcripts || {})[variant.Feature] || variant).SIFT4G_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SIFT4G'].checkPassed || function () {
        return true;
      })(((variant.transcripts || {})[variant.Feature] || variant).SIFT4G_score, ((variant.transcripts || {})[variant.Feature] || variant).SIFT4G_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___Polyphen',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'Polyphen',
    value: function value(variant) {
      return ((variant.transcripts || {})[variant.Feature] || variant).Polyphen;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['Polyphen'].checkPassed || function () {
        return true;
      })(((variant.transcripts || {})[variant.Feature] || variant).Polyphen, ((variant.transcripts || {})[variant.Feature] || variant).Polyphen_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___Polyphen_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'Polyphen_pred',
    value: function value(variant) {
      return predictionMetaDatas['Polyphen'].displayMap[((variant.transcripts || {})[variant.Feature] || variant).Polyphen_pred] || ((variant.transcripts || {})[variant.Feature] || variant).Polyphen_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['Polyphen'].checkPassed || function () {
        return true;
      })(((variant.transcripts || {})[variant.Feature] || variant).Polyphen, ((variant.transcripts || {})[variant.Feature] || variant).Polyphen_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___FATHMM_score',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'FATHMM_score',
    value: function value(variant) {
      return ((variant.transcripts || {})[variant.Feature] || variant).FATHMM_score;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['FATHMM'].checkPassed || function () {
        return true;
      })(((variant.transcripts || {})[variant.Feature] || variant).FATHMM_score, ((variant.transcripts || {})[variant.Feature] || variant).FATHMM_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___FATHMM_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'FATHMM_pred',
    value: function value(variant) {
      return predictionMetaDatas['FATHMM'].displayMap[((variant.transcripts || {})[variant.Feature] || variant).FATHMM_pred] || ((variant.transcripts || {})[variant.Feature] || variant).FATHMM_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['FATHMM'].checkPassed || function () {
        return true;
      })(((variant.transcripts || {})[variant.Feature] || variant).FATHMM_score, ((variant.transcripts || {})[variant.Feature] || variant).FATHMM_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PROVEAN_score',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'PROVEAN_score',
    value: function value(variant) {
      return ((variant.transcripts || {})[variant.Feature] || variant).PROVEAN_score;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['PROVEAN'].checkPassed || function () {
        return true;
      })(((variant.transcripts || {})[variant.Feature] || variant).PROVEAN_score, ((variant.transcripts || {})[variant.Feature] || variant).PROVEAN_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___PROVEAN_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'PROVEAN_pred',
    value: function value(variant) {
      return predictionMetaDatas['PROVEAN'].displayMap[((variant.transcripts || {})[variant.Feature] || variant).PROVEAN_pred] || ((variant.transcripts || {})[variant.Feature] || variant).PROVEAN_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['PROVEAN'].checkPassed || function () {
        return true;
      })(((variant.transcripts || {})[variant.Feature] || variant).PROVEAN_score, ((variant.transcripts || {})[variant.Feature] || variant).PROVEAN_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___CADD_phred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'CADD_phred',
    value: function value(variant) {
      return variant.CADD_phred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CADD_phred'].checkPassed || function () {
        return true;
      })(variant.CADD_phred, variant.CADD_phred_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___CADD_phred_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'CADD_phred_pred',
    value: function value(variant) {
      return predictionMetaDatas['CADD_phred'].displayMap[variant.CADD_phred_pred] || variant.CADD_phred_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CADD_phred'].checkPassed || function () {
        return true;
      })(variant.CADD_phred, variant.CADD_phred_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___MetaLR_score',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'MetaLR_score',
    value: function value(variant) {
      return variant.MetaLR_score;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['MetaLR'].checkPassed || function () {
        return true;
      })(variant.MetaLR_score, variant.MetaLR_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___MetaLR_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'MetaLR_pred',
    value: function value(variant) {
      return predictionMetaDatas['MetaLR'].displayMap[variant.MetaLR_pred] || variant.MetaLR_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['MetaLR'].checkPassed || function () {
        return true;
      })(variant.MetaLR_score, variant.MetaLR_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___MetaSVM_score',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'MetaSVM_score',
    value: function value(variant) {
      return variant.MetaSVM_score;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['MetaSVM'].checkPassed || function () {
        return true;
      })(variant.MetaSVM_score, variant.MetaSVM_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___MetaSVM_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'MetaSVM_pred',
    value: function value(variant) {
      return predictionMetaDatas['MetaSVM'].displayMap[variant.MetaSVM_pred] || variant.MetaSVM_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['MetaSVM'].checkPassed || function () {
        return true;
      })(variant.MetaSVM_score, variant.MetaSVM_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___REVEL_score',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'REVEL_score',
    value: function value(variant) {
      return variant.REVEL_score;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['REVEL'].checkPassed || function () {
        return true;
      })(variant.REVEL_score, variant.REVEL_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___REVEL_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'REVEL_pred',
    value: function value(variant) {
      return predictionMetaDatas['REVEL'].displayMap[variant.REVEL_pred] || variant.REVEL_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['REVEL'].checkPassed || function () {
        return true;
      })(variant.REVEL_score, variant.REVEL_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty'],
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___BayesDel_noAF_score',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'BayesDel_noAF_score',
    value: function value(variant) {
      return variant.BayesDel_noAF_score;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['BayesDel_noAF'].checkPassed || function () {
        return true;
      })(variant.BayesDel_noAF_score, variant.BayesDel_noAF_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___BayesDel_noAF_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'BayesDel_noAF_pred',
    value: function value(variant) {
      return predictionMetaDatas['BayesDel_noAF'].displayMap[variant.BayesDel_noAF_pred] || variant.BayesDel_noAF_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['BayesDel_noAF'].checkPassed || function () {
        return true;
      })(variant.BayesDel_noAF_score, variant.BayesDel_noAF_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_mitotip_score',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_mitotip_score',
    value: function value(variant) {
      return variant.gnomAD_g_mt_mitotip_score;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['gnomAD_g_mt_mitotip'].checkPassed || function () {
        return true;
      })(variant.gnomAD_g_mt_mitotip_score, variant.gnomAD_g_mt_mitotip_score_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_mitotip_score_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'gnomAD_g_mt_mitotip_score_pred',
    value: function value(variant) {
      return predictionMetaDatas['gnomAD_g_mt_mitotip'].displayMap[variant.gnomAD_g_mt_mitotip_score_pred] || variant.gnomAD_g_mt_mitotip_score_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['gnomAD_g_mt_mitotip'].checkPassed || function () {
        return true;
      })(variant.gnomAD_g_mt_mitotip_score, variant.gnomAD_g_mt_mitotip_score_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  },
  // // Splice Site
  // default
  {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___ada_score',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'ada_score',
    value: function value(variant) {
      return variant.ada_score;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['ada'].checkPassed || function () {
        return true;
      })(variant.ada_score, variant.ada_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___ada_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'ada_pred',
    value: function value(variant) {
      return predictionMetaDatas['ada'].displayMap[variant.ada_pred] || variant.ada_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['ada'].checkPassed || function () {
        return true;
      })(variant.ada_score, variant.ada_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___rf_score',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'rf_score',
    value: function value(variant) {
      return variant.rf_score;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['rf'].checkPassed || function () {
        return true;
      })(variant.rf_score, variant.rf_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___rf_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'rf_pred',
    value: function value(variant) {
      return predictionMetaDatas['rf'].displayMap[variant.rf_pred] || variant.rf_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['rf'].checkPassed || function () {
        return true;
      })(variant.rf_score, variant.rf_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___CI_SpliceAI_DS_AG',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'CI_SpliceAI_DS_AG',
    value: function value(variant) {
      return variant.CI_SpliceAI_DS_AG;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CI_SpliceAI_DS_AG'].checkPassed || function () {
        return true;
      })(variant.CI_SpliceAI_DS_AG) + ''] || 'empty'];
    },
    long: false
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___CI_SpliceAI_DS_AL',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'CI_SpliceAI_DS_AL',
    value: function value(variant) {
      return variant.CI_SpliceAI_DS_AL;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CI_SpliceAI_DS_AL'].checkPassed || function () {
        return true;
      })(variant.CI_SpliceAI_DS_AL) + ''] || 'empty'];
    },
    long: false
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___CI_SpliceAI_DS_DG',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'CI_SpliceAI_DS_DG',
    value: function value(variant) {
      return variant.CI_SpliceAI_DS_DG;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CI_SpliceAI_DS_DG'].checkPassed || function () {
        return true;
      })(variant.CI_SpliceAI_DS_DG) + ''] || 'empty'];
    },
    long: false
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___CI_SpliceAI_DS_DL',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'CI_SpliceAI_DS_DL',
    value: function value(variant) {
      return variant.CI_SpliceAI_DS_DL;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CI_SpliceAI_DS_DL'].checkPassed || function () {
        return true;
      })(variant.CI_SpliceAI_DS_DL) + ''] || 'empty'];
    },
    long: false
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___CI_SpliceAI_DP_AG',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'CI_SpliceAI_DP_AG',
    value: function value(variant) {
      return variant.CI_SpliceAI_DP_AG;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CI_SpliceAI_DP_AG'].checkPassed || function () {
        return true;
      })(variant.CI_SpliceAI_DP_AG) + ''] || 'empty'];
    },
    long: false
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___CI_SpliceAI_DP_AL',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'CI_SpliceAI_DP_AL',
    value: function value(variant) {
      return variant.CI_SpliceAI_DP_AL;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CI_SpliceAI_DP_AL'].checkPassed || function () {
        return true;
      })(variant.CI_SpliceAI_DP_AL) + ''] || 'empty'];
    },
    long: false
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___CI_SpliceAI_DP_DG',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'CI_SpliceAI_DP_DG',
    value: function value(variant) {
      return variant.CI_SpliceAI_DP_DG;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CI_SpliceAI_DP_DG'].checkPassed || function () {
        return true;
      })(variant.CI_SpliceAI_DP_DG) + ''] || 'empty'];
    },
    long: false
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___CI_SpliceAI_DP_DL',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'CI_SpliceAI_DP_DL',
    value: function value(variant) {
      return variant.CI_SpliceAI_DP_DL;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CI_SpliceAI_DP_DL'].checkPassed || function () {
        return true;
      })(variant.CI_SpliceAI_DP_DL) + ''] || 'empty'];
    },
    long: false
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'SpliceAI',
    link: {
      title: 'CONSTANT.global.data.reportPreviewOptions.linkTitle.___SpliceAI',
      url: function url(variant) {
        return 'https://spliceailookup.broadinstitute.org/#variant=' + [variant.CHROM, variant.POS, variant.REF, variant.ALT].join('-') + '&hg=38&distance=50&mask=0&precomputed=1';
      }
    },
    long: true,
    old: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI_DS_AG',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'SpliceAI_DS_AG',
    value: function value(variant) {
      return variant.SpliceAI_DS_AG;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SpliceAI_DS_AG'].checkPassed || function () {
        return true;
      })(variant.SpliceAI_DS_AG) + ''] || 'empty'];
    },
    long: true,
    old: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI_DS_AL',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'SpliceAI_DS_AL',
    value: function value(variant) {
      return variant.SpliceAI_DS_AL;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SpliceAI_DS_AL'].checkPassed || function () {
        return true;
      })(variant.SpliceAI_DS_AL) + ''] || 'empty'];
    },
    long: true,
    old: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI_DS_DG',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'SpliceAI_DS_DG',
    value: function value(variant) {
      return variant.SpliceAI_DS_DG;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SpliceAI_DS_DG'].checkPassed || function () {
        return true;
      })(variant.SpliceAI_DS_DG) + ''] || 'empty'];
    },
    long: true,
    old: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI_DS_DL',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'SpliceAI_DS_DL',
    value: function value(variant) {
      return variant.SpliceAI_DS_DL;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SpliceAI_DS_DL'].checkPassed || function () {
        return true;
      })(variant.SpliceAI_DS_DL) + ''] || 'empty'];
    },
    long: true,
    old: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI_DP_AG',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'SpliceAI_DP_AG',
    value: function value(variant) {
      return variant.SpliceAI_DP_AG;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SpliceAI_DP_AG'].checkPassed || function () {
        return true;
      })(variant.SpliceAI_DP_AG) + ''] || 'empty'];
    },
    long: true,
    old: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI_DP_AL',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'SpliceAI_DP_AL',
    value: function value(variant) {
      return variant.SpliceAI_DP_AL;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SpliceAI_DP_AL'].checkPassed || function () {
        return true;
      })(variant.SpliceAI_DP_AL) + ''] || 'empty'];
    },
    long: true,
    old: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI_DP_DG',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'SpliceAI_DP_DG',
    value: function value(variant) {
      return variant.SpliceAI_DP_DG;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SpliceAI_DP_DG'].checkPassed || function () {
        return true;
      })(variant.SpliceAI_DP_DG) + ''] || 'empty'];
    },
    long: true,
    old: true
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI_DP_DL',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'SpliceAI_DP_DL',
    value: function value(variant) {
      return variant.SpliceAI_DP_DL;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SpliceAI_DP_DL'].checkPassed || function () {
        return true;
      })(variant.SpliceAI_DP_DL) + ''] || 'empty'];
    },
    long: true,
    old: true
  },
  // // Conservation
  // default
  {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___GERPpp_NR',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psConservation',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'GERPpp_NR',
    value: function value(variant) {
      return variant.GERPpp_NR;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['GERPpp_NR'].checkPassed || function () {
        return true;
      })(variant.GERPpp_NR) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___GERPpp_RS',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psConservation',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'GERPpp_RS',
    value: function value(variant) {
      return variant.GERPpp_RS;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['GERPpp_RS'].checkPassed || function () {
        return true;
      })(variant.GERPpp_RS, variant.GERPpp_RS_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___GERPpp_RS_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psConservation',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'GERPpp_RS_pred',
    value: function value(variant) {
      return predictionMetaDatas['GERPpp_RS'].displayMap[variant.GERPpp_RS_pred] || variant.GERPpp_RS_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['GERPpp_RS'].checkPassed || function () {
        return true;
      })(variant.GERPpp_RS, variant.GERPpp_RS_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___SiPhy_29way_logOdds',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psConservation',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'SiPhy_29way_logOdds',
    value: function value(variant) {
      return variant.SiPhy_29way_logOdds;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SiPhy_29way_logOdds'].checkPassed || function () {
        return true;
      })(variant.SiPhy_29way_logOdds, variant.SiPhy_29way_logOdds_pred) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___SiPhy_29way_logOdds_pred',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psConservation',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'SiPhy_29way_logOdds_pred',
    value: function value(variant) {
      return predictionMetaDatas['SiPhy_29way_logOdds'].displayMap[variant.SiPhy_29way_logOdds_pred] || variant.SiPhy_29way_logOdds_pred;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SiPhy_29way_logOdds'].checkPassed || function () {
        return true;
      })(variant.SiPhy_29way_logOdds, variant.SiPhy_29way_logOdds_pred) + ''] || 'empty'];
    }
    // class: value => (value || value === 0) ? ['normal'] : ['empty']
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___SiPhy_29way_pi',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psConservation',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'SiPhy_29way_pi',
    value: function value(variant) {
      return variant.SiPhy_29way_pi ? variant.SiPhy_29way_pi.split(':').map(function (v) {
        return (Object(__WEBPACK_IMPORTED_MODULE_9__util__["g" /* fixNumber */])(v, 0.01) + '').replace(/^0$/, '0.0');
      }).join(':') : variant.SiPhy_29way_pi;
    },
    hover: function hover(variant) {
      return variant.SiPhy_29way_pi;
    },
    class: function _class(value, variant) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SiPhy_29way_pi'].checkPassed || function () {
        return true;
      })(variant.SiPhy_29way_pi) + ''] || 'empty'];
    }
  },
  // // gnomAD Constraint
  // default
  {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___oe_syn',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psgnomADConstraint',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'oe_syn',
    value: function value(variant, gene) {
      return (gene || variant || {}).oe_syn;
    },
    class: function _class(value, variant, gene) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['oe_syn'].checkPassed || function () {
        return true;
      })((gene || variant || {}).oe_syn) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___oe_mis',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psgnomADConstraint',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'oe_mis',
    value: function value(variant, gene) {
      return (gene || variant || {}).oe_mis;
    },
    class: function _class(value, variant, gene) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['oe_mis'].checkPassed || function () {
        return true;
      })((gene || variant || {}).oe_mis) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___oe_lof',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psgnomADConstraint',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'oe_lof',
    value: function value(variant, gene) {
      return (gene || variant || {}).oe_lof;
    },
    class: function _class(value, variant, gene) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['oe_lof'].checkPassed || function () {
        return true;
      })((gene || variant || {}).oe_lof) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___syn_z',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psgnomADConstraint',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'syn_z',
    value: function value(variant, gene) {
      return (gene || variant || {}).syn_z;
    },
    class: function _class(value, variant, gene) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['syn_z'].checkPassed || function () {
        return true;
      })((gene || variant || {}).syn_z) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___mis_z',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psgnomADConstraint',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'mis_z',
    value: function value(variant, gene) {
      return (gene || variant || {}).mis_z;
    },
    class: function _class(value, variant, gene) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['mis_z'].checkPassed || function () {
        return true;
      })((gene || variant || {}).mis_z) + ''] || 'empty'];
    }
  }, {
    title: 'CONSTANT.global.data.reportPreviewOptions.title.___pLI',
    group: '__DEFAULT',
    category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psgnomADConstraint',
    resultGroup: '__DEFAULT',
    resultCategory: '__DEFAULT',
    key: 'pLI',
    value: function value(variant, gene) {
      return (gene || variant || {}).pLI;
    },
    class: function _class(value, variant, gene) {
      return [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['pLI'].checkPassed || function () {
        return true;
      })((gene || variant || {}).pLI) + ''] || 'empty'];
    }
  }]
};

var reportPreviewTypeMap = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(reportPreviewOptions).reduce(function (typeMap, _ref43) {
  var _ref44 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref43, 2),
      type = _ref44[0],
      options = _ref44[1];

  var map = options.reduce(function (keyMap, option) {
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, keyMap, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, option.key, type));
  }, {});
  return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, typeMap, map);
}, {});

var datasetStatusMap = {
  created: {
    title: 'CONSTANT.global.data.datasetStatusMap.title.___created',
    color: '#333333'
  },
  analyzing: {
    title: 'CONSTANT.global.data.datasetStatusMap.title.___analyzing',
    color: '#83C91E'
  },
  completed: {
    title: 'CONSTANT.global.data.datasetStatusMap.title.___completed',
    color: '#003679'
  },
  failed: {
    title: 'CONSTANT.global.data.datasetStatusMap.title.___failed',
    color: '#BE0F0F'
  },
  disabled: {
    title: 'CONSTANT.global.data.datasetStatusMap.title.___disabled',
    color: '#BE0F0F'
  }
};

var datasetPermissionTypeMap = {
  private: {
    title: 'CONSTANT.global.data.datasetPermissionTypeMap.title.___private'
  },
  community: {
    title: 'CONSTANT.global.data.datasetPermissionTypeMap.title.___community'
  }
};

var datasetPermissionMap = {
  private: {
    title: 'CONSTANT.global.data.datasetPermissionMap.title.___private',
    color: '#BE0F0F',
    type: 'private'
  },
  basic: {
    title: 'CONSTANT.global.data.datasetPermissionMap.title.___basic',
    color: '#333333',
    type: 'community'
  },
  explore: {
    title: 'CONSTANT.global.data.datasetPermissionMap.title.___explore',
    color: '#003679',
    type: 'community'
  },
  full: {
    title: 'CONSTANT.global.data.datasetPermissionMap.title.___full',
    color: '#83C91E',
    type: 'community'
  }
};

var datasetInvitationPermissionMap = {
  explore: {
    title: 'CONSTANT.global.data.datasetInvitationPermissionMap.title.___explore'
  },
  full: {
    title: 'CONSTANT.global.data.datasetInvitationPermissionMap.title.___full'
  }
};

var datasetPipelineMap = {
  WES: {
    title: 'CONSTANT.global.data.datasetPipelineMap.title.___WES'
  },
  WGS: {
    title: 'CONSTANT.global.data.datasetPipelineMap.title.___WGS'
  }
};

var datasetShareAlert = function datasetShareAlert(dataset) {
  if (dataset.external_data_included) return 'CONSTANT.global.data.datasetShareAlert.___external_data_included';
  if (dataset.disabled) return 'CONSTANT.global.data.datasetShareAlert.___disabled';
  if (['analyzing'].includes(dataset.state)) return 'CONSTANT.global.data.datasetShareAlert.___analyzing';
  if (['created', 'failed'].includes(dataset.state)) return 'CONSTANT.global.data.datasetShareAlert.___failed';
  return null;
};

var familyRelationOptions = [{
  title: 'CONSTANT.global.data.familyRelationOptions.title.___Father',
  value: 'Father',
  group: 'Father',
  sex: 'Male',
  limit: 1
}, {
  title: 'CONSTANT.global.data.familyRelationOptions.title.___Mother',
  value: 'Mother',
  group: 'Mother',
  sex: 'Female',
  limit: 1
}, {
  title: 'CONSTANT.global.data.familyRelationOptions.title.___Brother',
  value: 'Brother',
  group: 'Proband',
  sex: 'Male',
  limit: null
}, {
  title: 'CONSTANT.global.data.familyRelationOptions.title.___Sister',
  value: 'Sister',
  group: 'Proband',
  sex: 'Female',
  limit: null
}, {
  title: 'CONSTANT.global.data.familyRelationOptions.title.___PaternalGrandfather',
  value: 'Paternal Grandfather',
  group: 'Paternal Grandfather',
  sex: 'Male',
  limit: 1
}, {
  title: 'CONSTANT.global.data.familyRelationOptions.title.___PaternalGrandmother',
  value: 'Paternal Grandmother',
  group: 'Paternal Grandmother',
  sex: 'Female',
  limit: 1
}, {
  title: 'CONSTANT.global.data.familyRelationOptions.title.___MaternalGrandfather',
  value: 'Maternal Grandfather',
  group: 'Maternal Grandfather',
  sex: 'Male',
  limit: 1
}, {
  title: 'CONSTANT.global.data.familyRelationOptions.title.___MaternalGrandmother',
  value: 'Maternal Grandmother',
  group: 'Maternal Grandmother',
  sex: 'Female',
  limit: 1
}, {
  title: 'CONSTANT.global.data.familyRelationOptions.title.___PaternalUncle',
  value: 'Paternal Uncle',
  group: 'Father',
  sex: 'Male',
  limit: null
}, {
  title: 'CONSTANT.global.data.familyRelationOptions.title.___PaternalAunt',
  value: 'Paternal Aunt',
  group: 'Father',
  sex: 'Female',
  limit: null
}, {
  title: 'CONSTANT.global.data.familyRelationOptions.title.___MaternalUncle',
  value: 'Maternal Uncle',
  group: 'Mother',
  sex: 'Male',
  limit: null
}, {
  title: 'CONSTANT.global.data.familyRelationOptions.title.___MaternalAunt',
  value: 'Maternal Aunt',
  group: 'Mother',
  sex: 'Female',
  limit: null
}];

var svClinvarOptions = [{
  title: 'CONSTANT.global.data.svClinvarOptions.title.___Pathogenic',
  subtitle: 'CONSTANT.global.data.svClinvarOptions.subtitle.___Pathogenic',
  value: 'Pathogenic',
  countValue: 'dbvar_patho_count',
  color: '#FA3D3D',
  grid: 2,
  order: {
    'overview': 1,
    'table': 1
  }
}, {
  title: 'CONSTANT.global.data.svClinvarOptions.title.___Likely_Pathogenic',
  subtitle: 'CONSTANT.global.data.svClinvarOptions.subtitle.___Likely_Pathogenic',
  value: 'Likely_pathogenic',
  countValue: 'dbvar_likely_patho_count',
  color: '#FF9E03',
  grid: 3,
  order: {
    'overview': 2,
    'table': 3
  }
}, {
  title: 'CONSTANT.global.data.svClinvarOptions.title.___Benign',
  subtitle: 'CONSTANT.global.data.svClinvarOptions.subtitle.___Benign',
  value: 'Benign',
  countValue: 'dbvar_benign_count',
  color: '#003679',
  grid: 2,
  order: {
    'overview': 5,
    'table': 4
  }
}, {
  title: 'CONSTANT.global.data.svClinvarOptions.title.___Likely_Benign',
  subtitle: 'CONSTANT.global.data.svClinvarOptions.subtitle.___Likely_Benign',
  value: 'Likely_benign',
  countValue: 'dbvar_likely_benign_count',
  color: '#83C91E',
  grid: 2,
  order: {
    'overview': 4,
    'table': 2
  }
}, {
  title: 'CONSTANT.global.data.svClinvarOptions.title.___Variant_of_Uncertain_Significance',
  subtitle: 'CONSTANT.global.data.svClinvarOptions.subtitle.___Variant_of_Uncertain_Significance',
  value: 'Uncertain_significance',
  countValue: 'dbvar_uncertain_count',
  color: '#F8C600',
  bold: true,
  grid: 5,
  order: {
    'overview': 3,
    'table': 5
  }
}, {
  title: 'CONSTANT.global.data.svClinvarOptions.title.___Conflicting_interpretations_of_pathogenicity',
  subtitle: 'CONSTANT.global.data.svClinvarOptions.subtitle.___Conflicting_interpretations_of_pathogenicity',
  value: 'Conflicting_interpretations_of_pathogenicity',
  countValue: 'dbvar_conflict_count',
  grid: 7,
  hidden: true
}];

var svDECIPHEROptions = [{
  title: 'CONSTANT.global.data.svDECIPHEROptions.title.___Pathogenic',
  subtitle: 'CONSTANT.global.data.svDECIPHEROptions.subtitle.___Pathogenic',
  value: 'Pathogenic',
  countValue: 'decipher_patho_count',
  color: '#FA3D3D',
  grid: 2,
  order: {
    'overview': 1,
    'table': 1
  }
}, {
  title: 'CONSTANT.global.data.svDECIPHEROptions.title.___Likely_Pathogenic',
  subtitle: 'CONSTANT.global.data.svDECIPHEROptions.subtitle.___Likely_Pathogenic',
  value: 'Likely_pathogenic',
  countValue: 'decipher_likely_patho_count',
  color: '#FF9E03',
  grid: 3,
  order: {
    'overview': 2,
    'table': 3
  }
}, {
  title: 'CONSTANT.global.data.svDECIPHEROptions.title.___Benign',
  subtitle: 'CONSTANT.global.data.svDECIPHEROptions.subtitle.___Benign',
  value: 'Benign',
  countValue: 'decipher_benign_count',
  color: '#003679',
  grid: 2,
  order: {
    'overview': 5,
    'table': 4
  }
}, {
  title: 'CONSTANT.global.data.svDECIPHEROptions.title.___Likely_Benign',
  subtitle: 'CONSTANT.global.data.svDECIPHEROptions.subtitle.___Likely_Benign',
  value: 'Likely_benign',
  countValue: 'decipher_likely_benign_count',
  color: '#83C91E',
  grid: 2,
  order: {
    'overview': 4,
    'table': 2
  }
}, {
  title: 'CONSTANT.global.data.svDECIPHEROptions.title.___Uncertain_Significance',
  subtitle: 'CONSTANT.global.data.svDECIPHEROptions.subtitle.___Uncertain_Significance',
  value: 'Uncertain_significance',
  countValue: 'decipher_uncertain_count',
  color: '#F8C600',
  bold: true,
  grid: 3,
  order: {
    'overview': 3,
    'table': 5
  }
}, {
  title: 'CONSTANT.global.data.svDECIPHEROptions.title.___Others',
  subtitle: 'CONSTANT.global.data.svDECIPHEROptions.subtitle.___Others',
  value: 'Others',
  countValue: 'decipher_conflict_count',
  grid: 2,
  hidden: true
}];

var svDosageSensitivityOptions = [{
  title: 'CONSTANT.global.data.svDosageSensitivityOptions.title.___Sufficient_evidence_for_dosage_pathogenicity',
  value: 3,
  alert: true
}, {
  title: 'CONSTANT.global.data.svDosageSensitivityOptions.title.___Some_evidence_for_dosage_pathogenicity',
  value: 2,
  alert: true
}, {
  title: 'CONSTANT.global.data.svDosageSensitivityOptions.title.___Little_evidence_for_dosage_pathogenicity',
  value: 1,
  alert: true
}, {
  title: 'CONSTANT.global.data.svDosageSensitivityOptions.title.___No_evidence_for_dosage_pathogenicity',
  value: 0,
  alert: false
}, {
  title: 'CONSTANT.global.data.svDosageSensitivityOptions.title.___Evidence_suggests_the_gene_is_not_dosage_sensitive',
  value: 40,
  alert: false
}, {
  title: 'CONSTANT.global.data.svDosageSensitivityOptions.title.___Gene_associated_with_autosomal_recessive_phenotype',
  value: 30,
  alert: false
}];

var svGenotypeOptions = [{
  title: 'CONSTANT.global.data.svGenotypeOptions.title.___Homozygous_reference',
  value: 'Homozygous reference'
}, {
  title: 'CONSTANT.global.data.svGenotypeOptions.title.___Heterozygous',
  value: 'Heterozygous'
}, {
  title: 'CONSTANT.global.data.svGenotypeOptions.title.___Homozygous_alternate',
  value: 'Homozygous alternate'
}];

var svTypeOptions = [{
  title: 'CONSTANT.global.data.svTypeOptions.title.___DEL',
  value: 'Deletion',
  color: '#E37F72'
}, {
  title: 'CONSTANT.global.data.svTypeOptions.title.___INS',
  value: 'Insertion',
  color: '#77C474'
}, {
  title: 'CONSTANT.global.data.svTypeOptions.title.___DUP',
  value: 'Duplication',
  color: '#5DACE6'
}, {
  title: 'CONSTANT.global.data.svTypeOptions.title.___INV',
  value: 'Inversion',
  color: '#D5AF4A'
}, {
  title: 'CONSTANT.global.data.svTypeOptions.title.___CTX',
  value: 'Translocation',
  color: '#C359D1'
}, {
  title: 'CONSTANT.global.data.svTypeOptions.title.___CNV',
  value: 'Copy number variation',
  filter: false
}, {
  title: 'CONSTANT.global.data.svTypeOptions.title.___BND',
  value: 'Breakend',
  filter: false
}];

var strClassificationMap = {
  'Pathogenic': {
    title: 'CONSTANT.global.data.strClassificationMap.title.___Pathogenic',
    key: 'Pathogenic',
    color: '#FA3D3D',
    bold: false
  },
  'Indeterminate': {
    title: 'CONSTANT.global.data.strClassificationMap.title.___Indeterminate',
    key: 'Indeterminate',
    color: '#F8C600',
    bold: true
  },
  'Intermediate': {
    title: 'CONSTANT.global.data.strClassificationMap.title.___Intermediate',
    key: 'Intermediate',
    color: '#F8C600',
    bold: false
  },
  'Normal': {
    title: 'CONSTANT.global.data.strClassificationMap.title.___Normal',
    key: 'Normal',
    color: '#349CCF',
    bold: false
  },
  'RU mismatch': {
    title: 'CONSTANT.global.data.strClassificationMap.title.___RU_mismatch',
    key: 'RU mismatch',
    color: '#AAAAAA',
    bold: false
  },
  'Catalog mismatch': {
    title: 'CONSTANT.global.data.strClassificationMap.title.___Catalog_mismatch',
    key: 'Catalog mismatch',
    color: '#AAAAAA',
    bold: false
  }
};

var intractableDiseaseDifficutyMap = {
  0: {
    title: 'CONSTANT.global.data.intractableDiseaseDifficutyMap.title.___easy'
  },
  1: {
    title: 'CONSTANT.global.data.intractableDiseaseDifficutyMap.title.___hard'
  },
  2: {
    title: 'CONSTANT.global.data.intractableDiseaseDifficutyMap.title.___very_hard'
  }
};

var intractableDiseaseMethodMap = {
  'A': {
    title: 'CONSTANT.global.data.intractableDiseaseMethodMap.title.___A',
    symbol: 'CONSTANT.global.data.intractableDiseaseMethodMap.symbol.___A',
    info: 'CONSTANT.global.data.intractableDiseaseMethodMap.info.___A'
  },
  'I': {
    title: 'CONSTANT.global.data.intractableDiseaseMethodMap.title.___I',
    symbol: 'CONSTANT.global.data.intractableDiseaseMethodMap.symbol.___I',
    info: 'CONSTANT.global.data.intractableDiseaseMethodMap.info.___I'
  },
  'U': {
    title: 'CONSTANT.global.data.intractableDiseaseMethodMap.title.___U',
    symbol: 'CONSTANT.global.data.intractableDiseaseMethodMap.symbol.___U',
    info: 'CONSTANT.global.data.intractableDiseaseMethodMap.info.___U'
  },
  'E': {
    title: 'CONSTANT.global.data.intractableDiseaseMethodMap.title.___E',
    symbol: 'CONSTANT.global.data.intractableDiseaseMethodMap.symbol.___E',
    info: 'CONSTANT.global.data.intractableDiseaseMethodMap.info.___E'
  },
  'O': {
    title: 'CONSTANT.global.data.intractableDiseaseMethodMap.title.___O',
    symbol: 'CONSTANT.global.data.intractableDiseaseMethodMap.symbol.___O',
    info: 'CONSTANT.global.data.intractableDiseaseMethodMap.info.___O'
  }
};

var intractableDiseaseOptions = [
// D006-4
{
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Duchenne_muscular_dystrophy',
  value: 'Duchenne muscular dystrophy',
  type: 'D006-4',
  difficuty: 0,
  method: 'A',
  nandoID: 'NANDO:1200488',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4523'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01963']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Becker_muscular_dystrophy',
  value: 'Becker muscular dystrophy',
  type: 'D006-4',
  difficuty: 0,
  method: 'A',
  nandoID: 'NANDO:1200489',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4523'],
    other: ['https://www.genome.jp/entry/ds_ja:H01964']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Familial_amyloidosis',
  value: 'Familial amyloidosis',
  type: 'D006-4',
  difficuty: 0,
  method: 'A',
  nandoID: 'NANDO:1200214',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/207'],
    other: ['https://www.kegg.jp/dbget-bin/www_bget?H00845+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Spinal_and_bulbar_muscular_atrophy_SBMA',
  value: 'Spinal and bulbar muscular atrophy (SBMA)',
  type: 'D006-4',
  difficuty: 0,
  method: 'I',
  nandoID: 'NANDO:1200001',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/234'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00062']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Myotonic_dystrophy',
  value: 'Myotonic dystrophy',
  type: 'D006-4',
  difficuty: 0,
  method: 'U',
  nandoID: 'NANDO:1200495',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/529'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00568']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Lysosomal_storage_diseases_including_mucopolysaccharidosis_type_I_mucopolysaccharidosis_type_II_Gaucher_disease_Fabry_disease_and_Pompe_disease',
  value: 'Lysosomal storage diseases (including mucopolysaccharidosis type I, mucopolysaccharidosis type II, Gaucher disease, Fabry disease, and Pompe disease)',
  type: 'D006-4',
  difficuty: 0,
  method: 'E',
  nandoID: 'NANDO:1200055',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4061'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01425']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Fragile_X_syndrome',
  value: 'Fragile X syndrome',
  type: 'D006-4',
  difficuty: 0,
  method: 'E',
  nandoID: 'NANDO:1200692',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4613'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00465']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___TNF_receptor_associated_periodic_syndrome_TRAPS',
  value: 'TNF receptor-associated periodic syndrome (TRAPS)',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200472',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4034'],
    other: ['https://www.kegg.jp/entry/H00912+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Nakajo_Nishimura_syndrome',
  value: 'Nakajo-Nishimura syndrome',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200867',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4583'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Familial_Mediterranean_fever',
  value: 'Familial Mediterranean fever',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200863',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4448'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00288']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Bethlem_myopathy',
  value: 'Bethlem myopathy',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200220',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4006'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01340']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___X_linked_myopathy_with_excessive_autophagy',
  value: 'X-linked myopathy with excessive autophagy',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200223',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3824'],
    other: ['https://www.kegg.jp/entry/H01781+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Non_dystrophic_myotonia_syndromes',
  value: 'Non-dystrophic myotonia syndromes',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200496',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4520'],
    other: ['https://www.genome.jp/entry/ds_ja:H01780']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hereditary_periodic_limb_paralysis',
  value: 'Hereditary periodic (limb) paralysis',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200502',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4529'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00215']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Autosomal_recessive_leukodystrophy_with_alopecia_and_spondylometaphyseal_dysplasia',
  value: 'Autosomal recessive leukodystrophy with alopecia and spondylometaphyseal dysplasia',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200544',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4550'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01757']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Tuberous_sclerosis',
  value: 'Tuberous sclerosis',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200607',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4385'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00915']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pachydermoperiostosis',
  value: 'Pachydermoperiostosis',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200642',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4604'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00457']
  }
},
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Neurofibromatosis_Type_I',
//   value: 'Neurofibromatosis Type I',
//   type: 'D006-4',
//   difficuty: 0,
//   method: 'O',
//   nandoID: 'NANDO: 2201003',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/3992'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/ds_ja:H01437'
//     ]
//   }
// },
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Neurofibromatosis_Type_2',
//   value: 'Neurofibromatosis Type 2',
//   type: 'D006-4',
//   difficuty: 0,
//   method: 'O',
//   nandoID: 'NANDO:1200227',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/275'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/ds_ja:H01438'
//     ]
//   }
// },
{
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Alexander_disease',
  value: 'Alexander disease',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200554',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4346'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00065']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Chronic_non_specific_multiple_ulcers_of_the_small_intestine',
  value: 'Chronic non-specific multiple ulcers of the small intestine',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200902',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4709'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01853']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___TRPV4_related_disorder',
  value: 'TRPV4-related disorder',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1201098',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/28604'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Fukuyama_congenital_muscular_dystrophy',
  value: 'Fukuyama congenital muscular dystrophy',
  type: 'D006-4',
  difficuty: 1,
  method: 'A',
  nandoID: 'NANDO:1200494',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4523'],
    other: ['https://www.kegg.jp/dbget-bin/www_bget?ds_ja:H01957']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Spinal_muscular_atrophy',
  value: 'Spinal muscular atrophy',
  type: 'D006-4',
  difficuty: 1,
  method: 'A',
  nandoID: 'NANDO:1200003',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/285'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00455']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Huntingtons_disease',
  value: 'Huntington\'s disease',
  type: 'D006-4',
  difficuty: 1,
  method: 'I',
  nandoID: 'NANDO:1200012',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/318'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00059']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Retinoblastoma',
  value: 'Retinoblastoma',
  type: 'D006-4',
  difficuty: 1,
  method: 'I',
  nandoID: 'NANDO:2200042',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/2226'],
    other: ['https://www.kegg.jp/entry/H01513+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Medullary_thyroid_carcinoma',
  value: 'Medullary thyroid carcinoma',
  type: 'D006-4',
  difficuty: 1,
  method: 'I',
  nandoID: 'NANDO:2201054',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3308'],
    other: ['https://www.kegg.jp/entry/H01592+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Multiple_endocrine_neoplasia_type_1_MEN1',
  value: 'Multiple endocrine neoplasia type 1 (MEN1)',
  type: 'D006-4',
  difficuty: 1,
  method: 'I',
  nandoID: 'NANDO:2200405',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3308'],
    other: ['https://www.kegg.jp/entry/H01102+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Phenylketonuria_PKU',
  value: 'Phenylketonuria (PKU)',
  type: 'D006-4',
  difficuty: 1,
  method: 'U',
  nandoID: 'NANDO:1200784',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4748'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00167']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Homocystinuria',
  value: 'Homocystinuria',
  type: 'D006-4',
  difficuty: 1,
  method: 'U',
  nandoID: 'NANDO:1201038',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/22378'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00183']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Citrullinemia_type_I',
  value: 'Citrullinemia type I',
  type: 'D006-4',
  difficuty: 1,
  method: 'U',
  nandoID: 'NANDO:1200802',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5435'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00185']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Argininosuccinic_aciduria_Urea_cycle_disorder',
  value: 'Argininosuccinic aciduria (Urea cycle disorder)',
  type: 'D006-4',
  difficuty: 1,
  method: 'U',
  nandoID: 'NANDO:1200802',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4733'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00185']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Isovaleric_acidemia',
  value: 'Isovaleric acidemia',
  type: 'D006-4',
  difficuty: 1,
  method: 'U',
  nandoID: 'NANDO:1200798',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4817'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00173']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___HMG_CoA_lyase_deficiency',
  value: 'HMG-CoA lyase deficiency',
  type: 'D006-4',
  difficuty: 1,
  method: 'U',
  nandoID: 'NANDO:2200497',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/901'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Multiple_carboxylase_deficiency',
  value: 'Multiple carboxylase deficiency',
  type: 'D006-4',
  difficuty: 1,
  method: 'U',
  nandoID: 'NANDO:1200820',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4826'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00180']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Glutaric_acidemia_type_1',
  value: 'Glutaric acidemia type 1',
  type: 'D006-4',
  difficuty: 1,
  method: 'U',
  nandoID: 'NANDO:1200800',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4832'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00178']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___MCAD_deficiency_Medium_chain_acyl_CoA_dehydrogenase_deficiency',
  value: 'MCAD deficiency (Medium-chain acyl-CoA dehydrogenase deficiency)',
  type: 'D006-4',
  difficuty: 1,
  method: 'U',
  nandoID: 'NANDO:2200513',
  links: {
    center: ['https://www.shouman.jp/disease/details/08_03_045/'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00488']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___VLCAD_deficiency_Very_long_chain_acyl_CoA_dehydrogenase_deficiency',
  value: 'VLCAD deficiency (Very long-chain acyl-CoA dehydrogenase deficiency)',
  type: 'D006-4',
  difficuty: 1,
  method: 'U',
  nandoID: 'NANDO:1201109',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/28612'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00392']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___CPT1_deficiency_Carnitine_palmitoyltransferase_I_deficiency',
  value: 'CPT1 deficiency (Carnitine palmitoyltransferase I deficiency)',
  type: 'D006-4',
  difficuty: 1,
  method: 'U',
  nandoID: 'NANDO:1200969',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5429'],
    other: ['https://www.kegg.jp/entry/ds_ja:H02596']
  }
},
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Menkes_Disease_Congenital_disorder_of_copper_metabolism',
//   value: 'Menkes Disease (Congenital disorder of copper metabolism)',
//   type: 'D006-4',
//   difficuty: 1,
//   method: 'U',
//   nandoID: 'NANDO:1200653',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/4730'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/ds_ja:H00209'
//     ]
//   }
// },
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Occipital_Horn_Syndrome_Congenital_disorder_of_copper_metabolism',
//   value: 'Occipital Horn Syndrome (Congenital disorder of copper metabolism)',
//   type: 'D006-4',
//   difficuty: 1,
//   method: 'U',
//   nandoID: 'NANDO:1200654',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/4556'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/ds_ja:H01859'
//     ]
//   }
// },
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Wilson_Disease_Congenital_disorder_of_copper_metabolism',
//   value: 'Wilson Disease (Congenital disorder of copper metabolism)',
//   type: 'D006-4',
//   difficuty: 1,
//   method: 'U',
//   nandoID: 'NANDO:1200655',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/4544'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/ds_ja:H00210'
//     ]
//   }
// },
{
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cryopyrin_associated_periodic_syndromes_CAPS',
  value: 'Cryopyrin-associated periodic syndromes (CAPS)',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200465',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3995'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00282']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Neurodegeneration_with_brain_iron_accumulation_NBIA',
  value: 'Neurodegeneration with brain iron accumulation (NBIA)',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200542',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4808'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00833']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_cerebral_leukodystrophy_including_central_nervous_system_hypomyelination',
  value: 'Congenital cerebral leukodystrophy (including central nervous system hypomyelination)',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200575',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4887'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00679']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___PCDH19_related_disorder',
  value: 'PCDH19-related disorder',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200599',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4643'],
    other: ['https://www.genome.jp/entry/ds_ja:H01775']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hypophosphatasia',
  value: 'Hypophosphatasia',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200656',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4565'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00213']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Apert_syndrome',
  value: 'Apert syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200667',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4679'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01755']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Rothmund_Thomson_syndrome',
  value: 'Rothmund-Thomson syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200671',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4472'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01734']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Prader_Willi_syndrome',
  value: 'Prader-Willi syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200678',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4769'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00478']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Angelman_syndrome',
  value: 'Angelman syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200686',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4771'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01732']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Smith_Magenis_syndrome',
  value: 'Smith-Magenis syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200687',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4854'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01791']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Fragile_X_associated_disorders',
  value: 'Fragile X-associated disorders',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200690',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4616'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01731']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Wolfram_syndrome',
  value: 'Wolfram syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200757',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4790'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00854']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hyper_IgD_syndrome',
  value: 'Hyper IgD syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200866',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4751'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___PAPA_syndrome_Pyogenic_sterile_arthritis_pyoderma_gangrenosum_and_acne',
  value: 'PAPA syndrome (Pyogenic sterile arthritis, pyoderma gangrenosum, and acne)',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200868',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4796'],
    other: ['https://www.kegg.jp/entry/H00287+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_anomaly_syndromes',
  value: 'Congenital anomaly syndromes',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200957',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5501'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___ACTH_resistance_syndrome',
  value: 'ACTH resistance syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200777',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4358'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00256']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Autosomal_recessive_punctate_epiphyseal_dysplasia_type_1_Peroxisomal_diseases_excluding_adrenoleukodystrophy',
  value: 'Autosomal recessive punctate epiphyseal dysplasia type 1(Peroxisomal diseases (excluding adrenoleukodystrophy))',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200758',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4622'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00205']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Familial_partial_lipodystrophy',
  value: 'Familial partial lipodystrophy',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200861',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5333'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01475']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Sotos_syndrome',
  value: 'Sotos syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200679',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4778'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00718']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Carnitine_deficiency_Carnitine_palmitoyltransferase_II_deficiency',
  value: 'Carnitine deficiency (Carnitine palmitoyltransferase II deficiency)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200969',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5429'],
    other: ['https://www.kegg.jp/entry/ds_ja:H02596']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Carnitine_deficiency_Carnitine_acylcarnitine_translocase_deficiency',
  value: 'Carnitine deficiency (Carnitine-acylcarnitine translocase deficiency)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200969',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5429'],
    other: ['https://www.kegg.jp/entry/ds_ja:H02596']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Carnitine_deficiency_OCTN2_deficiency_Primary_carnitine_deficiency',
  value: 'Carnitine deficiency (OCTN2 deficiency (Primary carnitine deficiency))',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200969',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5429'],
    other: ['https://www.kegg.jp/entry/ds_ja:H02596']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Citrin_deficiency',
  value: 'Citrin deficiency',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200978',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5435'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00185']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Non_ketotic_hyperglycinemia',
  value: 'Non-ketotic hyperglycinemia',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200984',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5441'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00191']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Beta_ketothiolase_deficiency',
  value: 'Beta-ketothiolase deficiency',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200987',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5444'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01076']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___3_Methylglutaconic_aciduria',
  value: '3-Methylglutaconic aciduria',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200989',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5450'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00754']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Glutaric_acidemia_type_2',
  value: 'Glutaric acidemia type 2',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200801',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4820'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00178']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_adrenal_hypoplasia',
  value: 'Congenital adrenal hypoplasia',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200403',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3853'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01772']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___ATR_X_syndrome_Alpha_thalassemia_X_linked_intellectual_disability_syndrome',
  value: 'ATR-X syndrome (Alpha-thalassemia X-linked intellectual disability syndrome)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200665',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4433'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01752']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hutchinson_Gilford_progeria_syndrome',
  value: 'Hutchinson-Gilford progeria syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1201007',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/6014'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00601']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Achondroplasia',
  value: 'Achondroplasia',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200877',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4571'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01749']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Progressive_Myoclonic_Epilepsy_Lafora_disease',
  value: 'Progressive Myoclonic Epilepsy (Lafora disease)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200955',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5426'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00810']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Sepiapterin_reductase_SR_deficiency',
  value: 'Sepiapterin reductase (SR) deficiency',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200982',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5438'],
    other: ['https://www.kegg.jp/entry/ds_ja:H02597']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Aromatic_L_amino_acid_decarboxylase_deficiency',
  value: 'Aromatic L-amino acid decarboxylase deficiency',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200988',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5447'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01161']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Osler_disease_Hereditary_hemorrhagic_telangiectasia',
  value: 'Osler disease (Hereditary hemorrhagic telangiectasia)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200744',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4352'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00533']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___CFC_syndrome_Cardiofaciocutaneous_syndrome',
  value: 'CFC syndrome (Cardiofaciocutaneous syndrome)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200462',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4096'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01745']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Costello_syndrome',
  value: 'Costello syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200463',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4086'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01747']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___CHARGE_syndrome',
  value: 'CHARGE syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200464',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4139'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00556']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Lysinuric_protein_intolerance',
  value: 'Lysinuric protein intolerance',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200809',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4682'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00899']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Adrenoleukodystrophy',
  value: 'Adrenoleukodystrophy',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200165',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/329'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00176']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Blau_syndrome',
  value: 'Blau syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200476',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3827'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00285']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Branchio_oto_renal_syndrome',
  value: 'Branchio-oto-renal syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200675',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4388'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00453']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Young_Simpson_syndrome',
  value: 'Young-Simpson syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200681',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4760'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01793']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_nephrogenic_diabetes_insipidus',
  value: 'Congenital nephrogenic diabetes insipidus',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200742',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5538'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00252']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Vitamin_D_dependent_rickets_osteomalacia',
  value: 'Vitamin D-dependent rickets/osteomalacia',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200781',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4562'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01143']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Nail_patella_syndrome_LMX1B_associated_nephropathy',
  value: 'Nail-patella syndrome / LMX1B-associated nephropathy',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200966',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5471'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___GLUT1_deficiency_syndrome',
  value: 'GLUT1 deficiency syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200799',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4454'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00836']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Resistance_to_thyroid_hormone',
  value: 'Resistance to thyroid hormone',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200395',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/258'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00249']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Weaver_syndrome',
  value: 'Weaver syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200659',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4685'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01751']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Coffin_Lowry_syndrome',
  value: 'Coffin-Lowry syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200660',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4667'],
    other: ['https://www.kegg.jp/entry/H00574+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Mowat_Wilson_syndrome',
  value: 'Mowat-Wilson syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200663',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4595'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00908']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hepatic_glycogen_storage_diseases_types_I_III_VI_IXa_IXb_IXc_IV',
  value: 'Hepatic glycogen storage diseases (types I, III, VI, IXa, IXb, IXc, IV)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200838',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5330'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01760']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Myopathic_glycogen_storage_diseases_types_III_IV_IXd',
  value: 'Myopathic glycogen storage diseases (types III, IV, IXd)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200823',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4712'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01762']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_protein_C_deficiency',
  value: 'Congenital protein C deficiency',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1201080',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5420'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00223']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_protein_S_deficiency',
  value: 'Congenital protein S deficiency',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1201081',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5420'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00223']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_antithrombin_deficiency',
  value: 'Congenital antithrombin deficiency',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1201082',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5420'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01381']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Amyotrophic_lateral_sclerosis_ALS',
  value: 'Amyotrophic lateral sclerosis (ALS)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200002',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/214'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00058']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Distal_myopathy_with_rimmed_vacuoles',
  value: 'Distal myopathy with rimmed vacuoles',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200218',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4003'],
    other: ['https://www.kegg.jp/entry/H02586+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Schwartz_Jampel_syndrome',
  value: 'Schwartz-Jampel syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200224',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3958'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01777']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hypertrophic_cardiomyopathy',
  value: 'Hypertrophic cardiomyopathy',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200286',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/320'],
    other: ['https://www.kegg.jp/entry/H00292+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Familial_hypercholesterolemia_holmozygous',
  value: 'Familial hypercholesterolemia (holmozygous)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:2200602',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/226'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00155']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_myopathy',
  value: 'Congenital myopathy',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200477',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4727'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01810']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___CADASIL_Cerebral_autosomal_dominant_arteriopathy_with_subcortical_infarcts_and_leukoencephalopathy',
  value: 'CADASIL (Cerebral autosomal dominant arteriopathy with subcortical infarcts and leukoencephalopathy)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200545',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4445'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00536']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hereditary_diffuse_leukoencephalopathy_with_axonal_spheroids',
  value: 'Hereditary diffuse leukoencephalopathy with axonal spheroids',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200546',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4499'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01807']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_insensitivity_to_pain_with_anhidrosis',
  value: 'Congenital insensitivity to pain with anhidrosis',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200553',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4361'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01836']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Familial_benign_chronic_pemphigus_Hailey_Hailey_disease',
  value: 'Familial benign chronic pemphigus (Hailey-Hailey disease)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200631',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4490'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00844']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Nasu_Hakola_disease',
  value: 'Nasu-Hakola disease',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200658',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4257'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00438']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Carney_complex',
  value: 'Carney complex',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200756',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4754'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01820']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Peroxisome_biogenesis_disorder',
  value: 'Peroxisome biogenesis disorder',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200759',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4621'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00205']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Peroxisomal_beta_oxidation_enzyme_deficiency',
  value: 'Peroxisomal beta-oxidation enzyme deficiency',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200764',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4622'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00407']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Plasmalogen_synthesis_enzyme_deficiency',
  value: 'Plasmalogen synthesis enzyme deficiency',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200758',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4622'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Acatalasemia',
  value: 'Acatalasemia',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200774',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4622'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_hyperoxaluria_type_I',
  value: 'Primary hyperoxaluria type I',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200758',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4622'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00117']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Refsum_disease',
  value: 'Refsum disease',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200769',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4622'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00075']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hereditary_folate_malabsorption',
  value: 'Hereditary folate malabsorption',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200810',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4823'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01252']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Atypical_porphyria',
  value: 'Atypical porphyria',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200814',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5546'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01763']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_erythropoietic_porphyria',
  value: 'Congenital erythropoietic porphyria',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200817',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5546'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00201']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Acute_intermittent_porphyria',
  value: 'Acute intermittent porphyria',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200812',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5546'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00202']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Erythropoietic_protoporphyria',
  value: 'Erythropoietic protoporphyria',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200815',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5546'],
    other: ['https://www.kegg.jp/entry/H00201+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___X_linked_protoporphyria',
  value: 'X-linked protoporphyria',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200818',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5546'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hereditary_coproporphyria',
  value: 'Hereditary coproporphyria',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200813',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5546'],
    other: ['https://www.kegg.jp/entry/H00202+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Porphyria_cutanea_tarda',
  value: 'Porphyria cutanea tarda',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200816',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5546'],
    other: ['https://www.kegg.jp/entry/H00202+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hepatoerythropoietic_porphyria',
  value: 'Hepatoerythropoietic porphyria',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200819',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5546'],
    other: ['https://www.kegg.jp/entry/H00202+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_hyperchylomicronemia',
  value: 'Primary hyperchylomicronemia',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200855',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4884'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01784']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Abetalipoproteinemia',
  value: 'Abetalipoproteinemia',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200857',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4574'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00160']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Thanatophoric_dysplasia',
  value: 'Thanatophoric dysplasia',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200874',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4715'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01750']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hereditary_pancreatitis',
  value: 'Hereditary pancreatitis',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200921',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4781'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00933']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cystic_fibrosis',
  value: 'Cystic fibrosis',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200922',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4532'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00218']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Usher_syndrome_type_1_type_2_type_3',
  value: 'Usher syndrome (type 1, type 2, type 3)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200941',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4625'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00779']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Canavan_disease',
  value: 'Canavan disease',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200948',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5414'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00074']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_glycosylphosphatidylinositol_deficiency',
  value: 'Congenital glycosylphosphatidylinositol deficiency',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200983',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5411'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01489']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Osteopetrosis',
  value: 'Osteopetrosis',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200998',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5393'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00436']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cerebral_creatine_deficiency_syndrome',
  value: 'Cerebral creatine deficiency syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1201032',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/22426'],
    other: ['https://www.genome.jp/entry/ds_ja:H00849']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Nephronophthisis',
  value: 'Nephronophthisis',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1201036',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/22438'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00537']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Familial_hypobetalipoproteinemia_type_1_homozygous_form',
  value: 'Familial hypobetalipoproteinemia type 1 (homozygous form)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1201037',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/22449'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01270']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Progressive_familial_intrahepatic_cholestasis',
  value: 'Progressive familial intrahepatic cholestasis',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1201042',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/22459'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00624']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Nutritional_epidermolysis_bullosa',
  value: 'Nutritional epidermolysis bullosa',
  type: 'D006-4',
  difficuty: 2,
  method: 'A',
  nandoID: 'NANDO:1200234',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5339'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00587']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_long_QT_syndrome',
  value: 'Congenital long QT syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'A',
  nandoID: 'NANDO:2200228',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/2263'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00720']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Maple_syrup_urine_disease',
  value: 'Maple syrup urine disease',
  type: 'D006-4',
  difficuty: 2,
  method: 'U',
  nandoID: 'NANDO:1200791',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4814'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00172']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Methylmalonic_acidemia',
  value: 'Methylmalonic acidemia',
  type: 'D006-4',
  difficuty: 2,
  method: 'U',
  nandoID: 'NANDO:1200793',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4860'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00174']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Propionic_acidemia',
  value: 'Propionic acidemia',
  type: 'D006-4',
  difficuty: 2,
  method: 'U',
  nandoID: 'NANDO:1200792',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5324'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00175']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___3_Methylcrotonylglycinuria',
  value: '3-Methylcrotonylglycinuria',
  type: 'D006-4',
  difficuty: 2,
  method: 'U',
  nandoID: 'NANDO:2200495',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4826'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00181']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___MTP_LCHAD_deficiency_Triple_Enzyme_Deficiency',
  value: 'MTP (LCHAD) deficiency (Triple Enzyme Deficiency)',
  type: 'D006-4',
  difficuty: 2,
  method: 'U',
  nandoID: 'NANDO:1200974',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5432'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01352']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Xeroderma_pigmentosum',
  value: 'Xeroderma pigmentosum',
  type: 'D006-4',
  difficuty: 2,
  method: 'U',
  nandoID: 'NANDO:1200608',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/217'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01428']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Loeys_Dietz_syndrome',
  value: 'Loeys-Dietz syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'U',
  nandoID: 'NANDO:1200644',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/664'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00800']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Familial_thoracic_aortic_aneurysm_and_dissection',
  value: 'Familial thoracic aortic aneurysm and dissection',
  type: 'D006-4',
  difficuty: 2,
  method: 'U',
  nandoID: null,
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3306'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Neuroacanthocytosis',
  value: 'Neuroacanthocytosis',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200013',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4052'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00832']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_myasthenic_syndrome',
  value: 'Congenital myasthenic syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200021',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3997'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00770']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_immunodeficiency_syndrome',
  value: 'Primary immunodeficiency syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200320',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/254'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01725']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Perry_syndrome',
  value: 'Perry syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200547',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4703'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00879']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Crouzon_syndrome',
  value: 'Crouzon syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200666',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4673'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01754']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pfeiffer_syndrome',
  value: 'Pfeiffer syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200668',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4676'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01756']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Antley_Bixler_syndrome',
  value: 'Antley-Bixler syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200669',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4670'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01753']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Tangier_disease',
  value: 'Tangier disease',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200854',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4586'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00159']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_dyserythropoietic_anemia',
  value: 'Congenital dyserythropoietic anemia',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200885',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4364'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00917']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Early_onset_bilateral_sensorineural_hearing_loss',
  value: 'Early-onset bilateral sensorineural hearing loss',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200945',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4628'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01705']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Urea_cycle_disorder',
  value: 'Urea cycle disorder',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200802',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4733'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01398']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Marfan_syndrome_Loeys_Dietz_Syndrome',
  value: 'Marfan syndrome/Loeys-Dietz Syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200644',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4793'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00653']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Vascular_Ehlers_Danlos_syndrome',
  value: 'Vascular Ehlers-Danlos syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200645',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4802'],
    other: ['https://www.kegg.jp/entry/H02242+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hereditary_autoinflammatory_disease',
  value: 'Hereditary autoinflammatory disease',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200993',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5408'],
    other: ['https://www.kegg.jp/entry/H02599+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hereditary_dystonia',
  value: 'Hereditary dystonia',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200511',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4899'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00831']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Dravet_syndrome',
  value: 'Dravet syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1200587',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4745'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01818']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Coffin_Siris_syndrome',
  value: 'Coffin-Siris syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1200670',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4763'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01403']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Kabuki_syndrome',
  value: 'Kabuki syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1200672',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4664'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00570']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pulmonary_alveolar_proteinosis_autoimmune_or_congenital',
  value: 'Pulmonary alveolar proteinosis (autoimmune or congenital)',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1200746',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4775'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00217']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Noonan_syndrome',
  value: 'Noonan syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1200680',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4866'],
    other: ['https://www.genome.jp/entry/ds_ja:H00523']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Osteogenesis_imperfecta',
  value: 'Osteogenesis imperfecta',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1200873',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4568'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00506']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Spinocerebellar_degeneration_excluding_multiple_system_atrophy',
  value: 'Spinocerebellar degeneration (excluding multiple system atrophy)',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1200037',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4880'],
    other: ['https://www.kegg.jp/entry/ds_ja:H01616']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Classical_Ehlers_Danlos_syndrome',
  value: 'Classical Ehlers-Danlos syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1200646',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4802'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00802']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Atypical_hemolytic_uremic_syndrome_aHUS',
  value: 'Atypical hemolytic uremic syndrome (aHUS)',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1200473',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3847'],
    other: ['https://www.kegg.jp/entry/H01434+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Alport_syndrome',
  value: 'Alport syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1200712',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4349'],
    other: ['https://www.kegg.jp/entry/H00581+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Fanconi_anemia',
  value: 'Fanconi anemia',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1200891',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4442'],
    other: ['https://www.kegg.jp/entry/H00238+-ja']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Alagille_syndrome',
  value: 'Alagille syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1200918',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4845'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00551']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Rubinstein_Taybi_syndrome',
  value: 'Rubinstein-Taybi syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1200461',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4068'],
    other: ['https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00504']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_ciliary_dyskinesia_including_Kartagener_syndrome',
  value: 'Primary ciliary dyskinesia (including Kartagener syndrome)',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1201096',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/28601'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Proteinuria_group',
  value: 'Proteinuria group',
  type: 'D006-4',
  difficuty: -1,
  method: null,
  nandoID: 'NANDO: 3000005',
  links: {
    center: [],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cardiomyopathy_group',
  value: 'Cardiomyopathy group',
  type: 'D006-4',
  difficuty: -1,
  method: null,
  nandoID: 'NANDO: 3000004 ',
  links: {
    center: [],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Growth_disorder_intellectual_disability_and_characteristic_facial_features_group',
  value: 'Growth disorder, intellectual disability, and characteristic facial features group',
  type: 'D006-4',
  difficuty: -1,
  method: null,
  nandoID: 'NANDO: 3000002',
  links: {
    center: [],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Intellectual_disability_and_epilepsy_group',
  value: 'Intellectual disability and epilepsy group',
  type: 'D006-4',
  difficuty: -1,
  method: null,
  nandoID: 'NANDO: 3000003',
  links: {
    center: [],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Fever_inflammation_rash_and_osteoarticular_syndrome_group',
  value: 'Fever, inflammation, rash, and osteoarticular syndrome group',
  type: 'D006-4',
  difficuty: -1,
  method: null,
  nandoID: 'NANDO: 3000006',
  links: {
    center: [],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Muscle_weakness_group',
  value: 'Muscle weakness group',
  type: 'D006-4',
  difficuty: -1,
  method: null,
  nandoID: 'NANDO: 3000001',
  links: {
    center: [],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Rett_syndrome',
  value: 'Rett syndrome',
  type: 'D006-4',
  difficuty: 0,
  method: 'E',
  nandoID: 'NANDO: 1200603',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4367'],
    other: ['https://www.kegg.jp/entry/ds_ja:H00862']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Lowe_syndrome_oculocerebrorenal_syndrome',
  value: 'Lowe syndrome (oculocerebrorenal syndrome)',
  type: 'D006-4',
  difficuty: 0,
  method: 'E',
  nandoID: 'NANDO: 2200188',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/28624'],
    other: ['https://www.kegg.jp/entry/H00692']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Miyoshi_myopathy',
  value: 'Miyoshi myopathy',
  type: 'D006-4',
  difficuty: 0,
  method: 'E',
  nandoID: 'NANDO: 1200217',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4003'],
    other: ['https://identifiers.org/kegg.disease:H01965']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Lecithin_cholesterol_acyltransferase_LCAT_deficiency',
  value: 'Lecithin-cholesterol acyltransferase (LCAT) deficiency',
  type: 'D006-4',
  difficuty: 0,
  method: 'E',
  nandoID: 'NANDO:1200852',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4546'],
    other: ['https://identifiers.org/kegg.disease:H00158']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Sitosterolemia',
  value: 'Sitosterolemia',
  type: 'D006-4',
  difficuty: 0,
  method: 'E',
  nandoID: 'NANDO:1200853',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4857'],
    other: ['https://identifiers.org/kegg.disease:H00152']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pseudohypoparathyroidism',
  value: 'Pseudohypoparathyroidism',
  type: 'D006-4',
  difficuty: 0,
  method: 'E',
  nandoID: 'NANDO:1200776',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/233'],
    other: ['https://identifiers.org/kegg.disease:H00244']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Marinesco_Sjögren_syndrome',
  value: 'Marinesco-Sjögren syndrome',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200485',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4787'],
    other: ['https://identifiers.org/kegg.disease:H01284']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Galactose_1_phosphate_uridyltransferase_deficiency',
  value: 'Galactose-1-phosphate uridyltransferase deficiency',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200851',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4828'],
    other: ['https://identifiers.org/kegg.disease:H02008']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Fibrodysplasia_ossificans_progressiva_FOP',
  value: 'Fibrodysplasia ossificans progressiva (FOP)',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200871',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/54'],
    other: ['https://identifiers.org/kegg.disease:H00430']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Aniridia',
  value: 'Aniridia',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1201001',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5452'],
    other: ['https://identifiers.org/kegg.disease:H00635']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___PURA_related_neurodevelopmental_disorders',
  value: 'PURA-related neurodevelopmental disorders',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO: 2201405',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/28609'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Leber_hereditary_optic_neuropathy_LHON',
  value: 'Leber hereditary optic neuropathy (LHON)',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200940',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4661'],
    other: ['https://identifiers.org/kegg.disease:H00068']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Alveolar_hypoventilation_syndrome',
  value: 'Alveolar hypoventilation syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200751',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/172'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cerebrotendinous_xanthomatosis_CTX',
  value: 'Cerebrotendinous xanthomatosis (CTX)',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200856',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4619'],
    other: ['https://identifiers.org/kegg.disease:H00151']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Joubert_syndrome_and_related_disorders_JSRD',
  value: 'Joubert syndrome and related disorders (JSRD)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200661',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4552'],
    other: ['https://identifiers.org/kegg.disease:H00530']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Werner_syndrome',
  value: 'Werner syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200676',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5321'],
    other: ['https://identifiers.org/kegg.disease:H01733']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cockayne_syndrome',
  value: 'Cockayne syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200677',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4436'],
    other: ['https://identifiers.org/kegg.disease:H00076']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pseudoxanthoma_elasticum_PXE',
  value: 'Pseudoxanthoma elasticum (PXE)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200643',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4580'],
    other: ['https://identifiers.org/kegg.disease:H00560']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Diamond_Blackfan_anemia',
  value: 'Diamond-Blackfan anemia',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200890',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4421'],
    other: ['https://identifiers.org/kegg.disease:H00237']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___LMNB1_related_leukoencephalopathy_ADLD',
  value: 'LMNB1-related leukoencephalopathy (ADLD)',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1201107',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/28607'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_ichthyosis',
  value: 'Congenital ichthyosis',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200609',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/288'],
    other: ['https://identifiers.org/kegg.disease:H01771']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Oculocutaneous_albinism',
  value: 'Oculocutaneous albinism',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200637',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4493'],
    other: ['https://identifiers.org/kegg.disease:H00168']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___STING_stimulator_of_interferon_genes_associated_vasculopathy_with_onset_in_infancy',
  value: 'STING (stimulator of interferon genes)-associated vasculopathy with onset in infancy',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO: 2201487',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/28615'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Progressive_leukoencephalopathy',
  value: 'Progressive leukoencephalopathy',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200949',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5416'],
    other: ['https://identifiers.org/kegg.disease:H02598']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Charcot_Marie_Tooth_disease_CMT',
  value: 'Charcot-Marie-Tooth disease (CMT)',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200016',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3773'],
    other: ['https://identifiers.org/kegg.disease:H00264']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_adrenal_hyperplasia_congenital_adrenal_enzyme_deficiency',
  value: 'Congenital adrenal hyperplasia (congenital adrenal enzyme deficiency)',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1200396',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/185'],
    other: ['https://identifiers.org/kegg.disease:H00258']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hemorrhagic_disorders_due_to_abnormal_fibrinolysis',
  value: 'Hemorrhagic disorders due to abnormal fibrinolysis',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1201112',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/28622'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Mitochondrial_diseases',
  value: 'Mitochondrial diseases',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1200173',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/335'],
    other: ['https://www.kegg.jp/entry/H01427']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Epstein_syndrome',
  value: 'Epstein syndrome',
  type: 'D006-4',
  difficuty: 2,
  method: 'E',
  nandoID: 'NANDO:1200893',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4651'],
    other: ['https://www.kegg.jp/entry/H01427']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___neurofibromatosis',
  value: 'Neurofibromatosis',
  type: 'D006-4',
  difficuty: 0,
  method: 'O',
  nandoID: 'NANDO:1200225',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5361'],
    other: ['https://www.kegg.jp/entry/H01437']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___congenital_hearing_loss',
  value: 'Congenital hearing loss',
  type: 'D006-4',
  difficuty: 0,
  method: 'U',
  nandoID: 'NANDO:1200941',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4624'],
    other: ['https://www.kegg.jp/entry/H00779']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___prion_disease',
  value: 'Prion disease',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200186',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5370'],
    other: ['https://www.kegg.jp/entry/H00061']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___familial_idiopathic_basal_ganglia_calcification',
  value: 'Familial idiopathic basal ganglia calcification',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200208',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3838'],
    other: ['https://www.kegg.jp/entry/H01574']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___williams_syndrome',
  value: 'Williams syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200664',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4766'],
    other: ['https://identifiers.org/kegg.disease:H01439']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___1p36_deletion_syndrome',
  value: '1p36 deletion syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200682',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4496'],
    other: ['https://identifiers.org/kegg.disease:H01792']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___4p_deletion_syndrome',
  value: '4p deletion syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200683',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4805'],
    other: ['https://identifiers.org/kegg.disease:H01773']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___5p_deletion_syndrome',
  value: '5p deletion syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200684',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4863'],
    other: ['https://identifiers.org/kegg.disease:H00764']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___paternal_uniparental_disomy_of_chromosome_14',
  value: 'Paternal uniparental disomy of chromosome 14',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200685',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4688'],
    other: ['https://identifiers.org/kegg.disease:H01801']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___22q11_2_deletion_syndrome',
  value: '22q11.2 deletion syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200688',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5318'],
    other: ['https://identifiers.org/kegg.disease:H01525']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___unverricht_lundborg_disease',
  value: 'Unverricht-Lundborg disease',
  type: 'D006-4',
  difficuty: 1,
  method: 'O',
  nandoID: 'NANDO:1200954',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5426'],
    other: ['https://identifiers.org/kegg.disease:H01995']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___congenital_disorder_of_copper_metabolism',
  value: 'Congenital disorder of copper metabolism',
  type: 'D006-4',
  difficuty: 1,
  method: 'U',
  nandoID: null,
  links: {
    center: [],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___hereditary_sideroblastic_anemia',
  value: 'Hereditary sideroblastic anemia',
  type: 'D006-4',
  difficuty: 2,
  method: 'O',
  nandoID: 'NANDO:1200892',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4406'],
    other: ['https://identifiers.org/kegg.disease:H00982']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___ring_chromosome_20_syndrome',
  value: 'Ring chromosome 20 syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200597',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4577'],
    other: ['https://identifiers.org/kegg.disease:H01831']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___emanuel_syndrome',
  value: 'Emanuel syndrome',
  type: 'D006-4',
  difficuty: 1,
  method: 'E',
  nandoID: 'NANDO:1200689',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4610'],
    other: ['https://identifiers.org/kegg.disease:H01790']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___dermatofibrosarcoma_protuberans',
  value: 'Dermatofibrosarcoma protuberans',
  type: 'D006-4',
  difficuty: 1,
  method: 'U',
  nandoID: null,
  links: {
    center: [],
    other: []
  }
},
// default
{
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_lateral_sclerosis',
  value: 'Primary lateral sclerosis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200008',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/92'],
    other: ['https://www.kegg.jp/entry/H00970']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Progressive_supranuclear_palsy',
  value: 'Progressive supranuclear palsy',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200009',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4114'],
    other: ['https://www.kegg.jp/entry/H00077']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Parkinsons_disease',
  value: 'Parkinson\'s disease',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200010',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/169'],
    other: ['https://www.kegg.jp/entry/H00057']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Corticobasal_degeneration',
  value: 'Corticobasal degeneration',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200011',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/142'],
    other: ['https://www.kegg.jp/entry/H01600']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Charcot_Marie_Tooth_disease',
  value: 'Charcot-Marie-Tooth disease',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200016',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3773'],
    other: ['https://www.kegg.jp/entry/H00264']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Myasthenia_gravis',
  value: 'Myasthenia gravis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200020',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/120'],
    other: ['https://www.kegg.jp/entry/H01594']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Multiple_sclerosis_Neuromyelitis_optica_spectrum_disorders',
  value: 'Multiple sclerosis/Neuromyelitis optica spectrum disorders',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200022',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3806'],
    other: ['https://www.kegg.jp/entry/H01490']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Chronic_inflammatory_demyelinating_polyneuropathy_Multifocal_motor_neuropathy',
  value: 'Chronic inflammatory demyelinating polyneuropathy/Multifocal motor neuropathy',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200029',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4089'],
    other: ['https://www.kegg.jp/entry/H01527']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Sporadic_inclusion_body_myositis',
  value: 'Sporadic inclusion body myositis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200032',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3801'],
    other: ['https://www.kegg.jp/entry/H01505']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Multiple_system_atrophy',
  value: 'Multiple system atrophy',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200034',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5365'],
    other: ['https://www.kegg.jp/entry/H01614']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Moyamoya_disease',
  value: 'Moyamoya disease',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200183',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/47'],
    other: ['https://www.kegg.jp/entry/H01396']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pemphigus',
  value: 'Pemphigus',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200228',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/153'],
    other: ['https://www.kegg.jp/entry/H01648']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pustular_psoriasis',
  value: 'Pustular psoriasis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200240',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/168'],
    other: ['https://www.kegg.jp/entry/H01663']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Stevens_Johnson_syndrome',
  value: 'Stevens-Johnson syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200245',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4073'],
    other: ['https://www.kegg.jp/entry/H01694']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Toxic_epidermal_necrolysis',
  value: 'Toxic epidermal necrolysis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200246',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4036'],
    other: ['https://www.kegg.jp/entry/H01694']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Takayasu_arteritis',
  value: 'Takayasu arteritis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200251',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/141'],
    other: ['https://www.kegg.jp/entry/H01465']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Giant_cell_arteritis',
  value: 'Giant cell arteritis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200258',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3928'],
    other: ['https://www.kegg.jp/entry/H01698']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Polyarteritis_nodosa',
  value: 'Polyarteritis nodosa',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200261',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/85'],
    other: ['https://www.kegg.jp/entry/H01382']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Granulomatosis_with_polyangiitis',
  value: 'Granulomatosis with polyangiitis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200263',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4011'],
    other: ['https://www.kegg.jp/entry/H01655']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Systemic_lupus_erythematosus',
  value: 'Systemic lupus erythematosus',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200272',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/53'],
    other: ['https://www.kegg.jp/entry/H00080']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Systemic_sclerosis',
  value: 'Systemic sclerosis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200277',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4026'],
    other: ['https://www.kegg.jp/entry/H01492']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Behcets_disease',
  value: 'Behcet\'s disease',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200284',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/187'],
    other: ['https://www.kegg.jp/entry/H01476']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Idiopathic_dilated_cardiomyopathy',
  value: 'Idiopathic dilated cardiomyopathy',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200285',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3985'],
    other: ['https://www.kegg.jp/entry/H00294']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Restrictive_cardiomyopathy',
  value: 'Restrictive cardiomyopathy',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200292',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/100'],
    other: ['https://www.kegg.jp/entry/H01219']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Aplastic_anemia',
  value: 'Aplastic anemia',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200295',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/106'],
    other: ['https://www.kegg.jp/entry/H01132']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Paroxysmal_nocturnal_hemoglobinuria',
  value: 'Paroxysmal nocturnal hemoglobinuria',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200311',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3783'],
    other: ['https://www.kegg.jp/entry/H01053']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Immune_thrombocytopenia',
  value: 'Immune thrombocytopenia',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200315',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/157'],
    other: ['https://www.kegg.jp/entry/H01240']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Thrombotic_thrombocytopenic_purpura',
  value: 'Thrombotic thrombocytopenic purpura',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200316',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/87'],
    other: ['https://www.kegg.jp/entry/H00225']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___IgA_nephropathy',
  value: 'IgA nephropathy',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200366',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/41'],
    other: ['https://www.kegg.jp/entry/H01581']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Polycystic_kidney_disease',
  value: 'Polycystic kidney disease',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200367',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/146'],
    other: ['https://www.kegg.jp/entry/H00542']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Ossification_of_posterior_longitudinal_ligament',
  value: 'Ossification of posterior longitudinal ligament',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200371',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/98'],
    other: ['https://www.kegg.jp/entry/H00431']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Idiopathic_osteonecrosis_of_femoral_head',
  value: 'Idiopathic osteonecrosis of femoral head',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200373',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/160'],
    other: ['https://www.kegg.jp/entry/H01529']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Diencephalo_hypophysial_insufficiency_inappropriate_ADH_syndrome',
  value: 'Diencephalo-hypophysial insufficiency-inappropriate ADH syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200374',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3988'],
    other: ['https://www.kegg.jp/entry/H01683']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Diencephalo_hypophysial_insufficiency_inappropriate_thyroid_stimulating_hormone_syndrome',
  value: 'Diencephalo-hypophysial insufficiency-inappropriate thyroid stimulating hormone syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200377',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/64'],
    other: ['https://www.kegg.jp/entry/H01701']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Diencephalo_hypophysial_insufficiency_inappropriate_prolactin_syndrome',
  value: 'Diencephalo-hypophysial insufficiency-inappropriate prolactin syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200378',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4045'],
    other: ['https://www.kegg.jp/entry/H01388']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cushing_disease',
  value: 'Cushing disease',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200379',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/78'],
    other: ['https://www.kegg.jp/entry/H01431']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Diencephalo_hypophysial_dysfunction_syndrome_of_abnormal_secretion_of_gonadotropin',
  value: 'Diencephalo-hypophysial dysfunction-syndrome of abnormal secretion of gonadotropin',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200380',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4070'],
    other: ['https://www.kegg.jp/entry/H01860']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Diencephalo_hypophysial_dysfunction_syndrome_of_abnormal_secretion_of_growth_hormone',
  value: 'Diencephalo-hypophysial dysfunction-syndrome of abnormal secretion of growth hormone',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200386',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3922'],
    other: ['https://www.kegg.jp/entry/H01864']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hypopituitarism_syndrome',
  value: 'Hypopituitarism syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200387',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4017'],
    other: ['https://www.kegg.jp/entry/H01700']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_adrenal_enzyme_deficiency',
  value: 'Congenital adrenal enzyme deficiency',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200396',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/185'],
    other: ['https://www.kegg.jp/entry/H00258']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Addisons_disease',
  value: 'Addison\'s disease',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200411',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/44'],
    other: ['https://www.kegg.jp/entry/H01598']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Sarcoidosis',
  value: 'Sarcoidosis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200415',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/110'],
    other: ['https://www.kegg.jp/entry/H01309']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pulmonary_arterial_hypertension',
  value: 'Pulmonary arterial hypertension',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200425',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/171'],
    other: ['https://www.kegg.jp/entry/H01621']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pulmonary_veno_occlusive_disease_pulmonary_capillary_hemangiomatosis',
  value: 'Pulmonary veno-occlusive disease / pulmonary capillary hemangiomatosis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200426',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3868'],
    other: ['https://www.kegg.jp/entry/H01866']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Chronic_thromboembolic_pulmonary_hypertension',
  value: 'Chronic thromboembolic pulmonary hypertension',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200429',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/192'],
    other: ['https://www.kegg.jp/entry/H01622']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Lymphangioleiomyomatosis',
  value: 'Lymphangioleiomyomatosis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200430',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/173'],
    other: ['https://www.kegg.jp/entry/H00896']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Retinitis_pigmentosa',
  value: 'Retinitis pigmentosa',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200431',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/196'],
    other: ['https://www.kegg.jp/entry/H00527']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Budd_Chiari_syndrome',
  value: 'Budd-Chiari syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200437',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/174'],
    other: ['https://www.kegg.jp/entry/H01433']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_biliary_cholangitis',
  value: 'Primary biliary cholangitis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200439',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/93'],
    other: ['https://www.kegg.jp/entry/H01467']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_sclerosing_cholangitis',
  value: 'Primary sclerosing cholangitis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200440',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3967'],
    other: ['https://www.kegg.jp/entry/H01684']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Crohns_disease',
  value: 'Crohn\'s disease',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200444',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/81'],
    other: ['https://www.kegg.jp/entry/H00286']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Ulcerative_colitis',
  value: 'Ulcerative colitis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200449',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/62'],
    other: ['https://www.kegg.jp/entry/H01466']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Chronic_idiopathic_intestinal_pseudo_obstruction',
  value: 'Chronic idiopathic intestinal pseudo-obstruction',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200458',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3960'],
    other: ['https://www.kegg.jp/entry/H01276']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Megacystis_microcolon_intestinal_hypoperistalsis_syndrome',
  value: 'Megacystis-microcolon-intestinal hypoperistalsis syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200459',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4064'],
    other: ['https://www.kegg.jp/entry/H01869']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Juvenile_idiopathic_arthritis',
  value: 'Juvenile idiopathic arthritis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200469',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/3946'],
    other: ['https://www.kegg.jp/entry/H01672']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Marinesco_Sjogren_syndrome',
  value: 'Marinesco-Sjogren syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200485',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4786'],
    other: ['https://www.kegg.jp/entry/H01284']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Myelomeningocele',
  value: 'Myelomeningocele',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200509',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4633'],
    other: ['https://www.kegg.jp/entry/H00262']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Frontotemporal_lobar_degeneration',
  value: 'Frontotemporal lobar degeneration',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200548',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4840'],
    other: ['https://www.kegg.jp/entry/H00078']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Acute_encephalopathy_with_biphasic_seizures_and_late_reduced_diffusion',
  value: 'Acute encephalopathy with biphasic seizures and late reduced diffusion',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200552',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4513'],
    other: ['https://www.kegg.jp/entry/H01841']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Moebius_syndrome',
  value: 'Moebius syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200559',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5326'],
    other: ['https://www.kegg.jp/entry/H01840']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Septo_optic_dysplasia_De_Morsier_syndrome',
  value: 'Septo-optic dysplasia / De Morsier syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200560',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4402'],
    other: ['https://www.kegg.jp/entry/H00544']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Aicardi_syndrome',
  value: 'Aicardi syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200562',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4393'],
    other: ['https://www.kegg.jp/entry/H01776']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hemimegalencephaly',
  value: 'Hemimegalencephaly',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200563',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4783'],
    other: ['https://www.kegg.jp/entry/H01833']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Focal_cortical_dysplasia',
  value: 'Focal cortical dysplasia',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200564',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4456'],
    other: ['https://www.kegg.jp/entry/H01251']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Neuronal_migration_defects',
  value: 'Neuronal migration defects',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200574',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4396'],
    other: ['https://www.kegg.jp/entry/H01835']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Epilepsy_with_myoclonic_atonic_seizures',
  value: 'Epilepsy with myoclonic atonic seizures',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200590',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4417'],
    other: ['https://www.kegg.jp/entry/H01823']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Lennox_Gastaut_syndrome',
  value: 'Lennox-Gastaut syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200591',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4889'],
    other: ['https://www.kegg.jp/entry/H01813']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___West_syndrome',
  value: 'West syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200592',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4414'],
    other: ['https://www.kegg.jp/entry/H01460']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Ohtahara_syndrome',
  value: 'Ohtahara syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200593',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4381'],
    other: ['https://www.kegg.jp/entry/H00606']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Early_myoclonic_encephalopathy',
  value: 'Early myoclonic encephalopathy',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200594',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4705'],
    other: ['https://www.kegg.jp/entry/H01819']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Epilepsy_of_infancy_with_migrating_focal_seizures',
  value: 'Epilepsy of infancy with migrating focal seizures',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200595',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4717'],
    other: ['https://www.kegg.jp/entry/H01815']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hemiconvulsion_hemiplegia_epilepsy_syndrome',
  value: 'Hemiconvulsion-hemiplegia-epilepsy syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200596',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4408'],
    other: ['https://www.kegg.jp/entry/H01808']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Rasmussens_encephalitis',
  value: 'Rasmussen\'s encephalitis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200598',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4339'],
    other: ['https://www.kegg.jp/entry/H01812']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Developmental_and_or_epileptic_encephalopathy_with_spike_wave_activation_in_sleep',
  value: 'Developmental and/or epileptic encephalopathy with spike-wave activation in sleep',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200601',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4654'],
    other: ['https://www.kegg.jp/entry/H01827']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Landau_Kleffner_syndrome',
  value: 'Landau-Kleffner syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200602',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4411'],
    other: ['https://www.kegg.jp/entry/H01514']
  }
},
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Rett_syndrome',
//   value: 'Rett syndrome',
//   type: 'default',
//   difficuty: null,
//   method: null,
//   nandoID: 'NANDO:1200603',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/4366'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/H00440'
//     ]
//   }
// },
{
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Sturge_Weber_syndrome',
  value: 'Sturge-Weber syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200606',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4307'],
    other: ['https://www.kegg.jp/entry/H01809']
  }
},
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_ichthyosis',
//   value: 'Congenital ichthyosis',
//   type: 'default',
//   difficuty: null,
//   method: null,
//   nandoID: 'NANDO:1200609',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/139'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/H01771'
//     ]
//   }
// },
{
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pemphigoid_including_Epidermolysis_bullosa_acquisita',
  value: 'Pemphigoid (including Epidermolysis bullosa acquisita)',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200632',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4525'],
    other: ['https://www.kegg.jp/entry/H01650']
  }
},
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Oculocutaneous_albinism',
//   value: 'Oculocutaneous albinism',
//   type: 'default',
//   difficuty: null,
//   method: null,
//   nandoID: 'NANDO:1200637',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/4492'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/H00168'
//     ]
//   }
// },
{
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pseudoxanthoma_elasticum',
  value: 'Pseudoxanthoma elasticum',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200643',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4579'],
    other: ['https://www.kegg.jp/entry/H00560']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___VATER_syndrome',
  value: 'VATER syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200657',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4850'],
    other: ['https://www.kegg.jp/entry/H01195']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Joubert_syndrome_and_related_disorders',
  value: 'Joubert syndrome and related disorders',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200661',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4552'],
    other: ['https://www.kegg.jp/entry/H00530']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Polysplenia_syndrome',
  value: 'Polysplenia syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200673',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5335'],
    other: ['https://www.kegg.jp/entry/H01764']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Asplenia_syndrome',
  value: 'Asplenia syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200674',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5341'],
    other: ['https://www.kegg.jp/entry/H01435']
  }
},
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Werner_syndrome',
//   value: 'Werner syndrome',
//   type: 'default',
//   difficuty: null,
//   method: null,
//   nandoID: 'NANDO:1200676',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/5320'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/H01733'
//     ]
//   }
// },
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cockayne_syndrome',
//   value: 'Cockayne syndrome',
//   type: 'default',
//   difficuty: null,
//   method: null,
//   nandoID: 'NANDO:1200677',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/4435'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/H00076'
//     ]
//   }
// },
{
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Truncus_arteriosus_communis',
  value: 'Truncus arteriosus communis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200693',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4895'],
    other: ['https://www.kegg.jp/entry/H01736']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Corrected_transposition_of_great_arteries',
  value: 'Corrected transposition of great arteries',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200698',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4474'],
    other: ['https://www.kegg.jp/entry/H01786']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Complete_transposition_of_the_great_arteries',
  value: 'Complete transposition of the great arteries',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200699',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4477'],
    other: ['https://www.kegg.jp/entry/H00550']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hypoplastic_left_heart_syndrome',
  value: 'Hypoplastic left heart syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200705',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4372'],
    other: ['https://www.kegg.jp/entry/H01272']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Tetralogy_of_Fallot',
  value: 'Tetralogy of Fallot',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200709',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4741'],
    other: ['https://www.kegg.jp/entry/H00549']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Double_outlet_right_ventricle',
  value: 'Double outlet right ventricle',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200710',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4873'],
    other: ['https://www.kegg.jp/entry/H00918']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Ebsteins_anomaly',
  value: 'Ebstein\'s anomaly',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200711',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4486'],
    other: ['https://www.kegg.jp/entry/H01783']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Galloway_Mowat_syndrome',
  value: 'Galloway-Mowat syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200713',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4468'],
    other: ['https://www.kegg.jp/entry/H01722']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_nephrotic_syndrome',
  value: 'Primary nephrotic syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200719',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4516'],
    other: ['https://www.kegg.jp/entry/H01657']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_membranoproliferative_glomerulonephritis',
  value: 'Primary membranoproliferative glomerulonephritis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200725',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4423'],
    other: ['https://www.kegg.jp/entry/H01726']
  }
},
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Alveolar_hypoventilation_syndrome',
//   value: 'Alveolar hypoventilation syndrome',
//   type: 'default',
//   difficuty: null,
//   method: null,
//   nandoID: 'NANDO:1200751',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/172'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/H01727'
//     ]
//   }
// },
{
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Alpha_1_antitrypsin_deficiency',
  value: 'Alpha-1-antitrypsin deficiency',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200755',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4738'],
    other: ['https://www.kegg.jp/entry/H01103']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hypoparathyroidism',
  value: 'Hypoparathyroidism',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200775',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4426'],
    other: ['https://www.kegg.jp/entry/H01862']
  }
},
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pseudohypoparathyroidism',
//   value: 'Pseudohypoparathyroidism',
//   type: 'default',
//   difficuty: null,
//   method: null,
//   nandoID: 'NANDO:1200776',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/72'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/H00244'
//     ]
//   }
// },
{
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Vitamin_D_resistant_rickets_Vitamin_D_resistant_osteomalacia',
  value: 'Vitamin D-resistant rickets/Vitamin D-resistant osteomalacia',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200778',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4558'],
    other: ['https://www.kegg.jp/entry/H00214']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Tyrosinemia_type_1',
  value: 'Tyrosinemia type 1',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200788',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4690'],
    other: ['https://www.kegg.jp/entry/H00165']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Tyrosinemia_type_2',
  value: 'Tyrosinemia type 2',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200789',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4693'],
    other: ['https://www.kegg.jp/entry/H00165']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Tyrosinemia_type_3',
  value: 'Tyrosinemia type 3',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200790',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4696'],
    other: ['https://www.kegg.jp/entry/H00165']
  }
},
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Galactose_1_phosphate_uridyltransferase_deficiency',
//   value: 'Galactose-1-phosphate uridyltransferase deficiency',
//   type: 'default',
//   difficuty: null,
//   method: null,
//   nandoID: 'NANDO:1200851',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/4828'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/H00070'
//     ]
//   }
// },
{
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Lecithin_cholesterol_acyltransferase_deficiency',
  value: 'Lecithin cholesterol acyltransferase deficiency',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200852',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4546'],
    other: ['https://www.kegg.jp/entry/H00158']
  }
},
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Sitosterolemia',
//   value: 'Sitosterolemia',
//   type: 'default',
//   difficuty: null,
//   method: null,
//   nandoID: 'NANDO:1200853',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/4856'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/H00152'
//     ]
//   }
// },
{
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cerebrotendinous_xanthomatosis',
  value: 'Cerebrotendinous xanthomatosis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200856',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4618'],
    other: ['https://www.kegg.jp/entry/H00151']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Chronic_recurrent_multifocal_osteomyelitis',
  value: 'Chronic recurrent multifocal osteomyelitis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200869',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4465'],
    other: ['https://www.kegg.jp/entry/H01117']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Ankylosing_spondylitis',
  value: 'Ankylosing spondylitis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200870',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4847'],
    other: ['https://www.kegg.jp/entry/H01674']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Fibrodysplasia_ossificans_progressiva',
  value: 'Fibrodysplasia ossificans progressiva',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200871',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/54'],
    other: ['https://www.kegg.jp/entry/H00430']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_scoliosis_with_rib_anomalies',
  value: 'Congenital scoliosis with rib anomalies',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200872',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4645'],
    other: ['https://www.kegg.jp/entry/H01851']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Giant_lymphatic_malformation_cervicofacial_lesion',
  value: 'Giant lymphatic malformation (cervicofacial lesion)',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200881',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4892'],
    other: ['https://www.kegg.jp/entry/H01471']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Giant_venous_malformation_cervical_oral_and_oropharyngeal_diffuse_lesion',
  value: 'Giant venous malformation (cervical, oral and oropharyngeal diffuse lesion)',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200882',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4756'],
    other: ['https://www.kegg.jp/entry/H00531']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Klippel_Trenaunay_Weber_syndrome',
  value: 'Klippel-Trenaunay-Weber syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200884',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4600'],
    other: ['https://www.kegg.jp/entry/H01788']
  }
},
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Diamond_Blackfan_anemia',
//   value: 'Diamond-Blackfan anemia',
//   type: 'default',
//   difficuty: null,
//   method: null,
//   nandoID: 'NANDO:1200890',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/4420'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/H00237'
//     ]
//   }
// },
{
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hirschsprung_disease',
  value: 'Hirschsprung disease',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200903',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4699'],
    other: ['https://www.kegg.jp/entry/H00910']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_diaphragmatic_hernia',
  value: 'Congenital diaphragmatic hernia',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200911',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4510'],
    other: ['https://www.kegg.jp/entry/H01241']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Biliary_atresia',
  value: 'Biliary atresia',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200913',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4735'],
    other: ['https://www.kegg.jp/entry/H01855']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Macular_dystrophy',
  value: 'Macular dystrophy',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1200931',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/4798'],
    other: ['https://www.kegg.jp/entry/H01770']
  }
},
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Progressive_leukoencephalopathy',
//   value: 'Progressive leukoencephalopathy',
//   type: 'default',
//   difficuty: null,
//   method: null,
//   nandoID: 'NANDO:1200949',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/5416'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/H02598'
//     ]
//   }
// },
{
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Anterior_segment_dysgenesis',
  value: 'Anterior segment dysgenesis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1201000',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5455'],
    other: ['https://www.kegg.jp/entry/H01159']
  }
},
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Aniridia',
//   value: 'Aniridia',
//   type: 'default',
//   difficuty: null,
//   method: null,
//   nandoID: 'NANDO:1201001',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/5452'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/H00635'
//     ]
//   }
// },
{
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Idiopathic_multicentric_Castlemans_disease',
  value: 'Idiopathic multicentric Castleman\'s disease',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1201005',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/5749'],
    other: ['https://www.kegg.jp/entry/H01479']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Gelatinous_drop_like_corneal_dystrophy',
  value: 'Gelatinous drop-like corneal dystrophy',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1201006',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/6016'],
    other: ['https://www.kegg.jp/entry/H00953']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___MECP2_Duplication_Syndrome',
  value: 'MECP2 Duplication Syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1201095',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/28597'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Autosomal_Dominant_Adult_Onset_Demyelinating_Leukodystrophy',
  value: 'Autosomal Dominant Adult-Onset Demyelinating Leukodystrophy',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1201107',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/28606'],
    other: ['https://www.kegg.jp/entry/H01230']
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___PURA_related_severe_neonatal_hypotonia_seizures_encephalopathy_syndrome',
  value: 'PURA-related severe neonatal hypotonia-seizures-encephalopathy syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1201108',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/28609'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___very_long_chain_acyl_CoA_dehydrogenase',
  value: 'very long-chain acyl-CoA dehydrogenase',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1201109',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/28612'],
    other: []
  }
},
// {
//   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___STING_stimulator_of_interferon_genes_associated_vasculopathy_with_onset_in_infancy',
//   value: 'STING (stimulator of interferon genes)-associated vasculopathy with onset in infancy',
//   type: 'default',
//   difficuty: null,
//   method: null,
//   nandoID: 'NANDO:1201110',
//   links: {
//     center: [
//       'https://www.nanbyou.or.jp/entry/28615'
//     ],
//     other: [
//       'https://www.kegg.jp/entry/H01746'
//     ]
//   }
// },
{
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Bleeding_disorder_with_abnormal_fibrinolysis',
  value: 'Bleeding disorder with abnormal fibrinolysis',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1201112',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/28621'],
    other: []
  }
}, {
  title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Lowe_syndrome',
  value: 'Lowe syndrome',
  type: 'default',
  difficuty: null,
  method: null,
  nandoID: 'NANDO:1201116',
  links: {
    center: ['https://www.nanbyou.or.jp/entry/28624'],
    other: ['https://www.kegg.jp/entry/H00692']
  }
}];

var workgroupRoleOptions = [{
  title: 'CONSTANT.global.data.workgroupRoleOptions.title.___owner',
  value: 'Owner',
  editable: ['Director', 'Member']
}, {
  title: 'CONSTANT.global.data.workgroupRoleOptions.title.___director',
  value: 'Director',
  editable: ['Director', 'Member']
}, {
  title: 'CONSTANT.global.data.workgroupRoleOptions.title.___member',
  value: 'Member',
  editable: []
}];

var licenseApiMap = __WEBPACK_IMPORTED_MODULE_8__config__["a" /* _LOCAL_BUILD */] ? {
  'vcf_analysis': 'CONSTANT.global.data.licenseApiMap.title.___vcf_analysis',
  'fastq_analysis': 'CONSTANT.global.data.licenseApiMap.title.___fastq_analysis',
  'report_module': 'CONSTANT.global.data.licenseApiMap.title.___report_module'
} : {
  'mastermind': 'CONSTANT.global.data.licenseApiMap.title.___mastermind'
};

var licenseStatusMap = {
  'inactive': 'CONSTANT.global.data.licenseStatusMap.title.___inactive',
  'active': 'CONSTANT.global.data.licenseStatusMap.title.___active',
  'exceeded': 'CONSTANT.global.data.licenseStatusMap.title.___exceeded',
  'expired': 'CONSTANT.global.data.licenseStatusMap.title.___expired',
  'unlimited': 'CONSTANT.global.data.licenseStatusMap.title.___unlimited'
};

/***/ }),

/***/ "x9yG":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDI0IDMwIj4KICA8ZyBpZD0iSGVtYXRvbG9neSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyMjEgNDIxKSI+CiAgICA8cGF0aCBpZD0i44OR44K5XzEwIiBkYXRhLW5hbWU9IuODkeOCuSAxMCIgZD0iTTc3LjA3NiwxMS4zMTlhMS4yOTQsMS4yOTQsMCwwLDAtMS43NTgsMGMtLjQ1LjQyMi0xMS4xMTgsMTAuNC0xMS4xMTgsMTcuMTA1LDAsNi45MTgsNS4zODEsMTIuNTUsMTIsMTIuNTVzMTItNS42MzIsMTItMTIuNTVjMC02LjctMTAuNjY3LTE2LjY4My0xMS4xMjQtMTcuMTA1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTE1Ni44MDEgLTQzMS45NzUpIiBmaWxsPSIjZmZmIi8+CiAgICA8cGF0aCBpZD0i44OR44K5XzExIiBkYXRhLW5hbWU9IuODkeOCuSAxMSIgZD0iTTAsMEE2Ljc4Nyw2Ljc4NywwLDAsMCw2LjI4Miw2LjgzMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIyNy43NTQgLTQwNy45NzUpIHJvdGF0ZSg0NSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMzY3OSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "xMCn":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTcuODU3LDUySDIuMTQzQTIuMTQzLDIuMTQzLDAsMCwxLDAsNDkuODU3VjM0LjE0M0EyLjE0MywyLjE0MywwLDAsMSwyLjE0MywzMkgxNy44NTdBMi4xNDMsMi4xNDMsMCwwLDEsMjAsMzQuMTQzVjQ5Ljg1N0EyLjE0MywyLjE0MywwLDAsMSwxNy44NTcsNTJaTTguNzE5LDQ3LjYyMmw4LjIxNC04LjIxNGEuNzE0LjcxNCwwLDAsMCwwLTEuMDFsLTEuMDEtMS4wMWEuNzE0LjcxNCwwLDAsMC0xLjAxLDBsLTYuNyw2LjdMNS4wODcsNDAuOTU5YS43MTQuNzE0LDAsMCwwLTEuMDEsMGwtMS4wMSwxLjAxYS43MTQuNzE0LDAsMCwwLDAsMS4wMWw0LjY0Myw0LjY0M0EuNzE0LjcxNCwwLDAsMCw4LjcxOSw0Ny42MjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMikiIGZpbGw9IiNmYTNkM2QiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "xccc":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzM0MzIiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDM0MzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTg3IC0xNTM5KSI+CiAgICA8ZyBpZD0i6ZW35pa55b2iXzE0OCIgZGF0YS1uYW1lPSLplbfmlrnlvaIgMTQ4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOTg3IDE1MzkpIiBmaWxsPSIjZmZmIiBzdHJva2U9IiMzMzMiIHN0cm9rZS13aWR0aD0iMSI+CiAgICAgIDxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcng9IjEwIiBzdHJva2U9Im5vbmUiLz4KICAgICAgPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSIgcng9IjkuNSIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogICAgPGcgaWQ9IuOCsOODq+ODvOODl18zOTUyIiBkYXRhLW5hbWU9IuOCsOODq+ODvOODlyAzOTUyIj4KICAgICAgPGNpcmNsZSBpZD0i5qWV5YaG5b2iXzEyMyIgZGF0YS1uYW1lPSLmpZXlhoblvaIgMTIzIiBjeD0iOSIgY3k9IjkiIHI9IjkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5ODggMTU0MCkiIGZpbGw9IiM4M2M5MWUiLz4KICAgICAgPGcgaWQ9IualleWGhuW9ol8xNTMiIGRhdGEtbmFtZT0i5qWV5YaG5b2iIDE1MyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk5MyAxNTQ1KSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjMzMzIiBzdHJva2Utd2lkdGg9IjEiPgogICAgICAgIDxjaXJjbGUgY3g9IjQiIGN5PSI0IiByPSI0IiBzdHJva2U9Im5vbmUiLz4KICAgICAgICA8Y2lyY2xlIGN4PSI0IiBjeT0iNCIgcj0iMy41IiBmaWxsPSJub25lIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "xg5u":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTcuODU3LDUySDIuMTQzQTIuMTQzLDIuMTQzLDAsMCwxLDAsNDkuODU3VjM0LjE0M0EyLjE0MywyLjE0MywwLDAsMSwyLjE0MywzMkgxNy44NTdBMi4xNDMsMi4xNDMsMCwwLDEsMjAsMzQuMTQzVjQ5Ljg1N0EyLjE0MywyLjE0MywwLDAsMSwxNy44NTcsNTJaTTguNzE5LDQ3LjYyMmw4LjIxNC04LjIxNGEuNzE0LjcxNCwwLDAsMCwwLTEuMDFsLTEuMDEtMS4wMWEuNzE0LjcxNCwwLDAsMC0xLjAxLDBsLTYuNyw2LjdMNS4wODcsNDAuOTU5YS43MTQuNzE0LDAsMCwwLTEuMDEsMGwtMS4wMSwxLjAxYS43MTQuNzE0LDAsMCwwLDAsMS4wMWw0LjY0Myw0LjY0M0EuNzE0LjcxNCwwLDAsMCw4LjcxOSw0Ny42MjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMikiIGZpbGw9IiM3MTQ4OTQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "z0Pm":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0i6ZW35pa55b2iXzE0OCIgZGF0YS1uYW1lPSLplbfmlrnlvaIgMTQ4IiBmaWxsPSIjZmZmIiBzdHJva2U9IiMzMzMiIHN0cm9rZS13aWR0aD0iMSI+CiAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIxMCIgc3Ryb2tlPSJub25lIi8+CiAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjE5IiBoZWlnaHQ9IjE5IiByeD0iOS41IiBmaWxsPSJub25lIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "z3W2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0ibWludXMtY2lyY2xlLXNvbGlkIiBkPSJNMTgsOEExMCwxMCwwLDEsMCwyOCwxOCwxMCwxMCwwLDAsMCwxOCw4Wk0xMi42NzcsMTkuNjEzYS40ODUuNDg1LDAsMCwxLS40ODQtLjQ4NFYxNi44NzFhLjQ4NS40ODUsMCwwLDEsLjQ4NC0uNDg0SDIzLjMyM2EuNDg1LjQ4NSwwLDAsMSwuNDg0LjQ4NHYyLjI1OGEuNDg1LjQ4NSwwLDAsMS0uNDg0LjQ4NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04IC04KSIgZmlsbD0iI2ZhM2QzZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "zSkq":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS41IiBoZWlnaHQ9IjE1LjUiIHZpZXdCb3g9IjAgMCAxNS41IDE1LjUiPgogIDxwYXRoIGlkPSJzZWFyY2gtbGlnaHQiIGQ9Ik0xNC45LDE0LjEwOSwxMS4xMTgsMTAuMzNhLjM0OC4zNDgsMCwwLDAtLjI0OS0uMWgtLjNhNi4wMzIsNi4wMzIsMCwxLDAtLjM0LjM0M3YuM2EuMzYuMzYsMCwwLDAsLjEuMjQ5TDE0LjEwOSwxNC45YS4zNTIuMzUyLDAsMCwwLC41LDBsLjI5LS4yOUEuMzUyLjM1MiwwLDAsMCwxNC45LDE0LjEwOVptLTguOC0yLjg1OWE1LjE1Niw1LjE1NiwwLDEsMSw1LjE1Ni01LjE1NkE1LjE1Miw1LjE1MiwwLDAsMSw2LjA5MywxMS4yNDlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjI1IDAuMjUpIiBmaWxsPSIjMDAzNjc5IiBzdHJva2U9IiMwMDM2NzkiIHN0cm9rZS13aWR0aD0iMC41Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "zVZS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/api/index.js
var api = __webpack_require__("gyMJ");

// EXTERNAL MODULE: ./src/mixins/toastMethods.vue + 1 modules
var toastMethods = __webpack_require__("2PDt");

// EXTERNAL MODULE: ./src/mixins/loginData.vue + 1 modules
var loginData = __webpack_require__("P6mg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/routeLoading.vue









/* harmony default export */ var routeLoading = ({
  mixins: [toastMethods["a" /* default */], loginData["a" /* default */]],
  computed: Object(vuex_esm["c" /* mapGetters */])(['initial']),
  data: function data() {
    return {
      initiated: false
    };
  },
  created: function created() {
    if (this.initial !== null) {
      this.fetch(this.initial);
    }
  },

  watch: {
    '$route': function $route() {
      if (this.initial !== null) {
        this.fetch(this.initial);
      }
    },
    'initial': function initial(value) {
      if (this.initial !== null) {
        this.fetch(this.initial);
      }
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction', 'setDialogLoadingAction']), {
    fetch: function fetch(initial) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var routeName, isListEmptyMessages, isListEmptyError, defaultActionAlert, customActions, action, redirect, config;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                routeName = _this.$route.name;
                _context.prev = 1;

                _this.setLoadingAction(true);

                if (!_this.preSetData) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return _this.preSetData();

              case 6:
                if (!_this.fetchDataGuest) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return _this.fetchDataGuest();

              case 9:
                if (!(initial && _this.fetchData)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 12;
                return _this.fetchData();

              case 12:
                if (!_this.afterSetData) {
                  _context.next = 15;
                  break;
                }

                _context.next = 15;
                return _this.afterSetData();

              case 15:
                _this.setLoadingAction(false);
                _this.initiated = true;
                _context.next = 57;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](1);
                isListEmptyMessages = [];

                isListEmptyError = function isListEmptyError(msg) {
                  return isListEmptyMessages.includes(msg);
                };

                defaultActionAlert = function defaultActionAlert(data) {
                  var msg = data.result.message || _this.$t('MIXIN.routeLoading.___noPermission');
                  _this.addToast('error', msg);
                };

                customActions = [{
                  status: 401,
                  path: '/cases',
                  alert: function alert() {
                    defaultActionAlert();
                    _this.setUserData(null);
                  }
                }];
                action = customActions.find(function (x) {
                  return (!x.name || _context.t0.message && x.name === _context.t0.message) && (!x.api || _context.t0.request && new RegExp(x.api).test(_context.t0.request.responseURL)) && (!x.status || _context.t0.response && x.status === _context.t0.response.status) && (!x.path || new RegExp(x.path).test(_this.$route.fullPath));
                });

                if (!(_this.$route.name === routeName)) {
                  _context.next = 55;
                  break;
                }

                if (!action) {
                  _context.next = 34;
                  break;
                }

                redirect = action.alert ? action.alert() : defaultActionAlert();

                _this.setLoadingAction(false);
                _this.setDialogLoadingAction(false);
                _this.$router.push(redirect || { name: 'user' });
                _context.next = 53;
                break;

              case 34:
                if (!(_context.t0.response && !isListEmptyError(_context.t0.response.data.result.message))) {
                  _context.next = 50;
                  break;
                }

                defaultActionAlert(_context.t0.response.data);
                _this.setLoadingAction(false);
                _this.setDialogLoadingAction(false);
                _context.prev = 38;
                config = _this.$ls.get('userInfo');
                _context.next = 42;
                return Object(api["_82" /* getUserToken */])(config);

              case 42:
                _context.next = 47;
                break;

              case 44:
                _context.prev = 44;
                _context.t1 = _context['catch'](38);

                _this.setUserData(null);

              case 47:
                _this.$router.push({ name: 'user' });
                _context.next = 53;
                break;

              case 50:
                console.error(_context.t0);
                _this.setLoadingAction(false);
                _this.setDialogLoadingAction(false);

              case 53:
                _context.next = 57;
                break;

              case 55:
                _this.setLoadingAction(false);
                _this.setDialogLoadingAction(false);

              case 57:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 19], [38, 44]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./src/mixins/routeLoading.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  routeLoading,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_routeLoading = __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1f19bd635b1dccdce4aa.js